/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 865);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(4);
var core = __webpack_require__(40);
var hide = __webpack_require__(30);
var redefine = __webpack_require__(31);
var ctx = __webpack_require__(41);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(90);


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(7);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(672);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = __webpack_require__.i({"NODE_ENV":"production"}).DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(87)))

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(699)();
}


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(50);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(117)('wks');
var uid = __webpack_require__(85);
var Symbol = __webpack_require__(4).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(43);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(6)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(2);
var IE8_DOM_DEFINE = __webpack_require__(268);
var toPrimitive = __webpack_require__(49);
var dP = Object.defineProperty;

exports.f = __webpack_require__(14) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 16 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(9);

var DOMProperty = __webpack_require__(100);
var ReactDOMComponentFlags = __webpack_require__(308);

var invariant = __webpack_require__(3);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var Flags = ReactDOMComponentFlags;

var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);

/**
 * Check if a given node should be cached.
 */
function shouldPrecacheNode(node, nodeID) {
  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
}

/**
 * Drill down (through composites and empty components) until we get a host or
 * host text component.
 *
 * This is pretty polymorphic but unavoidable with the current structure we have
 * for `_renderedChildren`.
 */
function getRenderedHostOrTextFromComponent(component) {
  var rendered;
  while (rendered = component._renderedComponent) {
    component = rendered;
  }
  return component;
}

/**
 * Populate `_hostNode` on the rendered host/text component with the given
 * DOM node. The passed `inst` can be a composite.
 */
function precacheNode(inst, node) {
  var hostInst = getRenderedHostOrTextFromComponent(inst);
  hostInst._hostNode = node;
  node[internalInstanceKey] = hostInst;
}

function uncacheNode(inst) {
  var node = inst._hostNode;
  if (node) {
    delete node[internalInstanceKey];
    inst._hostNode = null;
  }
}

/**
 * Populate `_hostNode` on each child of `inst`, assuming that the children
 * match up with the DOM (element) children of `node`.
 *
 * We cache entire levels at once to avoid an n^2 problem where we access the
 * children of a node sequentially and have to walk from the start to our target
 * node every time.
 *
 * Since we update `_renderedChildren` and the actual DOM at (slightly)
 * different times, we could race here and see a newer `_renderedChildren` than
 * the DOM nodes we see. To avoid this, ReactMultiChild calls
 * `prepareToManageChildren` before we change `_renderedChildren`, at which
 * time the container's child nodes are always cached (until it unmounts).
 */
function precacheChildNodes(inst, node) {
  if (inst._flags & Flags.hasCachedChildNodes) {
    return;
  }
  var children = inst._renderedChildren;
  var childNode = node.firstChild;
  outer: for (var name in children) {
    if (!children.hasOwnProperty(name)) {
      continue;
    }
    var childInst = children[name];
    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
    if (childID === 0) {
      // We're currently unmounting this child in ReactMultiChild; skip it.
      continue;
    }
    // We assume the child nodes are in the same order as the child instances.
    for (; childNode !== null; childNode = childNode.nextSibling) {
      if (shouldPrecacheNode(childNode, childID)) {
        precacheNode(childInst, childNode);
        continue outer;
      }
    }
    // We reached the end of the DOM children without finding an ID match.
     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
  }
  inst._flags |= Flags.hasCachedChildNodes;
}

/**
 * Given a DOM node, return the closest ReactDOMComponent or
 * ReactDOMTextComponent instance ancestor.
 */
function getClosestInstanceFromNode(node) {
  if (node[internalInstanceKey]) {
    return node[internalInstanceKey];
  }

  // Walk up the tree until we find an ancestor whose instance we have cached.
  var parents = [];
  while (!node[internalInstanceKey]) {
    parents.push(node);
    if (node.parentNode) {
      node = node.parentNode;
    } else {
      // Top of the tree. This node must not be part of a React tree (or is
      // unmounted, potentially).
      return null;
    }
  }

  var closest;
  var inst;
  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
    closest = inst;
    if (parents.length) {
      precacheChildNodes(inst, node);
    }
  }

  return closest;
}

/**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */
function getInstanceFromNode(node) {
  var inst = getClosestInstanceFromNode(node);
  if (inst != null && inst._hostNode === node) {
    return inst;
  } else {
    return null;
  }
}

/**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */
function getNodeFromInstance(inst) {
  // Without this first invariant, passing a non-DOM-component triggers the next
  // invariant for a missing parent, which is super confusing.
  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  if (inst._hostNode) {
    return inst._hostNode;
  }

  // Walk up the tree until we find an ancestor whose DOM node we have cached.
  var parents = [];
  while (!inst._hostNode) {
    parents.push(inst);
    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
    inst = inst._hostParent;
  }

  // Now parents contains each ancestor that does *not* have a cached native
  // node, and `inst` is the deepest ancestor that does.
  for (; parents.length; inst = parents.pop()) {
    precacheChildNodes(inst, inst._hostNode);
  }

  return inst._hostNode;
}

var ReactDOMComponentTree = {
  getClosestInstanceFromNode: getClosestInstanceFromNode,
  getInstanceFromNode: getInstanceFromNode,
  getNodeFromInstance: getNodeFromInstance,
  precacheChildNodes: precacheChildNodes,
  precacheNode: precacheNode,
  uncacheNode: uncacheNode
};

module.exports = ReactDOMComponentTree;

/***/ }),
/* 18 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
	}),
	getHeadElement = memoize(function () {
		return document.head || document.getElementsByTagName("head")[0];
	}),
	singletonElement = null,
	singletonCounter = 0,
	styleElementsInsertedAtTop = [];

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	// By default, add <style> tags to the bottom of <head>.
	if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

	var styles = listToStyles(list);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
}

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function insertStyleElement(options, styleElement) {
	var head = getHeadElement();
	var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
	if (options.insertAt === "top") {
		if(!lastStyleElementInsertedAtTop) {
			head.insertBefore(styleElement, head.firstChild);
		} else if(lastStyleElementInsertedAtTop.nextSibling) {
			head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			head.appendChild(styleElement);
		}
		styleElementsInsertedAtTop.push(styleElement);
	} else if (options.insertAt === "bottom") {
		head.appendChild(styleElement);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(styleElement) {
	styleElement.parentNode.removeChild(styleElement);
	var idx = styleElementsInsertedAtTop.indexOf(styleElement);
	if(idx >= 0) {
		styleElementsInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var styleElement = document.createElement("style");
	styleElement.type = "text/css";
	insertStyleElement(options, styleElement);
	return styleElement;
}

function createLinkElement(options) {
	var linkElement = document.createElement("link");
	linkElement.rel = "stylesheet";
	insertStyleElement(options, linkElement);
	return linkElement;
}

function addStyle(obj, options) {
	var styleElement, update, remove;

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement(options));
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement(options);
		update = updateLink.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement(options);
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(47);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Router__ = __webpack_require__(795);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Link__ = __webpack_require__(340);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IndexLink__ = __webpack_require__(791);
/* unused harmony reexport IndexLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__withRouter__ = __webpack_require__(806);
/* unused harmony reexport withRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IndexRedirect__ = __webpack_require__(792);
/* unused harmony reexport IndexRedirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IndexRoute__ = __webpack_require__(793);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__IndexRoute__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(342);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(794);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RouteUtils__ = __webpack_require__(68);
/* unused harmony reexport createRoutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RouterContext__ = __webpack_require__(229);
/* unused harmony reexport RouterContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PropTypes__ = __webpack_require__(228);
/* unused harmony reexport locationShape */
/* unused harmony reexport routerShape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__match__ = __webpack_require__(804);
/* unused harmony reexport match */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__useRouterHistory__ = __webpack_require__(347);
/* unused harmony reexport useRouterHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PatternUtils__ = __webpack_require__(102);
/* unused harmony reexport formatPattern */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__applyRouterMiddleware__ = __webpack_require__(797);
/* unused harmony reexport applyRouterMiddleware */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__browserHistory__ = __webpack_require__(798);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_15__browserHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__hashHistory__ = __webpack_require__(802);
/* unused harmony reexport hashHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__createMemoryHistory__ = __webpack_require__(344);
/* unused harmony reexport createMemoryHistory */
/* components */









/* components (configuration) */










/* utils */















/* histories */








/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var 後端 = function () {
  function 後端() {
    _classCallCheck(this, 後端);
  }

  _createClass(後端, null, [{
    key: '\u7DB2\u5740',
    value: function _() {
      // return 'http://private-f0474-tai5uan5gian5gi2phing5thai5.apiary-mock.com/';
      // return 'http://localhost:8000/';
      // return 'https://db.itaigi.tw/';
      return 'https://itaigi.tw/';
    }
  }, {
    key: '\u63E3\u6309\u5462\u8B1B\u5217\u8868',
    value: function _(漢字, 台羅) {
      return encodeURI(this.網址() + '平臺項目列表/揣按呢講列表?關鍵字=' + 漢字);
    }
  }, {
    key: '\u4F8B\u53E5\u5217\u8868',
    value: function _(漢字, 臺羅) {
      'safari需要直接用punycode';

      return encodeURI('https://leku.itaigi.tw/' + '看/?漢字=' + 漢字 + '&臺羅=' + 臺羅);
    }
  }, {
    key: '\u8CA2\u737B\u8005\u8868',
    value: function _() {
      return encodeURI(this.網址() + '貢獻者表');
    }
  }, {
    key: '\u6B63\u898F\u5316\u8CA2\u737B\u8005\u8868',
    value: function _() {
      return encodeURI(this.網址() + '正規化團隊表');
    }
  }, {
    key: '\u63E3\u7121\u5EFA\u8B70\u7684\u5916\u8A9E',
    value: function _(排序) {
      return encodeURI(this.網址() + '平臺項目列表/揣無建議的外語?排序=' + 排序);
    }
  }, {
    key: '\u5E73\u81FA\u9805\u76EE\u5167\u5BB9',
    value: function _(suId) {
      return encodeURI(this.網址() + '平臺項目/看詳細內容?平臺項目編號=' + suId);
    }
  }, {
    key: '\u52A0\u5916\u8A9E',
    value: function _() {
      return encodeURI(this.網址() + '平臺項目/加外語');
    }
  }, {
    key: '\u6295\u7968',
    value: function _() {
      return encodeURI(this.網址() + '平臺項目/投票');
    }
  }, {
    key: '\u52A0\u65B0\u8A5E\u6587\u672C',
    value: function _() {
      return encodeURI(this.網址() + '平臺項目/加新詞文本');
    }
  }, {
    key: '\u63E3\u5217\u8868',
    value: function _(名) {
      return encodeURI(this.網址() + '平臺項目列表/揣列表?關鍵字=' + 名);
    }
  }, {
    key: '\u63E3\u4E0A\u65B0\u8CA2\u737B\u7684\u5916\u8A9E',
    value: function _() {
      return encodeURI(this.網址() + '平臺項目列表/揣上新貢獻的外語');
    }
  }, {
    key: '\u767B\u5165',
    value: function _() {
      return encodeURI(this.網址() + 'accounts/facebook/login');
    }
  }, {
    key: '\u767B\u5165token',
    value: function token() {
      return encodeURI(this.網址() + 'accounts/facebook/login/token/');
    }
  }, {
    key: '\u540D\u59D3',
    value: function _(姓, 名) {
      return encodeURI('https://miasenn.itaigi.tw/' + 姓 + '/' + 名 + '/');
    }
  }]);

  return 後端;
}();

/* harmony default export */ __webpack_exports__["a"] = (後端);

/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 23 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 26 */
/***/ (function(module, exports) {

/**
 * Promise wrapper for superagent
 */

function wrap(superagent, Promise) {
  /**
   * Request object similar to superagent.Request, but with end() returning
   * a promise.
   */
  function PromiseRequest() {
    superagent.Request.apply(this, arguments);
  }

  // Inherit form superagent.Request
  PromiseRequest.prototype = Object.create(superagent.Request.prototype);

  /** Send request and get a promise that `end` was emitted */
  PromiseRequest.prototype.end = function(cb) {
    var _end = superagent.Request.prototype.end;
    var self = this;

    return new Promise(function(accept, reject) {
      _end.call(self, function(err, response) {
        if (cb) {
          cb(err, response);
        }

        if (err) {
          err.response = response;
          reject(err);
        } else {
          accept(response);
        }
      });
    });
  };

  /** Provide a more promise-y interface */
  PromiseRequest.prototype.then = function(resolve, reject) {
    var _end = superagent.Request.prototype.end;
    var self = this;

    return new Promise(function(accept, reject) {
      _end.call(self, function(err, response) {
        if (err) {
          err.response = response;
          reject(err);
        } else {
          accept(response);
        }
      });
    }).then(resolve, reject);
  };

  /**
   * Request builder with same interface as superagent.
   * It is convenient to import this as `request` in place of superagent.
   */
  var request = function(method, url) {
    return new PromiseRequest(method, url);
  };

  /** Helper for making an options request */
  request.options = function(url) {
    return request('OPTIONS', url);
  }

  /** Helper for making a head request */
  request.head = function(url, data) {
    var req = request('HEAD', url);
    if (data) {
      req.send(data);
    }
    return req;
  };

  /** Helper for making a get request */
  request.get = function(url, data) {
    var req = request('GET', url);
    if (data) {
      req.query(data);
    }
    return req;
  };

  /** Helper for making a post request */
  request.post = function(url, data) {
    var req = request('POST', url);
    if (data) {
      req.send(data);
    }
    return req;
  };

  /** Helper for making a put request */
  request.put = function(url, data) {
    var req = request('PUT', url);
    if (data) {
      req.send(data);
    }
    return req;
  };

  /** Helper for making a patch request */
  request.patch = function(url, data) {
    var req = request('PATCH', url);
    if (data) {
      req.send(data);
    }
    return req;
  };

  /** Helper for making a delete request */
  request.del = function(url) {
    return request('DELETE', url);
  };

  // Export the request builder
  return request;
}

module.exports = wrap;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Root reference for iframes.
 */

var root;
if (typeof window !== 'undefined') { // Browser window
  root = window;
} else if (typeof self !== 'undefined') { // Web Worker
  root = self;
} else { // Other environments
  console.warn("Using browser-only version of superagent in non-browser environment");
  root = this;
}

var Emitter = __webpack_require__(409);
var RequestBase = __webpack_require__(854);
var isObject = __webpack_require__(357);
var ResponseBase = __webpack_require__(855);
var Agent = __webpack_require__(853);

/**
 * Noop.
 */

function noop(){};

/**
 * Expose `request`.
 */

var request = exports = module.exports = function(method, url) {
  // callback
  if ('function' == typeof url) {
    return new exports.Request('GET', method).end(url);
  }

  // url first
  if (1 == arguments.length) {
    return new exports.Request('GET', method);
  }

  return new exports.Request(method, url);
}

exports.Request = Request;

/**
 * Determine XHR.
 */

request.getXHR = function () {
  if (root.XMLHttpRequest
      && (!root.location || 'file:' != root.location.protocol
          || !root.ActiveXObject)) {
    return new XMLHttpRequest;
  } else {
    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
  }
  throw Error("Browser-only version of superagent could not find XHR");
};

/**
 * Removes leading and trailing whitespace, added to support IE.
 *
 * @param {String} s
 * @return {String}
 * @api private
 */

var trim = ''.trim
  ? function(s) { return s.trim(); }
  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };

/**
 * Serialize the given `obj`.
 *
 * @param {Object} obj
 * @return {String}
 * @api private
 */

function serialize(obj) {
  if (!isObject(obj)) return obj;
  var pairs = [];
  for (var key in obj) {
    pushEncodedKeyValuePair(pairs, key, obj[key]);
  }
  return pairs.join('&');
}

/**
 * Helps 'serialize' with serializing arrays.
 * Mutates the pairs array.
 *
 * @param {Array} pairs
 * @param {String} key
 * @param {Mixed} val
 */

function pushEncodedKeyValuePair(pairs, key, val) {
  if (val != null) {
    if (Array.isArray(val)) {
      val.forEach(function(v) {
        pushEncodedKeyValuePair(pairs, key, v);
      });
    } else if (isObject(val)) {
      for(var subkey in val) {
        pushEncodedKeyValuePair(pairs, key + '[' + subkey + ']', val[subkey]);
      }
    } else {
      pairs.push(encodeURIComponent(key)
        + '=' + encodeURIComponent(val));
    }
  } else if (val === null) {
    pairs.push(encodeURIComponent(key));
  }
}

/**
 * Expose serialization method.
 */

request.serializeObject = serialize;

/**
  * Parse the given x-www-form-urlencoded `str`.
  *
  * @param {String} str
  * @return {Object}
  * @api private
  */

function parseString(str) {
  var obj = {};
  var pairs = str.split('&');
  var pair;
  var pos;

  for (var i = 0, len = pairs.length; i < len; ++i) {
    pair = pairs[i];
    pos = pair.indexOf('=');
    if (pos == -1) {
      obj[decodeURIComponent(pair)] = '';
    } else {
      obj[decodeURIComponent(pair.slice(0, pos))] =
        decodeURIComponent(pair.slice(pos + 1));
    }
  }

  return obj;
}

/**
 * Expose parser.
 */

request.parseString = parseString;

/**
 * Default MIME type map.
 *
 *     superagent.types.xml = 'application/xml';
 *
 */

request.types = {
  html: 'text/html',
  json: 'application/json',
  xml: 'text/xml',
  urlencoded: 'application/x-www-form-urlencoded',
  'form': 'application/x-www-form-urlencoded',
  'form-data': 'application/x-www-form-urlencoded'
};

/**
 * Default serialization map.
 *
 *     superagent.serialize['application/xml'] = function(obj){
 *       return 'generated xml here';
 *     };
 *
 */

request.serialize = {
  'application/x-www-form-urlencoded': serialize,
  'application/json': JSON.stringify
};

/**
  * Default parsers.
  *
  *     superagent.parse['application/xml'] = function(str){
  *       return { object parsed from str };
  *     };
  *
  */

request.parse = {
  'application/x-www-form-urlencoded': parseString,
  'application/json': JSON.parse
};

/**
 * Parse the given header `str` into
 * an object containing the mapped fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

function parseHeader(str) {
  var lines = str.split(/\r?\n/);
  var fields = {};
  var index;
  var line;
  var field;
  var val;

  for (var i = 0, len = lines.length; i < len; ++i) {
    line = lines[i];
    index = line.indexOf(':');
    if (index === -1) { // could be empty line, just skip it
      continue;
    }
    field = line.slice(0, index).toLowerCase();
    val = trim(line.slice(index + 1));
    fields[field] = val;
  }

  return fields;
}

/**
 * Check if `mime` is json or has +json structured syntax suffix.
 *
 * @param {String} mime
 * @return {Boolean}
 * @api private
 */

function isJSON(mime) {
  // should match /json or +json
  // but not /json-seq
  return /[\/+]json($|[^-\w])/.test(mime);
}

/**
 * Initialize a new `Response` with the given `xhr`.
 *
 *  - set flags (.ok, .error, etc)
 *  - parse header
 *
 * Examples:
 *
 *  Aliasing `superagent` as `request` is nice:
 *
 *      request = superagent;
 *
 *  We can use the promise-like API, or pass callbacks:
 *
 *      request.get('/').end(function(res){});
 *      request.get('/', function(res){});
 *
 *  Sending data can be chained:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' })
 *        .end(function(res){});
 *
 *  Or passed to `.send()`:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' }, function(res){});
 *
 *  Or passed to `.post()`:
 *
 *      request
 *        .post('/user', { name: 'tj' })
 *        .end(function(res){});
 *
 * Or further reduced to a single call for simple cases:
 *
 *      request
 *        .post('/user', { name: 'tj' }, function(res){});
 *
 * @param {XMLHTTPRequest} xhr
 * @param {Object} options
 * @api private
 */

function Response(req) {
  this.req = req;
  this.xhr = this.req.xhr;
  // responseText is accessible only if responseType is '' or 'text' and on older browsers
  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
     ? this.xhr.responseText
     : null;
  this.statusText = this.req.xhr.statusText;
  var status = this.xhr.status;
  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
  if (status === 1223) {
    status = 204;
  }
  this._setStatusProperties(status);
  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
  // getResponseHeader still works. so we get content-type even if getting
  // other headers fails.
  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
  this._setHeaderProperties(this.header);

  if (null === this.text && req._responseType) {
    this.body = this.xhr.response;
  } else {
    this.body = this.req.method != 'HEAD'
      ? this._parseBody(this.text ? this.text : this.xhr.response)
      : null;
  }
}

ResponseBase(Response.prototype);

/**
 * Parse the given body `str`.
 *
 * Used for auto-parsing of bodies. Parsers
 * are defined on the `superagent.parse` object.
 *
 * @param {String} str
 * @return {Mixed}
 * @api private
 */

Response.prototype._parseBody = function(str) {
  var parse = request.parse[this.type];
  if (this.req._parser) {
    return this.req._parser(this, str);
  }
  if (!parse && isJSON(this.type)) {
    parse = request.parse['application/json'];
  }
  return parse && str && (str.length || str instanceof Object)
    ? parse(str)
    : null;
};

/**
 * Return an `Error` representative of this response.
 *
 * @return {Error}
 * @api public
 */

Response.prototype.toError = function(){
  var req = this.req;
  var method = req.method;
  var url = req.url;

  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
  var err = new Error(msg);
  err.status = this.status;
  err.method = method;
  err.url = url;

  return err;
};

/**
 * Expose `Response`.
 */

request.Response = Response;

/**
 * Initialize a new `Request` with the given `method` and `url`.
 *
 * @param {String} method
 * @param {String} url
 * @api public
 */

function Request(method, url) {
  var self = this;
  this._query = this._query || [];
  this.method = method;
  this.url = url;
  this.header = {}; // preserves header name case
  this._header = {}; // coerces header names to lowercase
  this.on('end', function(){
    var err = null;
    var res = null;

    try {
      res = new Response(self);
    } catch(e) {
      err = new Error('Parser is unable to parse the response');
      err.parse = true;
      err.original = e;
      // issue #675: return the raw response if the response parsing fails
      if (self.xhr) {
        // ie9 doesn't have 'response' property
        err.rawResponse = typeof self.xhr.responseType == 'undefined' ? self.xhr.responseText : self.xhr.response;
        // issue #876: return the http status code if the response parsing fails
        err.status = self.xhr.status ? self.xhr.status : null;
        err.statusCode = err.status; // backwards-compat only
      } else {
        err.rawResponse = null;
        err.status = null;
      }

      return self.callback(err);
    }

    self.emit('response', res);

    var new_err;
    try {
      if (!self._isResponseOK(res)) {
        new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
      }
    } catch(custom_err) {
      new_err = custom_err; // ok() callback can throw
    }

    // #1000 don't catch errors from the callback to avoid double calling it
    if (new_err) {
      new_err.original = err;
      new_err.response = res;
      new_err.status = res.status;
      self.callback(new_err, res);
    } else {
      self.callback(null, res);
    }
  });
}

/**
 * Mixin `Emitter` and `RequestBase`.
 */

Emitter(Request.prototype);
RequestBase(Request.prototype);

/**
 * Set Content-Type to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.xml = 'application/xml';
 *
 *      request.post('/')
 *        .type('xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 *      request.post('/')
 *        .type('application/xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 * @param {String} type
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.type = function(type){
  this.set('Content-Type', request.types[type] || type);
  return this;
};

/**
 * Set Accept to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.json = 'application/json';
 *
 *      request.get('/agent')
 *        .accept('json')
 *        .end(callback);
 *
 *      request.get('/agent')
 *        .accept('application/json')
 *        .end(callback);
 *
 * @param {String} accept
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.accept = function(type){
  this.set('Accept', request.types[type] || type);
  return this;
};

/**
 * Set Authorization field value with `user` and `pass`.
 *
 * @param {String} user
 * @param {String} [pass] optional in case of using 'bearer' as type
 * @param {Object} options with 'type' property 'auto', 'basic' or 'bearer' (default 'basic')
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.auth = function(user, pass, options){
  if (1 === arguments.length) pass = '';
  if (typeof pass === 'object' && pass !== null) { // pass is optional and can be replaced with options
    options = pass;
    pass = '';
  }
  if (!options) {
    options = {
      type: 'function' === typeof btoa ? 'basic' : 'auto',
    };
  }

  var encoder = function(string) {
    if ('function' === typeof btoa) {
      return btoa(string);
    }
    throw new Error('Cannot use basic auth, btoa is not a function');
  };

  return this._auth(user, pass, options, encoder);
};

/**
 * Add query-string `val`.
 *
 * Examples:
 *
 *   request.get('/shoes')
 *     .query('size=10')
 *     .query({ color: 'blue' })
 *
 * @param {Object|String} val
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.query = function(val){
  if ('string' != typeof val) val = serialize(val);
  if (val) this._query.push(val);
  return this;
};

/**
 * Queue the given `file` as an attachment to the specified `field`,
 * with optional `options` (or filename).
 *
 * ``` js
 * request.post('/upload')
 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
 *   .end(callback);
 * ```
 *
 * @param {String} field
 * @param {Blob|File} file
 * @param {String|Object} options
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.attach = function(field, file, options){
  if (file) {
    if (this._data) {
      throw Error("superagent can't mix .send() and .attach()");
    }

    this._getFormData().append(field, file, options || file.name);
  }
  return this;
};

Request.prototype._getFormData = function(){
  if (!this._formData) {
    this._formData = new root.FormData();
  }
  return this._formData;
};

/**
 * Invoke the callback with `err` and `res`
 * and handle arity check.
 *
 * @param {Error} err
 * @param {Response} res
 * @api private
 */

Request.prototype.callback = function(err, res){
  if (this._shouldRetry(err, res)) {
    return this._retry();
  }

  var fn = this._callback;
  this.clearTimeout();

  if (err) {
    if (this._maxRetries) err.retries = this._retries - 1;
    this.emit('error', err);
  }

  fn(err, res);
};

/**
 * Invoke callback with x-domain error.
 *
 * @api private
 */

Request.prototype.crossDomainError = function(){
  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
  err.crossDomain = true;

  err.status = this.status;
  err.method = this.method;
  err.url = this.url;

  this.callback(err);
};

// This only warns, because the request is still likely to work
Request.prototype.buffer = Request.prototype.ca = Request.prototype.agent = function(){
  console.warn("This is not supported in browser version of superagent");
  return this;
};

// This throws, because it can't send/receive data as expected
Request.prototype.pipe = Request.prototype.write = function(){
  throw Error("Streaming is not supported in browser version of superagent");
};

/**
 * Check if `obj` is a host object,
 * we don't want to serialize these :)
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */
Request.prototype._isHost = function _isHost(obj) {
  // Native objects stringify to [object File], [object Blob], [object FormData], etc.
  return obj && 'object' === typeof obj && !Array.isArray(obj) && Object.prototype.toString.call(obj) !== '[object Object]';
}

/**
 * Initiate request, invoking callback `fn(res)`
 * with an instanceof `Response`.
 *
 * @param {Function} fn
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.end = function(fn){
  if (this._endCalled) {
    console.warn("Warning: .end() was called twice. This is not supported in superagent");
  }
  this._endCalled = true;

  // store callback
  this._callback = fn || noop;

  // querystring
  this._finalizeQueryString();

  return this._end();
};

Request.prototype._end = function() {
  var self = this;
  var xhr = (this.xhr = request.getXHR());
  var data = this._formData || this._data;

  this._setTimeouts();

  // state change
  xhr.onreadystatechange = function(){
    var readyState = xhr.readyState;
    if (readyState >= 2 && self._responseTimeoutTimer) {
      clearTimeout(self._responseTimeoutTimer);
    }
    if (4 != readyState) {
      return;
    }

    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
    // result in the error "Could not complete the operation due to error c00c023f"
    var status;
    try { status = xhr.status } catch(e) { status = 0; }

    if (!status) {
      if (self.timedout || self._aborted) return;
      return self.crossDomainError();
    }
    self.emit('end');
  };

  // progress
  var handleProgress = function(direction, e) {
    if (e.total > 0) {
      e.percent = e.loaded / e.total * 100;
    }
    e.direction = direction;
    self.emit('progress', e);
  };
  if (this.hasListeners('progress')) {
    try {
      xhr.onprogress = handleProgress.bind(null, 'download');
      if (xhr.upload) {
        xhr.upload.onprogress = handleProgress.bind(null, 'upload');
      }
    } catch(e) {
      // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
      // Reported here:
      // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
    }
  }

  // initiate request
  try {
    if (this.username && this.password) {
      xhr.open(this.method, this.url, true, this.username, this.password);
    } else {
      xhr.open(this.method, this.url, true);
    }
  } catch (err) {
    // see #1149
    return this.callback(err);
  }

  // CORS
  if (this._withCredentials) xhr.withCredentials = true;

  // body
  if (!this._formData && 'GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !this._isHost(data)) {
    // serialize stuff
    var contentType = this._header['content-type'];
    var serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];
    if (!serialize && isJSON(contentType)) {
      serialize = request.serialize['application/json'];
    }
    if (serialize) data = serialize(data);
  }

  // set header fields
  for (var field in this.header) {
    if (null == this.header[field]) continue;

    if (this.header.hasOwnProperty(field))
      xhr.setRequestHeader(field, this.header[field]);
  }

  if (this._responseType) {
    xhr.responseType = this._responseType;
  }

  // send stuff
  this.emit('request', this);

  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
  // We need null here if data is undefined
  xhr.send(typeof data !== 'undefined' ? data : null);
  return this;
};

request.agent = function() {
  return new Agent();
};

["GET", "POST", "OPTIONS", "PATCH", "PUT", "DELETE"].forEach(function(method) {
  Agent.prototype[method.toLowerCase()] = function(url, fn) {
    var req = new request.Request(method, url);
    this._setDefaults(req);
    if (fn) {
      req.end(fn);
    }
    return req;
  };
});

Agent.prototype.del = Agent.prototype['delete'];

/**
 * GET `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.get = function(url, data, fn) {
  var req = request('GET', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * HEAD `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.head = function(url, data, fn) {
  var req = request('HEAD', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * OPTIONS query to `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.options = function(url, data, fn) {
  var req = request('OPTIONS', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * DELETE `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

function del(url, data, fn) {
  var req = request('DELETE', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
}

request['del'] = del;
request['delete'] = del;

/**
 * PATCH `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.patch = function(url, data, fn) {
  var req = request('PATCH', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * POST `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.post = function(url, data, fn) {
  var req = request('POST', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * PUT `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.put = function(url, data, fn) {
  var req = request('PUT', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global, setImmediate) {/* @preserve
 * The MIT License (MIT)
 * 
 * Copyright (c) 2013-2018 Petka Antonov
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 * 
 */
/**
 * bluebird build version 3.7.2
 * Features enabled: core, race, call_get, generators, map, nodeify, promisify, props, reduce, settle, some, using, timers, filter, any, each
*/
!function(e){if(true)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{var f;"undefined"!=typeof window?f=window:"undefined"!=typeof global?f=global:"undefined"!=typeof self&&(f=self),f.Promise=e()}}(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof _dereq_=="function"&&_dereq_;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof _dereq_=="function"&&_dereq_;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
var SomePromiseArray = Promise._SomePromiseArray;
function any(promises) {
    var ret = new SomePromiseArray(promises);
    var promise = ret.promise();
    ret.setHowMany(1);
    ret.setUnwrap();
    ret.init();
    return promise;
}

Promise.any = function (promises) {
    return any(promises);
};

Promise.prototype.any = function () {
    return any(this);
};

};

},{}],2:[function(_dereq_,module,exports){
"use strict";
var firstLineError;
try {throw new Error(); } catch (e) {firstLineError = e;}
var schedule = _dereq_("./schedule");
var Queue = _dereq_("./queue");

function Async() {
    this._customScheduler = false;
    this._isTickUsed = false;
    this._lateQueue = new Queue(16);
    this._normalQueue = new Queue(16);
    this._haveDrainedQueues = false;
    var self = this;
    this.drainQueues = function () {
        self._drainQueues();
    };
    this._schedule = schedule;
}

Async.prototype.setScheduler = function(fn) {
    var prev = this._schedule;
    this._schedule = fn;
    this._customScheduler = true;
    return prev;
};

Async.prototype.hasCustomScheduler = function() {
    return this._customScheduler;
};

Async.prototype.haveItemsQueued = function () {
    return this._isTickUsed || this._haveDrainedQueues;
};


Async.prototype.fatalError = function(e, isNode) {
    if (isNode) {
        process.stderr.write("Fatal " + (e instanceof Error ? e.stack : e) +
            "\n");
        process.exit(2);
    } else {
        this.throwLater(e);
    }
};

Async.prototype.throwLater = function(fn, arg) {
    if (arguments.length === 1) {
        arg = fn;
        fn = function () { throw arg; };
    }
    if (typeof setTimeout !== "undefined") {
        setTimeout(function() {
            fn(arg);
        }, 0);
    } else try {
        this._schedule(function() {
            fn(arg);
        });
    } catch (e) {
        throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
};

function AsyncInvokeLater(fn, receiver, arg) {
    this._lateQueue.push(fn, receiver, arg);
    this._queueTick();
}

function AsyncInvoke(fn, receiver, arg) {
    this._normalQueue.push(fn, receiver, arg);
    this._queueTick();
}

function AsyncSettlePromises(promise) {
    this._normalQueue._pushOne(promise);
    this._queueTick();
}

Async.prototype.invokeLater = AsyncInvokeLater;
Async.prototype.invoke = AsyncInvoke;
Async.prototype.settlePromises = AsyncSettlePromises;


function _drainQueue(queue) {
    while (queue.length() > 0) {
        _drainQueueStep(queue);
    }
}

function _drainQueueStep(queue) {
    var fn = queue.shift();
    if (typeof fn !== "function") {
        fn._settlePromises();
    } else {
        var receiver = queue.shift();
        var arg = queue.shift();
        fn.call(receiver, arg);
    }
}

Async.prototype._drainQueues = function () {
    _drainQueue(this._normalQueue);
    this._reset();
    this._haveDrainedQueues = true;
    _drainQueue(this._lateQueue);
};

Async.prototype._queueTick = function () {
    if (!this._isTickUsed) {
        this._isTickUsed = true;
        this._schedule(this.drainQueues);
    }
};

Async.prototype._reset = function () {
    this._isTickUsed = false;
};

module.exports = Async;
module.exports.firstLineError = firstLineError;

},{"./queue":26,"./schedule":29}],3:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL, tryConvertToPromise, debug) {
var calledBind = false;
var rejectThis = function(_, e) {
    this._reject(e);
};

var targetRejected = function(e, context) {
    context.promiseRejectionQueued = true;
    context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
};

var bindingResolved = function(thisArg, context) {
    if (((this._bitField & 50397184) === 0)) {
        this._resolveCallback(context.target);
    }
};

var bindingRejected = function(e, context) {
    if (!context.promiseRejectionQueued) this._reject(e);
};

Promise.prototype.bind = function (thisArg) {
    if (!calledBind) {
        calledBind = true;
        Promise.prototype._propagateFrom = debug.propagateFromFunction();
        Promise.prototype._boundValue = debug.boundValueFunction();
    }
    var maybePromise = tryConvertToPromise(thisArg);
    var ret = new Promise(INTERNAL);
    ret._propagateFrom(this, 1);
    var target = this._target();
    ret._setBoundTo(maybePromise);
    if (maybePromise instanceof Promise) {
        var context = {
            promiseRejectionQueued: false,
            promise: ret,
            target: target,
            bindingPromise: maybePromise
        };
        target._then(INTERNAL, targetRejected, undefined, ret, context);
        maybePromise._then(
            bindingResolved, bindingRejected, undefined, ret, context);
        ret._setOnCancel(maybePromise);
    } else {
        ret._resolveCallback(target);
    }
    return ret;
};

Promise.prototype._setBoundTo = function (obj) {
    if (obj !== undefined) {
        this._bitField = this._bitField | 2097152;
        this._boundTo = obj;
    } else {
        this._bitField = this._bitField & (~2097152);
    }
};

Promise.prototype._isBound = function () {
    return (this._bitField & 2097152) === 2097152;
};

Promise.bind = function (thisArg, value) {
    return Promise.resolve(value).bind(thisArg);
};
};

},{}],4:[function(_dereq_,module,exports){
"use strict";
var old;
if (typeof Promise !== "undefined") old = Promise;
function noConflict() {
    try { if (Promise === bluebird) Promise = old; }
    catch (e) {}
    return bluebird;
}
var bluebird = _dereq_("./promise")();
bluebird.noConflict = noConflict;
module.exports = bluebird;

},{"./promise":22}],5:[function(_dereq_,module,exports){
"use strict";
var cr = Object.create;
if (cr) {
    var callerCache = cr(null);
    var getterCache = cr(null);
    callerCache[" size"] = getterCache[" size"] = 0;
}

module.exports = function(Promise) {
var util = _dereq_("./util");
var canEvaluate = util.canEvaluate;
var isIdentifier = util.isIdentifier;

var getMethodCaller;
var getGetter;
if (false) {
var makeMethodCaller = function (methodName) {
    return new Function("ensureMethod", "                                    \n\
        return function(obj) {                                               \n\
            'use strict'                                                     \n\
            var len = this.length;                                           \n\
            ensureMethod(obj, 'methodName');                                 \n\
            switch(len) {                                                    \n\
                case 1: return obj.methodName(this[0]);                      \n\
                case 2: return obj.methodName(this[0], this[1]);             \n\
                case 3: return obj.methodName(this[0], this[1], this[2]);    \n\
                case 0: return obj.methodName();                             \n\
                default:                                                     \n\
                    return obj.methodName.apply(obj, this);                  \n\
            }                                                                \n\
        };                                                                   \n\
        ".replace(/methodName/g, methodName))(ensureMethod);
};

var makeGetter = function (propertyName) {
    return new Function("obj", "                                             \n\
        'use strict';                                                        \n\
        return obj.propertyName;                                             \n\
        ".replace("propertyName", propertyName));
};

var getCompiled = function(name, compiler, cache) {
    var ret = cache[name];
    if (typeof ret !== "function") {
        if (!isIdentifier(name)) {
            return null;
        }
        ret = compiler(name);
        cache[name] = ret;
        cache[" size"]++;
        if (cache[" size"] > 512) {
            var keys = Object.keys(cache);
            for (var i = 0; i < 256; ++i) delete cache[keys[i]];
            cache[" size"] = keys.length - 256;
        }
    }
    return ret;
};

getMethodCaller = function(name) {
    return getCompiled(name, makeMethodCaller, callerCache);
};

getGetter = function(name) {
    return getCompiled(name, makeGetter, getterCache);
};
}

function ensureMethod(obj, methodName) {
    var fn;
    if (obj != null) fn = obj[methodName];
    if (typeof fn !== "function") {
        var message = "Object " + util.classString(obj) + " has no method '" +
            util.toString(methodName) + "'";
        throw new Promise.TypeError(message);
    }
    return fn;
}

function caller(obj) {
    var methodName = this.pop();
    var fn = ensureMethod(obj, methodName);
    return fn.apply(obj, this);
}
Promise.prototype.call = function (methodName) {
    var args = [].slice.call(arguments, 1);;
    if (false) {
        if (canEvaluate) {
            var maybeCaller = getMethodCaller(methodName);
            if (maybeCaller !== null) {
                return this._then(
                    maybeCaller, undefined, undefined, args, undefined);
            }
        }
    }
    args.push(methodName);
    return this._then(caller, undefined, undefined, args, undefined);
};

function namedGetter(obj) {
    return obj[this];
}
function indexedGetter(obj) {
    var index = +this;
    if (index < 0) index = Math.max(0, index + obj.length);
    return obj[index];
}
Promise.prototype.get = function (propertyName) {
    var isIndex = (typeof propertyName === "number");
    var getter;
    if (!isIndex) {
        if (canEvaluate) {
            var maybeGetter = getGetter(propertyName);
            getter = maybeGetter !== null ? maybeGetter : namedGetter;
        } else {
            getter = namedGetter;
        }
    } else {
        getter = indexedGetter;
    }
    return this._then(getter, undefined, undefined, propertyName, undefined);
};
};

},{"./util":36}],6:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, PromiseArray, apiRejection, debug) {
var util = _dereq_("./util");
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
var async = Promise._async;

Promise.prototype["break"] = Promise.prototype.cancel = function() {
    if (!debug.cancellation()) return this._warn("cancellation is disabled");

    var promise = this;
    var child = promise;
    while (promise._isCancellable()) {
        if (!promise._cancelBy(child)) {
            if (child._isFollowing()) {
                child._followee().cancel();
            } else {
                child._cancelBranched();
            }
            break;
        }

        var parent = promise._cancellationParent;
        if (parent == null || !parent._isCancellable()) {
            if (promise._isFollowing()) {
                promise._followee().cancel();
            } else {
                promise._cancelBranched();
            }
            break;
        } else {
            if (promise._isFollowing()) promise._followee().cancel();
            promise._setWillBeCancelled();
            child = promise;
            promise = parent;
        }
    }
};

Promise.prototype._branchHasCancelled = function() {
    this._branchesRemainingToCancel--;
};

Promise.prototype._enoughBranchesHaveCancelled = function() {
    return this._branchesRemainingToCancel === undefined ||
           this._branchesRemainingToCancel <= 0;
};

Promise.prototype._cancelBy = function(canceller) {
    if (canceller === this) {
        this._branchesRemainingToCancel = 0;
        this._invokeOnCancel();
        return true;
    } else {
        this._branchHasCancelled();
        if (this._enoughBranchesHaveCancelled()) {
            this._invokeOnCancel();
            return true;
        }
    }
    return false;
};

Promise.prototype._cancelBranched = function() {
    if (this._enoughBranchesHaveCancelled()) {
        this._cancel();
    }
};

Promise.prototype._cancel = function() {
    if (!this._isCancellable()) return;
    this._setCancelled();
    async.invoke(this._cancelPromises, this, undefined);
};

Promise.prototype._cancelPromises = function() {
    if (this._length() > 0) this._settlePromises();
};

Promise.prototype._unsetOnCancel = function() {
    this._onCancelField = undefined;
};

Promise.prototype._isCancellable = function() {
    return this.isPending() && !this._isCancelled();
};

Promise.prototype.isCancellable = function() {
    return this.isPending() && !this.isCancelled();
};

Promise.prototype._doInvokeOnCancel = function(onCancelCallback, internalOnly) {
    if (util.isArray(onCancelCallback)) {
        for (var i = 0; i < onCancelCallback.length; ++i) {
            this._doInvokeOnCancel(onCancelCallback[i], internalOnly);
        }
    } else if (onCancelCallback !== undefined) {
        if (typeof onCancelCallback === "function") {
            if (!internalOnly) {
                var e = tryCatch(onCancelCallback).call(this._boundValue());
                if (e === errorObj) {
                    this._attachExtraTrace(e.e);
                    async.throwLater(e.e);
                }
            }
        } else {
            onCancelCallback._resultCancelled(this);
        }
    }
};

Promise.prototype._invokeOnCancel = function() {
    var onCancelCallback = this._onCancel();
    this._unsetOnCancel();
    async.invoke(this._doInvokeOnCancel, this, onCancelCallback);
};

Promise.prototype._invokeInternalOnCancel = function() {
    if (this._isCancellable()) {
        this._doInvokeOnCancel(this._onCancel(), true);
        this._unsetOnCancel();
    }
};

Promise.prototype._resultCancelled = function() {
    this.cancel();
};

};

},{"./util":36}],7:[function(_dereq_,module,exports){
"use strict";
module.exports = function(NEXT_FILTER) {
var util = _dereq_("./util");
var getKeys = _dereq_("./es5").keys;
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;

function catchFilter(instances, cb, promise) {
    return function(e) {
        var boundTo = promise._boundValue();
        predicateLoop: for (var i = 0; i < instances.length; ++i) {
            var item = instances[i];

            if (item === Error ||
                (item != null && item.prototype instanceof Error)) {
                if (e instanceof item) {
                    return tryCatch(cb).call(boundTo, e);
                }
            } else if (typeof item === "function") {
                var matchesPredicate = tryCatch(item).call(boundTo, e);
                if (matchesPredicate === errorObj) {
                    return matchesPredicate;
                } else if (matchesPredicate) {
                    return tryCatch(cb).call(boundTo, e);
                }
            } else if (util.isObject(e)) {
                var keys = getKeys(item);
                for (var j = 0; j < keys.length; ++j) {
                    var key = keys[j];
                    if (item[key] != e[key]) {
                        continue predicateLoop;
                    }
                }
                return tryCatch(cb).call(boundTo, e);
            }
        }
        return NEXT_FILTER;
    };
}

return catchFilter;
};

},{"./es5":13,"./util":36}],8:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
var longStackTraces = false;
var contextStack = [];

Promise.prototype._promiseCreated = function() {};
Promise.prototype._pushContext = function() {};
Promise.prototype._popContext = function() {return null;};
Promise._peekContext = Promise.prototype._peekContext = function() {};

function Context() {
    this._trace = new Context.CapturedTrace(peekContext());
}
Context.prototype._pushContext = function () {
    if (this._trace !== undefined) {
        this._trace._promiseCreated = null;
        contextStack.push(this._trace);
    }
};

Context.prototype._popContext = function () {
    if (this._trace !== undefined) {
        var trace = contextStack.pop();
        var ret = trace._promiseCreated;
        trace._promiseCreated = null;
        return ret;
    }
    return null;
};

function createContext() {
    if (longStackTraces) return new Context();
}

function peekContext() {
    var lastIndex = contextStack.length - 1;
    if (lastIndex >= 0) {
        return contextStack[lastIndex];
    }
    return undefined;
}
Context.CapturedTrace = null;
Context.create = createContext;
Context.deactivateLongStackTraces = function() {};
Context.activateLongStackTraces = function() {
    var Promise_pushContext = Promise.prototype._pushContext;
    var Promise_popContext = Promise.prototype._popContext;
    var Promise_PeekContext = Promise._peekContext;
    var Promise_peekContext = Promise.prototype._peekContext;
    var Promise_promiseCreated = Promise.prototype._promiseCreated;
    Context.deactivateLongStackTraces = function() {
        Promise.prototype._pushContext = Promise_pushContext;
        Promise.prototype._popContext = Promise_popContext;
        Promise._peekContext = Promise_PeekContext;
        Promise.prototype._peekContext = Promise_peekContext;
        Promise.prototype._promiseCreated = Promise_promiseCreated;
        longStackTraces = false;
    };
    longStackTraces = true;
    Promise.prototype._pushContext = Context.prototype._pushContext;
    Promise.prototype._popContext = Context.prototype._popContext;
    Promise._peekContext = Promise.prototype._peekContext = peekContext;
    Promise.prototype._promiseCreated = function() {
        var ctx = this._peekContext();
        if (ctx && ctx._promiseCreated == null) ctx._promiseCreated = this;
    };
};
return Context;
};

},{}],9:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, Context,
    enableAsyncHooks, disableAsyncHooks) {
var async = Promise._async;
var Warning = _dereq_("./errors").Warning;
var util = _dereq_("./util");
var es5 = _dereq_("./es5");
var canAttachTrace = util.canAttachTrace;
var unhandledRejectionHandled;
var possiblyUnhandledRejection;
var bluebirdFramePattern =
    /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/;
var nodeFramePattern = /\((?:timers\.js):\d+:\d+\)/;
var parseLinePattern = /[\/<\(](.+?):(\d+):(\d+)\)?\s*$/;
var stackFramePattern = null;
var formatStack = null;
var indentStackFrames = false;
var printWarning;
var debugging = !!(util.env("BLUEBIRD_DEBUG") != 0 &&
                        (true ||
                         util.env("BLUEBIRD_DEBUG") ||
                         util.env("NODE_ENV") === "development"));

var warnings = !!(util.env("BLUEBIRD_WARNINGS") != 0 &&
    (debugging || util.env("BLUEBIRD_WARNINGS")));

var longStackTraces = !!(util.env("BLUEBIRD_LONG_STACK_TRACES") != 0 &&
    (debugging || util.env("BLUEBIRD_LONG_STACK_TRACES")));

var wForgottenReturn = util.env("BLUEBIRD_W_FORGOTTEN_RETURN") != 0 &&
    (warnings || !!util.env("BLUEBIRD_W_FORGOTTEN_RETURN"));

var deferUnhandledRejectionCheck;
(function() {
    var promises = [];

    function unhandledRejectionCheck() {
        for (var i = 0; i < promises.length; ++i) {
            promises[i]._notifyUnhandledRejection();
        }
        unhandledRejectionClear();
    }

    function unhandledRejectionClear() {
        promises.length = 0;
    }

    deferUnhandledRejectionCheck = function(promise) {
        promises.push(promise);
        setTimeout(unhandledRejectionCheck, 1);
    };

    es5.defineProperty(Promise, "_unhandledRejectionCheck", {
        value: unhandledRejectionCheck
    });
    es5.defineProperty(Promise, "_unhandledRejectionClear", {
        value: unhandledRejectionClear
    });
})();

Promise.prototype.suppressUnhandledRejections = function() {
    var target = this._target();
    target._bitField = ((target._bitField & (~1048576)) |
                      524288);
};

Promise.prototype._ensurePossibleRejectionHandled = function () {
    if ((this._bitField & 524288) !== 0) return;
    this._setRejectionIsUnhandled();
    deferUnhandledRejectionCheck(this);
};

Promise.prototype._notifyUnhandledRejectionIsHandled = function () {
    fireRejectionEvent("rejectionHandled",
                                  unhandledRejectionHandled, undefined, this);
};

Promise.prototype._setReturnedNonUndefined = function() {
    this._bitField = this._bitField | 268435456;
};

Promise.prototype._returnedNonUndefined = function() {
    return (this._bitField & 268435456) !== 0;
};

Promise.prototype._notifyUnhandledRejection = function () {
    if (this._isRejectionUnhandled()) {
        var reason = this._settledValue();
        this._setUnhandledRejectionIsNotified();
        fireRejectionEvent("unhandledRejection",
                                      possiblyUnhandledRejection, reason, this);
    }
};

Promise.prototype._setUnhandledRejectionIsNotified = function () {
    this._bitField = this._bitField | 262144;
};

Promise.prototype._unsetUnhandledRejectionIsNotified = function () {
    this._bitField = this._bitField & (~262144);
};

Promise.prototype._isUnhandledRejectionNotified = function () {
    return (this._bitField & 262144) > 0;
};

Promise.prototype._setRejectionIsUnhandled = function () {
    this._bitField = this._bitField | 1048576;
};

Promise.prototype._unsetRejectionIsUnhandled = function () {
    this._bitField = this._bitField & (~1048576);
    if (this._isUnhandledRejectionNotified()) {
        this._unsetUnhandledRejectionIsNotified();
        this._notifyUnhandledRejectionIsHandled();
    }
};

Promise.prototype._isRejectionUnhandled = function () {
    return (this._bitField & 1048576) > 0;
};

Promise.prototype._warn = function(message, shouldUseOwnTrace, promise) {
    return warn(message, shouldUseOwnTrace, promise || this);
};

Promise.onPossiblyUnhandledRejection = function (fn) {
    var context = Promise._getContext();
    possiblyUnhandledRejection = util.contextBind(context, fn);
};

Promise.onUnhandledRejectionHandled = function (fn) {
    var context = Promise._getContext();
    unhandledRejectionHandled = util.contextBind(context, fn);
};

var disableLongStackTraces = function() {};
Promise.longStackTraces = function () {
    if (async.haveItemsQueued() && !config.longStackTraces) {
        throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    if (!config.longStackTraces && longStackTracesIsSupported()) {
        var Promise_captureStackTrace = Promise.prototype._captureStackTrace;
        var Promise_attachExtraTrace = Promise.prototype._attachExtraTrace;
        var Promise_dereferenceTrace = Promise.prototype._dereferenceTrace;
        config.longStackTraces = true;
        disableLongStackTraces = function() {
            if (async.haveItemsQueued() && !config.longStackTraces) {
                throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
            }
            Promise.prototype._captureStackTrace = Promise_captureStackTrace;
            Promise.prototype._attachExtraTrace = Promise_attachExtraTrace;
            Promise.prototype._dereferenceTrace = Promise_dereferenceTrace;
            Context.deactivateLongStackTraces();
            config.longStackTraces = false;
        };
        Promise.prototype._captureStackTrace = longStackTracesCaptureStackTrace;
        Promise.prototype._attachExtraTrace = longStackTracesAttachExtraTrace;
        Promise.prototype._dereferenceTrace = longStackTracesDereferenceTrace;
        Context.activateLongStackTraces();
    }
};

Promise.hasLongStackTraces = function () {
    return config.longStackTraces && longStackTracesIsSupported();
};


var legacyHandlers = {
    unhandledrejection: {
        before: function() {
            var ret = util.global.onunhandledrejection;
            util.global.onunhandledrejection = null;
            return ret;
        },
        after: function(fn) {
            util.global.onunhandledrejection = fn;
        }
    },
    rejectionhandled: {
        before: function() {
            var ret = util.global.onrejectionhandled;
            util.global.onrejectionhandled = null;
            return ret;
        },
        after: function(fn) {
            util.global.onrejectionhandled = fn;
        }
    }
};

var fireDomEvent = (function() {
    var dispatch = function(legacy, e) {
        if (legacy) {
            var fn;
            try {
                fn = legacy.before();
                return !util.global.dispatchEvent(e);
            } finally {
                legacy.after(fn);
            }
        } else {
            return !util.global.dispatchEvent(e);
        }
    };
    try {
        if (typeof CustomEvent === "function") {
            var event = new CustomEvent("CustomEvent");
            util.global.dispatchEvent(event);
            return function(name, event) {
                name = name.toLowerCase();
                var eventData = {
                    detail: event,
                    cancelable: true
                };
                var domEvent = new CustomEvent(name, eventData);
                es5.defineProperty(
                    domEvent, "promise", {value: event.promise});
                es5.defineProperty(
                    domEvent, "reason", {value: event.reason});

                return dispatch(legacyHandlers[name], domEvent);
            };
        } else if (typeof Event === "function") {
            var event = new Event("CustomEvent");
            util.global.dispatchEvent(event);
            return function(name, event) {
                name = name.toLowerCase();
                var domEvent = new Event(name, {
                    cancelable: true
                });
                domEvent.detail = event;
                es5.defineProperty(domEvent, "promise", {value: event.promise});
                es5.defineProperty(domEvent, "reason", {value: event.reason});
                return dispatch(legacyHandlers[name], domEvent);
            };
        } else {
            var event = document.createEvent("CustomEvent");
            event.initCustomEvent("testingtheevent", false, true, {});
            util.global.dispatchEvent(event);
            return function(name, event) {
                name = name.toLowerCase();
                var domEvent = document.createEvent("CustomEvent");
                domEvent.initCustomEvent(name, false, true,
                    event);
                return dispatch(legacyHandlers[name], domEvent);
            };
        }
    } catch (e) {}
    return function() {
        return false;
    };
})();

var fireGlobalEvent = (function() {
    if (util.isNode) {
        return function() {
            return process.emit.apply(process, arguments);
        };
    } else {
        if (!util.global) {
            return function() {
                return false;
            };
        }
        return function(name) {
            var methodName = "on" + name.toLowerCase();
            var method = util.global[methodName];
            if (!method) return false;
            method.apply(util.global, [].slice.call(arguments, 1));
            return true;
        };
    }
})();

function generatePromiseLifecycleEventObject(name, promise) {
    return {promise: promise};
}

var eventToObjectGenerator = {
    promiseCreated: generatePromiseLifecycleEventObject,
    promiseFulfilled: generatePromiseLifecycleEventObject,
    promiseRejected: generatePromiseLifecycleEventObject,
    promiseResolved: generatePromiseLifecycleEventObject,
    promiseCancelled: generatePromiseLifecycleEventObject,
    promiseChained: function(name, promise, child) {
        return {promise: promise, child: child};
    },
    warning: function(name, warning) {
        return {warning: warning};
    },
    unhandledRejection: function (name, reason, promise) {
        return {reason: reason, promise: promise};
    },
    rejectionHandled: generatePromiseLifecycleEventObject
};

var activeFireEvent = function (name) {
    var globalEventFired = false;
    try {
        globalEventFired = fireGlobalEvent.apply(null, arguments);
    } catch (e) {
        async.throwLater(e);
        globalEventFired = true;
    }

    var domEventFired = false;
    try {
        domEventFired = fireDomEvent(name,
                    eventToObjectGenerator[name].apply(null, arguments));
    } catch (e) {
        async.throwLater(e);
        domEventFired = true;
    }

    return domEventFired || globalEventFired;
};

Promise.config = function(opts) {
    opts = Object(opts);
    if ("longStackTraces" in opts) {
        if (opts.longStackTraces) {
            Promise.longStackTraces();
        } else if (!opts.longStackTraces && Promise.hasLongStackTraces()) {
            disableLongStackTraces();
        }
    }
    if ("warnings" in opts) {
        var warningsOption = opts.warnings;
        config.warnings = !!warningsOption;
        wForgottenReturn = config.warnings;

        if (util.isObject(warningsOption)) {
            if ("wForgottenReturn" in warningsOption) {
                wForgottenReturn = !!warningsOption.wForgottenReturn;
            }
        }
    }
    if ("cancellation" in opts && opts.cancellation && !config.cancellation) {
        if (async.haveItemsQueued()) {
            throw new Error(
                "cannot enable cancellation after promises are in use");
        }
        Promise.prototype._clearCancellationData =
            cancellationClearCancellationData;
        Promise.prototype._propagateFrom = cancellationPropagateFrom;
        Promise.prototype._onCancel = cancellationOnCancel;
        Promise.prototype._setOnCancel = cancellationSetOnCancel;
        Promise.prototype._attachCancellationCallback =
            cancellationAttachCancellationCallback;
        Promise.prototype._execute = cancellationExecute;
        propagateFromFunction = cancellationPropagateFrom;
        config.cancellation = true;
    }
    if ("monitoring" in opts) {
        if (opts.monitoring && !config.monitoring) {
            config.monitoring = true;
            Promise.prototype._fireEvent = activeFireEvent;
        } else if (!opts.monitoring && config.monitoring) {
            config.monitoring = false;
            Promise.prototype._fireEvent = defaultFireEvent;
        }
    }
    if ("asyncHooks" in opts && util.nodeSupportsAsyncResource) {
        var prev = config.asyncHooks;
        var cur = !!opts.asyncHooks;
        if (prev !== cur) {
            config.asyncHooks = cur;
            if (cur) {
                enableAsyncHooks();
            } else {
                disableAsyncHooks();
            }
        }
    }
    return Promise;
};

function defaultFireEvent() { return false; }

Promise.prototype._fireEvent = defaultFireEvent;
Promise.prototype._execute = function(executor, resolve, reject) {
    try {
        executor(resolve, reject);
    } catch (e) {
        return e;
    }
};
Promise.prototype._onCancel = function () {};
Promise.prototype._setOnCancel = function (handler) { ; };
Promise.prototype._attachCancellationCallback = function(onCancel) {
    ;
};
Promise.prototype._captureStackTrace = function () {};
Promise.prototype._attachExtraTrace = function () {};
Promise.prototype._dereferenceTrace = function () {};
Promise.prototype._clearCancellationData = function() {};
Promise.prototype._propagateFrom = function (parent, flags) {
    ;
    ;
};

function cancellationExecute(executor, resolve, reject) {
    var promise = this;
    try {
        executor(resolve, reject, function(onCancel) {
            if (typeof onCancel !== "function") {
                throw new TypeError("onCancel must be a function, got: " +
                                    util.toString(onCancel));
            }
            promise._attachCancellationCallback(onCancel);
        });
    } catch (e) {
        return e;
    }
}

function cancellationAttachCancellationCallback(onCancel) {
    if (!this._isCancellable()) return this;

    var previousOnCancel = this._onCancel();
    if (previousOnCancel !== undefined) {
        if (util.isArray(previousOnCancel)) {
            previousOnCancel.push(onCancel);
        } else {
            this._setOnCancel([previousOnCancel, onCancel]);
        }
    } else {
        this._setOnCancel(onCancel);
    }
}

function cancellationOnCancel() {
    return this._onCancelField;
}

function cancellationSetOnCancel(onCancel) {
    this._onCancelField = onCancel;
}

function cancellationClearCancellationData() {
    this._cancellationParent = undefined;
    this._onCancelField = undefined;
}

function cancellationPropagateFrom(parent, flags) {
    if ((flags & 1) !== 0) {
        this._cancellationParent = parent;
        var branchesRemainingToCancel = parent._branchesRemainingToCancel;
        if (branchesRemainingToCancel === undefined) {
            branchesRemainingToCancel = 0;
        }
        parent._branchesRemainingToCancel = branchesRemainingToCancel + 1;
    }
    if ((flags & 2) !== 0 && parent._isBound()) {
        this._setBoundTo(parent._boundTo);
    }
}

function bindingPropagateFrom(parent, flags) {
    if ((flags & 2) !== 0 && parent._isBound()) {
        this._setBoundTo(parent._boundTo);
    }
}
var propagateFromFunction = bindingPropagateFrom;

function boundValueFunction() {
    var ret = this._boundTo;
    if (ret !== undefined) {
        if (ret instanceof Promise) {
            if (ret.isFulfilled()) {
                return ret.value();
            } else {
                return undefined;
            }
        }
    }
    return ret;
}

function longStackTracesCaptureStackTrace() {
    this._trace = new CapturedTrace(this._peekContext());
}

function longStackTracesAttachExtraTrace(error, ignoreSelf) {
    if (canAttachTrace(error)) {
        var trace = this._trace;
        if (trace !== undefined) {
            if (ignoreSelf) trace = trace._parent;
        }
        if (trace !== undefined) {
            trace.attachExtraTrace(error);
        } else if (!error.__stackCleaned__) {
            var parsed = parseStackAndMessage(error);
            util.notEnumerableProp(error, "stack",
                parsed.message + "\n" + parsed.stack.join("\n"));
            util.notEnumerableProp(error, "__stackCleaned__", true);
        }
    }
}

function longStackTracesDereferenceTrace() {
    this._trace = undefined;
}

function checkForgottenReturns(returnValue, promiseCreated, name, promise,
                               parent) {
    if (returnValue === undefined && promiseCreated !== null &&
        wForgottenReturn) {
        if (parent !== undefined && parent._returnedNonUndefined()) return;
        if ((promise._bitField & 65535) === 0) return;

        if (name) name = name + " ";
        var handlerLine = "";
        var creatorLine = "";
        if (promiseCreated._trace) {
            var traceLines = promiseCreated._trace.stack.split("\n");
            var stack = cleanStack(traceLines);
            for (var i = stack.length - 1; i >= 0; --i) {
                var line = stack[i];
                if (!nodeFramePattern.test(line)) {
                    var lineMatches = line.match(parseLinePattern);
                    if (lineMatches) {
                        handlerLine  = "at " + lineMatches[1] +
                            ":" + lineMatches[2] + ":" + lineMatches[3] + " ";
                    }
                    break;
                }
            }

            if (stack.length > 0) {
                var firstUserLine = stack[0];
                for (var i = 0; i < traceLines.length; ++i) {

                    if (traceLines[i] === firstUserLine) {
                        if (i > 0) {
                            creatorLine = "\n" + traceLines[i - 1];
                        }
                        break;
                    }
                }

            }
        }
        var msg = "a promise was created in a " + name +
            "handler " + handlerLine + "but was not returned from it, " +
            "see http://goo.gl/rRqMUw" +
            creatorLine;
        promise._warn(msg, true, promiseCreated);
    }
}

function deprecated(name, replacement) {
    var message = name +
        " is deprecated and will be removed in a future version.";
    if (replacement) message += " Use " + replacement + " instead.";
    return warn(message);
}

function warn(message, shouldUseOwnTrace, promise) {
    if (!config.warnings) return;
    var warning = new Warning(message);
    var ctx;
    if (shouldUseOwnTrace) {
        promise._attachExtraTrace(warning);
    } else if (config.longStackTraces && (ctx = Promise._peekContext())) {
        ctx.attachExtraTrace(warning);
    } else {
        var parsed = parseStackAndMessage(warning);
        warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
    }

    if (!activeFireEvent("warning", warning)) {
        formatAndLogError(warning, "", true);
    }
}

function reconstructStack(message, stacks) {
    for (var i = 0; i < stacks.length - 1; ++i) {
        stacks[i].push("From previous event:");
        stacks[i] = stacks[i].join("\n");
    }
    if (i < stacks.length) {
        stacks[i] = stacks[i].join("\n");
    }
    return message + "\n" + stacks.join("\n");
}

function removeDuplicateOrEmptyJumps(stacks) {
    for (var i = 0; i < stacks.length; ++i) {
        if (stacks[i].length === 0 ||
            ((i + 1 < stacks.length) && stacks[i][0] === stacks[i+1][0])) {
            stacks.splice(i, 1);
            i--;
        }
    }
}

function removeCommonRoots(stacks) {
    var current = stacks[0];
    for (var i = 1; i < stacks.length; ++i) {
        var prev = stacks[i];
        var currentLastIndex = current.length - 1;
        var currentLastLine = current[currentLastIndex];
        var commonRootMeetPoint = -1;

        for (var j = prev.length - 1; j >= 0; --j) {
            if (prev[j] === currentLastLine) {
                commonRootMeetPoint = j;
                break;
            }
        }

        for (var j = commonRootMeetPoint; j >= 0; --j) {
            var line = prev[j];
            if (current[currentLastIndex] === line) {
                current.pop();
                currentLastIndex--;
            } else {
                break;
            }
        }
        current = prev;
    }
}

function cleanStack(stack) {
    var ret = [];
    for (var i = 0; i < stack.length; ++i) {
        var line = stack[i];
        var isTraceLine = "    (No stack trace)" === line ||
            stackFramePattern.test(line);
        var isInternalFrame = isTraceLine && shouldIgnore(line);
        if (isTraceLine && !isInternalFrame) {
            if (indentStackFrames && line.charAt(0) !== " ") {
                line = "    " + line;
            }
            ret.push(line);
        }
    }
    return ret;
}

function stackFramesAsArray(error) {
    var stack = error.stack.replace(/\s+$/g, "").split("\n");
    for (var i = 0; i < stack.length; ++i) {
        var line = stack[i];
        if ("    (No stack trace)" === line || stackFramePattern.test(line)) {
            break;
        }
    }
    if (i > 0 && error.name != "SyntaxError") {
        stack = stack.slice(i);
    }
    return stack;
}

function parseStackAndMessage(error) {
    var stack = error.stack;
    var message = error.toString();
    stack = typeof stack === "string" && stack.length > 0
                ? stackFramesAsArray(error) : ["    (No stack trace)"];
    return {
        message: message,
        stack: error.name == "SyntaxError" ? stack : cleanStack(stack)
    };
}

function formatAndLogError(error, title, isSoft) {
    if (typeof console !== "undefined") {
        var message;
        if (util.isObject(error)) {
            var stack = error.stack;
            message = title + formatStack(stack, error);
        } else {
            message = title + String(error);
        }
        if (typeof printWarning === "function") {
            printWarning(message, isSoft);
        } else if (typeof console.log === "function" ||
            typeof console.log === "object") {
            console.log(message);
        }
    }
}

function fireRejectionEvent(name, localHandler, reason, promise) {
    var localEventFired = false;
    try {
        if (typeof localHandler === "function") {
            localEventFired = true;
            if (name === "rejectionHandled") {
                localHandler(promise);
            } else {
                localHandler(reason, promise);
            }
        }
    } catch (e) {
        async.throwLater(e);
    }

    if (name === "unhandledRejection") {
        if (!activeFireEvent(name, reason, promise) && !localEventFired) {
            formatAndLogError(reason, "Unhandled rejection ");
        }
    } else {
        activeFireEvent(name, promise);
    }
}

function formatNonError(obj) {
    var str;
    if (typeof obj === "function") {
        str = "[function " +
            (obj.name || "anonymous") +
            "]";
    } else {
        str = obj && typeof obj.toString === "function"
            ? obj.toString() : util.toString(obj);
        var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
        if (ruselessToString.test(str)) {
            try {
                var newStr = JSON.stringify(obj);
                str = newStr;
            }
            catch(e) {

            }
        }
        if (str.length === 0) {
            str = "(empty array)";
        }
    }
    return ("(<" + snip(str) + ">, no stack trace)");
}

function snip(str) {
    var maxChars = 41;
    if (str.length < maxChars) {
        return str;
    }
    return str.substr(0, maxChars - 3) + "...";
}

function longStackTracesIsSupported() {
    return typeof captureStackTrace === "function";
}

var shouldIgnore = function() { return false; };
var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
function parseLineInfo(line) {
    var matches = line.match(parseLineInfoRegex);
    if (matches) {
        return {
            fileName: matches[1],
            line: parseInt(matches[2], 10)
        };
    }
}

function setBounds(firstLineError, lastLineError) {
    if (!longStackTracesIsSupported()) return;
    var firstStackLines = (firstLineError.stack || "").split("\n");
    var lastStackLines = (lastLineError.stack || "").split("\n");
    var firstIndex = -1;
    var lastIndex = -1;
    var firstFileName;
    var lastFileName;
    for (var i = 0; i < firstStackLines.length; ++i) {
        var result = parseLineInfo(firstStackLines[i]);
        if (result) {
            firstFileName = result.fileName;
            firstIndex = result.line;
            break;
        }
    }
    for (var i = 0; i < lastStackLines.length; ++i) {
        var result = parseLineInfo(lastStackLines[i]);
        if (result) {
            lastFileName = result.fileName;
            lastIndex = result.line;
            break;
        }
    }
    if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName ||
        firstFileName !== lastFileName || firstIndex >= lastIndex) {
        return;
    }

    shouldIgnore = function(line) {
        if (bluebirdFramePattern.test(line)) return true;
        var info = parseLineInfo(line);
        if (info) {
            if (info.fileName === firstFileName &&
                (firstIndex <= info.line && info.line <= lastIndex)) {
                return true;
            }
        }
        return false;
    };
}

function CapturedTrace(parent) {
    this._parent = parent;
    this._promisesCreated = 0;
    var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
    captureStackTrace(this, CapturedTrace);
    if (length > 32) this.uncycle();
}
util.inherits(CapturedTrace, Error);
Context.CapturedTrace = CapturedTrace;

CapturedTrace.prototype.uncycle = function() {
    var length = this._length;
    if (length < 2) return;
    var nodes = [];
    var stackToIndex = {};

    for (var i = 0, node = this; node !== undefined; ++i) {
        nodes.push(node);
        node = node._parent;
    }
    length = this._length = i;
    for (var i = length - 1; i >= 0; --i) {
        var stack = nodes[i].stack;
        if (stackToIndex[stack] === undefined) {
            stackToIndex[stack] = i;
        }
    }
    for (var i = 0; i < length; ++i) {
        var currentStack = nodes[i].stack;
        var index = stackToIndex[currentStack];
        if (index !== undefined && index !== i) {
            if (index > 0) {
                nodes[index - 1]._parent = undefined;
                nodes[index - 1]._length = 1;
            }
            nodes[i]._parent = undefined;
            nodes[i]._length = 1;
            var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;

            if (index < length - 1) {
                cycleEdgeNode._parent = nodes[index + 1];
                cycleEdgeNode._parent.uncycle();
                cycleEdgeNode._length =
                    cycleEdgeNode._parent._length + 1;
            } else {
                cycleEdgeNode._parent = undefined;
                cycleEdgeNode._length = 1;
            }
            var currentChildLength = cycleEdgeNode._length + 1;
            for (var j = i - 2; j >= 0; --j) {
                nodes[j]._length = currentChildLength;
                currentChildLength++;
            }
            return;
        }
    }
};

CapturedTrace.prototype.attachExtraTrace = function(error) {
    if (error.__stackCleaned__) return;
    this.uncycle();
    var parsed = parseStackAndMessage(error);
    var message = parsed.message;
    var stacks = [parsed.stack];

    var trace = this;
    while (trace !== undefined) {
        stacks.push(cleanStack(trace.stack.split("\n")));
        trace = trace._parent;
    }
    removeCommonRoots(stacks);
    removeDuplicateOrEmptyJumps(stacks);
    util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
    util.notEnumerableProp(error, "__stackCleaned__", true);
};

var captureStackTrace = (function stackDetection() {
    var v8stackFramePattern = /^\s*at\s*/;
    var v8stackFormatter = function(stack, error) {
        if (typeof stack === "string") return stack;

        if (error.name !== undefined &&
            error.message !== undefined) {
            return error.toString();
        }
        return formatNonError(error);
    };

    if (typeof Error.stackTraceLimit === "number" &&
        typeof Error.captureStackTrace === "function") {
        Error.stackTraceLimit += 6;
        stackFramePattern = v8stackFramePattern;
        formatStack = v8stackFormatter;
        var captureStackTrace = Error.captureStackTrace;

        shouldIgnore = function(line) {
            return bluebirdFramePattern.test(line);
        };
        return function(receiver, ignoreUntil) {
            Error.stackTraceLimit += 6;
            captureStackTrace(receiver, ignoreUntil);
            Error.stackTraceLimit -= 6;
        };
    }
    var err = new Error();

    if (typeof err.stack === "string" &&
        err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
        stackFramePattern = /@/;
        formatStack = v8stackFormatter;
        indentStackFrames = true;
        return function captureStackTrace(o) {
            o.stack = new Error().stack;
        };
    }

    var hasStackAfterThrow;
    try { throw new Error(); }
    catch(e) {
        hasStackAfterThrow = ("stack" in e);
    }
    if (!("stack" in err) && hasStackAfterThrow &&
        typeof Error.stackTraceLimit === "number") {
        stackFramePattern = v8stackFramePattern;
        formatStack = v8stackFormatter;
        return function captureStackTrace(o) {
            Error.stackTraceLimit += 6;
            try { throw new Error(); }
            catch(e) { o.stack = e.stack; }
            Error.stackTraceLimit -= 6;
        };
    }

    formatStack = function(stack, error) {
        if (typeof stack === "string") return stack;

        if ((typeof error === "object" ||
            typeof error === "function") &&
            error.name !== undefined &&
            error.message !== undefined) {
            return error.toString();
        }
        return formatNonError(error);
    };

    return null;

})([]);

if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
    printWarning = function (message) {
        console.warn(message);
    };
    if (util.isNode && process.stderr.isTTY) {
        printWarning = function(message, isSoft) {
            var color = isSoft ? "\u001b[33m" : "\u001b[31m";
            console.warn(color + message + "\u001b[0m\n");
        };
    } else if (!util.isNode && typeof (new Error().stack) === "string") {
        printWarning = function(message, isSoft) {
            console.warn("%c" + message,
                        isSoft ? "color: darkorange" : "color: red");
        };
    }
}

var config = {
    warnings: warnings,
    longStackTraces: false,
    cancellation: false,
    monitoring: false,
    asyncHooks: false
};

if (longStackTraces) Promise.longStackTraces();

return {
    asyncHooks: function() {
        return config.asyncHooks;
    },
    longStackTraces: function() {
        return config.longStackTraces;
    },
    warnings: function() {
        return config.warnings;
    },
    cancellation: function() {
        return config.cancellation;
    },
    monitoring: function() {
        return config.monitoring;
    },
    propagateFromFunction: function() {
        return propagateFromFunction;
    },
    boundValueFunction: function() {
        return boundValueFunction;
    },
    checkForgottenReturns: checkForgottenReturns,
    setBounds: setBounds,
    warn: warn,
    deprecated: deprecated,
    CapturedTrace: CapturedTrace,
    fireDomEvent: fireDomEvent,
    fireGlobalEvent: fireGlobalEvent
};
};

},{"./errors":12,"./es5":13,"./util":36}],10:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
function returner() {
    return this.value;
}
function thrower() {
    throw this.reason;
}

Promise.prototype["return"] =
Promise.prototype.thenReturn = function (value) {
    if (value instanceof Promise) value.suppressUnhandledRejections();
    return this._then(
        returner, undefined, undefined, {value: value}, undefined);
};

Promise.prototype["throw"] =
Promise.prototype.thenThrow = function (reason) {
    return this._then(
        thrower, undefined, undefined, {reason: reason}, undefined);
};

Promise.prototype.catchThrow = function (reason) {
    if (arguments.length <= 1) {
        return this._then(
            undefined, thrower, undefined, {reason: reason}, undefined);
    } else {
        var _reason = arguments[1];
        var handler = function() {throw _reason;};
        return this.caught(reason, handler);
    }
};

Promise.prototype.catchReturn = function (value) {
    if (arguments.length <= 1) {
        if (value instanceof Promise) value.suppressUnhandledRejections();
        return this._then(
            undefined, returner, undefined, {value: value}, undefined);
    } else {
        var _value = arguments[1];
        if (_value instanceof Promise) _value.suppressUnhandledRejections();
        var handler = function() {return _value;};
        return this.caught(value, handler);
    }
};
};

},{}],11:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var PromiseReduce = Promise.reduce;
var PromiseAll = Promise.all;

function promiseAllThis() {
    return PromiseAll(this);
}

function PromiseMapSeries(promises, fn) {
    return PromiseReduce(promises, fn, INTERNAL, INTERNAL);
}

Promise.prototype.each = function (fn) {
    return PromiseReduce(this, fn, INTERNAL, 0)
              ._then(promiseAllThis, undefined, undefined, this, undefined);
};

Promise.prototype.mapSeries = function (fn) {
    return PromiseReduce(this, fn, INTERNAL, INTERNAL);
};

Promise.each = function (promises, fn) {
    return PromiseReduce(promises, fn, INTERNAL, 0)
              ._then(promiseAllThis, undefined, undefined, promises, undefined);
};

Promise.mapSeries = PromiseMapSeries;
};


},{}],12:[function(_dereq_,module,exports){
"use strict";
var es5 = _dereq_("./es5");
var Objectfreeze = es5.freeze;
var util = _dereq_("./util");
var inherits = util.inherits;
var notEnumerableProp = util.notEnumerableProp;

function subError(nameProperty, defaultMessage) {
    function SubError(message) {
        if (!(this instanceof SubError)) return new SubError(message);
        notEnumerableProp(this, "message",
            typeof message === "string" ? message : defaultMessage);
        notEnumerableProp(this, "name", nameProperty);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, this.constructor);
        } else {
            Error.call(this);
        }
    }
    inherits(SubError, Error);
    return SubError;
}

var _TypeError, _RangeError;
var Warning = subError("Warning", "warning");
var CancellationError = subError("CancellationError", "cancellation error");
var TimeoutError = subError("TimeoutError", "timeout error");
var AggregateError = subError("AggregateError", "aggregate error");
try {
    _TypeError = TypeError;
    _RangeError = RangeError;
} catch(e) {
    _TypeError = subError("TypeError", "type error");
    _RangeError = subError("RangeError", "range error");
}

var methods = ("join pop push shift unshift slice filter forEach some " +
    "every map indexOf lastIndexOf reduce reduceRight sort reverse").split(" ");

for (var i = 0; i < methods.length; ++i) {
    if (typeof Array.prototype[methods[i]] === "function") {
        AggregateError.prototype[methods[i]] = Array.prototype[methods[i]];
    }
}

es5.defineProperty(AggregateError.prototype, "length", {
    value: 0,
    configurable: false,
    writable: true,
    enumerable: true
});
AggregateError.prototype["isOperational"] = true;
var level = 0;
AggregateError.prototype.toString = function() {
    var indent = Array(level * 4 + 1).join(" ");
    var ret = "\n" + indent + "AggregateError of:" + "\n";
    level++;
    indent = Array(level * 4 + 1).join(" ");
    for (var i = 0; i < this.length; ++i) {
        var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
        var lines = str.split("\n");
        for (var j = 0; j < lines.length; ++j) {
            lines[j] = indent + lines[j];
        }
        str = lines.join("\n");
        ret += str + "\n";
    }
    level--;
    return ret;
};

function OperationalError(message) {
    if (!(this instanceof OperationalError))
        return new OperationalError(message);
    notEnumerableProp(this, "name", "OperationalError");
    notEnumerableProp(this, "message", message);
    this.cause = message;
    this["isOperational"] = true;

    if (message instanceof Error) {
        notEnumerableProp(this, "message", message.message);
        notEnumerableProp(this, "stack", message.stack);
    } else if (Error.captureStackTrace) {
        Error.captureStackTrace(this, this.constructor);
    }

}
inherits(OperationalError, Error);

var errorTypes = Error["__BluebirdErrorTypes__"];
if (!errorTypes) {
    errorTypes = Objectfreeze({
        CancellationError: CancellationError,
        TimeoutError: TimeoutError,
        OperationalError: OperationalError,
        RejectionError: OperationalError,
        AggregateError: AggregateError
    });
    es5.defineProperty(Error, "__BluebirdErrorTypes__", {
        value: errorTypes,
        writable: false,
        enumerable: false,
        configurable: false
    });
}

module.exports = {
    Error: Error,
    TypeError: _TypeError,
    RangeError: _RangeError,
    CancellationError: errorTypes.CancellationError,
    OperationalError: errorTypes.OperationalError,
    TimeoutError: errorTypes.TimeoutError,
    AggregateError: errorTypes.AggregateError,
    Warning: Warning
};

},{"./es5":13,"./util":36}],13:[function(_dereq_,module,exports){
var isES5 = (function(){
    "use strict";
    return this === undefined;
})();

if (isES5) {
    module.exports = {
        freeze: Object.freeze,
        defineProperty: Object.defineProperty,
        getDescriptor: Object.getOwnPropertyDescriptor,
        keys: Object.keys,
        names: Object.getOwnPropertyNames,
        getPrototypeOf: Object.getPrototypeOf,
        isArray: Array.isArray,
        isES5: isES5,
        propertyIsWritable: function(obj, prop) {
            var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
            return !!(!descriptor || descriptor.writable || descriptor.set);
        }
    };
} else {
    var has = {}.hasOwnProperty;
    var str = {}.toString;
    var proto = {}.constructor.prototype;

    var ObjectKeys = function (o) {
        var ret = [];
        for (var key in o) {
            if (has.call(o, key)) {
                ret.push(key);
            }
        }
        return ret;
    };

    var ObjectGetDescriptor = function(o, key) {
        return {value: o[key]};
    };

    var ObjectDefineProperty = function (o, key, desc) {
        o[key] = desc.value;
        return o;
    };

    var ObjectFreeze = function (obj) {
        return obj;
    };

    var ObjectGetPrototypeOf = function (obj) {
        try {
            return Object(obj).constructor.prototype;
        }
        catch (e) {
            return proto;
        }
    };

    var ArrayIsArray = function (obj) {
        try {
            return str.call(obj) === "[object Array]";
        }
        catch(e) {
            return false;
        }
    };

    module.exports = {
        isArray: ArrayIsArray,
        keys: ObjectKeys,
        names: ObjectKeys,
        defineProperty: ObjectDefineProperty,
        getDescriptor: ObjectGetDescriptor,
        freeze: ObjectFreeze,
        getPrototypeOf: ObjectGetPrototypeOf,
        isES5: isES5,
        propertyIsWritable: function() {
            return true;
        }
    };
}

},{}],14:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var PromiseMap = Promise.map;

Promise.prototype.filter = function (fn, options) {
    return PromiseMap(this, fn, options, INTERNAL);
};

Promise.filter = function (promises, fn, options) {
    return PromiseMap(promises, fn, options, INTERNAL);
};
};

},{}],15:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, tryConvertToPromise, NEXT_FILTER) {
var util = _dereq_("./util");
var CancellationError = Promise.CancellationError;
var errorObj = util.errorObj;
var catchFilter = _dereq_("./catch_filter")(NEXT_FILTER);

function PassThroughHandlerContext(promise, type, handler) {
    this.promise = promise;
    this.type = type;
    this.handler = handler;
    this.called = false;
    this.cancelPromise = null;
}

PassThroughHandlerContext.prototype.isFinallyHandler = function() {
    return this.type === 0;
};

function FinallyHandlerCancelReaction(finallyHandler) {
    this.finallyHandler = finallyHandler;
}

FinallyHandlerCancelReaction.prototype._resultCancelled = function() {
    checkCancel(this.finallyHandler);
};

function checkCancel(ctx, reason) {
    if (ctx.cancelPromise != null) {
        if (arguments.length > 1) {
            ctx.cancelPromise._reject(reason);
        } else {
            ctx.cancelPromise._cancel();
        }
        ctx.cancelPromise = null;
        return true;
    }
    return false;
}

function succeed() {
    return finallyHandler.call(this, this.promise._target()._settledValue());
}
function fail(reason) {
    if (checkCancel(this, reason)) return;
    errorObj.e = reason;
    return errorObj;
}
function finallyHandler(reasonOrValue) {
    var promise = this.promise;
    var handler = this.handler;

    if (!this.called) {
        this.called = true;
        var ret = this.isFinallyHandler()
            ? handler.call(promise._boundValue())
            : handler.call(promise._boundValue(), reasonOrValue);
        if (ret === NEXT_FILTER) {
            return ret;
        } else if (ret !== undefined) {
            promise._setReturnedNonUndefined();
            var maybePromise = tryConvertToPromise(ret, promise);
            if (maybePromise instanceof Promise) {
                if (this.cancelPromise != null) {
                    if (maybePromise._isCancelled()) {
                        var reason =
                            new CancellationError("late cancellation observer");
                        promise._attachExtraTrace(reason);
                        errorObj.e = reason;
                        return errorObj;
                    } else if (maybePromise.isPending()) {
                        maybePromise._attachCancellationCallback(
                            new FinallyHandlerCancelReaction(this));
                    }
                }
                return maybePromise._then(
                    succeed, fail, undefined, this, undefined);
            }
        }
    }

    if (promise.isRejected()) {
        checkCancel(this);
        errorObj.e = reasonOrValue;
        return errorObj;
    } else {
        checkCancel(this);
        return reasonOrValue;
    }
}

Promise.prototype._passThrough = function(handler, type, success, fail) {
    if (typeof handler !== "function") return this.then();
    return this._then(success,
                      fail,
                      undefined,
                      new PassThroughHandlerContext(this, type, handler),
                      undefined);
};

Promise.prototype.lastly =
Promise.prototype["finally"] = function (handler) {
    return this._passThrough(handler,
                             0,
                             finallyHandler,
                             finallyHandler);
};


Promise.prototype.tap = function (handler) {
    return this._passThrough(handler, 1, finallyHandler);
};

Promise.prototype.tapCatch = function (handlerOrPredicate) {
    var len = arguments.length;
    if(len === 1) {
        return this._passThrough(handlerOrPredicate,
                                 1,
                                 undefined,
                                 finallyHandler);
    } else {
         var catchInstances = new Array(len - 1),
            j = 0, i;
        for (i = 0; i < len - 1; ++i) {
            var item = arguments[i];
            if (util.isObject(item)) {
                catchInstances[j++] = item;
            } else {
                return Promise.reject(new TypeError(
                    "tapCatch statement predicate: "
                    + "expecting an object but got " + util.classString(item)
                ));
            }
        }
        catchInstances.length = j;
        var handler = arguments[i];
        return this._passThrough(catchFilter(catchInstances, handler, this),
                                 1,
                                 undefined,
                                 finallyHandler);
    }

};

return PassThroughHandlerContext;
};

},{"./catch_filter":7,"./util":36}],16:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise,
                          apiRejection,
                          INTERNAL,
                          tryConvertToPromise,
                          Proxyable,
                          debug) {
var errors = _dereq_("./errors");
var TypeError = errors.TypeError;
var util = _dereq_("./util");
var errorObj = util.errorObj;
var tryCatch = util.tryCatch;
var yieldHandlers = [];

function promiseFromYieldHandler(value, yieldHandlers, traceParent) {
    for (var i = 0; i < yieldHandlers.length; ++i) {
        traceParent._pushContext();
        var result = tryCatch(yieldHandlers[i])(value);
        traceParent._popContext();
        if (result === errorObj) {
            traceParent._pushContext();
            var ret = Promise.reject(errorObj.e);
            traceParent._popContext();
            return ret;
        }
        var maybePromise = tryConvertToPromise(result, traceParent);
        if (maybePromise instanceof Promise) return maybePromise;
    }
    return null;
}

function PromiseSpawn(generatorFunction, receiver, yieldHandler, stack) {
    if (debug.cancellation()) {
        var internal = new Promise(INTERNAL);
        var _finallyPromise = this._finallyPromise = new Promise(INTERNAL);
        this._promise = internal.lastly(function() {
            return _finallyPromise;
        });
        internal._captureStackTrace();
        internal._setOnCancel(this);
    } else {
        var promise = this._promise = new Promise(INTERNAL);
        promise._captureStackTrace();
    }
    this._stack = stack;
    this._generatorFunction = generatorFunction;
    this._receiver = receiver;
    this._generator = undefined;
    this._yieldHandlers = typeof yieldHandler === "function"
        ? [yieldHandler].concat(yieldHandlers)
        : yieldHandlers;
    this._yieldedPromise = null;
    this._cancellationPhase = false;
}
util.inherits(PromiseSpawn, Proxyable);

PromiseSpawn.prototype._isResolved = function() {
    return this._promise === null;
};

PromiseSpawn.prototype._cleanup = function() {
    this._promise = this._generator = null;
    if (debug.cancellation() && this._finallyPromise !== null) {
        this._finallyPromise._fulfill();
        this._finallyPromise = null;
    }
};

PromiseSpawn.prototype._promiseCancelled = function() {
    if (this._isResolved()) return;
    var implementsReturn = typeof this._generator["return"] !== "undefined";

    var result;
    if (!implementsReturn) {
        var reason = new Promise.CancellationError(
            "generator .return() sentinel");
        Promise.coroutine.returnSentinel = reason;
        this._promise._attachExtraTrace(reason);
        this._promise._pushContext();
        result = tryCatch(this._generator["throw"]).call(this._generator,
                                                         reason);
        this._promise._popContext();
    } else {
        this._promise._pushContext();
        result = tryCatch(this._generator["return"]).call(this._generator,
                                                          undefined);
        this._promise._popContext();
    }
    this._cancellationPhase = true;
    this._yieldedPromise = null;
    this._continue(result);
};

PromiseSpawn.prototype._promiseFulfilled = function(value) {
    this._yieldedPromise = null;
    this._promise._pushContext();
    var result = tryCatch(this._generator.next).call(this._generator, value);
    this._promise._popContext();
    this._continue(result);
};

PromiseSpawn.prototype._promiseRejected = function(reason) {
    this._yieldedPromise = null;
    this._promise._attachExtraTrace(reason);
    this._promise._pushContext();
    var result = tryCatch(this._generator["throw"])
        .call(this._generator, reason);
    this._promise._popContext();
    this._continue(result);
};

PromiseSpawn.prototype._resultCancelled = function() {
    if (this._yieldedPromise instanceof Promise) {
        var promise = this._yieldedPromise;
        this._yieldedPromise = null;
        promise.cancel();
    }
};

PromiseSpawn.prototype.promise = function () {
    return this._promise;
};

PromiseSpawn.prototype._run = function () {
    this._generator = this._generatorFunction.call(this._receiver);
    this._receiver =
        this._generatorFunction = undefined;
    this._promiseFulfilled(undefined);
};

PromiseSpawn.prototype._continue = function (result) {
    var promise = this._promise;
    if (result === errorObj) {
        this._cleanup();
        if (this._cancellationPhase) {
            return promise.cancel();
        } else {
            return promise._rejectCallback(result.e, false);
        }
    }

    var value = result.value;
    if (result.done === true) {
        this._cleanup();
        if (this._cancellationPhase) {
            return promise.cancel();
        } else {
            return promise._resolveCallback(value);
        }
    } else {
        var maybePromise = tryConvertToPromise(value, this._promise);
        if (!(maybePromise instanceof Promise)) {
            maybePromise =
                promiseFromYieldHandler(maybePromise,
                                        this._yieldHandlers,
                                        this._promise);
            if (maybePromise === null) {
                this._promiseRejected(
                    new TypeError(
                        "A value %s was yielded that could not be treated as a promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a\u000a".replace("%s", String(value)) +
                        "From coroutine:\u000a" +
                        this._stack.split("\n").slice(1, -7).join("\n")
                    )
                );
                return;
            }
        }
        maybePromise = maybePromise._target();
        var bitField = maybePromise._bitField;
        ;
        if (((bitField & 50397184) === 0)) {
            this._yieldedPromise = maybePromise;
            maybePromise._proxy(this, null);
        } else if (((bitField & 33554432) !== 0)) {
            Promise._async.invoke(
                this._promiseFulfilled, this, maybePromise._value()
            );
        } else if (((bitField & 16777216) !== 0)) {
            Promise._async.invoke(
                this._promiseRejected, this, maybePromise._reason()
            );
        } else {
            this._promiseCancelled();
        }
    }
};

Promise.coroutine = function (generatorFunction, options) {
    if (typeof generatorFunction !== "function") {
        throw new TypeError("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    var yieldHandler = Object(options).yieldHandler;
    var PromiseSpawn$ = PromiseSpawn;
    var stack = new Error().stack;
    return function () {
        var generator = generatorFunction.apply(this, arguments);
        var spawn = new PromiseSpawn$(undefined, undefined, yieldHandler,
                                      stack);
        var ret = spawn.promise();
        spawn._generator = generator;
        spawn._promiseFulfilled(undefined);
        return ret;
    };
};

Promise.coroutine.addYieldHandler = function(fn) {
    if (typeof fn !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(fn));
    }
    yieldHandlers.push(fn);
};

Promise.spawn = function (generatorFunction) {
    debug.deprecated("Promise.spawn()", "Promise.coroutine()");
    if (typeof generatorFunction !== "function") {
        return apiRejection("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    var spawn = new PromiseSpawn(generatorFunction, this);
    var ret = spawn.promise();
    spawn._run(Promise.spawn);
    return ret;
};
};

},{"./errors":12,"./util":36}],17:[function(_dereq_,module,exports){
"use strict";
module.exports =
function(Promise, PromiseArray, tryConvertToPromise, INTERNAL, async) {
var util = _dereq_("./util");
var canEvaluate = util.canEvaluate;
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
var reject;

if (false) {
if (canEvaluate) {
    var thenCallback = function(i) {
        return new Function("value", "holder", "                             \n\
            'use strict';                                                    \n\
            holder.pIndex = value;                                           \n\
            holder.checkFulfillment(this);                                   \n\
            ".replace(/Index/g, i));
    };

    var promiseSetter = function(i) {
        return new Function("promise", "holder", "                           \n\
            'use strict';                                                    \n\
            holder.pIndex = promise;                                         \n\
            ".replace(/Index/g, i));
    };

    var generateHolderClass = function(total) {
        var props = new Array(total);
        for (var i = 0; i < props.length; ++i) {
            props[i] = "this.p" + (i+1);
        }
        var assignment = props.join(" = ") + " = null;";
        var cancellationCode= "var promise;\n" + props.map(function(prop) {
            return "                                                         \n\
                promise = " + prop + ";                                      \n\
                if (promise instanceof Promise) {                            \n\
                    promise.cancel();                                        \n\
                }                                                            \n\
            ";
        }).join("\n");
        var passedArguments = props.join(", ");
        var name = "Holder$" + total;


        var code = "return function(tryCatch, errorObj, Promise, async) {    \n\
            'use strict';                                                    \n\
            function [TheName](fn) {                                         \n\
                [TheProperties]                                              \n\
                this.fn = fn;                                                \n\
                this.asyncNeeded = true;                                     \n\
                this.now = 0;                                                \n\
            }                                                                \n\
                                                                             \n\
            [TheName].prototype._callFunction = function(promise) {          \n\
                promise._pushContext();                                      \n\
                var ret = tryCatch(this.fn)([ThePassedArguments]);           \n\
                promise._popContext();                                       \n\
                if (ret === errorObj) {                                      \n\
                    promise._rejectCallback(ret.e, false);                   \n\
                } else {                                                     \n\
                    promise._resolveCallback(ret);                           \n\
                }                                                            \n\
            };                                                               \n\
                                                                             \n\
            [TheName].prototype.checkFulfillment = function(promise) {       \n\
                var now = ++this.now;                                        \n\
                if (now === [TheTotal]) {                                    \n\
                    if (this.asyncNeeded) {                                  \n\
                        async.invoke(this._callFunction, this, promise);     \n\
                    } else {                                                 \n\
                        this._callFunction(promise);                         \n\
                    }                                                        \n\
                                                                             \n\
                }                                                            \n\
            };                                                               \n\
                                                                             \n\
            [TheName].prototype._resultCancelled = function() {              \n\
                [CancellationCode]                                           \n\
            };                                                               \n\
                                                                             \n\
            return [TheName];                                                \n\
        }(tryCatch, errorObj, Promise, async);                               \n\
        ";

        code = code.replace(/\[TheName\]/g, name)
            .replace(/\[TheTotal\]/g, total)
            .replace(/\[ThePassedArguments\]/g, passedArguments)
            .replace(/\[TheProperties\]/g, assignment)
            .replace(/\[CancellationCode\]/g, cancellationCode);

        return new Function("tryCatch", "errorObj", "Promise", "async", code)
                           (tryCatch, errorObj, Promise, async);
    };

    var holderClasses = [];
    var thenCallbacks = [];
    var promiseSetters = [];

    for (var i = 0; i < 8; ++i) {
        holderClasses.push(generateHolderClass(i + 1));
        thenCallbacks.push(thenCallback(i + 1));
        promiseSetters.push(promiseSetter(i + 1));
    }

    reject = function (reason) {
        this._reject(reason);
    };
}}

Promise.join = function () {
    var last = arguments.length - 1;
    var fn;
    if (last > 0 && typeof arguments[last] === "function") {
        fn = arguments[last];
        if (false) {
            if (last <= 8 && canEvaluate) {
                var ret = new Promise(INTERNAL);
                ret._captureStackTrace();
                var HolderClass = holderClasses[last - 1];
                var holder = new HolderClass(fn);
                var callbacks = thenCallbacks;

                for (var i = 0; i < last; ++i) {
                    var maybePromise = tryConvertToPromise(arguments[i], ret);
                    if (maybePromise instanceof Promise) {
                        maybePromise = maybePromise._target();
                        var bitField = maybePromise._bitField;
                        ;
                        if (((bitField & 50397184) === 0)) {
                            maybePromise._then(callbacks[i], reject,
                                               undefined, ret, holder);
                            promiseSetters[i](maybePromise, holder);
                            holder.asyncNeeded = false;
                        } else if (((bitField & 33554432) !== 0)) {
                            callbacks[i].call(ret,
                                              maybePromise._value(), holder);
                        } else if (((bitField & 16777216) !== 0)) {
                            ret._reject(maybePromise._reason());
                        } else {
                            ret._cancel();
                        }
                    } else {
                        callbacks[i].call(ret, maybePromise, holder);
                    }
                }

                if (!ret._isFateSealed()) {
                    if (holder.asyncNeeded) {
                        var context = Promise._getContext();
                        holder.fn = util.contextBind(context, holder.fn);
                    }
                    ret._setAsyncGuaranteed();
                    ret._setOnCancel(holder);
                }
                return ret;
            }
        }
    }
    var args = [].slice.call(arguments);;
    if (fn) args.pop();
    var ret = new PromiseArray(args).promise();
    return fn !== undefined ? ret.spread(fn) : ret;
};

};

},{"./util":36}],18:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise,
                          PromiseArray,
                          apiRejection,
                          tryConvertToPromise,
                          INTERNAL,
                          debug) {
var util = _dereq_("./util");
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
var async = Promise._async;

function MappingPromiseArray(promises, fn, limit, _filter) {
    this.constructor$(promises);
    this._promise._captureStackTrace();
    var context = Promise._getContext();
    this._callback = util.contextBind(context, fn);
    this._preservedValues = _filter === INTERNAL
        ? new Array(this.length())
        : null;
    this._limit = limit;
    this._inFlight = 0;
    this._queue = [];
    async.invoke(this._asyncInit, this, undefined);
    if (util.isArray(promises)) {
        for (var i = 0; i < promises.length; ++i) {
            var maybePromise = promises[i];
            if (maybePromise instanceof Promise) {
                maybePromise.suppressUnhandledRejections();
            }
        }
    }
}
util.inherits(MappingPromiseArray, PromiseArray);

MappingPromiseArray.prototype._asyncInit = function() {
    this._init$(undefined, -2);
};

MappingPromiseArray.prototype._init = function () {};

MappingPromiseArray.prototype._promiseFulfilled = function (value, index) {
    var values = this._values;
    var length = this.length();
    var preservedValues = this._preservedValues;
    var limit = this._limit;

    if (index < 0) {
        index = (index * -1) - 1;
        values[index] = value;
        if (limit >= 1) {
            this._inFlight--;
            this._drainQueue();
            if (this._isResolved()) return true;
        }
    } else {
        if (limit >= 1 && this._inFlight >= limit) {
            values[index] = value;
            this._queue.push(index);
            return false;
        }
        if (preservedValues !== null) preservedValues[index] = value;

        var promise = this._promise;
        var callback = this._callback;
        var receiver = promise._boundValue();
        promise._pushContext();
        var ret = tryCatch(callback).call(receiver, value, index, length);
        var promiseCreated = promise._popContext();
        debug.checkForgottenReturns(
            ret,
            promiseCreated,
            preservedValues !== null ? "Promise.filter" : "Promise.map",
            promise
        );
        if (ret === errorObj) {
            this._reject(ret.e);
            return true;
        }

        var maybePromise = tryConvertToPromise(ret, this._promise);
        if (maybePromise instanceof Promise) {
            maybePromise = maybePromise._target();
            var bitField = maybePromise._bitField;
            ;
            if (((bitField & 50397184) === 0)) {
                if (limit >= 1) this._inFlight++;
                values[index] = maybePromise;
                maybePromise._proxy(this, (index + 1) * -1);
                return false;
            } else if (((bitField & 33554432) !== 0)) {
                ret = maybePromise._value();
            } else if (((bitField & 16777216) !== 0)) {
                this._reject(maybePromise._reason());
                return true;
            } else {
                this._cancel();
                return true;
            }
        }
        values[index] = ret;
    }
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= length) {
        if (preservedValues !== null) {
            this._filter(values, preservedValues);
        } else {
            this._resolve(values);
        }
        return true;
    }
    return false;
};

MappingPromiseArray.prototype._drainQueue = function () {
    var queue = this._queue;
    var limit = this._limit;
    var values = this._values;
    while (queue.length > 0 && this._inFlight < limit) {
        if (this._isResolved()) return;
        var index = queue.pop();
        this._promiseFulfilled(values[index], index);
    }
};

MappingPromiseArray.prototype._filter = function (booleans, values) {
    var len = values.length;
    var ret = new Array(len);
    var j = 0;
    for (var i = 0; i < len; ++i) {
        if (booleans[i]) ret[j++] = values[i];
    }
    ret.length = j;
    this._resolve(ret);
};

MappingPromiseArray.prototype.preservedValues = function () {
    return this._preservedValues;
};

function map(promises, fn, options, _filter) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }

    var limit = 0;
    if (options !== undefined) {
        if (typeof options === "object" && options !== null) {
            if (typeof options.concurrency !== "number") {
                return Promise.reject(
                    new TypeError("'concurrency' must be a number but it is " +
                                    util.classString(options.concurrency)));
            }
            limit = options.concurrency;
        } else {
            return Promise.reject(new TypeError(
                            "options argument must be an object but it is " +
                             util.classString(options)));
        }
    }
    limit = typeof limit === "number" &&
        isFinite(limit) && limit >= 1 ? limit : 0;
    return new MappingPromiseArray(promises, fn, limit, _filter).promise();
}

Promise.prototype.map = function (fn, options) {
    return map(this, fn, options, null);
};

Promise.map = function (promises, fn, options, _filter) {
    return map(promises, fn, options, _filter);
};


};

},{"./util":36}],19:[function(_dereq_,module,exports){
"use strict";
module.exports =
function(Promise, INTERNAL, tryConvertToPromise, apiRejection, debug) {
var util = _dereq_("./util");
var tryCatch = util.tryCatch;

Promise.method = function (fn) {
    if (typeof fn !== "function") {
        throw new Promise.TypeError("expecting a function but got " + util.classString(fn));
    }
    return function () {
        var ret = new Promise(INTERNAL);
        ret._captureStackTrace();
        ret._pushContext();
        var value = tryCatch(fn).apply(this, arguments);
        var promiseCreated = ret._popContext();
        debug.checkForgottenReturns(
            value, promiseCreated, "Promise.method", ret);
        ret._resolveFromSyncValue(value);
        return ret;
    };
};

Promise.attempt = Promise["try"] = function (fn) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }
    var ret = new Promise(INTERNAL);
    ret._captureStackTrace();
    ret._pushContext();
    var value;
    if (arguments.length > 1) {
        debug.deprecated("calling Promise.try with more than 1 argument");
        var arg = arguments[1];
        var ctx = arguments[2];
        value = util.isArray(arg) ? tryCatch(fn).apply(ctx, arg)
                                  : tryCatch(fn).call(ctx, arg);
    } else {
        value = tryCatch(fn)();
    }
    var promiseCreated = ret._popContext();
    debug.checkForgottenReturns(
        value, promiseCreated, "Promise.try", ret);
    ret._resolveFromSyncValue(value);
    return ret;
};

Promise.prototype._resolveFromSyncValue = function (value) {
    if (value === util.errorObj) {
        this._rejectCallback(value.e, false);
    } else {
        this._resolveCallback(value, true);
    }
};
};

},{"./util":36}],20:[function(_dereq_,module,exports){
"use strict";
var util = _dereq_("./util");
var maybeWrapAsError = util.maybeWrapAsError;
var errors = _dereq_("./errors");
var OperationalError = errors.OperationalError;
var es5 = _dereq_("./es5");

function isUntypedError(obj) {
    return obj instanceof Error &&
        es5.getPrototypeOf(obj) === Error.prototype;
}

var rErrorKey = /^(?:name|message|stack|cause)$/;
function wrapAsOperationalError(obj) {
    var ret;
    if (isUntypedError(obj)) {
        ret = new OperationalError(obj);
        ret.name = obj.name;
        ret.message = obj.message;
        ret.stack = obj.stack;
        var keys = es5.keys(obj);
        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!rErrorKey.test(key)) {
                ret[key] = obj[key];
            }
        }
        return ret;
    }
    util.markAsOriginatingFromRejection(obj);
    return obj;
}

function nodebackForPromise(promise, multiArgs) {
    return function(err, value) {
        if (promise === null) return;
        if (err) {
            var wrapped = wrapAsOperationalError(maybeWrapAsError(err));
            promise._attachExtraTrace(wrapped);
            promise._reject(wrapped);
        } else if (!multiArgs) {
            promise._fulfill(value);
        } else {
            var args = [].slice.call(arguments, 1);;
            promise._fulfill(args);
        }
        promise = null;
    };
}

module.exports = nodebackForPromise;

},{"./errors":12,"./es5":13,"./util":36}],21:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
var util = _dereq_("./util");
var async = Promise._async;
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;

function spreadAdapter(val, nodeback) {
    var promise = this;
    if (!util.isArray(val)) return successAdapter.call(promise, val, nodeback);
    var ret =
        tryCatch(nodeback).apply(promise._boundValue(), [null].concat(val));
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}

function successAdapter(val, nodeback) {
    var promise = this;
    var receiver = promise._boundValue();
    var ret = val === undefined
        ? tryCatch(nodeback).call(receiver, null)
        : tryCatch(nodeback).call(receiver, null, val);
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}
function errorAdapter(reason, nodeback) {
    var promise = this;
    if (!reason) {
        var newReason = new Error(reason + "");
        newReason.cause = reason;
        reason = newReason;
    }
    var ret = tryCatch(nodeback).call(promise._boundValue(), reason);
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}

Promise.prototype.asCallback = Promise.prototype.nodeify = function (nodeback,
                                                                     options) {
    if (typeof nodeback == "function") {
        var adapter = successAdapter;
        if (options !== undefined && Object(options).spread) {
            adapter = spreadAdapter;
        }
        this._then(
            adapter,
            errorAdapter,
            undefined,
            this,
            nodeback
        );
    }
    return this;
};
};

},{"./util":36}],22:[function(_dereq_,module,exports){
"use strict";
module.exports = function() {
var makeSelfResolutionError = function () {
    return new TypeError("circular promise resolution chain\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
};
var reflectHandler = function() {
    return new Promise.PromiseInspection(this._target());
};
var apiRejection = function(msg) {
    return Promise.reject(new TypeError(msg));
};
function Proxyable() {}
var UNDEFINED_BINDING = {};
var util = _dereq_("./util");
util.setReflectHandler(reflectHandler);

var getDomain = function() {
    var domain = process.domain;
    if (domain === undefined) {
        return null;
    }
    return domain;
};
var getContextDefault = function() {
    return null;
};
var getContextDomain = function() {
    return {
        domain: getDomain(),
        async: null
    };
};
var AsyncResource = util.isNode && util.nodeSupportsAsyncResource ?
    _dereq_("async_hooks").AsyncResource : null;
var getContextAsyncHooks = function() {
    return {
        domain: getDomain(),
        async: new AsyncResource("Bluebird::Promise")
    };
};
var getContext = util.isNode ? getContextDomain : getContextDefault;
util.notEnumerableProp(Promise, "_getContext", getContext);
var enableAsyncHooks = function() {
    getContext = getContextAsyncHooks;
    util.notEnumerableProp(Promise, "_getContext", getContextAsyncHooks);
};
var disableAsyncHooks = function() {
    getContext = getContextDomain;
    util.notEnumerableProp(Promise, "_getContext", getContextDomain);
};

var es5 = _dereq_("./es5");
var Async = _dereq_("./async");
var async = new Async();
es5.defineProperty(Promise, "_async", {value: async});
var errors = _dereq_("./errors");
var TypeError = Promise.TypeError = errors.TypeError;
Promise.RangeError = errors.RangeError;
var CancellationError = Promise.CancellationError = errors.CancellationError;
Promise.TimeoutError = errors.TimeoutError;
Promise.OperationalError = errors.OperationalError;
Promise.RejectionError = errors.OperationalError;
Promise.AggregateError = errors.AggregateError;
var INTERNAL = function(){};
var APPLY = {};
var NEXT_FILTER = {};
var tryConvertToPromise = _dereq_("./thenables")(Promise, INTERNAL);
var PromiseArray =
    _dereq_("./promise_array")(Promise, INTERNAL,
                               tryConvertToPromise, apiRejection, Proxyable);
var Context = _dereq_("./context")(Promise);
 /*jshint unused:false*/
var createContext = Context.create;

var debug = _dereq_("./debuggability")(Promise, Context,
    enableAsyncHooks, disableAsyncHooks);
var CapturedTrace = debug.CapturedTrace;
var PassThroughHandlerContext =
    _dereq_("./finally")(Promise, tryConvertToPromise, NEXT_FILTER);
var catchFilter = _dereq_("./catch_filter")(NEXT_FILTER);
var nodebackForPromise = _dereq_("./nodeback");
var errorObj = util.errorObj;
var tryCatch = util.tryCatch;
function check(self, executor) {
    if (self == null || self.constructor !== Promise) {
        throw new TypeError("the promise constructor cannot be invoked directly\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    if (typeof executor !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(executor));
    }

}

function Promise(executor) {
    if (executor !== INTERNAL) {
        check(this, executor);
    }
    this._bitField = 0;
    this._fulfillmentHandler0 = undefined;
    this._rejectionHandler0 = undefined;
    this._promise0 = undefined;
    this._receiver0 = undefined;
    this._resolveFromExecutor(executor);
    this._promiseCreated();
    this._fireEvent("promiseCreated", this);
}

Promise.prototype.toString = function () {
    return "[object Promise]";
};

Promise.prototype.caught = Promise.prototype["catch"] = function (fn) {
    var len = arguments.length;
    if (len > 1) {
        var catchInstances = new Array(len - 1),
            j = 0, i;
        for (i = 0; i < len - 1; ++i) {
            var item = arguments[i];
            if (util.isObject(item)) {
                catchInstances[j++] = item;
            } else {
                return apiRejection("Catch statement predicate: " +
                    "expecting an object but got " + util.classString(item));
            }
        }
        catchInstances.length = j;
        fn = arguments[i];

        if (typeof fn !== "function") {
            throw new TypeError("The last argument to .catch() " +
                "must be a function, got " + util.toString(fn));
        }
        return this.then(undefined, catchFilter(catchInstances, fn, this));
    }
    return this.then(undefined, fn);
};

Promise.prototype.reflect = function () {
    return this._then(reflectHandler,
        reflectHandler, undefined, this, undefined);
};

Promise.prototype.then = function (didFulfill, didReject) {
    if (debug.warnings() && arguments.length > 0 &&
        typeof didFulfill !== "function" &&
        typeof didReject !== "function") {
        var msg = ".then() only accepts functions but was passed: " +
                util.classString(didFulfill);
        if (arguments.length > 1) {
            msg += ", " + util.classString(didReject);
        }
        this._warn(msg);
    }
    return this._then(didFulfill, didReject, undefined, undefined, undefined);
};

Promise.prototype.done = function (didFulfill, didReject) {
    var promise =
        this._then(didFulfill, didReject, undefined, undefined, undefined);
    promise._setIsFinal();
};

Promise.prototype.spread = function (fn) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }
    return this.all()._then(fn, undefined, undefined, APPLY, undefined);
};

Promise.prototype.toJSON = function () {
    var ret = {
        isFulfilled: false,
        isRejected: false,
        fulfillmentValue: undefined,
        rejectionReason: undefined
    };
    if (this.isFulfilled()) {
        ret.fulfillmentValue = this.value();
        ret.isFulfilled = true;
    } else if (this.isRejected()) {
        ret.rejectionReason = this.reason();
        ret.isRejected = true;
    }
    return ret;
};

Promise.prototype.all = function () {
    if (arguments.length > 0) {
        this._warn(".all() was passed arguments but it does not take any");
    }
    return new PromiseArray(this).promise();
};

Promise.prototype.error = function (fn) {
    return this.caught(util.originatesFromRejection, fn);
};

Promise.getNewLibraryCopy = module.exports;

Promise.is = function (val) {
    return val instanceof Promise;
};

Promise.fromNode = Promise.fromCallback = function(fn) {
    var ret = new Promise(INTERNAL);
    ret._captureStackTrace();
    var multiArgs = arguments.length > 1 ? !!Object(arguments[1]).multiArgs
                                         : false;
    var result = tryCatch(fn)(nodebackForPromise(ret, multiArgs));
    if (result === errorObj) {
        ret._rejectCallback(result.e, true);
    }
    if (!ret._isFateSealed()) ret._setAsyncGuaranteed();
    return ret;
};

Promise.all = function (promises) {
    return new PromiseArray(promises).promise();
};

Promise.cast = function (obj) {
    var ret = tryConvertToPromise(obj);
    if (!(ret instanceof Promise)) {
        ret = new Promise(INTERNAL);
        ret._captureStackTrace();
        ret._setFulfilled();
        ret._rejectionHandler0 = obj;
    }
    return ret;
};

Promise.resolve = Promise.fulfilled = Promise.cast;

Promise.reject = Promise.rejected = function (reason) {
    var ret = new Promise(INTERNAL);
    ret._captureStackTrace();
    ret._rejectCallback(reason, true);
    return ret;
};

Promise.setScheduler = function(fn) {
    if (typeof fn !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(fn));
    }
    return async.setScheduler(fn);
};

Promise.prototype._then = function (
    didFulfill,
    didReject,
    _,    receiver,
    internalData
) {
    var haveInternalData = internalData !== undefined;
    var promise = haveInternalData ? internalData : new Promise(INTERNAL);
    var target = this._target();
    var bitField = target._bitField;

    if (!haveInternalData) {
        promise._propagateFrom(this, 3);
        promise._captureStackTrace();
        if (receiver === undefined &&
            ((this._bitField & 2097152) !== 0)) {
            if (!((bitField & 50397184) === 0)) {
                receiver = this._boundValue();
            } else {
                receiver = target === this ? undefined : this._boundTo;
            }
        }
        this._fireEvent("promiseChained", this, promise);
    }

    var context = getContext();
    if (!((bitField & 50397184) === 0)) {
        var handler, value, settler = target._settlePromiseCtx;
        if (((bitField & 33554432) !== 0)) {
            value = target._rejectionHandler0;
            handler = didFulfill;
        } else if (((bitField & 16777216) !== 0)) {
            value = target._fulfillmentHandler0;
            handler = didReject;
            target._unsetRejectionIsUnhandled();
        } else {
            settler = target._settlePromiseLateCancellationObserver;
            value = new CancellationError("late cancellation observer");
            target._attachExtraTrace(value);
            handler = didReject;
        }

        async.invoke(settler, target, {
            handler: util.contextBind(context, handler),
            promise: promise,
            receiver: receiver,
            value: value
        });
    } else {
        target._addCallbacks(didFulfill, didReject, promise,
                receiver, context);
    }

    return promise;
};

Promise.prototype._length = function () {
    return this._bitField & 65535;
};

Promise.prototype._isFateSealed = function () {
    return (this._bitField & 117506048) !== 0;
};

Promise.prototype._isFollowing = function () {
    return (this._bitField & 67108864) === 67108864;
};

Promise.prototype._setLength = function (len) {
    this._bitField = (this._bitField & -65536) |
        (len & 65535);
};

Promise.prototype._setFulfilled = function () {
    this._bitField = this._bitField | 33554432;
    this._fireEvent("promiseFulfilled", this);
};

Promise.prototype._setRejected = function () {
    this._bitField = this._bitField | 16777216;
    this._fireEvent("promiseRejected", this);
};

Promise.prototype._setFollowing = function () {
    this._bitField = this._bitField | 67108864;
    this._fireEvent("promiseResolved", this);
};

Promise.prototype._setIsFinal = function () {
    this._bitField = this._bitField | 4194304;
};

Promise.prototype._isFinal = function () {
    return (this._bitField & 4194304) > 0;
};

Promise.prototype._unsetCancelled = function() {
    this._bitField = this._bitField & (~65536);
};

Promise.prototype._setCancelled = function() {
    this._bitField = this._bitField | 65536;
    this._fireEvent("promiseCancelled", this);
};

Promise.prototype._setWillBeCancelled = function() {
    this._bitField = this._bitField | 8388608;
};

Promise.prototype._setAsyncGuaranteed = function() {
    if (async.hasCustomScheduler()) return;
    var bitField = this._bitField;
    this._bitField = bitField |
        (((bitField & 536870912) >> 2) ^
        134217728);
};

Promise.prototype._setNoAsyncGuarantee = function() {
    this._bitField = (this._bitField | 536870912) &
        (~134217728);
};

Promise.prototype._receiverAt = function (index) {
    var ret = index === 0 ? this._receiver0 : this[
            index * 4 - 4 + 3];
    if (ret === UNDEFINED_BINDING) {
        return undefined;
    } else if (ret === undefined && this._isBound()) {
        return this._boundValue();
    }
    return ret;
};

Promise.prototype._promiseAt = function (index) {
    return this[
            index * 4 - 4 + 2];
};

Promise.prototype._fulfillmentHandlerAt = function (index) {
    return this[
            index * 4 - 4 + 0];
};

Promise.prototype._rejectionHandlerAt = function (index) {
    return this[
            index * 4 - 4 + 1];
};

Promise.prototype._boundValue = function() {};

Promise.prototype._migrateCallback0 = function (follower) {
    var bitField = follower._bitField;
    var fulfill = follower._fulfillmentHandler0;
    var reject = follower._rejectionHandler0;
    var promise = follower._promise0;
    var receiver = follower._receiverAt(0);
    if (receiver === undefined) receiver = UNDEFINED_BINDING;
    this._addCallbacks(fulfill, reject, promise, receiver, null);
};

Promise.prototype._migrateCallbackAt = function (follower, index) {
    var fulfill = follower._fulfillmentHandlerAt(index);
    var reject = follower._rejectionHandlerAt(index);
    var promise = follower._promiseAt(index);
    var receiver = follower._receiverAt(index);
    if (receiver === undefined) receiver = UNDEFINED_BINDING;
    this._addCallbacks(fulfill, reject, promise, receiver, null);
};

Promise.prototype._addCallbacks = function (
    fulfill,
    reject,
    promise,
    receiver,
    context
) {
    var index = this._length();

    if (index >= 65535 - 4) {
        index = 0;
        this._setLength(0);
    }

    if (index === 0) {
        this._promise0 = promise;
        this._receiver0 = receiver;
        if (typeof fulfill === "function") {
            this._fulfillmentHandler0 = util.contextBind(context, fulfill);
        }
        if (typeof reject === "function") {
            this._rejectionHandler0 = util.contextBind(context, reject);
        }
    } else {
        var base = index * 4 - 4;
        this[base + 2] = promise;
        this[base + 3] = receiver;
        if (typeof fulfill === "function") {
            this[base + 0] =
                util.contextBind(context, fulfill);
        }
        if (typeof reject === "function") {
            this[base + 1] =
                util.contextBind(context, reject);
        }
    }
    this._setLength(index + 1);
    return index;
};

Promise.prototype._proxy = function (proxyable, arg) {
    this._addCallbacks(undefined, undefined, arg, proxyable, null);
};

Promise.prototype._resolveCallback = function(value, shouldBind) {
    if (((this._bitField & 117506048) !== 0)) return;
    if (value === this)
        return this._rejectCallback(makeSelfResolutionError(), false);
    var maybePromise = tryConvertToPromise(value, this);
    if (!(maybePromise instanceof Promise)) return this._fulfill(value);

    if (shouldBind) this._propagateFrom(maybePromise, 2);


    var promise = maybePromise._target();

    if (promise === this) {
        this._reject(makeSelfResolutionError());
        return;
    }

    var bitField = promise._bitField;
    if (((bitField & 50397184) === 0)) {
        var len = this._length();
        if (len > 0) promise._migrateCallback0(this);
        for (var i = 1; i < len; ++i) {
            promise._migrateCallbackAt(this, i);
        }
        this._setFollowing();
        this._setLength(0);
        this._setFollowee(maybePromise);
    } else if (((bitField & 33554432) !== 0)) {
        this._fulfill(promise._value());
    } else if (((bitField & 16777216) !== 0)) {
        this._reject(promise._reason());
    } else {
        var reason = new CancellationError("late cancellation observer");
        promise._attachExtraTrace(reason);
        this._reject(reason);
    }
};

Promise.prototype._rejectCallback =
function(reason, synchronous, ignoreNonErrorWarnings) {
    var trace = util.ensureErrorObject(reason);
    var hasStack = trace === reason;
    if (!hasStack && !ignoreNonErrorWarnings && debug.warnings()) {
        var message = "a promise was rejected with a non-error: " +
            util.classString(reason);
        this._warn(message, true);
    }
    this._attachExtraTrace(trace, synchronous ? hasStack : false);
    this._reject(reason);
};

Promise.prototype._resolveFromExecutor = function (executor) {
    if (executor === INTERNAL) return;
    var promise = this;
    this._captureStackTrace();
    this._pushContext();
    var synchronous = true;
    var r = this._execute(executor, function(value) {
        promise._resolveCallback(value);
    }, function (reason) {
        promise._rejectCallback(reason, synchronous);
    });
    synchronous = false;
    this._popContext();

    if (r !== undefined) {
        promise._rejectCallback(r, true);
    }
};

Promise.prototype._settlePromiseFromHandler = function (
    handler, receiver, value, promise
) {
    var bitField = promise._bitField;
    if (((bitField & 65536) !== 0)) return;
    promise._pushContext();
    var x;
    if (receiver === APPLY) {
        if (!value || typeof value.length !== "number") {
            x = errorObj;
            x.e = new TypeError("cannot .spread() a non-array: " +
                                    util.classString(value));
        } else {
            x = tryCatch(handler).apply(this._boundValue(), value);
        }
    } else {
        x = tryCatch(handler).call(receiver, value);
    }
    var promiseCreated = promise._popContext();
    bitField = promise._bitField;
    if (((bitField & 65536) !== 0)) return;

    if (x === NEXT_FILTER) {
        promise._reject(value);
    } else if (x === errorObj) {
        promise._rejectCallback(x.e, false);
    } else {
        debug.checkForgottenReturns(x, promiseCreated, "",  promise, this);
        promise._resolveCallback(x);
    }
};

Promise.prototype._target = function() {
    var ret = this;
    while (ret._isFollowing()) ret = ret._followee();
    return ret;
};

Promise.prototype._followee = function() {
    return this._rejectionHandler0;
};

Promise.prototype._setFollowee = function(promise) {
    this._rejectionHandler0 = promise;
};

Promise.prototype._settlePromise = function(promise, handler, receiver, value) {
    var isPromise = promise instanceof Promise;
    var bitField = this._bitField;
    var asyncGuaranteed = ((bitField & 134217728) !== 0);
    if (((bitField & 65536) !== 0)) {
        if (isPromise) promise._invokeInternalOnCancel();

        if (receiver instanceof PassThroughHandlerContext &&
            receiver.isFinallyHandler()) {
            receiver.cancelPromise = promise;
            if (tryCatch(handler).call(receiver, value) === errorObj) {
                promise._reject(errorObj.e);
            }
        } else if (handler === reflectHandler) {
            promise._fulfill(reflectHandler.call(receiver));
        } else if (receiver instanceof Proxyable) {
            receiver._promiseCancelled(promise);
        } else if (isPromise || promise instanceof PromiseArray) {
            promise._cancel();
        } else {
            receiver.cancel();
        }
    } else if (typeof handler === "function") {
        if (!isPromise) {
            handler.call(receiver, value, promise);
        } else {
            if (asyncGuaranteed) promise._setAsyncGuaranteed();
            this._settlePromiseFromHandler(handler, receiver, value, promise);
        }
    } else if (receiver instanceof Proxyable) {
        if (!receiver._isResolved()) {
            if (((bitField & 33554432) !== 0)) {
                receiver._promiseFulfilled(value, promise);
            } else {
                receiver._promiseRejected(value, promise);
            }
        }
    } else if (isPromise) {
        if (asyncGuaranteed) promise._setAsyncGuaranteed();
        if (((bitField & 33554432) !== 0)) {
            promise._fulfill(value);
        } else {
            promise._reject(value);
        }
    }
};

Promise.prototype._settlePromiseLateCancellationObserver = function(ctx) {
    var handler = ctx.handler;
    var promise = ctx.promise;
    var receiver = ctx.receiver;
    var value = ctx.value;
    if (typeof handler === "function") {
        if (!(promise instanceof Promise)) {
            handler.call(receiver, value, promise);
        } else {
            this._settlePromiseFromHandler(handler, receiver, value, promise);
        }
    } else if (promise instanceof Promise) {
        promise._reject(value);
    }
};

Promise.prototype._settlePromiseCtx = function(ctx) {
    this._settlePromise(ctx.promise, ctx.handler, ctx.receiver, ctx.value);
};

Promise.prototype._settlePromise0 = function(handler, value, bitField) {
    var promise = this._promise0;
    var receiver = this._receiverAt(0);
    this._promise0 = undefined;
    this._receiver0 = undefined;
    this._settlePromise(promise, handler, receiver, value);
};

Promise.prototype._clearCallbackDataAtIndex = function(index) {
    var base = index * 4 - 4;
    this[base + 2] =
    this[base + 3] =
    this[base + 0] =
    this[base + 1] = undefined;
};

Promise.prototype._fulfill = function (value) {
    var bitField = this._bitField;
    if (((bitField & 117506048) >>> 16)) return;
    if (value === this) {
        var err = makeSelfResolutionError();
        this._attachExtraTrace(err);
        return this._reject(err);
    }
    this._setFulfilled();
    this._rejectionHandler0 = value;

    if ((bitField & 65535) > 0) {
        if (((bitField & 134217728) !== 0)) {
            this._settlePromises();
        } else {
            async.settlePromises(this);
        }
        this._dereferenceTrace();
    }
};

Promise.prototype._reject = function (reason) {
    var bitField = this._bitField;
    if (((bitField & 117506048) >>> 16)) return;
    this._setRejected();
    this._fulfillmentHandler0 = reason;

    if (this._isFinal()) {
        return async.fatalError(reason, util.isNode);
    }

    if ((bitField & 65535) > 0) {
        async.settlePromises(this);
    } else {
        this._ensurePossibleRejectionHandled();
    }
};

Promise.prototype._fulfillPromises = function (len, value) {
    for (var i = 1; i < len; i++) {
        var handler = this._fulfillmentHandlerAt(i);
        var promise = this._promiseAt(i);
        var receiver = this._receiverAt(i);
        this._clearCallbackDataAtIndex(i);
        this._settlePromise(promise, handler, receiver, value);
    }
};

Promise.prototype._rejectPromises = function (len, reason) {
    for (var i = 1; i < len; i++) {
        var handler = this._rejectionHandlerAt(i);
        var promise = this._promiseAt(i);
        var receiver = this._receiverAt(i);
        this._clearCallbackDataAtIndex(i);
        this._settlePromise(promise, handler, receiver, reason);
    }
};

Promise.prototype._settlePromises = function () {
    var bitField = this._bitField;
    var len = (bitField & 65535);

    if (len > 0) {
        if (((bitField & 16842752) !== 0)) {
            var reason = this._fulfillmentHandler0;
            this._settlePromise0(this._rejectionHandler0, reason, bitField);
            this._rejectPromises(len, reason);
        } else {
            var value = this._rejectionHandler0;
            this._settlePromise0(this._fulfillmentHandler0, value, bitField);
            this._fulfillPromises(len, value);
        }
        this._setLength(0);
    }
    this._clearCancellationData();
};

Promise.prototype._settledValue = function() {
    var bitField = this._bitField;
    if (((bitField & 33554432) !== 0)) {
        return this._rejectionHandler0;
    } else if (((bitField & 16777216) !== 0)) {
        return this._fulfillmentHandler0;
    }
};

if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
    es5.defineProperty(Promise.prototype, Symbol.toStringTag, {
        get: function () {
            return "Object";
        }
    });
}

function deferResolve(v) {this.promise._resolveCallback(v);}
function deferReject(v) {this.promise._rejectCallback(v, false);}

Promise.defer = Promise.pending = function() {
    debug.deprecated("Promise.defer", "new Promise");
    var promise = new Promise(INTERNAL);
    return {
        promise: promise,
        resolve: deferResolve,
        reject: deferReject
    };
};

util.notEnumerableProp(Promise,
                       "_makeSelfResolutionError",
                       makeSelfResolutionError);

_dereq_("./method")(Promise, INTERNAL, tryConvertToPromise, apiRejection,
    debug);
_dereq_("./bind")(Promise, INTERNAL, tryConvertToPromise, debug);
_dereq_("./cancel")(Promise, PromiseArray, apiRejection, debug);
_dereq_("./direct_resolve")(Promise);
_dereq_("./synchronous_inspection")(Promise);
_dereq_("./join")(
    Promise, PromiseArray, tryConvertToPromise, INTERNAL, async);
Promise.Promise = Promise;
Promise.version = "3.7.2";
_dereq_('./call_get.js')(Promise);
_dereq_('./generators.js')(Promise, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug);
_dereq_('./map.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
_dereq_('./nodeify.js')(Promise);
_dereq_('./promisify.js')(Promise, INTERNAL);
_dereq_('./props.js')(Promise, PromiseArray, tryConvertToPromise, apiRejection);
_dereq_('./race.js')(Promise, INTERNAL, tryConvertToPromise, apiRejection);
_dereq_('./reduce.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
_dereq_('./settle.js')(Promise, PromiseArray, debug);
_dereq_('./some.js')(Promise, PromiseArray, apiRejection);
_dereq_('./timers.js')(Promise, INTERNAL, debug);
_dereq_('./using.js')(Promise, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug);
_dereq_('./any.js')(Promise);
_dereq_('./each.js')(Promise, INTERNAL);
_dereq_('./filter.js')(Promise, INTERNAL);
                                                         
    util.toFastProperties(Promise);                                          
    util.toFastProperties(Promise.prototype);                                
    function fillTypes(value) {                                              
        var p = new Promise(INTERNAL);                                       
        p._fulfillmentHandler0 = value;                                      
        p._rejectionHandler0 = value;                                        
        p._promise0 = value;                                                 
        p._receiver0 = value;                                                
    }                                                                        
    // Complete slack tracking, opt out of field-type tracking and           
    // stabilize map                                                         
    fillTypes({a: 1});                                                       
    fillTypes({b: 2});                                                       
    fillTypes({c: 3});                                                       
    fillTypes(1);                                                            
    fillTypes(function(){});                                                 
    fillTypes(undefined);                                                    
    fillTypes(false);                                                        
    fillTypes(new Promise(INTERNAL));                                        
    debug.setBounds(Async.firstLineError, util.lastLineError);               
    return Promise;                                                          

};

},{"./any.js":1,"./async":2,"./bind":3,"./call_get.js":5,"./cancel":6,"./catch_filter":7,"./context":8,"./debuggability":9,"./direct_resolve":10,"./each.js":11,"./errors":12,"./es5":13,"./filter.js":14,"./finally":15,"./generators.js":16,"./join":17,"./map.js":18,"./method":19,"./nodeback":20,"./nodeify.js":21,"./promise_array":23,"./promisify.js":24,"./props.js":25,"./race.js":27,"./reduce.js":28,"./settle.js":30,"./some.js":31,"./synchronous_inspection":32,"./thenables":33,"./timers.js":34,"./using.js":35,"./util":36,"async_hooks":undefined}],23:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL, tryConvertToPromise,
    apiRejection, Proxyable) {
var util = _dereq_("./util");
var isArray = util.isArray;

function toResolutionValue(val) {
    switch(val) {
    case -2: return [];
    case -3: return {};
    case -6: return new Map();
    }
}

function PromiseArray(values) {
    var promise = this._promise = new Promise(INTERNAL);
    if (values instanceof Promise) {
        promise._propagateFrom(values, 3);
        values.suppressUnhandledRejections();
    }
    promise._setOnCancel(this);
    this._values = values;
    this._length = 0;
    this._totalResolved = 0;
    this._init(undefined, -2);
}
util.inherits(PromiseArray, Proxyable);

PromiseArray.prototype.length = function () {
    return this._length;
};

PromiseArray.prototype.promise = function () {
    return this._promise;
};

PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
    var values = tryConvertToPromise(this._values, this._promise);
    if (values instanceof Promise) {
        values = values._target();
        var bitField = values._bitField;
        ;
        this._values = values;

        if (((bitField & 50397184) === 0)) {
            this._promise._setAsyncGuaranteed();
            return values._then(
                init,
                this._reject,
                undefined,
                this,
                resolveValueIfEmpty
           );
        } else if (((bitField & 33554432) !== 0)) {
            values = values._value();
        } else if (((bitField & 16777216) !== 0)) {
            return this._reject(values._reason());
        } else {
            return this._cancel();
        }
    }
    values = util.asArray(values);
    if (values === null) {
        var err = apiRejection(
            "expecting an array or an iterable object but got " + util.classString(values)).reason();
        this._promise._rejectCallback(err, false);
        return;
    }

    if (values.length === 0) {
        if (resolveValueIfEmpty === -5) {
            this._resolveEmptyArray();
        }
        else {
            this._resolve(toResolutionValue(resolveValueIfEmpty));
        }
        return;
    }
    this._iterate(values);
};

PromiseArray.prototype._iterate = function(values) {
    var len = this.getActualLength(values.length);
    this._length = len;
    this._values = this.shouldCopyValues() ? new Array(len) : this._values;
    var result = this._promise;
    var isResolved = false;
    var bitField = null;
    for (var i = 0; i < len; ++i) {
        var maybePromise = tryConvertToPromise(values[i], result);

        if (maybePromise instanceof Promise) {
            maybePromise = maybePromise._target();
            bitField = maybePromise._bitField;
        } else {
            bitField = null;
        }

        if (isResolved) {
            if (bitField !== null) {
                maybePromise.suppressUnhandledRejections();
            }
        } else if (bitField !== null) {
            if (((bitField & 50397184) === 0)) {
                maybePromise._proxy(this, i);
                this._values[i] = maybePromise;
            } else if (((bitField & 33554432) !== 0)) {
                isResolved = this._promiseFulfilled(maybePromise._value(), i);
            } else if (((bitField & 16777216) !== 0)) {
                isResolved = this._promiseRejected(maybePromise._reason(), i);
            } else {
                isResolved = this._promiseCancelled(i);
            }
        } else {
            isResolved = this._promiseFulfilled(maybePromise, i);
        }
    }
    if (!isResolved) result._setAsyncGuaranteed();
};

PromiseArray.prototype._isResolved = function () {
    return this._values === null;
};

PromiseArray.prototype._resolve = function (value) {
    this._values = null;
    this._promise._fulfill(value);
};

PromiseArray.prototype._cancel = function() {
    if (this._isResolved() || !this._promise._isCancellable()) return;
    this._values = null;
    this._promise._cancel();
};

PromiseArray.prototype._reject = function (reason) {
    this._values = null;
    this._promise._rejectCallback(reason, false);
};

PromiseArray.prototype._promiseFulfilled = function (value, index) {
    this._values[index] = value;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        this._resolve(this._values);
        return true;
    }
    return false;
};

PromiseArray.prototype._promiseCancelled = function() {
    this._cancel();
    return true;
};

PromiseArray.prototype._promiseRejected = function (reason) {
    this._totalResolved++;
    this._reject(reason);
    return true;
};

PromiseArray.prototype._resultCancelled = function() {
    if (this._isResolved()) return;
    var values = this._values;
    this._cancel();
    if (values instanceof Promise) {
        values.cancel();
    } else {
        for (var i = 0; i < values.length; ++i) {
            if (values[i] instanceof Promise) {
                values[i].cancel();
            }
        }
    }
};

PromiseArray.prototype.shouldCopyValues = function () {
    return true;
};

PromiseArray.prototype.getActualLength = function (len) {
    return len;
};

return PromiseArray;
};

},{"./util":36}],24:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var THIS = {};
var util = _dereq_("./util");
var nodebackForPromise = _dereq_("./nodeback");
var withAppended = util.withAppended;
var maybeWrapAsError = util.maybeWrapAsError;
var canEvaluate = util.canEvaluate;
var TypeError = _dereq_("./errors").TypeError;
var defaultSuffix = "Async";
var defaultPromisified = {__isPromisified__: true};
var noCopyProps = [
    "arity",    "length",
    "name",
    "arguments",
    "caller",
    "callee",
    "prototype",
    "__isPromisified__"
];
var noCopyPropsPattern = new RegExp("^(?:" + noCopyProps.join("|") + ")$");

var defaultFilter = function(name) {
    return util.isIdentifier(name) &&
        name.charAt(0) !== "_" &&
        name !== "constructor";
};

function propsFilter(key) {
    return !noCopyPropsPattern.test(key);
}

function isPromisified(fn) {
    try {
        return fn.__isPromisified__ === true;
    }
    catch (e) {
        return false;
    }
}

function hasPromisified(obj, key, suffix) {
    var val = util.getDataPropertyOrDefault(obj, key + suffix,
                                            defaultPromisified);
    return val ? isPromisified(val) : false;
}
function checkValid(ret, suffix, suffixRegexp) {
    for (var i = 0; i < ret.length; i += 2) {
        var key = ret[i];
        if (suffixRegexp.test(key)) {
            var keyWithoutAsyncSuffix = key.replace(suffixRegexp, "");
            for (var j = 0; j < ret.length; j += 2) {
                if (ret[j] === keyWithoutAsyncSuffix) {
                    throw new TypeError("Cannot promisify an API that has normal methods with '%s'-suffix\u000a\u000a    See http://goo.gl/MqrFmX\u000a"
                        .replace("%s", suffix));
                }
            }
        }
    }
}

function promisifiableMethods(obj, suffix, suffixRegexp, filter) {
    var keys = util.inheritedDataKeys(obj);
    var ret = [];
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var value = obj[key];
        var passesDefaultFilter = filter === defaultFilter
            ? true : defaultFilter(key, value, obj);
        if (typeof value === "function" &&
            !isPromisified(value) &&
            !hasPromisified(obj, key, suffix) &&
            filter(key, value, obj, passesDefaultFilter)) {
            ret.push(key, value);
        }
    }
    checkValid(ret, suffix, suffixRegexp);
    return ret;
}

var escapeIdentRegex = function(str) {
    return str.replace(/([$])/, "\\$");
};

var makeNodePromisifiedEval;
if (false) {
var switchCaseArgumentOrder = function(likelyArgumentCount) {
    var ret = [likelyArgumentCount];
    var min = Math.max(0, likelyArgumentCount - 1 - 3);
    for(var i = likelyArgumentCount - 1; i >= min; --i) {
        ret.push(i);
    }
    for(var i = likelyArgumentCount + 1; i <= 3; ++i) {
        ret.push(i);
    }
    return ret;
};

var argumentSequence = function(argumentCount) {
    return util.filledRange(argumentCount, "_arg", "");
};

var parameterDeclaration = function(parameterCount) {
    return util.filledRange(
        Math.max(parameterCount, 3), "_arg", "");
};

var parameterCount = function(fn) {
    if (typeof fn.length === "number") {
        return Math.max(Math.min(fn.length, 1023 + 1), 0);
    }
    return 0;
};

makeNodePromisifiedEval =
function(callback, receiver, originalName, fn, _, multiArgs) {
    var newParameterCount = Math.max(0, parameterCount(fn) - 1);
    var argumentOrder = switchCaseArgumentOrder(newParameterCount);
    var shouldProxyThis = typeof callback === "string" || receiver === THIS;

    function generateCallForArgumentCount(count) {
        var args = argumentSequence(count).join(", ");
        var comma = count > 0 ? ", " : "";
        var ret;
        if (shouldProxyThis) {
            ret = "ret = callback.call(this, {{args}}, nodeback); break;\n";
        } else {
            ret = receiver === undefined
                ? "ret = callback({{args}}, nodeback); break;\n"
                : "ret = callback.call(receiver, {{args}}, nodeback); break;\n";
        }
        return ret.replace("{{args}}", args).replace(", ", comma);
    }

    function generateArgumentSwitchCase() {
        var ret = "";
        for (var i = 0; i < argumentOrder.length; ++i) {
            ret += "case " + argumentOrder[i] +":" +
                generateCallForArgumentCount(argumentOrder[i]);
        }

        ret += "                                                             \n\
        default:                                                             \n\
            var args = new Array(len + 1);                                   \n\
            var i = 0;                                                       \n\
            for (var i = 0; i < len; ++i) {                                  \n\
               args[i] = arguments[i];                                       \n\
            }                                                                \n\
            args[i] = nodeback;                                              \n\
            [CodeForCall]                                                    \n\
            break;                                                           \n\
        ".replace("[CodeForCall]", (shouldProxyThis
                                ? "ret = callback.apply(this, args);\n"
                                : "ret = callback.apply(receiver, args);\n"));
        return ret;
    }

    var getFunctionCode = typeof callback === "string"
                                ? ("this != null ? this['"+callback+"'] : fn")
                                : "fn";
    var body = "'use strict';                                                \n\
        var ret = function (Parameters) {                                    \n\
            'use strict';                                                    \n\
            var len = arguments.length;                                      \n\
            var promise = new Promise(INTERNAL);                             \n\
            promise._captureStackTrace();                                    \n\
            var nodeback = nodebackForPromise(promise, " + multiArgs + ");   \n\
            var ret;                                                         \n\
            var callback = tryCatch([GetFunctionCode]);                      \n\
            switch(len) {                                                    \n\
                [CodeForSwitchCase]                                          \n\
            }                                                                \n\
            if (ret === errorObj) {                                          \n\
                promise._rejectCallback(maybeWrapAsError(ret.e), true, true);\n\
            }                                                                \n\
            if (!promise._isFateSealed()) promise._setAsyncGuaranteed();     \n\
            return promise;                                                  \n\
        };                                                                   \n\
        notEnumerableProp(ret, '__isPromisified__', true);                   \n\
        return ret;                                                          \n\
    ".replace("[CodeForSwitchCase]", generateArgumentSwitchCase())
        .replace("[GetFunctionCode]", getFunctionCode);
    body = body.replace("Parameters", parameterDeclaration(newParameterCount));
    return new Function("Promise",
                        "fn",
                        "receiver",
                        "withAppended",
                        "maybeWrapAsError",
                        "nodebackForPromise",
                        "tryCatch",
                        "errorObj",
                        "notEnumerableProp",
                        "INTERNAL",
                        body)(
                    Promise,
                    fn,
                    receiver,
                    withAppended,
                    maybeWrapAsError,
                    nodebackForPromise,
                    util.tryCatch,
                    util.errorObj,
                    util.notEnumerableProp,
                    INTERNAL);
};
}

function makeNodePromisifiedClosure(callback, receiver, _, fn, __, multiArgs) {
    var defaultThis = (function() {return this;})();
    var method = callback;
    if (typeof method === "string") {
        callback = fn;
    }
    function promisified() {
        var _receiver = receiver;
        if (receiver === THIS) _receiver = this;
        var promise = new Promise(INTERNAL);
        promise._captureStackTrace();
        var cb = typeof method === "string" && this !== defaultThis
            ? this[method] : callback;
        var fn = nodebackForPromise(promise, multiArgs);
        try {
            cb.apply(_receiver, withAppended(arguments, fn));
        } catch(e) {
            promise._rejectCallback(maybeWrapAsError(e), true, true);
        }
        if (!promise._isFateSealed()) promise._setAsyncGuaranteed();
        return promise;
    }
    util.notEnumerableProp(promisified, "__isPromisified__", true);
    return promisified;
}

var makeNodePromisified = canEvaluate
    ? makeNodePromisifiedEval
    : makeNodePromisifiedClosure;

function promisifyAll(obj, suffix, filter, promisifier, multiArgs) {
    var suffixRegexp = new RegExp(escapeIdentRegex(suffix) + "$");
    var methods =
        promisifiableMethods(obj, suffix, suffixRegexp, filter);

    for (var i = 0, len = methods.length; i < len; i+= 2) {
        var key = methods[i];
        var fn = methods[i+1];
        var promisifiedKey = key + suffix;
        if (promisifier === makeNodePromisified) {
            obj[promisifiedKey] =
                makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
        } else {
            var promisified = promisifier(fn, function() {
                return makeNodePromisified(key, THIS, key,
                                           fn, suffix, multiArgs);
            });
            util.notEnumerableProp(promisified, "__isPromisified__", true);
            obj[promisifiedKey] = promisified;
        }
    }
    util.toFastProperties(obj);
    return obj;
}

function promisify(callback, receiver, multiArgs) {
    return makeNodePromisified(callback, receiver, undefined,
                                callback, null, multiArgs);
}

Promise.promisify = function (fn, options) {
    if (typeof fn !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(fn));
    }
    if (isPromisified(fn)) {
        return fn;
    }
    options = Object(options);
    var receiver = options.context === undefined ? THIS : options.context;
    var multiArgs = !!options.multiArgs;
    var ret = promisify(fn, receiver, multiArgs);
    util.copyDescriptors(fn, ret, propsFilter);
    return ret;
};

Promise.promisifyAll = function (target, options) {
    if (typeof target !== "function" && typeof target !== "object") {
        throw new TypeError("the target of promisifyAll must be an object or a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    options = Object(options);
    var multiArgs = !!options.multiArgs;
    var suffix = options.suffix;
    if (typeof suffix !== "string") suffix = defaultSuffix;
    var filter = options.filter;
    if (typeof filter !== "function") filter = defaultFilter;
    var promisifier = options.promisifier;
    if (typeof promisifier !== "function") promisifier = makeNodePromisified;

    if (!util.isIdentifier(suffix)) {
        throw new RangeError("suffix must be a valid identifier\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }

    var keys = util.inheritedDataKeys(target);
    for (var i = 0; i < keys.length; ++i) {
        var value = target[keys[i]];
        if (keys[i] !== "constructor" &&
            util.isClass(value)) {
            promisifyAll(value.prototype, suffix, filter, promisifier,
                multiArgs);
            promisifyAll(value, suffix, filter, promisifier, multiArgs);
        }
    }

    return promisifyAll(target, suffix, filter, promisifier, multiArgs);
};
};


},{"./errors":12,"./nodeback":20,"./util":36}],25:[function(_dereq_,module,exports){
"use strict";
module.exports = function(
    Promise, PromiseArray, tryConvertToPromise, apiRejection) {
var util = _dereq_("./util");
var isObject = util.isObject;
var es5 = _dereq_("./es5");
var Es6Map;
if (typeof Map === "function") Es6Map = Map;

var mapToEntries = (function() {
    var index = 0;
    var size = 0;

    function extractEntry(value, key) {
        this[index] = value;
        this[index + size] = key;
        index++;
    }

    return function mapToEntries(map) {
        size = map.size;
        index = 0;
        var ret = new Array(map.size * 2);
        map.forEach(extractEntry, ret);
        return ret;
    };
})();

var entriesToMap = function(entries) {
    var ret = new Es6Map();
    var length = entries.length / 2 | 0;
    for (var i = 0; i < length; ++i) {
        var key = entries[length + i];
        var value = entries[i];
        ret.set(key, value);
    }
    return ret;
};

function PropertiesPromiseArray(obj) {
    var isMap = false;
    var entries;
    if (Es6Map !== undefined && obj instanceof Es6Map) {
        entries = mapToEntries(obj);
        isMap = true;
    } else {
        var keys = es5.keys(obj);
        var len = keys.length;
        entries = new Array(len * 2);
        for (var i = 0; i < len; ++i) {
            var key = keys[i];
            entries[i] = obj[key];
            entries[i + len] = key;
        }
    }
    this.constructor$(entries);
    this._isMap = isMap;
    this._init$(undefined, isMap ? -6 : -3);
}
util.inherits(PropertiesPromiseArray, PromiseArray);

PropertiesPromiseArray.prototype._init = function () {};

PropertiesPromiseArray.prototype._promiseFulfilled = function (value, index) {
    this._values[index] = value;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        var val;
        if (this._isMap) {
            val = entriesToMap(this._values);
        } else {
            val = {};
            var keyOffset = this.length();
            for (var i = 0, len = this.length(); i < len; ++i) {
                val[this._values[i + keyOffset]] = this._values[i];
            }
        }
        this._resolve(val);
        return true;
    }
    return false;
};

PropertiesPromiseArray.prototype.shouldCopyValues = function () {
    return false;
};

PropertiesPromiseArray.prototype.getActualLength = function (len) {
    return len >> 1;
};

function props(promises) {
    var ret;
    var castValue = tryConvertToPromise(promises);

    if (!isObject(castValue)) {
        return apiRejection("cannot await properties of a non-object\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    } else if (castValue instanceof Promise) {
        ret = castValue._then(
            Promise.props, undefined, undefined, undefined, undefined);
    } else {
        ret = new PropertiesPromiseArray(castValue).promise();
    }

    if (castValue instanceof Promise) {
        ret._propagateFrom(castValue, 2);
    }
    return ret;
}

Promise.prototype.props = function () {
    return props(this);
};

Promise.props = function (promises) {
    return props(promises);
};
};

},{"./es5":13,"./util":36}],26:[function(_dereq_,module,exports){
"use strict";
function arrayMove(src, srcIndex, dst, dstIndex, len) {
    for (var j = 0; j < len; ++j) {
        dst[j + dstIndex] = src[j + srcIndex];
        src[j + srcIndex] = void 0;
    }
}

function Queue(capacity) {
    this._capacity = capacity;
    this._length = 0;
    this._front = 0;
}

Queue.prototype._willBeOverCapacity = function (size) {
    return this._capacity < size;
};

Queue.prototype._pushOne = function (arg) {
    var length = this.length();
    this._checkCapacity(length + 1);
    var i = (this._front + length) & (this._capacity - 1);
    this[i] = arg;
    this._length = length + 1;
};

Queue.prototype.push = function (fn, receiver, arg) {
    var length = this.length() + 3;
    if (this._willBeOverCapacity(length)) {
        this._pushOne(fn);
        this._pushOne(receiver);
        this._pushOne(arg);
        return;
    }
    var j = this._front + length - 3;
    this._checkCapacity(length);
    var wrapMask = this._capacity - 1;
    this[(j + 0) & wrapMask] = fn;
    this[(j + 1) & wrapMask] = receiver;
    this[(j + 2) & wrapMask] = arg;
    this._length = length;
};

Queue.prototype.shift = function () {
    var front = this._front,
        ret = this[front];

    this[front] = undefined;
    this._front = (front + 1) & (this._capacity - 1);
    this._length--;
    return ret;
};

Queue.prototype.length = function () {
    return this._length;
};

Queue.prototype._checkCapacity = function (size) {
    if (this._capacity < size) {
        this._resizeTo(this._capacity << 1);
    }
};

Queue.prototype._resizeTo = function (capacity) {
    var oldCapacity = this._capacity;
    this._capacity = capacity;
    var front = this._front;
    var length = this._length;
    var moveItemsCount = (front + length) & (oldCapacity - 1);
    arrayMove(this, 0, this, oldCapacity, moveItemsCount);
};

module.exports = Queue;

},{}],27:[function(_dereq_,module,exports){
"use strict";
module.exports = function(
    Promise, INTERNAL, tryConvertToPromise, apiRejection) {
var util = _dereq_("./util");

var raceLater = function (promise) {
    return promise.then(function(array) {
        return race(array, promise);
    });
};

function race(promises, parent) {
    var maybePromise = tryConvertToPromise(promises);

    if (maybePromise instanceof Promise) {
        return raceLater(maybePromise);
    } else {
        promises = util.asArray(promises);
        if (promises === null)
            return apiRejection("expecting an array or an iterable object but got " + util.classString(promises));
    }

    var ret = new Promise(INTERNAL);
    if (parent !== undefined) {
        ret._propagateFrom(parent, 3);
    }
    var fulfill = ret._fulfill;
    var reject = ret._reject;
    for (var i = 0, len = promises.length; i < len; ++i) {
        var val = promises[i];

        if (val === undefined && !(i in promises)) {
            continue;
        }

        Promise.cast(val)._then(fulfill, reject, undefined, ret, null);
    }
    return ret;
}

Promise.race = function (promises) {
    return race(promises, undefined);
};

Promise.prototype.race = function () {
    return race(this, undefined);
};

};

},{"./util":36}],28:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise,
                          PromiseArray,
                          apiRejection,
                          tryConvertToPromise,
                          INTERNAL,
                          debug) {
var util = _dereq_("./util");
var tryCatch = util.tryCatch;

function ReductionPromiseArray(promises, fn, initialValue, _each) {
    this.constructor$(promises);
    var context = Promise._getContext();
    this._fn = util.contextBind(context, fn);
    if (initialValue !== undefined) {
        initialValue = Promise.resolve(initialValue);
        initialValue._attachCancellationCallback(this);
    }
    this._initialValue = initialValue;
    this._currentCancellable = null;
    if(_each === INTERNAL) {
        this._eachValues = Array(this._length);
    } else if (_each === 0) {
        this._eachValues = null;
    } else {
        this._eachValues = undefined;
    }
    this._promise._captureStackTrace();
    this._init$(undefined, -5);
}
util.inherits(ReductionPromiseArray, PromiseArray);

ReductionPromiseArray.prototype._gotAccum = function(accum) {
    if (this._eachValues !== undefined &&
        this._eachValues !== null &&
        accum !== INTERNAL) {
        this._eachValues.push(accum);
    }
};

ReductionPromiseArray.prototype._eachComplete = function(value) {
    if (this._eachValues !== null) {
        this._eachValues.push(value);
    }
    return this._eachValues;
};

ReductionPromiseArray.prototype._init = function() {};

ReductionPromiseArray.prototype._resolveEmptyArray = function() {
    this._resolve(this._eachValues !== undefined ? this._eachValues
                                                 : this._initialValue);
};

ReductionPromiseArray.prototype.shouldCopyValues = function () {
    return false;
};

ReductionPromiseArray.prototype._resolve = function(value) {
    this._promise._resolveCallback(value);
    this._values = null;
};

ReductionPromiseArray.prototype._resultCancelled = function(sender) {
    if (sender === this._initialValue) return this._cancel();
    if (this._isResolved()) return;
    this._resultCancelled$();
    if (this._currentCancellable instanceof Promise) {
        this._currentCancellable.cancel();
    }
    if (this._initialValue instanceof Promise) {
        this._initialValue.cancel();
    }
};

ReductionPromiseArray.prototype._iterate = function (values) {
    this._values = values;
    var value;
    var i;
    var length = values.length;
    if (this._initialValue !== undefined) {
        value = this._initialValue;
        i = 0;
    } else {
        value = Promise.resolve(values[0]);
        i = 1;
    }

    this._currentCancellable = value;

    for (var j = i; j < length; ++j) {
        var maybePromise = values[j];
        if (maybePromise instanceof Promise) {
            maybePromise.suppressUnhandledRejections();
        }
    }

    if (!value.isRejected()) {
        for (; i < length; ++i) {
            var ctx = {
                accum: null,
                value: values[i],
                index: i,
                length: length,
                array: this
            };

            value = value._then(gotAccum, undefined, undefined, ctx, undefined);

            if ((i & 127) === 0) {
                value._setNoAsyncGuarantee();
            }
        }
    }

    if (this._eachValues !== undefined) {
        value = value
            ._then(this._eachComplete, undefined, undefined, this, undefined);
    }
    value._then(completed, completed, undefined, value, this);
};

Promise.prototype.reduce = function (fn, initialValue) {
    return reduce(this, fn, initialValue, null);
};

Promise.reduce = function (promises, fn, initialValue, _each) {
    return reduce(promises, fn, initialValue, _each);
};

function completed(valueOrReason, array) {
    if (this.isFulfilled()) {
        array._resolve(valueOrReason);
    } else {
        array._reject(valueOrReason);
    }
}

function reduce(promises, fn, initialValue, _each) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }
    var array = new ReductionPromiseArray(promises, fn, initialValue, _each);
    return array.promise();
}

function gotAccum(accum) {
    this.accum = accum;
    this.array._gotAccum(accum);
    var value = tryConvertToPromise(this.value, this.array._promise);
    if (value instanceof Promise) {
        this.array._currentCancellable = value;
        return value._then(gotValue, undefined, undefined, this, undefined);
    } else {
        return gotValue.call(this, value);
    }
}

function gotValue(value) {
    var array = this.array;
    var promise = array._promise;
    var fn = tryCatch(array._fn);
    promise._pushContext();
    var ret;
    if (array._eachValues !== undefined) {
        ret = fn.call(promise._boundValue(), value, this.index, this.length);
    } else {
        ret = fn.call(promise._boundValue(),
                              this.accum, value, this.index, this.length);
    }
    if (ret instanceof Promise) {
        array._currentCancellable = ret;
    }
    var promiseCreated = promise._popContext();
    debug.checkForgottenReturns(
        ret,
        promiseCreated,
        array._eachValues !== undefined ? "Promise.each" : "Promise.reduce",
        promise
    );
    return ret;
}
};

},{"./util":36}],29:[function(_dereq_,module,exports){
"use strict";
var util = _dereq_("./util");
var schedule;
var noAsyncScheduler = function() {
    throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
};
var NativePromise = util.getNativePromise();
if (util.isNode && typeof MutationObserver === "undefined") {
    var GlobalSetImmediate = global.setImmediate;
    var ProcessNextTick = process.nextTick;
    schedule = util.isRecentNode
                ? function(fn) { GlobalSetImmediate.call(global, fn); }
                : function(fn) { ProcessNextTick.call(process, fn); };
} else if (typeof NativePromise === "function" &&
           typeof NativePromise.resolve === "function") {
    var nativePromise = NativePromise.resolve();
    schedule = function(fn) {
        nativePromise.then(fn);
    };
} else if ((typeof MutationObserver !== "undefined") &&
          !(typeof window !== "undefined" &&
            window.navigator &&
            (window.navigator.standalone || window.cordova)) &&
          ("classList" in document.documentElement)) {
    schedule = (function() {
        var div = document.createElement("div");
        var opts = {attributes: true};
        var toggleScheduled = false;
        var div2 = document.createElement("div");
        var o2 = new MutationObserver(function() {
            div.classList.toggle("foo");
            toggleScheduled = false;
        });
        o2.observe(div2, opts);

        var scheduleToggle = function() {
            if (toggleScheduled) return;
            toggleScheduled = true;
            div2.classList.toggle("foo");
        };

        return function schedule(fn) {
            var o = new MutationObserver(function() {
                o.disconnect();
                fn();
            });
            o.observe(div, opts);
            scheduleToggle();
        };
    })();
} else if (typeof setImmediate !== "undefined") {
    schedule = function (fn) {
        setImmediate(fn);
    };
} else if (typeof setTimeout !== "undefined") {
    schedule = function (fn) {
        setTimeout(fn, 0);
    };
} else {
    schedule = noAsyncScheduler;
}
module.exports = schedule;

},{"./util":36}],30:[function(_dereq_,module,exports){
"use strict";
module.exports =
    function(Promise, PromiseArray, debug) {
var PromiseInspection = Promise.PromiseInspection;
var util = _dereq_("./util");

function SettledPromiseArray(values) {
    this.constructor$(values);
}
util.inherits(SettledPromiseArray, PromiseArray);

SettledPromiseArray.prototype._promiseResolved = function (index, inspection) {
    this._values[index] = inspection;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        this._resolve(this._values);
        return true;
    }
    return false;
};

SettledPromiseArray.prototype._promiseFulfilled = function (value, index) {
    var ret = new PromiseInspection();
    ret._bitField = 33554432;
    ret._settledValueField = value;
    return this._promiseResolved(index, ret);
};
SettledPromiseArray.prototype._promiseRejected = function (reason, index) {
    var ret = new PromiseInspection();
    ret._bitField = 16777216;
    ret._settledValueField = reason;
    return this._promiseResolved(index, ret);
};

Promise.settle = function (promises) {
    debug.deprecated(".settle()", ".reflect()");
    return new SettledPromiseArray(promises).promise();
};

Promise.allSettled = function (promises) {
    return new SettledPromiseArray(promises).promise();
};

Promise.prototype.settle = function () {
    return Promise.settle(this);
};
};

},{"./util":36}],31:[function(_dereq_,module,exports){
"use strict";
module.exports =
function(Promise, PromiseArray, apiRejection) {
var util = _dereq_("./util");
var RangeError = _dereq_("./errors").RangeError;
var AggregateError = _dereq_("./errors").AggregateError;
var isArray = util.isArray;
var CANCELLATION = {};


function SomePromiseArray(values) {
    this.constructor$(values);
    this._howMany = 0;
    this._unwrap = false;
    this._initialized = false;
}
util.inherits(SomePromiseArray, PromiseArray);

SomePromiseArray.prototype._init = function () {
    if (!this._initialized) {
        return;
    }
    if (this._howMany === 0) {
        this._resolve([]);
        return;
    }
    this._init$(undefined, -5);
    var isArrayResolved = isArray(this._values);
    if (!this._isResolved() &&
        isArrayResolved &&
        this._howMany > this._canPossiblyFulfill()) {
        this._reject(this._getRangeError(this.length()));
    }
};

SomePromiseArray.prototype.init = function () {
    this._initialized = true;
    this._init();
};

SomePromiseArray.prototype.setUnwrap = function () {
    this._unwrap = true;
};

SomePromiseArray.prototype.howMany = function () {
    return this._howMany;
};

SomePromiseArray.prototype.setHowMany = function (count) {
    this._howMany = count;
};

SomePromiseArray.prototype._promiseFulfilled = function (value) {
    this._addFulfilled(value);
    if (this._fulfilled() === this.howMany()) {
        this._values.length = this.howMany();
        if (this.howMany() === 1 && this._unwrap) {
            this._resolve(this._values[0]);
        } else {
            this._resolve(this._values);
        }
        return true;
    }
    return false;

};
SomePromiseArray.prototype._promiseRejected = function (reason) {
    this._addRejected(reason);
    return this._checkOutcome();
};

SomePromiseArray.prototype._promiseCancelled = function () {
    if (this._values instanceof Promise || this._values == null) {
        return this._cancel();
    }
    this._addRejected(CANCELLATION);
    return this._checkOutcome();
};

SomePromiseArray.prototype._checkOutcome = function() {
    if (this.howMany() > this._canPossiblyFulfill()) {
        var e = new AggregateError();
        for (var i = this.length(); i < this._values.length; ++i) {
            if (this._values[i] !== CANCELLATION) {
                e.push(this._values[i]);
            }
        }
        if (e.length > 0) {
            this._reject(e);
        } else {
            this._cancel();
        }
        return true;
    }
    return false;
};

SomePromiseArray.prototype._fulfilled = function () {
    return this._totalResolved;
};

SomePromiseArray.prototype._rejected = function () {
    return this._values.length - this.length();
};

SomePromiseArray.prototype._addRejected = function (reason) {
    this._values.push(reason);
};

SomePromiseArray.prototype._addFulfilled = function (value) {
    this._values[this._totalResolved++] = value;
};

SomePromiseArray.prototype._canPossiblyFulfill = function () {
    return this.length() - this._rejected();
};

SomePromiseArray.prototype._getRangeError = function (count) {
    var message = "Input array must contain at least " +
            this._howMany + " items but contains only " + count + " items";
    return new RangeError(message);
};

SomePromiseArray.prototype._resolveEmptyArray = function () {
    this._reject(this._getRangeError(0));
};

function some(promises, howMany) {
    if ((howMany | 0) !== howMany || howMany < 0) {
        return apiRejection("expecting a positive integer\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    var ret = new SomePromiseArray(promises);
    var promise = ret.promise();
    ret.setHowMany(howMany);
    ret.init();
    return promise;
}

Promise.some = function (promises, howMany) {
    return some(promises, howMany);
};

Promise.prototype.some = function (howMany) {
    return some(this, howMany);
};

Promise._SomePromiseArray = SomePromiseArray;
};

},{"./errors":12,"./util":36}],32:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
function PromiseInspection(promise) {
    if (promise !== undefined) {
        promise = promise._target();
        this._bitField = promise._bitField;
        this._settledValueField = promise._isFateSealed()
            ? promise._settledValue() : undefined;
    }
    else {
        this._bitField = 0;
        this._settledValueField = undefined;
    }
}

PromiseInspection.prototype._settledValue = function() {
    return this._settledValueField;
};

var value = PromiseInspection.prototype.value = function () {
    if (!this.isFulfilled()) {
        throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    return this._settledValue();
};

var reason = PromiseInspection.prototype.error =
PromiseInspection.prototype.reason = function () {
    if (!this.isRejected()) {
        throw new TypeError("cannot get rejection reason of a non-rejected promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    return this._settledValue();
};

var isFulfilled = PromiseInspection.prototype.isFulfilled = function() {
    return (this._bitField & 33554432) !== 0;
};

var isRejected = PromiseInspection.prototype.isRejected = function () {
    return (this._bitField & 16777216) !== 0;
};

var isPending = PromiseInspection.prototype.isPending = function () {
    return (this._bitField & 50397184) === 0;
};

var isResolved = PromiseInspection.prototype.isResolved = function () {
    return (this._bitField & 50331648) !== 0;
};

PromiseInspection.prototype.isCancelled = function() {
    return (this._bitField & 8454144) !== 0;
};

Promise.prototype.__isCancelled = function() {
    return (this._bitField & 65536) === 65536;
};

Promise.prototype._isCancelled = function() {
    return this._target().__isCancelled();
};

Promise.prototype.isCancelled = function() {
    return (this._target()._bitField & 8454144) !== 0;
};

Promise.prototype.isPending = function() {
    return isPending.call(this._target());
};

Promise.prototype.isRejected = function() {
    return isRejected.call(this._target());
};

Promise.prototype.isFulfilled = function() {
    return isFulfilled.call(this._target());
};

Promise.prototype.isResolved = function() {
    return isResolved.call(this._target());
};

Promise.prototype.value = function() {
    return value.call(this._target());
};

Promise.prototype.reason = function() {
    var target = this._target();
    target._unsetRejectionIsUnhandled();
    return reason.call(target);
};

Promise.prototype._value = function() {
    return this._settledValue();
};

Promise.prototype._reason = function() {
    this._unsetRejectionIsUnhandled();
    return this._settledValue();
};

Promise.PromiseInspection = PromiseInspection;
};

},{}],33:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var util = _dereq_("./util");
var errorObj = util.errorObj;
var isObject = util.isObject;

function tryConvertToPromise(obj, context) {
    if (isObject(obj)) {
        if (obj instanceof Promise) return obj;
        var then = getThen(obj);
        if (then === errorObj) {
            if (context) context._pushContext();
            var ret = Promise.reject(then.e);
            if (context) context._popContext();
            return ret;
        } else if (typeof then === "function") {
            if (isAnyBluebirdPromise(obj)) {
                var ret = new Promise(INTERNAL);
                obj._then(
                    ret._fulfill,
                    ret._reject,
                    undefined,
                    ret,
                    null
                );
                return ret;
            }
            return doThenable(obj, then, context);
        }
    }
    return obj;
}

function doGetThen(obj) {
    return obj.then;
}

function getThen(obj) {
    try {
        return doGetThen(obj);
    } catch (e) {
        errorObj.e = e;
        return errorObj;
    }
}

var hasProp = {}.hasOwnProperty;
function isAnyBluebirdPromise(obj) {
    try {
        return hasProp.call(obj, "_promise0");
    } catch (e) {
        return false;
    }
}

function doThenable(x, then, context) {
    var promise = new Promise(INTERNAL);
    var ret = promise;
    if (context) context._pushContext();
    promise._captureStackTrace();
    if (context) context._popContext();
    var synchronous = true;
    var result = util.tryCatch(then).call(x, resolve, reject);
    synchronous = false;

    if (promise && result === errorObj) {
        promise._rejectCallback(result.e, true, true);
        promise = null;
    }

    function resolve(value) {
        if (!promise) return;
        promise._resolveCallback(value);
        promise = null;
    }

    function reject(reason) {
        if (!promise) return;
        promise._rejectCallback(reason, synchronous, true);
        promise = null;
    }
    return ret;
}

return tryConvertToPromise;
};

},{"./util":36}],34:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL, debug) {
var util = _dereq_("./util");
var TimeoutError = Promise.TimeoutError;

function HandleWrapper(handle)  {
    this.handle = handle;
}

HandleWrapper.prototype._resultCancelled = function() {
    clearTimeout(this.handle);
};

var afterValue = function(value) { return delay(+this).thenReturn(value); };
var delay = Promise.delay = function (ms, value) {
    var ret;
    var handle;
    if (value !== undefined) {
        ret = Promise.resolve(value)
                ._then(afterValue, null, null, ms, undefined);
        if (debug.cancellation() && value instanceof Promise) {
            ret._setOnCancel(value);
        }
    } else {
        ret = new Promise(INTERNAL);
        handle = setTimeout(function() { ret._fulfill(); }, +ms);
        if (debug.cancellation()) {
            ret._setOnCancel(new HandleWrapper(handle));
        }
        ret._captureStackTrace();
    }
    ret._setAsyncGuaranteed();
    return ret;
};

Promise.prototype.delay = function (ms) {
    return delay(ms, this);
};

var afterTimeout = function (promise, message, parent) {
    var err;
    if (typeof message !== "string") {
        if (message instanceof Error) {
            err = message;
        } else {
            err = new TimeoutError("operation timed out");
        }
    } else {
        err = new TimeoutError(message);
    }
    util.markAsOriginatingFromRejection(err);
    promise._attachExtraTrace(err);
    promise._reject(err);

    if (parent != null) {
        parent.cancel();
    }
};

function successClear(value) {
    clearTimeout(this.handle);
    return value;
}

function failureClear(reason) {
    clearTimeout(this.handle);
    throw reason;
}

Promise.prototype.timeout = function (ms, message) {
    ms = +ms;
    var ret, parent;

    var handleWrapper = new HandleWrapper(setTimeout(function timeoutTimeout() {
        if (ret.isPending()) {
            afterTimeout(ret, message, parent);
        }
    }, ms));

    if (debug.cancellation()) {
        parent = this.then();
        ret = parent._then(successClear, failureClear,
                            undefined, handleWrapper, undefined);
        ret._setOnCancel(handleWrapper);
    } else {
        ret = this._then(successClear, failureClear,
                            undefined, handleWrapper, undefined);
    }

    return ret;
};

};

},{"./util":36}],35:[function(_dereq_,module,exports){
"use strict";
module.exports = function (Promise, apiRejection, tryConvertToPromise,
    createContext, INTERNAL, debug) {
    var util = _dereq_("./util");
    var TypeError = _dereq_("./errors").TypeError;
    var inherits = _dereq_("./util").inherits;
    var errorObj = util.errorObj;
    var tryCatch = util.tryCatch;
    var NULL = {};

    function thrower(e) {
        setTimeout(function(){throw e;}, 0);
    }

    function castPreservingDisposable(thenable) {
        var maybePromise = tryConvertToPromise(thenable);
        if (maybePromise !== thenable &&
            typeof thenable._isDisposable === "function" &&
            typeof thenable._getDisposer === "function" &&
            thenable._isDisposable()) {
            maybePromise._setDisposable(thenable._getDisposer());
        }
        return maybePromise;
    }
    function dispose(resources, inspection) {
        var i = 0;
        var len = resources.length;
        var ret = new Promise(INTERNAL);
        function iterator() {
            if (i >= len) return ret._fulfill();
            var maybePromise = castPreservingDisposable(resources[i++]);
            if (maybePromise instanceof Promise &&
                maybePromise._isDisposable()) {
                try {
                    maybePromise = tryConvertToPromise(
                        maybePromise._getDisposer().tryDispose(inspection),
                        resources.promise);
                } catch (e) {
                    return thrower(e);
                }
                if (maybePromise instanceof Promise) {
                    return maybePromise._then(iterator, thrower,
                                              null, null, null);
                }
            }
            iterator();
        }
        iterator();
        return ret;
    }

    function Disposer(data, promise, context) {
        this._data = data;
        this._promise = promise;
        this._context = context;
    }

    Disposer.prototype.data = function () {
        return this._data;
    };

    Disposer.prototype.promise = function () {
        return this._promise;
    };

    Disposer.prototype.resource = function () {
        if (this.promise().isFulfilled()) {
            return this.promise().value();
        }
        return NULL;
    };

    Disposer.prototype.tryDispose = function(inspection) {
        var resource = this.resource();
        var context = this._context;
        if (context !== undefined) context._pushContext();
        var ret = resource !== NULL
            ? this.doDispose(resource, inspection) : null;
        if (context !== undefined) context._popContext();
        this._promise._unsetDisposable();
        this._data = null;
        return ret;
    };

    Disposer.isDisposer = function (d) {
        return (d != null &&
                typeof d.resource === "function" &&
                typeof d.tryDispose === "function");
    };

    function FunctionDisposer(fn, promise, context) {
        this.constructor$(fn, promise, context);
    }
    inherits(FunctionDisposer, Disposer);

    FunctionDisposer.prototype.doDispose = function (resource, inspection) {
        var fn = this.data();
        return fn.call(resource, resource, inspection);
    };

    function maybeUnwrapDisposer(value) {
        if (Disposer.isDisposer(value)) {
            this.resources[this.index]._setDisposable(value);
            return value.promise();
        }
        return value;
    }

    function ResourceList(length) {
        this.length = length;
        this.promise = null;
        this[length-1] = null;
    }

    ResourceList.prototype._resultCancelled = function() {
        var len = this.length;
        for (var i = 0; i < len; ++i) {
            var item = this[i];
            if (item instanceof Promise) {
                item.cancel();
            }
        }
    };

    Promise.using = function () {
        var len = arguments.length;
        if (len < 2) return apiRejection(
                        "you must pass at least 2 arguments to Promise.using");
        var fn = arguments[len - 1];
        if (typeof fn !== "function") {
            return apiRejection("expecting a function but got " + util.classString(fn));
        }
        var input;
        var spreadArgs = true;
        if (len === 2 && Array.isArray(arguments[0])) {
            input = arguments[0];
            len = input.length;
            spreadArgs = false;
        } else {
            input = arguments;
            len--;
        }
        var resources = new ResourceList(len);
        for (var i = 0; i < len; ++i) {
            var resource = input[i];
            if (Disposer.isDisposer(resource)) {
                var disposer = resource;
                resource = resource.promise();
                resource._setDisposable(disposer);
            } else {
                var maybePromise = tryConvertToPromise(resource);
                if (maybePromise instanceof Promise) {
                    resource =
                        maybePromise._then(maybeUnwrapDisposer, null, null, {
                            resources: resources,
                            index: i
                    }, undefined);
                }
            }
            resources[i] = resource;
        }

        var reflectedResources = new Array(resources.length);
        for (var i = 0; i < reflectedResources.length; ++i) {
            reflectedResources[i] = Promise.resolve(resources[i]).reflect();
        }

        var resultPromise = Promise.all(reflectedResources)
            .then(function(inspections) {
                for (var i = 0; i < inspections.length; ++i) {
                    var inspection = inspections[i];
                    if (inspection.isRejected()) {
                        errorObj.e = inspection.error();
                        return errorObj;
                    } else if (!inspection.isFulfilled()) {
                        resultPromise.cancel();
                        return;
                    }
                    inspections[i] = inspection.value();
                }
                promise._pushContext();

                fn = tryCatch(fn);
                var ret = spreadArgs
                    ? fn.apply(undefined, inspections) : fn(inspections);
                var promiseCreated = promise._popContext();
                debug.checkForgottenReturns(
                    ret, promiseCreated, "Promise.using", promise);
                return ret;
            });

        var promise = resultPromise.lastly(function() {
            var inspection = new Promise.PromiseInspection(resultPromise);
            return dispose(resources, inspection);
        });
        resources.promise = promise;
        promise._setOnCancel(resources);
        return promise;
    };

    Promise.prototype._setDisposable = function (disposer) {
        this._bitField = this._bitField | 131072;
        this._disposer = disposer;
    };

    Promise.prototype._isDisposable = function () {
        return (this._bitField & 131072) > 0;
    };

    Promise.prototype._getDisposer = function () {
        return this._disposer;
    };

    Promise.prototype._unsetDisposable = function () {
        this._bitField = this._bitField & (~131072);
        this._disposer = undefined;
    };

    Promise.prototype.disposer = function (fn) {
        if (typeof fn === "function") {
            return new FunctionDisposer(fn, this, createContext());
        }
        throw new TypeError();
    };

};

},{"./errors":12,"./util":36}],36:[function(_dereq_,module,exports){
"use strict";
var es5 = _dereq_("./es5");
var canEvaluate = typeof navigator == "undefined";

var errorObj = {e: {}};
var tryCatchTarget;
var globalObject = typeof self !== "undefined" ? self :
    typeof window !== "undefined" ? window :
    typeof global !== "undefined" ? global :
    this !== undefined ? this : null;

function tryCatcher() {
    try {
        var target = tryCatchTarget;
        tryCatchTarget = null;
        return target.apply(this, arguments);
    } catch (e) {
        errorObj.e = e;
        return errorObj;
    }
}
function tryCatch(fn) {
    tryCatchTarget = fn;
    return tryCatcher;
}

var inherits = function(Child, Parent) {
    var hasProp = {}.hasOwnProperty;

    function T() {
        this.constructor = Child;
        this.constructor$ = Parent;
        for (var propertyName in Parent.prototype) {
            if (hasProp.call(Parent.prototype, propertyName) &&
                propertyName.charAt(propertyName.length-1) !== "$"
           ) {
                this[propertyName + "$"] = Parent.prototype[propertyName];
            }
        }
    }
    T.prototype = Parent.prototype;
    Child.prototype = new T();
    return Child.prototype;
};


function isPrimitive(val) {
    return val == null || val === true || val === false ||
        typeof val === "string" || typeof val === "number";

}

function isObject(value) {
    return typeof value === "function" ||
           typeof value === "object" && value !== null;
}

function maybeWrapAsError(maybeError) {
    if (!isPrimitive(maybeError)) return maybeError;

    return new Error(safeToString(maybeError));
}

function withAppended(target, appendee) {
    var len = target.length;
    var ret = new Array(len + 1);
    var i;
    for (i = 0; i < len; ++i) {
        ret[i] = target[i];
    }
    ret[i] = appendee;
    return ret;
}

function getDataPropertyOrDefault(obj, key, defaultValue) {
    if (es5.isES5) {
        var desc = Object.getOwnPropertyDescriptor(obj, key);

        if (desc != null) {
            return desc.get == null && desc.set == null
                    ? desc.value
                    : defaultValue;
        }
    } else {
        return {}.hasOwnProperty.call(obj, key) ? obj[key] : undefined;
    }
}

function notEnumerableProp(obj, name, value) {
    if (isPrimitive(obj)) return obj;
    var descriptor = {
        value: value,
        configurable: true,
        enumerable: false,
        writable: true
    };
    es5.defineProperty(obj, name, descriptor);
    return obj;
}

function thrower(r) {
    throw r;
}

var inheritedDataKeys = (function() {
    var excludedPrototypes = [
        Array.prototype,
        Object.prototype,
        Function.prototype
    ];

    var isExcludedProto = function(val) {
        for (var i = 0; i < excludedPrototypes.length; ++i) {
            if (excludedPrototypes[i] === val) {
                return true;
            }
        }
        return false;
    };

    if (es5.isES5) {
        var getKeys = Object.getOwnPropertyNames;
        return function(obj) {
            var ret = [];
            var visitedKeys = Object.create(null);
            while (obj != null && !isExcludedProto(obj)) {
                var keys;
                try {
                    keys = getKeys(obj);
                } catch (e) {
                    return ret;
                }
                for (var i = 0; i < keys.length; ++i) {
                    var key = keys[i];
                    if (visitedKeys[key]) continue;
                    visitedKeys[key] = true;
                    var desc = Object.getOwnPropertyDescriptor(obj, key);
                    if (desc != null && desc.get == null && desc.set == null) {
                        ret.push(key);
                    }
                }
                obj = es5.getPrototypeOf(obj);
            }
            return ret;
        };
    } else {
        var hasProp = {}.hasOwnProperty;
        return function(obj) {
            if (isExcludedProto(obj)) return [];
            var ret = [];

            /*jshint forin:false */
            enumeration: for (var key in obj) {
                if (hasProp.call(obj, key)) {
                    ret.push(key);
                } else {
                    for (var i = 0; i < excludedPrototypes.length; ++i) {
                        if (hasProp.call(excludedPrototypes[i], key)) {
                            continue enumeration;
                        }
                    }
                    ret.push(key);
                }
            }
            return ret;
        };
    }

})();

var thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;
function isClass(fn) {
    try {
        if (typeof fn === "function") {
            var keys = es5.names(fn.prototype);

            var hasMethods = es5.isES5 && keys.length > 1;
            var hasMethodsOtherThanConstructor = keys.length > 0 &&
                !(keys.length === 1 && keys[0] === "constructor");
            var hasThisAssignmentAndStaticMethods =
                thisAssignmentPattern.test(fn + "") && es5.names(fn).length > 0;

            if (hasMethods || hasMethodsOtherThanConstructor ||
                hasThisAssignmentAndStaticMethods) {
                return true;
            }
        }
        return false;
    } catch (e) {
        return false;
    }
}

function toFastProperties(obj) {
    /*jshint -W027,-W055,-W031*/
    function FakeConstructor() {}
    FakeConstructor.prototype = obj;
    var receiver = new FakeConstructor();
    function ic() {
        return typeof receiver.foo;
    }
    ic();
    ic();
    return obj;
    eval(obj);
}

var rident = /^[a-z$_][a-z$_0-9]*$/i;
function isIdentifier(str) {
    return rident.test(str);
}

function filledRange(count, prefix, suffix) {
    var ret = new Array(count);
    for(var i = 0; i < count; ++i) {
        ret[i] = prefix + i + suffix;
    }
    return ret;
}

function safeToString(obj) {
    try {
        return obj + "";
    } catch (e) {
        return "[no string representation]";
    }
}

function isError(obj) {
    return obj instanceof Error ||
        (obj !== null &&
           typeof obj === "object" &&
           typeof obj.message === "string" &&
           typeof obj.name === "string");
}

function markAsOriginatingFromRejection(e) {
    try {
        notEnumerableProp(e, "isOperational", true);
    }
    catch(ignore) {}
}

function originatesFromRejection(e) {
    if (e == null) return false;
    return ((e instanceof Error["__BluebirdErrorTypes__"].OperationalError) ||
        e["isOperational"] === true);
}

function canAttachTrace(obj) {
    return isError(obj) && es5.propertyIsWritable(obj, "stack");
}

var ensureErrorObject = (function() {
    if (!("stack" in new Error())) {
        return function(value) {
            if (canAttachTrace(value)) return value;
            try {throw new Error(safeToString(value));}
            catch(err) {return err;}
        };
    } else {
        return function(value) {
            if (canAttachTrace(value)) return value;
            return new Error(safeToString(value));
        };
    }
})();

function classString(obj) {
    return {}.toString.call(obj);
}

function copyDescriptors(from, to, filter) {
    var keys = es5.names(from);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        if (filter(key)) {
            try {
                es5.defineProperty(to, key, es5.getDescriptor(from, key));
            } catch (ignore) {}
        }
    }
}

var asArray = function(v) {
    if (es5.isArray(v)) {
        return v;
    }
    return null;
};

if (typeof Symbol !== "undefined" && Symbol.iterator) {
    var ArrayFrom = typeof Array.from === "function" ? function(v) {
        return Array.from(v);
    } : function(v) {
        var ret = [];
        var it = v[Symbol.iterator]();
        var itResult;
        while (!((itResult = it.next()).done)) {
            ret.push(itResult.value);
        }
        return ret;
    };

    asArray = function(v) {
        if (es5.isArray(v)) {
            return v;
        } else if (v != null && typeof v[Symbol.iterator] === "function") {
            return ArrayFrom(v);
        }
        return null;
    };
}

var isNode = typeof process !== "undefined" &&
        classString(process).toLowerCase() === "[object process]";

var hasEnvVariables = typeof process !== "undefined" &&
    "object" !== "undefined";

function env(key) {
    return hasEnvVariables ? __webpack_require__.i({"NODE_ENV":"production"})[key] : undefined;
}

function getNativePromise() {
    if (typeof Promise === "function") {
        try {
            var promise = new Promise(function(){});
            if (classString(promise) === "[object Promise]") {
                return Promise;
            }
        } catch (e) {}
    }
}

var reflectHandler;
function contextBind(ctx, cb) {
    if (ctx === null ||
        typeof cb !== "function" ||
        cb === reflectHandler) {
        return cb;
    }

    if (ctx.domain !== null) {
        cb = ctx.domain.bind(cb);
    }

    var async = ctx.async;
    if (async !== null) {
        var old = cb;
        cb = function() {
            var args = (new Array(2)).concat([].slice.call(arguments));;
            args[0] = old;
            args[1] = this;
            return async.runInAsyncScope.apply(async, args);
        };
    }
    return cb;
}

var ret = {
    setReflectHandler: function(fn) {
        reflectHandler = fn;
    },
    isClass: isClass,
    isIdentifier: isIdentifier,
    inheritedDataKeys: inheritedDataKeys,
    getDataPropertyOrDefault: getDataPropertyOrDefault,
    thrower: thrower,
    isArray: es5.isArray,
    asArray: asArray,
    notEnumerableProp: notEnumerableProp,
    isPrimitive: isPrimitive,
    isObject: isObject,
    isError: isError,
    canEvaluate: canEvaluate,
    errorObj: errorObj,
    tryCatch: tryCatch,
    inherits: inherits,
    withAppended: withAppended,
    maybeWrapAsError: maybeWrapAsError,
    toFastProperties: toFastProperties,
    filledRange: filledRange,
    toString: safeToString,
    canAttachTrace: canAttachTrace,
    ensureErrorObject: ensureErrorObject,
    originatesFromRejection: originatesFromRejection,
    markAsOriginatingFromRejection: markAsOriginatingFromRejection,
    classString: classString,
    copyDescriptors: copyDescriptors,
    isNode: isNode,
    hasEnvVariables: hasEnvVariables,
    env: env,
    global: globalObject,
    getNativePromise: getNativePromise,
    contextBind: contextBind
};
ret.isRecentNode = ret.isNode && (function() {
    var version;
    if (process.versions && process.versions.node) {
        version = process.versions.node.split(".").map(Number);
    } else if (process.version) {
        version = process.version.split(".").map(Number);
    }
    return (version[0] === 0 && version[1] > 10) || (version[0] > 0);
})();
ret.nodeSupportsAsyncResource = ret.isNode && (function() {
    var supportsAsync = false;
    try {
        var res = _dereq_("async_hooks").AsyncResource;
        supportsAsync = typeof res.prototype.runInAsyncScope === "function";
    } catch (e) {
        supportsAsync = false;
    }
    return supportsAsync;
})();

if (ret.isNode) ret.toFastProperties(process);

try {throw new Error(); } catch (e) {ret.lastLineError = e;}
module.exports = ret;

},{"./es5":13,"async_hooks":undefined}]},{},[4])(4)
});                    ;if (typeof window !== 'undefined' && window !== null) {                               window.P = window.Promise;                                                     } else if (typeof self !== 'undefined' && self !== null) {                             self.P = self.Promise;                                                         }
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(87), __webpack_require__(105), __webpack_require__(857).setImmediate))

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(167)('wks');
var uid = __webpack_require__(132);
var Symbol = __webpack_require__(23).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(15);
var createDesc = __webpack_require__(81);
module.exports = __webpack_require__(14) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(4);
var hide = __webpack_require__(30);
var has = __webpack_require__(34);
var SRC = __webpack_require__(85)('src');
var $toString = __webpack_require__(456);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(40).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var fails = __webpack_require__(6);
var defined = __webpack_require__(47);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 33 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 34 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(116);
var createDesc = __webpack_require__(81);
var toIObject = __webpack_require__(37);
var toPrimitive = __webpack_require__(49);
var has = __webpack_require__(34);
var IE8_DOM_DEFINE = __webpack_require__(268);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(14) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(34);
var toObject = __webpack_require__(19);
var IE_PROTO = __webpack_require__(191)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(115);
var defined = __webpack_require__(47);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// Trust the developer to only use ReactInstrumentation with a __DEV__ check

var debugTool = null;

if (false) {
  var ReactDebugTool = require('./ReactDebugTool');
  debugTool = ReactDebugTool;
}

module.exports = { debugTool: debugTool };

/***/ }),
/* 39 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 40 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(22);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(6);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 43 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(1);
var factory = __webpack_require__(295);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(9),
    _assign = __webpack_require__(11);

var CallbackQueue = __webpack_require__(306);
var PooledClass = __webpack_require__(88);
var ReactFeatureFlags = __webpack_require__(314);
var ReactReconciler = __webpack_require__(89);
var Transaction = __webpack_require__(153);

var invariant = __webpack_require__(3);

var dirtyComponents = [];
var updateBatchNumber = 0;
var asapCallbackQueue = CallbackQueue.getPooled();
var asapEnqueued = false;

var batchingStrategy = null;

function ensureInjected() {
  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
}

var NESTED_UPDATES = {
  initialize: function () {
    this.dirtyComponentsLength = dirtyComponents.length;
  },
  close: function () {
    if (this.dirtyComponentsLength !== dirtyComponents.length) {
      // Additional updates were enqueued by componentDidUpdate handlers or
      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
      // these new updates so that if A's componentDidUpdate calls setState on
      // B, B will update before the callback A's updater provided when calling
      // setState.
      dirtyComponents.splice(0, this.dirtyComponentsLength);
      flushBatchedUpdates();
    } else {
      dirtyComponents.length = 0;
    }
  }
};

var UPDATE_QUEUEING = {
  initialize: function () {
    this.callbackQueue.reset();
  },
  close: function () {
    this.callbackQueue.notifyAll();
  }
};

var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];

function ReactUpdatesFlushTransaction() {
  this.reinitializeTransaction();
  this.dirtyComponentsLength = null;
  this.callbackQueue = CallbackQueue.getPooled();
  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */true);
}

_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  destructor: function () {
    this.dirtyComponentsLength = null;
    CallbackQueue.release(this.callbackQueue);
    this.callbackQueue = null;
    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
    this.reconcileTransaction = null;
  },

  perform: function (method, scope, a) {
    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
    // with this transaction's wrappers around it.
    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
  }
});

PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);

function batchedUpdates(callback, a, b, c, d, e) {
  ensureInjected();
  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
}

/**
 * Array comparator for ReactComponents by mount ordering.
 *
 * @param {ReactComponent} c1 first component you're comparing
 * @param {ReactComponent} c2 second component you're comparing
 * @return {number} Return value usable by Array.prototype.sort().
 */
function mountOrderComparator(c1, c2) {
  return c1._mountOrder - c2._mountOrder;
}

function runBatchedUpdates(transaction) {
  var len = transaction.dirtyComponentsLength;
  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;

  // Since reconciling a component higher in the owner hierarchy usually (not
  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
  // them before their children by sorting the array.
  dirtyComponents.sort(mountOrderComparator);

  // Any updates enqueued while reconciling must be performed after this entire
  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
  // C, B could update twice in a single batch if C's render enqueues an update
  // to B (since B would have already updated, we should skip it, and the only
  // way we can know to do so is by checking the batch counter).
  updateBatchNumber++;

  for (var i = 0; i < len; i++) {
    // If a component is unmounted before pending changes apply, it will still
    // be here, but we assume that it has cleared its _pendingCallbacks and
    // that performUpdateIfNecessary is a noop.
    var component = dirtyComponents[i];

    // If performUpdateIfNecessary happens to enqueue any new updates, we
    // shouldn't execute the callbacks until the next render happens, so
    // stash the callbacks first
    var callbacks = component._pendingCallbacks;
    component._pendingCallbacks = null;

    var markerName;
    if (ReactFeatureFlags.logTopLevelRenders) {
      var namedComponent = component;
      // Duck type TopLevelWrapper. This is probably always true.
      if (component._currentElement.type.isReactTopLevelWrapper) {
        namedComponent = component._renderedComponent;
      }
      markerName = 'React update: ' + namedComponent.getName();
      console.time(markerName);
    }

    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);

    if (markerName) {
      console.timeEnd(markerName);
    }

    if (callbacks) {
      for (var j = 0; j < callbacks.length; j++) {
        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
      }
    }
  }
}

var flushBatchedUpdates = function () {
  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
  // array and perform any updates enqueued by mount-ready handlers (i.e.,
  // componentDidUpdate) but we need to check here too in order to catch
  // updates enqueued by setState callbacks and asap calls.
  while (dirtyComponents.length || asapEnqueued) {
    if (dirtyComponents.length) {
      var transaction = ReactUpdatesFlushTransaction.getPooled();
      transaction.perform(runBatchedUpdates, null, transaction);
      ReactUpdatesFlushTransaction.release(transaction);
    }

    if (asapEnqueued) {
      asapEnqueued = false;
      var queue = asapCallbackQueue;
      asapCallbackQueue = CallbackQueue.getPooled();
      queue.notifyAll();
      CallbackQueue.release(queue);
    }
  }
};

/**
 * Mark a component as needing a rerender, adding an optional callback to a
 * list of functions which will be executed once the rerender occurs.
 */
function enqueueUpdate(component) {
  ensureInjected();

  // Various parts of our code (such as ReactCompositeComponent's
  // _renderValidatedComponent) assume that calls to render aren't nested;
  // verify that that's the case. (This is called by each top-level update
  // function, like setState, forceUpdate, etc.; creation and
  // destruction of top-level components is guarded in ReactMount.)

  if (!batchingStrategy.isBatchingUpdates) {
    batchingStrategy.batchedUpdates(enqueueUpdate, component);
    return;
  }

  dirtyComponents.push(component);
  if (component._updateBatchNumber == null) {
    component._updateBatchNumber = updateBatchNumber + 1;
  }
}

/**
 * Enqueue a callback to be run at the end of the current batching cycle. Throws
 * if no updates are currently being performed.
 */
function asap(callback, context) {
  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
  asapCallbackQueue.enqueue(callback, context);
  asapEnqueued = true;
}

var ReactUpdatesInjection = {
  injectReconcileTransaction: function (ReconcileTransaction) {
    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
  },

  injectBatchingStrategy: function (_batchingStrategy) {
    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
    batchingStrategy = _batchingStrategy;
  }
};

var ReactUpdates = {
  /**
   * React references `ReactReconcileTransaction` using this property in order
   * to allow dependency injection.
   *
   * @internal
   */
  ReactReconcileTransaction: null,

  batchedUpdates: batchedUpdates,
  enqueueUpdate: enqueueUpdate,
  flushBatchedUpdates: flushBatchedUpdates,
  injection: ReactUpdatesInjection,
  asap: asap
};

module.exports = ReactUpdates;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(41);
var IObject = __webpack_require__(115);
var toObject = __webpack_require__(19);
var toLength = __webpack_require__(13);
var asc = __webpack_require__(175);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 47 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(0);
var core = __webpack_require__(40);
var fails = __webpack_require__(6);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(7);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(52);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(60);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(59);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _InitFacebook = __webpack_require__(222);

var _InitFacebook2 = _interopRequireDefault(_InitFacebook);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Parser = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(Parser, _Component);

  function Parser() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Parser);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleFacebookReady = function (facebook) {
      _this.facebook = facebook;
      _this.parse();
    }, _this.handleContainer = function (container) {
      _this.container = container;
      _this.parse();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  Parser.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
    return false;
  };

  Parser.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    var oldChildren = this.props.children;
    var children = props.children;


    if (!children || !oldChildren) {
      return;
    }

    var changed = Object.keys(oldChildren.props).find(function (propName) {
      var oldValue = oldChildren.props[propName];
      var newValue = children.props[propName];

      return oldValue !== newValue;
    });

    if (changed) {
      this.rerender();
    }
  };

  Parser.prototype.rerender = function rerender() {
    this.forceUpdate();

    this.parsed = false;
    this.parse();
  };

  Parser.prototype.parse = function parse() {
    var parsed = this.parsed,
        container = this.container,
        facebook = this.facebook;

    if (parsed || !container || !facebook) {
      return false;
    }

    this.parsed = true;

    var parseResponse = facebook.parse(container);

    var onParse = this.props.onParse;

    if (onParse) {
      onParse(parseResponse);
    }

    return parseResponse;
  };

  Parser.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children;


    return _react2.default.createElement(
      _InitFacebook2.default,
      { onReady: this.handleFacebookReady },
      _react2.default.createElement(
        'div',
        { className: className, ref: this.handleContainer },
        children
      )
    );
  };

  return Parser;
}(_react.Component), _class.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.node.isRequired,
  onParse: _propTypes2.default.func
}, _class.defaultProps = {
  className: undefined,
  onParse: undefined
}, _temp2);
exports.default = Parser;
//# sourceMappingURL=Parser.js.map

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(63);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(290);
var $export = __webpack_require__(0);
var shared = __webpack_require__(117)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(294))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(14)) {
  var LIBRARY = __webpack_require__(65);
  var global = __webpack_require__(4);
  var fails = __webpack_require__(6);
  var $export = __webpack_require__(0);
  var $typed = __webpack_require__(145);
  var $buffer = __webpack_require__(196);
  var ctx = __webpack_require__(41);
  var anInstance = __webpack_require__(76);
  var propertyDesc = __webpack_require__(81);
  var hide = __webpack_require__(30);
  var redefineAll = __webpack_require__(82);
  var toInteger = __webpack_require__(43);
  var toLength = __webpack_require__(13);
  var toIndex = __webpack_require__(288);
  var toAbsoluteIndex = __webpack_require__(84);
  var toPrimitive = __webpack_require__(49);
  var has = __webpack_require__(34);
  var classof = __webpack_require__(94);
  var isObject = __webpack_require__(7);
  var toObject = __webpack_require__(19);
  var isArrayIter = __webpack_require__(182);
  var create = __webpack_require__(78);
  var getPrototypeOf = __webpack_require__(36);
  var gOPN = __webpack_require__(79).f;
  var getIterFn = __webpack_require__(198);
  var uid = __webpack_require__(85);
  var wks = __webpack_require__(12);
  var createArrayMethod = __webpack_require__(46);
  var createArrayIncludes = __webpack_require__(133);
  var speciesConstructor = __webpack_require__(118);
  var ArrayIterators = __webpack_require__(199);
  var Iterators = __webpack_require__(95);
  var $iterDetect = __webpack_require__(138);
  var setSpecies = __webpack_require__(83);
  var arrayFill = __webpack_require__(174);
  var arrayCopyWithin = __webpack_require__(260);
  var $DP = __webpack_require__(15);
  var $GOPD = __webpack_require__(35);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(11);

var PooledClass = __webpack_require__(88);

var emptyFunction = __webpack_require__(50);
var warning = __webpack_require__(10);

var didWarnForAddedNewProperty = false;
var isProxySupported = typeof Proxy === 'function';

var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var EventInterface = {
  type: null,
  target: null,
  // currentTarget is set when dispatching; no use in copying it here
  currentTarget: emptyFunction.thatReturnsNull,
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function (event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};

/**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {*} targetInst Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @param {DOMEventTarget} nativeEventTarget Target node.
 */
function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
  if (false) {
    // these have a getter/setter for warnings
    delete this.nativeEvent;
    delete this.preventDefault;
    delete this.stopPropagation;
  }

  this.dispatchConfig = dispatchConfig;
  this._targetInst = targetInst;
  this.nativeEvent = nativeEvent;

  var Interface = this.constructor.Interface;
  for (var propName in Interface) {
    if (!Interface.hasOwnProperty(propName)) {
      continue;
    }
    if (false) {
      delete this[propName]; // this has a getter/setter for warnings
    }
    var normalize = Interface[propName];
    if (normalize) {
      this[propName] = normalize(nativeEvent);
    } else {
      if (propName === 'target') {
        this.target = nativeEventTarget;
      } else {
        this[propName] = nativeEvent[propName];
      }
    }
  }

  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
  if (defaultPrevented) {
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  } else {
    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
  }
  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
  return this;
}

_assign(SyntheticEvent.prototype, {
  preventDefault: function () {
    this.defaultPrevented = true;
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.preventDefault) {
      event.preventDefault();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.returnValue !== 'unknown') {
      event.returnValue = false;
    }
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  },

  stopPropagation: function () {
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.stopPropagation) {
      event.stopPropagation();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.cancelBubble !== 'unknown') {
      // The ChangeEventPlugin registers a "propertychange" event for
      // IE. This event does not support bubbling or cancelling, and
      // any references to cancelBubble throw "Member not found".  A
      // typeof check of "unknown" circumvents this issue (and is also
      // IE specific).
      event.cancelBubble = true;
    }

    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
  },

  /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */
  persist: function () {
    this.isPersistent = emptyFunction.thatReturnsTrue;
  },

  /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */
  isPersistent: emptyFunction.thatReturnsFalse,

  /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */
  destructor: function () {
    var Interface = this.constructor.Interface;
    for (var propName in Interface) {
      if (false) {
        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
      } else {
        this[propName] = null;
      }
    }
    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
      this[shouldBeReleasedProperties[i]] = null;
    }
    if (false) {
      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
    }
  }
});

SyntheticEvent.Interface = EventInterface;

/**
 * Helper to reduce boilerplate when creating subclasses.
 *
 * @param {function} Class
 * @param {?object} Interface
 */
SyntheticEvent.augmentClass = function (Class, Interface) {
  var Super = this;

  var E = function () {};
  E.prototype = Super.prototype;
  var prototype = new E();

  _assign(prototype, Class.prototype);
  Class.prototype = prototype;
  Class.prototype.constructor = Class;

  Class.Interface = _assign({}, Super.Interface, Interface);
  Class.augmentClass = Super.augmentClass;

  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
};

/** Proxying after everything set on SyntheticEvent
  * to resolve Proxy issue on some WebKit browsers
  * in which some Event properties are set to undefined (GH#10010)
  */
if (false) {
  if (isProxySupported) {
    /*eslint-disable no-func-assign */
    SyntheticEvent = new Proxy(SyntheticEvent, {
      construct: function (target, args) {
        return this.apply(target, Object.create(target.prototype), args);
      },
      apply: function (constructor, that, args) {
        return new Proxy(constructor.apply(that, args), {
          set: function (target, prop, value) {
            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
              didWarnForAddedNewProperty = true;
            }
            target[prop] = value;
            return true;
          }
        });
      }
    });
    /*eslint-enable no-func-assign */
  }
}

PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);

module.exports = SyntheticEvent;

/**
  * Helper to nullify syntheticEvent instance properties when destructing
  *
  * @param {object} SyntheticEvent
  * @param {String} propName
  * @return {object} defineProperty object
  */
function getPooledWarningPropertyDefinition(propName, getVal) {
  var isFunction = typeof getVal === 'function';
  return {
    configurable: true,
    set: set,
    get: get
  };

  function set(val) {
    var action = isFunction ? 'setting the method' : 'setting the property';
    warn(action, 'This is effectively a no-op');
    return val;
  }

  function get() {
    var action = isFunction ? 'accessing the method' : 'accessing the property';
    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
    warn(action, result);
    return getVal;
  }

  function warn(action, result) {
    var warningCondition = false;
     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
  }
}

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debug__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__css__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var debug = __WEBPACK_IMPORTED_MODULE_1_debug___default()('itaigi:分享鍵');

var 分享鍵 = function (_React$Component) {
  _inherits(分享鍵, _React$Component);

  function 分享鍵(props) {
    _classCallCheck(this, 分享鍵);

    return _possibleConstructorReturn(this, (分享鍵.__proto__ || Object.getPrototypeOf(分享鍵)).call(this, props));
  }

  _createClass(分享鍵, [{
    key: 'getCurrentLocation',
    value: function getCurrentLocation() {
      var routerPathname = __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* browserHistory */].getCurrentLocation().pathname;
      var pathname = this.props.pathname;


      pathname = pathname || routerPathname || '';

      if (pathname[0] === '/') {
        pathname = pathname.substr(1);
      }

      pathname = encodeURIComponent(decodeURIComponent(pathname));

      return pathname;
    }
  }, {
    key: 'render',
    value: function render() {
      var size = this.props.size;

      var pathname = this.getCurrentLocation();

      var width = 92;
      var height = 20;
      if (size == 'large') {
        width = 110;
        height = 28;
      } else {
        size = 'small';
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe', {
        src: 'https://www.facebook.com/plugins/share_button.php?' + 'href=https%3A%2F%2Fitaigi.tw%2F' + pathname + '&appId=590065061070994' + '&layout=button_count' + '&mobile_iframe=true' + '&size=' + size + '&width=' + width + '&height=' + height,
        width: width, height: height,
        style: { border: 'none', overflow: 'hidden' },
        scrolling: 'no', frameBorder: '0',
        allowTransparency: 'true' });
    }
  }]);

  return 分享鍵;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (分享鍵);

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(403);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(402);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(240);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(240);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(111)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(23);
var core = __webpack_require__(33);
var ctx = __webpack_require__(110);
var hide = __webpack_require__(74);
var has = __webpack_require__(73);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(12)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(30)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 65 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(85)('meta');
var isObject = __webpack_require__(7);
var has = __webpack_require__(34);
var setDesc = __webpack_require__(15).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(6)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;

var _warning = __webpack_require__(70);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
  var _parsePath = parsePath(path),
      pathname = _parsePath.pathname,
      search = _parsePath.search,
      hash = _parsePath.hash;

  return createPath({
    pathname: pathname,
    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
    hash: hash
  });
};

var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
  var _parsePath2 = parsePath(path),
      pathname = _parsePath2.pathname,
      search = _parsePath2.search,
      hash = _parsePath2.hash;

  return createPath({
    pathname: pathname,
    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
      return prefix === '?' ? prefix : suffix;
    }),
    hash: hash
  });
};

var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
  var _parsePath3 = parsePath(path),
      search = _parsePath3.search;

  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
  return match && match[1];
};

var extractPath = function extractPath(string) {
  var match = string.match(/^(https?:)?\/\/[^\/]*/);
  return match == null ? string : string.substring(match[0].length);
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = extractPath(path);
  var search = '';
  var hash = '';

   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substring(hashIndex);
    pathname = pathname.substring(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substring(searchIndex);
    pathname = pathname.substring(0, searchIndex);
  }

  if (pathname === '') pathname = '/';

  return {
    pathname: pathname,
    search: search,
    hash: hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  if (location == null || typeof location === 'string') return location;

  var basename = location.basename,
      pathname = location.pathname,
      search = location.search,
      hash = location.hash;

  var path = (basename || '') + pathname;

  if (search && search !== '?') path += search;

  if (hash) path += hash;

  return path;
};

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isReactChildren;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRouteFromReactElement;
/* unused harmony export createRoutesFromReactChildren */
/* harmony export (immutable) */ __webpack_exports__["b"] = createRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function isValidChild(object) {
  return object == null || __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(object);
}

function isReactChildren(object) {
  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
}

function createRoute(defaultProps, props) {
  return _extends({}, defaultProps, props);
}

function createRouteFromReactElement(element) {
  var type = element.type;
  var route = createRoute(type.defaultProps, element.props);

  if (route.children) {
    var childRoutes = createRoutesFromReactChildren(route.children, route);

    if (childRoutes.length) route.childRoutes = childRoutes;

    delete route.children;
  }

  return route;
}

/**
 * Creates and returns a routes object from the given ReactChildren. JSX
 * provides a convenient way to visualize how routes in the hierarchy are
 * nested.
 *
 *   import { Route, createRoutesFromReactChildren } from 'react-router'
 *
 *   const routes = createRoutesFromReactChildren(
 *     <Route component={App}>
 *       <Route path="home" component={Dashboard}/>
 *       <Route path="news" component={NewsFeed}/>
 *     </Route>
 *   )
 *
 * Note: This method is automatically used when you provide <Route> children
 * to a <Router> component.
 */
function createRoutesFromReactChildren(children, parentRoute) {
  var routes = [];

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
    if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
      // Component classes may have a static create* method.
      if (element.type.createRouteFromReactElement) {
        var route = element.type.createRouteFromReactElement(element, parentRoute);

        if (route) routes.push(route);
      } else {
        routes.push(createRouteFromReactElement(element));
      }
    }
  });

  return routes;
}

/**
 * Creates and returns an array of routes from the given object which
 * may be a JSX route, a plain object route, or an array of either.
 */
function createRoutes(routes) {
  if (isReactChildren(routes)) {
    routes = createRoutesFromReactChildren(routes);
  } else if (routes && !Array.isArray(routes)) {
    routes = [routes];
  }

  return routes;
}

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @copyright © 2015, Rick Wong. All rights reserved.
 */


module.exports = {
	createContainer:              __webpack_require__(811),
	injectIntoMarkup:             __webpack_require__(812),
	isContainer:                  __webpack_require__(348),
	isRootContainer:              __webpack_require__(158),
	render:                       __webpack_require__(815),
	renderToString:               __webpack_require__(816),
	takeFromMarkup:               __webpack_require__(350),
	setPromiseConstructor:        function (PromiseConstructor) {
		__webpack_require__(231).Promise = PromiseConstructor;
	}
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(404);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(407);


/***/ }),
/* 73 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(75);
var createDesc = __webpack_require__(130);
module.exports = __webpack_require__(61) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(53);
var IE8_DOM_DEFINE = __webpack_require__(244);
var toPrimitive = __webpack_require__(170);
var dP = Object.defineProperty;

exports.f = __webpack_require__(61) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 76 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(41);
var call = __webpack_require__(271);
var isArrayIter = __webpack_require__(182);
var anObject = __webpack_require__(2);
var toLength = __webpack_require__(13);
var getIterFn = __webpack_require__(198);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(2);
var dPs = __webpack_require__(277);
var enumBugKeys = __webpack_require__(178);
var IE_PROTO = __webpack_require__(191)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(177)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(180).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(279);
var hiddenKeys = __webpack_require__(178).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(279);
var enumBugKeys = __webpack_require__(178);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(31);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(4);
var dP = __webpack_require__(15);
var DESCRIPTORS = __webpack_require__(14);
var SPECIES = __webpack_require__(12)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(43);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 85 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(7);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 87 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(9);

var invariant = __webpack_require__(3);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactRef = __webpack_require__(739);
var ReactInstrumentation = __webpack_require__(38);

var warning = __webpack_require__(10);

/**
 * Helper to call ReactRef.attachRefs with this composite component, split out
 * to avoid allocations in the transaction mount-ready queue.
 */
function attachRefs() {
  ReactRef.attachRefs(this, this._currentElement);
}

var ReactReconciler = {
  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} the containing host component instance
   * @param {?object} info about the host container
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
  {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
      }
    }
    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
      }
    }
    return markup;
  },

  /**
   * Returns a value that can be passed to
   * ReactComponentEnvironment.replaceNodeWithMarkup.
   */
  getHostNode: function (internalInstance) {
    return internalInstance.getHostNode();
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (internalInstance, safely) {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
      }
    }
    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
    internalInstance.unmountComponent(safely);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Update a component using a new element.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @internal
   */
  receiveComponent: function (internalInstance, nextElement, transaction, context) {
    var prevElement = internalInstance._currentElement;

    if (nextElement === prevElement && context === internalInstance._context) {
      // Since elements are immutable after the owner is rendered,
      // we can do a cheap identity compare here to determine if this is a
      // superfluous reconcile. It's possible for state to be mutable but such
      // change should trigger an update of the owner which would recreate
      // the element. We explicitly check for the existence of an owner since
      // it's possible for an element created outside a composite to be
      // deeply mutated and reused.

      // TODO: Bailing out early is just a perf optimization right?
      // TODO: Removing the return statement should affect correctness?
      return;
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
      }
    }

    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);

    if (refsChanged) {
      ReactRef.detachRefs(internalInstance, prevElement);
    }

    internalInstance.receiveComponent(nextElement, transaction, context);

    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Flush any dirty changes in a component.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
      // The component's enqueued batch number should always be the current
      // batch or the following one.
       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
      return;
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
      }
    }
    internalInstance.performUpdateIfNecessary(transaction);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  }
};

module.exports = ReactReconciler;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(11);

var ReactBaseClasses = __webpack_require__(351);
var ReactChildren = __webpack_require__(819);
var ReactDOMFactories = __webpack_require__(820);
var ReactElement = __webpack_require__(104);
var ReactPropTypes = __webpack_require__(821);
var ReactVersion = __webpack_require__(822);

var createReactClass = __webpack_require__(823);
var onlyChild = __webpack_require__(827);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SoundsMapping__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HapSing__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GA__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__HuatIm_css__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__HuatIm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__HuatIm_css__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var debug = __WEBPACK_IMPORTED_MODULE_3_debug___default()('itaigi:HuatIm');

var HuatIm = function (_React$Component) {
  _inherits(HuatIm, _React$Component);

  function HuatIm() {
    _classCallCheck(this, HuatIm);

    return _possibleConstructorReturn(this, (HuatIm.__proto__ || Object.getPrototypeOf(HuatIm)).apply(this, arguments));
  }

  _createClass(HuatIm, [{
    key: 'play',
    value: function play(id) {
      var _props = this.props,
          hanji = _props.hanji,
          音標 = _props.音標;

      document.getElementById(id).play();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__GA__["a" /* gaThiann */])(hanji, 音標);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          音標 = _props2.音標,
          hanji = _props2.hanji;

      if (!音標) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'HuatIm hidden' });
      }

      var id = __WEBPACK_IMPORTED_MODULE_1__SoundsMapping__["a" /* default */].map(音標);
      if (id === undefined) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__HapSing__["a" /* default */], { 音標: 音標, hanji: hanji });
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'HuatIm' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'audio',
          { id: 'audio_' + id },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source', { type: 'audio/mpeg',
            src: 'https://1763c5ee9859e0316ed6-db85b55a6a3fbe33f09b9245992383bd.ssl.cf1.rackcdn.com/' + id + '.mp3' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { onClick: this.play.bind(this, 'audio_' + id),
            className: 'ui compact icon button', title: '\u767C\u97F3' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'icon play' })
        )
      );
    }
  }]);

  return HuatIm;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (HuatIm);
;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(401);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(245);
var defined = __webpack_require__(160);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(39);
var TAG = __webpack_require__(12)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(15).f;
var has = __webpack_require__(34);
var TAG = __webpack_require__(12)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var defined = __webpack_require__(47);
var fails = __webpack_require__(6);
var spaces = __webpack_require__(194);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(25);

var _invariant2 = _interopRequireDefault(_invariant);

var _warning = __webpack_require__(70);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(67);

var _Actions = __webpack_require__(148);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createQuery = exports.createQuery = function createQuery(props) {
  return _extends(Object.create(null), props);
};

var createLocation = exports.createLocation = function createLocation() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;

   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;

  var pathname = object.pathname || '/';
  var search = object.search || '';
  var hash = object.hash || '';
  var state = object.state;

  return {
    pathname: pathname,
    search: search,
    hash: hash,
    state: state,
    action: action,
    key: key
  };
};

var isDate = function isDate(object) {
  return Object.prototype.toString.call(object) === '[object Date]';
};

var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
  if (a === b) return true;

  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (typeofA !== typeofB) return false;

  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;

  // Not the same object, but same type.
  if (typeofA === 'object') {
    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;

    if (!Array.isArray(a)) {
      var keysofA = Object.keys(a);
      var keysofB = Object.keys(b);
      return keysofA.length === keysofB.length && keysofA.every(function (key) {
        return statesAreEqual(a[key], b[key]);
      });
    }

    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return statesAreEqual(item, b[index]);
    });
  }

  // All other serializable types (string, number, boolean)
  // should be strict equal.
  return false;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.key === b.key &&
  // a.action === b.action && // Different action !== location change.
  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
};

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMNamespaces = __webpack_require__(206);
var setInnerHTML = __webpack_require__(155);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(214);
var setTextContent = __webpack_require__(329);

var ELEMENT_NODE_TYPE = 1;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

/**
 * In IE (8-11) and Edge, appending nodes with no children is dramatically
 * faster than appending a full subtree, so we essentially queue up the
 * .appendChild calls here and apply them so each node is added to its parent
 * before any children are added.
 *
 * In other browsers, doing so is slower or neutral compared to the other order
 * (in Firefox, twice as slow) so we only do this inversion in IE.
 *
 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
 */
var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);

function insertTreeChildren(tree) {
  if (!enableLazy) {
    return;
  }
  var node = tree.node;
  var children = tree.children;
  if (children.length) {
    for (var i = 0; i < children.length; i++) {
      insertTreeBefore(node, children[i], null);
    }
  } else if (tree.html != null) {
    setInnerHTML(node, tree.html);
  } else if (tree.text != null) {
    setTextContent(node, tree.text);
  }
}

var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
  // DocumentFragments aren't actually part of the DOM after insertion so
  // appending children won't update the DOM. We need to ensure the fragment
  // is properly populated first, breaking out of our lazy approach for just
  // this level. Also, some <object> plugins (like Flash Player) will read
  // <param> nodes immediately upon insertion into the DOM, so <object>
  // must also be populated prior to insertion into the DOM.
  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
    insertTreeChildren(tree);
    parentNode.insertBefore(tree.node, referenceNode);
  } else {
    parentNode.insertBefore(tree.node, referenceNode);
    insertTreeChildren(tree);
  }
});

function replaceChildWithTree(oldNode, newTree) {
  oldNode.parentNode.replaceChild(newTree.node, oldNode);
  insertTreeChildren(newTree);
}

function queueChild(parentTree, childTree) {
  if (enableLazy) {
    parentTree.children.push(childTree);
  } else {
    parentTree.node.appendChild(childTree.node);
  }
}

function queueHTML(tree, html) {
  if (enableLazy) {
    tree.html = html;
  } else {
    setInnerHTML(tree.node, html);
  }
}

function queueText(tree, text) {
  if (enableLazy) {
    tree.text = text;
  } else {
    setTextContent(tree.node, text);
  }
}

function toString() {
  return this.node.nodeName;
}

function DOMLazyTree(node) {
  return {
    node: node,
    children: [],
    html: null,
    text: null,
    toString: toString
  };
}

DOMLazyTree.insertTreeBefore = insertTreeBefore;
DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
DOMLazyTree.queueChild = queueChild;
DOMLazyTree.queueHTML = queueHTML;
DOMLazyTree.queueText = queueText;

module.exports = DOMLazyTree;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(9);

var invariant = __webpack_require__(3);

function checkMask(value, bitmask) {
  return (value & bitmask) === bitmask;
}

var DOMPropertyInjection = {
  /**
   * Mapping from normalized, camelcased property names to a configuration that
   * specifies how the associated DOM property should be accessed or rendered.
   */
  MUST_USE_PROPERTY: 0x1,
  HAS_BOOLEAN_VALUE: 0x4,
  HAS_NUMERIC_VALUE: 0x8,
  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,

  /**
   * Inject some specialized knowledge about the DOM. This takes a config object
   * with the following properties:
   *
   * isCustomAttribute: function that given an attribute name will return true
   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
   * attributes where it's impossible to enumerate all of the possible
   * attribute names,
   *
   * Properties: object mapping DOM property name to one of the
   * DOMPropertyInjection constants or null. If your attribute isn't in here,
   * it won't get written to the DOM.
   *
   * DOMAttributeNames: object mapping React attribute name to the DOM
   * attribute name. Attribute names not specified use the **lowercase**
   * normalized name.
   *
   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
   * attribute namespace URL. (Attribute names not specified use no namespace.)
   *
   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
   * Property names not specified use the normalized name.
   *
   * DOMMutationMethods: Properties that require special mutation methods. If
   * `value` is undefined, the mutation method should unset the property.
   *
   * @param {object} domPropertyConfig the config as described above.
   */
  injectDOMPropertyConfig: function (domPropertyConfig) {
    var Injection = DOMPropertyInjection;
    var Properties = domPropertyConfig.Properties || {};
    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};

    if (domPropertyConfig.isCustomAttribute) {
      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
    }

    for (var propName in Properties) {
      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;

      var lowerCased = propName.toLowerCase();
      var propConfig = Properties[propName];

      var propertyInfo = {
        attributeName: lowerCased,
        attributeNamespace: null,
        propertyName: propName,
        mutationMethod: null,

        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
      };
      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;

      if (false) {
        DOMProperty.getPossibleStandardName[lowerCased] = propName;
      }

      if (DOMAttributeNames.hasOwnProperty(propName)) {
        var attributeName = DOMAttributeNames[propName];
        propertyInfo.attributeName = attributeName;
        if (false) {
          DOMProperty.getPossibleStandardName[attributeName] = propName;
        }
      }

      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
      }

      if (DOMPropertyNames.hasOwnProperty(propName)) {
        propertyInfo.propertyName = DOMPropertyNames[propName];
      }

      if (DOMMutationMethods.hasOwnProperty(propName)) {
        propertyInfo.mutationMethod = DOMMutationMethods[propName];
      }

      DOMProperty.properties[propName] = propertyInfo;
    }
  }
};

/* eslint-disable max-len */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
/* eslint-enable max-len */

/**
 * DOMProperty exports lookup objects that can be used like functions:
 *
 *   > DOMProperty.isValid['id']
 *   true
 *   > DOMProperty.isValid['foobar']
 *   undefined
 *
 * Although this may be confusing, it performs better in general.
 *
 * @see http://jsperf.com/key-exists
 * @see http://jsperf.com/key-missing
 */
var DOMProperty = {
  ID_ATTRIBUTE_NAME: 'data-reactid',
  ROOT_ATTRIBUTE_NAME: 'data-reactroot',

  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',

  /**
   * Map from property "standard name" to an object with info about how to set
   * the property in the DOM. Each object contains:
   *
   * attributeName:
   *   Used when rendering markup or with `*Attribute()`.
   * attributeNamespace
   * propertyName:
   *   Used on DOM node instances. (This includes properties that mutate due to
   *   external factors.)
   * mutationMethod:
   *   If non-null, used instead of the property or `setAttribute()` after
   *   initial render.
   * mustUseProperty:
   *   Whether the property must be accessed and mutated as an object property.
   * hasBooleanValue:
   *   Whether the property should be removed when set to a falsey value.
   * hasNumericValue:
   *   Whether the property must be numeric or parse as a numeric and should be
   *   removed when set to a falsey value.
   * hasPositiveNumericValue:
   *   Whether the property must be positive numeric or parse as a positive
   *   numeric and should be removed when set to a falsey value.
   * hasOverloadedBooleanValue:
   *   Whether the property can be used as a flag as well as with a value.
   *   Removed when strictly equal to false; present without a value when
   *   strictly equal to true; present with a value otherwise.
   */
  properties: {},

  /**
   * Mapping from lowercase property names to the properly cased version, used
   * to warn in the case of missing properties. Available only in __DEV__.
   *
   * autofocus is predefined, because adding it to the property whitelist
   * causes unintended side effects.
   *
   * @type {Object}
   */
  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,

  /**
   * All of the isCustomAttribute() functions that have been injected.
   */
  _isCustomAttributeFunctions: [],

  /**
   * Checks whether a property name is a custom attribute.
   * @method
   */
  isCustomAttribute: function (attributeName) {
    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
      if (isCustomAttributeFn(attributeName)) {
        return true;
      }
    }
    return false;
  },

  injection: DOMPropertyInjection
};

module.exports = DOMProperty;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = getCurrentHref;

var _canUseDom = __webpack_require__(241);

var _canUseDom2 = _interopRequireDefault(_canUseDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getCurrentHref() {
  if (!_canUseDom2.default) {
    return 'http://www.facebook.com';
  }

  return location.href;
}
//# sourceMappingURL=getCurrentHref.js.map

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export compilePattern */
/* harmony export (immutable) */ __webpack_exports__["b"] = matchPattern;
/* harmony export (immutable) */ __webpack_exports__["a"] = getParamNames;
/* unused harmony export getParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = formatPattern;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);


function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function _compilePattern(pattern) {
  var regexpSource = '';
  var paramNames = [];
  var tokens = [];

  var match = void 0,
      lastIndex = 0,
      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
  while (match = matcher.exec(pattern)) {
    if (match.index !== lastIndex) {
      tokens.push(pattern.slice(lastIndex, match.index));
      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
    }

    if (match[1]) {
      regexpSource += '([^/]+)';
      paramNames.push(match[1]);
    } else if (match[0] === '**') {
      regexpSource += '(.*)';
      paramNames.push('splat');
    } else if (match[0] === '*') {
      regexpSource += '(.*?)';
      paramNames.push('splat');
    } else if (match[0] === '(') {
      regexpSource += '(?:';
    } else if (match[0] === ')') {
      regexpSource += ')?';
    } else if (match[0] === '\\(') {
      regexpSource += '\\(';
    } else if (match[0] === '\\)') {
      regexpSource += '\\)';
    }

    tokens.push(match[0]);

    lastIndex = matcher.lastIndex;
  }

  if (lastIndex !== pattern.length) {
    tokens.push(pattern.slice(lastIndex, pattern.length));
    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
  }

  return {
    pattern: pattern,
    regexpSource: regexpSource,
    paramNames: paramNames,
    tokens: tokens
  };
}

var CompiledPatternsCache = Object.create(null);

function compilePattern(pattern) {
  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);

  return CompiledPatternsCache[pattern];
}

/**
 * Attempts to match a pattern on the given pathname. Patterns may use
 * the following special characters:
 *
 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
 *                  captured string is considered a "param"
 * - ()             Wraps a segment of the URL that is optional
 * - *              Consumes (non-greedy) all characters up to the next
 *                  character in the pattern, or to the end of the URL if
 *                  there is none
 * - **             Consumes (greedy) all characters up to the next character
 *                  in the pattern, or to the end of the URL if there is none
 *
 *  The function calls callback(error, matched) when finished.
 * The return value is an object with the following properties:
 *
 * - remainingPathname
 * - paramNames
 * - paramValues
 */
function matchPattern(pattern, pathname) {
  // Ensure pattern starts with leading slash for consistency with pathname.
  if (pattern.charAt(0) !== '/') {
    pattern = '/' + pattern;
  }

  var _compilePattern2 = compilePattern(pattern),
      regexpSource = _compilePattern2.regexpSource,
      paramNames = _compilePattern2.paramNames,
      tokens = _compilePattern2.tokens;

  if (pattern.charAt(pattern.length - 1) !== '/') {
    regexpSource += '/?'; // Allow optional path separator at end.
  }

  // Special-case patterns like '*' for catch-all routes.
  if (tokens[tokens.length - 1] === '*') {
    regexpSource += '$';
  }

  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
  if (match == null) {
    return null;
  }

  var matchedPath = match[0];
  var remainingPathname = pathname.substr(matchedPath.length);

  if (remainingPathname) {
    // Require that the match ends at a path separator, if we didn't match
    // the full path, so any remaining pathname is a new path segment.
    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
      return null;
    }

    // If there is a remaining pathname, treat the path separator as part of
    // the remaining pathname for properly continuing the match.
    remainingPathname = '/' + remainingPathname;
  }

  return {
    remainingPathname: remainingPathname,
    paramNames: paramNames,
    paramValues: match.slice(1).map(function (v) {
      return v && decodeURIComponent(v);
    })
  };
}

function getParamNames(pattern) {
  return compilePattern(pattern).paramNames;
}

function getParams(pattern, pathname) {
  var match = matchPattern(pattern, pathname);
  if (!match) {
    return null;
  }

  var paramNames = match.paramNames,
      paramValues = match.paramValues;

  var params = {};

  paramNames.forEach(function (paramName, index) {
    params[paramName] = paramValues[index];
  });

  return params;
}

/**
 * Returns a version of the given pattern with params interpolated. Throws
 * if there is a dynamic segment of the pattern for which there is no param.
 */
function formatPattern(pattern, params) {
  params = params || {};

  var _compilePattern3 = compilePattern(pattern),
      tokens = _compilePattern3.tokens;

  var parenCount = 0,
      pathname = '',
      splatIndex = 0,
      parenHistory = [];

  var token = void 0,
      paramName = void 0,
      paramValue = void 0;
  for (var i = 0, len = tokens.length; i < len; ++i) {
    token = tokens[i];

    if (token === '*' || token === '**') {
      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;

      !(paramValue != null || parenCount > 0) ?  false ? invariant(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      if (paramValue != null) pathname += encodeURI(paramValue);
    } else if (token === '(') {
      parenHistory[parenCount] = '';
      parenCount += 1;
    } else if (token === ')') {
      var parenText = parenHistory.pop();
      parenCount -= 1;

      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
    } else if (token === '\\(') {
      pathname += '(';
    } else if (token === '\\)') {
      pathname += ')';
    } else if (token.charAt(0) === ':') {
      paramName = token.substring(1);
      paramValue = params[paramName];

      !(paramValue != null || parenCount > 0) ?  false ? invariant(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      if (paramValue == null) {
        if (parenCount) {
          parenHistory[parenCount - 1] = '';

          var curTokenIdx = tokens.indexOf(token);
          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
          var nextParenIdx = -1;

          for (var _i = 0; _i < tokensSubset.length; _i++) {
            if (tokensSubset[_i] == ')') {
              nextParenIdx = _i;
              break;
            }
          }

          !(nextParenIdx > 0) ?  false ? invariant(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

          // jump to ending paren
          i = curTokenIdx + nextParenIdx - 1;
        }
      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
    } else {
      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
    }
  }

  !(parenCount <= 0) ?  false ? invariant(false, 'Path "%s" is missing end paren', pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

  return pathname.replace(/\/+/g, '/');
}

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export _resetWarned */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var warned = {};

function routerWarning(falseToWarn, message) {
  // Only issue deprecation warnings once.
  if (message.indexOf('deprecated') !== -1) {
    if (warned[message]) {
      return;
    }

    warned[message] = true;
  }

  message = '[react-router] ' + message;

  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  __WEBPACK_IMPORTED_MODULE_0_warning___default.a.apply(undefined, [falseToWarn, message].concat(args));
}

function _resetWarned() {
  warned = {};
}

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(11);

var ReactCurrentOwner = __webpack_require__(57);

var warning = __webpack_require__(10);
var canDefineProperty = __webpack_require__(355);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(353);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 105 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return gaTshue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gaThiann; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return gaLeKu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return gaUaGi; });


var gaTshue = function gaTshue(su) {
  gtag('event', 'search', {
    search_term: su
  });
};

var gaThiann = function gaThiann(hanji, lomaji) {
  gtag('event', 'thiann', {
    event_category: 'engagement',
    event_label: hanji,
    hanji: hanji,
    lomaji: lomaji
  });
};

var gaLeKu = function gaLeKu(hanji, lomaji) {
  gtag('event', 'lē-kù', {
    event_category: 'engagement',
    event_label: hanji
  });
};

var gaUaGi = function gaUaGi(su) {
  gtag('event', 'uá-gī', {
    event_category: 'engagement',
    event_label: su
  });
};

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bluebird__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__APui__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var superagent = __webpack_require__(26)(__webpack_require__(27), __WEBPACK_IMPORTED_MODULE_1_bluebird__["Promise"]);

var log = __WEBPACK_IMPORTED_MODULE_4_debug___default()('itaigi:ABo');

var ABo = function (_React$Component) {
  _inherits(ABo, _React$Component);

  function ABo(props) {
    _classCallCheck(this, ABo);

    var _this = _possibleConstructorReturn(this, (ABo.__proto__ || Object.getPrototypeOf(ABo)).call(this, props));

    _this.state = {
      漢字: _this.props.漢字 || '',
      音標: _this.props.音標 || '',
      modalIsOpen: false,
      送出中: false
    };
    return _this;
  }

  _createClass(ABo, [{
    key: 'handle\u6F22\u5B57KeyUp',
    value: function handleKeyUp(evt) {
      var q = evt.target.value;
      this.setState({ 漢字: q });
    }
  }, {
    key: 'handle\u97F3\u6A19KeyUp',
    value: function handleKeyUp(evt) {
      var q = evt.target.value;
      this.setState({ 音標: q });
    }
  }, {
    key: '\u67E5\u600E\u6A23\u8B1B',
    value: function _(evt) {
      var _this2 = this;

      if (this.state.漢字 !== '' || this.state.音標 !== '') {
        var 外語內容 = {
          '外語資料': this.props.華語關鍵字
        };
        superagent.post(__WEBPACK_IMPORTED_MODULE_3____["a" /* default */].加外語()).withCredentials().set('Content-Type', 'application/x-www-form-urlencoded').set('X-CSRFToken', this.props.csrftoken).send(外語內容).then(function (_ref) {
          var body = _ref.body;
          return _this2.加外語新詞文本(body.平臺項目編號);
        }).catch(function (res) {
          window.open(__WEBPACK_IMPORTED_MODULE_3____["a" /* default */].登入(), '_blank');
        });
        this.setState({
          送出中: true
        });
      }
    }
  }, {
    key: '\u52A0\u5916\u8A9E\u65B0\u8A5E\u6587\u672C',
    value: function _(外語項目編號) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_4_debug___default()(外語項目編號);
      var 建議新詞文本 = void 0;
      if (this.state.漢字 !== '') {
        建議新詞文本 = {
          '外語項目編號': 外語項目編號,
          '文本資料': this.state.漢字,
          '音標資料': this.state.音標
        };
      } else {
        建議新詞文本 = {
          '外語項目編號': 外語項目編號,
          '文本資料': this.state.音標
        };
      }

      superagent.post(__WEBPACK_IMPORTED_MODULE_3____["a" /* default */].加新詞文本()).withCredentials().set('Content-Type', 'application/x-www-form-urlencoded').set('X-CSRFToken', this.props.csrftoken).send(建議新詞文本).then(function (_ref2) {
        var body = _ref2.body;
        return _this3.openModal();
      }).catch(function (a) {
        return __WEBPACK_IMPORTED_MODULE_4_debug___default()(a);
      });
    }
  }, {
    key: 'openModal',
    value: function openModal() {
      this.setState({ modalIsOpen: true });
    }
  }, {
    key: 'closeModal',
    value: function closeModal() {
      this.setState({
        modalIsOpen: false,
        漢字: '',
        音標: '',
        送出中: false
      });
    }
  }, {
    key: 'render\u6709\u767B\u5165\u9215\u4ED4',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        {
          className: 'ui positive button large' + (this.state.送出中 ? ' disabled' : ''),
          onClick: this.查怎樣講.bind(this) },
        '\u9001\u51FA'
      );
    }
  }, {
    key: 'render\u7121\u767B\u5165\u9215\u4ED4',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'ui buttons' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            className: 'ui button large' + (this.state.送出中 ? ' disabled' : ''),
            onClick: this.查怎樣講.bind(this) },
          '\u533F\u540D\u9001\u51FA'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'or' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          { method: 'get', action: __WEBPACK_IMPORTED_MODULE_3____["a" /* default */].登入() },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'submit', className: 'ui positive button large', value: '\u767B\u5165 & \u9001\u51FA' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'hidden', name: 'next',
            value: '/%E5%B0%8E%E5%90%91?%E7%B6%B2%E5%9D%80=' + '//itaigi.tw/k/' + this.props.華語關鍵字 + '?' + encodeURI('%E6%BC%A2%E5%AD%97=' + this.state.漢字 + '&' + '%E9%9F%B3%E6%A8%99=' + this.state.音標) })
        )
      );

      // %E6%BC%A2%E5%AD%97 漢字
      // %E9%9F%B3%E6%A8%99 音標
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'ui form' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'field' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            null,
            '\u81FA\u8A9E\u6F22\u5B57'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'abo ui input large' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { placeholder: '\u81FA\u8A9E\u6F22\u5B57', type: 'text',
              value: this.state.漢字,
              onChange: this.handle漢字KeyUp.bind(this) })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'field' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            null,
            '\u53F0\u7F85'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'abo ui input large' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { placeholder: '\u53F0\u7F85', type: 'text',
              value: this.state.音標,
              onChange: this.handle音標KeyUp.bind(this) })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'field' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            null,
            '\u9001\u51FA\u6642\uFF0C\u4EA6\u8868\u793A\u60A8\u540C\u610F\u5167\u5BB9\u4EE5',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { href: 'http://creativecommons.tw/cc0', target: 'blank' },
              'CC0'
            ),
            '\uFF62\u4E0D\u4FDD\u7559\u6B0A\u5229\uFF63\u6388\u6B0A '
          )
        ),
        this.props.編號 == '無登入' ? this.render無登入鈕仔() : this.render有登入鈕仔(),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__APui__["a" /* default */], { modalIsOpen: this.state.modalIsOpen,
          closeModal: this.closeModal.bind(this) })
      );
    }
  }]);

  return ABo;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (ABo);


ABo.propTypes = {
  漢字: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.string,
  音標: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.string,
  華語關鍵字: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.string,
  csrftoken: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.string
};

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_facebook__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_facebook___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_facebook__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var 留言板 = function (_React$Component) {
  _inherits(留言板, _React$Component);

  function 留言板() {
    _classCallCheck(this, 留言板);

    return _possibleConstructorReturn(this, (留言板.__proto__ || Object.getPrototypeOf(留言板)).apply(this, arguments));
  }

  _createClass(留言板, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_react_facebook___default.a,
        { appId: '174108146521045' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_facebook__["Comments"], { width: '100%' })
      );
    }
  }]);

  return 留言板;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (留言板);

/***/ }),
/* 109 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(127);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 112 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 113 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(2);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(39);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 116 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(40);
var global = __webpack_require__(4);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(65) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(2);
var aFunction = __webpack_require__(22);
var SPECIES = __webpack_require__(12)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(9);

var EventPluginRegistry = __webpack_require__(207);
var EventPluginUtils = __webpack_require__(208);
var ReactErrorUtils = __webpack_require__(212);

var accumulateInto = __webpack_require__(323);
var forEachAccumulated = __webpack_require__(324);
var invariant = __webpack_require__(3);

/**
 * Internal store for event listeners
 */
var listenerBank = {};

/**
 * Internal queue of events that have accumulated their dispatches and are
 * waiting to have their dispatches executed.
 */
var eventQueue = null;

/**
 * Dispatches an event and releases it back into the pool, unless persistent.
 *
 * @param {?object} event Synthetic event to be dispatched.
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @private
 */
var executeDispatchesAndRelease = function (event, simulated) {
  if (event) {
    EventPluginUtils.executeDispatchesInOrder(event, simulated);

    if (!event.isPersistent()) {
      event.constructor.release(event);
    }
  }
};
var executeDispatchesAndReleaseSimulated = function (e) {
  return executeDispatchesAndRelease(e, true);
};
var executeDispatchesAndReleaseTopLevel = function (e) {
  return executeDispatchesAndRelease(e, false);
};

var getDictionaryKey = function (inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
};

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

function shouldPreventMouseEvent(name, type, props) {
  switch (name) {
    case 'onClick':
    case 'onClickCapture':
    case 'onDoubleClick':
    case 'onDoubleClickCapture':
    case 'onMouseDown':
    case 'onMouseDownCapture':
    case 'onMouseMove':
    case 'onMouseMoveCapture':
    case 'onMouseUp':
    case 'onMouseUpCapture':
      return !!(props.disabled && isInteractive(type));
    default:
      return false;
  }
}

/**
 * This is a unified interface for event plugins to be installed and configured.
 *
 * Event plugins can implement the following properties:
 *
 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
 *     Required. When a top-level event is fired, this method is expected to
 *     extract synthetic events that will in turn be queued and dispatched.
 *
 *   `eventTypes` {object}
 *     Optional, plugins that fire events must publish a mapping of registration
 *     names that are used to register listeners. Values of this mapping must
 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
 *
 *   `executeDispatch` {function(object, function, string)}
 *     Optional, allows plugins to override how an event gets dispatched. By
 *     default, the listener is simply invoked.
 *
 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
 *
 * @public
 */
var EventPluginHub = {
  /**
   * Methods for injecting dependencies.
   */
  injection: {
    /**
     * @param {array} InjectedEventPluginOrder
     * @public
     */
    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,

    /**
     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
     */
    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
  },

  /**
   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {function} listener The callback to store.
   */
  putListener: function (inst, registrationName, listener) {
    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;

    var key = getDictionaryKey(inst);
    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
    bankForRegistrationName[key] = listener;

    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.didPutListener) {
      PluginModule.didPutListener(inst, registrationName, listener);
    }
  },

  /**
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @return {?function} The stored callback.
   */
  getListener: function (inst, registrationName) {
    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
    // live here; needs to be moved to a better place soon
    var bankForRegistrationName = listenerBank[registrationName];
    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
      return null;
    }
    var key = getDictionaryKey(inst);
    return bankForRegistrationName && bankForRegistrationName[key];
  },

  /**
   * Deletes a listener from the registration bank.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   */
  deleteListener: function (inst, registrationName) {
    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.willDeleteListener) {
      PluginModule.willDeleteListener(inst, registrationName);
    }

    var bankForRegistrationName = listenerBank[registrationName];
    // TODO: This should never be null -- when is it?
    if (bankForRegistrationName) {
      var key = getDictionaryKey(inst);
      delete bankForRegistrationName[key];
    }
  },

  /**
   * Deletes all listeners for the DOM element with the supplied ID.
   *
   * @param {object} inst The instance, which is the source of events.
   */
  deleteAllListeners: function (inst) {
    var key = getDictionaryKey(inst);
    for (var registrationName in listenerBank) {
      if (!listenerBank.hasOwnProperty(registrationName)) {
        continue;
      }

      if (!listenerBank[registrationName][key]) {
        continue;
      }

      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
      if (PluginModule && PluginModule.willDeleteListener) {
        PluginModule.willDeleteListener(inst, registrationName);
      }

      delete listenerBank[registrationName][key];
    }
  },

  /**
   * Allows registered plugins an opportunity to extract events from top-level
   * native browser events.
   *
   * @return {*} An accumulation of synthetic events.
   * @internal
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events;
    var plugins = EventPluginRegistry.plugins;
    for (var i = 0; i < plugins.length; i++) {
      // Not every plugin in the ordering may be loaded at runtime.
      var possiblePlugin = plugins[i];
      if (possiblePlugin) {
        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
        if (extractedEvents) {
          events = accumulateInto(events, extractedEvents);
        }
      }
    }
    return events;
  },

  /**
   * Enqueues a synthetic event that should be dispatched when
   * `processEventQueue` is invoked.
   *
   * @param {*} events An accumulation of synthetic events.
   * @internal
   */
  enqueueEvents: function (events) {
    if (events) {
      eventQueue = accumulateInto(eventQueue, events);
    }
  },

  /**
   * Dispatches all synthetic events on the event queue.
   *
   * @internal
   */
  processEventQueue: function (simulated) {
    // Set `eventQueue` to null before processing it so that we can tell if more
    // events get enqueued while processing.
    var processingEventQueue = eventQueue;
    eventQueue = null;
    if (simulated) {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
    } else {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
    }
    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
    // This would be a good time to rethrow if any of the event handlers threw.
    ReactErrorUtils.rethrowCaughtError();
  },

  /**
   * These are needed for tests only. Do not use!
   */
  __purge: function () {
    listenerBank = {};
  },

  __getListenerBank: function () {
    return listenerBank;
  }
};

module.exports = EventPluginHub;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPluginHub = __webpack_require__(119);
var EventPluginUtils = __webpack_require__(208);

var accumulateInto = __webpack_require__(323);
var forEachAccumulated = __webpack_require__(324);
var warning = __webpack_require__(10);

var getListener = EventPluginHub.getListener;

/**
 * Some event types have a notion of different registration names for different
 * "phases" of propagation. This finds listeners by a given phase.
 */
function listenerAtPhase(inst, event, propagationPhase) {
  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
  return getListener(inst, registrationName);
}

/**
 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
 * here, allows us to not have to bind or create functions for each event.
 * Mutating the event's members allows us to not have to create a wrapping
 * "dispatch" object that pairs the event with the listener.
 */
function accumulateDirectionalDispatches(inst, phase, event) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
  }
  var listener = listenerAtPhase(inst, event, phase);
  if (listener) {
    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
  }
}

/**
 * Collect dispatches (must be entirely collected before dispatching - see unit
 * tests). Lazily allocate the array to conserve memory.  We must loop through
 * each event and perform the traversal for each one. We cannot perform a
 * single traversal for the entire collection of events because each event may
 * have a different target.
 */
function accumulateTwoPhaseDispatchesSingle(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
 */
function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    var targetInst = event._targetInst;
    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Accumulates without regard to direction, does not look for phased
 * registration names. Same as `accumulateDirectDispatchesSingle` but without
 * requiring that the `dispatchMarker` be the same as the dispatched ID.
 */
function accumulateDispatches(inst, ignoredDirection, event) {
  if (event && event.dispatchConfig.registrationName) {
    var registrationName = event.dispatchConfig.registrationName;
    var listener = getListener(inst, registrationName);
    if (listener) {
      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
    }
  }
}

/**
 * Accumulates dispatches on an `SyntheticEvent`, but only for the
 * `dispatchMarker`.
 * @param {SyntheticEvent} event
 */
function accumulateDirectDispatchesSingle(event) {
  if (event && event.dispatchConfig.registrationName) {
    accumulateDispatches(event._targetInst, null, event);
  }
}

function accumulateTwoPhaseDispatches(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
}

function accumulateTwoPhaseDispatchesSkipTarget(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
}

function accumulateEnterLeaveDispatches(leave, enter, from, to) {
  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
}

function accumulateDirectDispatches(events) {
  forEachAccumulated(events, accumulateDirectDispatchesSingle);
}

/**
 * A small set of propagation patterns, each of which will accept a small amount
 * of information, and generate a set of "dispatch ready event objects" - which
 * are sets of events that have already been annotated with a set of dispatched
 * listener functions/ids. The API is designed this way to discourage these
 * propagation strategies from actually executing the dispatches, since we
 * always want to collect the entire set of dispatches before executing event a
 * single one.
 *
 * @constructor EventPropagators
 */
var EventPropagators = {
  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
  accumulateDirectDispatches: accumulateDirectDispatches,
  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
};

module.exports = EventPropagators;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 */

// TODO: Replace this with ES6: var ReactInstanceMap = new Map();

var ReactInstanceMap = {
  /**
   * This API should be called `delete` but we'd have to make sure to always
   * transform these to strings for IE support. When this transform is fully
   * supported we can rename it.
   */
  remove: function (key) {
    key._reactInternalInstance = undefined;
  },

  get: function (key) {
    return key._reactInternalInstance;
  },

  has: function (key) {
    return key._reactInternalInstance !== undefined;
  },

  set: function (key, value) {
    key._reactInternalInstance = value;
  }
};

module.exports = ReactInstanceMap;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(56);

var getEventTarget = __webpack_require__(217);

/**
 * @interface UIEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var UIEventInterface = {
  view: function (event) {
    if (event.view) {
      return event.view;
    }

    var target = getEventTarget(event);
    if (target.window === target) {
      // target is a window object
      return target;
    }

    var doc = target.ownerDocument;
    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
    if (doc) {
      return doc.defaultView || doc.parentWindow;
    } else {
      return window;
    }
  },
  detail: function (event) {
    return event.detail || 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);

module.exports = SyntheticUIEvent;

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = falsy;
/* unused harmony export history */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return component; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return components; });
/* unused harmony export route */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return routes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


function falsy(props, propName, componentName) {
  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
}

var history = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  listen: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  push: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  replace: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  go: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goBack: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goForward: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired
});

var component = __WEBPACK_IMPORTED_MODULE_0_prop_types__["elementType"];
var components = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([component, __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"]]);
var route = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["object"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["element"]]);
var routes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([route, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"])(route)]);

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GA__ = __webpack_require__(106);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var debug = __WEBPACK_IMPORTED_MODULE_2_debug___default()('itaigi:TuiIngHuaGi');

var TuiIngHuaGi = function (_React$Component) {
  _inherits(TuiIngHuaGi, _React$Component);

  function TuiIngHuaGi() {
    _classCallCheck(this, TuiIngHuaGi);

    return _possibleConstructorReturn(this, (TuiIngHuaGi.__proto__ || Object.getPrototypeOf(TuiIngHuaGi)).apply(this, arguments));
  }

  _createClass(TuiIngHuaGi, [{
    key: 'render',
    value: function render() {
      var 外語 = this.props.外語;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Link */],
        {
          className: 'item',
          to: '/k/' + 外語.外語資料,
          key: 外語.外語項目編號,
          onClick: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__GA__["b" /* gaUaGi */])(外語.外語資料)
        },
        外語.外語資料
      );
    }
  }]);

  return TuiIngHuaGi;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (TuiIngHuaGi);

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debug__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_debug__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var debug = __WEBPACK_IMPORTED_MODULE_1_debug___default()('itaigi:例句鈕仔');

var 例句鈕仔 = function (_React$Component) {
  _inherits(例句鈕仔, _React$Component);

  function 例句鈕仔() {
    _classCallCheck(this, 例句鈕仔);

    return _possibleConstructorReturn(this, (例句鈕仔.__proto__ || Object.getPrototypeOf(例句鈕仔)).apply(this, arguments));
  }

  _createClass(例句鈕仔, [{
    key: 'render',
    value: function render() {
      var 來開例句 = this.props.來開例句;

      if (來開例句 == undefined) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: '' });
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: '' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            onClick: 來開例句.bind(this),
            className: 'ui compact icon button', title: '\u4F8B\u53E5' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'icon list' })
        )
      );
    }
  }]);

  return 例句鈕仔;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (例句鈕仔);

/***/ }),
/* 127 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(249);
var enumBugKeys = __webpack_require__(162);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 129 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 130 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(75).f;
var has = __webpack_require__(73);
var TAG = __webpack_require__(29)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 132 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(37);
var toLength = __webpack_require__(13);
var toAbsoluteIndex = __webpack_require__(84);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(4);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(31);
var redefineAll = __webpack_require__(82);
var meta = __webpack_require__(66);
var forOf = __webpack_require__(77);
var anInstance = __webpack_require__(76);
var isObject = __webpack_require__(7);
var fails = __webpack_require__(6);
var $iterDetect = __webpack_require__(138);
var setToStringTag = __webpack_require__(96);
var inheritIfRequired = __webpack_require__(181);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(291);
var redefine = __webpack_require__(31);
var hide = __webpack_require__(30);
var fails = __webpack_require__(6);
var defined = __webpack_require__(47);
var wks = __webpack_require__(12);
var regexpExec = __webpack_require__(189);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(39);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(7);
var cof = __webpack_require__(39);
var MATCH = __webpack_require__(12)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(12)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(65) || !__webpack_require__(6)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(4)[K];
});


/***/ }),
/* 140 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(94);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(22);
var ctx = __webpack_require__(41);
var forOf = __webpack_require__(77);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(43);
var defined = __webpack_require__(47);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(4);
var hide = __webpack_require__(30);
var uid = __webpack_require__(85);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(4);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/**
 * Indicates that navigation was caused by a call to history.push.
 */
var PUSH = exports.PUSH = 'PUSH';

/**
 * Indicates that navigation was caused by a call to history.replace.
 */
var REPLACE = exports.REPLACE = 'REPLACE';

/**
 * Indicates that navigation was caused by some other action such
 * as using a browser's back/forward buttons and/or manually manipulating
 * the URL in a browser's location bar. This is the default.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
 * for more information.
 */
var POP = exports.POP = 'POP';

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(719);


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(11);

var EventPluginRegistry = __webpack_require__(207);
var ReactEventEmitterMixin = __webpack_require__(732);
var ViewportMetrics = __webpack_require__(322);

var getVendorPrefixedEventName = __webpack_require__(763);
var isEventSupported = __webpack_require__(219);

/**
 * Summary of `ReactBrowserEventEmitter` event handling:
 *
 *  - Top-level delegation is used to trap most native browser events. This
 *    may only occur in the main thread and is the responsibility of
 *    ReactEventListener, which is injected and can therefore support pluggable
 *    event sources. This is the only work that occurs in the main thread.
 *
 *  - We normalize and de-duplicate events to account for browser quirks. This
 *    may be done in the worker thread.
 *
 *  - Forward these native events (with the associated top-level type used to
 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
 *    to extract any synthetic events.
 *
 *  - The `EventPluginHub` will then process each event by annotating them with
 *    "dispatches", a sequence of listeners and IDs that care about that event.
 *
 *  - The `EventPluginHub` then dispatches the events.
 *
 * Overview of React and the event system:
 *
 * +------------+    .
 * |    DOM     |    .
 * +------------+    .
 *       |           .
 *       v           .
 * +------------+    .
 * | ReactEvent |    .
 * |  Listener  |    .
 * +------------+    .                         +-----------+
 *       |           .               +--------+|SimpleEvent|
 *       |           .               |         |Plugin     |
 * +-----|------+    .               v         +-----------+
 * |     |      |    .    +--------------+                    +------------+
 * |     +-----------.--->|EventPluginHub|                    |    Event   |
 * |            |    .    |              |     +-----------+  | Propagators|
 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
 * |            |    .    |              |     +-----------+  |  utilities |
 * |     +-----------.--->|              |                    +------------+
 * |     |      |    .    +--------------+
 * +-----|------+    .                ^        +-----------+
 *       |           .                |        |Enter/Leave|
 *       +           .                +-------+|Plugin     |
 * +-------------+   .                         +-----------+
 * | application |   .
 * |-------------|   .
 * |             |   .
 * |             |   .
 * +-------------+   .
 *                   .
 *    React Core     .  General Purpose Event Plugin System
 */

var hasEventPageXY;
var alreadyListeningTo = {};
var isMonitoringScrollValue = false;
var reactTopListenersCounter = 0;

// For events like 'submit' which don't consistently bubble (which we trap at a
// lower node than `document`), binding at `document` would cause duplicate
// events so we don't include them here
var topEventMapping = {
  topAbort: 'abort',
  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
  topBlur: 'blur',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topChange: 'change',
  topClick: 'click',
  topCompositionEnd: 'compositionend',
  topCompositionStart: 'compositionstart',
  topCompositionUpdate: 'compositionupdate',
  topContextMenu: 'contextmenu',
  topCopy: 'copy',
  topCut: 'cut',
  topDoubleClick: 'dblclick',
  topDrag: 'drag',
  topDragEnd: 'dragend',
  topDragEnter: 'dragenter',
  topDragExit: 'dragexit',
  topDragLeave: 'dragleave',
  topDragOver: 'dragover',
  topDragStart: 'dragstart',
  topDrop: 'drop',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topFocus: 'focus',
  topInput: 'input',
  topKeyDown: 'keydown',
  topKeyPress: 'keypress',
  topKeyUp: 'keyup',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topMouseDown: 'mousedown',
  topMouseMove: 'mousemove',
  topMouseOut: 'mouseout',
  topMouseOver: 'mouseover',
  topMouseUp: 'mouseup',
  topPaste: 'paste',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topScroll: 'scroll',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topSelectionChange: 'selectionchange',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTextInput: 'textInput',
  topTimeUpdate: 'timeupdate',
  topTouchCancel: 'touchcancel',
  topTouchEnd: 'touchend',
  topTouchMove: 'touchmove',
  topTouchStart: 'touchstart',
  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting',
  topWheel: 'wheel'
};

/**
 * To ensure no conflicts with other potential React instances on the page
 */
var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);

function getListeningForDocument(mountAt) {
  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
  // directly.
  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
    mountAt[topListenersIDKey] = reactTopListenersCounter++;
    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
  }
  return alreadyListeningTo[mountAt[topListenersIDKey]];
}

/**
 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
 * example:
 *
 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
 *
 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
 *
 * @internal
 */
var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
  /**
   * Injectable event backend
   */
  ReactEventListener: null,

  injection: {
    /**
     * @param {object} ReactEventListener
     */
    injectReactEventListener: function (ReactEventListener) {
      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
    }
  },

  /**
   * Sets whether or not any created callbacks should be enabled.
   *
   * @param {boolean} enabled True if callbacks should be enabled.
   */
  setEnabled: function (enabled) {
    if (ReactBrowserEventEmitter.ReactEventListener) {
      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
    }
  },

  /**
   * @return {boolean} True if callbacks are enabled.
   */
  isEnabled: function () {
    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
  },

  /**
   * We listen for bubbled touch events on the document object.
   *
   * Firefox v8.01 (and possibly others) exhibited strange behavior when
   * mounting `onmousemove` events at some node that was not the document
   * element. The symptoms were that if your mouse is not moving over something
   * contained within that mount point (for example on the background) the
   * top-level listeners for `onmousemove` won't be called. However, if you
   * register the `mousemove` on the document object, then it will of course
   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
   * top-level listeners to the document object only, at least for these
   * movement types of events and possibly all events.
   *
   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
   *
   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
   * they bubble to document.
   *
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {object} contentDocumentHandle Document which owns the container
   */
  listenTo: function (registrationName, contentDocumentHandle) {
    var mountAt = contentDocumentHandle;
    var isListening = getListeningForDocument(mountAt);
    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];

    for (var i = 0; i < dependencies.length; i++) {
      var dependency = dependencies[i];
      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
        if (dependency === 'topWheel') {
          if (isEventSupported('wheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
          } else if (isEventSupported('mousewheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
          } else {
            // Firefox needs to capture a different mouse scroll event.
            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
          }
        } else if (dependency === 'topScroll') {
          if (isEventSupported('scroll', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
          } else {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
          }
        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
          if (isEventSupported('focus', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
          } else if (isEventSupported('focusin')) {
            // IE has `focusin` and `focusout` events which bubble.
            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
          }

          // to make sure blur and focus event listeners are only attached once
          isListening.topBlur = true;
          isListening.topFocus = true;
        } else if (topEventMapping.hasOwnProperty(dependency)) {
          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
        }

        isListening[dependency] = true;
      }
    }
  },

  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
  },

  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
  },

  /**
   * Protect against document.createEvent() returning null
   * Some popup blocker extensions appear to do this:
   * https://github.com/facebook/react/issues/6887
   */
  supportsEventPageXY: function () {
    if (!document.createEvent) {
      return false;
    }
    var ev = document.createEvent('MouseEvent');
    return ev != null && 'pageX' in ev;
  },

  /**
   * Listens to window scroll and resize events. We cache scroll values so that
   * application code can access them without triggering reflows.
   *
   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
   * pageX/pageY isn't supported (legacy browsers).
   *
   * NOTE: Scroll events do not bubble.
   *
   * @see http://www.quirksmode.org/dom/events/scroll.html
   */
  ensureScrollValueMonitoring: function () {
    if (hasEventPageXY === undefined) {
      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
    }
    if (!hasEventPageXY && !isMonitoringScrollValue) {
      var refresh = ViewportMetrics.refreshScrollValues;
      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
      isMonitoringScrollValue = true;
    }
  }
});

module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(122);
var ViewportMetrics = __webpack_require__(322);

var getEventModifierState = __webpack_require__(216);

/**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var MouseEventInterface = {
  screenX: null,
  screenY: null,
  clientX: null,
  clientY: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  getModifierState: getEventModifierState,
  button: function (event) {
    // Webkit, Firefox, IE9+
    // which:  1 2 3
    // button: 0 1 2 (standard)
    var button = event.button;
    if ('which' in event) {
      return button;
    }
    // IE<9
    // which:  undefined
    // button: 0 0 0
    // button: 1 4 2 (onmouseup)
    return button === 2 ? 2 : button === 4 ? 1 : 0;
  },
  buttons: null,
  relatedTarget: function (event) {
    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
  },
  // "Proprietary" Interface.
  pageX: function (event) {
    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
  },
  pageY: function (event) {
    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);

module.exports = SyntheticMouseEvent;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(9);

var invariant = __webpack_require__(3);

var OBSERVED_ERROR = {};

/**
 * `Transaction` creates a black box that is able to wrap any method such that
 * certain invariants are maintained before and after the method is invoked
 * (Even if an exception is thrown while invoking the wrapped method). Whoever
 * instantiates a transaction can provide enforcers of the invariants at
 * creation time. The `Transaction` class itself will supply one additional
 * automatic invariant for you - the invariant that any transaction instance
 * should not be run while it is already being run. You would typically create a
 * single instance of a `Transaction` for reuse multiple times, that potentially
 * is used to wrap several different methods. Wrappers are extremely simple -
 * they only require implementing two methods.
 *
 * <pre>
 *                       wrappers (injected at creation time)
 *                                      +        +
 *                                      |        |
 *                    +-----------------|--------|--------------+
 *                    |                 v        |              |
 *                    |      +---------------+   |              |
 *                    |   +--|    wrapper1   |---|----+         |
 *                    |   |  +---------------+   v    |         |
 *                    |   |          +-------------+  |         |
 *                    |   |     +----|   wrapper2  |--------+   |
 *                    |   |     |    +-------------+  |     |   |
 *                    |   |     |                     |     |   |
 *                    |   v     v                     v     v   | wrapper
 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | +---+ +---+   +---------+   +---+ +---+ |
 *                    |  initialize                    close    |
 *                    +-----------------------------------------+
 * </pre>
 *
 * Use cases:
 * - Preserving the input selection ranges before/after reconciliation.
 *   Restoring selection even in the event of an unexpected error.
 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
 *   while guaranteeing that afterwards, the event system is reactivated.
 * - Flushing a queue of collected DOM mutations to the main UI thread after a
 *   reconciliation takes place in a worker thread.
 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
 *   content.
 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
 * - (Future use case): Layout calculations before and after DOM updates.
 *
 * Transactional plugin API:
 * - A module that has an `initialize` method that returns any precomputation.
 * - and a `close` method that accepts the precomputation. `close` is invoked
 *   when the wrapped process is completed, or has failed.
 *
 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
 * that implement `initialize` and `close`.
 * @return {Transaction} Single transaction for reuse in thread.
 *
 * @class Transaction
 */
var TransactionImpl = {
  /**
   * Sets up this instance so that it is prepared for collecting metrics. Does
   * so such that this setup method may be used on an instance that is already
   * initialized, in a way that does not consume additional memory upon reuse.
   * That can be useful if you decide to make your subclass of this mixin a
   * "PooledClass".
   */
  reinitializeTransaction: function () {
    this.transactionWrappers = this.getTransactionWrappers();
    if (this.wrapperInitData) {
      this.wrapperInitData.length = 0;
    } else {
      this.wrapperInitData = [];
    }
    this._isInTransaction = false;
  },

  _isInTransaction: false,

  /**
   * @abstract
   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
   */
  getTransactionWrappers: null,

  isInTransaction: function () {
    return !!this._isInTransaction;
  },

  /* eslint-disable space-before-function-paren */

  /**
   * Executes the function within a safety window. Use this for the top level
   * methods that result in large amounts of computation/mutations that would
   * need to be safety checked. The optional arguments helps prevent the need
   * to bind in many cases.
   *
   * @param {function} method Member of scope to call.
   * @param {Object} scope Scope to invoke from.
   * @param {Object?=} a Argument to pass to the method.
   * @param {Object?=} b Argument to pass to the method.
   * @param {Object?=} c Argument to pass to the method.
   * @param {Object?=} d Argument to pass to the method.
   * @param {Object?=} e Argument to pass to the method.
   * @param {Object?=} f Argument to pass to the method.
   *
   * @return {*} Return value from `method`.
   */
  perform: function (method, scope, a, b, c, d, e, f) {
    /* eslint-enable space-before-function-paren */
    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
    var errorThrown;
    var ret;
    try {
      this._isInTransaction = true;
      // Catching errors makes debugging more difficult, so we start with
      // errorThrown set to true before setting it to false after calling
      // close -- if it's still set to true in the finally block, it means
      // one of these calls threw.
      errorThrown = true;
      this.initializeAll(0);
      ret = method.call(scope, a, b, c, d, e, f);
      errorThrown = false;
    } finally {
      try {
        if (errorThrown) {
          // If `method` throws, prefer to show that stack trace over any thrown
          // by invoking `closeAll`.
          try {
            this.closeAll(0);
          } catch (err) {}
        } else {
          // Since `method` didn't throw, we don't want to silence the exception
          // here.
          this.closeAll(0);
        }
      } finally {
        this._isInTransaction = false;
      }
    }
    return ret;
  },

  initializeAll: function (startIndex) {
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      try {
        // Catching errors makes debugging more difficult, so we start with the
        // OBSERVED_ERROR state before overwriting it with the real return value
        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
        // block, it means wrapper.initialize threw.
        this.wrapperInitData[i] = OBSERVED_ERROR;
        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
      } finally {
        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
          // The initializer for wrapper i threw an error; initialize the
          // remaining wrappers but silence any exceptions from them to ensure
          // that the first error is the one to bubble up.
          try {
            this.initializeAll(i + 1);
          } catch (err) {}
        }
      }
    }
  },

  /**
   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
   * them the respective return values of `this.transactionWrappers.init[i]`
   * (`close`rs that correspond to initializers that failed will not be
   * invoked).
   */
  closeAll: function (startIndex) {
    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      var initData = this.wrapperInitData[i];
      var errorThrown;
      try {
        // Catching errors makes debugging more difficult, so we start with
        // errorThrown set to true before setting it to false after calling
        // close -- if it's still set to true in the finally block, it means
        // wrapper.close threw.
        errorThrown = true;
        if (initData !== OBSERVED_ERROR && wrapper.close) {
          wrapper.close.call(this, initData);
        }
        errorThrown = false;
      } finally {
        if (errorThrown) {
          // The closer for wrapper i threw an error; close the remaining
          // wrappers but silence any exceptions from them to ensure that the
          // first error is the one to bubble up.
          try {
            this.closeAll(i + 1);
          } catch (e) {}
        }
      }
    }
    this.wrapperInitData.length = 0;
  }
};

module.exports = TransactionImpl;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Based on the escape-html library, which is used under the MIT License below:
 *
 * Copyright (c) 2012-2013 TJ Holowaychuk
 * Copyright (c) 2015 Andreas Lubbe
 * Copyright (c) 2015 Tiancheng "Timothy" Gu
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 */



// code copied and modified from escape-html
/**
 * Module variables.
 * @private
 */

var matchHtmlRegExp = /["'&<>]/;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34:
        // "
        escape = '&quot;';
        break;
      case 38:
        // &
        escape = '&amp;';
        break;
      case 39:
        // '
        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
        break;
      case 60:
        // <
        escape = '&lt;';
        break;
      case 62:
        // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}
// end code copied and modified from escape-html

/**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */
function escapeTextContentForBrowser(text) {
  if (typeof text === 'boolean' || typeof text === 'number') {
    // this shortcircuit helps perf for types that we know will never have
    // special characters, especially given that this function is used often
    // for numeric dom ids.
    return '' + text;
  }
  return escapeHtml(text);
}

module.exports = escapeTextContentForBrowser;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(24);
var DOMNamespaces = __webpack_require__(206);

var WHITESPACE_TEST = /^[ \r\n\t\f]/;
var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;

var createMicrosoftUnsafeLocalFunction = __webpack_require__(214);

// SVG temp container for IE lacking innerHTML
var reusableSVGContainer;

/**
 * Set the innerHTML property of a node, ensuring that whitespace is preserved
 * even in IE8.
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */
var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
  // IE does not have innerHTML for SVG nodes, so instead we inject the
  // new markup in a temp node and then move the child nodes across into
  // the target node
  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
    var svgNode = reusableSVGContainer.firstChild;
    while (svgNode.firstChild) {
      node.appendChild(svgNode.firstChild);
    }
  } else {
    node.innerHTML = html;
  }
});

if (ExecutionEnvironment.canUseDOM) {
  // IE8: When updating a just created node with innerHTML only leading
  // whitespace is removed. When updating an existing node with innerHTML
  // whitespace in root TextNodes is also collapsed.
  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html

  // Feature detection; only IE8 is known to behave improperly like this.
  var testElement = document.createElement('div');
  testElement.innerHTML = ' ';
  if (testElement.innerHTML === '') {
    setInnerHTML = function (node, html) {
      // Magic theory: IE8 supposedly differentiates between added and updated
      // nodes when processing innerHTML, innerHTML on updated nodes suffers
      // from worse whitespace behavior. Re-adding a node like this triggers
      // the initial and more favorable whitespace behavior.
      // TODO: What to do on a detached node?
      if (node.parentNode) {
        node.parentNode.replaceChild(node, node);
      }

      // We also implement a workaround for non-visible tags disappearing into
      // thin air on IE8, this only happens if there is no visible text
      // in-front of the non-visible tags. Piggyback on the whitespace fix
      // and simply check if any non-visible tags appear in the source.
      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
        // Recover leading whitespace by temporarily prepending any character.
        // \uFEFF has the potential advantage of being zero-width/invisible.
        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
        // in hopes that this is preserved even if "\uFEFF" is transformed to
        // the actual Unicode character (by Babel, for example).
        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
        node.innerHTML = String.fromCharCode(0xfeff) + html;

        // deleteData leaves an empty `TextNode` which offsets the index of all
        // children. Definitely want to avoid this.
        var textNode = node.firstChild;
        if (textNode.data.length === 1) {
          node.removeChild(textNode);
        } else {
          textNode.deleteData(0, 1);
        }
      } else {
        node.innerHTML = html;
      }
    };
  }
  testElement = null;
}

module.exports = setInnerHTML;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = {
  BLUE: 'blue',
  WHITE: 'white'
};
//# sourceMappingURL=MessengerColor.js.map

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = {
  SMALL: 'small',
  MEDIUM: 'medium',
  STANDARD: 'standard',
  LARGE: 'large',
  XLARGE: 'xlarge'
};
//# sourceMappingURL=MessengerSize.js.map

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @copyright © 2015, Rick Wong. All rights reserved.
 */


var isContainer = __webpack_require__(348);

/**
 * @function isContainer
 */
module.exports = function (Container) {
	return !!(isContainer(Container) &&
	          Container.isRootContainer);
};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @copyright © 2015, Rick Wong. All rights reserved.
 */


module.exports = __webpack_require__(1);


/***/ }),
/* 160 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(63);
var document = __webpack_require__(23).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 162 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(127);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(53);
var dPs = __webpack_require__(432);
var enumBugKeys = __webpack_require__(162);
var IE_PROTO = __webpack_require__(166)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(161)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(243).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 165 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(167)('keys');
var uid = __webpack_require__(132);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(33);
var global = __webpack_require__(23);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(113) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 168 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(160);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(63);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(23);
var core = __webpack_require__(33);
var LIBRARY = __webpack_require__(113);
var wksExt = __webpack_require__(172);
var defineProperty = __webpack_require__(75).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(29);


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(144)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(19);
var toAbsoluteIndex = __webpack_require__(84);
var toLength = __webpack_require__(13);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(452);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(15);
var createDesc = __webpack_require__(81);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(7);
var document = __webpack_require__(4).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 178 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(12)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(4).document;
module.exports = document && document.documentElement;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(7);
var setPrototypeOf = __webpack_require__(190).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(95);
var ITERATOR = __webpack_require__(12)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(78);
var descriptor = __webpack_require__(81);
var setToStringTag = __webpack_require__(96);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(30)(IteratorPrototype, __webpack_require__(12)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(65);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(31);
var hide = __webpack_require__(30);
var Iterators = __webpack_require__(95);
var $iterCreate = __webpack_require__(183);
var setToStringTag = __webpack_require__(96);
var getPrototypeOf = __webpack_require__(36);
var ITERATOR = __webpack_require__(12)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 185 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 186 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(4);
var macrotask = __webpack_require__(195).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(39)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(22);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(114);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(7);
var anObject = __webpack_require__(2);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(41)(Function.call, __webpack_require__(35).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(117)('keys');
var uid = __webpack_require__(85);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(137);
var defined = __webpack_require__(47);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(43);
var defined = __webpack_require__(47);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 194 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(41);
var invoke = __webpack_require__(269);
var html = __webpack_require__(180);
var cel = __webpack_require__(177);
var global = __webpack_require__(4);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(39)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(4);
var DESCRIPTORS = __webpack_require__(14);
var LIBRARY = __webpack_require__(65);
var $typed = __webpack_require__(145);
var hide = __webpack_require__(30);
var redefineAll = __webpack_require__(82);
var fails = __webpack_require__(6);
var anInstance = __webpack_require__(76);
var toInteger = __webpack_require__(43);
var toLength = __webpack_require__(13);
var toIndex = __webpack_require__(288);
var gOPN = __webpack_require__(79).f;
var dP = __webpack_require__(15).f;
var arrayFill = __webpack_require__(174);
var setToStringTag = __webpack_require__(96);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(4);
var core = __webpack_require__(40);
var LIBRARY = __webpack_require__(65);
var wksExt = __webpack_require__(289);
var defineProperty = __webpack_require__(15).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(94);
var ITERATOR = __webpack_require__(12)('iterator');
var Iterators = __webpack_require__(95);
module.exports = __webpack_require__(40).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(64);
var step = __webpack_require__(272);
var Iterators = __webpack_require__(95);
var toIObject = __webpack_require__(37);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(184)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;

var _LocationUtils = __webpack_require__(98);

var _DOMUtils = __webpack_require__(149);

var _DOMStateStorage = __webpack_require__(299);

var _PathUtils = __webpack_require__(67);

var _ExecutionEnvironment = __webpack_require__(202);

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();

var _createLocation = function _createLocation(historyState) {
  var key = historyState && historyState.key;

  return (0, _LocationUtils.createLocation)({
    pathname: window.location.pathname,
    search: window.location.search,
    hash: window.location.hash,
    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
  }, undefined, key);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  var historyState = void 0;
  try {
    historyState = window.history.state || {};
  } catch (error) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    historyState = {};
  }

  return _createLocation(historyState);
};

var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

var startListener = exports.startListener = function startListener(listener) {
  var handlePopState = function handlePopState(event) {
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
      return;
    listener(_createLocation(event.state));
  };

  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
    return listener(getCurrentLocation());
  };

  if (needsHashchangeListener) {
    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
  }

  return function () {
    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

    if (needsHashchangeListener) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
    }
  };
};

var updateLocation = function updateLocation(location, updateState) {
  var state = location.state,
      key = location.key;


  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);

  updateState({ key: key }, (0, _PathUtils.createPath)(location));
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.pushState(state, null, path);
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.replaceState(state, null, path);
  });
};

var go = exports.go = function go(n) {
  if (n) window.history.go(n);
};

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _AsyncUtils = __webpack_require__(687);

var _PathUtils = __webpack_require__(67);

var _runTransitionHook = __webpack_require__(204);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _Actions = __webpack_require__(148);

var _LocationUtils = __webpack_require__(98);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createHistory = function createHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getCurrentLocation = options.getCurrentLocation,
      getUserConfirmation = options.getUserConfirmation,
      pushLocation = options.pushLocation,
      replaceLocation = options.replaceLocation,
      go = options.go,
      keyLength = options.keyLength;


  var currentLocation = void 0;
  var pendingLocation = void 0;
  var beforeListeners = [];
  var listeners = [];
  var allKeys = [];

  var getCurrentIndex = function getCurrentIndex() {
    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);

    if (currentLocation) return allKeys.indexOf(currentLocation.key);

    return -1;
  };

  var updateLocation = function updateLocation(nextLocation) {
    var currentIndex = getCurrentIndex();

    currentLocation = nextLocation;

    if (currentLocation.action === _Actions.PUSH) {
      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
    } else if (currentLocation.action === _Actions.REPLACE) {
      allKeys[currentIndex] = currentLocation.key;
    }

    listeners.forEach(function (listener) {
      return listener(currentLocation);
    });
  };

  var listenBefore = function listenBefore(listener) {
    beforeListeners.push(listener);

    return function () {
      return beforeListeners = beforeListeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var listen = function listen(listener) {
    listeners.push(listener);

    return function () {
      return listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
        return result != null ? done(result) : next();
      });
    }, function (message) {
      if (getUserConfirmation && typeof message === 'string') {
        getUserConfirmation(message, function (ok) {
          return callback(ok !== false);
        });
      } else {
        callback(message !== false);
      }
    });
  };

  var transitionTo = function transitionTo(nextLocation) {
    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do

    pendingLocation = nextLocation;

    confirmTransitionTo(nextLocation, function (ok) {
      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation

      pendingLocation = null;

      if (ok) {
        // Treat PUSH to same path like REPLACE to be consistent with browsers
        if (nextLocation.action === _Actions.PUSH) {
          var prevPath = (0, _PathUtils.createPath)(currentLocation);
          var nextPath = (0, _PathUtils.createPath)(nextLocation);

          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
        }

        if (nextLocation.action === _Actions.POP) {
          updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.PUSH) {
          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.REPLACE) {
          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
        }
      } else if (currentLocation && nextLocation.action === _Actions.POP) {
        var prevIndex = allKeys.indexOf(currentLocation.key);
        var nextIndex = allKeys.indexOf(nextLocation.key);

        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
      }
    });
  };

  var push = function push(input) {
    return transitionTo(createLocation(input, _Actions.PUSH));
  };

  var replace = function replace(input) {
    return transitionTo(createLocation(input, _Actions.REPLACE));
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength || 6);
  };

  var createHref = function createHref(location) {
    return (0, _PathUtils.createPath)(location);
  };

  var createLocation = function createLocation(location, action) {
    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
    return (0, _LocationUtils.createLocation)(location, action, key);
  };

  return {
    getCurrentLocation: getCurrentLocation,
    listenBefore: listenBefore,
    listen: listen,
    transitionTo: transitionTo,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    createKey: createKey,
    createPath: _PathUtils.createPath,
    createHref: createHref,
    createLocation: createLocation
  };
};

exports.default = createHistory;

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(70);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var runTransitionHook = function runTransitionHook(hook, location, callback) {
  var result = hook(location, callback);

  if (hook.length < 2) {
    // Assume the hook runs synchronously and automatically
    // call the callback with the return value.
    callback(result);
  } else {
     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
  }
};

exports.default = runTransitionHook;

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMLazyTree = __webpack_require__(99);
var Danger = __webpack_require__(711);
var ReactDOMComponentTree = __webpack_require__(17);
var ReactInstrumentation = __webpack_require__(38);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(214);
var setInnerHTML = __webpack_require__(155);
var setTextContent = __webpack_require__(329);

function getNodeAfter(parentNode, node) {
  // Special case for text components, which return [open, close] comments
  // from getHostNode.
  if (Array.isArray(node)) {
    node = node[1];
  }
  return node ? node.nextSibling : parentNode.firstChild;
}

/**
 * Inserts `childNode` as a child of `parentNode` at the `index`.
 *
 * @param {DOMElement} parentNode Parent node in which to insert.
 * @param {DOMElement} childNode Child node to insert.
 * @param {number} index Index at which to insert the child.
 * @internal
 */
var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
  // We rely exclusively on `insertBefore(node, null)` instead of also using
  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
  // we are careful to use `null`.)
  parentNode.insertBefore(childNode, referenceNode);
});

function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
}

function moveChild(parentNode, childNode, referenceNode) {
  if (Array.isArray(childNode)) {
    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
  } else {
    insertChildAt(parentNode, childNode, referenceNode);
  }
}

function removeChild(parentNode, childNode) {
  if (Array.isArray(childNode)) {
    var closingComment = childNode[1];
    childNode = childNode[0];
    removeDelimitedText(parentNode, childNode, closingComment);
    parentNode.removeChild(closingComment);
  }
  parentNode.removeChild(childNode);
}

function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
  var node = openingComment;
  while (true) {
    var nextNode = node.nextSibling;
    insertChildAt(parentNode, node, referenceNode);
    if (node === closingComment) {
      break;
    }
    node = nextNode;
  }
}

function removeDelimitedText(parentNode, startNode, closingComment) {
  while (true) {
    var node = startNode.nextSibling;
    if (node === closingComment) {
      // The closing comment is removed by ReactMultiChild.
      break;
    } else {
      parentNode.removeChild(node);
    }
  }
}

function replaceDelimitedText(openingComment, closingComment, stringText) {
  var parentNode = openingComment.parentNode;
  var nodeAfterComment = openingComment.nextSibling;
  if (nodeAfterComment === closingComment) {
    // There are no text nodes between the opening and closing comments; insert
    // a new one if stringText isn't empty.
    if (stringText) {
      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
    }
  } else {
    if (stringText) {
      // Set the text content of the first node after the opening comment, and
      // remove all following nodes up until the closing comment.
      setTextContent(nodeAfterComment, stringText);
      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
    } else {
      removeDelimitedText(parentNode, openingComment, closingComment);
    }
  }

  if (false) {
    ReactInstrumentation.debugTool.onHostOperation({
      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
      type: 'replace text',
      payload: stringText
    });
  }
}

var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
if (false) {
  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
    if (prevInstance._debugID !== 0) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: prevInstance._debugID,
        type: 'replace with',
        payload: markup.toString()
      });
    } else {
      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
      if (nextInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: nextInstance._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  };
}

/**
 * Operations for updating with DOM children.
 */
var DOMChildrenOperations = {
  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,

  replaceDelimitedText: replaceDelimitedText,

  /**
   * Updates a component's children by processing a series of updates. The
   * update configurations are each expected to have a `parentNode` property.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  processUpdates: function (parentNode, updates) {
    if (false) {
      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
    }

    for (var k = 0; k < updates.length; k++) {
      var update = updates[k];
      switch (update.type) {
        case 'INSERT_MARKUP':
          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'insert child',
              payload: {
                toIndex: update.toIndex,
                content: update.content.toString()
              }
            });
          }
          break;
        case 'MOVE_EXISTING':
          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'move child',
              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
            });
          }
          break;
        case 'SET_MARKUP':
          setInnerHTML(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace children',
              payload: update.content.toString()
            });
          }
          break;
        case 'TEXT_CONTENT':
          setTextContent(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace text',
              payload: update.content.toString()
            });
          }
          break;
        case 'REMOVE_NODE':
          removeChild(parentNode, update.fromNode);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'remove child',
              payload: { fromIndex: update.fromIndex }
            });
          }
          break;
      }
    }
  }
};

module.exports = DOMChildrenOperations;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMNamespaces = {
  html: 'http://www.w3.org/1999/xhtml',
  mathml: 'http://www.w3.org/1998/Math/MathML',
  svg: 'http://www.w3.org/2000/svg'
};

module.exports = DOMNamespaces;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(9);

var invariant = __webpack_require__(3);

/**
 * Injectable ordering of event plugins.
 */
var eventPluginOrder = null;

/**
 * Injectable mapping from names to event plugin modules.
 */
var namesToPlugins = {};

/**
 * Recomputes the plugin list using the injected plugins and plugin ordering.
 *
 * @private
 */
function recomputePluginOrdering() {
  if (!eventPluginOrder) {
    // Wait until an `eventPluginOrder` is injected.
    return;
  }
  for (var pluginName in namesToPlugins) {
    var pluginModule = namesToPlugins[pluginName];
    var pluginIndex = eventPluginOrder.indexOf(pluginName);
    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
    if (EventPluginRegistry.plugins[pluginIndex]) {
      continue;
    }
    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
    var publishedEvents = pluginModule.eventTypes;
    for (var eventName in publishedEvents) {
      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
    }
  }
}

/**
 * Publishes an event so that it can be dispatched by the supplied plugin.
 *
 * @param {object} dispatchConfig Dispatch configuration for the event.
 * @param {object} PluginModule Plugin publishing the event.
 * @return {boolean} True if the event was successfully published.
 * @private
 */
function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;

  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
  if (phasedRegistrationNames) {
    for (var phaseName in phasedRegistrationNames) {
      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
        var phasedRegistrationName = phasedRegistrationNames[phaseName];
        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
      }
    }
    return true;
  } else if (dispatchConfig.registrationName) {
    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
    return true;
  }
  return false;
}

/**
 * Publishes a registration name that is used to identify dispatched events and
 * can be used with `EventPluginHub.putListener` to register listeners.
 *
 * @param {string} registrationName Registration name to add.
 * @param {object} PluginModule Plugin publishing the event.
 * @private
 */
function publishRegistrationName(registrationName, pluginModule, eventName) {
  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;

  if (false) {
    var lowerCasedName = registrationName.toLowerCase();
    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;

    if (registrationName === 'onDoubleClick') {
      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
    }
  }
}

/**
 * Registers plugins so that they can extract and dispatch events.
 *
 * @see {EventPluginHub}
 */
var EventPluginRegistry = {
  /**
   * Ordered list of injected plugins.
   */
  plugins: [],

  /**
   * Mapping from event name to dispatch config
   */
  eventNameDispatchConfigs: {},

  /**
   * Mapping from registration name to plugin module
   */
  registrationNameModules: {},

  /**
   * Mapping from registration name to event name
   */
  registrationNameDependencies: {},

  /**
   * Mapping from lowercase registration names to the properly cased version,
   * used to warn in the case of missing event handlers. Available
   * only in __DEV__.
   * @type {Object}
   */
  possibleRegistrationNames:  false ? {} : null,
  // Trust the developer to only use possibleRegistrationNames in __DEV__

  /**
   * Injects an ordering of plugins (by plugin name). This allows the ordering
   * to be decoupled from injection of the actual plugins so that ordering is
   * always deterministic regardless of packaging, on-the-fly injection, etc.
   *
   * @param {array} InjectedEventPluginOrder
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginOrder}
   */
  injectEventPluginOrder: function (injectedEventPluginOrder) {
    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
    // Clone the ordering so it cannot be dynamically mutated.
    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
    recomputePluginOrdering();
  },

  /**
   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
   * in the ordering injected by `injectEventPluginOrder`.
   *
   * Plugins can be injected as part of page initialization or on-the-fly.
   *
   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginsByName}
   */
  injectEventPluginsByName: function (injectedNamesToPlugins) {
    var isOrderingDirty = false;
    for (var pluginName in injectedNamesToPlugins) {
      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
        continue;
      }
      var pluginModule = injectedNamesToPlugins[pluginName];
      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
        namesToPlugins[pluginName] = pluginModule;
        isOrderingDirty = true;
      }
    }
    if (isOrderingDirty) {
      recomputePluginOrdering();
    }
  },

  /**
   * Looks up the plugin for the supplied event.
   *
   * @param {object} event A synthetic event.
   * @return {?object} The plugin that created the supplied event.
   * @internal
   */
  getPluginModuleForEvent: function (event) {
    var dispatchConfig = event.dispatchConfig;
    if (dispatchConfig.registrationName) {
      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
    }
    if (dispatchConfig.phasedRegistrationNames !== undefined) {
      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
      // that it is not undefined.
      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;

      for (var phase in phasedRegistrationNames) {
        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
          continue;
        }
        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
        if (pluginModule) {
          return pluginModule;
        }
      }
    }
    return null;
  },

  /**
   * Exposed for unit testing.
   * @private
   */
  _resetEventPlugins: function () {
    eventPluginOrder = null;
    for (var pluginName in namesToPlugins) {
      if (namesToPlugins.hasOwnProperty(pluginName)) {
        delete namesToPlugins[pluginName];
      }
    }
    EventPluginRegistry.plugins.length = 0;

    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
    for (var eventName in eventNameDispatchConfigs) {
      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
        delete eventNameDispatchConfigs[eventName];
      }
    }

    var registrationNameModules = EventPluginRegistry.registrationNameModules;
    for (var registrationName in registrationNameModules) {
      if (registrationNameModules.hasOwnProperty(registrationName)) {
        delete registrationNameModules[registrationName];
      }
    }

    if (false) {
      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
      for (var lowerCasedName in possibleRegistrationNames) {
        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
          delete possibleRegistrationNames[lowerCasedName];
        }
      }
    }
  }
};

module.exports = EventPluginRegistry;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(9);

var ReactErrorUtils = __webpack_require__(212);

var invariant = __webpack_require__(3);
var warning = __webpack_require__(10);

/**
 * Injected dependencies:
 */

/**
 * - `ComponentTree`: [required] Module that can convert between React instances
 *   and actual node references.
 */
var ComponentTree;
var TreeTraversal;
var injection = {
  injectComponentTree: function (Injected) {
    ComponentTree = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
    }
  },
  injectTreeTraversal: function (Injected) {
    TreeTraversal = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
    }
  }
};

function isEndish(topLevelType) {
  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
}

function isMoveish(topLevelType) {
  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
}
function isStartish(topLevelType) {
  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
}

var validateEventDispatches;
if (false) {
  validateEventDispatches = function (event) {
    var dispatchListeners = event._dispatchListeners;
    var dispatchInstances = event._dispatchInstances;

    var listenersIsArr = Array.isArray(dispatchListeners);
    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;

    var instancesIsArr = Array.isArray(dispatchInstances);
    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;

    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
  };
}

/**
 * Dispatch the event to the listener.
 * @param {SyntheticEvent} event SyntheticEvent to handle
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @param {function} listener Application-level callback
 * @param {*} inst Internal component instance
 */
function executeDispatch(event, simulated, listener, inst) {
  var type = event.type || 'unknown-event';
  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
  if (simulated) {
    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
  } else {
    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
  }
  event.currentTarget = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches.
 */
function executeDispatchesInOrder(event, simulated) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
    }
  } else if (dispatchListeners) {
    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
  }
  event._dispatchListeners = null;
  event._dispatchInstances = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches, but stops
 * at the first dispatch execution returning true, and returns that id.
 *
 * @return {?string} id of the first dispatch execution who's listener returns
 * true, or null if no listener returned true.
 */
function executeDispatchesInOrderStopAtTrueImpl(event) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      if (dispatchListeners[i](event, dispatchInstances[i])) {
        return dispatchInstances[i];
      }
    }
  } else if (dispatchListeners) {
    if (dispatchListeners(event, dispatchInstances)) {
      return dispatchInstances;
    }
  }
  return null;
}

/**
 * @see executeDispatchesInOrderStopAtTrueImpl
 */
function executeDispatchesInOrderStopAtTrue(event) {
  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
  event._dispatchInstances = null;
  event._dispatchListeners = null;
  return ret;
}

/**
 * Execution of a "direct" dispatch - there must be at most one dispatch
 * accumulated on the event or it is considered an error. It doesn't really make
 * sense for an event with multiple dispatches (bubbled) to keep track of the
 * return values at each dispatch execution, but it does tend to make sense when
 * dealing with "direct" dispatches.
 *
 * @return {*} The return value of executing the single dispatch.
 */
function executeDirectDispatch(event) {
  if (false) {
    validateEventDispatches(event);
  }
  var dispatchListener = event._dispatchListeners;
  var dispatchInstance = event._dispatchInstances;
  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
  var res = dispatchListener ? dispatchListener(event) : null;
  event.currentTarget = null;
  event._dispatchListeners = null;
  event._dispatchInstances = null;
  return res;
}

/**
 * @param {SyntheticEvent} event
 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
 */
function hasDispatches(event) {
  return !!event._dispatchListeners;
}

/**
 * General utilities that are useful in creating custom Event Plugins.
 */
var EventPluginUtils = {
  isEndish: isEndish,
  isMoveish: isMoveish,
  isStartish: isStartish,

  executeDirectDispatch: executeDirectDispatch,
  executeDispatchesInOrder: executeDispatchesInOrder,
  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
  hasDispatches: hasDispatches,

  getInstanceFromNode: function (node) {
    return ComponentTree.getInstanceFromNode(node);
  },
  getNodeFromInstance: function (node) {
    return ComponentTree.getNodeFromInstance(node);
  },
  isAncestor: function (a, b) {
    return TreeTraversal.isAncestor(a, b);
  },
  getLowestCommonAncestor: function (a, b) {
    return TreeTraversal.getLowestCommonAncestor(a, b);
  },
  getParentInstance: function (inst) {
    return TreeTraversal.getParentInstance(inst);
  },
  traverseTwoPhase: function (target, fn, arg) {
    return TreeTraversal.traverseTwoPhase(target, fn, arg);
  },
  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
  },

  injection: injection
};

module.exports = EventPluginUtils;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(9);

var ReactPropTypesSecret = __webpack_require__(737);
var propTypesFactory = __webpack_require__(302);

var React = __webpack_require__(90);
var PropTypes = propTypesFactory(React.isValidElement);

var invariant = __webpack_require__(3);
var warning = __webpack_require__(10);

var hasReadOnlyValue = {
  button: true,
  checkbox: true,
  image: true,
  hidden: true,
  radio: true,
  reset: true,
  submit: true
};

function _assertSingleLink(inputProps) {
  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
}
function _assertValueLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
}

function _assertCheckedLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
}

var propTypes = {
  value: function (props, propName, componentName) {
    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  checked: function (props, propName, componentName) {
    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  onChange: PropTypes.func
};

var loggedTypeFailures = {};
function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Provide a linked `value` attribute for controlled forms. You should not use
 * this outside of the ReactDOM controlled form components.
 */
var LinkedValueUtils = {
  checkPropTypes: function (tagName, props, owner) {
    for (var propName in propTypes) {
      if (propTypes.hasOwnProperty(propName)) {
        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
      }
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var addendum = getDeclarationErrorAddendum(owner);
         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
      }
    }
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current value of the input either from value prop or link.
   */
  getValue: function (inputProps) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.value;
    }
    return inputProps.value;
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current checked status of the input either from checked prop
   *             or link.
   */
  getChecked: function (inputProps) {
    if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.value;
    }
    return inputProps.checked;
  },

  /**
   * @param {object} inputProps Props for form component
   * @param {SyntheticEvent} event change event to handle
   */
  executeOnChange: function (inputProps, event) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.requestChange(event.target.value);
    } else if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.requestChange(event.target.checked);
    } else if (inputProps.onChange) {
      return inputProps.onChange.call(undefined, event);
    }
  }
};

module.exports = LinkedValueUtils;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(9);

var invariant = __webpack_require__(3);

var injected = false;

var ReactComponentEnvironment = {
  /**
   * Optionally injectable hook for swapping out mount images in the middle of
   * the tree.
   */
  replaceNodeWithMarkup: null,

  /**
   * Optionally injectable hook for processing a queue of child updates. Will
   * later move into MultiChildComponents.
   */
  processChildrenUpdates: null,

  injection: {
    injectEnvironment: function (environment) {
      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
      injected = true;
    }
  }
};

module.exports = ReactComponentEnvironment;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var caughtError = null;

/**
 * Call a function while guarding against errors that happens within it.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} a First argument
 * @param {*} b Second argument
 */
function invokeGuardedCallback(name, func, a) {
  try {
    func(a);
  } catch (x) {
    if (caughtError === null) {
      caughtError = x;
    }
  }
}

var ReactErrorUtils = {
  invokeGuardedCallback: invokeGuardedCallback,

  /**
   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
   * handler are sure to be rethrown by rethrowCaughtError.
   */
  invokeGuardedCallbackWithCatch: invokeGuardedCallback,

  /**
   * During execution of guarded functions we will capture the first error which
   * we will rethrow to be handled by the top level error handler.
   */
  rethrowCaughtError: function () {
    if (caughtError) {
      var error = caughtError;
      caughtError = null;
      throw error;
    }
  }
};

if (false) {
  /**
   * To help development we can get better devtools integration by simulating a
   * real browser event.
   */
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
    var fakeNode = document.createElement('react');
    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
      var boundFunc = function () {
        func(a);
      };
      var evtType = 'react-' + name;
      fakeNode.addEventListener(evtType, boundFunc, false);
      var evt = document.createEvent('Event');
      evt.initEvent(evtType, false, false);
      fakeNode.dispatchEvent(evt);
      fakeNode.removeEventListener(evtType, boundFunc, false);
    };
  }
}

module.exports = ReactErrorUtils;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(9);

var ReactCurrentOwner = __webpack_require__(57);
var ReactInstanceMap = __webpack_require__(121);
var ReactInstrumentation = __webpack_require__(38);
var ReactUpdates = __webpack_require__(45);

var invariant = __webpack_require__(3);
var warning = __webpack_require__(10);

function enqueueUpdate(internalInstance) {
  ReactUpdates.enqueueUpdate(internalInstance);
}

function formatUnexpectedArgument(arg) {
  var type = typeof arg;
  if (type !== 'object') {
    return type;
  }
  var displayName = arg.constructor && arg.constructor.name || type;
  var keys = Object.keys(arg);
  if (keys.length > 0 && keys.length < 20) {
    return displayName + ' (keys: ' + keys.join(', ') + ')';
  }
  return displayName;
}

function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
  var internalInstance = ReactInstanceMap.get(publicInstance);
  if (!internalInstance) {
    if (false) {
      var ctor = publicInstance.constructor;
      // Only warn when we have a callerName. Otherwise we should be silent.
      // We're probably calling from enqueueCallback. We don't want to warn
      // there because we already warned for the corresponding lifecycle method.
      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
    }
    return null;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
  }

  return internalInstance;
}

/**
 * ReactUpdateQueue allows for state updates to be scheduled into a later
 * reconciliation step.
 */
var ReactUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    if (false) {
      var owner = ReactCurrentOwner.current;
      if (owner !== null) {
        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
        owner._warnedAboutRefsInRender = true;
      }
    }
    var internalInstance = ReactInstanceMap.get(publicInstance);
    if (internalInstance) {
      // During componentWillMount and render this will still be null but after
      // that will always render to something. At least for now. So we can use
      // this hack.
      return !!internalInstance._renderedComponent;
    } else {
      return false;
    }
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @param {string} callerName Name of the calling function in the public API.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback, callerName) {
    ReactUpdateQueue.validateCallback(callback, callerName);
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);

    // Previously we would throw an error if we didn't have an internal
    // instance. Since we want to make it a no-op instead, we mirror the same
    // behavior we have in other enqueue* methods.
    // We also need to ignore callbacks in componentWillMount. See
    // enqueueUpdates.
    if (!internalInstance) {
      return null;
    }

    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    // TODO: The callback here is ignored when setState is called from
    // componentWillMount. Either fix it or disallow doing so completely in
    // favor of getInitialState. Alternatively, we can disallow
    // componentWillMount during server-side rendering.
    enqueueUpdate(internalInstance);
  },

  enqueueCallbackInternal: function (internalInstance, callback) {
    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    enqueueUpdate(internalInstance);
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingForceUpdate = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState, callback) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingStateQueue = [completeState];
    internalInstance._pendingReplaceState = true;

    // Future-proof 15.5
    if (callback !== undefined && callback !== null) {
      ReactUpdateQueue.validateCallback(callback, 'replaceState');
      if (internalInstance._pendingCallbacks) {
        internalInstance._pendingCallbacks.push(callback);
      } else {
        internalInstance._pendingCallbacks = [callback];
      }
    }

    enqueueUpdate(internalInstance);
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    if (false) {
      ReactInstrumentation.debugTool.onSetState();
      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
    }

    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');

    if (!internalInstance) {
      return;
    }

    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
    queue.push(partialState);

    enqueueUpdate(internalInstance);
  },

  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
    internalInstance._pendingElement = nextElement;
    // TODO: introduce _pendingContext instead of setting it directly.
    internalInstance._context = nextContext;
    enqueueUpdate(internalInstance);
  },

  validateCallback: function (callback, callerName) {
    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
  }
};

module.exports = ReactUpdateQueue;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* globals MSApp */



/**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */

var createMicrosoftUnsafeLocalFunction = function (func) {
  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
    return function (arg0, arg1, arg2, arg3) {
      MSApp.execUnsafeLocalFunction(function () {
        return func(arg0, arg1, arg2, arg3);
      });
    };
  } else {
    return func;
  }
};

module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */

function getEventCharCode(nativeEvent) {
  var charCode;
  var keyCode = nativeEvent.keyCode;

  if ('charCode' in nativeEvent) {
    charCode = nativeEvent.charCode;

    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
    if (charCode === 0 && keyCode === 13) {
      charCode = 13;
    }
  } else {
    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
    charCode = keyCode;
  }

  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
  // Must not discard the (non-)printable Enter-key.
  if (charCode >= 32 || charCode === 13) {
    return charCode;
  }

  return 0;
}

module.exports = getEventCharCode;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */

var modifierKeyToProp = {
  Alt: 'altKey',
  Control: 'ctrlKey',
  Meta: 'metaKey',
  Shift: 'shiftKey'
};

// IE8 does not implement getModifierState so we simply map it to the only
// modifier keys exposed by the event itself, does not support Lock-keys.
// Currently, all major browsers except Chrome seems to support Lock-keys.
function modifierStateGetter(keyArg) {
  var syntheticEvent = this;
  var nativeEvent = syntheticEvent.nativeEvent;
  if (nativeEvent.getModifierState) {
    return nativeEvent.getModifierState(keyArg);
  }
  var keyProp = modifierKeyToProp[keyArg];
  return keyProp ? !!nativeEvent[keyProp] : false;
}

function getEventModifierState(nativeEvent) {
  return modifierStateGetter;
}

module.exports = getEventModifierState;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */

function getEventTarget(nativeEvent) {
  var target = nativeEvent.target || nativeEvent.srcElement || window;

  // Normalize SVG <use> element events #4963
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
  // @see http://www.quirksmode.org/js/events_properties.html
  return target.nodeType === 3 ? target.parentNode : target;
}

module.exports = getEventTarget;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(9),
    _assign = __webpack_require__(11);

var ReactCompositeComponent = __webpack_require__(718);
var ReactEmptyComponent = __webpack_require__(313);
var ReactHostComponent = __webpack_require__(315);

var getNextDebugID = __webpack_require__(825);
var invariant = __webpack_require__(3);
var warning = __webpack_require__(10);

// To avoid a cyclic dependency, we create the final class in this module
var ReactCompositeComponentWrapper = function (element) {
  this.construct(element);
};

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Check if the type reference is a known internal type. I.e. not a user
 * provided composite type.
 *
 * @param {function} type
 * @return {boolean} Returns true if this is a valid internal type.
 */
function isInternalComponentType(type) {
  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
}

/**
 * Given a ReactNode, create an instance that will actually be mounted.
 *
 * @param {ReactNode} node
 * @param {boolean} shouldHaveDebugID
 * @return {object} A new instance of the element's constructor.
 * @protected
 */
function instantiateReactComponent(node, shouldHaveDebugID) {
  var instance;

  if (node === null || node === false) {
    instance = ReactEmptyComponent.create(instantiateReactComponent);
  } else if (typeof node === 'object') {
    var element = node;
    var type = element.type;
    if (typeof type !== 'function' && typeof type !== 'string') {
      var info = '';
      if (false) {
        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
        }
      }
      info += getDeclarationErrorAddendum(element._owner);
       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
    }

    // Special case string values
    if (typeof element.type === 'string') {
      instance = ReactHostComponent.createInternalComponent(element);
    } else if (isInternalComponentType(element.type)) {
      // This is temporarily available for custom components that are not string
      // representations. I.e. ART. Once those are updated to use the string
      // representation, we can drop this code path.
      instance = new element.type(element);

      // We renamed this. Allow the old name for compat. :(
      if (!instance.getHostNode) {
        instance.getHostNode = instance.getNativeNode;
      }
    } else {
      instance = new ReactCompositeComponentWrapper(element);
    }
  } else if (typeof node === 'string' || typeof node === 'number') {
    instance = ReactHostComponent.createInstanceForText(node);
  } else {
     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
  }

  // These two fields are used by the DOM and ART diffing algorithms
  // respectively. Instead of using expandos on components, we should be
  // storing the state needed by the diffing algorithms elsewhere.
  instance._mountIndex = 0;
  instance._mountImage = null;

  if (false) {
    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
  }

  // Internal instances should fully constructed at this point, so they should
  // not get any new fields added to them at this point.
  if (false) {
    if (Object.preventExtensions) {
      Object.preventExtensions(instance);
    }
  }

  return instance;
}

_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
  _instantiateReactComponent: instantiateReactComponent
});

module.exports = instantiateReactComponent;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(24);

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature = document.implementation && document.implementation.hasFeature &&
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in document;

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Given a `prevElement` and `nextElement`, determines if the existing
 * instance should be updated as opposed to being destroyed or replaced by a new
 * instance. Both arguments are elements. This ensures that this logic can
 * operate on stateless trees without any backing instance.
 *
 * @param {?object} prevElement
 * @param {?object} nextElement
 * @return {boolean} True if the existing instance should be updated.
 * @protected
 */

function shouldUpdateReactComponent(prevElement, nextElement) {
  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;
  if (prevEmpty || nextEmpty) {
    return prevEmpty === nextEmpty;
  }

  var prevType = typeof prevElement;
  var nextType = typeof nextElement;
  if (prevType === 'string' || prevType === 'number') {
    return nextType === 'string' || nextType === 'number';
  } else {
    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
  }
}

module.exports = shouldUpdateReactComponent;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(11);

var emptyFunction = __webpack_require__(50);
var warning = __webpack_require__(10);

var validateDOMNesting = emptyFunction;

if (false) {
  // This validation code was written based on the HTML5 parsing spec:
  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  //
  // Note: this does not catch all invalid nesting, nor does it try to (as it's
  // not clear what practical benefit doing so provides); instead, we warn only
  // for cases where the parser will give a parse tree differing from what React
  // intended. For example, <b><div></div></b> is invalid but we don't warn
  // because it still parses correctly; we do warn for other cases like nested
  // <p> tags where the beginning of the second element implicitly closes the
  // first, causing a confusing mess.

  // https://html.spec.whatwg.org/multipage/syntax.html#special
  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',

  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
  // TODO: Distinguish by namespace here -- for <title>, including it here
  // errs on the side of fewer warnings
  'foreignObject', 'desc', 'title'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
  var buttonScopeTags = inScopeTags.concat(['button']);

  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];

  var emptyAncestorInfo = {
    current: null,

    formTag: null,
    aTagInScope: null,
    buttonTagInScope: null,
    nobrTagInScope: null,
    pTagInButtonScope: null,

    listItemTagAutoclosing: null,
    dlItemTagAutoclosing: null
  };

  var updatedAncestorInfo = function (oldInfo, tag, instance) {
    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
    var info = { tag: tag, instance: instance };

    if (inScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.aTagInScope = null;
      ancestorInfo.buttonTagInScope = null;
      ancestorInfo.nobrTagInScope = null;
    }
    if (buttonScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.pTagInButtonScope = null;
    }

    // See rules for 'li', 'dd', 'dt' start tags in
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
      ancestorInfo.listItemTagAutoclosing = null;
      ancestorInfo.dlItemTagAutoclosing = null;
    }

    ancestorInfo.current = info;

    if (tag === 'form') {
      ancestorInfo.formTag = info;
    }
    if (tag === 'a') {
      ancestorInfo.aTagInScope = info;
    }
    if (tag === 'button') {
      ancestorInfo.buttonTagInScope = info;
    }
    if (tag === 'nobr') {
      ancestorInfo.nobrTagInScope = info;
    }
    if (tag === 'p') {
      ancestorInfo.pTagInButtonScope = info;
    }
    if (tag === 'li') {
      ancestorInfo.listItemTagAutoclosing = info;
    }
    if (tag === 'dd' || tag === 'dt') {
      ancestorInfo.dlItemTagAutoclosing = info;
    }

    return ancestorInfo;
  };

  /**
   * Returns whether
   */
  var isTagValidWithParent = function (tag, parentTag) {
    // First, let's check if we're in an unusual parsing mode...
    switch (parentTag) {
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
      case 'select':
        return tag === 'option' || tag === 'optgroup' || tag === '#text';
      case 'optgroup':
        return tag === 'option' || tag === '#text';
      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
      // but
      case 'option':
        return tag === '#text';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
      // No special behavior since these rules fall back to "in body" mode for
      // all except special table nodes which cause bad parsing behavior anyway.

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
      case 'tr':
        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
      case 'tbody':
      case 'thead':
      case 'tfoot':
        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
      case 'colgroup':
        return tag === 'col' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
      case 'table':
        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
      case 'head':
        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
      case 'html':
        return tag === 'head' || tag === 'body';
      case '#document':
        return tag === 'html';
    }

    // Probably in the "in body" parsing mode, so we outlaw only tag combos
    // where the parsing rules cause implicit opens or closes to be added.
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    switch (tag) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

      case 'rp':
      case 'rt':
        return impliedEndTags.indexOf(parentTag) === -1;

      case 'body':
      case 'caption':
      case 'col':
      case 'colgroup':
      case 'frame':
      case 'head':
      case 'html':
      case 'tbody':
      case 'td':
      case 'tfoot':
      case 'th':
      case 'thead':
      case 'tr':
        // These tags are only valid with a few parents that have special child
        // parsing rules -- if we're down here, then none of those matched and
        // so we allow it only if we don't know what the parent is, as all other
        // cases are invalid.
        return parentTag == null;
    }

    return true;
  };

  /**
   * Returns whether
   */
  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
    switch (tag) {
      case 'address':
      case 'article':
      case 'aside':
      case 'blockquote':
      case 'center':
      case 'details':
      case 'dialog':
      case 'dir':
      case 'div':
      case 'dl':
      case 'fieldset':
      case 'figcaption':
      case 'figure':
      case 'footer':
      case 'header':
      case 'hgroup':
      case 'main':
      case 'menu':
      case 'nav':
      case 'ol':
      case 'p':
      case 'section':
      case 'summary':
      case 'ul':
      case 'pre':
      case 'listing':
      case 'table':
      case 'hr':
      case 'xmp':
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return ancestorInfo.pTagInButtonScope;

      case 'form':
        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

      case 'li':
        return ancestorInfo.listItemTagAutoclosing;

      case 'dd':
      case 'dt':
        return ancestorInfo.dlItemTagAutoclosing;

      case 'button':
        return ancestorInfo.buttonTagInScope;

      case 'a':
        // Spec says something about storing a list of markers, but it sounds
        // equivalent to this check.
        return ancestorInfo.aTagInScope;

      case 'nobr':
        return ancestorInfo.nobrTagInScope;
    }

    return null;
  };

  /**
   * Given a ReactCompositeComponent instance, return a list of its recursive
   * owners, starting at the root and ending with the instance itself.
   */
  var findOwnerStack = function (instance) {
    if (!instance) {
      return [];
    }

    var stack = [];
    do {
      stack.push(instance);
    } while (instance = instance._currentElement._owner);
    stack.reverse();
    return stack;
  };

  var didWarn = {};

  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;

    if (childText != null) {
      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
      childTag = '#text';
    }

    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
    var problematic = invalidParent || invalidAncestor;

    if (problematic) {
      var ancestorTag = problematic.tag;
      var ancestorInstance = problematic.instance;

      var childOwner = childInstance && childInstance._currentElement._owner;
      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;

      var childOwners = findOwnerStack(childOwner);
      var ancestorOwners = findOwnerStack(ancestorOwner);

      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
      var i;

      var deepestCommon = -1;
      for (i = 0; i < minStackLen; i++) {
        if (childOwners[i] === ancestorOwners[i]) {
          deepestCommon = i;
        } else {
          break;
        }
      }

      var UNKNOWN = '(unknown)';
      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ownerInfo = [].concat(
      // If the parent and child instances have a common owner ancestor, start
      // with that -- otherwise we just start with the parent's owners.
      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
      // If we're warning about an invalid (non-parent) ancestry, add '...'
      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');

      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
      if (didWarn[warnKey]) {
        return;
      }
      didWarn[warnKey] = true;

      var tagDisplayName = childTag;
      var whitespaceInfo = '';
      if (childTag === '#text') {
        if (/\S/.test(childText)) {
          tagDisplayName = 'Text nodes';
        } else {
          tagDisplayName = 'Whitespace text nodes';
          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
        }
      } else {
        tagDisplayName = '<' + childTag + '>';
      }

      if (invalidParent) {
        var info = '';
        if (ancestorTag === 'table' && childTag === 'tr') {
          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
        }
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
      } else {
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
      }
    }
  };

  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;

  // For testing
  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;
    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
  };
}

module.exports = validateDOMNesting;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _regenerator = __webpack_require__(72);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(71);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(52);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(60);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(59);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(1);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _canUseDom = __webpack_require__(241);

var _canUseDom2 = _interopRequireDefault(_canUseDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InitFacebook = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(InitFacebook, _Component);

  function InitFacebook() {
    (0, _classCallCheck3.default)(this, InitFacebook);
    return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
  }

  InitFacebook.prototype.componentDidMount = function componentDidMount() {
    if (_canUseDom2.default) {
      this.initFacebook();
    }
  };

  InitFacebook.prototype.initFacebook = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var onReady, facebook;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              onReady = this.props.onReady;
              _context.next = 3;
              return this.context.facebook.init();

            case 3:
              facebook = _context.sent;

              onReady(facebook);

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function initFacebook() {
      return _ref.apply(this, arguments);
    }

    return initFacebook;
  }();

  InitFacebook.prototype.render = function render() {
    return this.props.children;
  };

  return InitFacebook;
}(_react.Component), _class.propTypes = {
  children: _propTypes2.default.node,
  onReady: _propTypes2.default.func.isRequired
}, _class.defaultProps = {
  children: undefined
}, _class.contextTypes = {
  facebook: _propTypes2.default.object.isRequired
}, _temp);
exports.default = InitFacebook;
//# sourceMappingURL=InitFacebook.js.map

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _regenerator = __webpack_require__(72);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(71);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(52);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(60);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(59);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _InitFacebook = __webpack_require__(222);

var _InitFacebook2 = _interopRequireDefault(_InitFacebook);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Process = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(Process, _Component);

  function Process() {
    var _this2 = this;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Process);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      isWorking: false
    }, _this.handleClick = function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(evn) {
        var facebook, _this$props, dontWait, onResponse, onError, response, _onError;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                evn.preventDefault();
                evn.stopPropagation();

                _this.setState({
                  isWorking: true
                });

                _context.prev = 3;
                facebook = _this.state.facebook;

                if (facebook) {
                  _context.next = 7;
                  break;
                }

                throw new Error('Facebook is not initialized');

              case 7:
                _this$props = _this.props, dontWait = _this$props.dontWait, onResponse = _this$props.onResponse, onError = _this$props.onError;

                if (!dontWait) {
                  _context.next = 12;
                  break;
                }

                _this.process(facebook).then(function (response) {
                  if (onResponse) {
                    onResponse(response);
                  }
                }, function (error) {
                  if (onError) {
                    onError(error);
                  }
                });
                _context.next = 18;
                break;

              case 12:
                _context.next = 14;
                return _this.process(facebook);

              case 14:
                response = _context.sent;

                if (!onResponse) {
                  _context.next = 18;
                  break;
                }

                _context.next = 18;
                return onResponse(response);

              case 18:
                _context.next = 26;
                break;

              case 20:
                _context.prev = 20;
                _context.t0 = _context['catch'](3);
                _onError = _this.props.onError;

                if (!_onError) {
                  _context.next = 26;
                  break;
                }

                _context.next = 26;
                return _onError(_context.t0);

              case 26:

                _this.setState({
                  isWorking: false
                });

              case 27:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[3, 20]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }(), _this.handleFacebookReady = function (facebook) {
      _this.setState({ facebook: facebook });

      var onReady = _this.props.onReady;

      if (onReady) {
        onReady(facebook);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  Process.prototype.getElement = function getElement() {
    var _props = this.props,
        children = _props.children,
        render = _props.render,
        CustomComponent = _props.component;
    var _state = this.state,
        facebook = _state.facebook,
        isWorking = _state.isWorking;

    var isLoading = !facebook;
    var isReady = !isLoading && !isWorking;

    if (render) {
      return render({
        isWorking: isWorking,
        isLoading: isLoading,
        isReady: isReady,
        onClick: this.handleClick
      });
    }

    if (CustomComponent) {
      return _react2.default.createElement(CustomComponent, {
        onClick: this.handleClick,
        isLoading: isLoading,
        isWorking: isWorking,
        isReady: isReady
      });
    }

    return (0, _react.cloneElement)(children, {
      onClick: this.handleClick
    });
  };

  Process.prototype.render = function render() {
    return _react2.default.createElement(
      _InitFacebook2.default,
      { onReady: this.handleFacebookReady },
      this.getElement()
    );
  };

  return Process;
}(_react.Component), _class.propTypes = {
  children: _propTypes2.default.node,
  render: _propTypes2.default.func,
  component: _propTypes2.default.node,
  onReady: _propTypes2.default.func,
  onError: _propTypes2.default.func,
  onResponse: _propTypes2.default.func,
  dontWait: _propTypes2.default.bool
}, _class.defaultProps = {
  children: undefined,
  render: undefined,
  component: undefined,
  onReady: undefined,
  onError: undefined,
  onResponse: undefined,
  dontWait: undefined
}, _temp2);
exports.default = Process;
//# sourceMappingURL=Process.js.map

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = {
  LIGHT: 'light',
  DARK: 'dark'
};
//# sourceMappingURL=ColorScheme.js.map

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(785);



/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = loopAsync;
/* harmony export (immutable) */ __webpack_exports__["a"] = mapAsync;
function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var sync = false,
      hasNext = false,
      doneArgs = void 0;

  function done() {
    isDone = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      doneArgs = [].concat(Array.prototype.slice.call(arguments));
      return;
    }

    callback.apply(this, arguments);
  }

  function next() {
    if (isDone) {
      return;
    }

    hasNext = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      return;
    }

    sync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work.call(this, currentTurn++, next, done);
    }

    sync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(this, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  }

  next();
}

function mapAsync(array, work, callback) {
  var length = array.length;
  var values = [];

  if (length === 0) return callback(null, values);

  var isDone = false,
      doneCount = 0;

  function done(index, error, value) {
    if (isDone) return;

    if (error) {
      isDone = true;
      callback(error);
    } else {
      values[index] = value;

      isDone = ++doneCount === length;

      if (isDone) callback(null, values);
    }
  }

  array.forEach(function (item, index) {
    work(item, index, function (error, value) {
      done(index, error, value);
    });
  });
}

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ContextProvider;
/* harmony export (immutable) */ __webpack_exports__["b"] = ContextSubscriber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



// Works around issues with context updates failing to propagate.
// Caveat: the context value is expected to never change its identity.
// https://github.com/facebook/react/issues/2517
// https://github.com/reactjs/react-router/issues/470

var contextProviderShape = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  eventIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
});

function makeContextName(name) {
  return '@@contextSubscriber/' + name;
}

var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef !== 'undefined';

function ContextProvider(name) {
  var _childContextTypes, _config;

  var contextName = makeContextName(name);
  var listenersKey = contextName + '/listeners';
  var eventIndexKey = contextName + '/eventIndex';
  var subscribeKey = contextName + '/subscribe';

  var config = (_config = {
    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),

    getChildContext: function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextName] = {
        eventIndex: this[eventIndexKey],
        subscribe: this[subscribeKey]
      }, _ref;
    },


    // this method will be updated to UNSAFE_componentWillMount below for React versions >= 16.3
    componentWillMount: function componentWillMount() {
      this[listenersKey] = [];
      this[eventIndexKey] = 0;
    },


    // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
    componentWillReceiveProps: function componentWillReceiveProps() {
      this[eventIndexKey]++;
    },
    componentDidUpdate: function componentDidUpdate() {
      var _this = this;

      this[listenersKey].forEach(function (listener) {
        return listener(_this[eventIndexKey]);
      });
    }
  }, _config[subscribeKey] = function (listener) {
    var _this2 = this;

    // No need to immediately call listener here.
    this[listenersKey].push(listener);

    return function () {
      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
        return item !== listener;
      });
    };
  }, _config);

  if (prefixUnsafeLifecycleMethods) {
    config.UNSAFE_componentWillMount = config.componentWillMount;
    config.UNSAFE_componentWillReceiveProps = config.componentWillReceiveProps;
    delete config.componentWillMount;
    delete config.componentWillReceiveProps;
  }
  return config;
}

function ContextSubscriber(name) {
  var _contextTypes, _config2;

  var contextName = makeContextName(name);
  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
  var handleContextUpdateKey = contextName + '/handleContextUpdate';
  var unsubscribeKey = contextName + '/unsubscribe';

  var config = (_config2 = {
    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),

    getInitialState: function getInitialState() {
      var _ref2;

      if (!this.context[contextName]) {
        return {};
      }

      return _ref2 = {}, _ref2[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref2;
    },
    componentDidMount: function componentDidMount() {
      if (!this.context[contextName]) {
        return;
      }

      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
    },


    // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
    componentWillReceiveProps: function componentWillReceiveProps() {
      var _setState;

      if (!this.context[contextName]) {
        return;
      }

      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
    },
    componentWillUnmount: function componentWillUnmount() {
      if (!this[unsubscribeKey]) {
        return;
      }

      this[unsubscribeKey]();
      this[unsubscribeKey] = null;
    }
  }, _config2[handleContextUpdateKey] = function (eventIndex) {
    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
      var _setState2;

      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
    }
  }, _config2);

  if (prefixUnsafeLifecycleMethods) {
    config.UNSAFE_componentWillReceiveProps = config.componentWillReceiveProps;
    delete config.componentWillReceiveProps;
  }
  return config;
}

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return routerShape; });
/* unused harmony export locationShape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var routerShape = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  push: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  replace: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  go: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goBack: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goForward: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  setRouteLeaveHook: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  isActive: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired
});

var locationShape = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  pathname: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  search: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  state: __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"],
  action: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  key: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]
});

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_is__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getRouteParams__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ContextUtils__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RouteUtils__ = __webpack_require__(68);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };











/**
 * A <RouterContext> renders the component tree for a given router state
 * and sets the history object and the current location in context.
 */
var RouterContext = __WEBPACK_IMPORTED_MODULE_3_create_react_class___default()({
  displayName: 'RouterContext',

  mixins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__ContextUtils__["a" /* ContextProvider */])('router')],

  propTypes: {
    router: __WEBPACK_IMPORTED_MODULE_4_prop_types__["object"].isRequired,
    location: __WEBPACK_IMPORTED_MODULE_4_prop_types__["object"].isRequired,
    routes: __WEBPACK_IMPORTED_MODULE_4_prop_types__["array"].isRequired,
    params: __WEBPACK_IMPORTED_MODULE_4_prop_types__["object"].isRequired,
    components: __WEBPACK_IMPORTED_MODULE_4_prop_types__["array"].isRequired,
    createElement: __WEBPACK_IMPORTED_MODULE_4_prop_types__["func"].isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      createElement: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement
    };
  },


  childContextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_4_prop_types__["object"].isRequired
  },

  getChildContext: function getChildContext() {
    return {
      router: this.props.router
    };
  },
  createElement: function createElement(component, props) {
    return component == null ? null : this.props.createElement(component, props);
  },
  render: function render() {
    var _this = this;

    var _props = this.props,
        location = _props.location,
        routes = _props.routes,
        params = _props.params,
        components = _props.components,
        router = _props.router;

    var element = null;

    if (components) {
      element = components.reduceRight(function (element, components, index) {
        if (components == null) return element; // Don't create new children; use the grandchildren.

        var route = routes[index];
        var routeParams = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__getRouteParams__["a" /* default */])(route, params);
        var props = {
          location: location,
          params: params,
          route: route,
          router: router,
          routeParams: routeParams,
          routes: routes
        };

        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__RouteUtils__["a" /* isReactChildren */])(element)) {
          props.children = element;
        } else if (element) {
          for (var prop in element) {
            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
          }
        }

        // Handle components is object for { [name]: component } but not valid element
        // type of react, such as React.memo, React.lazy and so on.
        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object' && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_is__["isValidElementType"])(components)) {
          var elements = {};

          for (var key in components) {
            if (Object.prototype.hasOwnProperty.call(components, key)) {
              // Pass through the key as a prop to createElement to allow
              // custom createElement functions to know which named component
              // they're rendering, for e.g. matching up to fetched data.
              elements[key] = _this.createElement(components[key], _extends({
                key: key }, props));
            }
          }

          return elements;
        }

        return _this.createElement(components, props);
      }, element);
    }

    !(element === null || element === false || __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(element)) ?  false ? invariant(false, 'The root route must render a single element') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

    return element;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (RouterContext);

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @copyright © 2015, Rick Wong. All rights reserved.
 */


module.exports = __webpack_require__(11);


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * @copyright © 2015, Rick Wong. All rights reserved.
 */


module.exports = {
	Promise: global.Promise || function () {
		throw new Error("Missing ES6 Promise implementation");
	}
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(105)))

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Su_Su__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Su_SuTsitPuann__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GuanKiann_ABo_ABo__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__GuaGi_css__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__GuaGi_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__GuaGi_css__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var debug = __WEBPACK_IMPORTED_MODULE_4_debug___default()('itaigi:GuaGi');

var GuaGi = function (_React$Component) {
  _inherits(GuaGi, _React$Component);

  function GuaGi() {
    _classCallCheck(this, GuaGi);

    return _possibleConstructorReturn(this, (GuaGi.__proto__ || Object.getPrototypeOf(GuaGi)).apply(this, arguments));
  }

  _createClass(GuaGi, [{
    key: 'dedupeSu',
    value: function dedupeSu(inSu) {
      var seen = {};
      return inSu.filter(function (val, id) {
        var key = val.文本資料 + val.音標資料;
        if (seen[key]) return false;
        seen[key] = true;
        return true;
      });
    }
  }, {
    key: '\u986F\u793A\u8A5E',
    value: function _(詞) {
      var 來開例句 = this.props.開例句.bind(this, this.props.華語關鍵字, 詞.文本資料, 詞.音標資料);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Su_Su__["a" /* default */], {
        suId: 詞.新詞文本項目編號,
        suText: 詞.文本資料,
        suIm: 詞.音標資料,
        貢獻者: 詞.貢獻者,
        按呢講好: 詞.按呢講好,
        按呢無好: 詞.按呢無好,
        按呢講的外語列表: 詞.按呢講的外語列表,
        key: 詞.新詞文本項目編號,
        csrftoken: this.props.csrftoken,
        來開例句: 來開例句,
        variables: { 詞: 詞 },
        renderLoading: this.詞載入中(詞, 來開例句) });
    }
  }, {
    key: '\u8A5E\u8F09\u5165\u4E2D',
    value: function _(詞, 來開例句) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Su_SuTsitPuann__["a" /* default */], {
        詞: 詞,
        來開例句: 來開例句 });
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.新詞文本) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null);
      }

      var uniqueSu = this.dedupeSu(this.props.新詞文本);

      var suList = uniqueSu.map(this.顯示詞.bind(this));
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'guaGi' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'ui su vertical segment' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'ui stackable cards' },
            suList,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'ui su card' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'content' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h3',
                  { className: 'ui header' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'cloud upload icon' }),
                  '\u95A3\u6703\u4F7F\u6309\u5462\u8B1B'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__GuanKiann_ABo_ABo__["a" /* default */], { 華語關鍵字: this.props.華語關鍵字,
                  csrftoken: this.props.csrftoken,
                  編號: this.props.編號, 漢字: this.props.漢字, 音標: this.props.音標
                })
              )
            )
          )
        )
      );
    }
  }]);

  return GuaGi;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (GuaGi);

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debug__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GA__ = __webpack_require__(106);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var debug = __WEBPACK_IMPORTED_MODULE_1_debug___default()('itaigi:HapSing');

var HapSing = function (_React$Component) {
  _inherits(HapSing, _React$Component);

  function HapSing() {
    _classCallCheck(this, HapSing);

    return _possibleConstructorReturn(this, (HapSing.__proto__ || Object.getPrototypeOf(HapSing)).apply(this, arguments));
  }

  _createClass(HapSing, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.音標 === this.props.音標) return;
      var 音樂 = this.refs.音樂;
      if (音樂 != null) {
        音樂.load();
      }
    }
  }, {
    key: 'play',
    value: function play() {
      var _props = this.props,
          hanji = _props.hanji,
          音標 = _props.音標;

      var 音樂 = this.refs.音樂;
      if (音樂 != null) {
        音樂.play();
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__GA__["a" /* gaThiann */])(hanji, 音標);
    }
  }, {
    key: 'render',
    value: function render() {
      var 音標 = this.props.音標;

      var 標漢字音標 = 音標.replace('/', ' 。 ').trim();
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'HuatIm' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'audio',
          { ref: '\u97F3\u6A02' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source', { type: 'audio/x-wav',
            src: encodeURI('https://hts.ithuan.tw/文本直接合成?查詢腔口=台語&查詢語句=') + encodeURIComponent(標漢字音標)
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { onClick: this.play.bind(this),
            className: 'ui compact icon button', title: '\u767C\u97F3' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'icon play' })
        )
      );
    }
  }]);

  return HapSing;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (HapSing);
;

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debug__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_debug__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var debug = __WEBPACK_IMPORTED_MODULE_1_debug___default()('itaigi:LaiLik');

var LaiLik = function (_React$Component) {
  _inherits(LaiLik, _React$Component);

  function LaiLik() {
    _classCallCheck(this, LaiLik);

    return _possibleConstructorReturn(this, (LaiLik.__proto__ || Object.getPrototypeOf(LaiLik)).apply(this, arguments));
  }

  _createClass(LaiLik, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'content' },
        '\u51FA\u8655\uFF1A',
        this.props.貢獻者
      );
    }
  }]);

  return LaiLik;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (LaiLik);

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ToLam_css__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ToLam_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ToLam_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_logo_svg__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__images_logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_dictionary_svg__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_dictionary_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__images_dictionary_svg__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/*Pokeball by Arjun Mahanti from the Noun Project*/


var ToLam = function (_React$Component) {
  _inherits(ToLam, _React$Component);

  function ToLam() {
    _classCallCheck(this, ToLam);

    return _possibleConstructorReturn(this, (ToLam.__proto__ || Object.getPrototypeOf(ToLam)).apply(this, arguments));
  }

  _createClass(ToLam, [{
    key: 'render',
    value: function render() {
      var path = this.props.pathname;
      var menu_item_class = function menu_item_class(prefix) {
        if (path == prefix || path.startsWith(prefix + '/') || path === '/' && prefix === '/k') return 'item active';
        return 'item';
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'app bar container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'title' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Link */],
            { to: '/' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'i',
              { className: 'logo' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_3__images_logo_svg___default.a })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'ui labeled icon menu' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Link */],
            { className: menu_item_class('/k'), to: '/k' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'sound icon' }),
            '\u600E\u6A23\u8B1B'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Link */],
            { className: menu_item_class('/name'), to: '/name' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'question icon' }),
            '\u4F60\u7684\u540D\u5B57'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Link */],
            { className: menu_item_class('/t'), to: '/t' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'unmute icon' }),
            '\u6211\u5F88\u6703'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Link */],
            { className: menu_item_class('/mia'), to: '/mia' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'flag icon' }),
            '\u540D\u4EBA\u5802'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Link */],
            { className: menu_item_class('/tsing'), to: '/tsing' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'student icon' }),
            '\u6B63\u898F\u5316\u5718\u968A'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Link */],
            { className: menu_item_class('/iong'), to: '/iong' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'configure icon' }),
            '\u597D\u5DE5\u5177'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Link */],
            { className: menu_item_class('/tsu-te'), to: '/tsu-te' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'i',
              { className: 'icon' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_4__images_dictionary_svg___default.a })
            ),
            '\u53F0\u8A9E\u5BF6\u9451'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'ui right item' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'menu' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { className: 'item',
                href: 'https://www.facebook.com/ukauitaigi/', target: '_blank' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'facebook square icon big' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Link */],
              { className: 'item', to: '/about' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'info circle icon big' })
            )
          )
        )
      );
    }
  }]);

  return ToLam;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (ToLam);

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tshue_css__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tshue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Tshue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GA__ = __webpack_require__(106);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var debug = __WEBPACK_IMPORTED_MODULE_2_debug___default()('itaigi:Tshue');

var Tshue = function (_React$Component) {
  _inherits(Tshue, _React$Component);

  // Tshue should be only one cause the id.
  function Tshue(props) {
    _classCallCheck(this, Tshue);

    var _this = _possibleConstructorReturn(this, (Tshue.__proto__ || Object.getPrototypeOf(Tshue)).call(this, props));

    _this.state = {
      q: _this.props.defaultValue || ''
    };
    _this.查過的詞 = new Set();
    return _this;
  }

  _createClass(Tshue, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.defaultValue === this.props.defaultValue) return;
      var defaultValue = nextProps.defaultValue;

      if (this.查過的詞.has(defaultValue)) {
        this.查過的詞.delete(defaultValue);
      } else if (defaultValue === undefined) {
        this.refs.Tshue.value = '';
        this.setState({ q: '' });
      } else {
        this.refs.Tshue.value = defaultValue;
        this.setState({ q: defaultValue });
      }
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(evt) {
      if (evt.keyCode === 13) {
        this.查怎樣講(evt);
        return;
      }
    }
  }, {
    key: '\u67E5\u600E\u6A23\u8B1B',
    value: function _(evt) {
      var q = this.refs.Tshue.value;
      if (q !== this.state.q) {
        this.setState({ q: q });
        this.查過的詞.add(q);
        this.props.查怎樣講(q);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__GA__["c" /* gaTshue */])(q);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'ui fluid action input huge container tshue' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
          type: 'text',
          placeholder: '\u8F38\u5165\u83EF\u8A9E\uFF0C\u6309\u4E0B\u300C\u8B1B\u53F0\u8A9E\u300D',
          defaultValue: this.props.defaultValue,
          onKeyDown: this.handleKeyDown.bind(this),
          ref: 'Tshue',
          size: '8'
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'ui button huge teal',
            onClick: this.查怎樣講.bind(this) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'translate icon' }),
          '\u8B1B\u53F0\u8A9E'
        )
      );
    }
  }]);

  return Tshue;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Tshue);

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GuanKiann___ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GuanKiann___ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var debug = __WEBPACK_IMPORTED_MODULE_4_debug___default()('itaigi:Kong其他建議');

var 其他建議 = function (_React$Component) {
  _inherits(其他建議, _React$Component);

  function 其他建議(props) {
    _classCallCheck(this, 其他建議);

    var _this = _possibleConstructorReturn(this, (其他建議.__proto__ || Object.getPrototypeOf(其他建議)).call(this, props));

    _this.state = {
      全開: _this.預設顯示幾个()
    };
    _this.查過的詞 = new Set();
    return _this;
  }

  _createClass(其他建議, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.內容.其他建議 != this.props.內容.其他建議) {
        this.setState({ 全開: this.預設顯示幾个() });
      }
    }
  }, {
    key: '\u9810\u8A2D\u986F\u793A\u5E7E\u4E2A',
    value: function _() {
      return 6;
    }
  }, {
    key: '\u770B\u95A3\u8F03\u6FDF',
    value: function _() {
      if (this.props.內容.其他建議.length > this.state.全開) return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'su card' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { onClick: this.看閣較濟全開.bind(this),
              className: 'ui icon button' },
            '\u770B\u95A3\u8F03\u6FDF'
          )
        )
      );
    }
  }, {
    key: '\u770B\u95A3\u8F03\u6FDF\u5168\u958B',
    value: function _() {
      var 全開 = this.state.全開;

      全開 += this.預設顯示幾个();
      this.setState({ 全開: 全開 });
    }
  }, {
    key: '\u986F\u793A\u5EFA\u8B70',
    value: function _(建議, i) {
      var 來開例句 = this.props.開例句.bind(this, this.props.華語關鍵字, 建議.文本資料, 建議.音標資料);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__GuanKiann___["a" /* default */], { key: i,
        文本資料: 建議.文本資料,
        音標資料: 建議.音標資料,
        按呢講的外語列表: 建議.按呢講的外語列表,
        來開例句: 來開例句,
        variables: 建議,
        renderLoading: this.建議載入中(建議, 來開例句) });
    }
  }, {
    key: '\u5EFA\u8B70\u8F09\u5165\u4E2D',
    value: function _(建議, 來開例句) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__GuanKiann___["a" /* default */], {
        文本資料: 建議.文本資料,
        音標資料: 建議.音標資料,
        按呢講的外語列表: 建議.按呢講的外語列表,
        來開例句: 來開例句 });
    }
  }, {
    key: 'render',
    value: function render() {
      var 其他建議 = this.props.內容.其他建議.slice(0, this.state.全開);

      var 文本 = 其他建議.map(this.顯示建議.bind(this));
      if (文本.length == 0) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'kianGi' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'ui horizontal divider header' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'book icon' }),
          '\u76F8\u95DC\u8A5E\u689D'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'ui vertical segment' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'ui stackable cards' },
            文本,
            this.看閣較濟()
          )
        )
      );
    }
  }]);

  return 其他建議;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (其他建議);

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bluebird__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GuanKiann_GuaGi_GuaGi__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var superagent = __webpack_require__(26)(__webpack_require__(27), __WEBPACK_IMPORTED_MODULE_1_bluebird___default.a);





var debug = __WEBPACK_IMPORTED_MODULE_4_debug___default()('itaigi:抱去摸三隻');

var 抱去摸三隻 = function (_React$Component) {
  _inherits(抱去摸三隻, _React$Component);

  function 抱去摸三隻(props) {
    _classCallCheck(this, 抱去摸三隻);

    var _this = _possibleConstructorReturn(this, (抱去摸三隻.__proto__ || Object.getPrototypeOf(抱去摸三隻)).call(this, props));

    _this.state = {
      資料: undefined
    };
    return _this;
  }

  _createClass(抱去摸三隻, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.資料 != undefined) {
        this.setState({ 資料: undefined });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.資料 != undefined) {
        this.refs.寶可夢0.focus();
      }
    }
  }, {
    key: '\u9EDE\u843D',
    value: function _(名) {
      var _this2 = this;

      if (this.props.佗一隻 == 名) this.props.換一隻(undefined);else {
        this.props.換一隻(名);
        superagent.get(__WEBPACK_IMPORTED_MODULE_3____["a" /* default */].揣列表(名)).then(function (_ref) {
          var body = _ref.body;
          return _this2.setState({ 資料: body }), null;
        }).catch(function (err) {
          return debug(err);
        });
        setTimeout(function () {
          return _this2.refs.寶可夢0.focus();
        }, 50);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          寶貝名 = _props.寶貝名,
          佗一隻 = _props.佗一隻;

      var 鈕 = ['ui black basic button large', 'ui black basic button large', 'ui black basic button large'];
      var 詞條 = '';
      var 顯示 = -1;
      寶貝名.map(function (名, i) {
        return 名 == 佗一隻 ? 顯示 = i : 顯示;
      });

      if (顯示 != -1) {
        鈕[顯示] = 'ui red basic button large';
      }

      if (this.state.資料 != undefined) {
        var g = this.state.資料.列表[0];
        詞條 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'main container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__GuanKiann_GuaGi_GuaGi__["a" /* default */], { id: g.外語項目編號,
            key: g.外語項目編號, 新詞文本: g.新詞文本,
            csrftoken: this.props.csrftoken,
            開例句: function _() {
              return '';
            } })
        );
      } else {
        詞條 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null);
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: '\u5BF6\u53EF\u5922' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'three ui buttons' },
          寶貝名.map(function (鈕仔, 編號) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { key: 編號, ref: '寶可夢' + 編號,
                className: 鈕[編號],
                onClick: _this3.點落.bind(_this3, 寶貝名[編號]) },
              寶貝名[編號]
            );
          })
        ),
        詞條
      );
    }
  }]);

  return 抱去摸三隻;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (抱去摸三隻);

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(406);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(405);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 241 */
/***/ (function(module, exports) {

var canUseDOM = !!(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement
);

module.exports = canUseDOM;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(109);
var TAG = __webpack_require__(29)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(23).document;
module.exports = document && document.documentElement;


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(61) && !__webpack_require__(111)(function () {
  return Object.defineProperty(__webpack_require__(161)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(109);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(113);
var $export = __webpack_require__(62);
var redefine = __webpack_require__(252);
var hide = __webpack_require__(74);
var Iterators = __webpack_require__(112);
var $iterCreate = __webpack_require__(426);
var setToStringTag = __webpack_require__(131);
var getPrototypeOf = __webpack_require__(434);
var ITERATOR = __webpack_require__(29)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(129);
var createDesc = __webpack_require__(130);
var toIObject = __webpack_require__(93);
var toPrimitive = __webpack_require__(170);
var has = __webpack_require__(73);
var IE8_DOM_DEFINE = __webpack_require__(244);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(61) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(249);
var hiddenKeys = __webpack_require__(162).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(73);
var toIObject = __webpack_require__(93);
var arrayIndexOf = __webpack_require__(419)(false);
var IE_PROTO = __webpack_require__(166)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 250 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(53);
var isObject = __webpack_require__(63);
var newPromiseCapability = __webpack_require__(163);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(74);


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(53);
var aFunction = __webpack_require__(127);
var SPECIES = __webpack_require__(29)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(110);
var invoke = __webpack_require__(422);
var html = __webpack_require__(243);
var cel = __webpack_require__(161);
var global = __webpack_require__(23);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(109)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(168);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 256 */
/***/ (function(module, exports) {



/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(438)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(246)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(442);
var global = __webpack_require__(23);
var hide = __webpack_require__(74);
var Iterators = __webpack_require__(112);
var TO_STRING_TAG = __webpack_require__(29)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(39);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(19);
var toAbsoluteIndex = __webpack_require__(84);
var toLength = __webpack_require__(13);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(77);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(22);
var toObject = __webpack_require__(19);
var IObject = __webpack_require__(115);
var toLength = __webpack_require__(13);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(22);
var isObject = __webpack_require__(7);
var invoke = __webpack_require__(269);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(15).f;
var create = __webpack_require__(78);
var redefineAll = __webpack_require__(82);
var ctx = __webpack_require__(41);
var anInstance = __webpack_require__(76);
var forOf = __webpack_require__(77);
var $iterDefine = __webpack_require__(184);
var step = __webpack_require__(272);
var setSpecies = __webpack_require__(83);
var DESCRIPTORS = __webpack_require__(14);
var fastKey = __webpack_require__(66).fastKey;
var validate = __webpack_require__(86);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(94);
var from = __webpack_require__(261);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(82);
var getWeak = __webpack_require__(66).getWeak;
var anObject = __webpack_require__(2);
var isObject = __webpack_require__(7);
var anInstance = __webpack_require__(76);
var forOf = __webpack_require__(77);
var createArrayMethod = __webpack_require__(46);
var $has = __webpack_require__(34);
var validate = __webpack_require__(86);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(136);
var isObject = __webpack_require__(7);
var toLength = __webpack_require__(13);
var ctx = __webpack_require__(41);
var IS_CONCAT_SPREADABLE = __webpack_require__(12)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(14) && !__webpack_require__(6)(function () {
  return Object.defineProperty(__webpack_require__(177)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 269 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(7);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(2);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 272 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(186);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 274 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 275 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(14);
var getKeys = __webpack_require__(80);
var gOPS = __webpack_require__(140);
var pIE = __webpack_require__(116);
var toObject = __webpack_require__(19);
var IObject = __webpack_require__(115);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(6)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(15);
var anObject = __webpack_require__(2);
var getKeys = __webpack_require__(80);

module.exports = __webpack_require__(14) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(37);
var gOPN = __webpack_require__(79).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(34);
var toIObject = __webpack_require__(37);
var arrayIndexOf = __webpack_require__(133)(false);
var IE_PROTO = __webpack_require__(191)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(14);
var getKeys = __webpack_require__(80);
var toIObject = __webpack_require__(37);
var isEnum = __webpack_require__(116).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(79);
var gOPS = __webpack_require__(140);
var anObject = __webpack_require__(2);
var Reflect = __webpack_require__(4).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(4).parseFloat;
var $trim = __webpack_require__(97).trim;

module.exports = 1 / $parseFloat(__webpack_require__(194) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(4).parseInt;
var $trim = __webpack_require__(97).trim;
var ws = __webpack_require__(194);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 284 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(2);
var isObject = __webpack_require__(7);
var newPromiseCapability = __webpack_require__(188);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 286 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(13);
var repeat = __webpack_require__(193);
var defined = __webpack_require__(47);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(43);
var toLength = __webpack_require__(13);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(12);


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(264);
var validate = __webpack_require__(86);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(134)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(189);
__webpack_require__(0)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(14) && /./g.flags != 'g') __webpack_require__(15).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(114)
});


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(264);
var validate = __webpack_require__(86);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(134)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(4);
var each = __webpack_require__(46)(0);
var redefine = __webpack_require__(31);
var meta = __webpack_require__(66);
var assign = __webpack_require__(276);
var weak = __webpack_require__(266);
var isObject = __webpack_require__(7);
var validate = __webpack_require__(86);
var NATIVE_WEAK_MAP = __webpack_require__(86);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(134)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(11);

// -- Inlined from fbjs --

var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function _invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

var warning = function(){};

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

// /-- Inlined from fbjs --

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(50);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.readState = exports.saveState = undefined;

var _warning = __webpack_require__(70);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuotaExceededErrors = {
  QuotaExceededError: true,
  QUOTA_EXCEEDED_ERR: true
};

var SecurityErrors = {
  SecurityError: true
};

var KeyPrefix = '@@History/';

var createKey = function createKey(key) {
  return KeyPrefix + key;
};

var saveState = exports.saveState = function saveState(key, state) {
  if (!window.sessionStorage) {
    // Session storage is not available or hidden.
    // sessionStorage is undefined in Internet Explorer when served via file protocol.
     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;

    return;
  }

  try {
    if (state == null) {
      window.sessionStorage.removeItem(createKey(key));
    } else {
      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
    }
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;

      return;
    }

    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
      // Safari "private mode" throws QuotaExceededError.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;

      return;
    }

    throw error;
  }
};

var readState = exports.readState = function readState(key) {
  var json = void 0;
  try {
    json = window.sessionStorage.getItem(createKey(key));
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;

      return undefined;
    }
  }

  if (json) {
    try {
      return JSON.parse(json);
    } catch (error) {
      // Ignore invalid JSON.
    }
  }

  return undefined;
};

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _runTransitionHook = __webpack_require__(204);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _PathUtils = __webpack_require__(67);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useBasename = function useBasename(createHistory) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var history = createHistory(options);
    var basename = options.basename;


    var addBasename = function addBasename(location) {
      if (!location) return location;

      if (basename && location.basename == null) {
        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
          location.pathname = location.pathname.substring(basename.length);
          location.basename = basename;

          if (location.pathname === '') location.pathname = '/';
        } else {
          location.basename = '';
        }
      }

      return location;
    };

    var prependBasename = function prependBasename(location) {
      if (!basename) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var pname = object.pathname;
      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
      var pathname = normalizedBasename + normalizedPathname;

      return _extends({}, object, {
        pathname: pathname
      });
    };

    // Override all read methods with basename-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return addBasename(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(addBasename(location));
      });
    };

    // Override all write methods with basename-aware versions.
    var push = function push(location) {
      return history.push(prependBasename(location));
    };

    var replace = function replace(location) {
      return history.replace(prependBasename(location));
    };

    var createPath = function createPath(location) {
      return history.createPath(prependBasename(location));
    };

    var createHref = function createHref(location) {
      return history.createHref(prependBasename(location));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useBasename;

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _queryString = __webpack_require__(703);

var _runTransitionHook = __webpack_require__(204);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _LocationUtils = __webpack_require__(98);

var _PathUtils = __webpack_require__(67);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStringifyQuery = function defaultStringifyQuery(query) {
  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
};

var defaultParseQueryString = _queryString.parse;

/**
 * Returns a new createHistory function that may be used to create
 * history objects that know how to handle URL queries.
 */
var useQueries = function useQueries(createHistory) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var history = createHistory(options);
    var stringifyQuery = options.stringifyQuery,
        parseQueryString = options.parseQueryString;


    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;

    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;

    var decodeQuery = function decodeQuery(location) {
      if (!location) return location;

      if (location.query == null) location.query = parseQueryString(location.search.substring(1));

      return location;
    };

    var encodeQuery = function encodeQuery(location, query) {
      if (query == null) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var queryString = stringifyQuery(query);
      var search = queryString ? '?' + queryString : '';

      return _extends({}, object, {
        search: search
      });
    };

    // Override all read methods with query-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return decodeQuery(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(decodeQuery(location));
      });
    };

    // Override all write methods with query-aware versions.
    var push = function push(location) {
      return history.push(encodeQuery(location, location.query));
    };

    var replace = function replace(location) {
      return history.replace(encodeQuery(location, location.query));
    };

    var createPath = function createPath(location) {
      return history.createPath(encodeQuery(location, location.query));
    };

    var createHref = function createHref(location) {
      return history.createHref(encodeQuery(location, location.query));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));

      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);

      return decodeQuery(newLocation);
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useQueries;

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(700);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

(function(f) {
  if (true) {
    module.exports = f(__webpack_require__(1));
    /* global define */
  } else if (typeof define === 'function' && define.amd) {
    define(['react'], f);
  } else {
    var g;
    if (typeof window !== 'undefined') {
      g = window;
    } else if (typeof global !== 'undefined') {
      g = global;
    } else if (typeof self !== 'undefined') {
      g = self;
    } else {
      g = this;
    }

    if (typeof g.React === 'undefined') {
      throw Error('React module should be required before ReactDOMFactories');
    }

    g.ReactDOMFactories = f(g.React);
  }
})(function(React) {
  /**
   * Create a factory that creates HTML tag elements.
   */
  function createDOMFactory(type) {
    var factory = React.createElement.bind(null, type);
    // Expose the type on the factory and the prototype so that it can be
    // easily accessed on elements. E.g. `<Foo />.type === Foo`.
    // This should not be named `constructor` since this may not be the function
    // that created the element, and it may not even be a constructor.
    factory.type = type;
    return factory;
  };

  /**
   * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
   */
  var ReactDOMFactories = {
    a: createDOMFactory('a'),
    abbr: createDOMFactory('abbr'),
    address: createDOMFactory('address'),
    area: createDOMFactory('area'),
    article: createDOMFactory('article'),
    aside: createDOMFactory('aside'),
    audio: createDOMFactory('audio'),
    b: createDOMFactory('b'),
    base: createDOMFactory('base'),
    bdi: createDOMFactory('bdi'),
    bdo: createDOMFactory('bdo'),
    big: createDOMFactory('big'),
    blockquote: createDOMFactory('blockquote'),
    body: createDOMFactory('body'),
    br: createDOMFactory('br'),
    button: createDOMFactory('button'),
    canvas: createDOMFactory('canvas'),
    caption: createDOMFactory('caption'),
    cite: createDOMFactory('cite'),
    code: createDOMFactory('code'),
    col: createDOMFactory('col'),
    colgroup: createDOMFactory('colgroup'),
    data: createDOMFactory('data'),
    datalist: createDOMFactory('datalist'),
    dd: createDOMFactory('dd'),
    del: createDOMFactory('del'),
    details: createDOMFactory('details'),
    dfn: createDOMFactory('dfn'),
    dialog: createDOMFactory('dialog'),
    div: createDOMFactory('div'),
    dl: createDOMFactory('dl'),
    dt: createDOMFactory('dt'),
    em: createDOMFactory('em'),
    embed: createDOMFactory('embed'),
    fieldset: createDOMFactory('fieldset'),
    figcaption: createDOMFactory('figcaption'),
    figure: createDOMFactory('figure'),
    footer: createDOMFactory('footer'),
    form: createDOMFactory('form'),
    h1: createDOMFactory('h1'),
    h2: createDOMFactory('h2'),
    h3: createDOMFactory('h3'),
    h4: createDOMFactory('h4'),
    h5: createDOMFactory('h5'),
    h6: createDOMFactory('h6'),
    head: createDOMFactory('head'),
    header: createDOMFactory('header'),
    hgroup: createDOMFactory('hgroup'),
    hr: createDOMFactory('hr'),
    html: createDOMFactory('html'),
    i: createDOMFactory('i'),
    iframe: createDOMFactory('iframe'),
    img: createDOMFactory('img'),
    input: createDOMFactory('input'),
    ins: createDOMFactory('ins'),
    kbd: createDOMFactory('kbd'),
    keygen: createDOMFactory('keygen'),
    label: createDOMFactory('label'),
    legend: createDOMFactory('legend'),
    li: createDOMFactory('li'),
    link: createDOMFactory('link'),
    main: createDOMFactory('main'),
    map: createDOMFactory('map'),
    mark: createDOMFactory('mark'),
    menu: createDOMFactory('menu'),
    menuitem: createDOMFactory('menuitem'),
    meta: createDOMFactory('meta'),
    meter: createDOMFactory('meter'),
    nav: createDOMFactory('nav'),
    noscript: createDOMFactory('noscript'),
    object: createDOMFactory('object'),
    ol: createDOMFactory('ol'),
    optgroup: createDOMFactory('optgroup'),
    option: createDOMFactory('option'),
    output: createDOMFactory('output'),
    p: createDOMFactory('p'),
    param: createDOMFactory('param'),
    picture: createDOMFactory('picture'),
    pre: createDOMFactory('pre'),
    progress: createDOMFactory('progress'),
    q: createDOMFactory('q'),
    rp: createDOMFactory('rp'),
    rt: createDOMFactory('rt'),
    ruby: createDOMFactory('ruby'),
    s: createDOMFactory('s'),
    samp: createDOMFactory('samp'),
    script: createDOMFactory('script'),
    section: createDOMFactory('section'),
    select: createDOMFactory('select'),
    small: createDOMFactory('small'),
    source: createDOMFactory('source'),
    span: createDOMFactory('span'),
    strong: createDOMFactory('strong'),
    style: createDOMFactory('style'),
    sub: createDOMFactory('sub'),
    summary: createDOMFactory('summary'),
    sup: createDOMFactory('sup'),
    table: createDOMFactory('table'),
    tbody: createDOMFactory('tbody'),
    td: createDOMFactory('td'),
    textarea: createDOMFactory('textarea'),
    tfoot: createDOMFactory('tfoot'),
    th: createDOMFactory('th'),
    thead: createDOMFactory('thead'),
    time: createDOMFactory('time'),
    title: createDOMFactory('title'),
    tr: createDOMFactory('tr'),
    track: createDOMFactory('track'),
    u: createDOMFactory('u'),
    ul: createDOMFactory('ul'),
    var: createDOMFactory('var'),
    video: createDOMFactory('video'),
    wbr: createDOMFactory('wbr'),

    // SVG
    circle: createDOMFactory('circle'),
    clipPath: createDOMFactory('clipPath'),
    defs: createDOMFactory('defs'),
    ellipse: createDOMFactory('ellipse'),
    g: createDOMFactory('g'),
    image: createDOMFactory('image'),
    line: createDOMFactory('line'),
    linearGradient: createDOMFactory('linearGradient'),
    mask: createDOMFactory('mask'),
    path: createDOMFactory('path'),
    pattern: createDOMFactory('pattern'),
    polygon: createDOMFactory('polygon'),
    polyline: createDOMFactory('polyline'),
    radialGradient: createDOMFactory('radialGradient'),
    rect: createDOMFactory('rect'),
    stop: createDOMFactory('stop'),
    svg: createDOMFactory('svg'),
    text: createDOMFactory('text'),
    tspan: createDOMFactory('tspan'),
  };

  // due to wrapper and conditionals at the top, this will either become
  // `module.exports ReactDOMFactories` if that is available,
  // otherwise it will be defined via `define(['react'], ReactDOMFactories)`
  // if that is available,
  // otherwise it will be defined as global variable.
  return ReactDOMFactories;
});



/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * CSS properties which accept numbers but are not in units of "px".
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */
function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

module.exports = CSSProperty;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(9);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PooledClass = __webpack_require__(88);

var invariant = __webpack_require__(3);

/**
 * A specialized pseudo-event module to help keep track of components waiting to
 * be notified when their DOM representations are available for use.
 *
 * This implements `PooledClass`, so you should never need to instantiate this.
 * Instead, use `CallbackQueue.getPooled()`.
 *
 * @class ReactMountReady
 * @implements PooledClass
 * @internal
 */

var CallbackQueue = function () {
  function CallbackQueue(arg) {
    _classCallCheck(this, CallbackQueue);

    this._callbacks = null;
    this._contexts = null;
    this._arg = arg;
  }

  /**
   * Enqueues a callback to be invoked when `notifyAll` is invoked.
   *
   * @param {function} callback Invoked when `notifyAll` is invoked.
   * @param {?object} context Context to call `callback` with.
   * @internal
   */


  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
    this._callbacks = this._callbacks || [];
    this._callbacks.push(callback);
    this._contexts = this._contexts || [];
    this._contexts.push(context);
  };

  /**
   * Invokes all enqueued callbacks and clears the queue. This is invoked after
   * the DOM representation of a component has been created or updated.
   *
   * @internal
   */


  CallbackQueue.prototype.notifyAll = function notifyAll() {
    var callbacks = this._callbacks;
    var contexts = this._contexts;
    var arg = this._arg;
    if (callbacks && contexts) {
      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
      this._callbacks = null;
      this._contexts = null;
      for (var i = 0; i < callbacks.length; i++) {
        callbacks[i].call(contexts[i], arg);
      }
      callbacks.length = 0;
      contexts.length = 0;
    }
  };

  CallbackQueue.prototype.checkpoint = function checkpoint() {
    return this._callbacks ? this._callbacks.length : 0;
  };

  CallbackQueue.prototype.rollback = function rollback(len) {
    if (this._callbacks && this._contexts) {
      this._callbacks.length = len;
      this._contexts.length = len;
    }
  };

  /**
   * Resets the internal queue.
   *
   * @internal
   */


  CallbackQueue.prototype.reset = function reset() {
    this._callbacks = null;
    this._contexts = null;
  };

  /**
   * `PooledClass` looks for this.
   */


  CallbackQueue.prototype.destructor = function destructor() {
    this.reset();
  };

  return CallbackQueue;
}();

module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMProperty = __webpack_require__(100);
var ReactDOMComponentTree = __webpack_require__(17);
var ReactInstrumentation = __webpack_require__(38);

var quoteAttributeValueForBrowser = __webpack_require__(764);
var warning = __webpack_require__(10);

var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
var illegalAttributeNameCache = {};
var validatedAttributeNameCache = {};

function isAttributeNameSafe(attributeName) {
  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
    return true;
  }
  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
    return false;
  }
  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
    validatedAttributeNameCache[attributeName] = true;
    return true;
  }
  illegalAttributeNameCache[attributeName] = true;
   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
  return false;
}

function shouldIgnoreValue(propertyInfo, value) {
  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
}

/**
 * Operations for dealing with DOM properties.
 */
var DOMPropertyOperations = {
  /**
   * Creates markup for the ID property.
   *
   * @param {string} id Unescaped ID.
   * @return {string} Markup string.
   */
  createMarkupForID: function (id) {
    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
  },

  setAttributeForID: function (node, id) {
    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
  },

  createMarkupForRoot: function () {
    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
  },

  setAttributeForRoot: function (node) {
    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
  },

  /**
   * Creates markup for a property.
   *
   * @param {string} name
   * @param {*} value
   * @return {?string} Markup string, or null if the property was invalid.
   */
  createMarkupForProperty: function (name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      if (shouldIgnoreValue(propertyInfo, value)) {
        return '';
      }
      var attributeName = propertyInfo.attributeName;
      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
        return attributeName + '=""';
      }
      return attributeName + '=' + quoteAttributeValueForBrowser(value);
    } else if (DOMProperty.isCustomAttribute(name)) {
      if (value == null) {
        return '';
      }
      return name + '=' + quoteAttributeValueForBrowser(value);
    }
    return null;
  },

  /**
   * Creates markup for a custom property.
   *
   * @param {string} name
   * @param {*} value
   * @return {string} Markup string, or empty string if the property was invalid.
   */
  createMarkupForCustomAttribute: function (name, value) {
    if (!isAttributeNameSafe(name) || value == null) {
      return '';
    }
    return name + '=' + quoteAttributeValueForBrowser(value);
  },

  /**
   * Sets the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   * @param {*} value
   */
  setValueForProperty: function (node, name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, value);
      } else if (shouldIgnoreValue(propertyInfo, value)) {
        this.deleteValueForProperty(node, name);
        return;
      } else if (propertyInfo.mustUseProperty) {
        // Contrary to `setAttribute`, object properties are properly
        // `toString`ed by IE8/9.
        node[propertyInfo.propertyName] = value;
      } else {
        var attributeName = propertyInfo.attributeName;
        var namespace = propertyInfo.attributeNamespace;
        // `setAttribute` with objects becomes only `[object]` in IE8/9,
        // ('' + value) makes it output the correct toString()-value.
        if (namespace) {
          node.setAttributeNS(namespace, attributeName, '' + value);
        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
          node.setAttribute(attributeName, '');
        } else {
          node.setAttribute(attributeName, '' + value);
        }
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      DOMPropertyOperations.setValueForAttribute(node, name, value);
      return;
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  setValueForAttribute: function (node, name, value) {
    if (!isAttributeNameSafe(name)) {
      return;
    }
    if (value == null) {
      node.removeAttribute(name);
    } else {
      node.setAttribute(name, '' + value);
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  /**
   * Deletes an attributes from a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForAttribute: function (node, name) {
    node.removeAttribute(name);
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  },

  /**
   * Deletes the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForProperty: function (node, name) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, undefined);
      } else if (propertyInfo.mustUseProperty) {
        var propName = propertyInfo.propertyName;
        if (propertyInfo.hasBooleanValue) {
          node[propName] = false;
        } else {
          node[propName] = '';
        }
      } else {
        node.removeAttribute(propertyInfo.attributeName);
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      node.removeAttribute(name);
    }

    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  }
};

module.exports = DOMPropertyOperations;

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMComponentFlags = {
  hasCachedChildNodes: 1 << 0
};

module.exports = ReactDOMComponentFlags;

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var validateDOMNesting = __webpack_require__(221);

var DOC_NODE_TYPE = 9;

function ReactDOMContainerInfo(topLevelWrapper, node) {
  var info = {
    _topLevelWrapper: topLevelWrapper,
    _idCounter: 1,
    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
    _node: node,
    _tag: node ? node.nodeName.toLowerCase() : null,
    _namespaceURI: node ? node.namespaceURI : null
  };
  if (false) {
    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
  }
  return info;
}

module.exports = ReactDOMContainerInfo;

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(11);

var LinkedValueUtils = __webpack_require__(210);
var ReactDOMComponentTree = __webpack_require__(17);
var ReactUpdates = __webpack_require__(45);

var warning = __webpack_require__(10);

var didWarnValueLink = false;
var didWarnValueDefaultValue = false;

function updateOptionsIfPendingUpdateAndMounted() {
  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
    this._wrapperState.pendingUpdate = false;

    var props = this._currentElement.props;
    var value = LinkedValueUtils.getValue(props);

    if (value != null) {
      updateOptions(this, Boolean(props.multiple), value);
    }
  }
}

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

var valuePropNames = ['value', 'defaultValue'];

/**
 * Validation function for `value` and `defaultValue`.
 * @private
 */
function checkSelectPropTypes(inst, props) {
  var owner = inst._currentElement._owner;
  LinkedValueUtils.checkPropTypes('select', props, owner);

  if (props.valueLink !== undefined && !didWarnValueLink) {
     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
    didWarnValueLink = true;
  }

  for (var i = 0; i < valuePropNames.length; i++) {
    var propName = valuePropNames[i];
    if (props[propName] == null) {
      continue;
    }
    var isArray = Array.isArray(props[propName]);
    if (props.multiple && !isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    } else if (!props.multiple && isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    }
  }
}

/**
 * @param {ReactDOMComponent} inst
 * @param {boolean} multiple
 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
 * @private
 */
function updateOptions(inst, multiple, propValue) {
  var selectedValue, i;
  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;

  if (multiple) {
    selectedValue = {};
    for (i = 0; i < propValue.length; i++) {
      selectedValue['' + propValue[i]] = true;
    }
    for (i = 0; i < options.length; i++) {
      var selected = selectedValue.hasOwnProperty(options[i].value);
      if (options[i].selected !== selected) {
        options[i].selected = selected;
      }
    }
  } else {
    // Do not set `select.value` as exact behavior isn't consistent across all
    // browsers for all cases.
    selectedValue = '' + propValue;
    for (i = 0; i < options.length; i++) {
      if (options[i].value === selectedValue) {
        options[i].selected = true;
        return;
      }
    }
    if (options.length) {
      options[0].selected = true;
    }
  }
}

/**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */
var ReactDOMSelect = {
  getHostProps: function (inst, props) {
    return _assign({}, props, {
      onChange: inst._wrapperState.onChange,
      value: undefined
    });
  },

  mountWrapper: function (inst, props) {
    if (false) {
      checkSelectPropTypes(inst, props);
    }

    var value = LinkedValueUtils.getValue(props);
    inst._wrapperState = {
      pendingUpdate: false,
      initialValue: value != null ? value : props.defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      wasMultiple: Boolean(props.multiple)
    };

    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
      didWarnValueDefaultValue = true;
    }
  },

  getSelectValueContext: function (inst) {
    // ReactDOMOption looks at this initial value so the initial generated
    // markup has correct `selected` attributes
    return inst._wrapperState.initialValue;
  },

  postUpdateWrapper: function (inst) {
    var props = inst._currentElement.props;

    // After the initial mount, we control selected-ness manually so don't pass
    // this value down
    inst._wrapperState.initialValue = undefined;

    var wasMultiple = inst._wrapperState.wasMultiple;
    inst._wrapperState.wasMultiple = Boolean(props.multiple);

    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      inst._wrapperState.pendingUpdate = false;
      updateOptions(inst, Boolean(props.multiple), value);
    } else if (wasMultiple !== Boolean(props.multiple)) {
      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
      if (props.defaultValue != null) {
        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
      } else {
        // Revert the select back to its default unselected state.
        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
      }
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  if (this._rootNodeID) {
    this._wrapperState.pendingUpdate = true;
  }
  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
  return returnValue;
}

module.exports = ReactDOMSelect;

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(11);

var ReactUpdates = __webpack_require__(45);
var Transaction = __webpack_require__(153);

var emptyFunction = __webpack_require__(50);

var RESET_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: function () {
    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
  }
};

var FLUSH_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
};

var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];

function ReactDefaultBatchingStrategyTransaction() {
  this.reinitializeTransaction();
}

_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  }
});

var transaction = new ReactDefaultBatchingStrategyTransaction();

var ReactDefaultBatchingStrategy = {
  isBatchingUpdates: false,

  /**
   * Call the provided function in a context within which calls to `setState`
   * and friends are batched such that components aren't updated unnecessarily.
   */
  batchedUpdates: function (callback, a, b, c, d, e) {
    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;

    ReactDefaultBatchingStrategy.isBatchingUpdates = true;

    // The code is written this way to avoid extra allocations
    if (alreadyBatchingUpdates) {
      return callback(a, b, c, d, e);
    } else {
      return transaction.perform(callback, null, a, b, c, d, e);
    }
  }
};

module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ARIADOMPropertyConfig = __webpack_require__(706);
var BeforeInputEventPlugin = __webpack_require__(708);
var ChangeEventPlugin = __webpack_require__(710);
var DefaultEventPluginOrder = __webpack_require__(712);
var EnterLeaveEventPlugin = __webpack_require__(713);
var HTMLDOMPropertyConfig = __webpack_require__(715);
var ReactComponentBrowserEnvironment = __webpack_require__(717);
var ReactDOMComponent = __webpack_require__(720);
var ReactDOMComponentTree = __webpack_require__(17);
var ReactDOMEmptyComponent = __webpack_require__(721);
var ReactDOMTreeTraversal = __webpack_require__(730);
var ReactDOMTextComponent = __webpack_require__(728);
var ReactDefaultBatchingStrategy = __webpack_require__(311);
var ReactEventListener = __webpack_require__(733);
var ReactInjection = __webpack_require__(734);
var ReactReconcileTransaction = __webpack_require__(738);
var SVGDOMPropertyConfig = __webpack_require__(743);
var SelectEventPlugin = __webpack_require__(744);
var SimpleEventPlugin = __webpack_require__(745);

var alreadyInjected = false;

function inject() {
  if (alreadyInjected) {
    // TODO: This is currently true because these injections are shared between
    // the client and the server package. They should be built independently
    // and not share any injection state. Then this problem will be solved.
    return;
  }
  alreadyInjected = true;

  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);

  /**
   * Inject modules for resolving DOM hierarchy and plugin ordering.
   */
  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);

  /**
   * Some important event plugins included by default (without having to require
   * them).
   */
  ReactInjection.EventPluginHub.injectEventPluginsByName({
    SimpleEventPlugin: SimpleEventPlugin,
    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
    ChangeEventPlugin: ChangeEventPlugin,
    SelectEventPlugin: SelectEventPlugin,
    BeforeInputEventPlugin: BeforeInputEventPlugin
  });

  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);

  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);

  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);

  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
    return new ReactDOMEmptyComponent(instantiate);
  });

  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);

  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
}

module.exports = {
  inject: inject
};

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyComponentFactory;

var ReactEmptyComponentInjection = {
  injectEmptyComponentFactory: function (factory) {
    emptyComponentFactory = factory;
  }
};

var ReactEmptyComponent = {
  create: function (instantiate) {
    return emptyComponentFactory(instantiate);
  }
};

ReactEmptyComponent.injection = ReactEmptyComponentInjection;

module.exports = ReactEmptyComponent;

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ReactFeatureFlags = {
  // When true, call console.time() before and .timeEnd() after each top-level
  // render (both initial renders and updates). Useful when looking at prod-mode
  // timeline profiles in Chrome, for example.
  logTopLevelRenders: false
};

module.exports = ReactFeatureFlags;

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(9);

var invariant = __webpack_require__(3);

var genericComponentClass = null;
var textComponentClass = null;

var ReactHostComponentInjection = {
  // This accepts a class that receives the tag string. This is a catch all
  // that can render any kind of tag.
  injectGenericComponentClass: function (componentClass) {
    genericComponentClass = componentClass;
  },
  // This accepts a text component class that takes the text string to be
  // rendered as props.
  injectTextComponentClass: function (componentClass) {
    textComponentClass = componentClass;
  }
};

/**
 * Get a host internal component class for a specific tag.
 *
 * @param {ReactElement} element The element to create.
 * @return {function} The internal class constructor function.
 */
function createInternalComponent(element) {
  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
  return new genericComponentClass(element);
}

/**
 * @param {ReactText} text
 * @return {ReactComponent}
 */
function createInstanceForText(text) {
  return new textComponentClass(text);
}

/**
 * @param {ReactComponent} component
 * @return {boolean}
 */
function isTextComponent(component) {
  return component instanceof textComponentClass;
}

var ReactHostComponent = {
  createInternalComponent: createInternalComponent,
  createInstanceForText: createInstanceForText,
  isTextComponent: isTextComponent,
  injection: ReactHostComponentInjection
};

module.exports = ReactHostComponent;

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMSelection = __webpack_require__(726);

var containsNode = __webpack_require__(677);
var focusNode = __webpack_require__(297);
var getActiveElement = __webpack_require__(298);

function isInDocument(node) {
  return containsNode(document.documentElement, node);
}

/**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */
var ReactInputSelection = {
  hasSelectionCapabilities: function (elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
  },

  getSelectionInformation: function () {
    var focusedElem = getActiveElement();
    return {
      focusedElem: focusedElem,
      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
    };
  },

  /**
   * @restoreSelection: If any selection information was potentially lost,
   * restore it. This is useful when performing operations that could remove dom
   * nodes and place them back in, resulting in focus being lost.
   */
  restoreSelection: function (priorSelectionInformation) {
    var curFocusedElem = getActiveElement();
    var priorFocusedElem = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
      }
      focusNode(priorFocusedElem);
    }
  },

  /**
   * @getSelection: Gets the selection bounds of a focused textarea, input or
   * contentEditable node.
   * -@input: Look up selection bounds of this input
   * -@return {start: selectionStart, end: selectionEnd}
   */
  getSelection: function (input) {
    var selection;

    if ('selectionStart' in input) {
      // Modern browser with input or textarea.
      selection = {
        start: input.selectionStart,
        end: input.selectionEnd
      };
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      // IE8 input.
      var range = document.selection.createRange();
      // There can only be one selection per document in IE, so it must
      // be in our element.
      if (range.parentElement() === input) {
        selection = {
          start: -range.moveStart('character', -input.value.length),
          end: -range.moveEnd('character', -input.value.length)
        };
      }
    } else {
      // Content editable or old IE textarea.
      selection = ReactDOMSelection.getOffsets(input);
    }

    return selection || { start: 0, end: 0 };
  },

  /**
   * @setSelection: Sets the selection bounds of a textarea or input and focuses
   * the input.
   * -@input     Set selection bounds of this input or textarea
   * -@offsets   Object of same form that is returned from get*
   */
  setSelection: function (input, offsets) {
    var start = offsets.start;
    var end = offsets.end;
    if (end === undefined) {
      end = start;
    }

    if ('selectionStart' in input) {
      input.selectionStart = start;
      input.selectionEnd = Math.min(end, input.value.length);
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveStart('character', start);
      range.moveEnd('character', end - start);
      range.select();
    } else {
      ReactDOMSelection.setOffsets(input, offsets);
    }
  }
};

module.exports = ReactInputSelection;

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var adler32 = __webpack_require__(756);

var TAG_END = /\/?>/;
var COMMENT_START = /^<\!\-\-/;

var ReactMarkupChecksum = {
  CHECKSUM_ATTR_NAME: 'data-react-checksum',

  /**
   * @param {string} markup Markup string
   * @return {string} Markup string with checksum attribute attached
   */
  addChecksumToMarkup: function (markup) {
    var checksum = adler32(markup);

    // Add checksum (handle both parent tags, comments and self-closing tags)
    if (COMMENT_START.test(markup)) {
      return markup;
    } else {
      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
    }
  },

  /**
   * @param {string} markup to use
   * @param {DOMElement} element root React element
   * @returns {boolean} whether or not the markup is the same
   */
  canReuseMarkup: function (markup, element) {
    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
    var markupChecksum = adler32(markup);
    return markupChecksum === existingChecksum;
  }
};

module.exports = ReactMarkupChecksum;

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(9);

var DOMLazyTree = __webpack_require__(99);
var DOMProperty = __webpack_require__(100);
var React = __webpack_require__(90);
var ReactBrowserEventEmitter = __webpack_require__(151);
var ReactCurrentOwner = __webpack_require__(57);
var ReactDOMComponentTree = __webpack_require__(17);
var ReactDOMContainerInfo = __webpack_require__(309);
var ReactDOMFeatureFlags = __webpack_require__(722);
var ReactFeatureFlags = __webpack_require__(314);
var ReactInstanceMap = __webpack_require__(121);
var ReactInstrumentation = __webpack_require__(38);
var ReactMarkupChecksum = __webpack_require__(317);
var ReactReconciler = __webpack_require__(89);
var ReactUpdateQueue = __webpack_require__(213);
var ReactUpdates = __webpack_require__(45);

var emptyObject = __webpack_require__(147);
var instantiateReactComponent = __webpack_require__(218);
var invariant = __webpack_require__(3);
var setInnerHTML = __webpack_require__(155);
var shouldUpdateReactComponent = __webpack_require__(220);
var warning = __webpack_require__(10);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;

var ELEMENT_NODE_TYPE = 1;
var DOC_NODE_TYPE = 9;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

var instancesByReactRootID = {};

/**
 * Finds the index of the first character
 * that's not common between the two given strings.
 *
 * @return {number} the index of the character where the strings diverge
 */
function firstDifferenceIndex(string1, string2) {
  var minLen = Math.min(string1.length, string2.length);
  for (var i = 0; i < minLen; i++) {
    if (string1.charAt(i) !== string2.charAt(i)) {
      return i;
    }
  }
  return string1.length === string2.length ? -1 : minLen;
}

/**
 * @param {DOMElement|DOMDocument} container DOM element that may contain
 * a React component
 * @return {?*} DOM element that may have the reactRoot ID, or null.
 */
function getReactRootElementInContainer(container) {
  if (!container) {
    return null;
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    return container.documentElement;
  } else {
    return container.firstChild;
  }
}

function internalGetID(node) {
  // If node is something like a window, document, or text node, none of
  // which support attributes or a .getAttribute method, gracefully return
  // the empty string, as if the attribute were missing.
  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
}

/**
 * Mounts this component and inserts it into the DOM.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {ReactReconcileTransaction} transaction
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
  var markerName;
  if (ReactFeatureFlags.logTopLevelRenders) {
    var wrappedElement = wrapperInstance._currentElement.props.child;
    var type = wrappedElement.type;
    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
    console.time(markerName);
  }

  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
  );

  if (markerName) {
    console.timeEnd(markerName);
  }

  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
}

/**
 * Batched mount.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */
  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
  ReactUpdates.ReactReconcileTransaction.release(transaction);
}

/**
 * Unmounts a component and removes it from the DOM.
 *
 * @param {ReactComponent} instance React component instance.
 * @param {DOMElement} container DOM element to unmount from.
 * @final
 * @internal
 * @see {ReactMount.unmountComponentAtNode}
 */
function unmountComponentFromNode(instance, container, safely) {
  if (false) {
    ReactInstrumentation.debugTool.onBeginFlush();
  }
  ReactReconciler.unmountComponent(instance, safely);
  if (false) {
    ReactInstrumentation.debugTool.onEndFlush();
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    container = container.documentElement;
  }

  // http://jsperf.com/emptying-a-node
  while (container.lastChild) {
    container.removeChild(container.lastChild);
  }
}

/**
 * True if the supplied DOM node has a direct React-rendered child that is
 * not a React root element. Useful for warning in `render`,
 * `unmountComponentAtNode`, etc.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM element contains a direct child that was
 * rendered by React but is not a root element.
 * @internal
 */
function hasNonRootReactChild(container) {
  var rootEl = getReactRootElementInContainer(container);
  if (rootEl) {
    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
    return !!(inst && inst._hostParent);
  }
}

/**
 * True if the supplied DOM node is a React DOM element and
 * it has been rendered by another copy of React.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM has been rendered by another copy of React
 * @internal
 */
function nodeIsRenderedByOtherInstance(container) {
  var rootEl = getReactRootElementInContainer(container);
  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
}

/**
 * True if the supplied DOM node is a valid node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid DOM node.
 * @internal
 */
function isValidContainer(node) {
  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
}

/**
 * True if the supplied DOM node is a valid React node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid React DOM node.
 * @internal
 */
function isReactNode(node) {
  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
}

function getHostRootInstanceInContainer(container) {
  var rootEl = getReactRootElementInContainer(container);
  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
}

function getTopLevelWrapperInContainer(container) {
  var root = getHostRootInstanceInContainer(container);
  return root ? root._hostContainerInfo._topLevelWrapper : null;
}

/**
 * Temporary (?) hack so that we can store all top-level pending updates on
 * composites instead of having to worry about different types of components
 * here.
 */
var topLevelRootCounter = 1;
var TopLevelWrapper = function () {
  this.rootID = topLevelRootCounter++;
};
TopLevelWrapper.prototype.isReactComponent = {};
if (false) {
  TopLevelWrapper.displayName = 'TopLevelWrapper';
}
TopLevelWrapper.prototype.render = function () {
  return this.props.child;
};
TopLevelWrapper.isReactTopLevelWrapper = true;

/**
 * Mounting is the process of initializing a React component by creating its
 * representative DOM elements and inserting them into a supplied `container`.
 * Any prior content inside `container` is destroyed in the process.
 *
 *   ReactMount.render(
 *     component,
 *     document.getElementById('container')
 *   );
 *
 *   <div id="container">                   <-- Supplied `container`.
 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
 *       // ...                                 component.
 *     </div>
 *   </div>
 *
 * Inside of `container`, the first element rendered is the "reactRoot".
 */
var ReactMount = {
  TopLevelWrapper: TopLevelWrapper,

  /**
   * Used by devtools. The keys are not important.
   */
  _instancesByReactRootID: instancesByReactRootID,

  /**
   * This is a hook provided to support rendering React components while
   * ensuring that the apparent scroll position of its `container` does not
   * change.
   *
   * @param {DOMElement} container The `container` being rendered into.
   * @param {function} renderCallback This must be called once to do the render.
   */
  scrollMonitor: function (container, renderCallback) {
    renderCallback();
  },

  /**
   * Take a component that's already mounted into the DOM and replace its props
   * @param {ReactComponent} prevComponent component instance already in the DOM
   * @param {ReactElement} nextElement component instance to render
   * @param {DOMElement} container container to render into
   * @param {?function} callback function triggered on completion
   */
  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
    ReactMount.scrollMonitor(container, function () {
      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
      if (callback) {
        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
      }
    });

    return prevComponent;
  },

  /**
   * Render a new component into the DOM. Hooked by hooks!
   *
   * @param {ReactElement} nextElement element to render
   * @param {DOMElement} container container to render into
   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
   * @return {ReactComponent} nextComponent
   */
  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case.
     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;

    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
    var componentInstance = instantiateReactComponent(nextElement, false);

    // The initial render is synchronous but any updates that happen during
    // rendering, in componentWillMount or componentDidMount, will be batched
    // according to the current batching strategy.

    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);

    var wrapperID = componentInstance._instance.rootID;
    instancesByReactRootID[wrapperID] = componentInstance;

    return componentInstance;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
  },

  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;

     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;

    var nextWrappedElement = React.createElement(TopLevelWrapper, {
      child: nextElement
    });

    var nextContext;
    if (parentComponent) {
      var parentInst = ReactInstanceMap.get(parentComponent);
      nextContext = parentInst._processChildContext(parentInst._context);
    } else {
      nextContext = emptyObject;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);

    if (prevComponent) {
      var prevWrappedElement = prevComponent._currentElement;
      var prevElement = prevWrappedElement.props.child;
      if (shouldUpdateReactComponent(prevElement, nextElement)) {
        var publicInst = prevComponent._renderedComponent.getPublicInstance();
        var updatedCallback = callback && function () {
          callback.call(publicInst);
        };
        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
        return publicInst;
      } else {
        ReactMount.unmountComponentAtNode(container);
      }
    }

    var reactRootElement = getReactRootElementInContainer(container);
    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
    var containerHasNonRootReactChild = hasNonRootReactChild(container);

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;

      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
        var rootElementSibling = reactRootElement;
        while (rootElementSibling) {
          if (internalGetID(rootElementSibling)) {
            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
            break;
          }
          rootElementSibling = rootElementSibling.nextSibling;
        }
      }
    }

    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
    if (callback) {
      callback.call(component);
    }
    return component;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  render: function (nextElement, container, callback) {
    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
  },

  /**
   * Unmounts and destroys the React component rendered in the `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
   *
   * @param {DOMElement} container DOM element containing a React component.
   * @return {boolean} True if a component was found in and unmounted from
   *                   `container`
   */
  unmountComponentAtNode: function (container) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case. (Strictly speaking, unmounting won't cause a
    // render but we still don't expect to be in a render call here.)
     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);
    if (!prevComponent) {
      // Check if the node being unmounted was rendered by React, but isn't a
      // root node.
      var containerHasNonRootReactChild = hasNonRootReactChild(container);

      // Check if the container itself is a React root node.
      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
      }

      return false;
    }
    delete instancesByReactRootID[prevComponent._instance.rootID];
    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
    return true;
  },

  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;

    if (shouldReuseMarkup) {
      var rootElement = getReactRootElementInContainer(container);
      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
        ReactDOMComponentTree.precacheNode(instance, rootElement);
        return;
      } else {
        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);

        var rootMarkup = rootElement.outerHTML;
        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);

        var normalizedMarkup = markup;
        if (false) {
          // because rootMarkup is retrieved from the DOM, various normalizations
          // will have occurred which will not be present in `markup`. Here,
          // insert markup into a <div> or <iframe> depending on the container
          // type to perform the same normalizations before comparing.
          var normalizer;
          if (container.nodeType === ELEMENT_NODE_TYPE) {
            normalizer = document.createElement('div');
            normalizer.innerHTML = markup;
            normalizedMarkup = normalizer.innerHTML;
          } else {
            normalizer = document.createElement('iframe');
            document.body.appendChild(normalizer);
            normalizer.contentDocument.write(markup);
            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
            document.body.removeChild(normalizer);
          }
        }

        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);

        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;

        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
        }
      }
    }

    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;

    if (transaction.useCreateElement) {
      while (container.lastChild) {
        container.removeChild(container.lastChild);
      }
      DOMLazyTree.insertTreeBefore(container, markup, null);
    } else {
      setInnerHTML(container, markup);
      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
    }

    if (false) {
      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
      if (hostNode._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: hostNode._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  }
};

module.exports = ReactMount;

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(9);

var React = __webpack_require__(90);

var invariant = __webpack_require__(3);

var ReactNodeTypes = {
  HOST: 0,
  COMPOSITE: 1,
  EMPTY: 2,

  getType: function (node) {
    if (node === null || node === false) {
      return ReactNodeTypes.EMPTY;
    } else if (React.isValidElement(node)) {
      if (typeof node.type === 'function') {
        return ReactNodeTypes.COMPOSITE;
      } else {
        return ReactNodeTypes.HOST;
      }
    }
     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
  }
};

module.exports = ReactNodeTypes;

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(11);

var PooledClass = __webpack_require__(88);
var Transaction = __webpack_require__(153);
var ReactInstrumentation = __webpack_require__(38);
var ReactServerUpdateQueue = __webpack_require__(742);

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

var noopCallbackQueue = {
  enqueue: function () {}
};

/**
 * @class ReactServerRenderingTransaction
 * @param {boolean} renderToStaticMarkup
 */
function ReactServerRenderingTransaction(renderToStaticMarkup) {
  this.reinitializeTransaction();
  this.renderToStaticMarkup = renderToStaticMarkup;
  this.useCreateElement = false;
  this.updateQueue = new ReactServerUpdateQueue(this);
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array} Empty list of operation wrap procedures.
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return noopCallbackQueue;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return this.updateQueue;
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {},

  checkpoint: function () {},

  rollback: function () {}
};

_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactServerRenderingTransaction);

module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.6.2';

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ViewportMetrics = {
  currentScrollLeft: 0,

  currentScrollTop: 0,

  refreshScrollValues: function (scrollPosition) {
    ViewportMetrics.currentScrollLeft = scrollPosition.x;
    ViewportMetrics.currentScrollTop = scrollPosition.y;
  }
};

module.exports = ViewportMetrics;

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(9);

var invariant = __webpack_require__(3);

/**
 * Accumulates items that must not be null or undefined into the first one. This
 * is used to conserve memory by avoiding array allocations, and thus sacrifices
 * API cleanness. Since `current` can be null before being passed in and not
 * null after this function, make sure to assign it back to `current`:
 *
 * `a = accumulateInto(a, b);`
 *
 * This API should be sparingly used. Try `accumulate` for something cleaner.
 *
 * @return {*|array<*>} An accumulation of items.
 */

function accumulateInto(current, next) {
  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;

  if (current == null) {
    return next;
  }

  // Both are not empty. Warning: Never call x.concat(y) when you are not
  // certain that x is an Array (x could be a string with concat method).
  if (Array.isArray(current)) {
    if (Array.isArray(next)) {
      current.push.apply(current, next);
      return current;
    }
    current.push(next);
    return current;
  }

  if (Array.isArray(next)) {
    // A bit too dangerous to mutate `next`.
    return [current].concat(next);
  }

  return [current, next];
}

module.exports = accumulateInto;

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * @param {array} arr an "accumulation" of items which is either an Array or
 * a single item. Useful when paired with the `accumulate` module. This is a
 * simple utility that allows us to reason about a collection of items, but
 * handling the case when there is exactly one item (and we do not need to
 * allocate an array).
 */

function forEachAccumulated(arr, cb, scope) {
  if (Array.isArray(arr)) {
    arr.forEach(cb, scope);
  } else if (arr) {
    cb.call(scope, arr);
  }
}

module.exports = forEachAccumulated;

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactNodeTypes = __webpack_require__(319);

function getHostComponentFromComposite(inst) {
  var type;

  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
    inst = inst._renderedComponent;
  }

  if (type === ReactNodeTypes.HOST) {
    return inst._renderedComponent;
  } else if (type === ReactNodeTypes.EMPTY) {
    return null;
  }
}

module.exports = getHostComponentFromComposite;

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(24);

var contentKey = null;

/**
 * Gets the key used to access text content on a DOM node.
 *
 * @return {?string} Key used to access text content.
 * @internal
 */
function getTextContentAccessor() {
  if (!contentKey && ExecutionEnvironment.canUseDOM) {
    // Prefer textContent to innerText because many browsers support both but
    // SVG <text> elements don't support innerText even when <div> does.
    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
  }
  return contentKey;
}

module.exports = getTextContentAccessor;

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMComponentTree = __webpack_require__(17);

function isCheckable(elem) {
  var type = elem.type;
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
}

function getTracker(inst) {
  return inst._wrapperState.valueTracker;
}

function attachTracker(inst, tracker) {
  inst._wrapperState.valueTracker = tracker;
}

function detachTracker(inst) {
  inst._wrapperState.valueTracker = null;
}

function getValueFromNode(node) {
  var value;
  if (node) {
    value = isCheckable(node) ? '' + node.checked : node.value;
  }
  return value;
}

var inputValueTracking = {
  // exposed for testing
  _getTrackerFromNode: function (node) {
    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
  },


  track: function (inst) {
    if (getTracker(inst)) {
      return;
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var valueField = isCheckable(node) ? 'checked' : 'value';
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);

    var currentValue = '' + node[valueField];

    // if someone has already defined a value or Safari, then bail
    // and don't track value will cause over reporting of changes,
    // but it's better then a hard failure
    // (needed for certain tests that spyOn input values and Safari)
    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
      return;
    }

    Object.defineProperty(node, valueField, {
      enumerable: descriptor.enumerable,
      configurable: true,
      get: function () {
        return descriptor.get.call(this);
      },
      set: function (value) {
        currentValue = '' + value;
        descriptor.set.call(this, value);
      }
    });

    attachTracker(inst, {
      getValue: function () {
        return currentValue;
      },
      setValue: function (value) {
        currentValue = '' + value;
      },
      stopTracking: function () {
        detachTracker(inst);
        delete node[valueField];
      }
    });
  },

  updateValueIfChanged: function (inst) {
    if (!inst) {
      return false;
    }
    var tracker = getTracker(inst);

    if (!tracker) {
      inputValueTracking.track(inst);
      return true;
    }

    var lastValue = tracker.getValue();
    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));

    if (nextValue !== lastValue) {
      tracker.setValue(nextValue);
      return true;
    }

    return false;
  },
  stopTracking: function (inst) {
    var tracker = getTracker(inst);
    if (tracker) {
      tracker.stopTracking();
    }
  }
};

module.exports = inputValueTracking;

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */

var supportedInputTypes = {
  color: true,
  date: true,
  datetime: true,
  'datetime-local': true,
  email: true,
  month: true,
  number: true,
  password: true,
  range: true,
  search: true,
  tel: true,
  text: true,
  time: true,
  url: true,
  week: true
};

function isTextInputElement(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

  if (nodeName === 'input') {
    return !!supportedInputTypes[elem.type];
  }

  if (nodeName === 'textarea') {
    return true;
  }

  return false;
}

module.exports = isTextInputElement;

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(24);
var escapeTextContentForBrowser = __webpack_require__(154);
var setInnerHTML = __webpack_require__(155);

/**
 * Set the textContent property of a node, ensuring that whitespace is preserved
 * even in IE8. innerText is a poor substitute for textContent and, among many
 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
 * as it should.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */
var setTextContent = function (node, text) {
  if (text) {
    var firstChild = node.firstChild;

    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
      firstChild.nodeValue = text;
      return;
    }
  }
  node.textContent = text;
};

if (ExecutionEnvironment.canUseDOM) {
  if (!('textContent' in document.documentElement)) {
    setTextContent = function (node, text) {
      if (node.nodeType === 3) {
        node.nodeValue = text;
        return;
      }
      setInnerHTML(node, escapeTextContentForBrowser(text));
    };
  }
}

module.exports = setTextContent;

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(9);

var ReactCurrentOwner = __webpack_require__(57);
var REACT_ELEMENT_TYPE = __webpack_require__(731);

var getIteratorFn = __webpack_require__(761);
var invariant = __webpack_require__(3);
var KeyEscapeUtils = __webpack_require__(209);
var warning = __webpack_require__(10);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _extends2 = __webpack_require__(92);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(72);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(71);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(52);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(60);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(59);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Process2 = __webpack_require__(223);

var _Process3 = _interopRequireDefault(_Process2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Login = (_temp = _class = function (_Process) {
  (0, _inherits3.default)(Login, _Process);

  function Login() {
    (0, _classCallCheck3.default)(this, Login);
    return (0, _possibleConstructorReturn3.default)(this, _Process.apply(this, arguments));
  }

  Login.prototype.process = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(facebook) {
      var _props, scope, fields, returnScopes, rerequest, reauthorize, loginQpts, authType, response;

      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _props = this.props, scope = _props.scope, fields = _props.fields, returnScopes = _props.returnScopes, rerequest = _props.rerequest, reauthorize = _props.reauthorize;
              loginQpts = { scope: scope };
              authType = [];


              if (returnScopes) {
                loginQpts.return_scopes = true;
              }

              if (rerequest) {
                authType.push('rerequest');
              }

              if (reauthorize) {
                authType.push('reauthenticate');
              }

              if (authType.length) {
                loginQpts.auth_type = authType.join(',');
              }

              _context.next = 9;
              return facebook.login(loginQpts);

            case 9:
              response = _context.sent;

              if (!(response.status !== 'connected')) {
                _context.next = 12;
                break;
              }

              throw new Error('Unauthorized user');

            case 12:
              return _context.abrupt('return', facebook.getTokenDetailWithProfile({ fields: fields }));

            case 13:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function process(_x) {
      return _ref.apply(this, arguments);
    }

    return process;
  }();

  return Login;
}(_Process3.default), _class.propTypes = (0, _extends3.default)({}, _Process3.default.propTypes, {
  scope: _propTypes2.default.string.isRequired,
  fields: _propTypes2.default.arrayOf(_propTypes2.default.string),
  returnScopes: _propTypes2.default.bool,
  rerequest: _propTypes2.default.bool,
  reauthorize: _propTypes2.default.bool
}), _class.defaultProps = (0, _extends3.default)({}, _Process3.default.defaultProps, {
  scope: '',
  fields: ['id', 'first_name', 'last_name', 'middle_name', 'name', 'email', 'locale', 'gender', 'timezone', 'verified', 'link'],
  returnScopes: false,
  rerequest: false,
  reauthorize: false
}), _temp);
exports.default = Login;
//# sourceMappingURL=Login.js.map

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _extends2 = __webpack_require__(92);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(72);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(71);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(52);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(60);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(59);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getCurrentHref = __webpack_require__(101);

var _getCurrentHref2 = _interopRequireDefault(_getCurrentHref);

var _clearUndefinedProperties = __webpack_require__(337);

var _clearUndefinedProperties2 = _interopRequireDefault(_clearUndefinedProperties);

var _Process2 = __webpack_require__(223);

var _Process3 = _interopRequireDefault(_Process2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Share = (_temp = _class = function (_Process) {
  (0, _inherits3.default)(Share, _Process);

  function Share() {
    (0, _classCallCheck3.default)(this, Share);
    return (0, _possibleConstructorReturn3.default)(this, _Process.apply(this, arguments));
  }

  Share.prototype.process = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(facebook) {
      var _props, _props$href, href, display, _props$appId, appId, hashtag, redirectURI, quote, mobileIframe;

      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _props = this.props, _props$href = _props.href, href = _props$href === undefined ? (0, _getCurrentHref2.default)() : _props$href, display = _props.display, _props$appId = _props.appId, appId = _props$appId === undefined ? facebook.getAppId() : _props$appId, hashtag = _props.hashtag, redirectURI = _props.redirectURI, quote = _props.quote, mobileIframe = _props.mobileIframe;
              return _context.abrupt('return', facebook.ui((0, _clearUndefinedProperties2.default)({
                method: 'share',
                href: href,
                display: display,
                app_id: appId,
                hashtag: hashtag,
                redirect_uri: redirectURI,
                quote: quote,
                mobile_iframe: mobileIframe
              })));

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function process(_x) {
      return _ref.apply(this, arguments);
    }

    return process;
  }();

  return Share;
}(_Process3.default), _class.propTypes = (0, _extends3.default)({}, _Process3.default.propTypes, {
  href: _propTypes2.default.string,
  hashtag: _propTypes2.default.string,
  quote: _propTypes2.default.string,
  mobileIframe: _propTypes2.default.bool,
  display: _propTypes2.default.string,
  appId: _propTypes2.default.string,
  redirectURI: _propTypes2.default.string
}), _class.defaultProps = (0, _extends3.default)({}, _Process3.default.defaultProps, {
  href: undefined,
  hashtag: undefined,
  quote: undefined,
  mobileIframe: undefined,
  display: undefined,
  appId: undefined,
  redirectURI: undefined
}), _temp);
exports.default = Share;
//# sourceMappingURL=Share.js.map

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = {
  SOCIAL: 'social',
  REVERSE_TIME: 'reverse_time',
  TIME: 'time'
};
//# sourceMappingURL=CommentsOrderBy.js.map

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = {
  LIKE: 'like',
  RECOMMEND: 'recommend'
};
//# sourceMappingURL=LikeAction.js.map

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = {
  STANDARD: 'standard',
  BUTTON_COUNT: 'button_count',
  BUTTON: 'button',
  BOX_COUNT: 'box_count'
};
//# sourceMappingURL=LikeLayout.js.map

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = {
  SMALL: 'small',
  LARGE: 'large'
};
//# sourceMappingURL=LikeSize.js.map

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = clearUndefinedProperties;
function clearUndefinedProperties(obj) {
  if (!obj) {
    return obj;
  }

  var newObj = {};

  Object.keys(obj).forEach(function (propertyName) {
    var value = obj[propertyName];
    if (value !== undefined) {
      newObj[propertyName] = value;
    }
  });

  return newObj;
}
//# sourceMappingURL=clearUndefinedProperties.js.map

/***/ }),
/* 338 */
/***/ (function(module, exports) {

/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  return (/input|select|textarea|button|object/.test(nodeName) ?
    !element.disabled :
    "a" === nodeName ?
      element.href || isTabIndexNotNaN :
      isTabIndexNotNaN) && visible(element);
}

function hidden(el) {
  return (el.offsetWidth <= 0 && el.offsetHeight <= 0) ||
    el.style.display === 'none';
}

function visible(element) {
  while (element) {
    if (element === document.body) break;
    if (hidden(element)) return false;
    element = element.parentNode;
  }
  return true;
}

function tabbable(element) {
  var tabIndex = element.getAttribute('tabindex');
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  return [].slice.call(element.querySelectorAll('*'), 0).filter(function(el) {
    return tabbable(el);
  });
}

module.exports = findTabbableDescendants;



/***/ }),
/* 339 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = assign;


/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PropTypes__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContextUtils__ = __webpack_require__(227);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
function isEmptyObject(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
  }return true;
}

function resolveToLocation(to, router) {
  return typeof to === 'function' ? to(router.location) : to;
}

/**
 * A <Link> is used to create an <a> element that links to a route.
 * When that route is active, the link gets the value of its
 * activeClassName prop.
 *
 * For example, assuming you have the following route:
 *
 *   <Route path="/posts/:postID" component={Post} />
 *
 * You could use the following component to link to that route:
 *
 *   <Link to={`/posts/${post.id}`} />
 */
var Link = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'Link',

  mixins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__ContextUtils__["b" /* ContextSubscriber */])('router')],

  contextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_4__PropTypes__["a" /* routerShape */]
  },

  propTypes: {
    to: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_2_prop_types__["string"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"]]),
    activeStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"],
    activeClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"],
    onlyActiveOnIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types__["bool"].isRequired,
    onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"],
    target: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"],
    innerRef: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_2_prop_types__["string"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_prop_types__["shape"])({ current: __WEBPACK_IMPORTED_MODULE_2_prop_types__["elementType"] })])
  },

  getDefaultProps: function getDefaultProps() {
    return {
      onlyActiveOnIndex: false,
      style: {}
    };
  },
  handleClick: function handleClick(event) {
    if (this.props.onClick) this.props.onClick(event);

    if (event.defaultPrevented) return;

    var router = this.context.router;

    !router ?  false ? invariant(false, '<Link>s rendered outside of a router context cannot navigate.') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;

    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;

    // If target prop is set (e.g. to "_blank"), let browser handle link.
    /* istanbul ignore if: untestable with Karma */
    if (this.props.target) return;

    event.preventDefault();

    router.push(resolveToLocation(this.props.to, router));
  },
  render: function render() {
    var _props = this.props,
        to = _props.to,
        activeClassName = _props.activeClassName,
        activeStyle = _props.activeStyle,
        onlyActiveOnIndex = _props.onlyActiveOnIndex,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex', 'innerRef']);

    // Ignore if rendered outside the context of router to simplify unit testing.


    var router = this.context.router;


    if (router) {
      // If user does not specify a `to` prop, return an empty anchor tag.
      if (!to) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { ref: innerRef }));
      }

      var toLocation = resolveToLocation(to, router);
      props.href = router.createHref(toLocation);

      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
        if (router.isActive(toLocation, onlyActiveOnIndex)) {
          if (activeClassName) {
            if (props.className) {
              props.className += ' ' + activeClassName;
            } else {
              props.className = activeClassName;
            }
          }

          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
        }
      }
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick, ref: innerRef }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPromise;
function isPromise(obj) {
  return obj && typeof obj.then === 'function';
}

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RouteUtils__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PatternUtils__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(123);







/**
 * A <Redirect> is used to declare another URL path a client should
 * be sent to when they request a given URL.
 *
 * Redirects are placed alongside routes in the route configuration
 * and are traversed in the same manner.
 */
/* eslint-disable react/require-render-return */
var Redirect = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'Redirect',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element) {
      var route = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__RouteUtils__["c" /* createRouteFromReactElement */])(element);

      if (route.from) route.path = route.from;

      route.onEnter = function (nextState, replace) {
        var location = nextState.location,
            params = nextState.params;


        var pathname = void 0;
        if (route.to.charAt(0) === '/') {
          pathname = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__PatternUtils__["c" /* formatPattern */])(route.to, params);
        } else if (!route.to) {
          pathname = location.pathname;
        } else {
          var routeIndex = nextState.routes.indexOf(route);
          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
          pathname = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__PatternUtils__["c" /* formatPattern */])(pattern, params);
        }

        replace({
          pathname: pathname,
          query: route.query || location.query,
          state: route.state || location.state
        });
      };

      return route;
    },
    getRoutePattern: function getRoutePattern(routes, routeIndex) {
      var parentPattern = '';

      for (var i = routeIndex; i >= 0; i--) {
        var route = routes[i];
        var pattern = route.path || '';

        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;

        if (pattern.indexOf('/') === 0) break;
      }

      return '/' + parentPattern;
    }
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
    from: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"], // Alias for path
    to: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"].isRequired,
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    onEnter: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<Redirect> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouterObject;
/* harmony export (immutable) */ __webpack_exports__["b"] = assignRouterState;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function createRouterObject(history, transitionManager, state) {
  var router = _extends({}, history, {
    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
    isActive: transitionManager.isActive
  });

  return assignRouterState(router, state);
}

function assignRouterState(router, _ref) {
  var location = _ref.location,
      params = _ref.params,
      routes = _ref.routes;

  router.location = location;
  router.params = params;
  router.routes = routes;

  return router;
}

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createMemoryHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory__);




function createMemoryHistory(options) {
  // signatures and type checking differ between `useQueries` and
  // `createMemoryHistory`, have to create `memoryHistory` first because
  // `useQueries` doesn't understand the signature
  var memoryHistory = __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory___default()(options);
  var createHistory = function createHistory() {
    return memoryHistory;
  };
  var history = __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default()(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default()(createHistory))(options);
  return history;
}

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouterHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__useRouterHistory__ = __webpack_require__(347);


var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

function createRouterHistory(createHistory) {
  var history = void 0;
  if (canUseDOM) history = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__useRouterHistory__["a" /* default */])(createHistory)();
  return history;
}

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTransitionManager;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routerWarning__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TransitionUtils__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isActive__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getComponents__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__matchRoutes__ = __webpack_require__(805);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function hasAnyProperties(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
  }return false;
}

function createTransitionManager(history, routes) {
  var state = {};

  var _getTransitionUtils = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__TransitionUtils__["a" /* default */])(),
      runEnterHooks = _getTransitionUtils.runEnterHooks,
      runChangeHooks = _getTransitionUtils.runChangeHooks,
      runLeaveHooks = _getTransitionUtils.runLeaveHooks;

  // Signature should be (location, indexOnly), but needs to support (path,
  // query, indexOnly)


  function isActive(location, indexOnly) {
    location = history.createLocation(location);

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__isActive__["a" /* default */])(location, indexOnly, state.location, state.routes, state.params);
  }

  var partialNextState = void 0;

  function match(location, callback) {
    if (partialNextState && partialNextState.location === location) {
      // Continue from where we left off.
      finishMatch(partialNextState, callback);
    } else {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__matchRoutes__["a" /* default */])(routes, location, function (error, nextState) {
        if (error) {
          callback(error);
        } else if (nextState) {
          finishMatch(_extends({}, nextState, { location: location }), callback);
        } else {
          callback();
        }
      });
    }
  }

  function finishMatch(nextState, callback) {
    var _computeChangedRoutes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__["a" /* default */])(state, nextState),
        leaveRoutes = _computeChangedRoutes.leaveRoutes,
        changeRoutes = _computeChangedRoutes.changeRoutes,
        enterRoutes = _computeChangedRoutes.enterRoutes;

    runLeaveHooks(leaveRoutes, state);

    // Tear down confirmation hooks for left routes
    leaveRoutes.filter(function (route) {
      return enterRoutes.indexOf(route) === -1;
    }).forEach(removeListenBeforeHooksForRoute);

    // change and enter hooks are run in series
    runChangeHooks(changeRoutes, state, nextState, function (error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      runEnterHooks(enterRoutes, nextState, finishEnterHooks);
    });

    function finishEnterHooks(error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      // TODO: Fetch components after state is updated.
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__getComponents__["a" /* default */])(nextState, function (error, components) {
        if (error) {
          callback(error);
        } else {
          // TODO: Make match a pure function and have some other API
          // for "match and update state".
          callback(null, null, state = _extends({}, nextState, { components: components }));
        }
      });
    }

    function handleErrorOrRedirect(error, redirectInfo) {
      if (error) callback(error);else callback(null, redirectInfo);
    }
  }

  var RouteGuid = 1;

  function getRouteID(route) {
    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return route.__id__ || create && (route.__id__ = RouteGuid++);
  }

  var RouteHooks = Object.create(null);

  function getRouteHooksForRoutes(routes) {
    return routes.map(function (route) {
      return RouteHooks[getRouteID(route)];
    }).filter(function (hook) {
      return hook;
    });
  }

  function transitionHook(location, callback) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__matchRoutes__["a" /* default */])(routes, location, function (error, nextState) {
      if (nextState == null) {
        // TODO: We didn't actually match anything, but hang
        // onto error/nextState so we don't have to matchRoutes
        // again in the listen callback.
        callback();
        return;
      }

      // Cache some state here so we don't have to
      // matchRoutes() again in the listen callback.
      partialNextState = _extends({}, nextState, { location: location });

      var hooks = getRouteHooksForRoutes(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__["a" /* default */])(state, partialNextState).leaveRoutes);

      var result = void 0;
      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
        // Passing the location arg here indicates to
        // the user that this is a transition hook.
        result = hooks[i](location);
      }

      callback(result);
    });
  }

  /* istanbul ignore next: untestable with Karma */
  function beforeUnloadHook() {
    // Synchronously check to see if any route hooks want
    // to prevent the current window/tab from closing.
    if (state.routes) {
      var hooks = getRouteHooksForRoutes(state.routes);

      var message = void 0;
      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
        // Passing no args indicates to the user that this is a
        // beforeunload hook. We don't know the next location.
        message = hooks[i]();
      }

      return message;
    }
  }

  var unlistenBefore = void 0,
      unlistenBeforeUnload = void 0;

  function removeListenBeforeHooksForRoute(route) {
    var routeID = getRouteID(route);
    if (!routeID) {
      return;
    }

    delete RouteHooks[routeID];

    if (!hasAnyProperties(RouteHooks)) {
      // teardown transition & beforeunload hooks
      if (unlistenBefore) {
        unlistenBefore();
        unlistenBefore = null;
      }

      if (unlistenBeforeUnload) {
        unlistenBeforeUnload();
        unlistenBeforeUnload = null;
      }
    }
  }

  /**
   * Registers the given hook function to run before leaving the given route.
   *
   * During a normal transition, the hook function receives the next location
   * as its only argument and can return either a prompt message (string) to show the user,
   * to make sure they want to leave the page; or `false`, to prevent the transition.
   * Any other return value will have no effect.
   *
   * During the beforeunload event (in browsers) the hook receives no arguments.
   * In this case it must return a prompt message to prevent the transition.
   *
   * Returns a function that may be used to unbind the listener.
   */
  function listenBeforeLeavingRoute(route, hook) {
    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
    var routeID = getRouteID(route, true);

    RouteHooks[routeID] = hook;

    if (thereWereNoRouteHooks) {
      // setup transition & beforeunload hooks
      unlistenBefore = history.listenBefore(transitionHook);

      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
    }

    return function () {
      removeListenBeforeHooksForRoute(route);
    };
  }

  /**
   * This is the API for stateful environments. As the location
   * changes, we update state and call the listener. We can also
   * gracefully handle errors and redirects.
   */
  function listen(listener) {
    function historyListener(location) {
      if (state.location === location) {
        listener(null, state);
      } else {
        match(location, function (error, redirectLocation, nextState) {
          if (error) {
            listener(error);
          } else if (redirectLocation) {
            history.replace(redirectLocation);
          } else if (nextState) {
            listener(null, nextState);
          } else {
             false ? warning(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
          }
        });
      }
    }

    // TODO: Only use a single history listener. Otherwise we'll end up with
    // multiple concurrent calls to match.

    // Set up the history listener first in case the initial match redirects.
    var unsubscribe = history.listen(historyListener);

    if (state.location) {
      // Picking up on a matchContext.
      listener(null, state);
    } else {
      historyListener(history.getCurrentLocation());
    }

    return unsubscribe;
  }

  return {
    isActive: isActive,
    match: match,
    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
    listen: listen
  };
}

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useRouterHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__);



function useRouterHistory(createHistory) {
  return function (options) {
    var history = __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default()(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default()(createHistory))(options);
    return history;
  };
}

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @copyright © 2015, Rick Wong. All rights reserved.
 */


/**
 * @function isContainer
 */
module.exports = function (Container) {
	return !!(Container &&
	          Container.getFragment &&
	          Container.getAllFragments);
};


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @copyright © 2015, Rick Wong. All rights reserved.
 */


var React = __webpack_require__(159);

/**
 * @function overrideCreateElement
 */
module.exports = function (replacement, callback) {
	var originalCreateElement = React.createElement;

	React.createElement = function (t, p, c) {
		var args = [].slice.call(arguments);
		return replacement.apply(null, [originalCreateElement].concat(args));
	};

	callback();

	React.createElement = originalCreateElement;
};


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @copyright © 2015, Rick Wong. All rights reserved.
 */


/**
 * @function takeFromMarkup
 */
module.exports = function () {
	var packet = [];

	if (typeof window !== "undefined" && window.__reactTransmitPacket instanceof Array) {
		packet = window.__reactTransmitPacket.slice(0);
		delete window.__reactTransmitPacket;
	}

	return packet;
};


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(124),
    _assign = __webpack_require__(11);

var ReactNoopUpdateQueue = __webpack_require__(354);

var canDefineProperty = __webpack_require__(355);
var emptyObject = __webpack_require__(147);
var invariant = __webpack_require__(3);
var lowPriorityWarning = __webpack_require__(826);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(124);

var ReactCurrentOwner = __webpack_require__(57);

var invariant = __webpack_require__(3);
var warning = __webpack_require__(10);

function isNative(fn) {
  // Based on isNative() from Lodash
  var funcToString = Function.prototype.toString;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var reIsNative = RegExp('^' + funcToString
  // Take an example native function source for comparison
  .call(hasOwnProperty
  // Strip regex characters so we can use it for regex
  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
  // Remove hasOwnProperty from the template to make it generic
  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  try {
    var source = funcToString.call(fn);
    return reIsNative.test(source);
  } catch (err) {
    return false;
  }
}

var canUseCollections =
// Array.from
typeof Array.from === 'function' &&
// Map
typeof Map === 'function' && isNative(Map) &&
// Map.prototype.keys
Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
// Set
typeof Set === 'function' && isNative(Set) &&
// Set.prototype.keys
Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);

var setItem;
var getItem;
var removeItem;
var getItemIDs;
var addRoot;
var removeRoot;
var getRootIDs;

if (canUseCollections) {
  var itemMap = new Map();
  var rootIDSet = new Set();

  setItem = function (id, item) {
    itemMap.set(id, item);
  };
  getItem = function (id) {
    return itemMap.get(id);
  };
  removeItem = function (id) {
    itemMap['delete'](id);
  };
  getItemIDs = function () {
    return Array.from(itemMap.keys());
  };

  addRoot = function (id) {
    rootIDSet.add(id);
  };
  removeRoot = function (id) {
    rootIDSet['delete'](id);
  };
  getRootIDs = function () {
    return Array.from(rootIDSet.keys());
  };
} else {
  var itemByKey = {};
  var rootByKey = {};

  // Use non-numeric keys to prevent V8 performance issues:
  // https://github.com/facebook/react/pull/7232
  var getKeyFromID = function (id) {
    return '.' + id;
  };
  var getIDFromKey = function (key) {
    return parseInt(key.substr(1), 10);
  };

  setItem = function (id, item) {
    var key = getKeyFromID(id);
    itemByKey[key] = item;
  };
  getItem = function (id) {
    var key = getKeyFromID(id);
    return itemByKey[key];
  };
  removeItem = function (id) {
    var key = getKeyFromID(id);
    delete itemByKey[key];
  };
  getItemIDs = function () {
    return Object.keys(itemByKey).map(getIDFromKey);
  };

  addRoot = function (id) {
    var key = getKeyFromID(id);
    rootByKey[key] = true;
  };
  removeRoot = function (id) {
    var key = getKeyFromID(id);
    delete rootByKey[key];
  };
  getRootIDs = function () {
    return Object.keys(rootByKey).map(getIDFromKey);
  };
}

var unmountedIDs = [];

function purgeDeep(id) {
  var item = getItem(id);
  if (item) {
    var childIDs = item.childIDs;

    removeItem(id);
    childIDs.forEach(purgeDeep);
  }
}

function describeComponentFrame(name, source, ownerName) {
  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
}

function getDisplayName(element) {
  if (element == null) {
    return '#empty';
  } else if (typeof element === 'string' || typeof element === 'number') {
    return '#text';
  } else if (typeof element.type === 'string') {
    return element.type;
  } else {
    return element.type.displayName || element.type.name || 'Unknown';
  }
}

function describeID(id) {
  var name = ReactComponentTreeHook.getDisplayName(id);
  var element = ReactComponentTreeHook.getElement(id);
  var ownerID = ReactComponentTreeHook.getOwnerID(id);
  var ownerName;
  if (ownerID) {
    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
  }
   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
  return describeComponentFrame(name, element && element._source, ownerName);
}

var ReactComponentTreeHook = {
  onSetChildren: function (id, nextChildIDs) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.childIDs = nextChildIDs;

    for (var i = 0; i < nextChildIDs.length; i++) {
      var nextChildID = nextChildIDs[i];
      var nextChild = getItem(nextChildID);
      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
      if (nextChild.parentID == null) {
        nextChild.parentID = id;
        // TODO: This shouldn't be necessary but mounting a new root during in
        // componentWillMount currently causes not-yet-mounted components to
        // be purged from our tree data so their parent id is missing.
      }
      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
    }
  },
  onBeforeMountComponent: function (id, element, parentID) {
    var item = {
      element: element,
      parentID: parentID,
      text: null,
      childIDs: [],
      isMounted: false,
      updateCount: 0
    };
    setItem(id, item);
  },
  onBeforeUpdateComponent: function (id, element) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.element = element;
  },
  onMountComponent: function (id) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.isMounted = true;
    var isRoot = item.parentID === 0;
    if (isRoot) {
      addRoot(id);
    }
  },
  onUpdateComponent: function (id) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.updateCount++;
  },
  onUnmountComponent: function (id) {
    var item = getItem(id);
    if (item) {
      // We need to check if it exists.
      // `item` might not exist if it is inside an error boundary, and a sibling
      // error boundary child threw while mounting. Then this instance never
      // got a chance to mount, but it still gets an unmounting event during
      // the error boundary cleanup.
      item.isMounted = false;
      var isRoot = item.parentID === 0;
      if (isRoot) {
        removeRoot(id);
      }
    }
    unmountedIDs.push(id);
  },
  purgeUnmountedComponents: function () {
    if (ReactComponentTreeHook._preventPurging) {
      // Should only be used for testing.
      return;
    }

    for (var i = 0; i < unmountedIDs.length; i++) {
      var id = unmountedIDs[i];
      purgeDeep(id);
    }
    unmountedIDs.length = 0;
  },
  isMounted: function (id) {
    var item = getItem(id);
    return item ? item.isMounted : false;
  },
  getCurrentStackAddendum: function (topElement) {
    var info = '';
    if (topElement) {
      var name = getDisplayName(topElement);
      var owner = topElement._owner;
      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
    }

    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    info += ReactComponentTreeHook.getStackAddendumByID(id);
    return info;
  },
  getStackAddendumByID: function (id) {
    var info = '';
    while (id) {
      info += describeID(id);
      id = ReactComponentTreeHook.getParentID(id);
    }
    return info;
  },
  getChildIDs: function (id) {
    var item = getItem(id);
    return item ? item.childIDs : [];
  },
  getDisplayName: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element) {
      return null;
    }
    return getDisplayName(element);
  },
  getElement: function (id) {
    var item = getItem(id);
    return item ? item.element : null;
  },
  getOwnerID: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element || !element._owner) {
      return null;
    }
    return element._owner._debugID;
  },
  getParentID: function (id) {
    var item = getItem(id);
    return item ? item.parentID : null;
  },
  getSource: function (id) {
    var item = getItem(id);
    var element = item ? item.element : null;
    var source = element != null ? element._source : null;
    return source;
  },
  getText: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (typeof element === 'string') {
      return element;
    } else if (typeof element === 'number') {
      return '' + element;
    } else {
      return null;
    }
  },
  getUpdateCount: function (id) {
    var item = getItem(id);
    return item ? item.updateCount : 0;
  },


  getRootIDs: getRootIDs,
  getRegisteredIDs: getItemIDs,

  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
    if (typeof console.reactStack !== 'function') {
      return;
    }

    var stack = [];
    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    try {
      if (isCreatingElement) {
        stack.push({
          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
          fileName: currentSource ? currentSource.fileName : null,
          lineNumber: currentSource ? currentSource.lineNumber : null
        });
      }

      while (id) {
        var element = ReactComponentTreeHook.getElement(id);
        var parentID = ReactComponentTreeHook.getParentID(id);
        var ownerID = ReactComponentTreeHook.getOwnerID(id);
        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
        var source = element && element._source;
        stack.push({
          name: ownerName,
          fileName: source ? source.fileName : null,
          lineNumber: source ? source.lineNumber : null
        });
        id = parentID;
      }
    } catch (err) {
      // Internal state is messed up.
      // Stop building the stack (it's just a nice to have).
    }

    console.reactStack(stack);
  },
  popNonStandardWarningStack: function () {
    if (typeof console.reactStackEnd !== 'function') {
      return;
    }
    console.reactStackEnd();
  }
};

module.exports = ReactComponentTreeHook;

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var warning = __webpack_require__(10);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(666);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(18)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./Mia.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./Mia.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Check if `obj` is an object.
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */

function isObject(obj) {
  return null !== obj && 'object' === typeof obj;
}

module.exports = isObject;


/***/ }),
/* 358 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyOC4zNSAyMy44NiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiMwMTAxMDE7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5Bc3NldCA0PC90aXRsZT48ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTI3LjY0LDJIMjUuNzZWLjVhLjUuNSwwLDAsMC0uNS0uNUgxOC43MWE4LDgsMCwwLDAtNC41NCwxLjRBOCw4LDAsMCwwLDkuNjQsMEgzLjA5YS41MS41MSwwLDAsMC0uNTEuNVYySC43MUEuNzIuNzIsMCwwLDAsMCwyLjcyVjIwLjMzYTEuNzYsMS43NiwwLDAsMCwxLjczLDEuNzloOS4xMkExLjMyLDEuMzIsMCwwLDAsMTIsMjMuODZoNC4yOWExLjMyLDEuMzIsMCwwLDAsMS4xNy0xLjc0aDkuMTJhMS43NywxLjc3LDAsMCwwLDEuNzQtMS43OVYyLjcyQS43Mi43MiwwLDAsMCwyNy42NCwyWm0tMTMsLjI4YTcuMDYsNy4wNiwwLDAsMSw0LTEuMjZoNi4wNVYxOS4xNEgxOC43MWE4LjQ5LDguNDksMCwwLDAtNCwxLjA4Wk0zLjU5LDFIOS42NGE3LDcsMCwwLDEsNCwxLjI2djE4YTcuNzMsNy43MywwLDAsMC00LTEuMDhIMy41OVoiLz48L2c+PC9nPjwvc3ZnPg=="

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App_App__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Iah_Kong_Kong__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Iah_The_The__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Iah_Iong_Iong__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Iah_Mia_Mia__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Iah_Mia___ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Iah_About_About__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Iah___ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Ogilvy___ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Ogilvy___ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__GuanKiann_TshiuKiSuanTuann_KuahPau__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__GuanKiann_TshiuKiSuanTuann_TshiuKiSuanTuann__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Iah___ = __webpack_require__(397);




















__WEBPACK_IMPORTED_MODULE_3_debug___default.a.enable('itaigi:*');

var root = document.getElementById('app');

// if (window.location.pathname === '/') {
// render(<HuanGing/>, root)
// } else {
var history = __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* browserHistory */];
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'div',
  null,
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__GuanKiann_TshiuKiSuanTuann_KuahPau__["a" /* default */], null),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_router__["b" /* Router */],
    { history: history },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Route */],
      { path: '/', component: __WEBPACK_IMPORTED_MODULE_4__App_App__["a" /* default */] },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["d" /* IndexRoute */], { component: __WEBPACK_IMPORTED_MODULE_5__Iah_Kong_Kong__["a" /* default */] }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Route */], { path: 'k(/:k)(/:han)(/:lo)', component: __WEBPACK_IMPORTED_MODULE_5__Iah_Kong_Kong__["a" /* default */] }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Route */], { path: 't(/:k)', component: __WEBPACK_IMPORTED_MODULE_6__Iah_The_The__["a" /* default */] }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Route */], { path: 'iong', component: __WEBPACK_IMPORTED_MODULE_7__Iah_Iong_Iong__["a" /* default */] }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Route */], { path: 'mia', component: __WEBPACK_IMPORTED_MODULE_8__Iah_Mia_Mia__["a" /* default */] }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Route */], { path: 'tsing', component: __WEBPACK_IMPORTED_MODULE_9__Iah_Mia___["a" /* default */] }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Route */], { path: 'about', component: __WEBPACK_IMPORTED_MODULE_10__Iah_About_About__["a" /* default */] }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Route */], { path: 'tsu-te', component: __WEBPACK_IMPORTED_MODULE_12__Ogilvy___["a" /* default */] }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Route */], { path: 'tsu-te/pho-khi-bong', component: __WEBPACK_IMPORTED_MODULE_11__Iah___["a" /* default */] }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Route */], { path: 'tsu-te/kim-iong-kah-tai-gi', component: __WEBPACK_IMPORTED_MODULE_13__Ogilvy___["a" /* default */] }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Route */], { path: 'name(/:senn)(/:mia)(/)', component: __WEBPACK_IMPORTED_MODULE_16__Iah___["a" /* default */] }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Route */], { path: '*', component: __WEBPACK_IMPORTED_MODULE_5__Iah_Kong_Kong__["a" /* default */] })
    )
  )
), root);

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_2_react_router__["b" /* Router */],
  { history: history },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Route */], { path: '/*', component: __WEBPACK_IMPORTED_MODULE_15__GuanKiann_TshiuKiSuanTuann_TshiuKiSuanTuann__["a" /* default */] })
), document.getElementById('sidebar'));

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(650);

__webpack_require__(829);

__webpack_require__(410);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(105)))

/***/ }),
/* 361 */
/***/ (function(module, exports) {

// Generated by CoffeeScript 1.6.2
(function() {
  var asciiJSON;

  asciiJSON = exports;

  asciiJSON.isAscii = function(text) {
    return /^[\x00-\x7F]*$/.test(text);
  };

  asciiJSON.escapeNonAsciis = function(text) {
    var chars, code, i;

    chars = [];
    i = 0;
    while (i < text.length) {
      code = text.charCodeAt(i);
      if (code < 128) {
        chars.push(text[i]);
      } else {
        if (code < 256) {
          chars.push('\\u00');
        } else if (code < 4096) {
          chars.push('\\u0');
        } else {
          chars.push('\\u');
        }
        chars.push(code.toString(16));
      }
      i++;
    }
    return chars.join('');
  };

  asciiJSON.stringify = function(object) {
    var utf8JSON;

    utf8JSON = JSON.stringify(object);
    return asciiJSON.escapeNonAsciis(utf8JSON);
  };

  asciiJSON.parse = JSON.parse;

}).call(this);


/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GuanKiann_ToLam_ToLam__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GuanKiann_IapKha_IapKha__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GuanKiann___ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__GuanKiann___ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__GA__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App_css__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bluebird__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_debug__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_debug__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var superagent = __webpack_require__(26)(__webpack_require__(27), __WEBPACK_IMPORTED_MODULE_8_bluebird__["Promise"]);

var debug = __WEBPACK_IMPORTED_MODULE_10_debug___default()('itaigi:App');

var App = function (_React$Component) {
  _inherits(App, _React$Component);

  function App(props) {
    _classCallCheck(this, App);

    var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));

    _this.state = { csrftoken: '', 編號: '無登入' };
    _this.看編號();
    return _this;
  }

  _createClass(App, [{
    key: '\u770B\u7DE8\u865F',
    value: function _() {
      var _this2 = this;

      superagent.get(encodeURI(__WEBPACK_IMPORTED_MODULE_3____["a" /* default */].網址() + 'csrf/看')).withCredentials().then(function (_ref) {
        var body = _ref.body;
        return _this2.setState({ csrftoken: body.csrftoken }), null;
      }).catch(function (err) {
        return debug(err);
      });
      superagent.get(encodeURI(__WEBPACK_IMPORTED_MODULE_3____["a" /* default */].網址() + '使用者/看編號')).withCredentials().then(function (_ref2) {
        var body = _ref2.body;
        return _this2.setState({ 編號: body.使用者編號 }), null;
      }).catch(function (err) {
        return debug(err);
      });
    }
  }, {
    key: '\u67E5\u600E\u6A23\u8B1B',
    value: function _(外語) {
      __WEBPACK_IMPORTED_MODULE_9_react_router__["a" /* browserHistory */].replace('/k/' + 外語);
    }
  }, {
    key: '\u6B32\u63D0\u4F9B\u8B1B\u6CD5',
    value: function _(外語) {
      __WEBPACK_IMPORTED_MODULE_9_react_router__["a" /* browserHistory */].replace('/t/' + 外語);
    }
  }, {
    key: '\u958B\u4F8B\u53E5',
    value: function _(外語, 漢字, 台羅) {
      __WEBPACK_IMPORTED_MODULE_9_react_router__["a" /* browserHistory */].replace('/k/' + encodeURIComponent(外語) + '/' + encodeURIComponent(漢字) + '/' + encodeURIComponent(台羅));
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__GA__["d" /* gaLeKu */])(漢字, 台羅);
    }
  }, {
    key: '\u95DC\u4F8B\u53E5',
    value: function _(外語) {
      this.查怎樣講(外語);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$params = this.props.params,
          k = _props$params.k,
          han = _props$params.han,
          lo = _props$params.lo;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'app background' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'header',
          { className: 'app header' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__GuanKiann_ToLam_ToLam__["a" /* default */], { pathname: this.props.location.pathname })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(this.props.children, {
          查怎樣講: this.查怎樣講.bind(this),
          欲提供講法: this.欲提供講法.bind(this),
          csrftoken: this.state.csrftoken,
          編號: this.state.編號,
          開例句: this.開例句.bind(this),
          variables: { 關鍵字: k },
          renderLoading: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__GuanKiann___["a" /* default */], null)
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__GuanKiann___["a" /* default */], { 關例句: this.關例句.bind(this, k),
          漢字: han, 台羅: lo,
          variables: { 漢字: han, 台羅: lo } }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__GuanKiann_IapKha_IapKha__["a" /* default */], null)
      );
    }
  }]);

  return App;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (App);


App.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.object,
  children: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.object
};

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GuanKiann_ToLam_ToLam__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GuanKiann___ = __webpack_require__(58);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var FBTest = function (_React$Component) {
  _inherits(FBTest, _React$Component);

  function FBTest(props) {
    _classCallCheck(this, FBTest);

    var _this = _possibleConstructorReturn(this, (FBTest.__proto__ || Object.getPrototypeOf(FBTest)).call(this, props));

    _this.state = {
      href: ''
    };
    return _this;
  }

  /*
  componentDidMount() {
    var _this = this;
    window.fbAsyncInit = function () {
      FB.init({
        appId: '252264671778664',
        xfbml: true,
        version: 'v2.5',
      });
       FB.getLoginStatus(function (response) {
        FB.api('/ukauitaigi/feed', function (feed) {
          var postID = feed.data[0].id.split('_')[1];
          FB.api('/' + postID + '?fields=source', function (photo) {
            _this.getFacebookResponse(photo);
          });
        });
      });
     }.bind(this)
     ;(function (d, s, id) {
      var js;
      var fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {return;}
       js = d.createElement(s); js.id = id;
      js.src = '//connect.facebook.net/en_US/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
  }
  */

  _createClass(FBTest, [{
    key: 'renderFacebookResponse',
    value: function renderFacebookResponse() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'kong content' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'ui basic segment' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'ui middle aligned stackable grid container' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'eight wide column' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h1',
                  { className: 'ui header' },
                  '\u5FEB\u5206\u4EAB iTaigi \u7D66\u4F60\u7684\u670B\u53CB\u77E5\u9053\u5427\uFF01'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__GuanKiann___["a" /* default */], { size: 'large', pathname: '' })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'eight wide right floated column' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  { href: '//facebook.com/1730736483875375', target: '_blank' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { width: '480px', style: { maxWidth: '100%' }, src: 'https://s3-ap-southeast-1.amazonaws.com/' + 'itaigi.tw/images/footer.png' })
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)
      );
    }
  }, {
    key: 'getFacebookResponse',
    value: function getFacebookResponse(photo) {
      this.setState({ href: 'http://facebook.com/' + photo.id, src: photo.source });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container' },
          this.renderFacebookResponse()
        )
      );
    }
  }]);

  return FBTest;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (FBTest);

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_modal__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_modal__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var customStyles = {
  overlay: {
    zIndex: '200'
  },
  content: {
    maxWidth: '400px',
    maxHeight: '180px',
    margin: 'auto'
  }
};

var APui = function (_React$Component) {
  _inherits(APui, _React$Component);

  function APui() {
    _classCallCheck(this, APui);

    return _possibleConstructorReturn(this, (APui.__proto__ || Object.getPrototypeOf(APui)).apply(this, arguments));
  }

  _createClass(APui, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_react_modal___default.a,
        {
          contentLabel: 'APui',
          isOpen: this.props.modalIsOpen,
          onRequestClose: this.props.closeModal.bind(this),
          style: customStyles },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h2',
          { ref: 'subtitle' },
          '\u5DF2\u4E0A\u50B3\uFF01'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          '\u6B63\u898F\u5316\u5718\u968A\u6703\u5148\u5E6B\u5FD9\u6539\u6210\u6559\u80B2\u90E8\u7684\u63A8\u85A6\u7528\u5B57\u518D\u9001\u51FA\u5594\uFF01',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            onClick: this.props.closeModal.bind(this),
            className: 'ui button',
            style: { float: 'right' } },
          '\u597D\u5466'
        )
      );
    }
  }]);

  return APui;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (APui);

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_unorm__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_unorm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_unorm__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var old_mapping = { 'ti\u0301ng-tha\u0302u': '08102', 'kia\u0302m-sng-tinn': '13108', kenn: '12851', 'bo\u0302-khang': '08639', 'pha\u0302ng': '12277', 'iap-bue\u0301-ka\u0301u': '08464', 'lim tsiu\u0301': '07071', 'tio\u0300': '08029', 'tio\u0302': '10086', 'tio\u0304ng': '05519', 'tsai-kho\u0301o': '04406', kiong: '05975', 'pua\u0300nn-tha\u0301ng-sa\u0301i': '01543', 'lo\u0302-ko\u0301o': '13444', 'hua\u0301n-bo\u030Dk': '00885', 'tia\u0304n-tha\u0302u-tsang-tia\u0300m': '10376', 'i\u0301-toh': '08525', 'ko\u0300o-kheh': '13213', 'ji\u0304-ga\u0301n': '02374', 'bo\u0302 ki\u0300m bo\u0302 khi\u0304, tsia\u030Dh pah-ji\u0304. ': '60301', 'khua\u0300nn-ma\u0304i': '05361', 'ku\u0301-tn\u0302g': '00378', 'ho\u0301-si\u0301': '02327', 'oo-kim': '06286', 'tshi\u0301m': '13613', 'pi\u0301ng-tsu\u0302n': '01068', 'thi\u0304nn': '07741', 'po-le\u0302': '05301', 'ka\u0300n-kia\u0304u': '04861', 'khn\u0300g-po\u0304o': '03047', 'ti\u0304ng-ke\u0300': '03879', 'tsha\u0302-kia\u030Dh': '06140', 'bo\u030Dk-ti\u030Dk': '01923', 'gue\u030Dh-la\u0304i': '00850', 'tsha\u0301u-la\u0302ng': '06563', 'tsa\u0300-khi': '09111', 'tshang-tha\u0302u': '11379', 'tsiu\u0301-kan-that-a\u0301': '06858', 'kho\u0300ng-bu\u030Dt': '13028', 'tsok-pe\u0300': '02945', 'tia\u030Dh': '13259', 'a\u0304u gue\u030Dh-ji\u030Dt': '04931', ngeh: '07836', 'tia\u030Dk': '11678', 'tshia\u0302-ba\u030Dk': '07473', 'm\u0304 ka\u0301nn': '01082', 'tia\u030Dp': '08436', 'tia\u0300u-siong': '02239', 'tshah-koh': '08408', 'gua\u0304-la\u0302ng': '01426', 'gia\u030Dt-tsu\u0301': '12985', 'ban-kia\u0301nn': '05933', 'tha\u0300u-hong': '07969', 'ia\u0301n': '10638', 'ti\u0304-tsue\u0304': '04313', 'hi\u0304nn-kia\u0300nn': '02833', 'tsi\u0300n-hi\u0302ng': '09137', 'ma\u0300-ma\u0300-ha\u0301u': '10434', 'pha\u0300u te\u0302': '04372', 'gia\u0302n': '03401', 'sit-le\u0301': '01836', 'gia\u0302m': '12982', 'ga\u0304m': '11625', 'ga\u0304n': '09240', 'peh-kak': '00109', 'ga\u0304i': '12832', 'ia\u0302n-phia\u0301nn': '10310', 'ke\u0301nn-a\u0301': '07813', 'phah kim-a\u0301': '04058', 'lio\u030Dk-ha\u030Dp': '00655', 'ua\u0300n-tsheh': '04981', 'i\u0301ng-kue\u0300': '03940', 'm\u0304-tsai-la\u0302ng': '00987', 'tsa\u0300i': '10173', 'hio\u0300ng-sia\u0304n': '02230', 'ha\u0304u-po\u0301o': '05783', 'tsa\u0300m': '12650', 'tsa\u0300n': '11041', 'mn\u0302g-lo\u0304o': '04644', 'ti\u0301ng-poo': '08078', 'gua\u0304-kok': '01537', 'khiok-si\u0304': '04741', 'tha\u030Dk-tsheh': '13266', 'tiu\u0302-a\u0301': '10734', 'tso\u0301o-thua\u0302n-pi\u0300-hng': '06433', 'tsa\u0300u': '03302', 'tshun-thinn': '05016', 'ju\u0301-mia\u0302': '03560', 'ha\u0301i-hong': '06205', 'sit-ji\u030Dt': '10839', 'kik-sa\u0301i': '11785', 'ka\u0300m-tok': '10708', 'ha\u0301i-bi\u0304n': '06204', 'kheh-khi\u0300': '04888', 'ji\u0304n-hu\u0304n': '10863', 'sio-hui\u0302--e\u0302 tsia\u030Dh khih, tsit-tshio\u030Dh--e\u0302 khu\u0300n i\u0301. ': '60351', 'khi\u0301-sia\u0301u': '06770', 'tio\u030Dh-sua': '09040', 'sit-si\u0302n': '01758', 'huan-ho\u0304': '08772', 'be\u0304-ho\u0302': '06668', 'huah-hiu': '08231', 'bo\u0302-it-ti\u0304ng': '08598', 'tho\u030Dk-tsia\u0301': '13272', 'bih-sio-tshue\u0304': '09033', 'tang-thinn': '01442', 'li\u030Dk-sik': '10742', 'suah-hi\u0300': '09744', 'tshua\u030Dh-kak': '07474', 'ba\u0304n-ta\u0304i': '09917', 'iau-tshia\u0301nn': '12461', 'huat-ia\u0304m': '08745', 'koo-pia\u0301u': '03799', 'he\u0304-tshiu\u0301': '00260', 'gi\u0301n-a\u0301-si\u0300ng': '02159', 'tsu\u030Dt-bi\u0301-pn\u0304g': '06460', 'tsha\u0300i-po\u0301o': '08984', 'sua-lu\u0304n': '03328', 'sui\u0302-a\u0304u': '12040', 'tshiu\u0301-hu\u0302n': '01064', 'ku\u030Dt--to\u0301': '09733', 'tshia\u0301nn': '11414', 'lo\u030Dk-ngo\u0301o': '09927', 'phok-bu\u030Dt-kua\u0301n': '08226', 'sia\u0304-hiunn': '13222', 'ka\u0301i-tu\u0302': '10052', 'tsha\u0300u-io\u030Dh-ua\u0302n-a\u0301': '06647', 'bu\u0302n-ha\u030Dk': '01164', 'kha-pua\u0302nn': '10157', 'ji\u0304-tsa\u0301inn': '00122', 'li\u0301-lu\u0304n': '07705', 'te\u0302-a\u0301-iu\u0302': '06574', 'kue\u0301': '07917', 'kue\u0300': '13358', 'sin-la\u0302ng': '09527', 'te\u0304-tia\u0301m': '02426', 'bi\u0304n-tsu\u0301': '05593', 'jio\u0304-hia': '03118', 'ho\u0302o-to\u0302o': '11332', 'the\u0300-hiu': '06725', 'kua\u0302nn': '08312', phang: '10019', 'hia\u0304-io\u0302': '02009', 'ta\u0304ng-tshiu\u0301-tha\u0302u': '05527', 'the\u0300-jia\u030Dt': '06795', 'kua\u0301inn': '21512', 'tha\u0301ng': '07463', 'tha\u0301nn': '06004', 'ku\u0302n-tha\u0302u-sai': '06001', 'khuh-khuh-sa\u0300u': '03729', 'tsha-put-to': '05923', 'kua\u0300-i\u0300': '07417', 'tinn-but-but': '07688', 'tia\u0304n-hue\u0301-kiu\u0302-a\u0301': '10334', 'tshue-hong': '03003', 'tshiong-po\u0302o': '08993', 'siu-tsi\u0300ng': '05715', hoo: '03706', 'kha-tsiah': '01759', 'tsiau-hu\u0302n': '04154', hok: '10695', 'ue\u0304-su\u0302n': '08735', 'ti\u030Dt-ti\u030Dt': '04405', 'ki\u0301ng-tshat-kio\u030Dk': '13071', 'kho\u0301o-ha\u0301i': '05491', 'tshenn-thi\u0302': '04587', 'ku\u030Dt': '09714', 'tua\u0304-jua\u030Dh': '00523', 'thiah-tuann': '04115', 'huan-ah': '08780', 'kho\u0301o-mn\u0302g-a\u0301': '05478', 'tua\u0304-tsi\u030Dh': '00320', 'ho\u0304o-siong la\u0300u-khui\u0300, kiu\u0302 tsi\u0300n-po\u0304o. ': '60093', 'iu\u0302nn-kak-ta\u0304u-a\u0301': '02679', 'khau tsha\u0301u': '12352', 'tshiah-tsang': '03528', 'kia\u0302nn-u\u0304n': '02781', 'lu\u0300-a\u0301': '13322', 'sui\u0301 ba\u0301i bo\u0302 pi\u0301 tsi\u0301, a\u0300i-tio\u030Dh khah-tsha\u0301m si\u0301. ': '60313', 'sio\u0301-sing': '00302', 'se\u0300-i\u0302': '07776', 'ka\u0301u-kang': '04348', 'ma\u0301-ma\u0301-hu-hu': '06880', 'tha\u0300i-mue\u0304': '00969', 'io-tshioh': '09911', 'su\u0304-tsu\u0301': '03549', 'ka\u0301u-kha\u0301ng': '00084', 'hu\u0301n-tsia\u0301u': '06474', 'tio\u030Dh': '09007', 'tsiu\u0301-bu\u0301': '06840', kueh: '03605', 'tua\u0304-se\u0300-sim': '00444', 'tsui\u0301-khok-a\u0301': '01196', 'tshu\u0301-li\u0301': '07854', 'ta\u0304i-khua\u0301n': '09112', 'pui\u0302-tsut-tsut': '13651', 'ka\u0301m-sia\u0304': '09498', 'kam-a\u0301-sik': '05104', 'tshit-kho\u0301ng': '00083', 'si\u0302ng-tsiu\u0304': '02540', 'siu-ji\u030Dp': '02460', 'i\u0300ng-siu\u0302': '12211', 'khui--khui': '09215', 'tui\u0300-tshiong': '10494', 'thui\u0302': '12449', 'thui\u0301': '10787', tsiann: '10725', 'pak-to\u0301o': '09937', 'gia\u0300ng': '13391', 'su\u0304n-gue\u030Dh': '09256', 'khiang-a\u0301': '05831', 'tshing-siu\u0300': '07557', 'kai-tong': '10146', 'gu\u0302-soh': '01268', 'ka\u0301m thang': '08480', 'khia\u0304-sn\u0300g-ko\u0301ng': '07299', 'ka\u0300 ti ka\u0300 ka\u0301u, put-ju\u0302 ka-ki\u0304 tsa\u0301u. ': '60270', 'tsak-tso\u0304': '13293', 'ti\u0300ng-i\u0300': '00751', 'tsia\u030Dh tinn tsia\u030Dh kia\u0302m, tsha\u0300u kha-phi\u0304nn-lia\u0302m. ': '60224', 'hi\u0302-ka\u0301ng': '10622', 'tua\u0304-siu\u0304': '00503', 'bu\u0302-kho\u0301-na\u0304i-ho\u0302': '08617', 'tsu-a\u0301': '06368', 'bia\u0301n-hi\u0302': '12797', 'ba\u030Dk-kia\u0300nn': '02034', 'kang-hue\u0304': '00473', 'ue\u0300--la\u0302ng': '12560', 'khi\u0300-tsui\u0301': '03305', 'u\u0301n-ti\u0304ng': '12859', 'phak-tsha\u0300i': '12640', 'tsu\u0300-ho\u0301-ho\u0301': '09082', 'tsiam-tsi\u0301': '06889', 'a\u0302ng-ko-tshiah-tshi\u030Dh': '05442', 'si\u0301-tsi\u0302nn': '02581', 'siong-a\u0300i': '05295', 'tia\u0301nn-kha\u0300m': '10397', 'tshenn-a\u0301-tsa\u0302ng': '08934', 'khi\u0301-thi\u0302ng': '06771', 'pn\u0304g-tia\u0300m': '09273', 'teh-kiann': '08840', 'ko\u0301o-ke\u0300': '02946', 'ti\u0304m-ue': '11839', 'kong-so\u0301o': '00675', 'tho\u0300-ue\u0304': '05894', 'ka\u0304u': '04785', koh: '10941', 'hioh-kang': '09673', 'sio-sia\u0301m-sin': '05286', 'phue-tsua\u0301': '03257', 'kua\u0302n suann': '13008', 'sio\u0301-ti\u0304': '00328', 'mn\u0302g-bue\u0301-a\u0301': '00937', 'pha-lia\u0300n-ta\u0301u': '04174', 'huan-a\u0301': '08725', 'tsha\u0300i-ke\u0300-a\u0301': '08980', 'tha\u0301ng-kam': '07476', 'oo-tshiu\u0301': '06259', 'tshui\u0300-sui\u0301': '08212', 'ho\u0304': '10008', 'kam-ki\u0300m': '10709', 'ho\u0302': '04269', 'ho\u0301': '02282', 'bu\u0302n-tsiong': '01067', 'tshiong-tu\u030Dt': '11398', 'tsha\u0302-tiam': '06144', 'hu-tshe': '00970', 'ko\u0301o-tshui': '10394', 'khit-tsia\u030Dh ia\u0304 u\u0304 sann ni\u0302 ho\u0301-u\u0304n. ': '60072', 'ji\u030Dp-o\u030Dh': '00160', 'ko\u0301o-tshue': '10393', 'pa\u0302n': '07653', 'ba\u0304n gu\u0302 ka\u0304u-sa\u0301i-jio\u0304. ': '60339', 'pa\u0302i': '08592', 'thiu-tn\u0302g': '04057', 'mi\u0302-si\u0301-mi\u0302-nua\u0304': '10793', 'hua\u0302inn-ti\u030Dt': '11783', 'bue\u030Dh': '13152', 'phia\u0300n-su\u030Dt': '12970', 'kha\u030Dk-hueh': '04802', 'io\u0301ng-ka\u0301m': '04757', 'tia\u0301nn': '10387', 'po\u0304o-lia\u0301n': '03337', 'hainn-hainn-kio\u0300': '05853', 'kak-ngo\u0304o': '13061', 'iu\u0302nn-tsong': '05174', 'ke-ko\u0301ng-ue\u0304': '01631', 'la\u0301ng-a\u0301': '13265', 'kha\u0300u-pe\u0304-kha\u0300u-bu\u0301': '05848', 'tse\u0304-sia\u0302n': '03060', 'pha\u030Duh': '10314', 'liu\u0301-a\u0301': '09187', 'ba\u030Dk-khoo': '02006', 'ok-be\u0301': '08411', 'se\u0301-sin-khu': '05155', 'koh-iu\u0304nn': '02256', 'ji\u0302n-khua\u0302n': '00168', 'gio\u030Dh': '11938', 'gio\u030Dk': '01846', 'sann-kak': '00335', 'ho\u0301-sim': '02307', 'ke-hing': '12732', 'oo-ki\u0300': '06314', 'hue\u0300-tsha\u0301u': '07976', 'ki\u0302-thann': '03635', 'pho\u0301o-pho\u0301o-a\u0301': '08483', 'ha\u0304-siau': '00457', 'tshe\u0301nn': '11986', 'u\u0304-khua\u0301n': '02541', 'tshing-tuann': '07577', 'sann-kap': '05260', 'kho\u0301-gi\u0302': '01597', 'hua\u0304n-se\u0300': '00469', 'tshut-gia\u030Dp': '01579', 'thia\u0300nn-sioh': '06380', 'tsio-bo\u0304o': '04132', 'phah-pia\u0300nn': '04051', 'kua\u0300-ga\u0304i': '07444', 'tsu\u0302n-tshng': '07831', 'tshin-tsia\u0302nn': '11968', 'tong-tiu\u0302nn': '09791', 'khan-gu\u0302': '07606', 'sng-nn\u0301g': '08763', 'tsit-mn\u0304g': '11478', 'khin-pia\u0304n': '10915', 'kong-su\u0304': '00672', 'tu\u0302-mia\u0302': '06842', 'sa\u0300u-tshiu\u0301': '07374', 'ko\u0301o-tsa\u0301': '01475', 'o\u0304o-ping': '03433', 'pu\u0302-hia': '07073', 'tsa\u0301u-sio-jiok': '03455', 'ang-a\u0301-tha\u0302u': '03092', 'tsia\u030Dh-tsha\u0300i': '05661', 'huan-se\u0301': '08770', 'e\u0304 ka\u0304--la\u0302ng e\u0302 ka\u0301u be\u0304 pui\u0304. ': '60202', kuainn: '12935', 'sa\u0301i-pue-khi\u0301': '04892', 'he\u0302-bi\u0301': '11369', tioh: '12177', 'a\u0300n-gia\u030Dh': '05074', 'sio-tak': '05318', 'thik-senn': '06369', 'oo-tsho\u0300o': '06336', 'ba\u0304n-tang': '10542', 'gi\u0301m-tsua\u0302': '12047', 'ti\u030Dk-pia\u030Dt': '06276', thap: '09383', khong: '06111', 'hong-tshue': '05610', 'li\u0304ng': '09809', 'ti\u0301ng-e\u0304': '08041', 'tshut-mn\u0302g': '01500', 'ge\u030Dh-tho\u0302': '01037', 'khi\u0302m-siu\u0300': '09832', 'tsio-kia\u0301nn-sa\u0300i': '04020', 'hia\u0301nn-tha\u0302u': '13355', 'pia\u0300nn-hiat': '04028', 'pha\u0301inn-khu\u0300n': '01092', 'tsa\u0304nn hi\u0302': '13592', 'oo-to\u0304': '06326', 'ta\u0304i-kong': '07811', 'su-ha\u0304': '03362', 'iu\u0301nn-pui\u0302': '06594', 'tiong-su\u0302n': '00659', 'po\u0304ng-ta\u0304ng': '11294', 'la\u0300ng': '11550', 'tshui\u0300-ta': '08250', 'po\u0300o-sin': '01722', thiann: '13260', 'ue\u0304-sa\u0301i': '10120', 'tsiu\u0300-khi\u0301': '07859', 'tsin-sim': '06405', 'mue\u0304': '03774', 'ki\u0302-hi\u0302': '10586', 'n\u0302g-gi\u0300m-gi\u0300m': '09309', 'mue\u0302': '12279', 'sann-a\u0301-tu\u0302': '05531', 'nn\u0300g-ka\u0301u-khang-a\u0301': '12666', 'ho\u0300o': '03901', 'ho\u0301-khua\u0301n': '02385', 'nge\u0304': '08795', 'to\u0300-hia\u0300nn': '05755', 'ti\u0301ng gue\u030Dh-ji\u030Dt': '08050', 'ho\u0302o-liu': '13086', 'khe\u0300-bu\u0301': '04849', 'tho\u0301-tse\u0300-kia\u0301nn': '06779', 'pe\u030Dh-tua\u0300-hi\u0302': '01951', 'io\u0301ng--e\u0302': '11588', 'huat-pia\u0301u': '08751', 'tsha\u0301u-hi\u0302': '06607', 'ing-hue': '13133', 'tso\u0301o-bio\u0304': '06439', 'liu\u0301-a\u0301-khang': '09191', 'tsui\u0301-tsai': '00946', 'sam-ka\u0300i-niu\u0302-a\u0301': '00400', 'si\u0302ng-pu\u0301n': '02478', 'sut-ba\u030Dk-bue\u0301': '07360', 'tsia\u030Dh-mia\u0304': '05616', 'tha\u0300n-la\u0302u-tsui\u0301': '09096', 'kia\u0302nn-ki\u0302': '02749', 'pho\u030Dk': '11013', 'tsia\u030Dh-mia\u0302': '05605', 'thio\u0302ng': '12630', 'thio\u0300-bi\u0301': '13412', 'tshi\u0304 nia\u0301u-tshi\u0301, ka\u0304 po\u0300o-te\u0304. ': '60335', 'pha\u0301inn-ta\u0304i': '00875', 'sio\u0301-ha\u030Dk': '00537', 'ti\u0304-si\u0302': '03858', png: '09598', 'so\u0301o-i\u0301': '04004', 'khi\u0301-ke\u0300': '06791', 'to\u0304-hi\u0304ng': '10213', 'pua\u0300nn gue\u030Dh-ji\u030Dt': '01449', 'gi\u030Dk-thinn': '06714', 'tshiu\u0301-lok-a\u0301': '01170', 'ha\u0300n-ji\u0304': '10651', 'tsha\u0302n-khe\u0300': '01927', 'hiau-hi\u0304ng-tsi\u0302nn': '10427', 'siong-hu\u0302n': '09362', 'tsia\u030Dh-si\u030Dt': '05631', 'pn\u0304g': '09249', 'i\u0302nn': '09381', 'so\u0301': '12687', 'so\u0300': '12243', 'bue\u0304-tsi\u0302ng o\u030Dh kia\u0302nn sing o\u030Dh pue, bue\u0304-tsi\u0302ng ia\u0304-tsi\u0301ng siu\u0304nn ba\u0301n kue. ': '60123', 'so\u0302': '10859', 'nn\u0301g': '07918', 'kong-ho\u030Dk': '02088', 'king-i\u0302ng': '09879', 'kan-hiu': '00308', 'tshut-si\u030Dk': '01521', 'ua\u030Dh-tsi\u0302nn': '05225', 'phua\u0300nn-hue\u0300': '07988', 'lio\u0301ng': '03597', 'suan-po\u0300o': '04880', 'tsi\u0301-ka\u0300u': '05051', 'mn\u0302g-ta\u0301u': '04529', 'phia\u0300n-kio\u030Dk': '12965', 'sim-jio\u0302ng': '07069', 'pha\u0301inn-khang': '00985', 'ta\u0304u-tsha\u0300i-te\u0301--e\u0302': '03487', 'o\u0302ng-ia\u0302': '01274', 'tshi\u0300ng-tsi\u0301': '10292', 'ki\u0304-ji\u030Dt': '03171', 'tshah-hue': '08400', tsiunn: '07712', 'pio\u0301': '12024', 'pio\u0304': '13288', 'hong-to\u0304o': '05626', 'tn\u0304g-na\u0301u-kin': '12535', 'tua\u0304-ko\u0301o': '00502', 'siang-pe\u0302nn-ta\u0300u': '12743', 'pi\u0300-hng': '06406', 'gua\u0302n-tsa\u0304i': '05836', 'gui\u0302-hia\u0301m': '02263', 'ta\u0300ng-lo\u0304o-tsui\u0301': '05806', 'tsua\u0301n-ha\u030Dk': '12676', 'tshi\u0301ng': '11415', 'si\u0301ng-la\u030Dt': '05334', 'a\u0302ng-bi\u0304n-ah': '05422', 'be\u030Dh-a\u0301-tsiu\u0301': '08124', 'ha\u030Dp-pa\u0304n': '02262', 'ti\u0300-hui\u0304': '08490', 'tshiu\u0301 pho\u0304 ha\u0302i-ji\u0302, tsiah tsai pe\u0304-bu\u0301 si\u0302. ': '60105', 'sok-ka': '09428', 'tsiu\u0300nn-kue-a\u0301': '12709', 'tsiu\u0300-phi\u0304nn': '07858', 'kha\u0300u-tu\u0302': '02530', 'ba\u030Dk-iu\u0302': '01920', 'tsa\u030Dh tshia': '10300', 'tua\u0304-kuann-ho\u0301o': '00367', 'tia\u0304nn-tio\u030Dh': '03868', 'bia\u0304n': '05580', 'tshui\u0300-khi\u0301-kin': '08264', 'sio\u030Dk-be\u0304': '04768', 'o\u0304o-hua\u0302inn': '03476', 'ku\u0304-kong': '09907', 'u\u0304-sia\u0300nn': '02555', 'lu\u030Dt-su': '04965', 'sin-sian': '09588', 'ho\u0301-tshio\u0300-si\u0302n': '02362', 'ue\u0304-bo\u0301': '10102', 'tua\u0304-ji\u030Dt': '00265', 'khia\u0300m-hueh': '00929', 'ia\u0301n-tsa\u0300u': '10654', 'ha\u0302n-ba\u0304n': '09311', 'la\u0304u--e\u0302 la\u0304u-po\u0304o-tia\u0304nn, sia\u0300u-lia\u0302n--e\u0302 khah ta\u0301ng-hiannh. ': '60171', 'ui\u0302-ha\u0304m': '12015', 'ngia\u0302': '04503', 'hua\u030Dt-khua\u0301n': '10806', 'tsa\u030Dp-hue-go\u0304o-sik': '00117', 'ka-le\u0301': '08179', 'bu\u0301-ge\u0304': '04325', 'im-li\u030Dk': '08099', 'toh-a\u0301': '06122', 'tsn\u0300g hi\u0304nn': '13440', 'lak-khang': '11103', 'kok-pih': '02252', 'hue-be\u0304-tia\u0302u-ki': '04473', 'kha\u0300u-tia\u0304u-a\u0301': '05867', 'khui-khong': '12392', 'a\u0300m-lo\u0304o': '09648', 'thua-sin-thua-mia\u0304': '04040', 'tua\u0304-pak-to\u0301o': '00484', 'tsha\u030Dt-tha\u0302u': '10164', 'kau-thong': '02085', 'ok-pa\u0300': '08429', 'gia\u0300n': '13251', 'tsua\u0301-tsi\u0302nn': '06547', 'bi\u030Dt-ko\u0300': '07176', 'kua\u0300i--la\u0302ng': '03903', 'tshuah-ping': '13026', 'tshui\u0300-ta\u0301u': '08211', suah: '09721', 'tshiu\u0301-lo\u0304o-tsha\u0300i': '01128', suan: '07455', 'iu\u0304nn': '11189', 'ha\u0302': '11863', 'ha\u0304': '05880', 'hah-tshiu\u0300nn': '04822', 'tha\u0302u-tshiu\u0301': '12074', 'sat-ha\u0304i': '07516', 'tshin-kut-jio\u030Dk': '11965', 'ua\u0301inn': '13514', 'kan-a\u0301': '04399', 'sia\u030Dp-tsui\u0301': '05151', suat: '08037', 'tsa\u0302u': '09324', 'suann-tsha\u030Dt': '00490', 'gua\u0304-kau': '01471', 'sia\u0304nn-na\u0302': '13570', 'lia\u0304u-sn\u0300g': '06081', 'tiau-ko\u0301o-to\u0301ng': '00091', 'king-bio\u0304': '05957', 'gia\u030Dt-khiat-a\u0301-ue\u0304': '12997', 'khit-tsia\u030Dh he\u0304 tua\u0304 gua\u0304n. ': '60073', 'sio-lo\u0304': '11826', 'tha\u0300u-si\u0300-la\u0302ng': '07944', 'sua\u0301n-ti\u030Dk': '12014', 'tsa\u0302n': '11042', 'pia\u0301u-tha\u0302u': '07194', 'tsa\u0302i': '06694', 'la\u030Dt-tsi\u0301': '06116', 'ho\u0300ng': '03984', 'tsiong-sin': '07768', 'khi\u0301-phui\u0300-bi\u0304n': '06743', 'ho\u0300nn': '02283', 'tsa\u030Dp-tsi\u0300': '12757', 'kha\u0301inn': '10562', 'tshiu\u0301-tsih-pho\u0304o-a\u0301': '01140', 'tshuah-sa\u0301i': '06373', 'pu\u0300n-kha\u0301u': '12289', 'oo-pe\u030Dh-la\u0302i': '06268', 'pe\u0302nn-pe\u0302nn': '01700', 'phang-tsui\u0301': '04444', 'tsiap-kha': '07420', 'sia\u0301u ue\u0304': '08773', hong: '05585', 'li\u0301ng-tsi\u0304ng': '02949', 'tshim-khik': '07559', honn: '12976', 'kia\u0300n-si\u030Dp': '03474', 'pia\u0300n': '10180', 'ho\u0300o-tsui\u0301': '03909', 'im--si\u0301': '07554', 'ta\u0301nn-tia\u030Dp': '01784', 'pho\u0302o-sat': '09002', 'po\u0304ng-sim': '11346', 'o\u0301ng-ho\u030Dk': '03933', 'li\u0304 to\u0304ng-pin': '03048', 'tsin-tsi\u0302ng': '06425', 'phi\u0302-khi\u0300': '08945', 'la\u030Dk-ta\u030Dk': '11851', 'tua\u0304-siann-ue\u0304': '00555', 'tua\u0304-khui\u0300-tshua\u0301n': '00429', 'kua\u0302nn-jia\u030Dt-a\u0301': '08344', 'ta\u0304ng-tshiu\u0301': '05526', 'phian-mia\u0302': '06974', 'ti\u030Dk-ha\u0304u-io\u030Dh': '06294', 'hue-khoo': '04485', 'tsi\u030Dt ta\u0301u khah ia\u0302nn ka\u0301u tsio\u030Dh. ': '60008', 'ai-ua\u0300n': '04814', 'tong-ni\u0302': '09774', 'thian-tho\u030Dh': '12967', 'gue\u030Dh-bue\u0301': '00935', 'sio\u0300ng-kong': '05248', 'phi\u0304nn-tha\u0302u': '10987', 'tsue\u0304-gia\u030Dp': '09869', 'ue\u0304-kut': '10131', 'gue\u030Dh-la\u0304i-pa\u0302ng': '00853', 'ko\u0301ng-ho\u0301': '12413', 'na\u0301u-li\u030Dk': '09899', 'ko\u0301ng-ho\u0302': '12417', 'li\u0301ng': '10949', 'ah-a\u0301 thiann lui\u0302. ': '60360', 'in-ia\u0302n': '04863', 'phui\u0300-bi\u0304n': '03734', 'pho\u0301o-phia\u0300n': '08489', 'ha\u0300u-li\u0301': '03077', 'ia\u0304-khi\u0302n': '03815', 'lua\u0304n-se\u0300': '09337', 'phi\u0302-lo\u0302': '06383', hai: '04838', hak: '10817', ham: '13612', 'sua\u0301': '07249', 'sua\u0300': '07746', 'me\u0302-tshia': '10576', 'u\u0301n-sim-a\u0301': '12852', 'tn\u0302g-bue\u0301-tshenn': '04558', 'jio\u0302ng-a\u0301-po\u0300o': '08868', 'thian-pi\u0302ng': '01045', 'thun-lu\u0301n': '02996', hap: '06171', 'le\u0301-tn\u0302g': '12570', 'ka-im': '03571', 'a-phia\u0300n-sian': '11607', 'tsu\u0301n-tsat': '11119', 'tiunn-ti\u0302': '07227', 'khi\u0301-ko\u0302ng': '06736', 'tia\u0300u-ho\u0302ng': '02266', 'hue-m\u0302': '04468', 'ho\u0304o-li\u0302ng': '13196', 'teh-tia\u0304nn': '08811', 'kue\u0300-a\u0301-tsang': '12082', 'tui\u0300-tshiu\u0301': '10484', 'khak-ti\u0304ng': '11292', 'ui\u0302-sa\u0301n': '12008', 'sit-si\u0300n': '01743', 'bo\u0302-thn\u0302g': '08675', 'ba\u030Dt-tsiuh-tsiuh': '07189', 'tui-kiu\u0302': '06734', ngiau: '12518', 'ho\u0304o-huat': '13181', 'kia\u0302nn': '02619', 'ma\u0301-mah': '09445', 'be\u0301-ka': '06917', 'hua\u0304n-ui\u0302': '11328', 'pa\u0302i-tsu\u0301': '08601', 'tue\u0300-la\u0302ng-tsa\u0301u': '10788', 'ti\u030Dt': '04389', 'a\u0302ng-bah-li\u0301': '05412', 'siu\u0304-mia\u0304': '10454', 'pho\u0300ng-se': '11905', 'ji\u030Dt-tsi\u0300': '01147', 'ji\u030Dt-tsi\u0301': '00837', 'tua\u0304-mi\u0304': '00563', 'kho\u0300o-kho\u0300o': '03922', 'si\u0301-hi\u0302ng': '02483', 'ti\u030Dk': '11677', 'ti\u030Dh': '04996', 'tui\u0304-tsi\u0302n': '11035', 'sia\u0304ng': '13624', 'sio-kau-tshap': '05254', 'huan-i\u030Dk': '12621', 'kha\u0301m-tha\u0302u-kha\u0301m-bi\u0304n': '09708', 'sia\u0304nn': '13569', 'kua\u0304nn-tha\u0301ng-a\u0301': '07402', 'kim-a\u0301-tia\u0300m': '04538', 'ji\u0304n-tsin': '10872', 'a\u0304u-tse\u0304': '04945', 'tshin-iu\u0301': '11946', 'tn\u0301g-uan-se\u030Dh-kak': '12682', 'tsha\u030Dk-tsha\u030Dk': '13466', 'ti\u0301n-ta\u0304ng': '06059', 'tua\u0304-ta\u0301nn': '00554', 'tsha\u0300u-kua\u0304nn-sng': '06581', 'ti-kha-mi\u0304-sua\u0300nn': '11494', 'at-tshiu\u0301-pa\u0300': '10198', 'tsio-hue\u0304-a\u0301': '04136', 'kong-khui': '00743', 'hue\u0301-ngeh': '01247', 'tha\u0302u-khak-hia\u030Dh-a\u0301': '12106', 'ik-ling': '09680', 'sin-tsa\u0302i': '03439', 'peh-kua\u0302n-peh-ke\u0304': '13634', 'ta\u0304i-put-lia\u0301u': '00249', 'si\u0301m': '11038', 'lia\u030Dh-kin': '07412', 'tiong-ta\u0300u-tn\u0300g': '00725', 'sn\u0300g-gia\u030Dh': '10775', 'lo\u0301o-mi\u0304': '10633', 'tua\u0304-tsu\u0301-tua\u0304-i\u0300': '00285', 'tso\u0301ng-gia\u030Dh': '12320', 'hua\u0300-ia\u0302n': '01160', tshang: '11358', 'tho\u0301ng-tha\u0302u': '06087', 'uai-ko-tshi\u030Dh-tshua\u030Dh': '05175', 'lim thng': '07077', 'a\u0300m-tha\u0302u-a\u0301': '09659', 'li\u0301-tsa\u0302i': '07690', 'i\u0301m': '09250', 'i\u0301n': '00800', 'tn\u0301g-tsa\u0302i': '12679', soh: '06503', sok: '12285', 'bi\u030Dh': '12278', soo: '09161', 'bi\u030Dt': '10835', 'tshing-tsui\u0301': '07549', 'peh-khui': '12205', 'ho\u0304ng-ho\u0302ng': '10963', 'tinn-gia\u0302n-bi\u030Dt-gi\u0301': '07680', 'tsia\u0300u-ko\u0301ng': '09760', 'a-pah': '04574', 'ga\u0301n-kong': '07677', 'ko\u0301ng-tshio\u0300': '12423', 'ha\u0300m-phu\u030Dh': '12923', 'tsok-lua\u0304n': '02939', 'la\u0304u-kong-a\u0301': '02631', 'heh-kiann': '12167', 'tshui\u0300 tsia\u030Dh, ho\u0304o kha-tshng tshe\u0304-sia\u0300u. ': '60283', 'te\u0302-ko\u0301o': '06623', 'tsha\u0302-tha\u0302u-ang-a\u0301': '06165', 'thi\u0302n te\u0302': '09556', 'thiann-hiunn': '13273', 'ta\u0304u-a\u0301': '03423', 'bi\u0302ng-bo\u0304ng': '02220', 'li\u0302ng-a\u0301': '10295', 'thian-to\u0302ng': '01053', 'pa\u0300i': '04921', 'pho\u0301o-thong': '08481', 'tui\u0300-tshik': '10512', 'sim-kiann-ta\u0301nn-hiannh': '01220', 'hong-thai-ho\u0304o': '05680', 'su\u0304n-lo\u0304o': '09304', 'pe\u030Dh-bo\u030Dk-ni\u0301': '01881', 'tsha\u0300ng': '12625', 'siong-sim': '09335', 'iau-kiau': '03134', 'bu\u0302n-bu\u0302n-a\u0301-tshio\u0300': '00865', 'kan-sia\u030Dp': '00430', 'kah-be\u0301': '01946', 'ian-tshia\u0302ng': '09741', 'iu-bu\u0304n': '11113', 'kham-gia\u0304m': '07091', 'be\u0304-ki\u0300-tit': '06675', 'la\u0301n-si': '12816', 'khi\u0301-tia\u0304nn': '06782', tshiong: '11382', 'si\u0304n-tio\u0304ng': '09476', khu: '03769', 'bo\u0302-tu\u0301-ho\u0301': '08634', khi: '08543', 'khi\u0300ng-tsiok': '11107', 'phua\u0300-pak': '06435', 'liam-tsha\u0302n-enn': '04014', 'kho\u0300ng-tshn\u0302g': '12814', 'khe-poo': '09686', kha: '13642', 'gu\u0302-tshui\u0300-am': '01272', khe: '09672', 'a\u0304inn-kin': '06950', 'a\u0302ng-bue\u0301-tang': '05413', 'piau-tsu\u0301n': '11209', 'hi\u0302ng-kun': '02707', 'ta\u0304m-po\u030Dh-a\u0301': '07591', 'u\u0304-lo\u0304o-i\u0304ng': '02559', 'tshi\u0300-gia\u0304m': '10080', 'be\u0304-su': '06685', 'ba\u030Dt-tsa\u030Dt': '07193', 'ta\u0302n-sann-go\u0304o-niu\u0302': '08042', 'ti\u0304ng-si\u0300ng': '03853', 'la\u0304i-te\u0304': '00657', 'i\u030Dk-tha\u0301ng': '06217', 'la\u0304i-te\u0301': '00674', 'khia\u0300n-lo\u0301o': '04483', 'the-tsu\u0302n': '11111', 'tsio\u030Dh-to\u0304ng': '01932', 'i\u0300n-tshui\u0300': '12201', 'thiann-ko\u0301ng': '13278', 'la\u0302i-pin': '03588', 'kheh-tsia\u0301u': '04895', 'sua\u0300nn-soh': '11326', 'a\u0302ng-tsiu\u0301': '05429', 'hue\u0304-kua\u0301n': '09658', 'tshin-ba\u030Dk': '11952', 'ki\u0301n-tshiu\u0301': '10789', 'tsu\u0301-kak': '01338', 'tsha\u0302i-ho\u0302ng-tia\u0300m': '09051', 'a\u0304u-piah': '04984', 'khenn-kau': '03057', 'tshu\u0300-khe\u0300': '05850', 'tso\u030Dh--ji\u030Dt': '05017', 'pua\u0300nn-tshenn-si\u030Dk': '01470', 'siu-kang': '02467', 'tsia\u0301-bo\u0301': '03790', 'khi\u0301-moo ba\u0301i': '06715', 'ngia\u0302-la\u0304u-jia\u030Dt': '04658', 'u\u0304-lio\u0304ng to\u0304 u\u0304 hok. ': '60163', 'tshoo-hui\u0302': '07783', 'tui-pui\u0302': '07127', 'ki\u0300-a\u0301': '11994', 'phah-tshik-sue': '04185', 'tn\u0302g-ni\u0302-tsha\u0300i': '04548', 'tha\u0301ng-kua\u0304nn': '07479', 'ta\u0304u-kia\u0302m': '03530', 'tia\u0302u-khua\u0301n': '07521', 'sio-ia\u0301n': '05288', 'tik-su\u0301n': '02760', 'tse\u0304-tse\u0304': '12258', 'hua\u0304n-tsia\u0301': '07272', 'ka-lo\u0301-a\u0301': '06604', 'lio\u0301ng-kong': '03641', 'tsi\u0300m': '06177', 'ku\u0300-ta\u0304u': '01641', 'tia\u0304nn--khi\u0300': '03847', 'tsi\u0300n': '09131', 'mn\u0302g-kha\u0301u': '04520', 'hok-sam': '10701', 'tsiam-tshia': '06848', 'o\u0304o-kue\u0301-khiau': '03503', 'nua\u0304-tho\u0302o': '13139', un: '11917', 'kue\u0300-tsui\u0301': '10195', 'siu\u0300nn': '05244', 'su\u0300-kui\u0300': '01491', 'ti\u0301ng-bi\u0304n': '08071', 'se\u0300-lia\u030Dp-tsi\u0301': '07785', 'ke-tshi\u0301ng': '12744', 'si\u0302-se\u0300': '06072', 'phue\u0300-tha\u0302u': '06908', 'khong-am': '07305', 'ang-i\u0302': '03103', 'tsiu\u0301-la\u0302u': '06900', 'sia\u0300u-ba\u030Dk': '11153', 'oo-ta-sa\u0301n': '06313', 'tsi\u030Dt la\u0302ng tsi\u030Dt ke ta\u0304i, kong-ma\u0301 sui\u0302 la\u0302ng tsha\u0304i. ': '60001', 'tsa\u0302i-gua\u0302n': '06781', 'iu\u0300-lo\u0304o': '01807', 'e\u0304-hia\u0301u': '09656', 'tian-to\u0300': '12966', 'ho\u0304o-tha\u0302u': '01176', 'la\u0300u-tho\u0300o-tsi\u0300ng': '09928', 'kang-gia\u030Dp': '00474', 'i\u0301ng-pa\u0301i': '03946', 'kiann-la\u0302ng': '13318', 'kua\u0301': '10471', 'kua\u0300': '10821', 'ho\u0302o': '12963', 'tong-ti\u030Dt': '09782', 'khi\u0301ng': '04437', 'n\u0302g-kim': '09276', 'lu\u0302n-li\u0301': '05776', 'phi\u0302': '01862', 'phi\u0301': '10892', 'lia\u0302n-ha\u030Dp': '12339', 'tha\u0300i-ki\u030Dk-ku\u0302n': '01111', 'tshi\u0304-ke\u0300': '01815', 'tshiah-tsa-bo\u0301o': '03663', 'pui\u0300-a\u0301-hu\u0301n': '09772', 'hua\u0302n': '12447', 'kim-hi\u0302': '04627', 'bo\u030Dk-bo\u030Dk-siu\u0302': '03314', 'ho\u0300ng-pn\u0301g': '04143', 'hu\u0301n-tn\u0302g-a\u0301': '06482', 'tn\u0301g-tua\u0304-la\u0302ng': '12658', 'tsha\u0302n-hn\u0302g': '01981', 'ki\u0302-tha\u0304i': '08521', 'kha-tsiah-a\u0304u': '01761', 'siu\u0302-tsui\u0301': '04282', 'tse\u0300-hia\u0300n': '07737', 'hi\u0302-tio\u0300-a\u0301': '08150', 'phui\u0300': '03073', 'po\u0301-pio': '04782', 'kha\u0301m': '09662', 'bo\u0304ng-tia\u0302nn': '10460', 'kua\u0300n-tshia\u0302ng': '13141', 'sng-thiu-thia\u0300nn': '08742', 'tshua\u0304-lo\u0304o-ke': '13548', 'ho\u0301-gia\u030Dh': '02428', 'ho\u0301o-phue\u0302': '04542', 'kha\u0301u': '00191', 'ti\u0302ng-pue\u0304': '05546', 'pe\u0302nn-poo': '01752', 'pa\u0300ng-tshiu\u0301': '03998', 'tn\u0302g-te\u0301': '04631', 'bi\u0302-bi\u0302-a\u0301': '09492', 'be\u0301-be\u0304': '09119', 'sa\u0300': '09330', 'go\u0304o-gue\u030Dh-tseh': '00635', 'to\u0301o-tio\u0300ng': '03388', 'kap-tsua\u0304': '06067', 'thi\u0301ng-si\u0304ng': '12819', 'hua\u0304n-tsue\u0304': '01992', 'i\u0302nn-a\u0301-thng': '09397', 'tsu\u0302n-hue\u0300': '02378', 'tshing-te\u0302': '07571', 'tha\u0304i-gu\u0304': '04978', 'iu\u0301nn-tsui\u0301': '06566', 'tsa\u0301u-be\u0304-khui-kha': '03466', 'sok-io': '03332', 'tshenn-me\u0302 niau ka\u0304-tio\u030Dh si\u0301 nia\u0301u-tshi\u0301. ': '60198', 'pn\u0304g-pau': '09261', 'ue\u0304-ang-a\u0301': '08736', 'ki\u0302-li\u0302n': '12979', 'tsi\u0301ng-tse\u0302': '11724', 'ui\u0302-tshiu\u0302nn': '08306', 'khik-khui': '02951', 'tshut-be\u0304': '01615', 'tshi\u0304ng': '05332', 'to\u0300-khau': '05780', 'khi\u0304-tshn\u0302g': '03178', 'gua\u0304-ha\u0302ng': '01478', 'ua\u0304nn-tshiu\u0301': '08453', 'bua\u0301n': '10601', 'o\u0302-a\u0301-mi\u0304-sua\u0300nn': '07848', 'sit-gue\u030Dh': '10840', 'tso\u0301ng-kio\u0304ng': '12292', 'kui-sim': '07877', 'tiau-khik': '12038', 'ji\u0304': '10952', 'iu\u0302nn-ka\u0301ng': '02751', 'khi\u0301-pau': '11610', 'pa\u0300ng-hue\u0301': '04003', 'ji\u0301': '00201', 'go\u0304ng-si\u0302n': '13458', 'tsha\u0300i-tha\u0302u-kue\u0301': '08998', 'kia\u0302m-ko\u030Dk-ke': '13100', 'ko\u0301ng-tio\u030Dh tsia\u030Dh, tsing-phua\u0300 hia\u030Dh. ': '60370', 'tshiah-bah': '03436', 'tn\u0302g-a\u0301-siu\u0302nn': '09918', 'tshia\u0301nn-mn\u0304g': '11477', 'kho\u0300o': '11920', 'to\u0300ng-sua\u0301n': '09795', 'ba\u0302i': '05322', 'bi\u0302n-a\u0301-tsa\u0301-khi\u0301': '04222', 'kuann-tsha\u0301u': '08947', 'sio\u0304ng-kho\u0300': '00527', 'tso\u0300ng': '10006', 'hua\u0304n': '12448', 'hm\u030Dh-hm\u030Dh': '11669', 'hi\u0302-kuann-iu\u0302': '08130', 'kue\u0300-khui\u0300': '10235', 'bo\u0302-lu\u0304n': '08695', 'ua\u0301nn-ti\u0304': '09825', 'pit-tsik': '08905', 'sit-bi\u0302ng': '01738', 'ka-li\u0304ng': '12505', 'senn-ji\u030Dt': '01879', 'ba\u0304ng-a\u0301': '10791', 'tsua\u0301-phue': '06523', 'tha\u0300u-me\u0302': '08008', 'tshiah-ki': '06080', 'sit-tsong': '01837', 'tha\u0300-hue\u0301': '05020', 'hiann-ti\u0304-tsi\u0301-mue\u0304': '01336', 'tsa\u0300i-sann': '02142', 'tia\u0301m': '12486', 'tia\u0301n': '05905', 'ti\u0300n-te\u0300': '12712', 'tia\u0304n-sua\u0300nn': '10371', 'bah-ta\u0304u': '02676', 'to\u0300--khi\u0300': '05750', 'tshun-tsi\u0302nn': '11976', 'tua\u0304-bi\u0304n-si\u0302n': '00408', 'tsa\u0301-tn\u0300g': '02561', 'tua\u0304-la\u0302ng senn-ji\u030Dt tsia\u030Dh bah, gi\u0301n-a\u0301 senn-ji\u030Dt tsia\u030Dh phah. ': '60079', 'kia\u0300n-sia\u0300u-ta\u0304i': '03464', 'ok-po\u0300': '08414', 'su\u0304-bu\u0304-so\u0301o': '03575', 'thui-tsi\u0300n': '07414', 'kho\u0301-li\u0302ng': '01532', 'kan-hio\u0302ng': '02388', 'king-tsio tho\u0300o kia\u0301nn ui\u0304 kia\u0301nn si\u0301. ': '60092', 'tsia\u0300u-hoo-tsia\u0300u-kia\u0302nn': '09754', 'ku\u030Dt-liu-liu': '09740', 'mui\u0302-kui\u0300-hue': '04422', 'e\u0304-tit-thang': '09636', 'tio\u030Dh-kip': '09032', 'tsia\u0302nn-mi\u030Dh': '02504', 'tsha\u0300u-hi\u0304nn-la\u0302ng': '06583', 'kha-a\u0304u-tenn': '10123', 'tsu\u0304-tsun-sim': '02747', 'siu\u0304-tsue\u0304': '03686', 'ga\u0300n': '13615', 'phiah-tsi\u0304ng': '11006', 'ko\u0301o-le\u0304': '10401', 'bu\u030Dt': '13609', su: '11981', 'kann-siu\u0302': '10699', si: '10031', so: '07258', sa: '06015', 'tik-khoo': '02786', se: '02845', 'lia\u0302ng-tsui\u0301': '07501', 'o\u0302o': '08571', 'sio-kim': '11822', 'sio-kik': '05308', 'pi-tsha\u0301m': '08360', 'tsiap-siu\u0304': '07371', 'si\u030Dt-hia\u0304n': '10507', kong: '03224', 'tshia\u030Dk': '12160', 'khah-phi\u0300nn': '01453', 'to\u0300-ta\u030Dh': '05789', 'tshut-su\u0302n': '01482', 'tia\u0304n-hue\u0301-po\u0300o': '10331', jia: '11516', 'ka-tiu\u0301nn': '05939', 'phia\u030Dk': '08379', 'pa\u0300ng-hueh': '04029', 'la\u0302i-la\u0302i-khi\u0300-khi\u0300': '03563', 'siang-tshe-lo\u0304o': '12695', 'la\u0304ng-la\u0302u': '03208', 'tsia\u0300m-ui\u0304': '10423', 'tse\u0300-kn\u0300g': '09346', 'khah-ke': '10200', 'kua\u0301n-tha\u0304i--i': '10751', 'it-ti\u030Dt': '00021', 'a-kong': '04524', 'so\u0300o-lio\u0304ng': '11166', 'bi\u0302ng': '02126', 'ta\u0302u-a\u0301': '10957', 'po\u0304o-hu\u0304n': '08043', 'la\u0302m-ho\u0304o': '07564', 'gia\u0300n-sian-ko': '13268', 'ngia\u0302-sin-khi\u0300-ku\u0304': '04639', 'san-bi\u0302ng-ha\u0301i-se\u0300': '00477', 'sio\u0301-tn\u0302g': '00482', 'ho\u0302o-si\u0302n-ho\u0301o': '05459', 'kia\u0301nn-ji\u0302': '02192', 'iau-gia\u030Dt': '03139', 'ua\u030Dh-lo\u0304o': '05216', 'kua\u0301i-phia\u0300n': '04182', 'put-tik-i\u0301': '00720', 'the\u0300-hun': '06767', 'toh-kha': '06158', 'mi\u030Dh': '04343', 'iu\u0302-la\u0304u-a\u0301': '04316', 'lia\u0302u-lia\u0302u-a\u0301': '07824', 'thi\u0301ng': '07928', 'tsia\u0304n': '11426', 'tsia\u0304m': '11141', 'khia\u0304 kua\u0302n suann, khua\u0300nn be\u0301 sio that. ': '60282', 'ko-kui\u0300': '06886', 'it--la\u0302i': '00019', 'tsu\u0304-jia\u0302n': '02754', 'pa\u0300ng-nn\u0304g': '04030', 'khi\u0300-khua\u0302n': '07529', 'ti\u0301ng-a\u0301': '09463', 'pah-ji\u030Dt-a\u0302ng': '02638', 'sia\u0304ng-khua\u0301n': '13630', 'bo\u0302-bue\u0301-ha\u0304ng': '08625', 'kha-a\u0301': '10099', 'ke\u0300-na\u0302-a\u0301': '04493', 'ti-tsiok': '04403', 'ji\u030Dt--si\u0302': '01030', 'tam-su-ia\u0302nn': '11728', 'lu\u0304n-a\u0301': '07214', 'sua\u0304inn': '12223', 'phu\u0302-to\u0302': '10015', 'tsang-tshi\u0301ng-a\u0301': '08531', 'thuh-phua\u0300': '12495', 'tshia\u0301m-a\u0301': '13010', 'tsa\u030Dk-tio\u030Dh': '10432', 'bi\u0302n-tso\u030Dk': '01773', 'tshat-a\u0301': '12525', 'si\u0301-ba\u030Dk': '02480', 'ui\u0302-hua\u0301n': '10197', 'lia\u0304u-soh': '12603', 'tang-tsha\u0300i': '01566', 'kue\u0300-ni\u0302': '10211', 'sio\u0304ng-te\u0300-kong': '00388', 'khiam-hi': '12432', 'le\u0301-ma\u0304u': '12571', 'u\u0304n-mia\u0304': '10221', 'mua\u0301': '10602', 'khang-tshui\u0300': '04410', 'ke\u0301nn-tio\u030Dh': '05862', 'mua\u0302': '08114', 'ua\u0304nn-a\u0302ng': '08468', 'tshim-khenn': '07556', 'si\u030Dt-si\u030Dp': '10508', 'si\u030Dt-te\u0304': '10489', 'a-sa-puh-luh': '04559', 'tho\u0300o-a\u0301': '03634', 'tu\u0304n-to': '09179', 'mo\u0302o-tha\u0301n': '01088', 'hong-tia\u0302u-u\u0301-su\u0304n': '05689', 'kiat-tia\u0304u': '02167', 'bo\u0302-bi\u0302n': '08655', onn: '09379', 'io\u030Dh-te\u0302': '12887', kuat: '07872', 'gi\u0301n-a\u0301-enn': '02163', 'ti\u0300-sin-mia\u0304': '05415', 'i\u0302-pia\u0301u': '04853', 'tho\u0301ng': '06010', kuai: '03534', kuah: '04922', 'pia\u0301u-sio\u0301-mue\u0304': '04523', kuan: '12936', 'i\u0302ng-kang': '09183', 'siong-thian-ha\u0304i-li\u0301': '09336', 'kin-kut': '08894', 'so\u0301ng-khua\u0300i': '07615', 'tsu-le\u0302-ke\u0302': '06391', 'bi\u0302n-a\u0301-tsa\u0300i': '04224', 'ka\u0301u-sat': '04381', 'ko-kip': '06876', 'mi\u0302-nua\u0304': '10812', 'm\u0304-kam': '00889', 'tsi\u0302nn-mua\u0302': '12063', 'kuann-si': '03846', 'ka\u0304u-ta\u0304ng': '04815', 'pah-ki\u0301ng-ku\u0302n': '02841', 'tha\u0301n-khi': '03750', 'tik-hio\u030Dh': '02775', 'tsho\u0300ng-pa\u0304n': '08265', 'o\u0301o-sim-kuann': '05019', 'pu\u0300n-so\u0300-tshia': '12303', 'thio\u0300': '13411', 'hue-thia\u0302u': '04492', 'kio\u0304ng-sa\u0301n': '02222', 'ji\u0301m-na\u0304i': '03185', 'iu\u0300-kia\u0301nn': '01707', 'niu\u0302-tsha\u0301u': '12604', 'a\u0304u-tsan': '04993', 'kuan-tshat': '13431', 'tshu\u0300-hia\u0304': '05835', sak: '06018', 'ba\u0304u-tha\u0302u': '09123', sai: '02844', 'so\u0300ng-pha\u0300n--e\u0302': '03108', san: '00205', sam: '00170', 'khua\u0300nn-hia\u0304n-hia\u0304n': '05359', 'li\u0302ng-tan': '13368', 'sio-ki\u0304ng': '05297', 'tsa\u0302i-lia\u0304u': '03256', 'hi\u0302ng-se\u0300': '03199', 'hu\u0301n-gio\u0302': '06495', 'kia\u0302nn-tsu\u0302n tsa\u0301u be\u0301 sann hun mia\u0304. ': '60173', sau: '07490', sat: '11364', 'thui-lu\u0304n': '07431', 'hiu-sik': '02081', 'tui-kiu\u0300': '06737', 'tshi\u0300-tik-su\u0301n': '03647', 'ge\u0304-su\u030Dt': '12891', 'tsio\u030Dh-a\u0301': '01885', 'tshik-tsia\u0301u-a\u0301': '08080', 'thinn-ue\u0304': '07586', 'ta\u0300u-tso\u0300-hue\u0301': '06881', 'ta\u0304ng-kang': '07050', 'ba\u030Dk-tsiu khua\u0300nn ti\u0304 kue\u0301, kha ta\u030Dh-tio\u030Dh hue\u0301. ': '60139', 'lia\u0304u-li\u0301': '06065', 'ta\u0304ng-tho\u0301o': '07049', 'kik-khang': '11784', 'lia\u0301u-tsi\u0302nn': '00162', 'mn\u0302g-kha': '01120', 'oo-kui': '06346', 'ko-tiong': '06832', 'la\u0304u-put-siu': '02632', 'ia\u0302m-a\u0300ng-a\u0301': '13405', 'khi\u0300-hun': '06199', 'khua\u0300nn-tshut-tshut': '05338', 'phi\u0304nn-phang': '10982', 'tia\u0304nn-tso\u0300': '03861', 'the\u0302-gi\u0304': '08428', 'ta\u0304m-tsui\u0301': '07546', 'lo\u0304o-tha\u0302u': '10271', 'to\u0301-sia\u0300u': '05788', 'la\u0300u-the': '09959', 'ji\u0302n-tsi\u0302ng-se\u0300-su\u0304': '00143', phik: '11600', 'tsa\u0301-ba\u0304n': '02565', phih: '13045', 'tsua\u0304nn': '12543', phit: '00782', 'tshin-to\u0302ng': '11966', 'hit-lo\u0304': '03938', 'su-ji\u030Dp': '11990', 'hu\u0302-tshi\u0302': '03183', 'ho\u0302-khe': '04310', 'ut-ta\u0301u': '11226', 'sun-sa\u0300i': '05949', 'ka\u0302u-gi\u0301n-a\u0301': '08623', 'tha\u0300n sio': '09121', ling: '01647', 'sia\u0304n': '13606', 'tshua\u0304-sin-pu\u0304': '07141', 'bi\u0301-tsiu\u0301-tha\u0302u-a\u0301': '02726', 'tsi\u030Dt la\u0302ng hua\u0302n-lo\u0301 tsi\u030Dt iu\u0304nn, bo\u0302-la\u0302ng hua\u0302n-lo\u0301 tshin-tshiu\u0304nn.': '60003', 'ka-li\u0301': '03737', 'bia\u0301n-kio\u0301ng': '04754', 'siang-hong': '12698', 'pe\u030Dh-tsia\u030Dh': '01938', 'a\u0302u-u\u0304n': '08267', 'pe\u030Dh-li\u0304ng-si': '01959', 'hue-pa-li-niau': '04488', 'tshun-tshiu\u0301': '02894', 'pia\u0300nn-su-ia\u0302nn': '04167', 'tu\u0302-a\u0301': '12813', tshiunn: '10592', 'lo\u0302-kang': '08205', 'tha\u0302u-khak-tshue\u0301': '12107', 'huah-lin-long': '08232', 'pun be\u0304 pe\u0302nn, phah kah ji\u0304-ka\u0301u-me\u0302. ': '60098', 'the-ko': '11123', 'sit-bo\u0304ng': '01771', 'tso\u0300 kong-tshin, thiap pu\u0301n. ': '60258', 'ng-ng-iap-iap': '07401', 'lim te\u0302': '07070', 'khan-tshia': '07616', tuann: '08272', 'koh-tsa\u0300i': '10943', 'tsio-hoo': '04045', 'bo\u030Dk-mua\u0302-ho\u0302ng': '01075', 'he\u0304': '03352', 'tsi\u0301-iau': '01004', 'pi\u0300-iu\u0304': '03176', 'he\u0302': '11363', 'ha\u0304m-bi\u0302n': '08073', 'tshiam-ji\u0304': '12857', 'tha\u0300n-tsia\u030Dh-la\u0302ng': '09099', 'ti\u0301ng-si\u0300-la\u0302ng': '08053', 'hue\u0301-ti\u0304': '01283', 'thih-khi\u0301': '13194', 'su\u0300-si\u0302n-thng': '01531', 'kiat-ping': '08873', 'han-tsi\u0302-hu\u0301n': '08784', 'pua\u0302nn': '11244', 'tha\u0301ng-khoo': '07482', 'kho\u0302-tha\u0302u': '05505', 'bu\u0302-lua\u0304': '10882', 'hi\u0304nn-tsu': '02716', 'ka\u0302nn': '02973', 'ki-khi\u0300': '11762', 'mi\u0302-hiu\u0302': '08533', 'kiat-si\u030Dt': '08909', 'sio\u0301-khua\u0301-a\u0301': '00291', 'tiu\u0302nn-ha\u030Dp': '08284', 'thia\u0300nn-bo\u0301o-tsha\u0300i': '06374', 'siu-sim': '02469', 'pi-tsia\u0304n': '03692', 'ue\u0304-tshenn': '11396', 'kan-a\u0301-sun': '06961', 'khi\u0302ng-hun': '11286', 'to\u030Dh-hue\u0301': '09019', 'lo\u030Dh-pui\u0302': '09948', 'tshi\u0300-kue-a\u0301': '03640', 'khan-ka\u0302u-a\u0301': '07635', 'tui\u0300-hua\u0301n': '10483', 'tsi\u0302n': '12846', 'tsi\u0302m': '12631', 'tsia\u030Dh-pia\u0304n-nia\u0301-hia\u0304n': '05622', 'tsun-ki\u0300ng': '08340', 'khi\u0300-phut-phut': '06198', 'puann-sua\u0301': '09564', 'bi\u0302ng-phi\u0300nn': '02149', 'io\u0304ng-sim': '01880', 'pa\u0304ng-kiu\u0302': '08529', 'jiu\u0302-hi\u0302-kenn': '13084', 'sn\u0300g-pua\u0302nn': '10772', tsun: '08314', 'kua\u0302n-to\u0304o': '13015', 'sia\u0300-tsue\u0304': '07998', 'hi\u0300-khik': '12190', 'tsui\u0301-ke-siu\u0302': '01203', 'tsha\u0302-hi\u0302': '06155', 'ang-a\u0301-bi\u0304n': '03090', 'ka\u0301m-o\u0302o': '13543', 'kha\u0301m-kha\u0301m-khia\u030Dt-khia\u030Dt': '03046', 'tsui\u0301-la\u0302i-a\u0301': '01060', tsut: '03616', 'tsio\u030Dh-pa\u0302i': '01971', 'put-ji\u0302-ko\u0300': '00664', 'khit-tsia\u030Dh': '00404', 'a\u0301': '01310', 'ui\u0300': '09248', 'ui\u0302': '05193', 'hi\u0302-a\u0301-tshi\u0304': '08121', 'ui\u0304': '05389', 'oo-a\u0300m': '06319', 'ki-khi\u0300-tha\u0301ng': '11763', 'khai-ki-tso\u0301o': '09209', 'tua\u0304n': '12522', 'ua\u0302n-hun': '03116', 'kui\u0301-thi\u0300-tha\u0302u': '06864', 'phue-si\u0300n': '03249', 'a\u0304m-se\u0302': '12093', 'tshiu\u0302nn': '12779', 'hah-hi\u0300': '04817', 'phiau-tha\u0302u': '11214', 'ki-te\u0304': '07117', 'thio\u0301ng-a\u0301-poo': '09396', 'u\u0304-la\u030Dt': '02461', 'a\u0302ng-ba\u030Dk': '05407', 'hi\u0300-i\u0304nn': '12200', 'bah-hi\u0302-a\u0301': '02746', 'hua\u0300n': '07911', 'tshing-hue\u0301': '07550', 'tshi\u0300n-a\u0301': '06453', 'tsia\u030Dt-u\u0304n': '07421', 'ku\u0301n-tsui\u0301': '10604', 'a-tiu\u0304nn': '04521', 'hia\u0300n-ping': '11696', 'tshng-kho\u0300o': '05719', 'gi\u0304-tsu\u0301': '09849', 'li\u0301ng-ka\u0300u': '10966', 'tsiunn-sann': '11204', 'tse\u0301nn-tsui\u0301': '00622', 'tu\u0304--si\u0301': '11579', 'bo\u0302 khi\u0300': '08615', 'hi\u0304nn-khang-ta\u0304ng': '02695', 'suann-ho\u0302': '00489', 'hue\u0301-tshenn': '01262', 'khi\u0301-ta\u0302ng': '06772', 'pe\u030Dh-thn\u0302g-tshang': '02022', 'to\u0302ng-sim': '02147', 'tio\u0302ng-sin': '05562', 'tshut-tha\u0302u-thinn': '01626', 'ba\u0302ng': '06557', 'khi\u0302n-bu\u0304': '09360', 'tsa\u0304i-se\u0300': '02153', 'kiat-uan': '08889', 'tia\u0300m-a\u0301': '03845', 'khia\u0304m-tn\u0302g-neh-to\u0304o': '11002', 'hue\u0304-ha\u030Dp': '09616', 'a\u0304u-ni\u0302': '04941', 'tsi\u0300ng-bi\u0302ng': '12921', 'khi\u0301-kha-ta\u0304ng-tshiu\u0301': '06785', 'ho\u0304o-i': '04554', 'tsu\u0300-bi\u0302ng': '09093', 'li\u0302-ba\u0302': '06312', 'ka\u0302u ia\u0304 e\u0304 pua\u030Dh-lo\u030Dh tshiu\u0304-kha. ': '60302', 'pha\u0300nn-tsio\u030Dh-a\u0301': '00651', 'ka\u0304u-sa\u0301i': '04812', 'tha\u0301u tiong-khui\u0300': '08452', 'hu\u0301n': '06451', 'a\u0302ng-tshang-a\u0301-tha\u0302u': '05446', 'oo-hi\u0302-tsi\u0301': '06306', 'sa\u0301m-hu\u0301n': '12297', 'ta\u0304u-po\u0302o': '03508', '--lih': '05813', 'tsa\u0304i-senn tsi\u030Dt lia\u030Dp ta\u0304u, khah ia\u0302nn si\u0301-lia\u0301u pa\u0300i ti-tha\u0302u. ': '60146', 'tha\u0301n-khi-sin': '03751', 'bi\u0304-la\u0302i': '01727', 'te\u0304-it': '07718', 'kui\u0300-tio\u0304ng': '09097', 'tiong-kan': '00741', 'si\u0302n-bi\u0302ng': '06464', 'ji\u030Dp-mn\u0302g': '00118', 'po\u0301-tsi\u0300ng': '04780', 'tshik-hue\u0300-siu\u0304': '04701', 'pe\u0304nn-i\u0304nn': '06379', 'tho\u0302': '06109', 'ka\u0300u-su': '07387', 'phua\u0300-ke-tshi\u0301ng': '06441', 'ko-li\u0301': '06831', 'sng-kam-tinn': '10907', 'pa\u0304n-tshio\u0300-bi\u0304n': '03191', 'ia\u0300n-o': '11836', 'gua\u0301n': '03415', 'ji\u0302n-tso\u0304': '00146', 'pho\u0300ng-hong': '11902', 'li\u0302-a\u0301': '13435', 'oo-tho\u0302o': '06318', 'ua\u0302n-tsua\u0302n': '03093', 'sio-e-sio-kheh': '05282', 'li\u0302n': '11518', 'li\u0302m': '12333', 'tsih-sann': '10581', 'pe\u030Dh-tsia\u0301nn-bo\u0302-bi\u0304': '01911', 'oo-niau': '06342', 'ka\u0301u-kang-io': '04349', 'tshit-tho\u0302-tsa-bo\u0301o': '13562', 'sik-hok': '07297', 'ba\u030Dk-tshiu\u0304nn': '00903', 'tsu-bi\u0304': '08630', 'pa\u0300i-ha\u0304u': '04964', 'tshut-sai': '01520', 'hi-hua': '09041', 'ngeh-a\u0301': '03041', 'ta\u0304i-the\u0300': '01369', 'pa\u0302n-gi\u0302': '04690', 'na\u0302-a\u0302u': '12801', 'siau-tia\u0304nn': '06280', 'sua\u0300nn-lo\u0304o': '11333', 'la\u0304i si\u0302n thong gua\u0304 kui\u0301. ': '60095', 'to\u0300-tshiu\u0301-pi\u0302ng': '05748', 'tshio\u0300-khue': '06484', 'tsu-pa\u0302ng': '06132', 'tsua\u030Dh': '05910', 'tsua\u030Dt': '08856', 'huat-i': '04324', 'tshang-a\u0301': '11366', 'ti-hueh': '11447', 'sio\u0301-suat': '00511', 'to\u0302ng-si\u0302': '02212', 'tn\u0302g-a\u0301-ia\u0304m': '09919', 'tong-su\u0304-ji\u0302n': '09775', 'ia\u0304 tio\u030Dh tshue\u0302, ia\u0304 tio\u030Dh mue\u0302. ': '60071', 'ga\u0302u': '13506', 'thia\u0300u-ta\u0302ng': '10254', 'tia\u0304n-tshia': '10342', 'tso\u0302-tha\u0302u': '11177', 'ga\u0302n': '12778', 'ga\u0302m': '12264', 'kia\u0301m-tho\u0301': '12232', 'sa-bui': '03331', 'tshenn-su\u0301n-su\u0301n': '04584', 'pat-sian-toh': '00089', 'an-sim': '02310', 'an-sin': '02341', 'sia\u0301m-sih': '06923', 'ba\u030Dk-sat': '00991', 'sio-tha\u0300ng': '05284', 'kah-ha\u030Dh-le\u030Dh': '02012', 'tsin-si\u030Dt': '06438', 'tua\u0304-mia\u0302': '00309', 'a\u0300i-a\u0301': '11648', 'gi\u0301n-a\u0301-kang': '02155', 'mi\u0304-tha\u0302u': '13113', 'tio\u030Dh kua\u0302nn-jia\u030Dt-a\u0301': '09038', pok: '11011', 'tiong-ta\u0300u-pn\u0304g': '00724', 'im-bo\u0302o': '08101', 'tsiu\u0301-pue': '06853', 'tsha\u0300i-kua\u0301n': '08997', 'thuat-tsa\u0301u': '07820', 'tiu\u0302nn-so\u0301o': '08290', 'bo\u0302-he\u0304-lo\u030Dh': '08604', 'sua\u0300nn-hiunn': '11325', 'tsia\u0302n-pue\u0300': '04769', 'a\u0300m-kha\u0300m': '09627', 'lia\u030Dh-ka\u0302u': '07409', 'khui-to': '09180', 'tsha\u0300i-tsia\u0301u-a\u0301': '08987', 'khang-tshui\u0300-po\u0304o-tsi\u030Dh': '04411', 'tsa\u030Dp-ji\u0304-gue\u030Dh tsia\u030Dh tsha\u0300i-tha\u0302u, la\u030Dk-gue\u030Dh tsiah tn\u0301g-sa\u0300u. ': '60054', 'tsu\u0301-tsia\u030Dh-ku\u0302n-a\u0301': '08650', 'ni\u0302-koo-am': '01734', 'tshi\u0300-tik': '03646', 'ko\u0300ng-tsing': '09592', 'tua\u0304-pia\u0300nn-sa\u0300u': '00451', 'pu\u0300n-so\u0300-la\u0301ng': '12305', khainn: '07339', 'ji\u0302n-tiong': '00082', 'sua\u0300nn-ti\u0304n': '08473', 'sin-hun': '09561', 'pha\u0301inn-kia\u0301nn': '00904', 'ta\u0304u-tsiu\u0300nn': '03524', 'kua\u0301i-a\u0301': '05098', 'ta\u0304i-to\u0302ng-a\u0301': '00313', 'pi\u0304nn': '13046', 'tam-tng': '11718', 'sia\u0300u-pho\u0304o': '11180', 'ha\u030Dt': '01309', 'bi\u0302n-tshn\u0302g-pang': '06412', 'khua\u0300n-ka\u0301i': '12994', 'tn\u0304g': '12265', 'la\u0304u-po\u0304o-tia\u0304nn': '02673', 'o\u0301ng-ni\u0302': '03914', 'kua\u0302nn-sann': '08333', 'lo\u030Dk-jio\u0302ng': '08144', 'ngo\u0301o-lo\u0304o': '00759', 'pha\u0302ng-te\u0302': '06056', 'khit-tsia\u030Dh sin, ho\u0302ng-te\u0300 tshui\u0300. ': '60074', 'tsi\u030Dt ni\u0302 ua\u0304nn ji\u0304-tsa\u030Dp-si\u0300 e\u0302 tha\u0302u-ke. ': '60015', 'ji\u0304-tia\u0301n': '02345', 'hue\u0301-ke': '01300', 'po\u0304ng': '11273', 'huat-ko\u0302ng': '08737', 'tsok-ui\u0302': '02926', 'tsha\u0302-tha\u0302u': '06163', 'kia\u0302nn-a\u0304u-bue\u0301-mn\u0302g': '02704', 'tsi\u030Dt-ji\u030Dt-ka\u0300u-a\u0300m': '00007', 'tu\u0302n': '07804', 'tha\u0300i-po\u0301': '00994', 'suann-lu\u0304n': '00436', 'tia\u0302u-ti\u030Dt': '07509', 'ua\u0301n-tshin': '10930', 'tsia\u0302n': '04714', 'thian-ti\u0302ng': '01026', 'pha\u030Dk': '12808', 'tsu-a\u0302ng': '02511', 'ua\u030Dh-beh': '05210', 'khio\u0300-siu\u0301': '01512', 'oo-sim-kuann': '06262', 'tsia\u0302u': '10974', 'put-to\u0304ng-sa\u0301n': '00715', 'hue\u0300-bue\u0301': '07957', 'sia\u0300ng': '10533', 'pok-hun': '11034', 'siang-pi\u0302ng': '12701', 'phun-tsui\u0301': '11193', 'ho\u0301o-tshi\u0300n-tha\u0302u': '07068', 'sia\u0300nn': '09882', 'li\u0304ng-ji\u030Dt': '01446', 'hio\u0302ng-hio\u0302ng': '09299', 'ua\u0301nn': '09805', 'tia\u0300m-tha\u0302u-ke': '03884', heh: '12159', 'ha\u0304u-sua\u0301n-ji\u0302n': '05794', 'the\u0300-sin': '08519', 'ti\u0301ng-pua\u0300nn-sin': '08057', 'me\u0301-hue\u0301': '07607', 'sia\u0301nn-mih': '07125', 'si\u030Dt-gia\u0304m': '10528', 'tin-sioh': '05289', 'hia\u0301m': '12027', 'hia\u0301n': '13310', 'sio\u0304ng-ke': '00287', 'lia\u0302n-hue\u0302': '07950', 'pi\u0301ng-to\u0304o-sua': '00949', 'thinn-kong thia\u0300nn go\u0304ng-la\u0302ng. ': '60099', 'tso\u0300-kang': '06949', 'khua-kha\u0301u': '10094', 'siu\u0300-khi\u0300': '03381', 'tsong-gia\u0302m': '07834', 'thih-gu\u0302-a\u0301': '13174', 'la\u0302ng-la\u0302ng': '00069', 'na\u0302-tsa\u0302n': '13037', 'tshian-tshiu': '13384', tshenn: '04515', 'uan-iunn': '12152', 'o\u0301ng-sing': '03912', 'i\u0300n-siann': '12215', 'le\u0301-so\u0300o': '12573', 'kong-bi\u0302ng': '02076', ah: '12123', ak: '03295', am: '11519', 'thn\u0302g-tsui\u0301': '11868', an: '02291', 'tshi\u0304-tiu\u0301nn': '01740', 'm\u0304 tsai-ia\u0301nn': '00989', au: '11811', at: '10183', 'ba\u030Dk-kang': '00838', 'ah-nn\u0304g': '12135', 'ko-kia\u0300n': '06849', 'tho\u0302o-kat-tshu\u0300': '09414', 'tse\u0304-kann': '03058', 'siau-sa\u0301n-lo\u030Dh-bah': '06334', 'li\u0301-hi\u0302ng': '06037', 'tsua\u0301n-tsia\u030Dh': '12420', 'sng-a\u0301': '06119', 'tsu\u0304': '05471', 'tsha\u0302-keh': '06166', 'tsu\u0300': '13280', 'tsu\u0301': '08591', 'tsu\u0302': '08195', 'pu\u0304-la\u0302ng': '10524', 'pu\u030Dt-tso\u0301o': '02930', 'si\u0300ng': '03898', 'tsa\u0301u-be\u0304-li\u0304': '03467', 'to\u0302ng-ka\u0301m': '02241', 'khah-tua\u0304-bi\u0304n': '10188', 'i\u0300n-to\u0302ng': '02218', 'lo\u0302o-se\u0301': '13035', 'tshi\u0300-mo\u0302o-tha\u0302ng': '03632', 'tsha\u0301i-sik': '07218', 'kia\u0300n-sia\u0300u': '03462', 'sio\u0301-ji\u0302-ba\u0302-pi\u0300': '00355', 'phah-tn\u0304g tshiu\u0301-kut tian-to\u0300 io\u0301ng. ': '60187', 'na\u0304i-sim': '05399', 'po\u0304o-ui\u0304': '08063', 'ki\u0302-to\u0301': '05377', 'nua\u0300': '11980', 'nua\u0301': '11089', 'nua\u0302': '13123', 'nua\u0304': '13126', 'te\u0301-tshi\u0300ng': '08833', 'tshing-tsi\u0304ng': '07574', 'kai-jia\u0302n': '10143', 'sue-bue\u0301-to\u0304-ji\u0302n': '06663', 'the\u0300nn-tha\u0302u': '08699', 'the\u0301-bi\u0304n': '13339', 'ia\u030Dh': '13314', 'pe\u030Dh-tsha\u030Dt': '01997', 'tha\u0300i-kok-pua\u030Dt-a\u0301': '06214', 'tua\u0304-a\u0302ng-hue m\u0304 tsai ba\u0301i, i\u0302nn-a\u0301-hue ba\u0301i m\u0304 tsai. ': '60086', 'tua\u0304 tia\u0301nn bue\u0304 ku\u0301n, se\u0300 tia\u0301nn tshia\u0302ng-tshia\u0302ng-ku\u0301n. ': '60091', 'su\u0302n-kim': '06525', 'go\u0304ng-siu\u0304nn': '13460', 'ia\u030Dt': '11687', 'tshui\u0300-tshiu': '08270', 'n\u0302g-tsiu\u0301': '09284', 'ke-kia\u0301m': '01563', 'tsi\u0302ng-ji\u0302n': '07261', 'ia\u0300n-hue\u0304': '05951', 'pa\u0304n-se\u0300': '11331', 'ti-ka\u0301u-tsing-senn': '11464', 'tsit-tsa\u0304m': '07975', 'sio\u0304ng-gua\u0302n-me\u0302': '00254', 'tsiu-tsi\u0300': '03724', 'khi-hu\u0304': '08562', 'tha\u0302i--si\u0301': '02994', 'gu\u0302-tia\u0302u': '01250', 'sa\u0300u-bo\u0304ng': '07423', phiann: '03954', 'to-khing': '00154', 'suah-ho\u0302o-tsio': '11105', 'pa\u0304i': '07341', 'pha\u0301inn-tsi\u0300ng-tha\u0302u': '01044', tu: '13488', 'pia\u0301n-si\u030Dt': '04962', to: '08027', 'tshe\u0300nn': '13639', 'ko\u0301o-bu\u030Dt-siong ': '02917', ti: '11418', te: '05190', ta: '12268', 'tsi\u0301-tia\u0301m': '05073', 'tsia\u0301u-la\u0302i-a\u0301': '08145', 'tha\u0302u-pe\u030Dh': '12090', 'lia\u0302n-hue-kim': '11350', 'se\u0300-ta\u0304i': '01330', 'kiann-senn-hu\u0304n': '13324', 'bu\u0302n-ge\u0304': '01206', 'bo\u0302 a\u0300i': '08676', 'thua\u0304': '03294', 'tsiat-iok': '09855', 'pa\u0300ng-tsha\u0300u-phui\u0300': '04095', 'lo\u0304o-ting': '10268', 'pho\u0302o-tha\u0301nn': '03188', tshui: '10537', tshuh: '07665', tshun: '11940', 'gua\u0301': '03153', 'si\u0300-kha-to\u0304o-ti\u0304ng': '01589', 'kak-sik': '03435', 'a\u0300m-ho\u0304': '09647', 'li-li-lo-lo': '05855', tshue: '04333', sang: '12784', 'tsi\u030Dt-sut-a\u0301': '00026', sann: '05508', 'sia\u0302-si\u0304': '07481', 'ki\u0300-khi\u0301': '12013', 'pua\u0301nn-hi\u0302': '11617', tshut: '13090', 'a\u0304u-pe\u0304': '04956', 'suann-tang-o': '00402', 'tua\u0304-sun': '00418', 'tsing-si\u0302n': '10757', 'ngia\u0302-ting': '04660', 'oo-pe\u030Dh': '06267', 'hio\u0302ng-ho\u0302ng-tsiu\u0301': '09301', 'tsio\u030Dh-lia\u0301n': '02011', 'kip-sio-a\u0301': '08916', 'iu\u0302nn-a\u0301-ba\u030Dk': '02646', 'ka\u0300u-bu\u0304': '07396', 'ka\u0301m-kik': '09496', 'tsui\u0301-tsinn': '01083', 'phah-ji\u0304-ki': '04024', 'la\u0302i-o\u0301ng': '03565', 'kua\u0301n-tha\u0304i': '10750', 'ki\u0300m-khui\u0300': '09820', 'ba\u0302-ji\u0302-tik': '11955', 'tso\u0304-lo\u0304o': '08006', 'tsu-lia\u0304u': '10128', 'ti-sim': '11435', 'tsi\u0302nn-tsng': '12046', 'bo\u0301--e\u0302': '01739', 'tsoh-sit': '02953', 'mia\u0304': '03709', 'ji\u030Dp-lia\u0304m': '00165', 'lo\u0302ng-kun': '05534', 'mia\u0302': '11187', 'i\u0300nn-o\u0300nn': '08260', 'phua\u0300-po\u0300o-tsi\u0301': '06409', 'khi\u0304-pia\u0301nn': '05132', 'lia\u0301n-po\u0301': '11127', 'la\u0301ng': '13255', 'gua\u0302n-pu\u0301n': '05833', 'lio\u0300ng phue\u0304': '13344', 'tsu\u0301-ia\u0300u': '01357', 'the\u0302-a\u0300n': '08405', 'kha-tshng-a\u0304u': '01681', 'tso\u0301o-tshu\u0300': '06417', 'io\u0302 bue\u0301': '09536', 'kha-ke\u0302': '10127', 'tsa\u0301u-sio-lia\u030Dh': '03454', 'ha\u0301n-kia\u0302nn': '03374', 'bu\u0301-ta\u0302i': '10825', 'sa-long-pa-suh': '03341', 'o\u0301o-khang': '05034', 'a\u0300ng-phi\u0304nn': '13402', 'tsui\u0301-tso\u0302': '01156', 'pi\u0304ng': '03532', 'tshit-tho\u0302-mih-a\u0301': '13561', 'kiunn-si': '12394', 'tsha\u0300i-toh': '08981', '--leh': '04786', 'tsi\u030Dt tshui\u0300 kua\u0300 siang tsi\u030Dh. ': '60026', 'tho\u0301o-ti\u0304-kong': '00317', tshioh: '00798', 'kun-su\u0304': '05537', 'ka\u0301u-ge\u0302': '04352', 'uan-siu\u0302': '05743', 'siu\u0301nn-kim': '11466', 'tsai-si\u0301': '04401', 'phang-kue': '04450', 'bah-tsa\u0300ng-tseh': '02791', 'bia\u0301n-le\u0304': '04777', 'lo\u030Dh-la\u0302ng-e\u0302-tshui\u0300': '09900', 'tshia\u0300ng-siann': '07090', 'io-tshi\u0304': '03390', 'ka\u0301i-to\u030Dk': '10044', 'siat-li\u030Dp': '07882', 'tsuann-io\u030Dh-a\u0301': '09745', 'hua\u0300n-be\u0304': '08014', 'piau-pu\u0301n': '11197', 'ta\u0300u-la\u0304u-jia\u030Dt': '06906', 'a\u0302ng-mn\u0302g-tho\u0302o': '05402', 'pi\u0302ng-an': '01710', 'tsia\u0300m-ue\u0304': '10433', 'ke sa\u0301i lo\u030Dh tho\u0302o, ia\u0304 u\u0304 sann tshu\u0300n ian. ': '60379', 'tshi\u0304 kia\u0301nn bo\u0302-lu\u0304n pn\u0304g, tshi\u0304 pe\u0304-bu\u0301 sn\u0300g tn\u0300g. ': '60334', 'tsi\u030Dt tsiah gu\u0302 pak siang nia\u0301 phue\u0302. ': '60022', 'mua\u0302-la\u0301u': '08174', 'o\u0301ng-ji\u030Dt': '03906', 'kim-hun': '04618', 'si\u0300n-sim': '04721', 'to\u030Dk-to\u030Dk': '11838', 'ba\u030Dk-ba\u0302i': '01936', 'tsa\u0301-tsai': '02588', 'ua\u0300nn': '06096', 'kah-sim-bah': '05401', 'peh-ji\u0304': '00098', 'an-io\u0301ng': '02417', 'mo\u0302o-su\u030Dt': '13219', 'mua\u0301-i\u0300': '10624', 'kiann--si\u0301': '13325', 'tsia\u030Dh kue\u0301-tsi\u0301 pa\u0300i tshiu\u0304-tha\u0302u; tsia\u030Dh bi\u0301-pn\u0304g pa\u0300i tsha\u0302n-tha\u0302u. ': '60223', 'khia\u0304-ting-ko': '07303', 'be\u0304-hia\u0301u': '06684', 'tn\u0300g-i\u0300n': '10337', 'o\u0301o-tho\u0302o': '05059', 'tshua\u0300n-ko\u0301ng': '02952', 'lia\u0302n-tsiau-hue': '11353', 'khi\u0301-pue': '11614', 'khai-ka\u0301ng': '09235', 'sn\u0300g-huat': '10749', 'sua-sua\u0300nn': '03336', 'ba\u0304n-tshia\u0301nn-si\u0304': '10541', 'ti\u0301ng-pa\u0301i': '08104', 'kia\u0300-kim-pho\u0304o-a\u0301': '07182', 'i\u0301-ki\u030Dp': '01329', 'ah-tsiu\u0301nn': '12144', 'hi\u0302-tha\u0302u': '08165', 'ui\u0300-jua\u030Dh': '05302', 'pha\u0302ng-ta\u0301u': '06030', 'ka\u0301i-sim-bu\u0304n': '10033', 'kik-lia\u030Dt': '11791', 'ti-kuann-sik': '11454', 'sim-si\u0302n': '01046', 'lia\u0302n-lo\u030Dk': '12360', 'ka\u0301m-sim': '09462', 'sn\u0301g-si\u0302n': '09555', 'phah-thong-kuan': '04111', 'kim-a\u0301': '04535', 'tsha\u0300u-hue\u0301-hun': '06572', 'tiong-ko\u0301o': '00640', 'liu\u0301-ting-tsiap': '05096', 'khak-a\u0301-hia\u0302n': '08554', 'to\u0304ng-ia\u0302u': '07080', 'ba\u030Dk-tsiu-mn\u0302g': '01988', 'sim-kuann-tha\u0302u': '00952', 'po\u0301o-io\u030Dh': '10077', 'bi\u0302ng-tsai': '04237', 'sa-te': '03327', 'ka\u0304-tshui\u0300': '04821', 'be\u0301-la\u030Dt': '06828', 'ho\u0301o-tha\u0302u-kam': '04665', 'tsi\u030Dt gue\u030Dh-ji\u030Dt': '00006', 'se\u030Dh-le\u0302-thui': '10934', 'kui-sin-khu': '07886', 'i\u0302ng-hi\u0304ng': '10577', 'ho\u0302ng-hun': '09274', 'tia\u0300u-tia\u0301nn': '02245', 'a\u0304u-liu\u0301': '04974', 'bo\u0302ng-hu\u0302n': '00514', 'lo\u0304ng-hui\u0300': '06225', 'to\u0301o-khi\u0300': '11473', 'se-hong': '02848', 'bue\u0304 tsia\u030Dh go\u0304o-ji\u030Dt-tseh tsa\u0300ng, phua\u0300 hiu\u0302 m\u0304 kam pa\u0300ng. ': '60124', 'sua\u0300nn-o\u030Dh': '08494', 'bo\u0302-lo\u0304o-la\u0302i': '08682', 'bi\u0301-king': '02767', 'ke-si\u030Dt': '12766', 'bu\u0301-kia\u0301nn-i\u0301': '01708', 'jio\u0304-tsu\u0304-a\u0301-kauh': '03110', 'tsiap-tshiok': '07446', 'ui-hong': '04854', 'khi\u0301-ke-bo\u0301-phue\u0302': '06805', 'te\u0304-ki': '02368', 'si\u0304-li\u030Dk': '09017', 'king-kah': '04465', pang: '04207', 'siu-tso\u0302ng': '02589', 'pa\u0301-tsui\u0301': '10329', 'tsi\u0302ng-li\u0301': '07283', 'pue\u0304-tsheh': '05404', 'ia\u0302n-sua\u0300nn': '10311', 'pho\u0300ng-se-sann': '11906', 'lo\u030Dh-tu\u0300': '09946', 'kho\u0300 suann suann e\u0304 pang, kho\u0300 tsui\u0301 tsui\u0301 e\u0304 ta. ': '60353', 'ta\u0301n-lo\u0304o': '08907', 'siu\u0304-i': '10453', 'tshut-la\u0302ng': '01628', 'la\u0304n-si\u0302n': '13523', 'bo\u0304-kue\u0301': '11853', 'si\u0304-sua\u0304': '11880', 'tua\u0304-e\u0304': '00236', 'tso\u0300-ji\u0302n-tsi\u0302ng': '06947', 'tia\u0304n-po\u0300': '10356', 'huann-tha\u0302u-hi\u0301-bi\u0304n': '13243', 'ke\u0300-ang': '09442', 'tshiu\u0304-ba\u030Dk': '11739', 'ho\u0304o-su\u0304': '13169', 'pn\u0304g-sia\u030Dh': '09269', 'kau-tsi\u0302ng': '02083', 'lia\u0301u-jia\u0302n': '00150', 'thiah-ko\u0301o': '04056', 'ba\u0301ng-a\u0301': '13047', 'kok-tse\u0300': '07148', 'ho\u0302o-li\u0302-tsiann': '04371', 'au-kia\u0302m-tsha\u0300i': '10675', 'tha\u0300u-bue\u0301': '07958', 'tshit-kha-tshng': '04938', 'ko\u0301ng-pe\u030Dh-tsha\u030Dt': '12412', 'pua\u030Dh-pue': '09153', 'su\u0304n-tshiu\u0301': '09255', 'pha\u0301inn-tshui\u0300': '01076', 'huan-kiunn-a\u0301': '08783', 'tshue kue\u0301': '04378', 'tshio\u0300': '06450', 'tshio\u0304': '05186', 'thih-ki': '13179', 'huat-su': '04300', 'gi\u0301n-a\u0301-kia\u0301nn': '02157', 'io\u030Dh-tsa\u0302i': '12883', 'tsha\u0300u-ling-tai': '06575', 'thiah-sua\u0300nn': '04116', 'niu\u0302-a\u0301-kia\u0301n': '05891', 'pn\u0304g-a\u030Dh-a\u0301': '09291', 'phi-a\u0301': '04005', 'pa\u0300i-ho\u0301ng': '04970', 'lo\u0302o-su\u0301n': '13034', 'hiah-ni\u0304-a\u0301': '10262', 'lu\u0302n-pan': '11533', 'tua\u0304-sim-khui\u0300': '00275', 'sa\u0300ng-le\u0301': '06804', 'tshin-su\u0304': '11954', 'siang-tshiu\u0301': '12697', 'le\u0301-pa\u0300i-tn\u0302g': '12568', 'se\u030Dh-lia\u0300n-tn\u0301g': '10935', 'tsho\u0300o': '11521', 'pua\u0300nn-si\u0300-la\u0302ng': '01460', 'sann hun la\u0302ng, tshit hun tsng. ': '60060', 'kho\u0301ng-sik': '07766', 'tshi\u030Dk-a\u0301-mi\u0304': '10574', 'ko\u0302o': '11308', 'kia\u0302nn-tshun': '02705', 'ho\u0301o-tshiu': '04677', 'tshin-tsia\u0302nn-go\u0304o-tsa\u030Dp': '11970', 'ko\u0300o-sann-tn\u0300g': '13208', 'thinn-i\u0300': '01104', 'tshi\u0301ng-kiu\u0302': '11449', 'u\u0304 tsia\u030Dh koh u\u0304 lia\u030Dh. ': '60160', iaunn: '08196', 'pa\u0304-tshi\u0304': '11347', 'hi\u0302-tshi': '08170', 'm\u0304-bia\u0301n': '00932', 'hi\u0302-tsho': '08166', 'tsha\u0301i-ke': '11537', 'bi\u0301-ta\u0302i': '02620', 'gua\u0304-gua\u0304': '01463', 'khi\u0301-kia\u0302nn': '06730', 'tua\u0304-lo\u0304o': '00497', 'ko\u0301o-phio\u0300': '04476', 'ta\u0300u-sann-ka\u0304ng': '06866', 'niu\u0304-a\u0301': '09185', 'ma-la\u0301-so\u0301ng': '06852', 'sia\u0300u-li\u0301': '00833', 'loh-a\u0304u--ji\u030Dt': '09956', 'tsha\u0300u-la\u0304u': '06579', 'to\u0301-tia\u0300m': '05759', 'hui-tua\u0302nn': '05681', 'phia\u0304ng': '12977', 'senn-tn\u0302g': '01993', 'suann-ti': '00532', 'kak-si\u0300': '03490', 'kim-ka\u0302m': '04556', 'kue\u0300-po\u0304ng': '10266', 'su\u0304-si\u030Dt': '03586', 'tshu\u0300': '02452', 'oo-tshiunn': '06350', 'tshu\u0304': '09129', 'tsi\u030Dt-kua\u0301-a\u0301': '00037', 'senn-ue': '02031', 'phi\u0304nn-si\u030Dt': '10990', 'pia\u0304n-lu\u0304n': '13193', 'gu\u0302-tsi\u0301ng-a\u0301': '01284', 'mn\u0302g-kn\u0301g': '01143', thuah: '05981', 'khua\u0300nn-e\u0304-khi\u0301': '05367', 'kha-tha\u0302u-u': '10165', 'thi\u0300-tha\u0302u-tia\u0300m': '04776', 'tn\u0302g-te\u0301-kha-ue\u0304': '04632', 'tha\u0300u-ho\u0304o': '07964', 'lo\u0304o-tse\u0300': '10245', 'ti-ko-ge\u0302': '11469', 'gi\u0301-gia\u0302n': '10867', thuat: '07805', 'tua\u0304 ti\u0304n': '00432', 'po\u0300o-tha\u0302u-po\u0300o-bue\u0301': '01826', 'ka\u0301m-to\u0304ng': '09480', 'sim-gua\u0304n': '01208', 'sn\u0300g': '12577', 'senn-sua\u0304inn-a\u0301': '02028', 'se-thian': '02847', 'oo-niau-tsi\u0301--a\u0301': '06343', 'i\u0304nn': '06815', 'kha\u0301m-ue\u0304': '09699', 'tia\u0301m-sim-ta\u0300nn': '12491', 'tsiah-ni\u0304': '11541', 'i\u0304ng': '01853', 'i\u0302ng-gia\u030Dp': '12253', 'tn\u0302g': '04509', 'pha\u0302ng-tsu\u0302n': '02377', 'ho\u0302ng-hu\u0301-tse': '03505', 'ko\u0304-ko\u0304-lia\u0300n': '11914', 'tsi\u0302ng-hi\u0302ng': '07267', 'gu\u0302-pi': '01296', 'tinn-te\u0302': '07689', 'sua-bo\u030Dk': '03334', 'ti\u0301-kho\u0300ng': '04035', 'bi\u0304n-ti\u0301ng': '05651', 'ko\u0300ng-ua\u0302n': '06707', 'ling-tshui\u0300-a\u0301': '01781', 'a\u0301m-mue\u0302-a\u0301': '04322', 'pho\u0300ng-phue\u0302': '11897', 'ke-si': '05934', 'tsia\u0300u': '09746', 'khua\u0300nn-mia\u0304-sian': '05349', 'bi\u0301-kuan': '05466', 'i\u0300ng-hu\u0300': '12186', 'si\u0302n-kio\u0304': '06496', 'siu-tang': '02475', 'ngo\u0301o-a\u0301': '13528', 'tsin-tsia\u0302nn': '06436', 'iam-ke': '12060', 'tu\u0301-tio\u030Dh': '04127', 'hua\u0301n-tui\u0300': '01139', 'tu\u0300n': '09168', 'tsia\u0300n': '11674', 'tsia\u0300m': '01399', 'tshah-ki': '08399', 'kue-le\u030Dh-a\u0301': '10014', 'pau-ko\u0301': '01604', 'hua\u0300n-a\u0301': '07943', 'tsha-gia\u030Dh': '05965', 'u\u0304-tsi\u030Dt-ji\u030Dt': '02456', 'to\u0304o-tn\u0302g': '03389', 'tso\u0302ng-tsi\u0302nn': '09373', 'the-i\u0301': '13545', 'tsha\u0300u-ua\u0302n': '06564', 'i\u0301-a\u0301': '08517', 'se\u0300-tha\u0302u': '09374', 'ho\u0304o-sann': '04590', 'se\u0300-kan-la\u0302ng': '01373', 'tshiong-tsiok': '01339', 'pho\u0300ng-i\u0301': '11909', 'kha\u0300-iu\u0302': '10578', 'tshut-la\u030Dt': '01425', 'tshit-a\u0301-khue': '04847', 'tsha\u0302n-tsoo': '01944', 'hu\u0302n-phik': '10969', 'hue\u0304-sia\u0304': '09623', 'ki\u0302-ji\u0301': '08510', 'tshia\u0301n': '07535', 'tshia\u0301m': '13000', 'a\u0304u-bue\u0301-mn\u0302g': '04948', 'nia\u0301u-tshi\u0301-tng': '08157', 'io\u030Dh-pa\u0302ng': '12884', 'pia\u0300n-khia\u0300u': '13356', 'bo\u0302-tiunn-ti\u0302': '08665', 'si\u0302-pia\u030Dt': '12916', 'ji\u0304n-to\u0302ng': '10864', 'tsa\u0301-khu\u0300n': '02542', 'li\u030Dp': '01870', 'sian-tsha\u0301u': '01362', 'soo-ua\u0301n': '07703', 'kenn-sua\u0300nn': '09876', 'hit khua\u0301n': '03934', 'hui\u0300-ue\u0304': '11077', 'hia\u0301ng-hok': '03587', 'kia\u0301m-tia\u0301m': '12235', 'ka\u0300u-ha\u030Dk': '07433', 'kia\u0301m-si\u0301ng': '08561', 'u\u0304': '02450', 'ho\u030Dk-si\u030Dp': '08357', 'u\u0301': '04514', 'u\u0300': '07592', 'sia\u0300-bia\u0301n': '07956', 'ki\u0302ng': '11277', 'bo\u0302-tsho\u0300': '08698', 'sian-ji\u0302n phah ko\u0301o iu\u0301 si\u0302 tsho\u0300, kha-po\u0304o ta\u030Dh-tsha sia\u0301nn-la\u0302ng bo\u0302? ': '60116', 'ta\u0300m-sue\u0302': '10962', 'ki\u0302nn': '10446', 'tia\u0300u-tsi\u030Dp': '01571', 'tha\u0301ng-a\u0301': '07469', 'kai-si\u0301': '10106', 'a\u0302ng-tsi\u0302m': '05455', 'khua\u0301n-khn\u0300g': '08568', 'tsha\u0301-na\u0304u': '03023', 'tshia\u0301nn-la\u0302ng-kheh': '11431', 'tshut-u\u0304n': '01591', 'sai-pak-ho\u0304o, lo\u030Dh be\u0304 kue\u0300 tshia-lo\u0304o. ': '60174', 'bah-pia\u0301nn': '02793', 'si\u0302ng-i\u0300 tsia\u030Dh tsui\u0301 tinn. ': '60330', 'bio\u0302': '08382', 'sui\u0302': '12026', 'tsu\u0301-khua\u0302n': '01385', 'bio\u0301': '05331', 'si\u0302ng-khu\u0301n': '10166', 'bio\u0304': '11045', '--hngh': '05821', 'an-the\u030Dh': '02324', 'hui-huat': '04680', 'tsho\u0301ng-po\u0304ng': '11404', 'tshu\u0300-pinn': '05871', 'tsha\u0300i-tn\u0302g': '08983', 'sio-ka\u0304ng': '05251', 'la\u0304i-kho': '00692', 'sia\u0301u-sia\u0301u': '08769', 'tshin-tshiu\u0301': '11947', 'tsiam-ku\u0300': '06846', 'pe\u030Dh-ko\u0301ng': '02030', 'ta\u0304ng-ta\u0300nn': '05571', 'pho\u0300ng-hong-ku': '11903', 'si\u0300-tsia\u0300nn': '01467', 'pua\u0300nn-lo\u0304o': '01592', 'tsi\u030Dk-bo\u030Dk': '07192', 'tn\u0302g-to\u0304o': '09936', 'io-la\u0304i-bah': '09909', 'lia\u0304m-tsu': '03930', 'thih-ting-a\u0301': '13184', 'pa\u0301-sui\u0304 e\u0302 tiu\u0304 a\u0301, tha\u0302u le\u0302-le\u0302. ': '60336', 'la\u0304ng-tshui\u0300-hue': '03197', 'pi\u0301n-a\u0301-kut': '13371', 'ti\u0300-bo\u0304-a\u0301': '12203', 'ko\u0301-jia\u0302n': '04251', 'lia\u0302ng-ti\u0302ng': '07512', 'tshu\u0300n': '00202', 'tshin-la\u0302ng': '11944', 'tsha\u030Dp-tsha\u030Dp-nih': '06424', 'hang-hi\u0302': '11618', 'kho\u0301o-kang': '05476', 'gu\u0302-phi\u0304nn-khian': '01286', 'sok-te\u0302-sim': '12298', seh: '08036', 'su\u0300-ha\u0301i': '01527', 'po\u0301-sioh': '12990', 'tsia\u030Dh-tsiunn': '05683', 'tshiu\u0301nn-tha\u0302u-pio': '09584', 'ia\u030Dh-si\u0304': '03250', 'lo\u0301o': '11601', 'tse\u0300-khua\u0302n': '09377', 'khah-a\u0301': '13264', 'tho\u0301o-ue\u0304': '00487', 'pha-tshia-lin': '04041', 'tso\u0300 kuann phia\u0300n tshu\u0300-la\u0304i, tso\u0300-sing-li\u0301 phia\u0300n si\u030Dk-sa\u0304i. ': '60261', 'ho\u0300ng-su\u0300': '04140', 'te\u0302-pue': '06589', 'tiu\u0304-tsha\u0301u': '11296', 'ji\u030Dp-bo\u030Dk': '00086', 'khi\u0300-sin-lo\u0301o-mia\u0304': '06192', 'to\u0304ng-tu\u030Dt': '11104', 'pua\u0300-ki-kah': '12865', 'kiann--la\u0302ng': '13317', 'bo\u0302-lo\u0304o-i\u0304ng': '08681', 'sio-ki\u0300nn': '05259', 'su-huat': '01494', 'te\u0301-n\u0301g': '08802', 'tsia\u0301n-liu\u0301-a\u0301': '07013', 'ka\u0301m-sio\u0301ng': '09490', thok: '13645', 'tshiu\u0301-khiau': '00915', 'iu\u0302-la\u0302i': '01913', 'sio-ko\u0300': '05258', 'ta\u0304i-kah-tshio\u030Dh': '00305', 'n\u0302g-gu\u0302': '09258', 'ka\u0300u-i\u0304ng': '07116', 'po\u0301-ke': '04747', 'ang-sa\u0300i': '06539', hiat: '02615', hiau: '10407', 'bo\u0302ng': '10315', 'tshua\u0300n': '11857', 'kue\u0300-ji\u030Dt': '10194', 'siann-siann-ku\u0300-ku\u0300': '12378', 'phiat-a\u0301': '13536', hiah: '10185', hian: '07317', 'tshia\u0301nn-ba\u0304n': '01377', 'tso\u0301o': '06402', 'lak-lia\u0301n': '09998', 'tsha\u0300u-tshe\u0300nn': '06619', 'khu\u0304': '03601', 'khu\u0302': '09126', 'be\u0304-huan-tshia': '13648', 'oo-a-tshui\u0300': '06339', 'mn\u0302g-tshua\u0300nn': '04589', 'si\u0300-la\u0302m-sui\u0302': '01546', 'tshi\u0304ng-tshah': '05362', 'io\u0301ng-io\u0301ng be\u0301 pa\u030Dk ti\u0304 tsiong-kun-thia\u0304u. ': '60201', 'hong-kui\u0304': '05704', 'lia\u0301u-kang': '00077', 'tsim-tsiok': '09558', 'kha-tshng-kau': '01683', 'ka\u0301i-bu\u0304n': '10060', 'hue\u0302': '13620', 'hue\u0300': '07910', 'hue\u0301': '01221', 'siu\u0301nn': '11421', 'hue\u0304': '09596', 'kha\u0300u-lo\u0304o-tha\u0302u': '05865', 'kia\u0302m-ta\u0304nn': '13099', 'ti\u030Dt-liu-liu': '04416', 'pi\u0302ng-su\u0304n': '01793', 'tsa-poo ia\u0304-tio\u030Dh thia\u0300nn, tsa-bo\u0301o ia\u0304-tio\u030Dh tshia\u0302nn.': '60209', 'lo\u030Dh-suann-hong': '09903', 'tshin-a\u0300i': '11973', 'thn\u0300g-phue\u0302': '11921', 'khui-tuann': '09212', 'jia\u0302u-a\u0301-hi\u0302': '13360', 'khua\u0300nn-sue': '05357', 'a\u0300m-tn\u0300g': '09649', 'pu\u0301n-tho\u0301o': '01676', piau: '11184', 'pha ba\u0304ng': '04151', piak: '09719', piah: '11639', 'ke-tho\u0302-a\u0301': '12731', pian: '12773', 'tshoo-tsha\u0300i pia\u0304n-pn\u0304g': '07789', 'phi\u0304nn-sa\u0301i': '10983', 'ba\u0304n-hue\u0301': '10539', 'siau-hong': '06291', 'bo\u0301ng-to\u0304o': '04464', 'kua\u0300-pa\u0302i': '07408', 'ko\u0301ng-tsi\u0302ng': '12428', 'tshia\u0304ng-tu\u0301-tshia\u0304ng': '13599', 'pha\u030Dk-ji\u030Dt': '12811', 'ti\u0301ng-ji\u030Dt-a\u0301': '08051', 'khiunn-kha\u0301u': '08932', 'tshiu\u0301-to\u0301o': '00945', 'mi\u0304-sua\u0300nn': '13109', 'io-tsi\u0301': '09901', 'tsa\u0301u-tshiu\u0300nn': '03472', 'thiam-hok-siu\u0304': '07587', 'po\u0301-io\u0301ng-tiu\u0302nn': '04770', 'pe\u030Dh-tio\u0304': '02032', 'tsi\u0301-bu\u0302n': '05045', 'mue\u0302-la\u0302ng-le\u0301': '08323', 'kuan-sue\u0300': '12949', 'kheh-ho\u0304o': '04878', 'tsiu\u0304nn': '13006', 'hang-lo\u0302o': '06351', 'lo\u0304o-ia\u0302nn': '13197', 'tio\u030Dh-pe\u0304nn': '09036', 'bo\u0302-sim-tsi\u0302ng': '08606', 'pu\u0304n': '07715', 'bo\u0302 ji\u030Dt m\u0304 tsai ta\u0300u, bo\u0302 tshiu m\u0304 tsai la\u0304u. ': '60293', 'hong-bah': '04882', 'm\u0304-tsai-si\u0301': '00988', 'sa\u0300m-mn\u0302g-kui\u0301': '13209', 'ka\u0301-su\u0301': '06981', 'tsiu\u0301-tsui\u0300': '06902', 'pia\u0304n-ho\u030Dk': '04692', 'tua\u0300n': '12521', 'tsu\u0304-su': '02675', 'koo-io\u030Dh': '10833', 'e-bi\u0301': '05982', 'su\u0302n-si\u0304': '03126', 'tha\u0302u-na\u0301u': '12108', 'u\u0304-i\u0302ng': '02546', 'lu\u0302n': '11512', 'phah-phua\u0300': '04090', 'bah-ke-a\u0301': '02829', 'po\u0301-ho\u0304o': '04783', 'pa\u0302ng-king': '04129', kng: '05384', 'ua\u0300nn khi\u0301--la\u0302i': '06148', 'to\u030Dk-li\u030Dp': '11819', 'ka\u0300u-tann': '03629', 'ka\u0301m-i\u0300ng': '09497', 'kuat-sim': '03304', 'u\u0304 ia\u0300u-ki\u0301n': '02513', 'go\u0304ng-la\u0302ng': '13449', 'tsit-gia\u030Dp': '12612', 'sa\u0302i-tsia\u030Dh': '13428', 'pho\u0301o-to\u0304o': '08484', 'ti\u0300n-lo\u0304o': '12753', 'tsa\u030Dt-pak': '10515', 'ha\u0300m-ko\u0301o': '12912', 'ia\u0301u si\u0304': '08642', 'tsu\u0301-te\u0304': '00327', 'bi\u0301-niu\u0302': '02824', 'pia\u0300nn-me\u0302-kang': '04144', 'mue\u0302-la\u0302ng': '08318', hueh: '02616', 'sio-ua\u0304nn': '05294', 'tsio\u0301ng-tsio\u0301ng': '10768', 'mi\u0304-tshi\u030Dk-a\u0301': '13106', 'a\u0300u-ut-jua\u030Dh': '10677', 'gia\u030Dh ti\u0304': '13143', 'khi\u0300-so\u0300o': '06234', 'khoo-uh-a\u0301': '03758', 'pue-tsu\u0302n': '05648', khun: '10321', 'tik-ko': '02806', 'lia\u0302u-phik': '11025', khui: '09172', khue: '10083', 'lui\u0302-kong-si\u0300ng': '10326', 'kua-tshiu\u0301': '10603', 'ti\u0304-tshng': '07704', khut: '09811', 'la\u0304u-hiann': '02643', 'ho\u0301 ia\u0304 tsi\u030Dt ku\u0300, pha\u0301inn ia\u0304 tsi\u030Dt ku\u0300. ': '60147', 'tsio\u030Dh-ko': '02007', 'ba\u030Dk-nih-a\u0301': '01871', 'sia\u0304ng-si\u0302': '13628', 'thn\u0302g-jio\u0304-pe\u0304nn': '11877', 'tsa\u0301-tang': '02476', 'tsi\u0302ng-la\u0302ng-kia\u0301nn': '04720', 'thi\u0302ng-tshiu\u0301': '06955', 'hia\u0304': '01848', 'bi\u030Dt-po\u0302': '07187', 'kheh-u\u0304n': '04905', 'lia\u0301n-kio\u0304-a\u0301': '11544', 'ua\u0302n': '03068', 'ho\u0301-ho\u0301 ha\u0304u tha\u0302i kah sa\u0301i na\u0301 la\u0302u. ': '60152', 'tsi\u0302nn': '12022', 'iu\u0302nn-tshang': '05177', 'tsi\u0302ng': '07254', 'hu\u030Dt': '06105', 'tshi\u030Dh-a\u0301': '13048', 'mia\u0302-gia\u030Dh': '02272', 'a\u0304u-si\u0300-la\u0302ng': '04934', 'peh la\u0302u-thui': '13633', 'tha\u0300u-la\u0302u': '07967', 'po\u0300-tha\u0302u': '08305', 'lo\u030Dh-tshiu\u0301': '09912', 'khioh-kheh': '04064', 'ta\u030Dk ji\u030Dt': '07938', 'khau-se\u0301': '09350', 'ta\u0302u-ha\u0302ng': '03252', 'mue\u0302-la\u0302ng-po\u0302': '08321', 'tn\u0300g-ku': '10377', 'tshua\u0304-bo\u0301o': '07130', 'phah-tsi\u0301ng': '04147', 'e\u0304-ham': '00217', 'ho\u0300ng-sa\u0300ng': '04099', 'tsa-poo gi\u0301n-a\u0301': '05124', 'ta\u0304i-ji\u0302n': '00221', 'tsi\u030Dt po\u0304o ki\u0302, tsi\u030Dt po\u0304o tio\u030Dh. ': '60017', 'sioh-phue\u0302': '07263', 'ta\u0304i-pia\u0304n': '00384', 'e\u0304-te\u0301': '00365', 'khi\u0300-kuan': '11632', 'gua\u0304-ni\u0304': '07012', 'bo\u0302 thinn-li\u0301': '08607', 'su\u0301n': '08847', 'ka\u0304u-jio\u0304': '04804', 'pe\u030Dh-hia\u0304': '02033', 'un-i\u030Dk': '11259', 'kue\u0300-tha\u0302u': '10272', 'hua\u0302n-sio\u030Dk': '12459', 'senn-si\u0301': '01901', 'ba\u0304n-kia\u0302nn': '10543', 'khu\u0300n-sann': '08819', 'se\u0300nn': '03781', 'liam-hiunn': '04078', 'hu\u0301n-i\u0302nn': '06478', 'but-a\u0301-hi\u0302': '11608', 'kho\u0300ng-tsua\u0302nn-tsui\u0301': '13030', 'sio-po-kua': '05305', 'la\u0304i-sun': '00704', 'tshiu\u0301-tshi\u0300ng': '01130', 'ka\u0301i-eh': '10032', 'lo\u030Dh-kha-khi\u0300': '09988', 'ju\u0304n-gue\u030Dh': '09184', 'si\u030Dt-li\u030Dk': '10480', 'se\u0301-sann-pang': '05164', 'ti\u030Dt-tn\u0302g-ti\u030Dt-to\u0304o': '04420', 'ka\u0301ng-ia\u0301n': '12437', 'phok-a\u0300i': '08251', 'tsua\u0301n': '12655', 'te\u0304-ha\u0304': '02300', 'sik-ha\u030Dp': '11525', 'tsui\u0301-bi\u030Dt-tho\u0302': '01145', 'ki\u0304m-po\u0302': '03115', 'khua\u0300nn-khin': '05369', 'khang-khak-tsi-phio\u0300': '04413', 'sa\u0301n bah': '11252', 'ko\u0300o': '13204', 'khan-ang-i\u0302': '07614', 'kha\u030Dp-be\u0304-tio\u030Dh': '11298', 'to\u0300ng-go\u0304ng': '03595', 'me\u0302-bue\u0301': '10575', 'ku-tsiann': '12149', 'gua\u0302n-tha\u0302u': '05869', 'tia\u0300u-tshia-bue\u0301': '02186', 'kiap-so\u0300o': '03022', 'su\u0301n-tha\u0302u': '10590', 'ka\u0301i-tshiu\u0302': '10065', 'tsi\u0300ng-gi\u0304': '01804', 'hia\u0300ng-si\u0302': '02213', 'koo-niu\u0302': '03803', 'sio-sia\u0304ng': '05246', 'tshiu\u0301-hua\u0304nn-a\u0301': '00919', 'a\u0300i-khu\u0300n': '09486', 'oo-tshenn gi\u0302ng-hueh': '06288', 'tshenn-a\u0301': '08933', 'oo-hi\u0304nn-mua\u0302': '06274', 'khi\u0302ng-hue': '12834', 'u\u0302n-u\u0302n-a\u0301-hue\u0301': '00616', ut: '13467', 'ka\u0301i-pia\u0300n': '03287', 'kok-gi\u0301': '07147', 'gue\u030Dh-ji\u030Dt': '00861', 'tso\u0301ng-ke\u0300': '12296', 'pu\u0300n-ta\u0301u': '06367', 'an-tah': '02391', ui: '02843', 'sia\u0304ng-la\u0302ng': '13625', 'su\u0300-ki': '01499', ue: '12452', 'phah-la\u030Dh': '04176', 'lo\u0301ng si\u0304': '12817', 'to\u0301-ta\u0300nn': '05792', 'kua\u0302nn-thinn': '08325', 'to\u0304 si\u0304': '08330', 'siu-tiu\u0302nn': '02539', 'po\u0304o-ha\u0304': '08040', 'kiok-hue': '08978', hiong: '00592', 'tshu\u0301-hu\u0304n': '07850', 'sin-so\u0300o': '01978', 'su\u0301-ka\u0301': '08527', 'ji\u0302n-ma\u0301': '00139', 'tsit-su\u0302n': '11490', 'khua\u0300nn-u\u0304-khi\u0301': '05344', 'tho\u0301': '06691', 'tho\u0300': '05881', 'phua\u0300nn-tsue\u0304': '03020', 'tn\u0300g': '10318', 'the\u0300-a\u0304u': '06754', 'niu\u0304-tshiu\u0301': '13369', 'ta-se\u0301': '08644', 'khah-thi\u0302ng-a\u0301': '10239', 'ho\u0302ng-ha\u0304i': '03113', 'tsi\u0301-mue\u0304-a\u0301-phua\u0304nn': '03797', 'tsho\u0300o-tha\u0301ng': '11536', 'ki\u0302-si\u030Dt': '03687', 'soo-hut': '07683', 'ti-iu\u0302-phoh-a\u0301': '11462', 'pun-tiunn': '00718', 'khan-hu\u0301n': '07626', 'tsiok-hok': '06486', 'bah-tsa\u0300ng-kak': '02790', 'tsit-tia\u0301m-a\u0301': '08018', 'tsu\u0301-kua\u0301n': '01379', 'ia\u0302nn-bi\u0304n': '13059', 'sit-tia\u0304n': '01809', 'bo\u0302-tsing-tsha': '08687', 'ho\u0302ng-tsua\u0302n': '09278', 'thua\u0300nn-khang': '05205', 'sn\u0302g': '03141', 'lut  ': '12484', 'tshio\u0300-io\u0302ng': '06468', lang: '13254', tshng: '05333', 'tsia\u0302n-sin': '04736', 'tsua\u0302n-gua\u0302n': '05173', 'kut-keh': '06871', 'khia\u0300m-sia\u0300u': '01155', 'sio\u0304ng ki\u0301n': '00507', 'pa\u0300ng-sak': '04085', 'se\u0301-tsio\u030Dh-a\u0301': '05152', 'tshing-mue\u0302': '07590', 'sio-phah-ke-a\u0301': '05268', 'he\u0302-koo-phia\u030Dk-a\u0301': '11373', 'se\u0301': '09252', 'se\u0300': '10848', 'tsia\u0300nn': '01665', 'a\u0302ng-tso\u0301': '05433', 'gi\u0304-bu\u0304': '09861', 'hue\u0302-phue': '02182', 'bo\u0302-tha\u0302u-si\u0302n': '08700', 'ha\u0301i-tsui\u0301 i\u030Dk-tiu\u0302nn': '06184', 'be\u0301 tsha\u0302n a\u0300i ki\u0301ng ho\u0301 tsha\u0302n te\u0301, tshua\u0304-bo\u0301o a\u0300i ki\u0301ng ho\u0301 niu\u0302-le\u0301. ': '60306', 'phia\u0300n-gi\u0301n-a\u0301': '12964', 'hong-ko\u0301o': '05672', 'tia\u0304n-si\u0300n': '10344', 'pe\u0304nn': '06364', 'kha-to\u0301o': '10112', 'la\u0300m tsha\u0302n': '08576', 'mi\u0304-tho\u0302': '13096', senn: '01851', 'tsua\u0302nn-tsui\u0301': '05150', 'tua\u0304-la\u0302ng khia\u0304m tsi\u030Dt tshui\u0300, gi\u0301n-a\u0301 tsia\u030Dh kah ui\u0300. ': '60081', 'khua\u0300nn-pe\u0304nn': '05355', 'hu-hu\u0304': '01054', 'tsha\u0300u-sng': '06628', 'kha-ba\u030Dk': '10104', 'po\u0301o-tha\u0302u-tsinn-a\u0301': '04172', 'gua\u0302n-li\u0301': '05857', 'tsia\u0302n-kim': '04738', 'kho\u0300-se\u0300': '11595', 'tsha\u0300u-hue\u0301-sio': '06571', 'tha\u0301n-pi\u030Dk': '03722', 'pan-ma\u0301-sua\u0300nn': '08476', 'hia\u030Dt': '01869', 'tshiah-ba\u030Dk': '03432', 'hia\u030Dp': '04994', 'tsioh--la\u0302ng': '05742', 'ka\u0300i-bua\u030Dh': '04467', 'lia\u030Dp': '07738', 'lia\u030Dt': '06246', 'ti-tiam': '11474', 'lia\u030Dh': '07327', 'kan-kan-a\u0301': '00241', 'tsing-tsha': '10754', 'tshiok-hua\u0304n': '13051', 'phi\u0300ng': '09883', 'sat-bo\u0301': '11368', 'hia\u030Dh': '12777', 'phi\u0300nn': '01225', 'hiunn-hue\u0301': '05598', 'suann-tha\u0302u': '00542', 'sui\u0302-tsa\u0304i--li\u0301': '12034', 'thio-tshiu\u0301-pi\u0302ng': '05018', 'a-ma\u0301': '04637', 'sio\u0301-sim': '00268', 'su\u0301n-a\u0301': '08865', 'se\u0300nn-mia\u0304': '03919', 'tsia\u030Dh-tha\u0302u-lo\u0304o': '05697', 'niau-bi\u0302': '11960', 'hu\u0304n-ha\u030Dp': '07553', 'kho\u0300o-kha': '11929', 'kah-a\u0301': '13501', 'm\u0304-koh': '01124', 'la\u0304i-ha\u0302ng': '00662', 'jio\u030Dk-kui\u0300': '02713', 'pha\u030Dk-kuann': '12820', 'ka-ba\u0304ng-hi\u0302': '01603', 'king-li\u0301': '09862', 'mue\u0302-la\u0302ng-kong': '08320', 'khau-a\u0301': '09339', 'tsu\u0304-tsi\u0301': '02909', 'pat-ji\u0304-kha': '00101', 'thai-ta\u0301u': '11867', 'si\u0300-sua\u0300nn': '01562', 'si\u0302ng-li\u030Dp': '02479', 'la\u0302-li\u0301': '12973', 'sui\u0301-tang-tang': '08345', 'tho\u0301-phue\u0302-thia\u0300nn': '06723', 'khiong-si': '12228', 'ka\u0301i-thuat': '10057', 'pi\u0301-lu\u0304n': '01161', 'ke-nua\u0304-a\u0301': '12747', 'nia\u0301u-tshi\u0301-phia\u030Dk-a\u0301': '08158', 'to\u0304ng-tio\u030Dh': '11116', thih: '13165', 'tia\u0300m-tha\u0302u': '03883', 'ia\u0300u-ki\u0301n': '05567', 'ti\u0301ng-i\u0302': '08879', 'to-bah': '00105', 'an-tsi\u0304ng': '02420', 'siu-im-ki': '02514', 'pha\u0300nn-tshiu\u0301': '00626', 'hio\u0300ng-tsia\u0302n': '02201', 'bue\u0301-ia\u030Dh': '03135', 'khua\u0302n-ki\u0301ng': '12274', 'iu\u0300-ti\u0304-hn\u0302g': '01801', 'ho\u0304-mia\u0302': '10010', 'sua-sua': '03313', 'sai-pak-ho\u0304o': '02851', 'tha\u0300n-tsi\u0302nn': '09122', 'ta\u0304u-ngeh': '03477', 'tsu\u0302n-sim': '02309', 'la\u0300u-la\u0300u': '09986', 'pa\u0304i-ke\u0300': '07427', 'mui\u0301': '03290', 'tsi\u030Dt la\u0302ng khua\u0300nn-tshut tsi\u030Dt ke, sin-pu\u0304 khua\u0300nn-tshut ta-ke. ': '60002', 'khi\u030Dt': '09724', 'ta\u0301nn-tha\u0301ng': '01772', 'khi\u030Dp': '03159', 'ko\u0300o-hiong': '05057', 'tiunn-ti\u0302 bo\u0302 si\u030Dh-pu\u0301n. ': '60264', 'pha\u0301inn-i\u0300': '01106', 'kio\u0302-ti\u0301ng': '11754', 'pha\u0301inn-tshui\u0300-ta\u0301u': '01077', 'tshun-gu\u0302-to\u0302o': '05021', 'ka-bua\u030Dh-tsha\u0300i': '05490', 'a\u0304m-ku\u0301n': '12116', 'bia\u0301n-kiann': '02957', 'tsua\u0301-pang': '06524', 'hi\u0302ng tsi\u0302nn': '12462', 'hua\u0302inn-tsa\u0302i': '11792', 'ba\u0301ng-ta\u0300': '13069', 'phoo-bi\u0304n-than': '11554', 'tsha\u0302-tsau': '06114', 'ki-tsho\u0301o': '07152', 'a\u0304n-sia\u0300u': '05569', 'the\u0302-tha\u0302u': '08425', 'thi\u0302ng-kha': '07010', 'tshia\u0301nn-tse\u0304': '11448', 'po\u0304ng-khang': '11293', 'tsia\u0300-ha\u030Dh': '11377', 'bo\u0302-sua\u0300nn-tia\u0304n': '08694', 'khah khua\u0300i': '10215', 'tsa\u0304m-tsat': '06480', 'thap-khang': '09410', 'ua\u0304nn': '03227', 'khiap-si\u0300': '13497', 'to\u030Dk-ke\u0300': '05161', 'la\u0302i-lo\u0304o': '03582', 'siu\u0301-tsiat': '02394', 'sio\u0302ng-jio\u0302ng': '04244', 'to\u0300-tha\u0302u-tsai': '05799', thiu: '07742', 'pha\u0300u-a\u0301': '05197', thik: '06359', 'im-te\u0304': '08062', 'tshui\u0300-khoo': '08257', 'ko\u0301o-i\u0300': '01576', thio: '05002', phoh: '07739', phok: '11012', 'lia\u0302m-thi-thi': '12508', phoo: '11603', 'tsiu\u0304nn-tshiu\u0301': '00257', 'sio\u0300ng-pho\u0304o': '05314', 'tshua\u0302n': '13228', 'tshi\u0302ng-a\u0301': '10573', 'tsha\u0300i-po\u0301o-bi\u0301': '08985', 'pa\u0304i-ke': '07386', 'tsha\u030Dt-a\u0301-hue\u0300': '10101', 'ua\u030Dh-tsui\u0301': '05195', 'pe\u030Dh': '01860', 'pue-a\u0301': '04217', 'ba\u0304n-puann': '09965', 'tha\u0300i-ka\u0300m': '01141', 'si\u0300ng-li\u0304': '08218', 'ho\u0300ng-khi\u0300': '04106', 'sim-bu\u0304n': '01080', 'mi\u0302-se': '08526', 'tik-i\u0300': '07241', 'tsho\u0300ng-khang': '08227', 'pe\u030Dh-tshang-tshang': '02016', 'ho\u0301-pha\u0301inn tsa\u0304i sim-la\u0304i, tshui\u0300-tu\u0302n-phue\u0302 sio khua\u0301n-tha\u0304i. ': '60149', 'tsip-tsia\u0300u': '07142', 'ah-kak': '12153', 'tia\u0301m-tsing': '12507', 'tsui\u0301-gua\u0302n-tha\u0302u': '01112', 'kik-gua\u0304-gua\u0304': '11780', 'gue\u030Dh-niu\u0302': '01022', 'si\u030Dt-ko\u0301o': '12345', 'tsoh-tsha\u0302n-la\u0302ng': '02905', 'ngo\u0301o-kim-ha\u0302ng': '00683', 'siau-ia\u0302u': '08011', 'ia\u0301-sing': '08060', 'thih-tha\u0301ng': '13186', 'hioh-tshua\u0301n': '09692', 'bu\u0304n-pn\u0304g': '11833', 'sia\u0300u-kui\u0304': '11178', 'pa\u0302i-a\u0301': '08612', 'ha\u0300-sann': '03111', 'na\u0304i': '05388', 'tshuah-la\u0302u': '08403', 'tia\u0300u-kio\u0302': '02260', 'a\u0300i-ma\u0304i': '12229', 'koo-kia\u0301nn': '03848', 'pn\u0304g-si\u0302': '09285', 'tsiap-la\u030Dp': '07390', 'ngo\u0301o-kim': '00682', 'sio\u0301': '00204', 'kho\u0301o-kho\u0301o': '05488', 'na\u0304u': '11599', 'tsia\u030Dh-po\u0301o': '05670', 'kuah-hiunn': '08233', 'te\u0304-tsu\u0301': '03169', 'ka-le\u0301-hi\u0300': '08180', 'tshut-tsiu\u0301': '01533', 'ta\u0301n': '08843', 'ta\u0301m': '12328', 'tshut-tsui\u0301': '01444', 'tshut-hia\u0304n': '01547', 'ta\u0301i': '09716', 'kia\u030Dt-tshut': '08177', 'pho\u0300': '06400', 'tui\u0300-si\u0302': '10504', 'pho\u0304': '08026', 'thi\u0302': '08186', 'thi\u0301': '11919', 'thi\u0300': '04710', 'si\u0301 to\u0304-iu\u0301, bo\u0302 si\u0301 pi\u0302n-to\u0304. ': '60169', 'buah-bi\u0304n': '04077', 'tshun-pn\u0304g': '05058', 'keh-me\u0302': '10368', 'bi\u0304-bia\u0301n': '01715', 'pu\u0302n': '11771', 'mi-mi-mauh-mauh': '12318', 'phah-ku\u0302n': '04082', 'tua\u0302nn': '12220', 'thio\u0301ng': '09386', 'thuat-li\u0304': '07833', 'gu\u0302-tia\u0302u-la\u0304i tak gu\u0302-bo\u0301. ': '60114', 'tshiu\u0301-tia\u0304n-a\u0301': '01133', 'thian-jia\u0302n': '01089', 'hi\u0300ng tsiu\u0301': '11908', 'ho\u0301-ue\u0304': '02400', 'e\u0304-si': '00289', 'si\u0302-sio\u0302ng': '06060', 'pn\u0304g-tsha\u0300i': '09297', 'si\u0302-u\u0304n': '06076', 'hua\u0302n-lo\u0301': '09757', 'sik-to\u0300ng': '11538', 'm\u0304-si\u0304-se\u0300': '01002', 'ti-bo\u0301-ling-a\u0301': '11441', 'pe\u030Dh-pan': '01968', 'tshut-kha\u0301u': '01428', 'so-i\u0302nn': '07288', 'pa\u030Dt-la\u0302ng': '02983', 'pang-a\u0301': '04219', 'ke-kah': '05931', 'bu\u0302n-sin': '00957', 'kam-tsia\u0300': '02014', 'tshi-bu\u0301-tshi\u030Dh-tshu\u0304': '09425', 'tsha\u0302i-to': '09016', 'pa\u0301ng-phio\u0300': '09864', 'hua\u0304n-huat': '01919', 'kak-ko\u0301o': '03498', 'su-gi\u0302': '01609', 'hue-lui\u0301': '04487', 'tso\u0300-pha\u0301inn': '06954', 'kia\u0300n-tio\u030Dk': '04907', 'pia\u0301u-sio\u0301-ti\u0304': '04522', 'tshap-tshiu\u0301': '08389', 'pua\u0300nn-lo\u0304o-sai': '01594', 'tua\u0304-khui\u0300': '00428', 'pu\u0301n-mia\u0304-tsi\u0302nn': '01732', 'tshap-tshui\u0300': '08412', 'ta\u0300u-ku\u0300': '06839', 'khui\u0300': '06173', 'pue-tsia\u0301u': '05652', 'tshiu\u0301-bue\u0301': '00934', sioh: '07255', 'kok-la\u0302ng': '02139', 'kia\u0302m-kue\u0301': '13107', 'tshiu\u0304-tsai': '11750', 'u\u0304-la\u0302ng-ia\u0302n': '02465', 'sio-khik': '05271', 'kia\u0302m-mue\u0302': '13116', 'su-tsu': '05953', 'siong-phi\u0301n': '07065', 'bi\u0301ng-tsio\u0300ng': '07629', 'hong-ta\u0302ng': '05657', 'pn\u0304g-thng': '09296', 'hue-io\u0302': '02800', 'ta\u0302m-phua\u0300nn': '11395', 'a\u0304u-ia\u030Dh': '04992', 'ki\u0301n kia\u0302nn bo\u0302 ho\u0301 po\u0304o. ': '60342', 'tshoo-ki\u0300nn-bi\u0304n': '03654', 'hue\u0300-tsu\u0302n': '07987', 'ah-u\u0304n': '04181', 'u\u0304-mia\u0302': '02482', 'bi\u0304n-sik': '05606', 'it-ti\u0304ng': '00020', 'si\u030Dt-po\u0301o': '05671', 'tshing-pi\u030Dk': '07551', 'gi\u0302-bu\u0304n': '10685', 'ho\u0301-hiann-ti\u0304': '02315', 'le\u030Dh': '07713', '--lah': '07093', 'hui\u0300-si\u0302n': '09105', 'su-sio\u0301ng': '04976', 'keh-piah': '10372', 'tsha\u0300u-iu\u0302-ka\u0301u': '06592', 'tsi\u030Dt-si\u0300-ke\u0300': '00013', lok: '11734', 'khi\u0300-gia\u030Dp': '02098', 'ti-kha': '11491', toh: '06113', 'tiong-ho\u0304o': '03925', loh: '09894', 'lia\u0304n-si\u030Dp': '11327', 'hioh-ta\u0300u': '09689', khang: '04395', 'tia\u0300m-bi\u0304n': '03855', 'ua\u0300n': '04917', 'kau-the\u0300': '02092', 'kik-la\u030Dt': '11775', khann: '03716', 'pha\u0302ng-tsui\u0301': '06031', 'kuan-bo\u030Dk': '08512', 'hia\u0302n-hue\u0304': '11496', 'bo\u0304o-kuan': '09356', 'si\u0301-tiong': '02499', 'tsing-bi\u0301': '07817', 'gua\u030Dt-ha\u0304-no\u0301o-ji\u0302n': '00844', 'tsio\u030Dh': '01866', 'lo\u0302ng-to\u030Dk': '06375', 'la\u0304u-la\u0302ng': '02623', 'thia\u0300u-bu\u0301': '10263', 'tshi\u030Dk': '10556', 'pa\u0300i kong-ma\u0301': '04926', 'tshi\u030Dh': '06022', 'tshui\u0300-tsi\u030Dh': '08217', 'ji\u030Dt-tha\u0302u tshiah-ia\u0304nn-ia\u0304nn, sui\u0302 la\u0302ng ko\u0300o se\u0300nn-mia\u0304.': '60106', 'tsha\u030Dt-a\u0301-tshi\u0304': '10100', 'tshit-gue\u030Dh-pua\u0300nn ah-a\u0301, m\u0304 tsai si\u0301-ua\u030Dh. ': '60035', 'tso\u0302': '11143', 'lo\u0302ng-tiu\u0302nn': '10250', 'tho\u0301-ha\u0301i-la\u0302ng': '06762', 'thn\u0300g-pak-theh': '11928', 'kui\u0304-tsui\u0301': '11896', 'tho\u0302o-kha': '09422', 'tsio-pio': '04159', 'tsi\u030Dt ji\u030Dt tho\u0301-ha\u0301i, sann ji\u030Dt pha\u030Dk ba\u0304ng. ': '60011', 'hia\u0304n-sio\u0304ng': '07637', 'ji\u0302n-lu\u0302n': '00128', 'tui\u0300-kho\u0300ng': '10493', 'ia\u0302n-lo\u0304o': '04314', 'sio\u0301-su\u0304': '00348', 'bo\u0302 gu\u0302 sa\u0301i-be\u0301. ': '60295', 'tshuah-tshiam': '13039', 'to-tshui\u0300': '00147', 'pit--khui': '13598', 'tsuann-te\u0302': '09736', 'po\u0301-liu\u0302': '04751', 'po\u0301o-tshiong': '10037', 'ki\u0301ng-ko\u0300': '13053', 'su\u0301n-ha\u0304i': '09554', 'kia\u0300nn-tha\u0302u': '12956', 'kho\u0301ng': '07747', 'tsia\u0301u-a\u0301-ta\u030Dh': '08125', 'tsui\u0302': '13504', 'hong-pue-sua': '05632', 'a\u0304u-pa\u0301i': '04990', 'kong-hui\u0300': '00740', 'thiann-tio\u030Dh': '13276', 'hue-khua\u0302n': '04491', '--honnh': '01308', 'siong-lio\u0302ng': '07079', 'bo\u0302-ta\u0301nn': '08703', 'lia\u0304u-sio\u0301ng-be\u0304-ka\u0300u': '06075', 'tsiu\u0304nn-suann-tha\u0302u': '00244', 'bi\u0301-na\u0302': '02836', 'le\u0300': '13022', 'le\u0301': '09056', 'le\u0302': '12384', 'le\u0304': '03544', 'pa\u0300i-thok': '04968', 'bua\u0301n-tsiok': '10617', 'it ta\u0304i tshin, ji\u0304 ta\u0304i pia\u0301u, sann ta\u0304i m\u0304 bat lia\u0301u-lia\u0301u. ': '60013', 'to\u0300-tn\u0301g': '05804', 'be\u0304-kia\u0300n-sia\u0300u': '06665', 'hiong-tho\u0301o': '09134', 'thok-ba\u0304ng': '02563', 'hia\u0301ng-lia\u0304ng': '13212', 'sio\u0301-kn\u0301g-a\u0301': '00353', 'a\u0302ng-te\u0302': '05427', 'po\u0304o': '08025', 'gi\u0302ng-tsiap': '04621', 'be\u0304-hu\u0300': '06672', 'tsui\u0301-ko\u0301ng': '01144', 'tsu\u0301-i\u0300': '01375', 'sian-tsi\u0300n': '02096', 'khi\u0301-moo': '06713', 'kia\u0301m-ti\u0304ng': '12226', 'uan-khiau': '13233', 'siu\u0304-khi\u0300': '03671', 'tsi\u0301-hueh': '00930', 'khah-tsa\u0301': '10212', 'tso\u0304-hua\u0301n': '07940', 'tshinn-tshioh': '12481', 'pe\u030Dh-tsha\u030Dt-ue\u0304': '01999', 'ue\u0304': '10081', 'bo\u0302-pua\u0300nn-po\u0304o': '08616', 'kik-tsiu\u0301': '11794', 'khi\u0300-ku\u0304': '11631', 'si\u030Dh-su\u030Dt-kio\u0300': '11881', 'ke\u0301-bo\u0302-i\u0300': '07005', 'kha\u030Dunnh': '10555', 'ia\u0302n-sui': '04477', 'i\u0300ng pui\u0302': '11655', 'kuan-lo\u030Dh-im': '12954', 'hua\u0302i-san': '07542', 'sia\u0304ng-u\u0302n': '13626', 'tn\u0302g-kha-tshng': '04541', 'io\u0301ng-li\u0301': '11574', 'su-bi\u0304n': '12001', 'hue\u0304-tha\u0302u': '09657', 'tiong-ti\u030Dt': '03924', 'bua\u0302-khann': '11850', 'phah-bo\u0301o-tsha\u0300i': '04071', 'pha\u0301inn-pak-to\u0301o': '01118', 'tui\u0300-li\u030Dp': '10487', 'siat-kio\u030Dk': '07885', 'huan-tsha\u0301u': '12605', 'poo-tha\u0302u': '07151', 'an-pa\u0302i': '02372', 'kong-tik': '01610', 'ho\u0302o-si\u0302n-tsua\u0301': '05461', 'khi\u0302': '05235', 'tsioh-io\u0304ng': '05751', 'khi\u0300': '06172', 'khi\u0301': '11604', 'khi\u0304': '05092', 'tsu\u0304-ngo\u0301o': '02671', 'a\u0304u-tha\u0302u': '04987', 'ka\u0300nn-bo\u0301': '10905', 'i\u0301ng': '08573', 'sian pia\u0300nn sian, ha\u0304i-si\u0301 ka\u0302u tse\u0302-thian. ': '60117', 'ha\u0304-sui\u0301': '00262', 'oo-a\u0300ng-tshn\u0300g': '06349', 'tsa\u0302i-sa\u0301n': '06768', 'tsui\u0301-tsua\u0302nn': '01006', 'hua\u0300': '00781', 'pi\u030Dk': '01861', 'kue-a\u0301': '01883', 'bu\u0302n-kuann': '00972', 'tsok-huat': '02915', 'ba\u030Dk-tsiu-phue\u0302': '01989', 'a-koo': '04572', 'sa\u0301n-po\u0302': '07691', 'pia\u0301nn': '10951', 'ta\u0301u': '00806', 'kim-kong-tsio\u030Dh': '04596', 'ta\u0301n-ha\u0304u': '08888', 'tsha\u030Dp-tsha\u030Dp-tih': '13601', 'tsio\u0300ng': '07164', 'ling-bu\u0301': '01698', 'a-ia\u0302n': '03583', 'ke\u0300-ta\u030Dt': '10998', 'tshi\u030Dh tia\u0304n-li\u0302ng': '06077', 'pia\u0300nn-mia\u0304': '04044', 'tsa\u0302i-tsi\u0300ng': '06755', 'khuan-tho\u0300': '07132', 'tsha\u0300u-la\u0302ng': '06562', 'tu\u0304n': '09169', 'ta\u0304ng-siong': '05561', 'it-sing': '00015', 'ki-kuan-tshi\u0300ng': '11768', 'tshiu\u0304-n\u0301g': '11761', 'the\u0300-ngo\u0301o': '06724', 'tshua\u0304-sin-niu\u0302': '07140', 'bi\u0304n-tha\u0301ng': '05645', 'bia\u0304n-hue\u0304': '05667', 'si\u0301-hue\u0304': '02550', 'siong-tsu\u0302n': '07075', 'kho\u0301o-tua\u0300nn': '05482', 'kha\u0300m-kua\u0300': '05954', 'bah-tiam': '02718', 'bi\u0304n-iu-bi\u0304n-kat': '05682', 'ku\u0301n': '10600', 'po\u0300o-pha\u0302ng': '01831', 'hueh-hi\u0302ng': '02702', 'thn\u0300g-tshiah-kha': '11922', 'ke\u0300-ti\u0300': '05552', 'iu-iu-a\u0301-thia\u0300nn': '04887', 'tan-to\u030Dk': '08304', 'ka-kio\u0302ng': '01539', 'huann-huann-hi\u0301-hi\u0301 tsi\u030Dt kang, hua\u0302n-hua\u0302n-lo\u0301-lo\u0301 ia\u0304 tsi\u030Dt kang. ': '60386', 'hia\u0304n-la\u0302u-a\u0301': '07622', 'mi\u0302-tsioh-phue\u0304': '08539', 'ka\u0300n-su\u0304': '09469', 'la\u0302m-pi\u0302ng': '04723', 'kan-kho\u0301o-la\u0302ng': '12348', 'si-tsi\u0300ng': '05041', 'bo\u0302-la\u0302ng-ia\u0302n': '08600', 'sa\u0301i-ha\u030Dk-a\u0301': '04908', 'tsui\u0301-uan-iunn': '01187', 'o\u0304o-a\u0301': '03422', 'ti\u0301ng-lo\u030Dh': '08088', 'nge\u030Dh': '06008', 'tio\u0302-kha-tn\u0300g-te\u0302': '10148', 'sa\u0300m-su': '00389', 'ka-tsia\u0301n': '10922', 'tsha\u0300i tha\u0302ng tsia\u030Dh tsha\u0300i, tsha\u0300i-kha si\u0301. ': '60305', 'po\u0300o-sa\u0300ng': '11163', 'tsik-peh-tsi\u0301-mue\u0304': '03650', 'tsio\u030Dh-iu\u0302': '01921', 'ing-ko': '13456', 'thih-kang': '13171', 'tsok-tsia\u0301': '02918', 'tia\u0301m-tshe\u0301nn': '12504', 'u\u0304-tha\u0302u-u\u0304-bue\u0301': '02584', 'i\u0300ng-kong-a\u0301': '12183', 'ke\u0304-kip': '00431', 'li\u0302ng-ti\u0304': '05762', 'to\u0304-li\u0301': '10244', 'se\u0300-ha\u0300n thau ba\u0301n pu\u0302, tua\u0304-ha\u0300n thau khan gu\u0302. ': '60275', 'be\u0304 ha\u030Dh': '06660', 'li\u0302ng-ti\u0302': '05793', 'na\u0304u-pa\u0302ng': '11612', 'ji\u0304n-su': '10883', 'po\u0300-un': '08293', 'thinn-ti\u0301ng': '01072', 'tn\u0304g-tsiu\u0301nn tsa-poo tso\u0300 siu\u0300nn-kang, tn\u0304g-tsiu\u0301nn tsa-bo\u0301o tsiu\u0301-khang-pa\u0302ng. ': '60372', 'ua\u0304n-tso\u0304o': '08463', 'pan-ma\u0301': '08475', 'i\u0302-po\u0302': '04856', 'sian-li\u0301': '01325', 'ji\u030Dt-tha\u0302u': '01178', 'tsia\u030Dh-pn\u0304g-toh': '05664', 'too-ha\u030Dp': '08061', 'tsha\u0300u-tua\u0304nn': '06629', 'lo\u030Dh': '09895', 'tha\u0302ng': '12629', 'thau tsia\u030Dh': '06989', 'sua\u0301nn-kang': '08449', 'tsi\u030Dt-bi\u0304n': '00024', 'tsok-ka': '02928', 'phu\u0302n-kha-kut': '05300', 'siong-tia\u0301n': '07067', 'tit-la\u0302ng-thia\u0300nn': '07208', 'kah-tshui\u0300': '03577', 'phang-bi\u0304': '04456', tsng: '10025', 'a\u0300i-kiau': '09495', 'na\u0301u-tshue\u0301': '10003', 'ia\u0302n-tha\u0301ng': '10304', 'kia\u0302m-hi\u0302': '13101', 'to\u0304-tik': '10264', 'tha\u0300i-tha\u0300i': '00859', 'ki\u0301n-su\u0304-khuann-pa\u0304n': '10796', 'te\u0304-ki-tsu\u0301': '02369', 'tsa\u0301u-ke-a\u0301-sian': '03488', 'ia\u030Dh-a\u0301': '11391', 'sing-bo\u0304ng': '12356', 'te\u0304-ho\u0304-mia\u0302': '02398', 'tsi\u030Dt hun tsi\u0302nn, tsi\u030Dt hun hue\u0300. ': '60006', 'tshim-tso\u0304': '07575', mauh: '01404', 'tsik-ji\u0304m': '07948', 'khiu\u0301-tua\u0304-soh': '09529', 'tsa-bo\u0301o-the\u0301': '05120', 'ti\u0304ng-ki\u0302': '03866', 'ho\u0302-ka\u0301i': '03755', 'ha\u030Dk-ki\u0302': '11664', 'hua\u0301n-tsi\u0300ng': '01040', 'thiah-ji\u030Dt-a\u0301': '03999', 'toh-tha\u0302u': '06164', 'ha\u0301i-sim': '06213', 'kiu\u0302': '07602', 'lia\u0301u-a\u0304u': '00120', 'kiu\u0300': '04430', 'ta\u0302n-tsui\u0301-le\u0302': '11576', 'koo-khu\u030Dt-tse\u030Dh-tsi\u0301ng': '03838', 'ho\u0301-ke\u0300': '02413', 'la\u0301ng kho\u0300o': '12823', 'tan-ui\u0304': '08285', 'io\u030Dh-se\u0301': '12885', 'khan ang-i\u0302, su\u0304n ue\u0304-bue\u0301. ': '60273', 'ta\u030Dt-tsi\u0302nn': '05796', 'hue\u0301-suann': '01232', 'tshia\u0301nn-si\u0302n': '11475', 'ti-kha-khoo': '11492', phi: '03955', 'pa\u0304i-ha\u0304i': '07385', 'hiauh-hiauh': '12645', pha: '10005', 'khn\u0300g la\u0302ng tso\u0300 ho\u0301 ta\u0304i, khah-ia\u0302nn tsia\u030Dh tsa\u0301-tsai. ': '60382', 'niu\u0302-ka\u0301n': '05884', 'bi\u0301-ji\u0302n': '05396', 'tho\u0301o-si\u0300ng': '00368', 'kho\u0301-lia\u0302n': '01611', 'hi\u0304nn-sa\u0301i': '02703', 'hong-liu\u0302': '05627', 'pok-i\u0301nn': '11176', 'suan-o\u0302o': '05298', 'phua\u0304nn-tshiu\u0301': '02893', 'tshia-tshiu\u0301': '03420', 'hi\u0304ng-ji\u0302n te\u0302': '03239', 'tshiu\u0304-ta\u0304u': '11745', phau: '03969', 'lo\u0300ng-phua\u0300': '06052', 'tsoh-sit-la\u0302ng': '02954', phan: '12805', phak: '12632', 'pho\u0304ng': '11343', phah: '03971', 'pa\u0301-ak': '03264', 'be\u0301-phio\u0300': '09109', 'oo-pang-tshit-a\u0301': '06282', 'gue\u030Dh-la\u0302i-hiong': '00964', 'ta\u0302ng-tsi\u0302nn': '10947', 'hi\u0302n-tsu\u0302n': '06428', 'khi\u0304ng': '05474', 'hia\u0300n-huat': '11700', 'i\u0302-bi\u0302n': '07724', 'sim-ko\u0302ng-hue\u0301-to\u030Dh': '00947', 'si\u0300-bi\u0304n': '01513', 'ka-mn\u0302g': '05940', '--tsheh': '10416', 'bi\u0302ng-tshenn': '04238', 'kui\u0301-tsiann': '06897', 'kia\u0302nn-ta\u030Dh': '02805', 'kia\u0304n-tsua\u0302n': '06973', 'kua\u0300n-tsui\u0301': '13131', 'si\u0304nn-ke\u0302': '07903', 'thih-kah': '13176', 'tshut-siann': '01627', 'ha\u0300u-sim': '03080', 'ia\u0304-po\u0302': '03807', 'kong-bu\u0302n': '00624', 'bo\u0302 hit-lo\u0304 kha-tshng, siu\u0304nn beh tsia\u030Dh hit-lo\u0304 sia\u0300-io\u030Dh. ': '60297', 'thong-ko\u0301o': '08007', 'u\u0301n-ki': '12470', 'ha\u0300ng-ling': '04448', 'lo\u030Dh-khi\u0300': '09923', 'iu\u0302-ta\u0301i': '04311', 'tsi\u0300n-the\u0300': '09151', 'tsui\u0301-tsu\u0301n': '01109', 'tia\u0300u-a\u0304m': '02264', 'tsiu\u0304nn-ba\u030Dk': '00299', 'u\u0301n-ku': '12472', 'bu\u0302n-kia\u0304nn': '00898', 'ke-kak': '12769', 'pi\u0301ng-la\u0302i-pi\u0301ng-khi\u0300': '00963', 'be\u0304-siu-suann': '06661', 'tshenn-m\u0301': '11956', 'tshiu\u0301-ba\u030Dk': '00886', 'tsua\u0302n-jia\u0302n': '02094', 'be\u0304-hia\u0301u thi\u0300-tha\u0302u, tu\u0301-tio\u030Dh ho\u0302o-tshiu. ': '60253', 'kho\u0300ng-bah': '04360', 'iu\u0302-leh-leh': '04293', 'khi\u0301-iu\u0301-tshu\u0301-li\u0301': '06728', 'siak--to\u0301': '10547', 'a\u0302ng': '05382', 'tua\u0304-thui\u0301': '00508', 'pua\u0300nn-sio\u0301-si\u0301': '01435', 'thong-tsho\u0301': '11351', 'a\u0302nn': '12999', 'kia\u0300-ue\u0304': '07191', 'tso\u0301o-ma\u0301': '06434', 'io\u030Dh-tha\u0302u-a\u0301': '12898', 'hong-so': '05707', 'phah-sn\u0300g': '04148', 'tshui\u0300-khi\u0301': '08263', 'e\u0304-tit': '09635', 'lia\u030Dh-tso\u0300': '07395', 'pha\u0304': '04326', 'kauh-pui\u0302': '13534', 'u\u0304-gia\u030Dh': '02590', 'sua\u0300nn-hi\u0302ng': '08465', 'lo\u0304o-to\u0302o': '10246', 'pu\u0300n': '12281', 'tha\u0301i-ko': '13127', 'su-kho\u0301': '04943', 'la\u0301u-si\u030Dt': '02784', 'niau-bi\u0304n': '11961', 'tang-tseh-i\u0302nn': '01582', 'li\u0302m-kia\u0301m': '12374', 'tshi\u0304-io\u0302ng': '01754', 'kuann-tiu\u0302nn': '03865', 'tua\u0304-pia\u0301nn': '00515', 'ma\u0301-sio\u0304ng': '06830', 'tui\u0300-khim-a\u0301': '10525', 'pia\u0300nn-sing-li\u0301': '04013', 'ka\u0301m-un': '09478', 'tsu\u0300-bo\u030Dk': '04358', 'khi\u0301-ko\u0301o': '06787', 'phi\u0301n-a\u0301': '13539', 'ki\u0301-ki\u0301-tu\u030Dh-tu\u030Dh': '05043', 'ta\u030Dh-tsha': '11471', 'kiat-ha\u030Dp': '08874', 'to\u0301ng-pha\u0300i': '13095', 'pe\u030Dh-sik': '01903', 'khoo-kho\u0301o-ah': '01464', 'lui\u0301-tsik': '07796', 'tso\u030Dk': '07456', 'tse\u0300-ti\u0304ng': '03657', 'tshut-thuat': '01550', 'e\u0302-iu\u0302': '11586', 'ka\u0302u tse\u0302-thian': '08691', 'pha\u0301inn-mia\u0304-la\u0302ng': '00968', 'ha\u0300n-tsha\u0301u': '10659', 'tsip-huat': '07124', 'sia\u0304-tsi\u0300nn': '05958', 'khi\u0301-thok-a\u0301': '11623', 'li\u0301-hi\u0302': '12798', 'so\u0302ng': '05731', 'ga\u0302u-tsa\u0301': '13508', 'kim-po\u030Dh': '04650', 'e\u0304-i\u0304ng-tit': '09614', 'ngiau-ti': '12527', 'kia\u0300m-su\u0301n': '11001', 'bi\u0304n-tha\u0302ng': '11380', 'sit-siu': '01713', 'ji\u0302n-ke-tshu\u0300-a\u0301': '00134', 'ti\u0304ng': '13603', huat: '08721', 'bak tsui\u0301': '03308', 'sng-tsa\u0302i': '06129', 'hu\u0304n-lua\u0304n': '07583', 'gia\u030Dh-kua\u0302n': '13146', 'hu\u0302-ho\u0304': '07735', 'kong-i\u0302ng': '02100', 'phua\u0300-siu\u0300nn': '06416', 'bo\u0304o-tsi\u030Dp': '09365', huan: '12584', 'to\u0304ng-bu\u030Dt': '07064', 'ki\u0302-tiong': '03628', 'nn\u0304g-pau': '02991', 'khi\u0301-la\u0302i': '06740', 'pe\u0302nn-pun': '01686', 'ta\u0300ng': '05738', 'kuah-tiu\u0304-a\u0301': '08261', khit: '00183', 'sia\u0300u-lia\u0304m': '11156', 'ka-pho\u0301o': '05966', 'ta\u0300nn': '11685', 'kue\u0301-a\u0301': '10733', 'a\u0300u hue\u0300': '10663', khia: '03773', 'siu-hi\u0304ng': '05716', khik: '02448', khih: '06504', 'hioh-me\u0302': '09702', khin: '10887', 'siau-ho\u0302ng-tui\u0304': '06279', 'ku\u0302n-tha\u0302u': '05999', 'tho\u0300o': '02129', 'khin-si\u0304': '10926', 'sian-koo': '01341', 'bo\u030Dk-piau': '02008', 'mooh-piah-kui\u0301': '13503', 'la\u0301u-lia\u0304n': '02802', 'ing-kai-jia\u0302n': '12210', 'hiau-pai': '13137', 'khu-pia\u030Dt': '07062', 'thi\u0302ng-to\u0304o': '08817', 'tsa\u0300n-to\u0302ng': '12913', 'khioh-hi\u0304n': '04068', 'kha\u030Dp-tio\u030Dh': '11299', 'peh-kong': '02890', 'ti\u0302nn-tue\u0300': '13161', 'a\u0302ng-ki\u0300-ki\u0300': '05428', 'hip-au': '08951', 'kho\u0300o-tua\u0300': '11924', 'hia\u0300nn-hia\u0300nn': '02169', 'phu\u0300n-tshat': '11030', 'kong-li\u0301': '00670', ing: '13387', 'kha-bo\u0302o': '10155', 'bo\u030Dk-su': '04369', 'sio\u0304ng-gua\u0302n': '00246', 'tsa\u0301u-lo\u0304o': '03496', 'tsi\u030Dt lia\u030Dp tsha\u0302n-le\u0302 tsu\u0301 ka\u0301u ua\u0301nn-kong thng. ': '60024', 'phah-ko\u030Dk-ke': '04062', 'li\u0302ng-thong': '13378', 'tsa\u0302i-tsu\u0301': '06720', 'sai-khia': '03378', 'la\u0301u-a\u0301': '03550', 'hiong-tiu\u0301nn': '09142', 'be\u0301-a\u0301': '06836', 'teh--lo\u030Dh-khi\u0300': '08831', 'hong-tshia': '05614', 'sit-sn\u0300g': '01811', 'kha-pha\u0304ng': '10168', 'ut-kim': '11230', 'kia\u0300m-tik': '10997', 'tsha\u0300i-se': '08994', 'o\u030Dh kang-hu': '11647', 'le\u0301-bu\u030Dt': '12565', 'te\u0301-ki\u0302': '08827', 'su-ki': '01618', 'tok-phi\u0304nn-a\u0301': '07084', 'iu\u0301--e\u0302': '00983', puann: '09519', 'su\u030Dt': '07864', 'tshia-tsio\u0301ng': '03483', 'soo-khai': '07696', 'tshiu\u0301-i\u0300n': '00901', 'lo\u0302o-tan': '13009', 'thinn-hua\u0301n-te\u0304-lua\u0304n': '00866', 'ang-a\u0301': '03085', 'tshia\u0302ng-tshia\u0302ng-ku\u0301n': '03315', 'tsiann-bah': '10740', 'ko\u0304o': '03897', 'pe\u0304nn-tsi\u0302ng': '06381', 'tua\u0304-tn\u0302g': '00480', 'siong-tiu\u0302nn': '07076', 'gi\u0304-tiu\u0302nn': '13066', 'phi\u0304ng': '03533', 'so\u0300o-tsit': '06544', 'tsiu\u0304nn-suann': '00233', 'phi\u0304nn': '10972', 'ha\u0304u-khat-a\u0301': '13392', 'u\u0304-sin': '02496', 'tsha\u030Dp-tsha\u030Dp-lo\u030Dh': '13600', 'siong-gia\u030Dp': '07081', 'khia\u0304-pi\u0302n': '07273', 'pi\u0300-kiat': '06429', 'kha-khiau': '10107', 'hue\u0304-a\u0301': '09608', 'na\u0302-a\u0302u-khang': '12802', 'khu\u0301n': '06011', 'tsho\u0301-that-a\u0301': '06605', 'tshi\u0300ng-phi\u0304nn': '12212', 'uan-ke-niu\u0302-tse\u0300': '05767', 'si-jio\u0304': '11024', 'tua\u0304-tha\u0302u-tsha\u0300i': '00547', 'liu\u0300-tshiu\u0301': '10903', kiann: '13313', 'i\u0300-khi\u0300': '09479', 'thi\u0302ng': '06938', 'tha\u0300n-tsia\u030Dh': '09098', 'hong-bi\u0304n': '01015', 'piak-iu\u0302': '09731', 'tshun-tseh': '05062', 'tsa\u0301-ni\u0302': '02488', 'iau-kui\u0301': '05127', 'gua\u0304n-i\u0300': '12971', 'sing-le\u0301': '05231', 'un-tsi\u0302ng': '05991', 'thua\u0302n-kiat': '10465', 'la\u0302i-se\u0301': '03570', 'la\u0302i-se\u0300': '03551', 'hi\u0302-tshinn': '08167', 'ti-phue-a\u0301': '11467', 'si\u0300-phi\u0300nn-a\u0301': '01455', 'iu\u0302-tsui\u0301': '04281', 'khue\u0302-kha': '11852', 'tsui\u0301-tsu': '01043', tshuann: '02444', 'bi\u0301-ku': '02815', 'tsi\u0300nn-tso\u0300-tsi\u0302ng': '09560', 'lu\u0301n-khi\u0300': '03189', 'tshing-tshun': '04585', 'ia\u0301n-pia\u0300n': '10676', 'lio\u0304ng-ka\u0301i': '11489', 'hip-sio\u0300ng-kua\u0301n': '08941', 'bi\u0301-ko': '02808', 'tsun-tio\u0301ng': '08328', 'sia\u0301m-pi\u0304': '06916', 'tso\u0302ng': '09314', 'phah-pho\u0304ng-siu\u0302': '04138', 'sih-nah': '12838', 'ia\u0301-kiu\u0302': '08079', 'pha\u0301inn tik tshut ho\u0301 su\u0301n. ': '60110', 'a\u0300ng-a\u0301': '12561', 'kho\u0300': '11563', 'kho\u0301': '02603', 'kho\u0302': '05467', 'tong kia\u0301u': '04252', 'si\u0300-ku\u0300-lia\u0302n': '01465', 'thih-kui\u0304': '13199', 'hia\u0300nn': '02131', 'tsio\u0301': '00796', 'hue\u0301-si\u030Dt': '02079', 'the\u0300nn-thui\u0301': '08688', 'a\u0302ng-tsha\u0300i': '05436', 'sai-hu\u0304': '05948', 'tia\u030Dk sn\u0300g-pua\u0302nn': '11723', 'tsi\u030Dt-ke-hue\u0301-a\u0301': '00027', 'ke-bo\u0301-phue\u0302': '12706', 'kuan-tsat': '12952', 'gua\u0304-bi\u0304n': '01514', 'tsia\u030Dh-tsho\u0300o': '05690', 'te\u0300nn': '12266', 'hui\u0301-lui\u0304': '05873', 'kau-ua\u0304nn': '02090', 'tng nia\u0301u-tshi\u0301': '07236', 'lo\u030Dh-tho\u0302o': '09983', 'a\u0300i-ji\u0302n-a\u0301': '09460', 'a\u0301n-ne': '05030', 'le\u0302-bo\u0301ng': '12550', 'la\u0304u-sia\u030Dp': '10657', 'bo\u0302-khui\u0300': '08654', 'mi\u0304-sua\u0300nn-ko\u0302o': '13110', 'he\u0304-se\u0300nn-mia\u0304': '00369', 'hiong-suah': '00754', 'kim-ku\u030Dt': '04641', 'te\u0302-ia\u0302n': '12790', 'tng-teh': '09779', 'ba\u0302-io\u030Dh': '08169', 'ha\u0304-gua\u0302n': '00247', 'sia\u0301u': '08717', 'bu\u0301-ku\u0304': '01805', 'tshue-ta\u0301u': '04351', 'ui\u0304-ha\u0304-sui\u0302': '05398', 'sa\u0300n-hue\u0304': '08486', 'tio\u0301ng-pue\u0300': '04657', 'kang-su\u0304': '00350', 'tshit-sia\u030Dh': '00076', 'sia\u0301n': '13250', 'sia\u0301m': '06814', 'ha\u0304m-ha\u0304i': '08072', 'ba\u0301ng-a\u0301-tsui\u0301': '13049', 'pe\u030Dh-pe\u030Dh': '01890', 'su la\u0302ng m\u0304 su ti\u0304n, su ti\u0304n pha\u0301inn-khua\u0300nn bi\u0304n. ': '60356', 'the\u0304': '13581', 'the\u0302': '08383', 'the\u0301': '13316', 'the\u0300': '06700', 'kha-sia\u0300u': '10154', 'li\u0302ng-kho\u0301': '10485', 'kue\u0301-tsi\u0301': '04212', 'kong-gu\u0304': '00732', 'sa\u0300ng-si\u0302n': '06764', 'gio\u0302-pue': '12638', 'khia\u0301u': '01650', 'kue\u0301-tsi\u0301-hn\u0302g': '04214', 'la\u0304u-khok-khok': '02757', 'huat-hi\u0302ng': '08733', 'li\u0304-su\u0302n': '03011', iu: '11085', 'oo-hi\u0302-pio\u0304': '06308', 'hio\u030Dh-a\u0301': '10009', 'sua-sap': '03325', 'ua\u0302n-a\u0301': '00280', 'gi\u0302-sim': '10682', 'bo\u0302-po\u0304o': '08626', 'oo-kut-ke': '06299', 'ni\u0302-tsi\u0302nn': '12866', 'sio\u0304ng-tha\u0302u-a\u0301': '00544', 'tia\u0302u-liu\u0302': '11231', 'tua\u0304-pu\u0300': '00448', 'tio\u030Dh-siong': '09043', 'pa\u0300ng-ian-hue\u0301': '04137', 'bu\u0302n-nga\u0301': '01100', 'tua\u0304-ue\u0304': '00488', tng: '09763', 'thia\u0304m-ha\u0301i': '09417', 'ia\u0302nn': '13044', 'tia\u0301nn-tshe\u0300': '10398', 'tho\u0301-ha\u0301i': '06761', 'thi\u0304-ke': '10383', 'o\u0302-te': '07853', 'tso\u0300-hi\u0300--e\u0302 beh suah, khua\u0300nn-hi\u0300--e\u0302 m\u0304 suah. ': '60263', 'po\u0304o-lo\u030Dk': '08087', io: '09887', 'thau-lia\u030Dh': '07000', 'kak-tha\u0302u': '03516', uat: '10565', 'pin-nn\u0302g': '12549', uai: '05135', 'ki\u0304n bio\u0304 khi si\u0302n. ': '60196', 'to\u0304-gi\u0304': '10259', uan: '13410', 'la\u0304u-khong-kia\u0304n': '02736', 'tsua\u0301-te\u0304-a\u0301': '06537', 'toh-po\u0300o': '06124', 'kho\u030Dk-hi\u0302': '13442', 'la\u0302ng bo\u0302 tsia\u0300u thinn-li\u0301, thinn bo\u0302 tsia\u0300u kah-tsi\u0301. ': '60049', 'la\u0302n kam-tsia\u0300': '13512', 'pia\u0300nn-se\u0300': '04131', 'thong-tsi\u030Dp': '08013', 'si\u030Dt': '05589', khiah: '10942', 'tso\u0301ng-tsha\u0302i': '12308', 'tsui\u0301-tshia': '00959', khian: '08373', 'pik-ki\u0304n': '05540', khiap: '13496', 'po\u0304o-so\u0300o': '03335', khiat: '07257', khiau: '12904', 'ia\u0301u-siu\u0304-te\u0301-mia\u0304': '01138', 'si\u030Dk': '01867', 'si\u030Dh': '10837', 'tia\u0301nn-a\u0301': '10391', lam: '13253', tshi: '13080', tsho: '12332', 'su-li\u0304': '03375', lak: '09892', tsha: '05911', 'siau-hui\u0300-tsia\u0301': '06316', 'hia\u0301ng-i\u0300ng': '13220', tshe: '05912', 'ga\u0304i-tio\u030Dh': '12837', 'kui-lo\u0304o': '07902', 'tha\u0301i-ko-kui\u0301': '13128', lap: '13636', tshu: '12406', 'kan-si\u0302n': '02331', 'pe\u0304-bu\u0301': '04354', 'tshin-tso\u030Dk': '11971', 'sio-tu\u0301': '05264', 'si\u0300ng-te\u0304': '03915', 'the\u0300-ping': '06727', 'im-thim im-thim, ka\u0304 la\u0302ng sann tshu\u0300n tshim. ': '60279', 'tsio\u0301ng-kim': '11257', 'hiann-ti\u0304': '01335', 'tsho\u0300-lua\u0304n': '12051', 'ut-siong': '13469', 'tn\u0302g-a\u0301': '09914', 'gi\u0301n-a\u0301-kua': '02162', 'to\u0304ng-po\u0302ng': '05157', 'ji\u0304-tsua\u0301-la\u0301ng': '02364', 'gue\u030Dh-pia\u0301nn': '01152', 'a-phia\u0300n': '11606', 'tshu\u0300-kak-tha\u0302u': '05844', 'pu\u0300n-ki': '06385', 'iau-pa\u0301-tsha\u0301': '05130', 'le\u0301-pa\u0300i-ji\u030Dt': '12567', 'si\u0302 ka\u0300u si\u0302 tam-tng, bo\u0302 bi\u0301 tsiah tsu\u0301 han-tsi\u0302 thng. ': '60240', 'ia\u0301-siu\u0300': '08106', 'ha\u0301i-mi\u0302': '06233', 'sit-pue\u0302': '01780', 'go\u0304ng-ue\u0304': '13461', 'ho\u0301-si\u0300ng-te\u0304': '02348', 'siu\u0301nn-gue\u030Dh': '11436', 'kho\u0301-lia\u0302n-ta\u0304i': '01612', 'tshian-ki': '11526', 'hu\u0302-tsiu\u0300': '07726', 'bi\u0302n-sio\u030Dk': '01744', 'jio\u0304-tha\u0301ng': '03117', 'tik-khak': '04425', 'tn\u0304g-ling': '12526', 'ka\u0301ng': '12403', 'i\u0301-a\u0304u': '01351', 'tshio\u0300-pue': '06471', 'ka\u0301nn': '08440', 'ke-a\u0301': '12702', 'bue\u0301-tsa\u0301inn': '03105', 'ha\u030Dp-tsa\u0300u': '02202', 'tshui-tshia\u0302u': '07430', 'go\u0304o-si\u0302-tsui\u0301': '01032', 'thuh-hia\u030Dh': '03395', suann: '00206', 'tsoo-ha\u030Dp': '07765', 'kuann-tsit': '03885', 'su\u0304n-se\u0300': '09302', 'tsua\u0301n-pia\u0300n': '12683', 'iu\u0301nn-bu\u0301': '11577', 'kuann-tsin': '08949', 'tia\u0301m-sim': '12490', 'ta\u0302ng-ko\u0301ng-a\u0301': '10945', 'sio\u0301-kha\u0301u': '00237', 'tu\u0301-tn\u0304g': '04134', 'tha\u0304i-to\u0304o': '10546', 'ta\u0304i-pit': '01371', 'kua\u0301n': '12068', 'lo\u0302ng': '05515', 'ki\u0302-tsik': '03819', 'kua\u0301i': '05077', 'kuann-tsha\u0302': '08524', 'phui\u0300-hueh': '03725', 'koo-tsia\u0302nn': '03810', 'si\u0300-hng': '01448', 'hue-pa\u0302n': '04475', 'ti\u0300ng-tia\u0301m': '06918', 'ho\u0304ng-ho\u0302ng-bo\u030Dk': '10964', 'la\u0304': '03216', 'pia\u0304n-tong': '04702', 'e\u0304-ta\u0300ng': '09646', 'mi\u0304-hu\u0301n': '13097', 'sn\u0301g-tn\u0304g': '09581', 'bo\u0301o-tua\u0304-tsi\u0301': '05097', 'khia\u0302': '12782', 'bia\u030Dt-bo\u0302ng': '09725', 'khia\u0304': '07250', 'mo\u0302o-kui\u0301': '13217', tiau: '12028', 'kua\u0301nn': '10858', 'ki\u0301ng-po\u0300': '13064', 'tsia\u030Dh-gua\u0304-kha\u0301u': '05600', tiam: '06399', 'ki-kim': '07128', 'a\u0300n-kia\u0304nn': '06125', tiah: '10535', 'thn\u0302g-sng': '11889', 'jia-ji\u030Dt': '11522', 'ni\u0302-tau': '02366', 'ha\u0301i-poo': '06206', 'tsai-la\u0304n': '03396', 'ho\u0304-be\u0301': '10017', 'ui\u0301-ta\u0304i': '06948', 'bi\u0301n': '03961', 'tshiah-pho\u0300ng-se': '03694', 'pi\u0302n-ki\u0300': '11727', 'oo-ba\u030Dk': '06331', 'mua\u0301-si\u0300-ke\u0300': '10611', 'jio\u030Dk': '02608', 'ua\u0301': '05728', 'pio\u0301-a\u0301': '12032', 'keh--khui': '10360', 'ta\u030Dk': '07921', 'ta\u030Dh': '11429', 'bue\u0301-a\u0301': '03086', 'pua\u0304nn': '03970', 'to\u0302ng-tsi\u0300': '02181', 'tsi\u030Dt bo\u0301o bo\u0302-la\u0302ng tsai, nn\u0304g bo\u0301o sio-sia\u0300-ta\u0304i. ': '60019', 'mi\u030Dh-phue\u0300': '04373', 'hi\u0302-hu\u0301': '08133', 'lo\u030Dh-ho\u0304o': '09950', 'kuainn-mn\u0302g tio\u030Dh tshua\u0300nn, ko\u0301ng-ue\u0304 tio\u030Dh khua\u0300nn. ': '60381', 'ta\u030Dt': '05732', 'bi\u0302ng-hun': '05772', 'nge\u0304-tsia\u0304nn': '08825', 'pi\u0301-ju\u0304': '01079', 'sio\u0301-tua\u0300nn': '00298', 'hue\u0301-tsai': '01249', 'tshoo-io\u0301ng': '07773', 'lu\u0304n': '11417', 'ti\u0302ng-ku\u0300': '05533', 'sit-bi\u0302n': '01757', 'khi\u0304-a\u0301': '05103', 'a-li\u0301-put-ta\u030Dt': '04563', 'lo\u0302ng-pue\u0304': '06377', 'tshu\u0302n-pa\u0304n ': '02416', 'su\u0304-ha\u0304u': '03572', 'tho\u0301o-te\u0304': '00316', 'kha-bue\u0301': '10109', 'tsha\u0302n-kap-a\u0301': '01979', 'a\u0301m': '04278', 'a\u0301n': '05710', 'ho\u0301-sim ho\u0304o lui\u0302 tsim. ': '60148', 'tn\u0304g-lo\u0304o': '12536', 'a\u0301u': '03980', 'tsi\u0301ng-tha\u0302u-a\u0301': '05070', 'sam-put-go\u0304o-si\u0302': '00250', 'n\u0302g-ni\u0302': '09293', 'tsi\u030Dt-tak-ku\u0301-a\u0301': '00043', 'to\u0302ng-ha\u030Dk': '02258', 'un-tsua\u0302nn': '09684', 'sn\u0300g-tso\u0300': '10759', 'pha\u0300u-mi\u0304': '04385', 'u\u0304-tsi\u0302ng': '02534', 'ti\u0304ng-tauh': '13605', 'nge\u0304-khi\u0300': '08821', 'thia\u0300nn': '06362', 'bo\u0302-i\u0302ng': '08674', 'ho\u0304o-tsui\u0301': '04531', 'i\u0300-gua\u0304': '09465', 'kha\u0300u-sia\u0304': '01630', 'tsi-bai': '11348', 'ka\u0301m-kak': '09500', 'thiann-tshui\u0300': '13275', 'pun--e\u0302': '00681', 'khia\u0300ng-kha': '09368', 'tshua\u0304-jio\u0304': '06370', 'kha-tshng-phue\u0301': '01677', 'li\u0302ng': '13578', 'lo\u0302ng-a\u0301-la\u0304i': '13013', 'jia\u0301-ta\u0304i-tsi\u0300': '09464', 'kiu\u0302-tiu\u0302nn': '07634', 'pu\u0301n-te\u0301': '01735', 'hu\u0304n-lio\u0304ng': '02097', 'pu\u0301n-te\u0304': '01711', 'phua\u0300-keh': '06419', 'niu\u0301': '03598', 'niu\u0302': '09164', 'niu\u0304': '09165', 'khi\u0301-sik': '06729', 'pia\u0301u-ia\u0301n': '04649', 'ta\u0304i-to\u0304-kong': '00499', 'be\u0301-hi\u0300': '06913', tsioh: '05729', tsiok: '03405', 'kuann-ba\u0302ng': '08937', 'phah-kat': '04123', 'song-su\u0304': '08288', 'thau-la\u0302i-a\u0300m-khi\u0300': '06982', 'tsi\u030Dp-ha\u030Dp': '09263', 'tsha\u030Dt-tsu\u0302n': '10142', 'pia\u0304n-tsha\u0300i': '04698', 'king-hui\u0300': '09868', 'tua\u0304-thua': '00371', 'sia\u0300u-lia\u0302n': '00906', 'khua\u0300nn-ko\u0300o': '05380', 'tsho-tsha\u0300i': '12361', 'puann-ue\u0304': '09572', 'ka\u0301nn-na\u0301': '08469', 'nn\u0301g-tho\u0302o-tshim-ku\u030Dt': '07994', 'tshim-ia\u0304': '07560', 'pu\u0301n-sin': '01723', 'ba\u0302n-phue\u0302': '13422', khok: '12402', 'ha\u0304-li\u0304ng-ia\u0302nn': '05890', khoo: '10716', 'se\u0300-bi\u0304n': '09353', 'pa\u0304n-toh': '12005', 'phua\u0302n-ko\u0301o': '11249', 'ho\u0302o-lo\u0302o': '10018', 'khi\u0301ng-ti\u0304ng': '04457', 'thu\u030Dt ': '07806', 'hong-khi\u0300': '05638', hannh: '10646', 'tso\u0300-sai-kong': '06964', 'that-tshui\u0300-khang': '07732', 'tui\u0304-a\u0301': '11021', khenn: '03038', 'tho\u0302o': '09385', 'pha\u0301ng-se': '06532', 'tso\u0301ng sn\u0300g': '12312', 'sia\u0301nn-khua\u0301n': '07138', 'pat-sian-tsha\u0301i': '00090', 'ha\u0301i-pa\u0300': '06211', 'sio\u0301-koo': '00363', 'tsi\u0302nn si\u0300 kha, la\u0302ng nn\u0304g kha. ': '60357', 'ua\u0304n': '11314', 'tsu\u0301-la\u0302ng': '01323', 'hi\u0302ng': '09241', 'gu\u0302-sa\u0301i-ku': '01261', 'tho\u0301-ji\u0302n-tsi\u0302ng': '06706', 'ka\u0304u-kang': '04800', 'tso\u0300--la\u0302ng': '06945', 'tshn\u0300g': '02863', 'tsui\u0301-a\u0302ng-a\u0301-sik': '01012', 'i\u0302-to\u0304ng': '07731', 'tsi\u0300ng-ki\u0300': '12926', 'pho\u0302o-la\u0304n-pha': '03166', 'tshia\u0301ng-khoo-le\u0302': '12438', 'tha\u0301n-phak': '03763', 'li\u0304-sik': '03008', 'la\u0304i-ling': '00643', 'si\u0302-kia\u0302nn': '06038', 'tsho\u0301-kan-na\u0301': '06636', 'tsui\u0301-i\u0300ng-tsha\u0300i': '01191', 'khua\u0301nn': '08545', 'sio-sia\u0301m-tshia': '05287', 'khui-pi\u0302': '09214', 'phue\u0302-tua\u0300': '01950', 'khua\u0300n': '12981', 'khua\u0300i': '03152', 'tha\u0301ng-su\u0301n': '07480', 'kong-tsio\u0300ng': '00726', 'senn sia\u0301n': '02043', 'tsui\u0301-tshia\u0302ng': '13650', 'tsa\u030Dp tsa\u0301inn tshun-tshut, bo\u0302 pe\u0302nn tn\u0302g. ': '60057', tsang: '12783', 'tshu\u0302n-a\u0304u-po\u0304o': '02353', 'ting-a\u0301': '06835', buah: '03957', 'tiong-gua\u0302n': '00608', 'kah-tsi\u0301': '01874', 'lo\u030Dh-seh': '09976', 'tsi\u030Dt-tia\u0301m-a\u0301': '00041', 'be\u030Dh-a\u0301-te\u0302': '08123', 'lio\u0304ng-tsa\u0301': '00660', 'bah-kut': '02725', 'bi\u0304n-bo\u0302o-a\u0301': '05684', 'kua\u0300n tn\u0302g': '13142', 'put-tik-lia\u0301u': '00719', 'li\u0301ng-li\u0304': '02921', 'thinn-thang': '01091', 'ko-ko-ti\u0302nn': '10831', 'hi\u0300-kua\u0301n pinn e\u0302 ti-bo\u0301, be\u0304 pu\u0302n siau ma\u0304 e\u0304 phah-phik. ': '60346', 'tsn\u0300g-a\u0301': '13439', 'sng-hong': '12471', 'pia\u0300nn-se\u0300nn-mia\u0304': '04048', 'm\u0304-tsiah': '00839', 'ko\u0302o--la\u0302ng': '11318', 'tiong-ha\u030Dk': '00769', 'pah-ji\u030Dt': '02633', 'sann ta\u0304i lia\u030Dp-tsik, tsi\u030Dt ta\u0304i khi\u0302ng-khong. ': '60062', 'io\u0301ng-tsu\u0301': '11575', 'si\u0301m-phua\u0300nn': '11066', 'kua\u0300i-su\u0304': '03917', 'gia\u0300n-tha\u0302u': '13277', 'lo\u030Dk-sua\u0301n': '09995', 'tsa\u030Dp-tshap': '12742', 'phoo-mi\u0302-hiu\u0302': '11558', 'ia\u0301-si\u0300ng': '08067', 'go\u0304o-hun-tshia': '00619', 'ia\u0301-sim': '08045', 'sit-gia\u0302n': '01721', 'khia\u0300m-i\u0304ng': '00888', 'i\u0301-kio\u0304': '08540', 'ki-tok': '07143', 'sa\u0300u': '07319', 'kau-hi\u0304nn': '10299', 'sa\u0300m': '13205', 'sa\u0300n': '08442', 'sian-sinn-ma\u0301': '02071', 'pe\u0304nn-the\u0301': '06394', 'tiau-ti\u0302': '00123', 'pa\u0300ng-to\u030Dk': '04072', 'lia\u030Dh-tsu\u0301n': '07418', 'kim-sin': '04562', 'po\u0300o': '11137', 'i\u0300n-ue\u0304': '12208', 'kim-sik': '04549', 'ba\u0304n-su\u0304 khi\u0301-tha\u0302u la\u0302n. ': '60325', 'sin-bu\u0302n': '09577', 'a\u0300m-tiong': '09606', 'tshiu\u0301-bue\u0301-tsi\u0302nn': '00938', 'lua\u0301n': '05387', 'tshian-li\u0301-ga\u0301n': '00341', 'i\u0300nn-a\u0301': '11817', 'hok-khi\u0300': '10705', 'tsi\u030Dt-pu\u0302-sa\u0301i': '00025', 'nn\u0302g': '13247', 'thua\u0300nn-kho\u0300ng': '05230', 'tsia\u0301nn': '03292', 'tsui\u0301-tia\u0304n': '01132', 'kia\u0300n-sia\u0300u-tsha\u0301u': '03465', 'ha\u030Dp-tshui\u0300': '02229', tong: '04204', 'tsha\u0300i-ia\u0300n': '08995', 'bo\u030Dk-tsia\u0302n': '01926', 'huat-to\u0304o': '04295', 'ngo\u0301o-liu\u0301-ki': '00686', 'the\u0300-ko\u0301o': '06750', 'hu\u0300n-ta\u0300u': '11657', 'be\u0304 pha\u0301inn': '06657', 'sit-sio\u0302ng': '01766', 'to\u0304o-tsiam': '04890', 'tsui\u0300': '11520', 'tue\u0300-tsi\u0302ng-tue\u0300-a\u0304u': '10799', 'kong-ma\u0301': '00750', 'kiau-ngo\u0304o': '13285', 'pe\u0302nn ti\u0301ng tso\u0300 kah la\u0302u-kua\u0304nn, pe\u0302nn kha hia\u0302m kah la\u0302u-nua\u0304. ': '60291', 'tsui\u0301': '00823', 'tshut-ma\u0301': '01534', 'ka-iu\u0302-tsa\u0304m': '01495', 'hi\u0304ng-ji\u0302n': '03238', 'sia\u0301nn-sia\u0302u': '07149', 'niu\u0304-po\u0304o': '13374', 'kha-a\u0304u-to\u0301o': '10122', 'si\u0300n-ji\u0304m': '04729', 'tsia\u0300n-tshia': '11698', 'me\u0302--si\u0302': '10583', 'khio\u0300': '09834', 'suann-kok': '00337', 'pi\u0301n': '10897', 'tshu\u0300-tha\u0302u-ke': '05870', 'put-tsi\u0301': '00620', 'phah-tsio\u030Dh': '04009', 'khi\u0301-lo\u030Dh': '06783', 'kho\u0300ng-bah-pn\u0304g': '04362', 'ah-hia\u0300n': '12154', 'tshiah-siu\u0300': '03697', 'kiat-tshin': '08917', 'si\u0302-si\u0302': '06049', 'tsa\u0301ng-tha\u0302u': '10554', 'bue\u0301-ji\u0304-tsa\u0301inn': '03075', 'tiu\u0301nn-lo\u0301': '04550', 'tsu-ke\u0300-a\u0301': '06139', aih: '11638', 'ha\u0302-pau': '07816', 'tshi\u0304-ling': '10335', 'ting-a\u0301-khi\u0302nn': '06838', 'sia\u0304-kim': '12419', 'kho\u0300-pu\u0301n': '11392', 'tsa-poo': '05121', 'khia\u0300ng': '09328', 'ta\u0304i-ha\u030Dk': '00536', 'li\u0302ng-ui\u0304': '13373', 'tsi\u030Dt-ba\u030Dk-nih-a\u0301': '00016', 'tsi\u0304ng-tso\u0304': '12036', 'li\u0301n-pe\u0304': '05986', 'tsa\u0304m-a\u0301': '12941', 'khi\u0301-hue\u0301': '06718', 'the\u0300-ha\u030Dk': '06798', 'ti\u0302ng-ta\u0302nn': '05550', 'kan-khia\u0301u': '02317', 'phe\u0300': '03831', 'lia\u0302n-sua\u0300': '07986', 'phe\u0304': '09808', 'ta\u0301u-la\u0301ng': '01215', 'uan-ke': '05766', 'kha\u0301m-kha\u0301m': '09697', 'po\u0304o-tiu\u0301nn': '08069', 'bo\u0302-kia\u0302m-bo\u0302-siam': '08711', 'pau-ia\u0302nn': '01640', 'tho\u0302o-thoh': '09426', 'ka\u0302u-san--a\u0301': '08602', 'tshenn-me\u0302': '04576', 'tua\u0304-la\u0302ng': '00222', 'tua\u0304-ke-kha\u0301u': '00422', nih: '13564', 'kia\u0302nn-sua\u0301': '02737', 'khua\u0300nn-bo\u0302': '05364', 'tsha\u0302-se': '06143', 'jue\u0302': '06005', hang: '06249', 'tha\u0302u-thia\u0300nn': '12098', 'tshn\u0302g-kin': '03167', 'bi\u0302n-kan': '01792', 'lia\u0302n-tui\u0300': '12367', 'kun-o\u0302ng': '02990', 'tshit-ji\u0304-a\u0301': '00099', 'sio-tshia\u0301nn': '05306', 'pe\u0304-bu\u0301 thia\u0300nn kia\u0301nn tn\u0302g la\u0302u-tsui\u0301, kia\u0301nn thia\u0300nn pe\u0304-bu\u0301 tshiu\u0304-bue\u0301 hong. ': '60190', 'sing-siu\u0300': '05049', 'sin-kua\u0302n': '03529', 'me\u0302-kak': '11553', 'pak-po\u0304o': '01552', 'han-tsi\u0302-tshiam': '08786', 'tsha\u0302n-hua\u0304nn': '01914', 'tsia\u0302nn-tso\u0300': '02531', 'khi\u0300-tio\u0304ng': '11633', 'tshoo-la\u0302ng': '07754', the: '05392', 'pi\u0302ng-sio\u0302ng': '01767', 'gu\u0302-la\u0301m': '01277', 'tsa-poo-tso\u0301o': '05125', 'ba\u030Dk-tsui\u0301': '11019', 'sai-nai': '01466', 'po\u0300o-kui': '01819', 'tn\u0302g-to\u0302o': '04626', 'bo\u030Dk-lo\u030Dk': '02023', 'si\u0302-tsu\u0304n': '06057', 'hi\u0301-tsiu\u0301': '08239', 'hi\u0302n-tshia': '06413', 'gia\u030Dp-bu\u0304-ua\u0302n': '09634', 'sann-kha-niau': '00495', khiunn: '08928', 'ti\u0301ng-ji\u030Dt': '08048', 'phue\u0300-kak': '06847', khiok: '04718', khioh: '03960', 'siok-tsi\u0304ng': '08952', 'ju\u0302-tshu\u0301-ju\u0302-tshu\u0301': '02330', 'hue\u0302-siu\u0304nn tha\u0302u lia\u030Dh sat-bo\u0301. ': '60184', 'tshia-tha\u0302u': '03519', 'tn\u0300g-i\u0301-tn\u0300g-toh': '10357', 'tsiu-bi\u030Dt': '03746', 'phue\u0302-pau-a\u0301': '01889', 'so\u0300ng-kang-ti\u0304n': '03096', 'tshia\u0301nn-thiap': '11459', 'tua\u0304-se\u0300-ba\u030Dk, kua\u0302n-ke\u0304-hi\u0304nn. ': '60088', 'kann-ga\u030Dk': '10710', 'kue\u0300-si\u0302': '10232', 'sann-kenn-pua\u0300nn-me\u0302': '00331', 'au-a\u0301': '11818', 'be\u0301-pinn': '06922', 'tsui\u0301-tsha\u0302n': '00890', 'tio\u030Dh-ka\u0302u': '09039', 'gu\u0302-a\u0301-kia\u0301nn': '01235', 'la\u0302m-kua\u0301n': '04763', 'na\u0304i-si\u0300ng': '05418', 'han-tsi\u0302-khoo': '08785', 'tso\u0301ng-kua\u0301n': '12313', 'the\u0301-tho\u0301ng': '13343', 'tshap-pa\u0302i': '08416', 'senn-tso\u0300': '01948', 'tshui\u0300-e\u0304-ta\u0301u': '08208', 'gi\u0302n-kak-a\u0301': '10914', 'o\u030Dh--la\u0302ng': '11644', 'khua\u0300nn-tio\u0304ng': '05351', 'ia\u0301n-hi\u0300': '10669', 'si\u0301m-tsa': '11071', 'tha\u0302u-su\u0302n': '12087', 'tsu\u0300-si\u0301': '09083', 'ho\u0302-ho\u0301ng': '02914', 'phua\u0300nn': '07912', 'pia\u0300n-khua\u0301n': '13347', 'hm\u0302-a\u0301-tsha\u0301u': '05481', 'ku-li\u0301': '05475', 'kong-tshin': '00771', 'ta\u030Duh': '04266', 'kho\u0301-sioh': '01541', 'mua\u0302-te\u0304': '08147', 'ki\u0304n-bio\u0304-khi-si\u0302n': '04654', 'ba\u0301ng-sut-a\u0301': '13063', 'sia\u0304-le\u0301': '12441', 'ta\u0302m-lu\u0304n': '11409', 'hui\u0300-io\u0304ng': '09079', 'ha\u030Dp-ko\u0301o': '02199', 'khng-ta\u0302i': '12288', 'pha\u0301inn-mia\u0304': '00966', 'tik-than': '02832', 'lia\u0301n-bu\u0304': '11356', 'hong-ni\u0302': '12662', 'hi\u0304nn-pe\u0302-a\u0301': '02655', 'io-tha\u0301ng': '09971', 'ni\u0302': '02298', 'ni\u0301': '02605', 'suann-tang-pe\u030Dh-a\u0301': '00373', 'tua\u0304-tsi\u030Dh koh hi\u0300ng thi\u030Dh. ': '60084', 'tsio\u030Dh-sai': '01984', 'po\u0301-tsia\u0300nn': '04725', 'khah-ko\u0301ng': '10273', 'pho\u0300ng-to\u0304o-te\u0301-mia\u0304': '11899', 'tsha\u0300u-tshui\u0300-kak': '06608', 'a-ia\u0302n-phia\u0301nn': '03584', 'li\u0304 hiunn, bo\u0302 li\u0304 khiunn. ': '60380', 'phua\u0304nn-ke\u0300': '02940', 'pua\u0300n-thian-su\u0301n': '01451', 'ba\u0304n-ba\u0304n': '09985', 'ji\u030Dp-tshu\u0300': '00130', 'phok-su\u0304': '08206', 'lui\u0302-kong': '10324', 'tn\u0301g gua\u0304-ke': '12661', 'ho\u0300ng-khuan': '04156', 'hi\u0302-pio\u0304': '08171', 'hue\u0302-tap': '02237', 'ui\u0302-kin': '08279', 'khiu\u0302-khia\u0304m': '04653', 'sim-hue\u0301': '00871', 'mo\u0302o-koo': '13067', 'la\u0304i-bi\u0304n': '00700', 'tshiu\u0304-na\u0302': '11747', 'ku-si\u0302n': '12155', 'tho\u0301o-ke-a\u0301': '00558', 'tiu\u0304nn-la\u0302ng': '00218', 'hi\u0302-po\u0301o': '08146', 'ko\u0301o-to\u0301ng': '01584', 'kho\u0300ng': '04396', 'sit-kak-tshat': '01839', 'pha\u0301inn-ue\u0304': '01119', 'pa\u0301-eh': '10341', 'pi\u0300-su\u0300': '08070', 'ai-io\u0304-ue\u0302': '04824', 'ti\u0301-gia\u030Dh': '04178', 'go\u0302ng': '09601', 'tshenn-me\u0302-gu\u0302': '04577', 'i\u0302nn-khoo-a\u0301': '09424', 'bo\u030Dk-hui': '07852', 'tia\u0302nn-ta\u0301u': '05885', 'po\u0300-to\u0300': '08289', 'khua\u0302n-li\u030Dk': '13232', 'ji\u030Dp-ni\u0301': '00104', 'tshing-phang': '07563', 'tshim-kau': '07552', 'tik-tshio\u030Dh': '02792', 'tia\u0304nn-gi\u0302n': '03878', 'khenn-kha\u0300m': '03050', 'bua\u0302': '11844', 'hun-tshui\u0300-a\u0301': '12609', 'ka\u0301i-sueh': '10075', 'hio\u0300ng': '02132', 'ta\u0304i-a\u0301': '13583', 'tinn-thng': '07695', 'kiu\u0300-ho\u0304o': '07448', 'thinn-kong-kim': '00854', 'ti-tn\u0302g-a\u0301': '11488', 'pho\u0300-sa\u0301n': '06427', 'tha\u0301n-to\u0301': '03736', 'sua\u0301-ui\u0304': '07266', 'tia\u0302nn': '05879', 'toh-ti\u0301ng tsia\u030Dh-pn\u0304g, toh-kha pa\u0300ng-sa\u0301i. ': '60242', 'iu\u0302-tsho': '04323', 'tsio\u0301ng-le\u0304': '11270', 'tshian kim be\u0301 tshu\u0300, ba\u0304n kim be\u0301 tshu\u0300-pinn. ': '60076', 'hiunn-ian': '05669', 'ngo\u0301o-kok': '00768', 'hi\u0302-ji\u0304': '08161', 'to\u0304ng-siau': '05180', 'na\u0301u-mo\u030Doh-ia\u0304m': '09991', 'ga\u0302u-tshn\u0301g-tsia\u030Dh': '13509', 'si\u0301-lo\u0304o': '02558', 'kau-gua\u0304': '05532', 'pha\u0301inn-liu\u0301-la\u030Dk': '00939', 'sio-tsui\u0301': '11814', 'sa\u0300u tho\u0302o-kha': '07416', 'la\u0304u-tua\u0304-kong': '02629', 'tshenn-ko\u0302ng': '01912', 'tia\u0304n-tsu\u0301': '10323', 'thn\u0300g-khi\u0301': '11930', 'tsi\u030Dt tn\u0304g tsha ka\u0301u tshioh. ': '60004', tshong: '08798', 'hi\u0302-u\u0300n': '08151', 'ka\u0301u-bo\u0301': '04355', 'tsi\u0302ng-gua\u0304n': '07308', 'bio\u0302-sia\u0301': '08420', 'siang-bi\u0304n-to-kui\u0301': '12728', 'tho\u0301o-tua\u0304-khui\u0300': '02143', 'sio-la\u0301m': '05319', 'king-ki\u0302': '09866', 'po\u030Dk-tsa\u0300': '12835', 'gia\u030Dp': '09604', 'ha\u030Dp-iok': '02206', 'ti-bo\u0301-tsha\u0300i': '11442', thiap: '09068', thian: '00792', thiam: '07536', thiah: '03964', 'to\u0300ng-tha\u0302u': '11729', 'gia\u030Dh': '12776', 'ho\u0301-le\u0301': '02427', 'be\u0301-lo\u0301': '10686', 'hue\u0301-ki\u0300': '10459', 'sim-li\u0301': '01063', 'kia\u0301m-ki\u0301': '12234', 'tio\u0304ng-ia\u0300u': '05542', 'huan-a\u0301-kiunn': '08730', 'thi\u0302ng-pu\u0301n': '12411', 'hue\u0301-kim-koo': '01257', 'khi\u0300-siong-ka\u0301i-ut': '01573', 'siu-ka\u0301i': '05717', 'tiong-tshiu-tseh': '00693', 'tann-tsui\u0301': '11691', 'keh-ka\u0300i': '10349', 'tsu\u0301-si\u030Dk': '01359', 'ta\u0304ng': '05516', 'tsiu\u0301-tsau': '06915', 'pok-ge\u0302': '11149', 'bah-tsit-a\u0301': '02830', 'io\u030Dh-tse\u0300-su': '12897', 'liu-liu-tshiu-tshiu, tsia\u030Dh nn\u0304g lui\u0301 ba\u030Dk-tsiu. ': '60324', 'phok-bu\u030Dt': '08225', 'ji\u0302n-bu\u030Dt': '00116', 'ho\u0301-ni\u0302-tang': '02326', 'ta\u0304u-a\u0301-tsi\u0302': '03428', 'tsit-kue\u0300': '08004', 'ba\u0304n-li\u0302ng': '09964', 'm\u0304 kam-gua\u0304n': '00896', 'ut-tsut': '13468', 'ko\u0301ng-tshin-tsia\u0302nn': '12440', 'm\u0304-tu\u0301-ho\u0301': '00974', 'se-io\u030Dh': '02861', 'khin-sang': '10936', 'tseh-ji\u030Dt': '09850', 'tia\u0301m-phua\u0300': '12496', 'pi\u0301ng-pi\u0302ng': '00870', 'tiong-ho\u0302': '00673', 'hueh-kin': '02765', 'la\u0302m-a\u0301': '09610', 'tiu\u0302-tu\u0302': '13200', 'ha\u0304i-tha\u0302ng': '05964', 'tshut-ka\u0301ng': '01564', 'pe\u0304-la\u0304u-kia\u0301nn-iu\u0300': '04361', 'siu-ta\u0300nn': '02575', 'tua\u0304-hi\u0300': '00548', 'ta\u0301n-tha\u0304i': '08884', 'kia\u0301m-tshat-kuann': '12233', 'sio\u0301ng': '09450', 'tsha\u0300u-tha\u0302u-ke-a\u0301': '06640', 'tha\u0300': '05003', 'la\u0302u-a\u0301': '11194', 'phu\u0302-lu\u0304n': '06215', 'ba\u0301i-tshiu\u0301': '13553', 'tok-ha\u030Dk': '09794', 'sok-pa\u030Dk': '03339', 'phe\u0300-a\u0301': '03841', 'tsu\u0304-tsok-tsu\u0304-siu\u0304': '02669', 'iu\u0302nn-mn\u0302g': '02635', 'si-a\u0301-bue\u030Dh': '08870', 'sin-sui\u0301': '12386', 'a-m\u0301': '04570', 'tshenn-tshau': '09997', 'tsha\u0300i-tsa\u0300ng': '08992', 'i\u0304-pi\u0304': '10355', 'bi\u0304n-tha\u0302u-tsi\u0302ng': '05696', 'thua-bua\u0302': '04164', 'hiunn-li\u0301': '09141', 'kiu-tshiu\u0301': '00628', 'a\u0302ng-thiap-a\u0301': '05417', 'thia\u0301u-tsia\u0300n': '05068', 'kho\u0304ng-kha-khia\u0300u': '03021', 'pit-ia\u0300u': '01749', 'a\u0302ng-ku-kue\u0301': '05451', 'po\u0301-siu\u0301': '04733', 'tshia\u0302ng': '03299', 'kau-tsiap': '02084', 'hak-ke\u0300-tsng': '10830', 'tia\u0302u-ta\u0304i': '08513', 'pi\u0300nn-ka\u0302u-la\u0304ng': '13348', 'hue-si\u0302-a\u0301': '02730', 'mo\u030Doh': '11339', 'kia\u0300n-pa\u0301i': '03521', 'la\u0304u-si\u0302n-tsa\u0304i-tsa\u0304i': '02720', 'tshia-tsi\u0302nn': '03515', 'ak-pui\u0302': '03318', 'ba\u030Dk-tsa\u030Dt-a\u0301': '11028', 'he\u0304-gua\u0304n': '00561', 'mi\u030Dh-tsia\u030Dh': '04367', 'ti\u0304-tang-si\u0302': '03869', 'su\u0300-bu\u030Dt-a\u0301': '01497', 'ke\u0301-pa\u0302u': '06963', 'ka\u0301u-bo\u0301-hi\u0302': '04356', 'ni\u0302-te\u0301': '02347', 'kuann-lia\u0302n': '03359', 'a\u0300i-tsi\u0302ng': '09481', 'tshik-lio\u0302ng': '08579', 'lia\u0301n-a\u0301': '11523', 'khua\u0300': '11564', 'tiu\u0302nn': '08276', 'la\u0304m': '12240', 'ping-a\u0301': '02901', 'la\u0304n': '13520', 'la\u0304i': '02963', 'tshu\u0300-la\u0304i': '05829', 'la\u0304u': '02602', 'tsa\u0301u-sia\u0301m': '03468', 'khok-hi\u0302ng': '10908', 'pi-ai': '08353', 'senn gi\u0301n-a\u0301': '01896', 'ke\u0300 tsa-bo\u0301o-kia\u0301nn': '09440', 'tsia\u0304m-tshia\u0301nn': '11150', 'gua\u030Dt': '00811', 'sian-tho\u0302': '01360', 'ti-tha\u0302u-phue\u0302 tsua\u0300nn bo\u0302 iu\u0302. ': '60349', 'khua\u0302n': '12261', 'thi\u0302ng-tia\u0304n': '07011', 'tsha\u0300u-tshenn-kong': '06620', 'tua\u0304-a\u0304m-kui': '00546', 'ta\u030Dp-ta\u030Dp-tih-tih': '04292', 'thi\u0301--khui': '11927', 'tsu\u0304-to\u0304ng-tshia': '02731', 'ho\u0302ng-pi\u0304': '03480', 'ua\u030Dt-tha\u0302u': '09124', 'la\u0300ng-kang': '11551', 'tsia\u0302u-u\u0302n': '10975', 'o\u030Dh': '11643', 'tsiam-tsn\u0300g': '02433', 'pha\u0304nn': '03771', 'ta\u0304i-sa\u0300i': '00347', 'pha\u0304ng': '12284', 'ng-ko\u030Dk-ke': '07380', 'i\u0302-tshi\u0302': '10800', 'kue\u0300-sim': '10191', 'kue\u0300-sin': '10219', 'pua\u0300nn-tsiann-pe\u030Dh': '01599', 'si\u030Dp-ji\u0304-ke\u0300': '00100', 'sa\u0301n-pi-pa': '11254', 'sam-hia\u0302n': '00442', 'siunn-la\u0301ng': '11305', 'ka\u0300i-ha\u0304n': '05277', 'tshiu\u0301-kin-a\u0301': '00842', 'tsu\u0304-to\u0304ng': '02728', 'bi\u030Dt-gua\u030Dt': '10838', 'kue\u0300-sit': '10204', 'tshi\u0300ng-tshiu\u0301': '10293', 'tshiu\u0301-bue\u0301-la\u030Dt': '00936', 'to\u0300o': '13574', 'giat-a\u0301': '12879', 'bi\u0301-phun': '02798', 'kong-lo\u0302': '01555', 'ke\u0304-tshu\u0300-a\u0301': '00414', 'khu\u0300n-kho\u0301o': '03049', 'tsho\u0300ng-gia\u030Dp': '08252', 'ka\u0302u-hi\u0300': '08701', 'tshiu\u0301-pit': '01094', 'hia\u0304nn': '02613', 'lia\u0302n-hi\u0302': '13291', 'thn\u0302g-a\u0301-pia\u0301nn': '11872', 'phia\u0302u-kheh': '10457', 'tshenn-li\u0301ng': '01906', 'ke\u030Dh': '03162', 'tn\u0304g-tsiu\u0301nn': '12531', 'o\u0301ng-hue\u0302--e\u0302': '03913', 'sa\u0302i': '13420', 'a\u0300n-te\u0301': '06131', 'po\u0302o': '10895', 'hi-jio\u030Dk': '09034', 'phue\u0302-ka\u0302u-hi\u0300': '01972', 'thua\u0300nn': '10692', 'khui-khui': '09216', 'tso\u0300-ge\u0302': '06959', 'tha\u0302u-pa\u0301i': '12118', 'tsui\u0301-kho\u0300o': '01024', 'po\u0301-pue\u0300': '12986', 'la\u0304u-thian-tho\u030Dh': '02834', 'tia\u0300u-oo': '02246', 'kueh-niau': '11933', 'su\u0304n-si\u0304': '09268', 'ke-nn\u0304g-kn\u0301g': '12716', 'kap-tsoh': '06039', 'kui-tshing-ba\u0304n': '07876', 'kha-tshiu\u0301': '10095', 'ting-ki\u0300': '08756', 'mue\u0302-la\u0302ng po\u0301 ji\u030Dp pa\u0302ng, bo\u0302 po\u0301 tsi\u030Dt-si\u0300-la\u0302ng. ': '60286', 'to\u0304o-kha\u0301u': '08552', 'thua\u0302n-phio\u0300': '09363', 'tshia-lia\u0300n-ta\u0301u': '06091', 'kio\u030Dk-bi\u0304n': '03112', 'tsu\u0304n-ho\u0304o': '06860', 'hue\u0301-sio-poo': '01295', 'tsua\u0304': '07927', 'tshiu\u0301-bi\u0304n': '01014', 'tsua\u0302': '07843', 'tsua\u0301': '06499', 'lia\u030Dh-tho\u0300o-a\u0301': '07372', 'tsi\u0300-gua\u0304n': '03207', 'hue\u0301-tshia-lo\u0304o': '01256', 'tia\u0304m-tia\u0304m': '04958', 'hue\u0301-sio-tshu\u0300': '01294', 'tsha\u0302-khi\u030Dt': '06128', 'huan-a\u0301-la\u0302u': '08729', 'pa\u0304i-tshi\u0304': '07357', 'sio-mua\u0302': '05309', 'sio\u030Dh': '07497', 'sio\u030Dk': '13279', 'su-thong': '03387', 'tia\u0304n-ping-siunn': '10338', 'tshia\u0301n-sik': '07555', 'tsiah e\u0304': '00475', 'ha\u0302m-sau': '03013', 'hok-sio\u0300ng': '10704', 'sio-tha\u0302i': '05257', 'tsua\u0301-ting': '06546', 'ku\u0304-the\u0301': '03699', 'tit-la\u0302ng-sioh': '07209', 'tui\u0300-pua\u0300nn': '10486', 'sia\u030Dh-a\u0301': '03242', 'ke-kha-jia\u0301u': '12752', 'gia\u0302-kang': '10050', 'lia\u030Dh-ko\u0302ng': '07368', 'tua\u0304-peh': '00321', 'kue\u030Dh': '11736', 'put-tsi\u0301-a\u0301': '00632', 'phiann-lia\u0302u': '12115', 'kho\u0300o-tha\u0302u': '11934', 'e\u0304': '10693', 'ba\u0302-bu\u0304-kng': '11979', 'e\u0301': '09769', 'e\u0302': '11565', 'siau-to\u030Dk': '06289', 'ti-tsa\u0300u': '11450', 'kan-kho\u0301o-tse\u0304-kua\u0300': '12349', 'tshong-bi\u0302ng': '12341', 'to\u0304ng-sa\u0301n': '07074', 'lo\u030Dh-la\u0304n': '10002', 'pha\u0301inn-thinn': '00862', 'hue\u0301-sio-suann': '01293', 'ha\u0301i-ha\u0301i': '06209', 'thia\u0304u': '13571', 'kui\u0301-na\u0304': '08354', 'thia\u0304m': '09388', 'ha\u0301i-sua\u0300nn': '06235', 'tsui\u0301-to\u0304': '01126', '--hannh': '05823', 'a\u030Dp-a\u0301-pia\u0301nn': '07674', 'pik-ua\u0301': '05547', 'la\u0302ng nn\u0304g kha, tsi\u0302nn si\u0300 kha. ': '60042', 'ha\u0304n-tse\u0300': '05538', 'ke-a\u0301-kia\u0301nn': '12704', 'tia\u030Dh-bi\u0301': '13270', 'sia\u0300m-sa\u0301i-jio\u0304': '10619', 'mo\u0302o': '00821', 'ko\u0301o-thui\u0302': '10399', 'bi\u0302ng-sa\u0301n': '02224', 'nn\u0301g-si-a\u0301': '07993', 'tiu\u0304nn-la\u0302ng-ma\u0301': '00231', 'khang-pha\u0304ng': '04428', 'kha\u0300-mn\u0302g': '10580', 'tsa\u0301u-tso\u0302ng': '03491', 'ki\u0300-ik': '06799', 'pu\u0301n-ti\u0301ng': '01790', 'phah-sn\u0300g-pua\u0302nn': '04149', 'tsua\u030Dt-tui\u0300': '08910', 'ting-hue\u0301': '11816', 'ka\u0301m-a\u0301-tia\u0300m': '13542', 'pah-hue\u0300': '02743', 'tsia\u030Dh pn\u0304g ho\u0302ng-te\u0300 tua\u0304. ': '60228', 'ko-a\u0301-pia\u0301nn': '11871', kann: '10690', 'pe\u030Dh-ta\u0300i': '01949', 'u\u0302n-u\u0302n-a\u0301': '00615', eh: '03027', 'hi\u0302-ti\u0302n': '08168', 'suah-ia\u0302m': '11128', kang: '02595', 'kue\u0300-gia\u0300n': '10281', 'hue\u0301-tshia': '01252', 'thok-ji\u0302-so\u0301o': '02497', 'pe\u030Dh-a\u0302u': '01966', 'mauh-tshui\u0300': '01556', 'ji\u0304-ki\u0300': '02418', 'hia\u0301n-si\u0300ng': '13352', 'he\u0302-ka\u0302u': '11375', 'kap-hu\u0302n': '06064', 'iu\u0302nn': '02600', 'hia\u0304n-tu\u0301-hia\u0304n': '07619', 'na\u0304u-thiann': '11624', 'tua\u0304-pa\u0302ng': '00370', 'ui\u0304-tshut-hueh': '05406', 'ti-tso\u0302': '11497', 'tong-si\u0302': '09786', 'tsio\u0301-khueh': '01047', 'sa\u0301n-gia\u030Dp': '07697', 'hia\u0301ng-siu\u0304': '03564', 'phi\u0302-phi\u0302 tsia\u030Dh kah la\u0302u-tsi\u0302. ': '60136', 'ia\u0301m': '07336', thong: '07926', 'go\u0304ng-ta\u0301nn': '13464', 'la\u0300u-khui\u0300': '09962', 'tsu\u0300-ka\u0301i': '09115', 'onn-onn-khu\u0300n': '05854', 'kong-to\u0304': '00761', 'tha\u0302u-mn\u0302g-giap-a\u0301': '12079', 'sia\u0304ng-ni\u0302': '13627', 'tsu-le\u0302': '06390', 'ia\u0301u': '08597', 'hang bah': '06272', 'lo\u030Dk-kuan': '11182', 'sia\u0300n-tua\u0304-hi\u0304nn': '09528', 'ta\u0300-bo\u0302ng': '09874', tsuat: '04277', 'tsun-kui\u0300': '08339', 'tik-pa\u0302i': '02748', tsuan: '07165', 'tua\u0304 ka\u0301u pua\u0302nn tshiu\u0302nn, se\u0300 ka\u0301u khua\u0300nn-iu\u0304nn. ': '60085', tsuah: '04276', 'a\u0300u-kheh': '10655', 'io\u0302-tshiu\u0301': '09530', 'ti\u0300n-ui\u0304': '12713', 'tso\u0304-hok': '08009', 'tho\u0301-tha\u0300n': '06775', 'gu\u0302': '01228', 'gu\u0301': '10851', 'gu\u0304': '10177', 'sio-niu\u0304': '05320', 'ku-kha ku-la\u0304i bah. ': '60364', 'mi\u0301-po\u0301o': '12207', 'oh tso\u0300': '10429', 'oo-la\u0301i-hueh': '06324', 'gia\u0302m-tio\u0304ng': '12988', 'mua\u0302-po\u0300o': '08126', 'niu\u0302-a\u0301-hio\u030Dh': '05888', 'phu\u0302-ta\u0304ng': '06212', 'tshenn-tik-si': '04552', 'koo-ua\u0304nn-so\u0301': '03813', 'tsia\u030Dh-hok': '05674', 'liu\u0302-lo\u0304ng': '05208', 'tha\u0304u': '05138', 'senn-lia\u030Dp-a\u0301': '01958', 'phui\u0300-nua\u0304': '03765', 'tshiu\u0304-le': '11757', 'bo\u0302-khah-tsua\u030Dh': '08683', 'tsiap-tshui\u0300': '07405', 'hue\u0301-kn\u0301g': '01282', 'tha\u0304i': '04912', 'tsiu\u0301nn': '11142', 'ti\u0301ng-tshiu\u0301': '08047', 'tsa-poo-kia\u0301nn': '05123', 'ka\u0304u-ue\u0304-sa\u0301i': '04827', 'kong-io\u0304ng': '00650', thau: '06940', that: '11430', 'tsu\u0301n': '09667', 'tshiong-to\u0304ng': '11400', 'tshah-tha\u0302u': '08426', 'thia\u0304nn': '04683', 'hia\u0302n-a\u0301': '07760', thak: '05740', thai: '05391', thah: '09384', than: '12872', tham: '07913', 'lo\u030Dk-si\u0302ng': '09931', 'kha-tsiah-phiann': '01762', 'pha\u0301inn-io-tshi\u0304': '00951', 'ai-pe\u0304-kio\u0300-bu\u0301': '04809', 'he\u0302-ke\u0302': '11376', 'hong-sui\u0301': '05596', 'mua\u0301-bi\u0304n': '10620', 'kio\u0300-kheh': '01503', 'tshiu\u0301-te\u0301': '00971', 'kia\u0302m-nn\u0304g': '13092', 'so\u0301o': '03951', 'kiat-sio\u0302ng': '02225', 'pa\u0300i-ni\u0302': '04942', 'lia\u0302u khe-a\u0301': '13482', 'ha\u0300m-kua\u0304-kua\u0304': '12920', 'ji\u030Dp-siann': '00166', 'tsha\u0300i-tia\u0300m-tsa-bo\u0301o': '08976', 'pua\u0300nn': '07750', 'tso\u0301ng-king-li\u0301': '12311', 'hi\u0302-ti\u0302': '08127', 'ha\u030Dp-pi\u0300ng': '02188', 'lo\u0302o-si': '12395', 'thong-kue\u0300': '08005', 'tshiu\u0302nn-a\u0301': '12249', 'sui\u0301-sik': '08327', 'kim-tia\u0301nn': '04645', 'hit pa\u0301i': '03945', 'tha\u0302i ke ka\u0300 ka\u0302u. ': '60182', 'tha\u0300n-tsa\u0301': '09085', 'lia\u030Dp-a\u0301': '07759', 'go\u0304o': '10853', 'tio\u0300ng-siong': '00745', 'hia\u0304n-hia\u0304n': '07631', 'tho\u0302o-ta\u0304u-thn\u0302g': '09407', 'kho\u0300ng-gia\u030Dp': '13036', 'khua\u0300nn-be\u0304-khi\u0301': '05358', 'khai-gia\u030Dp': '09220', 'i\u0304-si\u0300ng': '07682', khuah: '12465', 'tsong-ho\u0302ng': '10076', khuat: '06505', 'khan-ti-ko': '07644', 'gu\u0302-bo\u0301': '01239', 'kua-khik': '10612', 'thiah-phua\u0300': '04089', 'pi-a\u0301': '11948', 'mia\u0302-tuann': '02231', 'sa\u0300n-hiong': '08450', 'pua\u0300nn-ke\u0300': '01608', 'the\u0300-hue\u0301': '06719', 'khi-mua\u0302': '08566', 'mn\u0302g-li\u0302': '04674', 'pha\u0301inn-khua\u0301n': '01087', 'khua\u0300i-tshia': '03179', 'pau-ui\u0302': '01558', 'tsai-bi\u0302n': '03368', 'hue\u0301-tshia-tsa\u0304m': '01255', 'ti\u0300n-suah': '12749', 'liu\u0302-lia\u0302n': '10631', 'kue\u0300-a\u0304u': '10229', 'tsui\u0301-hia\u030Dp-a\u0301': '01001', 'tshenn-ko\u0302ng ka\u0301u tsia\u030Dh bo\u0302 sa\u0301i. ': '60129', 'ua\u0300n-to\u0300o': '04947', 'bua\u030Dh-bua\u030Dh': '01701', 'tsu\u0300-i\u0300': '04377', 'khe-a\u0301-ki\u0302nn': '09678', 'kia\u0301u-ka\u0301': '13300', 'io\u0304ng pa\u030Dt-la\u0302ng e\u0302 ku\u0302n-tha\u0302u-bo\u0301 tsing tsio\u030Dh-sai. ': '60133', 'hua\u0302i-thai': '12818', 'ia\u0301u-siu\u0304-a\u0301': '01137', 'thia\u0301m-tha\u0302u': '03944', 'tho\u0302o-thua\u0300nn': '09412', 'ga\u0301n-si\u0302n': '07687', 'la\u0302ng-tha\u0302u': '00163', 'ma\u0301-li\u0302ng-tsi\u0302': '06893', 'hia\u030Dp-hue\u0304': '03684', 'tho\u0300o-sui\u0304': '02267', 'tah-te\u0301': '09091', 'kam-sim': '01878', 'hun-tha\u0302u': '12617', 'khan-koo': '07627', 'tn\u0301g-uat': '12673', 'ko-sio\u0301ng': '06850', 'tn\u0301g-uan': '12681', 'pa\u0302ng-tha\u0302u': '04169', 'lo\u0304o-tsui\u0301': '13172', 'ho\u0301-tsiu\u0301': '02365', 'put-ji\u0302n': '00607', 'kam-a\u0301': '05100', 'phue\u0304-lo\u0302ng': '07908', 'mua\u0302-sann': '08139', 'hu-ji\u0302n': '00828', 'lo\u0302': '13436', 'lo\u0300': '13484', 'ho\u0301 kia\u0301nn m\u0304-bia\u0301n tse\u0304, tse\u0304 kia\u0301nn go\u0304-si\u0301 pe\u0304. ': '60151', 'lo\u0304': '13223', 'ti-a\u0301': '11438', 'tshi-tsha\u0301m-lo\u030Dk-phik': '07296', 'tshiu\u0304': '11732', 'tsu\u0301n-tu\u0301-ho\u0301': '09682', 'pha\u0300nn-thua\u0300nn': '00689', 'kun-la\u0304m': '05578', 'pu\u0302-a\u0301': '07055', 'pa\u0304-kang': '11344', 'in-ui\u0304': '02205', 'giah tshi\u0300': '11101', 'ka\u0304ng': '02110', 'tua\u0304-ku\u0304': '00481', 'ta\u0304i-su': '01361', hioh: '09663', 'tshia\u0301n-siu\u0304nn': '07584', 'sim-pak': '01117', 'hiunn-hu': '05640', 'un-jiu\u0302': '09683', 'sim-ki': '01168', 'kim-kue': '04544', 'sia\u0300m-sa\u0301i': '10618', 'hi\u0300-pan': '12199', 'pia\u030Dt': '02962', 'khih-kak': '06522', 'phio\u0302': '12589', 'ke\u0300-thi\u0302ng-tshia': '05555', 'kiu\u0300-se\u0300-tsu\u0301': '07354', 'tsi\u0301nn': '06556', 'pe\u030Dh-thn\u0302g': '02021', 'mua\u0302-thinn-kue\u0300-ha\u0301i': '11848', 'tsi\u0301ng': '09886', 'ui\u0304-khui\u0300-io\u0302ng': '05444', 'ta\u0301nn-kik': '01828', 'kia\u0301nn-sun': '02210', 'un-si\u030Dp': '09690', 'mua\u0302-sat-ba\u030Dk': '08136', 'ha\u0300n-io\u030Dh-tia\u0300m': '10673', 'kiong-hi\u0301': '05994', giap: '11547', 'la\u030Dh-ji\u030Dt': '11738', 'kui\u0300-khi\u0300': '09102', 'tshi\u0300-kui': '03624', giah: '11097', 'ki\u0301ng-khi\u0300': '08472', 'bak-tshiu\u0301': '03307', 'tsi\u0301-to\u0304': '05067', 'pha\u0301inn tik tshut ho\u0301 su\u0301n, ho\u0301 tik tshut ku-lu\u0301n. ': '60109', 'sia\u0300u-lia\u0302n na\u0304 bo\u0302 tsi\u030Dt pa\u0301i go\u0304ng, lo\u0304o-pinn na\u0301 u\u0304 iu\u0301-i\u0300ng-kong. ': '60101', 'sin-lo\u0302ng': '09548', 'tsha\u0300u-jio\u0304-hiam': '06586', 'tsi\u0302nn-toh-a\u0301': '12043', 'ji\u0304-bu\u0301': '02318', 'tshap-tsi\u030Dt-kha': '08387', 'bo\u0302-ka\u0300u-ta\u0304ng': '08661', 'i\u0302nn-i\u0302nn': '09419', 'ko-le\u0302': '06924', 'tsiam-kha-iu\u0300-tshiu\u0301': '02402', 'sn\u0300g-mia\u0304': '10748', 'tsha\u0300u-tho\u0302o-bi\u0304': '06615', 'tso\u0301ng ko\u0301ng': '12319', 'bo\u0302o-iu\u0304nn': '11212', 'ho\u0301o-koo-po\u0302': '04573', 'hit-tah': '03936', 'to\u0301 tsi\u030Dt e\u0302': '02888', 'sia\u0300u-pa\u0302ng': '11157', 'hi\u0300-tshut': '12217', 'ting-tso\u0304': '11824', 'siu-tsui\u0301': '02470', 'lo\u0302-ha\u0300n-kha-a\u0301': '12863', 'huat-hia\u0304n': '08760', 'ke\u0301-sian': '06960', 'bo\u0302-tia\u0304nn-tio\u030Dh': '08633', 'khia\u0304-phio\u0300': '07284', 'ti\u0300-su\u0301': '05416', 'ui\u0302-gia\u0302n': '11998', 'phue\u0300-lia\u0304u': '06869', 'pu\u0301n-li\u0301ng': '01814', 'tsha\u0300i-ah': '08999', 'kim-tso\u0301': '04630', 'ba\u030Dk-tha\u0302u': '02024', 'kha-po\u0304o': '10111', 'lo\u030Dk-phik': '09993', 'te\u0302-suann': '06565', 'gua\u0304-tha\u0302u': '01625', 'la\u0302i': '07491', 'te\u0304-po\u0304o': '02339', 'la\u0302n': '13359', 'la\u0302m': '03346', 'sim-hi\u0304ng': '00926', 'tsia\u030Dh-tsi\u0302nn-kuann': '05694', 'phi\u0300-lu\u0304n-ko\u0301ng': '13073', 'la\u0302u': '06357', 'koo-mo\u0302o-tse\u030Dh-tsi\u0301ng': '03839', 'hip-sio\u0300ng-ki': '08940', 'bo\u0302o-hua\u0304n': '11213', 'khai-tiong': '09210', 'he\u0302-koo': '11372', 'pu\u0301n': '01664', 'kho\u0301o-tsi\u0302ng': '05496', 'kha-tshng-ta\u0301u': '01680', 'tuann-tsua\u0304': '08297', 'kai-tua\u0304nn': '09277', 'tsi\u030Dt-pah kho\u0300ng-it': '00018', 'o\u0302ng-lo\u030Dk-a\u0301': '01276', 'khan-lo\u0302-kenn': '07650', 'si\u0302n-bi\u0302ng hing, te\u0304-tsu\u0301 ki\u0302ng. ': '60246', 'a\u0300i pia\u0300nn tsiah e\u0304 ia\u0302nn. ': '60317', 'hia\u0304-phue\u0300-a\u0301': '01918', 'pua\u0300-ki': '12864', 'bi\u0304-bo\u0302ng-ji\u0302n': '01678', 'i\u0302ng-king': '09217', 'ho\u0304o-la\u0302i-thinn': '04565', 'sue-ba\u0301i': '06655', 'bo\u0302-ko\u0301ng-bo\u0302-ta\u0300nn': '08705', 'suh tsui\u0301': '07499', 'ta\u0302i-ua\u0302n tsi\u0302nn, im kha-ba\u030Dk. ': '60120', 'ka-lak-a\u0301': '01635', 'thn\u0300g-kho\u0300o-la\u0304n': '11932', 'u\u0304-ka\u0300u': '02532', 'lua\u0301n-jio\u030Dk': '07973', 'pi\u0300': '08031', 'iok-hue\u0304': '05440', 'tsiu\u0301-kua\u0301': '02406', 'hi-ba\u0304ng': '03119', 'sann-ki-tshiu\u0301': '00377', 'gua\u0302n-hi\u0302ng': '05842', 'pi\u0302': '08926', 'na\u0304i-io\u0304ng': '05408', 'li\u030Dk-su\u0301': '11779', kho: '05330', 'tham-tsa\u0302i': '07978', 'tsa\u0301ng': '10536', 'tng-tha\u0302u-tui\u0300-bi\u0304n': '09797', 'kua\u0302n-ke\u0304': '13007', 'ho\u0301-ka-tsa\u0300i': '02344', 'li\u030Dk-ta\u0304u-a\u0301': '10745', 'im-pue': '08077', 'kau-tse\u0300': '02101', 'kuan-kong': '13424', 'tsing-ka': '11022', 'bo\u0302-gi\u0304-niu\u0304': '08710', 'tsi\u0301n-tshat': '09046', 'sue\u0300-kim': '08816', 'io\u0301ng-tshi\u0304': '11596', 'to\u0302m': '01306', 'to\u0302o': '07922', 'a\u0302ng-io\u030Dh-tsui\u0301': '05457', 'su\u0302-tia\u0301n': '12919', 'kha\u0300m-kha': '05952', 'gi\u0301n-a\u0301-la\u0302ng u\u0304 hi\u0304nn bo\u0302 tshui\u0300. ': '60176', 'ngo\u0301o-tsha\u0301i': '00717', 'kang-tshiu\u0301nn': '00518', 'ke-a\u0304u': '05942', 'tshing-lia\u0302n': '04547', 'pho\u0304o-a\u0301': '12854', 'gua\u0304n-bo\u0304ng': '12969', 'kuan-lia\u0304m': '13425', 'gi\u0302ng-hueh': '11630', 'thian-kio\u0302': '01167', 'se\u0300-tsik': '07769', 'bat-siu\u0304nn': '06073', 'ti\u030Dt-pan': '05768', 'ha\u030Dk-gia\u030Dp': '11666', 'hong-thai-bue\u0301': '05679', 'gia\u0302u-gi\u0302': '11120', 'iu\u0304-a\u0301': '05101', 'lua\u030Dh': '10888', 'mia\u0304u': '03064', 'buah ia\u0302m': '04192', 'phe\u0304-a\u0301': '09815', 'tsiu\u0304nn suann khua\u0300nn suann-si\u0300, ji\u030Dp-mn\u0302g khua\u0300nn la\u0302ng i\u0300. ': '60067', 'oo-bi\u0304n-la\u0304-pue': '06292', 'ji\u0300-puh': '02234', 'gi\u0302n-tsua\u0301': '10920', 'bue\u0301': '03070', 'bue\u0302': '03033', 'po\u0304ng-bi\u0301-phang': '11291', 'bue\u0304': '01663', 'tha\u0300i-pe\u030Dh-tsiu\u0301': '00893', 'iu\u0302-ta\u0302ng': '09157', 'tan-gua\u0302n': '08280', 'lo\u0302ng-ku\u0304': '10220', 'ti\u0301ng-kua\u0302n': '08107', 'pak-to\u0301o na\u0301 tsui\u0301-kui\u0304, hing-kha\u0301m na\u0301 la\u0302u-thui. ': '60326', 'tsia\u030Dh la\u0302ng tsi\u030Dt kha\u0301u, po\u0300 la\u0302ng tsi\u030Dt ta\u0301u. ': '60218', 'ti-tha\u0302u m\u0304 ko\u0300o, ko\u0300o ah-bo\u0301 nn\u0304g. ': '60348', 'that-kia\u0300n-tsi\u0301': '11486', 'hia\u0301nn-ba\u030Dk': '13323', 'iu-siu\u0300': '12162', 'ka-ki\u0304-la\u0302ng': '05921', 'khi\u0301-kho': '11615', 'pa\u0301-sui\u0304': '10378', 'phua\u0304nn': '02867', 'hong-tshui\u0300-kha\u0301u': '05653', 'sit-tsi\u0300': '01718', 'tia\u0302u-io\u0301ng': '11410', 'thiat-the\u0300': '10585', 'pi\u0300nn-kui\u0301-pi\u0300nn-kua\u0300i': '13342', 'senn-thua\u0300nn': '01970', 'tshoo-tshi\u0304ng': '07777', 'pi\u0302-tho\u0301o': '08931', 'tshun-hong': '05044', 'tshenn-a\u0302ng-ting': '04586', 'lia\u0302ng': '07498', 'tsit-bu\u0304': '12606', 'tshi\u0304-tiu\u0302nn': '01782', 'ji\u0304n': '10846', 'ji\u0304m': '02054', 'ta\u0304i-sing': '01333', 'tia\u0302u-thi\u0302ng': '11399', 'hi\u0300-la\u0304ng': '12193', 'tia\u0304n-li\u0302ng': '10367', 'kui\u0300-som-som': '09107', 'tui\u0300-sio\u0304ng': '10513', 'tui\u0300-khim-a\u0301-sann': '10526', 'a\u0300i-sui\u0301': '09484', 'kut-jio\u030Dk': '06843', 'tik-tsue\u0304': '07244', 'ji\u0304-ka\u0301u-me\u0302': '00073', 'khi\u0302nn-ke': '04081', 'put-sam-put-su\u0300': '00606', 'mi\u0302-a\u0301-tsua\u0301': '10792', 'ta\u0304u-iu\u0302': '03446', 'kong-ka': '00706', 'la\u0304i-ma\u0301': '00749', 'kong-ke': '00707', 'buah-to': '03988', 'kim-ku-li\u030Dk': '04669', 'gi\u0301n-a\u0301-phi\u0301': '02158', 'ta\u0304ng-tha\u0302u-khin': '05574', 'pau-nia\u0301': '01605', 'senn-thih': '02040', 'hi\u0301-kho\u0301': '07881', 'bi\u0301-ko-mue\u0302': '02812', 'io\u0302-na\u0302': '09591', 'pue\u0304-iok': '05420', 'tsha\u0302n-ta\u0304u': '13375', 'a\u0300i-kha\u0300u': '09477', 'tshi\u0302nn': '13002', 'thia\u0300u-ka\u0301ng': '10252', 'tshi\u0302ng': '10569', 'pu\u0304-siu\u0304': '10495', 'kua\u0300-mia\u0302': '07363', 'bi\u0304n-po\u0300o': '05601', 'sann-kenn': '00330', 'hio\u0302ng-ho\u0302ng': '09300', 'phu\u0302-ti\u0302m': '06190', 'pua\u030Dh-pa\u0302i-a\u0301': '09155', 'siu-ki\u0300': '02576', 'bi\u0301-ling': '02651', 'tso\u0301ng-phoo': '12317', 'khin-gi\u0302n': '10927', 'tshiam-ta\u0302ng': '13301', 'ki\u030Dp-si\u0302': '01028', 'tshiah-sua': '03456', 'kio\u0300-mn\u0302g': '01501', 'tiong-tsit': '00713', 'thinn-kong': '00848', 'khit--e\u0302': '00375', 'hue bo\u0302 pah ji\u030Dt a\u0302ng, la\u0302ng bo\u0302 tshian ji\u030Dt ho\u0301. ': '60193', 'huat-su\u030Dt': '04304', 'u\u0304-to\u0300ng-tha\u0302u': '02577', 'khoo-pi-a\u0301': '03762', 'puah-kang': '11147', 'tang-ha\u0301i': '04243', 'khui-bi\u0304n': '09204', 'thu\u0301n': '13607', 'tshiau sin-khu': '09539', 'sian-tan': '01326', 'pe\u030Dh-ji\u0302n': '01876', 'tsi\u030Dh': '02611', 'oo-ian-thu\u0302n': '06325', 'tsi\u030Dt': '00001', 'tsi\u030Dp': '13491', 'tso\u030Dk-tshin': '07485', 'kha-tshng-kha\u0301u': '01679', 'pi\u0301n-tsiam': '10921', 'huan-be\u030Dh': '08764', 'lo\u030Dk-a\u0301': '08119', 'ho\u0300nn-ki\u0302': '02346', 'tsia\u0302nn': '10084', 'lia\u030Dh-li\u0302ng--e\u0302': '07439', 'sua\u0304inn-a\u0301-tshenn': '12225', 'sua\u0301n-phio\u0300': '12009', lop: '11735', 'kua\u0302nn--tio\u030Dh': '08337', 'io\u030Dh-tu\u0302': '12899', liang: '08271', 'gi\u0301-huat': '10870', 'sin-uan': '01940', 'ko\u0300o-khiam': '10274', 'sai-kong-tua\u0302nn': '01441', 'li\u0301m-li\u0301m--a\u0301': '12377', 'tsa\u0300n-si\u0302ng': '12914', 'io\u030Dh-tsiu\u0301': '12889', 'u\u0304 kia\u0301nn u\u0304 kia\u0301nn mia\u0304, bo\u0302 kia\u0301nn thinn tsu\u0300-tia\u0304nn. ': '60158', 'li\u0302m-tsiong': '12357', 'kong-hun': '00614', 'tsua\u0301-pa\u0302i': '06541', 'sio-tsing': '05290', 'tshui\u0300-tsua\u0302nn': '08249', 'sa\u0301ng-se\u0300': '12365', 'ge\u0302-tso\u0302': '01287', 'khiu\u0302-khiu\u0302': '04580', 'a\u0300nn-io': '02243', 'to\u0304-ka\u0300u': '10243', 'kha-kin': '10144', 'sann-pah la\u030Dk-tsa\u030Dp ha\u0302ng, ha\u0302ng-ha\u0302ng tshut tsio\u0304ng-gua\u0302n. ': '60064', 'tsu\u0300-im': '04366', 'sia\u0300-si\u0300-tsi\u0300ng': '03639', 'lia\u0301u-tsi\u0302nn sing-li\u0301 bo\u0302 la\u0302ng tso\u0300, tha\u0302i-tha\u0302u sing-li\u0301 u\u0304 la\u0302ng tso\u0300. ': '60039', 'phi-sng': '05375', 'lio\u030Dk': '00588', 'u\u0304-ia\u0301nn': '02567', 'i\u0300n-tshui\u0300-i\u0300n-tsi\u030Dh': '12202', 'ui\u0300-bu\u0304n': '11108', 'ke-kn\u0301g': '12721', 'tsui\u0301-tho\u0301o': '00840', 'mua\u0301-mua\u0301-si\u0304': '10629', 'gu\u0302 to\u0304 si\u0304 gu\u0302, khan ka\u0300u pak-kiann ia\u0304 si\u0304 gu\u0302. ': '60113', 'khioh-sue\u0300': '04122', 'sit-the\u0301-bi\u0304n': '01843', 'lo\u030Dk-kak': '08131', 'tsi\u0302nn-te\u0304-a\u0301': '12048', 'to\u0302ng-i\u0300': '02240', 'lo\u030Dk': '08111', 'tsok-io\u0304ng': '02903', 'li\u030Dk-tik': '10741', 'thn\u0302g-hio\u0304-su\u0304': '09348', 'king-kue\u0300': '09871', 'ba\u0304n-put-tik-i\u0301': '09910', 'tua\u0304-kia\u0301nn': '00310', 'ia\u0302n-tsi\u0301': '10291', '--li\u0301': '10028', 'kng-kio\u0304': '02591', 'ji\u030Dp ho\u0301o kha\u0301u, bo\u0302 si\u0301 ia\u0304 oo-a\u0301u.': '60053', 'tso\u0300-hong-thai': '06991', 'thiap-a\u0301': '03842', 'ho\u0302ng-te\u0300': '05273', 'kha\u0300u-tha\u0302u': '01624', 'si\u0302ng': '03953', 'tshut-pha\u0302ng': '01473', 'te\u0304-hu\u0304-a\u0301': '03193', 'ho\u0301-gia\u030Dh m\u0304-ta\u030Dt-tio\u030Dh e\u0304 tsia\u030Dh, ho\u0301 mia\u0304 m\u0304-ta\u030Dt-tio\u030Dh io\u0301ng-kia\u0304nn. ': '60154', 'tha\u0302u': '12065', 'ia\u0304-tsi\u0301ng': '07426', 'tha\u0302i': '02959', 'tha\u0302m': '09765', 'io\u030Dh-tuann': '12892', 'in-tuann': '02249', 'thn\u0302g-ko': '11885', 'sam-tshit-a\u0301': '00228', 'tsi\u0301-sa\u0300u': '01135', 'ku\u0300n-a\u0301': '08515', 'sio-iok': '05276', 'kau-a\u0301': '10297', 'hi\u0302ng-su\u0304': '02187', 'si\u0300n-io\u0304ng': '04726', 'si\u0300ng-bo\u0301': '09924', 'thi\u0302-kha\u0300u': '08234', 'tha\u0300m-bo\u0304ng-tshu\u0300': '07424', 'kha-te\u0301': '10116', 'kha-te\u0302': '10161', 'thian-li\u0301': '01062', 'gia\u0302': '01644', 'ha\u0301i-lio\u0304ng': '06226', 'ho\u0304ng-te\u0302': '03804', 'pa\u0302i-tsia\u0300u': '08679', 'that-a\u0301': '07720', 'su\u0301-io\u0304ng-la\u0302ng': '03556', 'pi\u0302-ui\u0304': '08942', 'pia\u0300n-king': '13330', 'la\u0304i-suann': '00603', 'suah-ta\u0304u-iu\u0302': '11100', 'se-thang': '06542', 'si\u0301-bah': '02490', 'oo-la\u0302ng': '06254', 'la\u030Dk-gue\u030Dh kua\u0300-tsha\u0300i ke\u0301 u\u0304 sim. ': '60096', 'la\u0302i-a\u0301': '07502', 'khu\u030Dt-tha\u0302u-suann': '13518', 'tia\u0302u-ka\u0301i': '11405', 'tsi\u0301nn-kiunn': '06642', 'ko\u0300o-su\u0304': '05028', 'gia\u0304m-si': '13336', 'sam-ka\u0300u': '00438', 'la\u0302n-hue': '13155', 'phi\u0302ng-lu\u0304n': '09118', 'hia\u0302nn-tsha\u0302': '11825', 'ba\u030Dk-tsiu': '01985', 'khan-ha\u030Dt-a\u0301': '07625', 'la\u0304u--e\u0302': '02692', 'ti\u0304ng-khok-khok': '13604', 'tshiau-sing': '09080', 'sio\u030Dk mi\u030Dh tsia\u030Dh phua\u0300 ke. ': '60199', 'ko\u0300o-tsip': '03745', 'tsa-hng': '05032', 'ho\u0301-tshui\u0300-ta\u0301u': '02380', 'thong-su': '07974', 'gia\u0304m-hueh': '13329', 'sia\u0300-hue\u0300-te\u0301': '03681', 'ngiu\u0301': '03155', 'huat-sing': '08732', 'kho\u030Dk': '08793', 'lo\u030Dh-bi\u0302n': '09963', 'hip ta\u0304u-tsha\u0300i': '08938', 'bu\u0301-ki\u0304m': '01717', 'po\u0300-ko\u0300': '08286', 'thu\u0304n-pe\u0302nn': '03042', 'ha\u0304ng-bo\u030Dk': '09262', 'bi\u0302n-a\u0301-ji\u030Dt': '04220', 'kho\u0301-hua\u0304nn': '05153', 'tha\u0302ng-thua\u0304': '12639', 'ba\u0304n-it': '09898', 'bi\u030Dh-a\u0301': '12291', 'oo-tshi\u0304': '06266', 'tshu\u0301-siau': '03672', 'sua\u0300nn-kang': '08448', 'tshian sn\u0300g ba\u0304n sn\u0300g, m\u0304-ta\u030Dt thinn tsi\u030Dt ue\u030Dh. ': '60078', 'pi\u0302n-tua\u0304nn-kut': '07992', 'pu\u0302n-ke-kui': '11800', 'bo\u0302-le\u0301': '08706', 'pa\u0301n-lia\u0302u': '04258', 'hu\u0301n-pia\u0301nn': '06490', 'ba\u0304n-tshia\u0301nn': '10540', 'tha\u0301ng-kua\u0300': '07483', 'tsha\u0300i-kue': '08966', 'lo\u0304o-i\u0304ng': '10206', 'tsha\u0301i-ko\u0300o': '07442', 'siong-phiau': '07085', 'i\u0301n-hu\u0302n': '01151', 'tshia-ia\u0304nn': '07154', 'pi\u0302n-tua\u0304nn': '07991', 'bah-soo': '02768', 'ka\u0301': '08858', 'ka\u0300': '10639', 'tsue\u0304': '09844', 'ka\u0304': '04789', 'si\u030Dk-sa\u0304i-la\u0302ng': '11229', 'iu-tha\u0304i': '12163', 'ta\u0302n-lui\u0302-kong': '11597', 'ha\u0301i-li\u0302ng-o\u0302ng': '06240', 'kha-tha\u0301ng': '10135', 'to\u030Dk-tshiu\u0301': '05149', 'ta\u0301nn-pa\u0304n': '01719', 'ga\u030Dk': '11144', 'khin-tshi\u0300n': '10919', 'li\u0304': '12693', 'nn\u0304g-pi\u0302ng': '03633', 'li\u0300': '09322', 'li\u0301': '03414', 'li\u0302': '13433', 'khua\u0300nn la\u0302ng tsia\u030Dh bah, m\u0304-thang khua\u0300nn la\u0302ng sio-phah. ': '60215', 'ka-lu\u0301n-su\u0301n': '02104', 'khik-ho\u030Dk': '02913', 'khoo-lo\u030Dh': '10765', 'ho\u0301-tsha\u0301i-tha\u0302u': '02370', 'thia\u0304u-a\u0301-kha': '05105', 'io-kia\u0301nn': '03371', 'tua\u0304-ta\u0302ng': '00462', 'bo\u030Dk-tiu\u0302nn': '04375', 'lia\u0302n-bi\u0301n': '11122', 'huan-hu\u0300': '02999', 'pha\u0301inn-siann-sa\u0300u': '01192', 'tshu\u0300-the\u030Dh': '05838', 'ji\u030Dt-a\u0304u': '00996', 'phua\u0300 tsha\u0302': '06418', 'sng-thia\u0300nn': '08754', 'tshiah-pe\u0302-pe\u0302': '03676', 'khua\u0300nn-iu\u0304nn': '05371', 'si\u0302ng-tam': '04163', 'at-a\u0301m': '10225', 'te\u0302-hio\u030Dh': '06621', '--ooh': '08197', 'jia\u030Dt-sim': '11247', 'hong-u\u0301': '05621', 'ba\u0304n-bu\u0302-it-sit': '09979', 'te\u0302-kua\u0301n': '06639', 'pa\u0301n-a\u0301': '04218', 'seh-pha\u0304ng': '09660', 'pha\u0300nn-tsi\u0302m': '00774', 'tho\u0301-ia\u0300': '06788', 'hue\u0301-sa\u0301i': '01258', 'thua-sua': '04037', 'gua\u0302n-tsa\u0301': '05839', 'tha\u0301n-tshio\u0300': '13649', 'ah-siu\u0301nn': '12156', khak: '12975', khah: '10172', khai: '09171', khan: '07594', kham: '08274', 'lo\u030Dh-tsu\u0302n': '09973', 'lo\u0304o-hui\u0300': '10256', 'ak-tshiu\u0301': '08454', 'ia\u0302-soo': '05448', 'to\u030Dk-tsha\u0302i': '11832', 'tia\u0304n-si\u0304': '10359', 'i\u0300-tsi\u0300': '09467', 'kio\u0302ng ah': '07225', khap: '03615', 'khn\u0300g': '03031', khat: '13589', khau: '13434', 'nn\u0304g-tshing': '03014', 'hue\u0301-khi\u0302nn': '01278', 'kua\u0301-hu\u0304': '10505', 'tia\u0301n-hong-si\u0302n': '05943', 'ang-bo\u0301o na\u0304 ka\u0304ng sim, oo-tho\u0302o pia\u0300n-si\u0302ng kim. ': '60249', 'ke-kak-a\u0301-tshia': '12720', 'kha-bue\u0301-pn\u0304g': '10110', 'tsue\u0304-ji\u0302n': '09848', 'be\u030Dh': '08112', 'si\u0302n--khi\u0300': '06458', 'to\u0302ng-ki': '02194', 'phun-a\u0301m': '11200', 'tshio\u0300-ue\u0304': '06483', 'kuann-lia\u0302u': '03876', 'kue-tsi\u0301': '01873', 'ka\u0301u-ga\u0304m-a\u0301': '04346', 'se-a\u0301': '06513', 'ioh-tshut-tshut': '12338', 'hi\u0302-la\u0302n-tshe\u0300-a\u0301': '08173', 'pang-ba\u0302ng': '12189', 'liu\u0302-sa\u0301n': '05211', 'bo\u0302-huat--i': '08636', 'siat-ke\u0300': '07891', 'tshia-tuann': '03482', 'ho\u0301ng-bu\u0304n': '07896', 'lo\u0302ng-bi\u0302n': '10203', 'tshai-sio\u0301ng': '07639', 'kuann-ua\u0302n': '03856', 'khan-lia\u0302n': '07632', 'pu\u0301n-si\u0300ng': '01737', 'si\u0301-gi\u0301n-a\u0301-po\u0301o': '02486', 'phian-sim': '06953', 'la\u0300m': '13614', 'gua\u0302n-ke\u0300': '05866', 'pu\u0304': '10470', 'te\u0304-ta\u0304ng': '02367', 'pu\u0300': '08311', 'pu\u0302': '05189', 'bu\u0304n': '11810', 'kue\u0300-ke\u0300': '09626', 'hue\u0300-te\u0301': '07961', 'iu\u0302nn-la\u0302u': '05176', 'siok-ua\u0300n': '07183', 'la\u0300u': '09893', 'sin-pu\u0304': '09562', 'ka\u0304u-bi\u0304n-phue\u0302': '04816', 'tio\u0304ng-tsi\u0302nn': '05573', 'tshia\u0302u si\u0302-tsing': '11162', 'tn\u0304g-kin': '12528', 'hue\u0302-hok': '02270', 'tsik-sun': '03668', 'bo\u0304ng-pa\u0302i': '10464', 'kiu\u0301': '00049', 'kiann-si\u0301': '13326', 'tsha\u0302n': '01855', 'hu\u030Dt-ka\u0300u': '02933', 'kia\u0301u-tong': '08880', 'tsha\u0302i': '09011', 'nia\u0301u-tshi\u0301': '08154', a: '04512', 'ua\u0300n-hu\u0304n': '04957', 'sa\u0300u-se': '07388', 'su\u0304n-li\u0304': '09266', 'thong-io\u0304ng': '07947', 'u\u0304-si\u0302-a\u0301': '02518', 'nge\u0304-ah': '08813', 'ba\u0301i bi\u0304': '13554', 'to\u0300-tua\u0304nn': '05787', 'hi\u0302ng-i': '02827', 'tshap-tshui\u0300-tshap-tsi\u030Dh': '08413', 'tah-hiannh': '09586', 'kui\u0301 kang': '08351', 'la\u0304ng-hong': '03186', 'tsa\u0301-ua\u0300nn': '02521', 'kia\u0301u-kui\u0301': '08893', 'hi\u0304nn-khua\u0302n': '02817', 'siau-hui\u0300': '06315', 'tshi\u0300n-sim': '05747', 'huat-gua\u0304n': '08788', 'tshit-tho\u0302-la\u0302ng': '13558', 'lo\u030Dh-ho\u0304o-thinn': '09951', 'siu-tsoo': '02526', 'sua\u0301-phoo': '07302', 'la\u0302n-bia\u0301n': '12943', 'tui\u0300-tu\u0301': '10496', 'ho\u0301-ho\u0301-la\u0302ng': '02325', 'kue-a\u0301-ni\u0302': '01886', 'so\u0301ng': '07593', 'to\u0304o': '03355', 'kho\u0301o-khn\u0300g': '05506', 'iu\u0302-tsia\u030Dh-kue\u0301': '04299', 'bi\u0302ng-bi\u0302ng': '04235', 'ha\u030Dp-tshiu\u0300nn': '02217', 'soo-io': '09221', 'kha\u0300': '10563', 'kha\u0301': '01649', 'tse\u0300-bu\u0304': '09359', 'bo\u0301-sin': '01725', 'bi\u0304n-phu\u0302n': '05628', 'khi\u0301-hio\u0302ng': '06776', 'm\u0304 ho\u0301-se\u0300': '00914', 'uai-tshua\u030Dh': '05169', 'hui\u0302': '07654', 'hong-khi\u0302m': '05656', 'hui\u0300': '09066', 'hui\u0301': '09666', 'sim-i\u0300': '01105', 'tsok-kua\u0300i': '02911', 'pa-lang': '01013', 'tsha\u0300u-tsia\u0304n': '06634', 'tia\u0300u-ko': '02251', 'hu\u0304n-be\u0302': '04245', 'ke-bong': '12754', 'si\u0300ng-keh': '03929', 'ti\u0300n-ap': '12765', 'bi\u0304n-tsik': '05691', 'ji\u0304n-tsue\u0304': '10875', 'tsa\u0304m-tha\u0302u': '12957', 'iu\u0300-mi\u0304-mi\u0304': '01840', 'io\u0302-lo\u0301o-a\u0301': '09590', 'oo-sim-tsio\u030Dh': '06261', 'su\u0301n-kuann': '08895', pho: '04330', 'nn\u0300g-tsn\u0300g': '12684', 'thua\u0300nn-sa\u0301i': '05206', 'mn\u0302g-phio\u0300': '04625', 'thau thiann': '07026', 'ma\u0301i': '09064', 'nua\u0304-ko\u0302o-ko\u0302o': '13144', 'ko-a\u0301': '11870', 'tsha\u0302n-hua\u0304nn-lo\u0304o': '01916', 'sio-su': '05311', 'sio\u0302ng-ngo\u0302o': '04249', 'bah-si\u0304nn-a\u0301': '02742', 'lo\u030Dh-la\u0300m': '09978', pun: '00594', puh: '08722', 'tsui\u0301-tsa\u030Dh': '01131', 'thang-a\u0301-khing': '08805', pue: '05587', 'ia\u0301u-siu\u0304': '01136', 'e-hng': '00372', 'sia\u0304-tsue\u0304': '12433', 'tshiong-bua\u0301n': '01378', put: '03219', 'ho\u0302ng-te\u0300-ta\u0304u': '05274', 'hu\u0304-bio\u0301': '01237', 'kuan-tsat-ia\u0304m': '12953', 'le\u030Dh to\u0304o': '09343', 'sa\u0301n-te\u0304': '07678', 'ti\u0304-iau': '04297', 'khui-hue': '09201', 'sia\u0301m-tio\u030Dh': '06885', 'phia\u0300n-kui\u0301': '12968', 'pe\u030Dh-ue\u0304': '01996', 'ba\u0304ng': '10779', 'thiam-ting': '07540', 'u\u0300n-tsui\u0301': '09531', 'bi\u0302n-su\u0304': '01730', 'bua\u0301n-lia\u0302n': '10931', 'koo-hu\u0304': '09146', 'hio\u0304-hue\u0301': '04966', 'gu\u0302-tha\u0302u': '01297', 'se-tsong': '02859', 'gi\u0304-a\u0300n': '13062', 'sian-pue\u0300': '02102', 'ka-tsa\u0300i': '03568', 'tua\u0304-tsi\u0301': '00359', 'pe\u030Dh-ku\u0301-tsha\u0300i': '01939', 'oo-tshiu': '06352', 'kue\u0300-khi\u0300': '10201', 'o\u030Dh-a\u0301-sian': '11650', 'po\u0301o-po\u0301o': '07823', 'ka\u0301u-tsa\u0300n-thah': '00157', 'tshoo-kip': '03675', 'pue\u0301': '08375', 'kn\u0301g-le\u0302-a\u0301-hong': '07440', 'oo-tso\u0301': '06311', 'tsi\u0301-thia\u0300nn': '01041', 'tsi\u0300-tsio\u0301': '02636', 'sua\u0304n': '10643', 'tsai-khin-ta\u0304ng': '04423', 'tha\u0302u-ti\u0304n': '12102', 'tsha\u0302-sia\u0300u': '05133', 'pue\u0304': '05390', 'lo\u0302o-si-ka\u0301': '12397', 'tsui\u0301-pha\u0304 ': '00981', 'lia\u0302n-hue': '11349', 'khue\u0302-si\u0300nn': '10012', 'tong-jia\u0302n': '09793', 'tha\u0302u-the': '12094', 'tsok-lo\u0304ng': '02910', 'kia\u0304nn': '02053', 'kho\u0301-pha\u0300': '01492', 'hu\u0302n-ang': '09267', 'ia\u0302n-pit-khau': '10308', 'hun-so\u0300o': '00767', 'be\u0301-tsu\u0301': '09077', 'mo\u0302o-honn ku kue\u0301 tsa\u0300ng, a\u0302ng-pau sui\u0302 li\u0301 sa\u0300ng. ': '60112', 'piah-khang': '11654', 'ha\u030Dk-ha\u0304u': '11656', 'ho\u0300o-ta\u0301u': '03908', 'tsia\u030Dh hi\u0302 tsia\u030Dh bah, ia\u0304-tio\u030Dh tsha\u0300i kah. ': '60225', 'sio-sia\u0302m': '05293', 'ta\u0304u-pia\u0301nn': '03509', 'ta\u030Dk e\u0302': '07933', 'tha\u0302u-mn\u0302g': '12075', 'bo\u0302-i\u0300-bo\u0302-su\u0300': '08678', 'khi\u0301-moo giang': '06717', 'kha-bo\u0302o-tshiu\u0301-i\u0300n': '10156', 'tshui\u0300-am': '08256', 'pi\u0302ng-kin': '01716', 'ho\u0302-pi\u0302ng': '03721', 'u\u0304-si\u0302n': '02527', 'kio\u0302ng-tshiu\u0301nn': '07242', 'pia\u030Dt-tsong': '03016', 'bah-si': '02764', 'kheh-tsa\u0300n': '04898', 'tsia\u0302n-in-hio\u0304-ko\u0301': '04731', 'sia\u0302n-a\u0301': '12634', 'a\u0300m-kong-tsia\u0301u': '09615', 'la\u0301u-tua\u0304': '02626', 'pho\u0300ng-hong tsui\u0301-ke tha\u0302i bo\u0302 bah. ': '60355', 'kui\u0301-ke\u0300': '10048', 'lia\u0304n-a\u0301': '12455', lim: '07042', 'pa\u0302ng-ok': '04063', liu: '09668', 'sann kha-po\u0304o tsi\u030Dt kha\u0301m tia\u0300m. ': '60065', 'sa\u0301i-ha\u030Dk-a\u0301-tha\u0302ng': '04909', 'si\u0304nn-ia\u0302m': '07909', 'tha\u0302u tua\u0304 bi\u0304n su\u0300-hong, to\u0301o tua\u0304 ki tsa\u0302i-o\u0302ng. ': '60358', 'khan--e\u0302': '07620', 'oo kan-a\u0301 te\u0301 ta\u0304u-iu\u0302. ': '60245', 'ko\u0300-so\u0300o': '03054', 'kua\u0300n-sio\u030Dk': '07707', 'hia--e\u0302': '10226', 'sann-a\u0301-kho\u0300o': '05530', 'te\u0304-li\u0301': '02373', kak: '12795', 'hit-tsa\u0304m': '03931', kai: '10082', kah: '10171', kan: '09175', kam: '01849', 'kho\u0300-ti\u0302ng': '11402', kap: '06023', kau: '10288', kat: '08853', 'be\u0301-tha\u0302u': '06910', 'ia\u0301u-tsiat': '00941', 'huan-a\u0300n': '12602', 'na\u0304u-ta\u0302i': '11609', 'hiu-ha\u030Dk': '02103', 'tsha\u0300i-tuann': '08988', 'sio\u0301-tsik': '00352', 'uai-ko': '05166', 'ho\u030Dk-hing': '08362', 'phua\u0304nn-tshua\u0304': '02931', 'tio\u0301ng': '04507', 'tshau-tsok': '11697', 'ko--koh': '05852', 'hia\u0304n-ta\u0304i': '07610', 'ki\u0301n': '10785', 'hu\u0304-lo\u0301': '01246', 'ji\u0302n-tsi\u0302ng': '00142', 'tia\u0300m-tsu\u0301': '03844', 'tha\u0300i': '03293', 'bu\u0301-jio\u030Dk': '04696', 'tha\u0300m': '07329', 'tha\u0300n': '09070', 'sa\u0301n-tsha\u0302n': '11251', 'po\u0300o-te\u0304': '01776', 'tsha\u0302n-tsng': '01898', 'tshui\u0300-tu\u0302n': '08241', 'tha\u0300u': '07919', 'pho\u0304o': '12845', 'nih-nih-khua\u0300nn': '13565', 'si\u0301-gi\u0301n-a\u0301-the': '02485', 'ka\u0301ng-su': '12421', 'ak-ho\u0304o': '03320', 'ta\u0304u-hu\u0304': '03504', 'pia\u0301u-si\u0304': '04543', 'hia\u0304n-kim': '07621', 'ga\u0302u khai': '13510', 'sann-a\u0301-ki': '05529', 'khe\u0301-huat': '07078', 'ka\u0301m-hua\u0300': '09461', 'tsi\u030Dt-ha\u030Dk-sa\u0301i': '00042', 'tsan-hi\u0302': '12359', 'siu\u0304-pa\u0301n': '10455', 'tia\u0304nn-tia\u0304nn': '03852', 'ji\u0302n-bi\u0302n': '00093', 'ki\u0301ng-tsia\u030Dh': '08404', 'tsui\u0301-tha\u0302u': '01180', 'tia\u0304n-na\u0301u': '10365', 'ti\u030Dk-sik': '06273', 'tha\u0302u-mn\u0302g-tsha\u0300i': '12078', 'khit-tsia\u030Dh-mia\u0304': '00407', 'ho\u0301-ta\u0301nn': '02424', 'pia\u0301u-king': '07190', 'ka\u0304u-si\u0300ng-te\u0304': '04807', 'tshim-to\u0304o': '07565', 'thih-khi\u0301 ta\u0302ng-ge\u0302-tso\u0302': '13195', 'jia\u0302u-phe\u0301-phe\u0301': '11271', 'ha\u030Dp-keh': '02214', 'kio\u0302ng-ko\u0300ng': '07243', 'bo\u0301-kim': '01742', 'phue-phi\u0302ng': '03269', 'tsha\u0300i-phue\u0300': '08982', 'kia\u0300n-pu\u0301n': '03429', 'tsiau-pa\u0302i': '04119', 'ha\u0302n': '13621', 'ha\u0302i': '04865', 'tsi\u030Dt-pua\u0300nn-e\u0302-a\u0301': '00011', 'hi\u0302-ua\u0302n': '08115', 'bo\u0301ng io': '04453', 'pa\u030Dt-tah': '03019', 'ia\u0302n-pit': '10306', 'kia\u0302m-tok-tok': '13112', 'tshun-kha': '02943', 'tsa\u030Dh-lo\u0304o': '10309', 'gia\u0301n-kiu\u0300': '05346', 'thui-ko\u0301ng': '07428', 'khioh-gi\u0301n-a\u0301': '04018', 'tia\u0304n-ko': '10379', hiannh: '05004', 'phi\u0300ng-su': '09961', 'khiau-ku': '02524', 'io\u0304ng-to\u0302o': '01963', 'se\u0300-ka\u0300i': '01355', 'ha\u030Dp-sn\u0300g': '02248', 'ue\u0300-sue\u0300': '12569', 'na\u0302': '12624', 'li\u0302ng-tsi': '13376', 'na\u0301': '03411', 'ho\u0301o-pa\u0300-bu\u0301': '04613', 'na\u0304': '05469', 'kenn-kha-kenn-tshiu\u0301': '09870', 'thu\u0301n-ta\u030Dh': '13608', 'tia\u0300m-ua\u0302n': '03857', 'hau-sia\u0302u-ue\u0304': '10437', 'tsha\u0301u-soh-a\u0301': '06603', 'niau-a\u0301': '11949', 'tsun-gia\u0302m': '08346', 'a\u0302ng-tsau': '05454', 'o\u030Dh-tn\u0302g': '11660', 'bah-ka\u0301m': '02770', 'kinn-a\u0301-kue\u0301': '13394', 'ge\u0302-tso\u0302-kut': '01288', 'a\u0301u-ut': '04196', 'kong-kin': '00625', 'ko\u0302o-a\u0301': '11320', 'kong-kik': '03280', 'ji\u0302n-sim': '00141', 'pu\u0301n-la\u0302i': '01729', 'kia\u0302m': '13087', 'the\u0302-khi\u0301': '08410', 'kue\u0300-hue\u0301': '10199', 'khin-tshiu\u0301': '10902', 'pi-kio\u030Dk': '08361', 'tsang-sui': '08535', 'm\u0304-tsia\u0302nn-iu\u0304nn': '00923', 'se-lang': '07706', 'phue-ta\u0302ng': '03268', 'na\u0301-pua\u030Dt-a\u0301': '04253', 'la\u0304u-jia\u030Dt': '11620', 'pue-tshi\u0301': '05673', 'tsi\u0302ng-sia\u0304': '04778', hiann: '01321', 'lo\u0301ng-tso\u0301ng': '12825', 'tia\u0304n-thui': '10354', 'hu\u0301n-kue\u0301': '06487', 'o\u0302-a\u0301': '07845', 'ta\u0301nn-tha\u0300m': '01770', 'si\u0300-kha-a\u0301': '01587', 'hiunn-te\u0304-a\u0301': '05649', 'ho\u0300o-ta\u0301u--e\u0302': '03910', 'kho\u0304ng': '11567', 'ia\u0301-ke-a\u0301-tshia': '08105', 'ke-tshi\u0304': '09024', 'i\u0300ng-ha\u0304u': '12198', 'pia\u0304n-tong-kheh-a\u0301': '04703', 'tha\u0302u-tshit': '12070', 'poo-kiunn': '05892', 'he\u0304-tho\u0301ng': '03386', 'hue\u0300-siu\u0304': '09701', 'tso\u0300-la\u0302ng': '06946', 'ngia\u030Duh': '12628', 'sua\u0301n-tshiu\u0301': '11993', 'ha\u030Dk-bu\u0304n': '11658', 'la\u0301m-sin': '06664', 'tshoo-ta\u0304ng': '07778', 'ho\u0301o--la\u0302ng': '07048', 'sua\u0301n-ki\u0301': '12016', 'te\u0300nn-sia\u0301u': '03579', 'na\u0301 u\u0304 na\u0301 bo\u0302': '05485', 'te\u0304-tha\u0302u': '02421', 'ka\u0300u-ua\u0302n': '07383', 'hia\u0301m-hia\u0301m': '12058', 'tsi\u030Dt lia\u030Dp bi\u0301, pah lia\u030Dp kua\u0304nn. ': '60025', 'kha-tau': '10133', 'e-tsa\u0301i-a\u0301': '00318', 'kia\u0300nn-khing': '12947', 'la\u0302u-a\u0301-tshu\u0300': '11196', 'tiong-ta\u0300u': '00722', 'the\u0301-keh': '13340', 'ui\u0300-lo\u0304': '11112', 'ta\u0302m-ko\u0302o-ko\u0302o': '11798', 'oo-si\u0300m-si\u0300m': '06253', 'la\u0304n-hu\u030Dt': '13522', 'ho\u0301-kia\u0301nn': '02322', 'kua\u0300i-phiah': '03948', 'sann ji\u030Dt bo\u0302 liu\u0304, peh-tsiu\u0304nn tshiu\u0304. ': '60061', 'po\u0300-ho\u030Dk': '08298', 'ko\u0301ng-ue\u0304': '12434', 'ji\u0304-pi\u0302ng': '02312', 'ui\u0301-ua\u0302n': '03801', 'tshiu\u0300nn': '07039', 'tse\u0304-tsio\u0301': '12247', 'ko\u0301o-a\u0301-ting': '10392', 'thiah-tshuann': '04027', 'su-kau': '03370', 'u\u0301n-tak-tak': '12868', 'tu\u0301-a\u0301-ho\u0301': '04007', 'hun-pia\u030Dt': '00667', 'a\u0300i-khu\u0300n-io\u030Dh-a\u0301': '09487', 'sia\u0300-io\u030Dh-a\u0301': '12551', 'pa\u0302i-lia\u030Dt': '07362', 'be\u0304-ti\u030Dt': '06670', 'ho\u0302ng-hun-tshi\u0304-a\u0301': '09275', 'pia\u0301u-hiann': '04534', 'ho\u0302-mi\u0301-kho\u0301o': '02889', 'nn\u0301g-sio\u0302-sio\u0302': '07977', 'sua\u0300nn-bu\u0302n': '08455', 'sua\u0304n-sia\u0302u': '06794', 'tsa\u0304i-la\u0302i-bi\u0301': '02190', 'sia-sia\u0300u': '10881', 'pak-la\u0304i': '09906', 'kan-na\u0301': '11769', 'sua\u0300n-a\u0301-hue': '10824', 'hong-sio\u030Dk': '05624', 'phah-phu\u0301-a\u0301-kng': '04118', 'ti-siu\u0304 m\u0304-ta\u030Dt ka\u0301u-siu\u0304 u\u0301n. ': '60347', 'tsia\u030Dh-kho\u0301o': '05630', 'tshian-kin-tshi\u0300n': '00276', 'e\u0304-ka\u0301ng': '00453', 'tsuan-bu\u0302n': '07181', 'ha\u0304u-tiu\u0301nn kiam ko\u0300ng tsing. ': '60241', 'tsin-li\u0301': '06426', 'ka\u0304u-hun': '04832', 'tshia\u0301n-bi\u0302n': '07570', 'tua\u0304-se\u0300': '00443', 'n\u0302g-ki-a\u0301-hue': '13635', 'e\u0304-pue\u0300': '00533', 'iu\u0302-ta\u0302ng-a\u0301': '04307', 'lia\u0302u': '13481', 'pau-hi\u0302': '12143', 'tshiu\u0301-su\u030Dt': '01069', 'kim-tsua\u0301-tia\u0300m': '04610', 'sia\u0304n-lio\u0302ng': '08221', 'put-si\u0302': '00708', 'ho\u0301-tshui\u0300': '02379', 'tshim-hua\u0304n': '04688', 'lia\u0302m': '12482', 'kha-jia\u0301u': '10097', 'siau-ia\u0304': '05936', 'tsa\u0301inn': '10174', 'pha\u0301u': '09127', 'khiau--khi\u0300': '02477', 'ka\u0304ng-khua\u0301n': '01370', 'kio\u0300': '01412', 'kio\u0302': '05473', 'kio\u0304': '12905', 'ta\u0300i-lia\u0304m': '07224', 'a\u0300i-sui\u0301 m\u0304 kiann la\u0302u phi\u0304nn-tsui\u0301. ': '60318', 'ta\u0300i-sin-mia\u0304': '07221', 'tsha\u0300u': '06553', 'tsha\u0300i': '08956', 'tsha\u0300m': '13366', 'tham-kuann-u\u0300-li\u0304': '07962', 'pa\u0300i-pu\u030Dt': '04944', 'kho-tiu\u0301nn': '05350', 'tsi\u030Dt-khu\u0300n-a\u0301': '00033', 'pho\u0300-hua\u0304i': '06442', 'hiunn-ua\u0300nn': '05637', 'bue\u0301-pang-tshia': '03136', 'huat-khi\u0301': '08757', 'tshoo-po\u0304o': '03653', 'ha\u0300u-tai': '03097', 'khin-po\u030Dh': '10932', 'tsheh-tu\u0302': '01383', 'siann-se\u0300': '12364', 'se\u030Dh-si\u0302n': '10918', 'tsa\u0300i-pa\u0301n': '02198', 'kho\u0301-tha\u0302u-mue\u0302': '05178', 'ti\u030Dk-khua\u0302n': '06353', 'nih-ba\u030Dk': '13566', 'uan-la\u0302i-uat-khi\u0300': '13235', 'la\u030Dp-sue\u0300': '06475', 'the\u0302-tshut': '08393', 'tshing-iu': '07566', 'the\u0300-tsiu\u0301': '06766', 'te\u0302-kua\u0300n': '06650', 'mua\u0302-tik-su\u0301n': '08129', 'm\u0301-po\u0302': '03808', 'pi\u0302ng': '01224', 'to\u0302ng': '08801', 'phi\u0301n-tsit': '04829', 'ji\u0302n-tan': '00610', 'khi\u0301-siu\u0302nn': '11605', 'pua\u0304nn ba\u0301ng-a\u0301': '04184', 'bu\u0302-koo': '08672', 'kha-pe\u030Dh-su\u0301n': '06576', 'tho\u0302o-ta\u0304u-ji\u0302n': '09405', 'lo\u030Dh-bue\u0301-tshiu\u0301': '09934', 'ke\u0300-tshik': '05556', 'lia\u0302n-khua\u0302n': '08016', 'tua\u0304-si\u0300-ke\u0300': '00292', 'te\u0301-pn\u0304g': '09114', 'tso\u0301ng-sia\u0300u': '12315', 'te\u0302-pua\u0302nn': '06631', 'thap-pu\u0301n': '09399', 'tsi\u0300ng-kheh': '05037', 'ba\u030Dk-khang': '01924', 'tsai-ho\u0304': '03391', 'bi\u0304-so\u0300o-hu\u0301n': '03742', 'siann-sa\u0300u': '12366', 'kiam-ko\u0300o': '05807', 'po\u0302ng': '03950', 'lia\u0301n-khap-tshio\u0300': '11102', 'thuah-thang': '05995', 'o-lo\u0301': '03733', 'thinn-tse\u0301nn': '00847', 'tn\u0302g-lo\u0300-so\u0300': '04678', 'thn\u0300g-khak': '11926', 'tsio\u0301-so\u0300o': '01154', 'hi\u0302ng-to\u0304ng': '02729', 'mo\u0304o-hia\u0301m': '04773', 'ua\u030Dh-thia\u0300u-thia\u0300u': '05217', 'king-tsio': '00538', 'khan-bo\u0302ng': '07603', 'lia\u0301u-bue\u0301-a\u0301-kia\u0301nn': '00107', 'hi-ki\u0302': '08810', 'gua\u0302n-siau': '00703', 'tsui\u0301-pit-a\u0301': '01096', 'hue\u0302-sim-tsua\u0301n-i\u0300': '02148', 'kue\u0300-kio\u0302': '10267', 'ha\u0304m-khenn': '08065', 'tso\u0302ng-pa\u0300i': '07226', 'ka\u0304u-sua-sap': '04806', 'pau-sit-tha\u0302u': '01633', 'phiau-phiat': '13085', 'tsua\u0301nn-iu\u0304nn': '04982', 'tui\u0304-tiu\u0301nn': '09202', 'a-se': '04553', 'pe\u030Dh-tshiunn': '02038', 'li\u0301n-nia\u0302': '05989', 'ang-a\u0301-tsheh': '03087', 'thui\u0302-a\u0301': '10607', 'i\u0302m-lua\u0304n': '07582', 'kiann-hi\u0300': '03591', 'siu\u0300-kiu\u0302-hue': '12608', 'ba\u030Dk-tsiu-ji\u0302n': '01986', 'la\u0302n-tit': '12948', 'tsha\u0300i-thng': '08990', 'pah-pah-khang': '02668', 'tsi\u0300ng-ti\u0304': '05033', 'thn\u0302g-pho\u0304o': '11890', 'n\u0301g': '11361', 'ta\u0304u-hue': '03451', 'tsi-phio\u0300': '01066', 'si\u0302-tsit': '12929', 'hak-tshu\u0300': '10827', 'tn\u0301g--khi\u0300': '12660', 'lo\u030Dh-la\u0302m': '09952', 'sau-sau': '07519', 'sia\u0304n-la\u0302m-si\u0300n-li\u0301': '08220', 'thinn-kong-senn': '00852', 'mi\u0304-thi': '13117', 'khia\u0304m-tsi\u0302nn': '11007', 'tsua\u0301-tshu\u0300': '06530', 'kho\u0300o-te\u0304-a\u0301': '11925', 'sia\u0304-tsua\u030Dt': '12431', 'kue\u0301-hio\u030Dh': '10767', 'na\u0304-tsu\u0301n': '05501', 'la\u0302n-san-tsi\u0302nn': '10347', 'kho\u0300o-gi\u0302n': '05956', 'tsia\u0301u-a\u0301': '08118', 'tsu\u0304-ho\u0304o': '02896', 'a\u0300m-po\u0304o': '09620', 'kha\u0300n-ho\u0304o-hu\u0304': '05379', 'thui\u0301-kho\u0300o': '10801', 'te\u0301-kho\u0300o': '08837', 'la\u0302u-hueh': '05201', 'to\u030Dk-sin': '11821', 'kiat-a\u0300n': '08891', 'tsua\u0302-kue': '07849', 'san-phik-ing-ta\u0302i': '00324', 'tshiat-tshiu\u0301': '00627', 'la\u0302ng bue\u0304 ka\u0300u, siann sing ka\u0300u. ': '60041', 'thui-hi\u0302ng': '07364', 'phi\u0302ng-se': '09780', 'ho\u0301-khua\u0300nn': '02355', 'sio\u0301-be\u0304': '00531', 'hua\u030Dt-lo\u030Dh': '08771', 'sio-tsio': '05266', 'tshut-ji\u030Dp': '01424', 'ta\u0304i-khi\u0300': '00427', 'ji\u0302n-ke': '00133', 'kho\u0301-pi\u0301': '01447', '--hioh': '11937', 'sio-phah-tia\u0304n': '05267', 'siu-tsi\u0301ng': '05724', nah: '12546', nai: '01648', 'khui-phua\u0300': '09207', 'kia\u0300u-kia\u0300u-kio\u0300': '11636', 'kiann bo\u0301o ta\u0304i-tio\u0304ng-hu, phah bo\u0301o ti ka\u0301u gu\u0302. ': '60389', 'lo\u0302-sim': '08210', 'pia\u0301nn-tia\u0300m': '10960', 'ha\u0301i-thuah': '06242', 'po\u0301-tsu\u0302n': '04732', 'tshiu\u0301-hong-khi\u0302m': '01017', 'pe\u0302-put': '06527', 'la\u0302u-thng': '05212', 'tshut-mia\u0302': '01472', 'gi\u0302m-a\u0301': '13474', 'kan-pue\u0300': '00340', 'tsha\u0300u-phui\u0300-sian': '06585', 'ia\u0301u-m\u0304-koh': '08609', 'ua\u0301nn-pua\u0302nn': '09827', 'pia\u0301u-tsi\u0301': '04569', 'koo-ta\u030Dk': '03880', 'hui\u0300-bu\u030Dt': '11069', 'ka\u0300u-te\u0300': '03644', 'piak-khang': '09732', e: '05980', 'ho\u0304o-kha\u0301u-tshau-pu\u0301n': '00845', 'nge\u0304-pia\u0300ng-pia\u0300ng': '08823', 'ti\u0301ng-tsa\u0300n': '08096', 'hua\u0301n-to\u0300-tn\u0301g': '01021', 'kia\u0300-phue': '07177', 'se\u0301-thua\u0304': '05154', 'sap-bu\u0302n-hu\u0301n': '08052', 'si\u0302ng-ho\u0302ng': '04858', 'kia\u0302nn-le\u0301': '02822', 'phue\u030Dh': '04267', 'pe\u0302nn': '08507', 'khu-kong-so\u0301o': '07052', 'tsa\u030Dp-it-ko': '00066', 'be\u0302': '06697', 'tshio\u0300-tha\u0302u-tshio\u0300-bi\u0304n': '06493', 'be\u0301': '06822', 'so\u0301o-tsa\u0304i': '04017', 'kn\u0300g-pit': '12012', 'li\u030Dp-a\u0300n': '01943', 'hiau-hio\u0302ng': '07522', 'khai-ho\u0300ng': '09200', 'tso\u0300-kong-tik': '06965', 'phi\u0304nn-a\u0301': '10977', 'tho\u0302o-ta\u0304u-iu\u0302': '09406', 'a\u0302m-kau': '07526', 'tshi\u0304-tsa-bo\u0301o': '10348', 'iu\u0301nn': '11569', 'ba\u0302-sia\u0304': '08140', 'tia\u0304n-tha\u0302u-mn\u0302g': '10375', 'si\u0302-ta\u0304i': '06033', 'tshi\u0300-khua\u0300nn': '10045', 'kiam-tsit': '05802', 'jia\u0300u': '03218', 'tsia\u0300n-su\u030Dt': '11710', 'kuann-ue\u0304': '03874', 'huat-ka\u0300nn': '08776', 'tsia\u0300nn-sin': '01724', 'si\u0302ng-pa\u0304i': '02535', 'tah-tah': '09113', 'pu\u0300n-kha\u0301u-tha\u0302ng': '12290', 'tio\u0300ng-to\u030Dk': '00687', 'im-kan': '08085', 'ah-a\u0304u': '04067', 'pi\u0302ng-tsi\u0304ng': '01821', 'ji\u0302n-tsi\u0302ng la\u0302u tsi\u030Dt sua\u0300nn, ji\u030Dt-a\u0304u ho\u0301 sio-khua\u0300nn. ': '60047', 'si\u0300-kha-a\u0301-siu\u0302': '01588', 'ok-la\u0302ng': '08388', 'ka\u0300-su\u0301': '11598', 'san-tin-ha\u0301i-bi\u0304': '00401', 'sn\u0300g-sia\u0300u': '10770', 'tiam-phue\u0302-e\u0302': '06410', 'tso\u0300-hi\u0300': '07021', 'tshua\u030Dh': '07453', 'tsang-lu\u0300-a\u0301': '08541', 'the\u0300-po\u0304o': '06735', 'o\u0302-a\u0301-tsian': '07847', 'lo\u0302o-ti\u0302n': '13040', 'ti\u0301ng-the\u0300': '08083', 'tsa\u0301u-tshue\u0304': '03484', 'bo\u030Dk-kue': '00887', 'la\u0304n-mua\u0304': '13526', 'tsin-tsia\u0300nn': '06408', 'to\u0302ng-pau': '02207', 'tha\u0302u-ba\u030Dk-tsia\u0301u': '12084', 'siong-na\u0301u-kin': '09366', 'kong-gua\u0302n': '00612', 'se-sik': '02853', 'lo\u030Dh-nn\u0301g': '09974', 'to-tsio\u030Dh': '00095', 'so\u0300o-bi\u0304n': '06528', 'ha\u0301n-tit': '03384', 'thuat-sua\u0300nn': '07829', 'khuann-khuann-a\u0301': '11079', 'sing-li\u0301-la\u0302ng': '01956', 'sa\u0300u-se-gi\u0301m-a\u0301': '07389', 'khui-tshi\u0304': '09193', 'ka\u0301i-ua\u0304nn': '03265', 'tha\u0302u-tsang-khoo-a\u0301': '12122', 'tshoo-khng': '07801', 'ho\u030Dk-li\u0302ng-ko': '06598', 'khan-ti\u0302n': '07651', 'o\u0302ng-hio\u0304': '01244', 'si\u0300-ke\u0300': '01506', 'bo\u0301ng-tshi\u0304': '04482', 'la\u0304i-tsa\u0302i': '00604', 'kiat-lan': '08898', 'ka\u0300u-pu\u0301n': '07114', 'tha\u0300m-ho\u0301ng': '07404', 'ngo\u0301o': '13527', 'li\u0304-hun': '12738', 'siu-li\u0301': '05720', 'a\u0304u-ta\u0301u': '04928', 'khai-siau': '09228', 'ha\u0300m': '12900', 'khuan-ha\u0304n': '11072', 'koo-tiu\u0304nn': '03783', 'ha\u0300n': '10642', 'tha\u0301n-hua\u0302inn': '03761', 'ha\u0300u': '03066', 'po\u0300o-tiu\u0304-a\u0301': '11172', 'nn\u0304g': '02967', 'ma\u0302u-tu\u0301n': '01937', 'la\u0302i-li\u030Dk': '03589', 'ia\u0302n-ha\u0301i': '04301', 'huan-sia\u0304': '08748', 'na\u0304-bo\u0302': '05498', 'la\u0301ng-khua\u0302n': '12827', 'la\u0302n-san': '10346', 'ke-mn\u0302g-tshi\u0301ng': '12700', 'tso\u0300-tsong': '07001', 'kue\u0300-ba\u030Dk': '10208', 'ah-hi\u0302ng-a\u0301': '12147', 'jia\u030Dt-sa\u0300u': '11267', 'tso\u0300-senn-ji\u030Dt': '06968', 'hu\u0301-tso\u0304o': '10911', 'ji\u030Dt-ki\u0302': '01084', 'khi\u0301-tshio': '06704', 'so\u0301o-iu\u0301': '04025', 'pa\u0300i-pa\u0300i': '04959', 'lia\u030Dh-bo\u0302-tha\u0302u-tsa\u0301ng': '07410', 'ta\u030Dk-a\u0300m': '07997', 'phue-khak': '03266', 'oo-to\u0300o-a\u0302ng': '06252', 'ia\u0300n-khi\u0300': '10428', 'ha\u0304u-li\u030Dk': '06029', 'tshiu\u0304-kin': '11749', 'a\u0304u--ji\u030Dt': '04929', 'kiunn-a\u0301': '04445', 'si\u030Dt-bu\u030Dt': '05620', 'tsit-tah': '07995', 'tang-kue-te\u0302': '01469', 'tiong-i': '00775', 'pha\u0301inn-mi\u030Dh': '00980', 'ah-bo\u0301-te\u0302': '12134', 'kia\u0300m': '10996', 'kia\u0300n': '03398', 'tsa\u0304i-tsa\u0302ng-n\u0302g': '02276', 'kn\u0301g-sim-pe\u030Dh': '07349', 'nia\u0301u-tshi\u0301-tak-a\u0301': '08159', 'be\u0304-sin': '11455', 'mui\u0302-hue': '07475', 'ba\u0301n-me\u030Dh': '06053', 'khe\u0302': '13487', 'khe\u0300': '13221', 'iam-ke tha\u0300n ho\u0304ng pue. ': '60365', 'lia\u030Dt-tshia': '02184', 'tsia\u0301': '04433', 'ho\u0300o-sia\u030Dh': '03916', 'gue\u030Dh-king': '01114', phinn: '11306', 'gio\u0302': '12627', 'to\u0302ng-su\u0304': '02189', hip: '08923', 'uai-tshui\u0300': '05170', 'ko\u0301ng-phua\u0300': '12422', 'jiu\u0302': '08378', 'a\u0302u-tsing': '08269', 'tsi\u030Dt ki tsha\u0301u, tsi\u030Dt tia\u0301m lo\u0304o. ': '60018', 'ha\u030Dk-su\u0304': '11646', 'ba\u0301u--si\u0301--ah': '01476', 'gua\u0302n-lio\u0304ng': '05868', 'ho\u0302-khi\u0300': '03740', 'la\u0300u-ham': '09897', 'gua\u0304-kong': '01438', 'u\u0304 sio-hiunn u\u0304 po\u0301-pi\u0300, u\u0304 tsia\u030Dh io\u030Dh u\u0304 kia\u0302nn-khi\u0300. ': '60165', 'khu\u0300n-tshe\u0301nn': '08838', kian: '07101', kiam: '05734', 'phua\u030Dh': '07866', 'bo\u0302-se\u0300-ji\u0304': '08669', 'la\u0302ng teh tso\u0300, thinn teh khua\u0300nn. ': '60044', 'ta\u0301nn-tha\u0302u': '12373', 'bi\u0304n-iu\u0302': '05617', 'sui\u0302-si\u0302': '12041', 'pn\u0304g-ua\u0301nn': '09303', 'pa\u0302ng': '12283', 'tsih-tsa\u0300i': '07422', 'pak-phue\u0302': '05752', kiat: '08854', kiap: '02966', 'kua\u0300n hong': '13136', 'siak-tshik': '10550', 'ni\u0301-bo\u030Dk': '02658', 'i\u0301n-khi\u0301': '01050', 'hue\u0301-tsi\u0300nn': '01290', 'phah-la\u0302n': '04191', 'ta\u030Dk-pa\u0301i': '08019', 'tshi\u0301m-sik': '10498', 'nn\u0301g-kut': '07980', 'ha\u0301i-iu\u0302nn': '06202', 'a-tsa': '08954', 'kua\u0304n-tiu\u0301nn': '11878', 'siu\u0304-tse\u0300': '03683', 'ti\u0301ng-gue\u030Dh': '08049', 'tshi\u0300ng-khang': '10301', 'sio\u0300ng-phi\u0300nn': '05250', 'khui-khia\u0300u': '09237', 'tsua\u0304inn': '10091', 'be\u0301-bi\u0304n': '06868', 'tshiu\u0304-sin': '11746', 'khui-khia\u0300m': '12388', 'jua\u030Dh-thinn': '11246', 'kua\u0300-tsha\u0300i': '04480', 'phian-phiah': '07015', 'sat-khi\u0300': '07518', 'phian-phian': '06997', 'hia\u0302m hue\u0300 tsiah si\u0304 be\u0301 hue\u0300 la\u0302ng. ': '60316', 'tui\u0300-pun': '10481', 'pa\u0301-hi\u0300': '03279', 'bu\u0302n-pi\u0302ng': '01166', 'phi\u0300-siu\u0300nn': '13058', 'tia\u0300u-tshia': '02185', 'tsa\u0301u-im': '03460', 'hua\u0302inn': '11770', 'pua\u0300nn-the-to\u0301': '01422', tsiah: '06820', tsian: '09717', tsiam: '06813', tsiap: '01671', 'kha\u030Dp-tha\u0302u': '11303', tsiat: '09837', tsiau: '03982', 'si\u0302n-toh': '06469', 'ti\u0301ng-ham': '08039', 'khang-tshiu\u0301': '04398', 'pi\u0300nn-kui\u0301': '13341', 'tua\u0300nn': '01661', tsin: '06396', 'it-lu\u030Dt': '00022', 'iu\u0302nn-a\u0301': '02642', 'hiong-tshin': '09159', 'si\u0301-tsue\u0304': '02554', 'mue\u0302-pn\u0304g': '12310', 'khi\u0301-ma\u0301': '06796', kheh: '13576', 'na\u0302-ta\u0302u-tsi\u0301--a\u0301': '04231', 'bo\u0302-i\u0300-tiong': '08677', 'pu\u0301n-tann': '04985', 'ki\u030Dk-tuan': '09703', 'toh-thuah': '06150', 'tik-mo\u030Doh': '02804', 'e\u030Dh': '06251', 'phu\u0301n': '12582', 'bio\u0304-kong': '11054', 'ka\u0300u-khui\u0300': '07133', 'o\u030Dh-a\u0301': '11649', 'tsi\u0302nn-ha\u0304ng': '12050', 'tshui\u0300-khang': '08228', 'be\u0304-i\u0304ng-tit': '06659', 'kim-tsiam-koo': '04616', 'kia\u0301u-tsha\u0301': '13299', 'thinn-kng': '00897', 'pue-li\u0302ng-a\u0301': '09000', 'mia\u0302-ji\u0304': '02171', 'su\u0301n-siong': '09570', 'tsi\u0300ng-tha\u0302u': '06389', 'ti m\u0304 tua\u0304, tua\u0304 tui\u0300 ka\u0301u khi\u0300. ': '60345', 'li\u0304-li\u0304': '12767', 'ha\u0300m-kia\u0300nn': '12931', 'tsa\u0300-io\u030Dh': '05227', 'po-tsio\u0301ng': '11407', 'put-bua\u0301n': '00762', 'ba\u0304u mi\u0304': '13580', 'ti\u0304nn': '09713', 'bih-ho\u0304o': '09030', 'ko\u0300ng-thui\u0302-a\u0301': '09576', 'kua\u0300n-si\u0300': '10551', 'tio\u0300-ji\u0304': '08093', 'ho\u0302-pit': '02902', 'thiu-the\u0300': '04098', 'tsi\u0300ng-tho\u0301ng': '01775', 'ji\u030Dp-i\u0304nn': '00140', 'hua\u0300n-tshu\u0300': '07971', 'gua\u0302n-ko\u0300': '05841', 'hu\u0301n-kuann': '06462', 'ha\u0300n-i': '10671', 'i\u0302-a\u0301': '04844', 'la\u0302u-thui': '11206', 'kng-bi\u0304n': '02080', 'pia\u0301u-hia\u0304n': '04623', 'tsia\u0300u-po\u0304o-la\u0302i': '09753', tsiu: '05148', 'he\u0304-pu\u0301n': '00296', 'pa\u0302i-a\u0301-tha\u0302u': '08518', 'e\u0304 senn tit kia\u0301nn sin, be\u0304 senn tit kia\u0301nn sim. ': '60321', 'o\u0304o-kue\u0301': '03500', 'lia\u0300n': '12444', 'lia\u0300m': '07313', 'kha\u0301u-khi\u0302m': '00458', 'niau-niau': '11975', 'ha\u030Dp tsio\u0301ng': '02233', 'sia\u0301-ji\u0304': '11063', 'mua\u0302-iu\u0302': '08134', 'kia\u0304': '07199', 'sue-u\u0304n': '06681', 'kia\u0300': '07160', 'tsi\u030Dt e\u0302 gi\u0301n-a\u0301 khah la\u0304u jia\u030Dt sann e\u0302 tua\u0304-la\u0302ng. ': '60033', 'mi\u0302-tsioh': '08538', 'tshiu\u0301-ko\u0301o': '00990', 'tsiap-kut': '07393', 'sa\u0301i-ba\u030Dk-bue\u0301': '03557', 'ni\u0302-ku\u0301-gue\u030Dh-tshim': '02302', 'tsiunn-tsi\u0302': '12399', 'tsha\u0300i-na\u0302': '09006', 'bi\u0301-le\u0304': '05463', 'hong-tshue-lia\u0301n': '05611', 'tshu\u0302n-si\u0301 ': '02329', 'huat-kue\u0301': '08775', 'ki\u0301-to\u0304ng': '12354', 'tik-ta\u0302ng': '02761', 'to\u0304o-lio\u0304ng': '04899', 'le\u0301-gi\u0302': '12572', 'i\u0300n-ka\u0300m': '02277', 'si\u0300-siu\u0300-a\u0301': '01484', 'tsu\u0302-a\u0300i': '09491', 'hi\u0304nn-a\u0300ng-a\u0301': '02823', 'la\u0301u-pa\u0301n': '02690', 'bi\u0301-thai': '02807', 'lue\u0304-sim': '00623', 'bue\u0304-tsi\u0302ng': '01785', 'si\u0304-a\u0301n-tsua\u0301nn': '05042', 'hiong-ka\u0301ng-kha': '05655', 'ku\u0301n-ka\u0301': '10623', 'ua\u0301inn-tio\u030Dh': '13515', 'kia\u0301m-gia\u0304m': '12236', 'khi\u0301-bi\u0301n-a\u0301': '11613', 'tsha\u0300i-hue': '08979', 'kuan-tsi\u0302ng-ko\u0300o-a\u0304u': '13426', 'a\u0304u-khok': '04989', 'siu-nua\u0304 siu-li\u0304-li\u0304, me\u0302-ni\u0302 tsio sio\u0301-ti\u0304. ': '60156', 'po\u0301o-phua\u0300-ba\u0304ng': '10049', 'mo\u0302o-pe\u0304nn': '01042', 'suann-a\u0304u-tsia\u0301u': '00392', 'kiu\u0300-tshenn': '07382', 'hue-khann': '04455', 'phuah-ho\u0304o': '11201', 'siat-sio\u0301ng': '07900', 'ba\u0301n te\u0302': '06054', 'pit-jia\u0302n': '01788', 'kau-kuah': '02087', 'pi\u0300n-sui': '13406', 'sio\u0304ng-ngo\u0301o': '00255', 'ko\u0301o-tsu': '01525', 'ua\u0301-ki\u0304n': '05764', 'tsi\u030Dt ji\u030Dt sua\u0301 tsai, sann ji\u030Dt khia\u0304 n\u0302g. ': '60012', 'ki\u0300ng-tio\u0304ng': '09547', 'tia\u0301m-hia\u030Dt': '12493', 'pi\u0300-su': '06420', 'u\u0304n-to\u0304ng-hue\u0304': '10242', 'thia\u0300u-soh-a\u0301': '10236', 'po\u0300-uan': '08292', 'tsiat-ku\u0304': '03281', 'bo\u0302o': '11188', 'tia\u0304m-tsi\u0304ng': '04986', beh: '07493', 'si\u030Dk-thih': '11236', 'su\u0301n-si': '08901', 'tsiu\u0300nn-lia\u0304u': '12730', 'a\u0300m-me\u0302': '09650', 'tshin-tshik': '11969', 'tshu\u0304-to\u0301': '09149', huah: '05327', 'pu\u0300n-tui': '12301', 'tshiu\u0302nn-tshik': '12788', 'tsu\u0301-to\u0304ng': '01363', 'pu\u0301n-i\u0300': '01795', 'uai tshui\u0300 ke tsia\u030Dh ho\u0301 bi\u0301. ': '60211', 'mua\u0302-tshiok': '08148', 'sin-khua\u0301n': '09567', 'hi\u0304ng': '09065', 'ka\u0301ng-ki\u0302nn': '08582', 'tho\u0302o-ang-a\u0301': '09402', 'hi\u0304nn': '02604', khip: '02980', 'kho\u0301ng-tsu\u0301-kong': '00841', 'tshiu\u0301-n\u0301g': '00826', 'li\u0301-a\u0301': '03241', 'khann-a\u0301': '03720', 'gua\u0304-ui\u0304': '01480', 'tha\u0300ng--kue\u0300': '06786', 'sui\u0302-ki-i\u0300ng-pia\u0300n': '12057', 'suah-si\u0302n': '09735', 'go\u0304o-si\u0302': '01027', 'tsho\u0300-bi\u0301': '12293', 'e\u0304-u\u0302n': '00248', 'tshio-tio\u0302': '13531', 'po\u0304ng-phue\u0302': '11290', 'a\u0300m-o\u030Dh-a\u0301': '09655', 'kau-kiat': '00737', 'tho\u0301o-la\u0302ng': '00220', 'tua\u0304-be\u0304': '00530', 'la\u0300u-sa\u0301i-be\u0301': '09955', 'po\u0301o-u\u0304n-tsi\u0302nn': '10069', 'pha\u0301inn': '00817', 'le\u0302-tsha\u0302n': '07611', 'e\u0304-pua\u0300nn-me\u0302': '00294', 'i\u0301-tha\u0302u-a\u0301': '08537', 'ua\u030Dh-ta\u0304ng': '05209', 'lo\u0300ng ko\u0301o': '06078', 'e\u0304-sa\u0301i': '09621', 'kn\u0300g-tsiam': '07979', 'khui-tshia': '09197', 'tso\u0301-iu\u0304': '01697', 'phi\u030Dh-phi\u030Dh-tshuah': '03728', 'jia\u0300u-pe\u0302-a\u0301': '03258', 'hue\u0304-to\u0302ng': '09617', 'tshui\u0300-tu\u0302n-phue\u0302': '08242', 'kim-ta\u0301u': '04527', 'tshiah-hue': '03661', 'ha\u0304u-iu\u0301': '06118', 'pha\u0301inn-lo\u0304o': '01122', 'ti\u0300-i\u0300m': '05445', 'lio\u0302ng-sim': '03418', 'ha\u030Dk-sing': '11652', 'ba\u0301n-hue\u0302': '06035', 'si\u0301-ti-a\u0301-ke\u0300': '02574', 'tua\u0304-tso\u030Dh--ji\u030Dt': '00395', 'la\u0304u-bu\u0301': '02654', 'ji\u0302m': '11090', 'hu\u0301n-tshia\u0302ng': '06481', 'ji\u0302n': '00577', 'hun-tshu\u0300n': '00605', 'tiunn-la\u0304u': '07217', 'khui-pua\u0302nn': '09227', 'su-su\u0304': '03377', 'e\u0304-kha': '00486', 'kia\u0301m-tsa': '12230', 'te\u0304-ke\u0300': '02412', 'puann-tshia': '09537', 'sam-pa\u0301n-a\u0301': '05493', 'pang-bo\u0302o': '04259', 'le\u0304-gua\u0304': '03553', 'tshiu\u0301-ua\u0301nn-kut': '01098', 'tsui\u0301-gi\u0302n': '01149', 'phah-kat-kiu\u0302': '04125', 'tia\u0304n-li\u030Dk': '10322', 'ut-hue\u0300': '13470', 'sua\u0300n': '10816', 'kik-pha\u0300i-tha\u0302u': '11786', 'it-puann': '00028', 'ka\u0300u-hun': '07110', 'ba\u030Dk-tsiu hue-hue, pu\u0302-a\u0301 khua\u0300nn-tso\u0300 tsha\u0300i-kue. ': '60137', 'bi\u0301-io\u0302ng': '05423', 'la\u0300u-si\u030Dt-a\u0301': '09999', 'kut-hu': '06873', 'sia\u0304-gua\u0304n': '12443', 'i\u0301-tia\u0304m-a\u0301': '08534', 'tsia\u0300nn-tong-si\u0302': '01800', 'siu\u0304nn-khang-siu\u0304nn-pha\u0304ng': '09472', 'gu\u0302-ka\u0301ng': '01273', 'koo-ia\u0302': '03816', 'ting-thah': '11834', 'ia\u030Dt-hong': '11706', 'bi\u0301-ko-siu\u0302nn': '02809', 'ka\u0301n': '13537', 'ka\u0301m': '13540', 'ka\u0301i': '10029', 'ha\u0300ng': '06511', 'kha\u0300ng-te\u0304': '04400', 'ka\u0301u': '04345', 'iu\u0302-se\u0301-se\u0301': '04298', 'hi\u0300ng-tshu\u0300': '11913', 'enn-a\u0301': '12185', 'hue\u0304-gi\u0304': '09661', 'ko\u0301ng-tshio\u0300-khue': '12425', 'khui\u0300nn-ua\u030Dh': '03184', 'tik-pe\u0302': '02722', 'iu\u0302-pia\u0304n-kio\u030Dk': '09143', 'tho\u0301o-kong-a\u0301-si\u0300ng': '00253', 'kui-lu\u030Dt': '07889', 'sio-khia\u0300m-tse\u0300': '05249', 'sui\u0302-i\u0300': '12052', 'n\u0300g-ba\u0304ng': '02221', 'lo\u030Dk-to\u0302': '12113', 'li\u030Dk-tik-su\u0301n': '10743', 'sam-san-kok-o\u0302ng': '00242', 'tsiu\u0304nn-pak': '00288', 'tsi\u0301-tua\u0302nn': '08919', khueh: '06506', 'tsa\u0302i-tsi\u0302ng': '00437', 'phua\u0300--khui': '06431', 'kua\u0301nn-kang': '10860', 'bo\u0304ng-ku': '10467', 'sua\u0304n-jio\u0304': '10653', 'tsio\u030Dh-kang': '01875', 'king-tse\u0300': '09878', 'tiunn-sin-se\u0300': '07222', 'jia\u0301ng': '12983', 'pia\u0300nn-senn-si\u0301': '04011', 'koh-e\u0304-khang': '06518', 'pu\u0302n pi-a\u0301': '11799', 'iu\u0302-tsi\u0300ng': '09145', 'si\u030Dp-tsua\u0302n': '00097', 'ji\u0302n-keh': '00136', 'pa\u0304n-huat': '12000', 'kui\u0300-tik': '06126', 'oo-thn\u0302g': '06340', 'tsa-poo-kia\u0301nn tit tsha\u0302n-hn\u0302g, tsa-bo\u0301o-kia\u0301nn tit ke\u0300-tsng. ': '60210', 'tua\u030Dt': '10450', 'jia\u0302u': '13079', 'su\u0304n-hong': '09279', lun: '07094', 'tsn\u0300g-khang': '13441', 'tshiah-ji\u0304': '03645', keh: '10312', 'siang e\u0302 tsn\u0304g, ok kah bo\u0302 la\u0302ng mn\u0304g. ': '60377', 'le\u0301-ho\u030Dk': '12564', 'tsia\u030Dh-tshi\u0304': '05603', 'phu\u0302n': '05238', 'sia\u0300m-jio\u0304': '10616', 'siau-tu\u0302': '06298', 'khip-tsio\u030Dh': '02993', 'kam-tinn': '01952', 'tsu\u0300-siau': '09120', 'sia\u030Dp': '05147', 'bio\u0304-si\u0304': '11064', 'sia\u030Dh': '03235', 'te\u0304-hi\u0302ng': '02337', 'pua\u030Dh-kia\u0301u': '09156', 'te\u0301-phi\u0300nn': '03840', 'huat-to\u0304ng': '08758', 'teh-pi\u0301nn': '08818', 'ji\u030Dp-tiu\u0302nn': '00149', 'sio\u030Dk-ke\u0300': '04766', 'thih-sian': '13191', 'khai-khu\u0301n': '09229', 'iu-tia\u0301m': '12166', 'pho\u0300o': '11342', 'khi\u0301-tshiu\u0301': '06712', 'phia\u030Dh': '12555', 'hu\u0304-li\u0301': '07167', 'gu\u0302-tu\u0300n-tsha\u0301u': '01279', 'li\u0301ng-ki-ki': '02908', 'sia\u0301u-ka\u0301u': '08744', 'la\u0300u-khang-tsua\u0304': '09947', 'kui\u0301-mn\u0302g-kuan': '06862', 'pia\u0301u-tsi\u0302ng': '04620', 'ko\u0301o-tong': '04458', 'su-hiann': '05928', 'pn\u0304g-phi\u0301': '09270', 'siong-pu\u0301n': '09340', 'sio\u030Dk-mia\u0302': '04730', 'ta\u0302u-tsu': '03271', 'tshut-hong-tha\u0302u': '01515', 'sua-tsio\u030Dh': '05340', 'tsu\u0304-so\u0301o': '02912', 'tso\u0300-kheh': '06987', 'pua\u0300n': '01396', 'hong-hue\u0301-tha\u0302u': '05599', 'tsn\u0304g': '04344', 'a\u0300m-ta\u0304m': '09638', 'pi\u0301ng-lia\u0300n-tn\u0301g': '01197', 'pu\u0300n-so\u0300-tshi\u0304-tiu\u0302nn': '12302', 'tshuh-ba\u030Dk': '07676', 'si\u030Dh-pu\u0301n': '10841', 'gi\u0302n-sik': '10909', 'tik-ba\u030Dk': '02656', 'kha\u0300u-ah': '02501', 'sin-khu': '03522', 'kang-tsok': '00323', 'tsia\u0300u-pa\u0304n': '09759', 'be\u0301-uann': '06904', 'ia\u0302n-ti\u0302': '03942', 'hiunn-lo\u0302o': '05706', 'sing-li\u0301': '01953', 'ji\u030Dt-sio\u0302ng': '01056', 'thai-a\u0301': '11869', 'tio\u030Dh-tshi\u0300ng': '09045', 'tshing-hoo': '10747', 'ho\u030Dk-tsa\u030Dp': '11413', 'tshi\u0300n': '06447', 'ki\u0302-ha\u0304n': '08523', 'ba\u030Dk-pua\u0302nn': '11032', 'ia\u0302n-ko\u0300o': '11324', pit: '08842', 'pi\u0301-bu\u0301': '00979', 'kue\u0301-tsa\u0300ng': '10769', 'ha\u0300u-tsu\u0301': '03078', 'thui-tshik': '07407', 'gu\u0302-ling-thn\u0302g': '01242', 'tshui\u0300-pe\u030Dh': '08215', 'thiam-iu\u0302-hiunn': '07562', 'e\u0304-ta\u0300u': '00439', 'lo\u0300ng mn\u0302g': '06045', 'ngo\u0301o-gi\u030Dk': '03192', 'siu\u0304-tong-be\u0304-khi\u0301': '03685', 'tshn\u0302g': '03140', 'iu\u0302-tsa\u0304i': '01895', 'kue\u0300-bi\u0304n': '10231', 'kau-i\u0301': '02093', 'tsi-tshut': '00877', 'hia\u0304n-si\u0300': '07609', 'pe\u030Dh-la\u0304i-tsia\u0300ng': '01877', 'pak-to\u0301o-bue\u0301': '09938', 'ho\u0301-ha\u0300n': '02409', i: '12685', 'la\u0304ng-sin-niu\u0302': '03201', 'tui\u0300-tshui\u0300': '10509', 'i\u0302ng-a\u0301-ue\u0304': '09192', 'tui\u0302': '08370', 'lo\u030Dk-thio\u0300ng': '11171', 'tui\u0300': '10475', 'kue\u0300-lo\u0302o': '10279', 'sim-sik': '01162', 'tse\u0300nn': '11416', 'bo\u0304ng': '07460', 'seh-a\u0304u-tshiu\u0301': '09625', 'phiann-lia\u0302u-kut': '12103', 'bo\u030Dk-kua\u0300i': '07851', 'pia\u0301n-sian-a\u0301': '11950', 'ho\u0304o-tsia\u0300u': '13189', 'la\u0302ng-kang': '00078', 'mi\u030Dh-kia\u0304nn': '04359', 'hi\u0300nn-tia\u0304u': '05052', 'm\u0304-ta\u030Dt': '01019', 'khiu\u0301-khiu\u0301-la\u030Dk-la\u030Dk': '09571', 'pi\u0302n-tsu\u0301n': '11716', 'sio\u0300ng-mia\u0304': '05262', 'ti\u0301ng-ka\u0301ng': '08084', 'a\u030Dh': '07661', 'tshoo-tsua\u0301': '07781', 'ji\u030Dt-kong-ting': '00900', 'ga\u0300n-tsui\u0301': '13616', 'jio\u0302ng': '08859', 'pi\u0300n-kha': '13399', 'tsi\u0300ng-khua\u0302n': '05076', 'bah-sik': '02666', 'khi\u0302ng': '11279', 'a\u030Dp': '07662', 'gi\u0304-hue\u0304': '13068', 'khi\u0302nn': '10286', 'mn\u0302g-khian': '04624', 'tshue-sn\u0302g': '04363', 'ha\u0300inn': '09439', 'po\u0300o-tsha\u0302n': '11152', 'kam-tsho\u0301': '01945', 'lo\u030Dk-im': '12002', 'siang-ti\u0302ng': '12726', 'ta\u030Dh-khiau': '11507', 'han-tsi\u0302': '08782', 'kah-i\u0300': '03580', 'ka\u0300u-ka\u0300u': '07136', 'si\u0300-phua\u0300': '01529', 'oo-im-thinn': '06304', 'phah-phik': '04050', 'liu\u0301-lia\u030Dh': '03194', 'phi\u0301n': '13538', 'phi\u0300ng-kim': '09949', 'be\u0304-su-ko\u0301ng': '06686', 'hueh-khi\u0300': '02714', 'se-tha\u0302u': '06239', 'gia\u0304m siong': '13350', 'hia\u030Dh-tha\u0302u': '12791', 'lo\u0302o-si-ting': '12396', 'the\u0302-pua\u030Dt': '08398', 'kio\u0304ng-kio\u0304ng': '07233', 'ka ho\u0302 ba\u0304n-su\u0304 hing, ka lua\u0304n ba\u0304n-se\u0300 ki\u0302ng. ': '60239', 'tshiu\u0301-khiau, khut-ji\u030Dp bo\u0302 khut-tshut. ': '60104', 'tua\u0304-ui\u0304': '00322', 'la\u0304i-siong': '00746', 'thiah-khui': '04130', 'kong-kio\u0304ng': '00654', 'ma\u0301-se-ma\u0301-se': '06845', 'phia\u0300n': '12962', 'pho\u0300ng-pia\u0301nn': '11912', 'kho\u0300ng-gi\u0304': '03284', 'puann-hi\u0300': '09587', 'sann-a\u0301-king': '05528', 'tshiu\u0301-ge\u0304': '01205', 'sia\u0301u-thiu\u0301-a\u0301': '00252', 'tsi\u0304ng-io\u0301ng': '12056', 'gua\u0302n-khi\u0300': '00710', 'phu\u0302-tsio\u030Dh': '06188', 'tshi-tsha\u0301m': '07295', 'kuan-te\u0300-ia\u0302': '12946', 'a\u0300ng': '13390', 'ka\u0300-tshia': '10218', 'pho\u0300ng-tshi\u0301': '11911', 'sin-lo\u0302': '03481', 'lu-tho\u0302o-ki': '12534', 'ua\u0301nn-kong': '09812', 'kang-tha\u0302u': '00543', 'a\u0300nn': '02130', 'tsio\u030Dh-ka\u0301m-tong': '01969', 'te\u0304-pua\u0302nn': '02415', 'tah iu\u0302': '09542', 'sian-kak': '02108', 'tua\u0304-phia\u0304ng': '00562', 'tsha\u0301u-poo': '06602', 'ah-pa\u0300': '12218', 'tha\u0302u-mia\u0302': '12086', 'liu\u0304-kue\u0301': '12789', 'lo\u030Dh-a\u0302u': '09977', 'gi\u030Dk': '06703', 'phu\u0301-sik': '08555', 'pe\u030Dh-pak-a\u0301': '01994', 'a\u0300u-na\u0301u': '11714', 'kuan-ta\u0302ng': '12950', 'tia\u0304n-kua\u0300n': '10386', 'tiu\u0304-sui\u0304': '11304', 'ue\u0304-pe\u0300nn': '10126', 'tsha\u0301-ke-la\u0304-ke\u0300': '03007', 'nge\u0304-kut': '08824', 'sia\u0300u-lia\u0302n-ke': '00913', 'hia\u0304n-tiu\u0302nn': '07633', 'hu\u0302-a\u0301': '07722', 'kia\u0301u-jia\u0301u': '13304', 'tsa-bo\u0301o-la\u0302ng': '05113', kiok: '08955', 'ti\u0302nn': '13149', 'oo-iu\u0302': '06283', 'tsia\u0300-koo-tsha\u0300i': '13294', 'hut-jia\u0302n': '03935', 'tang-iu\u0302nn': '04239', 'ho\u0301-thinn': '02306', 'tui-ji\u0304n': '06790', 'ia\u0301nn-i\u0300n': '11062', 'lo-so': '13242', 'to\u0302o-su': '10462', 'tsia\u030Dh-sik': '05608', 'i\u0301n-to\u0304o': '01086', 'hua\u0304nn-pua\u0302nn': '02570', 'tsia\u0301u-a\u0301-siu\u0304': '08122', 'bo\u0302-me\u0302-bo\u0302-ji\u030Dt': '08684', 'tsa\u0304nn': '13591', 'tsha\u0304i': '13619', 'hia\u0304-tshu\u0300': '01941', 'tsi\u030Dt me\u0302 tsua\u0302n tha\u0302u-lo\u0304o, thinn-kng bo\u0302-pua\u0300nn-po\u0304o. ': '60029', 'kang-tiu\u0302nn': '00447', 'khe\u030Dnnh tha\u0302m': '08255', 'li\u0301-kheh': '06046', 'a\u0301u-ho\u0302ng': '10425', 'tsa\u0301u-sia\u0300-be\u0301': '03479', 'io\u0301ng-lo\u0301': '11580', 'kiau-tshia': '12917', 'tshuan-pue\u0300': '00339', 'so\u0300ng': '03067', 'tsiu-ui\u0302': '03749', 'khah-tshia': '01488', 'kin-a\u0301-ji\u030Dt': '00638', 'sut-a\u0301': '07351', 'tsu\u030Dt-bi\u0301': '06459', 'tso\u0300-gi\u0304-niu\u0304': '07024', 'jia-tsa\u030Dh': '11540', hu: '11602', hi: '09009', 'thih-ting': '13182', 'tha\u0300n-tsia\u030Dh-tsa-bo\u0301o': '09100', 'ba\u030Dk-tsiu kim-kim la\u0302ng siong-tio\u0304ng. ': '60138', ha: '04796', 'tso\u0301ng-ba\u0304u': '12309', 'tshui-sing': '09341', 'gue\u030Dh-gua\u0304-ji\u030Dt': '00879', 'ke\u0304-im': '00403', 'tsa\u0301-khi\u0301-si\u0302-a\u0301': '02517', 'pha\u0300nn-sia\u0300u': '00766', 'thua\u0304-sann': '03322', 'tshoo-po\u0300o': '07761', 'tsit-tsu\u0304n': '07981', 'se\u0301-mn\u0302g-hong': '05159', 'a\u0300m-sa\u0300m': '09653', 'sioh-kia\u0301nn': '07265', 'ling-ga\u0302m': '01830', 'hu\u030Dt-tn\u0302g': '02932', 'tso\u0301ng-bu\u0304': '12299', 'i\u030Dk-king': '04255', 'hua\u0300-sin': '00953', 'thau-ka\u0304-ke-a\u0301': '06986', 'ki\u0300-ho\u0304': '06784', 'oo-hi\u0302': '06305', 'tsa\u030Dp-ji\u0304-hun': '00070', 'la\u0300ng-pha\u0304ng': '11561', 'tsa\u0304i-la\u0302ng': '02141', 'ji\u0302n-tsi\u0302ng-se\u0300-su\u0304 pue\u0302 ka\u0300u-ka\u0300u, bo\u0302 tia\u0301nn koh bo\u0302 tsa\u0300u.': '60046', 'ho\u0300ng-ho\u0300ng': '04052', 'ha\u0304u-hia': '13398', 'tsu\u0300-sia\u0304': '04368', 'bo\u0302-tsha\u0301i': '08663', 'ka\u0300u-gia\u030Dh': '07153', 'ke\u0304': '00178', 'pha\u030Dk ia\u0302m': '12828', 'ke\u0302': '10813', 'ke\u0301': '06933', 'ke\u0300': '05510', 'ga\u0304ng': '08369', 'tsiu\u0304nn-toh': '00425', 'oo-lio\u0302ng-a\u0301': '06347', 'pia\u0301u-bi\u0304n': '04591', 'sua\u0300n-jio\u0302ng': '10828', 'kau-tshap': '02089', 'lue\u0304-koh': '00765', 'ka\u0300u-tsui\u0301': '07112', 'ta-kuann': '00366', 'lu\u0300': '13309', 'lu\u0301': '00198', 'phe\u0304nn-phe\u0304nn-tshua\u0301n': '03923', 'the\u0302-ho\u0302ng': '08395', 'tshut-tha\u0302u': '13114', 'go\u0304ng--e\u0302': '13454', 'tsit-siann': '08017', 'so-ia\u0302m': '07310', hng: '06652', 'se\u0300-siann': '07802', 'hong-thai': '05677', 'tsho\u0300ng': '08183', 'tsa\u0300n-siann': '12928', 'sim-tha\u0302u': '01175', 'ta\u0304ng-ti\u0304': '07083', 'tsa\u0302i-thua\u0302n': '06789', 'to\u0304o-ti\u0304ng': '03248', 'king-siong': '09860', 'hiau-sim': '10420', 'pah-ji\u0304': '02622', 'khu-sok': '04038', 'kio\u0302ng-pia\u0304n': '07248', 'tsi\u0300m-khi\u0304': '06201', 'tang-sai-la\u0302m-pak': '04229', 'mo\u0302o-he\u0304': '01207', 'ga\u0300n-kn\u0300g': '13617', 'pua\u0300nn-kang': '01433', 'the\u0302-kiong': '08396', 'hua\u030Dt-kim': '10798', 'siau-hua\u0300': '06257', 'a\u0304u-tshiu\u0301': '04927', 'to\u0302-mia\u0304': '06742', 'senn-si\u0302-ji\u030Dt-gue\u030Dh': '01942', 'la\u0301u-ti\u0302n': '06690', 'ian-tsi': '06533', 'tsi\u0300nn-hong': '09549', 'tshiu\u0301-jia\u0301u': '00872', 'khu-hi\u030Dk': '07072', 'khi\u0301-ko': '11619', 'gia\u0302m-keh': '12989', 'tsia\u0304m-tsia\u0304m': '10667', 'iang-sann-thok-si\u0300': '01436', 'iu-nga\u0301': '04900', 'ah-bi\u0304': '12195', 'jio\u0304-ta\u0301u': '03082', 'tsua\u0301-si\u0300nn': '06531', 'io\u030Dh-kio\u030Dk': '12882', 'kha-sau': '10136', 'm\u0304-tsu\u0301n': '01020', 'tiu\u0302nn-bi\u0304n': '08291', 'tn\u0302g-mia\u0304': '04568', 'tshoo-sio\u030Dk': '07772', 'pu\u0301n-su\u0304': '01728', 'tshia-pua\u0302nn': '06083', 'hue-tsa\u0302ng': '04496', 'khi\u0301-bo\u0302-khang': '06769', 'm\u0304-tio\u030Dh': '01099', 'hue\u0302-hu\u0302n': '02253', 'tso\u0301ng--si\u0304': '12294', 'tho\u0302o-hu\u0301n': '09418', 'se-a\u0301-sann': '06517', 'tshut-lo\u0304o': '01590', 'lia\u0301n-khing': '11532', 'la\u0302ng-sn\u0302g': '13271', 'huan-a\u0301-iu\u0302': '08727', 'bi\u0301n-ta\u0304u': '07370', 'thi\u0300ng': '13261', 'tsia\u030Dh-ling': '05602', 'tn\u0304g-tio\u030Dh': '09568', 'ho\u0302ng-la\u0302i-bi\u0301': '11352', 'te\u0302-bo\u030Dk': '12786', 'kn\u0300g': '11988', 'nua\u0304-sia\u0301n': '13147', 'sim-a\u0301': '07056', 'ha\u0301i-le\u0304-a\u0301': '06244', 'tso\u0300-tio\u030Dh pha\u0301inn tsha\u0302n ba\u0304ng e\u0304 tang, tshua\u0304-tio\u030Dh pha\u0301inn bo\u0301o tsi\u030Dt-si\u0300-la\u0302ng. ': '60262', 'te\u0304-ga\u030Dk': '02410', 'tshoo-phue': '07770', 'bue\u0304-tsi\u0302ng-bue\u0304': '01786', 'si\u0301ng-li\u030Dp': '05339', 'tsiong-ki\u0304n': '07180', 'kui-tui': '07897', 'it-ti\u0300': '00023', 'ke-lam': '12772', 'a\u0304u-tiu\u0302nn': '04972', 'kui-tsik': '07888', 'kia\u0302nn-khi\u0300': '02715', 'tshin-sin': '11953', neh: '13418', 'kha\u0300u-liu\u0302': '02522', 'phah-tshui\u0300-ko\u0301o': '04114', 'hui\u0302-a\u0301-tia\u0300m': '07673', 'go\u0304o-hue\u0304': '10874', 'khe\u0301-si\u0304': '07058', 'pha\u0301inn-khua\u0300nn-siu\u0300nn': '01010', 'phio\u0300-pe\u030Dh-hu\u0301n': '10650', 'khiu\u0304-teh-teh': '13587', 'sio-tsioh-mn\u0304g': '05279', 'senn--e\u0302 tshia\u0301nn tsi\u030Dt pinn, io\u0301ng--e\u0302 un-tsi\u0302ng khah tua\u0304 thinn. ': '60130', 'si\u030Dp-ji\u0304-tsi\u0301-tn\u0302g': '00072', 'mn\u0302g-hong': '04592', meh: '04788', 'a-tsi\u0301m': '04672', 'lio\u0302ng-ho\u0304ng': '12150', 'i\u0300ng tsha\u0302n': '11651', 'mi\u0304-pau': '13091', 'kim-ku': '04668', 'pho\u0300ng-kam': '08560', 'to\u0304ng-tsok': '07061', 'ha\u0301i-i\u0301ng': '06222', 'to\u0302-pi\u0304': '06803', 'sa-tsi\u0302nn': '06086', 'tsi\u0302ng-ji\u030Dt': '04722', 'mua\u0302-tik': '08128', 'kiat-ua\u0300n': '08885', 'tio\u0300ng': '08924', 'ho\u0301ng-a\u0301-ke': '02068', 'sim-tso\u0304ng-pe\u0304nn': '01217', 'pa\u030Dk-tsha\u0302n': '13480', 'te\u0300nn-m\u0304-tsai': '03548', thuann: '13246', 'tshiu-tshi\u0300n': '05353', 'tshit-tho\u0302': '13557', 'siu-tshui\u0300': '02538', 'tsa\u030Dp-ji\u0304 senn-siu\u0300nn': '00071', 'tsa\u0301u-ka\u0301u': '03449', 'pu\u030Dt': '02878', 'thua-lui\u0304': '04110', 'a-sa\u0301ng': '04600', 'pue\u0301-khui': '08418', 'tik-tshuann': '02663', 'oo-bui': '06335', 'siong-jiah': '09367', 'kiu\u0300-kin': '04479', 'ho\u0301o': '04498', 'la\u0301n-la\u0301n': '12826', 'e\u0304-tshiu\u0301': '00261', 'tio\u030Dh-si\u0302': '09035', 'phu\u0300n': '11014', 'tng-tha\u0302u-pe\u030Dh-ji\u030Dt': '09796', 'gio\u0302-a\u0301': '12635', 'khia\u0304-go\u0302': '07306', 'tsu-se\u0300': '04860', 'ko\u0300o-ti\u0304ng': '03731', 'tsa\u0302i-si\u0302n-ia\u0302': '06765', 'tsu\u0301n-si\u0302': '09687', 'bia\u0301n-hui\u0300': '02938', 'u\u0304-lio\u0304ng': '02545', 'po\u0300-siu\u0302': '08281', 'tsia\u030Dh tio\u030Dh io\u030Dh, tshinn-tsha\u0301u tsi\u030Dt hio\u030Dh; tsia\u030Dh m\u0304-tio\u030Dh io\u030Dh, ji\u0302n-sim tsi\u030Dt tsio\u030Dh. ': '60227', 'to\u0304o-tha\u0302u': '08567', 'ka\u0301m-mo\u0304o': '09473', 'thih-ki-lo\u0304o': '13180', 'khn\u0300g-hue\u0300': '03056', 'tho\u0301ng-it': '07753', 'mi\u0304-ku': '13115', 'am-poo-tse\u0302': '13594', 'sua\u0300-tshui\u0300-bue\u0301': '07787', 'lu-tha\u0302u-mn\u0302g': '12539', 'hu\u030Dt-mn\u0302g': '02919', 'sue-bue\u0301': '06662', 'oo-hoo': '09408', 'la\u030Dh-tsik': '13163', 'a\u0302ng-sio': '05447', 'tsi\u0301n-so\u0301o': '09028', 'tsha\u0300u-hiam-hiam': '06643', 'a\u0302ng-sik': '05411', 'mi\u0302-a\u0301': '08514', 'sin-hing': '09580', 'tit-se\u0300': '07240', 'ti\u0302n-tia\u0302u': '13157', 'khia\u0304-ke': '07278', 'bo\u030Dk-hi\u0302': '01074', 'la\u0304u-pu\u0301n': '02653', 'ka\u0304u-khia\u0300n-sn\u0301g': '04833', 'phah-tsiat': '04036', 'lo\u030Dh-ke\u0300': '09989', 'go\u0304ng-go\u0304ng': '13465', 'tsu-tshang': '06387', 'nn\u0300g': '12653', 'kha\u0301u-tha\u0302u': '00541', 'pha\u0301inn-ko\u0301ng': '01194', 'si\u030Dt-hi\u0302ng': '10491', 'huan-tha\u0302u': '12616', 'hi\u0300-lo\u0302': '04490', 'khui-sim': '12387', 'kong-ha\u030Dk-ha\u0304u': '00770', 'tha\u0300u-ji\u030Dt': '07937', 'ho\u0304o-sap-a\u0301': '04663', 'ha\u0304i': '05899', 'to\u0304o-sio\u0301-gue\u030Dh': '04877', 'ha\u0304m': '08035', 'ha\u0304n': '05524', 'bua\u0301n-bua\u0301n': '10628', 'liap-ki\u0301ng': '13148', 'kuan-he\u0304': '12945', 'kue\u0300-sia\u0300u': '10265', 'ta\u0302ng-mn\u0302g': '02200', 'ha\u0304u': '13386', 'phu\u0302-pha\u0300nn': '06183', 'pha-tia\u0304nn': '04139', 'si\u0301 ba\u030Dk m\u0304 gua\u0304n kheh. ': '60166', 'pe\u0302-a\u0301': '06516', 'gu\u0302-nia\u0304': '01271', 'kan-kho\u0301o tha\u0302u, khui\u0300nn-ua\u030Dh bue\u0301. ': '60368', 'tso\u0300-ti\u0304n': '06994', 'o\u0302o-tia\u030Dp': '11408', 'gi\u0301n-a\u0301': '02152', 'sok-ka-tha\u0301ng': '09429', tsong: '10026', 'tsiu\u0304nn kio\u0304 tsiah beh pa\u0300ng jio\u0304. ': '60069', 'tui\u0302-sim-kuann': '08390', 'gua\u0304-kha\u0301u': '01434', 'ua\u030Dh-hue\u0304': '05214', 'ta\u0302ng-ni\u0302': '02170', 'tho\u0302o-tsui\u0301-sai': '09392', 'e\u0302nn-a\u0301': '09675', 'tik-sit tho\u0301o-ti\u0304-kong, tshi\u0304 bo\u0302 ke. ': '60265', 'ki\u0304n-ua\u0301': '04595', 'tsiunn-lo\u0301': '11210', 'ka\u0301i-iok': '10047', 'tong-te\u0304': '09773', 'khian-a\u0301': '07608', 'li\u0304-ha\u0304i': '10999', 'khong-khong': '07282', 'la\u0304u-sing': '02657', 'ho\u0302-su\u0304n': '03752', 'pho\u0302ng-kong': '10802', 'siu-kha-se\u0301-tshiu\u0301': '02557', 'hu\u0304-tam': '05570', 'gu\u0302-sa\u0301i-tsia\u0301u-a\u0301': '01260', 'hue-tsha\u0301u': '04472', 'sa\u0301n tsha\u0302n ga\u0302u suh tsui\u0301. ': '60344', 'i-ti\u0304': '12722', 'niu\u0302-a\u0301': '05886', 'pa\u0300ng-phui\u0300': '04032', 'tsian-si\u0302': '09737', 'kia\u0304n': '05393', 'ka\u0304ng-pe\u0304-koh-bu\u0301': '01345', 'hu\u0304-hing': '01234', 'ba\u0301u': '01403', 'ba\u0301i': '13551', 'tsha\u030Dk-ba\u030Dk': '13452', 'ka\u0301i-hun': '03282', 'tshi\u0304-lia\u0304u': '10351', 'ba\u0301n': '06006', 'tsua\u030Dt-lo\u0304o': '08908', 'tsui\u0301-bo\u0301': '00884', 'un-a\u0300i': '05996', 'kia\u0304u': '11136', 'kia\u0304n-tiu': '06972', 'pa\u0302i-tui\u0304': '07415', 'sit-la\u0302ng-le\u0301': '01673', 'ni\u0302-hue\u0300': '02393', 'lo\u0304ng-to\u0304ng': '06238', 'suann-to\u0304ng': '00397', 'pho\u0302o': '03164', 'u\u0300n': '09521', 'kiu\u0302-pue': '07630', 'n\u0301g-a\u0301': '09188', 'sia\u0304n-tha\u0302ng-a\u0301': '12646', 'tiu\u0300nn-khi\u0300': '08944', bong: '10557', 'pa\u0301-tsiok': '10343', 'ka-tsi\u0300-a\u0301': '01629', 'tsong-su\u0302': '03860', 'khui-tshui\u0300': '09211', 'bi\u0301-a\u0301-hu': '02648', 'i\u0302ng-sian-sian': '09190', 'ka\u0300u-ui\u0304': '03648', 'toh-ti\u0301ng': '06154', 'pa\u030Dk tsa\u0300ng': '11884', 'phua\u0300-pe\u0304nn': '06423', 'tso\u0301o-kong': '06404', 'to\u0304o-ka\u0302u': '03267', 'tsiat-io\u030Dk': '09852', 'lo\u0302o-hue\u0304': '13038', 'oo-ta\u030Dt-a\u0301': '06302', 'sua\u0300-tshui\u0300': '07786', 'bi\u0301-tshik': '02762', 'tsa\u0301n': '13432', 'tsu\u0301-te\u0304-hi\u0300': '00329', 'so\u0301o-hui\u0300': '04128', 'kiu\u0300-la\u0302ng': '07345', 'tshiu\u0301nn': '09522', 'tua\u0304nn': '05136', 'a\u0304u-tshut-si\u0300': '04936', 'hu\u0304n-gia\u030Dh': '02106', 'tsa\u0301u': '03404', 'bu\u030Dt-ke\u0300': '04379', 'ni\u0302-tseh': '02395', 'hua\u0304n-tio\u030Dh': '01977', 'la\u0302ng-bi\u0304n': '00127', 'khioh-tsha\u0302': '04086', 'sio\u030Dk-gi\u0301': '04764', 'ke\u0300-tsi\u0302nn': '11005', 'tsa\u0304i-gia\u030Dh': '02273', 'kim-hiunn-tsik': '04594', 'kho\u0301o-kam': '05484', 'sin-tsiann': '09533', 'tha\u0302u-tu\u0301-a\u0301': '12091', 'ho\u0302ng-ga\u0304i': '03138', 'bo\u0302-tsha\u0301i-kang': '08664', 'na\u0301-tshin-tshiu\u0304nn': '05504', 'tsua\u030Dt-tsi\u0302ng': '08896', 'o\u0304o-kua\u0301inn': '03485', 'thian-si\u0302': '01029', 'te\u0302-sim-phoh': '06569', 'im-tua\u0304-tsui\u0301': '07543', 'sa\u0300ng-tia\u0304nn': '06745', 'tia\u0304n-tho\u0302o': '10362', 'kha-tshng-kut': '01682', 'bo\u0302-gi\u0302-ngo\u0304o': '08686', 'pang-tsa\u0304n': '12216', 'tshiam-si': '13303', 'ta\u0302ng-sua\u0300nn': '10946', 'ti-a\u0301-kia\u0301nn': '11439', 'tshut-tshai': '01519', 'a\u0304m-kin': '12072', 'phah-kuann-si': '04047', 'ta\u0304u-kuann': '03470', 'tsa\u0302i tsu\u0301 siu\u0304 sann ji\u0304 tsua\u0302n. ': '60254', 'sin-si': '03452', 'pu\u0301n-tsi\u0302nn': '01822', 'hue-tsng': '04486', hooh: '12649', 'tshiu\u0301-sio\u030Dk': '01212', 'tshiu\u0301-sio\u030Dh': '01059', 'phi\u0304nn-lio\u0302ng': '10989', 'thiah-io\u030Dh-a\u0301': '04180', 'po\u0300o-ti\u0300': '01802', 'niu\u0304-ui\u0304': '13372', 'gua\u0304-ma\u0301': '01575', 'senn-si\u0302ng': '01900', 'phang-siu\u0304': '10042', 'tsa-bo\u0301o gi\u0301n-a\u0301': '05115', 'tsi\u0302m-a\u0301': '12636', 'po\u0300o-te\u0304-hi\u0300': '01777', 'lo\u0301o-la\u030Dt': '08203', 'kua\u0302nn-jua\u030Dh': '08343', 'sua\u0300nn': '11310', 'tsiam-tshui\u0300-ku\u030Dt-a\u0301': '02382', 'ta\u0304ng-siann': '05575', 'tsha\u0301u-se': '06632', 'tsoo-tsit': '07803', 'po\u0304ng-tsi\u0301': '11285', 'tia\u0302u': '11387', 'ti-kang': '11432', 'ah-a\u0301-kia\u0301nn': '12130', tiunn: '07203', 'thuh ': '12483', 'lui\u0302-thui\u0302': '11722', 'tiong-sim': '00621', 'khia\u0304m-khia\u0304m-a\u0301 i\u0304ng': '11003', 'tse\u030Dh-tsi\u0301ng': '08912', 'pe\u0302nn-te\u0304': '01709', 'kim-si\u0302n': '04675', 'kho-ua\u0302n': '05354', 'kuan-im': '13427', 'suat-hi\u0302': '13292', 'pe\u0304nn-thia\u0300nn': '06378', 'koo-bo\u0302ng': '10826', 'tsa\u0300i-hue\u0304': '02242', 'ta\u0302ng-a\u0301-bi\u0301-ko': '08869', 'lia\u0304n': '12450', 'lia\u0304m': '07314', 'ni\u0302-to\u0304o': '02352', 'ia\u0301u-u\u0304': '08624', 'lia\u0304u': '12580', 'sin-pu\u0304-a\u0301': '09563', 'hong-tshui\u0300': '04896', 'kue\u0301 kha': '07999', 'ta\u0300u-bo\u0302-i\u0302ng': '06883', 'me\u0304': '11317', 'a\u0302ng-tho\u0302o': '05438', 'tinn-kue': '07675', 'me\u0301': '07598', 'khan-ba\u0301n': '07624', 'me\u0302': '11548', 'tsa\u030Dp-tsn\u0302g': '00096', 'bi\u0301ng-siu\u0300': '07648', 'hu\u030Dt-sio\u0304ng': '02944', 'tsi\u0301-tsha\u0300i': '08902', 'la\u0304ng': '13257', 'kia\u0301m-huat': '08557', 'tsho\u0300ng-ki\u0301': '08266', 'tiu\u0300nn-kui': '08946', 'pua\u0302nn-nua\u0301': '11268', 'tsik-kong': '03631', 'u\u0300n-ta\u0304u-iu\u0302': '09538', 'pia\u0304n-ka\u0301i': '13190', 'hia\u0304n': '07601', 'ho\u0301o-kut-tsiu\u0301': '04615', 'kho\u0301o-to\u030Dk': '05487', 'o\u0301o': '05006', 'ne\u0302': '08499', 'ke\u0300-tshua\u0304': '09443', 'po\u0300-tap': '08300', 'kip-si\u0300ng': '04955', 'tsit-li\u0301': '12590', 'huat-kak': '08738', 'oo-hu\u0302n': '06317', 'hong-gia\u0302n': '00958', 'lo\u030Dh-tshia': '09940', 'hi\u030Dk-li\u0302ng': '06147', 'sap-bu\u0302n': '08046', 'oo-ka\u0301u-hiann': '06285', 'ta\u0300u-khang': '06857', 'sio\u0301-tsi\u0301m': '00557', 'la\u0304i-tiu\u0302nn': '00731', 'hi\u0300ng': '11894', 'pn\u0304g-si\u0302-tshi\u0300ng': '09287', 'khua\u0300nn-phua\u0300': '05356', 'hong-sik': '00908', 'ho\u0304o-mua': '04647', 'hi\u0300nn': '05005', 'hong-sip': '05698', 'su-tsi\u0302ng': '03385', 'hong-siu': '12663', 'to\u0301o-kua\u0304nn': '03392', 'si\u0300m': '13611', 'si\u0300n': '02136', 'se\u0301-a\u0301': '09259', 'liu\u0302-lo\u0302ng': '09709', 'tho\u0301-khe\u0300-hiann': '06753', 'gu\u0302-la\u0304n-pha-sua\u0304inn': '01230', 'bo\u0302-gi\u0302': '08685', 'sik-bo\u0302ng': '02694', 'ji\u030Dp-tho\u0301o': '00080', 'pah iu\u0304nn': '02796', 'gia\u030Dp-bu\u0304': '09633', 'ni\u0302-tha\u0302u': '02422', 'pau-ho\u030Dk-kin': '01568', 'lia\u0301n-ta\u0302u-a\u0301': '11121', 'se\u0300-khu\u0301n': '07788', 'tsiann-gue\u030Dh-tsiann-si\u0302': '01693', 'gua\u0302n-siu\u0301': '00699', 'tho\u0301o-siu\u0304nn': '00471', 'phue\u0302-e\u0302': '02019', 'gua\u0302n-tsik': '05849', 'gi\u030Dk-a\u0301': '01882', 'pia\u0304n-su\u0304': '13170', 'hioh-kua\u0302nn': '09693', bat: '06014', 'sia\u0300-bi\u0304n-phue\u0302': '03667', 'thuh-a\u0301': '12492', 'tshoo-kang': '07755', 'thian-kiu\u0301-pa\u0302i': '00830', 'la\u030Dk-gue\u030Dh-tang': '00633', 'tsha\u0300i-khok': '09001', ban: '05907', 'tshing-bi\u0302ng bo\u0302 tn\u0301g tshu\u0300, bo\u0302 tso\u0301o; kue\u0300-ni\u0302 bo\u0302 tn\u0301g tshu\u0300, bo\u0302 bo\u0301o. ': '60272', bak: '03297', bah: '02607', 'tsa\u0302i-tia\u0304u': '00529', 'lak-tsn\u0300g': '11129', 'si\u030Dt-phi\u0301n': '05625', 'khut-a\u0301': '09816', 'bi\u0302n-tshn\u0302g': '06411', 'jia\u030Dt-ta\u0300i': '11260', 'siat-pi\u0304': '07898', 'pn\u0304g-ua\u0302n': '09253', 'pa\u0301i': '09130', 'pa\u0301n': '04341', 'tsha\u0301i-io\u0304ng': '07358', 'a-tok-a\u0301': '04617', 'te\u0300nn-go\u0304ng': '03594', 'siann-tia\u0304u': '12369', 'phoo bi\u0304n than, tsi\u0300m tsui\u0301 o\u0302 . ': '60352', 'suann-kau': '00476', 'bu\u0304-sa\u0300-sa\u0300': '12951', 'ah-bo\u0301': '12132', 'kio\u030Dk': '03072', 'la\u0302m-lo\u0304o-ing': '04761', 'gua\u0304-sann': '01511', 'hiau-hi\u0304ng-tsi\u0302nn, sit-tik lia\u0301u, uan-o\u0301ng tsi\u0302nn, pua\u030Dh-su kia\u0301u. ': '60338', 'mui\u0301-ji\u030Dt': '03303', 'kia\u0300-io\u030Dh-pau': '07196', 'tsio\u0300': '09747', 'sit-ta\u0304ng': '01748', 'ha\u0304u-kang': '06117', 'tha\u0302i-ke-ka\u0300-ka\u0302u': '03026', 'tsia\u030Dh ke, e\u0304 khi\u0301-ke; tsia\u030Dh jiu\u0302-hi\u0302, senn gi\u0301n-a\u0301 ho\u0301 io-tshi\u0304. ': '60232', 'tua\u0302nn-khi\u0302m': '11075', 'the\u0300nn': '08593', 'ho\u030Dk-sa\u0304i': '04232', 'tsua\u030Dt-khui\u0300': '08892', 'tsi\u0300ng-pha\u0300i': '01746', 'oo-lok-to\u0304o': '06328', 'gi\u0302m-tsi\u0302nn': '13475', 'ta\u0301n--tsi\u030Dt-e\u0304': '08861', 'kha-to\u0300ng': '10160', 'sann-kha-be\u0301': '00494', 'bo\u0302-thong': '08670', 'kin-tsat': '08904', 'pua\u0300nn-me\u0302': '01596', 'se-iu\u0302nn-la\u0302ng': '02856', 'liu\u0302-ho\u0302ng': '07736', 'hu\u0300-tshiu\u0301': '06957', 'tha\u0304m-to\u0301o': '09819', 'ua\u0301nn-tha\u0302u-a\u0301': '09831', 'tui\u0300-tsi\u0301': '10501', 'lio\u030Dk-kio\u0302': '08100', 'o\u0304o-i\u0302nn': '03492', 'khioh-tsi\u0302nn': '04168', 'iu\u0302-kio\u030Dk': '09138', 'hua\u0300-ha\u030Dk': '01163', 'ku\u0301-tn\u0302g-pe\u0304nn': '00382', 'to\u0301o-kio\u0302ng': '11479', 'khong-kan': '04414', 'khia\u0304-ue\u0304-ping': '07301', ting: '03347', 'tha\u0300n-tsia\u030Dh-king': '09101', tinn: '07655', 'khan-khioh': '07617', 'ua\u0304nn-tso\u0300': '08477', 'tsa\u0304i-senn': '02166', 'i\u0302n': '07161', 'hua\u0302i-gi\u0302': '12822', 'hua\u0304nn-tha\u0302u': '02583', 'khiam-pi': '12416', 'pha-ki\u0302-li\u0302n': '04183', 'kia\u0300n-ti\u0300': '04903', 'tsua\u0300nn-iu\u0302': '05204', 'khiau-kha': '02556', 'kho\u0301-tsu\u030Dt-tsu\u030Dt': '05168', tann: '11684', 'tsoo-tha\u0302u': '07800', 'lia\u0302n': '13286', 'tik-a\u0301': '02641', tang: '04203', 'ha\u0301i-te\u0301': '06197', 'tshiah-ia\u030Dh': '03664', 'tsiu\u0301-la\u0304u-a\u0301': '06896', 'ke-kia\u0304n': '12725', 'sing-tsu\u0302n': '01897', 'khok-a\u0301-te': '12409', 'tsi\u0301ng-a\u0304m': '09996', 'hu\u0300-ju\u0304': '08341', 'a\u0301u-ba\u0302n': '04193', 'ti-tha\u0302u-pui\u0302': '11504', 'tshit-tho\u0302-mi\u030Dh': '13560', 'hi\u0302ng-li\u0301': '02672', 'pe\u030Dh-mua\u0302-iu\u0302': '01965', 'si\u0300-pinn': '01637', 'ho\u0302ng-hue\u0301': '12272', 'liap-sa\u0301i': '13134', it: '00045', 'tsiah-ni\u0304-a\u0301': '11542', ik: '09671', im: '05583', 'hua\u0302inn-pa\u0300-pa\u0300': '11802', 'lua\u0304': '11941', in: '13602', 'a-tsik': '04566', 'to\u0302ng-ia\u0302u': '08839', 'ti\u0304ng-hun': '05551', 'ha\u0304u-tiu\u0301nn': '06138', hiauh: '12623', 'ha\u0300u-la\u0302m': '03099', 'tse\u0304nn': '12029', 'ha\u030Dh-i\u0304ng': '02164', 'tsi\u030Dt e\u0302 tsi\u0302nn phah ji\u0304-tsa\u030Dp-si\u0300 e\u0302 kat. ': '60007', 'sia\u0304n-hi\u0302': '13361', 'thiau-kang': '00081', 'kua\u0301n-li\u0301': '10762', 'ia\u0301-bi\u0304': '08066', 'e\u0304-kham-tit': '09642', 'si\u0301ng': '05321', 'io\u0301ng-ho\u0304o': '11731', 'phoo-pa\u0302i': '11556', 'tsu\u0300-tsheh': '09076', 'hok-gi\u0301ng': '10706', 'kong-lo\u0304o': '00760', 'tse\u0302-pi\u0304': '10986', kip: '06500', 'sio-me\u0304 bo\u0302 ki\u0301ng tshui\u0300, sio-phah bo\u0302 ki\u0301ng ui\u0304. ': '60214', kiu: '00597', kik: '05582', kin: '10087', kim: '04506', 'tsng-a\u0301': '11849', 'sio\u0300ng-mia\u0304-sian': '05263', 'kang-a\u0301': '00282', 'kau-sia\u030Dp': '02082', 'hio\u030Dh': '10004', 'tsih-tsua\u0301': '10584', 'lo\u0301ng': '12807', 'tha\u030Dk-tsheh, tha\u030Dk ti\u0304 kha-tsiah-phiann. ': '60388', 'tsik thia\u0304u-a\u0301': '12180', 'sik-tsui\u0301': '02637', 'koo-a\u0301': '06515', 'ang-ke\u0300-toh': '03107', 'pa\u030Dt-ha\u0304ng': '03018', 'khioh-kut': '04100', 'tso\u0300-tsio\u0300': '07023', 'tiu\u0304-tia\u0302nn': '11295', 'kha\u0300n': '05324', 'kha\u0300m': '05909', 'ta\u0304ng-khi-pi\u0302ng': '05553', 'kian-kuann': '07134', 'kiu\u0302-tshue\u0302': '07642', 'na\u0302-kiu\u0302': '13031', 'kok-li\u030Dp': '07115', 'bi\u0301-thai-ba\u030Dk': '02811', 'ian-hue\u0301': '09727', 'me\u030Dh': '06552', 'pan-tsat-he\u0302': '08488', 'ju\u0302-tshu\u0301': '02328', 'kha\u0300u': '10939', 'lio\u0304ng-sio\u0304ng': '00730', 'sua\u0300-phah': '07771', 'kio\u0302-tun': '11760', 'hi-hue\u0301': '09020', 'ki\u0304n sui\u0301 ti hi\u0302 si\u0300ng, ki\u0304n san sik nia\u0301u im. ': '60195', 'nah-ji\u030Dt': '12548', 'kuainn-mn\u0302g': '12944', 'e\u0304-ha\u0302i': '00535', 'peh-suann': '13632', 'kui bi\u0304n': '07892', 'tsik-pi\u0304': '07989', 'tua\u0304-tshu\u0300': '00412', 'po\u0301o-u\u0304n': '10068', 'tham-tsia\u030Dh': '07968', 'n\u0302g-ta\u0304u': '09271', 'khi\u0301-in': '06726', 'me\u0302-kang': '10571', 'ba\u0301i-ka\u0302u ga\u0302u khia\u0300m-sia\u0300u. ': '60373', 'la\u0304u-tshang-tha\u0302u': '02733', 'te\u0304-tsi': '02304', 'tsa\u030Dh': '10290', 'pia\u0302nn': '01654', 'tsi\u0300ng-tsoh': '10744', 'oh ko\u0301ng': '10439', 'kio\u0302ng-tse\u0300': '07223', 'si\u030Dk-tshiu\u0301': '11225', 'khn\u0300g-ho\u0302': '12987', 'tsa\u0301-khi\u0301-tn\u0300g': '02529', 'u\u0304 tn\u0302g-suann kong, bo\u0302 tn\u0302g-suann ma\u0301. ': '60161', 'la\u0304n-tha\u0302n': '09371', 'lap-te\u0301': '09409', 'ga\u030Dk-tui\u0304': '11167', 'iu\u0300-siu\u0300 kha, ho\u0301-mia\u0304 te\u0301. ': '60122', 'ho\u0304ng': '10954', 'tsua\u030Dt-kau': '08872', 'ta\u0301n mi\u030Dh oh ka\u0300u, ta\u0301n la\u0302ng khua\u0300i la\u0304u. ': '60304', 'tshiu\u0302nn-hong': '12787', 'tso\u0300 tia\u0300m-bi\u0304n': '06983', 'bo\u0302 m\u0304-tio\u030Dh': '08608', 'puann-tshu\u0300': '09551', 'ua\u0302n-kang': '03079', 'pho\u0302o-the\u0302-tshiu\u0304': '08989', 'su-tshut': '11995', 'tho\u0301-tse\u0300': '06777', 'bo\u0302-ia\u0301nn-bo\u0302-tsiah': '08693', 'khi\u0302nn-a\u0301': '10296', 'siu-si\u0302ng': '02489', 'tso\u0300 gu\u0302 tio\u030Dh thua, tso\u0300-la\u0302ng tio\u030Dh bua\u0302. ': '60259', 'khai-tsi\u0302nn': '09232', 'a\u0304u-bu\u0301': '04937', 'jio\u0304-phe\u0300-a\u0301': '03101', 'io-tsi\u0301-pe\u0304nn': '09904', 'kua\u0301n-ko\u0300o': '10777', 'hi\u0300-hn\u0302g': '12206', 'thng-tha\u0302u': '08584', 'niu\u0302-le\u0301': '05895', 'tik-tshi\u0301ng': '02759', 'po\u0301o-tha\u0302u': '04171', khngh: '02974', 'tsha\u0302n-enn': '02027', 'a-ku\u0304': '04642', 'thia\u0300u': '10170', 'tsiu\u0301-sian': '06834', 'so\u0300o-si\u030Dt': '06529', 'ki\u0302': '08504', 'ki\u0301': '04999', 'ki\u0300': '11987', 'toh-kui\u0304': '06167', 'tshin-senn': '11951', 'tsiau-ji\u0304n': '04153', 'tsia\u0300nn-tio\u030Dh-si\u0302': '01791', 'phiat-po\u0304o': '13640', 'mue\u0304-sa\u0300i': '03811', 'siu\u0300-kiu\u0302': '12607', 'ba\u0301i-tsa\u0302i': '13552', 'ki\u0300-tsia\u0301': '06749', 'khua\u0302n-ha\u0304n': '13238', 'tse\u0304-toh': '03051', 'seh-a\u0301-kam': '08054', 'bu\u0302n-ji\u0304': '00907', 'bah-kha-a\u0301': '02778', 'jia-mua\u0302': '11543', 'la\u0302-gia\u0302': '12642', 'tsa\u0300u-kha': '03333', 'sueh-sia\u0304': '10885', 'tshi\u0300n-a\u0301-hue': '06456', 'thau-tsia\u030Dh-po\u0304o': '06990', 'pa\u0304n-hue\u0300': '12010', 'kha-tsiam-tshiu\u0301-iu\u0300': '10105', 'a-tsi\u0301': '04571', 'pu\u0304-nn\u0304g': '10492', 'ki\u0301ng-tsha\u0300i': '08417', 'i\u0301': '08509', 'i\u0300': '09455', luah: '06013', 'i\u0302': '04841', 'i\u0304': '04839', 'ha\u030Dk-li\u030Dk': '11645', 'pha\u0300i-tshut-so\u0301o': '05199', 'tsha\u0300i-to': '08958', 'thn\u0302g-tshang': '11887', 'tshoo-tshoo': '03655', 'sio\u0300ng-mia\u0304 bo\u0302 po, tsia\u030Dh tsui\u0301 to bo\u0302. ': '60213', 'hiauh-than': '12648', 'kia\u0302m-i\u0302nn-a\u0301': '13105', 'i-su\u030Dt': '12740', 'tsi\u0304n-li\u030Dk': '10696', 'ba\u0304': '07870', 'to\u0302o-tsi\u0301': '11053', 'ba\u0302': '08113', 'pha\u0301inn tsu\u0302n tu\u0301-tio\u030Dh ho\u0301 ka\u0301ng-lo\u0304o. ': '60111', 'tua\u0304-a\u0304u--ji\u030Dt': '00390', 'am-kng': '11529', 'tua\u0304-siann': '00553', 'li\u0302m-ki-i\u0300ng-pia\u0300n': '12370', 'tsu-se-ki\u0300': '07686', 'la\u0301-pah': '08214', 'hong-ting': '04889', 'khiap-si\u0300-mia\u0304': '13498', 'tam-po\u0301': '11703', 'bo\u0301ng kia\u0302nn': '04451', 'tho\u0302o-lio\u0302ng': '09432', 'khioh-kia\u0301nn-bu\u0301': '04019', 'kan-kho\u0301o': '12347', 'thuah-pang': '05985', 'kha\u0301m-a\u0301': '03040', 'po\u030Dh': '12335', 'hu\u0304n': '04199', 'ko\u0300-si\u0304': '03043', 'su\u0300-si\u0304': '01483', 'iu-tha\u0302u-kat-bi\u0304n': '11126', 'tsi\u0302ng-ang': '04752', 'tha\u0302u-bue\u0301': '12088', 'tshu\u0304 tsi\u030Dt to\u0301': '09132', 'e\u0304-kha-tshiu\u0301-la\u0302ng': '00492', 'la\u0304u-pa\u0302i-tsu\u0301': '02755', 'the\u0300-ho\u0302ng': '06802', 'tshian to\u0302o ba\u0304n to\u0302o, m\u0304 ta\u030Dt-tit huan tsha\u0302n tho\u0302o. ': '60077', 'sia\u0301u-kui\u0301-a\u0301-khak': '00433', 'a\u0300n-tsia\u0300u': '05061', 'ta\u0304u-si\u0304nn': '03478', 'si\u030Dt-ue\u0304': '10516', 'khn\u0300g li\u0301n iu\u0301-ha\u0300u tshian-ba\u0304n ku\u0300, be\u0304-hia\u0301u iu\u0301-ha\u0300u ti ka\u0301u gu\u0302. ': '60383', 'tshiu\u0301-pe\u0304': '01048', 'koo-khu\u030Dt': '03837', 'a\u0302ng-enn-a\u0301': '05452', 'bah-ua\u0302n': '02769', 'ha\u0304i--khi\u0300': '05929', kainn: '08192', 'pe\u0302-tsiu\u0304nn': '01838', 'a\u0304nn': '12067', 'tsia\u030Dh ho\u0301 ta\u0300u sio-po\u0300. ': '60221', 'hong-phi\u0302ng': '05663', 'ka\u0304u-po\u030Dh': '04830', 'pui\u0300-a\u0301': '09771', 'ta\u0304i-hong': '00264', 'khia\u0301n-tsik': '13188', 'tshiu\u0304-tsi\u0301': '11737', 'ho\u0301o-phi\u0304nn-sai': '04652', 'siok-li\u0301': '07541', 'pha\u0301inn-thiann': '01216', 'tshoo-sio\u030Dk-hue\u0300': '07775', 'huan-gi\u0302ng': '13236', 'tshi\u0301ng-si\u0304': '11443', '--ioh': '05874', 'pua\u0300n-sian': '01458', 'po\u0301o-tso\u0304o': '10040', 'tshiu\u0304-tsi\u0302': '11766', 'lo\u030Dh-pu\u0301n': '09925', 'jiu\u0302-hi\u0302': '13083', 'tsi\u0301-si\u0304': '05024', 'tsi\u030Dt hi\u0304nn-khang ji\u030Dp, tsi\u030Dt hi\u0304nn-khang tshut. ': '60016', 'tshi\u0304-bi\u0302n': '01699', 'kiu\u0300-tua\u0300': '04474', 'ga\u0304i-ba\u030Dk': '12833', 'khau-to': '09331', 'hue\u0301-hu': '01267', 'gua\u0304-lo\u0304o-a\u0301': '01593', 'tap-a\u0300n': '08890', 'ki\u0301n-si\u0304n': '12671', 'tsa\u0300u-ga\u030Dk': '04862', 'tia\u0300m': '11508', 'ke-bo\u0301-tha\u0302ng': '12707', 'ho\u0302-kho\u0301o': '02927', 'kha\u0301u-pe\u030Dh': '00300', 'bi\u0301n-a\u0301': '04006', 'lia\u030Dh-li\u0302ng': '07437', 'tua\u0304-hi\u0304nn': '00319', 'm\u0304-tsia\u0302nn-ka\u0302u': '00922', 'pi\u0301n-ko\u0300': '09817', 'gu\u0302-to\u0304o': '01251', 'lo\u0301o-li\u030Dk': '02984', 'tia\u0300u': '02124', 'teh-sa\u0300u': '08834', 'ba\u0304u-kang': '09074', 'ko\u0300ng-ku': '09585', 'ha\u0301i-kha\u0301u': '06181', 'tsha\u0300i-koo': '08973', 'io\u0301ng': '11568', 'tshi\u0301ng-bi\u0304ng': '11456', 'be\u0301-khi\u0301-ta\u0304u': '06905', 'thn\u0302g-ka\u0302m-a\u0301': '11876', 'ta\u0302ng': '10937', 'ling-tha\u0302u': '01824', 'kuah-pau': '08213', 'kue\u0301-i\u0300n': '10738', 'hau-sia\u0302u': '10436', 'pia\u0304n-tsha\u0300i-pn\u0304g': '04699', 'kang--e\u0302': '00680', 'ip-bo\u0304ng-kue\u0301': '06079', 'tsiu\u0304nn-kia\u0304': '00435', 'khit-tsia\u030Dh kua\u0301nn bio\u0304-kong. ': '60075', 'oo-lio\u0302ng-te\u0302': '06348', 'tsia\u030Dh bo\u0302 sann pe\u0301 i\u0300ng-tsha\u0300i, to\u0304 beh tsiu\u0304nn se-thian. ': '60226', 'tsng-sia\u0301u--e\u0302': '10062', 'ni\u0302-koo': '01733', 'ping-ki': '02195', 'gi\u0301n-a\u0301-khua\u0301n': '02161', 'ke-pak-la\u0304i': '12751', sannh: '09722', 'e-the': '05992', 'tshiu\u0304-tha\u0302u khia\u0304 ho\u0304o tsa\u0304i, m\u0304 kiann tshiu\u0304-bue\u0301 tso\u0300-hong-thai. ': '60354', 'ng-tsu\u0302n': '06473', 'hue\u0301-thang': '01289', 'pang-to\u0301o': '04247', 'kha-jiah': '10147', 'ke-sa\u0301i-u\u0304n': '12724', 'siu\u0304nn': '09451', 'hia\u0302u': '11036', 'a\u0300m-bo\u030Dk-bo\u030Dk': '09651', 'pu\u0301n-hu\u0304n': '01706', 'tshut-ting': '01423', 'hia\u0302m': '09438', 'an-tho\u0301o': '02301', 'hia\u0302n': '11423', 'iu-sian': '12161', 'ia\u0302u-gia\u0302n': '12415', 'te\u0304-ui\u0304': '02333', 'hun-sa\u0301i': '12599', 'hi-hi-hua\u0304-hua\u0304': '11031', 'ki\u0301ng-te\u0302': '08409', 'tu\u0301-tsiah': '03990', 'khi\u0301-pha\u0304ng': '11621', 'hue\u0301-tsio\u030Dh-a\u0301': '01243', 'sui\u0301-khui\u0300': '08335', 'i\u0301-tsi\u0302ng': '01349', 'kio\u0300-tsha\u0300i': '01567', 'sua-poo': '03324', 'sian-to\u0304ng': '01354', 'tsha\u030Duh-tsha\u030Duh-tih': '10435', 'tsiu\u0300-tha\u0302ng': '07862', 'kap-io\u030Dh-a\u0301': '06092', 'be\u0304-tit-thang': '06676', 'tshing-lia\u0302m': '07585', 'pia\u0301u': '04500', 'thua\u0300nn-tsi\u0301ng': '08583', 'tsui\u0301-sian': '00876', 'tsia\u0301u-phia\u030Dk-a\u0301': '08164', 'tshoo-i\u0304ng': '07763', 'pia\u0301n': '09062', 'bia\u0301n-sue\u0300': '02937', 'su-sim': '03366', 'la\u0304n-pha': '13524', 'tsun-tshing': '08342', 'kim-lo\u0302o': '04676', 'hiunn-koo-bah-mue\u0302': '05659', 'si\u0302ng-ji\u0304n': '04152', 'tia\u0300u--si\u0301': '02174', 'pha\u0301inn-tshua\u0304-tha\u0302u': '00825', 'tsa\u0302i-tsu\u0301-siu\u0304': '06711', 'kui\u0300-kenn': '09092', 'li\u0304-pho\u0301o': '12770', 'peh-se\u0300nn': '02683', 'tsu\u0300-tia\u0304nn': '09090', 'si\u0302n': '03410', 'li\u0302ng-hu\u0302n': '13382', 'put-kiu\u0302-ji\u0302n': '00669', 'li\u030Dp-tiu\u0302nn': '01967', 'hiu\u0302-a\u0301': '10036', 'lo\u0302-kenn': '12862', 'lui\u0302 ko\u0301o': '11720', 'sa\u0301i-lo\u0304ng': '03562', 'kui\u0304-pa\u0300i': '10121', 'un-a\u0301-hi\u0302': '13210', 'tsiok-ho\u0304': '06477', 'ka-ka\u0300u': '05945', 'sio-tshut-lo\u0304o': '05253', 'kho\u0300-tio\u030Dh': '11594', 'sak-tso\u0300-tui': '06058', 'sam-pat-khui\u0300': '00230', 'i-ua\u0301': '03573', 'tinn-kue\u0301': '07701', 'tu\u030Dh': '08435', 'khiat-hue\u0301': '07262', 'si\u0301-la\u0302ng-khua\u0301n': '02464', 'hi\u0302ng-gi\u030Dk': '11793', 'tiu\u0300nn': '08925', 'lo\u0302o-tik': '13027', 'bo\u0301ng-to\u0301ng': '12824', 'sok-kiat': '03330', 'ka\u0301m-a\u0301': '13541', 'o\u0304o-ni\u0302': '03448', 'tsa-bo\u0301o': '05111', 'tsi\u0302nn-tsa\u0302i': '12044', 'thiann-tha\u0302u': '13415', 'kong-kho\u0300': '01614', 'tang-hong': '04240', 'la\u0304i-kong': '00611', 'i\u0302ng-la\u0302ng': '09181', 'tsa\u030Dp-tshe-a\u0301-kang': '12729', bok: '08381', 'bo\u0304o': '01657', 'siau-tsai-ka\u0301i-eh': '06277', 'thi\u0302n tsiu\u0301': '09559', 'ke\u030Dh-bi\u0304': '03180', 'tsi\u0302ng-khok': '04779', 'gia\u0300ng-ge\u0302': '13393', 'tshui\u0300-hue': '08229', iang: '01421', 'senn-koo': '01974', 'hi-bi\u0302': '08829', 'bah-phue\u0302': '02659', 'a\u0302ng-ko\u0300ng-ko\u0300ng': '05435', 'ho\u0302o-si\u0302n-phah-a\u0301': '05458', 'la\u0302-sa\u0302m': '03820', 'na\u0302-ta\u0302u': '04230', 'li\u0301-a\u0301-kia\u0302m': '03245', 'ha\u0301i-bi\u0304': '06194', 'ha\u0304i-lia\u0301u-lia\u0301u': '05918', 'io\u0304ng-kong': '01887', 'a\u0300m-tn\u0300g kia\u0301m tsia\u030Dh tsi\u030Dt kha\u0301u, ua\u030Dh kah ka\u0301u-tsa\u030Dp-ka\u0301u. ': '60320', 'te\u0302-khoo': '06624', 'bo\u0302-lio\u0302ng-sim': '08627', 'i\u0300-hio\u0300ng': '09466', 'ba\u0304n-si\u0300ng': '10545', 'tia\u0304n-hue\u0301-thia\u0304u': '10333', 'a\u0304u-bue\u0301': '04946', 'ua\u0301nn-kue\u0301': '09826', 'kheh-a\u0301': '11319', 'lue\u0304-tsi\u0302ng': '00721', 'a\u0301u-tsua\u0301': '04093', 'tsiu\u0301-kan': '06855', 'tsa\u030Dt-tsinn': '10527', 'ian ': '13643', 'tsui\u0301-khi\u0300': '01039', 'pho\u0300ng-tshn\u0302g': '11898', 'pang-tso\u0304o': '12192', 'tho\u0301o-ba\u030Dk': '02165', 'thuat-tshiu\u0301': '07812', 'tshia-a\u0304u-ta\u0301u': '03453', 'ui\u0302-it': '07046', 'tshua\u0304-tha\u0302u': '13549', 'tsua\u0304nn tsui\u0301': '12547', 'bu\u0302 sam put si\u0302ng le\u0301.': '60292', 'jia\u030Dt-to\u030Dk': '11258', 'bi\u0304ng-li\u0304ng': '03719', 'khia\u0300n-phang': '04462', 'tsiam-phi\u0304nn': '06899', 'hang-hue\u0301': '06264', 'tso\u0300-tsha\u0300u-la\u0302ng': '06993', 'hia\u0302nn': '11803', 'hu\u0301-to\u0304': '10929', 'tshio\u030Dh': '10818', 'tshio\u030Dk': '09513', 'tsik-peh--e\u0302': '03651', 'iu-tshiu\u0302': '11118', 'kua\u0304n-li\u030Dp': '11874', 'tshit-tsa\u0301-peh-tsa\u0301': '00103', 'kuah-kim': '08230', 'tsia\u030Dh-po': '05688', 'ho\u0301-lio\u0304ng': '02387', 'a\u0304u-bu\u0301-bi\u0304n': '04939', 'pa\u030Dt-a\u0301-phio\u0300': '08963', 'tse\u0300nn-tshui\u0300': '11482', 'iu-bi\u0301': '12164', 'phu\u0302-to\u0302-tsiu\u0301': '10016', pinn: '12774', 'khi\u0300ng-ho\u0304': '11117', 'tsi\u0304ng-sa\u0300ng': '12924', ping: '02113', 'tio\u0302ng-io\u0302ng-tseh': '05559', 'tha\u0302i-tha\u0302u': '03024', 'sia\u0304-hue\u0304': '04415', 'sia\u0300n-hong': '09550', 'tia\u0302u-tsa': '11397', 'sin-ni\u0302': '09534', 'siu-io\u0301ng': '05723', sng: '12467', mau: '13588', 'ku\u0301-tsha\u0300i-hue': '05662', 'tho\u0304ng': '11311', 'khe-a\u0301': '09677', 'phu\u0302': '07539', 'phu\u0301': '08546', 'si\u030Dp': '00062', 'phu\u0304': '06174', mai: '05814', 'i\u0300n': '12172', 'tshun-lia\u0302n': '05072', 'i\u0300m': '11360', 'kho\u0301-gia\u0304m': '02838', 'gu\u0302-sa\u0301i-sik': '01259', 'sim-tn\u0302g': '01116', 'hi\u0302ng-io\u0302ng': '03187', 'tsu\u0304-hui\u0300': '02766', 'tse\u030Dh': '08855', 'khi\u0302m': '08713', 'siu-si\u030Dp': '02508', 'the\u0300-ta\u0302ng': '06773', 'ia\u0304nn': '12780', 'kok-tsio\u0301ng': '02247', 'sua\u0301nn-be\u0304': '08492', 'phah-ka-la\u030Duh': '04016', 'mn\u0302g-si\u0300nn': '04599', 'hu\u0301-sia\u0302nn': '03926', 'ha\u0300-thn\u0304g': '03098', 'nga\u0304i': '02614', 'si\u0304m-tsi\u0300': '05256', 'khia\u0304-khi\u0301': '07281', 'bo\u0302-sim-kuann': '08605', 'tshu\u0301-ti\u0300': '07856', 'it-lia\u030Dp-it': '00031', 'tio\u030Dh-ka-tsa\u030Dk': '09031', 'ta\u0300nn-tha\u0302u': '11730', 'kik-sim': '11777', 'tho\u0302o-pha\u0302ng': '09415', thang: '07925', 'ia\u0302n-ta\u0302u': '11323', 'a\u0304u-siu\u0304': '04953', 'tse\u0304 ho\u0304o tsia\u0300nn, tik la\u0302ng thia\u0300nn. ': '60178', 'ho\u030Dh': '13206', 'ho\u030Dk': '04200', 'khi\u0301-tha\u0302u': '06801', 'pua\u0300n-tsu\u0301': '01432', 'tsi\u0300ng-to\u0302o': '01779', 'sai-kong-giang': '01440', 'khau phue\u0302': '09342', 'ha\u0301i-tio\u0300ng': '06232', 'tsiu-to\u0300': '03726', 'hui\u0301-po\u0300ng': '11412', 'bi\u0304n-tsi\u0302ng': '05623', 'u\u0304n-to\u0302o': '10248', 'oo-moo': '06260', 'tso\u0304o': '02965', 'the\u0301-gia\u0304m': '13357', 'gua\u0302n-lia\u0304u': '05856', 'tsiam-khang': '06856', 'nga\u0301-khi\u0300': '09281', 'bu\u0302-so\u0301o-ui\u0304': '08635', 'tshin-tshui\u0300': '11972', 'tsi\u0301n-tua\u0300n': '09052', 'ho\u0300nn-kheh': '02351', 'phiah-si\u0300ng': '12563', 'bo\u0302--khi\u0300': '08614', 'khui-tsho': '09234', 'hue\u0302-tha\u0302u': '02265', 'la\u0304i-ha\u0302ng--e\u0302': '00663', 'tshi\u0300n-thui\u0302': '06494', 'tn\u0301g-lu\u0302n': '12675', 'tsi\u0301 pak ui\u0302 hun': '05063', 'tsu\u0301-kiong': '00420', 'tsia\u030Dp me\u0304 be\u0304 thiann, tsia\u030Dp phah be\u0304 thia\u0300nn. ': '60268', 'tan-su\u0302n': '08294', 'ke\u0300-sio\u030Dk': '13041', 'ki\u0304n-tshin': '04662', 'ka\u0301ng-si\u030Dp': '12430', 'pia\u0304n-so\u0301o': '04691', 'sann la\u0302ng ka\u0304ng go\u0304o ba\u030Dk, ji\u030Dt-a\u0304u bo\u0302 tn\u0302g-te\u0301-kha-ue\u0304. ': '60059', 'lo\u0301-tsho\u0301': '11232', 'tsiu\u0304-ki\u0304n': '08329', 'e hia\u0302n-a\u0301': '05993', 'hing-tio\u0301ng': '01347', 'kim-tia\u0302u': '04622', 'pi\u0301-sa\u0300i': '01195', 'tsioh tsi\u0302nn': '05795', 'pa\u0300ng-thiap-a\u0301': '04046', 'tshiam-a\u0301': '12853', 'be\u030Dh-ge\u0302-thn\u0302g': '08138', 'hing-sue': '11907', phut: '02958', 'ho\u0304o-mn\u0302g-a\u0301': '04532', 'khia\u0304-li\u0302ng': '07309', 'tsu\u0304-la\u0302i': '07268', 'kat-tsha\u0301i': '08913', 'la\u030Dh-pit': '13159', 'tshue\u0302-a\u0301': '11288', 'ma\u0301': '06823', 'ui\u0304-ti\u0300': '02942', 'ma\u0304': '11316', phue: '05394', 'tu\u0300-tu\u0300': '10627', 'hi\u0302ng-tso\u0304ng': '03181', 'khi\u0301-ke': '06760', 'ko\u0301ng-bi\u0302ng': '12418', phun: '11192', 'mn\u0302g': '04511', 'bi\u030Dh-tshio\u030Dh': '12314', 'pa\u030Dt-ui\u0304': '02995', 'tsia\u030Dh-ka-ki\u0304': '05635', 'ji\u030Dt-tha\u0302u-hue': '01181', 'sui\u0302-sin': '12037', 'tsong-ka\u0300u': '03862', 'lia\u0302ng-se\u0300': '07523', 'siang-senn-a\u0301': '12710', 'se\u030Dh-se\u030Dh-lia\u0304m': '10928', 'tsia\u0301u-tshi\u0300ng': '08153', 'tsia\u030Dh-a\u0300m': '05668', 'tsi\u0301m': '12513', 'bih-tshui\u0300': '09037', thinn: '07537', 'sann ni\u0302 tsi\u030Dt ju\u0304n, ho\u0301-pha\u0301inn tsia\u0300u lu\u0302n. ': '60063', 'si\u030Dt-tse\u0300': '10517', 'suann-sua\u0300nn': '00525', 'ta\u0301ng-hiannh': '12214', 'jia\u030Dp-it': '00827', 'khioh-tsui\u0301': '03994', 'ke-tshue\u0302': '12758', 'tho\u0300-to\u0300ng': '03130', 'me\u0302-ji\u030Dt': '10572', 'tshin-bi\u030Dt': '11967', 'sim-tso\u0304ng': '01214', 'si\u0302ng-tshin': '02579', 'hu\u0302-ha\u030Dp': '07725', 'kho\u0301o': '05470', 'tsia\u030Dh-tshi\u0304ng': '05629', 'bio\u0304-a\u0301': '11060', 'ba\u030Dk': '01864', 'oo-tinn-a\u0301-tsha\u0300i': '06301', 'niu\u0302-a\u0301-tshiu\u0304': '05889', 'su\u0304n': '09247', 'sua-hi\u0302': '12799', 'e\u0304-hia\u0301u thau tsia\u030Dh, be\u0304-hia\u0301u tshit tshui\u0300. ': '60323', 'su\u0300-sik-pa\u0302i': '01479', 'kio\u0300-kho\u0301o': '01509', 'tshi\u0300-tsha\u030Dk': '03700', 'pit-tshe': '13596', 'ki\u0300-jia\u0302n': '05054', 'se\u0301-bi\u0304n': '05165', 'ba\u030Dt': '07162', 'tann-kang': '11689', 'tsa\u0304i-te\u0304-la\u0302ng': '02173', 'ok-khia\u030Dk-khia\u030Dk': '08422', 'pau-u\u0301n': '01636', 'tsu\u0300n-kau': '02392', 'thua-pe\u0302nn': '04117', 'sa\u0301i-tsu\u0302n': '11593', 'lia\u0301m-to\u0301o': '10795', 'tsit-ua\u0302n': '12601', 'bi\u0302ng-li\u0304': '02180', 'bi\u0302ng-li\u0301': '04250', 'a\u0300ng-phi\u0304nn-siann': '13403', 'tsha\u0300u-hia\u0300n': '06645', 'phua\u0300nn-kuann': '03000', 'ka\u0300u-tui\u0300': '06159', 'suann-se\u0300': '00470', 'huat-li\u0304ng': '04283', 'sua\u0300-tshiu\u0301': '07758', 'ba\u0304n-tsua\u0302n': '09926', 'gue\u030Dh-tshe': '00965', 'tsing-li\u030Dk': '10730', 'tho\u0302o-sat': '09411', 'bah-kenn': '02831', 'thi\u0304n': '02060', 'hong-bue\u0301': '05612', 'tong-kui': '09798', 'teh-beh': '04820', 'tshap-tsa\u030Dp': '08427', 'khui-kha-kho\u0300o': '09222', 'ta\u0304u-tsiu\u0300nn-thng': '03525', 'hong-hui\u0300': '06682', 'ku\u0301-tn\u0302g pe\u0304nn, bo\u0302 ha\u0300u-tsu\u0301. ': '60070', '--heh': '11009', 'bo\u0301': '01668', 'bo\u0302': '08588', 'bo\u0304': '11843', 'ga\u0301n': '07667', 'thau-the\u030Dh': '07003', 'khui-hue\u0304': '09219', 'ua\u0300n-tha\u0300n': '04979', 'phang-hu\u0301n': '04471', 'tsa\u030Dt': '10472', 'tshing-sim': '07548', 'ga\u0304m-tha\u0302u-ga\u0304m-bi\u0304n': '11637', 'kian-phi\u0301': '07119', 'tsa\u030Dp': '12691', 'tsi\u0301-hu': '03785', 'phua\u0300-sia\u0300u-lia\u0302n': '06407', 'tsa\u030Dk': '10412', 'siong-ha\u0302ng': '07059', 'khu\u0300n-ta\u0300u': '08826', 'tiong-li\u030Dp': '00648', 'lo\u030Dh-la\u0302i': '09942', 'huann-huann-hi\u0301-hi\u0301': '13244', 'khia\u0300m-khueh': '01049', 'hu\u0302n': '10953', 'i\u0301n-tsu\u0301n': '00701', 'ui\u0304-kha\u0301u': '05397', 'tho\u0302o-ta\u0304u': '09404', 'ba\u030Dk-tsiah-mn\u0302g': '01987', 'to\u0300-tshiu\u0301': '05746', 'lue\u0304': '00584', 'hue-ki': '04459', 'tsua\u0300nn': '05192', 'ki-bi\u030Dt': '11751', 'tshau-lia\u0304n': '11726', 'khue\u0302-tshiu\u0301': '11847', 'gue\u030Dh-tiong': '00849', 'thian-ha\u0304': '00831', 'pau-pa\u030Dk': '01643', 'so\u0300o-ji\u0304': '11155', 'tsia\u0304n-tha\u0302ng': '11506', 'si\u0301-kat': '02543', 'ki\u0301n pha\u0301ng bo\u0302 ho\u0301 se, ki\u0301n ke\u0300 bo\u0302 ho\u0301 ta-ke. ': '60343', 'gue\u0304-sing': '01565', 'pu\u0300n-so\u0300': '12300', 'a\u0302ng-ku': '05450', 'kong-pe\u0302nn': '00644', 'si\u0300n-gio\u0301ng': '04728', 'lo\u0300ng-kiu\u0302': '06062', 'hi\u0302ng-ia\u0301nn': '03204', 'sam-sua\u0300nn-lo\u0304o': '00526', 'tso\u0300-tshin-tsia\u0302nn': '07018', 'lua\u030Dh tha\u0302u-mn\u0302g': '06089', 'gia\u0302m-siok': '12992', 'khu\u0300n-pa\u0302ng': '08812', 'tui\u0304-ua\u0304nn': '02936', 'li\u0300-phua\u0300': '09357', 'bu\u0301-ha\u0304u': '01756', 'te\u0301-mia\u0304': '08808', 'sio\u0301-gio\u030Dk-a\u0301': '00303', 'pau-a\u0304nn': '01623', 'sit-bi\u0304': '01731', 'se\u0301-tshui\u0300': '05171', 'pua\u0300nn-sio-li\u0301ng': '01619', 'an-u\u0301n': '02430', 'sua\u0300nn-tha\u0302u': '11336', 'tsa\u0300ng-ha\u030Dh': '10773', 'io\u0304ng': '01854', 'kue\u0301-tsi\u0301-ba\u0302': '04213', 'ni\u0301-po\u0300o': '05107', 'bo\u0302-lo\u0304o': '08680', 'ta\u0300u-ti\u0304n': '06879', 'sin-tia\u0301m-tia\u0301m': '09589', 'ak-tsak': '13408', 'tua\u0304-la\u0302ng a\u0300i tha\u0300n-tsi\u0302nn, gi\u0301n-a\u0301 a\u0300i kue\u0300-ni\u0302. ': '60080', 'li\u030Dp-tsi\u0300': '01910', 'tsha\u0300i-tsi\u0301': '08959', 'kang-o\u0302o': '02750', 'sn\u0300g na\u0302-a\u0302u': '12620', 'kiat-sui\u0304': '08920', 'khi\u0302n-khia\u0304m': '09370', 'ngo\u0301o-hiang': '00698', 'ti-tsha\u0300i': '11484', 'jia\u0301 hi\u0302m jia\u0301 ho\u0301o, m\u0304-thang jia\u0301-tio\u030Dh tshiah-tsa-bo\u0301o. ': '60319', 'sa\u0301i-tshia': '11582', 'tsha\u0300i-po\u0301o-tshiam': '08986', 'to\u0300-tia\u0300u': '05754', 'tso\u0300-ki\u0304': '06980', 'bi\u0301-phang': '02698', 'oo-mia\u0302-tuann': '06269', 'sio\u030Dk-gi\u0301-ue\u0304': '04765', 'kiann-hia\u0302nn': '13346', 'thia\u0304m-pu\u0301n': '09400', 'pho\u0304ng-song': '11354', 'tiunn-tuah': '07234', 'mue\u0302-la\u0302ng-tshui\u0300': '08322', 'phinn-tha\u0302u': '07019', 'a\u0304u-suann': '04925', 'ka-li\u0301-lia\u0302n-lo\u0302': '03738', 'hia\u0300n': '12850', 'hia\u0300m': '08193', 'la\u030Dk-gue\u030Dh-thinn': '00631', 'ka\u0304u tsi\u0301': '04799', 'ia\u0304-tshi\u0304': '03788', 'sio\u030Dk-mi\u030Dh': '04737', 'tsio\u030Dh-thia\u0304u': '01931', tsuh: '04275', 'lio\u0302ng-me\u030Dh': '12138', 'pa\u0300ng-sia\u0300u': '04158', 'tso\u0300-khia\u0300n-sn\u0301g': '07025', 'su\u0304n-tsio\u0302ng': '09288', 'ta\u030Dh-ue\u0304-tha\u0302u': '11493', 'niu\u0302-kia\u0301nn': '13637', 'thinn-sik': '00924', 'pha\u0300n-a\u0301': '05252', 'hi\u0302-tsai': '08141', 'pe\u030Dh-bah': '01902', 'tshenn-huan': '01973', 'sih-sut-a\u0301': '12401', 'ho\u0304o i': '00652', 'gi\u0301ng-thui\u0302': '05368', 'ho\u0302o-tsio': '05434', 'kinn-tsa\u0300ng': '13400', 'tho\u0301-tsi\u0302nn': '06800', 'tshut-phia\u030Dh': '01632', tuh: '05245', tui: '06699', 'u\u0301n-ta\u0300ng': '12861', tun: '09167', 'po\u030Dh-pa\u0301n': '12343', 'tsia\u030Dh-nn\u0301g-kiann-nge\u0304': '05650', 'tshenn-tsha\u0300i': '04633', 'i\u0302nn-a\u0301-hue': '09395', 'kiu\u0300-ping': '07365', 'pia\u0300n-thong': '13345', 'ko\u0301o-i\u0300-la\u0302ng': '01578', 'pua\u0300nn-iam-iu\u0302nn-a\u0301': '01553', 'oo-im': '06303', 'tshiu\u0301-kang': '00836', 'lo\u030Dk-kho\u030Dk-be\u0301': '09824', 'khai-kuan': '09239', 'jia\u0301u-a\u0301': '01233', 'hua\u0301n-sio\u0302ng': '01055', 'ta\u0301-ma\u0301-ka-lo\u0304o': '01765', 'tsua\u0301n-se\u0300': '12659', 'te\u0304-hng': '02305', 'tsha\u0300u-khi\u0304-a\u0301': '06597', 'kan-kui\u0301': '02399', 'tsua\u0301nn': '09767', 'kiat-a\u0301-pia\u0301nn': '06187', 'kiat-sok': '08877', 'bo\u0302o-tsa\u0302i-ha\u0304i-bi\u0304ng': '11964', 'si\u0304m': '08368', 'si\u0304n': '08927', 'ku\u0301--la\u0302i': '00345', 'kun-tui\u0304': '05558', 'kua-a\u0301-hi\u0300': '10610', 'tsa\u030Dp kia\u0301nn tsa\u030Dp sin-pu\u0304, tshun tsi\u030Dt e\u0302 la\u0304u kua\u0301-hu\u0304.': '60056', 'kau-i\u030Dk': '02074', 'tshui\u0300-tu\u0302n-phue\u0302 sio khua\u0301n-tha\u0304i. ': '60284', 'ha\u0301i-ang': '06210', 'io\u030Dh-hu\u0301n': '12886', 'tsia\u0300u-sio\u0302ng': '09756', 'pua\u0302nn-ue\u0304': '11266', 'tshe-ku\u0304': '03817', 'phah-bo\u0302--khi\u0300': '04120', 'io\u0302-tha\u0302u': '09582', 'ho\u0302o-si\u0302n-sa\u0301i-ki\u0300': '05460', 'su\u0300-phue\u0300': '01535', 'piah-tu\u0302': '11670', 'gi\u0304-tiu\u0301nn': '13057', 'si\u0302n-ui\u0304': '06461', 'tha\u0302u--a\u0301': '12081', 'o\u0304ng': '03986', 'hioh-tang': '09679', 'tsi-ua\u0304n': '01081', 'tshun-thinn a\u0304u-bu\u0301 bi\u0304n, beh pia\u0300n tsi\u030Dt si\u0302-kan. ': '60205', 'kin-sui\u0302': '10162', 'siu\u0304-ha\u0304i': '03669', 'ia\u0302n-tshia\u0302n': '03920', 'tshuh-tshuh': '07693', 'phi\u0304nn-im': '10985', 'ka\u0300u-kuann': '07375', 'khu\u0300n tha\u0301n-khi': '08809', 'sit-iok': '01747', 'kui-si\u0300-la\u0302ng': '07880', 'bo\u0304ng-a\u0301-poo': '10451', 'tshu\u0300-bi\u0304': '11458', 'ko\u0301o-tsui': '01621', 'tsiu\u0300-tsua\u0304': '03757', 'be\u0304 te\u0302 ko\u0301ng te\u0302 phang, be\u0304 hue ko\u0301ng hue a\u0302ng. ': '60350', 'thia\u0300u-tsiam': '10238', 'lua\u0304n-tsing-a\u0301': '09376', 'kin-tue\u0300': '10151', 'siann-sueh': '12368', 'sia\u0301u--e\u0302': '08749', 'tio\u030Dh-kiann': '09054', 'jia\u0302u-hu\u0302n': '11261', 'tua\u0304-khoo-tai': '00506', 'ba\u0302-bu\u0304-a\u0301-kng': '11978', 'nah--lo\u030Dh-khi\u0300': '01583', 'thang-a\u0301': '08803', 'ta\u0302u-ko\u0301': '03275', 'ta-so\u0300': '08702', 'tsiu\u0301-phiah': '06920', 'tsha\u0300u-ta\u0304u-hu\u0304': '06587', 'tsa\u030Dp-tsa\u030Dp-kio\u0300': '03727', 'sio-tsim': '05280', 'gu\u0302-tann': '01291', 'tha\u0300m-tshin': '07435', 'la\u0304ng-sai': '03202', 'tsu\u0301-tshi\u0302': '01352', 'u\u0304n-ho\u0302': '10224', 'li\u0304ng-gua\u0304': '01462', pat: '00055', pau: '01394', 'ham-a\u0301': '07846', 'gua\u0304-kuan': '01642', 'kio\u0302ng-tso\u0300ng': '07219', pak: '09889', pan: '06356', 'tsu\u0302-pi': '09485', 'i\u0301n-tha\u0302u-lo\u0304o': '01182', 'tshiu\u0301-se\u0300': '01101', 'tsi\u0300ng-ji\u0302n': '12910', 'ha\u0301i-ka\u0301u': '06200', 'thut-tshue\u0302': '07828', 'be\u030Dh-phi\u0300nn': '08117', 'tsiu\u0301-khui-a\u0301': '06888', 'oo-tha\u0302u-a\u0301-tshia': '06344', 'la\u0302m-tsu\u0301': '03361', 'bu\u0302n-bi\u0302ng': '00975', 'kui\u0301-mn\u0302g': '06861', 'li\u0302m-si\u0302': '12351', 'tsa-bo\u0301o-king': '05119', 'ai-kiu\u0302': '04805', 'bue\u0301-a\u0301-kia\u0301nn': '03088', 'pha\u0301inn-si\u0300ng-te\u0304': '00973', 'tshau-sim': '11690', 'tn\u0304g-khui\u0300': '12529', 'a\u0300n-tsi\u0302ng': '06152', 'a\u0302m-khang': '07511', 'khue\u0300': '05080', 'nn\u0301g-kauh-kauh': '07931', hainn: '05820', 'tia\u0304m--khi\u0300': '04935', 'bah-tsa\u0300ng': '02788', 'oo-mi\u0301-to\u0302o-hu\u030Dt': '04670', 'sio\u0301-lo\u0304o': '00498', 'mua\u0302-soh': '08143', 'khue\u0302': '11840', 'thinn-khi\u0300': '01038', 'tshiu\u0301-so\u0300o-lia\u0304u': '01157', 'tsha\u0304nn': '12021', 'nia\u0301u-tshi\u0301-a\u0301-tsi\u0300ng': '08156', 'khai-ha\u030Dk': '09230', 'ke\u0301-ga\u0302u': '06944', 'sio-ua\u0301': '05278', 'tang-pi\u0302ng': '04216', 'un-kua\u0300n': '09710', 'a-sia\u0300': '04578', 'ba\u030Dk-kia\u030Dh': '01023', 'thian-lio\u0302ng': '00955', 'ko\u0301ng tua\u0304-siann-ue\u0304': '12407', 'tsi\u0300ng-kia\u0300n': '05027', 'tshia\u0302nn-io\u0301ng': '06161', 'tsi\u0300n-tsi\u0302ng': '09144', 'phah-tshiu\u0301': '03995', 'su-hu\u0304': '05924', 'siong-si\u0300n': '05270', 'pio-hue\u0304-a\u0301': '11208', 'po\u0300o-lia\u0304u': '01755', 'ke\u0300nn-a\u0301': '07468', 'bo\u0302-ka\u0304ng': '08611', 'tsiap-tshiu\u0301': '07348', 'na\u0301u': '09885', 'se\u0300-kan': '01372', 'io\u0301ng-io\u030Dk': '11581', 'ti-to\u0304o': '11452', 'iu\u0300-siu\u0300': '01720', 'ko-le\u0302-tsha\u0300i': '06926', 'khong-tian': '07307', 'tua\u0300-kui\u0304': '07246', 'tsha\u0302-tha\u0301ng': '06153', 'ho\u0301o-tha\u0302u-ngeh-a\u0301': '04664', 'bue\u0301-siann': '03137', 'la\u030Dk-sa\u0301i-la\u030Dk-jio\u0304': '09544', 'the\u0302-tshe\u0301nn': '08424', 'khua\u0302n-ui': '13237', 'n\u0302g-sng': '09307', 'he\u0302-ji\u0302n': '11365', 'sa\u0301i-ba\u030Dk-tsi\u0300nn': '03558', 'na\u0302-a\u0301': '13025', 'hi\u0304nn-a\u0301 senn nn\u0304g hio\u030Dh, ka-ki\u0304 khua\u0300nn be\u0304 tio\u030Dh. ': '60172', 'i\u0302-tiu\u0304nn': '04842', 'lo\u0302ng-tshun': '10216', 'nn\u0300g-tsi\u0302nn-khang': '12677', 'si-sia\u0301': '05050', 'tio\u0304ng-ta\u0304i': '05525', 'tha\u0302m-o\u0302o': '09792', 'ti\u030Dk-tshiu\u0301': '11148', 'lio\u0300ng': '13308', 'khi\u0301-so\u0300o': '06774', 'pue\u0304-ho\u030Dk': '03567', 'tsha\u0300u-kha-sio\u030Dh': '06622', 'tsih-la\u030Dt': '07344', 'ke\u0300 ke tue\u0300 ke pue, ke\u0300 ka\u0301u tue\u0300 ka\u0301u tsa\u0301u. ': '60315', 'kng-tha\u0302u': '02105', 'ge\u0302-mn\u0302g': '10043', 'kui-ti\u0304ng': '07887', 'ue\u0304-bue\u0301': '10108', 'tshenn-m\u0301-po\u0302': '11957', 'bi\u0301-tsiunn': '02797', 'an-tso\u0300ng': '02397', 'iu\u0302-tshang-kue\u0301': '04318', 'ga\u0301n-li\u030Dk': '07668', 'go\u0304ng-ti\u030Dt': '13455', 'tshi\u0304-la\u0304i': '01684', 'it kiam ji\u0304 ko\u0300o, bong la\u0302-a\u0301 kiam se\u0301 kho\u0300o. ': '60021', 'tshi\u0300ng': '10289', 'to\u0302ng-to\u0302ng': '07135', 'be\u030Dh-ge\u0302-ko': '08137', 'oo-a\u0301u': '06327', 'sa\u0300ng-tsiu\u0304nn-suann': '06710', 'tsia\u0300u-si\u030Dt': '09758', 'tia\u0304n-ia\u0301nn': '10369', 'phah-tshe\u0301nn': '04166', '--tsi\u030Dt-kua\u0301': '00036', 'o\u0301ng-khut': '04234', 'suan-thua\u0302n': '04901', 'to\u0300ng': '08508', 'me\u0302-ni\u0302': '04227', 'pa\u0300': '13167', 'pa\u0301': '10320', 'pa\u0302': '04339', 'pa\u0304': '11337', 'sa\u0301n-thiu': '11255', 'tsok-bu\u0302n': '02897', 'su\u0301n-sit': '09532', 'gi\u0301ng-tso\u0302': '05370', 'm\u0304-kua\u0301n': '01142', 'oo-lo\u0301o-bo\u030Dk-tse\u0300': '06338', 'tshu\u0301-hua\u030Dt': '07857', 'tia\u0300m-ho\u0304': '03873', 'lah-sap': '03792', 'tsio\u030Dh-hue': '01905', 'loh-tso\u030Dh--ji\u030Dt': '09958', 'khia\u0304-tha\u0302u': '07304', 'a\u0300m-pn\u0304g': '09644', 'po\u030Dh-li-si': '12375', 'tsia--e\u0302': '11527', 'ho\u0301o-tha\u0302u-phang': '04667', 'ha\u0301nn': '12158', 'lu\u0301n-khi\u0300 kiu\u0302 tsa\u0302i, kik-khi\u0300 sio-tha\u0302i. ': '60179', 'pe\u030Dh-iu\u0304': '01930', 'sit-go\u0304o': '01812', 'khua\u0300-sim': '07347', 'be\u0301-be\u0304 sn\u0300g hun, sio-tshia\u0301nn bo\u0302 lu\u0304n. ': '60308', 'tshit-tho\u0302-gi\u0301n-a\u0301': '13559', 'ia\u0301nn-ba\u030Dk': '11061', 'tsa\u0300u-tha\u0302u': '03340', 'tia\u0304nn': '09801', 'i\u0302ng-io\u0301ng': '12255', 'thng-si\u0302-a\u0301-tsha\u0300i': '08578', 'ka\u0304u-hi\u0304ng': '04801', 'tn\u0302g-kang': '04519', 'li\u0304-ik': '03010', 'sa\u0300n-hiong-la\u0302ng': '08451', 'tshi\u0302m-a\u0301': '13421', 'ka\u0300i-lu\u0304n': '09706', 'ge\u0302': '04497', 'hip-jua\u030Dh': '08950', 'ge\u0300': '12509', 'pe\u030Dh-ho\u030Dh': '02042', 'ge\u0304': '12869', 'he-ku-sa\u0300u': '08740', 'ua\u0302n-bua\u0301n': '09423', 'tshit-la\u0304u-peh-la\u0304u': '00106', 'tshiong-hun': '01328', 'tshia-a\u0301-tsiam': '03426', 'pe\u030Dh-sa\u030Dh': '01983', 'pia\u0304n-sann': '04695', 'kiunn-bo\u0301': '12390', 'tsu\u0301-tiunn': '01366', 'nn\u0301g-kha-he\u0302': '08002', 'hu\u0301n-pit': '06476', tshing: '04516', 'ga\u0302u-la\u0302ng': '13507', 'tsi\u0300-tshin': '02813', 'gio\u030Dk-la\u0302n-hue': '02039', 'to\u0304o-ku\u0301n-a\u0301': '03259', tshinn: '12480', 'li\u0302m-kip': '12346', 'thi\u0301-tshio\u0300': '05990', 'thut-tha\u0302u': '03393', 'hue\u0302-lia\u0302n-ta\u0304u': '07835', 'hua\u0302i-lia\u0304m': '12815', 'ke\u0300-ka\u0300u': '05564', 'to\u0304-iu\u0301': '10196', 'la\u030Dh-bah': '12858', 'tshui\u0300-nua\u0304': '08268', 'ho\u0301-phi\u0304nn-sai': '02411', 'phi\u0304nn-khang-hong': '10981', 'go\u0304ng': '13447', 'ngia\u0301u': '11093', 'kua\u0300i-tshiu\u0301': '03907', 'ho\u0301 tsha\u0302n-te\u0304 put-ju\u0302 ho\u0301 tsu\u0301-te\u0304. ': '60150', 'ngo\u0302o-khi\u0302-ting': '10074', 'sim-kuann-khut-a\u0301': '00950', 'tsi\u0302ng-ia\u030Dh': '04784', 'ho\u0301ng': '02056', 'a-ki\u0304m': '04557', 'ti\u030Dk-su\u0302': '06296', 'sia\u0300n-tshui\u0300-phue\u0301': '09566', 'tsi\u0304n ji\u0302n-su\u0304, su\u0304n thinn-i\u0300. ': '60341', 'ju\u0304n-pia\u0301nn-kauh': '11235', 'tsi\u0301-mue\u0304': '03796', 'lo\u0302o-tsu\u0301': '13012', 'huat-tshut': '08731', 'huan-tshu\u0300': '12600', 'ia\u0304-kan-po\u0304o': '03814', 'ku tshio\u0300 pih bo\u0302 bue\u0301, pih tshio\u0300 ku tshoo phue\u0302. ': '60362', 'tsiap-sio\u030Dk': '07447', 'u\u0304n-tsua\u0301n': '10275', 'khin-ta\u0304ng': '10917', 'si\u030Dt-tsi\u0302ng': '10506', 'liu\u0302-hi\u0302ng': '05202', 'khuah-tshui\u0300': '12475', 'a-po\u0302': '04619', 'tsiunn-a\u0301m': '11199', 'bu\u0301-ku\u0304-kong': '01806', 'tshenn-po\u0304ng-pe\u030Dh-po\u0304ng': '04655', 'tua\u0304-tha\u0302u-bu\u0301': '00545', 'ha\u0300n-io\u030Dh': '10672', 'tia\u0300u-to\u0304ng': '11401', 'tu\u0300': '10596', 'tu\u0301': '03963', 'tu\u0302': '06819', 'li\u0301m': '12334', 'tu\u0304': '11571', 'thong-sio\u0302ng': '07983', 'tsha\u0302n-le\u0302 ka\u0302m tsui\u0301 kue\u0300 tang. ': '60134', 'ha\u030Dk-si\u030Dp': '11662', 'ta\u0302u-thai': '03251', 'tso\u0300-sik': '06979', 'ti-kuann': '11453', 'sa\u0300n-tshiah': '08466', 'kang-hu': '00271', 'hua\u0301n': '00789', 'si\u0304ng': '07663', 'lia\u0302n-sio\u030Dk': '08023', 'siang-bi\u0304n': '12727', 'sin-khu-pinn': '03523', 'tsui\u0301-o\u0304o-a\u0301': '00960', 'tha\u0300m-tha\u0302u': '07436', 'kut-tha\u0302u-hu': '06911', 'si\u0304nn': '07874', 'kha\u0300u-tshan': '05845', 'tsho\u0300-tsha\u0302': '04749', 'to\u0300-phak': '05803', 'a\u0304u-bo\u0301o': '04960', 'lio\u0304ng-ki\u0302-iok': '09198', 'ni\u0302-ki\u0301': '02357', 'bo\u0302-ga\u0304i-tio\u030Dh': '08708', 'ing-ko-phi\u0304nn': '13457', 'ho\u0302ng-siu\u0301': '03434', 'kan-hia\u0301m': '02419', 'tsha\u0300i-tshuah': '09005', 'kio\u030Dk-tiu\u0302nn': '11000', 'thi\u0302n': '09525', 'tsha\u0300u-iu\u0302': '06590', 'ui\u0304-pe\u0304nn': '05424', 'li\u0302ng-gi\u0301ng-kuann': '12141', 'ke-a\u0301-lo\u0304o': '09023', 'thiah-ji\u0304': '04022', liap: '13563', 'tsui\u0301-sa\u0301n': '01065', 'ke\u0300-a\u0301': '05099', 'hueh-ham': '02741', 'tsio\u0301ng-khua\u0302n': '08430', 'go\u0304o-ji\u030Dt-tseh': '00634', 'bi\u0301-ta\u0301u': '02634', 'lia\u0301u-pu\u0301n': '00092', 'lu-a\u0301': '12524', 'neh-kha-bue\u0301': '13430', lian: '11359', 'mi\u0304-ka\u0302u': '13102', liam: '13417', liah: '09012', 'tshiu\u0304-ling': '11742', 'hue\u0301-ke-bo\u0301': '01301', 'tsha\u0302n-kia\u0302u-a\u0301': '02003', 'gua\u0304-sun': '01522', 'i\u0301ng-ua\u0301n': '01813', 'a\u0300ng-to\u0304o': '12562', 'oo-keh-a\u0301': '06295', 'li\u0302ng-he\u0302': '12151', 'tso-gu\u0304': '11539', 'ua\u0301n-tsiok': '10913', 'tsia\u0300nn-lo\u0304o': '01808', 'a-tia': '04603', 'mua\u0302-tsi\u0302': '08162', 'sua\u0301nn': '08443', 'sai-a\u0301': '05927', 'ko\u0301': '11276', 'ko\u0300': '10181', 'tue\u0300-lo\u0304o': '10808', 'ko\u0302': '07717', 'tsa-bo\u0301o-ho\u0304o': '05116', 'ko\u0304': '09715', 'tsha\u0301u-tshio\u030Dh': '06625', 'be\u0304': '11424', 'tsi\u0302ng-bi\u0304n': '07276', 'tsia\u030Dh-la\u030Dt': '05592', 'hu\u0300n': '09603', 'sa\u0300ng': '06701', 'tsui\u0301-le\u0302': '01193', 'sia\u0300u-gia\u030Dh': '11179', 'pue\u0304-ki\u0301ng': '05432', 'tsa\u0301u-bi\u0304': '03443', 'hiong-tshun': '09139', 'sat-ba\u030Dk-hi\u0302': '04545', 'si\u0301-tse\u030Dh': '02544', 'pa\u0304n-li\u0301': '12007', 'tshun-u\u0302n': '02891', 'kau-lia\u0302ng-tsiu\u0301': '06891', 'tsu\u0304-tsua\u0301n-tshia': '02826', 'phah-tsio\u030Dh-sai': '04012', 'tio\u0300-kau': '08091', 'pui\u0302-nn\u0301g': '04478', 'tshia-sim': '03419', 'kia\u0302nn-tsu\u0302n': '02740', 'm\u0304-tsia\u0302nn-mi\u030Dh': '00921', 'tshio\u0300-bi\u0304n-ho\u0301o': '06466', 'ka\u0301m m\u0304 si\u0304': '08457', 'sn\u0301g': '05386', 'ka-tang': '05489', 'pa\u0300ng-tiau': '03989', 'mi\u0304-te\u0302': '13098', 'io\u030Dh-a\u0301': '12878', 'ka-tann': '01617', 'tsio\u0301ng-tsn\u0304g': '11256', 'se\u0300-li\u030Dk': '09332', 'tshe-it': '03625', 'tsa\u0302i-si\u0302n': '06763', 'hi\u0300-bu\u0302n': '12184', 'kiap-hiu\u0302': '10066', 'ka\u0300m-ti\u0304ng': '13284', 'bo\u0302-ia\u0301nn': '08692', 'siat-ia\u0302n-ta\u0302u': '07905', 'tse\u0304-ui\u0304': '03045', 'lah-sap-ue\u0304': '03794', 'gio\u030Dk-ho\u0302ng-ta\u0304i-te\u0300': '01935', 'phia\u0301nn': '10898', 'pia\u0300n-sik': '13328', 'ka\u0301u-gue\u030Dh thai, bo\u0302 la\u0302ng tsai. ': '60038', 'siat-si': '07890', 'hu\u0300-kui\u0300': '08338', 'bio\u0301-tsing': '05378', 'be\u0304-tsia\u030Dh-be\u0304-khu\u0300n': '06673', 'tia\u0304u': '11388', 'tso\u0300-kui\u0301': '06995', 'kong-tse\u0300': '00747', 'li\u0304-pia\u030Dt': '12715', 'tia\u0304n': '10316', 'tia\u0304m': '04919', 'toh-ku\u0302n': '06157', 'tik-ko-tshe': '02810', 'bi\u0301-tshia\u0301m': '02835', 'ha\u030Dh-su': '02271', 'senn-kia\u0301nn': '01894', 'tsi\u0302nn-kin': '12042', 'pua\u0300nn-sin': '01487', 'to\u0300-pi\u0302ng': '05749', 'kn\u0300g-a\u0301': '10608', 'jio\u0304-o\u0302o': '03122', 'tsi\u0301-ia\u0300u': '01510', 'tua\u0304-i\u0301ng': '00455', 'ko\u030Dk': '04790', 'pua\u0302nn-sia\u0300u': '11269', 'ko\u0300o-bu\u0304n': '13218', 'pha\u0304inn': '08437', 'ji\u0302n-sing': '00094', 'iu\u0302-hi\u0302': '04305', 'pa\u0300ng-siann': '04173', 'a\u0301u-uan': '04189', 'nga\u0301-lio\u0304ng': '09298', 'hit-si\u0302': '03927', 'sio\u0304ng-ku\u0301': '00232', 'tsha\u0300u-phu\u0301': '06609', 'ka-to': '10900', 'lo\u030Dh-tso\u0300ng': '09987', 'pi\u0301-phi\u0304ng': '00962', 'ho\u0304o-tsi\u030Dk': '01211', 'e-kue\u0301': '05997', 'pa\u0300ng-hong-siann': '04080', 'pia\u0300nn-sa\u0300u': '08478', 'tshu\u0301-te\u0300': '03690', 'khang-su\u0301n': '04421', 'thua-mia\u0304': '04043', 'tsa\u030Dt-phi\u0304nn': '10518', 'ti\u0304-pe\u0304nn': '04302', 'pa\u030Dk-kha': '11883', 'tua\u0304-thiann': '00565', 'ku\u0301-tsha\u0300i': '05660', 'iu\u0301nn-pe\u0304': '11587', 'si\u0302ng-ka': '02515', 'ba\u0301n tsha\u0301u': '06055', 'pa\u0301-ji\u0302n': '10325', 'bi\u0302n-ba\u0304ng': '06437', 'kia\u0300n-tsi\u0301-bah': '09902', 'mui\u0301-ni\u0302': '03311', 'kha-ta\u0302ng-kut': '10130', 'ti\u0301ng-ka\u0301ng u\u0304 mia\u0302-siann, e\u0304-ka\u0301ng sio\u0304ng tshut-mia\u0302. ': '60281', 'ba\u0301n tshui\u0300-khi\u0301': '06068', 'liu\u0301-la\u030Dk': '03200', 'oo-ku': '06345', 'la\u0302i-khi\u0300': '03552', 'tshiu\u0301nn-kiap': '09535', 'pu\u0302n-hong': '11787', 'thiu\u0301-a\u0301': '00636', 'tah-sim': '09075', 'pa\u0300ng-tsui\u0301-ting': '04002', 'lu\u0302n-khau': '11545', 'suh-ko\u0301ng': '07527', 'i\u0301ng-si\u0302': '03928', 'lia\u0302n-nga\u0304u': '11355', 'si\u0301 ho\u0302ng-te\u0300 m\u0304-ta\u030Dt-tit ua\u030Dh khit-tsia\u030Dh. ': '60167', 'tshia po\u0300o-pinn': '06034', 'tsit-khua\u0302n': '12622', 'sam-a\u0301': '03240', 'ba\u0302-pi\u0300': '08152', 'ui\u0302-pue\u0304': '10230', 'tsha\u0300u-hue\u0301-ta': '06570', 'tsi\u030Dt-tui\u0300-si\u0302': '00038', 'tia\u0300u-ka\u0302u': '02235', 'ka-ki\u0302': '03578', 'tha\u0302u-hi\u0302n-ba\u030Dk-a\u0300m': '12099', 'lia\u030Dh-pau': '07355', 'tsia\u0300u-ko\u0300o': '09762', 'phue\u0302-siunn': '02010', 'sia\u0301u-ka\u0301u-i\u0301ng': '08747', 'khi\u0301-hu\u0301n': '11616', 'thiah-phio\u0300': '04108', 'bo\u0302-na\u0304i': '08631', 'pn\u0304g-si\u0302-kut': '09286', 'huann-hi\u0301': '13241', 'sue\u0300-kheh': '10871', 'iu\u0302-kia\u0304nn': '09136', 'hua\u0302inn-ke\u030Dh': '11781', 'pah-ji\u030Dt-sa\u0300u': '02640', 'o\u0301ng': '03893', 'tsa-bo\u0301o-tso\u0301o': '05118', 'ko\u0302ng': '03345', 'tsia\u0301u': '08110', 'kho\u0300ng-io\u0302': '04380', 'tsha\u0301u-te\u0304 tshin-ke tse\u0304 tua\u0304-ui\u0304. ': '60252', 'tu\u0301n': '03030', 'tsue\u0304-ko\u0300': '09872', 'ko\u0302nn': '12487', 'kiu\u0301-kiong-a\u0301': '00111', 'kiat-lu\u0304n': '08915', 'kua\u0300-li\u0304': '07429', 'sio\u0301-ta\u0301n': '00463', 'tsia\u0301n': '06942', 'ko\u0301ng-ko\u0301o': '12410', 'tiu\u0300nn-la\u0302ng': '08953', 'pi\u0300nn': '13307', 'khia\u0300m-an': '00909', 'kha\u0300 tia\u0304n-ue\u0304': '10589', 'kia\u0301u-sian': '08864', 'tuann-kha-tshiu\u0301': '08301', 'ia\u0301u-koh teh': '08690', 'po\u0304ng-a\u0301': '11287', 'ti\u0300n-tsi\u0304ng-tse': '12761', 'bi\u0304-so\u0300o': '03741', 'to\u0302-hua\u0304n': '06722', 'an-ui\u0300': '02414', 'siau-khia\u0301n': '06330', 'ue\u030Dh': '10409', 'ke-kue\u0300': '12764', 'tua\u0300': '12651', 'tua\u0304': '00196', 'lia\u030Dp-mi\u0304-ang-a\u0301': '06095', 'lu\u0301n-tiu\u0302nn': '11712', 'tshoo-pa\u0301': '07791', 'ta\u030Duh-ta\u030Duh-a\u0301': '04291', 'lia\u0302u--lo\u030Dh-khi\u0300': '13483', 'te\u0302-bi\u0301': '06580', 'hi\u0300-pe\u0302nn kha khia\u0304 ku\u0301 to\u0304 si\u0304 li\u0301 e\u0302. ': '60366', 'ta-sang': '08707', 'tsha\u0302-to': '06115', 'si\u0301ng-su\u0304': '05348', 'lak-sik': '09932', 'pa\u0300ng-hu\u0301n-tsia\u0301u': '04092', 'thiam-tsng': '07579', 'tshia-pang': '03520', 'lia\u0304m-king': '03937', thng: '08574', 'tia\u0304n-hue\u0301-pho\u030Dk-a\u0301': '10332', 'ka\u0301u-kua\u0300i': '05203', 'tsha\u0302-tsha\u0302': '06142', penn: '12321', 'lia\u0302u-io\u0301ng': '12275', 'ke\u0300-sia\u0300u': '11004', 'tik-bi\u030Dh-a\u0301': '02819', 'mua\u0301-pak': '10625', 'khok-a\u0301': '12408', 'bue\u030Dh-a\u0301': '13153', 'siu\u0300-i': '12839', 'ia\u0302n-pit-ka\u0301-a\u0301': '10307', pah: '02597', 'tsa\u0300ng': '10724', 'tha\u0302m-a\u0301': '11227', 'kua\u0301n-sia\u0300u': '10771', 'sue\u0300-tshu\u0300': '08820', 'ta\u0301m-lio\u0304ng': '12363', 'tsu\u0301-tsia\u030Dh': '08649', 'siu-sia\u0300u': '02569', 'bo\u0302-pua\u0300nn-ha\u0304ng': '08619', 'ba\u0304n-su\u0304': '09941', 'la\u0302ng-tsa\u0302i': '00079', 'tua\u0304-hiann': '00281', 'ba\u0304n-ba\u0304n-a\u0301': '10552', 'hia\u0302m-gi\u0302': '09446', 'ing-ia': '03802', 'kheh-thiann': '04911', 'tso-sim': '10538', 'kui\u0301-na\u0304 kang': '08355', 'senn-hu\u0304n-la\u0302ng': '01893', 'thi\u0304nn-sann': '07779', 'kha-kut': '10132', 'hi\u0300-pe\u0302nn': '12204', 'tsi\u030Dt kah-tsi\u0301': '00017', 'tshua\u0304-lo\u0304o': '13547', 'ji\u0304-tsua\u0301': '02363', 'senn kia\u0301nn sai-a\u0301, tshi\u0304 kia\u0301nn sai-hu\u0304. ': '60128', 'hong-hue\u0301': '05597', 'tshi-ko-si\u0302n': '09784', 'a\u0302ng-lo\u0304o-tsiu\u0301': '05464', 'i\u0301n--la\u0302ng': '00601', 'tsa\u0301u-suann': '03417', 'tsiu\u0300-ku-a\u0301': '07860', 'gi\u0302n-phio\u0300': '10923', 'tsiong-la\u0302i': '07178', 'siu\u0301nn-su\u0300': '11498', 'sia\u030Dh-liu\u0302': '02004', 'tik-kha': '02777', 'tsi\u0300ng-tong': '01799', 'tik-sit': '07215', 'im-tik': '08095', 'ho\u0304ng-sa\u0300ng': '03805', 'kho\u0300-hua\u0304nn': '11583', 'tsiu\u0301-phue\u0300': '06878', 'li\u0304-tshiu\u0301': '12699', 'ta\u0301-ma\u0301-ka': '01764', 'tn\u0302g-tu-hi\u0302ng': '04601', 'tsi\u0302ng-bo\u0301o': '04742', 'ti\u0301ng-pua\u0300nn-me\u0302': '08058', 'sua\u0304n-tsio\u030Dh': '11250', 'ang-a\u0301-phiau': '03091', 'tu\u0300n-tshiu\u0301': '10328', 'khah-su': '10269', 'ki\u0301n-si\u0300ng': '10797', 'huah-ku\u0302n': '08235', 'phiau-ti\u0300': '11203', 'tio\u0301ng-tsi\u0300n': '04636', 'tsioh-kue\u0300': '05784', 'tsia\u0300n-tiu\u0302nn': '11713', 'hu\u0300-kio\u0302ng': '08336', 'khi\u0301-tshn\u0302g': '06733', 'ke\u0301-si\u0301': '06976', 'jua\u030Dh--tio\u030Dh': '11265', 'te\u0304-li\u0301-su': '02375', 'hong-hu\u0300': '12670', 'tshian-kim': '00379', 'si\u0302n-si\u0302n': '06470', 'tn\u0300g-phio\u0300': '09790', 'tinn-lo\u0304o': '07700', 'tsham-sio\u0302ng': '07082', 'hun-sin': '00671', 'tsue\u0300-a\u0304u': '08520', 'jio\u0304-to\u0304': '03132', 'ba\u0304n-ha\u0304ng': '09982', 'thiah-tsia\u030Dh-lo\u030Dh-pak': '04079', 'put-su\u0301-kui\u0301': '00661', 'hu\u0300n-kha\u0300i': '11114', 'te\u0302-sim-te\u0302': '06568', 'pun-tsi\u0302nn': '00772', 'si\u0300ng-king': '09984', 'tsia\u030Dh la\u0302ng tsi\u030Dt kin, ia\u0304-tio\u030Dh hi\u0302ng la\u0302ng si\u0300 niu\u0301. ': '60219', 'sio\u0301-pe\u030Dh-tsha\u0300i': '00304', 'mua\u0302-iu\u0302-tsiu\u0301': '08135', 'hu\u0301n-tia\u0302u': '06472', 'moo-hui': '10582', kok: '07095', 'sa-la\u0301-iu\u0302': '03317', koo: '08930', 'hia\u030Dp-to\u0302ng': '03642', 'iu\u0301': '03413', 'sio\u0301-kang': '00238', 'iu\u0302': '10178', 'iu\u0304': '05088', 'pia\u0301u-hiann-ti\u0304': '04537', 'sua\u0304n-tha\u0301ng': '10661', 'o\u0302ng--ko-liu\u0301--ko': '01265', 'tshia-pua\u030Dh-pi\u0301ng': '06070', 'nn\u0301g-poo': '07984', 'tsio\u0301ng-ak': '08415', 'i\u0300nn': '11807', 'tsui\u0301-tse\u0301nn': '00851', 'tsu\u0300-senn-niu\u0302-niu\u0302': '09081', 'tshua\u0300nn': '05520', 'i\u0300ng': '11640', 'sio\u0302ng-se\u0300': '10141', 'huat-lu\u030Dt': '04296', 'te\u0301-he\u0304': '03850', 'sam-a\u0301-tsha\u0302': '03244', 'tsi\u0302ng-ka\u0300u-tann': '07269', 'tsha\u0300u-tsho': '06641', 'pha\u0300u-ta\u0302i': '05198', 'bi\u0301-tsiu\u0301': '02724', 'tshua\u0301n': '08198', 'puann-u\u0304n': '09573', 'la\u0304u-hue\u0300-a\u0301': '02772', 'keh-king': '10361', 'khang-pak': '04418', 'ka\u0304u tsiu\u0301': '04819', 'hia\u0302nn-hue\u0301': '11815', 'hing-o\u0304ng': '11900', 'kik-kut': '11795', 'sio\u0302ng-tsi\u0302ng': '10134', 'hiann-so\u0301': '01374', 'la\u0304u-pe\u0304': '02691', 'tsu\u0304-tsa\u0304i': '02662', 'be\u0304 a\u0300n-sn\u0300g': '06671', 'tua\u0304-ka\u0301ng': '00454', 'm\u0304-kam hia\u0302m': '00894', 'tsu-pu\u0301n': '10103', 'hi\u0302-tsi\u0301': '08116', 'so\u0300ng-bi\u0301-a\u0301': '03095', 'tsa\u0301u-toh--e\u0302': '03461', 'ke-kia\u0301m tha\u0300n, khah be\u0304 sa\u0300n. ': '60119', 'tsheh-ke\u0300-a\u0301': '01353', 'kong-pun': '00613', 'sua\u0300nn-sian': '08458', 'sai-pi\u0302ng': '02849', 'tua\u0304-kua\u0302nn': '00449', 'ke-ta\u0300': '12750', 'put-ta\u0304n': '00665', 'ha\u030Dk-ui\u0304': '11653', 'sit-tshiu\u0301': '01687', 'gua\u0304-tse\u0304': '07022', 'khua\u0302n-li\u0304': '13234', 'tn\u0300g-tia\u0300m': '09777', 'li\u0302ng ': '21757', 'ke-nn\u0304g': '12714', 'hi\u0302n': '06398', 'hi\u0302m': '10678', 'ku\u0304-ni\u0302': '12591', 'tshiu\u0304-bue\u0301': '11744', 'tshi\u0304-tsha\u0301u': '01760', 'bah-ua\u0302n-a\u0301': '02630', 'kha\u0301u-tsa\u0300u': '00332', 'kua\u0301i-lo\u0304ng': '04034', 'khau-to-hue': '09333', 'tshu\u0300n-tso\u0301': '11329', 'ba\u0301n hue': '06044', 'la\u0302ng tshi\u0304 la\u0302ng, tsi\u030Dt ki kut, thinn tshi\u0304 la\u0302ng, pui\u0302-tsut-tsut. ': '60050', 'tho\u030Dk': '13263', 'tsing-kong': '10737', 'i\u0300n-a\u0301': '02150', 'bu\u0302n-hia\u0300n': '01210', 'sam-bu\u0302n-hi\u0302': '00277', 'tho\u0301o-kong-a\u0301': '00251', 'kui-ki\u0301': '07894', 'io\u030Dh-ua\u0302n': '12873', 'ui\u0302-la\u0302n': '05228', ka: '10896', 'a\u0304u-bi\u0304n': '04961', ke: '12692', 'khuah-pak': '12477', 'ta\u0304u': '03402', 'ia\u0304nn-ia\u0304nn-pue': '12792', ki: '06821', ko: '06825', 'thia\u0300u-ni\u0302': '10210', 'pue\u0302-tsi\u0302nn': '11501', 'ta\u0304i': '13582', ku: '12127', 'kho\u0301-la\u0302u': '05160', 'kuan-to': '12939', 'khik-i\u0300n-a\u0301': '03643', 'tua\u0304 ta\u0304i-tsi\u0300': '00286', 'tiu\u0304nn-m\u0301-po\u0302': '00364', 'i\u0301ng-hio\u0301ng': '11083', 'gia\u030Dh-tshiu\u0301': '13130', 'la\u030Dk': '09514', 'la\u030Dh': '13151', 'e\u0301-pui\u0302': '09778', 'la\u030Dp': '06452', 'si\u0302 tha\u0302u-lo\u0304o': '12927', 'tsai-ui\u0304': '04402', 'la\u030Dt': '00059', 'pi-siong': '08359', 'kuah-bah': '08216', 'kha\u0300u-iau': '05851', 'kap-a\u0301': '09021', 'ti\u0302ng-a\u0301': '04686', 'hi-sing': '13135', 'la\u0301u-tsa\u0301': '02664', 'a\u0300u-sa\u0301i-bi\u0304n': '10656', 'lo\u030Dh-sng': '10000', 'im-tia\u0304u': '05687', 'tso\u0301ng-tho\u0301ng': '12307', 'se\u0300-tsi\u0302ng': '01367', 'ta\u0302ng-sa\u0304i-a\u0301': '02193', 'i\u0300ng-gia\u0304m': '12219', 'ha\u0304ng-a\u0301': '04879', 'ta\u0302ng-ki': '08806', 'ho\u0301-pha\u0301inn': '02308', 'siu-suann': '02466', 'bo\u0302-siau': '08696', 'siong-sui\u0302': '05312', 'tsha\u0300i-te\u0301': '08974', 'kia\u0302m-tsha\u0300i': '13103', 'se\u0300-ha\u0300n': '07793', 'ku-sui': '12137', 'tap-sia\u0304': '08921', 'tho\u0301ng-ke\u0300': '07780', 'oo-sua\u0304n-tsio\u030Dh': '06333', 'iau-kua\u0300i': '03102', 'bu\u0302n-gi\u0302n': '06488', 'm\u0304-tsia\u0302nn': '00917', 'tsi\u0300n-po\u0304o': '09140', 'tsi\u0302ng-gi\u0304': '07292', 'giang-a\u0301': '09186', 'tsa\u030Dp-hue\u0300': '12741', 'ue\u0304-hu\u0302-a\u0301': '08761', 'siunn-a\u0301': '11289', 'tha\u0301u-khui\u0300': '08471', 'li\u0304-ia\u0302n': '12759', 'bu\u0300n': '11220', 'ha\u0301i-sa\u0301n': '06218', 'ki\u0301ng-sik': '08462', 'hiang-iu\u0302': '05618', 'gi\u0301n-a\u0301-tsai': '02160', 'sui\u0302-tsa\u0304i': '12033', 'kia\u0302nn-tha\u0300u-tha\u0300u': '02745', 'ba\u0302-a\u0301': '08326', 'la\u0304u-koo-po\u0302': '02684', 'bah-kuann': '02727', 'sai-gu\u0302': '08610', 'tsa\u0301-a\u0300m': '02549', 'a\u0300m-so\u0302-so\u0302': '09652', 'tia\u0301n-la\u0301m': '05968', 'ho\u030Dk-bu\u0304': '04246', 'tsing-bi\u030Dt': '10761', 'sa\u0300u-te\u0300 sa\u0300u piah-kak, se\u0301-bi\u0304n se\u0301 hi\u0304nn-khang. ': '60269', 'tsa\u030Dh-pi\u0302n': '10302', 'a\u0302ng-hi\u0304ng-tsha\u0300i': '05430', 'gi\u0301ng-puah': '05360', 'ka\u0301m-tsi\u0302ng': '09482', 'tuh-ku': '05313', 'tshe\u0304-sia\u0300u': '03059', 'kha-pe\u030Dh': '10115', 'nn\u0301g-ko\u0302-ko\u0302': '08010', 'ha\u0300m-ue\u0304': '12925', 'thi\u0302-thi\u0302-kha\u0300u-kha\u0300u': '08247', 'ua\u030Dh': '05182', 'm\u0304-tsia\u0302nn-la\u0302ng': '00918', 'tsia\u030Dh pa\u0301 ua\u0304nn iau. ': '60230', 'hi\u0300ng-tha\u0302u': '11915', 'ua\u030Dt': '09071', 'ho\u0304o-kha\u0301u-mia\u0302': '00843', 'tsong-ha\u030Dp': '10739', 'si\u0301ng-tsi\u0302nn': '05373', 'sia\u0301u-tham': '08762', 'le\u0302-a\u0301': '12389', 'bo\u0302 ke\u0302 gia\u0302 kau-i\u0301. ': '60298', 'lo\u0304o-tshiong': '10217', 'oo-a\u0300m-hi\u0302n': '06320', 'phah-pha\u0300i': '04073', 'tha\u0302u-tsa\u0301ng': '12117', 'kiat-ko\u0301': '08881', 'thang-hong': '07970', 'gua\u0304-tho\u0300': '01517', 'siau-siu\u0304': '11555', 'tsui\u0301-ko\u0301': '00976', 'tin-thiap': '05172', 'kiu\u0302-si\u0302n-mn\u0304g-pu\u030Dt': '03326', 'la\u0304u-la\u0302ng-ba\u030Dk': '02624', 'tshik-gia\u0304m': '08585', 'pu\u030Dt-a\u0301': '02900', 'siu-bi\u0304n': '05718', 'li\u0302ng-kak': '08972', 'tshui\u0300-bue\u0301': '08219', 'ti-kong': '11433', 'tsha\u0302-pe\u0302': '06145', 'thinn-kong-tso\u0301o': '00856', 'sio-jua\u030Dh': '11837', 'io\u0301ng-si\u0302n': '11591', 'bi\u0302ng-lia\u0302u': '04262', 'tsia\u030Dh la\u0302ng tha\u0302u tsing tsiu\u0301, ko\u0301ng la\u0302ng tha\u0302u ku\u0300 ue\u0304.': '60220', 'bi\u0301-tik': '05443', 'tshut-tshiu\u0301': '01443', 'khua\u0300nn-tha\u0302u': '05374', 'bi\u0304': '04268', 'bi\u0302': '07664', tshoh: '13573', tshok: '11138', 'bi\u0301': '05385', 'ka\u0301i-sa\u0300n': '10061', 'khu\u0300n-la\u0302n': '03061', 'su-koo': '05937', 'tshit-niu\u0302-ma\u0301-senn': '00132', 'ang-i\u0302 su\u0304n ue\u0304-bue\u0301, ke\u0301 ta\u0302ng ha\u0304i tsi\u0300ng-la\u0302ng. ': '60181', 'sann-tu\u0302-si\u0300-kha\u0300u': '00434', 'sok-ka-te\u0304-a\u0301': '09430', 'te\u0300nn-tian-te\u0300nn-go\u0304ng': '03592', 'sua\u0301-kha': '07293', 'hip-sio\u0300ng': '08939', 'tsa\u0302n-khok': '08565', 'sio\u0304ng-so\u0300o': '00465', 'tsiunn-a\u0301': '11195', 'suan-tsia\u0300n': '04906', 'jio\u0304-tsu\u0304-a\u0301': '03109', 'tia\u0301m-mia\u0302': '12494', 'mn\u0302g-ho\u0304o': '04528', 'ga\u0301n-kho': '07685', 'kiann bo\u0301o': '13337', 'ua\u0301nn-ta\u0301u': '09813', 'tsua\u0302n': '05139', '--mah': '10418', 'tua\u0304-pu\u0301n': '00297', 'u\u0304--e\u0302-bo\u0302--e\u0302': '02505', 'i\u0301nn': '11846', 'bo\u0302-la\u0301m-bo\u0302-ne': '08712', 'bi\u0302ng-hoo': '04233', 'tsia\u030Dh bi\u0301 m\u0304 tsai bi\u0301 ke\u0300. ': '60222', 'tsi\u0304n-po\u0304ng': '10711', 'ka\u0300-si\u0304': '07359', 'phoh-phoh': '07784', 'siu\u0300-se-a\u0301': '03382', 'tsik-peh-hiann-ti\u0304': '03649', 'tsiu\u0300nn': '12686', 'ki\u0300ng-jia\u0302n': '07733', 'thuat-tsi\u0301ng': '07826', 'kui\u0300-tseh': '03870', 'sit-ki\u0300ng': '01797', 'lia\u030Dh-kau-the\u0300': '07361', 'huat-sio': '08777', 'lua\u030Dh-a\u0301': '06032', 'pau-pn\u0304g': '01570', 'ti\u0304-ta\u0304i': '03843', 'ko\u0301o-tse\u0301nn': '10390', 'pi-kuan': '08365', 'pu\u0301n-la\u0302ng': '01672', 'tshing-ha\u0302n': '07578', 'tshut-la\u0302i': '01489', 'sann-tn\u0302g-nn\u0304g-te\u0301': '00380', 'tshin-tshiu\u0304nn': '11974', 'm\u0304-gua\u0304n': '01209', 'e\u0302-bi\u0301n-a\u0301': '11584', 'lo\u030Dk-te\u0304': '09972', 'tsa\u0304u-tsi\u0302nn': '03278', 'a\u0304nn-pia\u0301nn': '12112', 'mn\u0302g-si\u0302n': '04607', 'kiu\u0300-ua\u0304n': '07406', 'nia\u0304-nia\u0304': '10687', 'si\u0302ng-ho\u0302ng-bio\u0304': '04859', 'io\u030Dh-hng': '12875', 'kue\u0300-mia\u0302': '10209', 'hi\u0300-kn\u0301g': '04484', 'thian-po\u0302ng': '01190', 'pe\u0304': '06510', 'tiong-tshiu-pia\u0301nn': '00694', 'pe\u0301': '03214', 'pe\u0302': '06509', 'hn\u0302g': '09380', 'kio\u0304ng': '02111', 'thia\u0300u-tsua\u0304': '10247', 'ka\u0301u-siu\u0304': '04364', 'tsong-tshin': '03882', 'uan-hu\u0302n': '05786', 'to-a\u0301': '00088', 'tshi\u0301ng-ka\u0301': '11476', 'bo\u0302-ia\u0300u-bo\u0302-ki\u0301n': '08647', 'buah-hu\u0301n': '04091', 'thinn-pn\u0304g': '07581', 'siong-kan': '05247', 'iu\u0302-pn\u0304g': '04309', 'si\u0302ng-ji\u0302n': '02459', 'tshue-ka\u0301u-le\u0302': '03001', 'tsia\u030Dh-khui': '05702', 'siak-tha\u0301ng': '10548', 'ni\u0302-bue\u0301': '02335', 'ba\u030Dk-sa\u0301i': '01928', 'he-ku be\u0304 lu\u0301n tit sa\u0300u. ': '60312', 'ti\u0300ng-kin': '06870', 'sio-phah': '05265', 'thua\u0300nn-io\u0302': '05222', 'lio\u0304ng': '09163', 'pue\u0302-phua\u0304nn': '08064', 'sim pha\u0301inn bo\u0302 la\u0302ng tsai, tshui\u0300 pha\u0301inn sio\u0304ng li\u0304-ha\u0304i. ': '60103', 'ga\u0302': '01226', 'ian-ta\u0302ng': '09738', 'suah-ko\u0301o': '09742', 'tsiu\u0301-pa\u0302n': '06882', 'sio\u0302ng-ka': '04260', 'tsho\u0301': '06561', 'tsho\u0300': '04711', bih: '09014', 'si\u0302ng-si\u030Dt': '10150', 'ta\u0304u-tsha\u0300i': '03486', 'tshik-a\u0301': '08867', 'hit-tsi\u030Dt-ji\u030Dt': '03902', 'kan-na': '00456', 'kia\u0300n-gi\u0304': '04910', 'sio\u0301-mia\u0302': '00311', 'the\u0301-lio\u0304ng': '13353', 'io\u030Dh-ko\u0301o-a\u0301': '12894', 'bo\u0302-sia\u0301nn-hue\u0300': '08662', 'tshi-ko': '09783', 'tho\u0300ng-kho\u0301o': '08752', 'khio\u0301ng-po\u0300o': '05984', 'sio\u0304ng': '10406', ai: '04794', 'thau khua\u0300nn': '06988', 'sing-tio\u0301ng': '01925', 'tsia\u0300nn-ka\u0301ng': '01787', 'li\u0301ng-khi\u0300': '02929', 'keh-tn\u0301g-kang': '10380', 'to\u0304ng': '05145', 'tsiu\u0304': '08316', 'tik-ha\u030Dh': '02801', 'tshut-tiunn': '01538', 'tsiu\u0300': '07841', 'tsiu\u0301': '06811', 'su\u0304-gia\u030Dp': '03581', 'thiu-thia\u0300nn': '04087', 'su\u0304n-kia\u0302nn': '09264', 'lo\u0302o-tsi\u0302': '13445', 'iau-su\u030Dt': '03121', 'ji\u030Dt-gua\u030Dt-than': '00869', 'sann ko\u0301ng, si\u0300 m\u0304-tio\u030Dh. ': '60066', 'kip-la\u0304n': '04991', 'tshi\u0302m': '13419', 'ke-hue\u0301': '05932', 'phua\u0300-keh-tshui\u0300': '06421', 'si\u0302-ha\u0304u': '06048', peh: '13631', 'ta\u0304u-hu\u0304-sua': '03506', 'tsiat-si\u0301ng': '09854', 'te\u0302-hn\u0302g': '06614', 'sa\u0300n-kui\u0301': '08474', 'hia\u0301ng': '13203', 'ti-phoo': '11499', 'hia\u0301nn': '13311', 'tse\u0300-tso\u0301o': '07730', 'ko\u0300o-la\u0302ng-ua\u0300n': '13207', 'ka\u0301u-hia\u0304-ti\u030Dh-a\u0301': '04384', 'tio\u030Dh-tshenn-kiann': '09025', 'ui\u0302-su': '12006', 'pui\u0304': '02971', 'pui\u0302': '04436', 'tioh-tsi\u030Dh-kin': '12191', 'phah-tshiu\u0301-tshi\u0300ng': '04001', 'kuah-hue\u0300': '08243', 'huat-io\u0302ng': '08766', 'tsu\u0304-te\u0301': '02687', 'tsi\u030Dt-si\u0300-la\u0302ng': '00009', 'thai-si\u0302n': '05426', 'ia\u0302-tsi\u0301': '09605', 'ka\u0300-tsheh': '07353', 'siau-lo\u0304o': '11559', 'la\u0304i-li\u0301': '00757', 'tsia\u030Dh-tso\u0301o': '05641', 'khui-toh': '09206', 'gue\u030Dh-kip': '01095', 'tshut-tiu\u0302nn': '01557', 'ka-la\u030Dh': '10440', 'tshia-pia\u0300nn': '06042', 'thua\u0302n-jia\u0301m': '09349', 'tshiu\u0301-ki-a\u0301': '01171', 'bo\u030Dk-ni\u0301': '00928', 'tshue\u0304 tha\u0302u-lo\u0304o': '08495', 'te\u0302-tia\u0300m-a\u0301': '06588', 'ta\u0304u-khoo': '03501', 'o\u0302ng-la\u0302i': '01270', 'la\u0302ng': '12330', 'tshau-lo\u0302': '11711', 'ti-iu\u0302': '11461', 'sia\u0304ng-to\u0302o': '13629', 'kok-ho\u0302ng': '07120', 'lia\u030Dh-la\u0304u': '07425', 'e\u0302-tua\u0300': '11592', 'tsa\u0304i-ia\u0301': '02228', 'a-nia\u0302': '04597', 'tsah-po\u0300o': '07762', 'kui-pak-hue\u0301': '07901', 'tshiu\u0301-tua\u0304nn': '01005', 'siah-siah-kio\u0300': '04739', 'po\u0302-a\u0301': '07171', 'tshi\u0300 kia\u0302m-tsia\u0301nn': '10079', 'phu\u0300n-sia\u0304-ki': '11026', 'si\u030Dt-tsia\u0304n': '10522', 'tsi\u030Dt e\u0302 bo\u0301o khah ho\u0301 sann e\u0302 thinn-kong-tso\u0301o. ': '60034', 'u\u0304-hi\u0302ng': '02548', 'tsha\u0301u-tshu\u0300-a\u0301': '06601', 'bo\u0302-ka\u0300u-gue\u030Dh': '08659', 'oo-ian': '06323', 'siu-pua\u0302nn': '02571', 'tsia\u030Dh-tshi\u0300n-tha\u0302u': '05643', 'ue\u0304-sat': '10117', 'ki\u0301ng-ti\u0300': '08491', 'thi\u0300-tha\u0302u-to': '04775', 'an-bi\u0302n': '02360', 'khi\u0300-kha\u0300i': '06228', 'u\u0304-si\u0302-tsu\u0304n': '02520', 'hing-kua\u0300-kut': '06534', 'khi\u0300-sio\u0304ng': '06224', 'ki\u0301n-tiunn': '10803', 'tsui\u0301-hue\u0300': '01071', 'la\u0300u-e\u0304-ha\u0302i': '09905', 'pho\u0300ng-pha\u0304 ': '11901', 'kho\u0300ng-tsha\u0300i-tha\u0302u': '04376', 'ka-ki\u0304 tsai tsi\u030Dt tsa\u0302ng, khah ia\u0302nn khua\u0300nn pa\u030Dt-la\u0302ng. ': '60237', 'bi\u0302ng-pi\u030Dk': '04226', 'to\u0302ng-tshong': '02236', 'kuah-pe\u0304': '08237', 'tua\u0301n': '08792', 'tshin-ke-kong': '11963', 'kio\u0302-kha': '11759', 'hue\u0301-tua\u0304': '01231', 'tsi\u0304': '00210', 'lia\u0301n-tsn\u0300g': '11130', 'ta\u0302ng-iu\u0302': '06133', 'lu\u0301n': '11673', 'sim-kuann-a\u0301-kia\u0301nn': '00948', 'iu-gua\u0302n': '08651', 'kho\u0300o-tsi\u0302nn': '05961', 'hua\u0304nn': '03226', 'lin-long-ko\u0301o': '05215', 'jua\u030Dh--la\u0302ng': '11245', 'tsuan-khua\u0302n': '07197', 'ho\u0301-u\u0304n': '02403', 'tsui\u0301-phio\u0302': '01200', 'su\u0304-li\u0301': '03576', 'si\u0302n-hu\u0302n': '06489', 'ju\u0304n': '09245', 'pa\u0300i-it': '04924', 'ki\u0301-tsa\u0301inn': '05040', 'kho\u0300o-pa\u0302ng': '05938', 'bo\u0301o-tan': '03364', 'ni\u0301-lia\u0304u': '05126', 'puh-ge\u0302': '08750', 'keh-tn\u0301g-ni\u0302': '10382', 'ha\u0302ng-tsi\u0302ng': '02738', 'tsia\u030Dp-tsia\u030Dp': '07397', 'thiap-pu\u0301n': '09078', 'ping-siunn': '02257', 'ta\u0304u-phoh': '03475', 'tshiau-kip': '09106', 'phio\u0300-pe\u030Dh': '10649', 'ti-ko-si\u0302n': '11470', 'lio\u0301': '12267', 'lio\u0302': '13505', 'pa\u0300ng-li\u0304ng': '03992', 'kian-pa': '07111', 'phe\u0302nn-o\u0302o-tsha\u0300i-kue': '11234', 'li\u030Dh--khui': '09042', 'ka\u0301nn tso\u0300 pu\u0302-hia, tio\u030Dh m\u0304-thang kiann tsui\u0301 thn\u0300g. ': '60290', 'te\u0301-hue\u0300-siu\u0304': '08830', 'tsa\u0301u-kang-o\u0302o': '03438', 'su\u0304n-hong-ni\u0301': '09280', 'ta\u0300-bu\u0304': '09880', 'ka\u0301u-bo\u0301-ue': '04357', 'phah-m\u0304-ki\u0300nn': '04000', 'tha\u0302u-tsui\u0301': '12076', 'khan-kenn': '07649', 'ngo\u0301o-ka-pi\u0302': '00642', 'pa\u0301-kui\u0304': '10373', 'phue\u0300-kip': '06884', 'tua\u0304-a\u0304u--ni\u0302': '00391', 'hia\u030Dp-tso\u0304o': '03652', 'ba\u0304n-lia\u0302n-pit': '09929', 'pe\u0300nn': '05082', 'gue\u030Dh-sik': '00927', 'tsha\u0300u-kau-a\u0301': '06616', 'hu\u0302-io\u0301ng': '03205', 'li\u0302ng-gi\u0301ng': '12140', 'si\u0302-ki': '06084', 'a\u0302ng-ge\u0302': '05403', 'im-thim': '08098', 'kia\u0302nn-king': '02773', 'tsia\u0300': '11357', 'ho\u0302ng-tsui\u0301': '12271', 'tui\u0304-ngo\u0301o': '09196', 'kiat-ji\u030Dt': '02146', 'te\u0302-ta\u0301i': '06617', 'to\u0304-lo\u0304o': '10260', 'mn\u0304g': '07044', 'ta\u0304u-ling': '03430', 'sn\u0300g-be\u0304-ho\u0302': '10758', 'tsia\u0300nn-bi\u0304n': '01750', 'ia\u0302m-hue-a\u0301': '13396', 'iu\u0300-hue\u0300': '01778', 'ta\u0302u': '03220', 'khak-si\u030Dt': '11300', 'si\u0301 tsua\u0302 ua\u030Dh bue\u0301-liu. ': '60168', 'ta\u0302i': '13500', 'ta\u0302n': '11562', 'ta\u0302m': '11389', 'tsit-ma\u0301': '07982', 'n\u0302g-tha\u0301n': '09282', 'mue\u0302-a\u0301-pia\u0301nn': '07472', 'uan-khut': '05760', 'hun-iok': '07184', 'ba\u0304n-bu\u030Dt': '09945', 'bia\u030Dt': '09712', 'khi-khiau': '12442', 'jia-ho\u0304o': '11528', 'ue\u0304-tha\u0302u': '10163', 'bo\u0301o-la\u0302ng': '05093', 'thn\u0300g-sann': '11923', 'me\u0301-tshe\u0301nn': '07646', 'si\u0300nn-bi\u0304n': '05988', 'pak-to\u0301o tso\u0300 io\u030Dh-tu\u0302. ': '60327', 'gua\u0304n': '12960', 'la\u0302-gia\u0302-tshia': '12643', 'ui\u0302-ki\u0302': '08299', 'sit-pa\u0304i': '01769', 'io\u0302-ko\u0302': '09565', 'nia\u0301-siu\u0304': '10959', 'pian-tsi\u030Dp': '11335', 'li\u030Dk': '10729', 'li\u030Dh': '09013', 'gia\u0302m-kun': '12035', 'su\u0302n': '06497', 'tho\u0301-sia\u0300u': '06792', 'la-lun-a\u0301-sio': '04101', 'koo-ji\u0302': '03851', 'tsok-tsia\u0300n': '02948', 'mi\u0302': '10784', 'mi\u0304': '13088', 'tsi\u030Dt pia\u0300n tsha\u030Dt, pah si\u0300 tsha\u030Dt. ': '60028', 'ti-tsi\u030Dh': '11446', 'lua\u0302n-a\u0300i': '13302', 'pua\u0300n-si\u0300n-pua\u0300n-gi\u0302': '01502', 'siu-po\u0301o': '05721', 'huat-si\u0300ng-te\u0304': '08741', sing: '04439', 'tshut-gua\u0304': '01461', 'be\u0301-kua\u0300': '06898', 'po\u0304ng-pio\u0301': '11301', 'u\u0304 tsio\u0304ng-gua\u0302n ha\u030Dk-sing, bo\u0302 tsio\u0304ng-gua\u0302n sian-sinn.': '60159', 'sia\u0301-si\u0300': '07274', 'bu\u0301-khi\u0300': '04320', 'u\u0304n': '12959', 'ke\u0301-si\u0301-ke\u0301-ua\u030Dh': '06978', 'pa\u0300ng-sang': '04179', 'iu\u0302nn-mn\u0302g-sann': '02639', 'tsi\u0302ng-i\u0300': '07290', 'kio\u030Dk-se\u0300': '03127', 'tshiok-pan': '08082', 'tsi\u030Dt ji\u030Dt tsa\u0301u-pha-pha, tsi\u030Dt me\u0302 tia\u0301m ting-la\u0302. ': '60009', 'bue\u0301-tshiu\u0301': '03081', 'a\u0302ng-ba\u030Dk-lia\u0302n': '05410', 'ha\u0301i-tsua\u0302': '06220', 'liang-a\u0301': '08282', 'tsa\u0304m-tiu\u0301nn': '06465', 'lo\u0302-li\u030Dk': '08204', 'tsia\u0304m-si\u0302': '11161', 'siau-tsui\u0301': '06258', 'ho\u0301-io-tshi\u0304': '02340', 'huan-pa\u0301n': '12597', 'i\u0300ng-io\u0304ng': '12188', 'khu\u0302n': '10836', 'tue\u0304': '02883', 'bu\u0302n': '04510', 'pue\u0304-te\u0302': '08657', 'tue\u0300': '10781', 'kho\u0300-bu\u0302n': '11390', 'sia\u0301nn': '07092', 'po-so': '11403', 'tshiu\u0301-kut': '01052', 'io\u0302ng-li\u030Dk': '09231', 'tshia\u0301nn-toh': '11472', 'hue-kan': '04461', 'pa\u030Dt-e\u0302': '02985', 'po\u0301-kua\u0301n': '04762', 'hia\u030Dp-tiau': '03691', 'tha\u0301u--khui': '08485', 'pu\u0301n-tsia\u0302nn': '01714', 'te\u0302-tsa\u0302ng': '06649', 'ka\u0301m u\u0304': '08460', 'pan-kah': '08497', 'hue\u0301-ko': '01298', 'si\u0304-tua\u0304-la\u0302ng': '03170', 'tak-tsi\u030Dh': '13052', 'ka\u0300i': '10852', 'lue\u0304-io\u0302ng': '00705', 'ak-hue': '03319', 'ta\u0304u-kuann-tsi\u0300nn': '03471', 'tsui\u0301-li\u0302ng-tshia': '01186', 'la\u0302-a\u0301': '10035', 'lua\u0304n': '09312', 'tha\u0302u-hia\u030Dh': '12119', 'hio\u0304-pue\u0300': '04983', 'tia\u0304n-ue\u0304': '10366', 'pia\u0301nn-iu\u0300-a\u0301': '10958', 'mia\u0302-siann': '02268', 'ba\u030Dt-ba\u030Dt': '07188', 'si\u0301-gi\u0301n-a\u0301': '02484', 'si\u0302n-tsui\u0301': '03993', 'suann-niau': '00540', 'hit pi\u0302ng': '03911', 'tia\u0302u-tsi\u0301ng': '11411', 'a\u0304m-tshi': '12109', 'kha-to\u0301o-kut': '10113', 'tshiu\u0301-tsi\u0301ng-tha\u0302u-a\u0301': '01003', 'that phue\u0304': '11481', 'bi\u0302n-sim': '01691', 'a\u0300ng-siann': '13404', 'tshik-tshng': '08887', 'tn\u0302g-suann': '05827', 'pa\u0300ng': '03985', 'tsiau-tha\u0304i': '04069', 'tha\u0302u-tsang': '12120', 'tshiu\u0302nn-ui\u0302': '12252', 'pia\u0301u--e\u0302': '04575', 'poh-hua\u0304nn': '10961', 'to-pe\u0300nn': '00125', 'm\u0304-na\u0304': '00931', 'siong-hong-pa\u0304i-sio\u030Dk': '09354', 'kha-tsi\u0301ng-tha\u0302u-a\u0301': '10124', 'tsu\u0301-ji\u0304m': '01332', 'him-sia\u0304n': '04312', 'pian-khik': '11322', 'kia\u0300n-na\u0304': '03457', 'ko\u0301o': '10388', 'tshi\u0301ng-tsue\u0304': '11487', 'a\u0302ng-ta\u0304u-a\u0301': '05414', 'hu\u0304n--to\u0301': '04241', 'sio-tsiu\u0301': '11827', 'ki-su': '03255', 'ha\u0301i-to\u0302ng': '06221', 'tik-ham': '02621', kuann: '03357', 'tsu\u0302n-ua\u0302n': '07822', 'tso\u0300': '06937', 'tso\u0301': '08506', 'tso\u0304': '07929', 'pe\u030Dh-pau': '01888', 'tu\u0301-sia\u0300u': '04157', 'tsi\u030Dt bi\u0304n buah-piah siang bi\u0304n kng. ': '60020', 'ti\u0301ng-tang': '08055', 'tsai-ha\u0304i': '03380', 'tsu\u0301-hu\u0304': '01365', 'po\u0300-sia\u0300u': '08302', 'sai-kong': '01437', 'kan-la\u0302n': '12379', 'ping-kak': '02183', 'lo\u030Dh-bue\u0301': '09933', 'gua\u0302n-si\u0302n': '00712', 'tsui\u0301-ah': '01183', 'tsha\u0300u-hong': '06600', 'koo-i\u0302': '03800', 'kik-khi\u0300': '11789', 'tsui\u0301-li\u0302ng': '01184', 'khik-pua\u0302nn': '02572', 'siu-nua\u0304 siu ho\u0304o ta, ho\u0304o li\u0301 senn tsi\u030Dt e\u0302 u\u0304 la\u0304n-pha.': '60155', 'niu\u0302-niu\u0302': '05893', 'khi\u0304-tshui\u0300': '03196', siong: '05242', 'la\u0304u-mia\u0304': '02682', tso: '10529', 'tshia\u0302u': '11132', 'i\u0300nn-bo\u0301-a\u0301': '12187', tsi: '11341', lo: '01408', tse: '07923', 'u\u0304-tsi\u030Dt-bo\u0302-nn\u0304g': '02457', 'si\u0301-pa\u0301n': '02502', 'tio\u0304ng-tshi\u0304ng': '05541', lu: '12519', 'tshia\u0302n': '03889', 'tsui\u0301-kia\u0301u': '01153', tsu: '06355', 'thang-kng': '07949', 'ki\u0304m-a\u0301': '03084', 'si\u0301-tse\u0304-ua\u030Dh-tsia\u030Dh': '02492', 'ha\u0301i-hue\u0302-siu\u0304nn': '06195', 'tia\u0302u-iok': '07513', 'lu\u0301-ji\u0302': '00351', 'khua\u0300nn': '05325', 'pia\u0300n-hua\u0300': '13320', 'mia\u0304-u\u0304n': '03756', 'gu\u0302-ling-tshui\u0300-a\u0301': '01241', 'tsi\u0301ng-tsi\u0301': '10731', kiau: '11037', 'tsu\u0304-si\u0300n': '02701', 'kan-lo\u030Dk': '00522', 'pia\u0304n-pn\u0304g': '04700', sih: '12830', 'tua\u0304-se\u0300-ba\u030Dk': '00445', 'tn\u0301g': '12657', 'bi\u0302n-i\u0300': '01796', 'kui\u0300-tik-su\u0301n': '06127', 'ta\u0304ng-pe\u0304nn': '05548', 'tia\u0304n-si\u0300n-kio\u030Dk': '10345', 'si\u0301ng-kang': '05336', 'kua\u0301n-hat': '10774', 'mo\u0302o-honn': '00967', 'iu\u0302-ka\u0301u': '04294', 'pa\u0300ng-phui\u0300-ta\u0304u': '04033', 'png-a\u0301': '09609', 'pe\u030Dh-tsha\u0300i': '01976', 'pa\u0300-tsia\u0300m': '13175', 'tsu\u0301-hun': '01364', tsok: '02880', tsoh: '02879', 'bo\u0301o-kia\u0301nn': '05108', tsoo: '07749', 'ke-tsiu\u0301': '12735', 'bi\u0301-lua\u0302': '02839', 'o\u0302ng-la\u0302i tha\u0302u, si-kue bue\u0301. ': '60115', 'kha\u0301u-khi\u0300': '00426', 'tsi\u030Dt iu\u0304nn bi\u0301 tshi\u0304 pah-iu\u0304nn la\u0302ng. ': '60030', 'ta\u0300i-pe\u0304nn': '07229', 'ka-thiam': '01545', 'hi\u0301-kio\u030Dk': '08259', 'bua\u030Dh-tsha\u0301u': '05492', 'gue\u030Dh-ho\u0304ng': '01018', 'pa\u0301-tiu\u0300nn': '10358', 'khioh-tio\u030Dh': '04126', 'tshim-tse\u0301nn': '07544', 'pe\u030Dh-thiap-a\u0301': '01915', 'tsia\u0302n-kho': '04744', 'pua\u0302nn-a\u0301': '11248', 'tsia\u030Dp': '07312', 'ia\u0301u-koh': '08689', 'se-tsi\u0302n-o\u0302ng-ia\u0302': '02857', 'kian-ko\u0300o': '07121', 'tsia\u030Dh': '05588', 'koo-to\u030Dk': '03881', 'thia\u030Dp': '13249', 'tsi\u030Dp-thua\u0302n': '09306', 'ma\u0304i': '11425', 'hui\u0302-a\u0301': '07670', 'hing-kha\u0301m': '06519', 'seh-tshiu\u0301-pha\u0304ng': '09607', 'hong-huat': '00978', 'tha\u0302u-sing': '12085', 'khia\u0304m': '10993', 'ka-pi': '03743', 'kheh-sio': '13577', 'si\u0302ng-tsik': '02587', 'ge\u0304-tua\u0300nn': '12881', 'iu-tha\u0302u-kho\u0301o-bi\u0304n': '11125', 'suann-nia\u0301': '00549', 'phi-sann': '04075', 'tshiu\u0301-tsi\u0301': '00997', 'siu\u0300-hue': '12598', 'tshia\u0300nn--e\u0302': '05763', 'tshiu\u0304-ue': '11756', 'kha\u0301u-tshi\u0300': '00485', 'siong-tong': '05299', 'ba\u0302n-phue\u0302-sia\u0301n': '13423', 'tsoo-tshu\u0300': '06467', 'the\u0300nn-kua\u0302n': '08709', 'e\u0302-tsu\u0304': '11590', 'ue\u0304-thn\u0302g-ang-a\u0301': '08779', 'jia\u030Dt': '11237', 'tshut-sa\u0301n': '01548', 'bo\u0302-sia\u0301nn-mih': '08660', 'hong-siann': '05699', 'lo\u0304o-gio\u0304': '12371', 'po\u0301o-tia\u0301nn': '10070', 'kia\u0302m-tsia\u0301nn': '13093', 'ha\u030Dk-li\u0301': '11661', phngh: '09378', 'tshia\u0301n-thua-a\u0301': '07561', 'e-a\u0300m': '00472', 'ti\u0304m': '11808', 'khiu\u0302-mn\u0302g': '04526', 'ti\u0304n': '06817', 'se\u0300-su\u0304': '01340', 'kan-se\u0300': '02376', 'thiu-ti-bo\u0301-sue\u0300': '04161', 'tsu\u0301-pa\u0304n': '01381', 'be\u0304-tshun-tshia': '06688', 'lo\u0302o-mua\u0302': '13446', 'kue\u0300-hi\u0302': '13362', 'tshi\u0300n-tha\u0302u': '06492', 'pa\u0301-bi\u0302n': '10353', 'kang-ti\u0302ng-su': '00460', 'la\u030Dk-la\u030Dk-tshuah': '09493', 'ti-ki\u0301': '04397', 'u\u0304n-khi\u0300': '10234', 'tsha\u0300i-kue-tshe\u0300': '08968', 'siau-ki\u030Dk': '06321', 'i\u0300-gua\u0304n': '09499', 'tui\u0304-ua\u0302n': '09205', 'hi\u0304ng-tsha\u0300i': '07855', 'suann-ti\u0301ng': '00446', 'kha\u0300ng': '07332', 'khi\u0300-si\u0301 gia\u0304m bo\u0302 siong. ': '60243', 'iu\u0302-tsua\u0301': '04303', 'to\u0304ng-ki': '07086', 'thio\u0301ng-suann': '09390', 'tha\u0302u-ba\u030Dk': '12083', 'bi\u0301-la\u0301u': '02840', 'ta\u0302m-lok-lok': '11797', 'khi\u0300-hia\u0302m': '07524', 'kha\u0300m-tha\u0302u-kha\u0300m-bi\u0304n': '05962', 'bo\u0302-si\u0302n': '08656', 'sio\u0304ng-te\u0300': '00387', 'hu\u030Dt-si\u0304': '02906', 'thua\u0302n': '10442', 'ta\u0301u-a\u0301': '00874', 'pn\u0304g-ta\u0301u': '09257', 'tsi\u030Dt-e\u0304': '00004', 'tshu-phue\u0304': '08948', 'so\u0301-tha\u0302u': '12762', 'tua\u0304-hu\u0300-tua\u0304-kui\u0300': '00450', 'sia\u0300u-siu\u0304nn': '11169', 'phue-tha\u0301ng': '03261', 'lui\u0302': '10313', 'lui\u0301': '11895', 'bu\u0302n-tshi\u0304': '00882', 'lui\u0304': '12961', 'tsu-keh': '10129', 'kau-ta\u0300i': '02067', 'un-lua\u0301n': '09696', 'kho\u030Dk-tio\u030Dh': '08828', 'kin-ni\u0302': '00656', 'kam-tsia\u0300 bo\u0302 siang tha\u0302u tinn. ': '60126', 'tsi-tshi\u0302': '00998', 'tsu\u0302n kue\u0300 tsui\u0301 bo\u0302 hu\u0302n. ': '60277', 'to\u0301ng': '13089', 'bi\u0304n': '05581', 'sin-se\u0300': '03424', 'ia\u0301n-ua\u0302n': '10658', 'tsi\u0300ng-la\u0302ng': '07669', 'pha\u0302ng-po\u0300o': '02319', 'i\u0302nn-a\u0301-tshe\u0300': '09398', 'ta\u0304i-tsi\u0300': '01380', 'kui-e\u0302': '07875', 'sua-thio': '03321', 'tsai-ia\u0301nn': '04424', 'ti\u0304n-tha\u0302u': '06909', 'lo\u0302o': '13438', 'hua\u030Dt-tuann': '10805', 'tsa\u030Dh kng': '10298', 'tsham-kho\u0301-tsheh': '07060', 'khioh-a\u0302ng-tia\u0301m-a\u0301': '04074', 'hi\u0304ng-hok': '03877', 'ta\u0304i-tio\u0304ng-hu': '00240', 'tha\u0302u sio-sio, bue\u0301 li\u0301ng-li\u0301ng. ': '60359', 'tshui\u0300-phue\u0301': '08202', 'tshui\u0300': '09803', 'kok-huat': '07123', 'ho\u0302-bo\u030Dk': '03754', 'ta\u0304u-se': '03440', 'bo\u0302-pua\u0300nn-si': '08618', 'sia\u0301u-ji\u0302n': '00224', 'ba\u0304n-hi\u0304ng': '09943', 'tsha-tsho\u0300': '05960', 'pha\u0301inn-la\u0302ng': '00829', 'a-bu\u0301': '04540', 'hue-a\u0301-po\u0300o': '04446', 'la\u0302ng khan m\u0304 kia\u0302nn, kui\u0301 khan liu\u0300-liu\u0300-kia\u0302nn. ': '60048', 'tsok-gia\u030Dp': '02941', 'tsok-gia\u030Dt': '02955', 'tshia\u0302nn': '06097', 'khi\u030Dt-a\u0301': '03243', 'bi\u0301-khng': '02818', 'tshiau-to\u0304o': '09095', 'ka-tsua\u030Dh': '05507', 'ha\u030Dunnh-ha\u030Dunnh': '12256', 'mo\u0302o-tn\u0302g-ia\u0304m': '04419', 'soh-a\u0301': '06514', 'hi\u0304ng-u\u0304n': '03875', 'si\u030Dt-tn\u0302g': '05644', 'ki-li\u0301': '03076', 'bu\u0302': '08589', 'bu\u0301': '10815', 'tsi\u030Dt-pua\u0300nn': '00010', 'bu\u0304': '12938', 'go\u0304o-hun-a\u0301-tshia': '00617', 'pi\u0301ng-toh': '01035', 'la\u0302ng-ia\u0302n': '00159', 'go\u0304ng-tha\u0302u-go\u0304ng-bi\u0304n': '13463', 'phue\u0302-hu': '02013', 'tsha\u0301-la\u0304': '02997', 'tshiu\u0301-pio\u0301-a\u0301': '01174', 'bo\u0302-huat-to\u0304o': '08637', 'ha\u0304-ngo\u0301o': '00259', 'tsiam-tsa\u0301inn': '06865', 'ki\u0304n-la\u0302i': '04564', 'ho\u0301-tsiu\u0301 ti\u0302m a\u0300ng-te\u0301. ': '60153', 'thn\u0300g-kho\u0300o': '11931', 'ang-bo\u0301o': '06526', 'thia\u0304u-a\u0301-la\u0304i': '07723', 'tsi\u0300': '03150', 'tsi\u0301': '00816', 'tsi\u0302': '12383', 'sim-hiat': '00925', 'sio\u0301-gue\u030Dh': '00269', 'tshiu\u0301-ua\u0301nn': '01097', 'si\u0300ng-tsi\u0301': '09930', 'kua\u0304n': '11865', 'tsha\u0300n-la\u0304n': '12260', 'im-io\u0302ng': '08086', 'hong-se\u0300': '05666', 'tshia\u030Dk-tshia\u030Dk-tio\u0302': '12165', 'ko\u0301ng-po\u0300o-kio\u030Dk': '11081', 'po\u0302o-sim': '08724', 'tsha\u0301u-io\u030Dh': '06646', 'thap-kha': '09421', 'tsoh-tsha\u0302n': '02904', 'oo-ji\u0302n-ba\u030Dk-kia\u0300nn': '06256', 'sio\u0301-phio\u0300': '00441', 'phah-eh': '04031', 'ji\u0304-ho\u0304': '02396', 'io\u0302-ko\u0301o-long': '09575', 'tho\u0301o': '00192', 'pha-pha-tsa\u0301u': '04053', 'kho-bo\u030Dk': '05341', 'pi\u0302ng-sio\u0302ng-si\u0302': '01768', 'hio\u0304-su\u0304': '04975', 'pio-tha\u0302u': '11215', 'phun-tha\u0301ng': '11205', 'thiau-sua\u0301n': '05069', 'tshiu\u0302': '09459', 'tshiu\u0301': '00803', 'tiong-tsa\u0301inn': '00684', 'i\u0301n-iu\u0301': '01146', 'ta\u0300u-hue\u0301-ki\u0300': '06894', 'hua\u0304nn-tia\u0301nn-tsa\u0300u': '02562', 'thn\u0302g-hu\u0301n': '11879', 'sia\u0304ng-tshe-kong': '00273', 'hu\u0300-gia\u030Dp': '07009', 'ka\u0301i-to\u0302o': '03263', 'khan-sua\u0300nn': '07643', 'ta\u0300m': '10948', 'tio\u030Dh-tsui\u0301-tshi': '09018', 'ta\u0300n': '12515', 'ta\u0300u': '06826', 'phah-sn\u0301g': '04135', 'bia\u0301n sia\u0300u-siu\u0304nn': '02947', 'ti\u030Dt-tha\u0300u': '04409', 'so-i\u0302nn-a\u0301-thng': '07289', 'a\u0301n-tsua\u0301nn-iu\u0304nn': '05039', 'to\u0304o-tse\u0300': '04897', 'phiann-ki-kut': '12077', 'nn\u0304g-ji\u0302n': '02987', 'iu\u0301-ha\u0304n': '02512', 'hua\u0301n-pue\u0304': '01011', 'pi\u0301': '00819', 'ua\u0301-piah': '05791', 'pi\u0304': '07867', 'sia\u0300u-ia\u0302': '01113', 'ia\u0304-ho\u0301': '00315', 'ka\u0301i-tsiu\u0301': '10051', 'gue\u030Dh-pua\u0300nn': '00878', 'gue\u0304-sing tsia\u030Dh bu\u0301-ku\u0304, tshin-tshiu\u0304nn tsia\u030Dh ta\u0304u-hu\u0304. ': '60121', 'kue\u0300-i\u0300': '10257', 'le\u0301-pa\u0300i': '12566', 'ta\u0304i-pia\u0301u': '01346', 'po\u0300-siau': '08303', 'pho\u0300ng': '11891', 'hong-sia\u0302': '05615', 'bia\u0301n': '02885', 'sam-pat': '00219', 'sio-tsiu\u0301-ke': '11829', 'tsu\u0304-sin': '02771', 'tshui\u0300-kha\u0301u': '08207', 'pa\u0300ng-po\u0302o': '04142', 'a-so\u0301': '04638', 'tsuan-kang': '07169', 'hu\u0302-tso\u0304o': '03177', 'ka\u0301i-tsong': '03270', 'tsi\u0302ng-po\u0300': '07285', 'kik-khui\u0300': '11790', 'su\u0302n-khua\u0302n': '08363', 'ha\u0301i-ka-tsua\u030Dh': '06203', 'tsu-sik': '04851', 'kuah-tiu\u0304-a\u0301-bue\u0301': '08262', 'tho\u0302o-sik': '09401', 'tshoo-lo\u0301o': '07794', 'tho\u0301o-bah-tsi\u0300nn': '02178', 'kia\u0300n-kua\u0300i': '03445', 'tho\u0301-mia\u0304': '06741', 'tua\u0300-ha\u0300': '07220', 'tha\u0300u-tiong-ta\u0300u': '07934', 'iu\u0302nn-to\u0302': '09629', 'be\u0301-siu': '09084', 'kut-lu\u0302n': '06903', 'lo\u030Dh-tho\u0302o-si\u0302 peh-ji\u0304 mia\u0304. ': '60328', 'tsiu\u0300nn-kia\u0302m': '12771', '--ji\u0304-po\u0304o-tshit-a\u0301': '00108', 'iu\u0302-phio\u0300': '09154', 'huan-po\u0302': '08759', 'tu\u0301-ho\u0301': '04021', 'ha\u030Dp-li\u0301': '02223', 'la\u0302n-kan': '13132', 'sia\u0304-si\u0302n': '12424', 'tn\u0301g-siann': '12678', 'tsiat-khia\u0304m': '09875', 'si\u0302ng-i\u0300': '10145', 'ka\u0300u-si\u0302': '03670', 'tsa\u030Dh hong': '10303', 'bi\u0301n-tsia\u030Dt': '07399', 'bi\u0301-sik': '02665', 'kian-tshi\u0302': '07129', 'po\u0301-hia\u0301m': '04772', 'sa\u030Dh': '09723', 'kok-kua': '07146', 'la\u0304n-sui': '13521', 'le\u030Dh-a\u0301': '07721', 'sa\u0301n-hu\u0304': '07692', 'to\u030Dh': '09008', 'phah-be\u0304': '04160', 'to\u030Dk': '05137', 'iu\u0302-la\u0301m-tshia': '10280', 'khu\u0300n': '08790', 'ka-ki\u0304 pho\u0301ng sa\u0301i buah bi\u0304n. ': '60238', 'tshi\u0300-a\u0301': '03636', 'tso\u0300-gue\u030Dh-la\u0304i': '06958', 'si\u0301-sim': '02472', 'kong-ha\u0304u': '01524', 'liu\u0300-phi\u0301-a\u0301': '10912', 'la\u0300u-sa\u0301i-tshenn': '09954', 'su-hua\u0304n--e\u0302': '05959', 'ba\u030Dk-tsiu kua\u0300 ta\u0301u-ka\u0300i, khua\u0300nn la\u0302ng mi\u030Dh to\u0304 a\u0300i. ': '60141', 'sam-sing': '00398', 'gia\u0302m kuann-hu\u0301 tshut ka\u0304u tsha\u030Dt; gia\u0302m pe\u0304-bu\u0301 tshut a-li\u0301-put-ta\u030Dt. ': '60384', 'keh-ni\u0302': '10339', 'tshoo-sio\u030Dk-mih-a\u0301': '07774', 'kam-gua\u0304n': '02037', 'kap-pha\u0304ng': '06090', 'khe\u0300-hiann': '04843', 'tshiu\u0301-ha\u0304': '00835', 'bi\u0301-ka\u0301': '02763', 'hua\u0301n-hiau': '01134', 'kia\u0300nn': '12932', 'kho\u0301o-kue': '05483', 'bio\u0304-tia\u0302nn': '11073', 'gi\u030Dk-tsu\u0301': '06709', 'te\u0304-gu\u0302-huan-sin': '02313', 'khi\u0300-ap': '06241', iok: '05381', ioh: '12331', 'pue\u0302': '08032', 'pue\u0300': '11510', 'ua\u0301n': '10891', 'bue\u0301-tsui': '03125', 'tshu\u0300-te\u0304': '05837', 'e\u0301-la\u0302ng': '09770', 'tsik-si\u0302': '03009', 'sio\u0304ng ho\u0301': '00314', 'kuan-im-tik': '13429', 'tho\u0301o-khui\u0300': '02215', 'gi\u0302 la\u0302ng, m\u0304 tsia\u0302nn tsha\u030Dt. ': '60340', 'kau-lio\u0302ng': '09049', 'ko\u0300o-tshu\u0300': '13214', 'tsha\u0300i-bue\u0301': '08970', 'u\u0304n-su': '10270', 'tsha\u0301-ke-la\u0304-the\u030Dh': '03006', 'ha\u0301i-to\u0301': '06207', 'lu\u0302n-hue\u0302': '11534', 'tsia\u0300n-ta\u0300u': '11707', 'tia\u0301nn-phi\u0301': '10396', 'siu\u0304nn-tang-siu\u0304nn-sai': '09471', 'at-a\u0301': '09611', 'ua\u0301-ni\u0302': '05756', 'ho\u0304o-kha\u0301u': '00834', 'i\u0300-gi\u0304': '09494', 'tng-bi\u0304n': '09781', 'tshiah-gu\u0302': '03421', 'a\u0302ng-tsha\u0301i': '05441', 'bu\u0302n-su': '01036', 'tsha\u0301u-meh-kong': '06626', 'tshu\u0300-kha': '05864', 'a\u0304u-kha': '04977', 'kia\u0300n-li\u030Dp': '04881', 'tia\u0304n-pio\u0301': '10374', 'si\u0300nn': '05976', 'tsha\u0301u-meh-a\u0301': '06627', 'sio\u0300ng': '05243', 'gue\u030Dh-a\u0300m-me\u0302': '01107', 'm\u0304-tsi\u0302ng-gua\u0304n': '01058', 'ko\u0301ng-khi\u0301': '12426', 'thau-iap': '07004', 'tsio-sing': '04010', 'u\u0304n-sa\u0300ng': '10237', 'phong-pha\u0300i': '12664', 'tsa\u0301-ji\u030Dt': '02471', 'a\u0304inn': '06939', 'png-a\u0301-tshiu\u0304': '09612', 'to\u0300o-tsua\u0301': '13575', 'ti\u0300-pe\u0304nn': '05425', 'li\u0301n': '05971', 'tshai-gi\u0302': '07641', 'be\u0304-sa\u0301i-tit': '06667', 'tsia\u0300nn-tn\u0300g': '01810', 'ka-pue\u0304': '01516', 'pa\u030Dt-la\u0302ng e\u0302 kia\u0301nn si\u0301 be\u0304 lia\u0301u. ': '60177', 'ma\u0304 si\u0304': '10424', 'thih-be\u0301': '13183', 'tham-lua\u0302n': '08024', 'la\u0302m-tsu\u0301-ha\u0300n': '03363', 'su-bo\u0304o': '04980', 'ian-a\u0301-hi\u0302': '09728', 'phah-tn\u0304g': '04175', 'li\u0301-kua\u0301n': '06088', 'khi\u0301-si\u0300ng-te\u0304': '06747', 'ing-a\u0301': '13298', 'so\u0300-tsui\u0301': '12248', 'tsing-senn': '10752', 'su-hueh': '11997', haih: '05824', 'khoo-si-a\u0301': '03759', 'kiunn-bo\u0301-ah': '12391', 'tsi\u030Dk-kua\u0300n': '13032', 'bo\u0302-tsi\u0302ng': '08666', 'ke\u0301-tshui\u0300-khi\u0301': '07002', 'ke-tia\u0302u': '12719', 'ka\u0300u-tsa\u0304m': '03674', 'sia\u0300nn-tu\u0301-sia\u0300nn': '09944', 'hiau-hi\u0304ng': '10426', 'tsu\u0304-khiam': '02820', 'ti\u0302n-tsi\u0302ng': '08076', 'tshi\u0301-khak-tsha\u0301u': '10403', 'kiong-li\u0301': '05919', 'thi\u0302ng-khu\u0300n': '07008', 'tshiu\u0301nn-koo': '09541', 'tsa\u0300-tua\u0302nn': '05220', 'la\u0302ng na\u0304 sue, tsi\u0300ng pu\u0302-a\u0301 senn tsha\u0300i-kue. ': '60045', 'tsha\u030Dk-a\u0301': '13451', 'kong-ki\u0301ng': '02091', 'jia\u0301-su\u0304': '09470', 'io\u0302': '11280', 'io\u0301': '03165', 'ah-a\u0301': '12129', 'tha\u0300u-tsa\u0301': '07953', 'ke-jiu\u0302': '12748', 'sio\u0301-kia\u0301nn': '00312', 'thiah-thui\u0301': '04150', 'hui\u0300-khi\u0300-hui\u0300-tak': '09104', 'iau-sa\u0302i': '05134', 'huan-sin': '12595', 'tia\u0304n-hue\u0301': '10330', 'tsing-thong': '10763', 'ko\u0301o-tsheh': '01459', 'li\u0301-hui\u0300': '06069', 'tua\u0304-m\u0301': '00358', 'li\u0302ng kau li\u0302ng, ho\u0304ng kau ho\u0304ng, u\u0301n-ku--e\u0302 kau to\u0300ng-go\u0304ng. ': '60361', 'lo\u0300-kha-a\u0301': '13486', 'sin-mia\u0304': '03444', 'ka\u0301i-kuat': '10041', 'be\u0301 tshu\u0300, be\u0301 tshu\u0300-pinn. ': '60307', tsih: '10558', 'siong-tia\u0300m': '07063', tsik: '11845', 'si\u0300ng-tsit': '03941', tsim: '05826', 'bu\u0304n-bu\u0304n': '08358', tsio: '03983', 'sat-sing': '07505', tsia: '11514', 'khan sai-a\u0301': '07623', 'a\u0301u-po\u0302o': '04141', 'bo\u0302-ba\u0304ng': '08667', 'm\u0304 si\u0304': '01000', 'to\u0304ng-kiu\u0302': '11109', 'sa\u0300u-tshiu\u0301-tshenn': '07376', 'tsik-tik': '11854', 'jia\u030Dp': '00799', 'tsi\u0301ng-kah-hue': '05026', 'tshoo-tha\u0301ng': '07782', tsit: '12793', 'sio\u0301-mue\u0304': '00361', 'ia\u0304-ki\u0301ng': '03812', 'pah-hue\u0300 kong-si': '02744', 'i\u030Dk-king-a\u0301': '06227', 'si\u0300-khoo-ui\u0302-a\u0301': '01601', 'kin-te\u0301': '06130', 'kia\u0300n-siat': '04894', 'kau-kuan': '02107', 'so\u0300o-tsn\u0304g': '09029', 'tshu\u0300-ti\u0301ng': '05858', 'ia\u0304m': '04334', 'hia\u0300n ke\u0300': '13016', 'ti\u0300ng': '06812', 'khui-lo\u0304o': '09223', 'sia\u0302u': '11218', 'te\u0301-se\u0300': '03863', 'ia\u0304-si\u0304': '00393', 'kia\u0301u-kha': '08906', 'tshiu\u0301-pua\u0302nn': '01159', 'si\u0301-lo\u0304o-po\u0302ng': '02560', 'huan-a\u0301-mua': '08728', 'ko\u0301ng': '12404', 'nia\u0301u-tshi\u0301-a\u0301-uan': '08155', 'tsi\u030Dt-tiap-a\u0301-ku\u0301': '00039', 'sia\u0302n': '12626', 'ka\u0300ng-li\u0302m': '05576', 'sia\u0302m': '08315', 'ha\u0300m-ha\u0300m': '12930', 'tshian-ba\u0304n': '00479', 'bue\u0301-ta\u0302ng-kut': '03114', 'thua\u0301nn': '09320', 'te\u0304-ka\u0300i': '02354', 'kha-kiu\u0302': '10139', 'tsi\u0302nn-kuan': '12062', 'ga\u0304m-bi\u0304n': '11634', 'ngo\u0302o-to\u0302ng': '07517', 'pue\u0301-tshiu\u0301-bi\u0304n': '08391', 'la\u0304u-su': '02712', 'ku\u0302n': '13567', 'gu\u0302-kak': '01253', 'too-tshi\u0304': '08059', 'siong-hue\u0304': '05296', 'hue-hue--a\u0301': '04463', 'hiann-ti\u0304 na\u0304 ka\u0304ng sim, oo-tho\u0302o pia\u0300n-si\u0302ng kim. ': '60118', 'bu\u0301-io\u0301ng': '11174', 'si\u0302n-tsu\u0301-pa\u0302i-a\u0301': '06457', pih: '13289', pik: '10176', pio: '12933', 'siap-tshiu\u0301-pha\u0304ng': '11056', 'it-ta\u0300n': '00014', 'oo-mua\u0302-iu\u0302': '06307', 'ngiu\u0301 kha-tshng': '03174', 'tshiu\u0304-ki': '11748', 'pinn--a\u0301': '12911', 'ka\u0304u-ue\u0304': '04826', 'tsiah-si\u0304': '00394', 'ti-bo\u0301': '11440', 'tah-i\u0300ng': '08918', 'tinn-bi\u030Dt': '07702', 'gi\u0302ng': '11626', 'nge\u0304-ta\u0301u': '08835', 'po\u030Dk-ho\u0302': '12358', 'ti\u0302n': '12870', 'ti\u0302m': '03296', 'sio-sia\u0300-ta\u0304i': '05261', 'bu\u0302-huat-bu\u0302-thian': '08638', 'sio\u0304ng-thian': '00256', 'king-gia\u0304m': '09881', 'm\u0304 bat': '01031', 'la\u0304m-su\u0301': '12251', 'tsui\u0301-thuah': '01204', 'tia\u0304n-lo\u0302o': '10385', 'ta-lia\u0304u': '08653', 'pe\u030Dh-pe\u030Dh po\u0300o ni\u0301 kah oo. ': '60135', 'po\u0301-tio\u0304ng': '04745', 'kui\u0301-si\u0302n': '06875', 'siang-tha\u0302u': '12763', 'ke\u0301-kui\u0301-ke\u0301-kua\u0300i': '06996', 'gia\u0302-ke\u0302': '01745', 'tshiau-kue\u0300': '09116', 'siu\u0301nn-hua\u030Dt': '11495', 'ha\u0302 ku\u0302n': '11882', 'si\u0301-tsua\u0302nn': '02509', 'te\u0304nn': '06017', 'tsu\u0301n-sn\u0300g': '09704', 'pe\u030Dh-tsha\u030Dt-tshit--a\u0301': '01998', 'tsheh-pa\u0302ng': '01343', 'ha\u0300inn-tshian-tshiu': '09448', 'sia\u0301u-tham nn\u0300g ke-lam. ': '60257', 'a\u0302ng-ba\u030Dk-ki\u0302nn': '05409', 'tia\u0301n-ui': '05941', 'bi\u0304n-phue\u0302': '05604', 'tua\u0304-la\u030Dt': '00223', 'tsui\u0301-tsu\u0300n': '00911', 'sue\u0302-king': '04810', 'hioh-a\u0300m': '09695', 'tiong-ta\u0300u-si\u0302': '00723', 'i\u0300-kia\u0300n': '09468', 'si\u0300n-to\u0302o': '04748', 'king-tha\u0302u': '04489', 'pia\u0304n-ho\u0304o': '13201', 'sio\u0301-ba\u030Dk': '00270', 'ki\u030Dp-keh': '01034', 'te\u0301-ti\u0300': '03872', 'tshah-hue-a\u0301': '08401', 'beh ho\u0301-gia\u030Dh ta\u0301n a\u0304u-si\u0300, beh tso\u0300-kuann o\u030Dh tso\u0300-hi\u0300. ': '60271', 'sua-hi\u0302-ian': '12800', 'tia\u0300u tua\u0304-ta\u0302ng': '02144', 'siu\u0304-ku': '10468', 'lia\u0304m-tsiu\u0300': '03918', 'ti\u0302ng-su\u0302n': '05536', 'tho\u0300o-hueh': '02177', phiah: '12445', 'tshut-tsoo': '01530', phian: '06935', 'tsho\u0300-tshiu\u0301': '12031', 'tsi\u0301ng-tha\u0302u-bu\u0301-kong': '05071', phiau: '13078', phiat: '13535', 'to\u0302': '06702', 'to\u0300': '05726', 'to\u0301': '05908', 'to\u0304': '10186', 'siong-ho\u0301': '05255', 'a\u0300m-pan': '09630', 'lo\u0304o': '13513', 'ti\u030Dt-a\u0301': '04845', 'sin-kho\u0301o': '03458', 'pa\u030Dt': '02961', 'io\u030Dh-tsui\u0301': '12876', 'hun-thuann': '00778', 'pia\u0304n-io\u030Dh-a\u0301': '04704', 'pa\u030Dk': '13479', 'phi\u0302-phi\u0302': '01891', 'tshing-tsiu\u0301': '07572', 'mn\u0302g-kha-kha\u0301u': '04643', 'bo\u0302 mo\u0302o ke ke\u0301 tua\u0304-keh. ': '60294', 'ti\u0304ng-tsue\u0304': '03871', 'ka\u0301nn-si\u0301': '08461', 'hue\u0300-tha\u0302u': '08015', 'e-hng-a\u0300m': '00374', 'a\u0302n': '08857', 'pih-tsah': '11110', 'sia\u0304-tha\u0302u': '04426', 'kiu-tsui\u0301': '00629', 'kua\u0301nn-lo\u0304o': '10879', 'gi\u0304m': '03160', 'gi\u0304n': '08595', 'ba\u0301i-ka\u0302u': '13556', 'ta\u0304u-tha\u0302u': '03517', 'tshio\u0300-hai-hai': '06463', 'pe\u0304nn-la\u0302ng': '06366', 'ka\u0301i-u\u0304n': '03272', 'ko\u0300o-mn\u0302g': '13211', 'a\u0304u-ji\u030Dt': '04930', 'to-su\u0304': '02342', kut: '06824', 'pa\u0300ng-phui\u0300 an ka\u0301u sim. ': '60188', 'tsi\u0300n-kha\u0301u': '09133', kun: '05513', 'so\u0300o-ha\u030Dk': '11175', 'ha\u0300inn-tha\u0302u-a\u0301': '09447', kui: '07869', 'tsiu\u0300-me\u0304': '03760', kue: '01847', kua: '10595', 'gua\u0302n-ui\u0304': '05840', 'tshenn-sik': '04551', 'hit-tha\u0302u': '03943', 'lo\u030Dh-tsui\u0301': '09913', 'sann tn\u0300g': '00500', 'tui\u0304': '09178', 'ho\u0304o-li\u0301': '13187', 'ta\u0304u-ti\u0302n': '03527', 'sio-hiunn': '11823', 'nn\u0301g-kio\u0304': '08021', 'tsi\u030Dt-pua\u0300nn-ji\u030Dt-a\u0301': '00012', 'tsi\u030Dt ku\u0300 ue\u0304 sann kak la\u030Dk tsiam.': '60014', 'khia-so\u0300o': '03818', 'tsui\u0301-mn\u0302g': '00992', 'put-tsa\u0302i': '00602', 'khia\u0300m tsi\u0302nn ua\u0300n tse\u0300-tsu\u0301, put-ha\u0300u ua\u0300n pe\u0304-bu\u0301. ': '60107', 'tshian-kim-pho\u0301o': '00383', 'po\u0301o-thiam': '10054', 'tshau-sia\u0301': '03273', 'tio\u0302ng': '05518', 'tse\u0300-ho\u030Dk': '03659', kiunn: '12381', 'si\u0300': '01418', 'kua\u0302n': '12998', 'senn-ue\u0304': '01995', 'it tshia\u0302n, ji\u0304 ia\u0302n, sann sui\u0301, si\u0300 sia\u0300u-lia\u0302n. ': '60031', 'ba\u0304n-tshia': '10544', 'khia\u0304-ba\u0302i': '07275', 'tah-ke\u0300': '09546', 'ui\u0300-kua\u0302nn': '05292', 'a\u030Dh-tio\u030Dh': '05056', 'tshut-ke\u0300': '01574', 'tshiam-mia\u0302': '12856', 'tshue\u0304': '08434', 'tshue\u0302': '11281', 'tshue\u0301': '13315', 'tiu\u0304nn-la\u0302ng-kong': '00227', 'gu\u0302-a\u0301-kho\u0300o': '01236', 'pua\u030Dh tsi\u030Dt to\u0301, khioh-tio\u030Dh tsi\u030Dt tsiah kim ke-bo\u0301.': '60311', 'thuh-tsha\u0300u': '12497', 'u\u0304-hue\u0300': '02551', 'ke-ue\u0304': '01586', 'i\u0300-ji\u0302n': '12385', 'pak-kua\u0301n': '01598', 'pa\u0304n': '11982', 'ji\u0302n-gi\u0304': '00756', 'sng-su\u0301n': '10924', 'be\u0304-mia\u0304': '11457', 'li\u0304-io\u0304ng': '02992', 'pha\u0301inn-tsik-tik': '01173', 'sin-ki\u0302': '09540', 'phua\u0304nn-tsa\u0300u': '02924', 'tan-tia\u0302n': '00649', 'tann-a\u0301': '00637', 'kue\u0300-hun': '10189', 'tsio\u030Dh-kha\u0301m': '01909', 'huan-a\u0301-hue\u0301': '08726', 'he\u0302-a\u0301': '11367', 'khui\u0300-kha\u0301u': '06179', 'ko\u0301o-pu\u0301n': '04447', 'tua\u0304-koo': '00360', 'kua\u0304nn': '02594', 'tu\u030Dt-jia\u0302n': '05365', me: '09511', 'a\u0300m-ho\u0301ng': '09639', 'thui\u0302-thui\u0302': '10626', 'bo\u030Dk-mi\u0302': '01085', 'tshoo-it': '03626', 'sann-kak-thang': '00342', 'phu\u0300n-tsui\u0301-ti\u0302': '11020', 'ki\u0301n kia\u0302nn': '10794', 'sioh hue lia\u0302n phu\u0302n, thia\u0300nn kia\u0301nn lia\u0302n sun. ': '60266', 'tshui\u0300-ko\u0302o-ko\u0302o': '09828', 'sia\u0302nn-tshi\u0304': '04848', 'kik-ngo\u0301o-ji\u0302n': '11776', 'si\u0301-so\u0302': '02566', 'tia\u0301n-le\u0301': '03696', 'sio-sa\u0300ng': '05285', 'thong-po\u0300': '07990', 'su-bu\u0302n': '08456', 'kui-ni\u0302-tha\u0300ng-thinn': '07883', 'pha\u0301inn-sim': '00863', 'khua\u0301n': '08544', 'khang-tha\u0302u': '04427', 'si\u0302-si\u0302-khik-khik': '06050', 'pit-hu\u0302n': '13597', 'tho\u0301o-bo\u030Dk': '00263', 'li\u030Dk-lio\u0304ng': '00151', 'liu\u0301 liu\u0301-a\u0301': '09218', 'kua-bu\u0301-thua\u0302n': '10630', 'huan-tia\u0301m': '12618', 'hong-tia\u0302u': '04893', 'khit-tsia\u030Dh-tha\u0302u': '00410', 'lua\u0304n-ko\u0301ng': '09375', 'tu\u0302-pa\u0302ng': '11068', 'put-gi\u0304': '00755', 'tuann-sin': '08287', 'ta\u0300': '09842', 'gui\u0302-kip': '02204', 'tha\u0300u-a\u0300m': '07996', 'tui\u0300-put-tsu\u0304': '10482', 'go\u0304': '11570', 'go\u0304ng-tua\u0304-tai': '13450', 'go\u0302': '12794', 'tshi\u0304': '10319', 'kho\u0301ng-kha\u0300i': '10549', 'tshi\u0302': '09670', 'tshi\u0301': '10389', 'tshi\u0300': '10030', tsing: '13076', 'tshing-sia\u0300u': '07588', tsinn: '10727', 'ta\u0304i-pa\u0304n': '01382', 'pha\u0301inn-tsia\u030Dh': '01016', 'iau-tsiann': '03133', 'o\u0300-gio\u0302': '12372', 'ba\u0301n-tho\u0302': '12972', 'thia\u0300u-ka-kuan': '10202', 'pa\u0300i-tn\u0302g': '04969', 'tia\u0304n-kong': '10336', 'tsio\u030Dh-pang': '01917', 'm\u0304': '00818', 'pe\u030Dh-tsho\u0300o': '02018', 'm\u0301': '03777', 'su\u0300-thong-pat-ta\u030Dt': '01551', 'ta\u030Dh-ta\u0301u': '11437', 'lok-a\u0301': '11741', 'tsha\u0300i-tsi\u0302m': '09003', 'ha\u0301i-tsha\u0300i': '06223', 'tua\u0304-gi\u0302n': '00512', 'hoo-im': '03735', 'khuann-khuann-a\u0301-si\u0304': '11080', 'tsu\u0304-tsok-gia\u030Dt': '02670', 'po\u0301o': '10024', 'sio-tio\u030Dh': '11831', 'khan-si\u0302ng': '07612', 'sio-bah': '11820', 'tsha\u0300u-ia\u0304ng': '06618', 'sio-bat': '05283', 'tshut-pa\u0301n': '01496', 'khin-kho\u0301': '10904', 'tshenn-tshui\u0300': '04651', 'ko\u0300ng-hia\u0300n': '06808', 'ki\u0302-pua\u0302nn': '08536', 'hong-i\u0301ng': '05654', 'that-to\u0301-ke': '07729', 'tui\u0300-tsia\u0300u': '10514', 'gia\u0302m-lo\u0302-o\u0302ng': '12061', 'tsim-tshui\u0300': '05859', 'pa\u030Dt-ji\u030Dt': '02988', 'hia\u0302u-hue': '11070', 'gua\u0304': '01420', 'ni\u0302-tang': '02316', 'ng-a\u0301': '06454', 'ba\u0301n-bi\u0304n': '06047', 'bi\u0304n-kin': '05594', 'ha\u0301i-tua\u0300': '06216', 'tshut-tho\u0301o': '01429', 'ka\u0301n-tan': '12610', 'io\u0302ng-i\u0301n': '05922', 'tshn\u0301g': '02976', 'phah-thih': '04186', 'thua\u0302n-i\u0302nn': '10466', 'tshit-tshenn': '00121', 'kiat-sia\u0300u': '08914', 'ia\u0304 ng-a\u0301': '07391', 'tshuan-tshit': '00225', 'bo\u0301o-mi\u0301-la\u0302ng': '05095', 'ji\u0304-u\u0304n': '02404', 'tang-to\u0301-sai-uai': '04242', 'ka\u0301ng-lo\u0304o': '08581', 'pi\u0302n': '11671', 'ia\u0301n-gi\u0304': '10666', 'u\u0304-thong': '02537', 'su\u0302n-jia\u0302n': '06540', 'gua\u0302n-te\u0301': '05846', 'jia\u0302n-a\u0304u': '08641', 'sua\u0300--lo\u030Dh-khi\u0300': '07790', 'gia\u030Dp-tse\u0300': '09645', 'la\u0300u-kho\u0300o': '09994', 'liu\u0300-phue\u0302': '10906', tshiu: '13282', tshit: '04923', 'kang-ge\u0304': '00560', 'inn-ti\u0302nn': '13305', 'beh-si\u0301-beh-ua\u030Dh': '07507', 'tsha\u0301u-keh-a\u0301': '06644', tshia: '03408', tshio: '13529', tshin: '11935', tshim: '07533', tshik: '08851', tshih: '13519', 'hong-kua\u0300n': '05708', 'the\u0300-tia\u0304nn': '06744', 'kue\u0300-si\u0302 be\u0304 la\u030Dh-ji\u030Dt. ': '60331', 'gia\u030Dh-tha\u0302u': '13145', 'i\u0300m-sin': '11370', 'bi\u0302ng-ko\u0301ng': '04263', 'tio\u030Dh-tsha\u030Dt-thau': '09044', 'gi\u0304-ua\u0302n': '13060', tsiong: '07711', 'kio\u0302-a\u0301-sik': '05480', 'na\u0304i-tsi': '06669', 'to\u0304o-peh-a\u0301': '03246', 'lio\u030Dk-su': '00709', 'po\u0301-ue\u0304': '04767', 'sa\u0301i-si\u0300ng-te\u0304': '03566', 'pia\u0304n-pia\u0304n': '04693', 'huat-ho\u0302ng': '08781', 'tsha\u0302-tsha\u0301u': '06146', 'pha\u0301inn-si\u0301': '00916', 'sit-gia\u030Dp': '01798', 'the\u0301-io\u030Dk': '13332', 'ang-a\u0301-bo\u0301o si\u0304 sio-khia\u0300m-tse\u0300 . ': '60248', 'ah-bo\u0301-tshui\u0300': '12133', 'tsha\u0300ng-tshiu': '12380', 'tsua\u0304n': '12656', 'khan-tshiu\u0301': '07605', 'la\u0302m-iu\u0302nn': '04743', 'ka\u0304-tshui\u0300-khi\u0301-kin': '04823', 'kiu\u0301-gio\u0301ng': '00307', 'tsua\u0302nn': '05140', 'to\u0300-bi\u0304n': '05765', 'to\u0300-tha\u0302u-kia\u0302nn': '05798', 'mui\u0302-to\u030Dk': '07478', 'e\u0304-tso\u0300-tit': '09632', 'pe-pn\u0304g': '01794', 'kha-ta\u0301u': '10096', 'tik-a\u0301-ki': '02647', 'ji\u0302n-tsu\u0302': '00753', 'tsu\u0302n-ki\u0302': '07825', 'huat-hui': '08767', 'tsiunn-se\u0301': '11202', 'sia\u0300-tso\u0301o-kong': '03673', 'ha\u0301i-kha\u0301u-khiunn': '06182', 'siu\u0302': '04274', 'siu\u0301': '02290', 'siu\u0300': '12064', 'a-peh': '04555', 'siu\u0304': '03829', tok: '07041', 'khioh-ka\u030Dk': '04084', 'pe\u0302nn-poo-huan': '01753', 'la\u0302ng-kheh': '00119', 'ia\u0301n-to\u0301': '06992', 'kui\u0301-a\u0301': '06837', 'hi\u0304nn-khang-khin': '02697', 'tia\u0300u-kia\u0300nn': '01638', 'bo\u0302-ta-ua\u0302': '08632', 'tsu\u0300-bu\u0302n': '04350', 'be\u0302-si\u0300n': '06752', 'oo-se': '06275', 'ngo\u0301o-ji\u0302n': '00609', 'hong-tshang': '05686', 'ke\u0301-sia\u0301u': '07006', 'hia\u0304n-tshu\u0301-si\u0302': '07613', 'kua\u0300i-la\u0302ng': '03904', 'khia\u0300u-khia\u0300u': '12619', 'tue\u0300-hue\u0304-a\u0301': '10807', 'hn\u0304g': '10890', 'ua\u0301-ta\u0300u': '05775', 'khi\u0300-se\u0300': '07503', 'kui\u0301-tha\u0302u-kui\u0301-na\u0301u': '06912', 'tui\u0300-khua\u0300nn': '10502', 'ta\u0304i-lio\u0304ng': '00467', 'tsiu\u0304nn-siap-be\u0304-liap': '00293', 'ha\u0304-san': '00234', 'sat-tshiu\u0301': '07500', 'na\u0301u-pi\u0302n-hiat': '09975', 'kua-a\u0301': '10609', 'ia\u0302m': '13389', 'ia\u0302n': '10287', 'mua\u0302-phia\u0300n': '11855', 'pi\u0301ng': '00790', 'tsu\u0304-iu\u0302': '02660', 'hun-tsing': '00777', 'khui-khuah': '09236', 'lo\u0302-to\u0304ng': '08240', 'pi\u0301nn': '04920', 'thi\u0300ng-ha\u0304u': '13274', 'ua\u0302n-kiat': '03123', 'sio\u0300ng-tshin': '05310', 'tsia\u0300n-lua\u0304n': '11715', 'ki\u0304n suann tsho\u0300 bo\u0302 tsha\u0302, ki\u0304n khe tann bo\u0302 tsui\u0301. ': '60194', 'thiu-sue\u0300': '04121', 'tshing-khi\u0300-siu\u0300nn': '07569', 'hun-phue\u0300': '00714', 'bo\u0302-ta\u0304i-bo\u0302-tsi\u0300': '08613', 'ba\u0301ng-tha\u0302ng': '13075', 'i\u0300n-sik': '02175', 'khoo-tuann': '03748', 'ko\u0300o-tsiong': '05066', 'si\u0304ng ti gia\u0302 tsa\u0300u, si\u0304ng kia\u0301nn put-ha\u0300u. ': '60234', 'pua\u0300nn-la\u0302u-a\u0301': '01613', 'siann-im': '12350', 'iu\u0300-kut': '01763', 'phu\u0300n-tia\u0301m': '11033', 'ha\u030Dp-huat': '02197', 'liu\u0301-ting': '05094', 'sin-niu\u0302-pa\u0302ng': '09553', 'e\u0302-pue\u030Dh-a\u0301': '11585', 'sia\u0300u': '11139', 'tshut-ke': '01518', 'phua\u0300nn-tua\u0300n': '03025', 'sia\u0300m': '10597', 'sia\u0300n': '09516', 'tshi\u0301ng-ka\u0300u': '11480', 'thia\u0301n': '05906', 'thia\u0301m': '03894', 'ku\u0304': '12587', 'to\u0300-sia\u0300ng-hia\u0300nn': '05785', 'ku\u0301': '00181', 'ku\u0300': '01407', 'tshenn-ki\u0302': '04609', 'khia\u0300m': '00815', 'khia\u0300n': '04440', 'u\u0304-hi\u0304nn-bo\u0302-tshui\u0300': '02491', 'io\u0302 la\u0302ng bo\u0302-tsa\u0302i, io\u0302 ti bo\u0302 tha\u0302i. ': '60371', 'lua\u0304n-su\u0301': '09344', 'tsa\u030Dp-ji\u0304 senn-siu\u0300nn pia\u0300n-tha\u0300u-tha\u0300u. ': '60055', 'pa\u030Dt-khua\u0301n': '03017', 'li\u0302ng-tsu\u0302n': '12142', 'be\u0304-tit kue\u0300': '06677', 'thian-tsa\u0302i': '00832', 'lia\u0301u-lia\u0301u': '00067', 'tia\u0301nn-kua\u0300': '10400', 'tsha\u0302i-ho\u0302ng': '09050', 'khia\u0300u': '12583', 'a\u0302ng-tsha\u0300i-tha\u0302u': '05437', 'kau-o\u0301ng': '02073', 'sio\u0304ng-ti\u0301ng': '00461', 'thang-a\u0301-mn\u0302g': '08804', 'hui\u0300-khi\u0300': '09103', 'ke-a\u0301-ba\u030Dk': '12703', 'kok-tsi\u030Dk': '07156', 'hua\u0300n-a\u0301-pe\u030Dh': '07946', 'oo-so\u0302-so\u0302': '06329', 'sat-pi\u0300n': '11378', 'ba\u030Dk-tsiap': '11023', 'kho\u0301-kho\u0300': '01616', 'sai-to-tsi\u030Dh': '02846', 'ko-tshiu\u0301': '06833', 'hua\u0300-gia\u0304m': '01218', 'po\u0301o tshui\u0300-khi\u0301': '10058', 'tsu-po\u0301': '06392', 'tn\u0302g-sann': '04588', 'ti\u0300m': '07318', 'ti\u0300n': '12688', 'thio\u0300ng': '10568', 'ba\u030Dk-tsiam': '01947', 'senn-sian': '02002', 'kia\u0300n-ka\u0301i': '03493', 'po\u0300o-ki\u0301ng': '01783', 'gu\u0302-ling': '01238', 'sio-ku\u0301n-ku\u0301n': '11835', 'sit-tha\u0302u': '12574', 'the\u0302-tshin': '08423', 'hi\u0302ng-hua\u030Dt': '02250', 'su\u0304-a\u0304u': '03569', 'gi\u0304': '09846', 'gi\u0302': '10681', 'gi\u0301': '10850', 'tsu-sa\u0301n': '10140', 'pue\u0302-tue\u0300': '08092', 'tshui\u0300-kak': '08222', 'hu\u0300-pu\u0301n': '06967', 'ti\u0302nn-sin': '13154', 'pia\u0300nn-sio\u030Dk': '04060', 'ta\u0300m-ke\u0304': '10955', 'ho\u0300nn-sik': '02332', khing: '10938', 'ku-kha so\u0302--tshut-la\u0302i. ': '60363', 'ji\u030Dt-gua\u030Dt-ham': '00868', 'tso\u0301o-to\u0300ng': '04659', 'in-ko\u0301': '02196', 'hia\u0304n-si\u030Dt': '07640', 'ua\u0302n-kiat-phinn': '03124', 'ki-pu\u0301n': '07113', 'sam-sim-lio\u0301ng-i\u0300': '00274', 'ma\u0304 beh': '10430', 'tiau-ko\u0300o-i\u0300': '00124', 'tha\u0300i-pe\u030Dh-hu\u0301n': '00892', 'sua\u0301nn-phio\u0300': '08479', 'kong-hn\u0302g': '00748', 'pia\u0300n-sim': '13321', 'sian-ti': '02077', 'tsi\u0301--a\u0301': '03787', 'bi\u0304ng-te\u0302': '03764', 'tshiu\u0301-tha\u0302u': '01177', 'jio\u0304ng-to\u0304o': '13379', 'tah-kau-a\u0301': '09574', 'hia\u0300n-ki\u0300ng': '13017', 'tsia\u0302nn gue\u030Dh-ji\u030Dt': '02473', 'sio\u0301-gi\u0302n': '00513', 'o\u0302ng': '01229', 'tsia\u030Dh-pho\u0300ng-pia\u0301nn': '05692', 'io\u030Dh-phoh': '12890', mua: '10477', 'kong-tshin pia\u0300n su\u0304-tsu\u0301. ': '60097', 'phoh-si\u030Dt': '02564', 'bu\u0300n-tshi\u0301': '12502', 'hiam-tsio-a\u0301': '12393', 'u\u030Dt': '11984', 'tha\u0301i-ko-nua\u0304-lo\u0302': '13129', 'tsat-me\u030Dh': '09859', 'khe\u0300-kia\u0301nn': '04850', 'bue\u0301-ge\u0302': '03083', 'ta\u0301n--leh': '08883', 'lo\u0304o-pinn-ta\u0300nn-a\u0301': '10278', 'ko\u0301ng-ke\u0300': '12439', 'si\u0300ng-phiah': '03947', 'ti\u0304': '10723', 'thau-kang-kia\u0301m-lia\u0304u': '06952', 'ti\u0300': '10007', 'tia\u0302u-kia\u0304nn': '07506', 'ti\u0302': '06818', 'to\u0300-thiap': '05778', 'lia\u030Dh-ku-tsa\u0301u-pih': '07438', 'pi\u0300nn-bi\u0304n': '13338', 'ui-hia\u030Dp': '04855', 'thih-thui\u0302': '13192', 'khua\u0300nn-la\u0302ng-bo\u0302': '05335', 'khua\u0300n-sia\u0304n': '12991', 'pua\u0300': '12841', 'khong-kha\u0301m': '07291', 'tsa\u0301-sa\u0301n': '02536', 'be\u0302-lua\u0302n': '06809', 'ti-tu-ba\u0304ng': '10844', 'ha\u0302ng': '05521', 'tshenn-kiann': '02045', 'a\u0300i': '09456', 'a\u0300n': '06112', 'a\u0300m': '09594', 'gia\u0302n-su\u0302': '03489', 'ho\u0302o-si\u0302n-thi': '05462', 'hueh-sik': '02667', 'sa\u0300n-tsia\u030Dh-la\u0302ng': '08470', 'kim-tsua\u0301': '04608', 'ti\u0304-la\u0304ng': '10778', 'tu\u0301 beh': '04105', 'hue\u0302-siu\u0304nn': '03730', 'a\u0300u': '10641', 'a\u0300m-bi\u0302n-bong': '09631', 'kha-ta\u030Dh-tshia': '10159', 'la\u030Dt-tha\u0302u': '00164', 'ki-kuan': '11767', 'uan-o\u0301ng': '05761', 'senn-lo\u0304o': '02001', 'ti\u0304-lia\u0302u': '04321', 'siu-a\u0301m': '02503', 'a\u0304u ko\u0300 gue\u030Dh': '04963', 'ha\u0300u-ki\u0300ng': '03128', 'king-kah-tha\u0302u': '04466', 'tshin-tshiat': '11945', 'kia\u0301u-pu\u0301n': '08871', 'tui\u0300-bi\u0304n': '10503', 'tshenn-soo': '01955', 'ling-phe\u0300-a\u0301': '01736', 'kua\u0300i': '03899', 'bo\u0302 thang tshinn tsia\u030Dh, na\u0301 u\u0304 thang pha\u030Dk-kuann. ': '60299', 'kua\u0300n': '13364', 'la\u0301m-nua\u0304': '06689', 'niau-tha\u0302u-tsia\u0301u': '11977', 'u\u0304-si\u0302-u\u0304-tsu\u0304n': '02519', 'tsui\u0301-gu\u0302': '00873', 'tio\u0301ng-la\u0302m': '04560', 'si\u0300-pi\u0302ng': '01454', 'po\u0301-kia\u0300m': '12995', 'hiam-kiunn-a\u0301': '12400', 'ko\u0301o-ki\u0301': '05110', 'tsha\u0302n-tia\u0304n': '01907', 'pi\u0302ng-ti\u0301ng': '01789', 'ji\u0302n-bo\u0304ng': '00145', 'si\u030Dp-kua\u0300n': '07792', 'king-the\u0301': '03593', 'iap-thiap': '13638', 'kin-ki\u0300': '06162', 'hu\u030Dt-tshiu\u0301-kue': '02898', 'tsa\u030Dp-se\u0300': '12739', 'kua\u0301n-khu--e\u0302': '10760', 'bah-liu\u0302': '02799', 'sik-ti\u0304': '02803', 'sio-ka\u0300n': '05272', tiong: '03895', 'tsu\u0301n-tso\u0300': '09688', 'ta\u0300u-pang-tsa\u0304n': '06914', khng: '12282', khiang: '05808', 'phah-thih-a\u0301-kho\u0300o': '04188', 'ke-po\u0302': '05944', 'khai-huat': '09213', 'ki\u0302-kha\u0301': '03789', 'sit-lua\u0302n': '01841', 'lo\u030Dk-hn\u0302g': '11168', 'tsa\u0301u-tsing': '03502', 'khi\u0304-kue\u0301': '05131', 'ba\u030Dk-sik': '01904', 'ap-li\u030Dk': '12181', 'la\u0304u-to\u0300-kiu': '02711', 'tshe\u0300-khi\u0304': '06596', 'ka\u0301u-khang': '04365', 'la\u0302u-ti\u0301ng': '11207', 'tho\u0301o-sai': '00417', 'khui-io\u030Dh-a\u0301': '09238', 'tshut-khui\u0300': '01526', 'ban-a\u0301': '05926', 'tsu\u0302n-tsu\u0301': '07814', 'la\u0302u ba\u030Dk-sa\u0301i': '05200', 'pn\u0304g-le\u0304': '09310', 'oo-thinn-a\u0300m-te\u0304': '06263', 'ki-tok-ka\u0300u': '07144', 'to\u0302o-te\u0304': '05983', 'iu\u0301-ha\u0300u': '02494', 'lo\u0302ng-tsok-bu\u030Dt': '10214', 'pau-ho\u030Dk-a\u0301': '01569', 'khat-a\u0301': '13590', 'phah-kiu\u0302': '04107', 'ue\u0304-ho\u0301o-la\u0304n': '10118', 'tsu\u0301n-pi\u0304': '09691', 'ah-bi\u0302-a\u0301': '12136', 'ti\u0302ng-a\u0301-kha': '04687', 'tshun-tn\u0302g-tshiu\u0301': '02920', 'tshun-ka\u0301': '05048', 'khua\u0300nn-i-sing': '05376', 'na\u0301 e\u0304': '05863', 'hong-song': '05703', 'suh ling': '07504', 'ha\u0300n-bu\u0302n': '10648', 'tsi\u0301m-po\u0302': '12530', 'lia\u030Dh-sua-kin': '07367', 'ka\u0304u-le\u0301-so\u0300o': '04831', 'jia\u0302u-mia\u0304': '13081', 'ko-le\u0302-sim': '06925', 'io gi\u0301n-a\u0301': '03372', 'tsi\u030Dt ji\u030Dt thi\u0300-tha\u0302u, sann ji\u030Dt ia\u0302n-ta\u0302u. ': '60010', 'tha\u0302u-khi\u0301-sing': '12101', 'se\u0301-sann': '05162', 'pho\u0301-lio\u030Dk-a\u0301': '10967', 'bo\u0304ng-te\u0304': '10452', 'to\u0302ng-tsi\u0302ng': '02219', 'tse\u0302-tsua\u0302n': '10979', 'tu\u0302-hui': '06863', 'hui\u0300-tsi\u0301': '11055', 'ta\u0301u-ka\u0300i': '01108', 'lia\u0302m-tho\u0302o': '12500', 'khai-i\u0304ng': '09195', 'tsio\u0301ng': '10714', 'gua\u0304-ke': '01523', 'pho\u0304o-a\u0301-tsua\u0301': '12855', 'tua\u0304-niu\u0302-koo': '00415', 'sa\u0301i-tha\u0301ng': '04891', 'tshit tse\u0304 peh pe\u0302 ka\u0301u huat-ge\u0302. ': '60036', 'kah-phue\u0304': '10829', 'tui\u0304-lo\u030Dh': '11027', 'tsua\u030Dt-bo\u0304ng': '08897', 'nn\u0301g-si\u0300m-si\u0300m': '07932', 'pho\u0304-khia\u0300m': '04145', 'tshik-tshenn': '08882', 'pat-sian': '00087', 'tsho\u0300-go\u0304o': '12054', 'siong-ha\u0304i': '09355', 'sua\u0304n-siah': '06751', 'pa\u0304n-sian': '03172', 'tsia\u030Dh-hun': '05705', 'ki\u0300ng-tsiu\u0301': '09557', 'bi\u0304-tshai': '12429', 'the\u0301-hue\u0304': '13351', 'hun-pha\u0300i': '00690', 'pia\u0300nn': '08438', 'pah-po\u0304o-tsua\u0302': '02674', 'pia\u0300ng': '06698', 'tsing-lu\u0304n': '04382', 'khing-a\u0301': '08866', 'ju\u0302-la\u0302i-pu\u030Dt-tso\u0301o': '02343', 'a\u0302ng-kam': '05449', 'tn\u0302g-hue\u0300-siu\u0304': '04640', 'ti-tia\u0302u': '11451', 'tshing-kiat': '07589', 'sa\u0301n': '11242', 'sa\u0301m': '12280', 'sui\u0302-ia\u0302n': '12055', 'sa\u0301i': '11572', 'ui\u0300-tshui\u0300': '09295', 'gu\u0302-khi\u030Dt-a\u0301': '01248', 'tsa\u030Dp tshui\u0300 ka\u0301u kha-tshng. ': '60058', 'kiat-a\u0301-tsiap': '06186', 'hun-tshue': '12594', 'kip-tsi\u0300ng': '04967', 'ma\u0301-tso\u0301o': '09441', 'hue\u0301-tsi\u030Dh': '01245', 'sn\u0300g io': '12613', 'tsia\u0300nn-im': '01751', 'sio\u0301-tsia\u0301': '00362', 'kia\u0304n-khong': '06999', 'tse\u0300-tso\u0304': '10873', 'kia\u0300n-tsa\u0302i-ha\u0302ng': '04885', 'khue-ho\u030Dk': '04973', 'pa\u0302i-kut-soo': '07394', 'pi\u0302n-lio\u0302ng-sim': '11699', 'kong-bi\u0302n': '00646', 'tse\u0304-tshing': '03053', 'be\u0304-kham-tit': '06679', 'pia\u0304n-i': '04689', 'su\u0304n-ga\u0301n': '09290', 'kn\u0301g-hun': '07443', 'hiunn-koo': '05658', 'thua\u0302n-siu\u0304': '09361', 'piah-to\u0301o': '11659', 'io\u0301ng-kia\u0304nn': '04753', 'kik-bi\u0304n-tshiunn': '11788', 'io\u0301ng-khi\u0300': '04750', 'pa\u0300ng-sa\u0301i': '04065', 'sia\u0302nn--la\u0302ng': '07047', 'pi\u0302ng-iu\u0301': '04215', 'phi\u0301n-bi\u0302ng': '04808', 'ua\u0302n-si\u0302ng': '03094', 'liam-khau': '04195', '--bo\u0302-ta\u0301nn-ki\u0301n': '08622', 'tha\u0302u-phoo': '12114', 'pe\u030Dh-siak-siak': '02047', 'phang-lia\u0304u': '04469', 'la\u0304u-a-peh': '02699', 'tia\u0304n-hong': '10350', 'tsa\u0302ng': '13124', 'thiap-la\u0302ng-tsia\u030Dh': '09073', 'tshian-tshian-ba\u0304n-ba\u0304n': '00243', 'ka-to-pi\u0302ng': '10901', 'hia\u030Dp-pa\u0304n': '03695', 'te\u0304-tsoo': '02361', 'kiu\u0301-kia\u0300n': '00336', 'tsa\u030Dp-peh-pia\u0300n': '00075', 'hong-pho': '05619', 'ki\u0301ng': '13478', 'tho\u0301o-pau-a\u0301': '00290', 'sio\u030Dk-sin': '13283', 'kut-khi\u0300': '06872', 'phi\u0300-ju\u0304': '13065', 'ho\u030Dk-tsio\u0302ng': '04248', 'tshiu\u0301-lo\u0302ng': '01213', 'la\u0302u-tsui\u0301': '05196', 'thn\u0302g-tan': '11866', 'ia\u0301n-ka\u0301ng': '10670', 'mih-a\u0301': '13647', 'tam-ji\u0304m': '11694', 'ka\u0301i-tap': '10063', 'sia\u0301u-la\u0302ng': '08723', 'kik-kho\u0300o-kho\u0300o': '11782', 'tshia-lia\u0301n': '03512', 'tio\u0300ng-ke\u0300': '00695', 'a-put-to\u0301-a\u0301': '04525', 'oo-mue\u0302-a\u0301-tsiu\u0301': '06300', 'su-ia\u0302nn': '12017', 'bo\u0300ng-sian': '12812', 'ha\u0301i-sua-poo': '06191', 'tui\u0300-ua\u0304nn': '10510', 'tiong-tshiu': '00691', 'to\u0301o': '11428', 'tshue-hong-ki': '03004', 'si\u0302n-sio\u0304ng': '06485', 'lu\u0302n-ha\u0304m': '07576', 'tshui\u0300 pa\u0301 ba\u030Dk-tsiu iau. ': '60285', 'hua\u0301n-hue\u0301': '01025', 'te\u0304-phue\u0302': '02320', 'hue\u0304-phio\u0300': '09364', 'si\u0304-hui': '05035', 'pan-tiu\u0301nn': '06372', puah: '07751', nng: '12654', 'oo-a\u0301-hi\u0302 tsi\u0300nn tsui\u0301. ': '60244', 'ta\u0300-sann': '09856', 'tio\u0304ng-tsia\u030Dh': '05545', 'tia\u0301m-ga\u0301n': '12498', 'lo\u0304o-pinn': '10277', 'khui-ke\u0300': '09226', 'sau-siann': '07528', 'tsio\u0304ng-gua\u0302n': '04347', ni: '03966', 'pua\u0302nn-tshui\u0300-gi\u0301m': '11262', tit: '07207', 'niu\u0302-a\u0301-si': '05887', 'gia\u0302n-gi\u0301': '03507', 'kue\u0300-tshiu\u0301': '10193', ne: '13646', ng: '06448', tin: '05146', tih: '10598', tik: '02598', 'ki\u0302-kua\u0300i': '03798', tia: '06250', 'ok-to\u030Dk': '08402', 'tshi\u0300n-kua\u0304nn': '05757', 'lia\u030Dh-tha\u0301n-hua\u0302inn': '07373', 'u\u0301n-king-tsio': '12469', 'ho\u0301-gia\u030Dh-la\u0302ng': '02429', 'tsi\u0302nn-tshi\u0301': '12053', 'buah-piah': '04162', 'an-tshn\u0302g': '02338', 'tshi\u0300-khua\u0300nn-ma\u0304i': '10046', 'ah-sa\u0300ng': '04097', 'pn\u0304g-khann': '09272', 'e\u0304-sa\u0301i-tit': '09622', 'kang-bo\u0301': '00645', 'tso\u0300-su\u0302n': '06977', 'loh-a\u0304u--ni\u0302': '09957', 'siu-nua\u0304': '02592', 'pi\u0301ng-tshia': '00954', 'gi\u0301n-a\u0301-la\u0302ng': '02154', 'phi\u0302ng-phua\u0300nn': '09086', 'se-i': '02860', 'i\u0302nn-a\u0301': '09393', 'pia\u0301u-tshin': '04661', 'kue\u0300-tshui\u0300': '10249', 'pi\u0300n': '11858', 'o-lo\u0301 kah e\u0304 tak-tsi\u030Dh. ': '60183', 'tiu\u0304nn-la\u0302ng-pa\u0302': '00229', 'keh-tn\u0301g-ji\u030Dt': '10381', 'a-sia\u0300-kia\u0301nn': '04579', 'tsu\u0302-sia\u0304n': '09483', 'pn\u0304g-tha\u0301ng': '09289', 'tua\u0304 ba\u030Dk sin-niu\u0302 bo\u0302 khua\u0300nn-ki\u0300nn tsa\u0300u. ': '60083', 'tia\u0304n-ti\u0302': '10340', 'be\u0304-ba\u0301i': '06656', 'la\u030Dh-tsua\u0301': '13156', 'ta\u0304u-iu\u0302-ko': '03447', 'bu\u0302-ha\u0304n': '08646', 'ta\u0300i-tho\u0302-hue': '07228', 'tshua\u0304': '13546', '--neh': '03702', 'lah-sap-kui\u0301': '03793', tseh: '09836', 'a\u0300u-tu\u0304-tu\u0304': '11721', 'phue-lo\u0302ng': '03285', 'la\u0304u-la\u0302ng-pan': '02625', 'hu\u0304': '05511', 'tsi\u030Dp-tiong': '09254', 'pa\u0301-ti\u0304nn': '10363', 'hu\u0300': '05512', 'hu\u0301': '03967', 'hu\u0302': '07714', 'bo\u0304o-i\u030Dk': '09094', 'kian-ta\u0300ng': '07131', 'tsio\u0301ng-lui\u0304': '10776', 'iu\u0302-tshia': '04287', 'hong-si\u0302n': '05642', 'la\u030Dk-khua\u0302n': '09593', 'tse\u0300-to\u0304o': '03662', 'ting-sim': '11813', 'ki-tiu\u0302nn': '11755', 'tsha\u0300i-tsi\u0301-iu\u0302': '08960', 'ia\u0304': '07322', 'pak-kiann': '01490', 'ia\u0301': '08028', 'ia\u0300': '10410', 'ia\u0302': '09750', 'siu\u0302nn': '13610', 'ha\u0304u-lu\u030Dt': '06063', 'la\u0300u-sa\u0301i': '09953', 'suah-bue\u0301': '09730', 'tho\u0300o-lia\u0302n-sia\u0302n': '02255', 'khi\u0301-su\u0304': '06739', 'ji\u0304-tshiu\u0301': '00085', 'pia\u0300n-po\u0304o': '13331', 'si\u0301ng-ngo\u0304o': '12004', 'to\u0302ng-huan': '11078', 'tsho\u0300-la\u0302ng-hi\u0304nn': '11628', 'tshiu\u0301-lo\u0304o': '01121', 'lo\u0302-hua\u0302n': '08254', 'bi\u0302ng-hia\u0301n': '04264', 'sua\u0304n-pit': '11264', tsuann: '09718', 'si\u030Dp-pat-ta\u0302u-a\u0301': '00074', 'tsu\u0304-siu\u0301': '02709', 'tso\u0300-tua\u0304-tsui\u0301': '06951', 'khia\u0302n': '06930', 'su\u0300-sio\u0302ng': '01540', 'nn\u0301g-kha': '08000', 'tn\u0302g-siu\u0304': '04646', 'liu\u0302': '11241', 'ia\u030Dt-tshiu\u0301': '11692', 'liu\u0300': '10889', 'tsu\u0300n': '13281', 'sok-to\u0304o': '07966', 'liu\u0304': '12781', 'ga\u0301n-tsia\u0302n': '07684', 'tshi-tsi\u0302ng': '09789', 'tshau-si\u030Dp': '03286', 'tsham-ka': '07057', 'ha\u030Dk-hui\u0300': '11665', 'lo\u030Dh tsui\u0301 pe\u0302nn-pe\u0302nn ti\u0302m, tsua\u0302n bo\u0302 ta\u0304ng-tha\u0302u-khin. ': '60329', 'tshiu\u0304nn-ki\u0302': '09110', 'te\u0304-ha\u0304-to\u0304': '02303', 'kim-suann': '04518', 'tap-tshui\u0300-ko\u0301o': '08899', 'tshi\u0301-khak-kue\u0301': '10404', 'bo\u0302-lio\u0304ng': '08673', 'put-huat': '00678', 'tsun-siu\u0301': '11996', 'lo\u030Dk-tshui\u0300': '10664', 'kiat-a\u0301': '06185', 'kho\u0300-suann': '11573', 'kiu-kha': '00758', 'tshut-khi\u0302n': '01572', 'te\u0304-tsi\u0301': '02334', 'suah--tio\u030Dh': '09739', 'tsi\u0302ng-si\u0300': '04724', 'mo\u0302o-si\u0302n-a\u0301': '13216', 'ke\u0301nn': '05822', 'ka\u0301m-ko\u0301ng': '08496', 'ho\u0302o-si\u0302n bu\u0301 sa\u0301i-pue. ': '60217', 'tsa-poo-la\u0302ng': '05122', 'pha\u0300nn': '00589', 'o\u0301ng-si\u0301': '04228', 'mia\u0304-a\u0300n': '03739', 'tshe\u0301': '03158', 'tshe\u0300': '06551', 'tsha\u0301u-a\u0301': '06573', 'tshe\u0304': '03037', 'kian-ti\u0304ng': '07122', 'gu\u0302-ling-sik': '01240', 'ho\u030Dk-tsit': '08364', 'hiong-ti\u0300n': '09160', 'to\u0304ng-phua\u0300': '11106', 'kui-pi\u0302ng': '07878', 'u\u0304n-io\u0304ng': '10207', 'tio\u0300-hi\u0302-ang': '08081', 'ki-ha\u0304i': '11752', 'lo\u0301o-nn\u0304g': '10615', 'pe\u030Dh-mua\u0302': '01964', 'bo\u0302-siong-kan': '08645', 'kau-i\u0301n': '00630', 'sim-tsi\u0302ng': '01057', 'se\u0301-sann-tia\u0300m': '05163', 'tshia-ko\u0301o-hi\u0300': '03499', 'pue-oo': '05639', 'tua\u0304-ki\u0304m': '00325', 'tang-bue\u0301': '01481', 'hue\u0301-khi\u0300': '01266', 'khe-kau': '09698', 'su-lia\u0304m': '04954', 'bi\u0302n': '06397', 'lue\u0304-tsi\u0300ng': '00685', 'hit e\u0302': '03905', 'iu\u0302-thiu': '04290', 'ho\u0302o-tshiu': '12974', 'sn\u0300g-bo\u0302-pua\u0302nn': '10764', 'tha\u030Dk-tsheh-la\u0302ng': '13267', 'tio\u0304ng-si\u0304': '05557', 'hi\u0300-ia\u0304m': '04460', 'khau-siah': '09347', 'tshu\u0300-tsu\u0301': '05832', 'khit-tsia\u030Dh-khi\u0302m': '00409', 'pi\u0301ng-pak': '01115', 'kong-kua\u0301n': '00773', 'tsik-ta\u0302i': '12250', 'ta\u0301nn': '12329', 'ok-si\u0300ng': '08397', 'khia\u0304-siu\u0302': '07271', 'thian-bu\u0302n': '00858', 'kha\u0301u-tso\u0304': '00416', 'khia\u0304-siu\u0304': '07294', 'kue\u0300-mn\u0302g': '10227', 'phi\u0304nn-khang': '10980', 'tsi\u0302ng-a\u0304u': '04740', 'gia\u0302n-lu\u0304n': '03511', 'ku\u0304 siu\u0302 tsia\u030Dh sin siu\u0302. ': '60374', 'ta\u0300ng-sng': '05801', 'tsi\u030Dt hiong tsi\u030Dt sio\u030Dk. ': '60027', 'ka-pi-sik': '03744', 'li\u0301-sia\u0304': '06043', 'pat-tin': '00126', 'tsua\u0301-kheh-a\u0301': '06543', 'tsi\u0300ng-hu\u0301': '05031', 'tshi\u0300n-pn\u0304g': '05779', 'tshia-a\u0301': '03425', '--lia\u0301u-lia\u0301u': '00068', 'ga\u0304i-gio\u030Dh': '12836', 'tui\u0304-kha-khi\u0300': '11029', 'lia\u0302m-mi': '08020', 'kam-a\u0301-bi\u030Dt': '05106', 'ha\u0300u-koo': '03100', 'tsiu\u0304nn-tshi\u0304': '00295', 'ti\u0301ng-si': '08056', 'tin-po\u0301': '05316', 'ni\u0302-tsi\u0302nn-kha': '12867', 'ta\u0300m-tha\u0302u': '10970', tsenn: '04338', 'ti-ko': '11468', 'tsa\u0301u-be\u0301-ting': '03469', 'tho\u0302o-la\u0302ng': '09434', 'sa\u0300ng i hi\u0302, khah-su ka\u0300 i lia\u030Dh hi\u0302. ': '60255', 'kia\u0301nn-sa\u0300i': '02232', 'ki\u0300m-tsi\u0301': '09814', 'kho\u0301o-te\u0302-iu\u0302': '05494', 'ngo\u0301o-tso\u0304ng': '00779', 'senn-hu\u0304n': '01892', 'bo\u0302-siann-bo\u0302-sueh': '08704', 'jua\u030Dh': '11238', 'hun-sua\u0300nn': '00733', 'so\u0300o': '09015', 'tua\u0304-keh ke ba\u0304n thi\u0302. ': '60087', kinn: '13388', 'si\u030Dt-si': '10500', 'si\u0302ng-lia\u0302n': '02487', 'pak-to\u0301o-iau': '09939', 'thia\u0301n-si\u030Dt': '05963', 'la\u0302u-tsi\u0302': '05223', 'tua\u0304-gue\u030Dh': '00266', 'uan-uan-uat-uat': '13245', 'ka-ki\u0304': '05920', 'ki-hng': '06877', 'suann-kha\u0300m': '00421', 'ti\u0302nn sua\u0300nn': '13162', 'tshing-i\u0302ng': '07580', 'tsa\u0304i-sik-li\u0301': '02203', 'tsia\u030Dh-pn\u0304g-thiann': '05665', 'la\u0304n-tsia\u0301u': '13525', 'tse\u0300-koo': '07727', 'thi\u0302ng-su\u0304': '08807', 'pa\u0302i-ka\u0301i': '07419', 'sia\u0301u ka\u0301u tsing bo\u0304ng-kho\u0300ng. ': '60256', 'a\u0300m-sat': '09637', 'pha\u0301ng': '06502', 'si-kua': '10071', 'kau-liu\u0302': '02078', 'pat-ka-tsio\u0300ng': '00135', 'tsu\u0304-kak': '02837', 'pho\u0301ng': '07260', 'tsi\u0301 tshui\u0300-ta': '01078', 'ti-tha\u0302u-pi\u0302ng': '11502', 'ui\u0301-ji\u0304m': '03791', 'lia\u0302m-hi\u0302': '12978', 'tsha\u0300i-tha\u0302u': '08996', 'thap-tsi\u0302nn': '09431', 'pa\u0301i-kha': '09158', 'm\u0304-ti\u030Dh': '00999', 'ing-hio\u0302ng': '05499', 'to\u0300-the\u0300': '05770', 'hiong-ni\u0302': '00658', 'to\u0304ng-ua\u0302n': '07066', 'pia\u0302nn-tseh': '01685', 'tik-phi-a\u0301': '02689', 'bi\u0301-hu\u0301n': '02719', 'tso\u0300 kuann na\u0304 tshing-lia\u0302m, tsia\u030Dh-pn\u0304g tio\u030Dh kia\u0301u ia\u0302m. ': '60260', 'la\u0304u-o\u0304o-a\u0301': '02678', 'nge\u0304-tu\u0301-nge\u0304': '08814', 'tsiu\u0301-a\u0300ng': '06919', 'io\u030Dh': '12871', 'bo\u0302-pua\u0300nn-phiat': '08620', 'tng-ta\u0301n': '07239', 'si\u0301-lua\u0304--la\u0302ng': '02580', 'thua\u0300nn--khui': '08580', 'to\u0302-bo\u0302ng': '06708', 'ka\u0301u-hia\u0304': '04383', 'io\u030Dh-ko': '12895', 'tsha\u0300i-tia\u0300m': '08975', 'lo\u0302o-tsa\u0302i': '01674', 'pi\u0301nn-hi\u0302': '04971', 'tso\u0300-li\u0304': '07007', 'pi\u0300n-kak': '13395', 'puann-tshia\u0301nn': '09578', 'po\u0301-tsi\u0300ng-ji\u0302n': '04781', 'si\u0302-si\u0302n': '06041', 'kim-tsiam': '04614', 'kha\u0301u-king': '00346', 'tsa-me\u0302': '05064', 'ke\u0304-lo\u0304o': '00496', 'ti\u0301ng-pang': '08103', 'tsha\u0301u-pa\u0300-o\u0302ng': '06648', 'tiong-ti\u0301ng': '00736', 'kha-ta\u030Dh-a\u0301': '10158', 'a\u0301u-sim-hiat': '10421', 'kiu\u0302-king': '07638', 'ka\u0304u-tsua\u0301-phue': '04818', 'khe\u0300-pe\u0304': '04852', 'sai-pak': '02850', 'tha\u0302u-tsiu\u0304nn-a\u0301': '12073', 'sun-a\u0301': '05925', 'kho\u0301ng-tshiok': '01073', 'la\u0304i-kah-a\u0301': '00599', 'te\u0302-au': '06637', 'kui-ti\u0304n': '07895', nauh: '08190', 'tong-tshoo': '09776', 'pe\u0302-li\u0302ng-tsu\u0302n': '01827', 'si\u0302ng-siu\u0304': '04042', 'hua\u030Dt': '10786', 'hua\u030Dh': '02058', 'kong-po\u0302': '00716', 'khioh-ji\u0304-tsua\u0301--e\u0302': '04023', 'ta\u0301ng-su\u0304': '10011', 'ua\u0301-kho\u0300': '05790', 'sia\u0300u-tuann': '11164', 'ba\u030Dk-ni\u0304-hue': '05497', 'kui\u0300-pin': '09117', 'tshua\u0301n-khui\u0300': '08236', 'sa\u0300ng-ji\u030Dt-a\u0301': '06716', 'khi\u0301-hua\u0304nn': '11611', 'ak-ta\u0302m': '03338', 'tso\u030Dk-pho\u0301o': '07487', 'kia\u0302nn-te\u0301-lo\u0304o': '02758', 'go\u0304o-kin-ke\u0302': '00739', 'lo\u030Dh-kia\u0304': '09970', 'tsok-bu\u030Dt': '02916', 'ka\u0300u-siu\u0304': '07400', 'kue\u0300-o\u0301ng': '10222', 'sa\u0301n-ka\u0302u': '11263', 'go\u0304--si\u0301': '11578', 'khia\u0304-n\u0302g': '07286', 'tsio\u030Dh-tsa\u0304m': '02035', 'a\u0300m-te\u0304-a\u0301': '09640', 'tsia\u030Dh-toh': '05636', 'iu\u0302-tsha\u0300i': '04308', 'khih-tshui\u0300--e\u0302 tsia\u030Dh bi\u0301-hu\u0301n\u2014\u2014khua\u0300nn-hia\u0304n-hia\u0304n. ': '60247', 'ha\u0301i-sa\u0301n-mue\u0302': '06219', 'tsuan-sim': '07170', 'tsng-tha\u0302u': '02423', 'lo\u0301o-ko\u0301o-tsio\u030Dh': '13476', 'senn ke-nn\u0304g bo\u0302, pa\u0300ng ke-sa\u0301i u\u0304. ': '60132', 'bo\u0302-i-bo\u0302-ua\u0301': '08629', 'go\u0304o-ka\u0301i': '10877', 'tsia\u0301n-po\u0300o': '06966', 'pi-phi\u0301': '03689', 'ko\u0300o-ke': '13215', 'jia-hong': '11530', 'tshi\u0300-to\u0302ng': '08943', 'pu\u0302n ke-kui-a\u0301': '11801', 'beh-a\u0300m-a\u0301': '07525', 'tua\u0304-thui\u0301-kut': '00509', 'hue-sin-a\u0301': '04454', 'pa\u0302ng-sann': '12295', iam: '12025', ian: '09720', iah: '09512', 'la\u0302ng sim-kuann, gu\u0302 pak-to\u0301o. ': '60040', 'kia\u0302nn-lo\u0304o': '02780', 'ti\u0304ng-a\u0300n': '03859', 'tsha\u0301u-te\u0304-la\u0302ng': '06578', 'ku\u0301n-tsui\u0301-kua\u0300n': '10606', 'pha\u030Dk tshik': '12821', iau: '05078', 'sue-sia\u0302u': '06683', 'sian-sinn': '02069', iap: '08432', 'bue\u0301-a\u0304u': '03104', 'ti\u0302m-te\u0301': '03316', 'ka\u0300u-hu\u0300n': '07392', hue: '04442', 'bo\u0302ng-bu\u0304': '10384', hua: '04441', 'hi\u0302-tshi\u0300': '08142', hun: '12588', 'tsong-tsi\u0301': '03849', hui: '05586', 'tsi\u0301-ho\u0301': '01474', hut: '03962', 'ku\u0302n-tha\u0302u-bu\u0301': '06000', 'bu\u0301-thiann': '10834', 'si\u0301-tsi\u0300ng': '02525', 'li\u0301ng-siu\u0300': '10968', tshuah: '13020', tshuan: '08030', 'siu\u0304-kho\u0301o': '03666', jiok: '07920', 'i\u0302ng': '09174', 'ku\u0304-a\u0301': '09915', 'ke\u0300-ue\u0304': '05554', 'thong-i\u030Dk': '08022', 'sio\u0301-to\u0304o': '00333', 'i\u0300n-sio\u0304ng': '02238', 'oo-pang': '06281', 'tse\u0304': '12239', 'te\u0300nn-la\u030Dt': '12270', 'tsha\u0300u-bi\u0304n': '06599', 'tua\u0304-pi\u0302ng': '00279', 'tse\u0300': '07709', 'tse\u0301': '03778', 'tse\u0302': '10973', 'po\u0301-sing-ta\u0304i-te\u0300': '04727', ang: '06508', 'phua\u0300nn-kuat': '02998', 'khia\u0300m-tse\u0300': '01102', 'toh-ui\u0302': '06151', 'pho\u0304--e\u0302': '04055', 'kiann-si\u0301-la\u0302ng': '13327', 'bo\u0302-tik-khak': '08640', 'ba\u0304-hio\u030Dh': '07906', 'tsi\u0300ng-kua\u0300n': '12918', 'tsiu\u0301 khang-pa\u0302ng': '02350', 'pua\u0300nn-poo': '01542', 'iah-khang': '09543', 'phua\u0300-khang': '06415', 'tue\u0300-kio\u0304-a\u0304u--e\u0302': '10811', 'tshu\u0300-sue\u0300': '05860', 'a\u0302u-ti\u0304nn': '08253', 'hi\u0302ng-ui\u0302': '02706', 'pi\u0301nn-ta\u0304u': '04950', 'pue-te\u0301 m\u0304-thang tshi\u0304 kim-hi\u0302. ': '60189', tsheh: '11084', 'ka\u0304u-sa\u0301i-jio\u0304': '04813', 'bue\u0301-liu': '03129', 'tsha\u0300u-tshenn-a\u0301': '06595', 'ap-pik': '12197', 'tha\u0302u-ke-niu\u0302': '12097', 'hi\u0304nn-khang': '02693', 'ti\u0302-tha\u0302u': '11560', 'tshia\u0302ng-tsa\u0304i': '07216', 'tho\u0301o-pua\u030Dt-a\u0301': '00464', 'khi\u0301-khok-a\u0301': '11622', 'lo\u0301o-khi\u0300': '08406', 'ba\u030Dk-sa\u0301i-ko': '01929', 'tsia\u030Dh-so\u0302ng': '05633', 'kong-khai': '00742', 'bu\u0302n-hua\u0300': '00860', 'ta\u0300u-te\u0301': '03656', 'ka\u0300u-ki\u0302': '03682', 'the\u0301-tshau': '13354', 'pa\u0300-o\u0302ng': '13173', 'pa\u0304n-kong-hue\u0301-a\u0301': '11992', 'khu\u0300n-kho\u0300o': '08836', 'si\u0300n-ho\u0304': '04760', 'tsi\u0301m-tha\u0302u-lo\u0302ng': '04261', 'thn\u0302g-tsi\u0301ng': '09369', 'seh-khang': '09624', 'lia\u030Dh-sua': '07411', 'he\u0302-pi': '11371', 'ni\u0301-sik': '05109', 'ta-ke': '00419', 'thn\u0304g': '10691', 'la\u0300ng-gue\u030Dh': '11552', 'si\u030Dk-su\u0304': '10697', 'ki\u0301-hi\u0302ng': '12340', 'ju\u0302': '05979', 'ju\u0301': '09454', 'siu-tsi\u030Dp': '02547', 'pak-ki\u030Dk': '01580', 'n\u0302g-hi\u0302': '09294', 'ku\u0304-a\u0301-tha\u0300m-pa\u0302ng': '09920', 'e\u0304-poo': '00440', 'ko\u0301o-tshue-hue': '10395', 'phah-kha-tshng': '04008', 'tha\u0302u-ke': '12096', 'kui\u0300-hue': '06135', 'tsu-lui\u0304': '06382', 'tia\u0300u-kui\u0301-a\u0301': '02216', '--eh': '07495', 'ti\u0301ng': '08038', 'bo\u030Dk-tsa\u0302i': '00942', 'ka\u0300nn': '10893', 'a-i\u0302': '04583', 'kiann-kiann be\u0304 tio\u030Dh ti\u0301ng. ': '60390', 'ka\u0300ng': '05522', 'iu\u0302-tshia-king': '04288', 'ke-tha\u0302u': '09048', 'hue\u0301-sio': '01292', 'kim-kim': '04581', 'lim tsui\u0301': '07054', 'ke-nn\u0304g-ko': '12717', 'to\u0304ng-tsi\u0304ng': '07087', 'hong-tha\u0302u': '05695', 'huat-kuann': '04289', 'ti\u0301ng-pak-kua\u0300': '08089', 'jia\u0301': '09452', 'tsha\u0300u-tha\u0302u': '06638', 'sio-lia\u0302n-sua\u0300': '05291', 'po\u0301o-hueh': '10039', 'thau-senn--e\u0302': '06969', 'hue\u0301-thua\u0300nn': '01263', 'gue\u030Dh-tha\u0302u': '01179', 'mue\u0302-a\u0301': '07471', 'piak-toh': '09734', 'siu\u0301-li\u0301ng': '05678', 'tshi\u0300n-mue\u0302': '05800', 'khue\u0300 kha': '05128', 'mi\u0304-ta\u0300nn-a\u0301': '13111', 'gua\u0302n-tsu\u0301-pit': '05828', 'tsia\u0304m-to\u0304o': '11159', 'ba\u0301i-tsa\u0301inn': '13555', 'phah-thih-a\u0301-sai': '04187', 'thui-siau': '07432', 'phah la\u0302ng huah kiu\u0300-la\u0302ng. ': '60185', 'so\u0301 mn\u0302g': '12723', 'li\u0301-su\u0304': '07681', 'put-tap-put-tshit': '00738', 'tso\u0300-tha\u0302u': '07020', 'pi\u0301n-a\u0301': '10732', 'khang-khak': '04412', 'khua\u0301n-tha\u0304i': '08559', 'to\u0302-ping': '06732', 'iau-to\u0304': '03131', 'tua\u0304-tn\u0302g ko\u0300 sio\u0301-tn\u0302g. ': '60090', 'phu\u0301-phu\u0301': '08564', 'un-su\u0302n': '09700', 'kin-pu\u0301n': '06123', 'tso\u0300-sing-li\u0301': '06970', 'be\u0301-tsi\u0302': '06921', 'kha-la\u0302i-tshiu\u0301-la\u0302i': '10114', 'tsheh-sim': '11098', 'he-ku': '08739', 'tn\u0302g-n\u0301g': '04517', 'a\u0304u-tha\u0302u-tshu\u0300': '04988', 'lui\u0302-puah': '11709', 'ha\u0301i-hua\u0304nn': '06196', 'ti\u030Dh-a\u0301': '10698', 'khu\u0301n-kiu\u0302': '12194', 'bi\u0304n-hi\u0302ng': '05613', 'mn\u0302g-tshi\u0304': '04539', 'tsa\u0301-tsi\u0302ng': '02507', 'phua\u030Dh-lia\u0304n': '07907', 'phue\u0300-ha\u030Dp': '06841', 'be\u030Dh-a\u0301': '08120', 'thian-ka\u0301u-jia\u030Dt': '00982', 'ka\u0301i-pinn': '10971', 'ta\u030Dh-nge\u0304': '11483', 'la\u0304u-po\u0302-a\u0301': '02732', 'io-tsiah-kut': '09966', 'nn\u0301g-tsia\u0301nn': '07960', 'ba\u030Dk-tsiu khua\u0300nn-kua\u0302n, bo\u0302 khua\u0300nn-ke\u0304. ': '60140', 'kim-sua\u0300nn-lia\u0302n': '04656', 'bi\u0302n-a\u0301-a\u0300m': '04223', 'kheh-la\u0302ng': '04876', 'kun-tsu\u0301': '02986', 'tho\u0302-hue': '06136', poo: '07458', 'tsia\u0302n-to\u0302o': '04756', 'tsa\u030Dp-tsi\u0301ng-a\u0301-kia\u0301nn': '12756', 'tsu\u0302n': '07809', poh: '00063', 'tho\u0301o-sua\u0304inn-a\u0301': '00550', 'tsha\u0300u-ta': '06610', 'tshiu\u0304-tha\u0302u': '11764', 'phah-la\u0304-lia\u0302ng': '04054', 'si\u030Dt-tsa\u0304i': '10488', 'kai-kip': '09283', 'e\u0301-ka\u0301u': '07051', 'kho\u0301-a\u0300i': '01577', 'ha\u030Dp': '02121', 'mia\u0302-tsheh': '02151', 'hue\u0300-tsu\u0301': '07942', 'sing-ua\u030Dh': '01933', 'ue-a\u0301': '12456', 'ha\u030Dk': '12557', 'ha\u030Dh': '11282', 'a\u0302ng-lia\u0302n-hi\u0302': '05465', 'thu\u0302n': '12124', 'ta\u0300ng-tshui\u0300-khi\u0301': '05777', 'sng-seh': '12474', 'ta\u0301m-ta\u0301m': '12376', 'tn\u0302g-a\u0301-jia\u030Dt': '09922', 'ngo\u0301o-hok': '00763', 'pa\u0300ng-tse\u0300': '04133', 'si\u0301-si\u0300ng': '02500', 'hi\u0302ng sia\u0300u': '12460', 'ki\u0300-ti\u0302': '01051', 'sim-kuann': '00944', 'li\u0301ng-tho\u0301o': '10956', 'se\u0300-ui\u0304': '07767', 'bah-hu\u0301': '02688', 'hu\u0304-tse\u0300': '05560', 'suan-ti\u0302n': '07486', 'lia\u0300n-tn\u0301g': '12463', 'la\u0304m-sa\u0301m': '12259', 'a\u0300u-sik': '10652', 'si\u0301m-mn\u0304g': '11074', 'tha\u0301n-ti\u030Dt': '03732', 'bo\u0302-su\u0304-sa\u0301i': '08628', 'huat-bi\u0302ng': '08743', 'm\u0304-thang': '01070', 'ka-ia\u030Dh': '02075', 'tsu\u0301-ko\u0300o': '01384', 'it-to-lio\u0301ng-tua\u0304n': '00003', 'thn\u0302g-kam-bi\u030Dt-tinn': '11875', 'kho\u0301-na\u0301u': '01561', 'thiau-i\u0300-ko\u0300o': '00152', 'siu-bue\u0301': '02493', 'kiam-ji\u0304m': '05753', 'khui-bo\u0304o': '09224', 'ka-tshia': '01486', 'gue\u030Dh-ba\u0302i': '01008', 'la\u0302m-li\u0301': '03360', 'ko\u0300-tsu\u0302n': '02226', 'o\u0302': '07839', 'ku\u0301n-tshio\u0300': '10621', 'khu-liu\u0302': '04088', 'ku-moo': '12128', 'a-hiann': '04536', 'tik-ko\u0301ng': '02787', 'beh-tsai': '07510', 'ke\u0301-ia\u0301nn': '07016', 'i-ha\u030Dk': '12760', 'ui\u0302-lo\u0302o': '08308', 'oo-tshenn': '06287', 'hun-bi\u0302ng': '00677', 'pho\u0300ng-hu\u0301n': '11904', 'ka\u0304u-ka\u0304u-lia\u0304m': '10067', 'niu\u0302-thia\u0304u': '07477', 'i-na\u0304i': '03590', 'to\u0302ng--e\u0302': '07126', 'i\u0301-lia\u0302u': '08528', 'kho\u0301-o\u0300nn': '01560', 'ke\u0300-tsng': '09444', 'a\u0304u--la\u0302i': '04951', 'kiu\u0302-tsi\u0302ng': '03329', 'na\u0301 bue\u0304': '05834', 'tshut-tshui\u0300': '01554', 'pua\u030Dt-a\u0301': '08962', 'li\u0302ng-tshu\u0300': '13377', 'tshiu\u0301-khua\u0302n': '01189', 'phue\u0304-tuann': '07899', 'ting-tshai': '11830', 'bu\u0304-bu\u0304': '12958', 'tse\u0304-ue\u0304': '12254', 'ka-la\u030Duh': '02099', 'si-kue ua\u0301 tua\u0304 pi\u0302ng. ': '60175', 'gu\u0304-tio\u030Dh': '10255', 'king-tsio-iu\u0302': '00539', 'kha\u030Dh': '12689', 'kha\u030Dk': '04791', 'kue\u0300-ho\u0304o': '10192', 'khua\u0300nn-bo\u0302-khi\u0301': '05366', 'ha\u0301i-ki\u0302nn': '06231', 'ki\u0300nn-bi\u0304n': '03459', 'kiat-hiong': '02145', 'hua\u0301n-thinn': '00857', 'sa\u0301i-jio\u0304': '04884', 'tshin-ki\u0304n': '11959', 'kha\u030Dp': '11274', 'tsha\u0301i-tha\u0302u': '07247', 'ua\u0301nn-ko': '09830', 'a\u0304u': '04914', 'lia\u0302m-ka': '12503', 'kha-tshng': '01675', 'kia\u0300nn-ta\u0302i': '12942', 'tshua\u0301n-tua\u0304-khui\u0300': '08209', 'ki\u0301ng-tshat': '13070', 'ha\u030Dk-su\u030Dt': '11663', 'kho\u0301ng-bi\u0302ng-tshia': '00977', 'a\u0304n': '05523', 'a\u0304m': '12066', 'hun-huat': '00735', 'kia\u0301nn-sa\u0300i si\u0304 pua\u0300n-tsu\u0301. ': '60145', 'tsha\u0300i-kue-po\u0302o': '08969', 'phian-phian-a\u0301': '06998', 'si\u0302-tsing': '06094', 'tsio\u030Dh-bo\u0304': '02020', hing: '11893', 'tsi\u030Dt tshing sia m\u0304-ta\u030Dt peh pah hia\u0304n. ': '60005', 'hue\u0301-hun': '01299', 'se-iu\u0302nn': '02855', 'tshui\u0300-tsha\u0300u': '08238', 'su\u0304-kia\u0304nn': '03559', 'tn\u0301g-tshui\u0300': '12669', 'tsa-bo\u0301o-ka\u0301n': '05112', 'ia\u0301n-si\u030Dp': '10662', 'tsa\u0302i-li\u030Dk': '06705', 'hu\u0300-im': '05544', 'ho\u0302ng': '03416', 'pang-suann': '07210', 'ta\u0300ng-tsi\u030Dh': '05758', 'ku-khak': '12145', 'lio\u0302ng': '12126', 'tang-kue': '01468', 'tha\u0300m-thiann': '07451', 'kia\u0304-a\u0301': '07213', 'i\u0301-tsu\u0304': '08522', 'the\u0300-tshiu\u0301': '08511', 'puah--khui': '11165', 'a\u0302ng sui\u0301, oo tua\u0304-pa\u0304n. ': '60216', 'tsa\u030Dp-lia\u0304m': '12737', 'po\u0300o-tsha\u0302n-ko\u0301ng': '11154', 'kuah-ke\u0300': '08258', 'kim-kia\u0301nn': '04546', 'huah-hi\u0302-a\u0301': '08245', 'se\u0301-tn\u0304g': '05179', 'po\u0302': '07157', 'po\u0300': '08275', 'po\u0301': '12984', 'tsia\u030Dh-tsho': '05700', 'lo\u0304o-ti\u0302ng': '10253', 'ju\u0302-hu-ji\u0302n': '02311', 'sioh bi\u0304n-phue\u0302': '07277', 'sik-so\u0300o': '02723', 'sai-a\u0301-phi\u0304nn': '09752', 'tha\u0300i-pi\u030Dk-tshenn': '00891', 'tsi\u0302nn-ta\u0302ng-a\u0301': '12049', 'phah ku\u0302n-tha\u0302u': '04083', 'kua-ia\u0302u': '10632', 'ku\u030Dt-a\u0301': '07352', 'kak-tshe\u0301nn': '13074', 'siong-kha\u0301u': '09334', 'ho\u0302o-li\u0302': '04370', mooh: '13502', 'ti\u0300-sik': '08498', 'sin-niu\u0302': '09552', 'tha\u0302u-ka\u0300u': '12089', 'ta\u0304n-si\u0304': '02925', 'hing-kha\u0301m-kut': '06520', 'ian-thu\u0302n': '09743', 'i\u0302nn-khua\u0302n': '09433', 'si\u0301-ua\u030Dh': '02510', 'thuah-a\u0301': '07212', 'to\u0304o-tsu\u0302n': '08563', 'tui\u0300-tia\u0300u': '10521', 'hua\u0301n-si\u0301ng': '01007', 'kim-kho\u0300o': '04598', 'khui-thiah': '09199', 'pua\u0300nn-tha\u0301ng-sai-a\u0301': '01544', 'pha\u0301ng-tshia': '06521', 'tso\u0300-hue\u0301': '06971', 'kn\u0300g-thih': '12018', oo: '06248', om: '07338', 'thiau-la\u0302n': '00167', ok: '08366', oh: '10408', 'gi\u0302n': '10899', 'gi\u0302m': '13473', 'tsa\u030Dp-tsiok': '00110', 'ka-tsui': '01639', 'tshiu\u0304nn-phu\u0301': '00452', 'ba\u030Dk-ta\u0301u': '11018', 'pa\u0304n-kong': '11991', 'io\u030Dh-tse': '12893', 'peh-kim': '12196', 'pu\u030Dt-kham': '02956', jiah: '10088', 'ti\u0301ng-si kua\u0301n e\u0304-si, ti\u0302-tha\u0302u kua\u0301n pu\u0300n-ki. ': '60280', 'tsha\u030Dt': '10085', 'sip-sip': '12257', 'tsui\u0301-ting': '01172', 'e\u0304-pa\u0301i': '00556', 'ke\u0300-bo\u0302o': '05572', 'kua\u0301nn-ki\u0301n': '10880', 'tshia-hua': '07139', 'nua\u0304 tho\u0302o be\u0304 ko\u0302o tit piah. ': '60385', 'tua\u0304-ba\u030Dk': '00301', 'kn\u0300g-khi\u0302m': '12011', 'tsha\u030Dk': '13448', 'u\u0304 tshui\u0300 ko\u0301ng kah bo\u0302 nua\u0304. ': '60162', 'so\u0301o-u\u0304': '04026', 'tsha\u0302n-le\u0302': '02029', 'tsio\u0300-kia\u0300nn': '09761', 'kim-gia\u0302n': '04561', 'tsiu-tsua\u0302n': '03723', 'sio-tse\u0300nn': '05307', 'to\u0300-tha\u0302u': '05797', 'ta\u0300n-hiat-ka\u030Dk': '12523', 'sia\u0300-hue\u0300': '03679', 'ki\u0302-kan': '08532', 'sia\u0302nn': '02436', 'bi\u0304n-ma\u0304u': '05676', 'la\u0304u-huan-tian': '02756', 'kio\u0300-m\u0304-ka\u0301nn': '01450', 'it-kha\u0300i': '00034', 'lua\u0304n-la\u0302i': '09345', 'pn\u0304g-tn\u0300g': '09305', 'po\u0301-pi\u0300': '04735', 'hun-lui\u0304': '00776', 'tsa\u0300-tsha\u0300i': '10588', '--e\u0302': '04386', 'tsu\u0302n-bue\u0301': '07819', 'phi\u0304nn-ba\u030Dk-tshui\u0300': '10978', 'bah-po\u0301o': '02739', 'ti\u0301-ah': '04049', 'a-ia\u0302n-sua\u0300nn': '03585', 'nia\u0301-tua\u0300': '10965', 'tsio\u030Dh-pi': '01990', 'ua\u0301n-jia\u0302n': '03867', 'lia\u0304n-sia\u0301u-ue\u0304': '11330', 'kin-a\u0301': '00283', 'tsha\u0302i-kuat': '09026', 'to\u0302-tsa\u0301u': '06738', 'tsu-tu\u0302': '06168', 'sua\u0300n-a\u0301': '10823', 'si\u0304-tua\u0304': '03168', 'khua\u0300nn-khua\u0301n': '05363', 'im-tsui\u0301': '07547', 'ho\u0304-tso\u0300': '10013', 'kim-lia\u0304n-a\u0301': '04671', 'ka\u0301i-kik': '03253', 'bah-pau': '02650', 'ti\u0302ng-ti\u0302ng-tha\u030Dh-tha\u030Dh': '05543', 'tsa\u030Dh ji\u030Dt': '10294', 'khe\u030Dh': '05978', 'ji\u0302n-ua\u0302n': '00129', 'tshiu\u0301nn-tha\u0302u-hiunn': '09583', 'tsu\u0302n--ni\u0302': '04734', 'siap-thiap': '11076', 'i\u0301ng-i\u0301ng': '03921', 'ta\u0302u-phio\u0300': '03262', 'tsit-ui\u0304': '12593', 'lio\u030Dh-lio\u030Dh-a\u0301': '07694', 'kia\u0301u-siu\u0304': '08878', 'sia\u0304u-ka\u0300i': '07757', 'thih-pang': '13178', 'khi\u0302nn-tia\u0302u-tia\u0302u': '04039', 'tsia\u030Dh-tsi\u0302nn': '05693', 'to\u0304o-tsa\u0302i': '03394', 'go\u0304ng-tai': '13453', 'mo\u0302o-tn\u0302g': '04417', 'u\u0304n-to\u0304ng': '10240', 'tsha\u0300u-hi\u0304nn-a\u0300ng-a\u0301': '06582', 'a\u0300m-sa\u0300m-pe\u0304nn': '09654', 'kiu\u0300-tso\u0304o': '07366', 'hue\u0301-tsi\u0301ng': '01281', 'la\u0301n': '12804', 'khih-tshui\u0300': '06538', 'la\u0301m': '06651', 'ho\u0302o-lui\u0300-lui\u0300': '11334', 'lua\u0304n-tshau-tshau': '09372', 'oo-ji\u0302n': '06255', 'pho\u0304ng-ko\u0301-sua\u0304inn': '13056', 'tshun-a\u0301-hue': '05022', 'phah-pha\u0301inn': '03996', 'pue\u0302-sio\u0302ng': '11505', 'ku\u0304-sia\u0300u': '12614', 'la\u0301u': '02601', 'tho\u0302o-kat': '09413', 'gi\u0302n-ha\u0302ng': '10910', 'hue-li\u0302ng-ki': '05609', 'ua\u0304nn-thiap--e\u0302': '08467', 'si\u0302n-king': '06479', 'a\u0300n-sn\u0300g': '05065', 'thu\u0304n-tho\u0302o': '03055', 'lio\u030Dk-huat-tsua\u0302n-su': '00679', 'kok-ui\u0304': '02179', 'ka\u0301i-sik': '10078', 'tsiu\u0301nn-a\u0301': '11151', 'si\u0304-se\u0300': '03195', 'lio\u0302ng-kut': '12139', 'tha\u0302u-ge\u0302': '12080', 'kua\u0300n-tsong': '03658', 'so\u0301-si\u0302': '12736', 'n\u0302g': '09251', 'kue\u0300 kio\u0302 khah tse\u0304 li\u0301 kia\u0302nn-lo\u0304o, tsia\u030Dh ia\u0302m khah tse\u0304 li\u0301 tsia\u030Dh bi\u0301. ': '60332', 'bu\u0302n-gia\u0302n': '00956', 'ue-a\u0301-tsha\u0300i': '09921', song: '12785', 'khuah-lo\u0300ng-lo\u0300ng': '12478', 'tshia-to\u0300ng': '03514', 'tha\u0300n-sai-khia': '09087', 'tseh-khui\u0300': '09857', 'sua-tsio\u030Dh-a\u0301-tshia': '05342', 'nia\u0304': '08034', 'kua\u0301n-ke-po\u0302': '10755', 'tshim-tshia\u0301n': '07573', 'pua\u0300nn-tsat': '01581', 'nia\u0301': '10950', 'nia\u0302': '05882', 'a\u0302ng-bi\u0304n': '05421', 'suann-io': '00483', 'gua\u0304-tiu\u0302nn': '01559', 'oo-tshui\u0300-pit-a\u0301': '06309', 'kho\u0301-kn\u0300g': '02681', 'khioh-si\u030Dp': '04070', 'beh-ni\u0302': '07508', 'kuann-ia\u0304m': '03379', 'the\u0301-thiap': '13349', 'la\u0302ng-ia\u0301nn': '00156', 'kia\u0301nn': '02134', 'la\u0304u-la\u0302ng m\u0304 ko\u0301ng-ko\u0301o, sia\u0300u-lia\u0302n m\u0304 bat po\u0301. ': '60170', 'la\u0302u-bue\u0301-ti\u0301ng': '11198', teh: '08794', 'tsui\u0301-ku': '01185', 'tso\u0301o-tsi\u0301': '04530', 'sio\u0302ng-sio\u0302ng': '07232', 'si\u0302ng-tsua\u0302n': '02481', 'pia\u0300nn-pu\u0301n': '08459', 'tsui\u0301-ke': '01202', 'tshenn-bi\u0304n-lia\u0302u-ge\u0302': '04593', 'ka\u0301ng-kiu\u0300': '12414', 'hu\u0304-ji\u0302n-la\u0302ng': '07166', 'thn\u0302g': '11861', 'm\u0304 tsai': '00986', sue: '06653', 'bi\u0301-a\u0300ng': '02821', 'li\u0302-pa': '13413', sua: '05326', sun: '05896', sui: '12578', suh: '07494', 'mua\u0302-tshiok-ji\u0301-a\u0301': '08149', sut: '07315', 'tho\u0300o-a\u0301-bue\u0301': '03638', 'thong-kan': '07965', 'ia\u0302m-tia\u0302nn': '13397', 'put-ha\u0300u': '00668', 'a\u0304m-kui': '12100', 'ia\u0300u-tia\u0301m': '05577', 'tuh-ka-tsue\u0304': '05303', 'pi\u0301ng-to\u0304o': '00943', 'po-kua': '11406', 'si\u0300n-ta\u0301u': '04771', 'bu\u030Dt-siu': '03312', 'sio-pun tsia\u030Dh u\u0304 tshun, sio-tshiu\u0301nn tsia\u030Dh bo\u0302 hu\u0304n.': '60212', 'pe\u030Dh-kha-te\u0302': '02000', 'bu\u0304-tsui\u0301': '13623', 'ta\u0304m-sa\u0301m': '07089', 'huat tshui\u0300-khi\u0301': '08765', 'ting-siu': '11065', 'hi\u0301-thiap': '08223', 'li\u0304-khui': '12746', 'sio\u0301ng-siann': '00552', 'pe\u0304nn-siunn-si': '06376', 'kun-huat': '05539', 'hue-kio\u0304': '04494', 'ta\u0300u-su\u0301n-tha\u0302u': '06895', 'mi\u0304-tsia\u0300': '13094', 'ki\u0304n-si\u0304': '04634', 'sueh-to-sia\u0304': '10865', 'ma\u0300i': '07838', 'bat-hue\u0300': '06066', 'senn-nn\u0304g': '01908', 'him-sio\u0301ng': '04319', 'tsio\u0300ng-tsa\u0302i': '07168', 'pua\u0300nn-khong-tiong': '01498', 'tui\u0300-tap': '10511', 'pi\u0300nn-khang': '13335', 'siu\u0304-kim': '10456', 'kenn-si': '09867', 'mn\u0302g-tsi\u0301n': '04635', 'im-hu\u0302n': '08094', 'tsi\u0300ng-to\u0301ng': '05075', 'tsia\u0300nn-mn\u0302g': '01741', 'tsing-khu\u0304': '07818', 'ti\u0301ng-tsin': '08074', 'phu\u030Dt-phu\u030Dt-thia\u0300u': '13593', 'khu\u0301n-pa\u030Dk': '06085', 'tshia\u0300u-ta\u0302m': '06491', 'tsun-bi\u0304ng': '11999', 'na\u0302-sik': '12637', 'hun-khui': '00744', 'hong-pia\u0304n': '00993', 'sit-su\u0304': '01726', 'kim-pn\u0301g': '04648', 'hioh-khu\u0300n': '09694', 'tia\u0301m-ki\u0300': '12499', 'sam-ka\u0300i-kong': '00399', 'ke\u0300-sn\u0300g': '05566', 'po\u0300o-im': '11160', 'tsui\u0301-to\u0304-tha\u0302u': '01129', 'tsha\u0300i-ta\u0304u': '08971', 'pa\u0302ng-thi\u0304nn': '12306', 'pe\u030Dh-sia\u0301n': '02044', 'ka-tsa\u0301u': '05495', 'ji\u0302n-khi\u0300': '00137', 'se\u0300-sio\u030Dk': '01348', 'hoo-io\u030Dk': '03767', 'tsi\u0301n-tsai': '10866', 'so\u0301o-tik-sue\u0300': '04103', 'kho\u0300-sio\u030Dk': '11589', 'pa\u0302i-thik': '07356', 'u\u0304-tang-si\u0302-a\u0301': '02552', 'khui-ki': '09225', 'tsu\u0302n-a\u0301': '07815', 'tsu\u0304n-thia\u0300nn': '06874', 'tshian-sua\u0301': '11535', 'u\u0304-kui\u0304': '02578', 'put-ka\u0301m-tong': '00734', 'be\u0304-sa\u0301i': '06666', 'tshun--e\u0302': '11958', 'te\u0301-lo\u0304o': '08832', 'la\u0302u-tshi\u0300n-kua\u0304nn': '05207', 'ta-ke-kuann': '00423', 'kha\u030Dk-tha\u0302m': '04825', 'sing-sa\u0301n': '01954', 'si\u0301-tse\u0300nn': '02573', 'siau-sit': '06293', 'hia\u0300n-hing': '07628', 'si\u0304 m\u0304 si\u0304, me\u0304 ka-ki\u0304. ': '60207', 'tsiu\u0304nn-ji\u0304m': '00306', 'ba\u0302-bui': '04902', '--ueh': '08189', 'tsu\u0304-li\u030Dp': '02661', 'bu\u0301-tshi\u0304': '04284', 'na\u0301-tshiu\u0304nn': '05502', 'sia\u0304u-hing-tsiu\u0301': '07798', 'tia\u0301nn-pinn-so\u0302': '10402', 'sio-tsiu\u0301-le\u0302': '11828', 'i\u0300-a\u0300i': '09489', 'tik-ke-a\u0301': '02828', 'tua\u0304-bo\u0301o': '00396', 'hueh-kn\u0301g': '02789', 'sing-li\u0301-tiu\u0302nn': '01957', 'tsha\u0300i-sim': '08961', 'bu\u0301-the\u0301': '01842', 'ke\u0301-sian-ke\u0301-tak': '06962', 'la\u0302ng e\u0302 tshui\u0300, am be\u0304 ba\u030Dt. ': '60043', lan: '07916', 'ka\u0304 thinn-kong tsioh ta\u0301nn. ': '60142', uann: '11566', 'ha\u0302ng-khong': '06593', 'li\u0302ng-ka\u0301m': '13380', 'ha\u0302ng-kau': '02708', 'bo\u0302-lia\u0301u-si\u0302': '08599', uang: '13119', 'ah-a\u0301-tan': '12131', 'phue-tsu\u0301n': '03254', 'i\u0300n-suat': '02191', '--nih': '03701', tsah: '07743', tsai: '12489', 'ha\u0301i-kiap': '06208', tsak: '13290', tsam: '04272', tsan: '12322', 'tn\u0301g a\u0304u-tha\u0302u': '12667', 'ko\u0300ng': '09523', tsat: '07744', 'kau-pue\u0302': '02086', 'i\u0300m-si\u0304nn-a\u0301': '11374', 'a\u030Dp-a\u0301': '07672', 'siu\u0301nn-tsi\u0302nn': '11500', 'thia\u0300nn-tha\u0300ng': '06384', 'kak-a\u0301': '07470', 'tsiu\u0301-au': '06907', 'kia\u0300-senn-a\u0301': '07173', 'iu\u0302nn-ho\u030Dk': '05158', 'kua\u0300n-a\u0301': '13370', 'ke-kang': '12696', 'tsi\u0302nn-kui\u0301': '12045', 'pha\u0301inn-khua\u0300nn': '01009', 'tsi\u0302nn-kui\u0304': '12059', 'go\u0304ng--e\u0302 ia\u0304 u\u0304 tsi\u030Dt ha\u0304ng e\u0304. ': '60391', 'pu\u0302n-hue\u0301': '11778', 'tsho\u0300ng-ki\u0301ng': '08248', 'o\u0301ng-hui\u0300': '04254', 'ha\u0301n-kia\u0300n': '03376', 'si\u030Dp-ji\u0304-lo\u0304o': '00102', 'tshah-ue\u0304': '08419', 'kia\u0301m-tsha\u0301i': '12227', 'ba\u0301n-kiu\u0300': '06061', 'sim-sng': '01148', 'tsui\u0301-to\u0304-tsui\u0301': '01127', 'tshu\u0301': '02453', 'sio\u0301-ji\u0302-kho': '00354', 'phoo-pa\u0302i-ue\u0304': '11557', 'ki\u0300m': '09807', 'ki\u0300n': '09838', 'be\u0302-lua\u0304n': '06778', 'king--khui': '00468', 'si\u0301-khut-a\u0301-tsui\u0301': '02553', 'tha\u0301n': '08548', 'kok-tiong': '07108', 'tha\u0301u': '08446', 'tshia\u0301n-kia\u0300n': '07558', 'jia\u0301u-lua\u0304n': '12533', 'sio\u0304ng tse\u0304': '00551', 'si\u0302ng-kong': '02474', 'la\u0304u--khi\u0300': '02649', 'tio\u0300ng-io\u0304ng': '00647', 'hok-li\u0304': '10700', 'tu\u0301-tshia\u0304ng': '03987', 'kia\u0302m-lia\u0302n-hi\u0302': '13118', 'tsu\u0304n': '06816', 'ma\u0300i-ko\u0301ng': '07861', 'pia\u0304n-ho\u0304o-su\u0304': '13202', 'tua\u0304-pa\u0304n': '00524', 'khi\u0301-tshu\u0300': '06759', 'ti\u0301ng-kue\u0300': '08090', 'kue\u0300-pa\u0302ng': '10223', 'tsa\u0300': '05191', 'tsa\u0301': '02446', 'ba\u030Dk-te\u0304': '01899', 'tshia-a\u0301-sua\u0300nn': '03427', 'bo\u0302-tsha': '08652', 'tsia\u030Dh-ki\u0301n lo\u0300ng-phua\u0300 ua\u0301nn. ': '60231', 'ho\u0304o-ti\u0304ng': '01169', 'ti\u0302m-ta\u0304ng': '03323', 'bo\u0304-a\u0301': '08352', 'la\u0302ng-pa\u0304n': '00158', 'po\u0301o-thi\u0304nn': '10055', 'so-tsha\u0301u': '07280', 'hu\u0300-ho\u0304o': '08324', 'su-bio\u0301': '05930', 'tha\u0302m-nua\u0304': '09799', 'tha\u0302u-tsi\u0302ng': '12092', 'pha-hng': '04096', 'lio\u030Dh-a\u0301': '07671', 'pa\u0302i-kiu\u0302': '07403', 'tia\u0301n-po\u0301': '05967', 'si\u0302-ke\u0300': '06082', 'tsha\u0300i-kue-po\u0300o': '08967', 'ho\u030Dk-gua\u0302n': '08356', 'ge\u0302-sia\u0302u': '13494', 'tsioh-mn\u0304g': '05771', 'sua\u0301-tsai': '07279', 'tsiu\u0304-a\u0301n-ne': '08331', 'tsu\u0304-kio\u0302ng': '02734', 'pah-ba\u0304n': '02774', 'kho\u0301-tshi\u0300': '02776', 'tshiu\u0301-bo\u0302o': '01158', 'ta\u0304i-li\u0301': '01368', 'pe\u030Dh-ku\u0301n-tsui\u0301': '02005', 'tsha\u030Dt-a\u0301': '10098', 'pho\u0300-siong-hong': '06432', 'bu\u0301-tshin': '01820', 'ka\u0301i-ui\u0302': '10059', 'tsha\u0300i-tshi\u0304-a\u0301': '08965', 'be\u0304-ko\u0301ng-tit': '06687', 'ku\u0304-sik': '12592', 'pi\u0302-pe\u0302': '08768', 'bi\u0304ng': '03708', 'kio\u0302ng-nge\u0304': '07238', 'po\u0304ng-piah': '09829', 'tio\u0304ng-bi\u0302n': '05549', 'to\u0301ng-a\u0300n': '12231', 'kiat-kio\u030Dk': '08876', 'tsu\u0304-tha\u0302u': '02814', 'ho\u0300ng-to\u0304ng': '04165', 'niu\u0302-sua\u0300nn sui phua\u0300, kut-keh gua\u0302n-tsa\u0304i. ': '60197', 'tho\u0301o-tho\u0301o': '02168', 'iu\u0300': '01656', 'ka\u0301u bo\u0302 hia\u0302m tsu\u0301-la\u0302ng sa\u0300n. ': '60191', 'tsia\u0300nn-tshiu\u0301-pi\u0302ng': '01692', 'kuai-kha\u0301': '03554', 'la\u0302u phi\u0304nn-tsui\u0301': '05219', 'ki\u0304ng-tsing': '13029', 'hua\u0301nn': '06028', 'sin-li\u030Dk': '09579', 'tsui\u0301-kui\u0304': '01198', 'thia\u0301n-khui': '05950', 'tua\u0304-khoo': '00505', 'po\u0301-un-pue': '04759', 'tsio\u030Dh-lu\u0301n': '01991', 'tsai-pue\u0302': '06149', 'ku\u0304-li\u030Dk': '12615', 'hi\u0302m-ta\u0301nn': '10688', 'pia\u0300n-kua\u0300': '13334', niau: '11939', 'hi\u0304nn-a\u0301': '02645', 'sik-khia': '13077', 'sia\u0301m-hong': '06867', 'ka-sa\u0300u': '04828', 'ha\u030Dp-ka': '02209', 'bo\u030Dk-sim-pang': '00867', 'kim-ta\u0301u-a\u0300ng-a\u0301': '04533', 'tshit-a\u0301': '04933', 'tsi\u0301ng-kah': '05023', 'to\u0301-hue\u0304-a\u0301': '05781', 'i\u0300-su\u0300': '09474', 'gue\u030Dh-la\u0304i-hong': '00855', 'tshn\u0302g-bu\u0301': '03173', 'tua\u0304-kha-ta\u0302ng': '00493', 'ke-bo\u0301': '12705', 'ti-bah': '11445', 'nn\u0301g-sim': '07936', 'ia\u0301-be\u0301': '08075', king: '09176', 'hu\u0304n--khi\u0300': '04225', 'sia\u0301u-ka\u0301u-tsi\u0300ng': '08746', siunn: '11284', 'lu\u030Dt': '04913', 'tshia\u0301ng-kha-ke': '12435', 'sia\u0301u-su\u0301': '00349', 'pa\u0301n-la\u0302': '04257', 'liu\u0301': '09170', 'm\u0301--a\u0301': '03786', 'hia\u030Dp-li\u030Dk': '03627', 'ha\u0301i-kue-tsi\u0301': '06189', 'ki\u0300m-to\u0302o': '09822', 'tiu\u0304-tsha\u0301u-la\u0302ng': '11297', 'tshing-khi\u0300': '07568', 'oo-a': '06337', 'siunn-si-a\u0301': '05275', 'kiat-pa\u0300i': '08886', 'tha\u0300u-sim-lia\u0302ng': '07941', 'ho\u0304o-sua\u0300nn': '04628', 'phue\u0302': '01863', 'phue\u0301': '13516', 'phue\u0300': '06810', 'phue\u0304': '07868', 'ho\u0301-i\u0300': '02390', 'bi\u0304n-io\u0302ng': '05634', 'sia\u0301nn-la\u0302ng': '07106', 'ni\u0302-bue\u0301 gi\u0301n-a\u0301': '02336', 'sio-jia\u0301ng': '05317', 'khuat-tia\u0301m': '06548', 'tha\u0302u-tsang-bue\u0301': '12121', 'pi\u0301-ka\u0300u': '01125', 'ui\u0301-thok': '03806', 'tia\u0304nn-kim': '03854', 'keh-piah tshin-ke, le\u0301-so\u0300o gua\u0302n-tsa\u0304i. ': '60333', 'khi\u0300-lia\u0301u-lia\u0301u': '01427', 'tok-ku': '07088', 'iu\u0300-siann': '01833', 'su\u0304': '03142', 'pha\u0301inn-u\u0304n': '01123', 'su\u0302': '12907', 'su\u0301': '02455', 'su\u0300': '11419', 'io\u030Dh-phi\u0300nn': '12877', 'a\u0301n-tsua\u0301nn': '05038', 'tsio\u0302ng': '07252', 'lo\u0304ng-tsu\u0301': '06180', 'ho\u0302ng-kiong': '05281', 'po\u030Dk-lo\u0304o': '11181', 'ho\u0304o-sin-hu\u0302': '13177', 'kui\u0301-to\u0304': '05565', 'siu\u0300-pa\u0302ng': '12596', 'pia\u0300nn-hue\u0300-te\u0301': '08482', 'u\u0302n': '00596', 'tse\u0301nn': '00576', 'te\u0300': '08551', 'te\u0301': '09060', 'te\u0302': '12775', 'te\u0304': '07865', 'u\u0304n-to\u0304ng-tia\u0302nn': '10241', 'sing-bi\u0302ng': '12342', 'tho\u0301o-ti\u030Dt': '00376', 'u\u0304-te\u0301': '02498', 'tsiu\u0301-khut-a\u0301': '06890', 'la\u0300u-pha\u0302u': '09981', 'bi\u0301-ke\u0300': '02794', 'khai-tsa-bo\u0301o': '09203', 'thih-la\u0302ng': '13168', 'tsi\u0301ng-li\u0301': '11708', 'kue\u0301-tshe\u0300': '10766', 'thuah-mn\u0302g': '05987', 'kha-sau-king-a\u0301': '10138', 'pau-tshi\u0304--e\u0302': '01595', 'tha\u0302u-khak': '12104', 'lo\u030Dk-im-ki': '12003', 'ta\u0301nn-tsah': '01688', 'the-si\u0302': '07445', 'tua\u0304-to\u0304o-kui': '00334', 'khe-ko-a\u0301': '09685', 'io\u0302ng': '09177', 'ta\u0304u-phue\u0302': '03431', 'kha-thui\u0301': '10152', 'na\u0301 m\u0304': '05830', 'tsiat-tse\u0300': '09853', 'tshiu\u0301-to\u0300ng': '01165', 'tui\u0300-ni\u0302': '10490', 'bo\u030Dk': '07837', 'po\u0300-tsua\u0301': '08295', 'ki\u0300ng': '09524', 'iu\u0302nn-hi\u0302n': '02717', 'kut-la\u030Dt': '06829', 'tso\u0304o-ka\u0300u': '03012', 'ki\u0300nn': '03399', 'an-ka': '02359', 'thiu-tshiam': '04190', 'hue\u0300-iu\u0304nn': '08012', 'tiu\u0304nn-kong': '00245', 'tshia\u0300ng': '07038', 'tsiap-tha\u0304i': '07381', hit: '03891', hiu: '04793', 'khai-ki': '09208', 'tshia\u0300nn': '05730', 'tshi\u0301ng-a\u0301': '08863', 'tha\u0300u-ni\u0302': '07951', 'sui-jia\u0302n': '12476', hia: '10317', 'ue\u0304-pha\u0304ng': '10167', 'pue\u030Dh': '03978', 'mia\u0302-pho\u0304o': '02274', 'pha\u0301inn-se\u0300': '01103', 'nua\u0304-tho\u0302o-mue\u0302': '13140', 'put-kua\u0301n-si\u0302': '00764', 'tio\u030Dh-tha\u0302u': '09047', 'an-hu\u0304n': '02321', 'tha\u0301n-a\u0301': '08553', 'iu\u0302-tshang': '04317', 'pi\u0304-bia\u0301n': '12458', 'pua\u0300nn-tiong-tsa\u0304m': '01439', 'gi\u0302-si\u0302n-gi\u0302-kui\u0301': '10684', 'senn-siu\u0300nn': '01934', 'tshio-ko': '13530', 'pua\u0300nn-ji\u030Dt': '01445', 'tha\u0300ng': '06696', tshan: '03705', tsham: '10560', 'su\u0302n-tsa': '03106', tshai: '07599', tshah: '08385', 'tsiu\u0304nn ta\u030Dh-pang, tsiu\u0304nn bi\u0302n-tshn\u0302g, bo\u0302 se\u0301 kha khu\u0300n tiong-ng. ': '60068', 'sann-kak-kho\u0300o': '00343', 'ka\u0302u': '08596', 'kam-gua\u0304n tso\u0300 gu\u0302, m\u0304 kiann bo\u0302 le\u0302 thang thua. ': '60127', 'hue\u0304-tiu\u0302nn': '09641', 'tia\u0304n-ia\u0301nn-hi\u0300-hn\u0302g': '10370', 'ho\u0301-khang': '02349', tshau: '11680', tshat: '10635', 'pe\u030Dh-thih-a\u0301': '02041', tshap: '08386', 'huan-tian': '08787', 'tsia\u030Dh-ta\u0300u': '05646', 'ji\u0301m': '03148', 'am-kha\u0300m': '07384', 'thia\u0304u-a\u0301': '13572', 'li\u0302ng-gia\u0304m': '13385', 'kha\u0301u-bi\u0304n': '00405', 'tshun bo\u0302ng pha\u030Dk-si\u0301 kui\u0301, ha\u0304 bo\u0302ng tso\u0300-tua\u0304-tsui\u0301. ': '60206', 'kho-ha\u030Dk': '05372', 'tshit--a\u0301 khah hi\u0300ng peh--a\u0301. ': '60037', 'n\u0300g': '02133', 'ui\u0302-tsiok': '12020', 'ti-hi\u0300': '11465', 'm\u0304 ho\u0301': '00910', 'tshu\u0300-pinn-tha\u0302u-bue\u0301': '05872', 'khai-kha\u0301u': '09182', 'phah-phu\u0301n': '04177', 'hioh-jua\u030Dh': '09705', 'kia\u0300-thok': '07186', 'tsha\u0300u-phui\u0300': '06584', 'io\u030Dh-tsha\u0301u': '12888', 'tse\u0302-tha\u0302u': '10988', 'pha-hi\u0302': '04112', 'sioh-mia\u0304-mia\u0304': '07270', 'kok-po\u0301': '07155', 'tsa\u0300n-tso\u0304o': '12915', 'tsa-bo\u0301o-sun': '05117', 'po\u030Dh-pa\u0301n-a\u0301': '12344', 'oo-tsin-tsu': '06297', 'ni\u0302-kuan': '02431', 'bo\u0302-tua\u0304-bo\u0302-se\u0300': '08603', 'ki\u0301-tsia\u0300n': '12353', 'kiat-tsi\u0301': '08862', 'sin-the\u0301': '03531', 'to\u0301-ui\u0304': '02907', 'lia\u0302u-a\u0301': '11058', 'pi\u0301ng-pe\u030Dh-ka\u0302inn': '00895', 'tshap-sia\u0302u': '08421', 'ta\u0301inn': '02114', 'hua\u0301n-i\u0300ng': '01188', 'ka-ji\u0302n': '03547', tiuh: '09504', 'tua\u0304-i\u0302': '00386', 'te\u0302-sim': '06567', 'tshe\u0302': '13585', 'ki\u0300-sia\u0300u': '06793', 'kio\u0304ng-beh': '07235', 'tha\u0300i-khong': '00984', 'hi\u0302-la\u0302n': '08172', 'hua\u030Dt-phuat': '05221', 'tiong-to\u0302o': '00728', pu: '05818', 'bu\u0301-tsi\u0302nn': '01823', 'kho\u0301o-li\u0304ng-a\u0301': '05500', '--ah': '03350', pa: '13517', 'phi\u0300ng-tshia\u0301nn': '09992', pe: '01658', 'bia\u0301u-si\u0304': '12641', 'tho\u0302-a\u0301': '06121', 'tsih-tsiap': '07398', pi: '09804', 'kang-la\u0302ng': '00226', po: '11383', 'ba\u030Dk-ham': '01962', 'tsa\u0301-khi\u0301': '02528', 'sui\u0302-pia\u0304n': '12039', 'tse\u0300-su\u0304': '07728', 'tsa\u0301u-su': '03441', 'la\u0304i-tho\u0300': '00702', 'bo\u0304ng-kho\u0300ng': '10469', 'io\u030Dh-pau': '12880', 'kui\u0300-ji\u0302n': '09072', 'hia\u030Dp-tsui\u0301': '05015', 'phah-tshenn-kiann': '04015', 'suann-kha': '00491', 'sa\u0300ng-ke\u0300': '06780', 'a\u0302ng-pau': '05405', 'tua\u0304 ua\u0301nn koh bua\u0301n ki\u0302nn. ': '60089', 'te\u0302-tsng': '06606', 'lia\u030Dh-tn\u0302g-po\u0301o-te\u0301': '07379', 'kia\u0300nn-siunn-a\u0301': '12955', 'ji\u0304-pa\u0302ng': '00115', 'kam-tsik': '06388', 'tshiu\u0304-ling-thn\u0302g': '11743', 'tsi\u0301ng-tu\u0300n': '11719', 'tshiu\u0304nn': '09059', 'pak-pi\u0302ng': '01452', 'pe\u030Dh-tha\u0302u-khok-a\u0301': '02026', 'ha\u0301i-mua\u0302': '06243', 'tsheh-tia\u0300m': '01342', 'tshiu\u0304-a\u0301': '11740', 'tse\u0300-bu\u0302n': '07719', 'thu\u030Dt-lu\u0302n': '07830', 'tsia\u030Dh--la\u0302ng': '05591', 'se\u0300-sio\u030Dk-la\u0302ng': '01350', 'a\u0304u-po\u0304o': '04949', 'siu-kiann': '02593', 'tshap ta\u0304i-tsi\u0300': '08392', 'tha\u030Dk-si\u0301-tsheh': '13269', 'thiann-tn\u0302g': '13414', 'ka\u0300u-io\u030Dk': '07369', 'li\u0302ng-lo\u0302-tiu\u0302-tua\u0304n': '10810', 'phio\u0300': '07708', 'ua\u0304nn-tsu\u0301n': '08487', 'se\u0300-ji\u0304': '07797', 'e\u0304-kok': '00559', 'tsua\u0301-lok-a\u0301': '06545', 'm\u0304-tsia\u0302nn-kia\u0301nn': '00920', 'tshiam-tann': '13019', 'ke\u0300nn': '07462', 'li\u0301-ka\u0301i': '07698', hiunn: '05590', 'thn\u0300g': '11918', 'koo-po\u0302': '03809', 'lo\u0304ng-ka\u0301u-sio-ka\u0304': '03182', 'tn\u0301g-kut': '12668', 'tha\u0302m-kua\u0300n': '09800', 'khi\u0301-tshi\u0300n-mo\u030Doh': '06758', 'pia\u0304n-mue\u0302-la\u0302ng': '04697', 'khui\u0300-la\u030Dt': '06178', 'uan-ke pia\u0300n tshin-ke. ': '60236', 'tsi\u0302ng-se\u0300': '07287', 'khang-khue\u0300': '00528', 'khi\u0300-bi\u0304': '06193', 'ta\u030Dh-pang': '11460', 'lap--lo\u030Dh': '09420', 'lia\u0302n-lui\u0304': '07985', 'la\u0304u-a-po\u0302': '02700', 'ha\u0304u-me\u030Dh': '05769', 'tann-pui\u0302': '11702', 'mn\u0302g-mn\u0302g-a\u0301 ho\u0304o lo\u030Dh-ku\u0301, tho\u0302o ma\u0304 e\u0304 ta\u0302m. ': '60367', 'si\u030Dh-ta\u0304ng': '10842', 'tang-o': '05503', 'tsit-lio\u0304ng': '11485', 'te\u0302-iu\u0302': '06591', 'pua\u030Dh': '09125', 'se\u0300 khang m\u0304 po\u0301o, tua\u0304 khang kio\u0300-kho\u0301o. ': '60274', 'sin-tshun': '09545', 'tsu\u0301-si\u0302': '00424', 'ka\u0301m-jia\u0301m': '09475', 'ku\u0301-ku\u0301': '00235', 'tsa-bo\u0301o-kia\u0301nn': '05114', 'ha\u0301u': '02982', 'u\u0300n-a\u0301': '09394', 'ha\u0301i': '06176', 'ha\u0301n': '03353', 'ha\u0301m': '11675', 'bu\u030Dt-li\u0301': '04374', 'ba\u0301ng-a\u0301-hiunn': '13050', 'na\u0301u-kin': '09980', 'hiann-ko': '01358', 'tui\u0300-sia\u0300u': '10520', 'huat-tiu\u0302nn': '04306', 'suann-bo\u0302ng': '00501', 'ji\u0302n-su\u0304': '00112', 'tsioh-tua\u0300': '05805', 'khau-hong': '09352', 'kua\u0304nn-tsui\u0301': '07346', 'hu\u0302n-jiah': '07699', 'ki-hue\u0304': '11758', 'ko\u0301ng-ko\u0300': '11067', 'ku-kha': '12148', 'si\u0301-bo\u0302ng': '02468', 'po\u0300o-tshi\u0304-a\u0301': '01703', 'se\u0300-kia\u0301nn': '07764', 'khua\u0300nn-hong-sui\u0301': '05352', 'hong-siann-po\u0300ng-ia\u0301nn': '05701', 'pau-tsio\u0301ng-te\u0302': '01600', 'tiu\u0304': '11275', 'tshut-tsu': '01528', 'khia\u0304-sn\u0300g': '07298', 'kin-le': '08900', 'tshiong-hua\u0304n': '03310', 'bi\u0302n-ia\u0302u': '01834', 'phah ho\u0301o lia\u030Dh tsha\u030Dt ia\u0304-tio\u030Dh tshin hiann-ti\u0304. ': '60186', 'ta\u0301nn-jia\u0301u': '01835', 'tsia\u0302nn-si\u030Dt': '10149', 'tn\u0302g-a\u0304m-lo\u030Dk': '04666', 'a\u030Dh-sa\u0301i': '05029', 'lia\u0302n-tsi\u0301': '11345', 'to\u0300 tia\u0300u bo\u0302 ba\u030Dk-tsui\u0301. ': '60235', 'tsi\u0300nn': '11309', 'suann-phia\u0302nn': '00356', 'kuan-sim': '12940', 'ba\u0304n-se\u0300': '09916', 'tsi\u0300ng': '12901', 'tso\u0300-huat': '06985', 'pa\u0304i-si\u0304n': '07413', 'bo\u0301o-tua\u0304-tsi\u0301, tse\u0304 kim kau-i\u0301. ': '60208', 'la\u0304ng-li\u0302ng': '03206', 'pn\u0304g-kheh-a\u0301': '09308', 'sa\u0301i-bue\u0301': '04883', 'kia\u0301u': '12849', 'ta\u0300nn-a\u0301-mi\u0304': '11693', 'tsho\u0300ng-tso\u0304': '08244', 'kia\u0301n': '12847', 'kia\u0301m': '08549', 'hu\u0302-tshah': '03198', 'pa-kiat': '01093', 'tai-a\u0301': '06455', 'an-thai': '02356', 'kann-lo\u0302': '10702', 'huat-i\u0301nn': '08778', 'pih-tshiu\u0301-n\u0301g': '11099', 'the\u0300-sik': '06731', 'tsn\u0300g': '13437', 'tsha\u0300i-iu\u0302': '08977', 'thi\u030Dh': '08194', 'ke\u0301-gi\u0302n-phio\u0300': '07014', 'ka\u0300i-sia\u0304u': '00727', 'ko\u0301ng tsi\u030Dt e\u0302 ia\u0301nn, senn tsi\u030Dt e\u0302 kia\u0301nn. ': '60369', 'siang-tshiu\u0301 pho\u0304 ha\u0302i-ji\u0302, tsiah tsai pe\u0304-bu\u0301 si\u0302. ': '60376', 'lia\u0304u-sio\u0301ng': '06074', 'ki\u0300-tsa\u0304i': '11695', 'bi\u0302n--tsi\u030Dt-e\u0304': '06403', 'tn\u0301g-se\u030Dh': '12674', 'tsan-a\u0301': '12337', 'to\u0304-su\u0304': '10187', 'kia\u0302nn-lo\u0304o-kang': '02782', 'pau-pa\u0304n': '01620', 'oo-ia\u0301nn': '06332', 'ua\u030Dh-kat': '05213', 'tua\u0300-tshiu\u0301': '07211', 'ha\u0304u-sia\u0300': '06134', 'tsi\u030Dt-lo\u0304o': '00035', 'pha\u0301inn-phiah': '01199', 'hi\u0302-ba\u0304ng': '08160', 'tho\u0301-tsia\u030Dh': '06756', 'tsi\u0301-hui': '05053', 'sia\u0301nn-hue\u0300': '07137', 'ka\u0301i-lio\u0302ng': '03247', 'tshi\u0301ng-an': '11444', 'ua\u0300n senn bo\u0302 ua\u0300n si\u0301. ': '60203', 'tsi\u0304n-lio\u0304ng': '10707', long: '13225', 'bi\u0301-hu\u0301n-tsha\u0301': '02721', 'hi\u0300': '04438', 'ke-kui': '12733', 'hi\u0302': '08109', 'tiu\u0302-pi\u0304': '13033', 'tsui\u0301-hun-tshue': '01201', 'bu\u0301-li\u0301': '10822', 'ta\u0300i-sue': '07230', 'ji\u0304n-lo\u0304o': '10878', 'pho\u0300ng-ting': '09821', 'bo\u0302 hi\u0302, he\u0302 ma\u0304 ho\u0301. ': '60300', 'tsun-tio\u0304ng': '08334', 'tsa\u0304i-te\u0304': '02172', 'sann-lia\u0301n-tshia': '00534', 'tshun-kiu': '02892', 'bi\u0301ng': '07597', 'i-sing': '12708', 'ia\u0301nn': '11051', 'ia\u0300u-li\u0301ng': '05568', 'ta\u030Dp-tih': '04315', 'la\u0302ng tse\u0304 ue\u0304 to\u0304 tse\u0304, sam sik la\u0302ng ko\u0301ng ngo\u0301o sik ue\u0304.': '60051', 'bi\u0301-tia\u0300m': '02685', 'ngia\u0302-si\u0302n': '04605', 'tho\u0301-lu\u0304n': '06797', 'tsin-tu\u0301-ho\u0301': '06414', 'tsit-si\u0300-la\u0302ng': '07945', 'thong-ti': '07963', 'khan-kong': '07604', 'ka\u0301-bah': '08875', 'khiu\u0304': '13586', 'khiu\u0301': '09508', 'khiu\u0302': '04499', 'li-li-lak-lak': '12768', 'kho\u0301o-sim': '05477', 'tsua\u0301-phio\u0300': '06536', 'khu\u0300n-bi\u0302n': '08822', 'hua\u0301n-kho\u0300ng': '00940', 'lu\u0304n-bu\u0302n': '11434', 'li\u030Dp-the\u0301': '02046', 'ba\u030Dk-kia\u0300nn-ji\u0302n': '02036', 'kang-ti\u0302ng': '00459', 'la\u0302u-phi\u0304nn': '05218', 'tsha\u0302-lia\u0302u': '06160', 'sit-siann': '01832', 'ia\u0301u-bue\u0304': '08621', 'tshit-ia\u0302': '00153', 'tua\u0304-ko\u0301ng-hia\u0302n': '00520', 'go\u0304ng-ka\u0302u': '13459', 'pia\u0304n-khua\u0300nn': '04694', 'kha\u0300m-ti\u0301ng': '05947', 'gi\u0304-li\u0301': '09863', 'iu\u0300-khi\u0301': '01818', 'tse\u0304-kua\u0300': '09873', 'tshiah-kha-sian-a\u0301': '03495', 'po\u0302-tsia\u0301': '07179', 'to\u0304o-kuan': '03283', 'kiu\u0300-ho\u0304o-tshia': '07450', 'tsi\u0302ng-su\u0304': '07300', 'tsui\u0301-kau': '01110', 'tsa\u0304m': '12934', 'tsha\u0301u-e\u0302': '06635', 'phang-bi\u030Dt': '10072', 'tsa\u0304i': '02138', 'tsha\u0302': '06101', 'tsha\u0301': '04335', 'tia\u0304m-tia\u0304m tsia\u030Dh sann ua\u0301nn-kong pua\u0300nn. ': '60204', 'tsa\u0304u': '03210', 'tui\u0300-tha\u0302u': '10523', 'su\u0304n-sua\u0300': '09292', 'tsu\u0302n-khua\u0301n': '02386', 'pha\u0301inn-thi\u0300-tha\u0302u': '00995', 'tsu\u0302n-tsa\u0304i': '02323', 'phui\u0300-that-a\u0301': '03120', 'sio-me\u0304': '05304', 'ti\u0301ng-u\u0302n': '08044', 'sam-tsa\u0302n-bah': '00519', 'kiu\u0302-sa\u0300i': '07647', 'tsa\u0300m-kha-po\u0304o': '12672', 'tia\u0304n-khi\u0300': '10352', 'm\u0304-kiann': '01219', 'pa\u030Dt-ji\u030Dt-a\u0301': '02989', 'gi\u0302ng-sim': '11629', 'kuan-kun': '04746', 'ha\u0302m-uan': '03005', 'lio\u030Dk-thiok': '00711', 'tsiu\u0301-me\u0302': '02408', 'ti\u0300ng-koo-ki': '06851', 'te\u0304-tha\u0301n': '02384', 'phi\u0302ng': '09057', 'khua\u0300nn-ki\u0300nn': '05347', 'siu\u0304nn-pue': '09108', 'tho\u0302o-sua': '09403', 'tshiong-kong': '01327', 'tsi\u0300ng-king': '01803', 'thiu-lo\u0300': '04198', 'uan-siu\u0302-la\u0302ng': '05744', 'ue\u0304 ho\u0301o ue\u0304 phue\u0302 bo\u0302 ue\u0304 kut, ti ji\u0302n ti bi\u0304n put ti-sim. ': '60303', 'tsa-a\u0300m': '05060', 'tshenn tsia\u030Dh to bo\u0302-ka\u0300u, na\u0301 u\u0304 thang pha\u030Dk-kuann. ': '60131', 'pun-phenn': '00666', 'se\u030Dh': '10886', 'tho\u0301o-tsi\u030Dh': '02176', 'ba\u0304n-ba\u0304n-a\u0301-si\u0304': '10553', 'bo\u0302 bi\u0301 u\u0304 tsing-khu\u0304, bo\u0302 kia\u0301nn pho\u0304 sin-pu\u0304. ': '60296', 'tsi\u0304ng-hiunn': '07567', 'hue-tsai': '04470', 'sia\u0304': '12405', 'sia\u0302': '03412', 'sia\u0301': '11039', 'sia\u0300': '07915', 'ka\u0301ng-tn\u0302g': '12427', 'bu\u0301-a\u0301-kia\u0301nn': '01696', 'ke-bue\u0301-tsui': '12718', 'ki\u0301ng-ka\u0300i': '13054', 'tsi\u0300-khi\u0300': '03190', 'koh-khah': '10944', 'tshe-ka\u0300': '05946', 'hue-tsha\u0300i': '04481', 'thuat-sin': '07821', 'kiann-kia\u0300n-sia\u0300u': '13333', 'pi\u0302n-to\u0304': '08003', 'ji\u0302-tshia\u0301nn': '02644', 'ke-kui-a\u0301': '12734', 'tsha\u0300i-tu\u0302': '09004', 'pha\u0301inn kue ka\u0304u-tsi\u0301, pha\u0301inn-la\u0302ng ka\u0304u gia\u0302n-gi\u0301. ': '60108', 'phi\u0304nn-tsui\u0301': '10976', 'gu\u0302-kak-hue': '01254', 'ju\u0302-tsha\u0301ng-tsha\u0301ng': '05998', 'ak-tsui\u0301': '03306', 'khong-si\u030Dp': '04429', 'pian--kue\u0300-la\u0302i': '03203', 'tsia\u0300n-tsing': '11701', 'ia\u0301nn-hi\u0300': '11082', 'se\u0300-put-lio\u0301ng-li\u030Dp': '10861', 'tsi\u030Dt e\u0302 la\u0302ng tsi\u030Dt khua\u0301n mia\u0304. ': '60032', 'hua\u0304nn-ke': '02516', 'tsia\u0302nn-la\u0302ng': '02458', 'la\u0300u-kau': '09908', 'the\u030Dh': '08384', 'ti\u030Dk-ji\u0302n': '11146', 'kho\u0301-li\u0304': '02795', 'khe\u030Dnnh': '08187', 'ko\u0301o-pa\u0301n': '01493', 'sio\u0304ng-ka\u0300i': '00510', 'ti\u0304-leh': '02922', 'pu\u0300n-so\u0300-tha\u0301ng': '12304', 'ta\u0300u-kha-tshiu\u0301': '06892', 'thiann bo\u0301o tshui\u0300, tua\u0304 hu\u0300-kui\u0300. ': '60387', 'tua\u0300-nia\u0301': '07245', 'khin-siann-se\u0300-sueh': '10933', 'ka\u0301u-a\u0301': '04353', 'thng-si\u0302-a\u0301': '08577', 'ka\u0300u-kang': '07107', 'tsha\u0301u-te\u0304': '06577', 'io\u0304ng-i\u0300': '01982', 'te\u0304-a\u0301': '07879', 'ing-tho\u0302': '13138', 'kio\u0302-tha\u0302u': '11765', 'po\u0301-kui\u0300': '12993', 'tso\u0301o-ga\u0304i': '04673', 'tha\u0302u-khak-ua\u0301nn': '12105', 'ue\u0304-sing': '11393', 'i-sing-kua\u0301n': '12711', 'po\u0301o-si\u030Dp': '10056', 'lia\u0304n-ji\u0304': '11321', 'pok-kua\u0300': '00114', 'pi\u0302n-hiat': '07954', 'ki\u0302-mia\u0304u': '03795', 'khia\u0304-mia\u0302': '07264', 'ta\u030Dk-ni\u0302': '07952', 'hua\u0304nn-sia\u0300u': '02568', 'u\u0304-tsi\u0302nn-la\u0302ng': '02582', 'tshut-suann': '01430', 'pha\u0300u': '05188', 'tsha\u0300i-hn\u0302g': '08991', 'huat-tia\u0301n': '08753', 'tsha\u0301m': '10530', 'li\u030Dk-ta\u0304u-kui\u0301': '10746', 'ti\u0300-i\u0300': '05439', 'tsha\u0301i': '10782', phenn: '02870', 'tsha\u0301u': '06560', 'tse\u0304-hio\u0300ng': '03044', 'siu\u0304-be\u0304-khi\u0301': '03677', 'pha\u0300n': '13416', 'gi\u0301n-a\u0301-hiann': '02156', 'pha\u0300i': '05183', 'tsit khe bo\u0302 hi\u0302, pa\u030Dt khe tio\u0300. ': '60278', 'i\u0302nn--la\u0302ng e\u0304 pi\u0301nn, pi\u0301nn--la\u0302ng e\u0304 i\u0302nn. ': '60314', 'pe\u030Dh-pn\u0304g': '01980', 'tshenn-tsha\u0301u-a\u0301-tia\u0300m': '04611', 'tsi\u030Dp--tsi\u030Dt-e\u0304': '13492', 'bi\u0304n-tsui\u0301': '05595', 'hue-tua\u0300nn': '04449', 'si\u0300-khoo-lia\u0300n-tn\u0301g': '01602', 'hu\u0301-hua\u0300': '10790', 'pat-kua\u0300': '00113', 'tshenn-tsha\u0301u-a\u0301-te\u0302': '04612', 'tha\u0300n ia\u0304-tio\u030Dh tha\u0300n, tsia\u030Dh ia\u0304-tio\u030Dh tsia\u030Dh. ': '60309', 'tsi\u0300ng-tsu': '10756', 'li\u0302ng-sia\u0300nn': '13381', giang: '09166', 'tsho\u0300ng-ti\u0304': '08224', 'o\u030Dh-ue\u0304': '11667', 'sia-khia\u0300m': '10862', 'ho\u0301-se\u0300': '02389', 'i\u0302ng-tsi\u0302nn': '09233', 'tsiam-tshui\u0300-ngeh-a\u0301': '02381', 'tsiann--gue\u030Dh': '01690', 'la\u0301u-pa\u0302i': '02752', 'tshau-hua\u0302n': '11717', 'kiu\u0300-hue\u0301': '07350', 'tso\u0301ng-pho\u0300o-sai': '12316', 'su\u0304-bu\u0304': '03574', 'nua\u0304-se\u0302': '13014', 'lo\u0302ng-bi\u0302n-li\u030Dk': '10205', 'hiu\u0302': '10022', 'hiu\u0300': '13618', 'i\u0300ng-tsha\u0300i': '12362', 'sam-tha\u0300i-tsu\u0301': '00272', 'khui-tsiann': '09194', 'po\u0300o-e\u0302': '01817', 'lo\u030Dk-ko\u0302o-mue\u0302': '10668', 'thiau-la\u0304ng': '05036', 'a\u0304u-tsik': '04952', 'ha\u0301i-ti': '06236', 'the\u0302-mia\u0302': '08394', 'iu\u0304-koh': '00155', 'ti\u0302ng-tshing': '11233', 'kheh-ue\u0304': '04904', 'bat-ji\u0304': '06036', 'u\u0302n-a\u0301-si\u0304': '00639', 'pho\u0300ng-sai-sai': '11910', 'ko\u0301ng hau-sia\u0302u-ue\u0304': '12436', 'hua\u030Dt-khia\u0304': '10804', 'kha-to': '10093', 'puah-ka\u0300': '11173', tau: '07326', 'hun-le\u0301': '07195', 'siu\u0301nn-tsn\u0304g': '11463', 'lo\u0304o-le\u0302': '13198', 'ka\u0300n': '09449', 'po\u0300-be\u0301-a\u0301': '08296', 'sui\u0301': '00824', 'ka\u0300u': '07343', 'khio\u0301ng-kiann': '06002', 'ta\u0300u-ko\u0301o': '06859', 'be\u0301-mia\u0304': '09089', tam: '11683', tan: '12263', 'tuan-tsi\u0300ng': '10736', tah: '09067', tai: '03028', tak: '13043', 'bia\u0301n-tsi\u0302nn-pn\u0304g': '02950', sip: '12238', siu: '02445', sit: '12559', 'tsi\u0302m-ko\u0301ng': '12644', 'sui\u0304': '12276', 'to\u0304o-kuai-a\u0301': '03383', 'lak-te\u0304-a\u0301': '11753', 'ke-nn\u0304g ba\u030Dt-ba\u030Dt ia\u0304 u\u0304 pha\u0304ng. ': '60378', 'pi\u0300n-pinn': '13407', sia: '10857', sik: '12902', 'pua\u030Dh-tha\u0301ng': '04104', 'thiu\u0301': '00567', 'sak-tsa\u0301u': '06040', sio: '05241', sin: '03409', sim: '00801', 'gui\u0302-ki': '02259', 'kia\u0300n-sia\u0300u tn\u0301g siu\u0304-khi\u0300. ': '60180', 'tso\u0304-ue\u0304': '08001', 'u\u0304 iu\u0304nn khua\u0300nn iu\u0304nn, bo\u0302 iu\u0304nn ka-ki\u0304 siu\u0304nn. ': '60164', 'ho\u0302o-si\u0302n': '05456', phuah: '11191', 'ba\u030Dk-ka\u0301u-tsiam': '01922', 'tsu\u0302n-tha\u0302u': '07832', 'bo\u0302-gua\u0304-ku\u0301': '08658', 'bi\u0302n-tsio\u0300ng': '01774', 'to-tiam': '00138', 'tshia\u0302': '07452', 'to\u0300ng-tso\u0300': '09788', 'tsu-io\u0301ng': '08697', 'hiu-hiu-kio\u0300': '04811', 'tsip-hi\u0302ng': '07118', 'hua\u0302nn-hua\u0302nn-kio\u0300': '12506', 'tshiah-kha': '03494', 'ho\u0302ng-khong-ho\u0302': '03450', 'oo-iu\u0301': '06270', 'ti\u0301ng-kong-kut': '08068', 'tsua\u0301-tia\u0302u': '06535', 'sit-tik': '01816', 'gi\u0301n-a\u0301-la\u0302ng kha-tshng sann ta\u0301u hue\u0301. ': '60143', 'thiu-tha\u0302u': '04170', 'iu\u0302-tshai': '09150', 'lo\u0301o-bah': '10613', 'la\u0302u-kha': '11211', 'sia\u0301m-khui': '06887', 'tsi\u0300ng-sik': '01712', 'ko-bi\u0302ng': '06854', 'gu\u0302-sut-a\u0301': '01269', 'ko\u0301o-tsik': '01634', 'ta\u0302ng-tse\u0302': '02254', 'ji\u0304-ue\u030Dh': '02405', 'tsa\u0304i-tsit': '02269', 'pau-a\u0301': '01457', 'tsah tsi\u0302nn': '07799', 'ti\u0302ng': '05517', 'pho\u0304ng-ko\u0301': '13055', 'gue\u030Dh-khi\u0302m': '01090', 'ia\u0301nn-phi\u0300nn': '11057', 'hue-na\u0302': '04495', 'ki\u0302-kiu\u0302': '05345', 'ke-ta\u0302i': '12694', 'tha\u0301ng-pua\u0302nn': '07484', 'su\u0301n-khang': '10579', 'kio\u0300-si\u0304': '01505', 'kn\u0301g-le\u0302-a\u0301-tsn\u0304g': '07441', 'kui\u0301': '06827', 'kui\u0300': '09061', 'ta\u0300i': '07201', 'kui\u0304': '10092', 'tsok-phi\u0301n': '02923', 'sua\u0301n': '11983', 'hip--si\u0301': '08935', 'ik-tshiah-sng': '09681', 'ui\u0304-ga\u0302m': '05453', 'tshia-tsa\u0304m': '03463', 'kia\u0301u-king': '08903', 'kiu\u0302-e\u0302': '07645', 'koo-put-ji\u0302-tsiong': '03784', 'tshua\u0300n-thong': '02934', 'thinn-ti\u0301ng thinn-kong, te\u0304-e\u0304 bu\u0301-ku\u0304-kong. ': '60100', 'ji\u030Dp-sua\u0301n': '00161', 'pua\u030Dh-to\u0301': '09148', 'sannh-sim': '09726', 'koo-tai': '12157', 'tshu\u0300n-tshioh': '00267', 'khan-si': '07636', 'tsha\u0300i-pau': '08964', siang: '12690', 'tsut-a\u0301': '03637', 'ji\u030Dp la\u0302ng mn\u0302g, su\u0304n la\u0302ng i\u0300. ': '60052', siann: '12325', 'bi\u0304n-si\u030Dk': '05685', 'ta\u0304u-ju\u0301': '03442', 'phua\u0300': '06401', 'tha\u0301n-khia\u0304': '03747', tshiau: '09507', tshiat: '00595', 'tiu\u0300nn-kua\u0302n-ke\u0300': '10674', tshiap: '03776', 'tsha\u0301u-koo': '06613', tshian: '11517', tshiam: '13297', 'huat-ta\u030Dt': '08774', tshiah: '12453', 'khuah-bo\u0301ng-bo\u0301ng': '12473', 'phi\u0300ng-le\u0301': '10001', 'tiu\u0304nn-m\u0301': '00357', 'si\u0302-kan': '06071', 'ta\u030Dk-ke': '07972', 'oo-ka\u0301u': '06284', 'jia\u0302u-sia\u0300': '13082', 'gue\u030Dh': '00812', 'ki\u0300m-khi\u0304': '09818', 'kim-kim-khua\u0300nn': '04582', 'tshin-ke': '11962', 'si\u0302': '12906', 'si\u0301': '02454', kauh: '13533', 'se-io\u030Dh-pa\u0302ng': '02862', 'thu\u0304n': '03034', 'si\u0304': '01868', 'lo\u0302ng-a\u0301': '13011', 'pe\u0304nn-tshn\u0302g': '06371', 'khioh-ki\u0301ng': '04197', 'ha\u030Dk-lia\u0302u': '11668', 'khua\u0300nn-ji\u030Dt': '05337', 'ia\u0301-ba\u0302n': '08108', 'hit-jiah': '03939', 'ho\u0304o': '04513', 'jia\u0301m': '05085', 'to\u0300-pi\u0301ng': '05745', 'bi\u0302n-i\u0302ng-hua\u0300': '01829', 'kan-tsi\u0302ng': '04857', 'tshn\u0300g-a\u0301': '02899', 'hue\u0301-thui\u0301': '01285', 'jia\u0301u': '01222', 'the\u0301-la\u030Dt': '13319', 'se\u0301-i\u030Dk': '05167', 'tua\u0304-ko': '00413', 'sio-tsenn': '05269', 'pue\u0304-bo\u0304ng': '07145', 'ba\u0304u': '09069', 'bo\u0302 ia\u0300u-ki\u0301n': '08648', 'ta\u030Dt-tit': '05773', 'tinn-ta\u0304u': '07679', 'kua\u0302nn--la\u0302ng': '08319', 'lia\u030Dp-tsik': '07795', 'jiu\u0302-to\u0304': '05129', 'kuah-a\u0302u': '08246', 'tui\u0300-a\u0301u': '10497', 'kua\u0300n-tha\u0302u': '13383', 'sai-tsio\u0300-ji\u030Dt': '02858', 'suat-bi\u0302ng': '10869', 'ba\u0304n': '09891', 'khang-tshu\u0300-king': '04407', siau: '11546', siat: '07873', siap: '12237', 'lo\u0302o-hi\u0302': '13443', 'tsu\u0301-kia\u0300n': '01337', 'pha\u0301inn-tshiu\u0301-jia\u0301u': '00864', 'tua\u0304n-tsua\u030Dt': '12532', 'tshit-niu\u0302-ma\u0301': '00131', 'king-a\u0301': '09189', 'ka-tsio\u0301ng': '10438', 'na\u0302-a\u0302u-ti\u0300-a\u0301': '12803', sian: '10285', siam: '13495', siak: '10532', 'tsha\u0300ng-tsui\u0301-bi\u0304': '12633', siah: '12023', 'tha\u030Dk': '13262', 'tha\u030Dh': '13248', 'koo-tuann': '03864', 'kue\u0300-to\u0304o': '10251', 'ok be\u0301 ok la\u0302ng khia\u0302. ': '60287', 'ha\u0304u-senn': '04940', 'gi\u0301ng': '05328', 'senn-a\u0301': '01884', 'lu\u0302n-ti\u030Dt': '11531', 'pho\u0301o': '12903', 'phua\u0300-ta\u0301nn': '06440', 'tsu\u0302n-tshiu\u0301nn': '07827', 'ki\u0304m': '03063', 'ki\u0304n': '04504', 'a\u0300m-king-a\u0301': '09643', 'lia\u030Dh-ko-siu\u0302': '07434', 'so\u0301o-tik': '04102', 'a\u0300n-me\u030Dh': '05047', 'ping-thn\u0302g': '02261', 'thuann-hua\u0300n': '13240', 'phah-kha-tshiu\u0300nn': '04061', 'tsu\u0304-la\u0302i-tsui\u0301': '02680', 'ti-tu': '10843', 'pa\u0304i-lo\u0304o': '07449', 'su-li\u030Dp': '03369', 'kia\u0300-senn-tha\u0302ng': '07174', 'ua\u0304nn-phoo': '08493', 'hia\u030Dp-iok': '03665', 'u\u0301n-mua\u0302': '12479', 'khok-tha\u0302u': '12538', 'tso\u0304o-sa\u0301n-su\u0304': '03015', 'tsio\u030Dh-tha\u0302u-a\u0301': '02025', 'hi\u0304nn-kau': '02783', 'tha\u0300n-tsi\u0302nn iu\u0301 so\u0300o, se\u0300nn-mia\u0304 a\u0300i ko\u0300o. ': '60310', 'se\u0300-ki\u0301': '01356', 'tshiu\u0304nn-tshenn-thi\u0302': '00381', 'ho\u030Dk-tsong': '04256', 'hue\u0301-tshi\u0301': '01280', 'phi\u0302n': '11942', 'tshi\u0300-pho': '03660', 'ji\u0304n-tsho\u0300': '10884', 'tiong-ng': '13644', 'se\u0300-ha\u0300n hua\u0302n-lo\u0301 i be\u0304 tua\u0304, tua\u0304-ha\u0300n hua\u0302n-lo\u0301 i be\u0304 tshua\u0304. ': '60276', 'tshia-phio\u0300': '03473', 'ta\u0304i-kah-khe pa\u0300ng tsha\u0301u-hi\u0302\u2014\u2014u\u0304 tsu\u0301n bo\u0302. ': '60082', 'tshuan-kiong': '00338', 'pha\u0301inn-ta\u0302ng-ku\u0304-siah': '01150', 'tsia\u030Dh-la\u0304u': '05607', 'u\u0304n-tsua\u0301n-tshiu\u0301': '10276', 'hong-hio\u0300ng': '00902', 'pi\u0304-tsa': '08178', 'tshi\u0300n-tsha\u0301i': '05774', 'la\u0304u-ka\u0302u': '02753', 'ui-gia\u0302m': '04864', 'tshia-pu\u0300n-ta\u0301u': '06051', 'ia\u0302m-sng': '13401', 'khui-sn\u0301g': '12398', 'ta\u0302u-ki': '03277', 'thau ni': '06984', 'lo\u0300ng': '06003', 'gua\u0304-kho': '01508', 'tsia\u0300nn-tshiu\u0301': '01689', 'suan-gia\u0302n': '04886', 'thi\u0300-tha\u0302u': '04774', 'tshah-pan': '08407', 'tsi\u0304n': '10689', 'lo\u0304o-po\u0302ng-si': '10233', 'tsin-tsu': '06422', 'king-li\u030Dk': '09877', 'tsai-eh': '03365', 'ta\u0304u-a\u0304nn': '03518', 'si-kue': '02852', 'tham-sim': '07935', 'phui\u0300-tha\u0302m': '03753', 'sian-pia\u0300nn-sian': '01344', 'ang-a\u0301-mi\u030Dh': '03089', 'tshu\u0300-kak-tsia\u0301u-a\u0301': '05843', 'siu-liu\u0302': '02523', 'sua\u0300n-tha\u0302u': '10832', 'tsha\u0301u-lia\u0302u-a\u0301': '06630', 'tio\u030Dh-tha\u0302ng': '09053', 'tshut-si\u0300': '01456', 'thinn-te\u0304': '00905', 'nah-phi\u0304nn': '01606', 'ti-tha\u0302u-phue\u0302': '11503', 'tshut-sin': '01485', 'li\u0304-pia\u0304n': '03002', 'tshut-sik': '01477', 'tsi\u0300n-hiunn': '09147', 'gia\u0304m': '13312', he: '08716', 'thia\u0300u-tsui\u0301': '10190', 'lia\u030Dh-ti\u030Dt': '07378', 'iu\u0301-i\u0300ng-kong': '02585', 'a\u0304m-nia\u0301': '12111', 'po\u030Dk-tsi\u0302ng': '12355', 'la\u0302u-nua\u0304': '05229', 'la\u0302u-ti-ko-nua\u0304': '05224', 'to\u0302o-su-kua\u0301n': '10463', 'kho\u0301-kuann': '02686', 'am-kue': '11524', sueh: '10856', 'he\u0304-lo\u030Dh': '00478', 'kui-khi\u0300': '07893', 'ki\u0304-tsua\u030Dt': '04124', 'ka\u0300i-tshioh': '09674', 'tsa\u030Dp-tsi\u0301ng-a\u0301': '12755', 'tsu\u0301-gi\u0304': '01376', 'io\u030Dh-tan': '12874', 'ha\u0304nn': '04505', 'to-sia\u0304': '02425', 'ha\u0304ng': '09246', 'the\u0300-ua\u0304nn': '08530', 'ko-tiau': '06901', 'tso\u0301ng': '12287', 'tsiu\u0300-tsha\u0300m': '03766', 'ling-bu\u0301-tshia': '01704', 'tui\u0300-tha\u0304i': '10499', 'tsia\u0300nn-pu\u0301n': '01702', 'put-tio\u0300ng-io\u0304ng': '00618', 'tso\u0301-a\u0301': '08516', 'kha\u0300u-pe\u0304': '05847', 'tsa\u0302i-po\u0301': '06807', 'tia\u0300u-ta\u0304u': '02227', 'ti\u0304-an': '04286', 'io\u0302ng-ma\u0304u': '05955', 'tsi\u0304n-tiong': '10703', 'toh-kha\u0300m': '06141', 'ki\u0300-le\u0304-a\u0301': '12019', 'ka-su\u0304': '05935', 'khong-kia\u0304n': '07231', 'khang-pa\u0302ng': '04404', 'pia\u0304n': '13164', 'lia\u0302ng-hong': '07514', 'hue\u0300-sik': '07955', 'thua\u0301nn tsha\u0301u': '09358', 'tsu\u0304-siu': '02710', 'o\u0304m': '05472', 'o\u0304o': '03397', 'ji\u0302n-a\u0300i': '00752', 'po\u0300o-ba\u030Dk': '01705', 'hua\u0304n-la\u0302ng': '01872', 'na\u0304-si\u0304': '05486', 'la\u030Dh-tia\u0302u': '13158', 'tho\u0302o-tsui\u0301': '09391', 'ang tshin bo\u0301o tshin, la\u0304u-po\u0302-a\u0301 pha-tshia-lin. ': '60250', 'kha-phi\u0304nn-lia\u0302m': '10153', 'hng-poo': '06674', 'hu-kun': '00933', 'khi\u0301-hong': '06757', 'pui\u0302-bah': '04452', 'ue\u0304-sing-tsua\u0301': '11394', 'pia\u0301u-kia\u0301nn': '07175', 'sio-si\u0302': '05315', 'a\u0300m-sik': '09618', 'hit-tsu\u0304n': '03932', 'ki\u0304ng': '09600', 'thong-phue': '07959', 'ho\u0304o-sua\u0300nn-tsat': '04629', 'hiong-ko\u0302ng': '02072', 'kha-sio\u030Dh': '10137', 'kio\u0300-tso\u0300': '01536', 'hiah-ni\u0304': '10261', 'siong-tio\u0304ng': '09351', 'phi\u0304nn-sa\u0301i-ko': '10984', 'tsi\u0300ng-tshik': '05055', 'ti\u0301ng-pue\u0300': '08097', 'ta\u0304ng-kia\u0302m': '05579', 'pha\u0300i-tha\u0302u': '05226', 'tshio-ke': '13532', 'to-tsi\u0302ng': '02371', 'pau-tsong': '01585', 'tio\u030Dh-tse': '09027', 'ki\u0301ng--ah ki\u0301ng, ki\u0301ng-tio\u030Dh tsi\u030Dt e\u0302 be\u0304 li\u0302ng-gi\u0301ng. ': '60288', 'tsi\u0300n-hua\u0300': '09135', 'pa\u0300ng-kang': '03991', 'an-li\u0302ng': '02432', 'gua\u0304-ti\u0304': '01549', 'so\u0300ng-sit': '08283', 'ha\u030Dp-ua\u0301': '02208', 'tsi\u030Dt tsiah sat-bo\u0301 po\u0300ng kah tsui\u0301-gu\u0302 tua\u0304. ': '60023', 'bi\u0301-su\u030Dt': '05431', 'sin-tshi\u0301ng': '02017', 'bo\u0301o': '05083', 'tsa\u0302i-bu\u030Dt': '06748', 'te\u0300nn-tshenn': '03555', 'kiat-sn\u0300g': '08911', 'hua\u0302nn': '12488', 'tsha\u0301u-ka\u0302u': '06611', 'kha\u0301u-im': '00406', 'thih-kut-a\u0301-senn': '13185', 'tsa\u0302n-ji\u0301m': '08556', 'kak-khi\u0301': '03513', 'pa\u0300ng ta\u0304ng-la\u0304i': '04076', 'sim-su\u0304': '00961', 'ta-khok-khok': '08668', 'ti\u030Dt-tsiap': '04408', 'tho\u0301o-hui\u0301': '00411', 'ji\u0304n-ti\u0304ng': '10868', 'ha\u0304-sui\u0301-thng': '00278', 'se-mn\u0302g-ting': '02854', 'ngia\u030Duh-ngia\u030Duh-so\u0302': '12647', 'sia\u0300u-lia\u0302n be\u0304-hia\u0301u siu\u0304nn, tsia\u030Dh-la\u0304u m\u0304-tsia\u0302nn-iu\u0304nn. ': '60102', 'a\u0301u-hueh': '10422', 'tn\u0304g-tsi\u0301ng': '12537', 'tang-si\u0302': '09785', 'suah--khi\u0300': '09729', 'tann-sa\u0301i': '11705', 'lia\u0301u': '00050', 'tsa\u030Dp-lia\u0304m ta-ke tshut ba\u0302n-phue\u0302 sin-pu\u0304. ': '60375', 'suann-bue\u0301-liu': '00326', 'lia\u0301n': '11511', 'mua\u0301-gue\u030Dh': '10605', 'kim-kiat-a\u0301': '04602', 'khoo-pua\u0300nn': '10735', 'bu\u0301-sing': '04285', 'tsha\u0301u-in': '06612', thut: '12485', thun: '02969', thui: '07492', thuh: '02439', 'tsio\u030Dh-tsing-khu\u0304': '01960', 'ko-hueh-ap': '06844', thua: '03979', 'u\u0304-khang-bo\u0302-su\u0301n': '02506', 'keh-pak': '10364', '--aih': '04797', 'ji\u030Dt': '00810', 'pit-lo\u0302-a\u0301': '02935', 'po\u0300o-tha\u0302u': '01825', 'ji\u030Dp': '00054', 'kha\u0301m-tsa\u0304m': '03052', 'gu\u0302-nn\u0302g': '01264', 'na\u0301-tio\u030Dh': '05861', 'se\u0301-sin-khu-king': '05156', 'tsiong-kun': '07185', 'thn\u0302g-tshiu\u0301nn': '11886', 'a\u0302ng-khi\u0304': '05419', 'an-tshah': '02383', 'khok-khok': '12540', 'huat-li\u030Dk': '04280', 'phi\u0302-ta\u0300n': '01961', 'ha\u0301i-tsha\u030Dt': '06229', 'bi\u0301-tha\u0302ng': '02825', 'kio\u0302ng': '11278', 'bu\u0302n-ta\u0300n': '00883', 'tn\u0301g--la\u0302i': '12665', 'tsa\u0304i-tso\u0304': '02211', 'bo\u0300ng': '11812', 'ka\u0300ng-lo\u030Dh': '05563', 'niu\u0302-sua\u0300nn': '07520', 'pho\u0300-hui\u0300': '06430', 'oo-ta\u0304u': '06278', 'kho\u0301-tshat': '02785', 'siau-bia\u030Dt': '06322', 'tam-iu': '11725', 'gue\u030Dh-kng-me\u0302': '00899', 'u\u0304 tsi\u030Dt ho\u0301, bo\u0302 nn\u0304g ho\u0301. ': '60157', 'kia\u0300-hu\u0300': '07172', 'pih-kho\u0300o-kha': '11124', 'a\u0300m-hi\u0304ng': '09619', 'khi\u0300-u\u0304n': '06230', 'io-kut': '09968', 'sin-su\u0304': '07756', 'huat-tsok': '08734', 'tsau-that': '12680', 'tshu\u0301-hng': '07844', 'i\u030Dk': '02052', 'ki-kang': '03237', 'n\u0302g-sik': '09265', 'ka\u0302m': '02972', 'kua\u0302n ke\u0300': '13018', 'kam-tsia\u0300-phoh': '02015', 'bong-bo\u0302-lo\u0304o': '10587', 'put-ho\u030Dk': '00676', 'la\u0300u-sia\u030Dh': '09935', 'tsiu\u0300nn-tsha\u0300i': '12745', 'tsheh-pau': '01331', 'bi\u0302n-tsu\u0301': '01695', 'tsia\u0300nn-pi\u0302ng': '01694', 'io-gi\u0301n-a\u0301-kua': '03373', 'sia\u0300n-to\u0304ng': '10660', 'tshiah-sng': '03688', 'oo-pan': '06310', 'kok-la\u0304i': '07109', 'se\u030Dh-ke': '10925', 'si\u030Dt-ke\u0300': '10519', 'tha\u0302u-lo\u0304o': '12110', 'si\u030Dk-sa\u0304i': '11228', 'tua\u0304-tsa\u0302ng': '00564', 'io-tua\u0300': '09969', 'hia\u030Dp-gi\u0304': '03698', 'tui-ka': '06721', 'sin-ke\u0300': '03510', 'iu-kat-kat': '11115', 'thiu-khau': '04194', 'e\u0304 pua\u030Dh tsiah e\u0304 tua\u0304. ': '60322', 'la\u0302m-ki\u030Dk': '04758', 'tsa\u0301u-thia\u0300u': '03497', 'hueh-lo\u0304o': '02779', 'sio\u0304ng-king': '10876', 'pha\u0301inn-ni\u0302-tang': '00912', 'hi\u0300-kio\u030Dk': '12213', 'tshia\u0302ng-tsui\u0301': '03309', 'lo\u0300ng tsing': '06093', 'pue\u0302-io\u0301ng': '07150', 'phah-pho\u030Dk-a\u0301': '04155', 'tshi\u0300-tha\u0300m': '10053', 'sin-tsi\u0300n': '09569', 'ta\u0302u-pio': '03274', 'sio\u030Dk-hue\u0300': '04755', 'gi\u0304-khi\u0300': '09858', 'kia\u0302m-soo-ke': '13104', 'kio\u0302ng-to\u0304': '07237', 'si\u0301-la\u0302ng': '02462', 'i\u0300-mi\u0304': '09501', 'lo\u0300-kha': '13485', 'tso\u0304-hua\u0300': '07939', 'bo\u0301ng tha\u0300n khah be\u0304 sa\u0300n. ': '60192', 'tsia\u030Dh-tshing-nia\u0301-pia\u0304n': '05647', 'tsit-a\u0301-hi\u0302': '12796', 'ki\u0301n-ba\u0304n': '10809', 'ta\u0302u-kho\u0300': '03276', 'phah-mua\u0302-tshiok': '04113', 'kioh-sia\u0300u': '09990', 'khi\u0300-phik': '06237', 'ba\u0302-tsui\u0300': '08163', 'a-tsik-a\u0301': '04567', 'la\u0304u-tua\u0304-la\u0302ng': '02628', 'khi\u0301-io\u030Dh-tshi': '06806', 'gia\u030Dh tha\u0302u sann tshioh u\u0304 si\u0302n-bi\u0302ng. ': '60289', 'sim-so\u0301ng': '01061', 'sian-sinn-niu\u0302': '02070', hiam: '12382', 'gia\u030Dt-sia\u0302u': '12996', 'ui\u0302-su-ku\u0302n': '08307', 'tsi\u0300ng-su': '12922', 'kui\u0300-tsua\u0301': '05046', 'ta\u0304ng-la\u0304i': '05535', 'la\u0304i-sann': '00696', 'be\u0304-ta\u0300ng': '06680', 'tia\u0300u-na\u0302': '02275', 'kn\u0301g': '10720', 'si-si-su\u030Dt-su\u030Dt': '11888', 'khua\u0300nn-u\u0304': '05343', 'tshiu\u0304nn-tsui\u0301': '00258', 'tiu\u0301nn': '04508', 'kui-bue\u0301': '07884', 'tsiong-thi\u0302ng': '07734', 'go\u0304o ki tsi\u0301ng-tha\u0302u-a\u0301 tshun--tshut-la\u0302i bo\u0302 pe\u0302nn tn\u0302g.': '60094', 'ku-khak-hue': '12146', 'tia\u0304n-ho\u0304o': '02895', 'ngo\u0302o-khi\u0302': '10073', 'iu\u0302nn-bo\u0301': '02652', 'phi\u0301n-hi\u0304ng': '04803', 'tsat-la\u030Dt': '09847', 'ha\u0302n-liu\u0302': '08332', 'sia\u0300-tsik-ji\u0304m': '03680', 'tshian-li\u0301-kia\u0300nn': '00344', 'pik-tshiam-si': '10282', 'ko-a\u0301-tha\u0302u': '11873', 'ki\u0300m-tshui\u0300': '09823', 'ke\u0301-ho\u0301-sue': '06975', 'thi\u0302ng-tsi\u0301': '06956', 'tsha\u0301u-he\u0302': '06633', 'pa\u0300ng-hu\u0302-a\u0301': '04109', 'teh-ki': '08815', 'lo\u0301o-bah-pn\u0304g': '10614', tshoo: '07740', 'tsia\u030Dh ua\u0301nn-la\u0304i, sueh ua\u0301nn-gua\u0304. ': '60229', 'sian-ji\u0302n': '01324', 'pa\u0300ng-tsi\u0304n-po\u0304ng': '04146', 'bo\u0301ng': '04431', 'ji\u030Dt--si\u0302-a\u0301': '01033', 'sua\u0304inn-a\u0301': '12224', 'tsue\u0304-ok': '09865', 'ua\u0302n-kong-mn\u0302g': '09416', 'lue\u0304-po\u0304o': '00729', 'si\u0300-ke\u0300-so\u0302': '01507', 'ba\u0301ng': '13042', 'kut-la\u030Dt tsia\u030Dh-la\u030Dt, pi\u0302n-tua\u0304nn thun nua\u0304. ': '60337', 'tsiat-bo\u030Dk': '09851', 'si\u0301-la\u0302ng-bi\u0304n': '02463', 'ki\u0300-si\u0300ng': '06746', 'thua-sa\u0301i-lia\u0302n': '04066', 'sue\u0300': '10855', 'te\u0300nn-sa\u0301i': '12273', 'tsha\u0300u-tha\u0302u-a\u0301 ma\u0304 e\u0304 tso\u0300 ho\u0302ng-te\u0300, tso\u0300 tso\u0301ng-tho\u0301ng li\u0301 ma\u0304 u\u0304 ki-hue\u0304. ': '60251', 'tsi\u0301ng-kah-tshuann': '05025', 'siu-sok': '02586', 'kang-lia\u0302u': '00517', 'tua\u0304-tsu\u0302n--ni\u0302': '00385', '--looh': '13224', 'sik-tsha\u0301i': '02735', 'tio\u0300ng-hong': '00697', 'tshiam iok': '12860', 'thuh-tho\u0302o-ki': '12501', 'tshiong-hiat': '01334', 'tsa\u0300nn': '01307', 'pua\u0302nn-tshia': '11253', 'tse\u0300-tsu\u0301': '09338', 'kua\u0304inn': '03975', 'bo\u0302-bo\u0301o-bo\u0302-ka\u0302u': '08643', 'hi\u0304nn-khang-kui\u0301-a\u0301': '02696', 'huat-hu\u0301n': '08755', 'ia\u0300-sia\u0304n': '10419', 'sat-phi\u0304nn': '09427', 'pha\u0301u-be\u0301': '09152', 'khiu\u0304nn-tshui\u0300': '11635', 'tha\u0302u-bi\u0304n': '12095', 'huan-sa\u0300ng': '13239', 'hio\u0302ng': '09242', 'tho\u0301o-tn\u0302g-tha\u0302u': '02244', 'ni\u0302-ha\u0304n': '02358', 'ing-kai': '12209', 'keh-ji\u030Dt': '10327', 'tsia\u0300u-khi\u0301-kang': '09755', 'tshia\u0302u-tshi\u030Dk': '11170', 'kui-bo\u0302o': '07904', 'tshi\u0300ng-sat': '10305', 'sam-tsa\u0302n': '00516', 'pha-ki\u0304n-lo\u0304o': '04059', 'keh-a\u0301': '12457', 'tsu\u0304-ki\u0301': '02627', 'to\u0300ng--leh': '11704', 'sio\u030Dk mi\u030Dh bo\u0302 ho\u0301 hue\u0300. ': '60200', 'a\u0300m-si\u0304': '09613', 'lo\u030Dh-sue': '09967', 'hueh-ap': '02816', 'tiong-la\u0302ng': '00600', 'a\u0300m-si\u0302': '09628', 'la\u0304i-gua\u0304': '00641', 'tsiap-ki': '07377', 'iau-kui\u0301 ke\u0301 se\u0300-ji\u0304. ': '60233', 'ha\u030Dp-li\u030Dk': '02140', 'sio\u0301-so\u0300o': '00521', 'kik-lo\u0301': '11796', 'lo\u0302ng-gia\u030Dp': '10258', 'la\u0302m-tsui\u0301': '07545', 'tha\u0302u-la\u0302ng': '12071', 'tshi-be\u0302': '09787', 'ti\u0302nn-kha-pua\u0300nn-tshiu\u0301': '13160', 'tua\u0304-ha\u0300n': '00504', 'kua\u0301n-ke': '10753', 'la\u0304u-sue\u0300': '10665', 'ka\u0301m--tio\u030Dh': '09488', 'ki-a\u0301-ping': '04221', 'to\u030Dk-io\u030Dh': '05181', 'oo-sik': '06271', 'tsha\u0302-mn\u0302g': '06137', 'oo-thn\u0302g-kue\u0301': '06341', 'lio\u0302-iu\u0302': '11158', 'go\u0304ng-tsi\u0302nn': '13462', 'u\u0301n': '12466', 'khan-thua': '07618', 'ji\u0304-nn\u0302g': '11916', 'kim-hu\u0301n': '04606', 'po\u0301o-thiap': '10064', 'khu\u0304-lo\u030Dk-po\u0304o': '05722', 'po\u0301o-tang': '10038', 'tsa\u0301u-sik': '03437', 'se\u030Dh-lin-long': '10916', 'la\u0300u-hong': '09960', 'tso\u0300-sa\u0301n-khui\u0300': '07017', 'ka\u0300i-tsa\u0304i': '00653', 'a-tso\u0301o': '04604', 'ko-le\u0302-tsha\u0300i-i\u0301nn-a\u0301': '06927', 'tsng-kha': '02401', 'tsi\u0304ng': '12030', 'a\u0304u-ta\u0304i': '04932', 'kam-tshng': '06386', 'tsi\u0304nn': '06555', 'tha\u0300i-pi\u0302ng': '00881', 'hi\u0302ng-sik': '03175', 'tiu\u0300nn-to\u0304o': '08936', 'ta\u0304u-tshiam': '03526', 'tsio-ang': '04094', 'gi\u0304-lu\u0304n': '13072', 'tshi\u0300-kik': '03693', 'ji\u030Dp-ka\u0300u': '00144', 'o\u0302ng-ia\u0302-tse\u0300': '01275', 'jio\u0304': '03071', 'liu\u0302-lua\u0302n': '06393' };

var mapping = {};
for (var key in old_mapping) {
  mapping[__WEBPACK_IMPORTED_MODULE_1_unorm___default.a.nfc(key)] = old_mapping[key];
}

var SoundsMapping = function () {
  function SoundsMapping() {
    _classCallCheck(this, SoundsMapping);
  }

  _createClass(SoundsMapping, null, [{
    key: 'map',
    value: function map(k) {
      return mapping[k.split('/')[0]];
    }
  }]);

  return SoundsMapping;
}();

/* harmony default export */ __webpack_exports__["a"] = (SoundsMapping);

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IapKha_css__ = __webpack_require__(836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IapKha_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__IapKha_css__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var IapKha = function (_React$Component) {
  _inherits(IapKha, _React$Component);

  function IapKha() {
    _classCallCheck(this, IapKha);

    return _possibleConstructorReturn(this, (IapKha.__proto__ || Object.getPrototypeOf(IapKha)).apply(this, arguments));
  }

  _createClass(IapKha, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'footer',
        { className: 'app footer inverted' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'ui stackable menu container inverted' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Link */],
            { className: 'item', to: '/about' },
            '\u95DC\u65BC\u672C\u7AD9'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: 'item', target: '_blank', href: 'https://www.facebook.com/ukauitaigi/' },
            'FB'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: 'item', target: '_blank',
              href: 'https://g0v-tw.slack.com/messages/itaigi/' },
            'Slack'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: 'item', target: '_blank', href: 'http://moe.kktix.cc/' },
            '\u840C\u5178\u677E'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: 'item', target: '_blank', href: 'http://g0v.tw/' },
            'g0v'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: 'item', target: '_blank',
              href: 'https://g0v.hackpad.tw/moed7ct-taigi-neologism' },
            'Hackpad'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: 'item', target: '_blank', href: 'https://github.com/g0v/itaigi' },
            'GitHub'
          )
        )
      );
    }
  }]);

  return IapKha;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (IapKha);

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bluebird__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SangTshut__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(21);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var superagent = __webpack_require__(26)(__webpack_require__(27), __WEBPACK_IMPORTED_MODULE_1_bluebird__["Promise"]);




var KiuKongHuat = function (_React$Component) {
  _inherits(KiuKongHuat, _React$Component);

  function KiuKongHuat(props) {
    _classCallCheck(this, KiuKongHuat);

    var _this = _possibleConstructorReturn(this, (KiuKongHuat.__proto__ || Object.getPrototypeOf(KiuKongHuat)).call(this, props));

    _this.state = {
      modalIsOpen: false
    };
    return _this;
  }

  _createClass(KiuKongHuat, [{
    key: '\u554F\u5916\u8A9E',
    value: function _(evt) {
      var _this2 = this;

      var 外語內容 = {
        '外語資料': this.props.華語關鍵字
      };
      superagent.post(__WEBPACK_IMPORTED_MODULE_4____["a" /* default */].加外語()).withCredentials().set('Content-Type', 'application/x-www-form-urlencoded').set('X-CSRFToken', this.props.csrftoken).send(外語內容).then(function (_ref) {
        var body = _ref.body;
        return _this2.openModal();
      }).catch(function (res) {
        console.log(res);
      });
    }
  }, {
    key: 'openModal',
    value: function openModal() {
      this.setState({ modalIsOpen: true });
    }
  }, {
    key: 'closeModal',
    value: function closeModal() {
      this.setState({ modalIsOpen: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var 華語關鍵字 = this.props.華語關鍵字;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'ui horizontal divider header' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'cloud upload icon' }),
          '\u6211\u60F3\u6B32\u77E5\u5F71\u6309\u600E\u8B1B'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'ui button large olive', onClick: this.問外語.bind(this) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'student icon' }),
          '\u6C42\u8B1B\u6CD5'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SangTshut__["a" /* default */], { modalIsOpen: this.state.modalIsOpen,
          closeModal: this.closeModal.bind(this) })
      );
    }
  }]);

  return KiuKongHuat;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (KiuKongHuat);


KiuKongHuat.propTypes = {
  華語關鍵字: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.string,
  csrftoken: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.string
};

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_modal__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_modal__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var customStyles = {
  overlay: {
    zIndex: '200'
  },
  content: {
    maxWidth: '400px',
    maxHeight: '180px',
    margin: 'auto'
  }
};

var SangTshut = function (_React$Component) {
  _inherits(SangTshut, _React$Component);

  function SangTshut() {
    _classCallCheck(this, SangTshut);

    return _possibleConstructorReturn(this, (SangTshut.__proto__ || Object.getPrototypeOf(SangTshut)).apply(this, arguments));
  }

  _createClass(SangTshut, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_react_modal___default.a,
        {
          contentLabel: 'SangTshut',
          isOpen: this.props.modalIsOpen,
          onRequestClose: this.props.closeModal.bind(this),
          style: customStyles },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h2',
          { ref: 'subtitle' },
          '\u5DF2\u4E0A\u50B3\uFF01'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          '\u6536\u5230\uFF01\u5728\u300C\u6211\u5F88\u6703\u300D\u7B49\u5F85\u8B1B\u6CD5\u4E2D......',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            onClick: this.props.closeModal.bind(this),
            className: 'ui button',
            style: { float: 'right' } },
          '\u597D\u5466'
        )
      );
    }
  }]);

  return SangTshut;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (SangTshut);

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_transmit__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_transmit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_transmit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_cookie__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LaiLik_LaiLik__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__HuatIm_HuatIm__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6____ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TuiIngHuaGi__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bluebird__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_debug__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Su_css__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Su_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Su_css__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var superagent = __webpack_require__(26)(__webpack_require__(27), __WEBPACK_IMPORTED_MODULE_8_bluebird___default.a);



var debug = __WEBPACK_IMPORTED_MODULE_9_debug___default()('itaigi:Su');

var Su = function (_React$Component) {
  _inherits(Su, _React$Component);

  function Su(props) {
    _classCallCheck(this, Su);

    var _this = _possibleConstructorReturn(this, (Su.__proto__ || Object.getPrototypeOf(Su)).call(this, props));

    _this.state = {
      按呢講好: props.按呢講好,
      按呢無好: props.按呢無好,
      voted: __WEBPACK_IMPORTED_MODULE_2_react_cookie___default.a.load('vote_' + props.suId)
    };
    return _this;
  }

  _createClass(Su, [{
    key: '\u6295\u7968',
    value: function _(evt) {
      if (__WEBPACK_IMPORTED_MODULE_2_react_cookie___default.a.load('vote_' + this.props.suId)) {
        alert('這句投過了!');
        return;
      }

      var 票 = {
        平臺項目編號: this.props.suId,
        decision: evt
      };
      superagent.post(__WEBPACK_IMPORTED_MODULE_3____["a" /* default */].投票()).withCredentials().set('Content-Type', 'application/x-www-form-urlencoded').set('X-CSRFToken', this.props.csrftoken).send(票).then(function (_ref) {
        var body = _ref.body;
        if (body.success) __WEBPACK_IMPORTED_MODULE_2_react_cookie___default.a.save('vote_' + body.suId, evt, { path: '/' });
      }).catch(function (res) {
        console.log(res);
      });
      if (evt === '按呢講好') this.setState({
        按呢講好: this.props.按呢講好 + 1,
        voted: evt
      });else if (evt === '按呢無好') this.setState({
        按呢無好: this.props.按呢無好 + 1,
        voted: evt
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          suText = _props.suText,
          suIm = _props.suIm,
          suId = _props.suId,
          貢獻者 = _props.貢獻者,
          按呢講好 = _props.按呢講好,
          按呢無好 = _props.按呢無好,
          按呢講的外語列表 = _props.按呢講的外語列表;

      if (貢獻者 == '匿名') 貢獻者 = '沒有人';

      var suImText = suText === suIm ? '' : suIm;

      var 按呢講的外語 = 按呢講的外語列表.map(function (外語) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__TuiIngHuaGi__["a" /* default */], { key: 外語.外語項目編號, 外語: 外語 });
      });
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'su ui card' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'left floated' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h2',
              { className: 'ui header' },
              suText
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__HuatIm_HuatIm__["a" /* default */], { 音標: suIm, hanji: suText }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6____["a" /* default */], { 來開例句: this.props.來開例句.bind(this) }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'description' },
            suImText,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__LaiLik_LaiLik__["a" /* default */], { 貢獻者: 貢獻者 }),
            '\u83EF\u8A9E\uFF1A',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'ui horizontal list large' },
              按呢講的外語
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'ui compact menu large' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { className: 'item' + (this.state.voted ? ' disabled' : ''),
                onClick: this.投票.bind(this, '按呢講好') },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'icon heart' }),
              '\u6309\u5462\u8B1B\u597D ',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'floating ui label yellow' },
                this.state.按呢講好 || 按呢講好
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { className: 'item' + (this.state.voted ? ' disabled' : ''),
                onClick: this.投票.bind(this, '按呢無好') },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'icon help circle' }),
              '\u6309\u5462\u602A\u602A ',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'floating ui label orange' },
                this.state.按呢無好 || 按呢無好
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'report' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { onClick: function onClick() {
                  var appVersion = navigator.appVersion;
                  var d = new Date();
                  var n = d.toISOString();
                  console.log('這條沒聲音\n' + '時間：' + n + '\n' + 'appVersion: ' + appVersion);
                } },
              '\uD83D\uDE4B \u9019\u689D\u6C92\u8072\u97F3'
            )
          )
        )
      );
    }
  }]);

  return Su;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_react_transmit___default.a.createContainer(Su, {
  initialVariables: {},
  fragments: {},
  shouldContainerUpdate: function shouldContainerUpdate(nextVariables) {
    return this.variables.詞 != nextVariables.詞;
  }
}));

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HuatIm_HuatIm__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LaiLik_LaiLik__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_debug__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var debug = __WEBPACK_IMPORTED_MODULE_5_debug___default()('itaigi:SuTsitPuann');

var SuTsitPuann = function (_React$Component) {
  _inherits(SuTsitPuann, _React$Component);

  function SuTsitPuann() {
    _classCallCheck(this, SuTsitPuann);

    return _possibleConstructorReturn(this, (SuTsitPuann.__proto__ || Object.getPrototypeOf(SuTsitPuann)).apply(this, arguments));
  }

  _createClass(SuTsitPuann, [{
    key: 'render',
    value: function render() {
      var _props$ = this.props.詞,
          文本資料 = _props$.文本資料,
          音標資料 = _props$.音標資料,
          貢獻者 = _props$.貢獻者;

      if (貢獻者 == '匿名') 貢獻者 = '沒有人';

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'su ui card' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'left floated' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h2',
              { className: 'ui header' },
              文本資料
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__HuatIm_HuatIm__["a" /* default */], { 音標: 音標資料 }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["a" /* default */], { 來開例句: this.props.來開例句.bind(this) }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'description' },
            音標資料,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__LaiLik_LaiLik__["a" /* default */], { 貢獻者: 貢獻者 })
          )
        )
      );
    }
  }]);

  return SuTsitPuann;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (SuTsitPuann);

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__KuahPau_css__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__KuahPau_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__KuahPau_css__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var KuahPau = function (_React$Component) {
  _inherits(KuahPau, _React$Component);

  function KuahPau() {
    _classCallCheck(this, KuahPau);

    return _possibleConstructorReturn(this, (KuahPau.__proto__ || Object.getPrototypeOf(KuahPau)).apply(this, arguments));
  }

  _createClass(KuahPau, [{
    key: 'componentDidmount',
    value: function componentDidmount() {
      $('.ui.sidebar').sidebar('hide');
      $('.ui.sidebar').sidebar('setting', 'onHide', function () {});
      $('.ui.sidebar').sidebar('setting', 'onVisible', function () {});
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { id: 'KuahPau', className: 'ui vertical fixed icon menu' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { className: 'item', onClick: this._onKuahPauClick },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'sidebar icon' })
        )
      );
    }
  }, {
    key: '_onKuahPauClick',
    value: function _onKuahPauClick() {
      $('.ui.sidebar').sidebar('toggle');
    }
  }]);

  return KuahPau;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (KuahPau);

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ToLam_images_dictionary_svg__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ToLam_images_dictionary_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ToLam_images_dictionary_svg__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




/*Pokeball by Arjun Mahanti from the Noun Project*/


var TshiuKiSuanTuann = function (_React$Component) {
  _inherits(TshiuKiSuanTuann, _React$Component);

  function TshiuKiSuanTuann() {
    _classCallCheck(this, TshiuKiSuanTuann);

    return _possibleConstructorReturn(this, (TshiuKiSuanTuann.__proto__ || Object.getPrototypeOf(TshiuKiSuanTuann)).apply(this, arguments));
  }

  _createClass(TshiuKiSuanTuann, [{
    key: 'render',
    value: function render() {
      var path = this.props.location.pathname;
      var menu_item_class = function menu_item_class(prefix) {
        if (path == prefix || path.startsWith(prefix + '/') || path === '/' && prefix === '/k') return 'item active';
        return 'item';
      };

      var itemClick = function itemClick() {
        $('.ui.sidebar').sidebar('hide');
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Link */],
          { className: menu_item_class('/k'), to: '/k', onClick: itemClick },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'sound icon' }),
          '\u600E\u6A23\u8B1B'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Link */],
          { className: menu_item_class('/t'), to: '/name', onClick: itemClick },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'question icon' }),
          '\u4F60\u7684\u540D\u5B57'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Link */],
          { className: menu_item_class('/t'), to: '/t', onClick: itemClick },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'unmute icon' }),
          '\u6211\u5F88\u6703'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Link */],
          { className: menu_item_class('/mia'), to: '/mia', onClick: itemClick },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'flag icon' }),
          '\u540D\u4EBA\u5802'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Link */],
          { className: menu_item_class('/tsing'), to: '/tsing', onClick: itemClick },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'student icon' }),
          '\u6B63\u898F\u5316\u5718\u968A'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Link */],
          { className: menu_item_class('/iong'), to: '/iong', onClick: itemClick },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'configure icon' }),
          '\u597D\u5DE5\u5177'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Link */],
          { className: menu_item_class('/tsu-te'), to: '/tsu-te',
            onClick: itemClick },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'i',
            { className: 'icon' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_2__ToLam_images_dictionary_svg___default.a })
          ),
          '\u53F0\u8A9E\u5BF6\u9451'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'down item' },
          '' /* dummy item to show last item border*/
        )
      );
    }
  }]);

  return TshiuKiSuanTuann;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (TshiuKiSuanTuann);

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_modal__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_transmit__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_transmit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_transmit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bluebird__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6____ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__HuatIm_HuatIm__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Su_TuiIngHuaGi__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9____ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10____ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11____ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12____ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__GuanKiann___ = __webpack_require__(108);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var superagent = __webpack_require__(26)(__webpack_require__(27), __WEBPACK_IMPORTED_MODULE_3_bluebird___default.a);

var debug = __WEBPACK_IMPORTED_MODULE_4_debug___default()('itaigi:例句表');

var 例句表 = function (_React$Component) {
  _inherits(例句表, _React$Component);

  function 例句表() {
    _classCallCheck(this, 例句表);

    return _possibleConstructorReturn(this, (例句表.__proto__ || Object.getPrototypeOf(例句表)).apply(this, arguments));
  }

  _createClass(例句表, [{
    key: '\u6309\u5462\u8B1B\u7684\u5916\u8A9E',
    value: function _() {
      if (!this.props.按呢講的外語列表) {
        return null;
      }

      return this.props.按呢講的外語列表.map(function (外語, i) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Su_TuiIngHuaGi__["a" /* default */], { key: i, 外語: 外語 });
      });
    }
  }, {
    key: '\u4F8B\u53E5',
    value: function _() {
      if (!this.props.例句列表) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          '\u8F09\u5165\u4E2D\uFF0C\u5C0F\u7B49\u4E00\u4E0B...'
        );
      }

      if (this.props.例句列表.length === 0) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10____["a" /* default */], null);
      }

      return this.props.例句列表.map(function (例句, i) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9____["a" /* default */], { key: i, 第幾句: i + 1, 例句: 例句 });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var customStyles = {
        overlay: {
          zIndex: '200'
        }
      };
      var _props = this.props,
          漢字 = _props.漢字,
          台羅 = _props.台羅;

      var 看例句 = !!(漢字 && 台羅);
      var 台羅文字 = 漢字 === 台羅 ? '' : 台羅;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_react_modal___default.a,
        {
          contentLabel: '\u4F8B\u53E5\u8868',
          isOpen: 看例句,
          onRequestClose: this.props.關例句.bind(this),
          style: customStyles
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h2',
          { ref: 'subtitle' },
          漢字,
          ' ',
          台羅文字,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__HuatIm_HuatIm__["a" /* default */], { 音標: 台羅 })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: '\u5206\u4EAB' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11____["a" /* default */], null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12____["a" /* default */], null)
          )
        ),
        '\u83EF\u8A9E\uFF1A',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'ui horizontal list large' },
          this.按呢講的外語()
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'ui very relaxed divided list' },
          this.例句()
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            onClick: this.props.關例句.bind(this),
            className: 'ui right floated button'
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'check icon' }),
          '\u6211\u77E5\u5F71\u77E3'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__GuanKiann___["a" /* default */], null)
      );
    }
  }]);

  return 例句表;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_react_transmit___default.a.createContainer(例句表, {
  initialVariables: {},
  fragments: {
    按呢講的外語列表: function _(_ref) {
      var 漢字 = _ref.漢字,
          台羅 = _ref.台羅;

      if (漢字 && 台羅) {
        return superagent.get(__WEBPACK_IMPORTED_MODULE_6____["a" /* default */].揣按呢講列表(漢字, 台羅)).then(function (_ref2) {
          var body = _ref2.body;
          return body.列表;
        }).catch(function (err) {
          return console.log(err), __WEBPACK_IMPORTED_MODULE_3_bluebird___default.a.resolve([]);
        });
      }

      return __WEBPACK_IMPORTED_MODULE_3_bluebird___default.a.resolve(undefined);
    },
    例句列表: function _(_ref3) {
      var 漢字 = _ref3.漢字,
          台羅 = _ref3.台羅;

      if (漢字 && 台羅) {
        return superagent.get(__WEBPACK_IMPORTED_MODULE_6____["a" /* default */].例句列表(漢字, 台羅)).then(function (_ref4) {
          var body = _ref4.body;
          return body.例句;
        }).catch(function (err) {
          return console.log(err), __WEBPACK_IMPORTED_MODULE_3_bluebird___default.a.resolve([]);
        });
      }

      return __WEBPACK_IMPORTED_MODULE_3_bluebird___default.a.resolve(undefined);
    }
  }
}));

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debug__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__css__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var debug = __WEBPACK_IMPORTED_MODULE_1_debug___default()('itaigi:漢字臺羅一詞');

var 漢字臺羅一詞 = function (_React$Component) {
  _inherits(漢字臺羅一詞, _React$Component);

  function 漢字臺羅一詞() {
    _classCallCheck(this, 漢字臺羅一詞);

    return _possibleConstructorReturn(this, (漢字臺羅一詞.__proto__ || Object.getPrototypeOf(漢字臺羅一詞)).apply(this, arguments));
  }

  _createClass(漢字臺羅一詞, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'ruby',
        null,
        this.props.臺羅,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'rt',
          null,
          this.props.漢字
        )
      );
    }
  }]);

  return 漢字臺羅一詞;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (漢字臺羅一詞);

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debug__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_debug__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var debug = __WEBPACK_IMPORTED_MODULE_1_debug___default()('itaigi:無例句');

var 無例句 = function (_React$Component) {
  _inherits(無例句, _React$Component);

  function 無例句() {
    _classCallCheck(this, 無例句);

    return _possibleConstructorReturn(this, (無例句.__proto__ || Object.getPrototypeOf(無例句)).apply(this, arguments));
  }

  _createClass(無例句, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'ui item' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          '\u7121\u4F8B\u53E5'
        )
      );
    }
  }]);

  return 無例句;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (無例句);

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var 複製例句鈕仔 = function (_Component) {
  _inherits(複製例句鈕仔, _Component);

  function 複製例句鈕仔(props) {
    _classCallCheck(this, 複製例句鈕仔);

    var _this = _possibleConstructorReturn(this, (複製例句鈕仔.__proto__ || Object.getPrototypeOf(複製例句鈕仔)).call(this, props));

    _this.state = { isCopying: false };
    return _this;
  }

  _createClass(複製例句鈕仔, [{
    key: '\u8907\u88FD\u4F8B\u53E5',
    value: function _() {
      var _this2 = this;

      var _props = this.props,
          漢字 = _props.漢字,
          臺羅 = _props.臺羅,
          華語 = _props.華語;

      this.setState({ isCopying: true });
      var textField = document.createElement('textarea');
      textField.innerText = 漢字 + '\n' + 臺羅 + '\n' + 華語;
      document.body.appendChild(textField);
      textField.select();
      document.execCommand('copy');
      textField.remove();

      var clock = setTimeout(function () {
        _this2.setState({ isCopying: false });
      }, 1000);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { onClick: this.複製例句.bind(this),
            className: 'ui compact icon button' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'copy icon' })
        ),
        this.state.isCopying && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          '\u8907\u88FD\u6210\u529F\uFF01'
        )
      );
    }
  }]);

  return 複製例句鈕仔;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

複製例句鈕仔.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  漢字: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  臺羅: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  華語: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string
};

/* harmony default export */ __webpack_exports__["a"] = (複製例句鈕仔);

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HuatIm_HuatIm__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__css__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_debug__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var debug = __WEBPACK_IMPORTED_MODULE_5_debug___default()('itaigi:顯示例句一句');

var 顯示例句一句 = function (_React$Component) {
  _inherits(顯示例句一句, _React$Component);

  function 顯示例句一句() {
    _classCallCheck(this, 顯示例句一句);

    return _possibleConstructorReturn(this, (顯示例句一句.__proto__ || Object.getPrototypeOf(顯示例句一句)).apply(this, arguments));
  }

  _createClass(顯示例句一句, [{
    key: 'render',
    value: function render() {
      var 漢字陣列 = [];
      var 臺羅陣列 = [];

      var _props = this.props,
          第幾句 = _props.第幾句,
          例句 = _props.例句;


      例句.綜合標音.map(function (標音) {
        漢字陣列 = 漢字陣列.concat(標音.漢字.split(' '));
        臺羅陣列 = 臺羅陣列.concat(標音.臺羅閏號調.replace(/--/g, ' --').split(' '));
      });

      var 句 = 漢字陣列.map(function (分詞, i) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["a" /* default */], { key: i, 漢字: 漢字陣列[i], 臺羅: 臺羅陣列[i] });
      });
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'ui item' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'ui large teal circular label' },
            第幾句
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__HuatIm_HuatIm__["a" /* default */], { 音標: 臺羅陣列.join(' ') }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["a" /* default */], {
            漢字: 例句.漢字,
            臺羅: 例句.臺羅,
            華語: 例句.華語 })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: 'le7ku3 tai5' },
          句
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: 'le7ku3 hua5' },
          '\uFF08',
          例句.華語,
          '\uFF09'
        )
      );
    }
  }]);

  return 顯示例句一句;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (顯示例句一句);

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_transmit__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_transmit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_transmit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HuatIm_HuatIm__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Su_TuiIngHuaGi__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bluebird__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_debug__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_debug__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var superagent = __webpack_require__(26)(__webpack_require__(27), __WEBPACK_IMPORTED_MODULE_6_bluebird___default.a);
var debug = __WEBPACK_IMPORTED_MODULE_7_debug___default()('itaigi:一个建議');

var 一个建議 = function (_React$Component) {
  _inherits(一个建議, _React$Component);

  function 一个建議() {
    _classCallCheck(this, 一个建議);

    return _possibleConstructorReturn(this, (一个建議.__proto__ || Object.getPrototypeOf(一个建議)).apply(this, arguments));
  }

  _createClass(一个建議, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          文本資料 = _props.文本資料,
          音標資料 = _props.音標資料,
          按呢講的外語列表 = _props.按呢講的外語列表;

      var 按呢講的外語 = 按呢講的外語列表.map(function (外語) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Su_TuiIngHuaGi__["a" /* default */], { key: 外語.外語項目編號, 外語: 外語 });
      });
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'ui su card' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'left floated' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h2',
              { className: 'ui header' },
              文本資料
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__HuatIm_HuatIm__["a" /* default */], { 音標: 音標資料 }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["a" /* default */], { 來開例句: this.props.來開例句.bind(this) }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'description' },
            音標資料,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
            '\u83EF\u8A9E\uFF1A',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'ui horizontal list large' },
              按呢講的外語
            )
          )
        )
      );
    }
  }]);

  return 一个建議;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_react_transmit___default.a.createContainer(一个建議, {
  initialVariables: {},
  fragments: {},
  shouldContainerUpdate: function shouldContainerUpdate(nextVariables) {
    return this.variables.文本資料 != nextVariables.文本資料 || this.variables.音標資料 != nextVariables.音標資料;
  }
}));

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_transmit__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_transmit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_transmit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HuatIm_HuatIm__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Su_TuiIngHuaGi__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bluebird__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_debug__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_debug__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var superagent = __webpack_require__(26)(__webpack_require__(27), __WEBPACK_IMPORTED_MODULE_6_bluebird___default.a);
var debug = __WEBPACK_IMPORTED_MODULE_7_debug___default()('itaigi:一个建議');

var 一个建議 = function (_React$Component) {
  _inherits(一个建議, _React$Component);

  function 一个建議() {
    _classCallCheck(this, 一个建議);

    return _possibleConstructorReturn(this, (一个建議.__proto__ || Object.getPrototypeOf(一个建議)).apply(this, arguments));
  }

  _createClass(一个建議, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          文本資料 = _props.文本資料,
          音標資料 = _props.音標資料,
          按呢講的外語列表 = _props.按呢講的外語列表;

      var 按呢講的外語 = 按呢講的外語列表.map(function (外語) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Su_TuiIngHuaGi__["a" /* default */], { key: 外語.外語項目編號, 外語: 外語 });
      });
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'ui su card' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'left floated' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h2',
              { className: 'ui header' },
              文本資料
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__HuatIm_HuatIm__["a" /* default */], { 音標: 音標資料 }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["a" /* default */], { 來開例句: this.props.來開例句.bind(this) }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'description' },
            音標資料,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
            '\u83EF\u8A9E\uFF1A',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'ui horizontal list large' },
              按呢講的外語
            )
          )
        )
      );
    }
  }]);

  return 一个建議;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_react_transmit___default.a.createContainer(一个建議, {
  initialVariables: {},
  fragments: {},
  shouldContainerUpdate: function shouldContainerUpdate(nextVariables) {
    return this.variables.文本資料 != nextVariables.文本資料 || this.variables.音標資料 != nextVariables.音標資料;
  }
}));

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__css__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__css__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var 複製連結鍵 = function (_React$Component) {
  _inherits(複製連結鍵, _React$Component);

  function 複製連結鍵(props) {
    _classCallCheck(this, 複製連結鍵);

    var _this = _possibleConstructorReturn(this, (複製連結鍵.__proto__ || Object.getPrototypeOf(複製連結鍵)).call(this, props));

    _this.state = { isCopying: false };
    return _this;
  }

  _createClass(複製連結鍵, [{
    key: 'handleClick',
    value: function handleClick() {
      var _this2 = this;

      this.setState({ isCopying: true });

      var textField = document.createElement('textarea');
      textField.innerText = decodeURIComponent(window.location.href);
      document.body.appendChild(textField);
      textField.select();
      document.execCommand('copy');
      textField.remove();
      var clock = setTimeout(function () {
        _this2.setState({ isCopying: false });
      }, 1000);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            onClick: this.handleClick.bind(this),
            className: '\u8907\u88FD\u9023\u7D50', title: '\u8907\u88FD\u9023\u7D50' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'icon linkify' })
        ),
        this.state.isCopying && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            '\u9023\u7D50\u5DF2\u8907\u88FD\uFF0C\u53EF\u8F49\u8CBC\u5206\u4EAB'
          )
        )
      );
    }
  }]);

  return 複製連結鍵;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (複製連結鍵);

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var 載入頁面 = function (_Component) {
  _inherits(載入頁面, _Component);

  function 載入頁面() {
    _classCallCheck(this, 載入頁面);

    return _possibleConstructorReturn(this, (載入頁面.__proto__ || Object.getPrototypeOf(載入頁面)).apply(this, arguments));
  }

  _createClass(載入頁面, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'main ui text container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'ui padded compact basic segment' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            '\u8F09\u5165\u4E2D\uFF0C\u5C0F\u7B49\u4E00\u4E0B...'
          )
        )
      );
    }
  }]);

  return 載入頁面;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (載入頁面);

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(20);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var About = function (_React$Component) {
  _inherits(About, _React$Component);

  function About() {
    _classCallCheck(this, About);

    return _possibleConstructorReturn(this, (About.__proto__ || Object.getPrototypeOf(About)).apply(this, arguments));
  }

  _createClass(About, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'main container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'about' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'ui very padded vertical segment' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'ui header large' },
              'iTaigi \u662F g0v \u96F6\u6642\u653F\u5E9C\u5C08\u6848',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { target: '_blank', href: 'https://moedict.tw' },
                '\u300C\u840C\u5178\u300D'
              ),
              '\u7684\u5EF6\u4F38\u5C08\u6848\uFF0C\u60F3\u77E5\u9053\u4E00\u500B\u8A5E\u7684\u53F0\u8A9E\u600E\u9EBC\u8AAA\uFF0C\u4F86\u9019\u88E1\u67E5\u5C31\u5C0D\u4E86\uFF01\u751A\u9EBC\u90FD\u53EF\u4EE5\u67E5\uFF0C\u4F46\u4E0D\u4E00\u5B9A\u67E5\u5F97\u5230\uFF0C\u67E5\u4E0D\u5230\u6642\u53EF\u4EE5\u767C\u554F\uFF0C\u6216\u8005\u81EA\u5DF1\u767C\u660E\u53F0\u8A9E\u8B1B\u6CD5\u8CA2\u737B\u7D66\u5927\u5BB6\uFF0C\u7C21\u55AE\u8AAA\u5C31\u662F\u300C\u81EA\u5DF1\u7684\u8FAD\u5178\u81EA\u5DF1\u7DE8\u300D\u3002'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'ui header large' },
              '\u4EE5\u4E0B\u7C21\u55AE\u8AAA\u660E\u7528\u6CD5\uFF1A'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'ui very padded vertical segment' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'ui header large' },
              '\u5728',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Link */],
                { to: '/t' },
                '\u300C\u600E\u6A23\u8B1B\u300D'
              ),
              '\u67E5\u8A62\u6846\u4E2D\u8F38\u5165\u60F3\u67E5\u7684\u300C\u83EF\u8A9E\u8A5E\u300D\uFF0C\u6309\u4E0B\u300C\u53F0\u8A9E\u600E\u9EBC\u8B1B\u300D\uFF0C\u6703\u51FA\u73FE\u5404\u7A2E\u8B1B\u6CD5\u3002'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'ui header large' },
              '\u6BCF\u4E00\u500B\u5C0D\u61C9\u7684\u53F0\u8A9E\u8A5E\u76EE\u662F\u4E00\u5F35\u7368\u7ACB\u7684\u5361\u7247\uFF0C\u986F\u793A\u767C\u97F3 play \u9375\u3001\u51FA\u8655\u53CA\u8A72\u53F0\u8A9E\u8A5E\u5176\u4ED6\u7684\u5C0D\u61C9\u83EF\u8A9E\u3002'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'ui very padded vertical segment' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'ui header large' },
              '\u5982\u679C\u89BA\u5F97\u9019\u500B\u8B1B\u6CD5\u4E0D\u932F\uFF0C\u53EF\u4EE5\u9EDE\u300C\u6309\u5462\u8B1B\u597D\u300D\u4F86\u6295\u8D0A\u6210\u7968\uFF0C\u5982\u679C\u89BA\u5F97\u9019\u500B\u7FFB\u8B6F\u4E0D\u662F\u5F88\u59A5\u7576\uFF0C\u53EF\u4EE5\u9EDE\u300C\u6309\u5462\u602A\u602A\u300D\u6295\u7591\u616E\u7968\u3002'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'ui header large' },
              '\u9019\u4E9B\u8A5E\u5F59\u7684\u6392\u5217\u9806\u5E8F\u6703\u4F9D\u6295\u7968\u7D50\u679C\u4F86\u5448\u73FE\uFF0C\u4F7F\u7528\u8005\u53EF\u53C3\u8003\u6295\u7968\u7D50\u679C\u9078\u7528\u8A5E\u5F59\u3002'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'ui very padded vertical segment' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'ui header large' },
              '\u5982\u679C\u5448\u73FE\u51FA\u4F86\u7684\u8B1B\u6CD5\u90FD\u4E0D\u6EFF\u610F\uFF0C\u53EF\u4EE5\u5728\u300C\u95A3\u6703\u4F7F\u6309\u5462\u8B1B\u300D\u8CA2\u737B\u4F60\u7684\u5275\u610F\u3002(\u96B1\u79C1\u6B0A\u8072\u660E\uFF1A\u82E5\u767B\u5165\u7CFB\u7D71\uFF0C\u6211\u5011\u6703\u8A18\u9304\u4F60\u8CA2\u737B\u7684\u6B21\u6578\u4E26\u986F\u793A\u5728\u300C\u540D\u4EBA\u5802\u300D)'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'ui header large' },
              '\u4E0D\u719F\u53F0\u8A9E\u6F22\u5B57\u53CA\u62FC\u97F3\u4E5F\u6C92\u95DC\u4FC2\uFF0C\u7528\u4F60\u7684\u65B9\u5F0F\u76E1\u53EF\u80FD\u8868\u9054\u4F60\u7684\u8B1B\u6CD5\uFF0C\u6703\u6709\u6B63\u898F\u5316\u5718\u968A\u5E6B\u5FD9\u4FEE\u6539\u6210\u6559\u80B2\u90E8\u516C\u544A\u7684\u6F22\u5B57\u548C\u81FA\u7F85\uFF0C\u5B8C\u6210\u6B63\u898F\u5316\u5F8C\u5C31\u6703\u51FA\u73FE\u5728\u7DB2\u7AD9\u4E0A\u4F9B\u5927\u5BB6\u6295\u7968\u3002'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'ui very padded vertical segment' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'ui header large' },
              '\u5982\u679C\u4F60\u67E5\u7684\u83EF\u8A9E\u8A5E\u6C92\u6709\u5C0D\u61C9\u7684\u53F0\u8A9E\uFF0C\u53EF\u4EE5\u9EDE\u9078\u300C\u6C42\u8B1B\u6CD5\u300D\uFF0C\u9019\u500B\u8A5E\u5C31\u6703\u51FA\u73FE\u5728',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Link */],
                { to: '/t' },
                '\u300C\u6211\u5F88\u6703\u300D'
              ),
              '\u5340\u57DF\uFF0C\u7B49\u5F85\u5176\u4ED6\u4F7F\u7528\u8005\u63D0\u4F9B\u8B1B\u6CD5\u3002\u6216\u8005\u4F60\u81EA\u5DF1\u7ACB\u523B\u5C31\u53EF\u4EE5\u63D0\u4F9B\u8B1B\u6CD5\uFF0C\u8ACB\u76F4\u63A5\u5728\u300C\u6211\u6703\u66C9\uFF0C\u6703\u4F7F\u6309\u5462\u8B1B\u300D\u5E95\u4E0B\u586B\u5165\u3002'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'ui very padded vertical segment' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'ui header large' },
              '\u672C\u5C08\u6848\u6301\u7E8C\u9032\u884C\u4E2D\uFF0C\u56FA\u5B9A\u65BC\u96D9\u6708\u4E00\u6B21\u7684',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Link */],
                { target: '_blank', to: 'http://moe.kktix.cc/' },
                '\u840C\u5178\u677E'
              ),
              '\u4E00\u8D77\u5DE5\u4F5C\uFF0C\u671F\u9593\u4E5F\u6703\u4E0D\u5B9A\u671F\u8209\u8FA6\u53F0\u8A9E\u677E\uFF0C\u6B61\u8FCE\u5404\u65B9\u597D\u624B\u52A0\u5165\u611B\u53F0\u8A9E\u7684\u884C\u5217\uFF0C\u4E00\u8D77\u8B1B\u53F0\u8A9E\u3001\u73A9\u53F0\u8A9E\uFF0C\u4E0D\u7BA1\u662F\u4E0D\u662F\u5DE5\u7A0B\u5E2B\u90FD\u53EF\u4EE5\u53C3\u8207\u5594\uFF01'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'ui very padded vertical segment' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'ui header large' },
              '\u6B61\u8FCE\u53F0\u8A9E\u9054\u4EBA\u5230\u300C\u6211\u5F88\u6703\u300D\u5340\u57DF\uFF0C\u8CA2\u737B\u4F60\u7684\u53F0\u8A9E\u5275\u610F\uFF0C\u70BA\u5927\u5BB6\u60F3\u51FA\u5404\u7A2E\u53F0\u8A9E\u8B1B\u6CD5\uFF01(\u96B1\u79C1\u6B0A\u8072\u660E\uFF1A\u82E5\u767B\u5165\u7CFB\u7D71\uFF0C\u6211\u5011\u6703\u8A18\u9304\u4F60\u8CA2\u737B\u7684\u6B21\u6578\u4E26\u986F\u793A\u5728\u300C\u540D\u4EBA\u5802\u300D)'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'ui header large' },
              '\u9664\u4E86\u4E00\u822C\u4F7F\u7528\u8005\uFF0C\u6211\u5011\u4E5F\u9700\u8981\u719F\u6089\u6559\u80B2\u90E8\u53F0\u8A9E\u6F22\u5B57\u548C\u81FA\u7F85\u7684\u670B\u53CB\uFF0C\u4E00\u8D77\u52A0\u5165\u6B63\u898F\u5316\u5718\u968A\uFF0C\u6709\u610F\u8005\u8ACB\u79C1\u8A0A',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Link */],
                { target: '_blank', to: 'https://www.facebook.com/ukauitaigi' },
                'iTaigi FB \u7C89\u5C08'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'ui very padded vertical segment' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'ui header large' },
              '\u672C\u7DB2\u7AD9\u7684\u8A9E\u97F3\u5408\u6210\u670D\u52D9\u7531',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { href: 'https://\u610F\u50B3.\u53F0\u7063/' },
                '\u610F\u50B3\u79D1\u6280'
              ),
              '\u7684\u53F0\u7063\u5AA0\u8072\u8A08\u5283\u63D0\u4F9B\uFF0C\u53F0\u7063\u5AA0\u8072\u63A5\u53D7',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { href: 'https://www.moc.gov.tw/' },
                '\u6587\u5316\u90E8'
              ),
              '\u8A9E\u8A00\u591A\u6A23\u6027\u53CB\u5584\u74B0\u5883\u88DC\u52A9\u3002'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'ui large' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
                src: 'https://mocfile.moc.gov.tw/mochistory/images/download/logo/moc/moc_logo1.png',
                width: '300px' })
            )
          )
        )
      );
    }
  }]);

  return About;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

// About.propTypes = {
//   params: React.PropTypes.object,
//   查怎樣講: React.PropTypes.func,
// };


/* harmony default export */ __webpack_exports__["a"] = (About);

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GuanKiann___ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Iong_css__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Iong_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Iong_css__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Iong = function (_React$Component) {
  _inherits(Iong, _React$Component);

  function Iong() {
    _classCallCheck(this, Iong);

    return _possibleConstructorReturn(this, (Iong.__proto__ || Object.getPrototypeOf(Iong)).apply(this, arguments));
  }

  _createClass(Iong, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'main container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'iong' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'ui stackable cards' },
            __WEBPACK_IMPORTED_MODULE_2__config__["a" /* list */].map(function (cate) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'card', key: cate.category },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'content' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'h3',
                    null,
                    cate.category
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'padded' },
                    cate.links.map(function (_link) {
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        { key: _link.link },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Link */],
                          { to: _link.link,
                            target: '_blank' },
                          _link.title
                        )
                      );
                    })
                  )
                )
              );
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__GuanKiann___["a" /* default */], null)
        )
      );
    }
  }]);

  return Iong;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Iong);

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return list; });


var list = [{
  category: '字辭典類',
  links: [{
    title: '萌典',
    link: 'https://www.moedict.tw/\'發穎'
  }, {
    title: '教育部《臺灣閩南語常用詞辭典》',
    link: ' http://twblg.dict.edu.tw/ '
  }, {
    title: '台文/華文線頂辭典',
    link: 'http://210.240.194.97/ungian/soannteng/chil/Taihoa.asp'
  }, {
    title: '臺日大辭典',
    link: 'http://minhakka.ling.sinica.edu.tw/taijittian/'
  }, {
    title: '廈門音新字典（甘字典）',
    link: 'http://taigi.fhl.net/dick/'
  }, {
    title: '廈英大辭典',
    link: 'http://minhakka.ling.sinica.edu.tw/bkg/chong-su-tian.php?gi_gian=hoa'
  }, {
    title: 'ChhoeTaigi 找台語',
    link: 'https://chhoe.taigi.info'
  }]
}, {
  category: '輸入法類',
  links: [{
    title: '教育部臺灣閩南語漢字輸入法',
    link: 'http://depart.moe.edu.tw/ed2400/cp.aspx?n=BB47AA61331DDAC8&s=5900082022C17E11'
  }, {
    title: '信望愛台語客語輸入法',
    link: 'http://taigi.fhl.net/TaigiIME/ '
  }, {
    title: '台語輸入法 （TAIGIME） (Android)',
    link: 'https://play.google.com/store/apps/details?id=fr.magistry.taigime'
  }, {
    title: '台語輸入法 - TaigIME 2 (Android)',
    link: 'https://play.google.com/store/apps/details?id=fr.magistry.taigime2'
  }, {
    title: 'Phah Tâi-gí 臺語輸入法 (Android)',
    link: 'https://play.google.com/store/apps/details?id=com.taccotap.phahtaigi'
  }, {
    title: 'Phah Tâi-gí 臺語輸入法 (iOS)',
    link: 'https://apps.apple.com/tw/app/phahtaigi-台語輸入法/id1455093650'
  }, {
    title: '羅漢跤台語輸入法 (iOS)',
    link: 'https://itunes.apple.com/tw/app/lohanka-tai-yu-shu-ru-fa/id1080190324'
  }]
}, {
  category: '學習類',
  links: [{
    title: '臺灣閩南語推薦用字700字詞',
    link: 'https://language.moe.gov.tw/files/people_files/700iongji_107.05.03.pdf'
  }, {
    title: '臺灣閩南語羅馬字拼音教學網',
    link: 'http://tailo.moe.edu.tw/'
  }, {
    title: '臺灣閩南語羅馬拼音及其發音學習網',
    link: 'http://www.ntcu.edu.tw/tailo/'
  }, {
    title: '咱來學臺灣閩南語',
    link: 'https://language.moe.gov.tw/files/people_files/tsuguan-book.pdf'
  }, {
    title: '講台語當著時(台語教學)',
    link: 'http://liztaigi.blogspot.com/2017/11/blog-post.html'
  }]
}, {
  category: '文章',
  links: [{
    title: '什麼，你也懂台語字？',
    link: 'http://liztaigi.blogspot.tw/2015/08/blog-post_31.html'
  }]
}, {
  category: '字型',
  links: [{
    title: '台灣楷體、台灣宋體',
    link: 'http://wesingkasu.blogspot.tw/2012/01/blog-post_1223.html'
  }, {
    title: '花園明朝',
    link: 'http://fonts.jp/hanazono/'
  }, {
    title: 'Charis SIL',
    link: 'http://software.sil.org/charis/'
  }, {
    title: 'Fira Sans',
    link: 'https://github.com/mozilla/Fira'
  }]
}];



/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_transmit__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_transmit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_transmit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GuanKiann_Tshue_Tshue__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5____ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6____ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7____ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bluebird__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Kong_css__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Kong_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Kong_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_debug__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_debug__);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var superagent = __webpack_require__(26)(__webpack_require__(27), __WEBPACK_IMPORTED_MODULE_8_bluebird___default.a);




var debug = __WEBPACK_IMPORTED_MODULE_10_debug___default()('itaigi:Kong');

var Kong = function (_React$Component) {
  _inherits(Kong, _React$Component);

  function Kong() {
    _classCallCheck(this, Kong);

    return _possibleConstructorReturn(this, (Kong.__proto__ || Object.getPrototypeOf(Kong)).apply(this, arguments));
  }

  _createClass(Kong, [{
    key: 'render\u7121\u95DC\u9375\u5B57',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6____["a" /* default */], null);
    }
  }, {
    key: 'render\u932F\u8AA4',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["a" /* default */], { 華語關鍵字: this.props.kongData.關鍵字,
        csrftoken: this.props.csrftoken,
        編號: this.props.編號, 漢字: this.props.location.query.漢字, 音標: this.props.location.query.音標,
        內容: this.props.kongData.內容 });
    }
  }, {
    key: 'render\u7121\u7D50\u679C',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["a" /* default */], { 華語關鍵字: this.props.kongData.關鍵字,
        csrftoken: this.props.csrftoken,
        pathname: this.props.location.pathname,
        編號: this.props.編號, 漢字: this.props.location.query.漢字, 音標: this.props.location.query.音標,
        內容: this.props.kongData.內容,
        開例句: this.props.開例句.bind(this) });
    }
  }, {
    key: 'render\u6709\u8B1B\u6CD5',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5____["a" /* default */], { 華語關鍵字: this.props.kongData.關鍵字,
        csrftoken: this.props.csrftoken,
        pathname: this.props.location.pathname,
        編號: this.props.編號, 漢字: this.props.location.query.漢字, 音標: this.props.location.query.音標,
        內容: this.props.kongData.內容,
        開例句: this.props.開例句.bind(this) });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'main container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'nav',
          { className: 'navigation fixbar' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__GuanKiann_Tshue_Tshue__["a" /* default */], _extends({
            defaultValue: this.props.params.k,
            查怎樣講: this.props.查怎樣講.bind(this)
          }, this.props))
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'kong content' },
          this.props.kongData.結果 > 0 ? this.render有講法() : this.props.kongData.結果 === 0 ? this.render無結果() : this.props.kongData.結果 === -1 ? this.render錯誤() : this.props.kongData.結果 === -2 ? this.render無關鍵字() : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
        )
      );
    }
  }]);

  return Kong;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Kong.propTypes = {
  params: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.object,
  kongData: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.object,
  查怎樣講: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.func
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_react_transmit___default.a.createContainer(Kong, {
  initialVariables: {},
  fragments: {
    kongData: function kongData(_ref) {
      var 關鍵字 = _ref.關鍵字;

      if (關鍵字 === undefined) {
        return __WEBPACK_IMPORTED_MODULE_8_bluebird___default.a.resolve({
          '結果': -2,
          '訊息': '沒有提供關鍵字'
        });
      }

      return superagent.get(__WEBPACK_IMPORTED_MODULE_7____["a" /* default */].揣列表(關鍵字)).then(function (_ref2) {
        var body = _ref2.body;
        return {
          '關鍵字': 關鍵字,
          '結果': body.列表.length,
          '內容': body
        };
      }).catch(function (err) {
        return {
          '關鍵字': 關鍵字,
          '結果': -1,
          '訊息': '發生錯誤',
          '內容': err
        };
      });
    }
  },
  shouldContainerUpdate: function shouldContainerUpdate(nextVariables) {
    return this.variables.關鍵字 != nextVariables.關鍵字;
  }
}));

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GuanKiann_ABo_ABo__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GuanKiann_GuaGi_GuaGi__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GuanKiann___ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GuanKiann___ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5____ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_debug__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_debug__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var debug = __WEBPACK_IMPORTED_MODULE_6_debug___default()('itaigi:Kong有講法');

var 有講法 = function (_React$Component) {
  _inherits(有講法, _React$Component);

  function 有講法() {
    _classCallCheck(this, 有講法);

    return _possibleConstructorReturn(this, (有講法.__proto__ || Object.getPrototypeOf(有講法)).apply(this, arguments));
  }

  _createClass(有講法, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'kongHuat' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: '\u5206\u4EAB' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            '\u54C7\uFF01\u539F\u4F86\u300C',
            this.props.華語關鍵字,
            '\u300D\u662F\u9019\u6A23\u5B50\u8B1B\u7684\uFF01\u5FEB\u5206\u4EAB\u7D66\u4F60\u7684\u670B\u53CB\u77E5\u9053\u5427'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__GuanKiann___["a" /* default */], { pathname: this.props.pathname })
        ),
        this.props.內容.列表.map(function (g) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__GuanKiann_GuaGi_GuaGi__["a" /* default */], { id: g.外語項目編號,
            key: g.外語項目編號, 新詞文本: g.新詞文本,
            csrftoken: _this2.props.csrftoken,
            編號: _this2.props.編號, 漢字: _this2.props.漢字, 音標: _this2.props.音標,
            華語關鍵字: _this2.props.華語關鍵字,
            開例句: _this2.props.開例句.bind(_this2)
          });
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5____["a" /* default */], {
          內容: this.props.內容,
          華語關鍵字: this.props.華語關鍵字,
          開例句: this.props.開例句.bind(this) }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'ui horizontal divider header' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'outline comments icon' }),
          '\u4F86\u8A0E\u8AD6 \u300C',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'ui pink header' },
            this.props.華語關鍵字
          ),
          '\u300D'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__GuanKiann___["a" /* default */], null)
      );
    }
  }]);

  return 有講法;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (有講法);

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GuanKiann_Tshue_Tshue__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GuanKiann_ABo_ABo__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GuanKiann_KiuKongHuat_KiuKongHuat__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__GuanKiann___ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__GuanKiann___ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_debug__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_debug__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var debug = __WEBPACK_IMPORTED_MODULE_7_debug___default()('itaigi:Kong無結果');

var 無結果 = function (_React$Component) {
  _inherits(無結果, _React$Component);

  function 無結果() {
    _classCallCheck(this, 無結果);

    return _possibleConstructorReturn(this, (無結果.__proto__ || Object.getPrototypeOf(無結果)).apply(this, arguments));
  }

  _createClass(無結果, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'tshueBo' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: '\u5206\u4EAB' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            '\u300C',
            this.props.華語關鍵字,
            '\u300D\u7684\u53F0\u8A9E\u8981\u600E\u9EBC\u8AAA\u5462\uFF1F\u4F86\u8003\u8003\u4F60\u7684\u670B\u53CB\u5427\uFF01'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__GuanKiann___["a" /* default */], { pathname: this.props.pathname })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'guaGi' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'ui su vertical segment' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'ui stackable cards' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'ui su card' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'content' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__GuanKiann_KiuKongHuat_KiuKongHuat__["a" /* default */], { 華語關鍵字: this.props.華語關鍵字,
                    csrftoken: this.props.csrftoken })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'ui su card' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'content' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'h3',
                    { className: 'ui horizontal divider header' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'cloud upload icon' }),
                    '\u6211\u6703\u66C9\uFF0C\u6703\u4F7F\u6309\u5462\u8B1B'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__GuanKiann_ABo_ABo__["a" /* default */], { 華語關鍵字: this.props.華語關鍵字,
                    csrftoken: this.props.csrftoken,
                    編號: this.props.編號, 漢字: this.props.漢字, 音標: this.props.音標
                  })
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["a" /* default */], {
          內容: this.props.內容,
          華語關鍵字: this.props.華語關鍵字,
          開例句: this.props.開例句.bind(this) }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'ui horizontal divider header' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'outline comments icon' }),
          '\u4F86\u8A0E\u8AD6 \u300C',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'ui pink header' },
            this.props.華語關鍵字
          ),
          '\u300D'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__GuanKiann___["a" /* default */], null)
      );
    }
  }]);

  return 無結果;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (無結果);

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FBTest_FBTest__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GuanKiann___ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bluebird__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_bluebird__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var superagent = __webpack_require__(26)(__webpack_require__(27), __WEBPACK_IMPORTED_MODULE_6_bluebird___default.a);

var debug = __WEBPACK_IMPORTED_MODULE_5_debug___default()('itaigi:Kong無關鍵字');

var 新詞區塊 = function (_React$Component) {
  _inherits(新詞區塊, _React$Component);

  function 新詞區塊() {
    _classCallCheck(this, 新詞區塊);

    return _possibleConstructorReturn(this, (新詞區塊.__proto__ || Object.getPrototypeOf(新詞區塊)).apply(this, arguments));
  }

  _createClass(新詞區塊, [{
    key: 'render',
    value: function render() {
      var loading = this.props.newWords.length === 0;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'ui horizontal divider header' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ui icon rocket' }),
          '\u71D2\u71D9\u71D9 \u53F0\u8A9E\u65B0\u8A5E'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'ui inverted segment \u71D2\u71D9\u71D9' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'ui ' + (loading ? 'active' : '') + ' dimmer' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'ui text loader' },
              '\u5C0F\u7B49\u4E00\u4E0B'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'header large ' + (loading ? 'loading' : '') }),
          this.props.newWords.map(function (su, i) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Link */],
              {
                className: 'ui black large button',
                style: { marginBottom: '0.25em' },
                to: '/k/' + su,
                key: i },
              su
            );
          }),
          this.props.isShowMore ? '' : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              className: '' + (loading ? 'loading' : 'ui button  large'),
              onClick: this.props.onShowMoreClick },
            '\u986F\u793A\u591A\u4E00\u9EDE'
          )
        )
      );
    }
  }]);

  return 新詞區塊;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var 無關鍵字 = function (_React$Component2) {
  _inherits(無關鍵字, _React$Component2);

  function 無關鍵字(props) {
    _classCallCheck(this, 無關鍵字);

    var _this2 = _possibleConstructorReturn(this, (無關鍵字.__proto__ || Object.getPrototypeOf(無關鍵字)).call(this, props));

    _this2.state = {
      newWordsLess: [],
      newWordsMore: [],
      isShowMore: false
    };

    _this2.onShowMoreClick = function () {
      _this2.setState({
        isShowMore: !_this2.state.isShowMore
      });
    };
    return _this2;
  }

  _createClass(無關鍵字, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this3 = this;

      superagent.get(__WEBPACK_IMPORTED_MODULE_4____["a" /* default */].揣上新貢獻的外語()).then(function (_ref) {
        var body = _ref.body;

        var newWords = body.列表.map(function (item) {
          return item.外語資料;
        });
        var newWordsLess = newWords.slice(0, 20);
        var newWordsMore = newWords.slice(0, 80);
        _this3.setState({
          newWordsLess: newWordsLess,
          newWordsMore: newWordsMore
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      // let hot = ['小屁孩', '秀下限', '白海豚', '躺著也中槍'];

      var newWords = this.state.isShowMore ? this.state.newWordsMore : this.state.newWordsLess;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'kong content' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(新詞區塊, { newWords: newWords,
          isShowMore: this.state.isShowMore,
          onShowMoreClick: this.onShowMoreClick }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__FBTest_FBTest__["a" /* default */], null)
      );
    }
  }]);

  return 無關鍵字;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (無關鍵字);

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GuanKiann_ABo_ABo__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GuanKiann___ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_debug__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var debug = __WEBPACK_IMPORTED_MODULE_3_debug___default()('itaigi:Kong錯誤');

var 錯誤 = function (_React$Component) {
  _inherits(錯誤, _React$Component);

  function 錯誤() {
    _classCallCheck(this, 錯誤);

    return _possibleConstructorReturn(this, (錯誤.__proto__ || Object.getPrototypeOf(錯誤)).apply(this, arguments));
  }

  _createClass(錯誤, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'kong content' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'ui segment' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            null,
            '\u627E\u300C',
            this.props.華語關鍵字,
            '\u300D\u932F\u4E86\u55CE\uFF1F'
          ),
          this.props.內容,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { className: 'ui button large olive' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'student icon' }),
            '\u6C42\u8B1B\u6CD5'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          null,
          '\u6211\u6703\u66C9\uFF0C\u6703\u4F7F\u6309\u5462\u8B1B'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__GuanKiann_ABo_ABo__["a" /* default */], { 華語關鍵字: this.props.華語關鍵字,
          csrftoken: this.props.csrftoken,
          編號: this.props.編號, 漢字: this.props.漢字, 音標: this.props.音標
        })
      );
    }
  }]);

  return 錯誤;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (錯誤);

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_transmit__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_transmit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_transmit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bluebird__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Mia_css__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Mia_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Mia_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_debug__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_debug__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var superagent = __webpack_require__(26)(__webpack_require__(27), __WEBPACK_IMPORTED_MODULE_3_bluebird___default.a);


var debug = __WEBPACK_IMPORTED_MODULE_6_debug___default()('itaigi:Mia');

var Mia = function (_React$Component) {
  _inherits(Mia, _React$Component);

  function Mia() {
    _classCallCheck(this, Mia);

    return _possibleConstructorReturn(this, (Mia.__proto__ || Object.getPrototypeOf(Mia)).apply(this, arguments));
  }

  _createClass(Mia, [{
    key: '\u540D\u6B21',
    value: function _(排名) {
      var classes = void 0;
      switch (排名) {
        case 1:
          classes = 'ui ribbon yellow label';
          break;
        case 2:
          classes = 'ui ribbon grey label';
          break;
        case 3:
          classes = 'ui ribbon brown label';
          break;
        default:
          classes = '';
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: classes },
        排名
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'mia main ui text container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'table',
          { className: 'ui celled unstackable table' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'thead',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tr',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'th',
                { className: 'collapsing' },
                '\u540D\u6B21'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'th',
                null,
                '\u8CA2\u737B\u8005'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'th',
                { className: 'collapsing' },
                '\u6578\u91CF'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'tbody',
            null,
            this.props.MiaData.名人.map(function (g, idx) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                { key: idx },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  _this2.名次(idx + 1)
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  g.名
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  g.數量
                )
              );
            })
          )
        )
      );
    }
  }]);

  return Mia;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Mia.propTypes = {
  params: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.object,
  查怎樣講: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.func
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_react_transmit___default.a.createContainer(Mia, {
  initialVariables: {},
  fragments: {
    MiaData: function MiaData() {
      return superagent.get(__WEBPACK_IMPORTED_MODULE_4____["a" /* default */].貢獻者表()).then(function (_ref) {
        var body = _ref.body;
        return body;
      }).catch(function (err) {
        return { '名人': [] };
      });
    }
  }
}));

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_transmit__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_transmit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_transmit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bluebird__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Mia_css__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Mia_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Mia_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_debug__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_debug__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var superagent = __webpack_require__(26)(__webpack_require__(27), __WEBPACK_IMPORTED_MODULE_3_bluebird___default.a);


var debug = __WEBPACK_IMPORTED_MODULE_6_debug___default()('itaigi:正規化');

var 正規化 = function (_React$Component) {
  _inherits(正規化, _React$Component);

  function 正規化() {
    _classCallCheck(this, 正規化);

    return _possibleConstructorReturn(this, (正規化.__proto__ || Object.getPrototypeOf(正規化)).apply(this, arguments));
  }

  _createClass(正規化, [{
    key: '\u540D\u6B21',
    value: function _(排名) {
      var classes = void 0;
      switch (排名) {
        case 1:
          classes = 'ui ribbon yellow label';
          break;
        case 2:
          classes = 'ui ribbon grey label';
          break;
        case 3:
          classes = 'ui ribbon brown label';
          break;
        default:
          classes = '';
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: classes },
        排名
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'mia main ui text container' },
        '\u82E5\u662F\u4F60\u5C0D\u6559\u80B2\u90E8\u6F22\u5B57\u4F6E\u53F0\u7F85\u8AA0\u719F\u624B\uFF0C\u6703\u7576\u52A0\u5165\u6B63\u898F\u5316\u5718\u968A\uFF0C\u505A\u4F19\u9B25\u6821\u5C0D\u5DE1\u55B2\u3002 \u7DCA\u4F86\u79C1\u8A0A\u554F',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { href: 'https://www.facebook.com/ukauitaigi/', target: '_blank' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'icon facebook square' }),
          'FB\u7C89\u5C08'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'table',
          { className: 'ui celled unstackable table' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'thead',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tr',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'th',
                { className: 'collapsing' },
                '\u540D\u6B21'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'th',
                null,
                '\u8CA2\u737B\u8005'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'th',
                { className: 'collapsing' },
                '\u6578\u91CF'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'tbody',
            null,
            this.props.MiaData.名人.map(function (g, idx) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                { key: idx },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  _this2.名次(idx + 1)
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  g.名
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  g.數量
                )
              );
            })
          )
        )
      );
    }
  }]);

  return 正規化;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

正規化.propTypes = {
  params: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.object,
  查怎樣講: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.func
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_react_transmit___default.a.createContainer(正規化, {
  initialVariables: {},
  fragments: {
    MiaData: function MiaData() {
      return superagent.get(__WEBPACK_IMPORTED_MODULE_4____["a" /* default */].正規化貢獻者表()).then(function (_ref) {
        var body = _ref.body;
        return body;
      }).catch(function (err) {
        return { '名人': [] };
      });
    }
  }
}));

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__The_css__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__The_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__The_css__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var The = function (_React$Component) {
  _inherits(The, _React$Component);

  function The() {
    _classCallCheck(this, The);

    return _possibleConstructorReturn(this, (The.__proto__ || Object.getPrototypeOf(The)).apply(this, arguments));
  }

  _createClass(The, [{
    key: 'render',
    value: function render() {
      if (!this.props.params.k) {
        var 排序 = this.props.location.query.order == 'new' ? 'new' : 'hot';
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["a" /* default */], {
          pathname: this.props.location.pathname,
          csrftoken: this.props.csrftoken,
          排序: 排序,
          欲提供講法: this.props.欲提供講法.bind(this) });
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["a" /* default */], {
          華語關鍵字: this.props.params.k,
          pathname: this.props.location.pathname,
          csrftoken: this.props.csrftoken,
          編號: this.props.編號,
          漢字: this.props.location.query.漢字,
          音標: this.props.location.query.音標 });
      }
    }
  }]);

  return The;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (The);


The.propTypes = {
  params: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.object
};

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_debug__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var superagent = __webpack_require__(26)(__webpack_require__(27), Promise);



var debug = __WEBPACK_IMPORTED_MODULE_3_debug___default()('itaigi:選單項目');

var 選單項目 = function (_React$Component) {
  _inherits(選單項目, _React$Component);

  function 選單項目(props) {
    _classCallCheck(this, 選單項目);

    var _this = _possibleConstructorReturn(this, (選單項目.__proto__ || Object.getPrototypeOf(選單項目)).call(this, props));

    _this.state = {
      顯示幾个: _this.預設顯示幾个(),
      外語列表: {
        列表: []
      },
      拿資料中: false,
      排序: null
    };
    return _this;
  }

  _createClass(選單項目, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.要看哪一種(this.props.排序);
    }
  }, {
    key: '\u8981\u770B\u54EA\u4E00\u7A2E',
    value: function _(排序) {
      var _this2 = this;

      if (this.拿資料中 || this.排序已經是這個(排序)) return;
      this.setState({
        拿資料中: true,
        顯示幾个: this.預設顯示幾个(),
        排序: 排序
      });

      __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* browserHistory */].replace('/t?order=' + 排序);

      superagent.get(__WEBPACK_IMPORTED_MODULE_1____["a" /* default */].揣無建議的外語(排序)).then(function (_ref) {
        var body = _ref.body;

        _this2.setState({
          拿資料中: false,
          外語列表: body
        });
      }).catch(function (err) {
        return {
          '列表': [],
          '訊息': '發生錯誤',
          '內容': err
        };
      });
    }
  }, {
    key: '\u6392\u5E8F\u5DF2\u7D93\u662F\u9019\u500B',
    value: function _(排序) {
      return this.state.排序 == 排序;
    }
  }, {
    key: '\u9810\u8A2D\u986F\u793A\u5E7E\u4E2A',
    value: function _() {
      return 200;
    }
  }, {
    key: '\u770B\u95A3\u8F03\u6FDF\u5168\u958B',
    value: function _() {
      var 顯示幾个 = this.state.顯示幾个;

      顯示幾个 += this.預設顯示幾个();
      this.setState({ 顯示幾个: 顯示幾个 });
    }
  }, {
    key: '\u770B\u95A3\u8F03\u6FDF',
    value: function _() {
      if (this.state.外語列表.列表.length > this.state.顯示幾个) return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        {
          className: 'ui button teal basic large no-border',
          onClick: this.看閣較濟全開.bind(this) },
        '\u986F\u793A\u95A3\u8F03\u6FDF'
      );
    }
  }, {
    key: '\u6309\u9215\u985E\u5225\u7D66\u9019\u500B',
    value: function _(排序) {
      return 'ui button teal large ' + (this.state.排序 == 排序 ? '' : 'basic');
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var 列表 = this.state.外語列表.列表.slice(0, this.state.顯示幾个);

      var 無建議的外語列表 = 列表.map(function (guaGi) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { key: guaGi,
            className: 'ui button basic large no-border',
            onClick: _this3.props.欲提供講法.bind(_this3, guaGi) },
          guaGi
        );
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'ui forum segment' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          null,
          '\u4F60\u60F3\u6311\u6230\u54EA\u4E00\u5340'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { className: this.按鈕類別給這個('hot'), onClick: this.要看哪一種.bind(this, 'hot') },
            '\u71B1\u9580'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { className: this.按鈕類別給這個('new'), onClick: this.要看哪一種.bind(this, 'new') },
            '\u6700\u65B0'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'spinner icon' }),
          列表.length > 0 ? '這些詞還沒有人會用台語講' : '真的很會，所有詞都有台語講法了！不可能啦快去想問題.....'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          無建議的外語列表,
          this.看閣較濟()
        )
      );
    }
  }]);

  return 選單項目;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (選單項目);

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GuanKiann_ABo_ABo__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GuanKiann___ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GuanKiann___ = __webpack_require__(108);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var 顯示一個問題 = function (_React$Component) {
  _inherits(顯示一個問題, _React$Component);

  function 顯示一個問題() {
    _classCallCheck(this, 顯示一個問題);

    return _possibleConstructorReturn(this, (顯示一個問題.__proto__ || Object.getPrototypeOf(顯示一個問題)).apply(this, arguments));
  }

  _createClass(顯示一個問題, [{
    key: 'render',
    value: function render() {
      var 對應講法網址 = 'k/' + this.props.華語關鍵字;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'main container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'the content' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: '\u5206\u4EAB' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              '\u300C',
              this.props.華語關鍵字,
              '\u300D\u7684\u53F0\u8A9E\u8981\u600E\u9EBC\u8AAA\u5462\uFF1F\u4F86\u8003\u8003\u4F60\u7684\u670B\u53CB\u5427\uFF01'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__GuanKiann___["a" /* default */], { pathname: 對應講法網址 })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'ui forum segment' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'ui header' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'cloud upload icon' }),
              '\u6211\u6703\u66C9\uFF0C\u300C',
              this.props.華語關鍵字,
              '\u300D\u6703\u4F7F\u6309\u5462\u8B1B'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__GuanKiann_ABo_ABo__["a" /* default */], { 華語關鍵字: this.props.華語關鍵字,
              csrftoken: this.props.csrftoken,
              編號: this.props.編號, 漢字: this.props.漢字, 音標: this.props.音標
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__GuanKiann___["a" /* default */], null)
        )
      );
    }
  }]);

  return 顯示一個問題;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (顯示一個問題);

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GuanKiann___ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var debug = __WEBPACK_IMPORTED_MODULE_4_debug___default()('itaigi:顯示選單');

var 顯示選單 = function (_React$Component) {
  _inherits(顯示選單, _React$Component);

  function 顯示選單() {
    _classCallCheck(this, 顯示選單);

    return _possibleConstructorReturn(this, (顯示選單.__proto__ || Object.getPrototypeOf(顯示選單)).apply(this, arguments));
  }

  _createClass(顯示選單, [{
    key: '\u8F09\u5165\u4E2D',
    value: function _() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'ui forum segment' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'spinner icon' }),
          '\u8F09\u5165\u4E2D\uFF0C\u5C0F\u7B49\u4E00\u4E0B'
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'main container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'the content' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: '\u5206\u4EAB' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              '\u5927\u5BB6\u4F86\u5B78\u53F0\u8A9E\uFF0C\u5927\u5BB6\u505A\u4F19\u4F86\u8C50\u5BCC\u53F0\u8A9E\uFF01\u5FEB\u5206\u4EAB iTaigi \u7D66\u4F60\u7684\u670B\u53CB\u77E5\u9053\u5427\uFF01'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__GuanKiann___["a" /* default */], { pathname: this.props.pathname })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["a" /* default */], {
            欲提供講法: this.props.欲提供講法.bind(this),
            排序: this.props.排序,
            renderLoading: this.載入中 })
        )
      );
    }
  }]);

  return 顯示選單;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (顯示選單);

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__json__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var debug = __WEBPACK_IMPORTED_MODULE_4_debug___default()('itaigi:抱去摸');

var 抱去摸 = function (_React$Component) {
  _inherits(抱去摸, _React$Component);

  function 抱去摸(props) {
    _classCallCheck(this, 抱去摸);

    var _this = _possibleConstructorReturn(this, (抱去摸.__proto__ || Object.getPrototypeOf(抱去摸)).call(this, props));

    _this.state = {
      佗一隻: undefined,
      揣: ''
    };
    return _this;
  }

  _createClass(抱去摸, [{
    key: '\u63DB\u4E00\u96BB',
    value: function _(名) {
      this.setState({ 佗一隻: 名 });
    }
  }, {
    key: '\u6488\u51FA\u5BF6\u8C9D',
    value: function _() {
      var _this2 = this;

      var 表 = __WEBPACK_IMPORTED_MODULE_2__json___default.a;
      var 揣 = this.state.揣;
      var 顯示 = [];
      var 三隻 = [];

      表.map(function (一隻, i) {
        if (一隻.includes(揣)) {
          三隻.push(一隻);
        }

        if (三隻.length === 3 || i === 表.length - 1) {
          顯示.push(三隻);
          三隻 = [];
        }
      });

      var 寶貝鈕 = 顯示.map(function (三隻, i) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["a" /* default */], { key: i, 寶貝名: 三隻,
          佗一隻: _this2.state.佗一隻, 換一隻: _this2.換一隻.bind(_this2) });
      });
      return 寶貝鈕;
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(evt) {
      if (evt.keyCode === 13) {
        this.查寶貝();
        return;
      }
    }
  }, {
    key: '\u67E5\u5BF6\u8C9D',
    value: function _() {
      var 揣 = this.refs.揣.value;
      if (揣 !== this.state.揣) {
        this.setState({ 揣: 揣 });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var 寶貝鈕 = this.撈出寶貝();
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'main container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'kong content \u5BF6\u53EF\u5922\u5916\u53E3' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'ui fluid action input huge container tshue' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
              type: 'text',
              placeholder: '\u4F8B\u5982\uFF1A\u9F8D\u3001\u5C0F\u706B\u9F8D',
              defaultValue: '',
              onKeyDown: this.handleKeyDown.bind(this),
              ref: '\u63E3',
              size: '8'
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'ui button huge teal',
                onClick: this.查寶貝.bind(this) },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'translate icon' }),
              '\u62B1\u53BB\u6478 Go'
            )
          ),
          寶貝鈕
        )
      );
    }
  }]);

  return 抱去摸;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (抱去摸);

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_transmit__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_transmit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_transmit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bluebird__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__css__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__GuanKiann_HuatIm_HapSing__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_debug__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vm__ = __webpack_require__(862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vm__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var superagent = __webpack_require__(26)(__webpack_require__(27), __WEBPACK_IMPORTED_MODULE_3_bluebird___default.a);




var debug = __WEBPACK_IMPORTED_MODULE_7_debug___default()('itaigi:名姓');

var 名姓 = function (_React$Component) {
  _inherits(名姓, _React$Component);

  function 名姓(props) {
    _classCallCheck(this, 名姓);

    var _this = _possibleConstructorReturn(this, (名姓.__proto__ || Object.getPrototypeOf(名姓)).call(this, props));

    _this.state = { Mia: '', Senn: '' };
    _this.entry = true;
    return _this;
  }

  _createClass(名姓, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.liah(this.props.params.senn, this.props.params.mia);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.liah(nextProps.params.senn, nextProps.params.mia);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'mia main ui text container ui fluid action input container tshue"' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          { onSubmit: this.tsha.bind(this) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', { htmlFor: 'senn' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { className: 'miasenn', type: 'text', name: 'senn', placeholder: '\u4F60\u7684\u59D3',
            defaultValue: this.props.params.senn, ref: function ref(input) {
              return _this2.senn = input;
            },
            onChange: function onChange(e) {
              return _this2.setState({ value: e.target.value });
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', { htmlFor: 'mia' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { className: 'miasenn', type: 'text', name: 'mia', placeholder: '\u4F60\u7684\u540D',
            defaultValue: this.props.params.mia, ref: function ref(input) {
              return _this2.mia = input;
            },
            onChange: function onChange(e) {
              return _this2.setState({ value: e.target.value });
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'submit', value: '\u600E\u9EBC\u5538\uFF1F',
            className: 'miasenn ui button teal', disabled: this.disabled() })
        ),
        this.show() && this.hapsing && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'mia main ui text container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'name-ruby' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'ruby',
              null,
              this.props.params.senn,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'rt',
                null,
                this.state.Senn
              ),
              this.props.params.mia,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'rt',
                null,
                this.state.Mia
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'hapsing' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__GuanKiann_HuatIm_HapSing__["a" /* default */], { 音標: this.state.Senn + ' ' + this.state.Mia })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'main ui text container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'siokausik' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', { className: 'tip-hr-name' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'strong',
              null,
              '\u6EAB\u99A8\u63D0\u9192\uFF1A\u53EA\u80FD\u67E5\u59D3\u540D\uFF0C\u5426\u5247\u53EF\u80FD\u6703\u5F97\u5230\u932F\u8AA4\u767C\u97F3\uFF01'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h1',
              { className: 'siokausik' },
              '\uD83D\uDCAF\u53F0\u8A9E\u5C0F\u6559\u5BA4\uD83D\uDCAF'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h2',
              { className: 'siokausik' },
              '\u59D3\u540D\u767C\u97F3\u901A\u5247\uFF1A'
            ),
            '\u53F0\u8A9E\u6F22\u5B57\u5E38\u6709\u591A\u7A2E\u767C\u97F3\uFF0C\u59D3\u540D\u767C\u97F3\u901A\u5247\u70BA\uFF1A\u59D3\u7528\u767D\u8A71\u97F3\u3001\u540D\u7528\u6587\u8B80\u97F3\u3002',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h2',
              { className: 'siokausik' },
              '\u4EE5\u4E0A\u898F\u5247\u7576\u7136\u4E5F\u6709\u4F8B\u5916\uFF1A'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'siokausik' },
              '\uD83D\uDC49\u59D3\u7684\u7279\u4F8B'
            ),
            '\u4F8B\u5982\u300C\u8B1D\u300D\u59D3\u6709\u300CTsi\u0101\u300D\u3001\u300CSi\u0101\u300D\u5169\u7A2E\u767C\u97F3\uFF0C\u5404\u5730\u8154\u8ABF\u7FD2\u6163\u4E0D\u540C\uFF0C\u61C9\u8A72\u5C0A\u91CD\u540D\u5F9E\u4E3B\u4EBA\u7684\u539F\u5247\uFF0C\u4EE5\u672C\u4EBA\u81EA\u5DF1\u7684\u767C\u97F3\u70BA\u6E96\u3002',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
            '\u4E5F\u6709\u5C11\u6578\u7FD2\u6163\u8B80\u6210\u6587\u8B80\u97F3\u7684\u59D3\uFF0C\u50CF\u300C\u6797\u300D\u8B80\u300CL\xEEm\u300D\u4E0D\u8B80\u300CN\xE2\u300D\uFF0C\u300C\u99AC\u300D\u901A\u5E38\u8B80\u300CM\xE1\u300D\u4E0D\u8B80\u300CB\xE9\u300D\u7B49\u7B49\u3002',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
            '\u53E6\u5916\u4E5F\u6709\u4E00\u4E9B\u6587\u767D\u8B80\u7FFB\u8F49\u7684\u60C5\u5F62\u3002\u8209\u4F8B\u4F86\u8AAA\uFF0C\u300C\u5B6B\u300D\u59D3\u539F\u672C\u901A\u884C\u767D\u8A71\u97F3\u300CSng\u300D\uFF0C\u4F46\u6C11\u9593\u6709\u6F38\u6F38\u8F49\u6210\u6587\u8B80\u97F3\u300CSun\u300D\u7684\u8DA8\u52E2\u3002',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'siokausik' },
              '\uD83D\uDC49\u540D\u7684\u7279\u4F8B'
            ),
            '\u540D\u7684\u90E8\u5206\uFF0C\u96D6\u7136\u4E00\u822C\u6703\u7167\u5B57\u9762\u7528\u6587\u8B80\u97F3\u5FF5\uFF0C\u4F46\u6709\u6642\u7236\u6BCD\u9577\u8F29\u662F\u7528\u53E3\u8A9E\u8A5E\u3001\u767D\u8A71\u97F3\u4F86\u53D6\u540D\u3002 \u4F8B\u5982\u9673\u300C\u6C34\u6241\u300D\u662F\u53EB\u300CTsu\xED-p\xEDnn\u300D\u800C\u975E\u6587\u8B80\u97F3\u300CSu\xED-pi\xE1n\u300D\uFF0C \u674E\u300C\u6C5F\u5374\u300D\u662F\u5FF5\u300CKang-khioh\u300D\u800C\u4E0D\u662F\u300CKang-khiok\u300D\u3002\u6709\u6642\u5019\u9084\u6703\u6709\u300C\u6587+\u767D\u300D\u6216\u300C\u767D+\u6587\u300D\u7684\u7D44\u5408\u3002',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h2',
              { className: 'siokausik' },
              '\u56E0\u6B64\u2026\u2026'
            ),
            '\u300C\u59D3\u7528\u767D\u8A71\u97F3\u3001\u540D\u7528\u6587\u8B80\u97F3\u300D\u53EA\u662F\u5927\u539F\u5247\uFF0C\u4E0D\u898B\u5F97\u767E\u5206\u4E4B\u767E\u6B63\u78BA\u3002\u4F8B\u5916\u7684\u60C5\u6CC1\uFF0C\u6709\u53EF\u80FD\u662F\u81FA\u8A9E\u539F\u672C\u7684\u7FD2\u6163\uFF0C\u6216\u751A\u81F3\u662F\u7279\u5B9A\u5730\u5340\u3001\u5BB6\u65CF\u6216\u500B\u4EBA\u7684\u767C\u97F3\uFF0C\u6700\u597D\u7684\u65B9\u5F0F\u9084\u662F\u5411\u672C\u4EBA\u78BA\u8A8D\u3002'
          )
        )
      );
      debug(this.state.Senn + ' ' + this.state.Mia);
    }
  }, {
    key: 'show',
    value: function show() {
      var show = !this.disabled();
      if (show) return true;

      if (!this.entry) {
        this.hapsing = false;
        return false;
      }

      this.entry = false;
      if (!!this.props.params.senn && !!this.props.params.mia) {
        this.hapsing = true;
        return true;
      }

      this.hapsing = false;
      return false;
    }
  }, {
    key: 'disabled',
    value: function disabled() {
      return !(this.senn && !!this.senn.value && this.mia && !!this.mia.value);
    }
  }, {
    key: 'tsha',
    value: function tsha(event) {
      event.preventDefault();
      __WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* browserHistory */].replace('/name/' + this.senn.value + '/' + this.mia.value);
      debug(this.senn.value + '/' + this.mia.value);
      this.hapsing = true;
    }
  }, {
    key: 'liah',
    value: function liah(senn, mia) {
      var _this3 = this;

      if (senn != undefined && mia != undefined) {
        debug(senn, mia);
        superagent.get(__WEBPACK_IMPORTED_MODULE_4____["a" /* default */].名姓(senn, mia)).then(function (_ref) {
          var body = _ref.body;
          return _this3.setState(body);
        }).catch(function (err) {
          return debug('error');
        });
      }
    }
  }]);

  return 名姓;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

名姓.propTypes = {
  params: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.object,
  查怎樣講: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.func
};

/* harmony default export */ __webpack_exports__["a"] = (名姓);

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__css__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(399);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var 台語寶鑑 = function (_React$Component) {
  _inherits(台語寶鑑, _React$Component);

  function 台語寶鑑(props) {
    _classCallCheck(this, 台語寶鑑);

    var _this = _possibleConstructorReturn(this, (台語寶鑑.__proto__ || Object.getPrototypeOf(台語寶鑑)).call(this, props));

    _this.state = {
      data: [{
        image: __webpack_require__(860),
        name: '抱去摸',
        to: '/tsu-te/pho-khi-bong'
      }, {
        image: __webpack_require__(861),
        name: '金融kah台語',
        to: '/tsu-te/kim-iong-kah-tai-gi'
      }]
    };
    return _this;
  }

  _createClass(台語寶鑑, [{
    key: 'appendButtons',
    value: function appendButtons() {
      return this.state.data.map(function (d) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["a" /* default */], { data: d, key: d.name });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'main container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'kong content' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: '\u53F0\u8A9E\u5BF6\u9451-row' },
            this.appendButtons()
          )
        )
      );
    }
  }]);

  return 台語寶鑑;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (台語寶鑑);

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(20);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var 寶鑑按鈕 = function (_React$Component) {
  _inherits(寶鑑按鈕, _React$Component);

  function 寶鑑按鈕() {
    _classCallCheck(this, 寶鑑按鈕);

    return _possibleConstructorReturn(this, (寶鑑按鈕.__proto__ || Object.getPrototypeOf(寶鑑按鈕)).apply(this, arguments));
  }

  _createClass(寶鑑按鈕, [{
    key: 'render',
    value: function render() {
      var 按鈕 = this.props.data.image;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: '\u53F0\u8A9E\u5BF6\u9451-col' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Link */],
          { to: this.props.data.to },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: '\u53F0\u8A9E\u5BF6\u9451-button' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: '\u53F0\u8A9E\u5BF6\u9451-button-ico', style: { backgroundImage: 'url(' + 按鈕 + ')' } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: '\u53F0\u8A9E\u5BF6\u9451-button-name' },
              this.props.data.name
            )
          )
        )
      );
    }
  }]);

  return 寶鑑按鈕;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (寶鑑按鈕);

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__css__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Iah___ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__json__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__json__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var 金融尬台語 = function (_React$Component) {
  _inherits(金融尬台語, _React$Component);

  function 金融尬台語(props) {
    _classCallCheck(this, 金融尬台語);

    var _this = _possibleConstructorReturn(this, (金融尬台語.__proto__ || Object.getPrototypeOf(金融尬台語)).call(this, props));

    _this.state = { 佗一隻: undefined, 揣: '' };
    return _this;
  }

  _createClass(金融尬台語, [{
    key: '\u63DB\u4E00\u96BB',
    value: function _(名) {
      this.setState({ 佗一隻: 名 });
    }
  }, {
    key: '\u6488\u51FA\u5BF6\u8C9D',
    value: function _() {
      var _this2 = this;

      var 表 = __WEBPACK_IMPORTED_MODULE_4__json___default.a;
      var 揣 = this.state.揣;

      var 顯示 = [];
      var 三隻 = [];

      表.map(function (一隻, i) {
        if (一隻.includes(揣)) {
          三隻.push(一隻);
        }

        if (三隻.length === 3 || i === 表.length - 1) {
          顯示.push(三隻);
          三隻 = [];
        }
      });

      var 寶貝鈕 = 顯示.map(function (三隻, i) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Iah___["a" /* default */], {
          key: i,
          寶貝名: 三隻,
          佗一隻: _this2.state.佗一隻,
          換一隻: _this2.換一隻.bind(_this2)
        });
      });
      return 寶貝鈕;
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(evt) {
      if (evt.keyCode === 13) {
        this.查寶貝();
      }
    }
  }, {
    key: '\u67E5\u5BF6\u8C9D',
    value: function _() {
      var 揣 = this.refs.揣.value;
      if (揣 !== this.state.揣) {
        this.setState({ 揣: 揣 });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var 寶貝鈕 = this.撈出寶貝();
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'main container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'kong content \u91D1\u878D\u5C2C\u53F0\u8A9E\u5916\u53E3' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'ui fluid action input huge container tshue' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
              type: 'text',
              placeholder: '\u53BB\u69D3\u687F\u5316\u3001\u6295\u8CC7\u5831\u916C\u7387',
              defaultValue: '',
              onKeyDown: this.handleKeyDown.bind(this),
              ref: '\u63E3',
              size: '8'
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'ui button huge teal', onClick: this.查寶貝.bind(this) },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'translate icon' }),
              ' ',
              '\u8B1B\u53F0\u8A9E'
            )
          ),
          寶貝鈕
        )
      );
    }
  }]);

  return 金融尬台語;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (金融尬台語);

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(411), __esModule: true };

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(412), __esModule: true };

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(413), __esModule: true };

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(414), __esModule: true };

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(415), __esModule: true };

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(416), __esModule: true };

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(408);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 408 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Expose `Emitter`.
 */

if (true) {
  module.exports = Emitter;
}

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }

  // Remove event specific arrays for event types that no
  // one is subscribed for to avoid memory leak.
  if (callbacks.length === 0) {
    delete this._callbacks['$' + event];
  }

  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};

  var args = new Array(arguments.length - 1)
    , callbacks = this._callbacks['$' + event];

  for (var i = 1; i < arguments.length; i++) {
    args[i - 1] = arguments[i];
  }

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(458);
module.exports = __webpack_require__(40).RegExp.escape;


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(443);
module.exports = __webpack_require__(33).Object.assign;


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(444);
var $Object = __webpack_require__(33).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(445);
module.exports = __webpack_require__(33).Object.setPrototypeOf;


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(256);
__webpack_require__(257);
__webpack_require__(258);
__webpack_require__(446);
__webpack_require__(448);
__webpack_require__(449);
module.exports = __webpack_require__(33).Promise;


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(447);
__webpack_require__(256);
__webpack_require__(450);
__webpack_require__(451);
module.exports = __webpack_require__(33).Symbol;


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(257);
__webpack_require__(258);
module.exports = __webpack_require__(172).f('iterator');


/***/ }),
/* 417 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 418 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(93);
var toLength = __webpack_require__(255);
var toAbsoluteIndex = __webpack_require__(439);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(128);
var gOPS = __webpack_require__(165);
var pIE = __webpack_require__(129);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(110);
var call = __webpack_require__(425);
var isArrayIter = __webpack_require__(423);
var anObject = __webpack_require__(53);
var toLength = __webpack_require__(255);
var getIterFn = __webpack_require__(441);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 422 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(112);
var ITERATOR = __webpack_require__(29)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(109);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(53);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(164);
var descriptor = __webpack_require__(130);
var setToStringTag = __webpack_require__(131);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(74)(IteratorPrototype, __webpack_require__(29)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(29)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 428 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(132)('meta');
var isObject = __webpack_require__(63);
var has = __webpack_require__(73);
var setDesc = __webpack_require__(75).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(111)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(23);
var macrotask = __webpack_require__(254).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(109)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(61);
var getKeys = __webpack_require__(128);
var gOPS = __webpack_require__(165);
var pIE = __webpack_require__(129);
var toObject = __webpack_require__(169);
var IObject = __webpack_require__(245);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(111)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(75);
var anObject = __webpack_require__(53);
var getKeys = __webpack_require__(128);

module.exports = __webpack_require__(61) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(93);
var gOPN = __webpack_require__(248).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(73);
var toObject = __webpack_require__(169);
var IE_PROTO = __webpack_require__(166)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(74);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(63);
var anObject = __webpack_require__(53);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(110)(Function.call, __webpack_require__(247).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(23);
var core = __webpack_require__(33);
var dP = __webpack_require__(75);
var DESCRIPTORS = __webpack_require__(61);
var SPECIES = __webpack_require__(29)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(168);
var defined = __webpack_require__(160);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(168);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(23);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(242);
var ITERATOR = __webpack_require__(29)('iterator');
var Iterators = __webpack_require__(112);
module.exports = __webpack_require__(33).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(417);
var step = __webpack_require__(428);
var Iterators = __webpack_require__(112);
var toIObject = __webpack_require__(93);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(246)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(62);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(431) });


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(62);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(164) });


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(62);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(436).set });


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(113);
var global = __webpack_require__(23);
var ctx = __webpack_require__(110);
var classof = __webpack_require__(242);
var $export = __webpack_require__(62);
var isObject = __webpack_require__(63);
var aFunction = __webpack_require__(127);
var anInstance = __webpack_require__(418);
var forOf = __webpack_require__(421);
var speciesConstructor = __webpack_require__(253);
var task = __webpack_require__(254).set;
var microtask = __webpack_require__(430)();
var newPromiseCapabilityModule = __webpack_require__(163);
var perform = __webpack_require__(250);
var userAgent = __webpack_require__(440);
var promiseResolve = __webpack_require__(251);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(29)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(435)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(131)($Promise, PROMISE);
__webpack_require__(437)(PROMISE);
Wrapper = __webpack_require__(33)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(427)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(23);
var has = __webpack_require__(73);
var DESCRIPTORS = __webpack_require__(61);
var $export = __webpack_require__(62);
var redefine = __webpack_require__(252);
var META = __webpack_require__(429).KEY;
var $fails = __webpack_require__(111);
var shared = __webpack_require__(167);
var setToStringTag = __webpack_require__(131);
var uid = __webpack_require__(132);
var wks = __webpack_require__(29);
var wksExt = __webpack_require__(172);
var wksDefine = __webpack_require__(171);
var enumKeys = __webpack_require__(420);
var isArray = __webpack_require__(424);
var anObject = __webpack_require__(53);
var isObject = __webpack_require__(63);
var toObject = __webpack_require__(169);
var toIObject = __webpack_require__(93);
var toPrimitive = __webpack_require__(170);
var createDesc = __webpack_require__(130);
var _create = __webpack_require__(164);
var gOPNExt = __webpack_require__(433);
var $GOPD = __webpack_require__(247);
var $GOPS = __webpack_require__(165);
var $DP = __webpack_require__(75);
var $keys = __webpack_require__(128);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(248).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(129).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(113)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(74)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(62);
var core = __webpack_require__(33);
var global = __webpack_require__(23);
var speciesConstructor = __webpack_require__(253);
var promiseResolve = __webpack_require__(251);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(62);
var newPromiseCapability = __webpack_require__(163);
var perform = __webpack_require__(250);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(171)('asyncIterator');


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(171)('observable');


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(7);
var isArray = __webpack_require__(136);
var SPECIES = __webpack_require__(12)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(6);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(2);
var toPrimitive = __webpack_require__(49);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(80);
var gOPS = __webpack_require__(140);
var pIE = __webpack_require__(116);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(117)('native-function-to-string', Function.toString);


/***/ }),
/* 457 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(0);
var $re = __webpack_require__(457)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { copyWithin: __webpack_require__(260) });

__webpack_require__(64)('copyWithin');


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $every = __webpack_require__(46)(4);

$export($export.P + $export.F * !__webpack_require__(42)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { fill: __webpack_require__(174) });

__webpack_require__(64)('fill');


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $filter = __webpack_require__(46)(2);

$export($export.P + $export.F * !__webpack_require__(42)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(46)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(64)(KEY);


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(46)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(64)(KEY);


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $forEach = __webpack_require__(46)(0);
var STRICT = __webpack_require__(42)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(41);
var $export = __webpack_require__(0);
var toObject = __webpack_require__(19);
var call = __webpack_require__(271);
var isArrayIter = __webpack_require__(182);
var toLength = __webpack_require__(13);
var createProperty = __webpack_require__(176);
var getIterFn = __webpack_require__(198);

$export($export.S + $export.F * !__webpack_require__(138)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $indexOf = __webpack_require__(133)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(42)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(0);

$export($export.S, 'Array', { isArray: __webpack_require__(136) });


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(0);
var toIObject = __webpack_require__(37);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(115) != Object || !__webpack_require__(42)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(37);
var toInteger = __webpack_require__(43);
var toLength = __webpack_require__(13);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(42)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $map = __webpack_require__(46)(1);

$export($export.P + $export.F * !__webpack_require__(42)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var createProperty = __webpack_require__(176);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(6)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(262);

$export($export.P + $export.F * !__webpack_require__(42)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(262);

$export($export.P + $export.F * !__webpack_require__(42)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var html = __webpack_require__(180);
var cof = __webpack_require__(39);
var toAbsoluteIndex = __webpack_require__(84);
var toLength = __webpack_require__(13);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(6)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $some = __webpack_require__(46)(3);

$export($export.P + $export.F * !__webpack_require__(42)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var aFunction = __webpack_require__(22);
var toObject = __webpack_require__(19);
var fails = __webpack_require__(6);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(42)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(83)('Array');


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(0);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(0);
var toISOString = __webpack_require__(453);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(19);
var toPrimitive = __webpack_require__(49);

$export($export.P + $export.F * __webpack_require__(6)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(12)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(30)(proto, TO_PRIMITIVE, __webpack_require__(454));


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(31)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(0);

$export($export.P, 'Function', { bind: __webpack_require__(263) });


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(7);
var getPrototypeOf = __webpack_require__(36);
var HAS_INSTANCE = __webpack_require__(12)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(15).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(15).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(14) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(0);
var log1p = __webpack_require__(274);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(0);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(0);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(0);
var sign = __webpack_require__(186);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(0);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(0);
var $expm1 = __webpack_require__(185);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { fround: __webpack_require__(273) });


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(0);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(0);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(6)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { log1p: __webpack_require__(274) });


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { sign: __webpack_require__(186) });


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(185);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(6)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(185);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(4);
var has = __webpack_require__(34);
var cof = __webpack_require__(39);
var inheritIfRequired = __webpack_require__(181);
var toPrimitive = __webpack_require__(49);
var fails = __webpack_require__(6);
var gOPN = __webpack_require__(79).f;
var gOPD = __webpack_require__(35).f;
var dP = __webpack_require__(15).f;
var $trim = __webpack_require__(97).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(78)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(14) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(31)(global, NUMBER, $Number);
}


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(0);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(0);
var _isFinite = __webpack_require__(4).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', { isInteger: __webpack_require__(270) });


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(0);
var isInteger = __webpack_require__(270);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(282);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(283);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toInteger = __webpack_require__(43);
var aNumberValue = __webpack_require__(259);
var repeat = __webpack_require__(193);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(6)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $fails = __webpack_require__(6);
var aNumberValue = __webpack_require__(259);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(0);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(276) });


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(78) });


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(14), 'Object', { defineProperties: __webpack_require__(277) });


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(14), 'Object', { defineProperty: __webpack_require__(15).f });


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(7);
var meta = __webpack_require__(66).onFreeze;

__webpack_require__(48)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(37);
var $getOwnPropertyDescriptor = __webpack_require__(35).f;

__webpack_require__(48)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(48)('getOwnPropertyNames', function () {
  return __webpack_require__(278).f;
});


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(19);
var $getPrototypeOf = __webpack_require__(36);

__webpack_require__(48)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(7);

__webpack_require__(48)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(7);

__webpack_require__(48)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(7);

__webpack_require__(48)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { is: __webpack_require__(286) });


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(19);
var $keys = __webpack_require__(80);

__webpack_require__(48)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(7);
var meta = __webpack_require__(66).onFreeze;

__webpack_require__(48)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(7);
var meta = __webpack_require__(66).onFreeze;

__webpack_require__(48)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(190).set });


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(94);
var test = {};
test[__webpack_require__(12)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(31)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(282);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(283);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(65);
var global = __webpack_require__(4);
var ctx = __webpack_require__(41);
var classof = __webpack_require__(94);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(7);
var aFunction = __webpack_require__(22);
var anInstance = __webpack_require__(76);
var forOf = __webpack_require__(77);
var speciesConstructor = __webpack_require__(118);
var task = __webpack_require__(195).set;
var microtask = __webpack_require__(187)();
var newPromiseCapabilityModule = __webpack_require__(188);
var perform = __webpack_require__(284);
var userAgent = __webpack_require__(146);
var promiseResolve = __webpack_require__(285);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(12)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(82)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(96)($Promise, PROMISE);
__webpack_require__(83)(PROMISE);
Wrapper = __webpack_require__(40)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(138)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(22);
var anObject = __webpack_require__(2);
var rApply = (__webpack_require__(4).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(6)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(0);
var create = __webpack_require__(78);
var aFunction = __webpack_require__(22);
var anObject = __webpack_require__(2);
var isObject = __webpack_require__(7);
var fails = __webpack_require__(6);
var bind = __webpack_require__(263);
var rConstruct = (__webpack_require__(4).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(15);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(2);
var toPrimitive = __webpack_require__(49);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(6)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(0);
var gOPD = __webpack_require__(35).f;
var anObject = __webpack_require__(2);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(2);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(183)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(35);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(2);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(0);
var getProto = __webpack_require__(36);
var anObject = __webpack_require__(2);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(35);
var getPrototypeOf = __webpack_require__(36);
var has = __webpack_require__(34);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(7);
var anObject = __webpack_require__(2);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(2);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(281) });


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(2);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(0);
var setProto = __webpack_require__(190);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(15);
var gOPD = __webpack_require__(35);
var getPrototypeOf = __webpack_require__(36);
var has = __webpack_require__(34);
var $export = __webpack_require__(0);
var createDesc = __webpack_require__(81);
var anObject = __webpack_require__(2);
var isObject = __webpack_require__(7);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(4);
var inheritIfRequired = __webpack_require__(181);
var dP = __webpack_require__(15).f;
var gOPN = __webpack_require__(79).f;
var isRegExp = __webpack_require__(137);
var $flags = __webpack_require__(114);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(14) && (!CORRECT_NEW || __webpack_require__(6)(function () {
  re2[__webpack_require__(12)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(31)(global, 'RegExp', $RegExp);
}

__webpack_require__(83)('RegExp');


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(2);
var toLength = __webpack_require__(13);
var advanceStringIndex = __webpack_require__(173);
var regExpExec = __webpack_require__(141);

// @@match logic
__webpack_require__(135)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(2);
var toObject = __webpack_require__(19);
var toLength = __webpack_require__(13);
var toInteger = __webpack_require__(43);
var advanceStringIndex = __webpack_require__(173);
var regExpExec = __webpack_require__(141);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(135)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(2);
var sameValue = __webpack_require__(286);
var regExpExec = __webpack_require__(141);

// @@search logic
__webpack_require__(135)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(137);
var anObject = __webpack_require__(2);
var speciesConstructor = __webpack_require__(118);
var advanceStringIndex = __webpack_require__(173);
var toLength = __webpack_require__(13);
var callRegExpExec = __webpack_require__(141);
var regexpExec = __webpack_require__(189);
var fails = __webpack_require__(6);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(135)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(292);
var anObject = __webpack_require__(2);
var $flags = __webpack_require__(114);
var DESCRIPTORS = __webpack_require__(14);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(31)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(6)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(32)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(32)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(32)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(32)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $at = __webpack_require__(144)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(13);
var context = __webpack_require__(192);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(179)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(32)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(32)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(32)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toAbsoluteIndex = __webpack_require__(84);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(0);
var context = __webpack_require__(192);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(179)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(32)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(144)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(184)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(32)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(37);
var toLength = __webpack_require__(13);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(193)
});


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(32)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(13);
var context = __webpack_require__(192);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(179)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(32)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(32)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(32)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(97)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(4);
var has = __webpack_require__(34);
var DESCRIPTORS = __webpack_require__(14);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(31);
var META = __webpack_require__(66).KEY;
var $fails = __webpack_require__(6);
var shared = __webpack_require__(117);
var setToStringTag = __webpack_require__(96);
var uid = __webpack_require__(85);
var wks = __webpack_require__(12);
var wksExt = __webpack_require__(289);
var wksDefine = __webpack_require__(197);
var enumKeys = __webpack_require__(455);
var isArray = __webpack_require__(136);
var anObject = __webpack_require__(2);
var isObject = __webpack_require__(7);
var toObject = __webpack_require__(19);
var toIObject = __webpack_require__(37);
var toPrimitive = __webpack_require__(49);
var createDesc = __webpack_require__(81);
var _create = __webpack_require__(78);
var gOPNExt = __webpack_require__(278);
var $GOPD = __webpack_require__(35);
var $GOPS = __webpack_require__(140);
var $DP = __webpack_require__(15);
var $keys = __webpack_require__(80);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(79).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(116).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(65)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(30)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $typed = __webpack_require__(145);
var buffer = __webpack_require__(196);
var anObject = __webpack_require__(2);
var toAbsoluteIndex = __webpack_require__(84);
var toLength = __webpack_require__(13);
var isObject = __webpack_require__(7);
var ArrayBuffer = __webpack_require__(4).ArrayBuffer;
var speciesConstructor = __webpack_require__(118);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(6)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(83)(ARRAY_BUFFER);


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
$export($export.G + $export.W + $export.F * !__webpack_require__(145).ABV, {
  DataView: __webpack_require__(196).DataView
});


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(55)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(55)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(55)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(55)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(55)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(55)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(55)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(55)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(55)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(266);
var validate = __webpack_require__(86);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(134)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(267);
var toObject = __webpack_require__(19);
var toLength = __webpack_require__(13);
var aFunction = __webpack_require__(22);
var arraySpeciesCreate = __webpack_require__(175);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(64)('flatMap');


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(267);
var toObject = __webpack_require__(19);
var toLength = __webpack_require__(13);
var toInteger = __webpack_require__(43);
var arraySpeciesCreate = __webpack_require__(175);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(64)('flatten');


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(0);
var $includes = __webpack_require__(133)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(64)('includes');


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(0);
var microtask = __webpack_require__(187)();
var process = __webpack_require__(4).process;
var isNode = __webpack_require__(39)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(0);
var cof = __webpack_require__(39);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.G, { global: __webpack_require__(4) });


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(142)('Map');


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(143)('Map');


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(265)('Map') });


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var scale = __webpack_require__(275);
var fround = __webpack_require__(273);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { scale: __webpack_require__(275) });


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(0);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(19);
var aFunction = __webpack_require__(22);
var $defineProperty = __webpack_require__(15);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(14) && $export($export.P + __webpack_require__(139), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(19);
var aFunction = __webpack_require__(22);
var $defineProperty = __webpack_require__(15);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(14) && $export($export.P + __webpack_require__(139), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $entries = __webpack_require__(280)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(0);
var ownKeys = __webpack_require__(281);
var toIObject = __webpack_require__(37);
var gOPD = __webpack_require__(35);
var createProperty = __webpack_require__(176);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(19);
var toPrimitive = __webpack_require__(49);
var getPrototypeOf = __webpack_require__(36);
var getOwnPropertyDescriptor = __webpack_require__(35).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(14) && $export($export.P + __webpack_require__(139), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(19);
var toPrimitive = __webpack_require__(49);
var getPrototypeOf = __webpack_require__(36);
var getOwnPropertyDescriptor = __webpack_require__(35).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(14) && $export($export.P + __webpack_require__(139), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $values = __webpack_require__(280)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(0);
var global = __webpack_require__(4);
var core = __webpack_require__(40);
var microtask = __webpack_require__(187)();
var OBSERVABLE = __webpack_require__(12)('observable');
var aFunction = __webpack_require__(22);
var anObject = __webpack_require__(2);
var anInstance = __webpack_require__(76);
var redefineAll = __webpack_require__(82);
var hide = __webpack_require__(30);
var forOf = __webpack_require__(77);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(83)('Observable');


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(0);
var core = __webpack_require__(40);
var global = __webpack_require__(4);
var speciesConstructor = __webpack_require__(118);
var promiseResolve = __webpack_require__(285);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(0);
var newPromiseCapability = __webpack_require__(188);
var perform = __webpack_require__(284);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(54);
var anObject = __webpack_require__(2);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(54);
var anObject = __webpack_require__(2);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(293);
var from = __webpack_require__(261);
var metadata = __webpack_require__(54);
var anObject = __webpack_require__(2);
var getPrototypeOf = __webpack_require__(36);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(54);
var anObject = __webpack_require__(2);
var getPrototypeOf = __webpack_require__(36);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(54);
var anObject = __webpack_require__(2);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(54);
var anObject = __webpack_require__(2);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(54);
var anObject = __webpack_require__(2);
var getPrototypeOf = __webpack_require__(36);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(54);
var anObject = __webpack_require__(2);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(54);
var anObject = __webpack_require__(2);
var aFunction = __webpack_require__(22);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(142)('Set');


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(143)('Set');


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(265)('Set') });


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(0);
var $at = __webpack_require__(144)(true);
var $fails = __webpack_require__(6);

var FORCED = $fails(function () {
  return '𠮷'.at(0) !== '𠮷';
});

$export($export.P + $export.F * FORCED, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(0);
var defined = __webpack_require__(47);
var toLength = __webpack_require__(13);
var isRegExp = __webpack_require__(137);
var getFlags = __webpack_require__(114);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(183)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(287);
var userAgent = __webpack_require__(146);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(287);
var userAgent = __webpack_require__(146);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(97)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(97)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(197)('asyncIterator');


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(197)('observable');


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.S, 'System', { global: __webpack_require__(4) });


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(142)('WeakMap');


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(143)('WeakMap');


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(142)('WeakSet');


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(143)('WeakSet');


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(199);
var getKeys = __webpack_require__(80);
var redefine = __webpack_require__(31);
var global = __webpack_require__(4);
var hide = __webpack_require__(30);
var Iterators = __webpack_require__(95);
var wks = __webpack_require__(12);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $task = __webpack_require__(195);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(4);
var $export = __webpack_require__(0);
var userAgent = __webpack_require__(146);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(578);
__webpack_require__(517);
__webpack_require__(519);
__webpack_require__(518);
__webpack_require__(521);
__webpack_require__(523);
__webpack_require__(528);
__webpack_require__(522);
__webpack_require__(520);
__webpack_require__(530);
__webpack_require__(529);
__webpack_require__(525);
__webpack_require__(526);
__webpack_require__(524);
__webpack_require__(516);
__webpack_require__(527);
__webpack_require__(531);
__webpack_require__(532);
__webpack_require__(484);
__webpack_require__(486);
__webpack_require__(485);
__webpack_require__(534);
__webpack_require__(533);
__webpack_require__(504);
__webpack_require__(514);
__webpack_require__(515);
__webpack_require__(505);
__webpack_require__(506);
__webpack_require__(507);
__webpack_require__(508);
__webpack_require__(509);
__webpack_require__(510);
__webpack_require__(511);
__webpack_require__(512);
__webpack_require__(513);
__webpack_require__(487);
__webpack_require__(488);
__webpack_require__(489);
__webpack_require__(490);
__webpack_require__(491);
__webpack_require__(492);
__webpack_require__(493);
__webpack_require__(494);
__webpack_require__(495);
__webpack_require__(496);
__webpack_require__(497);
__webpack_require__(498);
__webpack_require__(499);
__webpack_require__(500);
__webpack_require__(501);
__webpack_require__(502);
__webpack_require__(503);
__webpack_require__(565);
__webpack_require__(570);
__webpack_require__(577);
__webpack_require__(568);
__webpack_require__(560);
__webpack_require__(561);
__webpack_require__(566);
__webpack_require__(571);
__webpack_require__(573);
__webpack_require__(556);
__webpack_require__(557);
__webpack_require__(558);
__webpack_require__(559);
__webpack_require__(562);
__webpack_require__(563);
__webpack_require__(564);
__webpack_require__(567);
__webpack_require__(569);
__webpack_require__(572);
__webpack_require__(574);
__webpack_require__(575);
__webpack_require__(576);
__webpack_require__(479);
__webpack_require__(481);
__webpack_require__(480);
__webpack_require__(483);
__webpack_require__(482);
__webpack_require__(468);
__webpack_require__(466);
__webpack_require__(472);
__webpack_require__(469);
__webpack_require__(475);
__webpack_require__(477);
__webpack_require__(465);
__webpack_require__(471);
__webpack_require__(462);
__webpack_require__(476);
__webpack_require__(460);
__webpack_require__(474);
__webpack_require__(473);
__webpack_require__(467);
__webpack_require__(470);
__webpack_require__(459);
__webpack_require__(461);
__webpack_require__(464);
__webpack_require__(463);
__webpack_require__(478);
__webpack_require__(199);
__webpack_require__(550);
__webpack_require__(291);
__webpack_require__(555);
__webpack_require__(292);
__webpack_require__(551);
__webpack_require__(552);
__webpack_require__(553);
__webpack_require__(554);
__webpack_require__(535);
__webpack_require__(290);
__webpack_require__(293);
__webpack_require__(294);
__webpack_require__(590);
__webpack_require__(579);
__webpack_require__(580);
__webpack_require__(585);
__webpack_require__(588);
__webpack_require__(589);
__webpack_require__(583);
__webpack_require__(586);
__webpack_require__(584);
__webpack_require__(587);
__webpack_require__(581);
__webpack_require__(582);
__webpack_require__(536);
__webpack_require__(537);
__webpack_require__(538);
__webpack_require__(539);
__webpack_require__(540);
__webpack_require__(543);
__webpack_require__(541);
__webpack_require__(542);
__webpack_require__(544);
__webpack_require__(545);
__webpack_require__(546);
__webpack_require__(547);
__webpack_require__(549);
__webpack_require__(548);
__webpack_require__(593);
__webpack_require__(591);
__webpack_require__(592);
__webpack_require__(634);
__webpack_require__(637);
__webpack_require__(636);
__webpack_require__(638);
__webpack_require__(639);
__webpack_require__(635);
__webpack_require__(640);
__webpack_require__(641);
__webpack_require__(615);
__webpack_require__(618);
__webpack_require__(614);
__webpack_require__(612);
__webpack_require__(613);
__webpack_require__(616);
__webpack_require__(617);
__webpack_require__(599);
__webpack_require__(633);
__webpack_require__(598);
__webpack_require__(632);
__webpack_require__(644);
__webpack_require__(646);
__webpack_require__(597);
__webpack_require__(631);
__webpack_require__(643);
__webpack_require__(645);
__webpack_require__(596);
__webpack_require__(642);
__webpack_require__(595);
__webpack_require__(600);
__webpack_require__(601);
__webpack_require__(602);
__webpack_require__(603);
__webpack_require__(604);
__webpack_require__(606);
__webpack_require__(605);
__webpack_require__(607);
__webpack_require__(608);
__webpack_require__(609);
__webpack_require__(611);
__webpack_require__(610);
__webpack_require__(620);
__webpack_require__(621);
__webpack_require__(622);
__webpack_require__(623);
__webpack_require__(625);
__webpack_require__(624);
__webpack_require__(627);
__webpack_require__(626);
__webpack_require__(628);
__webpack_require__(629);
__webpack_require__(630);
__webpack_require__(594);
__webpack_require__(619);
__webpack_require__(649);
__webpack_require__(648);
__webpack_require__(647);
module.exports = __webpack_require__(40);


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)();
// imports
exports.push([module.i, "@import url(//tauhu.tw/tauhu-oo.css);", ""]);

// module
exports.push([module.i, "body{margin:0}.app.background{display:flex;flex-flow:column nowrap;min-height:100vh;background-color:#f1efeb}.app .container{width:100%;max-width:960px;margin:0 auto}.app .main.container{display:flex;flex-flow:row wrap;flex-grow:1;align-content:flex-start;justify-content:center}.navigation{width:100%;height:50px;margin:1em 0}.app .app.header{min-height:90px;display:flex;justify-content:center;background:#fff}.app .app.footer{background:#1b1c1d}.ui.button.no-border{box-shadow:none}@media only screen and (max-width:767px){.app .main.container{width:auto!important;margin-left:1em!important;margin-right:1em!important}.app.footer>.menu.container{background:#1b1c1d;padding-left:0;padding-bottom:4em;overflow:hidden}.fixbar{width:104%;position:fixed;bottom:-.8em;z-index:999;box-shadow:0 4px 8px 0 rgba(0,0,0,.6),0 6px 20px 0 rgba(0,0,0,.57)}}.ui.form input[type=text],.ui.form input[type=text]:focus,body,div.description,h2,h2.ui.header,input[type=text]{font-family:tauhu-oo,Source Han Sans,Noto Sans CJK TC,PingFang TC,Microsoft JhengHei,sans-serif;font-weight:400}", ""]);

// exports


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)();
// imports


// module
exports.push([module.i, "@media only screen and (max-width:767px){.guaGi .ui.cards{justify-content:center}}@media only screen and (min-width:767px){.ui.su.card{width:310px}}", ""]);

// exports


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)();
// imports


// module
exports.push([module.i, ".HuatIm .button{margin-left:15px}", ""]);

// exports


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)();
// imports


// module
exports.push([module.i, ".ui.menu{justify-content:center}", ""]);

// exports


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)();
// imports


// module
exports.push([module.i, ".su{text-align:left}.report{padding-top:15px}", ""]);

// exports


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)();
// imports


// module
exports.push([module.i, ".app.bar{display:flex;justify-content:space-between;position:relative;width:960px;max-width:100%}.app.bar .title{display:block;margin:0;height:72px;margin:auto 0}.app.bar .logo img{height:100%}.ui.right.item{padding-top:10px}@media only screen and (max-width:767px){.app.bar>.title{width:100%;text-align:center;margin:auto 0}.app.bar>.icon.menu{display:none}.app.bar>.right.item{width:100%;position:absolute;text-align:right}.app.bar .menu{display:none}}", ""]);

// exports


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)();
// imports


// module
exports.push([module.i, "@media only screen and (min-width:768px){#KuahPau{display:none}}", ""]);

// exports


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)();
// imports


// module
exports.push([module.i, ".ui.fluid.action.input.tshue>input{-webkit-flex:1;flex:1;width:100%!important}@media only screen and (max-width:767px){.ui.fluid.action.input.tshue{margin-left:0!important;margin-right:0!important}}", ""]);

// exports


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)();
// imports


// module
exports.push([module.i, ".le7ku3.tai5 ruby{margin-right:6px;font-size:1.7rem}.le7ku3.tai5 ruby rt{font-size:1.9rem}", ""]);

// exports


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)();
// imports


// module
exports.push([module.i, ".le7ku3.tai5{line-height:5rem}.le7ku3.hua5{font-size:1.5rem;line-height:2rem;margin-top:-1rem;margin-bottom:20px}", ""]);

// exports


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)();
// imports


// module
exports.push([module.i, ".分享{margin:1em 0;text-align:center}.分享 span{font-size:120%;margin:0 5px}.分享 iframe{vertical-align:top;margin:0 5px}", ""]);

// exports


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)();
// imports


// module
exports.push([module.i, ".複製連結{font-size:80%;height:21.15px;width:68.66px;margin-left:-30px}", ""]);

// exports


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)();
// imports


// module
exports.push([module.i, "div.iong{margin:0 auto;padding-top:1em}@media only screen and (max-width:767px){.iong .ui.cards{justify-content:center}}", ""]);

// exports


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)();
// imports


// module
exports.push([module.i, ".kong.content{text-align:center;width:100%}.燒燙燙{min-height:150px}.燒燙燙 .loading{display:none}.燒燙燙 a{cursor:pointer}", ""]);

// exports


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)();
// imports


// module
exports.push([module.i, "@media only screen and (max-width:767px){.kianGi .ui.cards{justify-content:center}}", ""]);

// exports


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)();
// imports


// module
exports.push([module.i, ".mia.main.container{padding-top:20px;padding-bottom:20px}", ""]);

// exports


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)();
// imports


// module
exports.push([module.i, ".the.content{width:100%}", ""]);

// exports


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)();
// imports


// module
exports.push([module.i, "div.寶可夢,div.寶可夢外口{padding:5px}", ""]);

// exports


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)();
// imports


// module
exports.push([module.i, "form.miasenn,input.miasenn{width:180px;font-size:2rem}ruby{font-size:4rem}rt{font-size:1.5rem}.siokausik{text-align:justify;font-size:1.4rem}h1.siokausik{font-size:2rem;margin:0}h2.siokausik{font-size:1.8rem;margin:.2rem}h3.siokausik{font-size:1.6rem;margin:.6rem}.name-ruby{display:block!important}.hapsing{display:flex;justify-content:center;flex-direction:column;text-align:center;margin-top:-20px}hr.tip-hr-name{color:#ccc}", ""]);

// exports


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)();
// imports


// module
exports.push([module.i, "div.台語寶鑑-row{width:100%}div.台語寶鑑-col,div.台語寶鑑-row{float:left;height:auto;text-align:center}div.台語寶鑑-col{width:50%;box-sizing:content-box}div.台語寶鑑-button{display:inline-block;width:250px;height:250px;background-color:#fff;border-radius:10px;border:2px solid #ccc;margin:40px 0}div.台語寶鑑-button:hover{background-color:#eee}div.台語寶鑑-button-ico{float:left;width:100%;height:65%;background-position:bottom;background-repeat:no-repeat;background-size:30%}div.台語寶鑑-button-name{float:left;width:100%;height:auto;font-size:2em;margin-top:10%}div.台語寶鑑-col a{color:#000}@media only screen and (max-width:600px){div.台語寶鑑-col{width:100%}}", ""]);

// exports


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)();
// imports


// module
exports.push([module.i, "div.金融尬台語,div.金融尬台語口外{padding:5px}", ""]);

// exports


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(697);

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),
/* 673 */
/***/ (function(module, exports) {

module.exports = function(opts) {
  return new ElementClass(opts)
}

function indexOf(arr, prop) {
  if (arr.indexOf) return arr.indexOf(prop)
  for (var i = 0, len = arr.length; i < len; i++)
    if (arr[i] === prop) return i
  return -1
}

function ElementClass(opts) {
  if (!(this instanceof ElementClass)) return new ElementClass(opts)
  var self = this
  if (!opts) opts = {}

  // similar doing instanceof HTMLElement but works in IE8
  if (opts.nodeType) opts = {el: opts}

  this.opts = opts
  this.el = opts.el || document.body
  if (typeof this.el !== 'object') this.el = document.querySelector(this.el)
}

ElementClass.prototype.add = function(className) {
  var el = this.el
  if (!el) return
  if (el.className === "") return el.className = className
  var classes = el.className.split(' ')
  if (indexOf(classes, className) > -1) return classes
  classes.push(className)
  el.className = classes.join(' ')
  return classes
}

ElementClass.prototype.remove = function(className) {
  var el = this.el
  if (!el) return
  if (el.className === "") return
  var classes = el.className.split(' ')
  var idx = indexOf(classes, className)
  if (idx > -1) classes.splice(idx, 1)
  el.className = classes.join(' ')
  return classes
}

ElementClass.prototype.has = function(className) {
  var el = this.el
  if (!el) return
  var classes = el.className.split(' ')
  return indexOf(classes, className) > -1
}

ElementClass.prototype.toggle = function(className) {
  var el = this.el
  if (!el) return
  if (this.has(className)) this.remove(className)
  else this.add(className)
}


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var camelize = __webpack_require__(675);

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(685);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var invariant = __webpack_require__(3);

/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */
function toArray(obj) {
  var length = obj.length;

  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).
  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;

  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;

  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;

  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;

  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.
  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {
      // IE < 9 does not support Array#slice on collections objects
    }
  }

  // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.
  var ret = Array(length);
  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }
  return ret;
}

/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */
function hasArrayNature(obj) {
  return (
    // not null/false
    !!obj && (
    // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') &&
    // quacks like an array
    'length' in obj &&
    // not window
    !('setInterval' in obj) &&
    // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && (
    // a real array
    Array.isArray(obj) ||
    // arguments
    'callee' in obj ||
    // HTMLCollection/NodeList
    'item' in obj)
  );
}

/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */
function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/*eslint-disable fb-www/unsafe-html*/

var ExecutionEnvironment = __webpack_require__(24);

var createArrayFromMixed = __webpack_require__(678);
var getMarkupWrap = __webpack_require__(680);
var invariant = __webpack_require__(3);

/**
 * Dummy container used to render all markup.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Pattern used by `getNodeName`.
 */
var nodeNamePattern = /^\s*<(\w+)/;

/**
 * Extracts the `nodeName` of the first element in a string of markup.
 *
 * @param {string} markup String of markup.
 * @return {?string} Node name of the supplied markup.
 */
function getNodeName(markup) {
  var nodeNameMatch = markup.match(nodeNamePattern);
  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
}

/**
 * Creates an array containing the nodes rendered from the supplied markup. The
 * optionally supplied `handleScript` function will be invoked once for each
 * <script> element that is rendered. If no `handleScript` function is supplied,
 * an exception is thrown if any <script> elements are rendered.
 *
 * @param {string} markup A string of valid HTML markup.
 * @param {?function} handleScript Invoked once for each rendered <script>.
 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
 */
function createNodesFromMarkup(markup, handleScript) {
  var node = dummyNode;
  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
  var nodeName = getNodeName(markup);

  var wrap = nodeName && getMarkupWrap(nodeName);
  if (wrap) {
    node.innerHTML = wrap[1] + markup + wrap[2];

    var wrapDepth = wrap[0];
    while (wrapDepth--) {
      node = node.lastChild;
    }
  } else {
    node.innerHTML = markup;
  }

  var scripts = node.getElementsByTagName('script');
  if (scripts.length) {
    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
    createArrayFromMixed(scripts).forEach(handleScript);
  }

  var nodes = Array.from(node.childNodes);
  while (node.lastChild) {
    node.removeChild(node.lastChild);
  }
  return nodes;
}

module.exports = createNodesFromMarkup;

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/*eslint-disable fb-www/unsafe-html */

var ExecutionEnvironment = __webpack_require__(24);

var invariant = __webpack_require__(3);

/**
 * Dummy container used to detect which wraps are necessary.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Some browsers cannot use `innerHTML` to render certain elements standalone,
 * so we wrap them, render the wrapped nodes, then extract the desired node.
 *
 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
 */

var shouldWrap = {};

var selectWrap = [1, '<select multiple="true">', '</select>'];
var tableWrap = [1, '<table>', '</table>'];
var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];

var markupWrap = {
  '*': [1, '?<div>', '</div>'],

  'area': [1, '<map>', '</map>'],
  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
  'legend': [1, '<fieldset>', '</fieldset>'],
  'param': [1, '<object>', '</object>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],

  'optgroup': selectWrap,
  'option': selectWrap,

  'caption': tableWrap,
  'colgroup': tableWrap,
  'tbody': tableWrap,
  'tfoot': tableWrap,
  'thead': tableWrap,

  'td': trWrap,
  'th': trWrap
};

// Initialize the SVG elements since we know they'll always need to be wrapped
// consistently. If they are created inside a <div> they will be initialized in
// the wrong namespace (and will not display).
var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
svgElements.forEach(function (nodeName) {
  markupWrap[nodeName] = svgWrap;
  shouldWrap[nodeName] = true;
});

/**
 * Gets the markup wrap configuration for the supplied `nodeName`.
 *
 * NOTE: This lazily detects which wraps are necessary for the current browser.
 *
 * @param {string} nodeName Lowercase `nodeName`.
 * @return {?array} Markup wrap configuration, if applicable.
 */
function getMarkupWrap(nodeName) {
  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
  if (!markupWrap.hasOwnProperty(nodeName)) {
    nodeName = '*';
  }
  if (!shouldWrap.hasOwnProperty(nodeName)) {
    if (nodeName === '*') {
      dummyNode.innerHTML = '<link />';
    } else {
      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
    }
    shouldWrap[nodeName] = !dummyNode.firstChild;
  }
  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
}

module.exports = getMarkupWrap;

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }
  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(682);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(684);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var isSync = false,
      hasNext = false,
      doneArgs = void 0;

  var done = function done() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    isDone = true;

    if (isSync) {
      // Iterate instead of recursing if possible.
      doneArgs = args;
      return;
    }

    callback.apply(undefined, args);
  };

  var next = function next() {
    if (isDone) return;

    hasNext = true;

    if (isSync) return; // Iterate instead of recursing if possible.

    isSync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work(currentTurn++, next, done);
    }

    isSync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(undefined, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  };

  next();
};

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(201);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _warning = __webpack_require__(70);

var _warning2 = _interopRequireDefault(_warning);

var _LocationUtils = __webpack_require__(98);

var _DOMUtils = __webpack_require__(149);

var _DOMStateStorage = __webpack_require__(299);

var _PathUtils = __webpack_require__(67);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
  var path = pathCoder.decodePath(getHashPath());
  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);

  var state = void 0;
  if (key) {
    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
    state = (0, _DOMStateStorage.readState)(key);
  }

  var init = (0, _PathUtils.parsePath)(path);
  init.state = state;

  return (0, _LocationUtils.createLocation)(init, undefined, key);
};

var prevLocation = void 0;

var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = pathCoder.encodePath(path);

    if (path !== encodedPath) {
      // Always be sure we have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var currentLocation = getCurrentLocation(pathCoder, queryKey);

      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events

      prevLocation = currentLocation;

      listener(currentLocation);
    }
  };

  // Ensure the hash is encoded properly.
  var path = getHashPath();
  var encodedPath = pathCoder.encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);

  return function () {
    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
  };
};

var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
  var state = location.state,
      key = location.key;


  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));

  if (state !== undefined) {
    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
    (0, _DOMStateStorage.saveState)(key, state);
  }

  prevLocation = location;

  updateHash(path);
};

var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
  return updateLocation(location, pathCoder, queryKey, function (path) {
    if (getHashPath() !== path) {
      pushHashPath(path);
    } else {
       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
    }
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
  return updateLocation(location, pathCoder, queryKey, function (path) {
    if (getHashPath() !== path) replaceHashPath(path);
  });
};

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(201);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _LocationUtils = __webpack_require__(98);

var _PathUtils = __webpack_require__(67);

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  return (0, _LocationUtils.createLocation)(window.location);
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  window.location.href = (0, _PathUtils.createPath)(location);
  return false; // Don't update location
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  window.location.replace((0, _PathUtils.createPath)(location));
  return false; // Don't update location
};

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(25);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(202);

var _BrowserProtocol = __webpack_require__(201);

var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);

var _RefreshProtocol = __webpack_require__(689);

var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);

var _DOMUtils = __webpack_require__(149);

var _createHistory = __webpack_require__(203);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates and returns a history object that uses HTML5's history API
 * (pushState, replaceState, and the popstate event) to manage history.
 * This is the recommended method of managing history in browsers because
 * it provides the cleanest URLs.
 *
 * Note: In browsers that do not support the HTML5 history API full
 * page reloads will be used to preserve clean URLs. You can force this
 * behavior using { forceRefresh: true } in options.
 */
var createBrowserHistory = function createBrowserHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;

  var getUserConfirmation = Protocol.getUserConfirmation,
      getCurrentLocation = Protocol.getCurrentLocation,
      pushLocation = Protocol.pushLocation,
      replaceLocation = Protocol.replaceLocation,
      go = Protocol.go;


  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen
  });
};

exports.default = createBrowserHistory;

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(70);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(25);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(202);

var _DOMUtils = __webpack_require__(149);

var _HashProtocol = __webpack_require__(688);

var HashProtocol = _interopRequireWildcard(_HashProtocol);

var _createHistory = __webpack_require__(203);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DefaultQueryKey = '_k';

var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!' + path;
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substring(1) : path;
    }
  },
  noslash: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '/' ? path.substring(1) : path;
    },
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

var createHashHistory = function createHashHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var queryKey = options.queryKey,
      hashType = options.hashType;


   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;

  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;

  if (hashType == null) hashType = 'slash';

  if (!(hashType in HashPathCoders)) {
     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;

    hashType = 'slash';
  }

  var pathCoder = HashPathCoders[hashType];

  var getUserConfirmation = HashProtocol.getUserConfirmation;


  var getCurrentLocation = function getCurrentLocation() {
    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
  };

  var pushLocation = function pushLocation(location) {
    return HashProtocol.pushLocation(location, pathCoder, queryKey);
  };

  var replaceLocation = function replaceLocation(location) {
    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
  };

  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: HashProtocol.go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var go = function go(n) {
     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;

    history.go(n);
  };

  var createHref = function createHref(path) {
    return '#' + pathCoder.encodePath(history.createHref(path));
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen,
    go: go,
    createHref: createHref
  });
};

exports.default = createHashHistory;

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(70);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(25);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(98);

var _PathUtils = __webpack_require__(67);

var _createHistory = __webpack_require__(203);

var _createHistory2 = _interopRequireDefault(_createHistory);

var _Actions = __webpack_require__(148);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createStateStorage = function createStateStorage(entries) {
  return entries.filter(function (entry) {
    return entry.state;
  }).reduce(function (memo, entry) {
    memo[entry.key] = entry.state;
    return memo;
  }, {});
};

var createMemoryHistory = function createMemoryHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (Array.isArray(options)) {
    options = { entries: options };
  } else if (typeof options === 'string') {
    options = { entries: [options] };
  }

  var getCurrentLocation = function getCurrentLocation() {
    var entry = entries[current];
    var path = (0, _PathUtils.createPath)(entry);

    var key = void 0,
        state = void 0;
    if (entry.key) {
      key = entry.key;
      state = readState(key);
    }

    var init = (0, _PathUtils.parsePath)(path);

    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
  };

  var canGo = function canGo(n) {
    var index = current + n;
    return index >= 0 && index < entries.length;
  };

  var go = function go(n) {
    if (!n) return;

    if (!canGo(n)) {
       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;

      return;
    }

    current += n;
    var currentLocation = getCurrentLocation();

    // Change action to POP
    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
  };

  var pushLocation = function pushLocation(location) {
    current += 1;

    if (current < entries.length) entries.splice(current);

    entries.push(location);

    saveState(location.key, location.state);
  };

  var replaceLocation = function replaceLocation(location) {
    entries[current] = location;
    saveState(location.key, location.state);
  };

  var history = (0, _createHistory2.default)(_extends({}, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var _options = options,
      entries = _options.entries,
      current = _options.current;


  if (typeof entries === 'string') {
    entries = [entries];
  } else if (!Array.isArray(entries)) {
    entries = ['/'];
  }

  entries = entries.map(function (entry) {
    return (0, _LocationUtils.createLocation)(entry);
  });

  if (current == null) {
    current = entries.length - 1;
  } else {
    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
  }

  var storage = createStateStorage(entries);

  var saveState = function saveState(key, state) {
    return storage[key] = state;
  };

  var readState = function readState(key) {
    return storage[key];
  };

  return _extends({}, history, {
    canGo: canGo
  });
};

exports.default = createMemoryHistory;

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(695);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(694);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {// Coding standard for this project defined @ https://github.com/MatthewSH/standards/blob/master/JavaScript.md


exports = module.exports = !!(typeof process !== 'undefined' && process.versions && process.versions.node);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(87)))

/***/ }),
/* 697 */
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var printWarning = function() {};

if (false) {
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
  var has = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (false) {
    loggedTypeFailures = {};
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(303);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactIs = __webpack_require__(702);
var assign = __webpack_require__(11);

var ReactPropTypesSecret = __webpack_require__(303);
var checkPropTypes = __webpack_require__(698);

var has = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning = function() {};

if (false) {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (false) {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(701);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(832);
var objectAssign = __webpack_require__(11);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.load = load;
exports.select = select;
exports.save = save;
exports.remove = remove;
exports.setRawCookie = setRawCookie;
exports.plugToRequest = plugToRequest;

var _cookie = __webpack_require__(705);

var _cookie2 = _interopRequireDefault(_cookie);

var _objectAssign = __webpack_require__(11);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _isNode = __webpack_require__(696);

var _isNode2 = _interopRequireDefault(_isNode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _rawCookie = {};
var _res = undefined;

function _isResWritable() {
  return _res && !_res.headersSent;
}

function load(name, doNotParse, opt) {
  var cookies = _isNode2.default ? _rawCookie : _cookie2.default.parse(document.cookie, opt);
  var cookieVal = cookies && cookies[name];

  if (typeof doNotParse === 'undefined') {
    doNotParse = !cookieVal || cookieVal[0] !== '{' && cookieVal[0] !== '[';
  }

  if (!doNotParse) {
    try {
      cookieVal = JSON.parse(cookieVal);
    } catch (e) {
      // Not serialized object
    }
  }

  return cookieVal;
}

function select(regex) {
  var cookies = _isNode2.default ? _rawCookie : _cookie2.default.parse(document.cookie);

  if (!cookies) {
    return {};
  }

  if (!regex) {
    return cookies;
  }

  return Object.keys(cookies).reduce(function (accumulator, name) {
    if (!regex.test(name)) {
      return accumulator;
    }

    var newCookie = {};
    newCookie[name] = cookies[name];
    return (0, _objectAssign2.default)({}, accumulator, newCookie);
  }, {});
}

function save(name, val, opt) {
  _rawCookie[name] = val;

  // allow you to work with cookies as objects.
  if ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object') {
    _rawCookie[name] = JSON.stringify(val);
  }

  // Cookies only work in the browser
  if (!_isNode2.default) {
    document.cookie = _cookie2.default.serialize(name, _rawCookie[name], opt);
  }

  if (_isResWritable() && _res.cookie) {
    var expressOpt = _extends({}, opt);
    if (expressOpt.maxAge) {
      // the standard for maxAge is seconds but express uses milliseconds
      expressOpt.maxAge = opt.maxAge * 1000;
    }

    _res.cookie(name, val, opt);
  }
}

function remove(name, opt) {
  delete _rawCookie[name];

  if (typeof opt === 'undefined') {
    opt = {};
  } else if (typeof opt === 'string') {
    // Will be deprecated in future versions
    opt = { path: opt };
  } else {
    // Prevent mutation of opt below
    opt = (0, _objectAssign2.default)({}, opt);
  }

  if (typeof document !== 'undefined') {
    opt.expires = new Date(1970, 1, 1, 0, 0, 1);
    opt.maxAge = 0;
    document.cookie = _cookie2.default.serialize(name, '', opt);
  }

  if (_isResWritable() && _res.clearCookie) {
    _res.clearCookie(name, opt);
  }
}

function setRawCookie(rawCookie) {
  if (rawCookie) {
    _rawCookie = _cookie2.default.parse(rawCookie);
  } else {
    _rawCookie = {};
  }
}

function plugToRequest(req, res) {
  if (req.cookie) {
    _rawCookie = req.cookie;
  } else if (req.cookies) {
    _rawCookie = req.cookies;
  } else if (req.headers && req.headers.cookie) {
    setRawCookie(req.headers.cookie);
  } else {
    _rawCookie = {};
  }

  _res = res;

  return function unplug() {
    _res = null;
    _rawCookie = {};
  };
}

exports.default = {
  setRawCookie: setRawCookie,
  load: load,
  select: select,
  save: save,
  remove: remove,
  plugToRequest: plugToRequest
};

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.parse = parse;
exports.serialize = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;
var pairSplitRegExp = /; */;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var pairs = str.split(pairSplitRegExp);
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var eq_idx = pair.indexOf('=');

    // skip things that don't look like key=value
    if (eq_idx < 0) {
      continue;
    }

    var key = pair.substr(0, eq_idx).trim()
    var val = pair.substr(++eq_idx, pair.length).trim();

    // quoted values
    if ('"' == val[0]) {
      val = val.slice(1, -1);
    }

    // only assign once
    if (undefined == obj[key]) {
      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;
    if (isNaN(maxAge)) throw new Error('maxAge should be a Number');
    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ARIADOMPropertyConfig = {
  Properties: {
    // Global States and Properties
    'aria-current': 0, // state
    'aria-details': 0,
    'aria-disabled': 0, // state
    'aria-hidden': 0, // state
    'aria-invalid': 0, // state
    'aria-keyshortcuts': 0,
    'aria-label': 0,
    'aria-roledescription': 0,
    // Widget Attributes
    'aria-autocomplete': 0,
    'aria-checked': 0,
    'aria-expanded': 0,
    'aria-haspopup': 0,
    'aria-level': 0,
    'aria-modal': 0,
    'aria-multiline': 0,
    'aria-multiselectable': 0,
    'aria-orientation': 0,
    'aria-placeholder': 0,
    'aria-pressed': 0,
    'aria-readonly': 0,
    'aria-required': 0,
    'aria-selected': 0,
    'aria-sort': 0,
    'aria-valuemax': 0,
    'aria-valuemin': 0,
    'aria-valuenow': 0,
    'aria-valuetext': 0,
    // Live Region Attributes
    'aria-atomic': 0,
    'aria-busy': 0,
    'aria-live': 0,
    'aria-relevant': 0,
    // Drag-and-Drop Attributes
    'aria-dropeffect': 0,
    'aria-grabbed': 0,
    // Relationship Attributes
    'aria-activedescendant': 0,
    'aria-colcount': 0,
    'aria-colindex': 0,
    'aria-colspan': 0,
    'aria-controls': 0,
    'aria-describedby': 0,
    'aria-errormessage': 0,
    'aria-flowto': 0,
    'aria-labelledby': 0,
    'aria-owns': 0,
    'aria-posinset': 0,
    'aria-rowcount': 0,
    'aria-rowindex': 0,
    'aria-rowspan': 0,
    'aria-setsize': 0
  },
  DOMAttributeNames: {},
  DOMPropertyNames: {}
};

module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMComponentTree = __webpack_require__(17);

var focusNode = __webpack_require__(297);

var AutoFocusUtils = {
  focusDOMComponent: function () {
    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
  }
};

module.exports = AutoFocusUtils;

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPropagators = __webpack_require__(120);
var ExecutionEnvironment = __webpack_require__(24);
var FallbackCompositionState = __webpack_require__(714);
var SyntheticCompositionEvent = __webpack_require__(748);
var SyntheticInputEvent = __webpack_require__(751);

var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
var START_KEYCODE = 229;

var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;

var documentMode = null;
if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
  documentMode = document.documentMode;
}

// Webkit offers a very useful `textInput` event that can be used to
// directly represent `beforeInput`. The IE `textinput` event is not as
// useful, so we don't use it.
var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();

// In IE9+, we have access to composition events, but the data supplied
// by the native compositionend event may be incorrect. Japanese ideographic
// spaces, for instance (\u3000) are not recorded correctly.
var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);

/**
 * Opera <= 12 includes TextEvent in window, but does not fire
 * text input events. Rely on keypress instead.
 */
function isPresto() {
  var opera = window.opera;
  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
}

var SPACEBAR_CODE = 32;
var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

// Events and their corresponding property names.
var eventTypes = {
  beforeInput: {
    phasedRegistrationNames: {
      bubbled: 'onBeforeInput',
      captured: 'onBeforeInputCapture'
    },
    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
  },
  compositionEnd: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionEnd',
      captured: 'onCompositionEndCapture'
    },
    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionStart: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionStart',
      captured: 'onCompositionStartCapture'
    },
    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionUpdate: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionUpdate',
      captured: 'onCompositionUpdateCapture'
    },
    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  }
};

// Track whether we've ever handled a keypress on the space key.
var hasSpaceKeypress = false;

/**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */
function isKeypressCommand(nativeEvent) {
  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
  !(nativeEvent.ctrlKey && nativeEvent.altKey);
}

/**
 * Translate native top level events into event types.
 *
 * @param {string} topLevelType
 * @return {object}
 */
function getCompositionEventType(topLevelType) {
  switch (topLevelType) {
    case 'topCompositionStart':
      return eventTypes.compositionStart;
    case 'topCompositionEnd':
      return eventTypes.compositionEnd;
    case 'topCompositionUpdate':
      return eventTypes.compositionUpdate;
  }
}

/**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionStart(topLevelType, nativeEvent) {
  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
}

/**
 * Does our fallback mode think that this event is the end of composition?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionEnd(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topKeyUp':
      // Command keys insert or clear IME input.
      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
    case 'topKeyDown':
      // Expect IME keyCode on each keydown. If we get any other
      // code we must have exited earlier.
      return nativeEvent.keyCode !== START_KEYCODE;
    case 'topKeyPress':
    case 'topMouseDown':
    case 'topBlur':
      // Events are not possible without cancelling IME.
      return true;
    default:
      return false;
  }
}

/**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */
function getDataFromCustomEvent(nativeEvent) {
  var detail = nativeEvent.detail;
  if (typeof detail === 'object' && 'data' in detail) {
    return detail.data;
  }
  return null;
}

// Track the current IME composition fallback object, if any.
var currentComposition = null;

/**
 * @return {?object} A SyntheticCompositionEvent.
 */
function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var eventType;
  var fallbackData;

  if (canUseCompositionEvent) {
    eventType = getCompositionEventType(topLevelType);
  } else if (!currentComposition) {
    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
      eventType = eventTypes.compositionStart;
    }
  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
    eventType = eventTypes.compositionEnd;
  }

  if (!eventType) {
    return null;
  }

  if (useFallbackCompositionData) {
    // The current composition is stored statically and must not be
    // overwritten while composition continues.
    if (!currentComposition && eventType === eventTypes.compositionStart) {
      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
    } else if (eventType === eventTypes.compositionEnd) {
      if (currentComposition) {
        fallbackData = currentComposition.getData();
      }
    }
  }

  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);

  if (fallbackData) {
    // Inject data generated from fallback path into the synthetic event.
    // This matches the property of native CompositionEventInterface.
    event.data = fallbackData;
  } else {
    var customData = getDataFromCustomEvent(nativeEvent);
    if (customData !== null) {
      event.data = customData;
    }
  }

  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The string corresponding to this `beforeInput` event.
 */
function getNativeBeforeInputChars(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topCompositionEnd':
      return getDataFromCustomEvent(nativeEvent);
    case 'topKeyPress':
      /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */
      var which = nativeEvent.which;
      if (which !== SPACEBAR_CODE) {
        return null;
      }

      hasSpaceKeypress = true;
      return SPACEBAR_CHAR;

    case 'topTextInput':
      // Record the characters to be added to the DOM.
      var chars = nativeEvent.data;

      // If it's a spacebar character, assume that we have already handled
      // it at the keypress level and bail immediately. Android Chrome
      // doesn't give us keycodes, so we need to blacklist it.
      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
        return null;
      }

      return chars;

    default:
      // For other native event types, do nothing.
      return null;
  }
}

/**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 *
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The fallback string for this `beforeInput` event.
 */
function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
  // If we are currently composing (IME) and using a fallback to do so,
  // try to extract the composed characters from the fallback object.
  // If composition event is available, we extract a string only at
  // compositionevent, otherwise extract it at fallback events.
  if (currentComposition) {
    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
      var chars = currentComposition.getData();
      FallbackCompositionState.release(currentComposition);
      currentComposition = null;
      return chars;
    }
    return null;
  }

  switch (topLevelType) {
    case 'topPaste':
      // If a paste event occurs after a keypress, throw out the input
      // chars. Paste events should not lead to BeforeInput events.
      return null;
    case 'topKeyPress':
      /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */
      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
        return String.fromCharCode(nativeEvent.which);
      }
      return null;
    case 'topCompositionEnd':
      return useFallbackCompositionData ? null : nativeEvent.data;
    default:
      return null;
  }
}

/**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */
function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var chars;

  if (canUseTextInputEvent) {
    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
  } else {
    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
  }

  // If no characters are being inserted, no BeforeInput event should
  // be fired.
  if (!chars) {
    return null;
  }

  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);

  event.data = chars;
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */
var BeforeInputEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
  }
};

module.exports = BeforeInputEventPlugin;

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var CSSProperty = __webpack_require__(305);
var ExecutionEnvironment = __webpack_require__(24);
var ReactInstrumentation = __webpack_require__(38);

var camelizeStyleName = __webpack_require__(676);
var dangerousStyleValue = __webpack_require__(757);
var hyphenateStyleName = __webpack_require__(683);
var memoizeStringOnly = __webpack_require__(686);
var warning = __webpack_require__(10);

var processStyleName = memoizeStringOnly(function (styleName) {
  return hyphenateStyleName(styleName);
});

var hasShorthandPropertyBug = false;
var styleFloatAccessor = 'cssFloat';
if (ExecutionEnvironment.canUseDOM) {
  var tempStyle = document.createElement('div').style;
  try {
    // IE8 throws "Invalid argument." if resetting shorthand style properties.
    tempStyle.font = '';
  } catch (e) {
    hasShorthandPropertyBug = true;
  }
  // IE8 only supports accessing cssFloat (standard) as styleFloat
  if (document.documentElement.style.cssFloat === undefined) {
    styleFloatAccessor = 'styleFloat';
  }
}

if (false) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;

  var warnHyphenatedStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
  };

  var warnBadVendoredStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
  };

  var warnStyleValueWithSemicolon = function (name, value, owner) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
  };

  var warnStyleValueIsNaN = function (name, value, owner) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;
    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
  };

  var checkRenderMessage = function (owner) {
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' Check the render method of `' + name + '`.';
      }
    }
    return '';
  };

  /**
   * @param {string} name
   * @param {*} value
   * @param {ReactDOMComponent} component
   */
  var warnValidStyle = function (name, value, component) {
    var owner;
    if (component) {
      owner = component._currentElement._owner;
    }
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name, owner);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name, owner);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value, owner);
    }

    if (typeof value === 'number' && isNaN(value)) {
      warnStyleValueIsNaN(name, value, owner);
    }
  };
}

/**
 * Operations for dealing with CSS properties.
 */
var CSSPropertyOperations = {
  /**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */
  createMarkupForStyles: function (styles, component) {
    var serialized = '';
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      var styleValue = styles[styleName];
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styleValue, component);
        }
      }
      if (styleValue != null) {
        serialized += processStyleName(styleName) + ':';
        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
      }
    }
    return serialized || null;
  },

  /**
   * Sets the value for multiple styles on a node.  If a value is specified as
   * '' (empty string), the corresponding style property will be unset.
   *
   * @param {DOMElement} node
   * @param {object} styles
   * @param {ReactDOMComponent} component
   */
  setValueForStyles: function (node, styles, component) {
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: component._debugID,
        type: 'update styles',
        payload: styles
      });
    }

    var style = node.style;
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styles[styleName], component);
        }
      }
      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
      if (styleName === 'float' || styleName === 'cssFloat') {
        styleName = styleFloatAccessor;
      }
      if (isCustomProperty) {
        style.setProperty(styleName, styleValue);
      } else if (styleValue) {
        style[styleName] = styleValue;
      } else {
        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
        if (expansion) {
          // Shorthand property that IE8 won't like unsetting, so unset each
          // component to placate it
          for (var individualStyleName in expansion) {
            style[individualStyleName] = '';
          }
        } else {
          style[styleName] = '';
        }
      }
    }
  }
};

module.exports = CSSPropertyOperations;

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPluginHub = __webpack_require__(119);
var EventPropagators = __webpack_require__(120);
var ExecutionEnvironment = __webpack_require__(24);
var ReactDOMComponentTree = __webpack_require__(17);
var ReactUpdates = __webpack_require__(45);
var SyntheticEvent = __webpack_require__(56);

var inputValueTracking = __webpack_require__(327);
var getEventTarget = __webpack_require__(217);
var isEventSupported = __webpack_require__(219);
var isTextInputElement = __webpack_require__(328);

var eventTypes = {
  change: {
    phasedRegistrationNames: {
      bubbled: 'onChange',
      captured: 'onChangeCapture'
    },
    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
  }
};

function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
  event.type = 'change';
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}
/**
 * For IE shims
 */
var activeElement = null;
var activeElementInst = null;

/**
 * SECTION: handle `change` event
 */
function shouldUseChangeEvent(elem) {
  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
}

var doesChangeEventBubble = false;
if (ExecutionEnvironment.canUseDOM) {
  // See `handleChange` comment below
  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
}

function manualDispatchChangeEvent(nativeEvent) {
  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));

  // If change and propertychange bubbled, we'd just bind to it like all the
  // other events and have it go through ReactBrowserEventEmitter. Since it
  // doesn't, we manually listen for the events and so we have to enqueue and
  // process the abstract event manually.
  //
  // Batching is necessary here in order to ensure that all event handlers run
  // before the next rerender (including event handlers attached to ancestor
  // elements instead of directly on the input). Without this, controlled
  // components don't work properly in conjunction with event bubbling because
  // the component is rerendered and the value reverted before all the event
  // handlers can run. See https://github.com/facebook/react/issues/708.
  ReactUpdates.batchedUpdates(runEventInBatch, event);
}

function runEventInBatch(event) {
  EventPluginHub.enqueueEvents(event);
  EventPluginHub.processEventQueue(false);
}

function startWatchingForChangeEventIE8(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
}

function stopWatchingForChangeEventIE8() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
  activeElement = null;
  activeElementInst = null;
}

function getInstIfValueChanged(targetInst, nativeEvent) {
  var updated = inputValueTracking.updateValueIfChanged(targetInst);
  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;

  if (updated || simulated) {
    return targetInst;
  }
}

function getTargetInstForChangeEvent(topLevelType, targetInst) {
  if (topLevelType === 'topChange') {
    return targetInst;
  }
}

function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForChangeEventIE8();
    startWatchingForChangeEventIE8(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForChangeEventIE8();
  }
}

/**
 * SECTION: handle `input` event
 */
var isInputEventSupported = false;
if (ExecutionEnvironment.canUseDOM) {
  // IE9 claims to support the input event but fails to trigger it when
  // deleting text, so we ignore its input events.

  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
}

/**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */
function startWatchingForValueChange(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onpropertychange', handlePropertyChange);
}

/**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */
function stopWatchingForValueChange() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onpropertychange', handlePropertyChange);

  activeElement = null;
  activeElementInst = null;
}

/**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */
function handlePropertyChange(nativeEvent) {
  if (nativeEvent.propertyName !== 'value') {
    return;
  }
  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
    manualDispatchChangeEvent(nativeEvent);
  }
}

function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // In IE8, we can capture almost all .value changes by adding a
    // propertychange handler and looking for events with propertyName
    // equal to 'value'
    // In IE9, propertychange fires for most input events but is buggy and
    // doesn't fire when text is deleted, but conveniently, selectionchange
    // appears to fire in all of the remaining cases so we catch those and
    // forward the event if the value has changed
    // In either case, we don't want to call the event handler if the value
    // is changed from JS so we redefine a setter for `.value` that updates
    // our activeElementValue variable, allowing us to ignore those changes
    //
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForValueChange();
    startWatchingForValueChange(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForValueChange();
  }
}

// For IE8 and IE9.
function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
    // On the selectionchange event, the target is just document which isn't
    // helpful for us so just check activeElement instead.
    //
    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
    // propertychange on the first input event after setting `value` from a
    // script and fires only keydown, keypress, keyup. Catching keyup usually
    // gets it and catching keydown lets us fire an event for the first
    // keystroke if user does a key repeat (it'll be a little delayed: right
    // before the second keystroke). Other input methods (e.g., paste) seem to
    // fire selectionchange normally.
    return getInstIfValueChanged(activeElementInst, nativeEvent);
  }
}

/**
 * SECTION: handle `click` event
 */
function shouldUseClickEvent(elem) {
  // Use the `click` event to detect changes to checkbox and radio inputs.
  // This approach works across all browsers, whereas `change` does not fire
  // until `blur` in IE8.
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
}

function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topClick') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function handleControlledInputBlur(inst, node) {
  // TODO: In IE, inst is occasionally null. Why?
  if (inst == null) {
    return;
  }

  // Fiber and ReactDOM keep wrapper state in separate places
  var state = inst._wrapperState || node._wrapperState;

  if (!state || !state.controlled || node.type !== 'number') {
    return;
  }

  // If controlled, assign the value attribute to the current value on blur
  var value = '' + node.value;
  if (node.getAttribute('value') !== value) {
    node.setAttribute('value', value);
  }
}

/**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */
var ChangeEventPlugin = {
  eventTypes: eventTypes,

  _allowSimulatedPassThrough: true,
  _isInputEventSupported: isInputEventSupported,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    var getTargetInstFunc, handleEventFunc;
    if (shouldUseChangeEvent(targetNode)) {
      if (doesChangeEventBubble) {
        getTargetInstFunc = getTargetInstForChangeEvent;
      } else {
        handleEventFunc = handleEventsForChangeEventIE8;
      }
    } else if (isTextInputElement(targetNode)) {
      if (isInputEventSupported) {
        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
      } else {
        getTargetInstFunc = getTargetInstForInputEventPolyfill;
        handleEventFunc = handleEventsForInputEventPolyfill;
      }
    } else if (shouldUseClickEvent(targetNode)) {
      getTargetInstFunc = getTargetInstForClickEvent;
    }

    if (getTargetInstFunc) {
      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
      if (inst) {
        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
        return event;
      }
    }

    if (handleEventFunc) {
      handleEventFunc(topLevelType, targetNode, targetInst);
    }

    // When blurring, set the value attribute for number inputs
    if (topLevelType === 'topBlur') {
      handleControlledInputBlur(targetInst, targetNode);
    }
  }
};

module.exports = ChangeEventPlugin;

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(9);

var DOMLazyTree = __webpack_require__(99);
var ExecutionEnvironment = __webpack_require__(24);

var createNodesFromMarkup = __webpack_require__(679);
var emptyFunction = __webpack_require__(50);
var invariant = __webpack_require__(3);

var Danger = {
  /**
   * Replaces a node with a string of markup at its current position within its
   * parent. The markup must render into a single root node.
   *
   * @param {DOMElement} oldChild Child node to replace.
   * @param {string} markup Markup to render in place of the child node.
   * @internal
   */
  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;

    if (typeof markup === 'string') {
      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
      oldChild.parentNode.replaceChild(newChild, oldChild);
    } else {
      DOMLazyTree.replaceChildWithTree(oldChild, markup);
    }
  }
};

module.exports = Danger;

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Module that is injectable into `EventPluginHub`, that specifies a
 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
 * plugins, without having to package every one of them. This is better than
 * having plugins be ordered in the same order that they are injected because
 * that ordering would be influenced by the packaging order.
 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
 */

var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];

module.exports = DefaultEventPluginOrder;

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPropagators = __webpack_require__(120);
var ReactDOMComponentTree = __webpack_require__(17);
var SyntheticMouseEvent = __webpack_require__(152);

var eventTypes = {
  mouseEnter: {
    registrationName: 'onMouseEnter',
    dependencies: ['topMouseOut', 'topMouseOver']
  },
  mouseLeave: {
    registrationName: 'onMouseLeave',
    dependencies: ['topMouseOut', 'topMouseOver']
  }
};

var EnterLeaveEventPlugin = {
  eventTypes: eventTypes,

  /**
   * For almost every interaction we care about, there will be both a top-level
   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
   * we do not extract duplicate events. However, moving the mouse into the
   * browser from outside will not fire a `mouseout` event. In this case, we use
   * the `mouseover` top-level event.
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
      return null;
    }
    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
      // Must not be a mouse in or mouse out - ignoring.
      return null;
    }

    var win;
    if (nativeEventTarget.window === nativeEventTarget) {
      // `nativeEventTarget` is probably a window object.
      win = nativeEventTarget;
    } else {
      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
      var doc = nativeEventTarget.ownerDocument;
      if (doc) {
        win = doc.defaultView || doc.parentWindow;
      } else {
        win = window;
      }
    }

    var from;
    var to;
    if (topLevelType === 'topMouseOut') {
      from = targetInst;
      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
    } else {
      // Moving to a node from outside the window.
      from = null;
      to = targetInst;
    }

    if (from === to) {
      // Nothing pertains to our managed components.
      return null;
    }

    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);

    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
    leave.type = 'mouseleave';
    leave.target = fromNode;
    leave.relatedTarget = toNode;

    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
    enter.type = 'mouseenter';
    enter.target = toNode;
    enter.relatedTarget = fromNode;

    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);

    return [leave, enter];
  }
};

module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(11);

var PooledClass = __webpack_require__(88);

var getTextContentAccessor = __webpack_require__(326);

/**
 * This helper class stores information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 * @param {DOMEventTarget} root
 */
function FallbackCompositionState(root) {
  this._root = root;
  this._startText = this.getText();
  this._fallbackText = null;
}

_assign(FallbackCompositionState.prototype, {
  destructor: function () {
    this._root = null;
    this._startText = null;
    this._fallbackText = null;
  },

  /**
   * Get current text of input.
   *
   * @return {string}
   */
  getText: function () {
    if ('value' in this._root) {
      return this._root.value;
    }
    return this._root[getTextContentAccessor()];
  },

  /**
   * Determine the differing substring between the initially stored
   * text content and the current content.
   *
   * @return {string}
   */
  getData: function () {
    if (this._fallbackText) {
      return this._fallbackText;
    }

    var start;
    var startValue = this._startText;
    var startLength = startValue.length;
    var end;
    var endValue = this.getText();
    var endLength = endValue.length;

    for (start = 0; start < startLength; start++) {
      if (startValue[start] !== endValue[start]) {
        break;
      }
    }

    var minEnd = startLength - start;
    for (end = 1; end <= minEnd; end++) {
      if (startValue[startLength - end] !== endValue[endLength - end]) {
        break;
      }
    }

    var sliceTail = end > 1 ? 1 - end : undefined;
    this._fallbackText = endValue.slice(start, sliceTail);
    return this._fallbackText;
  }
});

PooledClass.addPoolingTo(FallbackCompositionState);

module.exports = FallbackCompositionState;

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMProperty = __webpack_require__(100);

var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

var HTMLDOMPropertyConfig = {
  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
  Properties: {
    /**
     * Standard Properties
     */
    accept: 0,
    acceptCharset: 0,
    accessKey: 0,
    action: 0,
    allowFullScreen: HAS_BOOLEAN_VALUE,
    allowTransparency: 0,
    alt: 0,
    // specifies target context for links with `preload` type
    as: 0,
    async: HAS_BOOLEAN_VALUE,
    autoComplete: 0,
    // autoFocus is polyfilled/normalized by AutoFocusUtils
    // autoFocus: HAS_BOOLEAN_VALUE,
    autoPlay: HAS_BOOLEAN_VALUE,
    capture: HAS_BOOLEAN_VALUE,
    cellPadding: 0,
    cellSpacing: 0,
    charSet: 0,
    challenge: 0,
    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    cite: 0,
    classID: 0,
    className: 0,
    cols: HAS_POSITIVE_NUMERIC_VALUE,
    colSpan: 0,
    content: 0,
    contentEditable: 0,
    contextMenu: 0,
    controls: HAS_BOOLEAN_VALUE,
    controlsList: 0,
    coords: 0,
    crossOrigin: 0,
    data: 0, // For `<object />` acts as `src`.
    dateTime: 0,
    'default': HAS_BOOLEAN_VALUE,
    defer: HAS_BOOLEAN_VALUE,
    dir: 0,
    disabled: HAS_BOOLEAN_VALUE,
    download: HAS_OVERLOADED_BOOLEAN_VALUE,
    draggable: 0,
    encType: 0,
    form: 0,
    formAction: 0,
    formEncType: 0,
    formMethod: 0,
    formNoValidate: HAS_BOOLEAN_VALUE,
    formTarget: 0,
    frameBorder: 0,
    headers: 0,
    height: 0,
    hidden: HAS_BOOLEAN_VALUE,
    high: 0,
    href: 0,
    hrefLang: 0,
    htmlFor: 0,
    httpEquiv: 0,
    icon: 0,
    id: 0,
    inputMode: 0,
    integrity: 0,
    is: 0,
    keyParams: 0,
    keyType: 0,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: HAS_BOOLEAN_VALUE,
    low: 0,
    manifest: 0,
    marginHeight: 0,
    marginWidth: 0,
    max: 0,
    maxLength: 0,
    media: 0,
    mediaGroup: 0,
    method: 0,
    min: 0,
    minLength: 0,
    // Caution; `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`.
    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    name: 0,
    nonce: 0,
    noValidate: HAS_BOOLEAN_VALUE,
    open: HAS_BOOLEAN_VALUE,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: HAS_BOOLEAN_VALUE,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 0,
    readOnly: HAS_BOOLEAN_VALUE,
    referrerPolicy: 0,
    rel: 0,
    required: HAS_BOOLEAN_VALUE,
    reversed: HAS_BOOLEAN_VALUE,
    role: 0,
    rows: HAS_POSITIVE_NUMERIC_VALUE,
    rowSpan: HAS_NUMERIC_VALUE,
    sandbox: 0,
    scope: 0,
    scoped: HAS_BOOLEAN_VALUE,
    scrolling: 0,
    seamless: HAS_BOOLEAN_VALUE,
    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    shape: 0,
    size: HAS_POSITIVE_NUMERIC_VALUE,
    sizes: 0,
    span: HAS_POSITIVE_NUMERIC_VALUE,
    spellCheck: 0,
    src: 0,
    srcDoc: 0,
    srcLang: 0,
    srcSet: 0,
    start: HAS_NUMERIC_VALUE,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 0,
    target: 0,
    title: 0,
    // Setting .type throws on non-<input> tags
    type: 0,
    useMap: 0,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,

    /**
     * RDFa Properties
     */
    about: 0,
    datatype: 0,
    inlist: 0,
    prefix: 0,
    // property is also supported for OpenGraph in meta tags.
    property: 0,
    resource: 0,
    'typeof': 0,
    vocab: 0,

    /**
     * Non-standard Properties
     */
    // autoCapitalize and autoCorrect are supported in Mobile Safari for
    // keyboard hints.
    autoCapitalize: 0,
    autoCorrect: 0,
    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
    autoSave: 0,
    // color is for Safari mask-icon link
    color: 0,
    // itemProp, itemScope, itemType are for
    // Microdata support. See http://schema.org/docs/gs.html
    itemProp: 0,
    itemScope: HAS_BOOLEAN_VALUE,
    itemType: 0,
    // itemID and itemRef are for Microdata support as well but
    // only specified in the WHATWG spec document. See
    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
    itemID: 0,
    itemRef: 0,
    // results show looking glass icon and recent searches on input
    // search fields in WebKit/Blink
    results: 0,
    // IE-only attribute that specifies security restrictions on an iframe
    // as an alternative to the sandbox attribute on IE<10
    security: 0,
    // IE-only attribute that controls focus behavior
    unselectable: 0
  },
  DOMAttributeNames: {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
  },
  DOMPropertyNames: {},
  DOMMutationMethods: {
    value: function (node, value) {
      if (value == null) {
        return node.removeAttribute('value');
      }

      // Number inputs get special treatment due to some edge cases in
      // Chrome. Let everything else assign the value attribute as normal.
      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
      if (node.type !== 'number' || node.hasAttribute('value') === false) {
        node.setAttribute('value', '' + value);
      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
        // Don't assign an attribute if validation reports bad
        // input. Chrome will clear the value. Additionally, don't
        // operate on inputs that have focus, otherwise Chrome might
        // strip off trailing decimal places and cause the user's
        // cursor position to jump to the beginning of the input.
        //
        // In ReactDOMInput, we have an onBlur event that will trigger
        // this function again when focus is lost.
        node.setAttribute('value', '' + value);
      }
    }
  }
};

module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactReconciler = __webpack_require__(89);

var instantiateReactComponent = __webpack_require__(218);
var KeyEscapeUtils = __webpack_require__(209);
var shouldUpdateReactComponent = __webpack_require__(220);
var traverseAllChildren = __webpack_require__(330);
var warning = __webpack_require__(10);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && __webpack_require__.i({"NODE_ENV":"production"}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(352);
}

function instantiateChild(childInstances, child, name, selfDebugID) {
  // We found a component instance.
  var keyUnique = childInstances[name] === undefined;
  if (false) {
    if (!ReactComponentTreeHook) {
      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
    }
    if (!keyUnique) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
    }
  }
  if (child != null && keyUnique) {
    childInstances[name] = instantiateReactComponent(child, true);
  }
}

/**
 * ReactChildReconciler provides helpers for initializing or updating a set of
 * children. Its output is suitable for passing it onto ReactMultiChild which
 * does diffed reordering and insertion.
 */
var ReactChildReconciler = {
  /**
   * Generates a "mount image" for each of the supplied children. In the case
   * of `ReactDOMComponent`, a mount image is a string of markup.
   *
   * @param {?object} nestedChildNodes Nested child maps.
   * @return {?object} A set of child instances.
   * @internal
   */
  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
  {
    if (nestedChildNodes == null) {
      return null;
    }
    var childInstances = {};

    if (false) {
      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
        return instantiateChild(childInsts, child, name, selfDebugID);
      }, childInstances);
    } else {
      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
    }
    return childInstances;
  },

  /**
   * Updates the rendered children and returns a new set of children.
   *
   * @param {?object} prevChildren Previously initialized set of children.
   * @param {?object} nextChildren Flat child element maps.
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @return {?object} A new set of child instances.
   * @internal
   */
  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
  {
    // We currently don't have a way to track moves here but if we use iterators
    // instead of for..in we can zip the iterators and check if an item has
    // moved.
    // TODO: If nothing has changed, return the prevChildren object so that we
    // can quickly bailout if nothing has changed.
    if (!nextChildren && !prevChildren) {
      return;
    }
    var name;
    var prevChild;
    for (name in nextChildren) {
      if (!nextChildren.hasOwnProperty(name)) {
        continue;
      }
      prevChild = prevChildren && prevChildren[name];
      var prevElement = prevChild && prevChild._currentElement;
      var nextElement = nextChildren[name];
      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
        nextChildren[name] = prevChild;
      } else {
        if (prevChild) {
          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
          ReactReconciler.unmountComponent(prevChild, false);
        }
        // The child must be instantiated before it's mounted.
        var nextChildInstance = instantiateReactComponent(nextElement, true);
        nextChildren[name] = nextChildInstance;
        // Creating mount image now ensures refs are resolved in right order
        // (see https://github.com/facebook/react/pull/7101 for explanation).
        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
        mountImages.push(nextChildMountImage);
      }
    }
    // Unmount children that are no longer present.
    for (name in prevChildren) {
      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
        prevChild = prevChildren[name];
        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
        ReactReconciler.unmountComponent(prevChild, false);
      }
    }
  },

  /**
   * Unmounts all rendered children. This should be used to clean up children
   * when this component is unmounted.
   *
   * @param {?object} renderedChildren Previously initialized set of children.
   * @internal
   */
  unmountChildren: function (renderedChildren, safely) {
    for (var name in renderedChildren) {
      if (renderedChildren.hasOwnProperty(name)) {
        var renderedChild = renderedChildren[name];
        ReactReconciler.unmountComponent(renderedChild, safely);
      }
    }
  }
};

module.exports = ReactChildReconciler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(87)))

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMChildrenOperations = __webpack_require__(205);
var ReactDOMIDOperations = __webpack_require__(723);

/**
 * Abstracts away all functionality of the reconciler that requires knowledge of
 * the browser context. TODO: These callers should be refactored to avoid the
 * need for this injection.
 */
var ReactComponentBrowserEnvironment = {
  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,

  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
};

module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(9),
    _assign = __webpack_require__(11);

var React = __webpack_require__(90);
var ReactComponentEnvironment = __webpack_require__(211);
var ReactCurrentOwner = __webpack_require__(57);
var ReactErrorUtils = __webpack_require__(212);
var ReactInstanceMap = __webpack_require__(121);
var ReactInstrumentation = __webpack_require__(38);
var ReactNodeTypes = __webpack_require__(319);
var ReactReconciler = __webpack_require__(89);

if (false) {
  var checkReactTypeSpec = require('./checkReactTypeSpec');
}

var emptyObject = __webpack_require__(147);
var invariant = __webpack_require__(3);
var shallowEqual = __webpack_require__(200);
var shouldUpdateReactComponent = __webpack_require__(220);
var warning = __webpack_require__(10);

var CompositeTypes = {
  ImpureClass: 0,
  PureClass: 1,
  StatelessFunctional: 2
};

function StatelessComponent(Component) {}
StatelessComponent.prototype.render = function () {
  var Component = ReactInstanceMap.get(this)._currentElement.type;
  var element = Component(this.props, this.context, this.updater);
  warnIfInvalidElement(Component, element);
  return element;
};

function warnIfInvalidElement(Component, element) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
  }
}

function shouldConstruct(Component) {
  return !!(Component.prototype && Component.prototype.isReactComponent);
}

function isPureComponent(Component) {
  return !!(Component.prototype && Component.prototype.isPureReactComponent);
}

// Separated into a function to contain deoptimizations caused by try/finally.
function measureLifeCyclePerf(fn, debugID, timerType) {
  if (debugID === 0) {
    // Top-level wrappers (see ReactMount) and empty components (see
    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
    // Both are implementation details that should go away in the future.
    return fn();
  }

  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
  try {
    return fn();
  } finally {
    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
  }
}

/**
 * ------------------ The Life-Cycle of a Composite Component ------------------
 *
 * - constructor: Initialization of state. The instance is now retained.
 *   - componentWillMount
 *   - render
 *   - [children's constructors]
 *     - [children's componentWillMount and render]
 *     - [children's componentDidMount]
 *     - componentDidMount
 *
 *       Update Phases:
 *       - componentWillReceiveProps (only called if parent updated)
 *       - shouldComponentUpdate
 *         - componentWillUpdate
 *           - render
 *           - [children's constructors or receive props phases]
 *         - componentDidUpdate
 *
 *     - componentWillUnmount
 *     - [children's componentWillUnmount]
 *   - [children destroyed]
 * - (destroyed): The instance is now blank, released by React and ready for GC.
 *
 * -----------------------------------------------------------------------------
 */

/**
 * An incrementing ID assigned to each component when it is mounted. This is
 * used to enforce the order in which `ReactUpdates` updates dirty components.
 *
 * @private
 */
var nextMountID = 1;

/**
 * @lends {ReactCompositeComponent.prototype}
 */
var ReactCompositeComponent = {
  /**
   * Base constructor for all composite component.
   *
   * @param {ReactElement} element
   * @final
   * @internal
   */
  construct: function (element) {
    this._currentElement = element;
    this._rootNodeID = 0;
    this._compositeType = null;
    this._instance = null;
    this._hostParent = null;
    this._hostContainerInfo = null;

    // See ReactUpdateQueue
    this._updateBatchNumber = null;
    this._pendingElement = null;
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    this._renderedNodeType = null;
    this._renderedComponent = null;
    this._context = null;
    this._mountOrder = 0;
    this._topLevelWrapper = null;

    // See ReactUpdates and ReactUpdateQueue.
    this._pendingCallbacks = null;

    // ComponentWillUnmount shall only be called once
    this._calledComponentWillUnmount = false;

    if (false) {
      this._warnedAboutRefsInRender = false;
    }
  },

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} hostParent
   * @param {?object} hostContainerInfo
   * @param {?object} context
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var _this = this;

    this._context = context;
    this._mountOrder = nextMountID++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var publicProps = this._currentElement.props;
    var publicContext = this._processContext(context);

    var Component = this._currentElement.type;

    var updateQueue = transaction.getUpdateQueue();

    // Initialize the public class
    var doConstruct = shouldConstruct(Component);
    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
    var renderedElement;

    // Support functional components
    if (!doConstruct && (inst == null || inst.render == null)) {
      renderedElement = inst;
      warnIfInvalidElement(Component, renderedElement);
      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
      inst = new StatelessComponent(Component);
      this._compositeType = CompositeTypes.StatelessFunctional;
    } else {
      if (isPureComponent(Component)) {
        this._compositeType = CompositeTypes.PureClass;
      } else {
        this._compositeType = CompositeTypes.ImpureClass;
      }
    }

    if (false) {
      // This will throw later in _renderValidatedComponent, but add an early
      // warning now to help debugging
      if (inst.render == null) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
      }

      var propsMutated = inst.props !== publicProps;
      var componentName = Component.displayName || Component.name || 'Component';

      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
    }

    // These should be set up in the constructor, but as a convenience for
    // simpler class abstractions, we set them up after the fact.
    inst.props = publicProps;
    inst.context = publicContext;
    inst.refs = emptyObject;
    inst.updater = updateQueue;

    this._instance = inst;

    // Store a reference from the instance back to the internal representation
    ReactInstanceMap.set(inst, this);

    if (false) {
      // Since plain JS classes are defined without any special initialization
      // logic, we can not catch common errors early. Therefore, we have to
      // catch them here, at initialization time, instead.
      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
    }

    var initialState = inst.state;
    if (initialState === undefined) {
      inst.state = initialState = null;
    }
    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;

    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    var markup;
    if (inst.unstable_handleError) {
      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } else {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }

    if (inst.componentDidMount) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(function () {
            return inst.componentDidMount();
          }, _this._debugID, 'componentDidMount');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
      }
    }

    return markup;
  },

  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
    if (false) {
      ReactCurrentOwner.current = this;
      try {
        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
    }
  },

  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
    var Component = this._currentElement.type;

    if (doConstruct) {
      if (false) {
        return measureLifeCyclePerf(function () {
          return new Component(publicProps, publicContext, updateQueue);
        }, this._debugID, 'ctor');
      } else {
        return new Component(publicProps, publicContext, updateQueue);
      }
    }

    // This can still be an instance in case of factory components
    // but we'll count this as time spent rendering as the more common case.
    if (false) {
      return measureLifeCyclePerf(function () {
        return Component(publicProps, publicContext, updateQueue);
      }, this._debugID, 'render');
    } else {
      return Component(publicProps, publicContext, updateQueue);
    }
  },

  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var markup;
    var checkpoint = transaction.checkpoint();
    try {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } catch (e) {
      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
      transaction.rollback(checkpoint);
      this._instance.unstable_handleError(e);
      if (this._pendingStateQueue) {
        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
      }
      checkpoint = transaction.checkpoint();

      this._renderedComponent.unmountComponent(true);
      transaction.rollback(checkpoint);

      // Try again - we've informed the component about the error, so they can render an error message this time.
      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }
    return markup;
  },

  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var inst = this._instance;

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (inst.componentWillMount) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillMount();
        }, debugID, 'componentWillMount');
      } else {
        inst.componentWillMount();
      }
      // When mounting, calls to `setState` by `componentWillMount` will set
      // `this._pendingStateQueue` without triggering a re-render.
      if (this._pendingStateQueue) {
        inst.state = this._processPendingState(inst.props, inst.context);
      }
    }

    // If not a stateless component, we now render
    if (renderedElement === undefined) {
      renderedElement = this._renderValidatedComponent();
    }

    var nodeType = ReactNodeTypes.getType(renderedElement);
    this._renderedNodeType = nodeType;
    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
    );
    this._renderedComponent = child;

    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);

    if (false) {
      if (debugID !== 0) {
        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
      }
    }

    return markup;
  },

  getHostNode: function () {
    return ReactReconciler.getHostNode(this._renderedComponent);
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (safely) {
    if (!this._renderedComponent) {
      return;
    }

    var inst = this._instance;

    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
      inst._calledComponentWillUnmount = true;

      if (safely) {
        var name = this.getName() + '.componentWillUnmount()';
        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
      } else {
        if (false) {
          measureLifeCyclePerf(function () {
            return inst.componentWillUnmount();
          }, this._debugID, 'componentWillUnmount');
        } else {
          inst.componentWillUnmount();
        }
      }
    }

    if (this._renderedComponent) {
      ReactReconciler.unmountComponent(this._renderedComponent, safely);
      this._renderedNodeType = null;
      this._renderedComponent = null;
      this._instance = null;
    }

    // Reset pending fields
    // Even if this component is scheduled for another update in ReactUpdates,
    // it would still be ignored because these fields are reset.
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;
    this._pendingCallbacks = null;
    this._pendingElement = null;

    // These fields do not really need to be reset since this object is no
    // longer accessible.
    this._context = null;
    this._rootNodeID = 0;
    this._topLevelWrapper = null;

    // Delete the reference from the instance to this internal representation
    // which allow the internals to be properly cleaned up even if the user
    // leaks a reference to the public instance.
    ReactInstanceMap.remove(inst);

    // Some existing components rely on inst.props even after they've been
    // destroyed (in event handlers).
    // TODO: inst.props = null;
    // TODO: inst.state = null;
    // TODO: inst.context = null;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _maskContext: function (context) {
    var Component = this._currentElement.type;
    var contextTypes = Component.contextTypes;
    if (!contextTypes) {
      return emptyObject;
    }
    var maskedContext = {};
    for (var contextName in contextTypes) {
      maskedContext[contextName] = context[contextName];
    }
    return maskedContext;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`, and asserts that they are valid.
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _processContext: function (context) {
    var maskedContext = this._maskContext(context);
    if (false) {
      var Component = this._currentElement.type;
      if (Component.contextTypes) {
        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
      }
    }
    return maskedContext;
  },

  /**
   * @param {object} currentContext
   * @return {object}
   * @private
   */
  _processChildContext: function (currentContext) {
    var Component = this._currentElement.type;
    var inst = this._instance;
    var childContext;

    if (inst.getChildContext) {
      if (false) {
        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
        try {
          childContext = inst.getChildContext();
        } finally {
          ReactInstrumentation.debugTool.onEndProcessingChildContext();
        }
      } else {
        childContext = inst.getChildContext();
      }
    }

    if (childContext) {
      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
      if (false) {
        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
      }
      for (var name in childContext) {
        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
      }
      return _assign({}, currentContext, childContext);
    }
    return currentContext;
  },

  /**
   * Assert that the context types are valid
   *
   * @param {object} typeSpecs Map of context field to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @private
   */
  _checkContextTypes: function (typeSpecs, values, location) {
    if (false) {
      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
    }
  },

  receiveComponent: function (nextElement, transaction, nextContext) {
    var prevElement = this._currentElement;
    var prevContext = this._context;

    this._pendingElement = null;

    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
  },

  /**
   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
   * is set, update the component.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (transaction) {
    if (this._pendingElement != null) {
      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
    } else {
      this._updateBatchNumber = null;
    }
  },

  /**
   * Perform an update to a mounted component. The componentWillReceiveProps and
   * shouldComponentUpdate methods are called, then (assuming the update isn't
   * skipped) the remaining update lifecycle methods are called and the DOM
   * representation is updated.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevParentElement
   * @param {ReactElement} nextParentElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
    var inst = this._instance;
    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;

    var willReceive = false;
    var nextContext;

    // Determine if the context has changed or not
    if (this._context === nextUnmaskedContext) {
      nextContext = inst.context;
    } else {
      nextContext = this._processContext(nextUnmaskedContext);
      willReceive = true;
    }

    var prevProps = prevParentElement.props;
    var nextProps = nextParentElement.props;

    // Not a simple state update but a props update
    if (prevParentElement !== nextParentElement) {
      willReceive = true;
    }

    // An update here will schedule an update but immediately set
    // _pendingStateQueue which will ensure that any state updates gets
    // immediately reconciled instead of waiting for the next batch.
    if (willReceive && inst.componentWillReceiveProps) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillReceiveProps(nextProps, nextContext);
        }, this._debugID, 'componentWillReceiveProps');
      } else {
        inst.componentWillReceiveProps(nextProps, nextContext);
      }
    }

    var nextState = this._processPendingState(nextProps, nextContext);
    var shouldUpdate = true;

    if (!this._pendingForceUpdate) {
      if (inst.shouldComponentUpdate) {
        if (false) {
          shouldUpdate = measureLifeCyclePerf(function () {
            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
          }, this._debugID, 'shouldComponentUpdate');
        } else {
          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
        }
      } else {
        if (this._compositeType === CompositeTypes.PureClass) {
          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
        }
      }
    }

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
    }

    this._updateBatchNumber = null;
    if (shouldUpdate) {
      this._pendingForceUpdate = false;
      // Will set `this.props`, `this.state` and `this.context`.
      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
    } else {
      // If it's determined that a component should not update, we still want
      // to set props and state but we shortcut the rest of the update.
      this._currentElement = nextParentElement;
      this._context = nextUnmaskedContext;
      inst.props = nextProps;
      inst.state = nextState;
      inst.context = nextContext;
    }
  },

  _processPendingState: function (props, context) {
    var inst = this._instance;
    var queue = this._pendingStateQueue;
    var replace = this._pendingReplaceState;
    this._pendingReplaceState = false;
    this._pendingStateQueue = null;

    if (!queue) {
      return inst.state;
    }

    if (replace && queue.length === 1) {
      return queue[0];
    }

    var nextState = _assign({}, replace ? queue[0] : inst.state);
    for (var i = replace ? 1 : 0; i < queue.length; i++) {
      var partial = queue[i];
      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
    }

    return nextState;
  },

  /**
   * Merges new props and state, notifies delegate methods of update and
   * performs update.
   *
   * @param {ReactElement} nextElement Next element
   * @param {object} nextProps Next public object to set as properties.
   * @param {?object} nextState Next object to set as state.
   * @param {?object} nextContext Next public object to set as context.
   * @param {ReactReconcileTransaction} transaction
   * @param {?object} unmaskedContext
   * @private
   */
  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
    var _this2 = this;

    var inst = this._instance;

    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
    var prevProps;
    var prevState;
    var prevContext;
    if (hasComponentDidUpdate) {
      prevProps = inst.props;
      prevState = inst.state;
      prevContext = inst.context;
    }

    if (inst.componentWillUpdate) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillUpdate(nextProps, nextState, nextContext);
        }, this._debugID, 'componentWillUpdate');
      } else {
        inst.componentWillUpdate(nextProps, nextState, nextContext);
      }
    }

    this._currentElement = nextElement;
    this._context = unmaskedContext;
    inst.props = nextProps;
    inst.state = nextState;
    inst.context = nextContext;

    this._updateRenderedComponent(transaction, unmaskedContext);

    if (hasComponentDidUpdate) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
      }
    }
  },

  /**
   * Call the component's `render` method and update the DOM accordingly.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  _updateRenderedComponent: function (transaction, context) {
    var prevComponentInstance = this._renderedComponent;
    var prevRenderedElement = prevComponentInstance._currentElement;
    var nextRenderedElement = this._renderValidatedComponent();

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
    } else {
      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
      ReactReconciler.unmountComponent(prevComponentInstance, false);

      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
      this._renderedNodeType = nodeType;
      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
      );
      this._renderedComponent = child;

      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);

      if (false) {
        if (debugID !== 0) {
          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
        }
      }

      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
    }
  },

  /**
   * Overridden in shallow rendering.
   *
   * @protected
   */
  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
  },

  /**
   * @protected
   */
  _renderValidatedComponentWithoutOwnerOrContext: function () {
    var inst = this._instance;
    var renderedElement;

    if (false) {
      renderedElement = measureLifeCyclePerf(function () {
        return inst.render();
      }, this._debugID, 'render');
    } else {
      renderedElement = inst.render();
    }

    if (false) {
      // We allow auto-mocks to proceed as if they're returning null.
      if (renderedElement === undefined && inst.render._isMockFunction) {
        // This is probably bad practice. Consider warning here and
        // deprecating this convenience.
        renderedElement = null;
      }
    }

    return renderedElement;
  },

  /**
   * @private
   */
  _renderValidatedComponent: function () {
    var renderedElement;
    if ("production" !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
      ReactCurrentOwner.current = this;
      try {
        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
    }
    !(
    // TODO: An `isValidNode` function would probably be more appropriate
    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;

    return renderedElement;
  },

  /**
   * Lazily allocates the refs object and stores `component` as `ref`.
   *
   * @param {string} ref Reference name.
   * @param {component} component Component to store as `ref`.
   * @final
   * @private
   */
  attachRef: function (ref, component) {
    var inst = this.getPublicInstance();
    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
    var publicComponentInstance = component.getPublicInstance();
    if (false) {
      var componentName = component && component.getName ? component.getName() : 'a component';
      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
    }
    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
    refs[ref] = publicComponentInstance;
  },

  /**
   * Detaches a reference name.
   *
   * @param {string} ref Name to dereference.
   * @final
   * @private
   */
  detachRef: function (ref) {
    var refs = this.getPublicInstance().refs;
    delete refs[ref];
  },

  /**
   * Get a text description of the component that can be used to identify it
   * in error messages.
   * @return {string} The name or null.
   * @internal
   */
  getName: function () {
    var type = this._currentElement.type;
    var constructor = this._instance && this._instance.constructor;
    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
  },

  /**
   * Get the publicly accessible representation of this component - i.e. what
   * is exposed by refs and returned by render. Can be null for stateless
   * components.
   *
   * @return {ReactComponent} the public component instance.
   * @internal
   */
  getPublicInstance: function () {
    var inst = this._instance;
    if (this._compositeType === CompositeTypes.StatelessFunctional) {
      return null;
    }
    return inst;
  },

  // Stub
  _instantiateReactComponent: null
};

module.exports = ReactCompositeComponent;

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/



var ReactDOMComponentTree = __webpack_require__(17);
var ReactDefaultInjection = __webpack_require__(312);
var ReactMount = __webpack_require__(318);
var ReactReconciler = __webpack_require__(89);
var ReactUpdates = __webpack_require__(45);
var ReactVersion = __webpack_require__(321);

var findDOMNode = __webpack_require__(758);
var getHostComponentFromComposite = __webpack_require__(325);
var renderSubtreeIntoContainer = __webpack_require__(765);
var warning = __webpack_require__(10);

ReactDefaultInjection.inject();

var ReactDOM = {
  findDOMNode: findDOMNode,
  render: ReactMount.render,
  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
  version: ReactVersion,

  /* eslint-disable camelcase */
  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
  /* eslint-enable camelcase */
};

// Inject the runtime into a devtools global hook regardless of browser.
// Allows for debugging when the hook is injected on the page.
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
    ComponentTree: {
      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
      getNodeFromInstance: function (inst) {
        // inst is an internal instance (but could be a composite)
        if (inst._renderedComponent) {
          inst = getHostComponentFromComposite(inst);
        }
        if (inst) {
          return ReactDOMComponentTree.getNodeFromInstance(inst);
        } else {
          return null;
        }
      }
    },
    Mount: ReactMount,
    Reconciler: ReactReconciler
  });
}

if (false) {
  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
    // First check if devtools is not installed
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
      // If we're in Chrome or Firefox, provide a download link if not installed.
      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
        // Firefox does not have the issue with devtools loaded over file://
        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
      }
    }

    var testFunc = function testFn() {};
    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;

    // If we're in IE8, check to see if we are in compatibility mode and provide
    // information on preventing compatibility mode
    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;

    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;

    var expectedFeatures = [
    // shims
    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];

    for (var i = 0; i < expectedFeatures.length; i++) {
      if (!expectedFeatures[i]) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
        break;
      }
    }
  }
}

if (false) {
  var ReactInstrumentation = require('./ReactInstrumentation');
  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');

  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
}

module.exports = ReactDOM;

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* global hasOwnProperty:true */



var _prodInvariant = __webpack_require__(9),
    _assign = __webpack_require__(11);

var AutoFocusUtils = __webpack_require__(707);
var CSSPropertyOperations = __webpack_require__(709);
var DOMLazyTree = __webpack_require__(99);
var DOMNamespaces = __webpack_require__(206);
var DOMProperty = __webpack_require__(100);
var DOMPropertyOperations = __webpack_require__(307);
var EventPluginHub = __webpack_require__(119);
var EventPluginRegistry = __webpack_require__(207);
var ReactBrowserEventEmitter = __webpack_require__(151);
var ReactDOMComponentFlags = __webpack_require__(308);
var ReactDOMComponentTree = __webpack_require__(17);
var ReactDOMInput = __webpack_require__(724);
var ReactDOMOption = __webpack_require__(725);
var ReactDOMSelect = __webpack_require__(310);
var ReactDOMTextarea = __webpack_require__(729);
var ReactInstrumentation = __webpack_require__(38);
var ReactMultiChild = __webpack_require__(735);
var ReactServerRenderingTransaction = __webpack_require__(320);

var emptyFunction = __webpack_require__(50);
var escapeTextContentForBrowser = __webpack_require__(154);
var invariant = __webpack_require__(3);
var isEventSupported = __webpack_require__(219);
var shallowEqual = __webpack_require__(200);
var inputValueTracking = __webpack_require__(327);
var validateDOMNesting = __webpack_require__(221);
var warning = __webpack_require__(10);

var Flags = ReactDOMComponentFlags;
var deleteListener = EventPluginHub.deleteListener;
var getNode = ReactDOMComponentTree.getNodeFromInstance;
var listenTo = ReactBrowserEventEmitter.listenTo;
var registrationNameModules = EventPluginRegistry.registrationNameModules;

// For quickly matching children type, to test if can be treated as content.
var CONTENT_TYPES = { string: true, number: true };

var STYLE = 'style';
var HTML = '__html';
var RESERVED_PROPS = {
  children: null,
  dangerouslySetInnerHTML: null,
  suppressContentEditableWarning: null
};

// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
var DOC_FRAGMENT_TYPE = 11;

function getDeclarationErrorAddendum(internalInstance) {
  if (internalInstance) {
    var owner = internalInstance._currentElement._owner || null;
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' This DOM node was rendered by `' + name + '`.';
      }
    }
  }
  return '';
}

function friendlyStringify(obj) {
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return '[' + obj.map(friendlyStringify).join(', ') + ']';
    } else {
      var pairs = [];
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
        }
      }
      return '{' + pairs.join(', ') + '}';
    }
  } else if (typeof obj === 'string') {
    return JSON.stringify(obj);
  } else if (typeof obj === 'function') {
    return '[function object]';
  }
  // Differs from JSON.stringify in that undefined because undefined and that
  // inf and nan don't become null
  return String(obj);
}

var styleMutationWarning = {};

function checkAndWarnForMutatedStyle(style1, style2, component) {
  if (style1 == null || style2 == null) {
    return;
  }
  if (shallowEqual(style1, style2)) {
    return;
  }

  var componentName = component._tag;
  var owner = component._currentElement._owner;
  var ownerName;
  if (owner) {
    ownerName = owner.getName();
  }

  var hash = ownerName + '|' + componentName;

  if (styleMutationWarning.hasOwnProperty(hash)) {
    return;
  }

  styleMutationWarning[hash] = true;

   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
}

/**
 * @param {object} component
 * @param {?object} props
 */
function assertValidProps(component, props) {
  if (!props) {
    return;
  }
  // Note the use of `==` which checks for null or undefined.
  if (voidElementTags[component._tag]) {
    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
  }
  if (props.dangerouslySetInnerHTML != null) {
    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
  }
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
  }
  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
}

function enqueuePutListener(inst, registrationName, listener, transaction) {
  if (transaction instanceof ReactServerRenderingTransaction) {
    return;
  }
  if (false) {
    // IE8 has no API for event capturing and the `onScroll` event doesn't
    // bubble.
    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
  }
  var containerInfo = inst._hostContainerInfo;
  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
  listenTo(registrationName, doc);
  transaction.getReactMountReady().enqueue(putListener, {
    inst: inst,
    registrationName: registrationName,
    listener: listener
  });
}

function putListener() {
  var listenerToPut = this;
  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
}

function inputPostMount() {
  var inst = this;
  ReactDOMInput.postMountWrapper(inst);
}

function textareaPostMount() {
  var inst = this;
  ReactDOMTextarea.postMountWrapper(inst);
}

function optionPostMount() {
  var inst = this;
  ReactDOMOption.postMountWrapper(inst);
}

var setAndValidateContentChildDev = emptyFunction;
if (false) {
  setAndValidateContentChildDev = function (content) {
    var hasExistingContent = this._contentDebugID != null;
    var debugID = this._debugID;
    // This ID represents the inlined child that has no backing instance:
    var contentDebugID = -debugID;

    if (content == null) {
      if (hasExistingContent) {
        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
      }
      this._contentDebugID = null;
      return;
    }

    validateDOMNesting(null, String(content), this, this._ancestorInfo);
    this._contentDebugID = contentDebugID;
    if (hasExistingContent) {
      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
    } else {
      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
    }
  };
}

// There are so many media events, it makes sense to just
// maintain a list rather than create a `trapBubbledEvent` for each
var mediaEvents = {
  topAbort: 'abort',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTimeUpdate: 'timeupdate',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting'
};

function trackInputValue() {
  inputValueTracking.track(this);
}

function trapBubbledEventsLocal() {
  var inst = this;
  // If a component renders to null or if another component fatals and causes
  // the state of the tree to be corrupted, `node` here can be null.
  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
  var node = getNode(inst);
  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;

  switch (inst._tag) {
    case 'iframe':
    case 'object':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'video':
    case 'audio':
      inst._wrapperState.listeners = [];
      // Create listener for each media event
      for (var event in mediaEvents) {
        if (mediaEvents.hasOwnProperty(event)) {
          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
        }
      }
      break;
    case 'source':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
      break;
    case 'img':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'form':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
      break;
    case 'input':
    case 'select':
    case 'textarea':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
      break;
  }
}

function postUpdateSelectWrapper() {
  ReactDOMSelect.postUpdateWrapper(this);
}

// For HTML, certain tags should omit their close tag. We keep a whitelist for
// those special-case tags.

var omittedCloseTags = {
  area: true,
  base: true,
  br: true,
  col: true,
  embed: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true
  // NOTE: menuitem's close tag should be omitted, but that causes problems.
};

var newlineEatingTags = {
  listing: true,
  pre: true,
  textarea: true
};

// For HTML, certain tags cannot have children. This has the same purpose as
// `omittedCloseTags` except that `menuitem` should still have its closing tag.

var voidElementTags = _assign({
  menuitem: true
}, omittedCloseTags);

// We accept any tag to be rendered but since this gets injected into arbitrary
// HTML, we want to make sure that it's a safe tag.
// http://www.w3.org/TR/REC-xml/#NT-Name

var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
var validatedTagCache = {};
var hasOwnProperty = {}.hasOwnProperty;

function validateDangerousTag(tag) {
  if (!hasOwnProperty.call(validatedTagCache, tag)) {
    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
    validatedTagCache[tag] = true;
  }
}

function isCustomComponent(tagName, props) {
  return tagName.indexOf('-') >= 0 || props.is != null;
}

var globalIdCounter = 1;

/**
 * Creates a new React class that is idempotent and capable of containing other
 * React components. It accepts event listeners and DOM properties that are
 * valid according to `DOMProperty`.
 *
 *  - Event listeners: `onClick`, `onMouseDown`, etc.
 *  - DOM properties: `className`, `name`, `title`, etc.
 *
 * The `style` property functions differently from the DOM API. It accepts an
 * object mapping of style properties to values.
 *
 * @constructor ReactDOMComponent
 * @extends ReactMultiChild
 */
function ReactDOMComponent(element) {
  var tag = element.type;
  validateDangerousTag(tag);
  this._currentElement = element;
  this._tag = tag.toLowerCase();
  this._namespaceURI = null;
  this._renderedChildren = null;
  this._previousStyle = null;
  this._previousStyleCopy = null;
  this._hostNode = null;
  this._hostParent = null;
  this._rootNodeID = 0;
  this._domID = 0;
  this._hostContainerInfo = null;
  this._wrapperState = null;
  this._topLevelWrapper = null;
  this._flags = 0;
  if (false) {
    this._ancestorInfo = null;
    setAndValidateContentChildDev.call(this, null);
  }
}

ReactDOMComponent.displayName = 'ReactDOMComponent';

ReactDOMComponent.Mixin = {
  /**
   * Generates root tag markup then recurses. This method has side effects and
   * is not idempotent.
   *
   * @internal
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?ReactDOMComponent} the parent component instance
   * @param {?object} info about the host container
   * @param {object} context
   * @return {string} The computed markup.
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    this._rootNodeID = globalIdCounter++;
    this._domID = hostContainerInfo._idCounter++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var props = this._currentElement.props;

    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        this._wrapperState = {
          listeners: null
        };
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'input':
        ReactDOMInput.mountWrapper(this, props, hostParent);
        props = ReactDOMInput.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'option':
        ReactDOMOption.mountWrapper(this, props, hostParent);
        props = ReactDOMOption.getHostProps(this, props);
        break;
      case 'select':
        ReactDOMSelect.mountWrapper(this, props, hostParent);
        props = ReactDOMSelect.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'textarea':
        ReactDOMTextarea.mountWrapper(this, props, hostParent);
        props = ReactDOMTextarea.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
    }

    assertValidProps(this, props);

    // We create tags in the namespace of their parent container, except HTML
    // tags get no namespace.
    var namespaceURI;
    var parentTag;
    if (hostParent != null) {
      namespaceURI = hostParent._namespaceURI;
      parentTag = hostParent._tag;
    } else if (hostContainerInfo._tag) {
      namespaceURI = hostContainerInfo._namespaceURI;
      parentTag = hostContainerInfo._tag;
    }
    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
      namespaceURI = DOMNamespaces.html;
    }
    if (namespaceURI === DOMNamespaces.html) {
      if (this._tag === 'svg') {
        namespaceURI = DOMNamespaces.svg;
      } else if (this._tag === 'math') {
        namespaceURI = DOMNamespaces.mathml;
      }
    }
    this._namespaceURI = namespaceURI;

    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo._tag) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(this._tag, null, this, parentInfo);
      }
      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
    }

    var mountImage;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var el;
      if (namespaceURI === DOMNamespaces.html) {
        if (this._tag === 'script') {
          // Create the script via .innerHTML so its "parser-inserted" flag is
          // set to true and it does not execute
          var div = ownerDocument.createElement('div');
          var type = this._currentElement.type;
          div.innerHTML = '<' + type + '></' + type + '>';
          el = div.removeChild(div.firstChild);
        } else if (props.is) {
          el = ownerDocument.createElement(this._currentElement.type, props.is);
        } else {
          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
          // See discussion in https://github.com/facebook/react/pull/6896
          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
          el = ownerDocument.createElement(this._currentElement.type);
        }
      } else {
        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
      }
      ReactDOMComponentTree.precacheNode(this, el);
      this._flags |= Flags.hasCachedChildNodes;
      if (!this._hostParent) {
        DOMPropertyOperations.setAttributeForRoot(el);
      }
      this._updateDOMProperties(null, props, transaction);
      var lazyTree = DOMLazyTree(el);
      this._createInitialChildren(transaction, props, context, lazyTree);
      mountImage = lazyTree;
    } else {
      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
      var tagContent = this._createContentMarkup(transaction, props, context);
      if (!tagContent && omittedCloseTags[this._tag]) {
        mountImage = tagOpen + '/>';
      } else {
        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
      }
    }

    switch (this._tag) {
      case 'input':
        transaction.getReactMountReady().enqueue(inputPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'textarea':
        transaction.getReactMountReady().enqueue(textareaPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'select':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'button':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'option':
        transaction.getReactMountReady().enqueue(optionPostMount, this);
        break;
    }

    return mountImage;
  },

  /**
   * Creates markup for the open tag and all attributes.
   *
   * This method has side effects because events get registered.
   *
   * Iterating over object properties is faster than iterating over arrays.
   * @see http://jsperf.com/obj-vs-arr-iteration
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @return {string} Markup of opening tag.
   */
  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
    var ret = '<' + this._currentElement.type;

    for (var propKey in props) {
      if (!props.hasOwnProperty(propKey)) {
        continue;
      }
      var propValue = props[propKey];
      if (propValue == null) {
        continue;
      }
      if (registrationNameModules.hasOwnProperty(propKey)) {
        if (propValue) {
          enqueuePutListener(this, propKey, propValue, transaction);
        }
      } else {
        if (propKey === STYLE) {
          if (propValue) {
            if (false) {
              // See `_updateDOMProperties`. style block
              this._previousStyle = propValue;
            }
            propValue = this._previousStyleCopy = _assign({}, props.style);
          }
          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
        }
        var markup = null;
        if (this._tag != null && isCustomComponent(this._tag, props)) {
          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
          }
        } else {
          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
        }
        if (markup) {
          ret += ' ' + markup;
        }
      }
    }

    // For static pages, no need to put React ID and checksum. Saves lots of
    // bytes.
    if (transaction.renderToStaticMarkup) {
      return ret;
    }

    if (!this._hostParent) {
      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
    }
    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
    return ret;
  },

  /**
   * Creates markup for the content between the tags.
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @param {object} context
   * @return {string} Content markup.
   */
  _createContentMarkup: function (transaction, props, context) {
    var ret = '';

    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        ret = innerHTML.__html;
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        ret = escapeTextContentForBrowser(contentToUse);
        if (false) {
          setAndValidateContentChildDev.call(this, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        ret = mountImages.join('');
      }
    }
    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
      // text/html ignores the first character in these tags if it's a newline
      // Prefer to break application/xml over text/html (for now) by adding
      // a newline specifically to get eaten by the parser. (Alternately for
      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
      // \r is normalized out by HTMLTextAreaElement#value.)
      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
      // See: Parsing of "textarea" "listing" and "pre" elements
      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
      return '\n' + ret;
    } else {
      return ret;
    }
  },

  _createInitialChildren: function (transaction, props, context, lazyTree) {
    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      // TODO: Validate that text is allowed as a child of this node
      if (contentToUse != null) {
        // Avoid setting textContent when the text is empty. In IE11 setting
        // textContent on a text area will cause the placeholder to not
        // show within the textarea until it has been focused and blurred again.
        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
        if (contentToUse !== '') {
          if (false) {
            setAndValidateContentChildDev.call(this, contentToUse);
          }
          DOMLazyTree.queueText(lazyTree, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        for (var i = 0; i < mountImages.length; i++) {
          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
        }
      }
    }
  },

  /**
   * Receives a next element and updates the component.
   *
   * @internal
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} context
   */
  receiveComponent: function (nextElement, transaction, context) {
    var prevElement = this._currentElement;
    this._currentElement = nextElement;
    this.updateComponent(transaction, prevElement, nextElement, context);
  },

  /**
   * Updates a DOM component after it has already been allocated and
   * attached to the DOM. Reconciles the root DOM node, then recurses.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevElement
   * @param {ReactElement} nextElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevElement, nextElement, context) {
    var lastProps = prevElement.props;
    var nextProps = this._currentElement.props;

    switch (this._tag) {
      case 'input':
        lastProps = ReactDOMInput.getHostProps(this, lastProps);
        nextProps = ReactDOMInput.getHostProps(this, nextProps);
        break;
      case 'option':
        lastProps = ReactDOMOption.getHostProps(this, lastProps);
        nextProps = ReactDOMOption.getHostProps(this, nextProps);
        break;
      case 'select':
        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
        break;
      case 'textarea':
        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
        break;
    }

    assertValidProps(this, nextProps);
    this._updateDOMProperties(lastProps, nextProps, transaction);
    this._updateDOMChildren(lastProps, nextProps, transaction, context);

    switch (this._tag) {
      case 'input':
        // Update the wrapper around inputs *after* updating props. This has to
        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
        // raise warnings and prevent the new value from being assigned.
        ReactDOMInput.updateWrapper(this);

        // We also check that we haven't missed a value update, such as a
        // Radio group shifting the checked value to another named radio input.
        inputValueTracking.updateValueIfChanged(this);
        break;
      case 'textarea':
        ReactDOMTextarea.updateWrapper(this);
        break;
      case 'select':
        // <select> value update needs to occur after <option> children
        // reconciliation
        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
        break;
    }
  },

  /**
   * Reconciles the properties by detecting differences in property values and
   * updating the DOM as necessary. This function is probably the single most
   * critical path for performance optimization.
   *
   * TODO: Benchmark whether checking for changed values in memory actually
   *       improves performance (especially statically positioned elements).
   * TODO: Benchmark the effects of putting this at the top since 99% of props
   *       do not change for a given reconciliation.
   * TODO: Benchmark areas that can be improved with caching.
   *
   * @private
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {?DOMElement} node
   */
  _updateDOMProperties: function (lastProps, nextProps, transaction) {
    var propKey;
    var styleName;
    var styleUpdates;
    for (propKey in lastProps) {
      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
        continue;
      }
      if (propKey === STYLE) {
        var lastStyle = this._previousStyleCopy;
        for (styleName in lastStyle) {
          if (lastStyle.hasOwnProperty(styleName)) {
            styleUpdates = styleUpdates || {};
            styleUpdates[styleName] = '';
          }
        }
        this._previousStyleCopy = null;
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (lastProps[propKey]) {
          // Only call deleteListener if there was a listener previously or
          // else willDeleteListener gets called when there wasn't actually a
          // listener (e.g., onClick={null})
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, lastProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
      }
    }
    for (propKey in nextProps) {
      var nextProp = nextProps[propKey];
      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
        continue;
      }
      if (propKey === STYLE) {
        if (nextProp) {
          if (false) {
            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
            this._previousStyle = nextProp;
          }
          nextProp = this._previousStyleCopy = _assign({}, nextProp);
        } else {
          this._previousStyleCopy = null;
        }
        if (lastProp) {
          // Unset styles on `lastProp` but not on `nextProp`.
          for (styleName in lastProp) {
            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = '';
            }
          }
          // Update styles that changed since `lastProp`.
          for (styleName in nextProp) {
            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = nextProp[styleName];
            }
          }
        } else {
          // Relies on `updateStylesByID` not mutating `styleUpdates`.
          styleUpdates = nextProp;
        }
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (nextProp) {
          enqueuePutListener(this, propKey, nextProp, transaction);
        } else if (lastProp) {
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, nextProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        var node = getNode(this);
        // If we're updating to null or undefined, we should remove the property
        // from the DOM node instead of inadvertently setting to a string. This
        // brings us in line with the same behavior we have on initial render.
        if (nextProp != null) {
          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
        } else {
          DOMPropertyOperations.deleteValueForProperty(node, propKey);
        }
      }
    }
    if (styleUpdates) {
      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
    }
  },

  /**
   * Reconciles the children with the various properties that affect the
   * children content.
   *
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   */
  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;

    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;

    // Note the use of `!=` which checks for null or undefined.
    var lastChildren = lastContent != null ? null : lastProps.children;
    var nextChildren = nextContent != null ? null : nextProps.children;

    // If we're switching from children to content/html or vice versa, remove
    // the old content
    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
    if (lastChildren != null && nextChildren == null) {
      this.updateChildren(null, transaction, context);
    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
      this.updateTextContent('');
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    }

    if (nextContent != null) {
      if (lastContent !== nextContent) {
        this.updateTextContent('' + nextContent);
        if (false) {
          setAndValidateContentChildDev.call(this, nextContent);
        }
      }
    } else if (nextHtml != null) {
      if (lastHtml !== nextHtml) {
        this.updateMarkup('' + nextHtml);
      }
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    } else if (nextChildren != null) {
      if (false) {
        setAndValidateContentChildDev.call(this, null);
      }

      this.updateChildren(nextChildren, transaction, context);
    }
  },

  getHostNode: function () {
    return getNode(this);
  },

  /**
   * Destroys all event registrations for this instance. Does not remove from
   * the DOM. That must be done by the parent.
   *
   * @internal
   */
  unmountComponent: function (safely) {
    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        var listeners = this._wrapperState.listeners;
        if (listeners) {
          for (var i = 0; i < listeners.length; i++) {
            listeners[i].remove();
          }
        }
        break;
      case 'input':
      case 'textarea':
        inputValueTracking.stopTracking(this);
        break;
      case 'html':
      case 'head':
      case 'body':
        /**
         * Components like <html> <head> and <body> can't be removed or added
         * easily in a cross-browser way, however it's valuable to be able to
         * take advantage of React's reconciliation for styling and <title>
         * management. So we just document it and throw in dangerous cases.
         */
         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
        break;
    }

    this.unmountChildren(safely);
    ReactDOMComponentTree.uncacheNode(this);
    EventPluginHub.deleteAllListeners(this);
    this._rootNodeID = 0;
    this._domID = 0;
    this._wrapperState = null;

    if (false) {
      setAndValidateContentChildDev.call(this, null);
    }
  },

  getPublicInstance: function () {
    return getNode(this);
  }
};

_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);

module.exports = ReactDOMComponent;

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(11);

var DOMLazyTree = __webpack_require__(99);
var ReactDOMComponentTree = __webpack_require__(17);

var ReactDOMEmptyComponent = function (instantiate) {
  // ReactCompositeComponent uses this:
  this._currentElement = null;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;
  this._hostContainerInfo = null;
  this._domID = 0;
};
_assign(ReactDOMEmptyComponent.prototype, {
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var domID = hostContainerInfo._idCounter++;
    this._domID = domID;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var nodeValue = ' react-empty: ' + this._domID + ' ';
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var node = ownerDocument.createComment(nodeValue);
      ReactDOMComponentTree.precacheNode(this, node);
      return DOMLazyTree(node);
    } else {
      if (transaction.renderToStaticMarkup) {
        // Normally we'd insert a comment node, but since this is a situation
        // where React won't take over (static pages), we can simply return
        // nothing.
        return '';
      }
      return '<!--' + nodeValue + '-->';
    }
  },
  receiveComponent: function () {},
  getHostNode: function () {
    return ReactDOMComponentTree.getNodeFromInstance(this);
  },
  unmountComponent: function () {
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMFeatureFlags = {
  useCreateElement: true,
  useFiber: false
};

module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMChildrenOperations = __webpack_require__(205);
var ReactDOMComponentTree = __webpack_require__(17);

/**
 * Operations used to process updates to DOM nodes.
 */
var ReactDOMIDOperations = {
  /**
   * Updates a component's children by processing a series of updates.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
    DOMChildrenOperations.processUpdates(node, updates);
  }
};

module.exports = ReactDOMIDOperations;

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(9),
    _assign = __webpack_require__(11);

var DOMPropertyOperations = __webpack_require__(307);
var LinkedValueUtils = __webpack_require__(210);
var ReactDOMComponentTree = __webpack_require__(17);
var ReactUpdates = __webpack_require__(45);

var invariant = __webpack_require__(3);
var warning = __webpack_require__(10);

var didWarnValueLink = false;
var didWarnCheckedLink = false;
var didWarnValueDefaultValue = false;
var didWarnCheckedDefaultChecked = false;
var didWarnControlledToUncontrolled = false;
var didWarnUncontrolledToControlled = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMInput.updateWrapper(this);
  }
}

function isControlled(props) {
  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
  return usesChecked ? props.checked != null : props.value != null;
}

/**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */
var ReactDOMInput = {
  getHostProps: function (inst, props) {
    var value = LinkedValueUtils.getValue(props);
    var checked = LinkedValueUtils.getChecked(props);

    var hostProps = _assign({
      // Make sure we set .type before any other properties (setting .value
      // before .type means .value is lost in IE11 and below)
      type: undefined,
      // Make sure we set .step before .value (setting .value before .step
      // means .value is rounded on mount, based upon step precision)
      step: undefined,
      // Make sure we set .min & .max before .value (to ensure proper order
      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
      min: undefined,
      max: undefined
    }, props, {
      defaultChecked: undefined,
      defaultValue: undefined,
      value: value != null ? value : inst._wrapperState.initialValue,
      checked: checked != null ? checked : inst._wrapperState.initialChecked,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);

      var owner = inst._currentElement._owner;

      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnCheckedLink = true;
      }
      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnCheckedDefaultChecked = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnValueDefaultValue = true;
      }
    }

    var defaultValue = props.defaultValue;
    inst._wrapperState = {
      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
      initialValue: props.value != null ? props.value : defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      controlled: isControlled(props)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    if (false) {
      var controlled = isControlled(props);
      var owner = inst._currentElement._owner;

      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnUncontrolledToControlled = true;
      }
      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnControlledToUncontrolled = true;
      }
    }

    // TODO: Shouldn't this be getChecked(props)?
    var checked = props.checked;
    if (checked != null) {
      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      if (value === 0 && node.value === '') {
        node.value = '0';
        // Note: IE9 reports a number inputs as 'text', so check props instead.
      } else if (props.type === 'number') {
        // Simulate `input.valueAsNumber`. IE9 does not support it
        var valueAsNumber = parseFloat(node.value, 10) || 0;

        if (
        // eslint-disable-next-line
        value != valueAsNumber ||
        // eslint-disable-next-line
        value == valueAsNumber && node.value != value) {
          // Cast `value` to a string to ensure the value is set correctly. While
          // browsers typically do this as necessary, jsdom doesn't.
          node.value = '' + value;
        }
      } else if (node.value !== '' + value) {
        // Cast `value` to a string to ensure the value is set correctly. While
        // browsers typically do this as necessary, jsdom doesn't.
        node.value = '' + value;
      }
    } else {
      if (props.value == null && props.defaultValue != null) {
        // In Chrome, assigning defaultValue to certain input types triggers input validation.
        // For number inputs, the display value loses trailing decimal points. For email inputs,
        // Chrome raises "The specified value <x> is not a valid email address".
        //
        // Here we check to see if the defaultValue has actually changed, avoiding these problems
        // when the user is inputting text
        //
        // https://github.com/facebook/react/issues/7253
        if (node.defaultValue !== '' + props.defaultValue) {
          node.defaultValue = '' + props.defaultValue;
        }
      }
      if (props.checked == null && props.defaultChecked != null) {
        node.defaultChecked = !!props.defaultChecked;
      }
    }
  },

  postMountWrapper: function (inst) {
    var props = inst._currentElement.props;

    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);

    // Detach value from defaultValue. We won't do anything if we're working on
    // submit or reset inputs as those values & defaultValues are linked. They
    // are not resetable nodes so this operation doesn't matter and actually
    // removes browser-default values (eg "Submit Query") when no value is
    // provided.

    switch (props.type) {
      case 'submit':
      case 'reset':
        break;
      case 'color':
      case 'date':
      case 'datetime':
      case 'datetime-local':
      case 'month':
      case 'time':
      case 'week':
        // This fixes the no-show issue on iOS Safari and Android Chrome:
        // https://github.com/facebook/react/issues/7233
        node.value = '';
        node.value = node.defaultValue;
        break;
      default:
        node.value = node.value;
        break;
    }

    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
    // this is needed to work around a chrome bug where setting defaultChecked
    // will sometimes influence the value of checked (even after detachment).
    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
    // We need to temporarily unset name to avoid disrupting radio button groups.
    var name = node.name;
    if (name !== '') {
      node.name = '';
    }
    node.defaultChecked = !node.defaultChecked;
    node.defaultChecked = !node.defaultChecked;
    if (name !== '') {
      node.name = name;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;

  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  // Here we use asap to wait until all updates have propagated, which
  // is important when using controlled components within layers:
  // https://github.com/facebook/react/issues/1698
  ReactUpdates.asap(forceUpdateIfMounted, this);

  var name = props.name;
  if (props.type === 'radio' && name != null) {
    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
    var queryRoot = rootNode;

    while (queryRoot.parentNode) {
      queryRoot = queryRoot.parentNode;
    }

    // If `rootNode.form` was non-null, then we could try `form.elements`,
    // but that sometimes behaves strangely in IE8. We could also try using
    // `form.getElementsByName`, but that will only return direct children
    // and won't include inputs that use the HTML5 `form=` attribute. Since
    // the input might not even be in a form, let's just use the global
    // `querySelectorAll` to ensure we don't miss anything.
    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

    for (var i = 0; i < group.length; i++) {
      var otherNode = group[i];
      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
        continue;
      }
      // This will throw if radio buttons rendered by different copies of React
      // and the same name are rendered into the same form (same as #1939).
      // That's probably okay; we don't support it just as we don't support
      // mixing React radio buttons with non-React ones.
      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
      // If this is a controlled radio button group, forcing the input that
      // was previously checked to update will cause it to be come re-checked
      // as appropriate.
      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
    }
  }

  return returnValue;
}

module.exports = ReactDOMInput;

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(11);

var React = __webpack_require__(90);
var ReactDOMComponentTree = __webpack_require__(17);
var ReactDOMSelect = __webpack_require__(310);

var warning = __webpack_require__(10);
var didWarnInvalidOptionChildren = false;

function flattenChildren(children) {
  var content = '';

  // Flatten children and warn if they aren't strings or numbers;
  // invalid types are ignored.
  React.Children.forEach(children, function (child) {
    if (child == null) {
      return;
    }
    if (typeof child === 'string' || typeof child === 'number') {
      content += child;
    } else if (!didWarnInvalidOptionChildren) {
      didWarnInvalidOptionChildren = true;
       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
    }
  });

  return content;
}

/**
 * Implements an <option> host component that warns when `selected` is set.
 */
var ReactDOMOption = {
  mountWrapper: function (inst, props, hostParent) {
    // TODO (yungsters): Remove support for `selected` in <option>.
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
    }

    // Look up whether this option is 'selected'
    var selectValue = null;
    if (hostParent != null) {
      var selectParent = hostParent;

      if (selectParent._tag === 'optgroup') {
        selectParent = selectParent._hostParent;
      }

      if (selectParent != null && selectParent._tag === 'select') {
        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
      }
    }

    // If the value is null (e.g., no specified value or after initial mount)
    // or missing (e.g., for <datalist>), we don't change props.selected
    var selected = null;
    if (selectValue != null) {
      var value;
      if (props.value != null) {
        value = props.value + '';
      } else {
        value = flattenChildren(props.children);
      }
      selected = false;
      if (Array.isArray(selectValue)) {
        // multiple
        for (var i = 0; i < selectValue.length; i++) {
          if ('' + selectValue[i] === value) {
            selected = true;
            break;
          }
        }
      } else {
        selected = '' + selectValue === value;
      }
    }

    inst._wrapperState = { selected: selected };
  },

  postMountWrapper: function (inst) {
    // value="" should make a value attribute (#6219)
    var props = inst._currentElement.props;
    if (props.value != null) {
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      node.setAttribute('value', props.value);
    }
  },

  getHostProps: function (inst, props) {
    var hostProps = _assign({ selected: undefined, children: undefined }, props);

    // Read state only from initial mount because <select> updates value
    // manually; we need the initial state only for server rendering
    if (inst._wrapperState.selected != null) {
      hostProps.selected = inst._wrapperState.selected;
    }

    var content = flattenChildren(props.children);

    if (content) {
      hostProps.children = content;
    }

    return hostProps;
  }
};

module.exports = ReactDOMOption;

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(24);

var getNodeForCharacterOffset = __webpack_require__(762);
var getTextContentAccessor = __webpack_require__(326);

/**
 * While `isCollapsed` is available on the Selection object and `collapsed`
 * is available on the Range object, IE11 sometimes gets them wrong.
 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
 */
function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
  return anchorNode === focusNode && anchorOffset === focusOffset;
}

/**
 * Get the appropriate anchor and focus node/offset pairs for IE.
 *
 * The catch here is that IE's selection API doesn't provide information
 * about whether the selection is forward or backward, so we have to
 * behave as though it's always forward.
 *
 * IE text differs from modern selection in that it behaves as though
 * block elements end with a new line. This means character offsets will
 * differ between the two APIs.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getIEOffsets(node) {
  var selection = document.selection;
  var selectedRange = selection.createRange();
  var selectedLength = selectedRange.text.length;

  // Duplicate selection so we can move range without breaking user selection.
  var fromStart = selectedRange.duplicate();
  fromStart.moveToElementText(node);
  fromStart.setEndPoint('EndToStart', selectedRange);

  var startOffset = fromStart.text.length;
  var endOffset = startOffset + selectedLength;

  return {
    start: startOffset,
    end: endOffset
  };
}

/**
 * @param {DOMElement} node
 * @return {?object}
 */
function getModernOffsets(node) {
  var selection = window.getSelection && window.getSelection();

  if (!selection || selection.rangeCount === 0) {
    return null;
  }

  var anchorNode = selection.anchorNode;
  var anchorOffset = selection.anchorOffset;
  var focusNode = selection.focusNode;
  var focusOffset = selection.focusOffset;

  var currentRange = selection.getRangeAt(0);

  // In Firefox, range.startContainer and range.endContainer can be "anonymous
  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
  // divs do not seem to expose properties, triggering a "Permission denied
  // error" if any of its properties are accessed. The only seemingly possible
  // way to avoid erroring is to access a property that typically works for
  // non-anonymous divs and catch any error that may otherwise arise. See
  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
  try {
    /* eslint-disable no-unused-expressions */
    currentRange.startContainer.nodeType;
    currentRange.endContainer.nodeType;
    /* eslint-enable no-unused-expressions */
  } catch (e) {
    return null;
  }

  // If the node and offset values are the same, the selection is collapsed.
  // `Selection.isCollapsed` is available natively, but IE sometimes gets
  // this value wrong.
  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);

  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;

  var tempRange = currentRange.cloneRange();
  tempRange.selectNodeContents(node);
  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);

  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);

  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
  var end = start + rangeLength;

  // Detect whether the selection is backward.
  var detectionRange = document.createRange();
  detectionRange.setStart(anchorNode, anchorOffset);
  detectionRange.setEnd(focusNode, focusOffset);
  var isBackward = detectionRange.collapsed;

  return {
    start: isBackward ? end : start,
    end: isBackward ? start : end
  };
}

/**
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setIEOffsets(node, offsets) {
  var range = document.selection.createRange().duplicate();
  var start, end;

  if (offsets.end === undefined) {
    start = offsets.start;
    end = start;
  } else if (offsets.start > offsets.end) {
    start = offsets.end;
    end = offsets.start;
  } else {
    start = offsets.start;
    end = offsets.end;
  }

  range.moveToElementText(node);
  range.moveStart('character', start);
  range.setEndPoint('EndToStart', range);
  range.moveEnd('character', end - start);
  range.select();
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setModernOffsets(node, offsets) {
  if (!window.getSelection) {
    return;
  }

  var selection = window.getSelection();
  var length = node[getTextContentAccessor()].length;
  var start = Math.min(offsets.start, length);
  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);

  // IE 11 uses modern selection, but doesn't support the extend method.
  // Flip backward selections, so we can set with a single range.
  if (!selection.extend && start > end) {
    var temp = end;
    end = start;
    start = temp;
  }

  var startMarker = getNodeForCharacterOffset(node, start);
  var endMarker = getNodeForCharacterOffset(node, end);

  if (startMarker && endMarker) {
    var range = document.createRange();
    range.setStart(startMarker.node, startMarker.offset);
    selection.removeAllRanges();

    if (start > end) {
      selection.addRange(range);
      selection.extend(endMarker.node, endMarker.offset);
    } else {
      range.setEnd(endMarker.node, endMarker.offset);
      selection.addRange(range);
    }
  }
}

var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);

var ReactDOMSelection = {
  /**
   * @param {DOMElement} node
   */
  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,

  /**
   * @param {DOMElement|DOMTextNode} node
   * @param {object} offsets
   */
  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
};

module.exports = ReactDOMSelection;

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDefaultInjection = __webpack_require__(312);
var ReactServerRendering = __webpack_require__(741);
var ReactVersion = __webpack_require__(321);

ReactDefaultInjection.inject();

var ReactDOMServer = {
  renderToString: ReactServerRendering.renderToString,
  renderToStaticMarkup: ReactServerRendering.renderToStaticMarkup,
  version: ReactVersion
};

module.exports = ReactDOMServer;

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(9),
    _assign = __webpack_require__(11);

var DOMChildrenOperations = __webpack_require__(205);
var DOMLazyTree = __webpack_require__(99);
var ReactDOMComponentTree = __webpack_require__(17);

var escapeTextContentForBrowser = __webpack_require__(154);
var invariant = __webpack_require__(3);
var validateDOMNesting = __webpack_require__(221);

/**
 * Text nodes violate a couple assumptions that React makes about components:
 *
 *  - When mounting text into the DOM, adjacent text nodes are merged.
 *  - Text nodes cannot be assigned a React root ID.
 *
 * This component is used to wrap strings between comment nodes so that they
 * can undergo the same reconciliation that is applied to elements.
 *
 * TODO: Investigate representing React components in the DOM with text nodes.
 *
 * @class ReactDOMTextComponent
 * @extends ReactComponent
 * @internal
 */
var ReactDOMTextComponent = function (text) {
  // TODO: This is really a ReactText (ReactNode), not a ReactElement
  this._currentElement = text;
  this._stringText = '' + text;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;

  // Properties
  this._domID = 0;
  this._mountIndex = 0;
  this._closingComment = null;
  this._commentNodes = null;
};

_assign(ReactDOMTextComponent.prototype, {
  /**
   * Creates the markup for this text node. This node is not intended to have
   * any features besides containing text content.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {string} Markup for this text node.
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo != null) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(null, this._stringText, this, parentInfo);
      }
    }

    var domID = hostContainerInfo._idCounter++;
    var openingValue = ' react-text: ' + domID + ' ';
    var closingValue = ' /react-text ';
    this._domID = domID;
    this._hostParent = hostParent;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var openingComment = ownerDocument.createComment(openingValue);
      var closingComment = ownerDocument.createComment(closingValue);
      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
      if (this._stringText) {
        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
      }
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
      ReactDOMComponentTree.precacheNode(this, openingComment);
      this._closingComment = closingComment;
      return lazyTree;
    } else {
      var escapedText = escapeTextContentForBrowser(this._stringText);

      if (transaction.renderToStaticMarkup) {
        // Normally we'd wrap this between comment nodes for the reasons stated
        // above, but since this is a situation where React won't take over
        // (static pages), we can simply return the text as it is.
        return escapedText;
      }

      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
    }
  },

  /**
   * Updates this component by updating the text content.
   *
   * @param {ReactText} nextText The next text content
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  receiveComponent: function (nextText, transaction) {
    if (nextText !== this._currentElement) {
      this._currentElement = nextText;
      var nextStringText = '' + nextText;
      if (nextStringText !== this._stringText) {
        // TODO: Save this as pending props and use performUpdateIfNecessary
        // and/or updateComponent to do the actual update for consistency with
        // other component types?
        this._stringText = nextStringText;
        var commentNodes = this.getHostNode();
        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
      }
    }
  },

  getHostNode: function () {
    var hostNode = this._commentNodes;
    if (hostNode) {
      return hostNode;
    }
    if (!this._closingComment) {
      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
      var node = openingComment.nextSibling;
      while (true) {
        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
          this._closingComment = node;
          break;
        }
        node = node.nextSibling;
      }
    }
    hostNode = [this._hostNode, this._closingComment];
    this._commentNodes = hostNode;
    return hostNode;
  },

  unmountComponent: function () {
    this._closingComment = null;
    this._commentNodes = null;
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMTextComponent;

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(9),
    _assign = __webpack_require__(11);

var LinkedValueUtils = __webpack_require__(210);
var ReactDOMComponentTree = __webpack_require__(17);
var ReactUpdates = __webpack_require__(45);

var invariant = __webpack_require__(3);
var warning = __webpack_require__(10);

var didWarnValueLink = false;
var didWarnValDefaultVal = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMTextarea.updateWrapper(this);
  }
}

/**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */
var ReactDOMTextarea = {
  getHostProps: function (inst, props) {
    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;

    // Always set children to the same thing. In IE9, the selection range will
    // get reset if `textContent` is mutated.  We could add a check in setTextContent
    // to only set the value if/when the value differs from the node value (which would
    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
    // The value can be a boolean or object so that's why it's forced to be a string.
    var hostProps = _assign({}, props, {
      value: undefined,
      defaultValue: undefined,
      children: '' + inst._wrapperState.initialValue,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
        didWarnValDefaultVal = true;
      }
    }

    var value = LinkedValueUtils.getValue(props);
    var initialValue = value;

    // Only bother fetching default value if we're going to use it
    if (value == null) {
      var defaultValue = props.defaultValue;
      // TODO (yungsters): Remove support for children content in <textarea>.
      var children = props.children;
      if (children != null) {
        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
        }
        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
        if (Array.isArray(children)) {
          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
          children = children[0];
        }

        defaultValue = '' + children;
      }
      if (defaultValue == null) {
        defaultValue = '';
      }
      initialValue = defaultValue;
    }

    inst._wrapperState = {
      initialValue: '' + initialValue,
      listeners: null,
      onChange: _handleChange.bind(inst)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      var newValue = '' + value;

      // To avoid side effects (such as losing text selection), only set value if changed
      if (newValue !== node.value) {
        node.value = newValue;
      }
      if (props.defaultValue == null) {
        node.defaultValue = newValue;
      }
    }
    if (props.defaultValue != null) {
      node.defaultValue = props.defaultValue;
    }
  },

  postMountWrapper: function (inst) {
    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var textContent = node.textContent;

    // Only set node.value if textContent is equal to the expected
    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
    // will populate textContent as well.
    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
    if (textContent === inst._wrapperState.initialValue) {
      node.value = textContent;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);
  ReactUpdates.asap(forceUpdateIfMounted, this);
  return returnValue;
}

module.exports = ReactDOMTextarea;

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(9);

var invariant = __webpack_require__(3);

/**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */
function getLowestCommonAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  var depthA = 0;
  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
    depthA++;
  }
  var depthB = 0;
  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
    depthB++;
  }

  // If A is deeper, crawl up.
  while (depthA - depthB > 0) {
    instA = instA._hostParent;
    depthA--;
  }

  // If B is deeper, crawl up.
  while (depthB - depthA > 0) {
    instB = instB._hostParent;
    depthB--;
  }

  // Walk in lockstep until we find a match.
  var depth = depthA;
  while (depth--) {
    if (instA === instB) {
      return instA;
    }
    instA = instA._hostParent;
    instB = instB._hostParent;
  }
  return null;
}

/**
 * Return if A is an ancestor of B.
 */
function isAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;

  while (instB) {
    if (instB === instA) {
      return true;
    }
    instB = instB._hostParent;
  }
  return false;
}

/**
 * Return the parent instance of the passed-in instance.
 */
function getParentInstance(inst) {
  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;

  return inst._hostParent;
}

/**
 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
 */
function traverseTwoPhase(inst, fn, arg) {
  var path = [];
  while (inst) {
    path.push(inst);
    inst = inst._hostParent;
  }
  var i;
  for (i = path.length; i-- > 0;) {
    fn(path[i], 'captured', arg);
  }
  for (i = 0; i < path.length; i++) {
    fn(path[i], 'bubbled', arg);
  }
}

/**
 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
 * should would receive a `mouseEnter` or `mouseLeave` event.
 *
 * Does not invoke the callback on the nearest common ancestor because nothing
 * "entered" or "left" that element.
 */
function traverseEnterLeave(from, to, fn, argFrom, argTo) {
  var common = from && to ? getLowestCommonAncestor(from, to) : null;
  var pathFrom = [];
  while (from && from !== common) {
    pathFrom.push(from);
    from = from._hostParent;
  }
  var pathTo = [];
  while (to && to !== common) {
    pathTo.push(to);
    to = to._hostParent;
  }
  var i;
  for (i = 0; i < pathFrom.length; i++) {
    fn(pathFrom[i], 'bubbled', argFrom);
  }
  for (i = pathTo.length; i-- > 0;) {
    fn(pathTo[i], 'captured', argTo);
  }
}

module.exports = {
  isAncestor: isAncestor,
  getLowestCommonAncestor: getLowestCommonAncestor,
  getParentInstance: getParentInstance,
  traverseTwoPhase: traverseTwoPhase,
  traverseEnterLeave: traverseEnterLeave
};

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPluginHub = __webpack_require__(119);

function runEventQueueInBatch(events) {
  EventPluginHub.enqueueEvents(events);
  EventPluginHub.processEventQueue(false);
}

var ReactEventEmitterMixin = {
  /**
   * Streams a fired top-level event to `EventPluginHub` where plugins have the
   * opportunity to create `ReactEvent`s to be dispatched.
   */
  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
    runEventQueueInBatch(events);
  }
};

module.exports = ReactEventEmitterMixin;

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(11);

var EventListener = __webpack_require__(296);
var ExecutionEnvironment = __webpack_require__(24);
var PooledClass = __webpack_require__(88);
var ReactDOMComponentTree = __webpack_require__(17);
var ReactUpdates = __webpack_require__(45);

var getEventTarget = __webpack_require__(217);
var getUnboundedScrollPosition = __webpack_require__(681);

/**
 * Find the deepest React component completely containing the root of the
 * passed-in instance (for use when entire React trees are nested within each
 * other). If React trees are not nested, returns null.
 */
function findParent(inst) {
  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
  // traversal, but caching is difficult to do correctly without using a
  // mutation observer to listen for all DOM changes.
  while (inst._hostParent) {
    inst = inst._hostParent;
  }
  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
  var container = rootNode.parentNode;
  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
}

// Used to store ancestor hierarchy in top level callback
function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
  this.topLevelType = topLevelType;
  this.nativeEvent = nativeEvent;
  this.ancestors = [];
}
_assign(TopLevelCallbackBookKeeping.prototype, {
  destructor: function () {
    this.topLevelType = null;
    this.nativeEvent = null;
    this.ancestors.length = 0;
  }
});
PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);

function handleTopLevelImpl(bookKeeping) {
  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);

  // Loop through the hierarchy, in case there's any nested components.
  // It's important that we build the array of ancestors before calling any
  // event handlers, because event handlers can modify the DOM, leading to
  // inconsistencies with ReactMount's node cache. See #1105.
  var ancestor = targetInst;
  do {
    bookKeeping.ancestors.push(ancestor);
    ancestor = ancestor && findParent(ancestor);
  } while (ancestor);

  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
    targetInst = bookKeeping.ancestors[i];
    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
  }
}

function scrollValueMonitor(cb) {
  var scrollPosition = getUnboundedScrollPosition(window);
  cb(scrollPosition);
}

var ReactEventListener = {
  _enabled: true,
  _handleTopLevel: null,

  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,

  setHandleTopLevel: function (handleTopLevel) {
    ReactEventListener._handleTopLevel = handleTopLevel;
  },

  setEnabled: function (enabled) {
    ReactEventListener._enabled = !!enabled;
  },

  isEnabled: function () {
    return ReactEventListener._enabled;
  },

  /**
   * Traps top-level events by using event bubbling.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  /**
   * Traps a top-level event by using event capturing.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  monitorScrollValue: function (refresh) {
    var callback = scrollValueMonitor.bind(null, refresh);
    EventListener.listen(window, 'scroll', callback);
  },

  dispatchEvent: function (topLevelType, nativeEvent) {
    if (!ReactEventListener._enabled) {
      return;
    }

    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
    try {
      // Event queue being processed in the same cycle allows
      // `preventDefault`.
      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
    } finally {
      TopLevelCallbackBookKeeping.release(bookKeeping);
    }
  }
};

module.exports = ReactEventListener;

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMProperty = __webpack_require__(100);
var EventPluginHub = __webpack_require__(119);
var EventPluginUtils = __webpack_require__(208);
var ReactComponentEnvironment = __webpack_require__(211);
var ReactEmptyComponent = __webpack_require__(313);
var ReactBrowserEventEmitter = __webpack_require__(151);
var ReactHostComponent = __webpack_require__(315);
var ReactUpdates = __webpack_require__(45);

var ReactInjection = {
  Component: ReactComponentEnvironment.injection,
  DOMProperty: DOMProperty.injection,
  EmptyComponent: ReactEmptyComponent.injection,
  EventPluginHub: EventPluginHub.injection,
  EventPluginUtils: EventPluginUtils.injection,
  EventEmitter: ReactBrowserEventEmitter.injection,
  HostComponent: ReactHostComponent.injection,
  Updates: ReactUpdates.injection
};

module.exports = ReactInjection;

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(9);

var ReactComponentEnvironment = __webpack_require__(211);
var ReactInstanceMap = __webpack_require__(121);
var ReactInstrumentation = __webpack_require__(38);

var ReactCurrentOwner = __webpack_require__(57);
var ReactReconciler = __webpack_require__(89);
var ReactChildReconciler = __webpack_require__(716);

var emptyFunction = __webpack_require__(50);
var flattenChildren = __webpack_require__(759);
var invariant = __webpack_require__(3);

/**
 * Make an update for markup to be rendered and inserted at a supplied index.
 *
 * @param {string} markup Markup that renders into an element.
 * @param {number} toIndex Destination index.
 * @private
 */
function makeInsertMarkup(markup, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'INSERT_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for moving an existing element to another index.
 *
 * @param {number} fromIndex Source index of the existing element.
 * @param {number} toIndex Destination index of the element.
 * @private
 */
function makeMove(child, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'MOVE_EXISTING',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: ReactReconciler.getHostNode(child),
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for removing an element at an index.
 *
 * @param {number} fromIndex Index of the element to remove.
 * @private
 */
function makeRemove(child, node) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'REMOVE_NODE',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: node,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the markup of a node.
 *
 * @param {string} markup Markup that renders into an element.
 * @private
 */
function makeSetMarkup(markup) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'SET_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the text content.
 *
 * @param {string} textContent Text content to set.
 * @private
 */
function makeTextContent(textContent) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'TEXT_CONTENT',
    content: textContent,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Push an update, if any, onto the queue. Creates a new queue if none is
 * passed and always returns the queue. Mutative.
 */
function enqueue(queue, update) {
  if (update) {
    queue = queue || [];
    queue.push(update);
  }
  return queue;
}

/**
 * Processes any enqueued updates.
 *
 * @private
 */
function processQueue(inst, updateQueue) {
  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
}

var setChildrenForInstrumentation = emptyFunction;
if (false) {
  var getDebugID = function (inst) {
    if (!inst._debugID) {
      // Check for ART-like instances. TODO: This is silly/gross.
      var internal;
      if (internal = ReactInstanceMap.get(inst)) {
        inst = internal;
      }
    }
    return inst._debugID;
  };
  setChildrenForInstrumentation = function (children) {
    var debugID = getDebugID(this);
    // TODO: React Native empty components are also multichild.
    // This means they still get into this method but don't have _debugID.
    if (debugID !== 0) {
      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
        return children[key]._debugID;
      }) : []);
    }
  };
}

/**
 * ReactMultiChild are capable of reconciling multiple children.
 *
 * @class ReactMultiChild
 * @internal
 */
var ReactMultiChild = {
  /**
   * Provides common functionality for components that must reconcile multiple
   * children. This is used by `ReactDOMComponent` to mount, update, and
   * unmount child components.
   *
   * @lends {ReactMultiChild.prototype}
   */
  Mixin: {
    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
      if (false) {
        var selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
        }
      }
      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
    },

    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
      var nextChildren;
      var selfDebugID = 0;
      if (false) {
        selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
          return nextChildren;
        }
      }
      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
      return nextChildren;
    },

    /**
     * Generates a "mount image" for each of the supplied children. In the case
     * of `ReactDOMComponent`, a mount image is a string of markup.
     *
     * @param {?object} nestedChildren Nested child maps.
     * @return {array} An array of mounted representations.
     * @internal
     */
    mountChildren: function (nestedChildren, transaction, context) {
      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
      this._renderedChildren = children;

      var mountImages = [];
      var index = 0;
      for (var name in children) {
        if (children.hasOwnProperty(name)) {
          var child = children[name];
          var selfDebugID = 0;
          if (false) {
            selfDebugID = getDebugID(this);
          }
          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
          child._mountIndex = index++;
          mountImages.push(mountImage);
        }
      }

      if (false) {
        setChildrenForInstrumentation.call(this, children);
      }

      return mountImages;
    },

    /**
     * Replaces any rendered children with a text content string.
     *
     * @param {string} nextContent String of content.
     * @internal
     */
    updateTextContent: function (nextContent) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      // Set new text content.
      var updates = [makeTextContent(nextContent)];
      processQueue(this, updates);
    },

    /**
     * Replaces any rendered children with a markup string.
     *
     * @param {string} nextMarkup String of markup.
     * @internal
     */
    updateMarkup: function (nextMarkup) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      var updates = [makeSetMarkup(nextMarkup)];
      processQueue(this, updates);
    },

    /**
     * Updates the rendered children with new children.
     *
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @internal
     */
    updateChildren: function (nextNestedChildrenElements, transaction, context) {
      // Hook used by React ART
      this._updateChildren(nextNestedChildrenElements, transaction, context);
    },

    /**
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @final
     * @protected
     */
    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
      var prevChildren = this._renderedChildren;
      var removedNodes = {};
      var mountImages = [];
      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
      if (!nextChildren && !prevChildren) {
        return;
      }
      var updates = null;
      var name;
      // `nextIndex` will increment for each child in `nextChildren`, but
      // `lastIndex` will be the last index visited in `prevChildren`.
      var nextIndex = 0;
      var lastIndex = 0;
      // `nextMountIndex` will increment for each newly mounted child.
      var nextMountIndex = 0;
      var lastPlacedNode = null;
      for (name in nextChildren) {
        if (!nextChildren.hasOwnProperty(name)) {
          continue;
        }
        var prevChild = prevChildren && prevChildren[name];
        var nextChild = nextChildren[name];
        if (prevChild === nextChild) {
          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
          prevChild._mountIndex = nextIndex;
        } else {
          if (prevChild) {
            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
            // The `removedNodes` loop below will actually remove the child.
          }
          // The child must be instantiated before it's mounted.
          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
          nextMountIndex++;
        }
        nextIndex++;
        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
      }
      // Remove children that are no longer present.
      for (name in removedNodes) {
        if (removedNodes.hasOwnProperty(name)) {
          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
        }
      }
      if (updates) {
        processQueue(this, updates);
      }
      this._renderedChildren = nextChildren;

      if (false) {
        setChildrenForInstrumentation.call(this, nextChildren);
      }
    },

    /**
     * Unmounts all rendered children. This should be used to clean up children
     * when this component is unmounted. It does not actually perform any
     * backend operations.
     *
     * @internal
     */
    unmountChildren: function (safely) {
      var renderedChildren = this._renderedChildren;
      ReactChildReconciler.unmountChildren(renderedChildren, safely);
      this._renderedChildren = null;
    },

    /**
     * Moves a child component to the supplied index.
     *
     * @param {ReactComponent} child Component to move.
     * @param {number} toIndex Destination index of the element.
     * @param {number} lastIndex Last index visited of the siblings of `child`.
     * @protected
     */
    moveChild: function (child, afterNode, toIndex, lastIndex) {
      // If the index of `child` is less than `lastIndex`, then it needs to
      // be moved. Otherwise, we do not need to move it because a child will be
      // inserted or moved before `child`.
      if (child._mountIndex < lastIndex) {
        return makeMove(child, afterNode, toIndex);
      }
    },

    /**
     * Creates a child component.
     *
     * @param {ReactComponent} child Component to create.
     * @param {string} mountImage Markup to insert.
     * @protected
     */
    createChild: function (child, afterNode, mountImage) {
      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
    },

    /**
     * Removes a child component.
     *
     * @param {ReactComponent} child Child to remove.
     * @protected
     */
    removeChild: function (child, node) {
      return makeRemove(child, node);
    },

    /**
     * Mounts a child with the supplied name.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to mount.
     * @param {string} name Name of the child.
     * @param {number} index Index at which to insert the child.
     * @param {ReactReconcileTransaction} transaction
     * @private
     */
    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
      child._mountIndex = index;
      return this.createChild(child, afterNode, mountImage);
    },

    /**
     * Unmounts a rendered child.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to unmount.
     * @private
     */
    _unmountChild: function (child, node) {
      var update = this.removeChild(child, node);
      child._mountIndex = null;
      return update;
    }
  }
};

module.exports = ReactMultiChild;

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(9);

var invariant = __webpack_require__(3);

/**
 * @param {?object} object
 * @return {boolean} True if `object` is a valid owner.
 * @final
 */
function isValidOwner(object) {
  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
}

/**
 * ReactOwners are capable of storing references to owned components.
 *
 * All components are capable of //being// referenced by owner components, but
 * only ReactOwner components are capable of //referencing// owned components.
 * The named reference is known as a "ref".
 *
 * Refs are available when mounted and updated during reconciliation.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return (
 *         <div onClick={this.handleClick}>
 *           <CustomComponent ref="custom" />
 *         </div>
 *       );
 *     },
 *     handleClick: function() {
 *       this.refs.custom.handleClick();
 *     },
 *     componentDidMount: function() {
 *       this.refs.custom.initialize();
 *     }
 *   });
 *
 * Refs should rarely be used. When refs are used, they should only be done to
 * control data that is not handled by React's data flow.
 *
 * @class ReactOwner
 */
var ReactOwner = {
  /**
   * Adds a component by ref to an owner component.
   *
   * @param {ReactComponent} component Component to reference.
   * @param {string} ref Name by which to refer to the component.
   * @param {ReactOwner} owner Component on which to record the ref.
   * @final
   * @internal
   */
  addComponentAsRefTo: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
    owner.attachRef(ref, component);
  },

  /**
   * Removes a component by ref from an owner component.
   *
   * @param {ReactComponent} component Component to dereference.
   * @param {string} ref Name of the ref to remove.
   * @param {ReactOwner} owner Component on which the ref is recorded.
   * @final
   * @internal
   */
  removeComponentAsRefFrom: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
    var ownerPublicInstance = owner.getPublicInstance();
    // Check that `component`'s owner is still alive and that `component` is still the current ref
    // because we do not want to detach the ref if another component stole it.
    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
      owner.detachRef(ref);
    }
  }
};

module.exports = ReactOwner;

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(11);

var CallbackQueue = __webpack_require__(306);
var PooledClass = __webpack_require__(88);
var ReactBrowserEventEmitter = __webpack_require__(151);
var ReactInputSelection = __webpack_require__(316);
var ReactInstrumentation = __webpack_require__(38);
var Transaction = __webpack_require__(153);
var ReactUpdateQueue = __webpack_require__(213);

/**
 * Ensures that, when possible, the selection range (currently selected text
 * input) is not disturbed by performing the transaction.
 */
var SELECTION_RESTORATION = {
  /**
   * @return {Selection} Selection information.
   */
  initialize: ReactInputSelection.getSelectionInformation,
  /**
   * @param {Selection} sel Selection information returned from `initialize`.
   */
  close: ReactInputSelection.restoreSelection
};

/**
 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
 * high level DOM manipulations (like temporarily removing a text input from the
 * DOM).
 */
var EVENT_SUPPRESSION = {
  /**
   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
   * the reconciliation.
   */
  initialize: function () {
    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
    ReactBrowserEventEmitter.setEnabled(false);
    return currentlyEnabled;
  },

  /**
   * @param {boolean} previouslyEnabled Enabled status of
   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
   *   restores the previous value.
   */
  close: function (previouslyEnabled) {
    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
  }
};

/**
 * Provides a queue for collecting `componentDidMount` and
 * `componentDidUpdate` callbacks during the transaction.
 */
var ON_DOM_READY_QUEUEING = {
  /**
   * Initializes the internal `onDOMReady` queue.
   */
  initialize: function () {
    this.reactMountReady.reset();
  },

  /**
   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
   */
  close: function () {
    this.reactMountReady.notifyAll();
  }
};

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

/**
 * Currently:
 * - The order that these are listed in the transaction is critical:
 * - Suppresses events.
 * - Restores selection range.
 *
 * Future:
 * - Restore document/overflow scroll positions that were unintentionally
 *   modified via DOM insertions above the top viewport boundary.
 * - Implement/integrate with customized constraint based layout system and keep
 *   track of which dimensions must be remeasured.
 *
 * @class ReactReconcileTransaction
 */
function ReactReconcileTransaction(useCreateElement) {
  this.reinitializeTransaction();
  // Only server-side rendering really needs this option (see
  // `ReactServerRendering`), but server-side uses
  // `ReactServerRenderingTransaction` instead. This option is here so that it's
  // accessible and defaults to false when `ReactDOMComponent` and
  // `ReactDOMTextComponent` checks it in `mountComponent`.`
  this.renderToStaticMarkup = false;
  this.reactMountReady = CallbackQueue.getPooled(null);
  this.useCreateElement = useCreateElement;
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array<object>} List of operation wrap procedures.
   *   TODO: convert to array<TransactionWrapper>
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return this.reactMountReady;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return ReactUpdateQueue;
  },

  /**
   * Save current transaction state -- if the return value from this method is
   * passed to `rollback`, the transaction will be reset to that state.
   */
  checkpoint: function () {
    // reactMountReady is the our only stateful wrapper
    return this.reactMountReady.checkpoint();
  },

  rollback: function (checkpoint) {
    this.reactMountReady.rollback(checkpoint);
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {
    CallbackQueue.release(this.reactMountReady);
    this.reactMountReady = null;
  }
};

_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactReconcileTransaction);

module.exports = ReactReconcileTransaction;

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ReactOwner = __webpack_require__(736);

var ReactRef = {};

function attachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(component.getPublicInstance());
  } else {
    // Legacy ref
    ReactOwner.addComponentAsRefTo(component, ref, owner);
  }
}

function detachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(null);
  } else {
    // Legacy ref
    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
  }
}

ReactRef.attachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    attachRef(ref, instance, element._owner);
  }
};

ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
  // If either the owner or a `ref` has changed, make sure the newest owner
  // has stored a reference to `this`, and the previous owner (if different)
  // has forgotten the reference to `this`. We use the element instead
  // of the public this.props because the post processing cannot determine
  // a ref. The ref conceptually lives on the element.

  // TODO: Should this even be possible? The owner cannot change because
  // it's forbidden by shouldUpdateReactComponent. The ref can change
  // if you swap the keys of but not the refs. Reconsider where this check
  // is made. It probably belongs where the key checking and
  // instantiateReactComponent is done.

  var prevRef = null;
  var prevOwner = null;
  if (prevElement !== null && typeof prevElement === 'object') {
    prevRef = prevElement.ref;
    prevOwner = prevElement._owner;
  }

  var nextRef = null;
  var nextOwner = null;
  if (nextElement !== null && typeof nextElement === 'object') {
    nextRef = nextElement.ref;
    nextOwner = nextElement._owner;
  }

  return prevRef !== nextRef ||
  // If owner changes but we have an unchanged function ref, don't update refs
  typeof nextRef === 'string' && nextOwner !== prevOwner;
};

ReactRef.detachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    detachRef(ref, instance, element._owner);
  }
};

module.exports = ReactRef;

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactServerBatchingStrategy = {
  isBatchingUpdates: false,
  batchedUpdates: function (callback) {
    // Don't do anything here. During the server rendering we don't want to
    // schedule any updates. We will simply ignore them.
  }
};

module.exports = ReactServerBatchingStrategy;

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var _prodInvariant = __webpack_require__(9);

var React = __webpack_require__(90);
var ReactDOMContainerInfo = __webpack_require__(309);
var ReactDefaultBatchingStrategy = __webpack_require__(311);
var ReactInstrumentation = __webpack_require__(38);
var ReactMarkupChecksum = __webpack_require__(317);
var ReactReconciler = __webpack_require__(89);
var ReactServerBatchingStrategy = __webpack_require__(740);
var ReactServerRenderingTransaction = __webpack_require__(320);
var ReactUpdates = __webpack_require__(45);

var emptyObject = __webpack_require__(147);
var instantiateReactComponent = __webpack_require__(218);
var invariant = __webpack_require__(3);

var pendingTransactions = 0;

/**
 * @param {ReactElement} element
 * @return {string} the HTML markup
 */
function renderToStringImpl(element, makeStaticMarkup) {
  var transaction;
  try {
    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);

    transaction = ReactServerRenderingTransaction.getPooled(makeStaticMarkup);

    pendingTransactions++;

    return transaction.perform(function () {
      var componentInstance = instantiateReactComponent(element, true);
      var markup = ReactReconciler.mountComponent(componentInstance, transaction, null, ReactDOMContainerInfo(), emptyObject, 0 /* parentDebugID */
      );
      if (false) {
        ReactInstrumentation.debugTool.onUnmountComponent(componentInstance._debugID);
      }
      if (!makeStaticMarkup) {
        markup = ReactMarkupChecksum.addChecksumToMarkup(markup);
      }
      return markup;
    }, null);
  } finally {
    pendingTransactions--;
    ReactServerRenderingTransaction.release(transaction);
    // Revert to the DOM batching strategy since these two renderers
    // currently share these stateful modules.
    if (!pendingTransactions) {
      ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
    }
  }
}

/**
 * Render a ReactElement to its initial HTML. This should only be used on the
 * server.
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdomserver.rendertostring
 */
function renderToString(element) {
  !React.isValidElement(element) ?  false ? invariant(false, 'renderToString(): You must pass a valid ReactElement.') : _prodInvariant('46') : void 0;
  return renderToStringImpl(element, false);
}

/**
 * Similar to renderToString, except this doesn't create extra DOM attributes
 * such as data-react-id that React uses internally.
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdomserver.rendertostaticmarkup
 */
function renderToStaticMarkup(element) {
  !React.isValidElement(element) ?  false ? invariant(false, 'renderToStaticMarkup(): You must pass a valid ReactElement.') : _prodInvariant('47') : void 0;
  return renderToStringImpl(element, true);
}

module.exports = {
  renderToString: renderToString,
  renderToStaticMarkup: renderToStaticMarkup
};

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReactUpdateQueue = __webpack_require__(213);

var warning = __webpack_require__(10);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the update queue used for server rendering.
 * It delegates to ReactUpdateQueue while server rendering is in progress and
 * switches to ReactNoopUpdateQueue after the transaction has completed.
 * @class ReactServerUpdateQueue
 * @param {Transaction} transaction
 */

var ReactServerUpdateQueue = function () {
  function ReactServerUpdateQueue(transaction) {
    _classCallCheck(this, ReactServerUpdateQueue);

    this.transaction = transaction;
  }

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */


  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
    return false;
  };

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
    }
  };

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
    } else {
      warnNoop(publicInstance, 'forceUpdate');
    }
  };

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} completeState Next state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
    } else {
      warnNoop(publicInstance, 'replaceState');
    }
  };

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} partialState Next partial state to be merged with state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
    } else {
      warnNoop(publicInstance, 'setState');
    }
  };

  return ReactServerUpdateQueue;
}();

module.exports = ReactServerUpdateQueue;

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var NS = {
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace'
};

// We use attributes for everything SVG so let's avoid some duplication and run
// code instead.
// The following are all specified in the HTML config already so we exclude here.
// - class (as className)
// - color
// - height
// - id
// - lang
// - max
// - media
// - method
// - min
// - name
// - style
// - target
// - type
// - width
var ATTRS = {
  accentHeight: 'accent-height',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 'alignment-baseline',
  allowReorder: 'allowReorder',
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 'arabic-form',
  ascent: 0,
  attributeName: 'attributeName',
  attributeType: 'attributeType',
  autoReverse: 'autoReverse',
  azimuth: 0,
  baseFrequency: 'baseFrequency',
  baseProfile: 'baseProfile',
  baselineShift: 'baseline-shift',
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 'calcMode',
  capHeight: 'cap-height',
  clip: 0,
  clipPath: 'clip-path',
  clipRule: 'clip-rule',
  clipPathUnits: 'clipPathUnits',
  colorInterpolation: 'color-interpolation',
  colorInterpolationFilters: 'color-interpolation-filters',
  colorProfile: 'color-profile',
  colorRendering: 'color-rendering',
  contentScriptType: 'contentScriptType',
  contentStyleType: 'contentStyleType',
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 'diffuseConstant',
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 'dominant-baseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 'edgeMode',
  elevation: 0,
  enableBackground: 'enable-background',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 'externalResourcesRequired',
  fill: 0,
  fillOpacity: 'fill-opacity',
  fillRule: 'fill-rule',
  filter: 0,
  filterRes: 'filterRes',
  filterUnits: 'filterUnits',
  floodColor: 'flood-color',
  floodOpacity: 'flood-opacity',
  focusable: 0,
  fontFamily: 'font-family',
  fontSize: 'font-size',
  fontSizeAdjust: 'font-size-adjust',
  fontStretch: 'font-stretch',
  fontStyle: 'font-style',
  fontVariant: 'font-variant',
  fontWeight: 'font-weight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 'glyph-name',
  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
  glyphOrientationVertical: 'glyph-orientation-vertical',
  glyphRef: 'glyphRef',
  gradientTransform: 'gradientTransform',
  gradientUnits: 'gradientUnits',
  hanging: 0,
  horizAdvX: 'horiz-adv-x',
  horizOriginX: 'horiz-origin-x',
  ideographic: 0,
  imageRendering: 'image-rendering',
  'in': 0,
  in2: 0,
  intercept: 0,
  k: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  kernelMatrix: 'kernelMatrix',
  kernelUnitLength: 'kernelUnitLength',
  kerning: 0,
  keyPoints: 'keyPoints',
  keySplines: 'keySplines',
  keyTimes: 'keyTimes',
  lengthAdjust: 'lengthAdjust',
  letterSpacing: 'letter-spacing',
  lightingColor: 'lighting-color',
  limitingConeAngle: 'limitingConeAngle',
  local: 0,
  markerEnd: 'marker-end',
  markerMid: 'marker-mid',
  markerStart: 'marker-start',
  markerHeight: 'markerHeight',
  markerUnits: 'markerUnits',
  markerWidth: 'markerWidth',
  mask: 0,
  maskContentUnits: 'maskContentUnits',
  maskUnits: 'maskUnits',
  mathematical: 0,
  mode: 0,
  numOctaves: 'numOctaves',
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 'overline-position',
  overlineThickness: 'overline-thickness',
  paintOrder: 'paint-order',
  panose1: 'panose-1',
  pathLength: 'pathLength',
  patternContentUnits: 'patternContentUnits',
  patternTransform: 'patternTransform',
  patternUnits: 'patternUnits',
  pointerEvents: 'pointer-events',
  points: 0,
  pointsAtX: 'pointsAtX',
  pointsAtY: 'pointsAtY',
  pointsAtZ: 'pointsAtZ',
  preserveAlpha: 'preserveAlpha',
  preserveAspectRatio: 'preserveAspectRatio',
  primitiveUnits: 'primitiveUnits',
  r: 0,
  radius: 0,
  refX: 'refX',
  refY: 'refY',
  renderingIntent: 'rendering-intent',
  repeatCount: 'repeatCount',
  repeatDur: 'repeatDur',
  requiredExtensions: 'requiredExtensions',
  requiredFeatures: 'requiredFeatures',
  restart: 0,
  result: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  seed: 0,
  shapeRendering: 'shape-rendering',
  slope: 0,
  spacing: 0,
  specularConstant: 'specularConstant',
  specularExponent: 'specularExponent',
  speed: 0,
  spreadMethod: 'spreadMethod',
  startOffset: 'startOffset',
  stdDeviation: 'stdDeviation',
  stemh: 0,
  stemv: 0,
  stitchTiles: 'stitchTiles',
  stopColor: 'stop-color',
  stopOpacity: 'stop-opacity',
  strikethroughPosition: 'strikethrough-position',
  strikethroughThickness: 'strikethrough-thickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 'stroke-dasharray',
  strokeDashoffset: 'stroke-dashoffset',
  strokeLinecap: 'stroke-linecap',
  strokeLinejoin: 'stroke-linejoin',
  strokeMiterlimit: 'stroke-miterlimit',
  strokeOpacity: 'stroke-opacity',
  strokeWidth: 'stroke-width',
  surfaceScale: 'surfaceScale',
  systemLanguage: 'systemLanguage',
  tableValues: 'tableValues',
  targetX: 'targetX',
  targetY: 'targetY',
  textAnchor: 'text-anchor',
  textDecoration: 'text-decoration',
  textRendering: 'text-rendering',
  textLength: 'textLength',
  to: 0,
  transform: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 'underline-position',
  underlineThickness: 'underline-thickness',
  unicode: 0,
  unicodeBidi: 'unicode-bidi',
  unicodeRange: 'unicode-range',
  unitsPerEm: 'units-per-em',
  vAlphabetic: 'v-alphabetic',
  vHanging: 'v-hanging',
  vIdeographic: 'v-ideographic',
  vMathematical: 'v-mathematical',
  values: 0,
  vectorEffect: 'vector-effect',
  version: 0,
  vertAdvY: 'vert-adv-y',
  vertOriginX: 'vert-origin-x',
  vertOriginY: 'vert-origin-y',
  viewBox: 'viewBox',
  viewTarget: 'viewTarget',
  visibility: 0,
  widths: 0,
  wordSpacing: 'word-spacing',
  writingMode: 'writing-mode',
  x: 0,
  xHeight: 'x-height',
  x1: 0,
  x2: 0,
  xChannelSelector: 'xChannelSelector',
  xlinkActuate: 'xlink:actuate',
  xlinkArcrole: 'xlink:arcrole',
  xlinkHref: 'xlink:href',
  xlinkRole: 'xlink:role',
  xlinkShow: 'xlink:show',
  xlinkTitle: 'xlink:title',
  xlinkType: 'xlink:type',
  xmlBase: 'xml:base',
  xmlns: 0,
  xmlnsXlink: 'xmlns:xlink',
  xmlLang: 'xml:lang',
  xmlSpace: 'xml:space',
  y: 0,
  y1: 0,
  y2: 0,
  yChannelSelector: 'yChannelSelector',
  z: 0,
  zoomAndPan: 'zoomAndPan'
};

var SVGDOMPropertyConfig = {
  Properties: {},
  DOMAttributeNamespaces: {
    xlinkActuate: NS.xlink,
    xlinkArcrole: NS.xlink,
    xlinkHref: NS.xlink,
    xlinkRole: NS.xlink,
    xlinkShow: NS.xlink,
    xlinkTitle: NS.xlink,
    xlinkType: NS.xlink,
    xmlBase: NS.xml,
    xmlLang: NS.xml,
    xmlSpace: NS.xml
  },
  DOMAttributeNames: {}
};

Object.keys(ATTRS).forEach(function (key) {
  SVGDOMPropertyConfig.Properties[key] = 0;
  if (ATTRS[key]) {
    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
  }
});

module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPropagators = __webpack_require__(120);
var ExecutionEnvironment = __webpack_require__(24);
var ReactDOMComponentTree = __webpack_require__(17);
var ReactInputSelection = __webpack_require__(316);
var SyntheticEvent = __webpack_require__(56);

var getActiveElement = __webpack_require__(298);
var isTextInputElement = __webpack_require__(328);
var shallowEqual = __webpack_require__(200);

var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;

var eventTypes = {
  select: {
    phasedRegistrationNames: {
      bubbled: 'onSelect',
      captured: 'onSelectCapture'
    },
    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
  }
};

var activeElement = null;
var activeElementInst = null;
var lastSelection = null;
var mouseDown = false;

// Track whether a listener exists for this plugin. If none exist, we do
// not extract events. See #3639.
var hasListener = false;

/**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getSelection(node) {
  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
    return {
      start: node.selectionStart,
      end: node.selectionEnd
    };
  } else if (window.getSelection) {
    var selection = window.getSelection();
    return {
      anchorNode: selection.anchorNode,
      anchorOffset: selection.anchorOffset,
      focusNode: selection.focusNode,
      focusOffset: selection.focusOffset
    };
  } else if (document.selection) {
    var range = document.selection.createRange();
    return {
      parentElement: range.parentElement(),
      text: range.text,
      top: range.boundingTop,
      left: range.boundingLeft
    };
  }
}

/**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @return {?SyntheticEvent}
 */
function constructSelectEvent(nativeEvent, nativeEventTarget) {
  // Ensure we have the right element, and that the user is not dragging a
  // selection (this matches native `select` event behavior). In HTML5, select
  // fires only on input and textarea thus if there's no focused element we
  // won't dispatch.
  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
    return null;
  }

  // Only fire when selection has actually changed.
  var currentSelection = getSelection(activeElement);
  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
    lastSelection = currentSelection;

    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);

    syntheticEvent.type = 'select';
    syntheticEvent.target = activeElement;

    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);

    return syntheticEvent;
  }

  return null;
}

/**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */
var SelectEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (!hasListener) {
      return null;
    }

    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    switch (topLevelType) {
      // Track the input node that has focus.
      case 'topFocus':
        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
          activeElement = targetNode;
          activeElementInst = targetInst;
          lastSelection = null;
        }
        break;
      case 'topBlur':
        activeElement = null;
        activeElementInst = null;
        lastSelection = null;
        break;
      // Don't fire the event while the user is dragging. This matches the
      // semantics of the native select event.
      case 'topMouseDown':
        mouseDown = true;
        break;
      case 'topContextMenu':
      case 'topMouseUp':
        mouseDown = false;
        return constructSelectEvent(nativeEvent, nativeEventTarget);
      // Chrome and IE fire non-standard event when selection is changed (and
      // sometimes when it hasn't). IE's event fires out of order with respect
      // to key and input events on deletion, so we discard it.
      //
      // Firefox doesn't support selectionchange, so check selection status
      // after each key entry. The selection changes after keydown and before
      // keyup, but we check on keydown as well in the case of holding down a
      // key, when multiple keydown events are fired but only one keyup is.
      // This is also our approach for IE handling, for the reason above.
      case 'topSelectionChange':
        if (skipSelectionChangeEvent) {
          break;
        }
      // falls through
      case 'topKeyDown':
      case 'topKeyUp':
        return constructSelectEvent(nativeEvent, nativeEventTarget);
    }

    return null;
  },

  didPutListener: function (inst, registrationName, listener) {
    if (registrationName === 'onSelect') {
      hasListener = true;
    }
  }
};

module.exports = SelectEventPlugin;

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(9);

var EventListener = __webpack_require__(296);
var EventPropagators = __webpack_require__(120);
var ReactDOMComponentTree = __webpack_require__(17);
var SyntheticAnimationEvent = __webpack_require__(746);
var SyntheticClipboardEvent = __webpack_require__(747);
var SyntheticEvent = __webpack_require__(56);
var SyntheticFocusEvent = __webpack_require__(750);
var SyntheticKeyboardEvent = __webpack_require__(752);
var SyntheticMouseEvent = __webpack_require__(152);
var SyntheticDragEvent = __webpack_require__(749);
var SyntheticTouchEvent = __webpack_require__(753);
var SyntheticTransitionEvent = __webpack_require__(754);
var SyntheticUIEvent = __webpack_require__(122);
var SyntheticWheelEvent = __webpack_require__(755);

var emptyFunction = __webpack_require__(50);
var getEventCharCode = __webpack_require__(215);
var invariant = __webpack_require__(3);

/**
 * Turns
 * ['abort', ...]
 * into
 * eventTypes = {
 *   'abort': {
 *     phasedRegistrationNames: {
 *       bubbled: 'onAbort',
 *       captured: 'onAbortCapture',
 *     },
 *     dependencies: ['topAbort'],
 *   },
 *   ...
 * };
 * topLevelEventsToDispatchConfig = {
 *   'topAbort': { sameConfig }
 * };
 */
var eventTypes = {};
var topLevelEventsToDispatchConfig = {};
['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
  var onEvent = 'on' + capitalizedEvent;
  var topEvent = 'top' + capitalizedEvent;

  var type = {
    phasedRegistrationNames: {
      bubbled: onEvent,
      captured: onEvent + 'Capture'
    },
    dependencies: [topEvent]
  };
  eventTypes[event] = type;
  topLevelEventsToDispatchConfig[topEvent] = type;
});

var onClickListeners = {};

function getDictionaryKey(inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
}

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

var SimpleEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
    if (!dispatchConfig) {
      return null;
    }
    var EventConstructor;
    switch (topLevelType) {
      case 'topAbort':
      case 'topCanPlay':
      case 'topCanPlayThrough':
      case 'topDurationChange':
      case 'topEmptied':
      case 'topEncrypted':
      case 'topEnded':
      case 'topError':
      case 'topInput':
      case 'topInvalid':
      case 'topLoad':
      case 'topLoadedData':
      case 'topLoadedMetadata':
      case 'topLoadStart':
      case 'topPause':
      case 'topPlay':
      case 'topPlaying':
      case 'topProgress':
      case 'topRateChange':
      case 'topReset':
      case 'topSeeked':
      case 'topSeeking':
      case 'topStalled':
      case 'topSubmit':
      case 'topSuspend':
      case 'topTimeUpdate':
      case 'topVolumeChange':
      case 'topWaiting':
        // HTML Events
        // @see http://www.w3.org/TR/html5/index.html#events-0
        EventConstructor = SyntheticEvent;
        break;
      case 'topKeyPress':
        // Firefox creates a keypress event for function keys too. This removes
        // the unwanted keypress events. Enter is however both printable and
        // non-printable. One would expect Tab to be as well (but it isn't).
        if (getEventCharCode(nativeEvent) === 0) {
          return null;
        }
      /* falls through */
      case 'topKeyDown':
      case 'topKeyUp':
        EventConstructor = SyntheticKeyboardEvent;
        break;
      case 'topBlur':
      case 'topFocus':
        EventConstructor = SyntheticFocusEvent;
        break;
      case 'topClick':
        // Firefox creates a click event on right mouse clicks. This removes the
        // unwanted click events.
        if (nativeEvent.button === 2) {
          return null;
        }
      /* falls through */
      case 'topDoubleClick':
      case 'topMouseDown':
      case 'topMouseMove':
      case 'topMouseUp':
      // TODO: Disabled elements should not respond to mouse events
      /* falls through */
      case 'topMouseOut':
      case 'topMouseOver':
      case 'topContextMenu':
        EventConstructor = SyntheticMouseEvent;
        break;
      case 'topDrag':
      case 'topDragEnd':
      case 'topDragEnter':
      case 'topDragExit':
      case 'topDragLeave':
      case 'topDragOver':
      case 'topDragStart':
      case 'topDrop':
        EventConstructor = SyntheticDragEvent;
        break;
      case 'topTouchCancel':
      case 'topTouchEnd':
      case 'topTouchMove':
      case 'topTouchStart':
        EventConstructor = SyntheticTouchEvent;
        break;
      case 'topAnimationEnd':
      case 'topAnimationIteration':
      case 'topAnimationStart':
        EventConstructor = SyntheticAnimationEvent;
        break;
      case 'topTransitionEnd':
        EventConstructor = SyntheticTransitionEvent;
        break;
      case 'topScroll':
        EventConstructor = SyntheticUIEvent;
        break;
      case 'topWheel':
        EventConstructor = SyntheticWheelEvent;
        break;
      case 'topCopy':
      case 'topCut':
      case 'topPaste':
        EventConstructor = SyntheticClipboardEvent;
        break;
    }
    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
    EventPropagators.accumulateTwoPhaseDispatches(event);
    return event;
  },

  didPutListener: function (inst, registrationName, listener) {
    // Mobile Safari does not fire properly bubble click events on
    // non-interactive elements, which means delegated click listeners do not
    // fire. The workaround for this bug involves attaching an empty click
    // listener on the target node.
    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      if (!onClickListeners[key]) {
        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
      }
    }
  },

  willDeleteListener: function (inst, registrationName) {
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      onClickListeners[key].remove();
      delete onClickListeners[key];
    }
  }
};

module.exports = SimpleEventPlugin;

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(56);

/**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */
var AnimationEventInterface = {
  animationName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);

module.exports = SyntheticAnimationEvent;

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(56);

/**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */
var ClipboardEventInterface = {
  clipboardData: function (event) {
    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);

module.exports = SyntheticClipboardEvent;

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(56);

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */
var CompositionEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);

module.exports = SyntheticCompositionEvent;

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticMouseEvent = __webpack_require__(152);

/**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var DragEventInterface = {
  dataTransfer: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);

module.exports = SyntheticDragEvent;

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(122);

/**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var FocusEventInterface = {
  relatedTarget: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);

module.exports = SyntheticFocusEvent;

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(56);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */
var InputEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);

module.exports = SyntheticInputEvent;

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(122);

var getEventCharCode = __webpack_require__(215);
var getEventKey = __webpack_require__(760);
var getEventModifierState = __webpack_require__(216);

/**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var KeyboardEventInterface = {
  key: getEventKey,
  location: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  repeat: null,
  locale: null,
  getModifierState: getEventModifierState,
  // Legacy Interface
  charCode: function (event) {
    // `charCode` is the result of a KeyPress event and represents the value of
    // the actual printable character.

    // KeyPress is deprecated, but its replacement is not yet final and not
    // implemented in any major browser. Only KeyPress has charCode.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    return 0;
  },
  keyCode: function (event) {
    // `keyCode` is the result of a KeyDown/Up event and represents the value of
    // physical keyboard key.

    // The actual meaning of the value depends on the users' keyboard layout
    // which cannot be detected. Assuming that it is a US keyboard layout
    // provides a surprisingly accurate mapping for US and European users.
    // Due to this, it is left to the user to implement at this time.
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  },
  which: function (event) {
    // `which` is an alias for either `keyCode` or `charCode` depending on the
    // type of the event.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);

module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(122);

var getEventModifierState = __webpack_require__(216);

/**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */
var TouchEventInterface = {
  touches: null,
  targetTouches: null,
  changedTouches: null,
  altKey: null,
  metaKey: null,
  ctrlKey: null,
  shiftKey: null,
  getModifierState: getEventModifierState
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);

module.exports = SyntheticTouchEvent;

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(56);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */
var TransitionEventInterface = {
  propertyName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);

module.exports = SyntheticTransitionEvent;

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticMouseEvent = __webpack_require__(152);

/**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var WheelEventInterface = {
  deltaX: function (event) {
    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
  },
  deltaY: function (event) {
    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
    'wheelDelta' in event ? -event.wheelDelta : 0;
  },
  deltaZ: null,

  // Browsers without "deltaMode" is reporting in raw wheel delta where one
  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
  deltaMode: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticMouseEvent}
 */
function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);

module.exports = SyntheticWheelEvent;

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var MOD = 65521;

// adler32 is not cryptographically strong, and is only used to sanity check that
// markup generated on the server matches the markup generated on the client.
// This implementation (a modified version of the SheetJS version) has been optimized
// for our use case, at the expense of conforming to the adler32 specification
// for non-ascii inputs.
function adler32(data) {
  var a = 1;
  var b = 0;
  var i = 0;
  var l = data.length;
  var m = l & ~0x3;
  while (i < m) {
    var n = Math.min(i + 4096, m);
    for (; i < n; i += 4) {
      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
    }
    a %= MOD;
    b %= MOD;
  }
  for (; i < l; i++) {
    b += a += data.charCodeAt(i);
  }
  a %= MOD;
  b %= MOD;
  return a | b << 16;
}

module.exports = adler32;

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var CSSProperty = __webpack_require__(305);
var warning = __webpack_require__(10);

var isUnitlessNumber = CSSProperty.isUnitlessNumber;
var styleWarnings = {};

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, component, isCustomProperty) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    if (false) {
      // Allow '0' to pass through without warning. 0 is already special and
      // doesn't require units, so we don't need to warn about it.
      if (component && value !== '0') {
        var owner = component._currentElement._owner;
        var ownerName = owner ? owner.getName() : null;
        if (ownerName && !styleWarnings[ownerName]) {
          styleWarnings[ownerName] = {};
        }
        var warned = false;
        if (ownerName) {
          var warnings = styleWarnings[ownerName];
          warned = warnings[name];
          if (!warned) {
            warnings[name] = true;
          }
        }
        if (!warned) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
        }
      }
    }
    value = value.trim();
  }
  return value + 'px';
}

module.exports = dangerousStyleValue;

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(9);

var ReactCurrentOwner = __webpack_require__(57);
var ReactDOMComponentTree = __webpack_require__(17);
var ReactInstanceMap = __webpack_require__(121);

var getHostComponentFromComposite = __webpack_require__(325);
var invariant = __webpack_require__(3);
var warning = __webpack_require__(10);

/**
 * Returns the DOM node rendered by this element.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
 *
 * @param {ReactComponent|DOMElement} componentOrElement
 * @return {?DOMElement} The root node of this element.
 */
function findDOMNode(componentOrElement) {
  if (false) {
    var owner = ReactCurrentOwner.current;
    if (owner !== null) {
      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
      owner._warnedAboutRefsInRender = true;
    }
  }
  if (componentOrElement == null) {
    return null;
  }
  if (componentOrElement.nodeType === 1) {
    return componentOrElement;
  }

  var inst = ReactInstanceMap.get(componentOrElement);
  if (inst) {
    inst = getHostComponentFromComposite(inst);
    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
  }

  if (typeof componentOrElement.render === 'function') {
     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
  } else {
     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
  }
}

module.exports = findDOMNode;

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var KeyEscapeUtils = __webpack_require__(209);
var traverseAllChildren = __webpack_require__(330);
var warning = __webpack_require__(10);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && __webpack_require__.i({"NODE_ENV":"production"}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(352);
}

/**
 * @param {function} traverseContext Context passed through traversal.
 * @param {?ReactComponent} child React child component.
 * @param {!string} name String name of key path to child.
 * @param {number=} selfDebugID Optional debugID of the current internal instance.
 */
function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
  // We found a component instance.
  if (traverseContext && typeof traverseContext === 'object') {
    var result = traverseContext;
    var keyUnique = result[name] === undefined;
    if (false) {
      if (!ReactComponentTreeHook) {
        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
      }
      if (!keyUnique) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
      }
    }
    if (keyUnique && child != null) {
      result[name] = child;
    }
  }
}

/**
 * Flattens children that are typically specified as `props.children`. Any null
 * children will not be included in the resulting object.
 * @return {!object} flattened children keyed by name.
 */
function flattenChildren(children, selfDebugID) {
  if (children == null) {
    return children;
  }
  var result = {};

  if (false) {
    traverseAllChildren(children, function (traverseContext, child, name) {
      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
    }, result);
  } else {
    traverseAllChildren(children, flattenSingleChildIntoContext, result);
  }
  return result;
}

module.exports = flattenChildren;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(87)))

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var getEventCharCode = __webpack_require__(215);

/**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var normalizeKey = {
  Esc: 'Escape',
  Spacebar: ' ',
  Left: 'ArrowLeft',
  Up: 'ArrowUp',
  Right: 'ArrowRight',
  Down: 'ArrowDown',
  Del: 'Delete',
  Win: 'OS',
  Menu: 'ContextMenu',
  Apps: 'ContextMenu',
  Scroll: 'ScrollLock',
  MozPrintableKey: 'Unidentified'
};

/**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var translateToKey = {
  8: 'Backspace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Control',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Escape',
  32: ' ',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
  45: 'Insert',
  46: 'Delete',
  112: 'F1',
  113: 'F2',
  114: 'F3',
  115: 'F4',
  116: 'F5',
  117: 'F6',
  118: 'F7',
  119: 'F8',
  120: 'F9',
  121: 'F10',
  122: 'F11',
  123: 'F12',
  144: 'NumLock',
  145: 'ScrollLock',
  224: 'Meta'
};

/**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */
function getEventKey(nativeEvent) {
  if (nativeEvent.key) {
    // Normalize inconsistent values reported by browsers due to
    // implementations of a working draft specification.

    // FireFox implements `key` but returns `MozPrintableKey` for all
    // printable characters (normalized to `Unidentified`), ignore it.
    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
    if (key !== 'Unidentified') {
      return key;
    }
  }

  // Browser does not implement `key`, polyfill as much of it as we can.
  if (nativeEvent.type === 'keypress') {
    var charCode = getEventCharCode(nativeEvent);

    // The enter-key is technically both printable and non-printable and can
    // thus be captured by `keypress`, no other non-printable key should.
    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
  }
  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
    // While user keyboard layout determines the actual meaning of each
    // `keyCode` value, almost all function keys have a universal value.
    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
  }
  return '';
}

module.exports = getEventKey;

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */

function getLeafNode(node) {
  while (node && node.firstChild) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */
function getSiblingNode(node) {
  while (node) {
    if (node.nextSibling) {
      return node.nextSibling;
    }
    node = node.parentNode;
  }
}

/**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */
function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  var nodeStart = 0;
  var nodeEnd = 0;

  while (node) {
    if (node.nodeType === 3) {
      nodeEnd = nodeStart + node.textContent.length;

      if (nodeStart <= offset && nodeEnd >= offset) {
        return {
          node: node,
          offset: offset - nodeStart
        };
      }

      nodeStart = nodeEnd;
    }

    node = getLeafNode(getSiblingNode(node));
  }
}

module.exports = getNodeForCharacterOffset;

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(24);

/**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

/**
 * A list of event names to a configurable list of vendor prefixes.
 */
var vendorPrefixes = {
  animationend: makePrefixMap('Animation', 'AnimationEnd'),
  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
  animationstart: makePrefixMap('Animation', 'AnimationStart'),
  transitionend: makePrefixMap('Transition', 'TransitionEnd')
};

/**
 * Event names that have already been detected and prefixed (if applicable).
 */
var prefixedEventNames = {};

/**
 * Element to check for prefixes on.
 */
var style = {};

/**
 * Bootstrap if a DOM exists.
 */
if (ExecutionEnvironment.canUseDOM) {
  style = document.createElement('div').style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are usable, and if not remove them from the map.
  if (!('AnimationEvent' in window)) {
    delete vendorPrefixes.animationend.animation;
    delete vendorPrefixes.animationiteration.animation;
    delete vendorPrefixes.animationstart.animation;
  }

  // Same as above
  if (!('TransitionEvent' in window)) {
    delete vendorPrefixes.transitionend.transition;
  }
}

/**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  } else if (!vendorPrefixes[eventName]) {
    return eventName;
  }

  var prefixMap = vendorPrefixes[eventName];

  for (var styleProp in prefixMap) {
    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
      return prefixedEventNames[eventName] = prefixMap[styleProp];
    }
  }

  return '';
}

module.exports = getVendorPrefixedEventName;

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var escapeTextContentForBrowser = __webpack_require__(154);

/**
 * Escapes attribute value to prevent scripting attacks.
 *
 * @param {*} value Value to escape.
 * @return {string} An escaped string.
 */
function quoteAttributeValueForBrowser(value) {
  return '"' + escapeTextContentForBrowser(value) + '"';
}

module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactMount = __webpack_require__(318);

module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(727);


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = Comments;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Parser = __webpack_require__(51);

var _Parser2 = _interopRequireDefault(_Parser);

var _getCurrentHref = __webpack_require__(101);

var _getCurrentHref2 = _interopRequireDefault(_getCurrentHref);

var _ColorScheme = __webpack_require__(224);

var _ColorScheme2 = _interopRequireDefault(_ColorScheme);

var _CommentsOrderBy = __webpack_require__(333);

var _CommentsOrderBy2 = _interopRequireDefault(_CommentsOrderBy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Comments(props) {
  var className = props.className,
      colorScheme = props.colorScheme,
      _props$href = props.href,
      href = _props$href === undefined ? (0, _getCurrentHref2.default)() : _props$href,
      numPosts = props.numPosts,
      orderBy = props.orderBy,
      width = props.width,
      children = props.children,
      onParse = props.onParse;


  return _react2.default.createElement(
    _Parser2.default,
    { className: className, onParse: onParse },
    _react2.default.createElement(
      'div',
      {
        className: 'fb-comments',
        'data-colorscheme': colorScheme,
        'data-numposts': numPosts,
        'data-href': href,
        'data-order-by': orderBy,
        'data-width': width,
        'data-skin': colorScheme
      },
      children
    )
  );
}

Comments.propTypes = {
  className: _propTypes2.default.string,
  href: _propTypes2.default.string,
  numPosts: _propTypes2.default.number.isRequired,
  orderBy: _propTypes2.default.string.isRequired,
  width: _propTypes2.default.oneOfType([_propTypes2.default.number.isRequired, _propTypes2.default.string.isRequired]),
  colorScheme: _propTypes2.default.string.isRequired,
  children: _propTypes2.default.node,
  onParse: _propTypes2.default.func
};

Comments.defaultProps = {
  numPosts: 10,
  orderBy: _CommentsOrderBy2.default.SOCIAL,
  width: 550,
  colorScheme: _ColorScheme2.default.LIGHT,
  children: undefined,
  className: undefined,
  href: undefined,
  onParse: undefined
};
//# sourceMappingURL=Comments.js.map

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = CommentsCount;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Parser = __webpack_require__(51);

var _Parser2 = _interopRequireDefault(_Parser);

var _getCurrentHref = __webpack_require__(101);

var _getCurrentHref2 = _interopRequireDefault(_getCurrentHref);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CommentsCount(props) {
  var className = props.className,
      _props$href = props.href,
      href = _props$href === undefined ? (0, _getCurrentHref2.default)() : _props$href,
      children = props.children,
      onParse = props.onParse;


  return _react2.default.createElement(
    _Parser2.default,
    { className: className, onParse: onParse },
    _react2.default.createElement(
      'span',
      {
        className: 'fb-comments-count',
        'data-href': href
      },
      children
    )
  );
}

CommentsCount.propTypes = {
  className: _propTypes2.default.string,
  href: _propTypes2.default.string,
  children: _propTypes2.default.node,
  onParse: _propTypes2.default.func
};

CommentsCount.defaultProps = {
  className: undefined,
  href: undefined,
  children: undefined,
  onParse: undefined
};
//# sourceMappingURL=CommentsCount.js.map

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = CustomChat;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Parser = __webpack_require__(51);

var _Parser2 = _interopRequireDefault(_Parser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CustomChat(props) {
  var className = props.className,
      dataRef = props.dataRef,
      minimized = props.minimized,
      children = props.children,
      pageId = props.pageId,
      onParse = props.onParse;


  return _react2.default.createElement(
    _Parser2.default,
    { className: className, onParse: onParse },
    _react2.default.createElement(
      'div',
      {
        className: 'fb-customerchat',
        'data-page_id': pageId,
        'data-ref': dataRef,
        'data-minimized': minimized
      },
      children
    )
  );
}

CustomChat.propTypes = {
  className: _propTypes2.default.string,
  dataRef: _propTypes2.default.string,
  pageId: _propTypes2.default.string.isRequired,
  minimized: _propTypes2.default.bool,
  onParse: _propTypes2.default.func,
  children: _propTypes2.default.node
};

CustomChat.defaultProps = {
  minimized: true,
  children: undefined,
  className: undefined,
  dataRef: undefined,
  onParse: undefined
};
//# sourceMappingURL=CustomChat.js.map

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = EmbeddedPost;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Parser = __webpack_require__(51);

var _Parser2 = _interopRequireDefault(_Parser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function EmbeddedPost(props) {
  var className = props.className,
      href = props.href,
      width = props.width,
      showText = props.showText,
      children = props.children,
      onParse = props.onParse;


  return _react2.default.createElement(
    _Parser2.default,
    { className: className, onParse: onParse },
    _react2.default.createElement(
      'div',
      {
        className: 'fb-post',
        'data-href': href,
        'data-width': width,
        'data-show-text': showText
      },
      children
    )
  );
}

EmbeddedPost.propTypes = {
  className: _propTypes2.default.string,
  href: _propTypes2.default.string.isRequired,
  width: _propTypes2.default.oneOfType([_propTypes2.default.number.isRequired, _propTypes2.default.string.isRequired]),
  showText: _propTypes2.default.bool.isRequired,
  children: _propTypes2.default.node,
  onParse: _propTypes2.default.func
};

EmbeddedPost.defaultProps = {
  href: 'http://www.facebook.com',
  width: 500, // 350 - 750
  showText: false,
  children: undefined,
  className: undefined,
  onParse: undefined
};
//# sourceMappingURL=EmbeddedPost.js.map

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.Method = exports.LoginStatus = undefined;

var _regenerator = __webpack_require__(72);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(71);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(92);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(52);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _debug = __webpack_require__(782);

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)('react-facebook:facebook');

var LoginStatus = exports.LoginStatus = {
  CONNECTED: 'connected',
  NOT_AUTHORIZED: 'not_authorized'
};

var Method = exports.Method = {
  GET: 'get',
  POST: 'post',
  DELETE: 'delete'
};

var Facebook = function () {
  function Facebook() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, Facebook);

    this.options = (0, _extends3.default)({
      domain: 'connect.facebook.net',
      version: 'v2.9',
      cookie: false,
      status: false,
      xfbml: false,
      language: 'en_US',
      frictionlessRequests: false
    }, options);

    if (!this.options.appId) {
      throw new Error('You need to set appId');
    }

    if (!this.options.wait) {
      this.init();
    }
  }

  Facebook.prototype.getAppId = function getAppId() {
    return this.options.appId;
  };

  Facebook.prototype.init = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var _this = this;

      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!this.loadingPromise) {
                _context.next = 2;
                break;
              }

              return _context.abrupt('return', this.loadingPromise);

            case 2:

              this.loadingPromise = new Promise(function (resolve) {
                var options = _this.options;


                window.fbAsyncInit = function () {
                  window.FB.init({
                    appId: options.appId,
                    version: options.version,
                    cookie: options.cookie,
                    status: options.status,
                    xfbml: options.xfbml,
                    frictionlessRequests: _this.frictionlessRequests
                  });

                  resolve(window.FB);
                };

                var fjs = document.getElementsByTagName('script')[0];
                if (!fjs) {
                  log('Script tag does not exists in the DOM');
                  return;
                }

                if (document.getElementById('facebook-jssdk')) {
                  return;
                }

                var js = document.createElement('script');
                js.id = 'facebook-jssdk';
                js.async = true;
                js.src = '//' + options.domain + '/' + options.language + '/sdk.js';

                fjs.parentNode.insertBefore(js, fjs);
              });

              return _context.abrupt('return', this.loadingPromise);

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function init() {
      return _ref.apply(this, arguments);
    }

    return init;
  }();

  Facebook.prototype.process = function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(method) {
      var before = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var after = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var fb;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.init();

            case 2:
              fb = _context2.sent;
              return _context2.abrupt('return', new Promise(function (resolve, reject) {
                fb[method].apply(fb, before.concat([function (response) {
                  if (!response || response.error) {
                    reject(new Error(response && response.error || 'Response is undefined'));
                    return;
                  }

                  resolve(response);
                }], after));
              }));

            case 4:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function process(_x2) {
      return _ref2.apply(this, arguments);
    }

    return process;
  }();

  Facebook.prototype.ui = function () {
    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(options) {
      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt('return', this.process('ui', [options]));

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function ui(_x5) {
      return _ref3.apply(this, arguments);
    }

    return ui;
  }();

  Facebook.prototype.api = function () {
    var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(path) {
      var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Method.GET;
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return _regenerator2.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt('return', this.process('api', [path, method, params]));

            case 1:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function api(_x6) {
      return _ref4.apply(this, arguments);
    }

    return api;
  }();

  Facebook.prototype.login = function () {
    var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return _regenerator2.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt('return', this.process('login', [], [opts]));

            case 1:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function login() {
      return _ref5.apply(this, arguments);
    }

    return login;
  }();

  Facebook.prototype.logout = function () {
    var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6() {
      return _regenerator2.default.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt('return', this.process('logout'));

            case 1:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, this);
    }));

    function logout() {
      return _ref6.apply(this, arguments);
    }

    return logout;
  }();

  Facebook.prototype.getLoginStatus = function () {
    var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7() {
      return _regenerator2.default.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt('return', this.process('getLoginStatus'));

            case 1:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, this);
    }));

    function getLoginStatus() {
      return _ref7.apply(this, arguments);
    }

    return getLoginStatus;
  }();

  Facebook.prototype.getAuthResponse = function () {
    var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8() {
      return _regenerator2.default.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              return _context8.abrupt('return', this.process('getAuthResponse'));

            case 1:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, this);
    }));

    function getAuthResponse() {
      return _ref8.apply(this, arguments);
    }

    return getAuthResponse;
  }();

  Facebook.prototype.getTokenDetail = function () {
    var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9() {
      var response;
      return _regenerator2.default.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return this.getLoginStatus();

            case 2:
              response = _context9.sent;

              if (!(response.status === LoginStatus.CONNECTED && response.authResponse)) {
                _context9.next = 5;
                break;
              }

              return _context9.abrupt('return', response.authResponse);

            case 5:
              throw new Error('Token is undefined');

            case 6:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, this);
    }));

    function getTokenDetail() {
      return _ref9.apply(this, arguments);
    }

    return getTokenDetail;
  }();

  Facebook.prototype.getProfile = function () {
    var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10(params) {
      return _regenerator2.default.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              return _context10.abrupt('return', this.api('/me', Method.GET, params));

            case 1:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, this);
    }));

    function getProfile(_x10) {
      return _ref10.apply(this, arguments);
    }

    return getProfile;
  }();

  Facebook.prototype.getTokenDetailWithProfile = function () {
    var _ref11 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee11(params) {
      var tokenDetail, profile;
      return _regenerator2.default.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return this.getTokenDetail();

            case 2:
              tokenDetail = _context11.sent;
              _context11.next = 5;
              return this.getProfile(params);

            case 5:
              profile = _context11.sent;
              return _context11.abrupt('return', {
                profile: profile,
                tokenDetail: tokenDetail
              });

            case 7:
            case 'end':
              return _context11.stop();
          }
        }
      }, _callee11, this);
    }));

    function getTokenDetailWithProfile(_x11) {
      return _ref11.apply(this, arguments);
    }

    return getTokenDetailWithProfile;
  }();

  Facebook.prototype.getToken = function () {
    var _ref12 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee12() {
      var authResponse;
      return _regenerator2.default.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return this.getTokenDetail();

            case 2:
              authResponse = _context12.sent;
              return _context12.abrupt('return', authResponse.accessToken);

            case 4:
            case 'end':
              return _context12.stop();
          }
        }
      }, _callee12, this);
    }));

    function getToken() {
      return _ref12.apply(this, arguments);
    }

    return getToken;
  }();

  Facebook.prototype.getUserId = function () {
    var _ref13 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee13() {
      var authResponse;
      return _regenerator2.default.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return this.getTokenDetail();

            case 2:
              authResponse = _context13.sent;
              return _context13.abrupt('return', authResponse.userID);

            case 4:
            case 'end':
              return _context13.stop();
          }
        }
      }, _callee13, this);
    }));

    function getUserId() {
      return _ref13.apply(this, arguments);
    }

    return getUserId;
  }();

  Facebook.prototype.sendInvite = function () {
    var _ref14 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee14(to, options) {
      return _regenerator2.default.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              return _context14.abrupt('return', this.ui((0, _extends3.default)({
                to: to,
                method: 'apprequests'
              }, options)));

            case 1:
            case 'end':
              return _context14.stop();
          }
        }
      }, _callee14, this);
    }));

    function sendInvite(_x12, _x13) {
      return _ref14.apply(this, arguments);
    }

    return sendInvite;
  }();

  Facebook.prototype.postAction = function () {
    var _ref15 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee15(ogNamespace, ogAction, ogObject, ogObjectUrl, noFeedStory) {
      var url;
      return _regenerator2.default.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              url = '/me/' + ogNamespace + ':' + ogAction + '?' + ogObject + '=' + encodeURIComponent(ogObjectUrl);


              if (noFeedStory === true) {
                url += '&no_feed_story=true';
              }

              return _context15.abrupt('return', this.api(url, Method.POST));

            case 3:
            case 'end':
              return _context15.stop();
          }
        }
      }, _callee15, this);
    }));

    function postAction(_x14, _x15, _x16, _x17, _x18) {
      return _ref15.apply(this, arguments);
    }

    return postAction;
  }();

  Facebook.prototype.getPermissions = function () {
    var _ref16 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee16() {
      var response;
      return _regenerator2.default.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              _context16.next = 2;
              return this.api('/me/permissions');

            case 2:
              response = _context16.sent;
              return _context16.abrupt('return', response.data);

            case 4:
            case 'end':
              return _context16.stop();
          }
        }
      }, _callee16, this);
    }));

    function getPermissions() {
      return _ref16.apply(this, arguments);
    }

    return getPermissions;
  }();

  Facebook.prototype.hasPermissions = function () {
    var _ref17 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee17(permissions) {
      var usersPermissions, findedPermissions;
      return _regenerator2.default.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return this.getPermissions();

            case 2:
              usersPermissions = _context17.sent;
              findedPermissions = permissions.filter(function (p) {
                return !!usersPermissions.find(function (row) {
                  var permission = row.permission,
                      status = row.status;

                  return status === 'granted' && permission === p;
                });
              });
              return _context17.abrupt('return', findedPermissions.length === permissions.length);

            case 5:
            case 'end':
              return _context17.stop();
          }
        }
      }, _callee17, this);
    }));

    function hasPermissions(_x19) {
      return _ref17.apply(this, arguments);
    }

    return hasPermissions;
  }();

  Facebook.prototype.subscribe = function () {
    var _ref18 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee18(eventName, callback) {
      var fb;
      return _regenerator2.default.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              _context18.next = 2;
              return this.init();

            case 2:
              fb = _context18.sent;

              fb.Event.subscribe(eventName, callback);

            case 4:
            case 'end':
              return _context18.stop();
          }
        }
      }, _callee18, this);
    }));

    function subscribe(_x20, _x21) {
      return _ref18.apply(this, arguments);
    }

    return subscribe;
  }();

  Facebook.prototype.unsubscribe = function () {
    var _ref19 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee19(eventName, callback) {
      var fb;
      return _regenerator2.default.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              _context19.next = 2;
              return this.init();

            case 2:
              fb = _context19.sent;

              fb.Event.unsubscribe(eventName, callback);

            case 4:
            case 'end':
              return _context19.stop();
          }
        }
      }, _callee19, this);
    }));

    function unsubscribe(_x22, _x23) {
      return _ref19.apply(this, arguments);
    }

    return unsubscribe;
  }();

  Facebook.prototype.parse = function () {
    var _ref20 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee20(parentNode) {
      var fb;
      return _regenerator2.default.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              _context20.next = 2;
              return this.init();

            case 2:
              fb = _context20.sent;


              if (typeof parentNode === 'undefined') {
                fb.XFBML.parse();
              } else {
                fb.XFBML.parse(parentNode);
              }

            case 4:
            case 'end':
              return _context20.stop();
          }
        }
      }, _callee20, this);
    }));

    function parse(_x24) {
      return _ref20.apply(this, arguments);
    }

    return parse;
  }();

  Facebook.prototype.getRequests = function () {
    var _ref21 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee21() {
      return _regenerator2.default.wrap(function _callee21$(_context21) {
        while (1) {
          switch (_context21.prev = _context21.next) {
            case 0:
              return _context21.abrupt('return', this.api('/me/apprequests'));

            case 1:
            case 'end':
              return _context21.stop();
          }
        }
      }, _callee21, this);
    }));

    function getRequests() {
      return _ref21.apply(this, arguments);
    }

    return getRequests;
  }();

  Facebook.prototype.removeRequest = function () {
    var _ref22 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee22(requestID) {
      return _regenerator2.default.wrap(function _callee22$(_context22) {
        while (1) {
          switch (_context22.prev = _context22.next) {
            case 0:
              return _context22.abrupt('return', this.api(requestID, Method.DELETE));

            case 1:
            case 'end':
              return _context22.stop();
          }
        }
      }, _callee22, this);
    }));

    function removeRequest(_x25) {
      return _ref22.apply(this, arguments);
    }

    return removeRequest;
  }();

  Facebook.prototype.setAutoGrow = function () {
    var _ref23 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee23() {
      var fb;
      return _regenerator2.default.wrap(function _callee23$(_context23) {
        while (1) {
          switch (_context23.prev = _context23.next) {
            case 0:
              _context23.next = 2;
              return this.init();

            case 2:
              fb = _context23.sent;

              fb.Canvas.setAutoGrow();

            case 4:
            case 'end':
              return _context23.stop();
          }
        }
      }, _callee23, this);
    }));

    function setAutoGrow() {
      return _ref23.apply(this, arguments);
    }

    return setAutoGrow;
  }();

  Facebook.prototype.paySimple = function () {
    var _ref24 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee24(product) {
      var quantity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      return _regenerator2.default.wrap(function _callee24$(_context24) {
        while (1) {
          switch (_context24.prev = _context24.next) {
            case 0:
              return _context24.abrupt('return', this.ui({
                method: 'pay',
                action: 'purchaseitem',
                product: product,
                quantity: quantity
              }));

            case 1:
            case 'end':
              return _context24.stop();
          }
        }
      }, _callee24, this);
    }));

    function paySimple(_x26) {
      return _ref24.apply(this, arguments);
    }

    return paySimple;
  }();

  Facebook.prototype.pay = function () {
    var _ref25 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee25(product, options) {
      return _regenerator2.default.wrap(function _callee25$(_context25) {
        while (1) {
          switch (_context25.prev = _context25.next) {
            case 0:
              return _context25.abrupt('return', this.ui((0, _extends3.default)({
                method: 'pay',
                action: 'purchaseitem',
                product: product
              }, options)));

            case 1:
            case 'end':
              return _context25.stop();
          }
        }
      }, _callee25, this);
    }));

    function pay(_x28, _x29) {
      return _ref25.apply(this, arguments);
    }

    return pay;
  }();

  return Facebook;
}();

/*
  sendToFriends: function(options, callback) {
    if(!options) {
      options = {};
    }

    options.method = 'send';

    this.afterLoad(function(err, fbApi) {
      if(err) {
        return callback(err);
      }

      FB.ui(options, function(response) {
        fbApi._callCallbackByResponse(callback, response);
      });
    });
  },

  sendMessage: function(message, name, caption, description, url, imgUrl, callback) {
    this.afterLoad(function(err, fbApi) {
      if(err) {
        return callback(err);
      }

      FB.ui({
        method: 'stream.publish',
        message: message,
        attachment: {
          name: name,
          caption: caption,
          description: description,
          href: url,
          media:[{
            type: 'image',
            src:  imgUrl,
            href: url
          }]
        },
        action_links: [{
          text: 'Code',
          href: url
        }],
        user_prompt_message: message
      },
      function(response) {
        fbApi._callCallbackByResponse(callback, response);
      });
    });
  },

  sendInviteForm: function(options, callback) {
    if(typeof options === 'function') {
      callback = options;
      options = {};
    }

    this.afterLoad(function(err, fbApi) {
      if(err) {
        return callback(err);
      }

      options.method = options.method || 'apprequests';


      FB.ui(options, function(response) {
        fbApi._callCallbackByResponse(callback, response);
      });
    });
  },

  checkPageLike: function(pageID, callback) {
    this.afterLoad(function(err, fbApi) {
      if(err) {
        return callback(err);
      }

      fbApi.getUserID(function(err, userID) {
        if(err) {
          return callback(err);
        }

        var fqlQuery = 'SELECT uid FROM page_fan WHERE page_id = ' + pageID + ' and uid =  '+ userID;
        var query = FB.Data.query(fqlQuery);

        query.wait(function(rows) {
          if (rows.length === 1 && rows[0].uid === userID) {
            callback(null, true, query);
          }
          else {
            callback(null, false, query);
          }
        });
      });
    });
  },

  sendMessageToFriend: function (friendID, link, callback) {
    this.afterLoad(function(err, fbApi) {
      if(err) {
        return callback(err);
      }

      FB.ui({
        to: friendID,
        method: 'send',
        link: link
      }, function(response) {
        fbApi._callCallbackByResponse(callback, response);
      });
    });
  },

  _prepareUsers: function(data) {
    var users=[];

    for(var index in data) {
      var userData=data[index];

      var user = {
        provider_uid: 'facebook'+'_'+userData.uid,
        provider: 'facebook',
        id: userData.uid,
        name: userData.name,
        first_name: userData.first_name,
        last_name: userData.last_name,
        status: (userData.status!==null) ? userData.status : null,
        image: '//graph.facebook.com/'+userData.uid+'/picture?'
      };

      users.push(user);
    }

    return users;
  },

  getUserList: function(callback) {
    this.afterLoad(function(err, fbApi) {
      if(err) {
        return callback(err);
      }

      FB.api('fql', { q: 'SELECT uid, name, first_name, last_name, online_presence, status FROM user WHERE uid IN ( SELECT uid2 FROM friend WHERE uid1 = me()) ORDER BY name' }, function (response)
      {
        var users = fbApi._prepareUsers(response.data);
        callback(null, users, response);
      });
    });
  },

  postFeed: function(options, callback) {
    this.afterLoad(function(err, fbApi) {
      if(err) {
        return callback(err);
      }

      options.method='feed';

      FB.ui(options, function(response) {
        fbApi._callCallbackByResponse(callback, response);
      });
    });
  },

  //need publish_stream
  createAlbum: function(name, description, callback) {
    this.afterLoad(function(err, fbApi) {
      if(err) {
        return callback(err);
      }

      FB.api('/me/albums', 'post', {
        name: name,
        description: description
      },function(response) {
        fbApi._callCallbackByResponse(callback, response);
      });
    });
  },

  //need publish_stream
  addImageToAlbum: function(albumID, imageURL, message, callback) {
    this.afterLoad(function(err, fbApi) {
      if(err) {
        return callback(err);
      }

      FB.api('/'+albumID+'/photos', 'post', {
        message: message,
        url: imageURL
      }, function(response) {
        fbApi._callCallbackByResponse(callback, response);
      });
    });
  },

  //'user_photos'
  getAlbums: function(callback) {
    this.afterLoad(function(err, fbApi) {
      if(err) {
        return callback(err);
      }

      FB.api('/me/albums', function(response) {
        fbApi._callCallbackByResponse(callback, response);
      });
    });
  },

  //'user_photos'
  getAlbumPhotos: function(albumID, callback) {
    this.afterLoad(function(err, fbApi) {
      if(err) {
        return callback(err);
      }

      FB.api('/'+albumID+'/photos', function(response) {
        fbApi._callCallbackByResponse(callback, response);
      });
    });
  },

  //'user_photos'
  getAlbumCoverPicture: function(albumID, callback) {
    this.afterLoad(function(err, fbApi) {
      if(err) {
        return callback(err);
      }

      FB.api('/'+albumID+'/picture', function(response) {
        fbApi._callCallbackByResponse(callback, response);
      });
    });
  },

  //'publish_stream'
  postPhoto: function(photoUrl, message, callback) {
    this.afterLoad(function(err, fbApi) {
      if(err) {
        return callback(err);
      }

      FB.api('/me/photos', 'post', {
        message: message,
        url: photoUrl
      },function(response) {
        fbApi._callCallbackByResponse(callback, response);
      });
    });
  },

  getPageInfo: function(callback) {
    this.afterLoad(function(err, fbApi) {
      if(err) {
        return callback(err);
      }

      FB.Canvas.getPageInfo(function(response) {
        fbApi._callCallbackByResponse(callback, response);
      });
    });
  }
*/


exports.default = Facebook;
//# sourceMappingURL=Facebook.js.map

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _regenerator = __webpack_require__(72);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(71);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(52);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(60);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(59);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(1);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Facebook = __webpack_require__(771);

var _Facebook2 = _interopRequireDefault(_Facebook);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var facebookInstance = null;

var Facebook = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Facebook, _Component);

  function Facebook() {
    (0, _classCallCheck3.default)(this, Facebook);
    return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
  }

  Facebook.prototype.getChildContext = function getChildContext() {
    return {
      facebook: this
    };
  };

  Facebook.prototype.init = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var _props, domain, version, appId, cookie, status, xfbml, language, frictionlessRequests, wait;

      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!this.facebook) {
                _props = this.props, domain = _props.domain, version = _props.version, appId = _props.appId, cookie = _props.cookie, status = _props.status, xfbml = _props.xfbml, language = _props.language, frictionlessRequests = _props.frictionlessRequests, wait = _props.wait;


                this.facebook = facebookInstance || new _Facebook2.default({
                  domain: domain,
                  appId: appId,
                  version: version,
                  cookie: cookie,
                  status: status,
                  xfbml: xfbml,
                  language: language,
                  frictionlessRequests: frictionlessRequests,
                  wait: wait
                });

                facebookInstance = this.facebook;
              }

              _context.next = 3;
              return this.facebook.init();

            case 3:
              return _context.abrupt('return', this.facebook);

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function init() {
      return _ref.apply(this, arguments);
    }

    return init;
  }();

  Facebook.prototype.render = function render() {
    return this.props.children;
  };

  return Facebook;
}(_react.Component), _class.propTypes = {
  appId: _propTypes2.default.string.isRequired,
  domain: _propTypes2.default.string,
  version: _propTypes2.default.string,
  cookie: _propTypes2.default.bool,
  status: _propTypes2.default.bool,
  xfbml: _propTypes2.default.bool,
  language: _propTypes2.default.string,
  frictionlessRequests: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  wait: _propTypes2.default.bool
}, _class.childContextTypes = {
  facebook: _propTypes2.default.object.isRequired
}, _class.defaultProps = {
  version: 'v2.9',
  cookie: false,
  status: false,
  xfbml: false,
  language: 'en_US',
  frictionlessRequests: false,
  domain: 'connect.facebook.net',
  children: undefined,
  wait: false
}, _temp);
exports.default = Facebook;
//# sourceMappingURL=FacebookProvider.js.map

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _extends2 = __webpack_require__(92);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(72);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(71);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(52);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(60);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(59);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getCurrentHref = __webpack_require__(101);

var _getCurrentHref2 = _interopRequireDefault(_getCurrentHref);

var _clearUndefinedProperties = __webpack_require__(337);

var _clearUndefinedProperties2 = _interopRequireDefault(_clearUndefinedProperties);

var _Process2 = __webpack_require__(223);

var _Process3 = _interopRequireDefault(_Process2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Feed = (_temp = _class = function (_Process) {
  (0, _inherits3.default)(Feed, _Process);

  function Feed() {
    (0, _classCallCheck3.default)(this, Feed);
    return (0, _possibleConstructorReturn3.default)(this, _Process.apply(this, arguments));
  }

  Feed.prototype.process = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(facebook) {
      var _props, _props$link, link, display, _props$appId, appId, redirectURI, from, to, picture, source, name, caption, description, ref;

      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _props = this.props, _props$link = _props.link, link = _props$link === undefined ? (0, _getCurrentHref2.default)() : _props$link, display = _props.display, _props$appId = _props.appId, appId = _props$appId === undefined ? facebook.getAppId() : _props$appId, redirectURI = _props.redirectURI, from = _props.from, to = _props.to, picture = _props.picture, source = _props.source, name = _props.name, caption = _props.caption, description = _props.description, ref = _props.ref;
              return _context.abrupt('return', facebook.ui((0, _clearUndefinedProperties2.default)({
                method: 'feed',
                link: link,
                display: display,
                app_id: appId,
                redirect_uri: redirectURI,
                from: from,
                to: to,
                picture: picture,
                source: source,
                name: name,
                caption: caption,
                description: description,
                ref: ref
              })));

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function process(_x) {
      return _ref.apply(this, arguments);
    }

    return process;
  }();

  return Feed;
}(_Process3.default), _class.propTypes = (0, _extends3.default)({}, _Process3.default.propTypes, {
  appId: _propTypes2.default.string,
  redirectURI: _propTypes2.default.string,
  display: _propTypes2.default.string,
  from: _propTypes2.default.string,
  to: _propTypes2.default.string,
  link: _propTypes2.default.string,
  source: _propTypes2.default.string,
  picture: _propTypes2.default.string, // deprecated
  name: _propTypes2.default.string, // deprecated
  caption: _propTypes2.default.string, // deprecated
  description: _propTypes2.default.string, // deprecated
  ref: _propTypes2.default.string
}), _class.defaultProps = (0, _extends3.default)({}, _Process3.default.defaultProps, {
  link: undefined,
  display: undefined,
  appId: undefined,
  redirectURI: undefined
}), _temp);
exports.default = Feed;
//# sourceMappingURL=Feed.js.map

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = Like;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Parser = __webpack_require__(51);

var _Parser2 = _interopRequireDefault(_Parser);

var _getCurrentHref = __webpack_require__(101);

var _getCurrentHref2 = _interopRequireDefault(_getCurrentHref);

var _LikeSize = __webpack_require__(336);

var _LikeSize2 = _interopRequireDefault(_LikeSize);

var _LikeLayout = __webpack_require__(335);

var _LikeLayout2 = _interopRequireDefault(_LikeLayout);

var _ColorScheme = __webpack_require__(224);

var _ColorScheme2 = _interopRequireDefault(_ColorScheme);

var _LikeAction = __webpack_require__(334);

var _LikeAction2 = _interopRequireDefault(_LikeAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Like(props) {
  var className = props.className,
      _props$href = props.href,
      href = _props$href === undefined ? (0, _getCurrentHref2.default)() : _props$href,
      layout = props.layout,
      colorScheme = props.colorScheme,
      action = props.action,
      showFaces = props.showFaces,
      share = props.share,
      children = props.children,
      width = props.width,
      size = props.size,
      kidDirectedSite = props.kidDirectedSite,
      referral = props.referral,
      onParse = props.onParse;


  return _react2.default.createElement(
    _Parser2.default,
    { className: className, onParse: onParse },
    _react2.default.createElement(
      'div',
      {
        className: 'fb-like',
        'data-ref': referral,
        'data-href': href,
        'data-layout': layout,
        'data-colorscheme': colorScheme,
        'data-action': action,
        'data-show-faces': showFaces,
        'data-share': share,
        'data-width': width,
        'data-size': size,
        'data-kid-directed-site': kidDirectedSite
      },
      children
    )
  );
}

Like.propTypes = {
  className: _propTypes2.default.string,
  referral: _propTypes2.default.string,
  href: _propTypes2.default.string,
  layout: _propTypes2.default.string.isRequired,
  showFaces: _propTypes2.default.bool.isRequired,
  colorScheme: _propTypes2.default.string.isRequired,
  action: _propTypes2.default.string.isRequired,
  share: _propTypes2.default.bool.isRequired,
  children: _propTypes2.default.node,
  width: _propTypes2.default.oneOfType([_propTypes2.default.number.isRequired, _propTypes2.default.string.isRequired]),
  size: _propTypes2.default.string,
  kidDirectedSite: _propTypes2.default.bool.isRequired,
  onParse: _propTypes2.default.func
};

Like.defaultProps = {
  layout: _LikeLayout2.default.STANDARD,
  showFaces: false,
  colorScheme: _ColorScheme2.default.LIGHT,
  action: _LikeAction2.default.LIKE,
  share: false,
  size: _LikeSize2.default.SMALL,
  kidDirectedSite: false,
  children: undefined,
  className: undefined,
  href: undefined,
  referral: undefined,
  width: undefined,
  onParse: undefined
};
//# sourceMappingURL=Like.js.map

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _extends2 = __webpack_require__(92);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(239);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(52);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(60);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(59);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSpinnerChildren = __webpack_require__(809);

var _reactSpinnerChildren2 = _interopRequireDefault(_reactSpinnerChildren);

var _Login = __webpack_require__(331);

var _Login2 = _interopRequireDefault(_Login);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoginButton = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(LoginButton, _Component);

  function LoginButton() {
    (0, _classCallCheck3.default)(this, LoginButton);
    return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
  }

  LoginButton.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        buttonClassName = _props.buttonClassName,
        iconClassName = _props.iconClassName,
        icon = _props.icon,
        spinner = _props.spinner,
        spinnerClassName = _props.spinnerClassName,
        rest = (0, _objectWithoutProperties3.default)(_props, ['children', 'buttonClassName', 'iconClassName', 'icon', 'spinner', 'spinnerClassName']);


    return _react2.default.createElement(_Login2.default, (0, _extends3.default)({}, rest, {
      render: function render(_ref) {
        var isWorking = _ref.isWorking,
            isLoading = _ref.isLoading,
            onClick = _ref.onClick;
        return _react2.default.createElement(
          'button',
          {
            type: 'button',
            className: buttonClassName,
            onClick: onClick,
            disabled: isWorking || isLoading
          },
          !!icon && _react2.default.createElement('i', { className: iconClassName }),
          children,
          !!spinner && (isWorking || isLoading) && _react2.default.createElement(_reactSpinnerChildren2.default, {
            config: _this2.props.spinnerConfig,
            className: spinnerClassName
          })
        );
      }
    }));
  };

  return LoginButton;
}(_react.Component), _class.propTypes = (0, _extends3.default)({}, _Login2.default.propTypes, {
  spinnerConfig: _propTypes2.default.object.isRequired,
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  buttonClassName: _propTypes2.default.string,
  iconClassName: _propTypes2.default.string,
  icon: _propTypes2.default.bool,
  spinnerClassName: _propTypes2.default.string,
  spinner: _propTypes2.default.bool
}), _class.defaultProps = (0, _extends3.default)({}, _Login2.default.defaultProps, {
  spinnerConfig: {},
  buttonClassName: 'btn btn-lg',
  iconClassName: 'fa fa-facebook pull-left',
  spinner: true,
  icon: true
}), _temp);
exports.default = LoginButton;
//# sourceMappingURL=LoginButton.js.map

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = MessageUs;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Parser = __webpack_require__(51);

var _Parser2 = _interopRequireDefault(_Parser);

var _MessengerSize = __webpack_require__(157);

var _MessengerSize2 = _interopRequireDefault(_MessengerSize);

var _MessengerColor = __webpack_require__(156);

var _MessengerColor2 = _interopRequireDefault(_MessengerColor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function MessageUs(props) {
  var className = props.className,
      color = props.color,
      appId = props.appId,
      pageId = props.pageId,
      children = props.children,
      dataRef = props.dataRef,
      size = props.size,
      onParse = props.onParse;


  return _react2.default.createElement(
    _Parser2.default,
    { className: className, onParse: onParse },
    _react2.default.createElement(
      'div',
      {
        className: 'fb-messengermessageus',
        messenger_app_id: appId,
        page_id: pageId,
        'data-color': color,
        'data-size': size,
        'data-ref': dataRef
      },
      children
    )
  );
}

MessageUs.propTypes = {
  className: _propTypes2.default.string,
  appId: _propTypes2.default.string.isRequired,
  pageId: _propTypes2.default.string.isRequired,
  color: _propTypes2.default.string,
  children: _propTypes2.default.node,
  size: _propTypes2.default.string,
  dataRef: _propTypes2.default.string,
  onParse: _propTypes2.default.func
};

MessageUs.defaultProps = {
  color: _MessengerColor2.default.BLUE,
  size: _MessengerSize2.default.STANDARD,
  dataRef: undefined,
  children: undefined,
  className: undefined,
  onParse: undefined
};
//# sourceMappingURL=MessageUs.js.map

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = MessengerCheckbox;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Parser = __webpack_require__(51);

var _Parser2 = _interopRequireDefault(_Parser);

var _MessengerSize = __webpack_require__(157);

var _MessengerSize2 = _interopRequireDefault(_MessengerSize);

var _MessengerColor = __webpack_require__(156);

var _MessengerColor2 = _interopRequireDefault(_MessengerColor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function MessengerCheckbox(props) {
  var className = props.className,
      origin = props.origin,
      prechecked = props.prechecked,
      allowLogin = props.allowLogin,
      userRef = props.userRef,
      color = props.color,
      appId = props.appId,
      pageId = props.pageId,
      children = props.children,
      size = props.size,
      onParse = props.onParse;


  return _react2.default.createElement(
    _Parser2.default,
    { className: className, onParse: onParse },
    _react2.default.createElement(
      'div',
      {
        className: 'fb-messenger-checkbox',
        messenger_app_id: appId,
        page_id: pageId,
        'data-color': color,
        'data-size': size,
        'data-origin': origin,
        user_ref: userRef,
        prechecked: prechecked,
        allow_login: allowLogin
      },
      children
    )
  );
}

MessengerCheckbox.propTypes = {
  className: _propTypes2.default.string,
  appId: _propTypes2.default.string.isRequired,
  pageId: _propTypes2.default.string.isRequired,
  color: _propTypes2.default.string,
  userRef: _propTypes2.default.string,
  origin: _propTypes2.default.string.isRequired,
  children: _propTypes2.default.node,
  size: _propTypes2.default.string,
  prechecked: _propTypes2.default.bool,
  allowLogin: _propTypes2.default.bool,
  onParse: _propTypes2.default.func
};

MessengerCheckbox.defaultProps = {
  color: _MessengerColor2.default.BLUE,
  size: _MessengerSize2.default.STANDARD,
  allowLogin: true,
  prechecked: false,
  userRef: undefined,
  children: undefined,
  className: undefined,
  onParse: undefined
};
//# sourceMappingURL=MessengerCheckbox.js.map

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = Page;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Parser = __webpack_require__(51);

var _Parser2 = _interopRequireDefault(_Parser);

var _getCurrentHref = __webpack_require__(101);

var _getCurrentHref2 = _interopRequireDefault(_getCurrentHref);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Page(props) {
  var className = props.className,
      style = props.style,
      _props$href = props.href,
      href = _props$href === undefined ? (0, _getCurrentHref2.default)() : _props$href,
      tabs = props.tabs,
      hideCover = props.hideCover,
      width = props.width,
      height = props.height,
      showFacepile = props.showFacepile,
      hideCTA = props.hideCTA,
      smallHeader = props.smallHeader,
      adaptContainerWidth = props.adaptContainerWidth,
      children = props.children,
      onParse = props.onParse;


  return _react2.default.createElement(
    _Parser2.default,
    { className: className, onParse: onParse },
    _react2.default.createElement(
      'div',
      {
        className: 'fb-page',
        style: style,
        'data-tabs': tabs,
        'data-hide-cover': hideCover,
        'data-show-facepile': showFacepile,
        'data-hide-cta': hideCTA,
        'data-href': href,
        'data-small-header': smallHeader,
        'data-adapt-container-width': adaptContainerWidth,
        'data-height': height,
        'data-width': width
      },
      children
    )
  );
}

Page.propTypes = {
  className: _propTypes2.default.string,
  href: _propTypes2.default.string.isRequired,
  tabs: _propTypes2.default.string,
  hideCover: _propTypes2.default.bool,
  height: _propTypes2.default.oneOfType([_propTypes2.default.number.isRequired, _propTypes2.default.string.isRequired]),
  width: _propTypes2.default.oneOfType([_propTypes2.default.number.isRequired, _propTypes2.default.string.isRequired]),
  showFacepile: _propTypes2.default.bool,
  hideCTA: _propTypes2.default.bool,
  smallHeader: _propTypes2.default.bool,
  adaptContainerWidth: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  onParse: _propTypes2.default.func
};

Page.defaultProps = {
  width: 340,
  height: 500,
  tabs: 'timeline',
  hideCover: false,
  showFacepile: true,
  hideCTA: false,
  smallHeader: false,
  adaptContainerWidth: true,
  children: undefined,
  className: undefined,
  onParse: undefined
};
//# sourceMappingURL=Page.js.map

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = SendToMessenger;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Parser = __webpack_require__(51);

var _Parser2 = _interopRequireDefault(_Parser);

var _MessengerSize = __webpack_require__(157);

var _MessengerSize2 = _interopRequireDefault(_MessengerSize);

var _MessengerColor = __webpack_require__(156);

var _MessengerColor2 = _interopRequireDefault(_MessengerColor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SendToMessenger(props) {
  var className = props.className,
      color = props.color,
      appId = props.appId,
      pageId = props.pageId,
      children = props.children,
      dataRef = props.dataRef,
      size = props.size,
      onParse = props.onParse;


  return _react2.default.createElement(
    _Parser2.default,
    { className: className, onParse: onParse },
    _react2.default.createElement(
      'div',
      {
        className: 'fb-send-to-messenger',
        messenger_app_id: appId,
        page_id: pageId,
        'data-color': color,
        'data-size': size,
        'data-ref': dataRef
      },
      children
    )
  );
}

SendToMessenger.propTypes = {
  className: _propTypes2.default.string,
  appId: _propTypes2.default.string.isRequired,
  pageId: _propTypes2.default.string.isRequired,
  color: _propTypes2.default.string,
  children: _propTypes2.default.node,
  dataRef: _propTypes2.default.string,
  size: _propTypes2.default.string,
  onParse: _propTypes2.default.func
};

SendToMessenger.defaultProps = {
  color: _MessengerColor2.default.BLUE,
  size: _MessengerSize2.default.STANDARD,
  dataRef: undefined,
  children: undefined,
  className: undefined,
  onParse: undefined
};
//# sourceMappingURL=SendToMessenger.js.map

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(92);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(239);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = ShareButton;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Share = __webpack_require__(332);

var _Share2 = _interopRequireDefault(_Share);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ShareButton(props) {
  var className = props.className,
      iconClassName = props.iconClassName,
      icon = props.icon,
      children = props.children,
      rest = (0, _objectWithoutProperties3.default)(props, ['className', 'iconClassName', 'icon', 'children']);


  return _react2.default.createElement(_Share2.default, (0, _extends3.default)({}, rest, {
    render: function render(_ref) {
      var isReady = _ref.isReady,
          onClick = _ref.onClick;
      return _react2.default.createElement(
        'button',
        {
          type: 'button',
          disabled: !isReady,
          className: className,
          onClick: onClick
        },
        !!icon && _react2.default.createElement('i', { className: iconClassName }),
        children
      );
    }
  }));
}

ShareButton.propTypes = (0, _extends3.default)({}, _Share2.default.propTypes, {
  className: _propTypes2.default.string,
  iconClassName: _propTypes2.default.string,
  icon: _propTypes2.default.bool
});

ShareButton.defaultProps = (0, _extends3.default)({}, _Share2.default.defaultProps, {
  className: 'btn btn-lg',
  iconClassName: 'fa fa-facebook pull-left',
  icon: true
});
//# sourceMappingURL=ShareButton.js.map

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.MessengerColor = exports.MessengerSize = exports.CommentsOrderBy = exports.LikeAction = exports.ColorScheme = exports.LikeLayout = exports.LikeSize = exports.SendToMessenger = exports.MessengerCheckbox = exports.MessageUs = exports.CustomChat = exports.Feed = exports.CommentsCount = exports.Comments = exports.EmbeddedPost = exports.LoginButton = exports.Login = exports.Page = exports.ShareButton = exports.Share = exports.Like = exports.InitFacebook = exports.Parser = exports.FacebookProvider = exports.default = undefined;

var _FacebookProvider2 = __webpack_require__(772);

var _FacebookProvider3 = _interopRequireDefault(_FacebookProvider2);

var _Parser2 = __webpack_require__(51);

var _Parser3 = _interopRequireDefault(_Parser2);

var _InitFacebook2 = __webpack_require__(222);

var _InitFacebook3 = _interopRequireDefault(_InitFacebook2);

var _Like2 = __webpack_require__(774);

var _Like3 = _interopRequireDefault(_Like2);

var _Share2 = __webpack_require__(332);

var _Share3 = _interopRequireDefault(_Share2);

var _ShareButton2 = __webpack_require__(780);

var _ShareButton3 = _interopRequireDefault(_ShareButton2);

var _Page2 = __webpack_require__(778);

var _Page3 = _interopRequireDefault(_Page2);

var _Login2 = __webpack_require__(331);

var _Login3 = _interopRequireDefault(_Login2);

var _LoginButton2 = __webpack_require__(775);

var _LoginButton3 = _interopRequireDefault(_LoginButton2);

var _EmbeddedPost2 = __webpack_require__(770);

var _EmbeddedPost3 = _interopRequireDefault(_EmbeddedPost2);

var _Comments2 = __webpack_require__(767);

var _Comments3 = _interopRequireDefault(_Comments2);

var _CommentsCount2 = __webpack_require__(768);

var _CommentsCount3 = _interopRequireDefault(_CommentsCount2);

var _Feed2 = __webpack_require__(773);

var _Feed3 = _interopRequireDefault(_Feed2);

var _CustomChat2 = __webpack_require__(769);

var _CustomChat3 = _interopRequireDefault(_CustomChat2);

var _MessageUs2 = __webpack_require__(776);

var _MessageUs3 = _interopRequireDefault(_MessageUs2);

var _MessengerCheckbox2 = __webpack_require__(777);

var _MessengerCheckbox3 = _interopRequireDefault(_MessengerCheckbox2);

var _SendToMessenger2 = __webpack_require__(779);

var _SendToMessenger3 = _interopRequireDefault(_SendToMessenger2);

var _LikeSize2 = __webpack_require__(336);

var _LikeSize3 = _interopRequireDefault(_LikeSize2);

var _LikeLayout2 = __webpack_require__(335);

var _LikeLayout3 = _interopRequireDefault(_LikeLayout2);

var _ColorScheme2 = __webpack_require__(224);

var _ColorScheme3 = _interopRequireDefault(_ColorScheme2);

var _LikeAction2 = __webpack_require__(334);

var _LikeAction3 = _interopRequireDefault(_LikeAction2);

var _CommentsOrderBy2 = __webpack_require__(333);

var _CommentsOrderBy3 = _interopRequireDefault(_CommentsOrderBy2);

var _MessengerSize2 = __webpack_require__(157);

var _MessengerSize3 = _interopRequireDefault(_MessengerSize2);

var _MessengerColor2 = __webpack_require__(156);

var _MessengerColor3 = _interopRequireDefault(_MessengerColor2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FacebookProvider3.default;
exports.FacebookProvider = _FacebookProvider3.default;
exports.Parser = _Parser3.default;
exports.InitFacebook = _InitFacebook3.default;
exports.Like = _Like3.default;
exports.Share = _Share3.default;
exports.ShareButton = _ShareButton3.default;
exports.Page = _Page3.default;
exports.Login = _Login3.default;
exports.LoginButton = _LoginButton3.default;
exports.EmbeddedPost = _EmbeddedPost3.default;
exports.Comments = _Comments3.default;
exports.CommentsCount = _CommentsCount3.default;
exports.Feed = _Feed3.default;
exports.CustomChat = _CustomChat3.default;
exports.MessageUs = _MessageUs3.default;
exports.MessengerCheckbox = _MessengerCheckbox3.default;
exports.SendToMessenger = _SendToMessenger3.default;
exports.LikeSize = _LikeSize3.default;
exports.LikeLayout = _LikeLayout3.default;
exports.ColorScheme = _ColorScheme3.default;
exports.LikeAction = _LikeAction3.default;
exports.CommentsOrderBy = _CommentsOrderBy3.default;
exports.MessengerSize = _MessengerSize3.default;
exports.MessengerColor = _MessengerColor3.default;
//# sourceMappingURL=index.js.map

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/* eslint-env browser */

/**
 * This is the web browser implementation of `debug()`.
 */
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = localstorage();
/**
 * Colors.
 */

exports.colors = ['#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC', '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF', '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC', '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF', '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC', '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033', '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366', '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933', '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC', '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF', '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'];
/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */
// eslint-disable-next-line complexity

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && (window.process.type === 'renderer' || window.process.__nwjs)) {
    return true;
  } // Internet Explorer and Edge do not support colors.


  if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
    return false;
  } // Is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632


  return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
  typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
  // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
  typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
  typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}
/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */


function formatArgs(args) {
  args[0] = (this.useColors ? '%c' : '') + this.namespace + (this.useColors ? ' %c' : ' ') + args[0] + (this.useColors ? '%c ' : ' ') + '+' + module.exports.humanize(this.diff);

  if (!this.useColors) {
    return;
  }

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit'); // The final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into

  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function (match) {
    if (match === '%%') {
      return;
    }

    index++;

    if (match === '%c') {
      // We only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });
  args.splice(lastC, 0, c);
}
/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */


function log() {
  var _console;

  // This hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return (typeof console === "undefined" ? "undefined" : _typeof(console)) === 'object' && console.log && (_console = console).log.apply(_console, arguments);
}
/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */


function save(namespaces) {
  try {
    if (namespaces) {
      exports.storage.setItem('debug', namespaces);
    } else {
      exports.storage.removeItem('debug');
    }
  } catch (error) {// Swallow
    // XXX (@Qix-) should we be logging these?
  }
}
/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */


function load() {
  var r;

  try {
    r = exports.storage.getItem('debug');
  } catch (error) {} // Swallow
  // XXX (@Qix-) should we be logging these?
  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG


  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = __webpack_require__.i({"NODE_ENV":"production"}).DEBUG;
  }

  return r;
}
/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */


function localstorage() {
  try {
    // TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
    // The Browser also has localStorage in the global context.
    return localStorage;
  } catch (error) {// Swallow
    // XXX (@Qix-) should we be logging these?
  }
}

module.exports = __webpack_require__(783)(exports);
var formatters = module.exports.formatters;
/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

formatters.j = function (v) {
  try {
    return JSON.stringify(v);
  } catch (error) {
    return '[UnexpectedJSONParseError]: ' + error.message;
  }
};


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(87)))

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 */
function setup(env) {
  createDebug.debug = createDebug;
  createDebug.default = createDebug;
  createDebug.coerce = coerce;
  createDebug.disable = disable;
  createDebug.enable = enable;
  createDebug.enabled = enabled;
  createDebug.humanize = __webpack_require__(784);
  Object.keys(env).forEach(function (key) {
    createDebug[key] = env[key];
  });
  /**
  * Active `debug` instances.
  */

  createDebug.instances = [];
  /**
  * The currently active debug mode names, and names to skip.
  */

  createDebug.names = [];
  createDebug.skips = [];
  /**
  * Map of special "%n" handling functions, for the debug "format" argument.
  *
  * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
  */

  createDebug.formatters = {};
  /**
  * Selects a color for a debug namespace
  * @param {String} namespace The namespace string for the for the debug instance to be colored
  * @return {Number|String} An ANSI color code for the given namespace
  * @api private
  */

  function selectColor(namespace) {
    var hash = 0;

    for (var i = 0; i < namespace.length; i++) {
      hash = (hash << 5) - hash + namespace.charCodeAt(i);
      hash |= 0; // Convert to 32bit integer
    }

    return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
  }

  createDebug.selectColor = selectColor;
  /**
  * Create a debugger with the given `namespace`.
  *
  * @param {String} namespace
  * @return {Function}
  * @api public
  */

  function createDebug(namespace) {
    var prevTime;

    function debug() {
      // Disabled?
      if (!debug.enabled) {
        return;
      }

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var self = debug; // Set `diff` timestamp

      var curr = Number(new Date());
      var ms = curr - (prevTime || curr);
      self.diff = ms;
      self.prev = prevTime;
      self.curr = curr;
      prevTime = curr;
      args[0] = createDebug.coerce(args[0]);

      if (typeof args[0] !== 'string') {
        // Anything else let's inspect with %O
        args.unshift('%O');
      } // Apply any `formatters` transformations


      var index = 0;
      args[0] = args[0].replace(/%([a-zA-Z%])/g, function (match, format) {
        // If we encounter an escaped % then don't increase the array index
        if (match === '%%') {
          return match;
        }

        index++;
        var formatter = createDebug.formatters[format];

        if (typeof formatter === 'function') {
          var val = args[index];
          match = formatter.call(self, val); // Now we need to remove `args[index]` since it's inlined in the `format`

          args.splice(index, 1);
          index--;
        }

        return match;
      }); // Apply env-specific formatting (colors, etc.)

      createDebug.formatArgs.call(self, args);
      var logFn = self.log || createDebug.log;
      logFn.apply(self, args);
    }

    debug.namespace = namespace;
    debug.enabled = createDebug.enabled(namespace);
    debug.useColors = createDebug.useColors();
    debug.color = selectColor(namespace);
    debug.destroy = destroy;
    debug.extend = extend; // Debug.formatArgs = formatArgs;
    // debug.rawLog = rawLog;
    // env-specific initialization logic for debug instances

    if (typeof createDebug.init === 'function') {
      createDebug.init(debug);
    }

    createDebug.instances.push(debug);
    return debug;
  }

  function destroy() {
    var index = createDebug.instances.indexOf(this);

    if (index !== -1) {
      createDebug.instances.splice(index, 1);
      return true;
    }

    return false;
  }

  function extend(namespace, delimiter) {
    return createDebug(this.namespace + (typeof delimiter === 'undefined' ? ':' : delimiter) + namespace);
  }
  /**
  * Enables a debug mode by namespaces. This can include modes
  * separated by a colon and wildcards.
  *
  * @param {String} namespaces
  * @api public
  */


  function enable(namespaces) {
    createDebug.save(namespaces);
    createDebug.names = [];
    createDebug.skips = [];
    var i;
    var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
    var len = split.length;

    for (i = 0; i < len; i++) {
      if (!split[i]) {
        // ignore empty strings
        continue;
      }

      namespaces = split[i].replace(/\*/g, '.*?');

      if (namespaces[0] === '-') {
        createDebug.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
      } else {
        createDebug.names.push(new RegExp('^' + namespaces + '$'));
      }
    }

    for (i = 0; i < createDebug.instances.length; i++) {
      var instance = createDebug.instances[i];
      instance.enabled = createDebug.enabled(instance.namespace);
    }
  }
  /**
  * Disable debug output.
  *
  * @api public
  */


  function disable() {
    createDebug.enable('');
  }
  /**
  * Returns true if the given mode name is enabled, false otherwise.
  *
  * @param {String} name
  * @return {Boolean}
  * @api public
  */


  function enabled(name) {
    if (name[name.length - 1] === '*') {
      return true;
    }

    var i;
    var len;

    for (i = 0, len = createDebug.skips.length; i < len; i++) {
      if (createDebug.skips[i].test(name)) {
        return false;
      }
    }

    for (i = 0, len = createDebug.names.length; i < len; i++) {
      if (createDebug.names[i].test(name)) {
        return true;
      }
    }

    return false;
  }
  /**
  * Coerce `val`.
  *
  * @param {Mixed} val
  * @return {Mixed}
  * @api private
  */


  function coerce(val) {
    if (val instanceof Error) {
      return val.stack || val.message;
    }

    return val;
  }

  createDebug.enable(createDebug.load());
  return createDebug;
}

module.exports = setup;



/***/ }),
/* 784 */
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var w = d * 7;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function (val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isFinite(val)) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'weeks':
    case 'week':
    case 'w':
      return n * w;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (msAbs >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (msAbs >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (msAbs >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return plural(ms, msAbs, d, 'day');
  }
  if (msAbs >= h) {
    return plural(ms, msAbs, h, 'hour');
  }
  if (msAbs >= m) {
    return plural(ms, msAbs, m, 'minute');
  }
  if (msAbs >= s) {
    return plural(ms, msAbs, s, 'second');
  }
  return ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, msAbs, n, name) {
  var isPlural = msAbs >= n * 1.5;
  return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
}


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);
var ReactDOM = __webpack_require__(150);
var DOMFactories = __webpack_require__(304);
var PropTypes = __webpack_require__(8);
var ExecutionEnvironment = __webpack_require__(674);
var ModalPortal = React.createFactory(__webpack_require__(786));
var ariaAppHider = __webpack_require__(787);
var refCount = __webpack_require__(789);
var elementClass = __webpack_require__(673);
var renderSubtreeIntoContainer = __webpack_require__(150).unstable_renderSubtreeIntoContainer;
var Assign = __webpack_require__(339);
var createReactClass = __webpack_require__(44);

var SafeHTMLElement = ExecutionEnvironment.canUseDOM ? window.HTMLElement : {};
var AppElement = ExecutionEnvironment.canUseDOM ? document.body : {appendChild: function() {}};

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = createReactClass({

  displayName: 'Modal',
  statics: {
    setAppElement: function(element) {
        AppElement = ariaAppHider.setElement(element);
    },
    injectCSS: function() {
      "production" !== "production"
        && console.warn('React-Modal: injectCSS has been deprecated ' +
                        'and no longer has any effect. It will be removed in a later version');
    }
  },

  propTypes: {
    isOpen: PropTypes.bool.isRequired,
    style: PropTypes.shape({
      content: PropTypes.object,
      overlay: PropTypes.object
    }),
    portalClassName: PropTypes.string,
    bodyOpenClassName: PropTypes.string,
    appElement: PropTypes.instanceOf(SafeHTMLElement),
    onAfterOpen: PropTypes.func,
    onRequestClose: PropTypes.func,
    closeTimeoutMS: PropTypes.number,
    ariaHideApp: PropTypes.bool,
    shouldCloseOnOverlayClick: PropTypes.bool,
    parentSelector: PropTypes.func,
    role: PropTypes.string,
    contentLabel: PropTypes.string.isRequired
  },

  getDefaultProps: function () {
    return {
      isOpen: false,
      portalClassName: 'ReactModalPortal',
      bodyOpenClassName: 'ReactModal__Body--open',
      ariaHideApp: true,
      closeTimeoutMS: 0,
      shouldCloseOnOverlayClick: true,
      parentSelector: function () { return document.body; }
    };
  },

  componentDidMount: function() {
    this.node = document.createElement('div');
    this.node.className = this.props.portalClassName;

    if (this.props.isOpen) refCount.add(this);

    var parent = getParentElement(this.props.parentSelector);
    parent.appendChild(this.node);
    this.renderPortal(this.props);
  },

  componentWillUpdate: function(newProps) {
    if(newProps.portalClassName !== this.props.portalClassName) {
      this.node.className = newProps.portalClassName;
    }
  },

  componentWillReceiveProps: function(newProps) {
    if (newProps.isOpen) refCount.add(this);
    if (!newProps.isOpen) refCount.remove(this);
    var currentParent = getParentElement(this.props.parentSelector);
    var newParent = getParentElement(newProps.parentSelector);

    if(newParent !== currentParent) {
      currentParent.removeChild(this.node);
      newParent.appendChild(this.node);
    }

    this.renderPortal(newProps);
  },

  componentWillUnmount: function() {
    if (!this.node) return;

    refCount.remove(this);

    if (this.props.ariaHideApp) {
      ariaAppHider.show(this.props.appElement);
    }

    var state = this.portal.state;
    var now = Date.now();
    var closesAt = state.isOpen && this.props.closeTimeoutMS
      && (state.closesAt
        || now + this.props.closeTimeoutMS);

    if (closesAt) {
      if (!state.beforeClose) {
        this.portal.closeWithTimeout();
      }

      var that = this;
      setTimeout(function() { that.removePortal(); }, closesAt - now);
    } else {
      this.removePortal();
    }
  },

  removePortal: function() {
    ReactDOM.unmountComponentAtNode(this.node);
    var parent = getParentElement(this.props.parentSelector);
    parent.removeChild(this.node);

    if (refCount.count() === 0) {
      elementClass(document.body).remove(this.props.bodyOpenClassName);
    }
  },

  renderPortal: function(props) {
    if (props.isOpen || refCount.count() > 0) {
      elementClass(document.body).add(this.props.bodyOpenClassName);
    } else {
      elementClass(document.body).remove(this.props.bodyOpenClassName);
    }

    if (props.ariaHideApp) {
      ariaAppHider.toggle(props.isOpen, props.appElement);
    }

    this.portal = renderSubtreeIntoContainer(this, ModalPortal(Assign({}, props, {defaultStyles: Modal.defaultStyles})), this.node);
  },

  render: function () {
    return DOMFactories.noscript();
  }
});

Modal.defaultStyles = {
  overlay: {
    position        : 'fixed',
    top             : 0,
    left            : 0,
    right           : 0,
    bottom          : 0,
    backgroundColor : 'rgba(255, 255, 255, 0.75)'
  },
  content: {
    position                : 'absolute',
    top                     : '40px',
    left                    : '40px',
    right                   : '40px',
    bottom                  : '40px',
    border                  : '1px solid #ccc',
    background              : '#fff',
    overflow                : 'auto',
    WebkitOverflowScrolling : 'touch',
    borderRadius            : '4px',
    outline                 : 'none',
    padding                 : '20px'
  }
}

module.exports = Modal


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);
var DOMFactories = __webpack_require__(304);
var focusManager = __webpack_require__(788);
var scopeTab = __webpack_require__(790);
var Assign = __webpack_require__(339);
var createReactClass = __webpack_require__(44);

var div = DOMFactories.div;

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: 'ReactModal__Overlay',
  content: 'ReactModal__Content'
};

var ModalPortal = module.exports = createReactClass({

  displayName: 'ModalPortal',
  shouldClose: null,

  getDefaultProps: function() {
    return {
      style: {
        overlay: {},
        content: {}
      }
    };
  },

  getInitialState: function() {
    return {
      afterOpen: false,
      beforeClose: false
    };
  },

  componentDidMount: function() {
    // Focus needs to be set when mounting and already open
    if (this.props.isOpen) {
      this.setFocusAfterRender(true);
      this.open();
    }
  },

  componentWillUnmount: function() {
    clearTimeout(this.closeTimer);
  },

  componentWillReceiveProps: function(newProps) {
    // Focus only needs to be set once when the modal is being opened
    if (!this.props.isOpen && newProps.isOpen) {
      this.setFocusAfterRender(true);
      this.open();
    } else if (this.props.isOpen && !newProps.isOpen) {
      this.close();
    }
  },

  componentDidUpdate: function () {
    if (this.focusAfterRender) {
      this.focusContent();
      this.setFocusAfterRender(false);
    }
  },

  setFocusAfterRender: function (focus) {
    this.focusAfterRender = focus;
  },

  afterClose: function () {
    focusManager.returnFocus();
    focusManager.teardownScopedFocus();
  },

  open: function () {
    if (this.state.afterOpen && this.state.beforeClose) {
      clearTimeout(this.closeTimer);
      this.setState({ beforeClose: false });
    } else {
      focusManager.setupScopedFocus(this.node);
      focusManager.markForFocusLater();
      this.setState({isOpen: true}, function() {
        this.setState({afterOpen: true});

        if (this.props.isOpen && this.props.onAfterOpen) {
          this.props.onAfterOpen();
        }
      }.bind(this));
    }
  },

  close: function() {
    if (this.props.closeTimeoutMS > 0)
      this.closeWithTimeout();
    else
      this.closeWithoutTimeout();
  },

  focusContent: function() {
    // Don't steal focus from inner elements
    if (!this.contentHasFocus()) {
      this.refs.content.focus();
    }
  },

  closeWithTimeout: function() {
    var closesAt = Date.now() + this.props.closeTimeoutMS;
    this.setState({beforeClose: true, closesAt: closesAt}, function() {
      this.closeTimer = setTimeout(this.closeWithoutTimeout, this.state.closesAt - Date.now());
    }.bind(this));
  },

  closeWithoutTimeout: function() {
    this.setState({
      beforeClose: false,
      isOpen: false,
      afterOpen: false,
      closesAt: null
    }, this.afterClose);
  },

  handleKeyDown: function(event) {
    if (event.keyCode == 9 /*tab*/) scopeTab(this.refs.content, event);
    if (event.keyCode == 27 /*esc*/) {
      event.preventDefault();
      this.requestClose(event);
    }
  },

  handleOverlayOnClick: function (event) {
    if (this.shouldClose === null) {
      this.shouldClose = true;
    }

    if (this.shouldClose && this.props.shouldCloseOnOverlayClick) {
      if (this.ownerHandlesClose())
        this.requestClose(event);
      else
        this.focusContent();
    }
    this.shouldClose = null;
  },

  handleContentOnClick: function () {
    this.shouldClose = false;
  },

  requestClose: function(event) {
    if (this.ownerHandlesClose())
      this.props.onRequestClose(event);
  },

  ownerHandlesClose: function() {
    return this.props.onRequestClose;
  },

  shouldBeClosed: function() {
    return !this.state.isOpen && !this.state.beforeClose;
  },

  contentHasFocus: function() {
    return document.activeElement === this.refs.content || this.refs.content.contains(document.activeElement);
  },

  buildClassName: function(which, additional) {
    var classNames = (typeof additional === 'object') ? additional : {
      base: CLASS_NAMES[which],
      afterOpen: CLASS_NAMES[which] + "--after-open",
      beforeClose: CLASS_NAMES[which] + "--before-close"
    };
    var className = classNames.base;
    if (this.state.afterOpen) { className += " " + classNames.afterOpen; }
    if (this.state.beforeClose) { className += " " + classNames.beforeClose; }
    return (typeof additional === 'string' && additional) ? [className, additional].join(" ") : className;
  },

  render: function() {
    var contentStyles = (this.props.className) ? {} : this.props.defaultStyles.content;
    var overlayStyles = (this.props.overlayClassName) ? {} : this.props.defaultStyles.overlay;

    return this.shouldBeClosed() ? div() : (
      div({
        ref: "overlay",
        className: this.buildClassName('overlay', this.props.overlayClassName),
        style: Assign({}, overlayStyles, this.props.style.overlay || {}),
        onClick: this.handleOverlayOnClick
      },
        div({
          ref: "content",
          style: Assign({}, contentStyles, this.props.style.content || {}),
          className: this.buildClassName('content', this.props.className),
          tabIndex: "-1",
          onKeyDown: this.handleKeyDown,
          onClick: this.handleContentOnClick,
          role: this.props.role,
          "aria-label": this.props.contentLabel
        },
          this.props.children
        )
      )
    );
  }
});


/***/ }),
/* 787 */
/***/ (function(module, exports) {

var _element = typeof document !== 'undefined' ? document.body : null;

function setElement(element) {
  if (typeof element === 'string') {
    var el = document.querySelectorAll(element);
    element = 'length' in el ? el[0] : el;
  }
  _element = element || _element;
  return _element;
}

function hide(appElement) {
  validateElement(appElement);
  (appElement || _element).setAttribute('aria-hidden', 'true');
}

function show(appElement) {
  validateElement(appElement);
  (appElement || _element).removeAttribute('aria-hidden');
}

function toggle(shouldHide, appElement) {
  if (shouldHide)
    hide(appElement);
  else
    show(appElement);
}

function validateElement(appElement) {
  if (!appElement && !_element)
    throw new Error('react-modal: You must set an element with `Modal.setAppElement(el)` to make this accessible');
}

function resetForTesting() {
  _element = document.body;
}

exports.toggle = toggle;
exports.setElement = setElement;
exports.show = show;
exports.hide = hide;
exports.resetForTesting = resetForTesting;


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

var findTabbable = __webpack_require__(338);
var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

function handleBlur(event) {
  needToFocus = true;
}

function handleFocus(event) {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function() {
      if (modalElement.contains(document.activeElement))
        return;
      var el = (findTabbable(modalElement)[0] || modalElement);
      el.focus();
    }, 0);
  }
}

exports.markForFocusLater = function() {
  focusLaterElements.push(document.activeElement);
};

exports.returnFocus = function() {
  var toFocus = null;
  try {
    toFocus = focusLaterElements.pop();
    toFocus.focus();
    return;
  }
  catch (e) {
    console.warn('You tried to return focus to '+toFocus+' but it is not in the DOM anymore');
  }
};

exports.setupScopedFocus = function(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener('blur', handleBlur, false);
    document.addEventListener('focus', handleFocus, true);
  } else {
    window.attachEvent('onBlur', handleBlur);
    document.attachEvent('onFocus', handleFocus);
  }
};

exports.teardownScopedFocus = function() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener('blur', handleBlur);
    document.removeEventListener('focus', handleFocus);
  } else {
    window.detachEvent('onBlur', handleBlur);
    document.detachEvent('onFocus', handleFocus);
  }
};


/***/ }),
/* 789 */
/***/ (function(module, exports) {

var modals = [];

module.exports = {
  add: function (element) {
    if (modals.indexOf(element) === -1) {
      modals.push(element);
    }
  },
  remove: function (element) {
    var index = modals.indexOf(element);
    if (index === -1) {
      return;
    }
    modals.splice(index, 1);
  },
  count: function () {
    return modals.length;
  }
};


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

var findTabbable = __webpack_require__(338);

module.exports = function(node, event) {
  var tabbable = findTabbable(node);
  if (!tabbable.length) {
      event.preventDefault();
      return;
  }
  var finalTabbable = tabbable[event.shiftKey ? 0 : tabbable.length - 1];
  var leavingFinalTabbable = (
    finalTabbable === document.activeElement ||
    // handle immediate shift+tab after opening with mouse
    node === document.activeElement
  );
  if (!leavingFinalTabbable) return;
  event.preventDefault();
  var target = tabbable[event.shiftKey ? tabbable.length - 1 : 0];
  target.focus();
};


/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(340);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/**
 * An <IndexLink> is used to link to an <IndexRoute>.
 */
var IndexLink = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'IndexLink',

  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Link__["a" /* default */], _extends({}, this.props, { onlyActiveOnIndex: true }));
  }
});

/* unused harmony default export */ var _unused_webpack_default_export = (IndexLink);

/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redirect__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(123);







/**
 * An <IndexRedirect> is used to redirect from an indexRoute.
 */
/* eslint-disable react/require-render-return */
var IndexRedirect = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'IndexRedirect',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = __WEBPACK_IMPORTED_MODULE_4__Redirect__["a" /* default */].createRouteFromReactElement(element);
      } else {
         false ? warning(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    to: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"].isRequired,
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    onEnter: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;
  }
});

/* unused harmony default export */ var _unused_webpack_default_export = (IndexRedirect);

/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(123);







/**
 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
 * a JSX route config.
 */
/* eslint-disable react/require-render-return */
var IndexRoute = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'IndexRoute',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["c" /* createRouteFromReactElement */])(element);
      } else {
         false ? warning(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    component: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["a" /* component */],
    components: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["b" /* components */],
    getComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
    getComponents: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (IndexRoute);

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RouteUtils__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__ = __webpack_require__(123);






/**
 * A <Route> is used to declare which components are rendered to the
 * page when the URL matches a given pattern.
 *
 * Routes are arranged in a nested tree structure. When a new URL is
 * requested, the tree is searched depth-first to find a route whose
 * path matches the URL.  When one is found, all routes in the tree
 * that lead to it are considered "active" and their components are
 * rendered into the DOM, nested in the same order as in the tree.
 */
/* eslint-disable react/require-render-return */
var Route = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'Route',

  statics: {
    createRouteFromReactElement: __WEBPACK_IMPORTED_MODULE_3__RouteUtils__["c" /* createRouteFromReactElement */]
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
    component: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["a" /* component */],
    components: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["b" /* components */],
    getComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
    getComponents: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<Route> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RouterContext__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RouteUtils__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RouterUtils__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__routerWarning__ = __webpack_require__(103);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }













var propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"],
  children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["d" /* routes */],
  routes: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["d" /* routes */], // alias for children
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  createElement: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onError: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onUpdate: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],

  // PRIVATE: For client-side rehydration of server match.
  matchContext: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"]
};

var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef !== 'undefined';

/**
 * A <Router> is a high-level API for automatically setting up
 * a router that renders a <RouterContext> with all the props
 * it needs each time the URL changes.
 */
var Router = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'Router',

  propTypes: propTypes,

  getDefaultProps: function getDefaultProps() {
    return {
      render: function render(props) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__RouterContext__["a" /* default */], props);
      }
    };
  },
  getInitialState: function getInitialState() {
    return {
      location: null,
      routes: null,
      params: null,
      components: null
    };
  },
  handleError: function handleError(error) {
    if (this.props.onError) {
      this.props.onError.call(this, error);
    } else {
      // Throw errors by default so we don't silently swallow them!
      throw error; // This error probably occurred in getChildRoutes or getComponents.
    }
  },
  createRouterObject: function createRouterObject(state) {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.router;
    }

    var history = this.props.history;

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__RouterUtils__["a" /* createRouterObject */])(history, this.transitionManager, state);
  },
  createTransitionManager: function createTransitionManager() {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.transitionManager;
    }

    var history = this.props.history;
    var _props = this.props,
        routes = _props.routes,
        children = _props.children;


    !history.getCurrentLocation ?  false ? invariant(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])(history, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__RouteUtils__["b" /* createRoutes */])(routes || children));
  },


  // this method will be updated to UNSAFE_componentWillMount below for React versions >= 16.3
  componentWillMount: function componentWillMount() {
    var _this = this;

    this.transitionManager = this.createTransitionManager();
    this.router = this.createRouterObject(this.state);

    this._unlisten = this.transitionManager.listen(function (error, state) {
      if (error) {
        _this.handleError(error);
      } else {
        // Keep the identity of this.router because of a caveat in ContextUtils:
        // they only work if the object identity is preserved.
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__RouterUtils__["b" /* assignRouterState */])(_this.router, state);
        _this.setState(state, _this.props.onUpdate);
      }
    });
  },


  // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
  /* istanbul ignore next: sanity check */
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
     false ? warning(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;

     false ? warning((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this._unlisten) this._unlisten();
  },
  render: function render() {
    var _state = this.state,
        location = _state.location,
        routes = _state.routes,
        params = _state.params,
        components = _state.components;

    var _props2 = this.props,
        createElement = _props2.createElement,
        render = _props2.render,
        props = _objectWithoutProperties(_props2, ['createElement', 'render']);

    if (location == null) return null; // Async match

    // Only forward non-Router-specific props to routing context, as those are
    // the only ones that might be custom routing context props.
    Object.keys(propTypes).forEach(function (propType) {
      return delete props[propType];
    });

    return render(_extends({}, props, {
      router: this.router,
      location: location,
      routes: routes,
      params: params,
      components: components,
      createElement: createElement
    }));
  }
});

if (prefixUnsafeLifecycleMethods) {
  Router.prototype.UNSAFE_componentWillReceiveProps = Router.prototype.componentWillReceiveProps;
  Router.prototype.UNSAFE_componentWillMount = Router.prototype.componentWillMount;
  delete Router.prototype.componentWillReceiveProps;
  delete Router.prototype.componentWillMount;
}

/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTransitionUtils;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(226);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var PendingHooks = function PendingHooks() {
  var _this = this;

  _classCallCheck(this, PendingHooks);

  this.hooks = [];

  this.add = function (hook) {
    return _this.hooks.push(hook);
  };

  this.remove = function (hook) {
    return _this.hooks = _this.hooks.filter(function (h) {
      return h !== hook;
    });
  };

  this.has = function (hook) {
    return _this.hooks.indexOf(hook) !== -1;
  };

  this.clear = function () {
    return _this.hooks = [];
  };
};

function getTransitionUtils() {
  var enterHooks = new PendingHooks();
  var changeHooks = new PendingHooks();

  function createTransitionHook(hook, route, asyncArity, pendingHooks) {
    var isSync = hook.length < asyncArity;

    var transitionHook = function transitionHook() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      hook.apply(route, args);

      if (isSync) {
        var callback = args[args.length - 1];
        // Assume hook executes synchronously and
        // automatically call the callback.
        callback();
      }
    };

    pendingHooks.add(transitionHook);

    return transitionHook;
  }

  function getEnterHooks(routes) {
    return routes.reduce(function (hooks, route) {
      if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
      return hooks;
    }, []);
  }

  function getChangeHooks(routes) {
    return routes.reduce(function (hooks, route) {
      if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
      return hooks;
    }, []);
  }

  function runTransitionHooks(length, iter, callback) {
    if (!length) {
      callback();
      return;
    }

    var redirectInfo = void 0;
    function replace(location) {
      redirectInfo = location;
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["b" /* loopAsync */])(length, function (index, next, done) {
      iter(index, replace, function (error) {
        if (error || redirectInfo) {
          done(error, redirectInfo); // No need to continue.
        } else {
          next();
        }
      });
    }, callback);
  }

  /**
   * Runs all onEnter hooks in the given array of routes in order
   * with onEnter(nextState, replace, callback) and calls
   * callback(error, redirectInfo) when finished. The first hook
   * to use replace short-circuits the loop.
   *
   * If a hook needs to run asynchronously, it may use the callback
   * function. However, doing so will cause the transition to pause,
   * which could lead to a non-responsive UI if the hook is slow.
   */
  function runEnterHooks(routes, nextState, callback) {
    enterHooks.clear();
    var hooks = getEnterHooks(routes);
    return runTransitionHooks(hooks.length, function (index, replace, next) {
      var wrappedNext = function wrappedNext() {
        if (enterHooks.has(hooks[index])) {
          next.apply(undefined, arguments);
          enterHooks.remove(hooks[index]);
        }
      };
      hooks[index](nextState, replace, wrappedNext);
    }, callback);
  }

  /**
   * Runs all onChange hooks in the given array of routes in order
   * with onChange(prevState, nextState, replace, callback) and calls
   * callback(error, redirectInfo) when finished. The first hook
   * to use replace short-circuits the loop.
   *
   * If a hook needs to run asynchronously, it may use the callback
   * function. However, doing so will cause the transition to pause,
   * which could lead to a non-responsive UI if the hook is slow.
   */
  function runChangeHooks(routes, state, nextState, callback) {
    changeHooks.clear();
    var hooks = getChangeHooks(routes);
    return runTransitionHooks(hooks.length, function (index, replace, next) {
      var wrappedNext = function wrappedNext() {
        if (changeHooks.has(hooks[index])) {
          next.apply(undefined, arguments);
          changeHooks.remove(hooks[index]);
        }
      };
      hooks[index](state, nextState, replace, wrappedNext);
    }, callback);
  }

  /**
   * Runs all onLeave hooks in the given array of routes in order.
   */
  function runLeaveHooks(routes, prevState) {
    for (var i = 0, len = routes.length; i < len; ++i) {
      if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
    }
  }

  return {
    runEnterHooks: runEnterHooks,
    runChangeHooks: runChangeHooks,
    runLeaveHooks: runLeaveHooks
  };
}

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RouterContext__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(103);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* unused harmony default export */ var _unused_webpack_default_export = (function () {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  if (false) {
    middlewares.forEach(function (middleware, index) {
      process.env.NODE_ENV !== 'production' ? warning(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
    });
  }

  var withContext = middlewares.map(function (middleware) {
    return middleware.renderRouterContext;
  }).filter(Boolean);
  var withComponent = middlewares.map(function (middleware) {
    return middleware.renderRouteComponent;
  }).filter(Boolean);

  var makeCreateElement = function makeCreateElement() {
    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"];
    return function (Component, props) {
      return withComponent.reduceRight(function (previous, renderRouteComponent) {
        return renderRouteComponent(previous, props);
      }, baseCreateElement(Component, props));
    };
  };

  return function (renderProps) {
    return withContext.reduceRight(function (previous, renderRouterContext) {
      return renderRouterContext(previous, renderProps);
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__RouterContext__["a" /* default */], _extends({}, renderProps, {
      createElement: makeCreateElement(renderProps.createElement)
    })));
  };
});

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRouterHistory__ = __webpack_require__(345);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__createRouterHistory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory___default.a));

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(102);


function routeParamsChanged(route, prevState, nextState) {
  if (!route.path) return false;

  var paramNames = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["a" /* getParamNames */])(route.path);

  return paramNames.some(function (paramName) {
    return prevState.params[paramName] !== nextState.params[paramName];
  });
}

/**
 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
 * the change from prevState to nextState. We leave routes if either
 * 1) they are not in the next state or 2) they are in the next state
 * but their params have changed (i.e. /users/123 => /users/456).
 *
 * leaveRoutes are ordered starting at the leaf route of the tree
 * we're leaving up to the common parent route. enterRoutes are ordered
 * from the top of the tree we're entering down to the leaf route.
 *
 * changeRoutes are any routes that didn't leave or enter during
 * the transition.
 */
function computeChangedRoutes(prevState, nextState) {
  var prevRoutes = prevState && prevState.routes;
  var nextRoutes = nextState.routes;

  var leaveRoutes = void 0,
      changeRoutes = void 0,
      enterRoutes = void 0;
  if (prevRoutes) {
    var parentIsLeaving = false;
    leaveRoutes = prevRoutes.filter(function (route) {
      if (parentIsLeaving) {
        return true;
      } else {
        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
        if (isLeaving) parentIsLeaving = true;
        return isLeaving;
      }
    });

    // onLeave hooks start at the leaf route.
    leaveRoutes.reverse();

    enterRoutes = [];
    changeRoutes = [];

    nextRoutes.forEach(function (route) {
      var isNew = prevRoutes.indexOf(route) === -1;
      var paramsChanged = leaveRoutes.indexOf(route) !== -1;

      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
    });
  } else {
    leaveRoutes = [];
    changeRoutes = [];
    enterRoutes = nextRoutes;
  }

  return {
    leaveRoutes: leaveRoutes,
    changeRoutes: changeRoutes,
    enterRoutes: enterRoutes
  };
}

/* harmony default export */ __webpack_exports__["a"] = (computeChangedRoutes);

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PromiseUtils__ = __webpack_require__(341);



function getComponentsForRoute(nextState, route, callback) {
  if (route.component || route.components) {
    callback(null, route.component || route.components);
    return;
  }

  var getComponent = route.getComponent || route.getComponents;
  if (getComponent) {
    var componentReturn = getComponent.call(route, nextState, callback);
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(componentReturn)) componentReturn.then(function (component) {
      return callback(null, component);
    }, callback);
  } else {
    callback();
  }
}

/**
 * Asynchronously fetches all components needed for the given router
 * state and calls callback(error, components) when finished.
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getComponents method.
 */
function getComponents(nextState, callback) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* mapAsync */])(nextState.routes, function (route, index, callback) {
    getComponentsForRoute(nextState, route, callback);
  }, callback);
}

/* harmony default export */ __webpack_exports__["a"] = (getComponents);

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(102);


/**
 * Extracts an object of params the given route cares about from
 * the given params object.
 */
function getRouteParams(route, params) {
  var routeParams = {};

  if (!route.path) return routeParams;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["a" /* getParamNames */])(route.path).forEach(function (p) {
    if (Object.prototype.hasOwnProperty.call(params, p)) {
      routeParams[p] = params[p];
    }
  });

  return routeParams;
}

/* harmony default export */ __webpack_exports__["a"] = (getRouteParams);

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRouterHistory__ = __webpack_require__(345);


/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__createRouterHistory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory___default.a));

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isActive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(102);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



function deepEqual(a, b) {
  if (a == b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return deepEqual(item, b[index]);
    });
  }

  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
    for (var p in a) {
      if (!Object.prototype.hasOwnProperty.call(a, p)) {
        continue;
      }

      if (a[p] === undefined) {
        if (b[p] !== undefined) {
          return false;
        }
      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
        return false;
      } else if (!deepEqual(a[p], b[p])) {
        return false;
      }
    }

    return true;
  }

  return String(a) === String(b);
}

/**
 * Returns true if the current pathname matches the supplied one, net of
 * leading and trailing slash normalization. This is sufficient for an
 * indexOnly route match.
 */
function pathIsActive(pathname, currentPathname) {
  // Normalize leading slash for consistency. Leading slash on pathname has
  // already been normalized in isActive. See caveat there.
  if (currentPathname.charAt(0) !== '/') {
    currentPathname = '/' + currentPathname;
  }

  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
  // `/foo` as active, but in this case, we would already have failed the
  // match.
  if (pathname.charAt(pathname.length - 1) !== '/') {
    pathname += '/';
  }
  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
    currentPathname += '/';
  }

  return currentPathname === pathname;
}

/**
 * Returns true if the given pathname matches the active routes and params.
 */
function routeIsActive(pathname, routes, params) {
  var remainingPathname = pathname,
      paramNames = [],
      paramValues = [];

  // for...of would work here but it's probably slower post-transpilation.
  for (var i = 0, len = routes.length; i < len; ++i) {
    var route = routes[i];
    var pattern = route.path || '';

    if (pattern.charAt(0) === '/') {
      remainingPathname = pathname;
      paramNames = [];
      paramValues = [];
    }

    if (remainingPathname !== null && pattern) {
      var matched = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["b" /* matchPattern */])(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }

      if (remainingPathname === '') {
        // We have an exact match on the route. Just check that all the params
        // match.
        // FIXME: This doesn't work on repeated params.
        return paramNames.every(function (paramName, index) {
          return String(paramValues[index]) === String(params[paramName]);
        });
      }
    }
  }

  return false;
}

/**
 * Returns true if all key/value pairs in the given query are
 * currently active.
 */
function queryIsActive(query, activeQuery) {
  if (activeQuery == null) return query == null;

  if (query == null) return true;

  return deepEqual(query, activeQuery);
}

/**
 * Returns true if a <Link> to the given pathname/query combination is
 * currently active.
 */
function isActive(_ref, indexOnly, currentLocation, routes, params) {
  var pathname = _ref.pathname,
      query = _ref.query;

  if (currentLocation == null) return false;

  // TODO: This is a bit ugly. It keeps around support for treating pathnames
  // without preceding slashes as absolute paths, but possibly also works
  // around the same quirks with basenames as in matchRoutes.
  if (pathname.charAt(0) !== '/') {
    pathname = '/' + pathname;
  }

  if (!pathIsActive(pathname, currentLocation.pathname)) {
    // The path check is necessary and sufficient for indexOnly, but otherwise
    // we still need to check the routes.
    if (indexOnly || !routeIsActive(pathname, routes, params)) {
      return false;
    }
  }

  return queryIsActive(query, currentLocation.query);
}

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RouterUtils__ = __webpack_require__(343);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









/**
 * A high-level API to be used for server-side rendering.
 *
 * This function matches a location to a set of routes and calls
 * callback(error, redirectLocation, renderProps) when finished.
 *
 * Note: You probably don't want to use this in a browser unless you're using
 * server-side rendering with async routes.
 */
function match(_ref, callback) {
  var history = _ref.history,
      routes = _ref.routes,
      location = _ref.location,
      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);

  !(history || location) ?  false ? invariant(false, 'match needs a history or a location') : __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false) : void 0;

  history = history ? history : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__["a" /* default */])(options);
  var transitionManager = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])(history, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(routes));

  if (location) {
    // Allow match({ location: '/the/path', ... })
    location = history.createLocation(location);
  } else {
    location = history.getCurrentLocation();
  }

  transitionManager.match(location, function (error, redirectLocation, nextState) {
    var renderProps = void 0;

    if (nextState) {
      var router = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__RouterUtils__["a" /* createRouterObject */])(history, transitionManager, nextState);
      renderProps = _extends({}, nextState, {
        router: router,
        matchContext: { transitionManager: transitionManager, router: router }
      });
    }

    callback(error, redirectLocation && history.createLocation(redirectLocation, __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__["REPLACE"]), renderProps);
  });
}

/* unused harmony default export */ var _unused_webpack_default_export = (match);

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = matchRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PromiseUtils__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PatternUtils__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routerWarning__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(68);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







function getChildRoutes(route, location, paramNames, paramValues, callback) {
  if (route.childRoutes) {
    return [null, route.childRoutes];
  }
  if (!route.getChildRoutes) {
    return [];
  }

  var sync = true,
      result = void 0;

  var partialNextState = {
    location: location,
    params: createParams(paramNames, paramValues)
  };

  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
    childRoutes = !error && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(childRoutes);
    if (sync) {
      result = [error, childRoutes];
      return;
    }

    callback(error, childRoutes);
  });

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
    return callback(null, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(childRoutes));
  }, callback);

  sync = false;
  return result; // Might be undefined.
}

function getIndexRoute(route, location, paramNames, paramValues, callback) {
  if (route.indexRoute) {
    callback(null, route.indexRoute);
  } else if (route.getIndexRoute) {
    var partialNextState = {
      location: location,
      params: createParams(paramNames, paramValues)
    };

    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
      callback(error, !error && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(indexRoute)[0]);
    });

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
      return callback(null, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(indexRoute)[0]);
    }, callback);
  } else if (route.childRoutes || route.getChildRoutes) {
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
        return;
      }

      var pathless = childRoutes.filter(function (childRoute) {
        return !childRoute.path;
      });

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["b" /* loopAsync */])(pathless.length, function (index, next, done) {
        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
          if (error || indexRoute) {
            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
            done(error, routes);
          } else {
            next();
          }
        });
      }, function (err, routes) {
        callback(null, routes);
      });
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

function assignParams(params, paramNames, paramValues) {
  return paramNames.reduce(function (params, paramName, index) {
    var paramValue = paramValues && paramValues[index];

    if (Array.isArray(params[paramName])) {
      params[paramName].push(paramValue);
    } else if (paramName in params) {
      params[paramName] = [params[paramName], paramValue];
    } else {
      params[paramName] = paramValue;
    }

    return params;
  }, params);
}

function createParams(paramNames, paramValues) {
  return assignParams({}, paramNames, paramValues);
}

function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
  var pattern = route.path || '';

  if (pattern.charAt(0) === '/') {
    remainingPathname = location.pathname;
    paramNames = [];
    paramValues = [];
  }

  // Only try to match the path if the route actually has a pattern, and if
  // we're not just searching for potential nested absolute paths.
  if (remainingPathname !== null && pattern) {
    try {
      var matched = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__PatternUtils__["b" /* matchPattern */])(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }
    } catch (error) {
      callback(error);
    }

    // By assumption, pattern is non-empty here, which is the prerequisite for
    // actually terminating a match.
    if (remainingPathname === '') {
      var match = {
        routes: [route],
        params: createParams(paramNames, paramValues)
      };

      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
        if (error) {
          callback(error);
        } else {
          if (Array.isArray(indexRoute)) {
            var _match$routes;

             false ? warning(indexRoute.every(function (route) {
              return !route.path;
            }), 'Index routes should not have paths') : void 0;
            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
          } else if (indexRoute) {
             false ? warning(!indexRoute.path, 'Index routes should not have paths') : void 0;
            match.routes.push(indexRoute);
          }

          callback(null, match);
        }
      });

      return;
    }
  }

  if (remainingPathname != null || route.childRoutes) {
    // Either a) this route matched at least some of the path or b)
    // we don't have to load this route's children asynchronously. In
    // either case continue checking for matches in the subtree.
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
      } else if (childRoutes) {
        // Check the child routes to see if any of them match.
        matchRoutes(childRoutes, location, function (error, match) {
          if (error) {
            callback(error);
          } else if (match) {
            // A child route matched! Augment the match and pass it up the stack.
            match.routes.unshift(route);
            callback(null, match);
          } else {
            callback();
          }
        }, remainingPathname, paramNames, paramValues);
      } else {
        callback();
      }
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

/**
 * Asynchronously matches the given location to a set of routes and calls
 * callback(error, state) when finished. The state object will have the
 * following properties:
 *
 * - routes       An array of routes that matched, in hierarchical order
 * - params       An object of URL parameters
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getChildRoutes method.
 */
function matchRoutes(routes, location, callback, remainingPathname) {
  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];

  if (remainingPathname === undefined) {
    // TODO: This is a little bit ugly, but it works around a quirk in history
    // that strips the leading slash from pathnames when using basenames with
    // trailing slashes.
    if (location.pathname.charAt(0) !== '/') {
      location = _extends({}, location, {
        pathname: '/' + location.pathname
      });
    }
    remainingPathname = location.pathname;
  }

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["b" /* loopAsync */])(routes.length, function (index, next, done) {
    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
      if (error || match) {
        done(error, match);
      } else {
        next();
      }
    });
  }, callback);
}

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContextUtils__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PropTypes__ = __webpack_require__(228);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function withRouter(WrappedComponent, options) {
  var withRef = options && options.withRef;

  var WithRouter = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
    displayName: 'WithRouter',

    mixins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__ContextUtils__["b" /* ContextSubscriber */])('router')],

    contextTypes: { router: __WEBPACK_IMPORTED_MODULE_5__PropTypes__["a" /* routerShape */] },
    propTypes: { router: __WEBPACK_IMPORTED_MODULE_5__PropTypes__["a" /* routerShape */] },

    getWrappedInstance: function getWrappedInstance() {
      !withRef ?  false ? invariant(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      return this.wrappedInstance;
    },
    render: function render() {
      var _this = this;

      var router = this.props.router || this.context.router;
      if (!router) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, this.props);
      }

      var params = router.params,
          location = router.location,
          routes = router.routes;

      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });

      if (withRef) {
        props.ref = function (c) {
          _this.wrappedInstance = c;
        };
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, props);
    }
  });

  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
  WithRouter.WrappedComponent = WrappedComponent;

  return __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default()(WithRouter, WrappedComponent);
}

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(807);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _spin = __webpack_require__(831);

var _spin2 = _interopRequireDefault(_spin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Spinner = function (_Component) {
  _inherits(Spinner, _Component);

  function Spinner() {
    _classCallCheck(this, Spinner);

    return _possibleConstructorReturn(this, (Spinner.__proto__ || Object.getPrototypeOf(Spinner)).apply(this, arguments));
  }

  _createClass(Spinner, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updateSpinner();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.updateSpinner();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.spinner) {
        this.spinner.stop();
        this.spinner = null;
      }
    }
  }, {
    key: 'updateSpinner',
    value: function updateSpinner() {
      var loaded = this.props.loaded;

      if (!loaded && !this.spinner) {
        this.spinner = new _spin2.default(this.props.config);
        this.spinner.spin(this.refs.loader);
      } else if (loaded && this.spinner) {
        this.spinner.stop();
        this.spinner = null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          loaded = _props.loaded,
          className = _props.className;


      if (loaded) {
        return this.props.children ? _react.Children.only(this.props.children) : null;
      }

      return _react2.default.createElement('div', { className: className, ref: 'loader' });
    }
  }]);

  return Spinner;
}(_react.Component);

Spinner.propTypes = {
  className: _propTypes2.default.string,
  config: _propTypes2.default.object.isRequired,
  loaded: _propTypes2.default.bool.isRequired,
  children: _propTypes2.default.node
};
Spinner.defaultProps = {
  config: {},
  loaded: false,
  className: 'loader'
};
exports.default = Spinner;

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @copyright © 2015, Rick Wong. All rights reserved.
 */


function assignProperty (object, key, value) {
	if (typeof object === "object") {
		object[key] = value;
	}

	return object;
}

module.exports = assignProperty;


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @copyright © 2015, Rick Wong. All rights reserved.
 */


var isRootContainer = __webpack_require__(158);
var promiseProxy    = __webpack_require__(231);
var React           = __webpack_require__(159);
var assign          = __webpack_require__(230);
var assignProperty  = __webpack_require__(810);

/**
 * @function createContainer
 * @returns {ReactClass}
 */
module.exports = function (Component, options) {
	options = arguments[1] || {};

	var Container = React.createClass({
		displayName: (Component.displayName || Component.name) + "TransmitContainer",
		propTypes: {
			variables:             React.PropTypes.object,
			onFetch:               React.PropTypes.func,
			renderLoading:         React.PropTypes.oneOfType([
				React.PropTypes.element,
				React.PropTypes.func
			])
		},
		statics: {
			isRootContainer:  !!options.initialVariables,
			variables:        options.initialVariables || {},
			prepareVariables: options.prepareVariables || function (v) { return v; },
			fragments:        options.fragments || {},
			/**
			 * @returns {Promise}
			 */
			getFragment:      function (fragmentName, variables) {
				if (!Container.fragments[fragmentName]) {
					throw new Error(Component.displayName + " has no '" + fragmentName +"' fragment")
				}

				variables = assign({}, Container.variables, variables || {});

				var promise = Container.fragments[fragmentName](variables);

				if (typeof promise === "function" && isRootContainer(Container)) {
					return promiseProxy.Promise.resolve(promise);
				}

				return promise;
			},
			/**
			 * @returns {Promise}
			 */
			getAllFragments: function (variables, optionalFragmentNames) {
				var promises = [];

				optionalFragmentNames = optionalFragmentNames || [];

				if (typeof optionalFragmentNames === "string") {
					optionalFragmentNames = [optionalFragmentNames];
				}

				Object.keys(Container.fragments).forEach(function (fragmentName) {
					if (optionalFragmentNames.length && optionalFragmentNames.indexOf(fragmentName) < 0) {
						return;
					}

					var promise = Container.getFragment(
						fragmentName, variables
					).then(function (fragmentResult) {
						return assignProperty({}, fragmentName, fragmentResult);
					});

					promises.push(promise);
				});

				if (!promises.length) {
					promises.push(promiseProxy.Promise.resolve(true));
				}

				return promiseProxy.Promise.all(
					promises
				).then(function (fetchedFragments) {
					return assign.apply(null, fetchedFragments);
				});
			},
			getComponent: function () {
				return Component;
			}
		},
		componentDidMount: function () {
			// Keep track of the mounted state manually, because the official isMounted() method
			// returns true when using renderToString() from react-dom/server.
			this._mounted = true;

			if (isRootContainer(Container)) {
				var promise = this.fetching || Promise.resolve(null);
				var _this = this;

				promise.then(function () {
					var deferredFragments = _this.missingFragments(false);

					if (deferredFragments.length) {
						_this.forceFetch({}, deferredFragments);
					}
				});
			}
		},
		componentWillUnmount: function () {
			this._mounted = false;
		},
		_isMounted: function () {
			// See the official `isMounted` discussion at https://github.com/facebook/react/issues/2787
			return !!this._mounted;
		},
		/**
		 * @returns {Promise|Boolean}
		 */
		forceFetch: function (nextVariables, optionalFragmentNames, skipDeferred) {
			var _this = this;
			nextVariables = nextVariables || {};

			if (!isRootContainer(Container)) {
				throw new Error("Only root Transmit Containers should fetch fragments");
			}

			if (options.shouldContainerUpdate && Object.keys(nextVariables).length) {
				if (!options.shouldContainerUpdate.call(this, nextVariables)) {
					return false;
				}
			}

			assign(_this.variables, nextVariables);
			var fetchPromise = Container.getAllFragments(_this.variables, optionalFragmentNames);

			fetchPromise.then(function (fetchedFragments) {
				var deferredFragments = {};

				Object.keys(fetchedFragments).forEach(function (key) {
					if (typeof fetchedFragments[key] !== "function") {
						return;
					}

					if (skipDeferred) {
						// Set deferred fragment to null so component will be rendered.
						fetchedFragments[key] = null;
					}
					else {
						// Remember and then delete the deferred fragment.
						assignProperty(deferredFragments, key, fetchedFragments[key]);
						delete fetchedFragments[key];
					}
				});

				_this.safeguardedSetState(fetchedFragments);

				if (!skipDeferred) {
					Object.keys(deferredFragments).forEach(function (key) {
						var fetchPromise = deferredFragments[key]().then(function (deferredFragment) {
							var fetchedDeferred = assignProperty({}, key, deferredFragment);

							_this.safeguardedSetState(fetchedDeferred);

							return fetchedDeferred;
						});

						_this.callOnFetchHandler(fetchPromise);
					});
				}

				return fetchedFragments;
			});

			_this.callOnFetchHandler(fetchPromise);

			return fetchPromise;
		},
		callOnFetchHandler: function (fetchPromise) {
			if (this.props && this.props.onFetch) {
				this.props.onFetch.call(this, fetchPromise);
			}
		},
		safeguardedSetState: function (stateChanges) {
			if (!this._isMounted()) {
				return;
			}

			if (!Object.keys(stateChanges).length) {
				return;
			}

			try {
				this.setState(stateChanges);
			}
			catch (error) {
				// Call to setState may fail if renderToString() was used.
				if (!error.message || !error.message.match(/^document/)) {
					throw error;
				}
			}
		},
		/**
		 * @returns {Array} Names of fragments with missing data.
		 */
		missingFragments: function (nullAllowed) {
			var state = this.state || {};
			var props = this.props || {};

			if (!Object.keys(Container.fragments).length) {
				return [];
			}

			var missing = [];

			for (var fragmentName in Container.fragments) {
				if (!Container.fragments.hasOwnProperty(fragmentName) ||
					props.hasOwnProperty(fragmentName) ||
					state.hasOwnProperty(fragmentName)) {
					if (nullAllowed) {
						continue;
					}

					if (props[fragmentName] || state[fragmentName]) {
						continue;
					}
				}

				missing.push(fragmentName);
			}

			return missing;
		},
		/**
		 */
		componentWillMount: function () {
			var externalVariables = this.props && this.props.variables || {};

			this.variables = assign({}, Container.variables, externalVariables);
			this.variables = Container.prepareVariables(this.variables);

			if (isRootContainer(Container)) {
				var missingFragments = this.missingFragments(true);

				if (missingFragments.length) {
					var _this = this;
					this.fetching = this.forceFetch({}, missingFragments, true).then(function () {
						_this.fetching = false;
					});
				}
				else {
					this.callOnFetchHandler(promiseProxy.Promise.resolve({}));
				}
			}
		},
		/**
		 *
		 */
		componentWillReceiveProps: function (nextProps) {
			if (isRootContainer(Container)) {
				this.forceFetch(nextProps.variables);
			}
		},
		/**
		 * @returns {ReactElement} or null
		 */
		render: function () {
			var state     = this.state || {};
			var props     = this.props || {};
			var transmit  = {
				variables:  this.variables,
				forceFetch: this.forceFetch,
				onFetch:    undefined
			};

			// Don't render without data.
			if (this.missingFragments(true).length) {
				return (typeof props.renderLoading === "function") ?
					props.renderLoading() : props.renderLoading || null;
			}

			return React.createElement(
				Component,
				assign({}, props, state, {transmit: transmit})
			);
		}
	});

	return Container;
};


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * NOTE: This file is copied from `react-async`. Thanks Andrey Popp!
 *
 * @see https://github.com/andreypopp/react-async
 */


var asciiJSON = __webpack_require__(361);

/**
 * Inject data and optional client scripts into markup.
 *
 * @param {String} markup
 * @param {Object} data
 * @param {?Array} scripts
 */
function injectIntoMarkup(markup, data, scripts) {
	var escapedJson = asciiJSON.stringify(data).replace(/<\//g, '<\\/');
	var injected = '<script>window.__reactTransmitPacket=' + escapedJson + '</script>';

	if (scripts) {
		injected += scripts.map(function(script) {
			return '<script src="' + script + '"></script>';
		}).join('');
	}

	if (markup.indexOf('</body>') > -1) {
		return markup.replace('</body>', injected + '$&');
	} else {
		return markup + injected;
	}
}

module.exports = injectIntoMarkup;


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @copyright © 2015, Rick Wong. All rights reserved.
 */


module.exports = __webpack_require__(766);


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @copyright © 2015, Rick Wong. All rights reserved.
 */


module.exports = __webpack_require__(150);


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @copyright © 2015, Rick Wong. All rights reserved.
 */


var assign                = __webpack_require__(230);
var isRootContainer       = __webpack_require__(158);
var overrideCreateElement = __webpack_require__(349);
var React                 = __webpack_require__(159);
var ReactDOM              = __webpack_require__(814);
var takeFromMarkup        = __webpack_require__(350);

var reactData = takeFromMarkup();

/**
 * @function render
 */
module.exports = function (Component, props, targetDOMNode, callback) {
	var fetchedFragments = reactData;

	overrideCreateElement(
		function (originalCreateElement, type, props, children) {
			var args = [].slice.call(arguments, 1);

			if (isRootContainer(type) && fetchedFragments.length) {
				assign(props, fetchedFragments.pop());
			}

			return originalCreateElement.apply(null, args);
		},
		function () {
			assign(props, {createElement: React.createElement});
			ReactDOM.render(React.createElement(Component, props), targetDOMNode, callback);
		}
	);
};


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @copyright © 2015, Rick Wong. All rights reserved.
 */


var assign                = __webpack_require__(230);
var isRootContainer       = __webpack_require__(158);
var overrideCreateElement = __webpack_require__(349);
var promiseProxy          = __webpack_require__(231);
var React                 = __webpack_require__(159);
var ReactDOM              = __webpack_require__(813);

/**
 * @function renderToString
 */
module.exports = function (Component, props) {
	props = props || {};

	return new promiseProxy.Promise(function (resolve, reject) {
		var promises = [];
		var myProps  = assign({}, props);

		var reactString;

		overrideCreateElement(
			function (originalCreateElement, type, props, children) {
				var args = [].slice.call(arguments, 1);

				if (isRootContainer(type)) {
					props.onFetch = function (promise) {
						promises.push(promise);
					};
				}

				return originalCreateElement.apply(null, args);
			},
			function () {
				assign(myProps, {createElement: React.createElement});
				reactString = ReactDOM.renderToString(React.createElement(Component, myProps));
			}
		);

		if (!promises.length) {
			resolve({reactString: reactString, reactData: []});
		}
		else {
			promiseProxy.Promise.all(promises).then(function (fetchedFragments) {
				var reactString;
				var reactData = fetchedFragments.slice(0);

				overrideCreateElement(
					function (originalCreateElement, type, props, children) {
						var args = [].slice.call(arguments, 1);

						if (isRootContainer(type) && fetchedFragments.length) {
							assign(props, fetchedFragments.pop());
						}

						return originalCreateElement.apply(null, args);
					},
					function () {
						assign(myProps, {createElement: React.createElement});
						reactString = ReactDOM.renderToString(React.createElement(Component, myProps));
					}
				);

				resolve({
					reactString: reactString,
					reactData:   reactData
				});
			}).catch(function (error) {
				reject(error);
			});
		}
	});
};


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(124);

var invariant = __webpack_require__(3);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var PooledClass = __webpack_require__(818);
var ReactElement = __webpack_require__(104);

var emptyFunction = __webpack_require__(50);
var traverseAllChildren = __webpack_require__(828);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactElement = __webpack_require__(104);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(104),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(302);

module.exports = factory(isValidElement);

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.7.0';


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(351),
    Component = _require.Component;

var _require2 = __webpack_require__(104),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(354);
var factory = __webpack_require__(295);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var nextDebugID = 1;

function getNextDebugID() {
  return nextDebugID++;
}

module.exports = getNextDebugID;

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var _prodInvariant = __webpack_require__(124);

var ReactElement = __webpack_require__(104);

var invariant = __webpack_require__(3);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(124);

var ReactCurrentOwner = __webpack_require__(57);
var REACT_ELEMENT_TYPE = __webpack_require__(353);

var getIteratorFn = __webpack_require__(824);
var invariant = __webpack_require__(3);
var KeyEscapeUtils = __webpack_require__(817);
var warning = __webpack_require__(10);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(105)))

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(105), __webpack_require__(87)))

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Copyright (c) 2011-2014 Felix Gnass
 * Licensed under the MIT license
 * http://spin.js.org/
 *
 * Example:
    var opts = {
      lines: 12             // The number of lines to draw
    , length: 7             // The length of each line
    , width: 5              // The line thickness
    , radius: 10            // The radius of the inner circle
    , scale: 1.0            // Scales overall size of the spinner
    , corners: 1            // Roundness (0..1)
    , color: '#000'         // #rgb or #rrggbb
    , opacity: 1/4          // Opacity of the lines
    , rotate: 0             // Rotation offset
    , direction: 1          // 1: clockwise, -1: counterclockwise
    , speed: 1              // Rounds per second
    , trail: 100            // Afterglow percentage
    , fps: 20               // Frames per second when using setTimeout()
    , zIndex: 2e9           // Use a high z-index by default
    , className: 'spinner'  // CSS class to assign to the element
    , top: '50%'            // center vertically
    , left: '50%'           // center horizontally
    , shadow: false         // Whether to render a shadow
    , hwaccel: false        // Whether to use hardware acceleration (might be buggy)
    , position: 'absolute'  // Element positioning
    }
    var target = document.getElementById('foo')
    var spinner = new Spinner(opts).spin(target)
 */
;(function (root, factory) {

  /* CommonJS */
  if (typeof module == 'object' && module.exports) module.exports = factory()

  /* AMD module */
  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))

  /* Browser global */
  else root.Spinner = factory()
}(this, function () {
  "use strict"

  var prefixes = ['webkit', 'Moz', 'ms', 'O'] /* Vendor prefixes */
    , animations = {} /* Animation rules keyed by their name */
    , useCssAnimations /* Whether to use CSS animations or setTimeout */
    , sheet /* A stylesheet to hold the @keyframe or VML rules. */

  /**
   * Utility function to create elements. If no tag name is given,
   * a DIV is created. Optionally properties can be passed.
   */
  function createEl (tag, prop) {
    var el = document.createElement(tag || 'div')
      , n

    for (n in prop) el[n] = prop[n]
    return el
  }

  /**
   * Appends children and returns the parent.
   */
  function ins (parent /* child1, child2, ...*/) {
    for (var i = 1, n = arguments.length; i < n; i++) {
      parent.appendChild(arguments[i])
    }

    return parent
  }

  /**
   * Creates an opacity keyframe animation rule and returns its name.
   * Since most mobile Webkits have timing issues with animation-delay,
   * we create separate rules for each line/segment.
   */
  function addAnimation (alpha, trail, i, lines) {
    var name = ['opacity', trail, ~~(alpha * 100), i, lines].join('-')
      , start = 0.01 + i/lines * 100
      , z = Math.max(1 - (1-alpha) / trail * (100-start), alpha)
      , prefix = useCssAnimations.substring(0, useCssAnimations.indexOf('Animation')).toLowerCase()
      , pre = prefix && '-' + prefix + '-' || ''

    if (!animations[name]) {
      sheet.insertRule(
        '@' + pre + 'keyframes ' + name + '{' +
        '0%{opacity:' + z + '}' +
        start + '%{opacity:' + alpha + '}' +
        (start+0.01) + '%{opacity:1}' +
        (start+trail) % 100 + '%{opacity:' + alpha + '}' +
        '100%{opacity:' + z + '}' +
        '}', sheet.cssRules.length)

      animations[name] = 1
    }

    return name
  }

  /**
   * Tries various vendor prefixes and returns the first supported property.
   */
  function vendor (el, prop) {
    var s = el.style
      , pp
      , i

    prop = prop.charAt(0).toUpperCase() + prop.slice(1)
    if (s[prop] !== undefined) return prop
    for (i = 0; i < prefixes.length; i++) {
      pp = prefixes[i]+prop
      if (s[pp] !== undefined) return pp
    }
  }

  /**
   * Sets multiple style properties at once.
   */
  function css (el, prop) {
    for (var n in prop) {
      el.style[vendor(el, n) || n] = prop[n]
    }

    return el
  }

  /**
   * Fills in default values.
   */
  function merge (obj) {
    for (var i = 1; i < arguments.length; i++) {
      var def = arguments[i]
      for (var n in def) {
        if (obj[n] === undefined) obj[n] = def[n]
      }
    }
    return obj
  }

  /**
   * Returns the line color from the given string or array.
   */
  function getColor (color, idx) {
    return typeof color == 'string' ? color : color[idx % color.length]
  }

  // Built-in defaults

  var defaults = {
    lines: 12             // The number of lines to draw
  , length: 7             // The length of each line
  , width: 5              // The line thickness
  , radius: 10            // The radius of the inner circle
  , scale: 1.0            // Scales overall size of the spinner
  , corners: 1            // Roundness (0..1)
  , color: '#000'         // #rgb or #rrggbb
  , opacity: 1/4          // Opacity of the lines
  , rotate: 0             // Rotation offset
  , direction: 1          // 1: clockwise, -1: counterclockwise
  , speed: 1              // Rounds per second
  , trail: 100            // Afterglow percentage
  , fps: 20               // Frames per second when using setTimeout()
  , zIndex: 2e9           // Use a high z-index by default
  , className: 'spinner'  // CSS class to assign to the element
  , top: '50%'            // center vertically
  , left: '50%'           // center horizontally
  , shadow: false         // Whether to render a shadow
  , hwaccel: false        // Whether to use hardware acceleration (might be buggy)
  , position: 'absolute'  // Element positioning
  }

  /** The constructor */
  function Spinner (o) {
    this.opts = merge(o || {}, Spinner.defaults, defaults)
  }

  // Global defaults that override the built-ins:
  Spinner.defaults = {}

  merge(Spinner.prototype, {
    /**
     * Adds the spinner to the given target element. If this instance is already
     * spinning, it is automatically removed from its previous target b calling
     * stop() internally.
     */
    spin: function (target) {
      this.stop()

      var self = this
        , o = self.opts
        , el = self.el = createEl(null, {className: o.className})

      css(el, {
        position: o.position
      , width: 0
      , zIndex: o.zIndex
      , left: o.left
      , top: o.top
      })

      if (target) {
        target.insertBefore(el, target.firstChild || null)
      }

      el.setAttribute('role', 'progressbar')
      self.lines(el, self.opts)

      if (!useCssAnimations) {
        // No CSS animation support, use setTimeout() instead
        var i = 0
          , start = (o.lines - 1) * (1 - o.direction) / 2
          , alpha
          , fps = o.fps
          , f = fps / o.speed
          , ostep = (1 - o.opacity) / (f * o.trail / 100)
          , astep = f / o.lines

        ;(function anim () {
          i++
          for (var j = 0; j < o.lines; j++) {
            alpha = Math.max(1 - (i + (o.lines - j) * astep) % f * ostep, o.opacity)

            self.opacity(el, j * o.direction + start, alpha, o)
          }
          self.timeout = self.el && setTimeout(anim, ~~(1000 / fps))
        })()
      }
      return self
    }

    /**
     * Stops and removes the Spinner.
     */
  , stop: function () {
      var el = this.el
      if (el) {
        clearTimeout(this.timeout)
        if (el.parentNode) el.parentNode.removeChild(el)
        this.el = undefined
      }
      return this
    }

    /**
     * Internal method that draws the individual lines. Will be overwritten
     * in VML fallback mode below.
     */
  , lines: function (el, o) {
      var i = 0
        , start = (o.lines - 1) * (1 - o.direction) / 2
        , seg

      function fill (color, shadow) {
        return css(createEl(), {
          position: 'absolute'
        , width: o.scale * (o.length + o.width) + 'px'
        , height: o.scale * o.width + 'px'
        , background: color
        , boxShadow: shadow
        , transformOrigin: 'left'
        , transform: 'rotate(' + ~~(360/o.lines*i + o.rotate) + 'deg) translate(' + o.scale*o.radius + 'px' + ',0)'
        , borderRadius: (o.corners * o.scale * o.width >> 1) + 'px'
        })
      }

      for (; i < o.lines; i++) {
        seg = css(createEl(), {
          position: 'absolute'
        , top: 1 + ~(o.scale * o.width / 2) + 'px'
        , transform: o.hwaccel ? 'translate3d(0,0,0)' : ''
        , opacity: o.opacity
        , animation: useCssAnimations && addAnimation(o.opacity, o.trail, start + i * o.direction, o.lines) + ' ' + 1 / o.speed + 's linear infinite'
        })

        if (o.shadow) ins(seg, css(fill('#000', '0 0 4px #000'), {top: '2px'}))
        ins(el, ins(seg, fill(getColor(o.color, i), '0 0 1px rgba(0,0,0,.1)')))
      }
      return el
    }

    /**
     * Internal method that adjusts the opacity of a single line.
     * Will be overwritten in VML fallback mode below.
     */
  , opacity: function (el, i, val) {
      if (i < el.childNodes.length) el.childNodes[i].style.opacity = val
    }

  })


  function initVML () {

    /* Utility function to create a VML tag */
    function vml (tag, attr) {
      return createEl('<' + tag + ' xmlns="urn:schemas-microsoft.com:vml" class="spin-vml">', attr)
    }

    // No CSS transforms but VML support, add a CSS rule for VML elements:
    sheet.addRule('.spin-vml', 'behavior:url(#default#VML)')

    Spinner.prototype.lines = function (el, o) {
      var r = o.scale * (o.length + o.width)
        , s = o.scale * 2 * r

      function grp () {
        return css(
          vml('group', {
            coordsize: s + ' ' + s
          , coordorigin: -r + ' ' + -r
          })
        , { width: s, height: s }
        )
      }

      var margin = -(o.width + o.length) * o.scale * 2 + 'px'
        , g = css(grp(), {position: 'absolute', top: margin, left: margin})
        , i

      function seg (i, dx, filter) {
        ins(
          g
        , ins(
            css(grp(), {rotation: 360 / o.lines * i + 'deg', left: ~~dx})
          , ins(
              css(
                vml('roundrect', {arcsize: o.corners})
              , { width: r
                , height: o.scale * o.width
                , left: o.scale * o.radius
                , top: -o.scale * o.width >> 1
                , filter: filter
                }
              )
            , vml('fill', {color: getColor(o.color, i), opacity: o.opacity})
            , vml('stroke', {opacity: 0}) // transparent stroke to fix color bleeding upon opacity change
            )
          )
        )
      }

      if (o.shadow)
        for (i = 1; i <= o.lines; i++) {
          seg(i, -2, 'progid:DXImageTransform.Microsoft.Blur(pixelradius=2,makeshadow=1,shadowopacity=.3)')
        }

      for (i = 1; i <= o.lines; i++) seg(i)
      return ins(el, g)
    }

    Spinner.prototype.opacity = function (el, i, val, o) {
      var c = el.firstChild
      o = o.shadow && o.lines || 0
      if (c && i + o < c.childNodes.length) {
        c = c.childNodes[i + o]; c = c && c.firstChild; c = c && c.firstChild
        if (c) c.opacity = val
      }
    }
  }

  if (typeof document !== 'undefined') {
    sheet = (function () {
      var el = createEl('style', {type : 'text/css'})
      ins(document.getElementsByTagName('head')[0], el)
      return el.sheet || el.styleSheet
    }())

    var probe = css(createEl('group'), {behavior: 'url(#default#VML)'})

    if (!vendor(probe, 'transform') && probe.adj) initVML()
    else useCssAnimations = vendor(probe, 'animation')
  }

  return Spinner

}));


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(651);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(18)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/postcss-loader/index.js!./App.css", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/postcss-loader/index.js!./App.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(652);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(18)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./GuaGi.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./GuaGi.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(653);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(18)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./HuatIm.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./HuatIm.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(654);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(18)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./IapKha.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./IapKha.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(655);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(18)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./Su.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./Su.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(656);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(18)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./ToLam.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./ToLam.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(657);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(18)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./KuahPau.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./KuahPau.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(658);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(18)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./Tshue.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./Tshue.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(659);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(18)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./漢字臺羅一詞.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./漢字臺羅一詞.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(660);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(18)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./顯示例句一句.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./顯示例句一句.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(661);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(18)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./分享鍵.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./分享鍵.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(662);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(18)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./複製連結鍵.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./複製連結鍵.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(663);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(18)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./Iong.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./Iong.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(664);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(18)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./Kong.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./Kong.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(665);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(18)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./其他建議.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./其他建議.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(667);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(18)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./The.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./The.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(668);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(18)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./抱去摸.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./抱去摸.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(669);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(18)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./名姓.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./名姓.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(670);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(18)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./台語寶鑑.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./台語寶鑑.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(671);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(18)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./金融尬台語.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./金融尬台語.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 853 */
/***/ (function(module, exports) {

function Agent() {
  this._defaults = [];
}

["use", "on", "once", "set", "query", "type", "accept", "auth", "withCredentials", "sortQuery", "retry", "ok", "redirects",
 "timeout", "buffer", "serialize", "parse", "ca", "key", "pfx", "cert"].forEach(function(fn) {
  /** Default setting for all requests from this agent */
  Agent.prototype[fn] = function(/*varargs*/) {
    this._defaults.push({fn:fn, arguments:arguments});
    return this;
  }
});

Agent.prototype._setDefaults = function(req) {
    this._defaults.forEach(function(def) {
      req[def.fn].apply(req, def.arguments);
    });
};

module.exports = Agent;


/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Module of mixed-in functions shared between node and client code
 */
var isObject = __webpack_require__(357);

/**
 * Expose `RequestBase`.
 */

module.exports = RequestBase;

/**
 * Initialize a new `RequestBase`.
 *
 * @api public
 */

function RequestBase(obj) {
  if (obj) return mixin(obj);
}

/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in RequestBase.prototype) {
    obj[key] = RequestBase.prototype[key];
  }
  return obj;
}

/**
 * Clear previous timeout.
 *
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.clearTimeout = function _clearTimeout(){
  clearTimeout(this._timer);
  clearTimeout(this._responseTimeoutTimer);
  delete this._timer;
  delete this._responseTimeoutTimer;
  return this;
};

/**
 * Override default response body parser
 *
 * This function will be called to convert incoming data into request.body
 *
 * @param {Function}
 * @api public
 */

RequestBase.prototype.parse = function parse(fn){
  this._parser = fn;
  return this;
};

/**
 * Set format of binary response body.
 * In browser valid formats are 'blob' and 'arraybuffer',
 * which return Blob and ArrayBuffer, respectively.
 *
 * In Node all values result in Buffer.
 *
 * Examples:
 *
 *      req.get('/')
 *        .responseType('blob')
 *        .end(callback);
 *
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.responseType = function(val){
  this._responseType = val;
  return this;
};

/**
 * Override default request body serializer
 *
 * This function will be called to convert data set via .send or .attach into payload to send
 *
 * @param {Function}
 * @api public
 */

RequestBase.prototype.serialize = function serialize(fn){
  this._serializer = fn;
  return this;
};

/**
 * Set timeouts.
 *
 * - response timeout is time between sending request and receiving the first byte of the response. Includes DNS and connection time.
 * - deadline is the time from start of the request to receiving response body in full. If the deadline is too short large files may not load at all on slow connections.
 *
 * Value of 0 or false means no timeout.
 *
 * @param {Number|Object} ms or {response, deadline}
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.timeout = function timeout(options){
  if (!options || 'object' !== typeof options) {
    this._timeout = options;
    this._responseTimeout = 0;
    return this;
  }

  for(var option in options) {
    switch(option) {
      case 'deadline':
        this._timeout = options.deadline;
        break;
      case 'response':
        this._responseTimeout = options.response;
        break;
      default:
        console.warn("Unknown timeout option", option);
    }
  }
  return this;
};

/**
 * Set number of retry attempts on error.
 *
 * Failed requests will be retried 'count' times if timeout or err.code >= 500.
 *
 * @param {Number} count
 * @param {Function} [fn]
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.retry = function retry(count, fn){
  // Default to 1 if no count passed or true
  if (arguments.length === 0 || count === true) count = 1;
  if (count <= 0) count = 0;
  this._maxRetries = count;
  this._retries = 0;
  this._retryCallback = fn;
  return this;
};

var ERROR_CODES = [
  'ECONNRESET',
  'ETIMEDOUT',
  'EADDRINFO',
  'ESOCKETTIMEDOUT'
];

/**
 * Determine if a request should be retried.
 * (Borrowed from segmentio/superagent-retry)
 *
 * @param {Error} err
 * @param {Response} [res]
 * @returns {Boolean}
 */
RequestBase.prototype._shouldRetry = function(err, res) {
  if (!this._maxRetries || this._retries++ >= this._maxRetries) {
    return false;
  }
  if (this._retryCallback) {
    try {
      var override = this._retryCallback(err, res);
      if (override === true) return true;
      if (override === false) return false;
      // undefined falls back to defaults
    } catch(e) {
      console.error(e);
    }
  }
  if (res && res.status && res.status >= 500 && res.status != 501) return true;
  if (err) {
    if (err.code && ~ERROR_CODES.indexOf(err.code)) return true;
    // Superagent timeout
    if (err.timeout && err.code == 'ECONNABORTED') return true;
    if (err.crossDomain) return true;
  }
  return false;
};

/**
 * Retry request
 *
 * @return {Request} for chaining
 * @api private
 */

RequestBase.prototype._retry = function() {

  this.clearTimeout();

  // node
  if (this.req) {
    this.req = null;
    this.req = this.request();
  }

  this._aborted = false;
  this.timedout = false;

  return this._end();
};

/**
 * Promise support
 *
 * @param {Function} resolve
 * @param {Function} [reject]
 * @return {Request}
 */

RequestBase.prototype.then = function then(resolve, reject) {
  if (!this._fullfilledPromise) {
    var self = this;
    if (this._endCalled) {
      console.warn("Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises");
    }
    this._fullfilledPromise = new Promise(function(innerResolve, innerReject) {
      self.end(function(err, res) {
        if (err) innerReject(err);
        else innerResolve(res);
      });
    });
  }
  return this._fullfilledPromise.then(resolve, reject);
};

RequestBase.prototype['catch'] = function(cb) {
  return this.then(undefined, cb);
};

/**
 * Allow for extension
 */

RequestBase.prototype.use = function use(fn) {
  fn(this);
  return this;
};

RequestBase.prototype.ok = function(cb) {
  if ('function' !== typeof cb) throw Error("Callback required");
  this._okCallback = cb;
  return this;
};

RequestBase.prototype._isResponseOK = function(res) {
  if (!res) {
    return false;
  }

  if (this._okCallback) {
    return this._okCallback(res);
  }

  return res.status >= 200 && res.status < 300;
};

/**
 * Get request header `field`.
 * Case-insensitive.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

RequestBase.prototype.get = function(field){
  return this._header[field.toLowerCase()];
};

/**
 * Get case-insensitive header `field` value.
 * This is a deprecated internal API. Use `.get(field)` instead.
 *
 * (getHeader is no longer used internally by the superagent code base)
 *
 * @param {String} field
 * @return {String}
 * @api private
 * @deprecated
 */

RequestBase.prototype.getHeader = RequestBase.prototype.get;

/**
 * Set header `field` to `val`, or multiple fields with one object.
 * Case-insensitive.
 *
 * Examples:
 *
 *      req.get('/')
 *        .set('Accept', 'application/json')
 *        .set('X-API-Key', 'foobar')
 *        .end(callback);
 *
 *      req.get('/')
 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
 *        .end(callback);
 *
 * @param {String|Object} field
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.set = function(field, val){
  if (isObject(field)) {
    for (var key in field) {
      this.set(key, field[key]);
    }
    return this;
  }
  this._header[field.toLowerCase()] = val;
  this.header[field] = val;
  return this;
};

/**
 * Remove header `field`.
 * Case-insensitive.
 *
 * Example:
 *
 *      req.get('/')
 *        .unset('User-Agent')
 *        .end(callback);
 *
 * @param {String} field
 */
RequestBase.prototype.unset = function(field){
  delete this._header[field.toLowerCase()];
  delete this.header[field];
  return this;
};

/**
 * Write the field `name` and `val`, or multiple fields with one object
 * for "multipart/form-data" request bodies.
 *
 * ``` js
 * request.post('/upload')
 *   .field('foo', 'bar')
 *   .end(callback);
 *
 * request.post('/upload')
 *   .field({ foo: 'bar', baz: 'qux' })
 *   .end(callback);
 * ```
 *
 * @param {String|Object} name
 * @param {String|Blob|File|Buffer|fs.ReadStream} val
 * @return {Request} for chaining
 * @api public
 */
RequestBase.prototype.field = function(name, val) {
  // name should be either a string or an object.
  if (null === name || undefined === name) {
    throw new Error('.field(name, val) name can not be empty');
  }

  if (this._data) {
    console.error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");
  }

  if (isObject(name)) {
    for (var key in name) {
      this.field(key, name[key]);
    }
    return this;
  }

  if (Array.isArray(val)) {
    for (var i in val) {
      this.field(name, val[i]);
    }
    return this;
  }

  // val should be defined now
  if (null === val || undefined === val) {
    throw new Error('.field(name, val) val can not be empty');
  }
  if ('boolean' === typeof val) {
    val = '' + val;
  }
  this._getFormData().append(name, val);
  return this;
};

/**
 * Abort the request, and clear potential timeout.
 *
 * @return {Request}
 * @api public
 */
RequestBase.prototype.abort = function(){
  if (this._aborted) {
    return this;
  }
  this._aborted = true;
  this.xhr && this.xhr.abort(); // browser
  this.req && this.req.abort(); // node
  this.clearTimeout();
  this.emit('abort');
  return this;
};

RequestBase.prototype._auth = function(user, pass, options, base64Encoder) {
  switch (options.type) {
    case 'basic':
      this.set('Authorization', 'Basic ' + base64Encoder(user + ':' + pass));
      break;

    case 'auto':
      this.username = user;
      this.password = pass;
      break;

    case 'bearer': // usage would be .auth(accessToken, { type: 'bearer' })
      this.set('Authorization', 'Bearer ' + user);
      break;
  }
  return this;
};

/**
 * Enable transmission of cookies with x-domain requests.
 *
 * Note that for this to work the origin must not be
 * using "Access-Control-Allow-Origin" with a wildcard,
 * and also must set "Access-Control-Allow-Credentials"
 * to "true".
 *
 * @api public
 */

RequestBase.prototype.withCredentials = function(on) {
  // This is browser-only functionality. Node side is no-op.
  if (on == undefined) on = true;
  this._withCredentials = on;
  return this;
};

/**
 * Set the max redirects to `n`. Does noting in browser XHR implementation.
 *
 * @param {Number} n
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.redirects = function(n){
  this._maxRedirects = n;
  return this;
};

/**
 * Maximum size of buffered response body, in bytes. Counts uncompressed size.
 * Default 200MB.
 *
 * @param {Number} n
 * @return {Request} for chaining
 */
RequestBase.prototype.maxResponseSize = function(n){
  if ('number' !== typeof n) {
    throw TypeError("Invalid argument");
  }
  this._maxResponseSize = n;
  return this;
};

/**
 * Convert to a plain javascript object (not JSON string) of scalar properties.
 * Note as this method is designed to return a useful non-this value,
 * it cannot be chained.
 *
 * @return {Object} describing method, url, and data of this request
 * @api public
 */

RequestBase.prototype.toJSON = function() {
  return {
    method: this.method,
    url: this.url,
    data: this._data,
    headers: this._header,
  };
};

/**
 * Send `data` as the request body, defaulting the `.type()` to "json" when
 * an object is given.
 *
 * Examples:
 *
 *       // manual json
 *       request.post('/user')
 *         .type('json')
 *         .send('{"name":"tj"}')
 *         .end(callback)
 *
 *       // auto json
 *       request.post('/user')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // manual x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send('name=tj')
 *         .end(callback)
 *
 *       // auto x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // defaults to x-www-form-urlencoded
 *      request.post('/user')
 *        .send('name=tobi')
 *        .send('species=ferret')
 *        .end(callback)
 *
 * @param {String|Object} data
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.send = function(data){
  var isObj = isObject(data);
  var type = this._header['content-type'];

  if (this._formData) {
    console.error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");
  }

  if (isObj && !this._data) {
    if (Array.isArray(data)) {
      this._data = [];
    } else if (!this._isHost(data)) {
      this._data = {};
    }
  } else if (data && this._data && this._isHost(this._data)) {
    throw Error("Can't merge these send calls");
  }

  // merge
  if (isObj && isObject(this._data)) {
    for (var key in data) {
      this._data[key] = data[key];
    }
  } else if ('string' == typeof data) {
    // default to x-www-form-urlencoded
    if (!type) this.type('form');
    type = this._header['content-type'];
    if ('application/x-www-form-urlencoded' == type) {
      this._data = this._data
        ? this._data + '&' + data
        : data;
    } else {
      this._data = (this._data || '') + data;
    }
  } else {
    this._data = data;
  }

  if (!isObj || this._isHost(data)) {
    return this;
  }

  // default to json
  if (!type) this.type('json');
  return this;
};

/**
 * Sort `querystring` by the sort function
 *
 *
 * Examples:
 *
 *       // default order
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery()
 *         .end(callback)
 *
 *       // customized sort function
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery(function(a, b){
 *           return a.length - b.length;
 *         })
 *         .end(callback)
 *
 *
 * @param {Function} sort
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.sortQuery = function(sort) {
  // _sort default to true but otherwise can be a function or boolean
  this._sort = typeof sort === 'undefined' ? true : sort;
  return this;
};

/**
 * Compose querystring to append to req.url
 *
 * @api private
 */
RequestBase.prototype._finalizeQueryString = function(){
  var query = this._query.join('&');
  if (query) {
    this.url += (this.url.indexOf('?') >= 0 ? '&' : '?') + query;
  }
  this._query.length = 0; // Makes the call idempotent

  if (this._sort) {
    var index = this.url.indexOf('?');
    if (index >= 0) {
      var queryArr = this.url.substring(index + 1).split('&');
      if ('function' === typeof this._sort) {
        queryArr.sort(this._sort);
      } else {
        queryArr.sort();
      }
      this.url = this.url.substring(0, index) + '?' + queryArr.join('&');
    }
  }
};

// For backwards compat only
RequestBase.prototype._appendQueryString = function() {console.trace("Unsupported");}

/**
 * Invoke callback with timeout error.
 *
 * @api private
 */

RequestBase.prototype._timeoutError = function(reason, timeout, errno){
  if (this._aborted) {
    return;
  }
  var err = new Error(reason + timeout + 'ms exceeded');
  err.timeout = timeout;
  err.code = 'ECONNABORTED';
  err.errno = errno;
  this.timedout = true;
  this.abort();
  this.callback(err);
};

RequestBase.prototype._setTimeouts = function() {
  var self = this;

  // deadline
  if (this._timeout && !this._timer) {
    this._timer = setTimeout(function(){
      self._timeoutError('Timeout of ', self._timeout, 'ETIME');
    }, this._timeout);
  }
  // response timeout
  if (this._responseTimeout && !this._responseTimeoutTimer) {
    this._responseTimeoutTimer = setTimeout(function(){
      self._timeoutError('Response timeout of ', self._responseTimeout, 'ETIMEDOUT');
    }, this._responseTimeout);
  }
};


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Module dependencies.
 */

var utils = __webpack_require__(856);

/**
 * Expose `ResponseBase`.
 */

module.exports = ResponseBase;

/**
 * Initialize a new `ResponseBase`.
 *
 * @api public
 */

function ResponseBase(obj) {
  if (obj) return mixin(obj);
}

/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in ResponseBase.prototype) {
    obj[key] = ResponseBase.prototype[key];
  }
  return obj;
}

/**
 * Get case-insensitive `field` value.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

ResponseBase.prototype.get = function(field) {
  return this.header[field.toLowerCase()];
};

/**
 * Set header related properties:
 *
 *   - `.type` the content type without params
 *
 * A response of "Content-Type: text/plain; charset=utf-8"
 * will provide you with a `.type` of "text/plain".
 *
 * @param {Object} header
 * @api private
 */

ResponseBase.prototype._setHeaderProperties = function(header){
    // TODO: moar!
    // TODO: make this a util

    // content-type
    var ct = header['content-type'] || '';
    this.type = utils.type(ct);

    // params
    var params = utils.params(ct);
    for (var key in params) this[key] = params[key];

    this.links = {};

    // links
    try {
        if (header.link) {
            this.links = utils.parseLinks(header.link);
        }
    } catch (err) {
        // ignore
    }
};

/**
 * Set flags such as `.ok` based on `status`.
 *
 * For example a 2xx response will give you a `.ok` of __true__
 * whereas 5xx will be __false__ and `.error` will be __true__. The
 * `.clientError` and `.serverError` are also available to be more
 * specific, and `.statusType` is the class of error ranging from 1..5
 * sometimes useful for mapping respond colors etc.
 *
 * "sugar" properties are also defined for common cases. Currently providing:
 *
 *   - .noContent
 *   - .badRequest
 *   - .unauthorized
 *   - .notAcceptable
 *   - .notFound
 *
 * @param {Number} status
 * @api private
 */

ResponseBase.prototype._setStatusProperties = function(status){
    var type = status / 100 | 0;

    // status / class
    this.status = this.statusCode = status;
    this.statusType = type;

    // basics
    this.info = 1 == type;
    this.ok = 2 == type;
    this.redirect = 3 == type;
    this.clientError = 4 == type;
    this.serverError = 5 == type;
    this.error = (4 == type || 5 == type)
        ? this.toError()
        : false;

    // sugar
    this.created = 201 == status;
    this.accepted = 202 == status;
    this.noContent = 204 == status;
    this.badRequest = 400 == status;
    this.unauthorized = 401 == status;
    this.notAcceptable = 406 == status;
    this.forbidden = 403 == status;
    this.notFound = 404 == status;
    this.unprocessableEntity = 422 == status;
};


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Return the mime type for the given `str`.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

exports.type = function(str){
  return str.split(/ *; */).shift();
};

/**
 * Return header field parameters.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

exports.params = function(str){
  return str.split(/ *; */).reduce(function(obj, str){
    var parts = str.split(/ *= */);
    var key = parts.shift();
    var val = parts.shift();

    if (key && val) obj[key] = val;
    return obj;
  }, {});
};

/**
 * Parse Link header fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

exports.parseLinks = function(str){
  return str.split(/ *, */).reduce(function(obj, str){
    var parts = str.split(/ *; */);
    var url = parts[0].slice(1, -1);
    var rel = parts[1].split(/ *= */)[1].slice(1, -1);
    obj[rel] = url;
    return obj;
  }, {});
};

/**
 * Strip content related fields from `header`.
 *
 * @param {Object} header
 * @return {Object} header
 * @api private
 */

exports.cleanHeader = function(header, changesOrigin){
  delete header['content-type'];
  delete header['content-length'];
  delete header['transfer-encoding'];
  delete header['host'];
  // secuirty
  if (changesOrigin) {
    delete header['authorization'];
    delete header['cookie'];
  }
  return header;
};


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(830);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(105)))

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

(function (root) {
   "use strict";

/***** unorm.js *****/

/*
 * UnicodeNormalizer 1.0.0
 * Copyright (c) 2008 Matsuza
 * Dual licensed under the MIT (MIT-LICENSE.txt) and GPL (GPL-LICENSE.txt) licenses.
 * $Date: 2008-06-05 16:44:17 +0200 (Thu, 05 Jun 2008) $
 * $Rev: 13309 $
 */

   var DEFAULT_FEATURE = [null, 0, {}];
   var CACHE_THRESHOLD = 10;
   var SBase = 0xAC00, LBase = 0x1100, VBase = 0x1161, TBase = 0x11A7, LCount = 19, VCount = 21, TCount = 28;
   var NCount = VCount * TCount; // 588
   var SCount = LCount * NCount; // 11172

   var UChar = function(cp, feature){
      this.codepoint = cp;
      this.feature = feature;
   };

   // Strategies
   var cache = {};
   var cacheCounter = [];
   for (var i = 0; i <= 0xFF; ++i){
      cacheCounter[i] = 0;
   }

   function fromCache(next, cp, needFeature){
      var ret = cache[cp];
      if(!ret){
         ret = next(cp, needFeature);
         if(!!ret.feature && ++cacheCounter[(cp >> 8) & 0xFF] > CACHE_THRESHOLD){
            cache[cp] = ret;
         }
      }
      return ret;
   }

   function fromData(next, cp, needFeature){
      var hash = cp & 0xFF00;
      var dunit = UChar.udata[hash] || {};
      var f = dunit[cp];
      return f ? new UChar(cp, f) : new UChar(cp, DEFAULT_FEATURE);
   }
   function fromCpOnly(next, cp, needFeature){
      return !!needFeature ? next(cp, needFeature) : new UChar(cp, null);
   }
   function fromRuleBasedJamo(next, cp, needFeature){
      var j;
      if(cp < LBase || (LBase + LCount <= cp && cp < SBase) || (SBase + SCount < cp)){
         return next(cp, needFeature);
      }
      if(LBase <= cp && cp < LBase + LCount){
         var c = {};
         var base = (cp - LBase) * VCount;
         for (j = 0; j < VCount; ++j){
            c[VBase + j] = SBase + TCount * (j + base);
         }
         return new UChar(cp, [,,c]);
      }

      var SIndex = cp - SBase;
      var TIndex = SIndex % TCount;
      var feature = [];
      if(TIndex !== 0){
         feature[0] = [SBase + SIndex - TIndex, TBase + TIndex];
      } else {
         feature[0] = [LBase + Math.floor(SIndex / NCount), VBase + Math.floor((SIndex % NCount) / TCount)];
         feature[2] = {};
         for (j = 1; j < TCount; ++j){
            feature[2][TBase + j] = cp + j;
         }
      }
      return new UChar(cp, feature);
   }
   function fromCpFilter(next, cp, needFeature){
      return cp < 60 || 13311 < cp && cp < 42607 ? new UChar(cp, DEFAULT_FEATURE) : next(cp, needFeature);
   }

   var strategies = [fromCpFilter, fromCache, fromCpOnly, fromRuleBasedJamo, fromData];

   UChar.fromCharCode = strategies.reduceRight(function (next, strategy) {
      return function (cp, needFeature) {
         return strategy(next, cp, needFeature);
      };
   }, null);

   UChar.isHighSurrogate = function(cp){
      return cp >= 0xD800 && cp <= 0xDBFF;
   };
   UChar.isLowSurrogate = function(cp){
      return cp >= 0xDC00 && cp <= 0xDFFF;
   };

   UChar.prototype.prepFeature = function(){
      if(!this.feature){
         this.feature = UChar.fromCharCode(this.codepoint, true).feature;
      }
   };

   UChar.prototype.toString = function(){
      if(this.codepoint < 0x10000){
         return String.fromCharCode(this.codepoint);
      } else {
         var x = this.codepoint - 0x10000;
         return String.fromCharCode(Math.floor(x / 0x400) + 0xD800, x % 0x400 + 0xDC00);
      }
   };

   UChar.prototype.getDecomp = function(){
      this.prepFeature();
      return this.feature[0] || null;
   };

   UChar.prototype.isCompatibility = function(){
      this.prepFeature();
      return !!this.feature[1] && (this.feature[1] & (1 << 8));
   };
   UChar.prototype.isExclude = function(){
      this.prepFeature();
      return !!this.feature[1] && (this.feature[1] & (1 << 9));
   };
   UChar.prototype.getCanonicalClass = function(){
      this.prepFeature();
      return !!this.feature[1] ? (this.feature[1] & 0xff) : 0;
   };
   UChar.prototype.getComposite = function(following){
      this.prepFeature();
      if(!this.feature[2]){
         return null;
      }
      var cp = this.feature[2][following.codepoint];
      return cp ? UChar.fromCharCode(cp) : null;
   };

   var UCharIterator = function(str){
      this.str = str;
      this.cursor = 0;
   };
   UCharIterator.prototype.next = function(){
      if(!!this.str && this.cursor < this.str.length){
         var cp = this.str.charCodeAt(this.cursor++);
         var d;
         if(UChar.isHighSurrogate(cp) && this.cursor < this.str.length && UChar.isLowSurrogate((d = this.str.charCodeAt(this.cursor)))){
            cp = (cp - 0xD800) * 0x400 + (d -0xDC00) + 0x10000;
            ++this.cursor;
         }
         return UChar.fromCharCode(cp);
      } else {
         this.str = null;
         return null;
      }
   };

   var RecursDecompIterator = function(it, cano){
      this.it = it;
      this.canonical = cano;
      this.resBuf = [];
   };

   RecursDecompIterator.prototype.next = function(){
      function recursiveDecomp(cano, uchar){
         var decomp = uchar.getDecomp();
         if(!!decomp && !(cano && uchar.isCompatibility())){
            var ret = [];
            for(var i = 0; i < decomp.length; ++i){
               var a = recursiveDecomp(cano, UChar.fromCharCode(decomp[i]));
                ret = ret.concat(a);
            }
            return ret;
         } else {
            return [uchar];
         }
      }
      if(this.resBuf.length === 0){
         var uchar = this.it.next();
         if(!uchar){
            return null;
         }
         this.resBuf = recursiveDecomp(this.canonical, uchar);
      }
      return this.resBuf.shift();
   };

   var DecompIterator = function(it){
      this.it = it;
      this.resBuf = [];
   };

   DecompIterator.prototype.next = function(){
      var cc;
      if(this.resBuf.length === 0){
         do{
            var uchar = this.it.next();
            if(!uchar){
               break;
            }
            cc = uchar.getCanonicalClass();
            var inspt = this.resBuf.length;
            if(cc !== 0){
               for(; inspt > 0; --inspt){
                  var uchar2 = this.resBuf[inspt - 1];
                  var cc2 = uchar2.getCanonicalClass();
                  if(cc2 <= cc){
                     break;
                  }
               }
            }
            this.resBuf.splice(inspt, 0, uchar);
         } while(cc !== 0);
      }
      return this.resBuf.shift();
   };

   var CompIterator = function(it){
      this.it = it;
      this.procBuf = [];
      this.resBuf = [];
      this.lastClass = null;
   };

   CompIterator.prototype.next = function(){
      while(this.resBuf.length === 0){
         var uchar = this.it.next();
         if(!uchar){
            this.resBuf = this.procBuf;
            this.procBuf = [];
            break;
         }
         if(this.procBuf.length === 0){
            this.lastClass = uchar.getCanonicalClass();
            this.procBuf.push(uchar);
         } else {
            var starter = this.procBuf[0];
            var composite = starter.getComposite(uchar);
            var cc = uchar.getCanonicalClass();
            if(!!composite && (this.lastClass < cc || this.lastClass === 0)){
               this.procBuf[0] = composite;
            } else {
               if(cc === 0){
                  this.resBuf = this.procBuf;
                  this.procBuf = [];
               }
               this.lastClass = cc;
               this.procBuf.push(uchar);
            }
         }
      }
      return this.resBuf.shift();
   };

   var createIterator = function(mode, str){
      switch(mode){
         case "NFD":
            return new DecompIterator(new RecursDecompIterator(new UCharIterator(str), true));
         case "NFKD":
            return new DecompIterator(new RecursDecompIterator(new UCharIterator(str), false));
         case "NFC":
            return new CompIterator(new DecompIterator(new RecursDecompIterator(new UCharIterator(str), true)));
         case "NFKC":
            return new CompIterator(new DecompIterator(new RecursDecompIterator(new UCharIterator(str), false)));
      }
      throw mode + " is invalid";
   };
   var normalize = function(mode, str){
      var it = createIterator(mode, str);
      var ret = "";
      var uchar;
      while(!!(uchar = it.next())){
         ret += uchar.toString();
      }
      return ret;
   };

   /* API functions */
   function nfd(str){
      return normalize("NFD", str);
   }

   function nfkd(str){
      return normalize("NFKD", str);
   }

   function nfc(str){
      return normalize("NFC", str);
   }

   function nfkc(str){
      return normalize("NFKC", str);
   }

/* Unicode data */
UChar.udata={
0:{60:[,,{824:8814}],61:[,,{824:8800}],62:[,,{824:8815}],65:[,,{768:192,769:193,770:194,771:195,772:256,774:258,775:550,776:196,777:7842,778:197,780:461,783:512,785:514,803:7840,805:7680,808:260}],66:[,,{775:7682,803:7684,817:7686}],67:[,,{769:262,770:264,775:266,780:268,807:199}],68:[,,{775:7690,780:270,803:7692,807:7696,813:7698,817:7694}],69:[,,{768:200,769:201,770:202,771:7868,772:274,774:276,775:278,776:203,777:7866,780:282,783:516,785:518,803:7864,807:552,808:280,813:7704,816:7706}],70:[,,{775:7710}],71:[,,{769:500,770:284,772:7712,774:286,775:288,780:486,807:290}],72:[,,{770:292,775:7714,776:7718,780:542,803:7716,807:7720,814:7722}],73:[,,{768:204,769:205,770:206,771:296,772:298,774:300,775:304,776:207,777:7880,780:463,783:520,785:522,803:7882,808:302,816:7724}],74:[,,{770:308}],75:[,,{769:7728,780:488,803:7730,807:310,817:7732}],76:[,,{769:313,780:317,803:7734,807:315,813:7740,817:7738}],77:[,,{769:7742,775:7744,803:7746}],78:[,,{768:504,769:323,771:209,775:7748,780:327,803:7750,807:325,813:7754,817:7752}],79:[,,{768:210,769:211,770:212,771:213,772:332,774:334,775:558,776:214,777:7886,779:336,780:465,783:524,785:526,795:416,803:7884,808:490}],80:[,,{769:7764,775:7766}],82:[,,{769:340,775:7768,780:344,783:528,785:530,803:7770,807:342,817:7774}],83:[,,{769:346,770:348,775:7776,780:352,803:7778,806:536,807:350}],84:[,,{775:7786,780:356,803:7788,806:538,807:354,813:7792,817:7790}],85:[,,{768:217,769:218,770:219,771:360,772:362,774:364,776:220,777:7910,778:366,779:368,780:467,783:532,785:534,795:431,803:7908,804:7794,808:370,813:7798,816:7796}],86:[,,{771:7804,803:7806}],87:[,,{768:7808,769:7810,770:372,775:7814,776:7812,803:7816}],88:[,,{775:7818,776:7820}],89:[,,{768:7922,769:221,770:374,771:7928,772:562,775:7822,776:376,777:7926,803:7924}],90:[,,{769:377,770:7824,775:379,780:381,803:7826,817:7828}],97:[,,{768:224,769:225,770:226,771:227,772:257,774:259,775:551,776:228,777:7843,778:229,780:462,783:513,785:515,803:7841,805:7681,808:261}],98:[,,{775:7683,803:7685,817:7687}],99:[,,{769:263,770:265,775:267,780:269,807:231}],100:[,,{775:7691,780:271,803:7693,807:7697,813:7699,817:7695}],101:[,,{768:232,769:233,770:234,771:7869,772:275,774:277,775:279,776:235,777:7867,780:283,783:517,785:519,803:7865,807:553,808:281,813:7705,816:7707}],102:[,,{775:7711}],103:[,,{769:501,770:285,772:7713,774:287,775:289,780:487,807:291}],104:[,,{770:293,775:7715,776:7719,780:543,803:7717,807:7721,814:7723,817:7830}],105:[,,{768:236,769:237,770:238,771:297,772:299,774:301,776:239,777:7881,780:464,783:521,785:523,803:7883,808:303,816:7725}],106:[,,{770:309,780:496}],107:[,,{769:7729,780:489,803:7731,807:311,817:7733}],108:[,,{769:314,780:318,803:7735,807:316,813:7741,817:7739}],109:[,,{769:7743,775:7745,803:7747}],110:[,,{768:505,769:324,771:241,775:7749,780:328,803:7751,807:326,813:7755,817:7753}],111:[,,{768:242,769:243,770:244,771:245,772:333,774:335,775:559,776:246,777:7887,779:337,780:466,783:525,785:527,795:417,803:7885,808:491}],112:[,,{769:7765,775:7767}],114:[,,{769:341,775:7769,780:345,783:529,785:531,803:7771,807:343,817:7775}],115:[,,{769:347,770:349,775:7777,780:353,803:7779,806:537,807:351}],116:[,,{775:7787,776:7831,780:357,803:7789,806:539,807:355,813:7793,817:7791}],117:[,,{768:249,769:250,770:251,771:361,772:363,774:365,776:252,777:7911,778:367,779:369,780:468,783:533,785:535,795:432,803:7909,804:7795,808:371,813:7799,816:7797}],118:[,,{771:7805,803:7807}],119:[,,{768:7809,769:7811,770:373,775:7815,776:7813,778:7832,803:7817}],120:[,,{775:7819,776:7821}],121:[,,{768:7923,769:253,770:375,771:7929,772:563,775:7823,776:255,777:7927,778:7833,803:7925}],122:[,,{769:378,770:7825,775:380,780:382,803:7827,817:7829}],160:[[32],256],168:[[32,776],256,{768:8173,769:901,834:8129}],170:[[97],256],175:[[32,772],256],178:[[50],256],179:[[51],256],180:[[32,769],256],181:[[956],256],184:[[32,807],256],185:[[49],256],186:[[111],256],188:[[49,8260,52],256],189:[[49,8260,50],256],190:[[51,8260,52],256],192:[[65,768]],193:[[65,769]],194:[[65,770],,{768:7846,769:7844,771:7850,777:7848}],195:[[65,771]],196:[[65,776],,{772:478}],197:[[65,778],,{769:506}],198:[,,{769:508,772:482}],199:[[67,807],,{769:7688}],200:[[69,768]],201:[[69,769]],202:[[69,770],,{768:7872,769:7870,771:7876,777:7874}],203:[[69,776]],204:[[73,768]],205:[[73,769]],206:[[73,770]],207:[[73,776],,{769:7726}],209:[[78,771]],210:[[79,768]],211:[[79,769]],212:[[79,770],,{768:7890,769:7888,771:7894,777:7892}],213:[[79,771],,{769:7756,772:556,776:7758}],214:[[79,776],,{772:554}],216:[,,{769:510}],217:[[85,768]],218:[[85,769]],219:[[85,770]],220:[[85,776],,{768:475,769:471,772:469,780:473}],221:[[89,769]],224:[[97,768]],225:[[97,769]],226:[[97,770],,{768:7847,769:7845,771:7851,777:7849}],227:[[97,771]],228:[[97,776],,{772:479}],229:[[97,778],,{769:507}],230:[,,{769:509,772:483}],231:[[99,807],,{769:7689}],232:[[101,768]],233:[[101,769]],234:[[101,770],,{768:7873,769:7871,771:7877,777:7875}],235:[[101,776]],236:[[105,768]],237:[[105,769]],238:[[105,770]],239:[[105,776],,{769:7727}],241:[[110,771]],242:[[111,768]],243:[[111,769]],244:[[111,770],,{768:7891,769:7889,771:7895,777:7893}],245:[[111,771],,{769:7757,772:557,776:7759}],246:[[111,776],,{772:555}],248:[,,{769:511}],249:[[117,768]],250:[[117,769]],251:[[117,770]],252:[[117,776],,{768:476,769:472,772:470,780:474}],253:[[121,769]],255:[[121,776]]},
256:{256:[[65,772]],257:[[97,772]],258:[[65,774],,{768:7856,769:7854,771:7860,777:7858}],259:[[97,774],,{768:7857,769:7855,771:7861,777:7859}],260:[[65,808]],261:[[97,808]],262:[[67,769]],263:[[99,769]],264:[[67,770]],265:[[99,770]],266:[[67,775]],267:[[99,775]],268:[[67,780]],269:[[99,780]],270:[[68,780]],271:[[100,780]],274:[[69,772],,{768:7700,769:7702}],275:[[101,772],,{768:7701,769:7703}],276:[[69,774]],277:[[101,774]],278:[[69,775]],279:[[101,775]],280:[[69,808]],281:[[101,808]],282:[[69,780]],283:[[101,780]],284:[[71,770]],285:[[103,770]],286:[[71,774]],287:[[103,774]],288:[[71,775]],289:[[103,775]],290:[[71,807]],291:[[103,807]],292:[[72,770]],293:[[104,770]],296:[[73,771]],297:[[105,771]],298:[[73,772]],299:[[105,772]],300:[[73,774]],301:[[105,774]],302:[[73,808]],303:[[105,808]],304:[[73,775]],306:[[73,74],256],307:[[105,106],256],308:[[74,770]],309:[[106,770]],310:[[75,807]],311:[[107,807]],313:[[76,769]],314:[[108,769]],315:[[76,807]],316:[[108,807]],317:[[76,780]],318:[[108,780]],319:[[76,183],256],320:[[108,183],256],323:[[78,769]],324:[[110,769]],325:[[78,807]],326:[[110,807]],327:[[78,780]],328:[[110,780]],329:[[700,110],256],332:[[79,772],,{768:7760,769:7762}],333:[[111,772],,{768:7761,769:7763}],334:[[79,774]],335:[[111,774]],336:[[79,779]],337:[[111,779]],340:[[82,769]],341:[[114,769]],342:[[82,807]],343:[[114,807]],344:[[82,780]],345:[[114,780]],346:[[83,769],,{775:7780}],347:[[115,769],,{775:7781}],348:[[83,770]],349:[[115,770]],350:[[83,807]],351:[[115,807]],352:[[83,780],,{775:7782}],353:[[115,780],,{775:7783}],354:[[84,807]],355:[[116,807]],356:[[84,780]],357:[[116,780]],360:[[85,771],,{769:7800}],361:[[117,771],,{769:7801}],362:[[85,772],,{776:7802}],363:[[117,772],,{776:7803}],364:[[85,774]],365:[[117,774]],366:[[85,778]],367:[[117,778]],368:[[85,779]],369:[[117,779]],370:[[85,808]],371:[[117,808]],372:[[87,770]],373:[[119,770]],374:[[89,770]],375:[[121,770]],376:[[89,776]],377:[[90,769]],378:[[122,769]],379:[[90,775]],380:[[122,775]],381:[[90,780]],382:[[122,780]],383:[[115],256,{775:7835}],416:[[79,795],,{768:7900,769:7898,771:7904,777:7902,803:7906}],417:[[111,795],,{768:7901,769:7899,771:7905,777:7903,803:7907}],431:[[85,795],,{768:7914,769:7912,771:7918,777:7916,803:7920}],432:[[117,795],,{768:7915,769:7913,771:7919,777:7917,803:7921}],439:[,,{780:494}],452:[[68,381],256],453:[[68,382],256],454:[[100,382],256],455:[[76,74],256],456:[[76,106],256],457:[[108,106],256],458:[[78,74],256],459:[[78,106],256],460:[[110,106],256],461:[[65,780]],462:[[97,780]],463:[[73,780]],464:[[105,780]],465:[[79,780]],466:[[111,780]],467:[[85,780]],468:[[117,780]],469:[[220,772]],470:[[252,772]],471:[[220,769]],472:[[252,769]],473:[[220,780]],474:[[252,780]],475:[[220,768]],476:[[252,768]],478:[[196,772]],479:[[228,772]],480:[[550,772]],481:[[551,772]],482:[[198,772]],483:[[230,772]],486:[[71,780]],487:[[103,780]],488:[[75,780]],489:[[107,780]],490:[[79,808],,{772:492}],491:[[111,808],,{772:493}],492:[[490,772]],493:[[491,772]],494:[[439,780]],495:[[658,780]],496:[[106,780]],497:[[68,90],256],498:[[68,122],256],499:[[100,122],256],500:[[71,769]],501:[[103,769]],504:[[78,768]],505:[[110,768]],506:[[197,769]],507:[[229,769]],508:[[198,769]],509:[[230,769]],510:[[216,769]],511:[[248,769]],66045:[,220]},
512:{512:[[65,783]],513:[[97,783]],514:[[65,785]],515:[[97,785]],516:[[69,783]],517:[[101,783]],518:[[69,785]],519:[[101,785]],520:[[73,783]],521:[[105,783]],522:[[73,785]],523:[[105,785]],524:[[79,783]],525:[[111,783]],526:[[79,785]],527:[[111,785]],528:[[82,783]],529:[[114,783]],530:[[82,785]],531:[[114,785]],532:[[85,783]],533:[[117,783]],534:[[85,785]],535:[[117,785]],536:[[83,806]],537:[[115,806]],538:[[84,806]],539:[[116,806]],542:[[72,780]],543:[[104,780]],550:[[65,775],,{772:480}],551:[[97,775],,{772:481}],552:[[69,807],,{774:7708}],553:[[101,807],,{774:7709}],554:[[214,772]],555:[[246,772]],556:[[213,772]],557:[[245,772]],558:[[79,775],,{772:560}],559:[[111,775],,{772:561}],560:[[558,772]],561:[[559,772]],562:[[89,772]],563:[[121,772]],658:[,,{780:495}],688:[[104],256],689:[[614],256],690:[[106],256],691:[[114],256],692:[[633],256],693:[[635],256],694:[[641],256],695:[[119],256],696:[[121],256],728:[[32,774],256],729:[[32,775],256],730:[[32,778],256],731:[[32,808],256],732:[[32,771],256],733:[[32,779],256],736:[[611],256],737:[[108],256],738:[[115],256],739:[[120],256],740:[[661],256],66272:[,220]},
768:{768:[,230],769:[,230],770:[,230],771:[,230],772:[,230],773:[,230],774:[,230],775:[,230],776:[,230,{769:836}],777:[,230],778:[,230],779:[,230],780:[,230],781:[,230],782:[,230],783:[,230],784:[,230],785:[,230],786:[,230],787:[,230],788:[,230],789:[,232],790:[,220],791:[,220],792:[,220],793:[,220],794:[,232],795:[,216],796:[,220],797:[,220],798:[,220],799:[,220],800:[,220],801:[,202],802:[,202],803:[,220],804:[,220],805:[,220],806:[,220],807:[,202],808:[,202],809:[,220],810:[,220],811:[,220],812:[,220],813:[,220],814:[,220],815:[,220],816:[,220],817:[,220],818:[,220],819:[,220],820:[,1],821:[,1],822:[,1],823:[,1],824:[,1],825:[,220],826:[,220],827:[,220],828:[,220],829:[,230],830:[,230],831:[,230],832:[[768],230],833:[[769],230],834:[,230],835:[[787],230],836:[[776,769],230],837:[,240],838:[,230],839:[,220],840:[,220],841:[,220],842:[,230],843:[,230],844:[,230],845:[,220],846:[,220],848:[,230],849:[,230],850:[,230],851:[,220],852:[,220],853:[,220],854:[,220],855:[,230],856:[,232],857:[,220],858:[,220],859:[,230],860:[,233],861:[,234],862:[,234],863:[,233],864:[,234],865:[,234],866:[,233],867:[,230],868:[,230],869:[,230],870:[,230],871:[,230],872:[,230],873:[,230],874:[,230],875:[,230],876:[,230],877:[,230],878:[,230],879:[,230],884:[[697]],890:[[32,837],256],894:[[59]],900:[[32,769],256],901:[[168,769]],902:[[913,769]],903:[[183]],904:[[917,769]],905:[[919,769]],906:[[921,769]],908:[[927,769]],910:[[933,769]],911:[[937,769]],912:[[970,769]],913:[,,{768:8122,769:902,772:8121,774:8120,787:7944,788:7945,837:8124}],917:[,,{768:8136,769:904,787:7960,788:7961}],919:[,,{768:8138,769:905,787:7976,788:7977,837:8140}],921:[,,{768:8154,769:906,772:8153,774:8152,776:938,787:7992,788:7993}],927:[,,{768:8184,769:908,787:8008,788:8009}],929:[,,{788:8172}],933:[,,{768:8170,769:910,772:8169,774:8168,776:939,788:8025}],937:[,,{768:8186,769:911,787:8040,788:8041,837:8188}],938:[[921,776]],939:[[933,776]],940:[[945,769],,{837:8116}],941:[[949,769]],942:[[951,769],,{837:8132}],943:[[953,769]],944:[[971,769]],945:[,,{768:8048,769:940,772:8113,774:8112,787:7936,788:7937,834:8118,837:8115}],949:[,,{768:8050,769:941,787:7952,788:7953}],951:[,,{768:8052,769:942,787:7968,788:7969,834:8134,837:8131}],953:[,,{768:8054,769:943,772:8145,774:8144,776:970,787:7984,788:7985,834:8150}],959:[,,{768:8056,769:972,787:8000,788:8001}],961:[,,{787:8164,788:8165}],965:[,,{768:8058,769:973,772:8161,774:8160,776:971,787:8016,788:8017,834:8166}],969:[,,{768:8060,769:974,787:8032,788:8033,834:8182,837:8179}],970:[[953,776],,{768:8146,769:912,834:8151}],971:[[965,776],,{768:8162,769:944,834:8167}],972:[[959,769]],973:[[965,769]],974:[[969,769],,{837:8180}],976:[[946],256],977:[[952],256],978:[[933],256,{769:979,776:980}],979:[[978,769]],980:[[978,776]],981:[[966],256],982:[[960],256],1008:[[954],256],1009:[[961],256],1010:[[962],256],1012:[[920],256],1013:[[949],256],1017:[[931],256],66422:[,230],66423:[,230],66424:[,230],66425:[,230],66426:[,230]},
1024:{1024:[[1045,768]],1025:[[1045,776]],1027:[[1043,769]],1030:[,,{776:1031}],1031:[[1030,776]],1036:[[1050,769]],1037:[[1048,768]],1038:[[1059,774]],1040:[,,{774:1232,776:1234}],1043:[,,{769:1027}],1045:[,,{768:1024,774:1238,776:1025}],1046:[,,{774:1217,776:1244}],1047:[,,{776:1246}],1048:[,,{768:1037,772:1250,774:1049,776:1252}],1049:[[1048,774]],1050:[,,{769:1036}],1054:[,,{776:1254}],1059:[,,{772:1262,774:1038,776:1264,779:1266}],1063:[,,{776:1268}],1067:[,,{776:1272}],1069:[,,{776:1260}],1072:[,,{774:1233,776:1235}],1075:[,,{769:1107}],1077:[,,{768:1104,774:1239,776:1105}],1078:[,,{774:1218,776:1245}],1079:[,,{776:1247}],1080:[,,{768:1117,772:1251,774:1081,776:1253}],1081:[[1080,774]],1082:[,,{769:1116}],1086:[,,{776:1255}],1091:[,,{772:1263,774:1118,776:1265,779:1267}],1095:[,,{776:1269}],1099:[,,{776:1273}],1101:[,,{776:1261}],1104:[[1077,768]],1105:[[1077,776]],1107:[[1075,769]],1110:[,,{776:1111}],1111:[[1110,776]],1116:[[1082,769]],1117:[[1080,768]],1118:[[1091,774]],1140:[,,{783:1142}],1141:[,,{783:1143}],1142:[[1140,783]],1143:[[1141,783]],1155:[,230],1156:[,230],1157:[,230],1158:[,230],1159:[,230],1217:[[1046,774]],1218:[[1078,774]],1232:[[1040,774]],1233:[[1072,774]],1234:[[1040,776]],1235:[[1072,776]],1238:[[1045,774]],1239:[[1077,774]],1240:[,,{776:1242}],1241:[,,{776:1243}],1242:[[1240,776]],1243:[[1241,776]],1244:[[1046,776]],1245:[[1078,776]],1246:[[1047,776]],1247:[[1079,776]],1250:[[1048,772]],1251:[[1080,772]],1252:[[1048,776]],1253:[[1080,776]],1254:[[1054,776]],1255:[[1086,776]],1256:[,,{776:1258}],1257:[,,{776:1259}],1258:[[1256,776]],1259:[[1257,776]],1260:[[1069,776]],1261:[[1101,776]],1262:[[1059,772]],1263:[[1091,772]],1264:[[1059,776]],1265:[[1091,776]],1266:[[1059,779]],1267:[[1091,779]],1268:[[1063,776]],1269:[[1095,776]],1272:[[1067,776]],1273:[[1099,776]]},
1280:{1415:[[1381,1410],256],1425:[,220],1426:[,230],1427:[,230],1428:[,230],1429:[,230],1430:[,220],1431:[,230],1432:[,230],1433:[,230],1434:[,222],1435:[,220],1436:[,230],1437:[,230],1438:[,230],1439:[,230],1440:[,230],1441:[,230],1442:[,220],1443:[,220],1444:[,220],1445:[,220],1446:[,220],1447:[,220],1448:[,230],1449:[,230],1450:[,220],1451:[,230],1452:[,230],1453:[,222],1454:[,228],1455:[,230],1456:[,10],1457:[,11],1458:[,12],1459:[,13],1460:[,14],1461:[,15],1462:[,16],1463:[,17],1464:[,18],1465:[,19],1466:[,19],1467:[,20],1468:[,21],1469:[,22],1471:[,23],1473:[,24],1474:[,25],1476:[,230],1477:[,220],1479:[,18]},
1536:{1552:[,230],1553:[,230],1554:[,230],1555:[,230],1556:[,230],1557:[,230],1558:[,230],1559:[,230],1560:[,30],1561:[,31],1562:[,32],1570:[[1575,1619]],1571:[[1575,1620]],1572:[[1608,1620]],1573:[[1575,1621]],1574:[[1610,1620]],1575:[,,{1619:1570,1620:1571,1621:1573}],1608:[,,{1620:1572}],1610:[,,{1620:1574}],1611:[,27],1612:[,28],1613:[,29],1614:[,30],1615:[,31],1616:[,32],1617:[,33],1618:[,34],1619:[,230],1620:[,230],1621:[,220],1622:[,220],1623:[,230],1624:[,230],1625:[,230],1626:[,230],1627:[,230],1628:[,220],1629:[,230],1630:[,230],1631:[,220],1648:[,35],1653:[[1575,1652],256],1654:[[1608,1652],256],1655:[[1735,1652],256],1656:[[1610,1652],256],1728:[[1749,1620]],1729:[,,{1620:1730}],1730:[[1729,1620]],1746:[,,{1620:1747}],1747:[[1746,1620]],1749:[,,{1620:1728}],1750:[,230],1751:[,230],1752:[,230],1753:[,230],1754:[,230],1755:[,230],1756:[,230],1759:[,230],1760:[,230],1761:[,230],1762:[,230],1763:[,220],1764:[,230],1767:[,230],1768:[,230],1770:[,220],1771:[,230],1772:[,230],1773:[,220]},
1792:{1809:[,36],1840:[,230],1841:[,220],1842:[,230],1843:[,230],1844:[,220],1845:[,230],1846:[,230],1847:[,220],1848:[,220],1849:[,220],1850:[,230],1851:[,220],1852:[,220],1853:[,230],1854:[,220],1855:[,230],1856:[,230],1857:[,230],1858:[,220],1859:[,230],1860:[,220],1861:[,230],1862:[,220],1863:[,230],1864:[,220],1865:[,230],1866:[,230],2027:[,230],2028:[,230],2029:[,230],2030:[,230],2031:[,230],2032:[,230],2033:[,230],2034:[,220],2035:[,230]},
2048:{2070:[,230],2071:[,230],2072:[,230],2073:[,230],2075:[,230],2076:[,230],2077:[,230],2078:[,230],2079:[,230],2080:[,230],2081:[,230],2082:[,230],2083:[,230],2085:[,230],2086:[,230],2087:[,230],2089:[,230],2090:[,230],2091:[,230],2092:[,230],2093:[,230],2137:[,220],2138:[,220],2139:[,220],2276:[,230],2277:[,230],2278:[,220],2279:[,230],2280:[,230],2281:[,220],2282:[,230],2283:[,230],2284:[,230],2285:[,220],2286:[,220],2287:[,220],2288:[,27],2289:[,28],2290:[,29],2291:[,230],2292:[,230],2293:[,230],2294:[,220],2295:[,230],2296:[,230],2297:[,220],2298:[,220],2299:[,230],2300:[,230],2301:[,230],2302:[,230],2303:[,230]},
2304:{2344:[,,{2364:2345}],2345:[[2344,2364]],2352:[,,{2364:2353}],2353:[[2352,2364]],2355:[,,{2364:2356}],2356:[[2355,2364]],2364:[,7],2381:[,9],2385:[,230],2386:[,220],2387:[,230],2388:[,230],2392:[[2325,2364],512],2393:[[2326,2364],512],2394:[[2327,2364],512],2395:[[2332,2364],512],2396:[[2337,2364],512],2397:[[2338,2364],512],2398:[[2347,2364],512],2399:[[2351,2364],512],2492:[,7],2503:[,,{2494:2507,2519:2508}],2507:[[2503,2494]],2508:[[2503,2519]],2509:[,9],2524:[[2465,2492],512],2525:[[2466,2492],512],2527:[[2479,2492],512]},
2560:{2611:[[2610,2620],512],2614:[[2616,2620],512],2620:[,7],2637:[,9],2649:[[2582,2620],512],2650:[[2583,2620],512],2651:[[2588,2620],512],2654:[[2603,2620],512],2748:[,7],2765:[,9],68109:[,220],68111:[,230],68152:[,230],68153:[,1],68154:[,220],68159:[,9],68325:[,230],68326:[,220]},
2816:{2876:[,7],2887:[,,{2878:2891,2902:2888,2903:2892}],2888:[[2887,2902]],2891:[[2887,2878]],2892:[[2887,2903]],2893:[,9],2908:[[2849,2876],512],2909:[[2850,2876],512],2962:[,,{3031:2964}],2964:[[2962,3031]],3014:[,,{3006:3018,3031:3020}],3015:[,,{3006:3019}],3018:[[3014,3006]],3019:[[3015,3006]],3020:[[3014,3031]],3021:[,9]},
3072:{3142:[,,{3158:3144}],3144:[[3142,3158]],3149:[,9],3157:[,84],3158:[,91],3260:[,7],3263:[,,{3285:3264}],3264:[[3263,3285]],3270:[,,{3266:3274,3285:3271,3286:3272}],3271:[[3270,3285]],3272:[[3270,3286]],3274:[[3270,3266],,{3285:3275}],3275:[[3274,3285]],3277:[,9]},
3328:{3398:[,,{3390:3402,3415:3404}],3399:[,,{3390:3403}],3402:[[3398,3390]],3403:[[3399,3390]],3404:[[3398,3415]],3405:[,9],3530:[,9],3545:[,,{3530:3546,3535:3548,3551:3550}],3546:[[3545,3530]],3548:[[3545,3535],,{3530:3549}],3549:[[3548,3530]],3550:[[3545,3551]]},
3584:{3635:[[3661,3634],256],3640:[,103],3641:[,103],3642:[,9],3656:[,107],3657:[,107],3658:[,107],3659:[,107],3763:[[3789,3762],256],3768:[,118],3769:[,118],3784:[,122],3785:[,122],3786:[,122],3787:[,122],3804:[[3755,3737],256],3805:[[3755,3745],256]},
3840:{3852:[[3851],256],3864:[,220],3865:[,220],3893:[,220],3895:[,220],3897:[,216],3907:[[3906,4023],512],3917:[[3916,4023],512],3922:[[3921,4023],512],3927:[[3926,4023],512],3932:[[3931,4023],512],3945:[[3904,4021],512],3953:[,129],3954:[,130],3955:[[3953,3954],512],3956:[,132],3957:[[3953,3956],512],3958:[[4018,3968],512],3959:[[4018,3969],256],3960:[[4019,3968],512],3961:[[4019,3969],256],3962:[,130],3963:[,130],3964:[,130],3965:[,130],3968:[,130],3969:[[3953,3968],512],3970:[,230],3971:[,230],3972:[,9],3974:[,230],3975:[,230],3987:[[3986,4023],512],3997:[[3996,4023],512],4002:[[4001,4023],512],4007:[[4006,4023],512],4012:[[4011,4023],512],4025:[[3984,4021],512],4038:[,220]},
4096:{4133:[,,{4142:4134}],4134:[[4133,4142]],4151:[,7],4153:[,9],4154:[,9],4237:[,220],4348:[[4316],256],69702:[,9],69759:[,9],69785:[,,{69818:69786}],69786:[[69785,69818]],69787:[,,{69818:69788}],69788:[[69787,69818]],69797:[,,{69818:69803}],69803:[[69797,69818]],69817:[,9],69818:[,7]},
4352:{69888:[,230],69889:[,230],69890:[,230],69934:[[69937,69927]],69935:[[69938,69927]],69937:[,,{69927:69934}],69938:[,,{69927:69935}],69939:[,9],69940:[,9],70003:[,7],70080:[,9]},
4608:{70197:[,9],70198:[,7],70377:[,7],70378:[,9]},
4864:{4957:[,230],4958:[,230],4959:[,230],70460:[,7],70471:[,,{70462:70475,70487:70476}],70475:[[70471,70462]],70476:[[70471,70487]],70477:[,9],70502:[,230],70503:[,230],70504:[,230],70505:[,230],70506:[,230],70507:[,230],70508:[,230],70512:[,230],70513:[,230],70514:[,230],70515:[,230],70516:[,230]},
5120:{70841:[,,{70832:70844,70842:70843,70845:70846}],70843:[[70841,70842]],70844:[[70841,70832]],70846:[[70841,70845]],70850:[,9],70851:[,7]},
5376:{71096:[,,{71087:71098}],71097:[,,{71087:71099}],71098:[[71096,71087]],71099:[[71097,71087]],71103:[,9],71104:[,7]},
5632:{71231:[,9],71350:[,9],71351:[,7]},
5888:{5908:[,9],5940:[,9],6098:[,9],6109:[,230]},
6144:{6313:[,228]},
6400:{6457:[,222],6458:[,230],6459:[,220]},
6656:{6679:[,230],6680:[,220],6752:[,9],6773:[,230],6774:[,230],6775:[,230],6776:[,230],6777:[,230],6778:[,230],6779:[,230],6780:[,230],6783:[,220],6832:[,230],6833:[,230],6834:[,230],6835:[,230],6836:[,230],6837:[,220],6838:[,220],6839:[,220],6840:[,220],6841:[,220],6842:[,220],6843:[,230],6844:[,230],6845:[,220]},
6912:{6917:[,,{6965:6918}],6918:[[6917,6965]],6919:[,,{6965:6920}],6920:[[6919,6965]],6921:[,,{6965:6922}],6922:[[6921,6965]],6923:[,,{6965:6924}],6924:[[6923,6965]],6925:[,,{6965:6926}],6926:[[6925,6965]],6929:[,,{6965:6930}],6930:[[6929,6965]],6964:[,7],6970:[,,{6965:6971}],6971:[[6970,6965]],6972:[,,{6965:6973}],6973:[[6972,6965]],6974:[,,{6965:6976}],6975:[,,{6965:6977}],6976:[[6974,6965]],6977:[[6975,6965]],6978:[,,{6965:6979}],6979:[[6978,6965]],6980:[,9],7019:[,230],7020:[,220],7021:[,230],7022:[,230],7023:[,230],7024:[,230],7025:[,230],7026:[,230],7027:[,230],7082:[,9],7083:[,9],7142:[,7],7154:[,9],7155:[,9]},
7168:{7223:[,7],7376:[,230],7377:[,230],7378:[,230],7380:[,1],7381:[,220],7382:[,220],7383:[,220],7384:[,220],7385:[,220],7386:[,230],7387:[,230],7388:[,220],7389:[,220],7390:[,220],7391:[,220],7392:[,230],7394:[,1],7395:[,1],7396:[,1],7397:[,1],7398:[,1],7399:[,1],7400:[,1],7405:[,220],7412:[,230],7416:[,230],7417:[,230]},
7424:{7468:[[65],256],7469:[[198],256],7470:[[66],256],7472:[[68],256],7473:[[69],256],7474:[[398],256],7475:[[71],256],7476:[[72],256],7477:[[73],256],7478:[[74],256],7479:[[75],256],7480:[[76],256],7481:[[77],256],7482:[[78],256],7484:[[79],256],7485:[[546],256],7486:[[80],256],7487:[[82],256],7488:[[84],256],7489:[[85],256],7490:[[87],256],7491:[[97],256],7492:[[592],256],7493:[[593],256],7494:[[7426],256],7495:[[98],256],7496:[[100],256],7497:[[101],256],7498:[[601],256],7499:[[603],256],7500:[[604],256],7501:[[103],256],7503:[[107],256],7504:[[109],256],7505:[[331],256],7506:[[111],256],7507:[[596],256],7508:[[7446],256],7509:[[7447],256],7510:[[112],256],7511:[[116],256],7512:[[117],256],7513:[[7453],256],7514:[[623],256],7515:[[118],256],7516:[[7461],256],7517:[[946],256],7518:[[947],256],7519:[[948],256],7520:[[966],256],7521:[[967],256],7522:[[105],256],7523:[[114],256],7524:[[117],256],7525:[[118],256],7526:[[946],256],7527:[[947],256],7528:[[961],256],7529:[[966],256],7530:[[967],256],7544:[[1085],256],7579:[[594],256],7580:[[99],256],7581:[[597],256],7582:[[240],256],7583:[[604],256],7584:[[102],256],7585:[[607],256],7586:[[609],256],7587:[[613],256],7588:[[616],256],7589:[[617],256],7590:[[618],256],7591:[[7547],256],7592:[[669],256],7593:[[621],256],7594:[[7557],256],7595:[[671],256],7596:[[625],256],7597:[[624],256],7598:[[626],256],7599:[[627],256],7600:[[628],256],7601:[[629],256],7602:[[632],256],7603:[[642],256],7604:[[643],256],7605:[[427],256],7606:[[649],256],7607:[[650],256],7608:[[7452],256],7609:[[651],256],7610:[[652],256],7611:[[122],256],7612:[[656],256],7613:[[657],256],7614:[[658],256],7615:[[952],256],7616:[,230],7617:[,230],7618:[,220],7619:[,230],7620:[,230],7621:[,230],7622:[,230],7623:[,230],7624:[,230],7625:[,230],7626:[,220],7627:[,230],7628:[,230],7629:[,234],7630:[,214],7631:[,220],7632:[,202],7633:[,230],7634:[,230],7635:[,230],7636:[,230],7637:[,230],7638:[,230],7639:[,230],7640:[,230],7641:[,230],7642:[,230],7643:[,230],7644:[,230],7645:[,230],7646:[,230],7647:[,230],7648:[,230],7649:[,230],7650:[,230],7651:[,230],7652:[,230],7653:[,230],7654:[,230],7655:[,230],7656:[,230],7657:[,230],7658:[,230],7659:[,230],7660:[,230],7661:[,230],7662:[,230],7663:[,230],7664:[,230],7665:[,230],7666:[,230],7667:[,230],7668:[,230],7669:[,230],7676:[,233],7677:[,220],7678:[,230],7679:[,220]},
7680:{7680:[[65,805]],7681:[[97,805]],7682:[[66,775]],7683:[[98,775]],7684:[[66,803]],7685:[[98,803]],7686:[[66,817]],7687:[[98,817]],7688:[[199,769]],7689:[[231,769]],7690:[[68,775]],7691:[[100,775]],7692:[[68,803]],7693:[[100,803]],7694:[[68,817]],7695:[[100,817]],7696:[[68,807]],7697:[[100,807]],7698:[[68,813]],7699:[[100,813]],7700:[[274,768]],7701:[[275,768]],7702:[[274,769]],7703:[[275,769]],7704:[[69,813]],7705:[[101,813]],7706:[[69,816]],7707:[[101,816]],7708:[[552,774]],7709:[[553,774]],7710:[[70,775]],7711:[[102,775]],7712:[[71,772]],7713:[[103,772]],7714:[[72,775]],7715:[[104,775]],7716:[[72,803]],7717:[[104,803]],7718:[[72,776]],7719:[[104,776]],7720:[[72,807]],7721:[[104,807]],7722:[[72,814]],7723:[[104,814]],7724:[[73,816]],7725:[[105,816]],7726:[[207,769]],7727:[[239,769]],7728:[[75,769]],7729:[[107,769]],7730:[[75,803]],7731:[[107,803]],7732:[[75,817]],7733:[[107,817]],7734:[[76,803],,{772:7736}],7735:[[108,803],,{772:7737}],7736:[[7734,772]],7737:[[7735,772]],7738:[[76,817]],7739:[[108,817]],7740:[[76,813]],7741:[[108,813]],7742:[[77,769]],7743:[[109,769]],7744:[[77,775]],7745:[[109,775]],7746:[[77,803]],7747:[[109,803]],7748:[[78,775]],7749:[[110,775]],7750:[[78,803]],7751:[[110,803]],7752:[[78,817]],7753:[[110,817]],7754:[[78,813]],7755:[[110,813]],7756:[[213,769]],7757:[[245,769]],7758:[[213,776]],7759:[[245,776]],7760:[[332,768]],7761:[[333,768]],7762:[[332,769]],7763:[[333,769]],7764:[[80,769]],7765:[[112,769]],7766:[[80,775]],7767:[[112,775]],7768:[[82,775]],7769:[[114,775]],7770:[[82,803],,{772:7772}],7771:[[114,803],,{772:7773}],7772:[[7770,772]],7773:[[7771,772]],7774:[[82,817]],7775:[[114,817]],7776:[[83,775]],7777:[[115,775]],7778:[[83,803],,{775:7784}],7779:[[115,803],,{775:7785}],7780:[[346,775]],7781:[[347,775]],7782:[[352,775]],7783:[[353,775]],7784:[[7778,775]],7785:[[7779,775]],7786:[[84,775]],7787:[[116,775]],7788:[[84,803]],7789:[[116,803]],7790:[[84,817]],7791:[[116,817]],7792:[[84,813]],7793:[[116,813]],7794:[[85,804]],7795:[[117,804]],7796:[[85,816]],7797:[[117,816]],7798:[[85,813]],7799:[[117,813]],7800:[[360,769]],7801:[[361,769]],7802:[[362,776]],7803:[[363,776]],7804:[[86,771]],7805:[[118,771]],7806:[[86,803]],7807:[[118,803]],7808:[[87,768]],7809:[[119,768]],7810:[[87,769]],7811:[[119,769]],7812:[[87,776]],7813:[[119,776]],7814:[[87,775]],7815:[[119,775]],7816:[[87,803]],7817:[[119,803]],7818:[[88,775]],7819:[[120,775]],7820:[[88,776]],7821:[[120,776]],7822:[[89,775]],7823:[[121,775]],7824:[[90,770]],7825:[[122,770]],7826:[[90,803]],7827:[[122,803]],7828:[[90,817]],7829:[[122,817]],7830:[[104,817]],7831:[[116,776]],7832:[[119,778]],7833:[[121,778]],7834:[[97,702],256],7835:[[383,775]],7840:[[65,803],,{770:7852,774:7862}],7841:[[97,803],,{770:7853,774:7863}],7842:[[65,777]],7843:[[97,777]],7844:[[194,769]],7845:[[226,769]],7846:[[194,768]],7847:[[226,768]],7848:[[194,777]],7849:[[226,777]],7850:[[194,771]],7851:[[226,771]],7852:[[7840,770]],7853:[[7841,770]],7854:[[258,769]],7855:[[259,769]],7856:[[258,768]],7857:[[259,768]],7858:[[258,777]],7859:[[259,777]],7860:[[258,771]],7861:[[259,771]],7862:[[7840,774]],7863:[[7841,774]],7864:[[69,803],,{770:7878}],7865:[[101,803],,{770:7879}],7866:[[69,777]],7867:[[101,777]],7868:[[69,771]],7869:[[101,771]],7870:[[202,769]],7871:[[234,769]],7872:[[202,768]],7873:[[234,768]],7874:[[202,777]],7875:[[234,777]],7876:[[202,771]],7877:[[234,771]],7878:[[7864,770]],7879:[[7865,770]],7880:[[73,777]],7881:[[105,777]],7882:[[73,803]],7883:[[105,803]],7884:[[79,803],,{770:7896}],7885:[[111,803],,{770:7897}],7886:[[79,777]],7887:[[111,777]],7888:[[212,769]],7889:[[244,769]],7890:[[212,768]],7891:[[244,768]],7892:[[212,777]],7893:[[244,777]],7894:[[212,771]],7895:[[244,771]],7896:[[7884,770]],7897:[[7885,770]],7898:[[416,769]],7899:[[417,769]],7900:[[416,768]],7901:[[417,768]],7902:[[416,777]],7903:[[417,777]],7904:[[416,771]],7905:[[417,771]],7906:[[416,803]],7907:[[417,803]],7908:[[85,803]],7909:[[117,803]],7910:[[85,777]],7911:[[117,777]],7912:[[431,769]],7913:[[432,769]],7914:[[431,768]],7915:[[432,768]],7916:[[431,777]],7917:[[432,777]],7918:[[431,771]],7919:[[432,771]],7920:[[431,803]],7921:[[432,803]],7922:[[89,768]],7923:[[121,768]],7924:[[89,803]],7925:[[121,803]],7926:[[89,777]],7927:[[121,777]],7928:[[89,771]],7929:[[121,771]]},
7936:{7936:[[945,787],,{768:7938,769:7940,834:7942,837:8064}],7937:[[945,788],,{768:7939,769:7941,834:7943,837:8065}],7938:[[7936,768],,{837:8066}],7939:[[7937,768],,{837:8067}],7940:[[7936,769],,{837:8068}],7941:[[7937,769],,{837:8069}],7942:[[7936,834],,{837:8070}],7943:[[7937,834],,{837:8071}],7944:[[913,787],,{768:7946,769:7948,834:7950,837:8072}],7945:[[913,788],,{768:7947,769:7949,834:7951,837:8073}],7946:[[7944,768],,{837:8074}],7947:[[7945,768],,{837:8075}],7948:[[7944,769],,{837:8076}],7949:[[7945,769],,{837:8077}],7950:[[7944,834],,{837:8078}],7951:[[7945,834],,{837:8079}],7952:[[949,787],,{768:7954,769:7956}],7953:[[949,788],,{768:7955,769:7957}],7954:[[7952,768]],7955:[[7953,768]],7956:[[7952,769]],7957:[[7953,769]],7960:[[917,787],,{768:7962,769:7964}],7961:[[917,788],,{768:7963,769:7965}],7962:[[7960,768]],7963:[[7961,768]],7964:[[7960,769]],7965:[[7961,769]],7968:[[951,787],,{768:7970,769:7972,834:7974,837:8080}],7969:[[951,788],,{768:7971,769:7973,834:7975,837:8081}],7970:[[7968,768],,{837:8082}],7971:[[7969,768],,{837:8083}],7972:[[7968,769],,{837:8084}],7973:[[7969,769],,{837:8085}],7974:[[7968,834],,{837:8086}],7975:[[7969,834],,{837:8087}],7976:[[919,787],,{768:7978,769:7980,834:7982,837:8088}],7977:[[919,788],,{768:7979,769:7981,834:7983,837:8089}],7978:[[7976,768],,{837:8090}],7979:[[7977,768],,{837:8091}],7980:[[7976,769],,{837:8092}],7981:[[7977,769],,{837:8093}],7982:[[7976,834],,{837:8094}],7983:[[7977,834],,{837:8095}],7984:[[953,787],,{768:7986,769:7988,834:7990}],7985:[[953,788],,{768:7987,769:7989,834:7991}],7986:[[7984,768]],7987:[[7985,768]],7988:[[7984,769]],7989:[[7985,769]],7990:[[7984,834]],7991:[[7985,834]],7992:[[921,787],,{768:7994,769:7996,834:7998}],7993:[[921,788],,{768:7995,769:7997,834:7999}],7994:[[7992,768]],7995:[[7993,768]],7996:[[7992,769]],7997:[[7993,769]],7998:[[7992,834]],7999:[[7993,834]],8000:[[959,787],,{768:8002,769:8004}],8001:[[959,788],,{768:8003,769:8005}],8002:[[8000,768]],8003:[[8001,768]],8004:[[8000,769]],8005:[[8001,769]],8008:[[927,787],,{768:8010,769:8012}],8009:[[927,788],,{768:8011,769:8013}],8010:[[8008,768]],8011:[[8009,768]],8012:[[8008,769]],8013:[[8009,769]],8016:[[965,787],,{768:8018,769:8020,834:8022}],8017:[[965,788],,{768:8019,769:8021,834:8023}],8018:[[8016,768]],8019:[[8017,768]],8020:[[8016,769]],8021:[[8017,769]],8022:[[8016,834]],8023:[[8017,834]],8025:[[933,788],,{768:8027,769:8029,834:8031}],8027:[[8025,768]],8029:[[8025,769]],8031:[[8025,834]],8032:[[969,787],,{768:8034,769:8036,834:8038,837:8096}],8033:[[969,788],,{768:8035,769:8037,834:8039,837:8097}],8034:[[8032,768],,{837:8098}],8035:[[8033,768],,{837:8099}],8036:[[8032,769],,{837:8100}],8037:[[8033,769],,{837:8101}],8038:[[8032,834],,{837:8102}],8039:[[8033,834],,{837:8103}],8040:[[937,787],,{768:8042,769:8044,834:8046,837:8104}],8041:[[937,788],,{768:8043,769:8045,834:8047,837:8105}],8042:[[8040,768],,{837:8106}],8043:[[8041,768],,{837:8107}],8044:[[8040,769],,{837:8108}],8045:[[8041,769],,{837:8109}],8046:[[8040,834],,{837:8110}],8047:[[8041,834],,{837:8111}],8048:[[945,768],,{837:8114}],8049:[[940]],8050:[[949,768]],8051:[[941]],8052:[[951,768],,{837:8130}],8053:[[942]],8054:[[953,768]],8055:[[943]],8056:[[959,768]],8057:[[972]],8058:[[965,768]],8059:[[973]],8060:[[969,768],,{837:8178}],8061:[[974]],8064:[[7936,837]],8065:[[7937,837]],8066:[[7938,837]],8067:[[7939,837]],8068:[[7940,837]],8069:[[7941,837]],8070:[[7942,837]],8071:[[7943,837]],8072:[[7944,837]],8073:[[7945,837]],8074:[[7946,837]],8075:[[7947,837]],8076:[[7948,837]],8077:[[7949,837]],8078:[[7950,837]],8079:[[7951,837]],8080:[[7968,837]],8081:[[7969,837]],8082:[[7970,837]],8083:[[7971,837]],8084:[[7972,837]],8085:[[7973,837]],8086:[[7974,837]],8087:[[7975,837]],8088:[[7976,837]],8089:[[7977,837]],8090:[[7978,837]],8091:[[7979,837]],8092:[[7980,837]],8093:[[7981,837]],8094:[[7982,837]],8095:[[7983,837]],8096:[[8032,837]],8097:[[8033,837]],8098:[[8034,837]],8099:[[8035,837]],8100:[[8036,837]],8101:[[8037,837]],8102:[[8038,837]],8103:[[8039,837]],8104:[[8040,837]],8105:[[8041,837]],8106:[[8042,837]],8107:[[8043,837]],8108:[[8044,837]],8109:[[8045,837]],8110:[[8046,837]],8111:[[8047,837]],8112:[[945,774]],8113:[[945,772]],8114:[[8048,837]],8115:[[945,837]],8116:[[940,837]],8118:[[945,834],,{837:8119}],8119:[[8118,837]],8120:[[913,774]],8121:[[913,772]],8122:[[913,768]],8123:[[902]],8124:[[913,837]],8125:[[32,787],256],8126:[[953]],8127:[[32,787],256,{768:8141,769:8142,834:8143}],8128:[[32,834],256],8129:[[168,834]],8130:[[8052,837]],8131:[[951,837]],8132:[[942,837]],8134:[[951,834],,{837:8135}],8135:[[8134,837]],8136:[[917,768]],8137:[[904]],8138:[[919,768]],8139:[[905]],8140:[[919,837]],8141:[[8127,768]],8142:[[8127,769]],8143:[[8127,834]],8144:[[953,774]],8145:[[953,772]],8146:[[970,768]],8147:[[912]],8150:[[953,834]],8151:[[970,834]],8152:[[921,774]],8153:[[921,772]],8154:[[921,768]],8155:[[906]],8157:[[8190,768]],8158:[[8190,769]],8159:[[8190,834]],8160:[[965,774]],8161:[[965,772]],8162:[[971,768]],8163:[[944]],8164:[[961,787]],8165:[[961,788]],8166:[[965,834]],8167:[[971,834]],8168:[[933,774]],8169:[[933,772]],8170:[[933,768]],8171:[[910]],8172:[[929,788]],8173:[[168,768]],8174:[[901]],8175:[[96]],8178:[[8060,837]],8179:[[969,837]],8180:[[974,837]],8182:[[969,834],,{837:8183}],8183:[[8182,837]],8184:[[927,768]],8185:[[908]],8186:[[937,768]],8187:[[911]],8188:[[937,837]],8189:[[180]],8190:[[32,788],256,{768:8157,769:8158,834:8159}]},
8192:{8192:[[8194]],8193:[[8195]],8194:[[32],256],8195:[[32],256],8196:[[32],256],8197:[[32],256],8198:[[32],256],8199:[[32],256],8200:[[32],256],8201:[[32],256],8202:[[32],256],8209:[[8208],256],8215:[[32,819],256],8228:[[46],256],8229:[[46,46],256],8230:[[46,46,46],256],8239:[[32],256],8243:[[8242,8242],256],8244:[[8242,8242,8242],256],8246:[[8245,8245],256],8247:[[8245,8245,8245],256],8252:[[33,33],256],8254:[[32,773],256],8263:[[63,63],256],8264:[[63,33],256],8265:[[33,63],256],8279:[[8242,8242,8242,8242],256],8287:[[32],256],8304:[[48],256],8305:[[105],256],8308:[[52],256],8309:[[53],256],8310:[[54],256],8311:[[55],256],8312:[[56],256],8313:[[57],256],8314:[[43],256],8315:[[8722],256],8316:[[61],256],8317:[[40],256],8318:[[41],256],8319:[[110],256],8320:[[48],256],8321:[[49],256],8322:[[50],256],8323:[[51],256],8324:[[52],256],8325:[[53],256],8326:[[54],256],8327:[[55],256],8328:[[56],256],8329:[[57],256],8330:[[43],256],8331:[[8722],256],8332:[[61],256],8333:[[40],256],8334:[[41],256],8336:[[97],256],8337:[[101],256],8338:[[111],256],8339:[[120],256],8340:[[601],256],8341:[[104],256],8342:[[107],256],8343:[[108],256],8344:[[109],256],8345:[[110],256],8346:[[112],256],8347:[[115],256],8348:[[116],256],8360:[[82,115],256],8400:[,230],8401:[,230],8402:[,1],8403:[,1],8404:[,230],8405:[,230],8406:[,230],8407:[,230],8408:[,1],8409:[,1],8410:[,1],8411:[,230],8412:[,230],8417:[,230],8421:[,1],8422:[,1],8423:[,230],8424:[,220],8425:[,230],8426:[,1],8427:[,1],8428:[,220],8429:[,220],8430:[,220],8431:[,220],8432:[,230]},
8448:{8448:[[97,47,99],256],8449:[[97,47,115],256],8450:[[67],256],8451:[[176,67],256],8453:[[99,47,111],256],8454:[[99,47,117],256],8455:[[400],256],8457:[[176,70],256],8458:[[103],256],8459:[[72],256],8460:[[72],256],8461:[[72],256],8462:[[104],256],8463:[[295],256],8464:[[73],256],8465:[[73],256],8466:[[76],256],8467:[[108],256],8469:[[78],256],8470:[[78,111],256],8473:[[80],256],8474:[[81],256],8475:[[82],256],8476:[[82],256],8477:[[82],256],8480:[[83,77],256],8481:[[84,69,76],256],8482:[[84,77],256],8484:[[90],256],8486:[[937]],8488:[[90],256],8490:[[75]],8491:[[197]],8492:[[66],256],8493:[[67],256],8495:[[101],256],8496:[[69],256],8497:[[70],256],8499:[[77],256],8500:[[111],256],8501:[[1488],256],8502:[[1489],256],8503:[[1490],256],8504:[[1491],256],8505:[[105],256],8507:[[70,65,88],256],8508:[[960],256],8509:[[947],256],8510:[[915],256],8511:[[928],256],8512:[[8721],256],8517:[[68],256],8518:[[100],256],8519:[[101],256],8520:[[105],256],8521:[[106],256],8528:[[49,8260,55],256],8529:[[49,8260,57],256],8530:[[49,8260,49,48],256],8531:[[49,8260,51],256],8532:[[50,8260,51],256],8533:[[49,8260,53],256],8534:[[50,8260,53],256],8535:[[51,8260,53],256],8536:[[52,8260,53],256],8537:[[49,8260,54],256],8538:[[53,8260,54],256],8539:[[49,8260,56],256],8540:[[51,8260,56],256],8541:[[53,8260,56],256],8542:[[55,8260,56],256],8543:[[49,8260],256],8544:[[73],256],8545:[[73,73],256],8546:[[73,73,73],256],8547:[[73,86],256],8548:[[86],256],8549:[[86,73],256],8550:[[86,73,73],256],8551:[[86,73,73,73],256],8552:[[73,88],256],8553:[[88],256],8554:[[88,73],256],8555:[[88,73,73],256],8556:[[76],256],8557:[[67],256],8558:[[68],256],8559:[[77],256],8560:[[105],256],8561:[[105,105],256],8562:[[105,105,105],256],8563:[[105,118],256],8564:[[118],256],8565:[[118,105],256],8566:[[118,105,105],256],8567:[[118,105,105,105],256],8568:[[105,120],256],8569:[[120],256],8570:[[120,105],256],8571:[[120,105,105],256],8572:[[108],256],8573:[[99],256],8574:[[100],256],8575:[[109],256],8585:[[48,8260,51],256],8592:[,,{824:8602}],8594:[,,{824:8603}],8596:[,,{824:8622}],8602:[[8592,824]],8603:[[8594,824]],8622:[[8596,824]],8653:[[8656,824]],8654:[[8660,824]],8655:[[8658,824]],8656:[,,{824:8653}],8658:[,,{824:8655}],8660:[,,{824:8654}]},
8704:{8707:[,,{824:8708}],8708:[[8707,824]],8712:[,,{824:8713}],8713:[[8712,824]],8715:[,,{824:8716}],8716:[[8715,824]],8739:[,,{824:8740}],8740:[[8739,824]],8741:[,,{824:8742}],8742:[[8741,824]],8748:[[8747,8747],256],8749:[[8747,8747,8747],256],8751:[[8750,8750],256],8752:[[8750,8750,8750],256],8764:[,,{824:8769}],8769:[[8764,824]],8771:[,,{824:8772}],8772:[[8771,824]],8773:[,,{824:8775}],8775:[[8773,824]],8776:[,,{824:8777}],8777:[[8776,824]],8781:[,,{824:8813}],8800:[[61,824]],8801:[,,{824:8802}],8802:[[8801,824]],8804:[,,{824:8816}],8805:[,,{824:8817}],8813:[[8781,824]],8814:[[60,824]],8815:[[62,824]],8816:[[8804,824]],8817:[[8805,824]],8818:[,,{824:8820}],8819:[,,{824:8821}],8820:[[8818,824]],8821:[[8819,824]],8822:[,,{824:8824}],8823:[,,{824:8825}],8824:[[8822,824]],8825:[[8823,824]],8826:[,,{824:8832}],8827:[,,{824:8833}],8828:[,,{824:8928}],8829:[,,{824:8929}],8832:[[8826,824]],8833:[[8827,824]],8834:[,,{824:8836}],8835:[,,{824:8837}],8836:[[8834,824]],8837:[[8835,824]],8838:[,,{824:8840}],8839:[,,{824:8841}],8840:[[8838,824]],8841:[[8839,824]],8849:[,,{824:8930}],8850:[,,{824:8931}],8866:[,,{824:8876}],8872:[,,{824:8877}],8873:[,,{824:8878}],8875:[,,{824:8879}],8876:[[8866,824]],8877:[[8872,824]],8878:[[8873,824]],8879:[[8875,824]],8882:[,,{824:8938}],8883:[,,{824:8939}],8884:[,,{824:8940}],8885:[,,{824:8941}],8928:[[8828,824]],8929:[[8829,824]],8930:[[8849,824]],8931:[[8850,824]],8938:[[8882,824]],8939:[[8883,824]],8940:[[8884,824]],8941:[[8885,824]]},
8960:{9001:[[12296]],9002:[[12297]]},
9216:{9312:[[49],256],9313:[[50],256],9314:[[51],256],9315:[[52],256],9316:[[53],256],9317:[[54],256],9318:[[55],256],9319:[[56],256],9320:[[57],256],9321:[[49,48],256],9322:[[49,49],256],9323:[[49,50],256],9324:[[49,51],256],9325:[[49,52],256],9326:[[49,53],256],9327:[[49,54],256],9328:[[49,55],256],9329:[[49,56],256],9330:[[49,57],256],9331:[[50,48],256],9332:[[40,49,41],256],9333:[[40,50,41],256],9334:[[40,51,41],256],9335:[[40,52,41],256],9336:[[40,53,41],256],9337:[[40,54,41],256],9338:[[40,55,41],256],9339:[[40,56,41],256],9340:[[40,57,41],256],9341:[[40,49,48,41],256],9342:[[40,49,49,41],256],9343:[[40,49,50,41],256],9344:[[40,49,51,41],256],9345:[[40,49,52,41],256],9346:[[40,49,53,41],256],9347:[[40,49,54,41],256],9348:[[40,49,55,41],256],9349:[[40,49,56,41],256],9350:[[40,49,57,41],256],9351:[[40,50,48,41],256],9352:[[49,46],256],9353:[[50,46],256],9354:[[51,46],256],9355:[[52,46],256],9356:[[53,46],256],9357:[[54,46],256],9358:[[55,46],256],9359:[[56,46],256],9360:[[57,46],256],9361:[[49,48,46],256],9362:[[49,49,46],256],9363:[[49,50,46],256],9364:[[49,51,46],256],9365:[[49,52,46],256],9366:[[49,53,46],256],9367:[[49,54,46],256],9368:[[49,55,46],256],9369:[[49,56,46],256],9370:[[49,57,46],256],9371:[[50,48,46],256],9372:[[40,97,41],256],9373:[[40,98,41],256],9374:[[40,99,41],256],9375:[[40,100,41],256],9376:[[40,101,41],256],9377:[[40,102,41],256],9378:[[40,103,41],256],9379:[[40,104,41],256],9380:[[40,105,41],256],9381:[[40,106,41],256],9382:[[40,107,41],256],9383:[[40,108,41],256],9384:[[40,109,41],256],9385:[[40,110,41],256],9386:[[40,111,41],256],9387:[[40,112,41],256],9388:[[40,113,41],256],9389:[[40,114,41],256],9390:[[40,115,41],256],9391:[[40,116,41],256],9392:[[40,117,41],256],9393:[[40,118,41],256],9394:[[40,119,41],256],9395:[[40,120,41],256],9396:[[40,121,41],256],9397:[[40,122,41],256],9398:[[65],256],9399:[[66],256],9400:[[67],256],9401:[[68],256],9402:[[69],256],9403:[[70],256],9404:[[71],256],9405:[[72],256],9406:[[73],256],9407:[[74],256],9408:[[75],256],9409:[[76],256],9410:[[77],256],9411:[[78],256],9412:[[79],256],9413:[[80],256],9414:[[81],256],9415:[[82],256],9416:[[83],256],9417:[[84],256],9418:[[85],256],9419:[[86],256],9420:[[87],256],9421:[[88],256],9422:[[89],256],9423:[[90],256],9424:[[97],256],9425:[[98],256],9426:[[99],256],9427:[[100],256],9428:[[101],256],9429:[[102],256],9430:[[103],256],9431:[[104],256],9432:[[105],256],9433:[[106],256],9434:[[107],256],9435:[[108],256],9436:[[109],256],9437:[[110],256],9438:[[111],256],9439:[[112],256],9440:[[113],256],9441:[[114],256],9442:[[115],256],9443:[[116],256],9444:[[117],256],9445:[[118],256],9446:[[119],256],9447:[[120],256],9448:[[121],256],9449:[[122],256],9450:[[48],256]},
10752:{10764:[[8747,8747,8747,8747],256],10868:[[58,58,61],256],10869:[[61,61],256],10870:[[61,61,61],256],10972:[[10973,824],512]},
11264:{11388:[[106],256],11389:[[86],256],11503:[,230],11504:[,230],11505:[,230]},
11520:{11631:[[11617],256],11647:[,9],11744:[,230],11745:[,230],11746:[,230],11747:[,230],11748:[,230],11749:[,230],11750:[,230],11751:[,230],11752:[,230],11753:[,230],11754:[,230],11755:[,230],11756:[,230],11757:[,230],11758:[,230],11759:[,230],11760:[,230],11761:[,230],11762:[,230],11763:[,230],11764:[,230],11765:[,230],11766:[,230],11767:[,230],11768:[,230],11769:[,230],11770:[,230],11771:[,230],11772:[,230],11773:[,230],11774:[,230],11775:[,230]},
11776:{11935:[[27597],256],12019:[[40863],256]},
12032:{12032:[[19968],256],12033:[[20008],256],12034:[[20022],256],12035:[[20031],256],12036:[[20057],256],12037:[[20101],256],12038:[[20108],256],12039:[[20128],256],12040:[[20154],256],12041:[[20799],256],12042:[[20837],256],12043:[[20843],256],12044:[[20866],256],12045:[[20886],256],12046:[[20907],256],12047:[[20960],256],12048:[[20981],256],12049:[[20992],256],12050:[[21147],256],12051:[[21241],256],12052:[[21269],256],12053:[[21274],256],12054:[[21304],256],12055:[[21313],256],12056:[[21340],256],12057:[[21353],256],12058:[[21378],256],12059:[[21430],256],12060:[[21448],256],12061:[[21475],256],12062:[[22231],256],12063:[[22303],256],12064:[[22763],256],12065:[[22786],256],12066:[[22794],256],12067:[[22805],256],12068:[[22823],256],12069:[[22899],256],12070:[[23376],256],12071:[[23424],256],12072:[[23544],256],12073:[[23567],256],12074:[[23586],256],12075:[[23608],256],12076:[[23662],256],12077:[[23665],256],12078:[[24027],256],12079:[[24037],256],12080:[[24049],256],12081:[[24062],256],12082:[[24178],256],12083:[[24186],256],12084:[[24191],256],12085:[[24308],256],12086:[[24318],256],12087:[[24331],256],12088:[[24339],256],12089:[[24400],256],12090:[[24417],256],12091:[[24435],256],12092:[[24515],256],12093:[[25096],256],12094:[[25142],256],12095:[[25163],256],12096:[[25903],256],12097:[[25908],256],12098:[[25991],256],12099:[[26007],256],12100:[[26020],256],12101:[[26041],256],12102:[[26080],256],12103:[[26085],256],12104:[[26352],256],12105:[[26376],256],12106:[[26408],256],12107:[[27424],256],12108:[[27490],256],12109:[[27513],256],12110:[[27571],256],12111:[[27595],256],12112:[[27604],256],12113:[[27611],256],12114:[[27663],256],12115:[[27668],256],12116:[[27700],256],12117:[[28779],256],12118:[[29226],256],12119:[[29238],256],12120:[[29243],256],12121:[[29247],256],12122:[[29255],256],12123:[[29273],256],12124:[[29275],256],12125:[[29356],256],12126:[[29572],256],12127:[[29577],256],12128:[[29916],256],12129:[[29926],256],12130:[[29976],256],12131:[[29983],256],12132:[[29992],256],12133:[[30000],256],12134:[[30091],256],12135:[[30098],256],12136:[[30326],256],12137:[[30333],256],12138:[[30382],256],12139:[[30399],256],12140:[[30446],256],12141:[[30683],256],12142:[[30690],256],12143:[[30707],256],12144:[[31034],256],12145:[[31160],256],12146:[[31166],256],12147:[[31348],256],12148:[[31435],256],12149:[[31481],256],12150:[[31859],256],12151:[[31992],256],12152:[[32566],256],12153:[[32593],256],12154:[[32650],256],12155:[[32701],256],12156:[[32769],256],12157:[[32780],256],12158:[[32786],256],12159:[[32819],256],12160:[[32895],256],12161:[[32905],256],12162:[[33251],256],12163:[[33258],256],12164:[[33267],256],12165:[[33276],256],12166:[[33292],256],12167:[[33307],256],12168:[[33311],256],12169:[[33390],256],12170:[[33394],256],12171:[[33400],256],12172:[[34381],256],12173:[[34411],256],12174:[[34880],256],12175:[[34892],256],12176:[[34915],256],12177:[[35198],256],12178:[[35211],256],12179:[[35282],256],12180:[[35328],256],12181:[[35895],256],12182:[[35910],256],12183:[[35925],256],12184:[[35960],256],12185:[[35997],256],12186:[[36196],256],12187:[[36208],256],12188:[[36275],256],12189:[[36523],256],12190:[[36554],256],12191:[[36763],256],12192:[[36784],256],12193:[[36789],256],12194:[[37009],256],12195:[[37193],256],12196:[[37318],256],12197:[[37324],256],12198:[[37329],256],12199:[[38263],256],12200:[[38272],256],12201:[[38428],256],12202:[[38582],256],12203:[[38585],256],12204:[[38632],256],12205:[[38737],256],12206:[[38750],256],12207:[[38754],256],12208:[[38761],256],12209:[[38859],256],12210:[[38893],256],12211:[[38899],256],12212:[[38913],256],12213:[[39080],256],12214:[[39131],256],12215:[[39135],256],12216:[[39318],256],12217:[[39321],256],12218:[[39340],256],12219:[[39592],256],12220:[[39640],256],12221:[[39647],256],12222:[[39717],256],12223:[[39727],256],12224:[[39730],256],12225:[[39740],256],12226:[[39770],256],12227:[[40165],256],12228:[[40565],256],12229:[[40575],256],12230:[[40613],256],12231:[[40635],256],12232:[[40643],256],12233:[[40653],256],12234:[[40657],256],12235:[[40697],256],12236:[[40701],256],12237:[[40718],256],12238:[[40723],256],12239:[[40736],256],12240:[[40763],256],12241:[[40778],256],12242:[[40786],256],12243:[[40845],256],12244:[[40860],256],12245:[[40864],256]},
12288:{12288:[[32],256],12330:[,218],12331:[,228],12332:[,232],12333:[,222],12334:[,224],12335:[,224],12342:[[12306],256],12344:[[21313],256],12345:[[21316],256],12346:[[21317],256],12358:[,,{12441:12436}],12363:[,,{12441:12364}],12364:[[12363,12441]],12365:[,,{12441:12366}],12366:[[12365,12441]],12367:[,,{12441:12368}],12368:[[12367,12441]],12369:[,,{12441:12370}],12370:[[12369,12441]],12371:[,,{12441:12372}],12372:[[12371,12441]],12373:[,,{12441:12374}],12374:[[12373,12441]],12375:[,,{12441:12376}],12376:[[12375,12441]],12377:[,,{12441:12378}],12378:[[12377,12441]],12379:[,,{12441:12380}],12380:[[12379,12441]],12381:[,,{12441:12382}],12382:[[12381,12441]],12383:[,,{12441:12384}],12384:[[12383,12441]],12385:[,,{12441:12386}],12386:[[12385,12441]],12388:[,,{12441:12389}],12389:[[12388,12441]],12390:[,,{12441:12391}],12391:[[12390,12441]],12392:[,,{12441:12393}],12393:[[12392,12441]],12399:[,,{12441:12400,12442:12401}],12400:[[12399,12441]],12401:[[12399,12442]],12402:[,,{12441:12403,12442:12404}],12403:[[12402,12441]],12404:[[12402,12442]],12405:[,,{12441:12406,12442:12407}],12406:[[12405,12441]],12407:[[12405,12442]],12408:[,,{12441:12409,12442:12410}],12409:[[12408,12441]],12410:[[12408,12442]],12411:[,,{12441:12412,12442:12413}],12412:[[12411,12441]],12413:[[12411,12442]],12436:[[12358,12441]],12441:[,8],12442:[,8],12443:[[32,12441],256],12444:[[32,12442],256],12445:[,,{12441:12446}],12446:[[12445,12441]],12447:[[12424,12426],256],12454:[,,{12441:12532}],12459:[,,{12441:12460}],12460:[[12459,12441]],12461:[,,{12441:12462}],12462:[[12461,12441]],12463:[,,{12441:12464}],12464:[[12463,12441]],12465:[,,{12441:12466}],12466:[[12465,12441]],12467:[,,{12441:12468}],12468:[[12467,12441]],12469:[,,{12441:12470}],12470:[[12469,12441]],12471:[,,{12441:12472}],12472:[[12471,12441]],12473:[,,{12441:12474}],12474:[[12473,12441]],12475:[,,{12441:12476}],12476:[[12475,12441]],12477:[,,{12441:12478}],12478:[[12477,12441]],12479:[,,{12441:12480}],12480:[[12479,12441]],12481:[,,{12441:12482}],12482:[[12481,12441]],12484:[,,{12441:12485}],12485:[[12484,12441]],12486:[,,{12441:12487}],12487:[[12486,12441]],12488:[,,{12441:12489}],12489:[[12488,12441]],12495:[,,{12441:12496,12442:12497}],12496:[[12495,12441]],12497:[[12495,12442]],12498:[,,{12441:12499,12442:12500}],12499:[[12498,12441]],12500:[[12498,12442]],12501:[,,{12441:12502,12442:12503}],12502:[[12501,12441]],12503:[[12501,12442]],12504:[,,{12441:12505,12442:12506}],12505:[[12504,12441]],12506:[[12504,12442]],12507:[,,{12441:12508,12442:12509}],12508:[[12507,12441]],12509:[[12507,12442]],12527:[,,{12441:12535}],12528:[,,{12441:12536}],12529:[,,{12441:12537}],12530:[,,{12441:12538}],12532:[[12454,12441]],12535:[[12527,12441]],12536:[[12528,12441]],12537:[[12529,12441]],12538:[[12530,12441]],12541:[,,{12441:12542}],12542:[[12541,12441]],12543:[[12467,12488],256]},
12544:{12593:[[4352],256],12594:[[4353],256],12595:[[4522],256],12596:[[4354],256],12597:[[4524],256],12598:[[4525],256],12599:[[4355],256],12600:[[4356],256],12601:[[4357],256],12602:[[4528],256],12603:[[4529],256],12604:[[4530],256],12605:[[4531],256],12606:[[4532],256],12607:[[4533],256],12608:[[4378],256],12609:[[4358],256],12610:[[4359],256],12611:[[4360],256],12612:[[4385],256],12613:[[4361],256],12614:[[4362],256],12615:[[4363],256],12616:[[4364],256],12617:[[4365],256],12618:[[4366],256],12619:[[4367],256],12620:[[4368],256],12621:[[4369],256],12622:[[4370],256],12623:[[4449],256],12624:[[4450],256],12625:[[4451],256],12626:[[4452],256],12627:[[4453],256],12628:[[4454],256],12629:[[4455],256],12630:[[4456],256],12631:[[4457],256],12632:[[4458],256],12633:[[4459],256],12634:[[4460],256],12635:[[4461],256],12636:[[4462],256],12637:[[4463],256],12638:[[4464],256],12639:[[4465],256],12640:[[4466],256],12641:[[4467],256],12642:[[4468],256],12643:[[4469],256],12644:[[4448],256],12645:[[4372],256],12646:[[4373],256],12647:[[4551],256],12648:[[4552],256],12649:[[4556],256],12650:[[4558],256],12651:[[4563],256],12652:[[4567],256],12653:[[4569],256],12654:[[4380],256],12655:[[4573],256],12656:[[4575],256],12657:[[4381],256],12658:[[4382],256],12659:[[4384],256],12660:[[4386],256],12661:[[4387],256],12662:[[4391],256],12663:[[4393],256],12664:[[4395],256],12665:[[4396],256],12666:[[4397],256],12667:[[4398],256],12668:[[4399],256],12669:[[4402],256],12670:[[4406],256],12671:[[4416],256],12672:[[4423],256],12673:[[4428],256],12674:[[4593],256],12675:[[4594],256],12676:[[4439],256],12677:[[4440],256],12678:[[4441],256],12679:[[4484],256],12680:[[4485],256],12681:[[4488],256],12682:[[4497],256],12683:[[4498],256],12684:[[4500],256],12685:[[4510],256],12686:[[4513],256],12690:[[19968],256],12691:[[20108],256],12692:[[19977],256],12693:[[22235],256],12694:[[19978],256],12695:[[20013],256],12696:[[19979],256],12697:[[30002],256],12698:[[20057],256],12699:[[19993],256],12700:[[19969],256],12701:[[22825],256],12702:[[22320],256],12703:[[20154],256]},
12800:{12800:[[40,4352,41],256],12801:[[40,4354,41],256],12802:[[40,4355,41],256],12803:[[40,4357,41],256],12804:[[40,4358,41],256],12805:[[40,4359,41],256],12806:[[40,4361,41],256],12807:[[40,4363,41],256],12808:[[40,4364,41],256],12809:[[40,4366,41],256],12810:[[40,4367,41],256],12811:[[40,4368,41],256],12812:[[40,4369,41],256],12813:[[40,4370,41],256],12814:[[40,4352,4449,41],256],12815:[[40,4354,4449,41],256],12816:[[40,4355,4449,41],256],12817:[[40,4357,4449,41],256],12818:[[40,4358,4449,41],256],12819:[[40,4359,4449,41],256],12820:[[40,4361,4449,41],256],12821:[[40,4363,4449,41],256],12822:[[40,4364,4449,41],256],12823:[[40,4366,4449,41],256],12824:[[40,4367,4449,41],256],12825:[[40,4368,4449,41],256],12826:[[40,4369,4449,41],256],12827:[[40,4370,4449,41],256],12828:[[40,4364,4462,41],256],12829:[[40,4363,4457,4364,4453,4523,41],256],12830:[[40,4363,4457,4370,4462,41],256],12832:[[40,19968,41],256],12833:[[40,20108,41],256],12834:[[40,19977,41],256],12835:[[40,22235,41],256],12836:[[40,20116,41],256],12837:[[40,20845,41],256],12838:[[40,19971,41],256],12839:[[40,20843,41],256],12840:[[40,20061,41],256],12841:[[40,21313,41],256],12842:[[40,26376,41],256],12843:[[40,28779,41],256],12844:[[40,27700,41],256],12845:[[40,26408,41],256],12846:[[40,37329,41],256],12847:[[40,22303,41],256],12848:[[40,26085,41],256],12849:[[40,26666,41],256],12850:[[40,26377,41],256],12851:[[40,31038,41],256],12852:[[40,21517,41],256],12853:[[40,29305,41],256],12854:[[40,36001,41],256],12855:[[40,31069,41],256],12856:[[40,21172,41],256],12857:[[40,20195,41],256],12858:[[40,21628,41],256],12859:[[40,23398,41],256],12860:[[40,30435,41],256],12861:[[40,20225,41],256],12862:[[40,36039,41],256],12863:[[40,21332,41],256],12864:[[40,31085,41],256],12865:[[40,20241,41],256],12866:[[40,33258,41],256],12867:[[40,33267,41],256],12868:[[21839],256],12869:[[24188],256],12870:[[25991],256],12871:[[31631],256],12880:[[80,84,69],256],12881:[[50,49],256],12882:[[50,50],256],12883:[[50,51],256],12884:[[50,52],256],12885:[[50,53],256],12886:[[50,54],256],12887:[[50,55],256],12888:[[50,56],256],12889:[[50,57],256],12890:[[51,48],256],12891:[[51,49],256],12892:[[51,50],256],12893:[[51,51],256],12894:[[51,52],256],12895:[[51,53],256],12896:[[4352],256],12897:[[4354],256],12898:[[4355],256],12899:[[4357],256],12900:[[4358],256],12901:[[4359],256],12902:[[4361],256],12903:[[4363],256],12904:[[4364],256],12905:[[4366],256],12906:[[4367],256],12907:[[4368],256],12908:[[4369],256],12909:[[4370],256],12910:[[4352,4449],256],12911:[[4354,4449],256],12912:[[4355,4449],256],12913:[[4357,4449],256],12914:[[4358,4449],256],12915:[[4359,4449],256],12916:[[4361,4449],256],12917:[[4363,4449],256],12918:[[4364,4449],256],12919:[[4366,4449],256],12920:[[4367,4449],256],12921:[[4368,4449],256],12922:[[4369,4449],256],12923:[[4370,4449],256],12924:[[4366,4449,4535,4352,4457],256],12925:[[4364,4462,4363,4468],256],12926:[[4363,4462],256],12928:[[19968],256],12929:[[20108],256],12930:[[19977],256],12931:[[22235],256],12932:[[20116],256],12933:[[20845],256],12934:[[19971],256],12935:[[20843],256],12936:[[20061],256],12937:[[21313],256],12938:[[26376],256],12939:[[28779],256],12940:[[27700],256],12941:[[26408],256],12942:[[37329],256],12943:[[22303],256],12944:[[26085],256],12945:[[26666],256],12946:[[26377],256],12947:[[31038],256],12948:[[21517],256],12949:[[29305],256],12950:[[36001],256],12951:[[31069],256],12952:[[21172],256],12953:[[31192],256],12954:[[30007],256],12955:[[22899],256],12956:[[36969],256],12957:[[20778],256],12958:[[21360],256],12959:[[27880],256],12960:[[38917],256],12961:[[20241],256],12962:[[20889],256],12963:[[27491],256],12964:[[19978],256],12965:[[20013],256],12966:[[19979],256],12967:[[24038],256],12968:[[21491],256],12969:[[21307],256],12970:[[23447],256],12971:[[23398],256],12972:[[30435],256],12973:[[20225],256],12974:[[36039],256],12975:[[21332],256],12976:[[22812],256],12977:[[51,54],256],12978:[[51,55],256],12979:[[51,56],256],12980:[[51,57],256],12981:[[52,48],256],12982:[[52,49],256],12983:[[52,50],256],12984:[[52,51],256],12985:[[52,52],256],12986:[[52,53],256],12987:[[52,54],256],12988:[[52,55],256],12989:[[52,56],256],12990:[[52,57],256],12991:[[53,48],256],12992:[[49,26376],256],12993:[[50,26376],256],12994:[[51,26376],256],12995:[[52,26376],256],12996:[[53,26376],256],12997:[[54,26376],256],12998:[[55,26376],256],12999:[[56,26376],256],13000:[[57,26376],256],13001:[[49,48,26376],256],13002:[[49,49,26376],256],13003:[[49,50,26376],256],13004:[[72,103],256],13005:[[101,114,103],256],13006:[[101,86],256],13007:[[76,84,68],256],13008:[[12450],256],13009:[[12452],256],13010:[[12454],256],13011:[[12456],256],13012:[[12458],256],13013:[[12459],256],13014:[[12461],256],13015:[[12463],256],13016:[[12465],256],13017:[[12467],256],13018:[[12469],256],13019:[[12471],256],13020:[[12473],256],13021:[[12475],256],13022:[[12477],256],13023:[[12479],256],13024:[[12481],256],13025:[[12484],256],13026:[[12486],256],13027:[[12488],256],13028:[[12490],256],13029:[[12491],256],13030:[[12492],256],13031:[[12493],256],13032:[[12494],256],13033:[[12495],256],13034:[[12498],256],13035:[[12501],256],13036:[[12504],256],13037:[[12507],256],13038:[[12510],256],13039:[[12511],256],13040:[[12512],256],13041:[[12513],256],13042:[[12514],256],13043:[[12516],256],13044:[[12518],256],13045:[[12520],256],13046:[[12521],256],13047:[[12522],256],13048:[[12523],256],13049:[[12524],256],13050:[[12525],256],13051:[[12527],256],13052:[[12528],256],13053:[[12529],256],13054:[[12530],256]},
13056:{13056:[[12450,12497,12540,12488],256],13057:[[12450,12523,12501,12449],256],13058:[[12450,12531,12506,12450],256],13059:[[12450,12540,12523],256],13060:[[12452,12491,12531,12464],256],13061:[[12452,12531,12481],256],13062:[[12454,12457,12531],256],13063:[[12456,12473,12463,12540,12489],256],13064:[[12456,12540,12459,12540],256],13065:[[12458,12531,12473],256],13066:[[12458,12540,12512],256],13067:[[12459,12452,12522],256],13068:[[12459,12521,12483,12488],256],13069:[[12459,12525,12522,12540],256],13070:[[12460,12525,12531],256],13071:[[12460,12531,12510],256],13072:[[12462,12460],256],13073:[[12462,12491,12540],256],13074:[[12461,12517,12522,12540],256],13075:[[12462,12523,12480,12540],256],13076:[[12461,12525],256],13077:[[12461,12525,12464,12521,12512],256],13078:[[12461,12525,12513,12540,12488,12523],256],13079:[[12461,12525,12527,12483,12488],256],13080:[[12464,12521,12512],256],13081:[[12464,12521,12512,12488,12531],256],13082:[[12463,12523,12476,12452,12525],256],13083:[[12463,12525,12540,12493],256],13084:[[12465,12540,12473],256],13085:[[12467,12523,12490],256],13086:[[12467,12540,12509],256],13087:[[12469,12452,12463,12523],256],13088:[[12469,12531,12481,12540,12512],256],13089:[[12471,12522,12531,12464],256],13090:[[12475,12531,12481],256],13091:[[12475,12531,12488],256],13092:[[12480,12540,12473],256],13093:[[12487,12471],256],13094:[[12489,12523],256],13095:[[12488,12531],256],13096:[[12490,12494],256],13097:[[12494,12483,12488],256],13098:[[12495,12452,12484],256],13099:[[12497,12540,12475,12531,12488],256],13100:[[12497,12540,12484],256],13101:[[12496,12540,12524,12523],256],13102:[[12500,12450,12473,12488,12523],256],13103:[[12500,12463,12523],256],13104:[[12500,12467],256],13105:[[12499,12523],256],13106:[[12501,12449,12521,12483,12489],256],13107:[[12501,12451,12540,12488],256],13108:[[12502,12483,12471,12455,12523],256],13109:[[12501,12521,12531],256],13110:[[12504,12463,12479,12540,12523],256],13111:[[12506,12477],256],13112:[[12506,12491,12498],256],13113:[[12504,12523,12484],256],13114:[[12506,12531,12473],256],13115:[[12506,12540,12472],256],13116:[[12505,12540,12479],256],13117:[[12509,12452,12531,12488],256],13118:[[12508,12523,12488],256],13119:[[12507,12531],256],13120:[[12509,12531,12489],256],13121:[[12507,12540,12523],256],13122:[[12507,12540,12531],256],13123:[[12510,12452,12463,12525],256],13124:[[12510,12452,12523],256],13125:[[12510,12483,12495],256],13126:[[12510,12523,12463],256],13127:[[12510,12531,12471,12519,12531],256],13128:[[12511,12463,12525,12531],256],13129:[[12511,12522],256],13130:[[12511,12522,12496,12540,12523],256],13131:[[12513,12460],256],13132:[[12513,12460,12488,12531],256],13133:[[12513,12540,12488,12523],256],13134:[[12516,12540,12489],256],13135:[[12516,12540,12523],256],13136:[[12518,12450,12531],256],13137:[[12522,12483,12488,12523],256],13138:[[12522,12521],256],13139:[[12523,12500,12540],256],13140:[[12523,12540,12502,12523],256],13141:[[12524,12512],256],13142:[[12524,12531,12488,12466,12531],256],13143:[[12527,12483,12488],256],13144:[[48,28857],256],13145:[[49,28857],256],13146:[[50,28857],256],13147:[[51,28857],256],13148:[[52,28857],256],13149:[[53,28857],256],13150:[[54,28857],256],13151:[[55,28857],256],13152:[[56,28857],256],13153:[[57,28857],256],13154:[[49,48,28857],256],13155:[[49,49,28857],256],13156:[[49,50,28857],256],13157:[[49,51,28857],256],13158:[[49,52,28857],256],13159:[[49,53,28857],256],13160:[[49,54,28857],256],13161:[[49,55,28857],256],13162:[[49,56,28857],256],13163:[[49,57,28857],256],13164:[[50,48,28857],256],13165:[[50,49,28857],256],13166:[[50,50,28857],256],13167:[[50,51,28857],256],13168:[[50,52,28857],256],13169:[[104,80,97],256],13170:[[100,97],256],13171:[[65,85],256],13172:[[98,97,114],256],13173:[[111,86],256],13174:[[112,99],256],13175:[[100,109],256],13176:[[100,109,178],256],13177:[[100,109,179],256],13178:[[73,85],256],13179:[[24179,25104],256],13180:[[26157,21644],256],13181:[[22823,27491],256],13182:[[26126,27835],256],13183:[[26666,24335,20250,31038],256],13184:[[112,65],256],13185:[[110,65],256],13186:[[956,65],256],13187:[[109,65],256],13188:[[107,65],256],13189:[[75,66],256],13190:[[77,66],256],13191:[[71,66],256],13192:[[99,97,108],256],13193:[[107,99,97,108],256],13194:[[112,70],256],13195:[[110,70],256],13196:[[956,70],256],13197:[[956,103],256],13198:[[109,103],256],13199:[[107,103],256],13200:[[72,122],256],13201:[[107,72,122],256],13202:[[77,72,122],256],13203:[[71,72,122],256],13204:[[84,72,122],256],13205:[[956,8467],256],13206:[[109,8467],256],13207:[[100,8467],256],13208:[[107,8467],256],13209:[[102,109],256],13210:[[110,109],256],13211:[[956,109],256],13212:[[109,109],256],13213:[[99,109],256],13214:[[107,109],256],13215:[[109,109,178],256],13216:[[99,109,178],256],13217:[[109,178],256],13218:[[107,109,178],256],13219:[[109,109,179],256],13220:[[99,109,179],256],13221:[[109,179],256],13222:[[107,109,179],256],13223:[[109,8725,115],256],13224:[[109,8725,115,178],256],13225:[[80,97],256],13226:[[107,80,97],256],13227:[[77,80,97],256],13228:[[71,80,97],256],13229:[[114,97,100],256],13230:[[114,97,100,8725,115],256],13231:[[114,97,100,8725,115,178],256],13232:[[112,115],256],13233:[[110,115],256],13234:[[956,115],256],13235:[[109,115],256],13236:[[112,86],256],13237:[[110,86],256],13238:[[956,86],256],13239:[[109,86],256],13240:[[107,86],256],13241:[[77,86],256],13242:[[112,87],256],13243:[[110,87],256],13244:[[956,87],256],13245:[[109,87],256],13246:[[107,87],256],13247:[[77,87],256],13248:[[107,937],256],13249:[[77,937],256],13250:[[97,46,109,46],256],13251:[[66,113],256],13252:[[99,99],256],13253:[[99,100],256],13254:[[67,8725,107,103],256],13255:[[67,111,46],256],13256:[[100,66],256],13257:[[71,121],256],13258:[[104,97],256],13259:[[72,80],256],13260:[[105,110],256],13261:[[75,75],256],13262:[[75,77],256],13263:[[107,116],256],13264:[[108,109],256],13265:[[108,110],256],13266:[[108,111,103],256],13267:[[108,120],256],13268:[[109,98],256],13269:[[109,105,108],256],13270:[[109,111,108],256],13271:[[80,72],256],13272:[[112,46,109,46],256],13273:[[80,80,77],256],13274:[[80,82],256],13275:[[115,114],256],13276:[[83,118],256],13277:[[87,98],256],13278:[[86,8725,109],256],13279:[[65,8725,109],256],13280:[[49,26085],256],13281:[[50,26085],256],13282:[[51,26085],256],13283:[[52,26085],256],13284:[[53,26085],256],13285:[[54,26085],256],13286:[[55,26085],256],13287:[[56,26085],256],13288:[[57,26085],256],13289:[[49,48,26085],256],13290:[[49,49,26085],256],13291:[[49,50,26085],256],13292:[[49,51,26085],256],13293:[[49,52,26085],256],13294:[[49,53,26085],256],13295:[[49,54,26085],256],13296:[[49,55,26085],256],13297:[[49,56,26085],256],13298:[[49,57,26085],256],13299:[[50,48,26085],256],13300:[[50,49,26085],256],13301:[[50,50,26085],256],13302:[[50,51,26085],256],13303:[[50,52,26085],256],13304:[[50,53,26085],256],13305:[[50,54,26085],256],13306:[[50,55,26085],256],13307:[[50,56,26085],256],13308:[[50,57,26085],256],13309:[[51,48,26085],256],13310:[[51,49,26085],256],13311:[[103,97,108],256]},
27136:{92912:[,1],92913:[,1],92914:[,1],92915:[,1],92916:[,1]},
27392:{92976:[,230],92977:[,230],92978:[,230],92979:[,230],92980:[,230],92981:[,230],92982:[,230]},
42496:{42607:[,230],42612:[,230],42613:[,230],42614:[,230],42615:[,230],42616:[,230],42617:[,230],42618:[,230],42619:[,230],42620:[,230],42621:[,230],42652:[[1098],256],42653:[[1100],256],42655:[,230],42736:[,230],42737:[,230]},
42752:{42864:[[42863],256],43000:[[294],256],43001:[[339],256]},
43008:{43014:[,9],43204:[,9],43232:[,230],43233:[,230],43234:[,230],43235:[,230],43236:[,230],43237:[,230],43238:[,230],43239:[,230],43240:[,230],43241:[,230],43242:[,230],43243:[,230],43244:[,230],43245:[,230],43246:[,230],43247:[,230],43248:[,230],43249:[,230]},
43264:{43307:[,220],43308:[,220],43309:[,220],43347:[,9],43443:[,7],43456:[,9]},
43520:{43696:[,230],43698:[,230],43699:[,230],43700:[,220],43703:[,230],43704:[,230],43710:[,230],43711:[,230],43713:[,230],43766:[,9]},
43776:{43868:[[42791],256],43869:[[43831],256],43870:[[619],256],43871:[[43858],256],44013:[,9]},
48128:{113822:[,1]},
53504:{119134:[[119127,119141],512],119135:[[119128,119141],512],119136:[[119135,119150],512],119137:[[119135,119151],512],119138:[[119135,119152],512],119139:[[119135,119153],512],119140:[[119135,119154],512],119141:[,216],119142:[,216],119143:[,1],119144:[,1],119145:[,1],119149:[,226],119150:[,216],119151:[,216],119152:[,216],119153:[,216],119154:[,216],119163:[,220],119164:[,220],119165:[,220],119166:[,220],119167:[,220],119168:[,220],119169:[,220],119170:[,220],119173:[,230],119174:[,230],119175:[,230],119176:[,230],119177:[,230],119178:[,220],119179:[,220],119210:[,230],119211:[,230],119212:[,230],119213:[,230],119227:[[119225,119141],512],119228:[[119226,119141],512],119229:[[119227,119150],512],119230:[[119228,119150],512],119231:[[119227,119151],512],119232:[[119228,119151],512]},
53760:{119362:[,230],119363:[,230],119364:[,230]},
54272:{119808:[[65],256],119809:[[66],256],119810:[[67],256],119811:[[68],256],119812:[[69],256],119813:[[70],256],119814:[[71],256],119815:[[72],256],119816:[[73],256],119817:[[74],256],119818:[[75],256],119819:[[76],256],119820:[[77],256],119821:[[78],256],119822:[[79],256],119823:[[80],256],119824:[[81],256],119825:[[82],256],119826:[[83],256],119827:[[84],256],119828:[[85],256],119829:[[86],256],119830:[[87],256],119831:[[88],256],119832:[[89],256],119833:[[90],256],119834:[[97],256],119835:[[98],256],119836:[[99],256],119837:[[100],256],119838:[[101],256],119839:[[102],256],119840:[[103],256],119841:[[104],256],119842:[[105],256],119843:[[106],256],119844:[[107],256],119845:[[108],256],119846:[[109],256],119847:[[110],256],119848:[[111],256],119849:[[112],256],119850:[[113],256],119851:[[114],256],119852:[[115],256],119853:[[116],256],119854:[[117],256],119855:[[118],256],119856:[[119],256],119857:[[120],256],119858:[[121],256],119859:[[122],256],119860:[[65],256],119861:[[66],256],119862:[[67],256],119863:[[68],256],119864:[[69],256],119865:[[70],256],119866:[[71],256],119867:[[72],256],119868:[[73],256],119869:[[74],256],119870:[[75],256],119871:[[76],256],119872:[[77],256],119873:[[78],256],119874:[[79],256],119875:[[80],256],119876:[[81],256],119877:[[82],256],119878:[[83],256],119879:[[84],256],119880:[[85],256],119881:[[86],256],119882:[[87],256],119883:[[88],256],119884:[[89],256],119885:[[90],256],119886:[[97],256],119887:[[98],256],119888:[[99],256],119889:[[100],256],119890:[[101],256],119891:[[102],256],119892:[[103],256],119894:[[105],256],119895:[[106],256],119896:[[107],256],119897:[[108],256],119898:[[109],256],119899:[[110],256],119900:[[111],256],119901:[[112],256],119902:[[113],256],119903:[[114],256],119904:[[115],256],119905:[[116],256],119906:[[117],256],119907:[[118],256],119908:[[119],256],119909:[[120],256],119910:[[121],256],119911:[[122],256],119912:[[65],256],119913:[[66],256],119914:[[67],256],119915:[[68],256],119916:[[69],256],119917:[[70],256],119918:[[71],256],119919:[[72],256],119920:[[73],256],119921:[[74],256],119922:[[75],256],119923:[[76],256],119924:[[77],256],119925:[[78],256],119926:[[79],256],119927:[[80],256],119928:[[81],256],119929:[[82],256],119930:[[83],256],119931:[[84],256],119932:[[85],256],119933:[[86],256],119934:[[87],256],119935:[[88],256],119936:[[89],256],119937:[[90],256],119938:[[97],256],119939:[[98],256],119940:[[99],256],119941:[[100],256],119942:[[101],256],119943:[[102],256],119944:[[103],256],119945:[[104],256],119946:[[105],256],119947:[[106],256],119948:[[107],256],119949:[[108],256],119950:[[109],256],119951:[[110],256],119952:[[111],256],119953:[[112],256],119954:[[113],256],119955:[[114],256],119956:[[115],256],119957:[[116],256],119958:[[117],256],119959:[[118],256],119960:[[119],256],119961:[[120],256],119962:[[121],256],119963:[[122],256],119964:[[65],256],119966:[[67],256],119967:[[68],256],119970:[[71],256],119973:[[74],256],119974:[[75],256],119977:[[78],256],119978:[[79],256],119979:[[80],256],119980:[[81],256],119982:[[83],256],119983:[[84],256],119984:[[85],256],119985:[[86],256],119986:[[87],256],119987:[[88],256],119988:[[89],256],119989:[[90],256],119990:[[97],256],119991:[[98],256],119992:[[99],256],119993:[[100],256],119995:[[102],256],119997:[[104],256],119998:[[105],256],119999:[[106],256],120000:[[107],256],120001:[[108],256],120002:[[109],256],120003:[[110],256],120005:[[112],256],120006:[[113],256],120007:[[114],256],120008:[[115],256],120009:[[116],256],120010:[[117],256],120011:[[118],256],120012:[[119],256],120013:[[120],256],120014:[[121],256],120015:[[122],256],120016:[[65],256],120017:[[66],256],120018:[[67],256],120019:[[68],256],120020:[[69],256],120021:[[70],256],120022:[[71],256],120023:[[72],256],120024:[[73],256],120025:[[74],256],120026:[[75],256],120027:[[76],256],120028:[[77],256],120029:[[78],256],120030:[[79],256],120031:[[80],256],120032:[[81],256],120033:[[82],256],120034:[[83],256],120035:[[84],256],120036:[[85],256],120037:[[86],256],120038:[[87],256],120039:[[88],256],120040:[[89],256],120041:[[90],256],120042:[[97],256],120043:[[98],256],120044:[[99],256],120045:[[100],256],120046:[[101],256],120047:[[102],256],120048:[[103],256],120049:[[104],256],120050:[[105],256],120051:[[106],256],120052:[[107],256],120053:[[108],256],120054:[[109],256],120055:[[110],256],120056:[[111],256],120057:[[112],256],120058:[[113],256],120059:[[114],256],120060:[[115],256],120061:[[116],256],120062:[[117],256],120063:[[118],256]},
54528:{120064:[[119],256],120065:[[120],256],120066:[[121],256],120067:[[122],256],120068:[[65],256],120069:[[66],256],120071:[[68],256],120072:[[69],256],120073:[[70],256],120074:[[71],256],120077:[[74],256],120078:[[75],256],120079:[[76],256],120080:[[77],256],120081:[[78],256],120082:[[79],256],120083:[[80],256],120084:[[81],256],120086:[[83],256],120087:[[84],256],120088:[[85],256],120089:[[86],256],120090:[[87],256],120091:[[88],256],120092:[[89],256],120094:[[97],256],120095:[[98],256],120096:[[99],256],120097:[[100],256],120098:[[101],256],120099:[[102],256],120100:[[103],256],120101:[[104],256],120102:[[105],256],120103:[[106],256],120104:[[107],256],120105:[[108],256],120106:[[109],256],120107:[[110],256],120108:[[111],256],120109:[[112],256],120110:[[113],256],120111:[[114],256],120112:[[115],256],120113:[[116],256],120114:[[117],256],120115:[[118],256],120116:[[119],256],120117:[[120],256],120118:[[121],256],120119:[[122],256],120120:[[65],256],120121:[[66],256],120123:[[68],256],120124:[[69],256],120125:[[70],256],120126:[[71],256],120128:[[73],256],120129:[[74],256],120130:[[75],256],120131:[[76],256],120132:[[77],256],120134:[[79],256],120138:[[83],256],120139:[[84],256],120140:[[85],256],120141:[[86],256],120142:[[87],256],120143:[[88],256],120144:[[89],256],120146:[[97],256],120147:[[98],256],120148:[[99],256],120149:[[100],256],120150:[[101],256],120151:[[102],256],120152:[[103],256],120153:[[104],256],120154:[[105],256],120155:[[106],256],120156:[[107],256],120157:[[108],256],120158:[[109],256],120159:[[110],256],120160:[[111],256],120161:[[112],256],120162:[[113],256],120163:[[114],256],120164:[[115],256],120165:[[116],256],120166:[[117],256],120167:[[118],256],120168:[[119],256],120169:[[120],256],120170:[[121],256],120171:[[122],256],120172:[[65],256],120173:[[66],256],120174:[[67],256],120175:[[68],256],120176:[[69],256],120177:[[70],256],120178:[[71],256],120179:[[72],256],120180:[[73],256],120181:[[74],256],120182:[[75],256],120183:[[76],256],120184:[[77],256],120185:[[78],256],120186:[[79],256],120187:[[80],256],120188:[[81],256],120189:[[82],256],120190:[[83],256],120191:[[84],256],120192:[[85],256],120193:[[86],256],120194:[[87],256],120195:[[88],256],120196:[[89],256],120197:[[90],256],120198:[[97],256],120199:[[98],256],120200:[[99],256],120201:[[100],256],120202:[[101],256],120203:[[102],256],120204:[[103],256],120205:[[104],256],120206:[[105],256],120207:[[106],256],120208:[[107],256],120209:[[108],256],120210:[[109],256],120211:[[110],256],120212:[[111],256],120213:[[112],256],120214:[[113],256],120215:[[114],256],120216:[[115],256],120217:[[116],256],120218:[[117],256],120219:[[118],256],120220:[[119],256],120221:[[120],256],120222:[[121],256],120223:[[122],256],120224:[[65],256],120225:[[66],256],120226:[[67],256],120227:[[68],256],120228:[[69],256],120229:[[70],256],120230:[[71],256],120231:[[72],256],120232:[[73],256],120233:[[74],256],120234:[[75],256],120235:[[76],256],120236:[[77],256],120237:[[78],256],120238:[[79],256],120239:[[80],256],120240:[[81],256],120241:[[82],256],120242:[[83],256],120243:[[84],256],120244:[[85],256],120245:[[86],256],120246:[[87],256],120247:[[88],256],120248:[[89],256],120249:[[90],256],120250:[[97],256],120251:[[98],256],120252:[[99],256],120253:[[100],256],120254:[[101],256],120255:[[102],256],120256:[[103],256],120257:[[104],256],120258:[[105],256],120259:[[106],256],120260:[[107],256],120261:[[108],256],120262:[[109],256],120263:[[110],256],120264:[[111],256],120265:[[112],256],120266:[[113],256],120267:[[114],256],120268:[[115],256],120269:[[116],256],120270:[[117],256],120271:[[118],256],120272:[[119],256],120273:[[120],256],120274:[[121],256],120275:[[122],256],120276:[[65],256],120277:[[66],256],120278:[[67],256],120279:[[68],256],120280:[[69],256],120281:[[70],256],120282:[[71],256],120283:[[72],256],120284:[[73],256],120285:[[74],256],120286:[[75],256],120287:[[76],256],120288:[[77],256],120289:[[78],256],120290:[[79],256],120291:[[80],256],120292:[[81],256],120293:[[82],256],120294:[[83],256],120295:[[84],256],120296:[[85],256],120297:[[86],256],120298:[[87],256],120299:[[88],256],120300:[[89],256],120301:[[90],256],120302:[[97],256],120303:[[98],256],120304:[[99],256],120305:[[100],256],120306:[[101],256],120307:[[102],256],120308:[[103],256],120309:[[104],256],120310:[[105],256],120311:[[106],256],120312:[[107],256],120313:[[108],256],120314:[[109],256],120315:[[110],256],120316:[[111],256],120317:[[112],256],120318:[[113],256],120319:[[114],256]},
54784:{120320:[[115],256],120321:[[116],256],120322:[[117],256],120323:[[118],256],120324:[[119],256],120325:[[120],256],120326:[[121],256],120327:[[122],256],120328:[[65],256],120329:[[66],256],120330:[[67],256],120331:[[68],256],120332:[[69],256],120333:[[70],256],120334:[[71],256],120335:[[72],256],120336:[[73],256],120337:[[74],256],120338:[[75],256],120339:[[76],256],120340:[[77],256],120341:[[78],256],120342:[[79],256],120343:[[80],256],120344:[[81],256],120345:[[82],256],120346:[[83],256],120347:[[84],256],120348:[[85],256],120349:[[86],256],120350:[[87],256],120351:[[88],256],120352:[[89],256],120353:[[90],256],120354:[[97],256],120355:[[98],256],120356:[[99],256],120357:[[100],256],120358:[[101],256],120359:[[102],256],120360:[[103],256],120361:[[104],256],120362:[[105],256],120363:[[106],256],120364:[[107],256],120365:[[108],256],120366:[[109],256],120367:[[110],256],120368:[[111],256],120369:[[112],256],120370:[[113],256],120371:[[114],256],120372:[[115],256],120373:[[116],256],120374:[[117],256],120375:[[118],256],120376:[[119],256],120377:[[120],256],120378:[[121],256],120379:[[122],256],120380:[[65],256],120381:[[66],256],120382:[[67],256],120383:[[68],256],120384:[[69],256],120385:[[70],256],120386:[[71],256],120387:[[72],256],120388:[[73],256],120389:[[74],256],120390:[[75],256],120391:[[76],256],120392:[[77],256],120393:[[78],256],120394:[[79],256],120395:[[80],256],120396:[[81],256],120397:[[82],256],120398:[[83],256],120399:[[84],256],120400:[[85],256],120401:[[86],256],120402:[[87],256],120403:[[88],256],120404:[[89],256],120405:[[90],256],120406:[[97],256],120407:[[98],256],120408:[[99],256],120409:[[100],256],120410:[[101],256],120411:[[102],256],120412:[[103],256],120413:[[104],256],120414:[[105],256],120415:[[106],256],120416:[[107],256],120417:[[108],256],120418:[[109],256],120419:[[110],256],120420:[[111],256],120421:[[112],256],120422:[[113],256],120423:[[114],256],120424:[[115],256],120425:[[116],256],120426:[[117],256],120427:[[118],256],120428:[[119],256],120429:[[120],256],120430:[[121],256],120431:[[122],256],120432:[[65],256],120433:[[66],256],120434:[[67],256],120435:[[68],256],120436:[[69],256],120437:[[70],256],120438:[[71],256],120439:[[72],256],120440:[[73],256],120441:[[74],256],120442:[[75],256],120443:[[76],256],120444:[[77],256],120445:[[78],256],120446:[[79],256],120447:[[80],256],120448:[[81],256],120449:[[82],256],120450:[[83],256],120451:[[84],256],120452:[[85],256],120453:[[86],256],120454:[[87],256],120455:[[88],256],120456:[[89],256],120457:[[90],256],120458:[[97],256],120459:[[98],256],120460:[[99],256],120461:[[100],256],120462:[[101],256],120463:[[102],256],120464:[[103],256],120465:[[104],256],120466:[[105],256],120467:[[106],256],120468:[[107],256],120469:[[108],256],120470:[[109],256],120471:[[110],256],120472:[[111],256],120473:[[112],256],120474:[[113],256],120475:[[114],256],120476:[[115],256],120477:[[116],256],120478:[[117],256],120479:[[118],256],120480:[[119],256],120481:[[120],256],120482:[[121],256],120483:[[122],256],120484:[[305],256],120485:[[567],256],120488:[[913],256],120489:[[914],256],120490:[[915],256],120491:[[916],256],120492:[[917],256],120493:[[918],256],120494:[[919],256],120495:[[920],256],120496:[[921],256],120497:[[922],256],120498:[[923],256],120499:[[924],256],120500:[[925],256],120501:[[926],256],120502:[[927],256],120503:[[928],256],120504:[[929],256],120505:[[1012],256],120506:[[931],256],120507:[[932],256],120508:[[933],256],120509:[[934],256],120510:[[935],256],120511:[[936],256],120512:[[937],256],120513:[[8711],256],120514:[[945],256],120515:[[946],256],120516:[[947],256],120517:[[948],256],120518:[[949],256],120519:[[950],256],120520:[[951],256],120521:[[952],256],120522:[[953],256],120523:[[954],256],120524:[[955],256],120525:[[956],256],120526:[[957],256],120527:[[958],256],120528:[[959],256],120529:[[960],256],120530:[[961],256],120531:[[962],256],120532:[[963],256],120533:[[964],256],120534:[[965],256],120535:[[966],256],120536:[[967],256],120537:[[968],256],120538:[[969],256],120539:[[8706],256],120540:[[1013],256],120541:[[977],256],120542:[[1008],256],120543:[[981],256],120544:[[1009],256],120545:[[982],256],120546:[[913],256],120547:[[914],256],120548:[[915],256],120549:[[916],256],120550:[[917],256],120551:[[918],256],120552:[[919],256],120553:[[920],256],120554:[[921],256],120555:[[922],256],120556:[[923],256],120557:[[924],256],120558:[[925],256],120559:[[926],256],120560:[[927],256],120561:[[928],256],120562:[[929],256],120563:[[1012],256],120564:[[931],256],120565:[[932],256],120566:[[933],256],120567:[[934],256],120568:[[935],256],120569:[[936],256],120570:[[937],256],120571:[[8711],256],120572:[[945],256],120573:[[946],256],120574:[[947],256],120575:[[948],256]},
55040:{120576:[[949],256],120577:[[950],256],120578:[[951],256],120579:[[952],256],120580:[[953],256],120581:[[954],256],120582:[[955],256],120583:[[956],256],120584:[[957],256],120585:[[958],256],120586:[[959],256],120587:[[960],256],120588:[[961],256],120589:[[962],256],120590:[[963],256],120591:[[964],256],120592:[[965],256],120593:[[966],256],120594:[[967],256],120595:[[968],256],120596:[[969],256],120597:[[8706],256],120598:[[1013],256],120599:[[977],256],120600:[[1008],256],120601:[[981],256],120602:[[1009],256],120603:[[982],256],120604:[[913],256],120605:[[914],256],120606:[[915],256],120607:[[916],256],120608:[[917],256],120609:[[918],256],120610:[[919],256],120611:[[920],256],120612:[[921],256],120613:[[922],256],120614:[[923],256],120615:[[924],256],120616:[[925],256],120617:[[926],256],120618:[[927],256],120619:[[928],256],120620:[[929],256],120621:[[1012],256],120622:[[931],256],120623:[[932],256],120624:[[933],256],120625:[[934],256],120626:[[935],256],120627:[[936],256],120628:[[937],256],120629:[[8711],256],120630:[[945],256],120631:[[946],256],120632:[[947],256],120633:[[948],256],120634:[[949],256],120635:[[950],256],120636:[[951],256],120637:[[952],256],120638:[[953],256],120639:[[954],256],120640:[[955],256],120641:[[956],256],120642:[[957],256],120643:[[958],256],120644:[[959],256],120645:[[960],256],120646:[[961],256],120647:[[962],256],120648:[[963],256],120649:[[964],256],120650:[[965],256],120651:[[966],256],120652:[[967],256],120653:[[968],256],120654:[[969],256],120655:[[8706],256],120656:[[1013],256],120657:[[977],256],120658:[[1008],256],120659:[[981],256],120660:[[1009],256],120661:[[982],256],120662:[[913],256],120663:[[914],256],120664:[[915],256],120665:[[916],256],120666:[[917],256],120667:[[918],256],120668:[[919],256],120669:[[920],256],120670:[[921],256],120671:[[922],256],120672:[[923],256],120673:[[924],256],120674:[[925],256],120675:[[926],256],120676:[[927],256],120677:[[928],256],120678:[[929],256],120679:[[1012],256],120680:[[931],256],120681:[[932],256],120682:[[933],256],120683:[[934],256],120684:[[935],256],120685:[[936],256],120686:[[937],256],120687:[[8711],256],120688:[[945],256],120689:[[946],256],120690:[[947],256],120691:[[948],256],120692:[[949],256],120693:[[950],256],120694:[[951],256],120695:[[952],256],120696:[[953],256],120697:[[954],256],120698:[[955],256],120699:[[956],256],120700:[[957],256],120701:[[958],256],120702:[[959],256],120703:[[960],256],120704:[[961],256],120705:[[962],256],120706:[[963],256],120707:[[964],256],120708:[[965],256],120709:[[966],256],120710:[[967],256],120711:[[968],256],120712:[[969],256],120713:[[8706],256],120714:[[1013],256],120715:[[977],256],120716:[[1008],256],120717:[[981],256],120718:[[1009],256],120719:[[982],256],120720:[[913],256],120721:[[914],256],120722:[[915],256],120723:[[916],256],120724:[[917],256],120725:[[918],256],120726:[[919],256],120727:[[920],256],120728:[[921],256],120729:[[922],256],120730:[[923],256],120731:[[924],256],120732:[[925],256],120733:[[926],256],120734:[[927],256],120735:[[928],256],120736:[[929],256],120737:[[1012],256],120738:[[931],256],120739:[[932],256],120740:[[933],256],120741:[[934],256],120742:[[935],256],120743:[[936],256],120744:[[937],256],120745:[[8711],256],120746:[[945],256],120747:[[946],256],120748:[[947],256],120749:[[948],256],120750:[[949],256],120751:[[950],256],120752:[[951],256],120753:[[952],256],120754:[[953],256],120755:[[954],256],120756:[[955],256],120757:[[956],256],120758:[[957],256],120759:[[958],256],120760:[[959],256],120761:[[960],256],120762:[[961],256],120763:[[962],256],120764:[[963],256],120765:[[964],256],120766:[[965],256],120767:[[966],256],120768:[[967],256],120769:[[968],256],120770:[[969],256],120771:[[8706],256],120772:[[1013],256],120773:[[977],256],120774:[[1008],256],120775:[[981],256],120776:[[1009],256],120777:[[982],256],120778:[[988],256],120779:[[989],256],120782:[[48],256],120783:[[49],256],120784:[[50],256],120785:[[51],256],120786:[[52],256],120787:[[53],256],120788:[[54],256],120789:[[55],256],120790:[[56],256],120791:[[57],256],120792:[[48],256],120793:[[49],256],120794:[[50],256],120795:[[51],256],120796:[[52],256],120797:[[53],256],120798:[[54],256],120799:[[55],256],120800:[[56],256],120801:[[57],256],120802:[[48],256],120803:[[49],256],120804:[[50],256],120805:[[51],256],120806:[[52],256],120807:[[53],256],120808:[[54],256],120809:[[55],256],120810:[[56],256],120811:[[57],256],120812:[[48],256],120813:[[49],256],120814:[[50],256],120815:[[51],256],120816:[[52],256],120817:[[53],256],120818:[[54],256],120819:[[55],256],120820:[[56],256],120821:[[57],256],120822:[[48],256],120823:[[49],256],120824:[[50],256],120825:[[51],256],120826:[[52],256],120827:[[53],256],120828:[[54],256],120829:[[55],256],120830:[[56],256],120831:[[57],256]},
59392:{125136:[,220],125137:[,220],125138:[,220],125139:[,220],125140:[,220],125141:[,220],125142:[,220]},
60928:{126464:[[1575],256],126465:[[1576],256],126466:[[1580],256],126467:[[1583],256],126469:[[1608],256],126470:[[1586],256],126471:[[1581],256],126472:[[1591],256],126473:[[1610],256],126474:[[1603],256],126475:[[1604],256],126476:[[1605],256],126477:[[1606],256],126478:[[1587],256],126479:[[1593],256],126480:[[1601],256],126481:[[1589],256],126482:[[1602],256],126483:[[1585],256],126484:[[1588],256],126485:[[1578],256],126486:[[1579],256],126487:[[1582],256],126488:[[1584],256],126489:[[1590],256],126490:[[1592],256],126491:[[1594],256],126492:[[1646],256],126493:[[1722],256],126494:[[1697],256],126495:[[1647],256],126497:[[1576],256],126498:[[1580],256],126500:[[1607],256],126503:[[1581],256],126505:[[1610],256],126506:[[1603],256],126507:[[1604],256],126508:[[1605],256],126509:[[1606],256],126510:[[1587],256],126511:[[1593],256],126512:[[1601],256],126513:[[1589],256],126514:[[1602],256],126516:[[1588],256],126517:[[1578],256],126518:[[1579],256],126519:[[1582],256],126521:[[1590],256],126523:[[1594],256],126530:[[1580],256],126535:[[1581],256],126537:[[1610],256],126539:[[1604],256],126541:[[1606],256],126542:[[1587],256],126543:[[1593],256],126545:[[1589],256],126546:[[1602],256],126548:[[1588],256],126551:[[1582],256],126553:[[1590],256],126555:[[1594],256],126557:[[1722],256],126559:[[1647],256],126561:[[1576],256],126562:[[1580],256],126564:[[1607],256],126567:[[1581],256],126568:[[1591],256],126569:[[1610],256],126570:[[1603],256],126572:[[1605],256],126573:[[1606],256],126574:[[1587],256],126575:[[1593],256],126576:[[1601],256],126577:[[1589],256],126578:[[1602],256],126580:[[1588],256],126581:[[1578],256],126582:[[1579],256],126583:[[1582],256],126585:[[1590],256],126586:[[1592],256],126587:[[1594],256],126588:[[1646],256],126590:[[1697],256],126592:[[1575],256],126593:[[1576],256],126594:[[1580],256],126595:[[1583],256],126596:[[1607],256],126597:[[1608],256],126598:[[1586],256],126599:[[1581],256],126600:[[1591],256],126601:[[1610],256],126603:[[1604],256],126604:[[1605],256],126605:[[1606],256],126606:[[1587],256],126607:[[1593],256],126608:[[1601],256],126609:[[1589],256],126610:[[1602],256],126611:[[1585],256],126612:[[1588],256],126613:[[1578],256],126614:[[1579],256],126615:[[1582],256],126616:[[1584],256],126617:[[1590],256],126618:[[1592],256],126619:[[1594],256],126625:[[1576],256],126626:[[1580],256],126627:[[1583],256],126629:[[1608],256],126630:[[1586],256],126631:[[1581],256],126632:[[1591],256],126633:[[1610],256],126635:[[1604],256],126636:[[1605],256],126637:[[1606],256],126638:[[1587],256],126639:[[1593],256],126640:[[1601],256],126641:[[1589],256],126642:[[1602],256],126643:[[1585],256],126644:[[1588],256],126645:[[1578],256],126646:[[1579],256],126647:[[1582],256],126648:[[1584],256],126649:[[1590],256],126650:[[1592],256],126651:[[1594],256]},
61696:{127232:[[48,46],256],127233:[[48,44],256],127234:[[49,44],256],127235:[[50,44],256],127236:[[51,44],256],127237:[[52,44],256],127238:[[53,44],256],127239:[[54,44],256],127240:[[55,44],256],127241:[[56,44],256],127242:[[57,44],256],127248:[[40,65,41],256],127249:[[40,66,41],256],127250:[[40,67,41],256],127251:[[40,68,41],256],127252:[[40,69,41],256],127253:[[40,70,41],256],127254:[[40,71,41],256],127255:[[40,72,41],256],127256:[[40,73,41],256],127257:[[40,74,41],256],127258:[[40,75,41],256],127259:[[40,76,41],256],127260:[[40,77,41],256],127261:[[40,78,41],256],127262:[[40,79,41],256],127263:[[40,80,41],256],127264:[[40,81,41],256],127265:[[40,82,41],256],127266:[[40,83,41],256],127267:[[40,84,41],256],127268:[[40,85,41],256],127269:[[40,86,41],256],127270:[[40,87,41],256],127271:[[40,88,41],256],127272:[[40,89,41],256],127273:[[40,90,41],256],127274:[[12308,83,12309],256],127275:[[67],256],127276:[[82],256],127277:[[67,68],256],127278:[[87,90],256],127280:[[65],256],127281:[[66],256],127282:[[67],256],127283:[[68],256],127284:[[69],256],127285:[[70],256],127286:[[71],256],127287:[[72],256],127288:[[73],256],127289:[[74],256],127290:[[75],256],127291:[[76],256],127292:[[77],256],127293:[[78],256],127294:[[79],256],127295:[[80],256],127296:[[81],256],127297:[[82],256],127298:[[83],256],127299:[[84],256],127300:[[85],256],127301:[[86],256],127302:[[87],256],127303:[[88],256],127304:[[89],256],127305:[[90],256],127306:[[72,86],256],127307:[[77,86],256],127308:[[83,68],256],127309:[[83,83],256],127310:[[80,80,86],256],127311:[[87,67],256],127338:[[77,67],256],127339:[[77,68],256],127376:[[68,74],256]},
61952:{127488:[[12411,12363],256],127489:[[12467,12467],256],127490:[[12469],256],127504:[[25163],256],127505:[[23383],256],127506:[[21452],256],127507:[[12487],256],127508:[[20108],256],127509:[[22810],256],127510:[[35299],256],127511:[[22825],256],127512:[[20132],256],127513:[[26144],256],127514:[[28961],256],127515:[[26009],256],127516:[[21069],256],127517:[[24460],256],127518:[[20877],256],127519:[[26032],256],127520:[[21021],256],127521:[[32066],256],127522:[[29983],256],127523:[[36009],256],127524:[[22768],256],127525:[[21561],256],127526:[[28436],256],127527:[[25237],256],127528:[[25429],256],127529:[[19968],256],127530:[[19977],256],127531:[[36938],256],127532:[[24038],256],127533:[[20013],256],127534:[[21491],256],127535:[[25351],256],127536:[[36208],256],127537:[[25171],256],127538:[[31105],256],127539:[[31354],256],127540:[[21512],256],127541:[[28288],256],127542:[[26377],256],127543:[[26376],256],127544:[[30003],256],127545:[[21106],256],127546:[[21942],256],127552:[[12308,26412,12309],256],127553:[[12308,19977,12309],256],127554:[[12308,20108,12309],256],127555:[[12308,23433,12309],256],127556:[[12308,28857,12309],256],127557:[[12308,25171,12309],256],127558:[[12308,30423,12309],256],127559:[[12308,21213,12309],256],127560:[[12308,25943,12309],256],127568:[[24471],256],127569:[[21487],256]},
63488:{194560:[[20029]],194561:[[20024]],194562:[[20033]],194563:[[131362]],194564:[[20320]],194565:[[20398]],194566:[[20411]],194567:[[20482]],194568:[[20602]],194569:[[20633]],194570:[[20711]],194571:[[20687]],194572:[[13470]],194573:[[132666]],194574:[[20813]],194575:[[20820]],194576:[[20836]],194577:[[20855]],194578:[[132380]],194579:[[13497]],194580:[[20839]],194581:[[20877]],194582:[[132427]],194583:[[20887]],194584:[[20900]],194585:[[20172]],194586:[[20908]],194587:[[20917]],194588:[[168415]],194589:[[20981]],194590:[[20995]],194591:[[13535]],194592:[[21051]],194593:[[21062]],194594:[[21106]],194595:[[21111]],194596:[[13589]],194597:[[21191]],194598:[[21193]],194599:[[21220]],194600:[[21242]],194601:[[21253]],194602:[[21254]],194603:[[21271]],194604:[[21321]],194605:[[21329]],194606:[[21338]],194607:[[21363]],194608:[[21373]],194609:[[21375]],194610:[[21375]],194611:[[21375]],194612:[[133676]],194613:[[28784]],194614:[[21450]],194615:[[21471]],194616:[[133987]],194617:[[21483]],194618:[[21489]],194619:[[21510]],194620:[[21662]],194621:[[21560]],194622:[[21576]],194623:[[21608]],194624:[[21666]],194625:[[21750]],194626:[[21776]],194627:[[21843]],194628:[[21859]],194629:[[21892]],194630:[[21892]],194631:[[21913]],194632:[[21931]],194633:[[21939]],194634:[[21954]],194635:[[22294]],194636:[[22022]],194637:[[22295]],194638:[[22097]],194639:[[22132]],194640:[[20999]],194641:[[22766]],194642:[[22478]],194643:[[22516]],194644:[[22541]],194645:[[22411]],194646:[[22578]],194647:[[22577]],194648:[[22700]],194649:[[136420]],194650:[[22770]],194651:[[22775]],194652:[[22790]],194653:[[22810]],194654:[[22818]],194655:[[22882]],194656:[[136872]],194657:[[136938]],194658:[[23020]],194659:[[23067]],194660:[[23079]],194661:[[23000]],194662:[[23142]],194663:[[14062]],194664:[[14076]],194665:[[23304]],194666:[[23358]],194667:[[23358]],194668:[[137672]],194669:[[23491]],194670:[[23512]],194671:[[23527]],194672:[[23539]],194673:[[138008]],194674:[[23551]],194675:[[23558]],194676:[[24403]],194677:[[23586]],194678:[[14209]],194679:[[23648]],194680:[[23662]],194681:[[23744]],194682:[[23693]],194683:[[138724]],194684:[[23875]],194685:[[138726]],194686:[[23918]],194687:[[23915]],194688:[[23932]],194689:[[24033]],194690:[[24034]],194691:[[14383]],194692:[[24061]],194693:[[24104]],194694:[[24125]],194695:[[24169]],194696:[[14434]],194697:[[139651]],194698:[[14460]],194699:[[24240]],194700:[[24243]],194701:[[24246]],194702:[[24266]],194703:[[172946]],194704:[[24318]],194705:[[140081]],194706:[[140081]],194707:[[33281]],194708:[[24354]],194709:[[24354]],194710:[[14535]],194711:[[144056]],194712:[[156122]],194713:[[24418]],194714:[[24427]],194715:[[14563]],194716:[[24474]],194717:[[24525]],194718:[[24535]],194719:[[24569]],194720:[[24705]],194721:[[14650]],194722:[[14620]],194723:[[24724]],194724:[[141012]],194725:[[24775]],194726:[[24904]],194727:[[24908]],194728:[[24910]],194729:[[24908]],194730:[[24954]],194731:[[24974]],194732:[[25010]],194733:[[24996]],194734:[[25007]],194735:[[25054]],194736:[[25074]],194737:[[25078]],194738:[[25104]],194739:[[25115]],194740:[[25181]],194741:[[25265]],194742:[[25300]],194743:[[25424]],194744:[[142092]],194745:[[25405]],194746:[[25340]],194747:[[25448]],194748:[[25475]],194749:[[25572]],194750:[[142321]],194751:[[25634]],194752:[[25541]],194753:[[25513]],194754:[[14894]],194755:[[25705]],194756:[[25726]],194757:[[25757]],194758:[[25719]],194759:[[14956]],194760:[[25935]],194761:[[25964]],194762:[[143370]],194763:[[26083]],194764:[[26360]],194765:[[26185]],194766:[[15129]],194767:[[26257]],194768:[[15112]],194769:[[15076]],194770:[[20882]],194771:[[20885]],194772:[[26368]],194773:[[26268]],194774:[[32941]],194775:[[17369]],194776:[[26391]],194777:[[26395]],194778:[[26401]],194779:[[26462]],194780:[[26451]],194781:[[144323]],194782:[[15177]],194783:[[26618]],194784:[[26501]],194785:[[26706]],194786:[[26757]],194787:[[144493]],194788:[[26766]],194789:[[26655]],194790:[[26900]],194791:[[15261]],194792:[[26946]],194793:[[27043]],194794:[[27114]],194795:[[27304]],194796:[[145059]],194797:[[27355]],194798:[[15384]],194799:[[27425]],194800:[[145575]],194801:[[27476]],194802:[[15438]],194803:[[27506]],194804:[[27551]],194805:[[27578]],194806:[[27579]],194807:[[146061]],194808:[[138507]],194809:[[146170]],194810:[[27726]],194811:[[146620]],194812:[[27839]],194813:[[27853]],194814:[[27751]],194815:[[27926]]},
63744:{63744:[[35912]],63745:[[26356]],63746:[[36554]],63747:[[36040]],63748:[[28369]],63749:[[20018]],63750:[[21477]],63751:[[40860]],63752:[[40860]],63753:[[22865]],63754:[[37329]],63755:[[21895]],63756:[[22856]],63757:[[25078]],63758:[[30313]],63759:[[32645]],63760:[[34367]],63761:[[34746]],63762:[[35064]],63763:[[37007]],63764:[[27138]],63765:[[27931]],63766:[[28889]],63767:[[29662]],63768:[[33853]],63769:[[37226]],63770:[[39409]],63771:[[20098]],63772:[[21365]],63773:[[27396]],63774:[[29211]],63775:[[34349]],63776:[[40478]],63777:[[23888]],63778:[[28651]],63779:[[34253]],63780:[[35172]],63781:[[25289]],63782:[[33240]],63783:[[34847]],63784:[[24266]],63785:[[26391]],63786:[[28010]],63787:[[29436]],63788:[[37070]],63789:[[20358]],63790:[[20919]],63791:[[21214]],63792:[[25796]],63793:[[27347]],63794:[[29200]],63795:[[30439]],63796:[[32769]],63797:[[34310]],63798:[[34396]],63799:[[36335]],63800:[[38706]],63801:[[39791]],63802:[[40442]],63803:[[30860]],63804:[[31103]],63805:[[32160]],63806:[[33737]],63807:[[37636]],63808:[[40575]],63809:[[35542]],63810:[[22751]],63811:[[24324]],63812:[[31840]],63813:[[32894]],63814:[[29282]],63815:[[30922]],63816:[[36034]],63817:[[38647]],63818:[[22744]],63819:[[23650]],63820:[[27155]],63821:[[28122]],63822:[[28431]],63823:[[32047]],63824:[[32311]],63825:[[38475]],63826:[[21202]],63827:[[32907]],63828:[[20956]],63829:[[20940]],63830:[[31260]],63831:[[32190]],63832:[[33777]],63833:[[38517]],63834:[[35712]],63835:[[25295]],63836:[[27138]],63837:[[35582]],63838:[[20025]],63839:[[23527]],63840:[[24594]],63841:[[29575]],63842:[[30064]],63843:[[21271]],63844:[[30971]],63845:[[20415]],63846:[[24489]],63847:[[19981]],63848:[[27852]],63849:[[25976]],63850:[[32034]],63851:[[21443]],63852:[[22622]],63853:[[30465]],63854:[[33865]],63855:[[35498]],63856:[[27578]],63857:[[36784]],63858:[[27784]],63859:[[25342]],63860:[[33509]],63861:[[25504]],63862:[[30053]],63863:[[20142]],63864:[[20841]],63865:[[20937]],63866:[[26753]],63867:[[31975]],63868:[[33391]],63869:[[35538]],63870:[[37327]],63871:[[21237]],63872:[[21570]],63873:[[22899]],63874:[[24300]],63875:[[26053]],63876:[[28670]],63877:[[31018]],63878:[[38317]],63879:[[39530]],63880:[[40599]],63881:[[40654]],63882:[[21147]],63883:[[26310]],63884:[[27511]],63885:[[36706]],63886:[[24180]],63887:[[24976]],63888:[[25088]],63889:[[25754]],63890:[[28451]],63891:[[29001]],63892:[[29833]],63893:[[31178]],63894:[[32244]],63895:[[32879]],63896:[[36646]],63897:[[34030]],63898:[[36899]],63899:[[37706]],63900:[[21015]],63901:[[21155]],63902:[[21693]],63903:[[28872]],63904:[[35010]],63905:[[35498]],63906:[[24265]],63907:[[24565]],63908:[[25467]],63909:[[27566]],63910:[[31806]],63911:[[29557]],63912:[[20196]],63913:[[22265]],63914:[[23527]],63915:[[23994]],63916:[[24604]],63917:[[29618]],63918:[[29801]],63919:[[32666]],63920:[[32838]],63921:[[37428]],63922:[[38646]],63923:[[38728]],63924:[[38936]],63925:[[20363]],63926:[[31150]],63927:[[37300]],63928:[[38584]],63929:[[24801]],63930:[[20102]],63931:[[20698]],63932:[[23534]],63933:[[23615]],63934:[[26009]],63935:[[27138]],63936:[[29134]],63937:[[30274]],63938:[[34044]],63939:[[36988]],63940:[[40845]],63941:[[26248]],63942:[[38446]],63943:[[21129]],63944:[[26491]],63945:[[26611]],63946:[[27969]],63947:[[28316]],63948:[[29705]],63949:[[30041]],63950:[[30827]],63951:[[32016]],63952:[[39006]],63953:[[20845]],63954:[[25134]],63955:[[38520]],63956:[[20523]],63957:[[23833]],63958:[[28138]],63959:[[36650]],63960:[[24459]],63961:[[24900]],63962:[[26647]],63963:[[29575]],63964:[[38534]],63965:[[21033]],63966:[[21519]],63967:[[23653]],63968:[[26131]],63969:[[26446]],63970:[[26792]],63971:[[27877]],63972:[[29702]],63973:[[30178]],63974:[[32633]],63975:[[35023]],63976:[[35041]],63977:[[37324]],63978:[[38626]],63979:[[21311]],63980:[[28346]],63981:[[21533]],63982:[[29136]],63983:[[29848]],63984:[[34298]],63985:[[38563]],63986:[[40023]],63987:[[40607]],63988:[[26519]],63989:[[28107]],63990:[[33256]],63991:[[31435]],63992:[[31520]],63993:[[31890]],63994:[[29376]],63995:[[28825]],63996:[[35672]],63997:[[20160]],63998:[[33590]],63999:[[21050]],194816:[[27966]],194817:[[28023]],194818:[[27969]],194819:[[28009]],194820:[[28024]],194821:[[28037]],194822:[[146718]],194823:[[27956]],194824:[[28207]],194825:[[28270]],194826:[[15667]],194827:[[28363]],194828:[[28359]],194829:[[147153]],194830:[[28153]],194831:[[28526]],194832:[[147294]],194833:[[147342]],194834:[[28614]],194835:[[28729]],194836:[[28702]],194837:[[28699]],194838:[[15766]],194839:[[28746]],194840:[[28797]],194841:[[28791]],194842:[[28845]],194843:[[132389]],194844:[[28997]],194845:[[148067]],194846:[[29084]],194847:[[148395]],194848:[[29224]],194849:[[29237]],194850:[[29264]],194851:[[149000]],194852:[[29312]],194853:[[29333]],194854:[[149301]],194855:[[149524]],194856:[[29562]],194857:[[29579]],194858:[[16044]],194859:[[29605]],194860:[[16056]],194861:[[16056]],194862:[[29767]],194863:[[29788]],194864:[[29809]],194865:[[29829]],194866:[[29898]],194867:[[16155]],194868:[[29988]],194869:[[150582]],194870:[[30014]],194871:[[150674]],194872:[[30064]],194873:[[139679]],194874:[[30224]],194875:[[151457]],194876:[[151480]],194877:[[151620]],194878:[[16380]],194879:[[16392]],194880:[[30452]],194881:[[151795]],194882:[[151794]],194883:[[151833]],194884:[[151859]],194885:[[30494]],194886:[[30495]],194887:[[30495]],194888:[[30538]],194889:[[16441]],194890:[[30603]],194891:[[16454]],194892:[[16534]],194893:[[152605]],194894:[[30798]],194895:[[30860]],194896:[[30924]],194897:[[16611]],194898:[[153126]],194899:[[31062]],194900:[[153242]],194901:[[153285]],194902:[[31119]],194903:[[31211]],194904:[[16687]],194905:[[31296]],194906:[[31306]],194907:[[31311]],194908:[[153980]],194909:[[154279]],194910:[[154279]],194911:[[31470]],194912:[[16898]],194913:[[154539]],194914:[[31686]],194915:[[31689]],194916:[[16935]],194917:[[154752]],194918:[[31954]],194919:[[17056]],194920:[[31976]],194921:[[31971]],194922:[[32000]],194923:[[155526]],194924:[[32099]],194925:[[17153]],194926:[[32199]],194927:[[32258]],194928:[[32325]],194929:[[17204]],194930:[[156200]],194931:[[156231]],194932:[[17241]],194933:[[156377]],194934:[[32634]],194935:[[156478]],194936:[[32661]],194937:[[32762]],194938:[[32773]],194939:[[156890]],194940:[[156963]],194941:[[32864]],194942:[[157096]],194943:[[32880]],194944:[[144223]],194945:[[17365]],194946:[[32946]],194947:[[33027]],194948:[[17419]],194949:[[33086]],194950:[[23221]],194951:[[157607]],194952:[[157621]],194953:[[144275]],194954:[[144284]],194955:[[33281]],194956:[[33284]],194957:[[36766]],194958:[[17515]],194959:[[33425]],194960:[[33419]],194961:[[33437]],194962:[[21171]],194963:[[33457]],194964:[[33459]],194965:[[33469]],194966:[[33510]],194967:[[158524]],194968:[[33509]],194969:[[33565]],194970:[[33635]],194971:[[33709]],194972:[[33571]],194973:[[33725]],194974:[[33767]],194975:[[33879]],194976:[[33619]],194977:[[33738]],194978:[[33740]],194979:[[33756]],194980:[[158774]],194981:[[159083]],194982:[[158933]],194983:[[17707]],194984:[[34033]],194985:[[34035]],194986:[[34070]],194987:[[160714]],194988:[[34148]],194989:[[159532]],194990:[[17757]],194991:[[17761]],194992:[[159665]],194993:[[159954]],194994:[[17771]],194995:[[34384]],194996:[[34396]],194997:[[34407]],194998:[[34409]],194999:[[34473]],195000:[[34440]],195001:[[34574]],195002:[[34530]],195003:[[34681]],195004:[[34600]],195005:[[34667]],195006:[[34694]],195007:[[17879]],195008:[[34785]],195009:[[34817]],195010:[[17913]],195011:[[34912]],195012:[[34915]],195013:[[161383]],195014:[[35031]],195015:[[35038]],195016:[[17973]],195017:[[35066]],195018:[[13499]],195019:[[161966]],195020:[[162150]],195021:[[18110]],195022:[[18119]],195023:[[35488]],195024:[[35565]],195025:[[35722]],195026:[[35925]],195027:[[162984]],195028:[[36011]],195029:[[36033]],195030:[[36123]],195031:[[36215]],195032:[[163631]],195033:[[133124]],195034:[[36299]],195035:[[36284]],195036:[[36336]],195037:[[133342]],195038:[[36564]],195039:[[36664]],195040:[[165330]],195041:[[165357]],195042:[[37012]],195043:[[37105]],195044:[[37137]],195045:[[165678]],195046:[[37147]],195047:[[37432]],195048:[[37591]],195049:[[37592]],195050:[[37500]],195051:[[37881]],195052:[[37909]],195053:[[166906]],195054:[[38283]],195055:[[18837]],195056:[[38327]],195057:[[167287]],195058:[[18918]],195059:[[38595]],195060:[[23986]],195061:[[38691]],195062:[[168261]],195063:[[168474]],195064:[[19054]],195065:[[19062]],195066:[[38880]],195067:[[168970]],195068:[[19122]],195069:[[169110]],195070:[[38923]],195071:[[38923]]},
64000:{64000:[[20999]],64001:[[24230]],64002:[[25299]],64003:[[31958]],64004:[[23429]],64005:[[27934]],64006:[[26292]],64007:[[36667]],64008:[[34892]],64009:[[38477]],64010:[[35211]],64011:[[24275]],64012:[[20800]],64013:[[21952]],64016:[[22618]],64018:[[26228]],64021:[[20958]],64022:[[29482]],64023:[[30410]],64024:[[31036]],64025:[[31070]],64026:[[31077]],64027:[[31119]],64028:[[38742]],64029:[[31934]],64030:[[32701]],64032:[[34322]],64034:[[35576]],64037:[[36920]],64038:[[37117]],64042:[[39151]],64043:[[39164]],64044:[[39208]],64045:[[40372]],64046:[[37086]],64047:[[38583]],64048:[[20398]],64049:[[20711]],64050:[[20813]],64051:[[21193]],64052:[[21220]],64053:[[21329]],64054:[[21917]],64055:[[22022]],64056:[[22120]],64057:[[22592]],64058:[[22696]],64059:[[23652]],64060:[[23662]],64061:[[24724]],64062:[[24936]],64063:[[24974]],64064:[[25074]],64065:[[25935]],64066:[[26082]],64067:[[26257]],64068:[[26757]],64069:[[28023]],64070:[[28186]],64071:[[28450]],64072:[[29038]],64073:[[29227]],64074:[[29730]],64075:[[30865]],64076:[[31038]],64077:[[31049]],64078:[[31048]],64079:[[31056]],64080:[[31062]],64081:[[31069]],64082:[[31117]],64083:[[31118]],64084:[[31296]],64085:[[31361]],64086:[[31680]],64087:[[32244]],64088:[[32265]],64089:[[32321]],64090:[[32626]],64091:[[32773]],64092:[[33261]],64093:[[33401]],64094:[[33401]],64095:[[33879]],64096:[[35088]],64097:[[35222]],64098:[[35585]],64099:[[35641]],64100:[[36051]],64101:[[36104]],64102:[[36790]],64103:[[36920]],64104:[[38627]],64105:[[38911]],64106:[[38971]],64107:[[24693]],64108:[[148206]],64109:[[33304]],64112:[[20006]],64113:[[20917]],64114:[[20840]],64115:[[20352]],64116:[[20805]],64117:[[20864]],64118:[[21191]],64119:[[21242]],64120:[[21917]],64121:[[21845]],64122:[[21913]],64123:[[21986]],64124:[[22618]],64125:[[22707]],64126:[[22852]],64127:[[22868]],64128:[[23138]],64129:[[23336]],64130:[[24274]],64131:[[24281]],64132:[[24425]],64133:[[24493]],64134:[[24792]],64135:[[24910]],64136:[[24840]],64137:[[24974]],64138:[[24928]],64139:[[25074]],64140:[[25140]],64141:[[25540]],64142:[[25628]],64143:[[25682]],64144:[[25942]],64145:[[26228]],64146:[[26391]],64147:[[26395]],64148:[[26454]],64149:[[27513]],64150:[[27578]],64151:[[27969]],64152:[[28379]],64153:[[28363]],64154:[[28450]],64155:[[28702]],64156:[[29038]],64157:[[30631]],64158:[[29237]],64159:[[29359]],64160:[[29482]],64161:[[29809]],64162:[[29958]],64163:[[30011]],64164:[[30237]],64165:[[30239]],64166:[[30410]],64167:[[30427]],64168:[[30452]],64169:[[30538]],64170:[[30528]],64171:[[30924]],64172:[[31409]],64173:[[31680]],64174:[[31867]],64175:[[32091]],64176:[[32244]],64177:[[32574]],64178:[[32773]],64179:[[33618]],64180:[[33775]],64181:[[34681]],64182:[[35137]],64183:[[35206]],64184:[[35222]],64185:[[35519]],64186:[[35576]],64187:[[35531]],64188:[[35585]],64189:[[35582]],64190:[[35565]],64191:[[35641]],64192:[[35722]],64193:[[36104]],64194:[[36664]],64195:[[36978]],64196:[[37273]],64197:[[37494]],64198:[[38524]],64199:[[38627]],64200:[[38742]],64201:[[38875]],64202:[[38911]],64203:[[38923]],64204:[[38971]],64205:[[39698]],64206:[[40860]],64207:[[141386]],64208:[[141380]],64209:[[144341]],64210:[[15261]],64211:[[16408]],64212:[[16441]],64213:[[152137]],64214:[[154832]],64215:[[163539]],64216:[[40771]],64217:[[40846]],195072:[[38953]],195073:[[169398]],195074:[[39138]],195075:[[19251]],195076:[[39209]],195077:[[39335]],195078:[[39362]],195079:[[39422]],195080:[[19406]],195081:[[170800]],195082:[[39698]],195083:[[40000]],195084:[[40189]],195085:[[19662]],195086:[[19693]],195087:[[40295]],195088:[[172238]],195089:[[19704]],195090:[[172293]],195091:[[172558]],195092:[[172689]],195093:[[40635]],195094:[[19798]],195095:[[40697]],195096:[[40702]],195097:[[40709]],195098:[[40719]],195099:[[40726]],195100:[[40763]],195101:[[173568]]},
64256:{64256:[[102,102],256],64257:[[102,105],256],64258:[[102,108],256],64259:[[102,102,105],256],64260:[[102,102,108],256],64261:[[383,116],256],64262:[[115,116],256],64275:[[1396,1398],256],64276:[[1396,1381],256],64277:[[1396,1387],256],64278:[[1406,1398],256],64279:[[1396,1389],256],64285:[[1497,1460],512],64286:[,26],64287:[[1522,1463],512],64288:[[1506],256],64289:[[1488],256],64290:[[1491],256],64291:[[1492],256],64292:[[1499],256],64293:[[1500],256],64294:[[1501],256],64295:[[1512],256],64296:[[1514],256],64297:[[43],256],64298:[[1513,1473],512],64299:[[1513,1474],512],64300:[[64329,1473],512],64301:[[64329,1474],512],64302:[[1488,1463],512],64303:[[1488,1464],512],64304:[[1488,1468],512],64305:[[1489,1468],512],64306:[[1490,1468],512],64307:[[1491,1468],512],64308:[[1492,1468],512],64309:[[1493,1468],512],64310:[[1494,1468],512],64312:[[1496,1468],512],64313:[[1497,1468],512],64314:[[1498,1468],512],64315:[[1499,1468],512],64316:[[1500,1468],512],64318:[[1502,1468],512],64320:[[1504,1468],512],64321:[[1505,1468],512],64323:[[1507,1468],512],64324:[[1508,1468],512],64326:[[1510,1468],512],64327:[[1511,1468],512],64328:[[1512,1468],512],64329:[[1513,1468],512],64330:[[1514,1468],512],64331:[[1493,1465],512],64332:[[1489,1471],512],64333:[[1499,1471],512],64334:[[1508,1471],512],64335:[[1488,1500],256],64336:[[1649],256],64337:[[1649],256],64338:[[1659],256],64339:[[1659],256],64340:[[1659],256],64341:[[1659],256],64342:[[1662],256],64343:[[1662],256],64344:[[1662],256],64345:[[1662],256],64346:[[1664],256],64347:[[1664],256],64348:[[1664],256],64349:[[1664],256],64350:[[1658],256],64351:[[1658],256],64352:[[1658],256],64353:[[1658],256],64354:[[1663],256],64355:[[1663],256],64356:[[1663],256],64357:[[1663],256],64358:[[1657],256],64359:[[1657],256],64360:[[1657],256],64361:[[1657],256],64362:[[1700],256],64363:[[1700],256],64364:[[1700],256],64365:[[1700],256],64366:[[1702],256],64367:[[1702],256],64368:[[1702],256],64369:[[1702],256],64370:[[1668],256],64371:[[1668],256],64372:[[1668],256],64373:[[1668],256],64374:[[1667],256],64375:[[1667],256],64376:[[1667],256],64377:[[1667],256],64378:[[1670],256],64379:[[1670],256],64380:[[1670],256],64381:[[1670],256],64382:[[1671],256],64383:[[1671],256],64384:[[1671],256],64385:[[1671],256],64386:[[1677],256],64387:[[1677],256],64388:[[1676],256],64389:[[1676],256],64390:[[1678],256],64391:[[1678],256],64392:[[1672],256],64393:[[1672],256],64394:[[1688],256],64395:[[1688],256],64396:[[1681],256],64397:[[1681],256],64398:[[1705],256],64399:[[1705],256],64400:[[1705],256],64401:[[1705],256],64402:[[1711],256],64403:[[1711],256],64404:[[1711],256],64405:[[1711],256],64406:[[1715],256],64407:[[1715],256],64408:[[1715],256],64409:[[1715],256],64410:[[1713],256],64411:[[1713],256],64412:[[1713],256],64413:[[1713],256],64414:[[1722],256],64415:[[1722],256],64416:[[1723],256],64417:[[1723],256],64418:[[1723],256],64419:[[1723],256],64420:[[1728],256],64421:[[1728],256],64422:[[1729],256],64423:[[1729],256],64424:[[1729],256],64425:[[1729],256],64426:[[1726],256],64427:[[1726],256],64428:[[1726],256],64429:[[1726],256],64430:[[1746],256],64431:[[1746],256],64432:[[1747],256],64433:[[1747],256],64467:[[1709],256],64468:[[1709],256],64469:[[1709],256],64470:[[1709],256],64471:[[1735],256],64472:[[1735],256],64473:[[1734],256],64474:[[1734],256],64475:[[1736],256],64476:[[1736],256],64477:[[1655],256],64478:[[1739],256],64479:[[1739],256],64480:[[1733],256],64481:[[1733],256],64482:[[1737],256],64483:[[1737],256],64484:[[1744],256],64485:[[1744],256],64486:[[1744],256],64487:[[1744],256],64488:[[1609],256],64489:[[1609],256],64490:[[1574,1575],256],64491:[[1574,1575],256],64492:[[1574,1749],256],64493:[[1574,1749],256],64494:[[1574,1608],256],64495:[[1574,1608],256],64496:[[1574,1735],256],64497:[[1574,1735],256],64498:[[1574,1734],256],64499:[[1574,1734],256],64500:[[1574,1736],256],64501:[[1574,1736],256],64502:[[1574,1744],256],64503:[[1574,1744],256],64504:[[1574,1744],256],64505:[[1574,1609],256],64506:[[1574,1609],256],64507:[[1574,1609],256],64508:[[1740],256],64509:[[1740],256],64510:[[1740],256],64511:[[1740],256]},
64512:{64512:[[1574,1580],256],64513:[[1574,1581],256],64514:[[1574,1605],256],64515:[[1574,1609],256],64516:[[1574,1610],256],64517:[[1576,1580],256],64518:[[1576,1581],256],64519:[[1576,1582],256],64520:[[1576,1605],256],64521:[[1576,1609],256],64522:[[1576,1610],256],64523:[[1578,1580],256],64524:[[1578,1581],256],64525:[[1578,1582],256],64526:[[1578,1605],256],64527:[[1578,1609],256],64528:[[1578,1610],256],64529:[[1579,1580],256],64530:[[1579,1605],256],64531:[[1579,1609],256],64532:[[1579,1610],256],64533:[[1580,1581],256],64534:[[1580,1605],256],64535:[[1581,1580],256],64536:[[1581,1605],256],64537:[[1582,1580],256],64538:[[1582,1581],256],64539:[[1582,1605],256],64540:[[1587,1580],256],64541:[[1587,1581],256],64542:[[1587,1582],256],64543:[[1587,1605],256],64544:[[1589,1581],256],64545:[[1589,1605],256],64546:[[1590,1580],256],64547:[[1590,1581],256],64548:[[1590,1582],256],64549:[[1590,1605],256],64550:[[1591,1581],256],64551:[[1591,1605],256],64552:[[1592,1605],256],64553:[[1593,1580],256],64554:[[1593,1605],256],64555:[[1594,1580],256],64556:[[1594,1605],256],64557:[[1601,1580],256],64558:[[1601,1581],256],64559:[[1601,1582],256],64560:[[1601,1605],256],64561:[[1601,1609],256],64562:[[1601,1610],256],64563:[[1602,1581],256],64564:[[1602,1605],256],64565:[[1602,1609],256],64566:[[1602,1610],256],64567:[[1603,1575],256],64568:[[1603,1580],256],64569:[[1603,1581],256],64570:[[1603,1582],256],64571:[[1603,1604],256],64572:[[1603,1605],256],64573:[[1603,1609],256],64574:[[1603,1610],256],64575:[[1604,1580],256],64576:[[1604,1581],256],64577:[[1604,1582],256],64578:[[1604,1605],256],64579:[[1604,1609],256],64580:[[1604,1610],256],64581:[[1605,1580],256],64582:[[1605,1581],256],64583:[[1605,1582],256],64584:[[1605,1605],256],64585:[[1605,1609],256],64586:[[1605,1610],256],64587:[[1606,1580],256],64588:[[1606,1581],256],64589:[[1606,1582],256],64590:[[1606,1605],256],64591:[[1606,1609],256],64592:[[1606,1610],256],64593:[[1607,1580],256],64594:[[1607,1605],256],64595:[[1607,1609],256],64596:[[1607,1610],256],64597:[[1610,1580],256],64598:[[1610,1581],256],64599:[[1610,1582],256],64600:[[1610,1605],256],64601:[[1610,1609],256],64602:[[1610,1610],256],64603:[[1584,1648],256],64604:[[1585,1648],256],64605:[[1609,1648],256],64606:[[32,1612,1617],256],64607:[[32,1613,1617],256],64608:[[32,1614,1617],256],64609:[[32,1615,1617],256],64610:[[32,1616,1617],256],64611:[[32,1617,1648],256],64612:[[1574,1585],256],64613:[[1574,1586],256],64614:[[1574,1605],256],64615:[[1574,1606],256],64616:[[1574,1609],256],64617:[[1574,1610],256],64618:[[1576,1585],256],64619:[[1576,1586],256],64620:[[1576,1605],256],64621:[[1576,1606],256],64622:[[1576,1609],256],64623:[[1576,1610],256],64624:[[1578,1585],256],64625:[[1578,1586],256],64626:[[1578,1605],256],64627:[[1578,1606],256],64628:[[1578,1609],256],64629:[[1578,1610],256],64630:[[1579,1585],256],64631:[[1579,1586],256],64632:[[1579,1605],256],64633:[[1579,1606],256],64634:[[1579,1609],256],64635:[[1579,1610],256],64636:[[1601,1609],256],64637:[[1601,1610],256],64638:[[1602,1609],256],64639:[[1602,1610],256],64640:[[1603,1575],256],64641:[[1603,1604],256],64642:[[1603,1605],256],64643:[[1603,1609],256],64644:[[1603,1610],256],64645:[[1604,1605],256],64646:[[1604,1609],256],64647:[[1604,1610],256],64648:[[1605,1575],256],64649:[[1605,1605],256],64650:[[1606,1585],256],64651:[[1606,1586],256],64652:[[1606,1605],256],64653:[[1606,1606],256],64654:[[1606,1609],256],64655:[[1606,1610],256],64656:[[1609,1648],256],64657:[[1610,1585],256],64658:[[1610,1586],256],64659:[[1610,1605],256],64660:[[1610,1606],256],64661:[[1610,1609],256],64662:[[1610,1610],256],64663:[[1574,1580],256],64664:[[1574,1581],256],64665:[[1574,1582],256],64666:[[1574,1605],256],64667:[[1574,1607],256],64668:[[1576,1580],256],64669:[[1576,1581],256],64670:[[1576,1582],256],64671:[[1576,1605],256],64672:[[1576,1607],256],64673:[[1578,1580],256],64674:[[1578,1581],256],64675:[[1578,1582],256],64676:[[1578,1605],256],64677:[[1578,1607],256],64678:[[1579,1605],256],64679:[[1580,1581],256],64680:[[1580,1605],256],64681:[[1581,1580],256],64682:[[1581,1605],256],64683:[[1582,1580],256],64684:[[1582,1605],256],64685:[[1587,1580],256],64686:[[1587,1581],256],64687:[[1587,1582],256],64688:[[1587,1605],256],64689:[[1589,1581],256],64690:[[1589,1582],256],64691:[[1589,1605],256],64692:[[1590,1580],256],64693:[[1590,1581],256],64694:[[1590,1582],256],64695:[[1590,1605],256],64696:[[1591,1581],256],64697:[[1592,1605],256],64698:[[1593,1580],256],64699:[[1593,1605],256],64700:[[1594,1580],256],64701:[[1594,1605],256],64702:[[1601,1580],256],64703:[[1601,1581],256],64704:[[1601,1582],256],64705:[[1601,1605],256],64706:[[1602,1581],256],64707:[[1602,1605],256],64708:[[1603,1580],256],64709:[[1603,1581],256],64710:[[1603,1582],256],64711:[[1603,1604],256],64712:[[1603,1605],256],64713:[[1604,1580],256],64714:[[1604,1581],256],64715:[[1604,1582],256],64716:[[1604,1605],256],64717:[[1604,1607],256],64718:[[1605,1580],256],64719:[[1605,1581],256],64720:[[1605,1582],256],64721:[[1605,1605],256],64722:[[1606,1580],256],64723:[[1606,1581],256],64724:[[1606,1582],256],64725:[[1606,1605],256],64726:[[1606,1607],256],64727:[[1607,1580],256],64728:[[1607,1605],256],64729:[[1607,1648],256],64730:[[1610,1580],256],64731:[[1610,1581],256],64732:[[1610,1582],256],64733:[[1610,1605],256],64734:[[1610,1607],256],64735:[[1574,1605],256],64736:[[1574,1607],256],64737:[[1576,1605],256],64738:[[1576,1607],256],64739:[[1578,1605],256],64740:[[1578,1607],256],64741:[[1579,1605],256],64742:[[1579,1607],256],64743:[[1587,1605],256],64744:[[1587,1607],256],64745:[[1588,1605],256],64746:[[1588,1607],256],64747:[[1603,1604],256],64748:[[1603,1605],256],64749:[[1604,1605],256],64750:[[1606,1605],256],64751:[[1606,1607],256],64752:[[1610,1605],256],64753:[[1610,1607],256],64754:[[1600,1614,1617],256],64755:[[1600,1615,1617],256],64756:[[1600,1616,1617],256],64757:[[1591,1609],256],64758:[[1591,1610],256],64759:[[1593,1609],256],64760:[[1593,1610],256],64761:[[1594,1609],256],64762:[[1594,1610],256],64763:[[1587,1609],256],64764:[[1587,1610],256],64765:[[1588,1609],256],64766:[[1588,1610],256],64767:[[1581,1609],256]},
64768:{64768:[[1581,1610],256],64769:[[1580,1609],256],64770:[[1580,1610],256],64771:[[1582,1609],256],64772:[[1582,1610],256],64773:[[1589,1609],256],64774:[[1589,1610],256],64775:[[1590,1609],256],64776:[[1590,1610],256],64777:[[1588,1580],256],64778:[[1588,1581],256],64779:[[1588,1582],256],64780:[[1588,1605],256],64781:[[1588,1585],256],64782:[[1587,1585],256],64783:[[1589,1585],256],64784:[[1590,1585],256],64785:[[1591,1609],256],64786:[[1591,1610],256],64787:[[1593,1609],256],64788:[[1593,1610],256],64789:[[1594,1609],256],64790:[[1594,1610],256],64791:[[1587,1609],256],64792:[[1587,1610],256],64793:[[1588,1609],256],64794:[[1588,1610],256],64795:[[1581,1609],256],64796:[[1581,1610],256],64797:[[1580,1609],256],64798:[[1580,1610],256],64799:[[1582,1609],256],64800:[[1582,1610],256],64801:[[1589,1609],256],64802:[[1589,1610],256],64803:[[1590,1609],256],64804:[[1590,1610],256],64805:[[1588,1580],256],64806:[[1588,1581],256],64807:[[1588,1582],256],64808:[[1588,1605],256],64809:[[1588,1585],256],64810:[[1587,1585],256],64811:[[1589,1585],256],64812:[[1590,1585],256],64813:[[1588,1580],256],64814:[[1588,1581],256],64815:[[1588,1582],256],64816:[[1588,1605],256],64817:[[1587,1607],256],64818:[[1588,1607],256],64819:[[1591,1605],256],64820:[[1587,1580],256],64821:[[1587,1581],256],64822:[[1587,1582],256],64823:[[1588,1580],256],64824:[[1588,1581],256],64825:[[1588,1582],256],64826:[[1591,1605],256],64827:[[1592,1605],256],64828:[[1575,1611],256],64829:[[1575,1611],256],64848:[[1578,1580,1605],256],64849:[[1578,1581,1580],256],64850:[[1578,1581,1580],256],64851:[[1578,1581,1605],256],64852:[[1578,1582,1605],256],64853:[[1578,1605,1580],256],64854:[[1578,1605,1581],256],64855:[[1578,1605,1582],256],64856:[[1580,1605,1581],256],64857:[[1580,1605,1581],256],64858:[[1581,1605,1610],256],64859:[[1581,1605,1609],256],64860:[[1587,1581,1580],256],64861:[[1587,1580,1581],256],64862:[[1587,1580,1609],256],64863:[[1587,1605,1581],256],64864:[[1587,1605,1581],256],64865:[[1587,1605,1580],256],64866:[[1587,1605,1605],256],64867:[[1587,1605,1605],256],64868:[[1589,1581,1581],256],64869:[[1589,1581,1581],256],64870:[[1589,1605,1605],256],64871:[[1588,1581,1605],256],64872:[[1588,1581,1605],256],64873:[[1588,1580,1610],256],64874:[[1588,1605,1582],256],64875:[[1588,1605,1582],256],64876:[[1588,1605,1605],256],64877:[[1588,1605,1605],256],64878:[[1590,1581,1609],256],64879:[[1590,1582,1605],256],64880:[[1590,1582,1605],256],64881:[[1591,1605,1581],256],64882:[[1591,1605,1581],256],64883:[[1591,1605,1605],256],64884:[[1591,1605,1610],256],64885:[[1593,1580,1605],256],64886:[[1593,1605,1605],256],64887:[[1593,1605,1605],256],64888:[[1593,1605,1609],256],64889:[[1594,1605,1605],256],64890:[[1594,1605,1610],256],64891:[[1594,1605,1609],256],64892:[[1601,1582,1605],256],64893:[[1601,1582,1605],256],64894:[[1602,1605,1581],256],64895:[[1602,1605,1605],256],64896:[[1604,1581,1605],256],64897:[[1604,1581,1610],256],64898:[[1604,1581,1609],256],64899:[[1604,1580,1580],256],64900:[[1604,1580,1580],256],64901:[[1604,1582,1605],256],64902:[[1604,1582,1605],256],64903:[[1604,1605,1581],256],64904:[[1604,1605,1581],256],64905:[[1605,1581,1580],256],64906:[[1605,1581,1605],256],64907:[[1605,1581,1610],256],64908:[[1605,1580,1581],256],64909:[[1605,1580,1605],256],64910:[[1605,1582,1580],256],64911:[[1605,1582,1605],256],64914:[[1605,1580,1582],256],64915:[[1607,1605,1580],256],64916:[[1607,1605,1605],256],64917:[[1606,1581,1605],256],64918:[[1606,1581,1609],256],64919:[[1606,1580,1605],256],64920:[[1606,1580,1605],256],64921:[[1606,1580,1609],256],64922:[[1606,1605,1610],256],64923:[[1606,1605,1609],256],64924:[[1610,1605,1605],256],64925:[[1610,1605,1605],256],64926:[[1576,1582,1610],256],64927:[[1578,1580,1610],256],64928:[[1578,1580,1609],256],64929:[[1578,1582,1610],256],64930:[[1578,1582,1609],256],64931:[[1578,1605,1610],256],64932:[[1578,1605,1609],256],64933:[[1580,1605,1610],256],64934:[[1580,1581,1609],256],64935:[[1580,1605,1609],256],64936:[[1587,1582,1609],256],64937:[[1589,1581,1610],256],64938:[[1588,1581,1610],256],64939:[[1590,1581,1610],256],64940:[[1604,1580,1610],256],64941:[[1604,1605,1610],256],64942:[[1610,1581,1610],256],64943:[[1610,1580,1610],256],64944:[[1610,1605,1610],256],64945:[[1605,1605,1610],256],64946:[[1602,1605,1610],256],64947:[[1606,1581,1610],256],64948:[[1602,1605,1581],256],64949:[[1604,1581,1605],256],64950:[[1593,1605,1610],256],64951:[[1603,1605,1610],256],64952:[[1606,1580,1581],256],64953:[[1605,1582,1610],256],64954:[[1604,1580,1605],256],64955:[[1603,1605,1605],256],64956:[[1604,1580,1605],256],64957:[[1606,1580,1581],256],64958:[[1580,1581,1610],256],64959:[[1581,1580,1610],256],64960:[[1605,1580,1610],256],64961:[[1601,1605,1610],256],64962:[[1576,1581,1610],256],64963:[[1603,1605,1605],256],64964:[[1593,1580,1605],256],64965:[[1589,1605,1605],256],64966:[[1587,1582,1610],256],64967:[[1606,1580,1610],256],65008:[[1589,1604,1746],256],65009:[[1602,1604,1746],256],65010:[[1575,1604,1604,1607],256],65011:[[1575,1603,1576,1585],256],65012:[[1605,1581,1605,1583],256],65013:[[1589,1604,1593,1605],256],65014:[[1585,1587,1608,1604],256],65015:[[1593,1604,1610,1607],256],65016:[[1608,1587,1604,1605],256],65017:[[1589,1604,1609],256],65018:[[1589,1604,1609,32,1575,1604,1604,1607,32,1593,1604,1610,1607,32,1608,1587,1604,1605],256],65019:[[1580,1604,32,1580,1604,1575,1604,1607],256],65020:[[1585,1740,1575,1604],256]},
65024:{65040:[[44],256],65041:[[12289],256],65042:[[12290],256],65043:[[58],256],65044:[[59],256],65045:[[33],256],65046:[[63],256],65047:[[12310],256],65048:[[12311],256],65049:[[8230],256],65056:[,230],65057:[,230],65058:[,230],65059:[,230],65060:[,230],65061:[,230],65062:[,230],65063:[,220],65064:[,220],65065:[,220],65066:[,220],65067:[,220],65068:[,220],65069:[,220],65072:[[8229],256],65073:[[8212],256],65074:[[8211],256],65075:[[95],256],65076:[[95],256],65077:[[40],256],65078:[[41],256],65079:[[123],256],65080:[[125],256],65081:[[12308],256],65082:[[12309],256],65083:[[12304],256],65084:[[12305],256],65085:[[12298],256],65086:[[12299],256],65087:[[12296],256],65088:[[12297],256],65089:[[12300],256],65090:[[12301],256],65091:[[12302],256],65092:[[12303],256],65095:[[91],256],65096:[[93],256],65097:[[8254],256],65098:[[8254],256],65099:[[8254],256],65100:[[8254],256],65101:[[95],256],65102:[[95],256],65103:[[95],256],65104:[[44],256],65105:[[12289],256],65106:[[46],256],65108:[[59],256],65109:[[58],256],65110:[[63],256],65111:[[33],256],65112:[[8212],256],65113:[[40],256],65114:[[41],256],65115:[[123],256],65116:[[125],256],65117:[[12308],256],65118:[[12309],256],65119:[[35],256],65120:[[38],256],65121:[[42],256],65122:[[43],256],65123:[[45],256],65124:[[60],256],65125:[[62],256],65126:[[61],256],65128:[[92],256],65129:[[36],256],65130:[[37],256],65131:[[64],256],65136:[[32,1611],256],65137:[[1600,1611],256],65138:[[32,1612],256],65140:[[32,1613],256],65142:[[32,1614],256],65143:[[1600,1614],256],65144:[[32,1615],256],65145:[[1600,1615],256],65146:[[32,1616],256],65147:[[1600,1616],256],65148:[[32,1617],256],65149:[[1600,1617],256],65150:[[32,1618],256],65151:[[1600,1618],256],65152:[[1569],256],65153:[[1570],256],65154:[[1570],256],65155:[[1571],256],65156:[[1571],256],65157:[[1572],256],65158:[[1572],256],65159:[[1573],256],65160:[[1573],256],65161:[[1574],256],65162:[[1574],256],65163:[[1574],256],65164:[[1574],256],65165:[[1575],256],65166:[[1575],256],65167:[[1576],256],65168:[[1576],256],65169:[[1576],256],65170:[[1576],256],65171:[[1577],256],65172:[[1577],256],65173:[[1578],256],65174:[[1578],256],65175:[[1578],256],65176:[[1578],256],65177:[[1579],256],65178:[[1579],256],65179:[[1579],256],65180:[[1579],256],65181:[[1580],256],65182:[[1580],256],65183:[[1580],256],65184:[[1580],256],65185:[[1581],256],65186:[[1581],256],65187:[[1581],256],65188:[[1581],256],65189:[[1582],256],65190:[[1582],256],65191:[[1582],256],65192:[[1582],256],65193:[[1583],256],65194:[[1583],256],65195:[[1584],256],65196:[[1584],256],65197:[[1585],256],65198:[[1585],256],65199:[[1586],256],65200:[[1586],256],65201:[[1587],256],65202:[[1587],256],65203:[[1587],256],65204:[[1587],256],65205:[[1588],256],65206:[[1588],256],65207:[[1588],256],65208:[[1588],256],65209:[[1589],256],65210:[[1589],256],65211:[[1589],256],65212:[[1589],256],65213:[[1590],256],65214:[[1590],256],65215:[[1590],256],65216:[[1590],256],65217:[[1591],256],65218:[[1591],256],65219:[[1591],256],65220:[[1591],256],65221:[[1592],256],65222:[[1592],256],65223:[[1592],256],65224:[[1592],256],65225:[[1593],256],65226:[[1593],256],65227:[[1593],256],65228:[[1593],256],65229:[[1594],256],65230:[[1594],256],65231:[[1594],256],65232:[[1594],256],65233:[[1601],256],65234:[[1601],256],65235:[[1601],256],65236:[[1601],256],65237:[[1602],256],65238:[[1602],256],65239:[[1602],256],65240:[[1602],256],65241:[[1603],256],65242:[[1603],256],65243:[[1603],256],65244:[[1603],256],65245:[[1604],256],65246:[[1604],256],65247:[[1604],256],65248:[[1604],256],65249:[[1605],256],65250:[[1605],256],65251:[[1605],256],65252:[[1605],256],65253:[[1606],256],65254:[[1606],256],65255:[[1606],256],65256:[[1606],256],65257:[[1607],256],65258:[[1607],256],65259:[[1607],256],65260:[[1607],256],65261:[[1608],256],65262:[[1608],256],65263:[[1609],256],65264:[[1609],256],65265:[[1610],256],65266:[[1610],256],65267:[[1610],256],65268:[[1610],256],65269:[[1604,1570],256],65270:[[1604,1570],256],65271:[[1604,1571],256],65272:[[1604,1571],256],65273:[[1604,1573],256],65274:[[1604,1573],256],65275:[[1604,1575],256],65276:[[1604,1575],256]},
65280:{65281:[[33],256],65282:[[34],256],65283:[[35],256],65284:[[36],256],65285:[[37],256],65286:[[38],256],65287:[[39],256],65288:[[40],256],65289:[[41],256],65290:[[42],256],65291:[[43],256],65292:[[44],256],65293:[[45],256],65294:[[46],256],65295:[[47],256],65296:[[48],256],65297:[[49],256],65298:[[50],256],65299:[[51],256],65300:[[52],256],65301:[[53],256],65302:[[54],256],65303:[[55],256],65304:[[56],256],65305:[[57],256],65306:[[58],256],65307:[[59],256],65308:[[60],256],65309:[[61],256],65310:[[62],256],65311:[[63],256],65312:[[64],256],65313:[[65],256],65314:[[66],256],65315:[[67],256],65316:[[68],256],65317:[[69],256],65318:[[70],256],65319:[[71],256],65320:[[72],256],65321:[[73],256],65322:[[74],256],65323:[[75],256],65324:[[76],256],65325:[[77],256],65326:[[78],256],65327:[[79],256],65328:[[80],256],65329:[[81],256],65330:[[82],256],65331:[[83],256],65332:[[84],256],65333:[[85],256],65334:[[86],256],65335:[[87],256],65336:[[88],256],65337:[[89],256],65338:[[90],256],65339:[[91],256],65340:[[92],256],65341:[[93],256],65342:[[94],256],65343:[[95],256],65344:[[96],256],65345:[[97],256],65346:[[98],256],65347:[[99],256],65348:[[100],256],65349:[[101],256],65350:[[102],256],65351:[[103],256],65352:[[104],256],65353:[[105],256],65354:[[106],256],65355:[[107],256],65356:[[108],256],65357:[[109],256],65358:[[110],256],65359:[[111],256],65360:[[112],256],65361:[[113],256],65362:[[114],256],65363:[[115],256],65364:[[116],256],65365:[[117],256],65366:[[118],256],65367:[[119],256],65368:[[120],256],65369:[[121],256],65370:[[122],256],65371:[[123],256],65372:[[124],256],65373:[[125],256],65374:[[126],256],65375:[[10629],256],65376:[[10630],256],65377:[[12290],256],65378:[[12300],256],65379:[[12301],256],65380:[[12289],256],65381:[[12539],256],65382:[[12530],256],65383:[[12449],256],65384:[[12451],256],65385:[[12453],256],65386:[[12455],256],65387:[[12457],256],65388:[[12515],256],65389:[[12517],256],65390:[[12519],256],65391:[[12483],256],65392:[[12540],256],65393:[[12450],256],65394:[[12452],256],65395:[[12454],256],65396:[[12456],256],65397:[[12458],256],65398:[[12459],256],65399:[[12461],256],65400:[[12463],256],65401:[[12465],256],65402:[[12467],256],65403:[[12469],256],65404:[[12471],256],65405:[[12473],256],65406:[[12475],256],65407:[[12477],256],65408:[[12479],256],65409:[[12481],256],65410:[[12484],256],65411:[[12486],256],65412:[[12488],256],65413:[[12490],256],65414:[[12491],256],65415:[[12492],256],65416:[[12493],256],65417:[[12494],256],65418:[[12495],256],65419:[[12498],256],65420:[[12501],256],65421:[[12504],256],65422:[[12507],256],65423:[[12510],256],65424:[[12511],256],65425:[[12512],256],65426:[[12513],256],65427:[[12514],256],65428:[[12516],256],65429:[[12518],256],65430:[[12520],256],65431:[[12521],256],65432:[[12522],256],65433:[[12523],256],65434:[[12524],256],65435:[[12525],256],65436:[[12527],256],65437:[[12531],256],65438:[[12441],256],65439:[[12442],256],65440:[[12644],256],65441:[[12593],256],65442:[[12594],256],65443:[[12595],256],65444:[[12596],256],65445:[[12597],256],65446:[[12598],256],65447:[[12599],256],65448:[[12600],256],65449:[[12601],256],65450:[[12602],256],65451:[[12603],256],65452:[[12604],256],65453:[[12605],256],65454:[[12606],256],65455:[[12607],256],65456:[[12608],256],65457:[[12609],256],65458:[[12610],256],65459:[[12611],256],65460:[[12612],256],65461:[[12613],256],65462:[[12614],256],65463:[[12615],256],65464:[[12616],256],65465:[[12617],256],65466:[[12618],256],65467:[[12619],256],65468:[[12620],256],65469:[[12621],256],65470:[[12622],256],65474:[[12623],256],65475:[[12624],256],65476:[[12625],256],65477:[[12626],256],65478:[[12627],256],65479:[[12628],256],65482:[[12629],256],65483:[[12630],256],65484:[[12631],256],65485:[[12632],256],65486:[[12633],256],65487:[[12634],256],65490:[[12635],256],65491:[[12636],256],65492:[[12637],256],65493:[[12638],256],65494:[[12639],256],65495:[[12640],256],65498:[[12641],256],65499:[[12642],256],65500:[[12643],256],65504:[[162],256],65505:[[163],256],65506:[[172],256],65507:[[175],256],65508:[[166],256],65509:[[165],256],65510:[[8361],256],65512:[[9474],256],65513:[[8592],256],65514:[[8593],256],65515:[[8594],256],65516:[[8595],256],65517:[[9632],256],65518:[[9675],256]}

};

   /***** Module to export */
   var unorm = {
      nfc: nfc,
      nfd: nfd,
      nfkc: nfkc,
      nfkd: nfkd
   };

   /*globals module:true,define:true*/

   // CommonJS
   if (true) {
      module.exports = unorm;

   // AMD
   } else if (typeof define === "function" && define.amd) {
      define("unorm", function () {
         return unorm;
      });

   // Global
   } else {
      root.unorm = unorm;
   }

   /***** Export as shim for String::normalize method *****/
   /*
      http://wiki.ecmascript.org/doku.php?id=harmony:specification_drafts#november_8_2013_draft_rev_21

      21.1.3.12 String.prototype.normalize(form="NFC")
      When the normalize method is called with one argument form, the following steps are taken:

      1. Let O be CheckObjectCoercible(this value).
      2. Let S be ToString(O).
      3. ReturnIfAbrupt(S).
      4. If form is not provided or undefined let form be "NFC".
      5. Let f be ToString(form).
      6. ReturnIfAbrupt(f).
      7. If f is not one of "NFC", "NFD", "NFKC", or "NFKD", then throw a RangeError Exception.
      8. Let ns be the String value is the result of normalizing S into the normalization form named by f as specified in Unicode Standard Annex #15, UnicodeNormalizatoin Forms.
      9. Return ns.

      The length property of the normalize method is 0.

      *NOTE* The normalize function is intentionally generic; it does not require that its this value be a String object. Therefore it can be transferred to other kinds of objects for use as a method.
   */
    unorm.shimApplied = false;

   if (!String.prototype.normalize) {
      Object.defineProperty(String.prototype, "normalize", {
         enumerable: false,
         configurable: true,
         writable: true,
         value: function normalize (/*form*/) {
            
            var str = "" + this;
            var form = arguments[0] === undefined ? "NFC" : arguments[0];

            if (this === null || this === undefined) {
               throw new TypeError("Cannot call method on " + Object.prototype.toString.call(this));
            }

            if (form === "NFC") {
               return unorm.nfc(str);
            } else if (form === "NFD") {
               return unorm.nfd(str);
            } else if (form === "NFKC") {
               return unorm.nfkc(str);
            } else if (form === "NFKD") {
               return unorm.nfkd(str);
            } else {
               throw new RangeError("Invalid normalization form: " + form);
            }
         }
      });

      unorm.shimApplied = true;
   }
}(this));


/***/ }),
/* 859 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 860 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMzAiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDI0IDI0OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PGc+PHBhdGggZD0iTTEyLDAuNUM1LjY1OSwwLjUsMC41LDUuNjU5LDAuNSwxMlM1LjY1OSwyMy41LDEyLDIzLjVTMjMuNSwxOC4zNDEsMjMuNSwxMlMxOC4zNDEsMC41LDEyLDAuNXogTTEyLDguNSAgIGMxLjkzLDAsMy41LDEuNTcsMy41LDMuNXMtMS41NywzLjUtMy41LDMuNVM4LjUsMTMuOTMsOC41LDEyUzEwLjA3LDguNSwxMiw4LjV6IE0xMiwyMi41Yy01LjYyMSwwLTEwLjIxMS00LjQ0My0xMC40NzUtMTBoNi4wMjUgICBjMC4yNTIsMi4yNDQsMi4xMzksNCw0LjQ0OSw0czQuMTk3LTEuNzU2LDQuNDQ5LTRoNi4wMjVDMjIuMjExLDE4LjA1NywxNy42MjEsMjIuNSwxMiwyMi41eiIvPjxwYXRoIGQ9Ik0xMiw5LjVjLTEuMzc4LDAtMi41LDEuMTIyLTIuNSwyLjVzMS4xMjIsMi41LDIuNSwyLjVzMi41LTEuMTIyLDIuNS0yLjVTMTMuMzc4LDkuNSwxMiw5LjV6IE0xMiwxMy41ICAgYy0wLjgyNywwLTEuNS0wLjY3My0xLjUtMS41czAuNjczLTEuNSwxLjUtMS41czEuNSwwLjY3MywxLjUsMS41UzEyLjgyNywxMy41LDEyLDEzLjV6Ii8+PC9nPjx0ZXh0IHg9IjAiIHk9IjM5IiBmaWxsPSIjMDAwMDAwIiBmb250LXNpemU9IjVweCIgZm9udC13ZWlnaHQ9ImJvbGQiIGZvbnQtZmFtaWx5PSInSGVsdmV0aWNhIE5ldWUnLCBIZWx2ZXRpY2EsIEFyaWFsLVVuaWNvZGUsIEFyaWFsLCBTYW5zLXNlcmlmIj5DcmVhdGVkIGJ5IGljb24gNTQ8L3RleHQ+PHRleHQgeD0iMCIgeT0iNDQiIGZpbGw9IiMwMDAwMDAiIGZvbnQtc2l6ZT0iNXB4IiBmb250LXdlaWdodD0iYm9sZCIgZm9udC1mYW1pbHk9IidIZWx2ZXRpY2EgTmV1ZScsIEhlbHZldGljYSwgQXJpYWwtVW5pY29kZSwgQXJpYWwsIFNhbnMtc2VyaWYiPmZyb20gdGhlIE5vdW4gUHJvamVjdDwvdGV4dD48L3N2Zz4="

/***/ }),
/* 861 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA3OC44IDk1LjEiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojMjMxZjIwO308L3N0eWxlPjwvZGVmcz48dGl0bGU+QXNzZXQgNTwvdGl0bGU+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik03Ni40LDE1LjJINjMuNlYyLjRBMi40MywyLjQzLDAsMCwwLDYxLjIsMEgyLjRBMi40MywyLjQzLDAsMCwwLDAsMi40Vjc3LjVhMi40MywyLjQzLDAsMCwwLDIuNCwyLjRIMTUuMlY5Mi43YTIuNDMsMi40MywwLDAsMCwyLjQsMi40SDc2LjRhMi40MywyLjQzLDAsMCwwLDIuNC0yLjRWMTcuNUEyLjM1LDIuMzUsMCwwLDAsNzYuNCwxNS4yWk0xNS4yLDE3LjVWNzVINC43VjQuN0g1OC44VjE1LjJIMTcuNkEyLjI5LDIuMjksMCwwLDAsMTUuMiwxNy41Wm00LjcsNzIuOFYxOS45SDc0VjkwLjNaIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNjQuMzYsMzcuNzVsLTIuOTQtLjQxYTIuNzEsMi43MSwwLDAsMS0xLjY3LS43MiwxLjU3LDEuNTcsMCwwLDEtLjQ4LTEuMTJjMC0xLjA2Ljg1LTIuMjYsMi45NC0yLjI2YTYuNjcsNi42NywwLDAsMSwzLjkxLjg3QTEuMTIsMS4xMiwwLDAsMCw2Ny41MywzNGwyLjI2LTIuMjZhMSwxLDAsMCwwLS4xLTEuNTYsMTAuMzEsMTAuMzEsMCwwLDAtNS42NC0yVjI2LjM4YTEuMSwxLjEsMCwwLDAtMS4xLTEuMUg2MC40OGExLjEsMS4xLDAsMCwwLTEuMSwxLjF2MkE3LjM0LDcuMzQsMCwwLDAsNTMuNSwzNS43YTYuNzUsNi43NSwwLDAsMCwxLjY3LDQuODgsOC4yMSw4LjIxLDAsMCwwLDQuODksMi4xNWwyLjkzLjQxYTIuODIsMi44MiwwLDAsMSwxLjYxLjY1LDIuMDUsMi4wNSwwLDAsMSwuNDcsMS40NGMwLDEuNC0xLjEyLDIuMTgtMy40OCwyLjE4YTkuMjYsOS4yNiwwLDAsMS00LjU3LTEsMS4zOCwxLjM4LDAsMCwwLTEuNzEuMTlsLTIsMmExLjI0LDEuMjQsMCwwLDAsLjExLDEuODYsMTEuMSwxMS4xLDAsMCwwLDYsMi4xOHYxLjkyYTEuMzYsMS4zNiwwLDAsMCwxLjM3LDEuMzZoMS45M2ExLjM2LDEuMzYsMCwwLDAsMS4zNy0xLjM2VjUyLjVDNjgsNTEuNzYsNzEsNDkuMjEsNzEsNDUuMDlhNy4xMyw3LjEzLDAsMCwwLTEuODEtNS4zM0E4LjI1LDguMjUsMCwwLDAsNjQuMzYsMzcuNzVaIi8+PHJlY3QgY2xhc3M9ImNscy0xIiB4PSIyMy42MSIgeT0iNDcuMTEiIHdpZHRoPSI2LjQyIiBoZWlnaHQ9IjcuOTYiIHJ4PSIxLjMiLz48cmVjdCBjbGFzcz0iY2xzLTEiIHg9IjMzLjExIiB5PSI0MS4yNCIgd2lkdGg9IjYuNDIiIGhlaWdodD0iMTMuODMiIHJ4PSIxLjMiLz48cmVjdCBjbGFzcz0iY2xzLTEiIHg9IjQyLjYxIiB5PSIzNi4zOCIgd2lkdGg9IjYuNDIiIGhlaWdodD0iMTguNjkiIHJ4PSIxLjMiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik01OC4xNyw2MS41N3YxMmwxMiwuODhWNzQuM0ExMi43NSwxMi43NSwwLDAsMCw1OC4xNyw2MS41N1oiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik00OC45NCw4My44QTEyLjc0LDEyLjc0LDAsMCwwLDcwLjEsNzUuOTJMNTcuNzIsNzVaIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNTYuNzIsNzRWNjEuNTdhMTIuNzQsMTIuNzQsMCwwLDAtOC44MSwyMS4yTDU2LjcyLDc0WiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTI1LjQ5LDQwLjYzbDYuODktNi44OCw0LjEsNC4xczAsMCwuMDUsMGExLjQ5LDEuNDksMCwwLDAsMi4xMywwbDcuODItNy44MS43NS43NWEuNzYuNzYsMCwwLDAsMS4yNy0uMzdsMS00LjU3YS43Ni43NiwwLDAsMC0uOS0uOTFMNDQuMDYsMjZhLjc2Ljc2LDAsMCwwLS4zNiwxLjI3bC42NC42NEwzNy42LDM0LjY5bC00LjE1LTQuMTVhMS41MywxLjUzLDAsMCwwLTIuMTUsMGwtNy45NSw4YTEuNTEsMS41MSwwLDAsMCwyLjE0LDIuMTRaIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMzcuMTQsNjEuNTFIMjcuNTVhMi42MiwyLjYyLDAsMCwwLTIuNjMsMi42M3YyMGEyLjYzLDIuNjMsMCwwLDAsMi42MywyLjYzaDkuNTlhMi42MywyLjYzLDAsMCwwLDIuNjMtMi42M3YtMjBBMi42MywyLjYzLDAsMCwwLDM3LjE0LDYxLjUxWm0tNy4yMiwxLjQzaDQuODR2LjY2SDI5LjkyWm0yLjQyLDIzYTEuNiwxLjYsMCwxLDEsMS42LTEuNkExLjYsMS42LDAsMCwxLDMyLjM0LDg1LjkzWm01LjI4LTQuMDdIMjcuMDZ2LTE3SDM3LjYyWiIvPjwvZz48L2c+PC9zdmc+"

/***/ }),
/* 862 */
/***/ (function(module, exports) {

var indexOf = function (xs, item) {
    if (xs.indexOf) return xs.indexOf(item);
    else for (var i = 0; i < xs.length; i++) {
        if (xs[i] === item) return i;
    }
    return -1;
};
var Object_keys = function (obj) {
    if (Object.keys) return Object.keys(obj)
    else {
        var res = [];
        for (var key in obj) res.push(key)
        return res;
    }
};

var forEach = function (xs, fn) {
    if (xs.forEach) return xs.forEach(fn)
    else for (var i = 0; i < xs.length; i++) {
        fn(xs[i], i, xs);
    }
};

var defineProp = (function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            })
        };
    } catch(e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}());

var globals = ['Array', 'Boolean', 'Date', 'Error', 'EvalError', 'Function',
'Infinity', 'JSON', 'Math', 'NaN', 'Number', 'Object', 'RangeError',
'ReferenceError', 'RegExp', 'String', 'SyntaxError', 'TypeError', 'URIError',
'decodeURI', 'decodeURIComponent', 'encodeURI', 'encodeURIComponent', 'escape',
'eval', 'isFinite', 'isNaN', 'parseFloat', 'parseInt', 'undefined', 'unescape'];

function Context() {}
Context.prototype = {};

var Script = exports.Script = function NodeScript (code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};

Script.prototype.runInContext = function (context) {
    if (!(context instanceof Context)) {
        throw new TypeError("needs a 'context' argument.");
    }
    
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    
    document.body.appendChild(iframe);
    
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;

    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    
    forEach(Object_keys(context), function (key) {
        win[key] = context[key];
    });
    forEach(globals, function (key) {
        if (context[key]) {
            win[key] = context[key];
        }
    });
    
    var winKeys = Object_keys(win);

    var res = wEval.call(win, this.code);
    
    forEach(Object_keys(win), function (key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) {
            context[key] = win[key];
        }
    });

    forEach(globals, function (key) {
        if (!(key in context)) {
            defineProp(context, key, win[key]);
        }
    });
    
    document.body.removeChild(iframe);
    
    return res;
};

Script.prototype.runInThisContext = function () {
    return eval(this.code); // maybe...
};

Script.prototype.runInNewContext = function (context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);

    if (context) {
        forEach(Object_keys(ctx), function (key) {
            context[key] = ctx[key];
        });
    }

    return res;
};

forEach(Object_keys(Script.prototype), function (name) {
    exports[name] = Script[name] = function (code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});

exports.isContext = function (context) {
    return context instanceof Context;
};

exports.createScript = function (code) {
    return exports.Script(code);
};

exports.createContext = Script.createContext = function (context) {
    var copy = new Context();
    if(typeof context === 'object') {
        forEach(Object_keys(context), function (key) {
            copy[key] = context[key];
        });
    }
    return copy;
};


/***/ }),
/* 863 */
/***/ (function(module, exports) {

module.exports = ["寶可夢","妙蛙種子","妙蛙草","妙蛙花","小火龍","火恐龍","噴火龍","傑尼龜","卡咪龜","水箭龜","綠毛蟲","鐵甲蛹","巴大蝴","獨角蟲","鐵殼昆","大針蜂","波波","比比鳥","比鵰","小拉達","拉達","烈雀","大嘴雀","阿柏蛇","阿柏怪","皮卡丘","雷丘","穿山鼠","穿山王","尼多蘭","尼多娜","尼多后","尼多朗","尼多力諾","尼多王","皮皮","皮可西","六尾","九尾","胖丁","胖可丁","超音蝠","大嘴蝠","走路草","臭臭花","霸王花","派拉斯","派拉斯特","毛球","末入蛾","地鼠","三地鼠","喵喵","貓老大","可達鴨","哥達鴨","猴怪","火爆猴","卡蒂狗","風速狗","蚊香蝌蚪","蚊香蛙","快泳蛙","凱西","勇吉拉","胡地","腕力","豪力","怪力","喇叭芽","口呆花","大食花","瑪瑙水母","毒刺水母","小拳石","隆隆石","隆隆岩","小火馬","烈焰馬","呆呆獸","呆河馬","小磁怪","三合一磁怪","大蔥鴨","嘟嘟","嘟嘟利","小海獅","白海獅","臭泥","臭臭泥","大舌貝","鐵甲貝","鬼斯","鬼斯通","耿鬼","大岩蛇","素利普","素利拍","大鉗蟹","巨鉗蟹","雷電球","頑皮彈","蛋蛋","椰蛋樹","可拉可拉","嘎拉嘎拉","沙瓦郎","艾比郎","大舌頭","瓦斯彈","雙彈瓦斯","鐵甲犀牛","鐵甲暴龍","吉利蛋","蔓藤怪","袋龍","墨海馬","海刺龍","角金魚","金魚王","海星星","寶石海星","吸盤魔偶","飛天螳螂","迷唇姐","電擊獸","鴨嘴火龍","大甲","肯泰羅","鯉魚王","暴鯉龍","乘龍","百變怪","伊布","水精靈","雷精靈","火精靈","３Ｄ龍","菊石獸","多刺菊石獸","化石盔","鐮刀盔","化石翼龍","卡比獸","急凍鳥","閃電鳥","火焰鳥","迷你龍","哈克龍","快龍","超夢","夢幻"]

/***/ }),
/* 864 */
/***/ (function(module, exports) {

module.exports = ["外幣","美金","日幣","通貨膨脹","自動櫃員機","道瓊工業指數","三大法人","數位支付","熱錢","精算師","套牢","擠兌","貶值","贖回","交割","零股","面值","洗錢","銀根","頭寸","透支","大盤","牛市","多頭","行動科技","開放資料","搜尋引擎","大數據","區塊鏈","去中心化","加密貨幣","比特幣","匿名化","雲端運算","資料庫","人工智慧","深度學習","使用者體驗","物聯網","演算法","新創公司","孵化器","加速器","天使投資人","群眾募資","共享辦公室","虛擬實境","擴增實境","混合實境","跨境電商","法人","標準差","直效行銷","躉繳","連續競價","去槓桿化","槓桿交易","滯脹","二級市場","次級市場","集中市場","現貨市場","影子銀行","鍋爐室騙局","綠皮書","授信","回檔","盤整","空殼公司","借殼上市","公債","衍生性金融商品","指數型基金","權證","選擇權","次級房貸","保本基金","交叉持股","複利","毛利率","殖利率","投資報酬率","折現率"]

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(360);
module.exports = __webpack_require__(359);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle.js